/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum ActionItemCombinationRelation {
  BEFORE_RESPECTIVE_PRESCRIPTION = "BEFORE_RESPECTIVE_PRESCRIPTION",
  STARTING_FROM_OR_BEFORE_RESPECTIVE_PRESCRIPTION = "STARTING_FROM_OR_BEFORE_RESPECTIVE_PRESCRIPTION",
  STARTING_FROM_RESPECTIVE_PRESCRIPTION = "STARTING_FROM_RESPECTIVE_PRESCRIPTION",
}

export enum ActionItemCombinationRule {
  INDEPENDENTLY = "INDEPENDENTLY",
  IN_COMBINATION_WITH = "IN_COMBINATION_WITH",
}

export enum ActionItemRangeType {
  STARTING_FROM = "STARTING_FROM",
  WITHIN = "WITHIN",
}

export enum ActionLogicalOperator {
  AND_TO = "AND_TO",
  OF = "OF",
  OR_TO = "OR_TO",
}

export enum ActionType {
  APPLY = "APPLY",
  DEDUCT = "DEDUCT",
}

export enum AdverseEventGrades {
  I = "I",
  II = "II",
  III = "III",
  IV = "IV",
}

export enum AdverseEventType {
  ACUTE_HEPATITIS = "ACUTE_HEPATITIS",
  ALT_INCREASED = "ALT_INCREASED",
  AST_INCREASED = "AST_INCREASED",
  COLITIS = "COLITIS",
  DIARRHOEA = "DIARRHOEA",
  HYPOPITUITARISM = "HYPOPITUITARISM",
  INTERSTITIAL_LUNG_DISEASE = "INTERSTITIAL_LUNG_DISEASE",
  PNEUMONITIS = "PNEUMONITIS",
  PYREXIA = "PYREXIA",
}

export enum AgreementDashboardTarget {
  BUYER = "BUYER",
  MIXED = "MIXED",
  SELLER = "SELLER",
}

export enum AgreementRunStatus {
  EXECUTED = "EXECUTED",
  IN_EXECUTION = "IN_EXECUTION",
}

export enum AgreementSubjectMatter {
  DEVICES = "DEVICES",
  DRUGS = "DRUGS",
}

export enum AgreementTagType {
  ARTICLE_71 = "ARTICLE_71",
  CUSTOM = "CUSTOM",
  SLL = "SLL",
  VOLUME_BASED = "VOLUME_BASED",
}

export enum AgreementUserRole {
  APPROVER = "APPROVER",
  EDITOR = "EDITOR",
  FULL_ACCESS_USER = "FULL_ACCESS_USER",
  LIMITED_ACCESS_USER = "LIMITED_ACCESS_USER",
  OWNER = "OWNER",
}

export enum AmountsType {
  TOTAL_AMOUNT = "TOTAL_AMOUNT",
}

export enum ArithmeticalOperator {
  BOTH = "BOTH",
  EQUAL = "EQUAL",
  GREATER_THEN = "GREATER_THEN",
  GREATER_THEN_OR_EQUAL = "GREATER_THEN_OR_EQUAL",
  LESS_THEN = "LESS_THEN",
  LESS_THEN_OR_EQUAL = "LESS_THEN_OR_EQUAL",
}

export enum AssigneeStatus {
  NO = "NO",
  YES_ALWAYS = "YES_ALWAYS",
  YES_WHEN_CREATOR = "YES_WHEN_CREATOR",
}

export enum AttributeSize {
  EXTRALONG = "EXTRALONG",
  LONG = "LONG",
  MEDIUM = "MEDIUM",
  SHORT = "SHORT",
}

export enum AttributeValidationStatus {
  INVALID = "INVALID",
  MISSING = "MISSING",
  VALID = "VALID",
}

export enum BlobContainerType {
  COMPANY_LOGO = "COMPANY_LOGO",
  PROFILE_PICTURE = "PROFILE_PICTURE",
  SIGNATURE = "SIGNATURE",
}

export enum CaseEventCategory {
  CHAT = "CHAT",
  DATA_ADDITION = "DATA_ADDITION",
  FINANCIALLY_RELEVANT = "FINANCIALLY_RELEVANT",
  NEGOTIATION = "NEGOTIATION",
  SYSTEM = "SYSTEM",
}

export enum CaseEventTrigger {
  APPLICATION = "APPLICATION",
  USER = "USER",
}

export enum CaseEventType {
  ATTRIBUTES_CHANGE = "ATTRIBUTES_CHANGE",
  AUTOMATIC_AGREEMENT_EXECUTION = "AUTOMATIC_AGREEMENT_EXECUTION",
  CASE_ACCEPTANCE = "CASE_ACCEPTANCE",
  CASE_CREATION = "CASE_CREATION",
  CASE_PROCESSED_WITHOUT_REVIEW = "CASE_PROCESSED_WITHOUT_REVIEW",
  CASE_STATE_CHANGE = "CASE_STATE_CHANGE",
  FILE_ATTACHMENT = "FILE_ATTACHMENT",
  FORM_ADDITION = "FORM_ADDITION",
  FORM_DELETION = "FORM_DELETION",
  FORM_EDIT = "FORM_EDIT",
  MANUAL_AGREEMENT_EXECUTION = "MANUAL_AGREEMENT_EXECUTION",
  NEGOTIABLE_ATTRIBUTES_ADDITION = "NEGOTIABLE_ATTRIBUTES_ADDITION",
  NEGOTIATION_ROUND_REJECTION = "NEGOTIATION_ROUND_REJECTION",
  RECORD_ADDITION = "RECORD_ADDITION",
  RECORD_REVOCATION = "RECORD_REVOCATION",
  RECORD_UPDATE = "RECORD_UPDATE",
  REPLY_ADDITION = "REPLY_ADDITION",
  THREAD_CREATION = "THREAD_CREATION",
  USER_MENTION = "USER_MENTION",
}

export enum CaseReportingStatus {
  CONTINUES = "CONTINUES",
  DISCONTINUED = "DISCONTINUED",
  UNKNOWN = "UNKNOWN",
}

export enum CaseStatus {
  ABANDONED = "ABANDONED",
  ACTIVE = "ACTIVE",
  ARCHIVED = "ARCHIVED",
  IN_REVIEW = "IN_REVIEW",
  SUSPENDED = "SUSPENDED",
  TENTATIVE = "TENTATIVE",
}

export enum CatalogueAttributeType {
  FORM = "FORM",
  PATIENT = "PATIENT",
  RECORD = "RECORD",
}

export enum CodeCategory {
  GTIN = "GTIN",
  PHARMACODE = "PHARMACODE",
  SWISSMEDICNO8 = "SWISSMEDICNO8",
}

export enum ConditionConsideredRating {
  A = "A",
  AB = "AB",
  B = "B",
  C = "C",
  D = "D",
}

export enum ConditionConsideredSecIntervention {
  PER_COHORT = "PER_COHORT",
}

export enum ConditionLogicalOperator {
  AND = "AND",
  OR = "OR",
}

export enum ConditionType {
  ACTIVE_INGREDIENT_QUANTITY = "ACTIVE_INGREDIENT_QUANTITY",
  ADVERSE_EVENT = "ADVERSE_EVENT",
  AMOUNT_OF = "AMOUNT_OF",
  LDL_LEVEL = "LDL_LEVEL",
  PRESCRIPTION_NUMBER = "PRESCRIPTION_NUMBER",
  RATING = "RATING",
  RESPONSE = "RESPONSE",
  SECONDARY_INTERVENTION_RATE = "SECONDARY_INTERVENTION_RATE",
  SURGERY = "SURGERY",
  TREATMENT_DURATION = "TREATMENT_DURATION",
  PATENT="PATENT"
}

export enum ConfigurableChartType {
  DoT = "DoT",
  LDL = "LDL",
}

export enum ContractPartType {
  AGGREGATION = "AGGREGATION",
  BASIC_INFO = "BASIC_INFO",
  DATA_GUIDANCE = "DATA_GUIDANCE",
  ELIGIBILITY = "ELIGIBILITY",
  MEASUREMENT = "MEASUREMENT",
  PRICING = "PRICING",
  TREATMENT = "TREATMENT",
  TREATMENT_AND_OUTCOME = "TREATMENT_AND_OUTCOME",
}

export enum ContractStatus {
  APPROVED = "APPROVED",
  COMPLETED = "COMPLETED",
  DRAFT = "DRAFT",
  IN_APPROVAL = "IN_APPROVAL",
  OPEN = "OPEN",
  PENDING = "PENDING",
  REJECTED = "REJECTED",
  RUNNING = "RUNNING",
  TERMINATED = "TERMINATED",
}

export enum ContractWorkflowStatus {
  APPROVE = "APPROVE",
  PENDING = "PENDING",
  REJECT = "REJECT",
}

export enum ContractWorkflowStepType {
  FINAL = "FINAL",
  INITIAL = "INITIAL",
}

export enum ContractWorkflowType {
  APPROVAL = "APPROVAL",
  TERMINATION = "TERMINATION",
}

export enum CountdownOperator {
  BEFORE = "BEFORE",
  STARTING_FROM = "STARTING_FROM",
}

export enum CountdownPoint {
  EARLIEST = "EARLIEST",
  HIGHEST = "HIGHEST",
  LATEST = "LATEST",
}

export enum CounterpartyRole {
  BUYER = "BUYER",
  OBSERVER = "OBSERVER",
  SELLER = "SELLER",
}

export enum CoverageRequestRating {
  A = "A",
  AB = "AB",
  B = "B",
  C = "C",
}

export enum CoverageRequestTherapyDecision {
  APPROVED = "APPROVED",
  DECLINED = "DECLINED",
  TRIAL = "TRIAL",
}

export enum CycleAdherence {
  SEMI_STRICT = "SEMI_STRICT",
  SOFT = "SOFT",
  STRICT = "STRICT",
}

export enum CycleStartingPoint {
  PREVIOUS_CYCLE_FIRST_RECORD = "PREVIOUS_CYCLE_FIRST_RECORD",
  PREVIOUS_CYCLE_LAST_RECORD = "PREVIOUS_CYCLE_LAST_RECORD",
}

export enum DataContainerCreationWay {
  MANUAL_ENTRY = "MANUAL_ENTRY",
  UPLOAD = "UPLOAD",
}

export enum DataContainerSharingTrigger {
  AGREEMENT_INCLUSION = "AGREEMENT_INCLUSION",
  INVOICE_CREATION = "INVOICE_CREATION",
  NEVER = "NEVER",
}

export enum DataSubType {
  CHAT = "CHAT",
  TABLE = "TABLE",
}

export enum DataType {
  BOOLEAN = "BOOLEAN",
  DATE = "DATE",
  NUMBER = "NUMBER",
  TEXT = "TEXT",
  WIDGET = "WIDGET",
}

export enum Decision {
  APPROVE = "APPROVE",
  REJECT = "REJECT",
}

export enum DeltaType {
  ANY = "ANY",
  NEGATIVE = "NEGATIVE",
  POSITIVE = "POSITIVE",
}

export enum DocumentStatus {
  IN_REVIEW = "IN_REVIEW",
  IN_APPROVAL = "IN_APPROVAL",
  ISSUED = "ISSUED",
  SETTLED = "SETTLED",
  WORKING_DRAFT = "WORKING_DRAFT",
}

export enum DocumentType {
  CREDIT_NOTE = "CREDIT_NOTE",
  FREE_OF_CHARGE = "FREE_OF_CHARGE",
  INVOICE = "INVOICE",
}

export enum EnrollingConditionType {
  CUSTOM_CONDITION = "CUSTOM_CONDITION",
  CYCLE_LIMIT = "CYCLE_LIMIT",
  DATA_GUIDANCE = "DATA_GUIDANCE",
  LDL_LEVEL = "LDL_LEVEL",
  NOT_YET_CONFIRMED = "NOT_YET_CONFIRMED",
  OUTSIDE_VALIDITY_PERIOD = "OUTSIDE_VALIDITY_PERIOD",
  PATIENT_AGE = "PATIENT_AGE",
  PREVIOUS_THERAPY = "PREVIOUS_THERAPY",
  RATING = "RATING",
  REJECTED = "REJECTED",
  THERAPY_DECISION = "THERAPY_DECISION",
  UNCERTAIN = "UNCERTAIN",
  UNKNOWN = "UNKNOWN",
}

export enum EnrolmentDateType {
  DIAGNOSIS_DATE = "DIAGNOSIS_DATE",
  FIRST_RECORD_DATE = "FIRST_RECORD_DATE",
  RECORD_DATE = "RECORD_DATE",
  REQUEST_RECEIPT_DATE = "REQUEST_RECEIPT_DATE",
}

export enum EntityPriceType {
  CASE = "CASE",
  CYCLE = "CYCLE",
  GRAM = "GRAM",
  MILLIGRAM = "MILLIGRAM",
  MILLILITRE = "MILLILITRE",
  PACK = "PACK",
}

export enum FinancialDataPointStatus {
  APPROVED = "APPROVED",
  DECLINED = "DECLINED",
  UNDECIDED = "UNDECIDED",
}

export enum FinancialSummaryColumnName {
  BASELINE_PRICE = "BASELINE_PRICE",
  DISCOUNTS = "DISCOUNTS",
  EX_FACTORY_PRICE = "EX_FACTORY_PRICE",
  GROSS_AMOUNT = "GROSS_AMOUNT",
  NET_AMOUNT = "NET_AMOUNT",
  NET_AVG_DISCOUNT_RATE = "NET_AVG_DISCOUNT_RATE",
  NET_AVG_PRICE = "NET_AVG_PRICE",
  NET_PRICE = "NET_PRICE",
  PRODUCT = "PRODUCT",
  PUBLIC_PRICE = "PUBLIC_PRICE",
  QUANTITY = "QUANTITY",
  TOTAL_DISCOUNTS = "TOTAL_DISCOUNTS",
  VARIABLE = "VARIABLE",
}

export enum FlexContainerType {
  FORM = "FORM",
  RECORD = "RECORD",
}

export enum FlexEntityFeature {
  DELETION = "DELETION",
  EDITING = "EDITING",
  SAVING = "SAVING",
  SUBMISSION = "SUBMISSION",
}

export enum FlexFormStatus {
  COOLING_PERIOD = "COOLING_PERIOD",
  DRAFT = "DRAFT",
  MATCHED = "MATCHED",
  REVOKED = "REVOKED",
  SUBMITTED = "SUBMITTED",
  UNMATCHED = "UNMATCHED",
}

export enum GQLResponseStatus {
  ERROR = "ERROR",
  SUCCESS = "SUCCESS",
}

export enum IRAdverseEventDoseModifications {
  NO_MODIFICATION = "NO_MODIFICATION",
  PERMANENTLY_DISCONTINUE = "PERMANENTLY_DISCONTINUE",
  REDUCE_DOSE = "REDUCE_DOSE",
  WITHHOLD_DOSE = "WITHHOLD_DOSE",
}

export enum InclusionType {
  INCLUDED = "INCLUDED",
  NOT_INCLUDED = "NOT_INCLUDED",
}

export enum InterventionOccurrence {
  FIRST_SURGERY_DATE = "FIRST_SURGERY_DATE",
}

export enum InterventionType {
  RELATED_TO_PAF = "RELATED_TO_PAF",
}

export enum InvoiceApprovalRole {
  APPROVER = "APPROVER",
  CONFIRMOR = "CONFIRMOR",
}

export enum ItemScope {
  ALL = "ALL",
  REPETINGITEMS = "REPETINGITEMS",
  SPECIFIC = "SPECIFIC",
}

export enum MasterDataCreationWay {
  IMPORTED = "IMPORTED",
  MANUAL_ENTRY = "MANUAL_ENTRY",
}

export enum MicroContentType {
  NEW_CASES = "NEW_CASES",
  THERAPY_TRIALS = "THERAPY_TRIALS",
  TREATMENT_CONTINUATION = "TREATMENT_CONTINUATION",
}

export enum MonitoringType {
  CHANGED_BETWEEN = "CHANGED_BETWEEN",
}

export enum NegotiationRoundStatus {
  ACCEPTED = "ACCEPTED",
  ACCEPTED_WITHOUT_REVIEW = "ACCEPTED_WITHOUT_REVIEW",
  IN_REVIEW = "IN_REVIEW",
  REJECTED = "REJECTED",
}

export enum NotificationType {
  INDIVIDUAL = "INDIVIDUAL",
  SUMMARY = "SUMMARY",
}

export enum Occurrence {
  FOR_THE_FIRST_TIME = "FOR_THE_FIRST_TIME",
  FOR_THE_FOURTH_TIME = "FOR_THE_FOURTH_TIME",
  FOR_THE_SECOND_TIME = "FOR_THE_SECOND_TIME",
  FOR_THE_THIRD_TIME = "FOR_THE_THIRD_TIME",
}

export enum OccurrenceEnum {
  FORM_ENTRY = "FORM_ENTRY",
  RECORD_ENTRY = "RECORD_ENTRY",
  RECORD_IMPORT = "RECORD_IMPORT",
  RECORD_UPLOAD = "RECORD_UPLOAD",
}

export enum OutcomeBasedStatus {
  NON_TREATMENT_RELATED = "NON_TREATMENT_RELATED",
  TREATMENT_RELATED = "TREATMENT_RELATED",
}

export enum PackOptionType {
  SPECIFIC = "SPECIFIC",
  WHOLE = "WHOLE",
}

export enum PackVolumeUoMType {
  Stk = "Stk",
}

export enum PatientScope {
  PER_AGREEMENT = "PER_AGREEMENT",
  PER_PATIENT = "PER_PATIENT",
}

export enum PriceCategory {
  INTERNAL = "INTERNAL",
  PEXF = "PEXF",
  PPUB = "PPUB",
  CROSS_COUNTRY = "CROSS_COUNTRY",
  AVERAGE_GENERIC="AVERAGE_GENERIC"
}

export enum PriceType {
  CUSTOM_PRICE_PERCENT = "CUSTOM_PRICE_PERCENT",
  EX_FACTORY_PRICE_PERCENT = "EX_FACTORY_PRICE_PERCENT",
  FIXED_FEE = "FIXED_FEE",
  PUBLIC_PRICE_PERCENT = "PUBLIC_PRICE_PERCENT",
  RECORD_DISCOUNT_PERCENT = "RECORD_DISCOUNT_PERCENT",
  RECORD_PRICE_PERCENT = "RECORD_PRICE_PERCENT",
  CROSS_COUNTRY_PERCENT="CROSS_COUNTRY_PERCENT",
	AVG_GENERIC_PERCENT="AVG_GENERIC_PERCENT",
	DIFF_BETWEEN_EX_FACTORY_AND_CROSS_COUNTRY="DIFF_BETWEEN_EX_FACTORY_AND_CROSS_COUNTRY",
}

export enum PublicAgreementView {
  DASHBOARD = "DASHBOARD",
  LIST = "LIST",
}

export enum QuestCompletionStatus {
  ACTIVE = "ACTIVE",
  DISMISSED = "DISMISSED",
  EXPIRED = "EXPIRED",
  REVOKED = "REVOKED",
  SUBMITTED_FORM = "SUBMITTED_FORM",
}

export enum ReasonsForDiscontinuation {
  ADVERSE_EVENT = "ADVERSE_EVENT",
  ANOTHER_THERAPY_START = "ANOTHER_THERAPY_START",
  DEATH = "DEATH",
  NO_INFO = "NO_INFO",
  PROGRESSIVE_DISEASE = "PROGRESSIVE_DISEASE",
}

export enum RecordNature {
  ADMINISTERED = "ADMINISTERED",
  PRESCRIBED = "PRESCRIBED",
}

export enum RefundStatus {
  DECLINED = "DECLINED",
  INVOICED = "INVOICED",
  NEW = "NEW",
  PENDING = "PENDING",
  SETTLED = "SETTLED",
}

export enum Reintervention {
  DID_NOT_OCCUR = "DID_NOT_OCCUR",
  OCCURED = "OCCURED",
}

export enum ReportInterventionType {
  PRIMARY_INTERVENTION = "PRIMARY_INTERVENTION",
  SECONDARY_INTERVENTION = "SECONDARY_INTERVENTION",
}

export enum ReportItemsUsedFilter {
  ALL = "ALL",
  PRIMARY_AND_SECONDARY_INTERVENTION = "PRIMARY_AND_SECONDARY_INTERVENTION",
  PRIMARY_INTERVENTION_ONLY = "PRIMARY_INTERVENTION_ONLY",
}

export enum ResponseInclusionType {
  IS = "IS",
  IS_NOT = "IS_NOT",
}

export enum ResultSelectionType {
  EARLIEST = "EARLIEST",
  HIGHEST = "HIGHEST",
  LATEST = "LATEST",
  LOWEST = "LOWEST",
}

export enum RollingRangeType {
  CALENDAR_MONTH = "CALENDAR_MONTH",
  CALENDAR_QUARTER = "CALENDAR_QUARTER",
  CALENDAR_YEAR = "CALENDAR_YEAR",
  EXACTLY = "EXACTLY",
}

export enum SortDirection {
  ASC = "ASC",
  DESC = "DESC",
}

export enum StatusHistorical {
  MANDATORY = "MANDATORY",
  MANDATORY_FOR_SUBMISSION = "MANDATORY_FOR_SUBMISSION",
  OPTIONAL = "OPTIONAL",
}

export enum SupportedMessageNodes {
  Case = "Case",
  RefundCase = "RefundCase",
}

export enum TaskStatus {
  READ = "READ",
  UNREAD = "UNREAD",
}

export enum TimeframeRangeType {
  EVER = "EVER",
  STARTING_FROM = "STARTING_FROM",
  UP_TO = "UP_TO",
  WITHIN = "WITHIN",
  WITHIN_ROLLING_RANGE_OF = "WITHIN_ROLLING_RANGE_OF",
  WITHIN_THERAPY_TRIAL = "WITHIN_THERAPY_TRIAL",
  WITHIN_THE_COVERAGE_PERIOD = "WITHIN_THE_COVERAGE_PERIOD",
}

export enum TimeframeRelation {
  BEFORE = "BEFORE",
  STARTING_FROM = "STARTING_FROM",
}

export enum TimeframeStartingPoint {
  AGREEMENT_START_DATE = "AGREEMENT_START_DATE",
  AGREEMENT_VERSION_START_DATE = "AGREEMENT_VERSION_START_DATE",
  COVERAGE_PERIOD_START = "COVERAGE_PERIOD_START",
  FIRST_ADMINISTRATION_DATE = "FIRST_ADMINISTRATION_DATE",
  FIRST_PRESCRIPTION_DATE = "FIRST_PRESCRIPTION_DATE",
  INTENDED_START_DATE = "INTENDED_START_DATE",
  PROGRESSION_DATE = "PROGRESSION_DATE",
  REQUEST_RECEIPT_DATE = "REQUEST_RECEIPT_DATE",
  TREATMENT_START_DATE = "TREATMENT_START_DATE",
}

export enum Translations {
  DE = "DE",
  EN = "EN",
}

export enum TreatingPhysicianTitle {
  DOCTOR = "DOCTOR",
  PROFESSOR = "PROFESSOR",
}

export enum TreatmentDiscontinuationReason {
  ANOTHER_THERAPY_START = "ANOTHER_THERAPY_START",
  ANY = "ANY",
  NO_INFO = "NO_INFO",
  PATIENT_DEATH = "PATIENT_DEATH",
  TRAE = "TRAE",
}

export enum TreatmentDurationConditionAspect {
  DISCONTINUED = "DISCONTINUED",
  LASTED = "LASTED",
}

export enum UnitedResponseType {
  COMPLETE_RESPONSE = "COMPLETE_RESPONSE",
  NO_INFO = "NO_INFO",
  NO_PCR = "NO_PCR",
  PARTIAL_RESPONSE = "PARTIAL_RESPONSE",
  PATHOLOGICAL_COMPLETE_RESPONSE = "PATHOLOGICAL_COMPLETE_RESPONSE",
  PCR = "PCR",
  PROGRESSIVE_DISEASE = "PROGRESSIVE_DISEASE",
  STABLE_DISEASE = "STABLE_DISEASE",
}

export enum UoMType {
  CUR = "CUR",
  GRAM = "GRAM",
  MILLIGRAM = "MILLIGRAM",
  MILLILITRE = "MILLILITRE",
  PACK = "PACK",
}

export enum WidgetType {
  INITIAL_RESPONSE_REVIEW = "INITIAL_RESPONSE_REVIEW",
  PROGRESSION_FREE_PATIENTS = "PROGRESSION_FREE_PATIENTS",
  TOTAL_RESPONSES = "TOTAL_RESPONSES",
}

/**
 * An enum describing what kind of type a given `__Type` is.
 */
export enum __TypeKind {
  ENUM = "ENUM",
  INPUT_OBJECT = "INPUT_OBJECT",
  INTERFACE = "INTERFACE",
  LIST = "LIST",
  NON_NULL = "NON_NULL",
  OBJECT = "OBJECT",
  SCALAR = "SCALAR",
  UNION = "UNION",
}

export interface ActionPrescriptionRelationshipWhere {
  AND?: ActionPrescriptionRelationshipWhere[] | null;
  OR?: ActionPrescriptionRelationshipWhere[] | null;
  order?: number | null;
  order_GT?: number | null;
  order_GTE?: number | null;
  order_IN?: (number | null)[] | null;
  order_LT?: number | null;
  order_LTE?: number | null;
  order_NOT?: number | null;
  order_NOT_IN?: (number | null)[] | null;
}

export interface AgreementCounterpartyRolesAggregateInput {
  AND?: AgreementCounterpartyRolesAggregateInput[] | null;
  OR?: AgreementCounterpartyRolesAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: AgreementCounterpartyRolesNodeAggregationWhereInput | null;
}

export interface AgreementCounterpartyRolesConnectionWhere {
  AND?: AgreementCounterpartyRolesConnectionWhere[] | null;
  OR?: AgreementCounterpartyRolesConnectionWhere[] | null;
  edge?: CounterpartyRoleRelationshipWhere | null;
  edge_NOT?: CounterpartyRoleRelationshipWhere | null;
  node?: OrganizationWhere | null;
  node_NOT?: OrganizationWhere | null;
}

export interface AgreementCounterpartyRolesNodeAggregationWhereInput {
  AND?: AgreementCounterpartyRolesNodeAggregationWhereInput[] | null;
  BIC_AVERAGE_EQUAL?: number | null;
  BIC_AVERAGE_GT?: number | null;
  BIC_AVERAGE_GTE?: number | null;
  BIC_AVERAGE_LT?: number | null;
  BIC_AVERAGE_LTE?: number | null;
  BIC_EQUAL?: string | null;
  BIC_GT?: number | null;
  BIC_GTE?: number | null;
  BIC_LONGEST_EQUAL?: number | null;
  BIC_LONGEST_GT?: number | null;
  BIC_LONGEST_GTE?: number | null;
  BIC_LONGEST_LT?: number | null;
  BIC_LONGEST_LTE?: number | null;
  BIC_LT?: number | null;
  BIC_LTE?: number | null;
  BIC_SHORTEST_EQUAL?: number | null;
  BIC_SHORTEST_GT?: number | null;
  BIC_SHORTEST_GTE?: number | null;
  BIC_SHORTEST_LT?: number | null;
  BIC_SHORTEST_LTE?: number | null;
  IBAN_AVERAGE_EQUAL?: number | null;
  IBAN_AVERAGE_GT?: number | null;
  IBAN_AVERAGE_GTE?: number | null;
  IBAN_AVERAGE_LT?: number | null;
  IBAN_AVERAGE_LTE?: number | null;
  IBAN_EQUAL?: string | null;
  IBAN_GT?: number | null;
  IBAN_GTE?: number | null;
  IBAN_LONGEST_EQUAL?: number | null;
  IBAN_LONGEST_GT?: number | null;
  IBAN_LONGEST_GTE?: number | null;
  IBAN_LONGEST_LT?: number | null;
  IBAN_LONGEST_LTE?: number | null;
  IBAN_LT?: number | null;
  IBAN_LTE?: number | null;
  IBAN_SHORTEST_EQUAL?: number | null;
  IBAN_SHORTEST_GT?: number | null;
  IBAN_SHORTEST_GTE?: number | null;
  IBAN_SHORTEST_LT?: number | null;
  IBAN_SHORTEST_LTE?: number | null;
  OR?: AgreementCounterpartyRolesNodeAggregationWhereInput[] | null;
  accountName_AVERAGE_EQUAL?: number | null;
  accountName_AVERAGE_GT?: number | null;
  accountName_AVERAGE_GTE?: number | null;
  accountName_AVERAGE_LT?: number | null;
  accountName_AVERAGE_LTE?: number | null;
  accountName_EQUAL?: string | null;
  accountName_GT?: number | null;
  accountName_GTE?: number | null;
  accountName_LONGEST_EQUAL?: number | null;
  accountName_LONGEST_GT?: number | null;
  accountName_LONGEST_GTE?: number | null;
  accountName_LONGEST_LT?: number | null;
  accountName_LONGEST_LTE?: number | null;
  accountName_LT?: number | null;
  accountName_LTE?: number | null;
  accountName_SHORTEST_EQUAL?: number | null;
  accountName_SHORTEST_GT?: number | null;
  accountName_SHORTEST_GTE?: number | null;
  accountName_SHORTEST_LT?: number | null;
  accountName_SHORTEST_LTE?: number | null;
  accountNumber_AVERAGE_EQUAL?: number | null;
  accountNumber_AVERAGE_GT?: number | null;
  accountNumber_AVERAGE_GTE?: number | null;
  accountNumber_AVERAGE_LT?: number | null;
  accountNumber_AVERAGE_LTE?: number | null;
  accountNumber_EQUAL?: string | null;
  accountNumber_GT?: number | null;
  accountNumber_GTE?: number | null;
  accountNumber_LONGEST_EQUAL?: number | null;
  accountNumber_LONGEST_GT?: number | null;
  accountNumber_LONGEST_GTE?: number | null;
  accountNumber_LONGEST_LT?: number | null;
  accountNumber_LONGEST_LTE?: number | null;
  accountNumber_LT?: number | null;
  accountNumber_LTE?: number | null;
  accountNumber_SHORTEST_EQUAL?: number | null;
  accountNumber_SHORTEST_GT?: number | null;
  accountNumber_SHORTEST_GTE?: number | null;
  accountNumber_SHORTEST_LT?: number | null;
  accountNumber_SHORTEST_LTE?: number | null;
  billingAddress_AVERAGE_EQUAL?: number | null;
  billingAddress_AVERAGE_GT?: number | null;
  billingAddress_AVERAGE_GTE?: number | null;
  billingAddress_AVERAGE_LT?: number | null;
  billingAddress_AVERAGE_LTE?: number | null;
  billingAddress_EQUAL?: string | null;
  billingAddress_GT?: number | null;
  billingAddress_GTE?: number | null;
  billingAddress_LONGEST_EQUAL?: number | null;
  billingAddress_LONGEST_GT?: number | null;
  billingAddress_LONGEST_GTE?: number | null;
  billingAddress_LONGEST_LT?: number | null;
  billingAddress_LONGEST_LTE?: number | null;
  billingAddress_LT?: number | null;
  billingAddress_LTE?: number | null;
  billingAddress_SHORTEST_EQUAL?: number | null;
  billingAddress_SHORTEST_GT?: number | null;
  billingAddress_SHORTEST_GTE?: number | null;
  billingAddress_SHORTEST_LT?: number | null;
  billingAddress_SHORTEST_LTE?: number | null;
  contactEmail_AVERAGE_EQUAL?: number | null;
  contactEmail_AVERAGE_GT?: number | null;
  contactEmail_AVERAGE_GTE?: number | null;
  contactEmail_AVERAGE_LT?: number | null;
  contactEmail_AVERAGE_LTE?: number | null;
  contactEmail_EQUAL?: string | null;
  contactEmail_GT?: number | null;
  contactEmail_GTE?: number | null;
  contactEmail_LONGEST_EQUAL?: number | null;
  contactEmail_LONGEST_GT?: number | null;
  contactEmail_LONGEST_GTE?: number | null;
  contactEmail_LONGEST_LT?: number | null;
  contactEmail_LONGEST_LTE?: number | null;
  contactEmail_LT?: number | null;
  contactEmail_LTE?: number | null;
  contactEmail_SHORTEST_EQUAL?: number | null;
  contactEmail_SHORTEST_GT?: number | null;
  contactEmail_SHORTEST_GTE?: number | null;
  contactEmail_SHORTEST_LT?: number | null;
  contactEmail_SHORTEST_LTE?: number | null;
  contactFirstName_AVERAGE_EQUAL?: number | null;
  contactFirstName_AVERAGE_GT?: number | null;
  contactFirstName_AVERAGE_GTE?: number | null;
  contactFirstName_AVERAGE_LT?: number | null;
  contactFirstName_AVERAGE_LTE?: number | null;
  contactFirstName_EQUAL?: string | null;
  contactFirstName_GT?: number | null;
  contactFirstName_GTE?: number | null;
  contactFirstName_LONGEST_EQUAL?: number | null;
  contactFirstName_LONGEST_GT?: number | null;
  contactFirstName_LONGEST_GTE?: number | null;
  contactFirstName_LONGEST_LT?: number | null;
  contactFirstName_LONGEST_LTE?: number | null;
  contactFirstName_LT?: number | null;
  contactFirstName_LTE?: number | null;
  contactFirstName_SHORTEST_EQUAL?: number | null;
  contactFirstName_SHORTEST_GT?: number | null;
  contactFirstName_SHORTEST_GTE?: number | null;
  contactFirstName_SHORTEST_LT?: number | null;
  contactFirstName_SHORTEST_LTE?: number | null;
  contactLastName_AVERAGE_EQUAL?: number | null;
  contactLastName_AVERAGE_GT?: number | null;
  contactLastName_AVERAGE_GTE?: number | null;
  contactLastName_AVERAGE_LT?: number | null;
  contactLastName_AVERAGE_LTE?: number | null;
  contactLastName_EQUAL?: string | null;
  contactLastName_GT?: number | null;
  contactLastName_GTE?: number | null;
  contactLastName_LONGEST_EQUAL?: number | null;
  contactLastName_LONGEST_GT?: number | null;
  contactLastName_LONGEST_GTE?: number | null;
  contactLastName_LONGEST_LT?: number | null;
  contactLastName_LONGEST_LTE?: number | null;
  contactLastName_LT?: number | null;
  contactLastName_LTE?: number | null;
  contactLastName_SHORTEST_EQUAL?: number | null;
  contactLastName_SHORTEST_GT?: number | null;
  contactLastName_SHORTEST_GTE?: number | null;
  contactLastName_SHORTEST_LT?: number | null;
  contactLastName_SHORTEST_LTE?: number | null;
  contactOccupation_AVERAGE_EQUAL?: number | null;
  contactOccupation_AVERAGE_GT?: number | null;
  contactOccupation_AVERAGE_GTE?: number | null;
  contactOccupation_AVERAGE_LT?: number | null;
  contactOccupation_AVERAGE_LTE?: number | null;
  contactOccupation_EQUAL?: string | null;
  contactOccupation_GT?: number | null;
  contactOccupation_GTE?: number | null;
  contactOccupation_LONGEST_EQUAL?: number | null;
  contactOccupation_LONGEST_GT?: number | null;
  contactOccupation_LONGEST_GTE?: number | null;
  contactOccupation_LONGEST_LT?: number | null;
  contactOccupation_LONGEST_LTE?: number | null;
  contactOccupation_LT?: number | null;
  contactOccupation_LTE?: number | null;
  contactOccupation_SHORTEST_EQUAL?: number | null;
  contactOccupation_SHORTEST_GT?: number | null;
  contactOccupation_SHORTEST_GTE?: number | null;
  contactOccupation_SHORTEST_LT?: number | null;
  contactOccupation_SHORTEST_LTE?: number | null;
  contactPhone_AVERAGE_EQUAL?: number | null;
  contactPhone_AVERAGE_GT?: number | null;
  contactPhone_AVERAGE_GTE?: number | null;
  contactPhone_AVERAGE_LT?: number | null;
  contactPhone_AVERAGE_LTE?: number | null;
  contactPhone_EQUAL?: string | null;
  contactPhone_GT?: number | null;
  contactPhone_GTE?: number | null;
  contactPhone_LONGEST_EQUAL?: number | null;
  contactPhone_LONGEST_GT?: number | null;
  contactPhone_LONGEST_GTE?: number | null;
  contactPhone_LONGEST_LT?: number | null;
  contactPhone_LONGEST_LTE?: number | null;
  contactPhone_LT?: number | null;
  contactPhone_LTE?: number | null;
  contactPhone_SHORTEST_EQUAL?: number | null;
  contactPhone_SHORTEST_GT?: number | null;
  contactPhone_SHORTEST_GTE?: number | null;
  contactPhone_SHORTEST_LT?: number | null;
  contactPhone_SHORTEST_LTE?: number | null;
  createdOn_AVERAGE_EQUAL?: number | null;
  createdOn_AVERAGE_GT?: number | null;
  createdOn_AVERAGE_GTE?: number | null;
  createdOn_AVERAGE_LT?: number | null;
  createdOn_AVERAGE_LTE?: number | null;
  createdOn_EQUAL?: number | null;
  createdOn_GT?: number | null;
  createdOn_GTE?: number | null;
  createdOn_LT?: number | null;
  createdOn_LTE?: number | null;
  createdOn_MAX_EQUAL?: number | null;
  createdOn_MAX_GT?: number | null;
  createdOn_MAX_GTE?: number | null;
  createdOn_MAX_LT?: number | null;
  createdOn_MAX_LTE?: number | null;
  createdOn_MIN_EQUAL?: number | null;
  createdOn_MIN_GT?: number | null;
  createdOn_MIN_GTE?: number | null;
  createdOn_MIN_LT?: number | null;
  createdOn_MIN_LTE?: number | null;
  createdOn_SUM_EQUAL?: number | null;
  createdOn_SUM_GT?: number | null;
  createdOn_SUM_GTE?: number | null;
  createdOn_SUM_LT?: number | null;
  createdOn_SUM_LTE?: number | null;
  deliveryAddress_AVERAGE_EQUAL?: number | null;
  deliveryAddress_AVERAGE_GT?: number | null;
  deliveryAddress_AVERAGE_GTE?: number | null;
  deliveryAddress_AVERAGE_LT?: number | null;
  deliveryAddress_AVERAGE_LTE?: number | null;
  deliveryAddress_EQUAL?: string | null;
  deliveryAddress_GT?: number | null;
  deliveryAddress_GTE?: number | null;
  deliveryAddress_LONGEST_EQUAL?: number | null;
  deliveryAddress_LONGEST_GT?: number | null;
  deliveryAddress_LONGEST_GTE?: number | null;
  deliveryAddress_LONGEST_LT?: number | null;
  deliveryAddress_LONGEST_LTE?: number | null;
  deliveryAddress_LT?: number | null;
  deliveryAddress_LTE?: number | null;
  deliveryAddress_SHORTEST_EQUAL?: number | null;
  deliveryAddress_SHORTEST_GT?: number | null;
  deliveryAddress_SHORTEST_GTE?: number | null;
  deliveryAddress_SHORTEST_LT?: number | null;
  deliveryAddress_SHORTEST_LTE?: number | null;
  domicile_AVERAGE_EQUAL?: number | null;
  domicile_AVERAGE_GT?: number | null;
  domicile_AVERAGE_GTE?: number | null;
  domicile_AVERAGE_LT?: number | null;
  domicile_AVERAGE_LTE?: number | null;
  domicile_EQUAL?: string | null;
  domicile_GT?: number | null;
  domicile_GTE?: number | null;
  domicile_LONGEST_EQUAL?: number | null;
  domicile_LONGEST_GT?: number | null;
  domicile_LONGEST_GTE?: number | null;
  domicile_LONGEST_LT?: number | null;
  domicile_LONGEST_LTE?: number | null;
  domicile_LT?: number | null;
  domicile_LTE?: number | null;
  domicile_SHORTEST_EQUAL?: number | null;
  domicile_SHORTEST_GT?: number | null;
  domicile_SHORTEST_GTE?: number | null;
  domicile_SHORTEST_LT?: number | null;
  domicile_SHORTEST_LTE?: number | null;
  dualApprovalThreshold_AVERAGE_EQUAL?: number | null;
  dualApprovalThreshold_AVERAGE_GT?: number | null;
  dualApprovalThreshold_AVERAGE_GTE?: number | null;
  dualApprovalThreshold_AVERAGE_LT?: number | null;
  dualApprovalThreshold_AVERAGE_LTE?: number | null;
  dualApprovalThreshold_EQUAL?: number | null;
  dualApprovalThreshold_GT?: number | null;
  dualApprovalThreshold_GTE?: number | null;
  dualApprovalThreshold_LT?: number | null;
  dualApprovalThreshold_LTE?: number | null;
  dualApprovalThreshold_MAX_EQUAL?: number | null;
  dualApprovalThreshold_MAX_GT?: number | null;
  dualApprovalThreshold_MAX_GTE?: number | null;
  dualApprovalThreshold_MAX_LT?: number | null;
  dualApprovalThreshold_MAX_LTE?: number | null;
  dualApprovalThreshold_MIN_EQUAL?: number | null;
  dualApprovalThreshold_MIN_GT?: number | null;
  dualApprovalThreshold_MIN_GTE?: number | null;
  dualApprovalThreshold_MIN_LT?: number | null;
  dualApprovalThreshold_MIN_LTE?: number | null;
  dualApprovalThreshold_SUM_EQUAL?: number | null;
  dualApprovalThreshold_SUM_GT?: number | null;
  dualApprovalThreshold_SUM_GTE?: number | null;
  dualApprovalThreshold_SUM_LT?: number | null;
  dualApprovalThreshold_SUM_LTE?: number | null;
  eIN_AVERAGE_EQUAL?: number | null;
  eIN_AVERAGE_GT?: number | null;
  eIN_AVERAGE_GTE?: number | null;
  eIN_AVERAGE_LT?: number | null;
  eIN_AVERAGE_LTE?: number | null;
  eIN_EQUAL?: string | null;
  eIN_GT?: number | null;
  eIN_GTE?: number | null;
  eIN_LONGEST_EQUAL?: number | null;
  eIN_LONGEST_GT?: number | null;
  eIN_LONGEST_GTE?: number | null;
  eIN_LONGEST_LT?: number | null;
  eIN_LONGEST_LTE?: number | null;
  eIN_LT?: number | null;
  eIN_LTE?: number | null;
  eIN_SHORTEST_EQUAL?: number | null;
  eIN_SHORTEST_GT?: number | null;
  eIN_SHORTEST_GTE?: number | null;
  eIN_SHORTEST_LT?: number | null;
  eIN_SHORTEST_LTE?: number | null;
  fax_AVERAGE_EQUAL?: number | null;
  fax_AVERAGE_GT?: number | null;
  fax_AVERAGE_GTE?: number | null;
  fax_AVERAGE_LT?: number | null;
  fax_AVERAGE_LTE?: number | null;
  fax_EQUAL?: string | null;
  fax_GT?: number | null;
  fax_GTE?: number | null;
  fax_LONGEST_EQUAL?: number | null;
  fax_LONGEST_GT?: number | null;
  fax_LONGEST_GTE?: number | null;
  fax_LONGEST_LT?: number | null;
  fax_LONGEST_LTE?: number | null;
  fax_LT?: number | null;
  fax_LTE?: number | null;
  fax_SHORTEST_EQUAL?: number | null;
  fax_SHORTEST_GT?: number | null;
  fax_SHORTEST_GTE?: number | null;
  fax_SHORTEST_LT?: number | null;
  fax_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  legalName_AVERAGE_EQUAL?: number | null;
  legalName_AVERAGE_GT?: number | null;
  legalName_AVERAGE_GTE?: number | null;
  legalName_AVERAGE_LT?: number | null;
  legalName_AVERAGE_LTE?: number | null;
  legalName_EQUAL?: string | null;
  legalName_GT?: number | null;
  legalName_GTE?: number | null;
  legalName_LONGEST_EQUAL?: number | null;
  legalName_LONGEST_GT?: number | null;
  legalName_LONGEST_GTE?: number | null;
  legalName_LONGEST_LT?: number | null;
  legalName_LONGEST_LTE?: number | null;
  legalName_LT?: number | null;
  legalName_LTE?: number | null;
  legalName_SHORTEST_EQUAL?: number | null;
  legalName_SHORTEST_GT?: number | null;
  legalName_SHORTEST_GTE?: number | null;
  legalName_SHORTEST_LT?: number | null;
  legalName_SHORTEST_LTE?: number | null;
  logo_AVERAGE_EQUAL?: number | null;
  logo_AVERAGE_GT?: number | null;
  logo_AVERAGE_GTE?: number | null;
  logo_AVERAGE_LT?: number | null;
  logo_AVERAGE_LTE?: number | null;
  logo_EQUAL?: string | null;
  logo_GT?: number | null;
  logo_GTE?: number | null;
  logo_LONGEST_EQUAL?: number | null;
  logo_LONGEST_GT?: number | null;
  logo_LONGEST_GTE?: number | null;
  logo_LONGEST_LT?: number | null;
  logo_LONGEST_LTE?: number | null;
  logo_LT?: number | null;
  logo_LTE?: number | null;
  logo_SHORTEST_EQUAL?: number | null;
  logo_SHORTEST_GT?: number | null;
  logo_SHORTEST_GTE?: number | null;
  logo_SHORTEST_LT?: number | null;
  logo_SHORTEST_LTE?: number | null;
  name_AVERAGE_EQUAL?: number | null;
  name_AVERAGE_GT?: number | null;
  name_AVERAGE_GTE?: number | null;
  name_AVERAGE_LT?: number | null;
  name_AVERAGE_LTE?: number | null;
  name_EQUAL?: string | null;
  name_GT?: number | null;
  name_GTE?: number | null;
  name_LONGEST_EQUAL?: number | null;
  name_LONGEST_GT?: number | null;
  name_LONGEST_GTE?: number | null;
  name_LONGEST_LT?: number | null;
  name_LONGEST_LTE?: number | null;
  name_LT?: number | null;
  name_LTE?: number | null;
  name_SHORTEST_EQUAL?: number | null;
  name_SHORTEST_GT?: number | null;
  name_SHORTEST_GTE?: number | null;
  name_SHORTEST_LT?: number | null;
  name_SHORTEST_LTE?: number | null;
  paymentTerms_AVERAGE_EQUAL?: number | null;
  paymentTerms_AVERAGE_GT?: number | null;
  paymentTerms_AVERAGE_GTE?: number | null;
  paymentTerms_AVERAGE_LT?: number | null;
  paymentTerms_AVERAGE_LTE?: number | null;
  paymentTerms_EQUAL?: number | null;
  paymentTerms_GT?: number | null;
  paymentTerms_GTE?: number | null;
  paymentTerms_LT?: number | null;
  paymentTerms_LTE?: number | null;
  paymentTerms_MAX_EQUAL?: number | null;
  paymentTerms_MAX_GT?: number | null;
  paymentTerms_MAX_GTE?: number | null;
  paymentTerms_MAX_LT?: number | null;
  paymentTerms_MAX_LTE?: number | null;
  paymentTerms_MIN_EQUAL?: number | null;
  paymentTerms_MIN_GT?: number | null;
  paymentTerms_MIN_GTE?: number | null;
  paymentTerms_MIN_LT?: number | null;
  paymentTerms_MIN_LTE?: number | null;
  paymentTerms_SUM_EQUAL?: number | null;
  paymentTerms_SUM_GT?: number | null;
  paymentTerms_SUM_GTE?: number | null;
  paymentTerms_SUM_LT?: number | null;
  paymentTerms_SUM_LTE?: number | null;
  phone_AVERAGE_EQUAL?: number | null;
  phone_AVERAGE_GT?: number | null;
  phone_AVERAGE_GTE?: number | null;
  phone_AVERAGE_LT?: number | null;
  phone_AVERAGE_LTE?: number | null;
  phone_EQUAL?: string | null;
  phone_GT?: number | null;
  phone_GTE?: number | null;
  phone_LONGEST_EQUAL?: number | null;
  phone_LONGEST_GT?: number | null;
  phone_LONGEST_GTE?: number | null;
  phone_LONGEST_LT?: number | null;
  phone_LONGEST_LTE?: number | null;
  phone_LT?: number | null;
  phone_LTE?: number | null;
  phone_SHORTEST_EQUAL?: number | null;
  phone_SHORTEST_GT?: number | null;
  phone_SHORTEST_GTE?: number | null;
  phone_SHORTEST_LT?: number | null;
  phone_SHORTEST_LTE?: number | null;
  tenantId_AVERAGE_EQUAL?: number | null;
  tenantId_AVERAGE_GT?: number | null;
  tenantId_AVERAGE_GTE?: number | null;
  tenantId_AVERAGE_LT?: number | null;
  tenantId_AVERAGE_LTE?: number | null;
  tenantId_EQUAL?: string | null;
  tenantId_GT?: number | null;
  tenantId_GTE?: number | null;
  tenantId_LONGEST_EQUAL?: number | null;
  tenantId_LONGEST_GT?: number | null;
  tenantId_LONGEST_GTE?: number | null;
  tenantId_LONGEST_LT?: number | null;
  tenantId_LONGEST_LTE?: number | null;
  tenantId_LT?: number | null;
  tenantId_LTE?: number | null;
  tenantId_SHORTEST_EQUAL?: number | null;
  tenantId_SHORTEST_GT?: number | null;
  tenantId_SHORTEST_GTE?: number | null;
  tenantId_SHORTEST_LT?: number | null;
  tenantId_SHORTEST_LTE?: number | null;
  website_AVERAGE_EQUAL?: number | null;
  website_AVERAGE_GT?: number | null;
  website_AVERAGE_GTE?: number | null;
  website_AVERAGE_LT?: number | null;
  website_AVERAGE_LTE?: number | null;
  website_EQUAL?: string | null;
  website_GT?: number | null;
  website_GTE?: number | null;
  website_LONGEST_EQUAL?: number | null;
  website_LONGEST_GT?: number | null;
  website_LONGEST_GTE?: number | null;
  website_LONGEST_LT?: number | null;
  website_LONGEST_LTE?: number | null;
  website_LT?: number | null;
  website_LTE?: number | null;
  website_SHORTEST_EQUAL?: number | null;
  website_SHORTEST_GT?: number | null;
  website_SHORTEST_GTE?: number | null;
  website_SHORTEST_LT?: number | null;
  website_SHORTEST_LTE?: number | null;
}

export interface AgreementCurrencyAggregateInput {
  AND?: AgreementCurrencyAggregateInput[] | null;
  OR?: AgreementCurrencyAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: AgreementCurrencyNodeAggregationWhereInput | null;
}

export interface AgreementCurrencyConnectionWhere {
  AND?: AgreementCurrencyConnectionWhere[] | null;
  OR?: AgreementCurrencyConnectionWhere[] | null;
  node?: CurrencyWhere | null;
  node_NOT?: CurrencyWhere | null;
}

export interface AgreementCurrencyNodeAggregationWhereInput {
  AND?: AgreementCurrencyNodeAggregationWhereInput[] | null;
  Code_AVERAGE_EQUAL?: number | null;
  Code_AVERAGE_GT?: number | null;
  Code_AVERAGE_GTE?: number | null;
  Code_AVERAGE_LT?: number | null;
  Code_AVERAGE_LTE?: number | null;
  Code_EQUAL?: string | null;
  Code_GT?: number | null;
  Code_GTE?: number | null;
  Code_LONGEST_EQUAL?: number | null;
  Code_LONGEST_GT?: number | null;
  Code_LONGEST_GTE?: number | null;
  Code_LONGEST_LT?: number | null;
  Code_LONGEST_LTE?: number | null;
  Code_LT?: number | null;
  Code_LTE?: number | null;
  Code_SHORTEST_EQUAL?: number | null;
  Code_SHORTEST_GT?: number | null;
  Code_SHORTEST_GTE?: number | null;
  Code_SHORTEST_LT?: number | null;
  Code_SHORTEST_LTE?: number | null;
  Name_AVERAGE_EQUAL?: number | null;
  Name_AVERAGE_GT?: number | null;
  Name_AVERAGE_GTE?: number | null;
  Name_AVERAGE_LT?: number | null;
  Name_AVERAGE_LTE?: number | null;
  Name_EQUAL?: string | null;
  Name_GT?: number | null;
  Name_GTE?: number | null;
  Name_LONGEST_EQUAL?: number | null;
  Name_LONGEST_GT?: number | null;
  Name_LONGEST_GTE?: number | null;
  Name_LONGEST_LT?: number | null;
  Name_LONGEST_LTE?: number | null;
  Name_LT?: number | null;
  Name_LTE?: number | null;
  Name_SHORTEST_EQUAL?: number | null;
  Name_SHORTEST_GT?: number | null;
  Name_SHORTEST_GTE?: number | null;
  Name_SHORTEST_LT?: number | null;
  Name_SHORTEST_LTE?: number | null;
  OR?: AgreementCurrencyNodeAggregationWhereInput[] | null;
  symbol_AVERAGE_EQUAL?: number | null;
  symbol_AVERAGE_GT?: number | null;
  symbol_AVERAGE_GTE?: number | null;
  symbol_AVERAGE_LT?: number | null;
  symbol_AVERAGE_LTE?: number | null;
  symbol_EQUAL?: string | null;
  symbol_GT?: number | null;
  symbol_GTE?: number | null;
  symbol_LONGEST_EQUAL?: number | null;
  symbol_LONGEST_GT?: number | null;
  symbol_LONGEST_GTE?: number | null;
  symbol_LONGEST_LT?: number | null;
  symbol_LONGEST_LTE?: number | null;
  symbol_LT?: number | null;
  symbol_LTE?: number | null;
  symbol_SHORTEST_EQUAL?: number | null;
  symbol_SHORTEST_GT?: number | null;
  symbol_SHORTEST_GTE?: number | null;
  symbol_SHORTEST_LT?: number | null;
  symbol_SHORTEST_LTE?: number | null;
}

export interface AgreementDataContainersAggregateInput {
  AND?: AgreementDataContainersAggregateInput[] | null;
  OR?: AgreementDataContainersAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: AgreementDataContainersNodeAggregationWhereInput | null;
}

export interface AgreementDataContainersConnectionWhere {
  AND?: AgreementDataContainersConnectionWhere[] | null;
  OR?: AgreementDataContainersConnectionWhere[] | null;
  node?: DataContainerWhere | null;
  node_NOT?: DataContainerWhere | null;
}

export interface AgreementDataContainersNodeAggregationWhereInput {
  AND?: AgreementDataContainersNodeAggregationWhereInput[] | null;
  OR?: AgreementDataContainersNodeAggregationWhereInput[] | null;
  subType_AVERAGE_EQUAL?: number | null;
  subType_AVERAGE_GT?: number | null;
  subType_AVERAGE_GTE?: number | null;
  subType_AVERAGE_LT?: number | null;
  subType_AVERAGE_LTE?: number | null;
  subType_EQUAL?: string | null;
  subType_GT?: number | null;
  subType_GTE?: number | null;
  subType_LONGEST_EQUAL?: number | null;
  subType_LONGEST_GT?: number | null;
  subType_LONGEST_GTE?: number | null;
  subType_LONGEST_LT?: number | null;
  subType_LONGEST_LTE?: number | null;
  subType_LT?: number | null;
  subType_LTE?: number | null;
  subType_SHORTEST_EQUAL?: number | null;
  subType_SHORTEST_GT?: number | null;
  subType_SHORTEST_GTE?: number | null;
  subType_SHORTEST_LT?: number | null;
  subType_SHORTEST_LTE?: number | null;
  timeframeEnd_AVERAGE_EQUAL?: number | null;
  timeframeEnd_AVERAGE_GT?: number | null;
  timeframeEnd_AVERAGE_GTE?: number | null;
  timeframeEnd_AVERAGE_LT?: number | null;
  timeframeEnd_AVERAGE_LTE?: number | null;
  timeframeEnd_EQUAL?: number | null;
  timeframeEnd_GT?: number | null;
  timeframeEnd_GTE?: number | null;
  timeframeEnd_LT?: number | null;
  timeframeEnd_LTE?: number | null;
  timeframeEnd_MAX_EQUAL?: number | null;
  timeframeEnd_MAX_GT?: number | null;
  timeframeEnd_MAX_GTE?: number | null;
  timeframeEnd_MAX_LT?: number | null;
  timeframeEnd_MAX_LTE?: number | null;
  timeframeEnd_MIN_EQUAL?: number | null;
  timeframeEnd_MIN_GT?: number | null;
  timeframeEnd_MIN_GTE?: number | null;
  timeframeEnd_MIN_LT?: number | null;
  timeframeEnd_MIN_LTE?: number | null;
  timeframeEnd_SUM_EQUAL?: number | null;
  timeframeEnd_SUM_GT?: number | null;
  timeframeEnd_SUM_GTE?: number | null;
  timeframeEnd_SUM_LT?: number | null;
  timeframeEnd_SUM_LTE?: number | null;
  timeframeStart_AVERAGE_EQUAL?: number | null;
  timeframeStart_AVERAGE_GT?: number | null;
  timeframeStart_AVERAGE_GTE?: number | null;
  timeframeStart_AVERAGE_LT?: number | null;
  timeframeStart_AVERAGE_LTE?: number | null;
  timeframeStart_EQUAL?: number | null;
  timeframeStart_GT?: number | null;
  timeframeStart_GTE?: number | null;
  timeframeStart_LT?: number | null;
  timeframeStart_LTE?: number | null;
  timeframeStart_MAX_EQUAL?: number | null;
  timeframeStart_MAX_GT?: number | null;
  timeframeStart_MAX_GTE?: number | null;
  timeframeStart_MAX_LT?: number | null;
  timeframeStart_MAX_LTE?: number | null;
  timeframeStart_MIN_EQUAL?: number | null;
  timeframeStart_MIN_GT?: number | null;
  timeframeStart_MIN_GTE?: number | null;
  timeframeStart_MIN_LT?: number | null;
  timeframeStart_MIN_LTE?: number | null;
  timeframeStart_SUM_EQUAL?: number | null;
  timeframeStart_SUM_GT?: number | null;
  timeframeStart_SUM_GTE?: number | null;
  timeframeStart_SUM_LT?: number | null;
  timeframeStart_SUM_LTE?: number | null;
}

export interface AgreementDecisionAsOfAggregateInput {
  AND?: AgreementDecisionAsOfAggregateInput[] | null;
  OR?: AgreementDecisionAsOfAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: AgreementDecisionAsOfNodeAggregationWhereInput | null;
}

export interface AgreementDecisionAsOfConnectionWhere {
  AND?: AgreementDecisionAsOfConnectionWhere[] | null;
  OR?: AgreementDecisionAsOfConnectionWhere[] | null;
  node?: OrganizationWhere | null;
  node_NOT?: OrganizationWhere | null;
}

export interface AgreementDecisionAsOfNodeAggregationWhereInput {
  AND?: AgreementDecisionAsOfNodeAggregationWhereInput[] | null;
  BIC_AVERAGE_EQUAL?: number | null;
  BIC_AVERAGE_GT?: number | null;
  BIC_AVERAGE_GTE?: number | null;
  BIC_AVERAGE_LT?: number | null;
  BIC_AVERAGE_LTE?: number | null;
  BIC_EQUAL?: string | null;
  BIC_GT?: number | null;
  BIC_GTE?: number | null;
  BIC_LONGEST_EQUAL?: number | null;
  BIC_LONGEST_GT?: number | null;
  BIC_LONGEST_GTE?: number | null;
  BIC_LONGEST_LT?: number | null;
  BIC_LONGEST_LTE?: number | null;
  BIC_LT?: number | null;
  BIC_LTE?: number | null;
  BIC_SHORTEST_EQUAL?: number | null;
  BIC_SHORTEST_GT?: number | null;
  BIC_SHORTEST_GTE?: number | null;
  BIC_SHORTEST_LT?: number | null;
  BIC_SHORTEST_LTE?: number | null;
  IBAN_AVERAGE_EQUAL?: number | null;
  IBAN_AVERAGE_GT?: number | null;
  IBAN_AVERAGE_GTE?: number | null;
  IBAN_AVERAGE_LT?: number | null;
  IBAN_AVERAGE_LTE?: number | null;
  IBAN_EQUAL?: string | null;
  IBAN_GT?: number | null;
  IBAN_GTE?: number | null;
  IBAN_LONGEST_EQUAL?: number | null;
  IBAN_LONGEST_GT?: number | null;
  IBAN_LONGEST_GTE?: number | null;
  IBAN_LONGEST_LT?: number | null;
  IBAN_LONGEST_LTE?: number | null;
  IBAN_LT?: number | null;
  IBAN_LTE?: number | null;
  IBAN_SHORTEST_EQUAL?: number | null;
  IBAN_SHORTEST_GT?: number | null;
  IBAN_SHORTEST_GTE?: number | null;
  IBAN_SHORTEST_LT?: number | null;
  IBAN_SHORTEST_LTE?: number | null;
  OR?: AgreementDecisionAsOfNodeAggregationWhereInput[] | null;
  accountName_AVERAGE_EQUAL?: number | null;
  accountName_AVERAGE_GT?: number | null;
  accountName_AVERAGE_GTE?: number | null;
  accountName_AVERAGE_LT?: number | null;
  accountName_AVERAGE_LTE?: number | null;
  accountName_EQUAL?: string | null;
  accountName_GT?: number | null;
  accountName_GTE?: number | null;
  accountName_LONGEST_EQUAL?: number | null;
  accountName_LONGEST_GT?: number | null;
  accountName_LONGEST_GTE?: number | null;
  accountName_LONGEST_LT?: number | null;
  accountName_LONGEST_LTE?: number | null;
  accountName_LT?: number | null;
  accountName_LTE?: number | null;
  accountName_SHORTEST_EQUAL?: number | null;
  accountName_SHORTEST_GT?: number | null;
  accountName_SHORTEST_GTE?: number | null;
  accountName_SHORTEST_LT?: number | null;
  accountName_SHORTEST_LTE?: number | null;
  accountNumber_AVERAGE_EQUAL?: number | null;
  accountNumber_AVERAGE_GT?: number | null;
  accountNumber_AVERAGE_GTE?: number | null;
  accountNumber_AVERAGE_LT?: number | null;
  accountNumber_AVERAGE_LTE?: number | null;
  accountNumber_EQUAL?: string | null;
  accountNumber_GT?: number | null;
  accountNumber_GTE?: number | null;
  accountNumber_LONGEST_EQUAL?: number | null;
  accountNumber_LONGEST_GT?: number | null;
  accountNumber_LONGEST_GTE?: number | null;
  accountNumber_LONGEST_LT?: number | null;
  accountNumber_LONGEST_LTE?: number | null;
  accountNumber_LT?: number | null;
  accountNumber_LTE?: number | null;
  accountNumber_SHORTEST_EQUAL?: number | null;
  accountNumber_SHORTEST_GT?: number | null;
  accountNumber_SHORTEST_GTE?: number | null;
  accountNumber_SHORTEST_LT?: number | null;
  accountNumber_SHORTEST_LTE?: number | null;
  billingAddress_AVERAGE_EQUAL?: number | null;
  billingAddress_AVERAGE_GT?: number | null;
  billingAddress_AVERAGE_GTE?: number | null;
  billingAddress_AVERAGE_LT?: number | null;
  billingAddress_AVERAGE_LTE?: number | null;
  billingAddress_EQUAL?: string | null;
  billingAddress_GT?: number | null;
  billingAddress_GTE?: number | null;
  billingAddress_LONGEST_EQUAL?: number | null;
  billingAddress_LONGEST_GT?: number | null;
  billingAddress_LONGEST_GTE?: number | null;
  billingAddress_LONGEST_LT?: number | null;
  billingAddress_LONGEST_LTE?: number | null;
  billingAddress_LT?: number | null;
  billingAddress_LTE?: number | null;
  billingAddress_SHORTEST_EQUAL?: number | null;
  billingAddress_SHORTEST_GT?: number | null;
  billingAddress_SHORTEST_GTE?: number | null;
  billingAddress_SHORTEST_LT?: number | null;
  billingAddress_SHORTEST_LTE?: number | null;
  contactEmail_AVERAGE_EQUAL?: number | null;
  contactEmail_AVERAGE_GT?: number | null;
  contactEmail_AVERAGE_GTE?: number | null;
  contactEmail_AVERAGE_LT?: number | null;
  contactEmail_AVERAGE_LTE?: number | null;
  contactEmail_EQUAL?: string | null;
  contactEmail_GT?: number | null;
  contactEmail_GTE?: number | null;
  contactEmail_LONGEST_EQUAL?: number | null;
  contactEmail_LONGEST_GT?: number | null;
  contactEmail_LONGEST_GTE?: number | null;
  contactEmail_LONGEST_LT?: number | null;
  contactEmail_LONGEST_LTE?: number | null;
  contactEmail_LT?: number | null;
  contactEmail_LTE?: number | null;
  contactEmail_SHORTEST_EQUAL?: number | null;
  contactEmail_SHORTEST_GT?: number | null;
  contactEmail_SHORTEST_GTE?: number | null;
  contactEmail_SHORTEST_LT?: number | null;
  contactEmail_SHORTEST_LTE?: number | null;
  contactFirstName_AVERAGE_EQUAL?: number | null;
  contactFirstName_AVERAGE_GT?: number | null;
  contactFirstName_AVERAGE_GTE?: number | null;
  contactFirstName_AVERAGE_LT?: number | null;
  contactFirstName_AVERAGE_LTE?: number | null;
  contactFirstName_EQUAL?: string | null;
  contactFirstName_GT?: number | null;
  contactFirstName_GTE?: number | null;
  contactFirstName_LONGEST_EQUAL?: number | null;
  contactFirstName_LONGEST_GT?: number | null;
  contactFirstName_LONGEST_GTE?: number | null;
  contactFirstName_LONGEST_LT?: number | null;
  contactFirstName_LONGEST_LTE?: number | null;
  contactFirstName_LT?: number | null;
  contactFirstName_LTE?: number | null;
  contactFirstName_SHORTEST_EQUAL?: number | null;
  contactFirstName_SHORTEST_GT?: number | null;
  contactFirstName_SHORTEST_GTE?: number | null;
  contactFirstName_SHORTEST_LT?: number | null;
  contactFirstName_SHORTEST_LTE?: number | null;
  contactLastName_AVERAGE_EQUAL?: number | null;
  contactLastName_AVERAGE_GT?: number | null;
  contactLastName_AVERAGE_GTE?: number | null;
  contactLastName_AVERAGE_LT?: number | null;
  contactLastName_AVERAGE_LTE?: number | null;
  contactLastName_EQUAL?: string | null;
  contactLastName_GT?: number | null;
  contactLastName_GTE?: number | null;
  contactLastName_LONGEST_EQUAL?: number | null;
  contactLastName_LONGEST_GT?: number | null;
  contactLastName_LONGEST_GTE?: number | null;
  contactLastName_LONGEST_LT?: number | null;
  contactLastName_LONGEST_LTE?: number | null;
  contactLastName_LT?: number | null;
  contactLastName_LTE?: number | null;
  contactLastName_SHORTEST_EQUAL?: number | null;
  contactLastName_SHORTEST_GT?: number | null;
  contactLastName_SHORTEST_GTE?: number | null;
  contactLastName_SHORTEST_LT?: number | null;
  contactLastName_SHORTEST_LTE?: number | null;
  contactOccupation_AVERAGE_EQUAL?: number | null;
  contactOccupation_AVERAGE_GT?: number | null;
  contactOccupation_AVERAGE_GTE?: number | null;
  contactOccupation_AVERAGE_LT?: number | null;
  contactOccupation_AVERAGE_LTE?: number | null;
  contactOccupation_EQUAL?: string | null;
  contactOccupation_GT?: number | null;
  contactOccupation_GTE?: number | null;
  contactOccupation_LONGEST_EQUAL?: number | null;
  contactOccupation_LONGEST_GT?: number | null;
  contactOccupation_LONGEST_GTE?: number | null;
  contactOccupation_LONGEST_LT?: number | null;
  contactOccupation_LONGEST_LTE?: number | null;
  contactOccupation_LT?: number | null;
  contactOccupation_LTE?: number | null;
  contactOccupation_SHORTEST_EQUAL?: number | null;
  contactOccupation_SHORTEST_GT?: number | null;
  contactOccupation_SHORTEST_GTE?: number | null;
  contactOccupation_SHORTEST_LT?: number | null;
  contactOccupation_SHORTEST_LTE?: number | null;
  contactPhone_AVERAGE_EQUAL?: number | null;
  contactPhone_AVERAGE_GT?: number | null;
  contactPhone_AVERAGE_GTE?: number | null;
  contactPhone_AVERAGE_LT?: number | null;
  contactPhone_AVERAGE_LTE?: number | null;
  contactPhone_EQUAL?: string | null;
  contactPhone_GT?: number | null;
  contactPhone_GTE?: number | null;
  contactPhone_LONGEST_EQUAL?: number | null;
  contactPhone_LONGEST_GT?: number | null;
  contactPhone_LONGEST_GTE?: number | null;
  contactPhone_LONGEST_LT?: number | null;
  contactPhone_LONGEST_LTE?: number | null;
  contactPhone_LT?: number | null;
  contactPhone_LTE?: number | null;
  contactPhone_SHORTEST_EQUAL?: number | null;
  contactPhone_SHORTEST_GT?: number | null;
  contactPhone_SHORTEST_GTE?: number | null;
  contactPhone_SHORTEST_LT?: number | null;
  contactPhone_SHORTEST_LTE?: number | null;
  createdOn_AVERAGE_EQUAL?: number | null;
  createdOn_AVERAGE_GT?: number | null;
  createdOn_AVERAGE_GTE?: number | null;
  createdOn_AVERAGE_LT?: number | null;
  createdOn_AVERAGE_LTE?: number | null;
  createdOn_EQUAL?: number | null;
  createdOn_GT?: number | null;
  createdOn_GTE?: number | null;
  createdOn_LT?: number | null;
  createdOn_LTE?: number | null;
  createdOn_MAX_EQUAL?: number | null;
  createdOn_MAX_GT?: number | null;
  createdOn_MAX_GTE?: number | null;
  createdOn_MAX_LT?: number | null;
  createdOn_MAX_LTE?: number | null;
  createdOn_MIN_EQUAL?: number | null;
  createdOn_MIN_GT?: number | null;
  createdOn_MIN_GTE?: number | null;
  createdOn_MIN_LT?: number | null;
  createdOn_MIN_LTE?: number | null;
  createdOn_SUM_EQUAL?: number | null;
  createdOn_SUM_GT?: number | null;
  createdOn_SUM_GTE?: number | null;
  createdOn_SUM_LT?: number | null;
  createdOn_SUM_LTE?: number | null;
  deliveryAddress_AVERAGE_EQUAL?: number | null;
  deliveryAddress_AVERAGE_GT?: number | null;
  deliveryAddress_AVERAGE_GTE?: number | null;
  deliveryAddress_AVERAGE_LT?: number | null;
  deliveryAddress_AVERAGE_LTE?: number | null;
  deliveryAddress_EQUAL?: string | null;
  deliveryAddress_GT?: number | null;
  deliveryAddress_GTE?: number | null;
  deliveryAddress_LONGEST_EQUAL?: number | null;
  deliveryAddress_LONGEST_GT?: number | null;
  deliveryAddress_LONGEST_GTE?: number | null;
  deliveryAddress_LONGEST_LT?: number | null;
  deliveryAddress_LONGEST_LTE?: number | null;
  deliveryAddress_LT?: number | null;
  deliveryAddress_LTE?: number | null;
  deliveryAddress_SHORTEST_EQUAL?: number | null;
  deliveryAddress_SHORTEST_GT?: number | null;
  deliveryAddress_SHORTEST_GTE?: number | null;
  deliveryAddress_SHORTEST_LT?: number | null;
  deliveryAddress_SHORTEST_LTE?: number | null;
  domicile_AVERAGE_EQUAL?: number | null;
  domicile_AVERAGE_GT?: number | null;
  domicile_AVERAGE_GTE?: number | null;
  domicile_AVERAGE_LT?: number | null;
  domicile_AVERAGE_LTE?: number | null;
  domicile_EQUAL?: string | null;
  domicile_GT?: number | null;
  domicile_GTE?: number | null;
  domicile_LONGEST_EQUAL?: number | null;
  domicile_LONGEST_GT?: number | null;
  domicile_LONGEST_GTE?: number | null;
  domicile_LONGEST_LT?: number | null;
  domicile_LONGEST_LTE?: number | null;
  domicile_LT?: number | null;
  domicile_LTE?: number | null;
  domicile_SHORTEST_EQUAL?: number | null;
  domicile_SHORTEST_GT?: number | null;
  domicile_SHORTEST_GTE?: number | null;
  domicile_SHORTEST_LT?: number | null;
  domicile_SHORTEST_LTE?: number | null;
  dualApprovalThreshold_AVERAGE_EQUAL?: number | null;
  dualApprovalThreshold_AVERAGE_GT?: number | null;
  dualApprovalThreshold_AVERAGE_GTE?: number | null;
  dualApprovalThreshold_AVERAGE_LT?: number | null;
  dualApprovalThreshold_AVERAGE_LTE?: number | null;
  dualApprovalThreshold_EQUAL?: number | null;
  dualApprovalThreshold_GT?: number | null;
  dualApprovalThreshold_GTE?: number | null;
  dualApprovalThreshold_LT?: number | null;
  dualApprovalThreshold_LTE?: number | null;
  dualApprovalThreshold_MAX_EQUAL?: number | null;
  dualApprovalThreshold_MAX_GT?: number | null;
  dualApprovalThreshold_MAX_GTE?: number | null;
  dualApprovalThreshold_MAX_LT?: number | null;
  dualApprovalThreshold_MAX_LTE?: number | null;
  dualApprovalThreshold_MIN_EQUAL?: number | null;
  dualApprovalThreshold_MIN_GT?: number | null;
  dualApprovalThreshold_MIN_GTE?: number | null;
  dualApprovalThreshold_MIN_LT?: number | null;
  dualApprovalThreshold_MIN_LTE?: number | null;
  dualApprovalThreshold_SUM_EQUAL?: number | null;
  dualApprovalThreshold_SUM_GT?: number | null;
  dualApprovalThreshold_SUM_GTE?: number | null;
  dualApprovalThreshold_SUM_LT?: number | null;
  dualApprovalThreshold_SUM_LTE?: number | null;
  eIN_AVERAGE_EQUAL?: number | null;
  eIN_AVERAGE_GT?: number | null;
  eIN_AVERAGE_GTE?: number | null;
  eIN_AVERAGE_LT?: number | null;
  eIN_AVERAGE_LTE?: number | null;
  eIN_EQUAL?: string | null;
  eIN_GT?: number | null;
  eIN_GTE?: number | null;
  eIN_LONGEST_EQUAL?: number | null;
  eIN_LONGEST_GT?: number | null;
  eIN_LONGEST_GTE?: number | null;
  eIN_LONGEST_LT?: number | null;
  eIN_LONGEST_LTE?: number | null;
  eIN_LT?: number | null;
  eIN_LTE?: number | null;
  eIN_SHORTEST_EQUAL?: number | null;
  eIN_SHORTEST_GT?: number | null;
  eIN_SHORTEST_GTE?: number | null;
  eIN_SHORTEST_LT?: number | null;
  eIN_SHORTEST_LTE?: number | null;
  fax_AVERAGE_EQUAL?: number | null;
  fax_AVERAGE_GT?: number | null;
  fax_AVERAGE_GTE?: number | null;
  fax_AVERAGE_LT?: number | null;
  fax_AVERAGE_LTE?: number | null;
  fax_EQUAL?: string | null;
  fax_GT?: number | null;
  fax_GTE?: number | null;
  fax_LONGEST_EQUAL?: number | null;
  fax_LONGEST_GT?: number | null;
  fax_LONGEST_GTE?: number | null;
  fax_LONGEST_LT?: number | null;
  fax_LONGEST_LTE?: number | null;
  fax_LT?: number | null;
  fax_LTE?: number | null;
  fax_SHORTEST_EQUAL?: number | null;
  fax_SHORTEST_GT?: number | null;
  fax_SHORTEST_GTE?: number | null;
  fax_SHORTEST_LT?: number | null;
  fax_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  legalName_AVERAGE_EQUAL?: number | null;
  legalName_AVERAGE_GT?: number | null;
  legalName_AVERAGE_GTE?: number | null;
  legalName_AVERAGE_LT?: number | null;
  legalName_AVERAGE_LTE?: number | null;
  legalName_EQUAL?: string | null;
  legalName_GT?: number | null;
  legalName_GTE?: number | null;
  legalName_LONGEST_EQUAL?: number | null;
  legalName_LONGEST_GT?: number | null;
  legalName_LONGEST_GTE?: number | null;
  legalName_LONGEST_LT?: number | null;
  legalName_LONGEST_LTE?: number | null;
  legalName_LT?: number | null;
  legalName_LTE?: number | null;
  legalName_SHORTEST_EQUAL?: number | null;
  legalName_SHORTEST_GT?: number | null;
  legalName_SHORTEST_GTE?: number | null;
  legalName_SHORTEST_LT?: number | null;
  legalName_SHORTEST_LTE?: number | null;
  logo_AVERAGE_EQUAL?: number | null;
  logo_AVERAGE_GT?: number | null;
  logo_AVERAGE_GTE?: number | null;
  logo_AVERAGE_LT?: number | null;
  logo_AVERAGE_LTE?: number | null;
  logo_EQUAL?: string | null;
  logo_GT?: number | null;
  logo_GTE?: number | null;
  logo_LONGEST_EQUAL?: number | null;
  logo_LONGEST_GT?: number | null;
  logo_LONGEST_GTE?: number | null;
  logo_LONGEST_LT?: number | null;
  logo_LONGEST_LTE?: number | null;
  logo_LT?: number | null;
  logo_LTE?: number | null;
  logo_SHORTEST_EQUAL?: number | null;
  logo_SHORTEST_GT?: number | null;
  logo_SHORTEST_GTE?: number | null;
  logo_SHORTEST_LT?: number | null;
  logo_SHORTEST_LTE?: number | null;
  name_AVERAGE_EQUAL?: number | null;
  name_AVERAGE_GT?: number | null;
  name_AVERAGE_GTE?: number | null;
  name_AVERAGE_LT?: number | null;
  name_AVERAGE_LTE?: number | null;
  name_EQUAL?: string | null;
  name_GT?: number | null;
  name_GTE?: number | null;
  name_LONGEST_EQUAL?: number | null;
  name_LONGEST_GT?: number | null;
  name_LONGEST_GTE?: number | null;
  name_LONGEST_LT?: number | null;
  name_LONGEST_LTE?: number | null;
  name_LT?: number | null;
  name_LTE?: number | null;
  name_SHORTEST_EQUAL?: number | null;
  name_SHORTEST_GT?: number | null;
  name_SHORTEST_GTE?: number | null;
  name_SHORTEST_LT?: number | null;
  name_SHORTEST_LTE?: number | null;
  paymentTerms_AVERAGE_EQUAL?: number | null;
  paymentTerms_AVERAGE_GT?: number | null;
  paymentTerms_AVERAGE_GTE?: number | null;
  paymentTerms_AVERAGE_LT?: number | null;
  paymentTerms_AVERAGE_LTE?: number | null;
  paymentTerms_EQUAL?: number | null;
  paymentTerms_GT?: number | null;
  paymentTerms_GTE?: number | null;
  paymentTerms_LT?: number | null;
  paymentTerms_LTE?: number | null;
  paymentTerms_MAX_EQUAL?: number | null;
  paymentTerms_MAX_GT?: number | null;
  paymentTerms_MAX_GTE?: number | null;
  paymentTerms_MAX_LT?: number | null;
  paymentTerms_MAX_LTE?: number | null;
  paymentTerms_MIN_EQUAL?: number | null;
  paymentTerms_MIN_GT?: number | null;
  paymentTerms_MIN_GTE?: number | null;
  paymentTerms_MIN_LT?: number | null;
  paymentTerms_MIN_LTE?: number | null;
  paymentTerms_SUM_EQUAL?: number | null;
  paymentTerms_SUM_GT?: number | null;
  paymentTerms_SUM_GTE?: number | null;
  paymentTerms_SUM_LT?: number | null;
  paymentTerms_SUM_LTE?: number | null;
  phone_AVERAGE_EQUAL?: number | null;
  phone_AVERAGE_GT?: number | null;
  phone_AVERAGE_GTE?: number | null;
  phone_AVERAGE_LT?: number | null;
  phone_AVERAGE_LTE?: number | null;
  phone_EQUAL?: string | null;
  phone_GT?: number | null;
  phone_GTE?: number | null;
  phone_LONGEST_EQUAL?: number | null;
  phone_LONGEST_GT?: number | null;
  phone_LONGEST_GTE?: number | null;
  phone_LONGEST_LT?: number | null;
  phone_LONGEST_LTE?: number | null;
  phone_LT?: number | null;
  phone_LTE?: number | null;
  phone_SHORTEST_EQUAL?: number | null;
  phone_SHORTEST_GT?: number | null;
  phone_SHORTEST_GTE?: number | null;
  phone_SHORTEST_LT?: number | null;
  phone_SHORTEST_LTE?: number | null;
  tenantId_AVERAGE_EQUAL?: number | null;
  tenantId_AVERAGE_GT?: number | null;
  tenantId_AVERAGE_GTE?: number | null;
  tenantId_AVERAGE_LT?: number | null;
  tenantId_AVERAGE_LTE?: number | null;
  tenantId_EQUAL?: string | null;
  tenantId_GT?: number | null;
  tenantId_GTE?: number | null;
  tenantId_LONGEST_EQUAL?: number | null;
  tenantId_LONGEST_GT?: number | null;
  tenantId_LONGEST_GTE?: number | null;
  tenantId_LONGEST_LT?: number | null;
  tenantId_LONGEST_LTE?: number | null;
  tenantId_LT?: number | null;
  tenantId_LTE?: number | null;
  tenantId_SHORTEST_EQUAL?: number | null;
  tenantId_SHORTEST_GT?: number | null;
  tenantId_SHORTEST_GTE?: number | null;
  tenantId_SHORTEST_LT?: number | null;
  tenantId_SHORTEST_LTE?: number | null;
  website_AVERAGE_EQUAL?: number | null;
  website_AVERAGE_GT?: number | null;
  website_AVERAGE_GTE?: number | null;
  website_AVERAGE_LT?: number | null;
  website_AVERAGE_LTE?: number | null;
  website_EQUAL?: string | null;
  website_GT?: number | null;
  website_GTE?: number | null;
  website_LONGEST_EQUAL?: number | null;
  website_LONGEST_GT?: number | null;
  website_LONGEST_GTE?: number | null;
  website_LONGEST_LT?: number | null;
  website_LONGEST_LTE?: number | null;
  website_LT?: number | null;
  website_LTE?: number | null;
  website_SHORTEST_EQUAL?: number | null;
  website_SHORTEST_GT?: number | null;
  website_SHORTEST_GTE?: number | null;
  website_SHORTEST_LT?: number | null;
  website_SHORTEST_LTE?: number | null;
}

export interface AgreementDecisionInput {
  agreementId: string;
  decision: Decision;
}

export interface AgreementDecisionMadeByAggregateInput {
  AND?: AgreementDecisionMadeByAggregateInput[] | null;
  OR?: AgreementDecisionMadeByAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: AgreementDecisionMadeByNodeAggregationWhereInput | null;
}

export interface AgreementDecisionMadeByConnectionWhere {
  AND?: AgreementDecisionMadeByConnectionWhere[] | null;
  OR?: AgreementDecisionMadeByConnectionWhere[] | null;
  node?: UserWhere | null;
  node_NOT?: UserWhere | null;
}

export interface AgreementDecisionMadeByNodeAggregationWhereInput {
  AND?: AgreementDecisionMadeByNodeAggregationWhereInput[] | null;
  OR?: AgreementDecisionMadeByNodeAggregationWhereInput[] | null;
  deletedOn_EQUAL?: any | null;
  deletedOn_GT?: any | null;
  deletedOn_GTE?: any | null;
  deletedOn_LT?: any | null;
  deletedOn_LTE?: any | null;
  deletedOn_MAX_EQUAL?: any | null;
  deletedOn_MAX_GT?: any | null;
  deletedOn_MAX_GTE?: any | null;
  deletedOn_MAX_LT?: any | null;
  deletedOn_MAX_LTE?: any | null;
  deletedOn_MIN_EQUAL?: any | null;
  deletedOn_MIN_GT?: any | null;
  deletedOn_MIN_GTE?: any | null;
  deletedOn_MIN_LT?: any | null;
  deletedOn_MIN_LTE?: any | null;
  department_AVERAGE_EQUAL?: number | null;
  department_AVERAGE_GT?: number | null;
  department_AVERAGE_GTE?: number | null;
  department_AVERAGE_LT?: number | null;
  department_AVERAGE_LTE?: number | null;
  department_EQUAL?: string | null;
  department_GT?: number | null;
  department_GTE?: number | null;
  department_LONGEST_EQUAL?: number | null;
  department_LONGEST_GT?: number | null;
  department_LONGEST_GTE?: number | null;
  department_LONGEST_LT?: number | null;
  department_LONGEST_LTE?: number | null;
  department_LT?: number | null;
  department_LTE?: number | null;
  department_SHORTEST_EQUAL?: number | null;
  department_SHORTEST_GT?: number | null;
  department_SHORTEST_GTE?: number | null;
  department_SHORTEST_LT?: number | null;
  department_SHORTEST_LTE?: number | null;
  email_AVERAGE_EQUAL?: number | null;
  email_AVERAGE_GT?: number | null;
  email_AVERAGE_GTE?: number | null;
  email_AVERAGE_LT?: number | null;
  email_AVERAGE_LTE?: number | null;
  email_EQUAL?: string | null;
  email_GT?: number | null;
  email_GTE?: number | null;
  email_LONGEST_EQUAL?: number | null;
  email_LONGEST_GT?: number | null;
  email_LONGEST_GTE?: number | null;
  email_LONGEST_LT?: number | null;
  email_LONGEST_LTE?: number | null;
  email_LT?: number | null;
  email_LTE?: number | null;
  email_SHORTEST_EQUAL?: number | null;
  email_SHORTEST_GT?: number | null;
  email_SHORTEST_GTE?: number | null;
  email_SHORTEST_LT?: number | null;
  email_SHORTEST_LTE?: number | null;
  firstName_AVERAGE_EQUAL?: number | null;
  firstName_AVERAGE_GT?: number | null;
  firstName_AVERAGE_GTE?: number | null;
  firstName_AVERAGE_LT?: number | null;
  firstName_AVERAGE_LTE?: number | null;
  firstName_EQUAL?: string | null;
  firstName_GT?: number | null;
  firstName_GTE?: number | null;
  firstName_LONGEST_EQUAL?: number | null;
  firstName_LONGEST_GT?: number | null;
  firstName_LONGEST_GTE?: number | null;
  firstName_LONGEST_LT?: number | null;
  firstName_LONGEST_LTE?: number | null;
  firstName_LT?: number | null;
  firstName_LTE?: number | null;
  firstName_SHORTEST_EQUAL?: number | null;
  firstName_SHORTEST_GT?: number | null;
  firstName_SHORTEST_GTE?: number | null;
  firstName_SHORTEST_LT?: number | null;
  firstName_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  lastName_AVERAGE_EQUAL?: number | null;
  lastName_AVERAGE_GT?: number | null;
  lastName_AVERAGE_GTE?: number | null;
  lastName_AVERAGE_LT?: number | null;
  lastName_AVERAGE_LTE?: number | null;
  lastName_EQUAL?: string | null;
  lastName_GT?: number | null;
  lastName_GTE?: number | null;
  lastName_LONGEST_EQUAL?: number | null;
  lastName_LONGEST_GT?: number | null;
  lastName_LONGEST_GTE?: number | null;
  lastName_LONGEST_LT?: number | null;
  lastName_LONGEST_LTE?: number | null;
  lastName_LT?: number | null;
  lastName_LTE?: number | null;
  lastName_SHORTEST_EQUAL?: number | null;
  lastName_SHORTEST_GT?: number | null;
  lastName_SHORTEST_GTE?: number | null;
  lastName_SHORTEST_LT?: number | null;
  lastName_SHORTEST_LTE?: number | null;
  position_AVERAGE_EQUAL?: number | null;
  position_AVERAGE_GT?: number | null;
  position_AVERAGE_GTE?: number | null;
  position_AVERAGE_LT?: number | null;
  position_AVERAGE_LTE?: number | null;
  position_EQUAL?: string | null;
  position_GT?: number | null;
  position_GTE?: number | null;
  position_LONGEST_EQUAL?: number | null;
  position_LONGEST_GT?: number | null;
  position_LONGEST_GTE?: number | null;
  position_LONGEST_LT?: number | null;
  position_LONGEST_LTE?: number | null;
  position_LT?: number | null;
  position_LTE?: number | null;
  position_SHORTEST_EQUAL?: number | null;
  position_SHORTEST_GT?: number | null;
  position_SHORTEST_GTE?: number | null;
  position_SHORTEST_LT?: number | null;
  position_SHORTEST_LTE?: number | null;
  preferredLanguage_AVERAGE_EQUAL?: number | null;
  preferredLanguage_AVERAGE_GT?: number | null;
  preferredLanguage_AVERAGE_GTE?: number | null;
  preferredLanguage_AVERAGE_LT?: number | null;
  preferredLanguage_AVERAGE_LTE?: number | null;
  preferredLanguage_EQUAL?: string | null;
  preferredLanguage_GT?: number | null;
  preferredLanguage_GTE?: number | null;
  preferredLanguage_LONGEST_EQUAL?: number | null;
  preferredLanguage_LONGEST_GT?: number | null;
  preferredLanguage_LONGEST_GTE?: number | null;
  preferredLanguage_LONGEST_LT?: number | null;
  preferredLanguage_LONGEST_LTE?: number | null;
  preferredLanguage_LT?: number | null;
  preferredLanguage_LTE?: number | null;
  preferredLanguage_SHORTEST_EQUAL?: number | null;
  preferredLanguage_SHORTEST_GT?: number | null;
  preferredLanguage_SHORTEST_GTE?: number | null;
  preferredLanguage_SHORTEST_LT?: number | null;
  preferredLanguage_SHORTEST_LTE?: number | null;
  tenantId_AVERAGE_EQUAL?: number | null;
  tenantId_AVERAGE_GT?: number | null;
  tenantId_AVERAGE_GTE?: number | null;
  tenantId_AVERAGE_LT?: number | null;
  tenantId_AVERAGE_LTE?: number | null;
  tenantId_EQUAL?: string | null;
  tenantId_GT?: number | null;
  tenantId_GTE?: number | null;
  tenantId_LONGEST_EQUAL?: number | null;
  tenantId_LONGEST_GT?: number | null;
  tenantId_LONGEST_GTE?: number | null;
  tenantId_LONGEST_LT?: number | null;
  tenantId_LONGEST_LTE?: number | null;
  tenantId_LT?: number | null;
  tenantId_LTE?: number | null;
  tenantId_SHORTEST_EQUAL?: number | null;
  tenantId_SHORTEST_GT?: number | null;
  tenantId_SHORTEST_GTE?: number | null;
  tenantId_SHORTEST_LT?: number | null;
  tenantId_SHORTEST_LTE?: number | null;
}

export interface AgreementDecisionWhere {
  AND?: AgreementDecisionWhere[] | null;
  OR?: AgreementDecisionWhere[] | null;
  asOf?: OrganizationWhere | null;
  asOfAggregate?: AgreementDecisionAsOfAggregateInput | null;
  asOfConnection?: AgreementDecisionAsOfConnectionWhere | null;
  asOfConnection_NOT?: AgreementDecisionAsOfConnectionWhere | null;
  asOf_NOT?: OrganizationWhere | null;
  createdOn?: any | null;
  createdOn_GT?: any | null;
  createdOn_GTE?: any | null;
  createdOn_IN?: (any | null)[] | null;
  createdOn_LT?: any | null;
  createdOn_LTE?: any | null;
  createdOn_NOT?: any | null;
  createdOn_NOT_IN?: (any | null)[] | null;
  decision?: Decision | null;
  decision_IN?: (Decision | null)[] | null;
  decision_NOT?: Decision | null;
  decision_NOT_IN?: (Decision | null)[] | null;
  isArchived?: boolean | null;
  isArchived_NOT?: boolean | null;
  madeBy?: UserWhere | null;
  madeByAggregate?: AgreementDecisionMadeByAggregateInput | null;
  madeByConnection?: AgreementDecisionMadeByConnectionWhere | null;
  madeByConnection_NOT?: AgreementDecisionMadeByConnectionWhere | null;
  madeBy_NOT?: UserWhere | null;
}

export interface AgreementDeviceAlternativeSetsAggregateInput {
  AND?: AgreementDeviceAlternativeSetsAggregateInput[] | null;
  OR?: AgreementDeviceAlternativeSetsAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: AgreementDeviceAlternativeSetsNodeAggregationWhereInput | null;
}

export interface AgreementDeviceAlternativeSetsConnectionWhere {
  AND?: AgreementDeviceAlternativeSetsConnectionWhere[] | null;
  OR?: AgreementDeviceAlternativeSetsConnectionWhere[] | null;
  node?: DeviceAlternativeWhere | null;
  node_NOT?: DeviceAlternativeWhere | null;
}

export interface AgreementDeviceAlternativeSetsNodeAggregationWhereInput {
  AND?: AgreementDeviceAlternativeSetsNodeAggregationWhereInput[] | null;
  OR?: AgreementDeviceAlternativeSetsNodeAggregationWhereInput[] | null;
  code_AVERAGE_EQUAL?: number | null;
  code_AVERAGE_GT?: number | null;
  code_AVERAGE_GTE?: number | null;
  code_AVERAGE_LT?: number | null;
  code_AVERAGE_LTE?: number | null;
  code_EQUAL?: string | null;
  code_GT?: number | null;
  code_GTE?: number | null;
  code_LONGEST_EQUAL?: number | null;
  code_LONGEST_GT?: number | null;
  code_LONGEST_GTE?: number | null;
  code_LONGEST_LT?: number | null;
  code_LONGEST_LTE?: number | null;
  code_LT?: number | null;
  code_LTE?: number | null;
  code_SHORTEST_EQUAL?: number | null;
  code_SHORTEST_GT?: number | null;
  code_SHORTEST_GTE?: number | null;
  code_SHORTEST_LT?: number | null;
  code_SHORTEST_LTE?: number | null;
}

export interface AgreementFinancialSummaryColumnRelationshipWhere {
  AND?: AgreementFinancialSummaryColumnRelationshipWhere[] | null;
  OR?: AgreementFinancialSummaryColumnRelationshipWhere[] | null;
  hasHelpMessage?: boolean | null;
  hasHelpMessage_NOT?: boolean | null;
  isIncluded?: boolean | null;
  isIncluded_NOT?: boolean | null;
  localizationKey?: string | null;
  localizationKey_CONTAINS?: string | null;
  localizationKey_ENDS_WITH?: string | null;
  localizationKey_IN?: (string | null)[] | null;
  localizationKey_MATCHES?: string | null;
  localizationKey_NOT?: string | null;
  localizationKey_NOT_CONTAINS?: string | null;
  localizationKey_NOT_ENDS_WITH?: string | null;
  localizationKey_NOT_IN?: (string | null)[] | null;
  localizationKey_NOT_STARTS_WITH?: string | null;
  localizationKey_STARTS_WITH?: string | null;
  position?: number | null;
  position_GT?: number | null;
  position_GTE?: number | null;
  position_IN?: (number | null)[] | null;
  position_LT?: number | null;
  position_LTE?: number | null;
  position_NOT?: number | null;
  position_NOT_IN?: (number | null)[] | null;
}

export interface AgreementNegotiableAttributesAggregateInput {
  AND?: AgreementNegotiableAttributesAggregateInput[] | null;
  OR?: AgreementNegotiableAttributesAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: AgreementNegotiableAttributesNodeAggregationWhereInput | null;
}

export interface AgreementNegotiableAttributesConnectionWhere {
  AND?: AgreementNegotiableAttributesConnectionWhere[] | null;
  OR?: AgreementNegotiableAttributesConnectionWhere[] | null;
  node?: CatalogueAttributeWhere | null;
  node_NOT?: CatalogueAttributeWhere | null;
}

export interface AgreementNegotiableAttributesNodeAggregationWhereInput {
  AND?: AgreementNegotiableAttributesNodeAggregationWhereInput[] | null;
  OR?: AgreementNegotiableAttributesNodeAggregationWhereInput[] | null;
  caption_AVERAGE_EQUAL?: number | null;
  caption_AVERAGE_GT?: number | null;
  caption_AVERAGE_GTE?: number | null;
  caption_AVERAGE_LT?: number | null;
  caption_AVERAGE_LTE?: number | null;
  caption_EQUAL?: string | null;
  caption_GT?: number | null;
  caption_GTE?: number | null;
  caption_LONGEST_EQUAL?: number | null;
  caption_LONGEST_GT?: number | null;
  caption_LONGEST_GTE?: number | null;
  caption_LONGEST_LT?: number | null;
  caption_LONGEST_LTE?: number | null;
  caption_LT?: number | null;
  caption_LTE?: number | null;
  caption_SHORTEST_EQUAL?: number | null;
  caption_SHORTEST_GT?: number | null;
  caption_SHORTEST_GTE?: number | null;
  caption_SHORTEST_LT?: number | null;
  caption_SHORTEST_LTE?: number | null;
  decimalPrecision_AVERAGE_EQUAL?: number | null;
  decimalPrecision_AVERAGE_GT?: number | null;
  decimalPrecision_AVERAGE_GTE?: number | null;
  decimalPrecision_AVERAGE_LT?: number | null;
  decimalPrecision_AVERAGE_LTE?: number | null;
  decimalPrecision_EQUAL?: number | null;
  decimalPrecision_GT?: number | null;
  decimalPrecision_GTE?: number | null;
  decimalPrecision_LT?: number | null;
  decimalPrecision_LTE?: number | null;
  decimalPrecision_MAX_EQUAL?: number | null;
  decimalPrecision_MAX_GT?: number | null;
  decimalPrecision_MAX_GTE?: number | null;
  decimalPrecision_MAX_LT?: number | null;
  decimalPrecision_MAX_LTE?: number | null;
  decimalPrecision_MIN_EQUAL?: number | null;
  decimalPrecision_MIN_GT?: number | null;
  decimalPrecision_MIN_GTE?: number | null;
  decimalPrecision_MIN_LT?: number | null;
  decimalPrecision_MIN_LTE?: number | null;
  decimalPrecision_SUM_EQUAL?: number | null;
  decimalPrecision_SUM_GT?: number | null;
  decimalPrecision_SUM_GTE?: number | null;
  decimalPrecision_SUM_LT?: number | null;
  decimalPrecision_SUM_LTE?: number | null;
  defaultValue_AVERAGE_EQUAL?: number | null;
  defaultValue_AVERAGE_GT?: number | null;
  defaultValue_AVERAGE_GTE?: number | null;
  defaultValue_AVERAGE_LT?: number | null;
  defaultValue_AVERAGE_LTE?: number | null;
  defaultValue_EQUAL?: string | null;
  defaultValue_GT?: number | null;
  defaultValue_GTE?: number | null;
  defaultValue_LONGEST_EQUAL?: number | null;
  defaultValue_LONGEST_GT?: number | null;
  defaultValue_LONGEST_GTE?: number | null;
  defaultValue_LONGEST_LT?: number | null;
  defaultValue_LONGEST_LTE?: number | null;
  defaultValue_LT?: number | null;
  defaultValue_LTE?: number | null;
  defaultValue_SHORTEST_EQUAL?: number | null;
  defaultValue_SHORTEST_GT?: number | null;
  defaultValue_SHORTEST_GTE?: number | null;
  defaultValue_SHORTEST_LT?: number | null;
  defaultValue_SHORTEST_LTE?: number | null;
  id_AVERAGE_EQUAL?: number | null;
  id_AVERAGE_GT?: number | null;
  id_AVERAGE_GTE?: number | null;
  id_AVERAGE_LT?: number | null;
  id_AVERAGE_LTE?: number | null;
  id_EQUAL?: string | null;
  id_GT?: number | null;
  id_GTE?: number | null;
  id_LONGEST_EQUAL?: number | null;
  id_LONGEST_GT?: number | null;
  id_LONGEST_GTE?: number | null;
  id_LONGEST_LT?: number | null;
  id_LONGEST_LTE?: number | null;
  id_LT?: number | null;
  id_LTE?: number | null;
  id_SHORTEST_EQUAL?: number | null;
  id_SHORTEST_GT?: number | null;
  id_SHORTEST_GTE?: number | null;
  id_SHORTEST_LT?: number | null;
  id_SHORTEST_LTE?: number | null;
  identifier_AVERAGE_EQUAL?: number | null;
  identifier_AVERAGE_GT?: number | null;
  identifier_AVERAGE_GTE?: number | null;
  identifier_AVERAGE_LT?: number | null;
  identifier_AVERAGE_LTE?: number | null;
  identifier_EQUAL?: string | null;
  identifier_GT?: number | null;
  identifier_GTE?: number | null;
  identifier_LONGEST_EQUAL?: number | null;
  identifier_LONGEST_GT?: number | null;
  identifier_LONGEST_GTE?: number | null;
  identifier_LONGEST_LT?: number | null;
  identifier_LONGEST_LTE?: number | null;
  identifier_LT?: number | null;
  identifier_LTE?: number | null;
  identifier_SHORTEST_EQUAL?: number | null;
  identifier_SHORTEST_GT?: number | null;
  identifier_SHORTEST_GTE?: number | null;
  identifier_SHORTEST_LT?: number | null;
  identifier_SHORTEST_LTE?: number | null;
  longLabelLocalizationKey_AVERAGE_EQUAL?: number | null;
  longLabelLocalizationKey_AVERAGE_GT?: number | null;
  longLabelLocalizationKey_AVERAGE_GTE?: number | null;
  longLabelLocalizationKey_AVERAGE_LT?: number | null;
  longLabelLocalizationKey_AVERAGE_LTE?: number | null;
  longLabelLocalizationKey_EQUAL?: string | null;
  longLabelLocalizationKey_GT?: number | null;
  longLabelLocalizationKey_GTE?: number | null;
  longLabelLocalizationKey_LONGEST_EQUAL?: number | null;
  longLabelLocalizationKey_LONGEST_GT?: number | null;
  longLabelLocalizationKey_LONGEST_GTE?: number | null;
  longLabelLocalizationKey_LONGEST_LT?: number | null;
  longLabelLocalizationKey_LONGEST_LTE?: number | null;
  longLabelLocalizationKey_LT?: number | null;
  longLabelLocalizationKey_LTE?: number | null;
  longLabelLocalizationKey_SHORTEST_EQUAL?: number | null;
  longLabelLocalizationKey_SHORTEST_GT?: number | null;
  longLabelLocalizationKey_SHORTEST_GTE?: number | null;
  longLabelLocalizationKey_SHORTEST_LT?: number | null;
  longLabelLocalizationKey_SHORTEST_LTE?: number | null;
  maxLength_AVERAGE_EQUAL?: number | null;
  maxLength_AVERAGE_GT?: number | null;
  maxLength_AVERAGE_GTE?: number | null;
  maxLength_AVERAGE_LT?: number | null;
  maxLength_AVERAGE_LTE?: number | null;
  maxLength_EQUAL?: number | null;
  maxLength_GT?: number | null;
  maxLength_GTE?: number | null;
  maxLength_LT?: number | null;
  maxLength_LTE?: number | null;
  maxLength_MAX_EQUAL?: number | null;
  maxLength_MAX_GT?: number | null;
  maxLength_MAX_GTE?: number | null;
  maxLength_MAX_LT?: number | null;
  maxLength_MAX_LTE?: number | null;
  maxLength_MIN_EQUAL?: number | null;
  maxLength_MIN_GT?: number | null;
  maxLength_MIN_GTE?: number | null;
  maxLength_MIN_LT?: number | null;
  maxLength_MIN_LTE?: number | null;
  maxLength_SUM_EQUAL?: number | null;
  maxLength_SUM_GT?: number | null;
  maxLength_SUM_GTE?: number | null;
  maxLength_SUM_LT?: number | null;
  maxLength_SUM_LTE?: number | null;
  minLength_AVERAGE_EQUAL?: number | null;
  minLength_AVERAGE_GT?: number | null;
  minLength_AVERAGE_GTE?: number | null;
  minLength_AVERAGE_LT?: number | null;
  minLength_AVERAGE_LTE?: number | null;
  minLength_EQUAL?: number | null;
  minLength_GT?: number | null;
  minLength_GTE?: number | null;
  minLength_LT?: number | null;
  minLength_LTE?: number | null;
  minLength_MAX_EQUAL?: number | null;
  minLength_MAX_GT?: number | null;
  minLength_MAX_GTE?: number | null;
  minLength_MAX_LT?: number | null;
  minLength_MAX_LTE?: number | null;
  minLength_MIN_EQUAL?: number | null;
  minLength_MIN_GT?: number | null;
  minLength_MIN_GTE?: number | null;
  minLength_MIN_LT?: number | null;
  minLength_MIN_LTE?: number | null;
  minLength_SUM_EQUAL?: number | null;
  minLength_SUM_GT?: number | null;
  minLength_SUM_GTE?: number | null;
  minLength_SUM_LT?: number | null;
  minLength_SUM_LTE?: number | null;
  rules_AVERAGE_EQUAL?: number | null;
  rules_AVERAGE_GT?: number | null;
  rules_AVERAGE_GTE?: number | null;
  rules_AVERAGE_LT?: number | null;
  rules_AVERAGE_LTE?: number | null;
  rules_EQUAL?: string | null;
  rules_GT?: number | null;
  rules_GTE?: number | null;
  rules_LONGEST_EQUAL?: number | null;
  rules_LONGEST_GT?: number | null;
  rules_LONGEST_GTE?: number | null;
  rules_LONGEST_LT?: number | null;
  rules_LONGEST_LTE?: number | null;
  rules_LT?: number | null;
  rules_LTE?: number | null;
  rules_SHORTEST_EQUAL?: number | null;
  rules_SHORTEST_GT?: number | null;
  rules_SHORTEST_GTE?: number | null;
  rules_SHORTEST_LT?: number | null;
  rules_SHORTEST_LTE?: number | null;
  shortLabelLocalizationKey_AVERAGE_EQUAL?: number | null;
  shortLabelLocalizationKey_AVERAGE_GT?: number | null;
  shortLabelLocalizationKey_AVERAGE_GTE?: number | null;
  shortLabelLocalizationKey_AVERAGE_LT?: number | null;
  shortLabelLocalizationKey_AVERAGE_LTE?: number | null;
  shortLabelLocalizationKey_EQUAL?: string | null;
  shortLabelLocalizationKey_GT?: number | null;
  shortLabelLocalizationKey_GTE?: number | null;
  shortLabelLocalizationKey_LONGEST_EQUAL?: number | null;
  shortLabelLocalizationKey_LONGEST_GT?: number | null;
  shortLabelLocalizationKey_LONGEST_GTE?: number | null;
  shortLabelLocalizationKey_LONGEST_LT?: number | null;
  shortLabelLocalizationKey_LONGEST_LTE?: number | null;
  shortLabelLocalizationKey_LT?: number | null;
  shortLabelLocalizationKey_LTE?: number | null;
  shortLabelLocalizationKey_SHORTEST_EQUAL?: number | null;
  shortLabelLocalizationKey_SHORTEST_GT?: number | null;
  shortLabelLocalizationKey_SHORTEST_GTE?: number | null;
  shortLabelLocalizationKey_SHORTEST_LT?: number | null;
  shortLabelLocalizationKey_SHORTEST_LTE?: number | null;
  values_AVERAGE_EQUAL?: number | null;
  values_AVERAGE_GT?: number | null;
  values_AVERAGE_GTE?: number | null;
  values_AVERAGE_LT?: number | null;
  values_AVERAGE_LTE?: number | null;
  values_EQUAL?: string | null;
  values_GT?: number | null;
  values_GTE?: number | null;
  values_LONGEST_EQUAL?: number | null;
  values_LONGEST_GT?: number | null;
  values_LONGEST_GTE?: number | null;
  values_LONGEST_LT?: number | null;
  values_LONGEST_LTE?: number | null;
  values_LT?: number | null;
  values_LTE?: number | null;
  values_SHORTEST_EQUAL?: number | null;
  values_SHORTEST_GT?: number | null;
  values_SHORTEST_GTE?: number | null;
  values_SHORTEST_LT?: number | null;
  values_SHORTEST_LTE?: number | null;
}

export interface AgreementNextVersionsAggregateInput {
  AND?: AgreementNextVersionsAggregateInput[] | null;
  OR?: AgreementNextVersionsAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: AgreementNextVersionsNodeAggregationWhereInput | null;
}

export interface AgreementNextVersionsConnectionWhere {
  AND?: AgreementNextVersionsConnectionWhere[] | null;
  OR?: AgreementNextVersionsConnectionWhere[] | null;
  node?: AgreementWhere | null;
  node_NOT?: AgreementWhere | null;
}

export interface AgreementNextVersionsNodeAggregationWhereInput {
  AND?: AgreementNextVersionsNodeAggregationWhereInput[] | null;
  OR?: AgreementNextVersionsNodeAggregationWhereInput[] | null;
  description_AVERAGE_EQUAL?: number | null;
  description_AVERAGE_GT?: number | null;
  description_AVERAGE_GTE?: number | null;
  description_AVERAGE_LT?: number | null;
  description_AVERAGE_LTE?: number | null;
  description_EQUAL?: string | null;
  description_GT?: number | null;
  description_GTE?: number | null;
  description_LONGEST_EQUAL?: number | null;
  description_LONGEST_GT?: number | null;
  description_LONGEST_GTE?: number | null;
  description_LONGEST_LT?: number | null;
  description_LONGEST_LTE?: number | null;
  description_LT?: number | null;
  description_LTE?: number | null;
  description_SHORTEST_EQUAL?: number | null;
  description_SHORTEST_GT?: number | null;
  description_SHORTEST_GTE?: number | null;
  description_SHORTEST_LT?: number | null;
  description_SHORTEST_LTE?: number | null;
  formattedAmount_AVERAGE_EQUAL?: number | null;
  formattedAmount_AVERAGE_GT?: number | null;
  formattedAmount_AVERAGE_GTE?: number | null;
  formattedAmount_AVERAGE_LT?: number | null;
  formattedAmount_AVERAGE_LTE?: number | null;
  formattedAmount_EQUAL?: string | null;
  formattedAmount_GT?: number | null;
  formattedAmount_GTE?: number | null;
  formattedAmount_LONGEST_EQUAL?: number | null;
  formattedAmount_LONGEST_GT?: number | null;
  formattedAmount_LONGEST_GTE?: number | null;
  formattedAmount_LONGEST_LT?: number | null;
  formattedAmount_LONGEST_LTE?: number | null;
  formattedAmount_LT?: number | null;
  formattedAmount_LTE?: number | null;
  formattedAmount_SHORTEST_EQUAL?: number | null;
  formattedAmount_SHORTEST_GT?: number | null;
  formattedAmount_SHORTEST_GTE?: number | null;
  formattedAmount_SHORTEST_LT?: number | null;
  formattedAmount_SHORTEST_LTE?: number | null;
  formattedCounterparties_AVERAGE_EQUAL?: number | null;
  formattedCounterparties_AVERAGE_GT?: number | null;
  formattedCounterparties_AVERAGE_GTE?: number | null;
  formattedCounterparties_AVERAGE_LT?: number | null;
  formattedCounterparties_AVERAGE_LTE?: number | null;
  formattedCounterparties_EQUAL?: string | null;
  formattedCounterparties_GT?: number | null;
  formattedCounterparties_GTE?: number | null;
  formattedCounterparties_LONGEST_EQUAL?: number | null;
  formattedCounterparties_LONGEST_GT?: number | null;
  formattedCounterparties_LONGEST_GTE?: number | null;
  formattedCounterparties_LONGEST_LT?: number | null;
  formattedCounterparties_LONGEST_LTE?: number | null;
  formattedCounterparties_LT?: number | null;
  formattedCounterparties_LTE?: number | null;
  formattedCounterparties_SHORTEST_EQUAL?: number | null;
  formattedCounterparties_SHORTEST_GT?: number | null;
  formattedCounterparties_SHORTEST_GTE?: number | null;
  formattedCounterparties_SHORTEST_LT?: number | null;
  formattedCounterparties_SHORTEST_LTE?: number | null;
  formattedDiseases_AVERAGE_EQUAL?: number | null;
  formattedDiseases_AVERAGE_GT?: number | null;
  formattedDiseases_AVERAGE_GTE?: number | null;
  formattedDiseases_AVERAGE_LT?: number | null;
  formattedDiseases_AVERAGE_LTE?: number | null;
  formattedDiseases_EQUAL?: string | null;
  formattedDiseases_GT?: number | null;
  formattedDiseases_GTE?: number | null;
  formattedDiseases_LONGEST_EQUAL?: number | null;
  formattedDiseases_LONGEST_GT?: number | null;
  formattedDiseases_LONGEST_GTE?: number | null;
  formattedDiseases_LONGEST_LT?: number | null;
  formattedDiseases_LONGEST_LTE?: number | null;
  formattedDiseases_LT?: number | null;
  formattedDiseases_LTE?: number | null;
  formattedDiseases_SHORTEST_EQUAL?: number | null;
  formattedDiseases_SHORTEST_GT?: number | null;
  formattedDiseases_SHORTEST_GTE?: number | null;
  formattedDiseases_SHORTEST_LT?: number | null;
  formattedDiseases_SHORTEST_LTE?: number | null;
  formattedIndications_AVERAGE_EQUAL?: number | null;
  formattedIndications_AVERAGE_GT?: number | null;
  formattedIndications_AVERAGE_GTE?: number | null;
  formattedIndications_AVERAGE_LT?: number | null;
  formattedIndications_AVERAGE_LTE?: number | null;
  formattedIndications_EQUAL?: string | null;
  formattedIndications_GT?: number | null;
  formattedIndications_GTE?: number | null;
  formattedIndications_LONGEST_EQUAL?: number | null;
  formattedIndications_LONGEST_GT?: number | null;
  formattedIndications_LONGEST_GTE?: number | null;
  formattedIndications_LONGEST_LT?: number | null;
  formattedIndications_LONGEST_LTE?: number | null;
  formattedIndications_LT?: number | null;
  formattedIndications_LTE?: number | null;
  formattedIndications_SHORTEST_EQUAL?: number | null;
  formattedIndications_SHORTEST_GT?: number | null;
  formattedIndications_SHORTEST_GTE?: number | null;
  formattedIndications_SHORTEST_LT?: number | null;
  formattedIndications_SHORTEST_LTE?: number | null;
  formattedProducts_AVERAGE_EQUAL?: number | null;
  formattedProducts_AVERAGE_GT?: number | null;
  formattedProducts_AVERAGE_GTE?: number | null;
  formattedProducts_AVERAGE_LT?: number | null;
  formattedProducts_AVERAGE_LTE?: number | null;
  formattedProducts_EQUAL?: string | null;
  formattedProducts_GT?: number | null;
  formattedProducts_GTE?: number | null;
  formattedProducts_LONGEST_EQUAL?: number | null;
  formattedProducts_LONGEST_GT?: number | null;
  formattedProducts_LONGEST_GTE?: number | null;
  formattedProducts_LONGEST_LT?: number | null;
  formattedProducts_LONGEST_LTE?: number | null;
  formattedProducts_LT?: number | null;
  formattedProducts_LTE?: number | null;
  formattedProducts_SHORTEST_EQUAL?: number | null;
  formattedProducts_SHORTEST_GT?: number | null;
  formattedProducts_SHORTEST_GTE?: number | null;
  formattedProducts_SHORTEST_LT?: number | null;
  formattedProducts_SHORTEST_LTE?: number | null;
  formattedTags_AVERAGE_EQUAL?: number | null;
  formattedTags_AVERAGE_GT?: number | null;
  formattedTags_AVERAGE_GTE?: number | null;
  formattedTags_AVERAGE_LT?: number | null;
  formattedTags_AVERAGE_LTE?: number | null;
  formattedTags_EQUAL?: string | null;
  formattedTags_GT?: number | null;
  formattedTags_GTE?: number | null;
  formattedTags_LONGEST_EQUAL?: number | null;
  formattedTags_LONGEST_GT?: number | null;
  formattedTags_LONGEST_GTE?: number | null;
  formattedTags_LONGEST_LT?: number | null;
  formattedTags_LONGEST_LTE?: number | null;
  formattedTags_LT?: number | null;
  formattedTags_LTE?: number | null;
  formattedTags_SHORTEST_EQUAL?: number | null;
  formattedTags_SHORTEST_GT?: number | null;
  formattedTags_SHORTEST_GTE?: number | null;
  formattedTags_SHORTEST_LT?: number | null;
  formattedTags_SHORTEST_LTE?: number | null;
  formattedValidityPeriod_AVERAGE_EQUAL?: number | null;
  formattedValidityPeriod_AVERAGE_GT?: number | null;
  formattedValidityPeriod_AVERAGE_GTE?: number | null;
  formattedValidityPeriod_AVERAGE_LT?: number | null;
  formattedValidityPeriod_AVERAGE_LTE?: number | null;
  formattedValidityPeriod_EQUAL?: string | null;
  formattedValidityPeriod_GT?: number | null;
  formattedValidityPeriod_GTE?: number | null;
  formattedValidityPeriod_LONGEST_EQUAL?: number | null;
  formattedValidityPeriod_LONGEST_GT?: number | null;
  formattedValidityPeriod_LONGEST_GTE?: number | null;
  formattedValidityPeriod_LONGEST_LT?: number | null;
  formattedValidityPeriod_LONGEST_LTE?: number | null;
  formattedValidityPeriod_LT?: number | null;
  formattedValidityPeriod_LTE?: number | null;
  formattedValidityPeriod_SHORTEST_EQUAL?: number | null;
  formattedValidityPeriod_SHORTEST_GT?: number | null;
  formattedValidityPeriod_SHORTEST_GTE?: number | null;
  formattedValidityPeriod_SHORTEST_LT?: number | null;
  formattedValidityPeriod_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  initialVersionId_AVERAGE_EQUAL?: number | null;
  initialVersionId_AVERAGE_GT?: number | null;
  initialVersionId_AVERAGE_GTE?: number | null;
  initialVersionId_AVERAGE_LT?: number | null;
  initialVersionId_AVERAGE_LTE?: number | null;
  initialVersionId_EQUAL?: string | null;
  initialVersionId_GT?: number | null;
  initialVersionId_GTE?: number | null;
  initialVersionId_LONGEST_EQUAL?: number | null;
  initialVersionId_LONGEST_GT?: number | null;
  initialVersionId_LONGEST_GTE?: number | null;
  initialVersionId_LONGEST_LT?: number | null;
  initialVersionId_LONGEST_LTE?: number | null;
  initialVersionId_LT?: number | null;
  initialVersionId_LTE?: number | null;
  initialVersionId_SHORTEST_EQUAL?: number | null;
  initialVersionId_SHORTEST_GT?: number | null;
  initialVersionId_SHORTEST_GTE?: number | null;
  initialVersionId_SHORTEST_LT?: number | null;
  initialVersionId_SHORTEST_LTE?: number | null;
  name_AVERAGE_EQUAL?: number | null;
  name_AVERAGE_GT?: number | null;
  name_AVERAGE_GTE?: number | null;
  name_AVERAGE_LT?: number | null;
  name_AVERAGE_LTE?: number | null;
  name_EQUAL?: string | null;
  name_GT?: number | null;
  name_GTE?: number | null;
  name_LONGEST_EQUAL?: number | null;
  name_LONGEST_GT?: number | null;
  name_LONGEST_GTE?: number | null;
  name_LONGEST_LT?: number | null;
  name_LONGEST_LTE?: number | null;
  name_LT?: number | null;
  name_LTE?: number | null;
  name_SHORTEST_EQUAL?: number | null;
  name_SHORTEST_GT?: number | null;
  name_SHORTEST_GTE?: number | null;
  name_SHORTEST_LT?: number | null;
  name_SHORTEST_LTE?: number | null;
  searchTerm_AVERAGE_EQUAL?: number | null;
  searchTerm_AVERAGE_GT?: number | null;
  searchTerm_AVERAGE_GTE?: number | null;
  searchTerm_AVERAGE_LT?: number | null;
  searchTerm_AVERAGE_LTE?: number | null;
  searchTerm_EQUAL?: string | null;
  searchTerm_GT?: number | null;
  searchTerm_GTE?: number | null;
  searchTerm_LONGEST_EQUAL?: number | null;
  searchTerm_LONGEST_GT?: number | null;
  searchTerm_LONGEST_GTE?: number | null;
  searchTerm_LONGEST_LT?: number | null;
  searchTerm_LONGEST_LTE?: number | null;
  searchTerm_LT?: number | null;
  searchTerm_LTE?: number | null;
  searchTerm_SHORTEST_EQUAL?: number | null;
  searchTerm_SHORTEST_GT?: number | null;
  searchTerm_SHORTEST_GTE?: number | null;
  searchTerm_SHORTEST_LT?: number | null;
  searchTerm_SHORTEST_LTE?: number | null;
  totalAmount_AVERAGE_EQUAL?: number | null;
  totalAmount_AVERAGE_GT?: number | null;
  totalAmount_AVERAGE_GTE?: number | null;
  totalAmount_AVERAGE_LT?: number | null;
  totalAmount_AVERAGE_LTE?: number | null;
  totalAmount_EQUAL?: number | null;
  totalAmount_GT?: number | null;
  totalAmount_GTE?: number | null;
  totalAmount_LT?: number | null;
  totalAmount_LTE?: number | null;
  totalAmount_MAX_EQUAL?: number | null;
  totalAmount_MAX_GT?: number | null;
  totalAmount_MAX_GTE?: number | null;
  totalAmount_MAX_LT?: number | null;
  totalAmount_MAX_LTE?: number | null;
  totalAmount_MIN_EQUAL?: number | null;
  totalAmount_MIN_GT?: number | null;
  totalAmount_MIN_GTE?: number | null;
  totalAmount_MIN_LT?: number | null;
  totalAmount_MIN_LTE?: number | null;
  totalAmount_SUM_EQUAL?: number | null;
  totalAmount_SUM_GT?: number | null;
  totalAmount_SUM_GTE?: number | null;
  totalAmount_SUM_LT?: number | null;
  totalAmount_SUM_LTE?: number | null;
  unlimited_AVERAGE_EQUAL?: number | null;
  unlimited_AVERAGE_GT?: number | null;
  unlimited_AVERAGE_GTE?: number | null;
  unlimited_AVERAGE_LT?: number | null;
  unlimited_AVERAGE_LTE?: number | null;
  unlimited_EQUAL?: number | null;
  unlimited_GT?: number | null;
  unlimited_GTE?: number | null;
  unlimited_LT?: number | null;
  unlimited_LTE?: number | null;
  unlimited_MAX_EQUAL?: number | null;
  unlimited_MAX_GT?: number | null;
  unlimited_MAX_GTE?: number | null;
  unlimited_MAX_LT?: number | null;
  unlimited_MAX_LTE?: number | null;
  unlimited_MIN_EQUAL?: number | null;
  unlimited_MIN_GT?: number | null;
  unlimited_MIN_GTE?: number | null;
  unlimited_MIN_LT?: number | null;
  unlimited_MIN_LTE?: number | null;
  unlimited_SUM_EQUAL?: number | null;
  unlimited_SUM_GT?: number | null;
  unlimited_SUM_GTE?: number | null;
  unlimited_SUM_LT?: number | null;
  unlimited_SUM_LTE?: number | null;
  version_AVERAGE_EQUAL?: number | null;
  version_AVERAGE_GT?: number | null;
  version_AVERAGE_GTE?: number | null;
  version_AVERAGE_LT?: number | null;
  version_AVERAGE_LTE?: number | null;
  version_EQUAL?: number | null;
  version_GT?: number | null;
  version_GTE?: number | null;
  version_LT?: number | null;
  version_LTE?: number | null;
  version_MAX_EQUAL?: number | null;
  version_MAX_GT?: number | null;
  version_MAX_GTE?: number | null;
  version_MAX_LT?: number | null;
  version_MAX_LTE?: number | null;
  version_MIN_EQUAL?: number | null;
  version_MIN_GT?: number | null;
  version_MIN_GTE?: number | null;
  version_MIN_LT?: number | null;
  version_MIN_LTE?: number | null;
  version_SUM_EQUAL?: number | null;
  version_SUM_GT?: number | null;
  version_SUM_GTE?: number | null;
  version_SUM_LT?: number | null;
  version_SUM_LTE?: number | null;
}

export interface AgreementOptions {
  limit?: number | null;
  offset?: number | null;
  sort?: (AgreementSort | null)[] | null;
}

export interface AgreementScopeCountryScopesAggregateInput {
  AND?: AgreementScopeCountryScopesAggregateInput[] | null;
  OR?: AgreementScopeCountryScopesAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  edge?: AgreementScopeCountryScopesEdgeAggregationWhereInput | null;
  node?: AgreementScopeCountryScopesNodeAggregationWhereInput | null;
}

export interface AgreementScopeCountryScopesConnectionWhere {
  AND?: AgreementScopeCountryScopesConnectionWhere[] | null;
  OR?: AgreementScopeCountryScopesConnectionWhere[] | null;
  edge?: CountryScopeRelationshipWhere | null;
  edge_NOT?: CountryScopeRelationshipWhere | null;
  node?: CurrencyWhere | null;
  node_NOT?: CurrencyWhere | null;
}

export interface AgreementScopeCountryScopesEdgeAggregationWhereInput {
  AND?: AgreementScopeCountryScopesEdgeAggregationWhereInput[] | null;
  OR?: AgreementScopeCountryScopesEdgeAggregationWhereInput[] | null;
  countryScopeId_AVERAGE_EQUAL?: number | null;
  countryScopeId_AVERAGE_GT?: number | null;
  countryScopeId_AVERAGE_GTE?: number | null;
  countryScopeId_AVERAGE_LT?: number | null;
  countryScopeId_AVERAGE_LTE?: number | null;
  countryScopeId_EQUAL?: string | null;
  countryScopeId_GT?: number | null;
  countryScopeId_GTE?: number | null;
  countryScopeId_LONGEST_EQUAL?: number | null;
  countryScopeId_LONGEST_GT?: number | null;
  countryScopeId_LONGEST_GTE?: number | null;
  countryScopeId_LONGEST_LT?: number | null;
  countryScopeId_LONGEST_LTE?: number | null;
  countryScopeId_LT?: number | null;
  countryScopeId_LTE?: number | null;
  countryScopeId_SHORTEST_EQUAL?: number | null;
  countryScopeId_SHORTEST_GT?: number | null;
  countryScopeId_SHORTEST_GTE?: number | null;
  countryScopeId_SHORTEST_LT?: number | null;
  countryScopeId_SHORTEST_LTE?: number | null;
}

export interface AgreementScopeCountryScopesNodeAggregationWhereInput {
  AND?: AgreementScopeCountryScopesNodeAggregationWhereInput[] | null;
  Code_AVERAGE_EQUAL?: number | null;
  Code_AVERAGE_GT?: number | null;
  Code_AVERAGE_GTE?: number | null;
  Code_AVERAGE_LT?: number | null;
  Code_AVERAGE_LTE?: number | null;
  Code_EQUAL?: string | null;
  Code_GT?: number | null;
  Code_GTE?: number | null;
  Code_LONGEST_EQUAL?: number | null;
  Code_LONGEST_GT?: number | null;
  Code_LONGEST_GTE?: number | null;
  Code_LONGEST_LT?: number | null;
  Code_LONGEST_LTE?: number | null;
  Code_LT?: number | null;
  Code_LTE?: number | null;
  Code_SHORTEST_EQUAL?: number | null;
  Code_SHORTEST_GT?: number | null;
  Code_SHORTEST_GTE?: number | null;
  Code_SHORTEST_LT?: number | null;
  Code_SHORTEST_LTE?: number | null;
  Name_AVERAGE_EQUAL?: number | null;
  Name_AVERAGE_GT?: number | null;
  Name_AVERAGE_GTE?: number | null;
  Name_AVERAGE_LT?: number | null;
  Name_AVERAGE_LTE?: number | null;
  Name_EQUAL?: string | null;
  Name_GT?: number | null;
  Name_GTE?: number | null;
  Name_LONGEST_EQUAL?: number | null;
  Name_LONGEST_GT?: number | null;
  Name_LONGEST_GTE?: number | null;
  Name_LONGEST_LT?: number | null;
  Name_LONGEST_LTE?: number | null;
  Name_LT?: number | null;
  Name_LTE?: number | null;
  Name_SHORTEST_EQUAL?: number | null;
  Name_SHORTEST_GT?: number | null;
  Name_SHORTEST_GTE?: number | null;
  Name_SHORTEST_LT?: number | null;
  Name_SHORTEST_LTE?: number | null;
  OR?: AgreementScopeCountryScopesNodeAggregationWhereInput[] | null;
  symbol_AVERAGE_EQUAL?: number | null;
  symbol_AVERAGE_GT?: number | null;
  symbol_AVERAGE_GTE?: number | null;
  symbol_AVERAGE_LT?: number | null;
  symbol_AVERAGE_LTE?: number | null;
  symbol_EQUAL?: string | null;
  symbol_GT?: number | null;
  symbol_GTE?: number | null;
  symbol_LONGEST_EQUAL?: number | null;
  symbol_LONGEST_GT?: number | null;
  symbol_LONGEST_GTE?: number | null;
  symbol_LONGEST_LT?: number | null;
  symbol_LONGEST_LTE?: number | null;
  symbol_LT?: number | null;
  symbol_LTE?: number | null;
  symbol_SHORTEST_EQUAL?: number | null;
  symbol_SHORTEST_GT?: number | null;
  symbol_SHORTEST_GTE?: number | null;
  symbol_SHORTEST_LT?: number | null;
  symbol_SHORTEST_LTE?: number | null;
}

export interface AgreementScopeCyclesAggregateInput {
  AND?: AgreementScopeCyclesAggregateInput[] | null;
  OR?: AgreementScopeCyclesAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: AgreementScopeCyclesNodeAggregationWhereInput | null;
}

export interface AgreementScopeCyclesConnectionWhere {
  AND?: AgreementScopeCyclesConnectionWhere[] | null;
  OR?: AgreementScopeCyclesConnectionWhere[] | null;
  node?: CycleConfigurationWhere | null;
  node_NOT?: CycleConfigurationWhere | null;
}

export interface AgreementScopeCyclesNodeAggregationWhereInput {
  AND?: AgreementScopeCyclesNodeAggregationWhereInput[] | null;
  OR?: AgreementScopeCyclesNodeAggregationWhereInput[] | null;
  lengthFrom_AVERAGE_EQUAL?: number | null;
  lengthFrom_AVERAGE_GT?: number | null;
  lengthFrom_AVERAGE_GTE?: number | null;
  lengthFrom_AVERAGE_LT?: number | null;
  lengthFrom_AVERAGE_LTE?: number | null;
  lengthFrom_EQUAL?: number | null;
  lengthFrom_GT?: number | null;
  lengthFrom_GTE?: number | null;
  lengthFrom_LT?: number | null;
  lengthFrom_LTE?: number | null;
  lengthFrom_MAX_EQUAL?: number | null;
  lengthFrom_MAX_GT?: number | null;
  lengthFrom_MAX_GTE?: number | null;
  lengthFrom_MAX_LT?: number | null;
  lengthFrom_MAX_LTE?: number | null;
  lengthFrom_MIN_EQUAL?: number | null;
  lengthFrom_MIN_GT?: number | null;
  lengthFrom_MIN_GTE?: number | null;
  lengthFrom_MIN_LT?: number | null;
  lengthFrom_MIN_LTE?: number | null;
  lengthFrom_SUM_EQUAL?: number | null;
  lengthFrom_SUM_GT?: number | null;
  lengthFrom_SUM_GTE?: number | null;
  lengthFrom_SUM_LT?: number | null;
  lengthFrom_SUM_LTE?: number | null;
  lengthTo_AVERAGE_EQUAL?: number | null;
  lengthTo_AVERAGE_GT?: number | null;
  lengthTo_AVERAGE_GTE?: number | null;
  lengthTo_AVERAGE_LT?: number | null;
  lengthTo_AVERAGE_LTE?: number | null;
  lengthTo_EQUAL?: number | null;
  lengthTo_GT?: number | null;
  lengthTo_GTE?: number | null;
  lengthTo_LT?: number | null;
  lengthTo_LTE?: number | null;
  lengthTo_MAX_EQUAL?: number | null;
  lengthTo_MAX_GT?: number | null;
  lengthTo_MAX_GTE?: number | null;
  lengthTo_MAX_LT?: number | null;
  lengthTo_MAX_LTE?: number | null;
  lengthTo_MIN_EQUAL?: number | null;
  lengthTo_MIN_GT?: number | null;
  lengthTo_MIN_GTE?: number | null;
  lengthTo_MIN_LT?: number | null;
  lengthTo_MIN_LTE?: number | null;
  lengthTo_SUM_EQUAL?: number | null;
  lengthTo_SUM_GT?: number | null;
  lengthTo_SUM_GTE?: number | null;
  lengthTo_SUM_LT?: number | null;
  lengthTo_SUM_LTE?: number | null;
  name_AVERAGE_EQUAL?: number | null;
  name_AVERAGE_GT?: number | null;
  name_AVERAGE_GTE?: number | null;
  name_AVERAGE_LT?: number | null;
  name_AVERAGE_LTE?: number | null;
  name_EQUAL?: string | null;
  name_GT?: number | null;
  name_GTE?: number | null;
  name_LONGEST_EQUAL?: number | null;
  name_LONGEST_GT?: number | null;
  name_LONGEST_GTE?: number | null;
  name_LONGEST_LT?: number | null;
  name_LONGEST_LTE?: number | null;
  name_LT?: number | null;
  name_LTE?: number | null;
  name_SHORTEST_EQUAL?: number | null;
  name_SHORTEST_GT?: number | null;
  name_SHORTEST_GTE?: number | null;
  name_SHORTEST_LT?: number | null;
  name_SHORTEST_LTE?: number | null;
  order_AVERAGE_EQUAL?: number | null;
  order_AVERAGE_GT?: number | null;
  order_AVERAGE_GTE?: number | null;
  order_AVERAGE_LT?: number | null;
  order_AVERAGE_LTE?: number | null;
  order_EQUAL?: number | null;
  order_GT?: number | null;
  order_GTE?: number | null;
  order_LT?: number | null;
  order_LTE?: number | null;
  order_MAX_EQUAL?: number | null;
  order_MAX_GT?: number | null;
  order_MAX_GTE?: number | null;
  order_MAX_LT?: number | null;
  order_MAX_LTE?: number | null;
  order_MIN_EQUAL?: number | null;
  order_MIN_GT?: number | null;
  order_MIN_GTE?: number | null;
  order_MIN_LT?: number | null;
  order_MIN_LTE?: number | null;
  order_SUM_EQUAL?: number | null;
  order_SUM_GT?: number | null;
  order_SUM_GTE?: number | null;
  order_SUM_LT?: number | null;
  order_SUM_LTE?: number | null;
}

export interface AgreementScopeDiseasesAggregateInput {
  AND?: AgreementScopeDiseasesAggregateInput[] | null;
  OR?: AgreementScopeDiseasesAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  edge?: AgreementScopeDiseasesEdgeAggregationWhereInput | null;
  node?: AgreementScopeDiseasesNodeAggregationWhereInput | null;
}

export interface AgreementScopeDiseasesConnectionWhere {
  AND?: AgreementScopeDiseasesConnectionWhere[] | null;
  OR?: AgreementScopeDiseasesConnectionWhere[] | null;
  edge?: EnrollingConditionDiseaseRelationshipWhere | null;
  edge_NOT?: EnrollingConditionDiseaseRelationshipWhere | null;
  node?: DiseaseWhere | null;
  node_NOT?: DiseaseWhere | null;
}

export interface AgreementScopeDiseasesEdgeAggregationWhereInput {
  AND?: AgreementScopeDiseasesEdgeAggregationWhereInput[] | null;
  OR?: AgreementScopeDiseasesEdgeAggregationWhereInput[] | null;
  Score_AVERAGE_EQUAL?: number | null;
  Score_AVERAGE_GT?: number | null;
  Score_AVERAGE_GTE?: number | null;
  Score_AVERAGE_LT?: number | null;
  Score_AVERAGE_LTE?: number | null;
  Score_EQUAL?: number | null;
  Score_GT?: number | null;
  Score_GTE?: number | null;
  Score_LT?: number | null;
  Score_LTE?: number | null;
  Score_MAX_EQUAL?: number | null;
  Score_MAX_GT?: number | null;
  Score_MAX_GTE?: number | null;
  Score_MAX_LT?: number | null;
  Score_MAX_LTE?: number | null;
  Score_MIN_EQUAL?: number | null;
  Score_MIN_GT?: number | null;
  Score_MIN_GTE?: number | null;
  Score_MIN_LT?: number | null;
  Score_MIN_LTE?: number | null;
  Score_SUM_EQUAL?: number | null;
  Score_SUM_GT?: number | null;
  Score_SUM_GTE?: number | null;
  Score_SUM_LT?: number | null;
  Score_SUM_LTE?: number | null;
}

export interface AgreementScopeDiseasesNodeAggregationWhereInput {
  AND?: AgreementScopeDiseasesNodeAggregationWhereInput[] | null;
  Icd10Code_AVERAGE_EQUAL?: number | null;
  Icd10Code_AVERAGE_GT?: number | null;
  Icd10Code_AVERAGE_GTE?: number | null;
  Icd10Code_AVERAGE_LT?: number | null;
  Icd10Code_AVERAGE_LTE?: number | null;
  Icd10Code_EQUAL?: string | null;
  Icd10Code_GT?: number | null;
  Icd10Code_GTE?: number | null;
  Icd10Code_LONGEST_EQUAL?: number | null;
  Icd10Code_LONGEST_GT?: number | null;
  Icd10Code_LONGEST_GTE?: number | null;
  Icd10Code_LONGEST_LT?: number | null;
  Icd10Code_LONGEST_LTE?: number | null;
  Icd10Code_LT?: number | null;
  Icd10Code_LTE?: number | null;
  Icd10Code_SHORTEST_EQUAL?: number | null;
  Icd10Code_SHORTEST_GT?: number | null;
  Icd10Code_SHORTEST_GTE?: number | null;
  Icd10Code_SHORTEST_LT?: number | null;
  Icd10Code_SHORTEST_LTE?: number | null;
  Name_AVERAGE_EQUAL?: number | null;
  Name_AVERAGE_GT?: number | null;
  Name_AVERAGE_GTE?: number | null;
  Name_AVERAGE_LT?: number | null;
  Name_AVERAGE_LTE?: number | null;
  Name_EQUAL?: string | null;
  Name_GT?: number | null;
  Name_GTE?: number | null;
  Name_LONGEST_EQUAL?: number | null;
  Name_LONGEST_GT?: number | null;
  Name_LONGEST_GTE?: number | null;
  Name_LONGEST_LT?: number | null;
  Name_LONGEST_LTE?: number | null;
  Name_LT?: number | null;
  Name_LTE?: number | null;
  Name_SHORTEST_EQUAL?: number | null;
  Name_SHORTEST_GT?: number | null;
  Name_SHORTEST_GTE?: number | null;
  Name_SHORTEST_LT?: number | null;
  Name_SHORTEST_LTE?: number | null;
  OR?: AgreementScopeDiseasesNodeAggregationWhereInput[] | null;
}

export interface AgreementScopeEnrollingConditionSetsAggregateInput {
  AND?: AgreementScopeEnrollingConditionSetsAggregateInput[] | null;
  OR?: AgreementScopeEnrollingConditionSetsAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: AgreementScopeEnrollingConditionSetsNodeAggregationWhereInput | null;
}

export interface AgreementScopeEnrollingConditionSetsConnectionWhere {
  AND?: AgreementScopeEnrollingConditionSetsConnectionWhere[] | null;
  OR?: AgreementScopeEnrollingConditionSetsConnectionWhere[] | null;
  node?: EnrollingConditionSetWhere | null;
  node_NOT?: EnrollingConditionSetWhere | null;
}

export interface AgreementScopeEnrollingConditionSetsNodeAggregationWhereInput {
  AND?: AgreementScopeEnrollingConditionSetsNodeAggregationWhereInput[] | null;
  OR?: AgreementScopeEnrollingConditionSetsNodeAggregationWhereInput[] | null;
  order_AVERAGE_EQUAL?: number | null;
  order_AVERAGE_GT?: number | null;
  order_AVERAGE_GTE?: number | null;
  order_AVERAGE_LT?: number | null;
  order_AVERAGE_LTE?: number | null;
  order_EQUAL?: number | null;
  order_GT?: number | null;
  order_GTE?: number | null;
  order_LT?: number | null;
  order_LTE?: number | null;
  order_MAX_EQUAL?: number | null;
  order_MAX_GT?: number | null;
  order_MAX_GTE?: number | null;
  order_MAX_LT?: number | null;
  order_MAX_LTE?: number | null;
  order_MIN_EQUAL?: number | null;
  order_MIN_GT?: number | null;
  order_MIN_GTE?: number | null;
  order_MIN_LT?: number | null;
  order_MIN_LTE?: number | null;
  order_SUM_EQUAL?: number | null;
  order_SUM_GT?: number | null;
  order_SUM_GTE?: number | null;
  order_SUM_LT?: number | null;
  order_SUM_LTE?: number | null;
}

export interface AgreementScopeIndicationsAggregateInput {
  AND?: AgreementScopeIndicationsAggregateInput[] | null;
  OR?: AgreementScopeIndicationsAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: AgreementScopeIndicationsNodeAggregationWhereInput | null;
}

export interface AgreementScopeIndicationsConnectionWhere {
  AND?: AgreementScopeIndicationsConnectionWhere[] | null;
  OR?: AgreementScopeIndicationsConnectionWhere[] | null;
  node?: IndicationWhere | null;
  node_NOT?: IndicationWhere | null;
}

export interface AgreementScopeIndicationsNodeAggregationWhereInput {
  AND?: AgreementScopeIndicationsNodeAggregationWhereInput[] | null;
  OR?: AgreementScopeIndicationsNodeAggregationWhereInput[] | null;
  code_AVERAGE_EQUAL?: number | null;
  code_AVERAGE_GT?: number | null;
  code_AVERAGE_GTE?: number | null;
  code_AVERAGE_LT?: number | null;
  code_AVERAGE_LTE?: number | null;
  code_EQUAL?: string | null;
  code_GT?: number | null;
  code_GTE?: number | null;
  code_LONGEST_EQUAL?: number | null;
  code_LONGEST_GT?: number | null;
  code_LONGEST_GTE?: number | null;
  code_LONGEST_LT?: number | null;
  code_LONGEST_LTE?: number | null;
  code_LT?: number | null;
  code_LTE?: number | null;
  code_SHORTEST_EQUAL?: number | null;
  code_SHORTEST_GT?: number | null;
  code_SHORTEST_GTE?: number | null;
  code_SHORTEST_LT?: number | null;
  code_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  intentLocalizationKey_AVERAGE_EQUAL?: number | null;
  intentLocalizationKey_AVERAGE_GT?: number | null;
  intentLocalizationKey_AVERAGE_GTE?: number | null;
  intentLocalizationKey_AVERAGE_LT?: number | null;
  intentLocalizationKey_AVERAGE_LTE?: number | null;
  intentLocalizationKey_EQUAL?: string | null;
  intentLocalizationKey_GT?: number | null;
  intentLocalizationKey_GTE?: number | null;
  intentLocalizationKey_LONGEST_EQUAL?: number | null;
  intentLocalizationKey_LONGEST_GT?: number | null;
  intentLocalizationKey_LONGEST_GTE?: number | null;
  intentLocalizationKey_LONGEST_LT?: number | null;
  intentLocalizationKey_LONGEST_LTE?: number | null;
  intentLocalizationKey_LT?: number | null;
  intentLocalizationKey_LTE?: number | null;
  intentLocalizationKey_SHORTEST_EQUAL?: number | null;
  intentLocalizationKey_SHORTEST_GT?: number | null;
  intentLocalizationKey_SHORTEST_GTE?: number | null;
  intentLocalizationKey_SHORTEST_LT?: number | null;
  intentLocalizationKey_SHORTEST_LTE?: number | null;
  intent_AVERAGE_EQUAL?: number | null;
  intent_AVERAGE_GT?: number | null;
  intent_AVERAGE_GTE?: number | null;
  intent_AVERAGE_LT?: number | null;
  intent_AVERAGE_LTE?: number | null;
  intent_EQUAL?: string | null;
  intent_GT?: number | null;
  intent_GTE?: number | null;
  intent_LONGEST_EQUAL?: number | null;
  intent_LONGEST_GT?: number | null;
  intent_LONGEST_GTE?: number | null;
  intent_LONGEST_LT?: number | null;
  intent_LONGEST_LTE?: number | null;
  intent_LT?: number | null;
  intent_LTE?: number | null;
  intent_SHORTEST_EQUAL?: number | null;
  intent_SHORTEST_GT?: number | null;
  intent_SHORTEST_GTE?: number | null;
  intent_SHORTEST_LT?: number | null;
  intent_SHORTEST_LTE?: number | null;
  lineLocalizationKey_AVERAGE_EQUAL?: number | null;
  lineLocalizationKey_AVERAGE_GT?: number | null;
  lineLocalizationKey_AVERAGE_GTE?: number | null;
  lineLocalizationKey_AVERAGE_LT?: number | null;
  lineLocalizationKey_AVERAGE_LTE?: number | null;
  lineLocalizationKey_EQUAL?: string | null;
  lineLocalizationKey_GT?: number | null;
  lineLocalizationKey_GTE?: number | null;
  lineLocalizationKey_LONGEST_EQUAL?: number | null;
  lineLocalizationKey_LONGEST_GT?: number | null;
  lineLocalizationKey_LONGEST_GTE?: number | null;
  lineLocalizationKey_LONGEST_LT?: number | null;
  lineLocalizationKey_LONGEST_LTE?: number | null;
  lineLocalizationKey_LT?: number | null;
  lineLocalizationKey_LTE?: number | null;
  lineLocalizationKey_SHORTEST_EQUAL?: number | null;
  lineLocalizationKey_SHORTEST_GT?: number | null;
  lineLocalizationKey_SHORTEST_GTE?: number | null;
  lineLocalizationKey_SHORTEST_LT?: number | null;
  lineLocalizationKey_SHORTEST_LTE?: number | null;
  line_AVERAGE_EQUAL?: number | null;
  line_AVERAGE_GT?: number | null;
  line_AVERAGE_GTE?: number | null;
  line_AVERAGE_LT?: number | null;
  line_AVERAGE_LTE?: number | null;
  line_EQUAL?: string | null;
  line_GT?: number | null;
  line_GTE?: number | null;
  line_LONGEST_EQUAL?: number | null;
  line_LONGEST_GT?: number | null;
  line_LONGEST_GTE?: number | null;
  line_LONGEST_LT?: number | null;
  line_LONGEST_LTE?: number | null;
  line_LT?: number | null;
  line_LTE?: number | null;
  line_SHORTEST_EQUAL?: number | null;
  line_SHORTEST_GT?: number | null;
  line_SHORTEST_GTE?: number | null;
  line_SHORTEST_LT?: number | null;
  line_SHORTEST_LTE?: number | null;
  mutationLocalizationKey_AVERAGE_EQUAL?: number | null;
  mutationLocalizationKey_AVERAGE_GT?: number | null;
  mutationLocalizationKey_AVERAGE_GTE?: number | null;
  mutationLocalizationKey_AVERAGE_LT?: number | null;
  mutationLocalizationKey_AVERAGE_LTE?: number | null;
  mutationLocalizationKey_EQUAL?: string | null;
  mutationLocalizationKey_GT?: number | null;
  mutationLocalizationKey_GTE?: number | null;
  mutationLocalizationKey_LONGEST_EQUAL?: number | null;
  mutationLocalizationKey_LONGEST_GT?: number | null;
  mutationLocalizationKey_LONGEST_GTE?: number | null;
  mutationLocalizationKey_LONGEST_LT?: number | null;
  mutationLocalizationKey_LONGEST_LTE?: number | null;
  mutationLocalizationKey_LT?: number | null;
  mutationLocalizationKey_LTE?: number | null;
  mutationLocalizationKey_SHORTEST_EQUAL?: number | null;
  mutationLocalizationKey_SHORTEST_GT?: number | null;
  mutationLocalizationKey_SHORTEST_GTE?: number | null;
  mutationLocalizationKey_SHORTEST_LT?: number | null;
  mutationLocalizationKey_SHORTEST_LTE?: number | null;
  mutation_AVERAGE_EQUAL?: number | null;
  mutation_AVERAGE_GT?: number | null;
  mutation_AVERAGE_GTE?: number | null;
  mutation_AVERAGE_LT?: number | null;
  mutation_AVERAGE_LTE?: number | null;
  mutation_EQUAL?: string | null;
  mutation_GT?: number | null;
  mutation_GTE?: number | null;
  mutation_LONGEST_EQUAL?: number | null;
  mutation_LONGEST_GT?: number | null;
  mutation_LONGEST_GTE?: number | null;
  mutation_LONGEST_LT?: number | null;
  mutation_LONGEST_LTE?: number | null;
  mutation_LT?: number | null;
  mutation_LTE?: number | null;
  mutation_SHORTEST_EQUAL?: number | null;
  mutation_SHORTEST_GT?: number | null;
  mutation_SHORTEST_GTE?: number | null;
  mutation_SHORTEST_LT?: number | null;
  mutation_SHORTEST_LTE?: number | null;
  typeLocalizationKey_AVERAGE_EQUAL?: number | null;
  typeLocalizationKey_AVERAGE_GT?: number | null;
  typeLocalizationKey_AVERAGE_GTE?: number | null;
  typeLocalizationKey_AVERAGE_LT?: number | null;
  typeLocalizationKey_AVERAGE_LTE?: number | null;
  typeLocalizationKey_EQUAL?: string | null;
  typeLocalizationKey_GT?: number | null;
  typeLocalizationKey_GTE?: number | null;
  typeLocalizationKey_LONGEST_EQUAL?: number | null;
  typeLocalizationKey_LONGEST_GT?: number | null;
  typeLocalizationKey_LONGEST_GTE?: number | null;
  typeLocalizationKey_LONGEST_LT?: number | null;
  typeLocalizationKey_LONGEST_LTE?: number | null;
  typeLocalizationKey_LT?: number | null;
  typeLocalizationKey_LTE?: number | null;
  typeLocalizationKey_SHORTEST_EQUAL?: number | null;
  typeLocalizationKey_SHORTEST_GT?: number | null;
  typeLocalizationKey_SHORTEST_GTE?: number | null;
  typeLocalizationKey_SHORTEST_LT?: number | null;
  typeLocalizationKey_SHORTEST_LTE?: number | null;
  type_AVERAGE_EQUAL?: number | null;
  type_AVERAGE_GT?: number | null;
  type_AVERAGE_GTE?: number | null;
  type_AVERAGE_LT?: number | null;
  type_AVERAGE_LTE?: number | null;
  type_EQUAL?: string | null;
  type_GT?: number | null;
  type_GTE?: number | null;
  type_LONGEST_EQUAL?: number | null;
  type_LONGEST_GT?: number | null;
  type_LONGEST_GTE?: number | null;
  type_LONGEST_LT?: number | null;
  type_LONGEST_LTE?: number | null;
  type_LT?: number | null;
  type_LTE?: number | null;
  type_SHORTEST_EQUAL?: number | null;
  type_SHORTEST_GT?: number | null;
  type_SHORTEST_GTE?: number | null;
  type_SHORTEST_LT?: number | null;
  type_SHORTEST_LTE?: number | null;
}

export interface AgreementScopeOrganizationScopesAggregateInput {
  AND?: AgreementScopeOrganizationScopesAggregateInput[] | null;
  OR?: AgreementScopeOrganizationScopesAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  edge?: AgreementScopeOrganizationScopesEdgeAggregationWhereInput | null;
  node?: AgreementScopeOrganizationScopesNodeAggregationWhereInput | null;
}

export interface AgreementScopeOrganizationScopesConnectionWhere {
  AND?: AgreementScopeOrganizationScopesConnectionWhere[] | null;
  OR?: AgreementScopeOrganizationScopesConnectionWhere[] | null;
  edge?: OrganizationScopeRelationshipWhere | null;
  edge_NOT?: OrganizationScopeRelationshipWhere | null;
  node?: OrganizationWhere | null;
  node_NOT?: OrganizationWhere | null;
}

export interface AgreementScopeOrganizationScopesEdgeAggregationWhereInput {
  AND?: AgreementScopeOrganizationScopesEdgeAggregationWhereInput[] | null;
  OR?: AgreementScopeOrganizationScopesEdgeAggregationWhereInput[] | null;
  organizationScopeId_AVERAGE_EQUAL?: number | null;
  organizationScopeId_AVERAGE_GT?: number | null;
  organizationScopeId_AVERAGE_GTE?: number | null;
  organizationScopeId_AVERAGE_LT?: number | null;
  organizationScopeId_AVERAGE_LTE?: number | null;
  organizationScopeId_EQUAL?: string | null;
  organizationScopeId_GT?: number | null;
  organizationScopeId_GTE?: number | null;
  organizationScopeId_LONGEST_EQUAL?: number | null;
  organizationScopeId_LONGEST_GT?: number | null;
  organizationScopeId_LONGEST_GTE?: number | null;
  organizationScopeId_LONGEST_LT?: number | null;
  organizationScopeId_LONGEST_LTE?: number | null;
  organizationScopeId_LT?: number | null;
  organizationScopeId_LTE?: number | null;
  organizationScopeId_SHORTEST_EQUAL?: number | null;
  organizationScopeId_SHORTEST_GT?: number | null;
  organizationScopeId_SHORTEST_GTE?: number | null;
  organizationScopeId_SHORTEST_LT?: number | null;
  organizationScopeId_SHORTEST_LTE?: number | null;
}

export interface AgreementScopeOrganizationScopesNodeAggregationWhereInput {
  AND?: AgreementScopeOrganizationScopesNodeAggregationWhereInput[] | null;
  BIC_AVERAGE_EQUAL?: number | null;
  BIC_AVERAGE_GT?: number | null;
  BIC_AVERAGE_GTE?: number | null;
  BIC_AVERAGE_LT?: number | null;
  BIC_AVERAGE_LTE?: number | null;
  BIC_EQUAL?: string | null;
  BIC_GT?: number | null;
  BIC_GTE?: number | null;
  BIC_LONGEST_EQUAL?: number | null;
  BIC_LONGEST_GT?: number | null;
  BIC_LONGEST_GTE?: number | null;
  BIC_LONGEST_LT?: number | null;
  BIC_LONGEST_LTE?: number | null;
  BIC_LT?: number | null;
  BIC_LTE?: number | null;
  BIC_SHORTEST_EQUAL?: number | null;
  BIC_SHORTEST_GT?: number | null;
  BIC_SHORTEST_GTE?: number | null;
  BIC_SHORTEST_LT?: number | null;
  BIC_SHORTEST_LTE?: number | null;
  IBAN_AVERAGE_EQUAL?: number | null;
  IBAN_AVERAGE_GT?: number | null;
  IBAN_AVERAGE_GTE?: number | null;
  IBAN_AVERAGE_LT?: number | null;
  IBAN_AVERAGE_LTE?: number | null;
  IBAN_EQUAL?: string | null;
  IBAN_GT?: number | null;
  IBAN_GTE?: number | null;
  IBAN_LONGEST_EQUAL?: number | null;
  IBAN_LONGEST_GT?: number | null;
  IBAN_LONGEST_GTE?: number | null;
  IBAN_LONGEST_LT?: number | null;
  IBAN_LONGEST_LTE?: number | null;
  IBAN_LT?: number | null;
  IBAN_LTE?: number | null;
  IBAN_SHORTEST_EQUAL?: number | null;
  IBAN_SHORTEST_GT?: number | null;
  IBAN_SHORTEST_GTE?: number | null;
  IBAN_SHORTEST_LT?: number | null;
  IBAN_SHORTEST_LTE?: number | null;
  OR?: AgreementScopeOrganizationScopesNodeAggregationWhereInput[] | null;
  accountName_AVERAGE_EQUAL?: number | null;
  accountName_AVERAGE_GT?: number | null;
  accountName_AVERAGE_GTE?: number | null;
  accountName_AVERAGE_LT?: number | null;
  accountName_AVERAGE_LTE?: number | null;
  accountName_EQUAL?: string | null;
  accountName_GT?: number | null;
  accountName_GTE?: number | null;
  accountName_LONGEST_EQUAL?: number | null;
  accountName_LONGEST_GT?: number | null;
  accountName_LONGEST_GTE?: number | null;
  accountName_LONGEST_LT?: number | null;
  accountName_LONGEST_LTE?: number | null;
  accountName_LT?: number | null;
  accountName_LTE?: number | null;
  accountName_SHORTEST_EQUAL?: number | null;
  accountName_SHORTEST_GT?: number | null;
  accountName_SHORTEST_GTE?: number | null;
  accountName_SHORTEST_LT?: number | null;
  accountName_SHORTEST_LTE?: number | null;
  accountNumber_AVERAGE_EQUAL?: number | null;
  accountNumber_AVERAGE_GT?: number | null;
  accountNumber_AVERAGE_GTE?: number | null;
  accountNumber_AVERAGE_LT?: number | null;
  accountNumber_AVERAGE_LTE?: number | null;
  accountNumber_EQUAL?: string | null;
  accountNumber_GT?: number | null;
  accountNumber_GTE?: number | null;
  accountNumber_LONGEST_EQUAL?: number | null;
  accountNumber_LONGEST_GT?: number | null;
  accountNumber_LONGEST_GTE?: number | null;
  accountNumber_LONGEST_LT?: number | null;
  accountNumber_LONGEST_LTE?: number | null;
  accountNumber_LT?: number | null;
  accountNumber_LTE?: number | null;
  accountNumber_SHORTEST_EQUAL?: number | null;
  accountNumber_SHORTEST_GT?: number | null;
  accountNumber_SHORTEST_GTE?: number | null;
  accountNumber_SHORTEST_LT?: number | null;
  accountNumber_SHORTEST_LTE?: number | null;
  billingAddress_AVERAGE_EQUAL?: number | null;
  billingAddress_AVERAGE_GT?: number | null;
  billingAddress_AVERAGE_GTE?: number | null;
  billingAddress_AVERAGE_LT?: number | null;
  billingAddress_AVERAGE_LTE?: number | null;
  billingAddress_EQUAL?: string | null;
  billingAddress_GT?: number | null;
  billingAddress_GTE?: number | null;
  billingAddress_LONGEST_EQUAL?: number | null;
  billingAddress_LONGEST_GT?: number | null;
  billingAddress_LONGEST_GTE?: number | null;
  billingAddress_LONGEST_LT?: number | null;
  billingAddress_LONGEST_LTE?: number | null;
  billingAddress_LT?: number | null;
  billingAddress_LTE?: number | null;
  billingAddress_SHORTEST_EQUAL?: number | null;
  billingAddress_SHORTEST_GT?: number | null;
  billingAddress_SHORTEST_GTE?: number | null;
  billingAddress_SHORTEST_LT?: number | null;
  billingAddress_SHORTEST_LTE?: number | null;
  contactEmail_AVERAGE_EQUAL?: number | null;
  contactEmail_AVERAGE_GT?: number | null;
  contactEmail_AVERAGE_GTE?: number | null;
  contactEmail_AVERAGE_LT?: number | null;
  contactEmail_AVERAGE_LTE?: number | null;
  contactEmail_EQUAL?: string | null;
  contactEmail_GT?: number | null;
  contactEmail_GTE?: number | null;
  contactEmail_LONGEST_EQUAL?: number | null;
  contactEmail_LONGEST_GT?: number | null;
  contactEmail_LONGEST_GTE?: number | null;
  contactEmail_LONGEST_LT?: number | null;
  contactEmail_LONGEST_LTE?: number | null;
  contactEmail_LT?: number | null;
  contactEmail_LTE?: number | null;
  contactEmail_SHORTEST_EQUAL?: number | null;
  contactEmail_SHORTEST_GT?: number | null;
  contactEmail_SHORTEST_GTE?: number | null;
  contactEmail_SHORTEST_LT?: number | null;
  contactEmail_SHORTEST_LTE?: number | null;
  contactFirstName_AVERAGE_EQUAL?: number | null;
  contactFirstName_AVERAGE_GT?: number | null;
  contactFirstName_AVERAGE_GTE?: number | null;
  contactFirstName_AVERAGE_LT?: number | null;
  contactFirstName_AVERAGE_LTE?: number | null;
  contactFirstName_EQUAL?: string | null;
  contactFirstName_GT?: number | null;
  contactFirstName_GTE?: number | null;
  contactFirstName_LONGEST_EQUAL?: number | null;
  contactFirstName_LONGEST_GT?: number | null;
  contactFirstName_LONGEST_GTE?: number | null;
  contactFirstName_LONGEST_LT?: number | null;
  contactFirstName_LONGEST_LTE?: number | null;
  contactFirstName_LT?: number | null;
  contactFirstName_LTE?: number | null;
  contactFirstName_SHORTEST_EQUAL?: number | null;
  contactFirstName_SHORTEST_GT?: number | null;
  contactFirstName_SHORTEST_GTE?: number | null;
  contactFirstName_SHORTEST_LT?: number | null;
  contactFirstName_SHORTEST_LTE?: number | null;
  contactLastName_AVERAGE_EQUAL?: number | null;
  contactLastName_AVERAGE_GT?: number | null;
  contactLastName_AVERAGE_GTE?: number | null;
  contactLastName_AVERAGE_LT?: number | null;
  contactLastName_AVERAGE_LTE?: number | null;
  contactLastName_EQUAL?: string | null;
  contactLastName_GT?: number | null;
  contactLastName_GTE?: number | null;
  contactLastName_LONGEST_EQUAL?: number | null;
  contactLastName_LONGEST_GT?: number | null;
  contactLastName_LONGEST_GTE?: number | null;
  contactLastName_LONGEST_LT?: number | null;
  contactLastName_LONGEST_LTE?: number | null;
  contactLastName_LT?: number | null;
  contactLastName_LTE?: number | null;
  contactLastName_SHORTEST_EQUAL?: number | null;
  contactLastName_SHORTEST_GT?: number | null;
  contactLastName_SHORTEST_GTE?: number | null;
  contactLastName_SHORTEST_LT?: number | null;
  contactLastName_SHORTEST_LTE?: number | null;
  contactOccupation_AVERAGE_EQUAL?: number | null;
  contactOccupation_AVERAGE_GT?: number | null;
  contactOccupation_AVERAGE_GTE?: number | null;
  contactOccupation_AVERAGE_LT?: number | null;
  contactOccupation_AVERAGE_LTE?: number | null;
  contactOccupation_EQUAL?: string | null;
  contactOccupation_GT?: number | null;
  contactOccupation_GTE?: number | null;
  contactOccupation_LONGEST_EQUAL?: number | null;
  contactOccupation_LONGEST_GT?: number | null;
  contactOccupation_LONGEST_GTE?: number | null;
  contactOccupation_LONGEST_LT?: number | null;
  contactOccupation_LONGEST_LTE?: number | null;
  contactOccupation_LT?: number | null;
  contactOccupation_LTE?: number | null;
  contactOccupation_SHORTEST_EQUAL?: number | null;
  contactOccupation_SHORTEST_GT?: number | null;
  contactOccupation_SHORTEST_GTE?: number | null;
  contactOccupation_SHORTEST_LT?: number | null;
  contactOccupation_SHORTEST_LTE?: number | null;
  contactPhone_AVERAGE_EQUAL?: number | null;
  contactPhone_AVERAGE_GT?: number | null;
  contactPhone_AVERAGE_GTE?: number | null;
  contactPhone_AVERAGE_LT?: number | null;
  contactPhone_AVERAGE_LTE?: number | null;
  contactPhone_EQUAL?: string | null;
  contactPhone_GT?: number | null;
  contactPhone_GTE?: number | null;
  contactPhone_LONGEST_EQUAL?: number | null;
  contactPhone_LONGEST_GT?: number | null;
  contactPhone_LONGEST_GTE?: number | null;
  contactPhone_LONGEST_LT?: number | null;
  contactPhone_LONGEST_LTE?: number | null;
  contactPhone_LT?: number | null;
  contactPhone_LTE?: number | null;
  contactPhone_SHORTEST_EQUAL?: number | null;
  contactPhone_SHORTEST_GT?: number | null;
  contactPhone_SHORTEST_GTE?: number | null;
  contactPhone_SHORTEST_LT?: number | null;
  contactPhone_SHORTEST_LTE?: number | null;
  createdOn_AVERAGE_EQUAL?: number | null;
  createdOn_AVERAGE_GT?: number | null;
  createdOn_AVERAGE_GTE?: number | null;
  createdOn_AVERAGE_LT?: number | null;
  createdOn_AVERAGE_LTE?: number | null;
  createdOn_EQUAL?: number | null;
  createdOn_GT?: number | null;
  createdOn_GTE?: number | null;
  createdOn_LT?: number | null;
  createdOn_LTE?: number | null;
  createdOn_MAX_EQUAL?: number | null;
  createdOn_MAX_GT?: number | null;
  createdOn_MAX_GTE?: number | null;
  createdOn_MAX_LT?: number | null;
  createdOn_MAX_LTE?: number | null;
  createdOn_MIN_EQUAL?: number | null;
  createdOn_MIN_GT?: number | null;
  createdOn_MIN_GTE?: number | null;
  createdOn_MIN_LT?: number | null;
  createdOn_MIN_LTE?: number | null;
  createdOn_SUM_EQUAL?: number | null;
  createdOn_SUM_GT?: number | null;
  createdOn_SUM_GTE?: number | null;
  createdOn_SUM_LT?: number | null;
  createdOn_SUM_LTE?: number | null;
  deliveryAddress_AVERAGE_EQUAL?: number | null;
  deliveryAddress_AVERAGE_GT?: number | null;
  deliveryAddress_AVERAGE_GTE?: number | null;
  deliveryAddress_AVERAGE_LT?: number | null;
  deliveryAddress_AVERAGE_LTE?: number | null;
  deliveryAddress_EQUAL?: string | null;
  deliveryAddress_GT?: number | null;
  deliveryAddress_GTE?: number | null;
  deliveryAddress_LONGEST_EQUAL?: number | null;
  deliveryAddress_LONGEST_GT?: number | null;
  deliveryAddress_LONGEST_GTE?: number | null;
  deliveryAddress_LONGEST_LT?: number | null;
  deliveryAddress_LONGEST_LTE?: number | null;
  deliveryAddress_LT?: number | null;
  deliveryAddress_LTE?: number | null;
  deliveryAddress_SHORTEST_EQUAL?: number | null;
  deliveryAddress_SHORTEST_GT?: number | null;
  deliveryAddress_SHORTEST_GTE?: number | null;
  deliveryAddress_SHORTEST_LT?: number | null;
  deliveryAddress_SHORTEST_LTE?: number | null;
  domicile_AVERAGE_EQUAL?: number | null;
  domicile_AVERAGE_GT?: number | null;
  domicile_AVERAGE_GTE?: number | null;
  domicile_AVERAGE_LT?: number | null;
  domicile_AVERAGE_LTE?: number | null;
  domicile_EQUAL?: string | null;
  domicile_GT?: number | null;
  domicile_GTE?: number | null;
  domicile_LONGEST_EQUAL?: number | null;
  domicile_LONGEST_GT?: number | null;
  domicile_LONGEST_GTE?: number | null;
  domicile_LONGEST_LT?: number | null;
  domicile_LONGEST_LTE?: number | null;
  domicile_LT?: number | null;
  domicile_LTE?: number | null;
  domicile_SHORTEST_EQUAL?: number | null;
  domicile_SHORTEST_GT?: number | null;
  domicile_SHORTEST_GTE?: number | null;
  domicile_SHORTEST_LT?: number | null;
  domicile_SHORTEST_LTE?: number | null;
  dualApprovalThreshold_AVERAGE_EQUAL?: number | null;
  dualApprovalThreshold_AVERAGE_GT?: number | null;
  dualApprovalThreshold_AVERAGE_GTE?: number | null;
  dualApprovalThreshold_AVERAGE_LT?: number | null;
  dualApprovalThreshold_AVERAGE_LTE?: number | null;
  dualApprovalThreshold_EQUAL?: number | null;
  dualApprovalThreshold_GT?: number | null;
  dualApprovalThreshold_GTE?: number | null;
  dualApprovalThreshold_LT?: number | null;
  dualApprovalThreshold_LTE?: number | null;
  dualApprovalThreshold_MAX_EQUAL?: number | null;
  dualApprovalThreshold_MAX_GT?: number | null;
  dualApprovalThreshold_MAX_GTE?: number | null;
  dualApprovalThreshold_MAX_LT?: number | null;
  dualApprovalThreshold_MAX_LTE?: number | null;
  dualApprovalThreshold_MIN_EQUAL?: number | null;
  dualApprovalThreshold_MIN_GT?: number | null;
  dualApprovalThreshold_MIN_GTE?: number | null;
  dualApprovalThreshold_MIN_LT?: number | null;
  dualApprovalThreshold_MIN_LTE?: number | null;
  dualApprovalThreshold_SUM_EQUAL?: number | null;
  dualApprovalThreshold_SUM_GT?: number | null;
  dualApprovalThreshold_SUM_GTE?: number | null;
  dualApprovalThreshold_SUM_LT?: number | null;
  dualApprovalThreshold_SUM_LTE?: number | null;
  eIN_AVERAGE_EQUAL?: number | null;
  eIN_AVERAGE_GT?: number | null;
  eIN_AVERAGE_GTE?: number | null;
  eIN_AVERAGE_LT?: number | null;
  eIN_AVERAGE_LTE?: number | null;
  eIN_EQUAL?: string | null;
  eIN_GT?: number | null;
  eIN_GTE?: number | null;
  eIN_LONGEST_EQUAL?: number | null;
  eIN_LONGEST_GT?: number | null;
  eIN_LONGEST_GTE?: number | null;
  eIN_LONGEST_LT?: number | null;
  eIN_LONGEST_LTE?: number | null;
  eIN_LT?: number | null;
  eIN_LTE?: number | null;
  eIN_SHORTEST_EQUAL?: number | null;
  eIN_SHORTEST_GT?: number | null;
  eIN_SHORTEST_GTE?: number | null;
  eIN_SHORTEST_LT?: number | null;
  eIN_SHORTEST_LTE?: number | null;
  fax_AVERAGE_EQUAL?: number | null;
  fax_AVERAGE_GT?: number | null;
  fax_AVERAGE_GTE?: number | null;
  fax_AVERAGE_LT?: number | null;
  fax_AVERAGE_LTE?: number | null;
  fax_EQUAL?: string | null;
  fax_GT?: number | null;
  fax_GTE?: number | null;
  fax_LONGEST_EQUAL?: number | null;
  fax_LONGEST_GT?: number | null;
  fax_LONGEST_GTE?: number | null;
  fax_LONGEST_LT?: number | null;
  fax_LONGEST_LTE?: number | null;
  fax_LT?: number | null;
  fax_LTE?: number | null;
  fax_SHORTEST_EQUAL?: number | null;
  fax_SHORTEST_GT?: number | null;
  fax_SHORTEST_GTE?: number | null;
  fax_SHORTEST_LT?: number | null;
  fax_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  legalName_AVERAGE_EQUAL?: number | null;
  legalName_AVERAGE_GT?: number | null;
  legalName_AVERAGE_GTE?: number | null;
  legalName_AVERAGE_LT?: number | null;
  legalName_AVERAGE_LTE?: number | null;
  legalName_EQUAL?: string | null;
  legalName_GT?: number | null;
  legalName_GTE?: number | null;
  legalName_LONGEST_EQUAL?: number | null;
  legalName_LONGEST_GT?: number | null;
  legalName_LONGEST_GTE?: number | null;
  legalName_LONGEST_LT?: number | null;
  legalName_LONGEST_LTE?: number | null;
  legalName_LT?: number | null;
  legalName_LTE?: number | null;
  legalName_SHORTEST_EQUAL?: number | null;
  legalName_SHORTEST_GT?: number | null;
  legalName_SHORTEST_GTE?: number | null;
  legalName_SHORTEST_LT?: number | null;
  legalName_SHORTEST_LTE?: number | null;
  logo_AVERAGE_EQUAL?: number | null;
  logo_AVERAGE_GT?: number | null;
  logo_AVERAGE_GTE?: number | null;
  logo_AVERAGE_LT?: number | null;
  logo_AVERAGE_LTE?: number | null;
  logo_EQUAL?: string | null;
  logo_GT?: number | null;
  logo_GTE?: number | null;
  logo_LONGEST_EQUAL?: number | null;
  logo_LONGEST_GT?: number | null;
  logo_LONGEST_GTE?: number | null;
  logo_LONGEST_LT?: number | null;
  logo_LONGEST_LTE?: number | null;
  logo_LT?: number | null;
  logo_LTE?: number | null;
  logo_SHORTEST_EQUAL?: number | null;
  logo_SHORTEST_GT?: number | null;
  logo_SHORTEST_GTE?: number | null;
  logo_SHORTEST_LT?: number | null;
  logo_SHORTEST_LTE?: number | null;
  name_AVERAGE_EQUAL?: number | null;
  name_AVERAGE_GT?: number | null;
  name_AVERAGE_GTE?: number | null;
  name_AVERAGE_LT?: number | null;
  name_AVERAGE_LTE?: number | null;
  name_EQUAL?: string | null;
  name_GT?: number | null;
  name_GTE?: number | null;
  name_LONGEST_EQUAL?: number | null;
  name_LONGEST_GT?: number | null;
  name_LONGEST_GTE?: number | null;
  name_LONGEST_LT?: number | null;
  name_LONGEST_LTE?: number | null;
  name_LT?: number | null;
  name_LTE?: number | null;
  name_SHORTEST_EQUAL?: number | null;
  name_SHORTEST_GT?: number | null;
  name_SHORTEST_GTE?: number | null;
  name_SHORTEST_LT?: number | null;
  name_SHORTEST_LTE?: number | null;
  paymentTerms_AVERAGE_EQUAL?: number | null;
  paymentTerms_AVERAGE_GT?: number | null;
  paymentTerms_AVERAGE_GTE?: number | null;
  paymentTerms_AVERAGE_LT?: number | null;
  paymentTerms_AVERAGE_LTE?: number | null;
  paymentTerms_EQUAL?: number | null;
  paymentTerms_GT?: number | null;
  paymentTerms_GTE?: number | null;
  paymentTerms_LT?: number | null;
  paymentTerms_LTE?: number | null;
  paymentTerms_MAX_EQUAL?: number | null;
  paymentTerms_MAX_GT?: number | null;
  paymentTerms_MAX_GTE?: number | null;
  paymentTerms_MAX_LT?: number | null;
  paymentTerms_MAX_LTE?: number | null;
  paymentTerms_MIN_EQUAL?: number | null;
  paymentTerms_MIN_GT?: number | null;
  paymentTerms_MIN_GTE?: number | null;
  paymentTerms_MIN_LT?: number | null;
  paymentTerms_MIN_LTE?: number | null;
  paymentTerms_SUM_EQUAL?: number | null;
  paymentTerms_SUM_GT?: number | null;
  paymentTerms_SUM_GTE?: number | null;
  paymentTerms_SUM_LT?: number | null;
  paymentTerms_SUM_LTE?: number | null;
  phone_AVERAGE_EQUAL?: number | null;
  phone_AVERAGE_GT?: number | null;
  phone_AVERAGE_GTE?: number | null;
  phone_AVERAGE_LT?: number | null;
  phone_AVERAGE_LTE?: number | null;
  phone_EQUAL?: string | null;
  phone_GT?: number | null;
  phone_GTE?: number | null;
  phone_LONGEST_EQUAL?: number | null;
  phone_LONGEST_GT?: number | null;
  phone_LONGEST_GTE?: number | null;
  phone_LONGEST_LT?: number | null;
  phone_LONGEST_LTE?: number | null;
  phone_LT?: number | null;
  phone_LTE?: number | null;
  phone_SHORTEST_EQUAL?: number | null;
  phone_SHORTEST_GT?: number | null;
  phone_SHORTEST_GTE?: number | null;
  phone_SHORTEST_LT?: number | null;
  phone_SHORTEST_LTE?: number | null;
  tenantId_AVERAGE_EQUAL?: number | null;
  tenantId_AVERAGE_GT?: number | null;
  tenantId_AVERAGE_GTE?: number | null;
  tenantId_AVERAGE_LT?: number | null;
  tenantId_AVERAGE_LTE?: number | null;
  tenantId_EQUAL?: string | null;
  tenantId_GT?: number | null;
  tenantId_GTE?: number | null;
  tenantId_LONGEST_EQUAL?: number | null;
  tenantId_LONGEST_GT?: number | null;
  tenantId_LONGEST_GTE?: number | null;
  tenantId_LONGEST_LT?: number | null;
  tenantId_LONGEST_LTE?: number | null;
  tenantId_LT?: number | null;
  tenantId_LTE?: number | null;
  tenantId_SHORTEST_EQUAL?: number | null;
  tenantId_SHORTEST_GT?: number | null;
  tenantId_SHORTEST_GTE?: number | null;
  tenantId_SHORTEST_LT?: number | null;
  tenantId_SHORTEST_LTE?: number | null;
  website_AVERAGE_EQUAL?: number | null;
  website_AVERAGE_GT?: number | null;
  website_AVERAGE_GTE?: number | null;
  website_AVERAGE_LT?: number | null;
  website_AVERAGE_LTE?: number | null;
  website_EQUAL?: string | null;
  website_GT?: number | null;
  website_GTE?: number | null;
  website_LONGEST_EQUAL?: number | null;
  website_LONGEST_GT?: number | null;
  website_LONGEST_GTE?: number | null;
  website_LONGEST_LT?: number | null;
  website_LONGEST_LTE?: number | null;
  website_LT?: number | null;
  website_LTE?: number | null;
  website_SHORTEST_EQUAL?: number | null;
  website_SHORTEST_GT?: number | null;
  website_SHORTEST_GTE?: number | null;
  website_SHORTEST_LT?: number | null;
  website_SHORTEST_LTE?: number | null;
}

export interface AgreementScopeRelationshipWhere {
  AND?: AgreementScopeRelationshipWhere[] | null;
  OR?: AgreementScopeRelationshipWhere[] | null;
  excludedOn?: any | null;
  excludedOn_GT?: any | null;
  excludedOn_GTE?: any | null;
  excludedOn_IN?: (any | null)[] | null;
  excludedOn_LT?: any | null;
  excludedOn_LTE?: any | null;
  excludedOn_NOT?: any | null;
  excludedOn_NOT_IN?: (any | null)[] | null;
  isExtended?: boolean | null;
  isExtended_NOT?: boolean | null;
}

export interface AgreementScopeTreatmentSetsAggregateInput {
  AND?: AgreementScopeTreatmentSetsAggregateInput[] | null;
  OR?: AgreementScopeTreatmentSetsAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: AgreementScopeTreatmentSetsNodeAggregationWhereInput | null;
}

export interface AgreementScopeTreatmentSetsConnectionWhere {
  AND?: AgreementScopeTreatmentSetsConnectionWhere[] | null;
  OR?: AgreementScopeTreatmentSetsConnectionWhere[] | null;
  node?: TreatmentSetWhere | null;
  node_NOT?: TreatmentSetWhere | null;
}

export interface AgreementScopeTreatmentSetsNodeAggregationWhereInput {
  AND?: AgreementScopeTreatmentSetsNodeAggregationWhereInput[] | null;
  OR?: AgreementScopeTreatmentSetsNodeAggregationWhereInput[] | null;
  order_AVERAGE_EQUAL?: number | null;
  order_AVERAGE_GT?: number | null;
  order_AVERAGE_GTE?: number | null;
  order_AVERAGE_LT?: number | null;
  order_AVERAGE_LTE?: number | null;
  order_EQUAL?: number | null;
  order_GT?: number | null;
  order_GTE?: number | null;
  order_LT?: number | null;
  order_LTE?: number | null;
  order_MAX_EQUAL?: number | null;
  order_MAX_GT?: number | null;
  order_MAX_GTE?: number | null;
  order_MAX_LT?: number | null;
  order_MAX_LTE?: number | null;
  order_MIN_EQUAL?: number | null;
  order_MIN_GT?: number | null;
  order_MIN_GTE?: number | null;
  order_MIN_LT?: number | null;
  order_MIN_LTE?: number | null;
  order_SUM_EQUAL?: number | null;
  order_SUM_GT?: number | null;
  order_SUM_GTE?: number | null;
  order_SUM_LT?: number | null;
  order_SUM_LTE?: number | null;
}

export interface AgreementScopeWhere {
  AND?: AgreementScopeWhere[] | null;
  OR?: AgreementScopeWhere[] | null;
  code?: string | null;
  code_CONTAINS?: string | null;
  code_ENDS_WITH?: string | null;
  code_IN?: (string | null)[] | null;
  code_MATCHES?: string | null;
  code_NOT?: string | null;
  code_NOT_CONTAINS?: string | null;
  code_NOT_ENDS_WITH?: string | null;
  code_NOT_IN?: (string | null)[] | null;
  code_NOT_STARTS_WITH?: string | null;
  code_STARTS_WITH?: string | null;
  countryScopes?: CurrencyWhere | null;
  countryScopesAggregate?: AgreementScopeCountryScopesAggregateInput | null;
  countryScopesConnection?: AgreementScopeCountryScopesConnectionWhere | null;
  countryScopesConnection_NOT?: AgreementScopeCountryScopesConnectionWhere | null;
  countryScopes_NOT?: CurrencyWhere | null;
  cycles?: CycleConfigurationWhere | null;
  cyclesAggregate?: AgreementScopeCyclesAggregateInput | null;
  cyclesConnection?: AgreementScopeCyclesConnectionWhere | null;
  cyclesConnection_NOT?: AgreementScopeCyclesConnectionWhere | null;
  cycles_NOT?: CycleConfigurationWhere | null;
  diseases?: DiseaseWhere | null;
  diseasesAggregate?: AgreementScopeDiseasesAggregateInput | null;
  diseasesConnection?: AgreementScopeDiseasesConnectionWhere | null;
  diseasesConnection_NOT?: AgreementScopeDiseasesConnectionWhere | null;
  diseases_NOT?: DiseaseWhere | null;
  enrollingConditionSets?: EnrollingConditionSetWhere | null;
  enrollingConditionSetsAggregate?: AgreementScopeEnrollingConditionSetsAggregateInput | null;
  enrollingConditionSetsConnection?: AgreementScopeEnrollingConditionSetsConnectionWhere | null;
  enrollingConditionSetsConnection_NOT?: AgreementScopeEnrollingConditionSetsConnectionWhere | null;
  enrollingConditionSets_NOT?: EnrollingConditionSetWhere | null;
  indications?: IndicationWhere | null;
  indicationsAggregate?: AgreementScopeIndicationsAggregateInput | null;
  indicationsConnection?: AgreementScopeIndicationsConnectionWhere | null;
  indicationsConnection_NOT?: AgreementScopeIndicationsConnectionWhere | null;
  indications_NOT?: IndicationWhere | null;
  isDeleted?: boolean | null;
  isDeleted_NOT?: boolean | null;
  logicalOperator?: ConditionLogicalOperator | null;
  logicalOperator_IN?: (ConditionLogicalOperator | null)[] | null;
  logicalOperator_NOT?: ConditionLogicalOperator | null;
  logicalOperator_NOT_IN?: (ConditionLogicalOperator | null)[] | null;
  order?: number | null;
  order_GT?: number | null;
  order_GTE?: number | null;
  order_IN?: (number | null)[] | null;
  order_LT?: number | null;
  order_LTE?: number | null;
  order_NOT?: number | null;
  order_NOT_IN?: (number | null)[] | null;
  organizationScopes?: OrganizationWhere | null;
  organizationScopesAggregate?: AgreementScopeOrganizationScopesAggregateInput | null;
  organizationScopesConnection?: AgreementScopeOrganizationScopesConnectionWhere | null;
  organizationScopesConnection_NOT?: AgreementScopeOrganizationScopesConnectionWhere | null;
  organizationScopes_NOT?: OrganizationWhere | null;
  scopeId?: string | null;
  scopeId_CONTAINS?: string | null;
  scopeId_ENDS_WITH?: string | null;
  scopeId_IN?: (string | null)[] | null;
  scopeId_MATCHES?: string | null;
  scopeId_NOT?: string | null;
  scopeId_NOT_CONTAINS?: string | null;
  scopeId_NOT_ENDS_WITH?: string | null;
  scopeId_NOT_IN?: (string | null)[] | null;
  scopeId_NOT_STARTS_WITH?: string | null;
  scopeId_STARTS_WITH?: string | null;
  tenantIds?: string[] | null;
  tenantIds_INCLUDES?: string | null;
  tenantIds_NOT?: string[] | null;
  tenantIds_NOT_INCLUDES?: string | null;
  treatmentSets?: TreatmentSetWhere | null;
  treatmentSetsAggregate?: AgreementScopeTreatmentSetsAggregateInput | null;
  treatmentSetsConnection?: AgreementScopeTreatmentSetsConnectionWhere | null;
  treatmentSetsConnection_NOT?: AgreementScopeTreatmentSetsConnectionWhere | null;
  treatmentSets_NOT?: TreatmentSetWhere | null;
}

/**
 * Fields to sort Agreements by. The order in which sorts are applied is not guaranteed when specifying many fields in one AgreementSort object.
 */
export interface AgreementSort {
  canParticipateInApproval?: SortDirection | null;
  canUserViewFinancials?: SortDirection | null;
  description?: SortDirection | null;
  formattedAmount?: SortDirection | null;
  formattedCounterparties?: SortDirection | null;
  formattedDiseases?: SortDirection | null;
  formattedIndications?: SortDirection | null;
  formattedProducts?: SortDirection | null;
  formattedTags?: SortDirection | null;
  formattedValidityPeriod?: SortDirection | null;
  id?: SortDirection | null;
  initialVersionId?: SortDirection | null;
  isApprovedByOrganization?: SortDirection | null;
  isArchived?: SortDirection | null;
  isDeleted?: SortDirection | null;
  isExtended?: SortDirection | null;
  isFirstVersion?: SortDirection | null;
  isHidden?: SortDirection | null;
  isInsightsAvailable?: SortDirection | null;
  isLastVersion?: SortDirection | null;
  isStobContract?: SortDirection | null;
  lastVersionStatus?: SortDirection | null;
  lastVersionValidToDate?: SortDirection | null;
  name?: SortDirection | null;
  searchTerm?: SortDirection | null;
  status?: SortDirection | null;
  subjectMatter?: SortDirection | null;
  totalAmount?: SortDirection | null;
  unlimited?: SortDirection | null;
  validFromDate?: SortDirection | null;
  validToDate?: SortDirection | null;
  version?: SortDirection | null;
}

export interface AgreementStatusTransitionCausedByAggregateInput {
  AND?: AgreementStatusTransitionCausedByAggregateInput[] | null;
  OR?: AgreementStatusTransitionCausedByAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: AgreementStatusTransitionCausedByNodeAggregationWhereInput | null;
}

export interface AgreementStatusTransitionCausedByConnectionWhere {
  AND?: AgreementStatusTransitionCausedByConnectionWhere[] | null;
  OR?: AgreementStatusTransitionCausedByConnectionWhere[] | null;
  node?: UserWhere | null;
  node_NOT?: UserWhere | null;
}

export interface AgreementStatusTransitionCausedByNodeAggregationWhereInput {
  AND?: AgreementStatusTransitionCausedByNodeAggregationWhereInput[] | null;
  OR?: AgreementStatusTransitionCausedByNodeAggregationWhereInput[] | null;
  deletedOn_EQUAL?: any | null;
  deletedOn_GT?: any | null;
  deletedOn_GTE?: any | null;
  deletedOn_LT?: any | null;
  deletedOn_LTE?: any | null;
  deletedOn_MAX_EQUAL?: any | null;
  deletedOn_MAX_GT?: any | null;
  deletedOn_MAX_GTE?: any | null;
  deletedOn_MAX_LT?: any | null;
  deletedOn_MAX_LTE?: any | null;
  deletedOn_MIN_EQUAL?: any | null;
  deletedOn_MIN_GT?: any | null;
  deletedOn_MIN_GTE?: any | null;
  deletedOn_MIN_LT?: any | null;
  deletedOn_MIN_LTE?: any | null;
  department_AVERAGE_EQUAL?: number | null;
  department_AVERAGE_GT?: number | null;
  department_AVERAGE_GTE?: number | null;
  department_AVERAGE_LT?: number | null;
  department_AVERAGE_LTE?: number | null;
  department_EQUAL?: string | null;
  department_GT?: number | null;
  department_GTE?: number | null;
  department_LONGEST_EQUAL?: number | null;
  department_LONGEST_GT?: number | null;
  department_LONGEST_GTE?: number | null;
  department_LONGEST_LT?: number | null;
  department_LONGEST_LTE?: number | null;
  department_LT?: number | null;
  department_LTE?: number | null;
  department_SHORTEST_EQUAL?: number | null;
  department_SHORTEST_GT?: number | null;
  department_SHORTEST_GTE?: number | null;
  department_SHORTEST_LT?: number | null;
  department_SHORTEST_LTE?: number | null;
  email_AVERAGE_EQUAL?: number | null;
  email_AVERAGE_GT?: number | null;
  email_AVERAGE_GTE?: number | null;
  email_AVERAGE_LT?: number | null;
  email_AVERAGE_LTE?: number | null;
  email_EQUAL?: string | null;
  email_GT?: number | null;
  email_GTE?: number | null;
  email_LONGEST_EQUAL?: number | null;
  email_LONGEST_GT?: number | null;
  email_LONGEST_GTE?: number | null;
  email_LONGEST_LT?: number | null;
  email_LONGEST_LTE?: number | null;
  email_LT?: number | null;
  email_LTE?: number | null;
  email_SHORTEST_EQUAL?: number | null;
  email_SHORTEST_GT?: number | null;
  email_SHORTEST_GTE?: number | null;
  email_SHORTEST_LT?: number | null;
  email_SHORTEST_LTE?: number | null;
  firstName_AVERAGE_EQUAL?: number | null;
  firstName_AVERAGE_GT?: number | null;
  firstName_AVERAGE_GTE?: number | null;
  firstName_AVERAGE_LT?: number | null;
  firstName_AVERAGE_LTE?: number | null;
  firstName_EQUAL?: string | null;
  firstName_GT?: number | null;
  firstName_GTE?: number | null;
  firstName_LONGEST_EQUAL?: number | null;
  firstName_LONGEST_GT?: number | null;
  firstName_LONGEST_GTE?: number | null;
  firstName_LONGEST_LT?: number | null;
  firstName_LONGEST_LTE?: number | null;
  firstName_LT?: number | null;
  firstName_LTE?: number | null;
  firstName_SHORTEST_EQUAL?: number | null;
  firstName_SHORTEST_GT?: number | null;
  firstName_SHORTEST_GTE?: number | null;
  firstName_SHORTEST_LT?: number | null;
  firstName_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  lastName_AVERAGE_EQUAL?: number | null;
  lastName_AVERAGE_GT?: number | null;
  lastName_AVERAGE_GTE?: number | null;
  lastName_AVERAGE_LT?: number | null;
  lastName_AVERAGE_LTE?: number | null;
  lastName_EQUAL?: string | null;
  lastName_GT?: number | null;
  lastName_GTE?: number | null;
  lastName_LONGEST_EQUAL?: number | null;
  lastName_LONGEST_GT?: number | null;
  lastName_LONGEST_GTE?: number | null;
  lastName_LONGEST_LT?: number | null;
  lastName_LONGEST_LTE?: number | null;
  lastName_LT?: number | null;
  lastName_LTE?: number | null;
  lastName_SHORTEST_EQUAL?: number | null;
  lastName_SHORTEST_GT?: number | null;
  lastName_SHORTEST_GTE?: number | null;
  lastName_SHORTEST_LT?: number | null;
  lastName_SHORTEST_LTE?: number | null;
  position_AVERAGE_EQUAL?: number | null;
  position_AVERAGE_GT?: number | null;
  position_AVERAGE_GTE?: number | null;
  position_AVERAGE_LT?: number | null;
  position_AVERAGE_LTE?: number | null;
  position_EQUAL?: string | null;
  position_GT?: number | null;
  position_GTE?: number | null;
  position_LONGEST_EQUAL?: number | null;
  position_LONGEST_GT?: number | null;
  position_LONGEST_GTE?: number | null;
  position_LONGEST_LT?: number | null;
  position_LONGEST_LTE?: number | null;
  position_LT?: number | null;
  position_LTE?: number | null;
  position_SHORTEST_EQUAL?: number | null;
  position_SHORTEST_GT?: number | null;
  position_SHORTEST_GTE?: number | null;
  position_SHORTEST_LT?: number | null;
  position_SHORTEST_LTE?: number | null;
  preferredLanguage_AVERAGE_EQUAL?: number | null;
  preferredLanguage_AVERAGE_GT?: number | null;
  preferredLanguage_AVERAGE_GTE?: number | null;
  preferredLanguage_AVERAGE_LT?: number | null;
  preferredLanguage_AVERAGE_LTE?: number | null;
  preferredLanguage_EQUAL?: string | null;
  preferredLanguage_GT?: number | null;
  preferredLanguage_GTE?: number | null;
  preferredLanguage_LONGEST_EQUAL?: number | null;
  preferredLanguage_LONGEST_GT?: number | null;
  preferredLanguage_LONGEST_GTE?: number | null;
  preferredLanguage_LONGEST_LT?: number | null;
  preferredLanguage_LONGEST_LTE?: number | null;
  preferredLanguage_LT?: number | null;
  preferredLanguage_LTE?: number | null;
  preferredLanguage_SHORTEST_EQUAL?: number | null;
  preferredLanguage_SHORTEST_GT?: number | null;
  preferredLanguage_SHORTEST_GTE?: number | null;
  preferredLanguage_SHORTEST_LT?: number | null;
  preferredLanguage_SHORTEST_LTE?: number | null;
  tenantId_AVERAGE_EQUAL?: number | null;
  tenantId_AVERAGE_GT?: number | null;
  tenantId_AVERAGE_GTE?: number | null;
  tenantId_AVERAGE_LT?: number | null;
  tenantId_AVERAGE_LTE?: number | null;
  tenantId_EQUAL?: string | null;
  tenantId_GT?: number | null;
  tenantId_GTE?: number | null;
  tenantId_LONGEST_EQUAL?: number | null;
  tenantId_LONGEST_GT?: number | null;
  tenantId_LONGEST_GTE?: number | null;
  tenantId_LONGEST_LT?: number | null;
  tenantId_LONGEST_LTE?: number | null;
  tenantId_LT?: number | null;
  tenantId_LTE?: number | null;
  tenantId_SHORTEST_EQUAL?: number | null;
  tenantId_SHORTEST_GT?: number | null;
  tenantId_SHORTEST_GTE?: number | null;
  tenantId_SHORTEST_LT?: number | null;
  tenantId_SHORTEST_LTE?: number | null;
}

export interface AgreementStatusTransitionWhere {
  AND?: AgreementStatusTransitionWhere[] | null;
  OR?: AgreementStatusTransitionWhere[] | null;
  causedBy?: UserWhere | null;
  causedByAggregate?: AgreementStatusTransitionCausedByAggregateInput | null;
  causedByConnection?: AgreementStatusTransitionCausedByConnectionWhere | null;
  causedByConnection_NOT?: AgreementStatusTransitionCausedByConnectionWhere | null;
  causedBy_NOT?: UserWhere | null;
  createdOn?: any | null;
  createdOn_GT?: any | null;
  createdOn_GTE?: any | null;
  createdOn_IN?: (any | null)[] | null;
  createdOn_LT?: any | null;
  createdOn_LTE?: any | null;
  createdOn_NOT?: any | null;
  createdOn_NOT_IN?: (any | null)[] | null;
  from?: ContractStatus | null;
  from_IN?: (ContractStatus | null)[] | null;
  from_NOT?: ContractStatus | null;
  from_NOT_IN?: (ContractStatus | null)[] | null;
  to?: ContractStatus | null;
  to_IN?: (ContractStatus | null)[] | null;
  to_NOT?: ContractStatus | null;
  to_NOT_IN?: (ContractStatus | null)[] | null;
}

export interface AgreementTagDefaultUserRolesAggregateInput {
  AND?: AgreementTagDefaultUserRolesAggregateInput[] | null;
  OR?: AgreementTagDefaultUserRolesAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: AgreementTagDefaultUserRolesNodeAggregationWhereInput | null;
}

export interface AgreementTagDefaultUserRolesConnectionWhere {
  AND?: AgreementTagDefaultUserRolesConnectionWhere[] | null;
  OR?: AgreementTagDefaultUserRolesConnectionWhere[] | null;
  edge?: AgreementTagUserRoleRelationshipWhere | null;
  edge_NOT?: AgreementTagUserRoleRelationshipWhere | null;
  node?: UserWhere | null;
  node_NOT?: UserWhere | null;
}

export interface AgreementTagDefaultUserRolesNodeAggregationWhereInput {
  AND?: AgreementTagDefaultUserRolesNodeAggregationWhereInput[] | null;
  OR?: AgreementTagDefaultUserRolesNodeAggregationWhereInput[] | null;
  deletedOn_EQUAL?: any | null;
  deletedOn_GT?: any | null;
  deletedOn_GTE?: any | null;
  deletedOn_LT?: any | null;
  deletedOn_LTE?: any | null;
  deletedOn_MAX_EQUAL?: any | null;
  deletedOn_MAX_GT?: any | null;
  deletedOn_MAX_GTE?: any | null;
  deletedOn_MAX_LT?: any | null;
  deletedOn_MAX_LTE?: any | null;
  deletedOn_MIN_EQUAL?: any | null;
  deletedOn_MIN_GT?: any | null;
  deletedOn_MIN_GTE?: any | null;
  deletedOn_MIN_LT?: any | null;
  deletedOn_MIN_LTE?: any | null;
  department_AVERAGE_EQUAL?: number | null;
  department_AVERAGE_GT?: number | null;
  department_AVERAGE_GTE?: number | null;
  department_AVERAGE_LT?: number | null;
  department_AVERAGE_LTE?: number | null;
  department_EQUAL?: string | null;
  department_GT?: number | null;
  department_GTE?: number | null;
  department_LONGEST_EQUAL?: number | null;
  department_LONGEST_GT?: number | null;
  department_LONGEST_GTE?: number | null;
  department_LONGEST_LT?: number | null;
  department_LONGEST_LTE?: number | null;
  department_LT?: number | null;
  department_LTE?: number | null;
  department_SHORTEST_EQUAL?: number | null;
  department_SHORTEST_GT?: number | null;
  department_SHORTEST_GTE?: number | null;
  department_SHORTEST_LT?: number | null;
  department_SHORTEST_LTE?: number | null;
  email_AVERAGE_EQUAL?: number | null;
  email_AVERAGE_GT?: number | null;
  email_AVERAGE_GTE?: number | null;
  email_AVERAGE_LT?: number | null;
  email_AVERAGE_LTE?: number | null;
  email_EQUAL?: string | null;
  email_GT?: number | null;
  email_GTE?: number | null;
  email_LONGEST_EQUAL?: number | null;
  email_LONGEST_GT?: number | null;
  email_LONGEST_GTE?: number | null;
  email_LONGEST_LT?: number | null;
  email_LONGEST_LTE?: number | null;
  email_LT?: number | null;
  email_LTE?: number | null;
  email_SHORTEST_EQUAL?: number | null;
  email_SHORTEST_GT?: number | null;
  email_SHORTEST_GTE?: number | null;
  email_SHORTEST_LT?: number | null;
  email_SHORTEST_LTE?: number | null;
  firstName_AVERAGE_EQUAL?: number | null;
  firstName_AVERAGE_GT?: number | null;
  firstName_AVERAGE_GTE?: number | null;
  firstName_AVERAGE_LT?: number | null;
  firstName_AVERAGE_LTE?: number | null;
  firstName_EQUAL?: string | null;
  firstName_GT?: number | null;
  firstName_GTE?: number | null;
  firstName_LONGEST_EQUAL?: number | null;
  firstName_LONGEST_GT?: number | null;
  firstName_LONGEST_GTE?: number | null;
  firstName_LONGEST_LT?: number | null;
  firstName_LONGEST_LTE?: number | null;
  firstName_LT?: number | null;
  firstName_LTE?: number | null;
  firstName_SHORTEST_EQUAL?: number | null;
  firstName_SHORTEST_GT?: number | null;
  firstName_SHORTEST_GTE?: number | null;
  firstName_SHORTEST_LT?: number | null;
  firstName_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  lastName_AVERAGE_EQUAL?: number | null;
  lastName_AVERAGE_GT?: number | null;
  lastName_AVERAGE_GTE?: number | null;
  lastName_AVERAGE_LT?: number | null;
  lastName_AVERAGE_LTE?: number | null;
  lastName_EQUAL?: string | null;
  lastName_GT?: number | null;
  lastName_GTE?: number | null;
  lastName_LONGEST_EQUAL?: number | null;
  lastName_LONGEST_GT?: number | null;
  lastName_LONGEST_GTE?: number | null;
  lastName_LONGEST_LT?: number | null;
  lastName_LONGEST_LTE?: number | null;
  lastName_LT?: number | null;
  lastName_LTE?: number | null;
  lastName_SHORTEST_EQUAL?: number | null;
  lastName_SHORTEST_GT?: number | null;
  lastName_SHORTEST_GTE?: number | null;
  lastName_SHORTEST_LT?: number | null;
  lastName_SHORTEST_LTE?: number | null;
  position_AVERAGE_EQUAL?: number | null;
  position_AVERAGE_GT?: number | null;
  position_AVERAGE_GTE?: number | null;
  position_AVERAGE_LT?: number | null;
  position_AVERAGE_LTE?: number | null;
  position_EQUAL?: string | null;
  position_GT?: number | null;
  position_GTE?: number | null;
  position_LONGEST_EQUAL?: number | null;
  position_LONGEST_GT?: number | null;
  position_LONGEST_GTE?: number | null;
  position_LONGEST_LT?: number | null;
  position_LONGEST_LTE?: number | null;
  position_LT?: number | null;
  position_LTE?: number | null;
  position_SHORTEST_EQUAL?: number | null;
  position_SHORTEST_GT?: number | null;
  position_SHORTEST_GTE?: number | null;
  position_SHORTEST_LT?: number | null;
  position_SHORTEST_LTE?: number | null;
  preferredLanguage_AVERAGE_EQUAL?: number | null;
  preferredLanguage_AVERAGE_GT?: number | null;
  preferredLanguage_AVERAGE_GTE?: number | null;
  preferredLanguage_AVERAGE_LT?: number | null;
  preferredLanguage_AVERAGE_LTE?: number | null;
  preferredLanguage_EQUAL?: string | null;
  preferredLanguage_GT?: number | null;
  preferredLanguage_GTE?: number | null;
  preferredLanguage_LONGEST_EQUAL?: number | null;
  preferredLanguage_LONGEST_GT?: number | null;
  preferredLanguage_LONGEST_GTE?: number | null;
  preferredLanguage_LONGEST_LT?: number | null;
  preferredLanguage_LONGEST_LTE?: number | null;
  preferredLanguage_LT?: number | null;
  preferredLanguage_LTE?: number | null;
  preferredLanguage_SHORTEST_EQUAL?: number | null;
  preferredLanguage_SHORTEST_GT?: number | null;
  preferredLanguage_SHORTEST_GTE?: number | null;
  preferredLanguage_SHORTEST_LT?: number | null;
  preferredLanguage_SHORTEST_LTE?: number | null;
  tenantId_AVERAGE_EQUAL?: number | null;
  tenantId_AVERAGE_GT?: number | null;
  tenantId_AVERAGE_GTE?: number | null;
  tenantId_AVERAGE_LT?: number | null;
  tenantId_AVERAGE_LTE?: number | null;
  tenantId_EQUAL?: string | null;
  tenantId_GT?: number | null;
  tenantId_GTE?: number | null;
  tenantId_LONGEST_EQUAL?: number | null;
  tenantId_LONGEST_GT?: number | null;
  tenantId_LONGEST_GTE?: number | null;
  tenantId_LONGEST_LT?: number | null;
  tenantId_LONGEST_LTE?: number | null;
  tenantId_LT?: number | null;
  tenantId_LTE?: number | null;
  tenantId_SHORTEST_EQUAL?: number | null;
  tenantId_SHORTEST_GT?: number | null;
  tenantId_SHORTEST_GTE?: number | null;
  tenantId_SHORTEST_LT?: number | null;
  tenantId_SHORTEST_LTE?: number | null;
}

export interface AgreementTagUserRoleRelationshipWhere {
  AND?: AgreementTagUserRoleRelationshipWhere[] | null;
  OR?: AgreementTagUserRoleRelationshipWhere[] | null;
  caseAssignee?: AssigneeStatus | null;
  caseAssignee_IN?: (AssigneeStatus | null)[] | null;
  caseAssignee_NOT?: AssigneeStatus | null;
  caseAssignee_NOT_IN?: (AssigneeStatus | null)[] | null;
  documentAssignee?: AssigneeStatus | null;
  documentAssignee_IN?: (AssigneeStatus | null)[] | null;
  documentAssignee_NOT?: AssigneeStatus | null;
  documentAssignee_NOT_IN?: (AssigneeStatus | null)[] | null;
  isAgreementAssignee?: boolean | null;
  isAgreementAssignee_NOT?: boolean | null;
  role?: AgreementUserRole | null;
  role_IN?: (AgreementUserRole | null)[] | null;
  role_NOT?: AgreementUserRole | null;
  role_NOT_IN?: (AgreementUserRole | null)[] | null;
}

export interface AgreementTagWhere {
  AND?: AgreementTagWhere[] | null;
  OR?: AgreementTagWhere[] | null;
  defaultUserRoles?: UserWhere | null;
  defaultUserRolesAggregate?: AgreementTagDefaultUserRolesAggregateInput | null;
  defaultUserRolesConnection?: AgreementTagDefaultUserRolesConnectionWhere | null;
  defaultUserRolesConnection_NOT?: AgreementTagDefaultUserRolesConnectionWhere | null;
  defaultUserRoles_NOT?: UserWhere | null;
  id?: number | null;
  id_GT?: number | null;
  id_GTE?: number | null;
  id_IN?: (number | null)[] | null;
  id_LT?: number | null;
  id_LTE?: number | null;
  id_NOT?: number | null;
  id_NOT_IN?: (number | null)[] | null;
  name?: string | null;
  name_CONTAINS?: string | null;
  name_ENDS_WITH?: string | null;
  name_IN?: (string | null)[] | null;
  name_MATCHES?: string | null;
  name_NOT?: string | null;
  name_NOT_CONTAINS?: string | null;
  name_NOT_ENDS_WITH?: string | null;
  name_NOT_IN?: (string | null)[] | null;
  name_NOT_STARTS_WITH?: string | null;
  name_STARTS_WITH?: string | null;
  type?: AgreementTagType | null;
  type_IN?: (AgreementTagType | null)[] | null;
  type_NOT?: AgreementTagType | null;
  type_NOT_IN?: (AgreementTagType | null)[] | null;
}

export interface AgreementTagsAggregateInput {
  AND?: AgreementTagsAggregateInput[] | null;
  OR?: AgreementTagsAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: AgreementTagsNodeAggregationWhereInput | null;
}

export interface AgreementTagsConnectionWhere {
  AND?: AgreementTagsConnectionWhere[] | null;
  OR?: AgreementTagsConnectionWhere[] | null;
  node?: AgreementTagWhere | null;
  node_NOT?: AgreementTagWhere | null;
}

export interface AgreementTagsNodeAggregationWhereInput {
  AND?: AgreementTagsNodeAggregationWhereInput[] | null;
  OR?: AgreementTagsNodeAggregationWhereInput[] | null;
  id_AVERAGE_EQUAL?: number | null;
  id_AVERAGE_GT?: number | null;
  id_AVERAGE_GTE?: number | null;
  id_AVERAGE_LT?: number | null;
  id_AVERAGE_LTE?: number | null;
  id_EQUAL?: number | null;
  id_GT?: number | null;
  id_GTE?: number | null;
  id_LT?: number | null;
  id_LTE?: number | null;
  id_MAX_EQUAL?: number | null;
  id_MAX_GT?: number | null;
  id_MAX_GTE?: number | null;
  id_MAX_LT?: number | null;
  id_MAX_LTE?: number | null;
  id_MIN_EQUAL?: number | null;
  id_MIN_GT?: number | null;
  id_MIN_GTE?: number | null;
  id_MIN_LT?: number | null;
  id_MIN_LTE?: number | null;
  id_SUM_EQUAL?: number | null;
  id_SUM_GT?: number | null;
  id_SUM_GTE?: number | null;
  id_SUM_LT?: number | null;
  id_SUM_LTE?: number | null;
  name_AVERAGE_EQUAL?: number | null;
  name_AVERAGE_GT?: number | null;
  name_AVERAGE_GTE?: number | null;
  name_AVERAGE_LT?: number | null;
  name_AVERAGE_LTE?: number | null;
  name_EQUAL?: string | null;
  name_GT?: number | null;
  name_GTE?: number | null;
  name_LONGEST_EQUAL?: number | null;
  name_LONGEST_GT?: number | null;
  name_LONGEST_GTE?: number | null;
  name_LONGEST_LT?: number | null;
  name_LONGEST_LTE?: number | null;
  name_LT?: number | null;
  name_LTE?: number | null;
  name_SHORTEST_EQUAL?: number | null;
  name_SHORTEST_GT?: number | null;
  name_SHORTEST_GTE?: number | null;
  name_SHORTEST_LT?: number | null;
  name_SHORTEST_LTE?: number | null;
}

export interface AgreementUserRoleRelationshipWhere {
  AND?: AgreementUserRoleRelationshipWhere[] | null;
  OR?: AgreementUserRoleRelationshipWhere[] | null;
  canApprove?: boolean | null;
  canApprove_NOT?: boolean | null;
  canModifyFinancials?: boolean | null;
  canModifyFinancials_NOT?: boolean | null;
  canViewFinancials?: boolean | null;
  canViewFinancials_NOT?: boolean | null;
  isAssignee?: boolean | null;
  isAssignee_NOT?: boolean | null;
  role?: AgreementUserRole | null;
  role_IN?: (AgreementUserRole | null)[] | null;
  role_NOT?: AgreementUserRole | null;
  role_NOT_IN?: (AgreementUserRole | null)[] | null;
}

export interface AgreementUserRolesAggregateInput {
  AND?: AgreementUserRolesAggregateInput[] | null;
  OR?: AgreementUserRolesAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: AgreementUserRolesNodeAggregationWhereInput | null;
}

export interface AgreementUserRolesConnectionWhere {
  AND?: AgreementUserRolesConnectionWhere[] | null;
  OR?: AgreementUserRolesConnectionWhere[] | null;
  edge?: AgreementUserRoleRelationshipWhere | null;
  edge_NOT?: AgreementUserRoleRelationshipWhere | null;
  node?: UserWhere | null;
  node_NOT?: UserWhere | null;
}

export interface AgreementUserRolesNodeAggregationWhereInput {
  AND?: AgreementUserRolesNodeAggregationWhereInput[] | null;
  OR?: AgreementUserRolesNodeAggregationWhereInput[] | null;
  deletedOn_EQUAL?: any | null;
  deletedOn_GT?: any | null;
  deletedOn_GTE?: any | null;
  deletedOn_LT?: any | null;
  deletedOn_LTE?: any | null;
  deletedOn_MAX_EQUAL?: any | null;
  deletedOn_MAX_GT?: any | null;
  deletedOn_MAX_GTE?: any | null;
  deletedOn_MAX_LT?: any | null;
  deletedOn_MAX_LTE?: any | null;
  deletedOn_MIN_EQUAL?: any | null;
  deletedOn_MIN_GT?: any | null;
  deletedOn_MIN_GTE?: any | null;
  deletedOn_MIN_LT?: any | null;
  deletedOn_MIN_LTE?: any | null;
  department_AVERAGE_EQUAL?: number | null;
  department_AVERAGE_GT?: number | null;
  department_AVERAGE_GTE?: number | null;
  department_AVERAGE_LT?: number | null;
  department_AVERAGE_LTE?: number | null;
  department_EQUAL?: string | null;
  department_GT?: number | null;
  department_GTE?: number | null;
  department_LONGEST_EQUAL?: number | null;
  department_LONGEST_GT?: number | null;
  department_LONGEST_GTE?: number | null;
  department_LONGEST_LT?: number | null;
  department_LONGEST_LTE?: number | null;
  department_LT?: number | null;
  department_LTE?: number | null;
  department_SHORTEST_EQUAL?: number | null;
  department_SHORTEST_GT?: number | null;
  department_SHORTEST_GTE?: number | null;
  department_SHORTEST_LT?: number | null;
  department_SHORTEST_LTE?: number | null;
  email_AVERAGE_EQUAL?: number | null;
  email_AVERAGE_GT?: number | null;
  email_AVERAGE_GTE?: number | null;
  email_AVERAGE_LT?: number | null;
  email_AVERAGE_LTE?: number | null;
  email_EQUAL?: string | null;
  email_GT?: number | null;
  email_GTE?: number | null;
  email_LONGEST_EQUAL?: number | null;
  email_LONGEST_GT?: number | null;
  email_LONGEST_GTE?: number | null;
  email_LONGEST_LT?: number | null;
  email_LONGEST_LTE?: number | null;
  email_LT?: number | null;
  email_LTE?: number | null;
  email_SHORTEST_EQUAL?: number | null;
  email_SHORTEST_GT?: number | null;
  email_SHORTEST_GTE?: number | null;
  email_SHORTEST_LT?: number | null;
  email_SHORTEST_LTE?: number | null;
  firstName_AVERAGE_EQUAL?: number | null;
  firstName_AVERAGE_GT?: number | null;
  firstName_AVERAGE_GTE?: number | null;
  firstName_AVERAGE_LT?: number | null;
  firstName_AVERAGE_LTE?: number | null;
  firstName_EQUAL?: string | null;
  firstName_GT?: number | null;
  firstName_GTE?: number | null;
  firstName_LONGEST_EQUAL?: number | null;
  firstName_LONGEST_GT?: number | null;
  firstName_LONGEST_GTE?: number | null;
  firstName_LONGEST_LT?: number | null;
  firstName_LONGEST_LTE?: number | null;
  firstName_LT?: number | null;
  firstName_LTE?: number | null;
  firstName_SHORTEST_EQUAL?: number | null;
  firstName_SHORTEST_GT?: number | null;
  firstName_SHORTEST_GTE?: number | null;
  firstName_SHORTEST_LT?: number | null;
  firstName_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  lastName_AVERAGE_EQUAL?: number | null;
  lastName_AVERAGE_GT?: number | null;
  lastName_AVERAGE_GTE?: number | null;
  lastName_AVERAGE_LT?: number | null;
  lastName_AVERAGE_LTE?: number | null;
  lastName_EQUAL?: string | null;
  lastName_GT?: number | null;
  lastName_GTE?: number | null;
  lastName_LONGEST_EQUAL?: number | null;
  lastName_LONGEST_GT?: number | null;
  lastName_LONGEST_GTE?: number | null;
  lastName_LONGEST_LT?: number | null;
  lastName_LONGEST_LTE?: number | null;
  lastName_LT?: number | null;
  lastName_LTE?: number | null;
  lastName_SHORTEST_EQUAL?: number | null;
  lastName_SHORTEST_GT?: number | null;
  lastName_SHORTEST_GTE?: number | null;
  lastName_SHORTEST_LT?: number | null;
  lastName_SHORTEST_LTE?: number | null;
  position_AVERAGE_EQUAL?: number | null;
  position_AVERAGE_GT?: number | null;
  position_AVERAGE_GTE?: number | null;
  position_AVERAGE_LT?: number | null;
  position_AVERAGE_LTE?: number | null;
  position_EQUAL?: string | null;
  position_GT?: number | null;
  position_GTE?: number | null;
  position_LONGEST_EQUAL?: number | null;
  position_LONGEST_GT?: number | null;
  position_LONGEST_GTE?: number | null;
  position_LONGEST_LT?: number | null;
  position_LONGEST_LTE?: number | null;
  position_LT?: number | null;
  position_LTE?: number | null;
  position_SHORTEST_EQUAL?: number | null;
  position_SHORTEST_GT?: number | null;
  position_SHORTEST_GTE?: number | null;
  position_SHORTEST_LT?: number | null;
  position_SHORTEST_LTE?: number | null;
  preferredLanguage_AVERAGE_EQUAL?: number | null;
  preferredLanguage_AVERAGE_GT?: number | null;
  preferredLanguage_AVERAGE_GTE?: number | null;
  preferredLanguage_AVERAGE_LT?: number | null;
  preferredLanguage_AVERAGE_LTE?: number | null;
  preferredLanguage_EQUAL?: string | null;
  preferredLanguage_GT?: number | null;
  preferredLanguage_GTE?: number | null;
  preferredLanguage_LONGEST_EQUAL?: number | null;
  preferredLanguage_LONGEST_GT?: number | null;
  preferredLanguage_LONGEST_GTE?: number | null;
  preferredLanguage_LONGEST_LT?: number | null;
  preferredLanguage_LONGEST_LTE?: number | null;
  preferredLanguage_LT?: number | null;
  preferredLanguage_LTE?: number | null;
  preferredLanguage_SHORTEST_EQUAL?: number | null;
  preferredLanguage_SHORTEST_GT?: number | null;
  preferredLanguage_SHORTEST_GTE?: number | null;
  preferredLanguage_SHORTEST_LT?: number | null;
  preferredLanguage_SHORTEST_LTE?: number | null;
  tenantId_AVERAGE_EQUAL?: number | null;
  tenantId_AVERAGE_GT?: number | null;
  tenantId_AVERAGE_GTE?: number | null;
  tenantId_AVERAGE_LT?: number | null;
  tenantId_AVERAGE_LTE?: number | null;
  tenantId_EQUAL?: string | null;
  tenantId_GT?: number | null;
  tenantId_GTE?: number | null;
  tenantId_LONGEST_EQUAL?: number | null;
  tenantId_LONGEST_GT?: number | null;
  tenantId_LONGEST_GTE?: number | null;
  tenantId_LONGEST_LT?: number | null;
  tenantId_LONGEST_LTE?: number | null;
  tenantId_LT?: number | null;
  tenantId_LTE?: number | null;
  tenantId_SHORTEST_EQUAL?: number | null;
  tenantId_SHORTEST_GT?: number | null;
  tenantId_SHORTEST_GTE?: number | null;
  tenantId_SHORTEST_LT?: number | null;
  tenantId_SHORTEST_LTE?: number | null;
}

export interface AgreementWhere {
  AND?: AgreementWhere[] | null;
  OR?: AgreementWhere[] | null;
  allowedForms?: string[] | null;
  allowedForms_INCLUDES?: string | null;
  allowedForms_NOT?: string[] | null;
  allowedForms_NOT_INCLUDES?: string | null;
  allowedRecords?: string[] | null;
  allowedRecords_INCLUDES?: string | null;
  allowedRecords_NOT?: string[] | null;
  allowedRecords_NOT_INCLUDES?: string | null;
  counterpartyRoles?: OrganizationWhere | null;
  counterpartyRolesAggregate?: AgreementCounterpartyRolesAggregateInput | null;
  counterpartyRolesConnection?: AgreementCounterpartyRolesConnectionWhere | null;
  counterpartyRolesConnection_NOT?: AgreementCounterpartyRolesConnectionWhere | null;
  counterpartyRoles_NOT?: OrganizationWhere | null;
  currency?: CurrencyWhere | null;
  currencyAggregate?: AgreementCurrencyAggregateInput | null;
  currencyConnection?: AgreementCurrencyConnectionWhere | null;
  currencyConnection_NOT?: AgreementCurrencyConnectionWhere | null;
  currency_NOT?: CurrencyWhere | null;
  dataContainers?: DataContainerWhere | null;
  dataContainersAggregate?: AgreementDataContainersAggregateInput | null;
  dataContainersConnection?: AgreementDataContainersConnectionWhere | null;
  dataContainersConnection_NOT?: AgreementDataContainersConnectionWhere | null;
  dataContainers_NOT?: DataContainerWhere | null;
  description?: string | null;
  description_CONTAINS?: string | null;
  description_ENDS_WITH?: string | null;
  description_IN?: (string | null)[] | null;
  description_MATCHES?: string | null;
  description_NOT?: string | null;
  description_NOT_CONTAINS?: string | null;
  description_NOT_ENDS_WITH?: string | null;
  description_NOT_IN?: (string | null)[] | null;
  description_NOT_STARTS_WITH?: string | null;
  description_STARTS_WITH?: string | null;
  deviceAlternativeSets?: DeviceAlternativeWhere | null;
  deviceAlternativeSetsAggregate?: AgreementDeviceAlternativeSetsAggregateInput | null;
  deviceAlternativeSetsConnection?: AgreementDeviceAlternativeSetsConnectionWhere | null;
  deviceAlternativeSetsConnection_NOT?: AgreementDeviceAlternativeSetsConnectionWhere | null;
  deviceAlternativeSets_NOT?: DeviceAlternativeWhere | null;
  formattedAmount?: string | null;
  formattedAmount_CONTAINS?: string | null;
  formattedAmount_ENDS_WITH?: string | null;
  formattedAmount_IN?: (string | null)[] | null;
  formattedAmount_MATCHES?: string | null;
  formattedAmount_NOT?: string | null;
  formattedAmount_NOT_CONTAINS?: string | null;
  formattedAmount_NOT_ENDS_WITH?: string | null;
  formattedAmount_NOT_IN?: (string | null)[] | null;
  formattedAmount_NOT_STARTS_WITH?: string | null;
  formattedAmount_STARTS_WITH?: string | null;
  formattedCounterparties?: string | null;
  formattedCounterparties_CONTAINS?: string | null;
  formattedCounterparties_ENDS_WITH?: string | null;
  formattedCounterparties_IN?: (string | null)[] | null;
  formattedCounterparties_MATCHES?: string | null;
  formattedCounterparties_NOT?: string | null;
  formattedCounterparties_NOT_CONTAINS?: string | null;
  formattedCounterparties_NOT_ENDS_WITH?: string | null;
  formattedCounterparties_NOT_IN?: (string | null)[] | null;
  formattedCounterparties_NOT_STARTS_WITH?: string | null;
  formattedCounterparties_STARTS_WITH?: string | null;
  formattedDiseases?: string | null;
  formattedDiseases_CONTAINS?: string | null;
  formattedDiseases_ENDS_WITH?: string | null;
  formattedDiseases_IN?: (string | null)[] | null;
  formattedDiseases_MATCHES?: string | null;
  formattedDiseases_NOT?: string | null;
  formattedDiseases_NOT_CONTAINS?: string | null;
  formattedDiseases_NOT_ENDS_WITH?: string | null;
  formattedDiseases_NOT_IN?: (string | null)[] | null;
  formattedDiseases_NOT_STARTS_WITH?: string | null;
  formattedDiseases_STARTS_WITH?: string | null;
  formattedIndications?: string | null;
  formattedIndications_CONTAINS?: string | null;
  formattedIndications_ENDS_WITH?: string | null;
  formattedIndications_IN?: (string | null)[] | null;
  formattedIndications_MATCHES?: string | null;
  formattedIndications_NOT?: string | null;
  formattedIndications_NOT_CONTAINS?: string | null;
  formattedIndications_NOT_ENDS_WITH?: string | null;
  formattedIndications_NOT_IN?: (string | null)[] | null;
  formattedIndications_NOT_STARTS_WITH?: string | null;
  formattedIndications_STARTS_WITH?: string | null;
  formattedProducts?: string | null;
  formattedProducts_CONTAINS?: string | null;
  formattedProducts_ENDS_WITH?: string | null;
  formattedProducts_IN?: (string | null)[] | null;
  formattedProducts_MATCHES?: string | null;
  formattedProducts_NOT?: string | null;
  formattedProducts_NOT_CONTAINS?: string | null;
  formattedProducts_NOT_ENDS_WITH?: string | null;
  formattedProducts_NOT_IN?: (string | null)[] | null;
  formattedProducts_NOT_STARTS_WITH?: string | null;
  formattedProducts_STARTS_WITH?: string | null;
  formattedTags?: string | null;
  formattedTags_CONTAINS?: string | null;
  formattedTags_ENDS_WITH?: string | null;
  formattedTags_IN?: (string | null)[] | null;
  formattedTags_MATCHES?: string | null;
  formattedTags_NOT?: string | null;
  formattedTags_NOT_CONTAINS?: string | null;
  formattedTags_NOT_ENDS_WITH?: string | null;
  formattedTags_NOT_IN?: (string | null)[] | null;
  formattedTags_NOT_STARTS_WITH?: string | null;
  formattedTags_STARTS_WITH?: string | null;
  formattedValidityPeriod?: string | null;
  formattedValidityPeriod_CONTAINS?: string | null;
  formattedValidityPeriod_ENDS_WITH?: string | null;
  formattedValidityPeriod_IN?: (string | null)[] | null;
  formattedValidityPeriod_MATCHES?: string | null;
  formattedValidityPeriod_NOT?: string | null;
  formattedValidityPeriod_NOT_CONTAINS?: string | null;
  formattedValidityPeriod_NOT_ENDS_WITH?: string | null;
  formattedValidityPeriod_NOT_IN?: (string | null)[] | null;
  formattedValidityPeriod_NOT_STARTS_WITH?: string | null;
  formattedValidityPeriod_STARTS_WITH?: string | null;
  id?: string | null;
  id_CONTAINS?: string | null;
  id_ENDS_WITH?: string | null;
  id_IN?: (string | null)[] | null;
  id_MATCHES?: string | null;
  id_NOT?: string | null;
  id_NOT_CONTAINS?: string | null;
  id_NOT_ENDS_WITH?: string | null;
  id_NOT_IN?: (string | null)[] | null;
  id_NOT_STARTS_WITH?: string | null;
  id_STARTS_WITH?: string | null;
  initialVersionId?: string | null;
  initialVersionId_CONTAINS?: string | null;
  initialVersionId_ENDS_WITH?: string | null;
  initialVersionId_IN?: (string | null)[] | null;
  initialVersionId_MATCHES?: string | null;
  initialVersionId_NOT?: string | null;
  initialVersionId_NOT_CONTAINS?: string | null;
  initialVersionId_NOT_ENDS_WITH?: string | null;
  initialVersionId_NOT_IN?: (string | null)[] | null;
  initialVersionId_NOT_STARTS_WITH?: string | null;
  initialVersionId_STARTS_WITH?: string | null;
  isArchived?: boolean | null;
  isArchived_NOT?: boolean | null;
  isDeleted?: boolean | null;
  isDeleted_NOT?: boolean | null;
  isExtended?: boolean | null;
  isExtended_NOT?: boolean | null;
  isFirstVersion?: boolean | null;
  isFirstVersion_NOT?: boolean | null;
  isHidden?: boolean | null;
  isHidden_NOT?: boolean | null;
  isInsightsAvailable?: boolean | null;
  isInsightsAvailable_NOT?: boolean | null;
  isLastVersion?: boolean | null;
  isLastVersion_NOT?: boolean | null;
  lastVersionValidToDate?: any | null;
  lastVersionValidToDate_GT?: any | null;
  lastVersionValidToDate_GTE?: any | null;
  lastVersionValidToDate_IN?: (any | null)[] | null;
  lastVersionValidToDate_LT?: any | null;
  lastVersionValidToDate_LTE?: any | null;
  lastVersionValidToDate_NOT?: any | null;
  lastVersionValidToDate_NOT_IN?: (any | null)[] | null;
  name?: string | null;
  name_CONTAINS?: string | null;
  name_ENDS_WITH?: string | null;
  name_IN?: (string | null)[] | null;
  name_MATCHES?: string | null;
  name_NOT?: string | null;
  name_NOT_CONTAINS?: string | null;
  name_NOT_ENDS_WITH?: string | null;
  name_NOT_IN?: (string | null)[] | null;
  name_NOT_STARTS_WITH?: string | null;
  name_STARTS_WITH?: string | null;
  negotiableAttributes?: CatalogueAttributeWhere | null;
  negotiableAttributesAggregate?: AgreementNegotiableAttributesAggregateInput | null;
  negotiableAttributesConnection?: AgreementNegotiableAttributesConnectionWhere | null;
  negotiableAttributesConnection_NOT?: AgreementNegotiableAttributesConnectionWhere | null;
  negotiableAttributes_NOT?: CatalogueAttributeWhere | null;
  nextVersions?: AgreementWhere | null;
  nextVersionsAggregate?: AgreementNextVersionsAggregateInput | null;
  nextVersionsConnection?: AgreementNextVersionsConnectionWhere | null;
  nextVersionsConnection_NOT?: AgreementNextVersionsConnectionWhere | null;
  nextVersions_NOT?: AgreementWhere | null;
  searchTerm?: string | null;
  searchTerm_CONTAINS?: string | null;
  searchTerm_ENDS_WITH?: string | null;
  searchTerm_IN?: (string | null)[] | null;
  searchTerm_MATCHES?: string | null;
  searchTerm_NOT?: string | null;
  searchTerm_NOT_CONTAINS?: string | null;
  searchTerm_NOT_ENDS_WITH?: string | null;
  searchTerm_NOT_IN?: (string | null)[] | null;
  searchTerm_NOT_STARTS_WITH?: string | null;
  searchTerm_STARTS_WITH?: string | null;
  status?: ContractStatus | null;
  status_IN?: (ContractStatus | null)[] | null;
  status_NOT?: ContractStatus | null;
  status_NOT_IN?: (ContractStatus | null)[] | null;
  subjectMatter?: AgreementSubjectMatter | null;
  subjectMatter_IN?: (AgreementSubjectMatter | null)[] | null;
  subjectMatter_NOT?: AgreementSubjectMatter | null;
  subjectMatter_NOT_IN?: (AgreementSubjectMatter | null)[] | null;
  tags?: AgreementTagWhere | null;
  tagsAggregate?: AgreementTagsAggregateInput | null;
  tagsConnection?: AgreementTagsConnectionWhere | null;
  tagsConnection_NOT?: AgreementTagsConnectionWhere | null;
  tags_NOT?: AgreementTagWhere | null;
  tenantIds?: string[] | null;
  tenantIds_INCLUDES?: string | null;
  tenantIds_NOT?: string[] | null;
  tenantIds_NOT_INCLUDES?: string | null;
  totalAmount?: number | null;
  totalAmount_GT?: number | null;
  totalAmount_GTE?: number | null;
  totalAmount_IN?: (number | null)[] | null;
  totalAmount_LT?: number | null;
  totalAmount_LTE?: number | null;
  totalAmount_NOT?: number | null;
  totalAmount_NOT_IN?: (number | null)[] | null;
  unlimited?: number | null;
  unlimited_GT?: number | null;
  unlimited_GTE?: number | null;
  unlimited_IN?: (number | null)[] | null;
  unlimited_LT?: number | null;
  unlimited_LTE?: number | null;
  unlimited_NOT?: number | null;
  unlimited_NOT_IN?: (number | null)[] | null;
  userRoles?: UserWhere | null;
  userRolesAggregate?: AgreementUserRolesAggregateInput | null;
  userRolesConnection?: AgreementUserRolesConnectionWhere | null;
  userRolesConnection_NOT?: AgreementUserRolesConnectionWhere | null;
  userRoles_NOT?: UserWhere | null;
  validFromDate?: any | null;
  validFromDate_GT?: any | null;
  validFromDate_GTE?: any | null;
  validFromDate_IN?: (any | null)[] | null;
  validFromDate_LT?: any | null;
  validFromDate_LTE?: any | null;
  validFromDate_NOT?: any | null;
  validFromDate_NOT_IN?: (any | null)[] | null;
  validToDate?: any | null;
  validToDate_GT?: any | null;
  validToDate_GTE?: any | null;
  validToDate_IN?: (any | null)[] | null;
  validToDate_LT?: any | null;
  validToDate_LTE?: any | null;
  validToDate_NOT?: any | null;
  validToDate_NOT_IN?: (any | null)[] | null;
  version?: number | null;
  version_GT?: number | null;
  version_GTE?: number | null;
  version_IN?: (number | null)[] | null;
  version_LT?: number | null;
  version_LTE?: number | null;
  version_NOT?: number | null;
  version_NOT_IN?: (number | null)[] | null;
  workflows?: ContractWorkflowWhere | null;
  workflowsAggregate?: AgreementWorkflowsAggregateInput | null;
  workflowsConnection?: AgreementWorkflowsConnectionWhere | null;
  workflowsConnection_NOT?: AgreementWorkflowsConnectionWhere | null;
  workflows_NOT?: ContractWorkflowWhere | null;
}

export interface AgreementWorkflowsAggregateInput {
  AND?: AgreementWorkflowsAggregateInput[] | null;
  OR?: AgreementWorkflowsAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
}

export interface AgreementWorkflowsConnectionWhere {
  AND?: AgreementWorkflowsConnectionWhere[] | null;
  OR?: AgreementWorkflowsConnectionWhere[] | null;
  node?: ContractWorkflowWhere | null;
  node_NOT?: ContractWorkflowWhere | null;
}

export interface ApplyUserRolesToAllInput {
  agreementTag: AgreementTagType;
  userId: string;
}

export interface AssignInvoiceToUserInput {
  assignee?: AssigneeInput | null;
  invoiceId: string;
}

export interface AssigneeInput {
  emails: string[];
  tenantId: string;
}

export interface BaseAgreementAddedByAggregateInput {
  AND?: BaseAgreementAddedByAggregateInput[] | null;
  OR?: BaseAgreementAddedByAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: BaseAgreementAddedByNodeAggregationWhereInput | null;
}

export interface BaseAgreementAddedByConnectionWhere {
  AND?: BaseAgreementAddedByConnectionWhere[] | null;
  OR?: BaseAgreementAddedByConnectionWhere[] | null;
  node?: UserWhere | null;
  node_NOT?: UserWhere | null;
}

export interface BaseAgreementAddedByNodeAggregationWhereInput {
  AND?: BaseAgreementAddedByNodeAggregationWhereInput[] | null;
  OR?: BaseAgreementAddedByNodeAggregationWhereInput[] | null;
  deletedOn_EQUAL?: any | null;
  deletedOn_GT?: any | null;
  deletedOn_GTE?: any | null;
  deletedOn_LT?: any | null;
  deletedOn_LTE?: any | null;
  deletedOn_MAX_EQUAL?: any | null;
  deletedOn_MAX_GT?: any | null;
  deletedOn_MAX_GTE?: any | null;
  deletedOn_MAX_LT?: any | null;
  deletedOn_MAX_LTE?: any | null;
  deletedOn_MIN_EQUAL?: any | null;
  deletedOn_MIN_GT?: any | null;
  deletedOn_MIN_GTE?: any | null;
  deletedOn_MIN_LT?: any | null;
  deletedOn_MIN_LTE?: any | null;
  department_AVERAGE_EQUAL?: number | null;
  department_AVERAGE_GT?: number | null;
  department_AVERAGE_GTE?: number | null;
  department_AVERAGE_LT?: number | null;
  department_AVERAGE_LTE?: number | null;
  department_EQUAL?: string | null;
  department_GT?: number | null;
  department_GTE?: number | null;
  department_LONGEST_EQUAL?: number | null;
  department_LONGEST_GT?: number | null;
  department_LONGEST_GTE?: number | null;
  department_LONGEST_LT?: number | null;
  department_LONGEST_LTE?: number | null;
  department_LT?: number | null;
  department_LTE?: number | null;
  department_SHORTEST_EQUAL?: number | null;
  department_SHORTEST_GT?: number | null;
  department_SHORTEST_GTE?: number | null;
  department_SHORTEST_LT?: number | null;
  department_SHORTEST_LTE?: number | null;
  email_AVERAGE_EQUAL?: number | null;
  email_AVERAGE_GT?: number | null;
  email_AVERAGE_GTE?: number | null;
  email_AVERAGE_LT?: number | null;
  email_AVERAGE_LTE?: number | null;
  email_EQUAL?: string | null;
  email_GT?: number | null;
  email_GTE?: number | null;
  email_LONGEST_EQUAL?: number | null;
  email_LONGEST_GT?: number | null;
  email_LONGEST_GTE?: number | null;
  email_LONGEST_LT?: number | null;
  email_LONGEST_LTE?: number | null;
  email_LT?: number | null;
  email_LTE?: number | null;
  email_SHORTEST_EQUAL?: number | null;
  email_SHORTEST_GT?: number | null;
  email_SHORTEST_GTE?: number | null;
  email_SHORTEST_LT?: number | null;
  email_SHORTEST_LTE?: number | null;
  firstName_AVERAGE_EQUAL?: number | null;
  firstName_AVERAGE_GT?: number | null;
  firstName_AVERAGE_GTE?: number | null;
  firstName_AVERAGE_LT?: number | null;
  firstName_AVERAGE_LTE?: number | null;
  firstName_EQUAL?: string | null;
  firstName_GT?: number | null;
  firstName_GTE?: number | null;
  firstName_LONGEST_EQUAL?: number | null;
  firstName_LONGEST_GT?: number | null;
  firstName_LONGEST_GTE?: number | null;
  firstName_LONGEST_LT?: number | null;
  firstName_LONGEST_LTE?: number | null;
  firstName_LT?: number | null;
  firstName_LTE?: number | null;
  firstName_SHORTEST_EQUAL?: number | null;
  firstName_SHORTEST_GT?: number | null;
  firstName_SHORTEST_GTE?: number | null;
  firstName_SHORTEST_LT?: number | null;
  firstName_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  lastName_AVERAGE_EQUAL?: number | null;
  lastName_AVERAGE_GT?: number | null;
  lastName_AVERAGE_GTE?: number | null;
  lastName_AVERAGE_LT?: number | null;
  lastName_AVERAGE_LTE?: number | null;
  lastName_EQUAL?: string | null;
  lastName_GT?: number | null;
  lastName_GTE?: number | null;
  lastName_LONGEST_EQUAL?: number | null;
  lastName_LONGEST_GT?: number | null;
  lastName_LONGEST_GTE?: number | null;
  lastName_LONGEST_LT?: number | null;
  lastName_LONGEST_LTE?: number | null;
  lastName_LT?: number | null;
  lastName_LTE?: number | null;
  lastName_SHORTEST_EQUAL?: number | null;
  lastName_SHORTEST_GT?: number | null;
  lastName_SHORTEST_GTE?: number | null;
  lastName_SHORTEST_LT?: number | null;
  lastName_SHORTEST_LTE?: number | null;
  position_AVERAGE_EQUAL?: number | null;
  position_AVERAGE_GT?: number | null;
  position_AVERAGE_GTE?: number | null;
  position_AVERAGE_LT?: number | null;
  position_AVERAGE_LTE?: number | null;
  position_EQUAL?: string | null;
  position_GT?: number | null;
  position_GTE?: number | null;
  position_LONGEST_EQUAL?: number | null;
  position_LONGEST_GT?: number | null;
  position_LONGEST_GTE?: number | null;
  position_LONGEST_LT?: number | null;
  position_LONGEST_LTE?: number | null;
  position_LT?: number | null;
  position_LTE?: number | null;
  position_SHORTEST_EQUAL?: number | null;
  position_SHORTEST_GT?: number | null;
  position_SHORTEST_GTE?: number | null;
  position_SHORTEST_LT?: number | null;
  position_SHORTEST_LTE?: number | null;
  preferredLanguage_AVERAGE_EQUAL?: number | null;
  preferredLanguage_AVERAGE_GT?: number | null;
  preferredLanguage_AVERAGE_GTE?: number | null;
  preferredLanguage_AVERAGE_LT?: number | null;
  preferredLanguage_AVERAGE_LTE?: number | null;
  preferredLanguage_EQUAL?: string | null;
  preferredLanguage_GT?: number | null;
  preferredLanguage_GTE?: number | null;
  preferredLanguage_LONGEST_EQUAL?: number | null;
  preferredLanguage_LONGEST_GT?: number | null;
  preferredLanguage_LONGEST_GTE?: number | null;
  preferredLanguage_LONGEST_LT?: number | null;
  preferredLanguage_LONGEST_LTE?: number | null;
  preferredLanguage_LT?: number | null;
  preferredLanguage_LTE?: number | null;
  preferredLanguage_SHORTEST_EQUAL?: number | null;
  preferredLanguage_SHORTEST_GT?: number | null;
  preferredLanguage_SHORTEST_GTE?: number | null;
  preferredLanguage_SHORTEST_LT?: number | null;
  preferredLanguage_SHORTEST_LTE?: number | null;
  tenantId_AVERAGE_EQUAL?: number | null;
  tenantId_AVERAGE_GT?: number | null;
  tenantId_AVERAGE_GTE?: number | null;
  tenantId_AVERAGE_LT?: number | null;
  tenantId_AVERAGE_LTE?: number | null;
  tenantId_EQUAL?: string | null;
  tenantId_GT?: number | null;
  tenantId_GTE?: number | null;
  tenantId_LONGEST_EQUAL?: number | null;
  tenantId_LONGEST_GT?: number | null;
  tenantId_LONGEST_GTE?: number | null;
  tenantId_LONGEST_LT?: number | null;
  tenantId_LONGEST_LTE?: number | null;
  tenantId_LT?: number | null;
  tenantId_LTE?: number | null;
  tenantId_SHORTEST_EQUAL?: number | null;
  tenantId_SHORTEST_GT?: number | null;
  tenantId_SHORTEST_GTE?: number | null;
  tenantId_SHORTEST_LT?: number | null;
  tenantId_SHORTEST_LTE?: number | null;
}

export interface BaseAgreementCounterpartiesAggregateInput {
  AND?: BaseAgreementCounterpartiesAggregateInput[] | null;
  OR?: BaseAgreementCounterpartiesAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: BaseAgreementCounterpartiesNodeAggregationWhereInput | null;
}

export interface BaseAgreementCounterpartiesConnectionWhere {
  AND?: BaseAgreementCounterpartiesConnectionWhere[] | null;
  OR?: BaseAgreementCounterpartiesConnectionWhere[] | null;
  edge?: BaseAgreementCounterpartyRelationshipWhere | null;
  edge_NOT?: BaseAgreementCounterpartyRelationshipWhere | null;
  node?: OrganizationWhere | null;
  node_NOT?: OrganizationWhere | null;
}

export interface BaseAgreementCounterpartiesNodeAggregationWhereInput {
  AND?: BaseAgreementCounterpartiesNodeAggregationWhereInput[] | null;
  BIC_AVERAGE_EQUAL?: number | null;
  BIC_AVERAGE_GT?: number | null;
  BIC_AVERAGE_GTE?: number | null;
  BIC_AVERAGE_LT?: number | null;
  BIC_AVERAGE_LTE?: number | null;
  BIC_EQUAL?: string | null;
  BIC_GT?: number | null;
  BIC_GTE?: number | null;
  BIC_LONGEST_EQUAL?: number | null;
  BIC_LONGEST_GT?: number | null;
  BIC_LONGEST_GTE?: number | null;
  BIC_LONGEST_LT?: number | null;
  BIC_LONGEST_LTE?: number | null;
  BIC_LT?: number | null;
  BIC_LTE?: number | null;
  BIC_SHORTEST_EQUAL?: number | null;
  BIC_SHORTEST_GT?: number | null;
  BIC_SHORTEST_GTE?: number | null;
  BIC_SHORTEST_LT?: number | null;
  BIC_SHORTEST_LTE?: number | null;
  IBAN_AVERAGE_EQUAL?: number | null;
  IBAN_AVERAGE_GT?: number | null;
  IBAN_AVERAGE_GTE?: number | null;
  IBAN_AVERAGE_LT?: number | null;
  IBAN_AVERAGE_LTE?: number | null;
  IBAN_EQUAL?: string | null;
  IBAN_GT?: number | null;
  IBAN_GTE?: number | null;
  IBAN_LONGEST_EQUAL?: number | null;
  IBAN_LONGEST_GT?: number | null;
  IBAN_LONGEST_GTE?: number | null;
  IBAN_LONGEST_LT?: number | null;
  IBAN_LONGEST_LTE?: number | null;
  IBAN_LT?: number | null;
  IBAN_LTE?: number | null;
  IBAN_SHORTEST_EQUAL?: number | null;
  IBAN_SHORTEST_GT?: number | null;
  IBAN_SHORTEST_GTE?: number | null;
  IBAN_SHORTEST_LT?: number | null;
  IBAN_SHORTEST_LTE?: number | null;
  OR?: BaseAgreementCounterpartiesNodeAggregationWhereInput[] | null;
  accountName_AVERAGE_EQUAL?: number | null;
  accountName_AVERAGE_GT?: number | null;
  accountName_AVERAGE_GTE?: number | null;
  accountName_AVERAGE_LT?: number | null;
  accountName_AVERAGE_LTE?: number | null;
  accountName_EQUAL?: string | null;
  accountName_GT?: number | null;
  accountName_GTE?: number | null;
  accountName_LONGEST_EQUAL?: number | null;
  accountName_LONGEST_GT?: number | null;
  accountName_LONGEST_GTE?: number | null;
  accountName_LONGEST_LT?: number | null;
  accountName_LONGEST_LTE?: number | null;
  accountName_LT?: number | null;
  accountName_LTE?: number | null;
  accountName_SHORTEST_EQUAL?: number | null;
  accountName_SHORTEST_GT?: number | null;
  accountName_SHORTEST_GTE?: number | null;
  accountName_SHORTEST_LT?: number | null;
  accountName_SHORTEST_LTE?: number | null;
  accountNumber_AVERAGE_EQUAL?: number | null;
  accountNumber_AVERAGE_GT?: number | null;
  accountNumber_AVERAGE_GTE?: number | null;
  accountNumber_AVERAGE_LT?: number | null;
  accountNumber_AVERAGE_LTE?: number | null;
  accountNumber_EQUAL?: string | null;
  accountNumber_GT?: number | null;
  accountNumber_GTE?: number | null;
  accountNumber_LONGEST_EQUAL?: number | null;
  accountNumber_LONGEST_GT?: number | null;
  accountNumber_LONGEST_GTE?: number | null;
  accountNumber_LONGEST_LT?: number | null;
  accountNumber_LONGEST_LTE?: number | null;
  accountNumber_LT?: number | null;
  accountNumber_LTE?: number | null;
  accountNumber_SHORTEST_EQUAL?: number | null;
  accountNumber_SHORTEST_GT?: number | null;
  accountNumber_SHORTEST_GTE?: number | null;
  accountNumber_SHORTEST_LT?: number | null;
  accountNumber_SHORTEST_LTE?: number | null;
  billingAddress_AVERAGE_EQUAL?: number | null;
  billingAddress_AVERAGE_GT?: number | null;
  billingAddress_AVERAGE_GTE?: number | null;
  billingAddress_AVERAGE_LT?: number | null;
  billingAddress_AVERAGE_LTE?: number | null;
  billingAddress_EQUAL?: string | null;
  billingAddress_GT?: number | null;
  billingAddress_GTE?: number | null;
  billingAddress_LONGEST_EQUAL?: number | null;
  billingAddress_LONGEST_GT?: number | null;
  billingAddress_LONGEST_GTE?: number | null;
  billingAddress_LONGEST_LT?: number | null;
  billingAddress_LONGEST_LTE?: number | null;
  billingAddress_LT?: number | null;
  billingAddress_LTE?: number | null;
  billingAddress_SHORTEST_EQUAL?: number | null;
  billingAddress_SHORTEST_GT?: number | null;
  billingAddress_SHORTEST_GTE?: number | null;
  billingAddress_SHORTEST_LT?: number | null;
  billingAddress_SHORTEST_LTE?: number | null;
  contactEmail_AVERAGE_EQUAL?: number | null;
  contactEmail_AVERAGE_GT?: number | null;
  contactEmail_AVERAGE_GTE?: number | null;
  contactEmail_AVERAGE_LT?: number | null;
  contactEmail_AVERAGE_LTE?: number | null;
  contactEmail_EQUAL?: string | null;
  contactEmail_GT?: number | null;
  contactEmail_GTE?: number | null;
  contactEmail_LONGEST_EQUAL?: number | null;
  contactEmail_LONGEST_GT?: number | null;
  contactEmail_LONGEST_GTE?: number | null;
  contactEmail_LONGEST_LT?: number | null;
  contactEmail_LONGEST_LTE?: number | null;
  contactEmail_LT?: number | null;
  contactEmail_LTE?: number | null;
  contactEmail_SHORTEST_EQUAL?: number | null;
  contactEmail_SHORTEST_GT?: number | null;
  contactEmail_SHORTEST_GTE?: number | null;
  contactEmail_SHORTEST_LT?: number | null;
  contactEmail_SHORTEST_LTE?: number | null;
  contactFirstName_AVERAGE_EQUAL?: number | null;
  contactFirstName_AVERAGE_GT?: number | null;
  contactFirstName_AVERAGE_GTE?: number | null;
  contactFirstName_AVERAGE_LT?: number | null;
  contactFirstName_AVERAGE_LTE?: number | null;
  contactFirstName_EQUAL?: string | null;
  contactFirstName_GT?: number | null;
  contactFirstName_GTE?: number | null;
  contactFirstName_LONGEST_EQUAL?: number | null;
  contactFirstName_LONGEST_GT?: number | null;
  contactFirstName_LONGEST_GTE?: number | null;
  contactFirstName_LONGEST_LT?: number | null;
  contactFirstName_LONGEST_LTE?: number | null;
  contactFirstName_LT?: number | null;
  contactFirstName_LTE?: number | null;
  contactFirstName_SHORTEST_EQUAL?: number | null;
  contactFirstName_SHORTEST_GT?: number | null;
  contactFirstName_SHORTEST_GTE?: number | null;
  contactFirstName_SHORTEST_LT?: number | null;
  contactFirstName_SHORTEST_LTE?: number | null;
  contactLastName_AVERAGE_EQUAL?: number | null;
  contactLastName_AVERAGE_GT?: number | null;
  contactLastName_AVERAGE_GTE?: number | null;
  contactLastName_AVERAGE_LT?: number | null;
  contactLastName_AVERAGE_LTE?: number | null;
  contactLastName_EQUAL?: string | null;
  contactLastName_GT?: number | null;
  contactLastName_GTE?: number | null;
  contactLastName_LONGEST_EQUAL?: number | null;
  contactLastName_LONGEST_GT?: number | null;
  contactLastName_LONGEST_GTE?: number | null;
  contactLastName_LONGEST_LT?: number | null;
  contactLastName_LONGEST_LTE?: number | null;
  contactLastName_LT?: number | null;
  contactLastName_LTE?: number | null;
  contactLastName_SHORTEST_EQUAL?: number | null;
  contactLastName_SHORTEST_GT?: number | null;
  contactLastName_SHORTEST_GTE?: number | null;
  contactLastName_SHORTEST_LT?: number | null;
  contactLastName_SHORTEST_LTE?: number | null;
  contactOccupation_AVERAGE_EQUAL?: number | null;
  contactOccupation_AVERAGE_GT?: number | null;
  contactOccupation_AVERAGE_GTE?: number | null;
  contactOccupation_AVERAGE_LT?: number | null;
  contactOccupation_AVERAGE_LTE?: number | null;
  contactOccupation_EQUAL?: string | null;
  contactOccupation_GT?: number | null;
  contactOccupation_GTE?: number | null;
  contactOccupation_LONGEST_EQUAL?: number | null;
  contactOccupation_LONGEST_GT?: number | null;
  contactOccupation_LONGEST_GTE?: number | null;
  contactOccupation_LONGEST_LT?: number | null;
  contactOccupation_LONGEST_LTE?: number | null;
  contactOccupation_LT?: number | null;
  contactOccupation_LTE?: number | null;
  contactOccupation_SHORTEST_EQUAL?: number | null;
  contactOccupation_SHORTEST_GT?: number | null;
  contactOccupation_SHORTEST_GTE?: number | null;
  contactOccupation_SHORTEST_LT?: number | null;
  contactOccupation_SHORTEST_LTE?: number | null;
  contactPhone_AVERAGE_EQUAL?: number | null;
  contactPhone_AVERAGE_GT?: number | null;
  contactPhone_AVERAGE_GTE?: number | null;
  contactPhone_AVERAGE_LT?: number | null;
  contactPhone_AVERAGE_LTE?: number | null;
  contactPhone_EQUAL?: string | null;
  contactPhone_GT?: number | null;
  contactPhone_GTE?: number | null;
  contactPhone_LONGEST_EQUAL?: number | null;
  contactPhone_LONGEST_GT?: number | null;
  contactPhone_LONGEST_GTE?: number | null;
  contactPhone_LONGEST_LT?: number | null;
  contactPhone_LONGEST_LTE?: number | null;
  contactPhone_LT?: number | null;
  contactPhone_LTE?: number | null;
  contactPhone_SHORTEST_EQUAL?: number | null;
  contactPhone_SHORTEST_GT?: number | null;
  contactPhone_SHORTEST_GTE?: number | null;
  contactPhone_SHORTEST_LT?: number | null;
  contactPhone_SHORTEST_LTE?: number | null;
  createdOn_AVERAGE_EQUAL?: number | null;
  createdOn_AVERAGE_GT?: number | null;
  createdOn_AVERAGE_GTE?: number | null;
  createdOn_AVERAGE_LT?: number | null;
  createdOn_AVERAGE_LTE?: number | null;
  createdOn_EQUAL?: number | null;
  createdOn_GT?: number | null;
  createdOn_GTE?: number | null;
  createdOn_LT?: number | null;
  createdOn_LTE?: number | null;
  createdOn_MAX_EQUAL?: number | null;
  createdOn_MAX_GT?: number | null;
  createdOn_MAX_GTE?: number | null;
  createdOn_MAX_LT?: number | null;
  createdOn_MAX_LTE?: number | null;
  createdOn_MIN_EQUAL?: number | null;
  createdOn_MIN_GT?: number | null;
  createdOn_MIN_GTE?: number | null;
  createdOn_MIN_LT?: number | null;
  createdOn_MIN_LTE?: number | null;
  createdOn_SUM_EQUAL?: number | null;
  createdOn_SUM_GT?: number | null;
  createdOn_SUM_GTE?: number | null;
  createdOn_SUM_LT?: number | null;
  createdOn_SUM_LTE?: number | null;
  deliveryAddress_AVERAGE_EQUAL?: number | null;
  deliveryAddress_AVERAGE_GT?: number | null;
  deliveryAddress_AVERAGE_GTE?: number | null;
  deliveryAddress_AVERAGE_LT?: number | null;
  deliveryAddress_AVERAGE_LTE?: number | null;
  deliveryAddress_EQUAL?: string | null;
  deliveryAddress_GT?: number | null;
  deliveryAddress_GTE?: number | null;
  deliveryAddress_LONGEST_EQUAL?: number | null;
  deliveryAddress_LONGEST_GT?: number | null;
  deliveryAddress_LONGEST_GTE?: number | null;
  deliveryAddress_LONGEST_LT?: number | null;
  deliveryAddress_LONGEST_LTE?: number | null;
  deliveryAddress_LT?: number | null;
  deliveryAddress_LTE?: number | null;
  deliveryAddress_SHORTEST_EQUAL?: number | null;
  deliveryAddress_SHORTEST_GT?: number | null;
  deliveryAddress_SHORTEST_GTE?: number | null;
  deliveryAddress_SHORTEST_LT?: number | null;
  deliveryAddress_SHORTEST_LTE?: number | null;
  domicile_AVERAGE_EQUAL?: number | null;
  domicile_AVERAGE_GT?: number | null;
  domicile_AVERAGE_GTE?: number | null;
  domicile_AVERAGE_LT?: number | null;
  domicile_AVERAGE_LTE?: number | null;
  domicile_EQUAL?: string | null;
  domicile_GT?: number | null;
  domicile_GTE?: number | null;
  domicile_LONGEST_EQUAL?: number | null;
  domicile_LONGEST_GT?: number | null;
  domicile_LONGEST_GTE?: number | null;
  domicile_LONGEST_LT?: number | null;
  domicile_LONGEST_LTE?: number | null;
  domicile_LT?: number | null;
  domicile_LTE?: number | null;
  domicile_SHORTEST_EQUAL?: number | null;
  domicile_SHORTEST_GT?: number | null;
  domicile_SHORTEST_GTE?: number | null;
  domicile_SHORTEST_LT?: number | null;
  domicile_SHORTEST_LTE?: number | null;
  dualApprovalThreshold_AVERAGE_EQUAL?: number | null;
  dualApprovalThreshold_AVERAGE_GT?: number | null;
  dualApprovalThreshold_AVERAGE_GTE?: number | null;
  dualApprovalThreshold_AVERAGE_LT?: number | null;
  dualApprovalThreshold_AVERAGE_LTE?: number | null;
  dualApprovalThreshold_EQUAL?: number | null;
  dualApprovalThreshold_GT?: number | null;
  dualApprovalThreshold_GTE?: number | null;
  dualApprovalThreshold_LT?: number | null;
  dualApprovalThreshold_LTE?: number | null;
  dualApprovalThreshold_MAX_EQUAL?: number | null;
  dualApprovalThreshold_MAX_GT?: number | null;
  dualApprovalThreshold_MAX_GTE?: number | null;
  dualApprovalThreshold_MAX_LT?: number | null;
  dualApprovalThreshold_MAX_LTE?: number | null;
  dualApprovalThreshold_MIN_EQUAL?: number | null;
  dualApprovalThreshold_MIN_GT?: number | null;
  dualApprovalThreshold_MIN_GTE?: number | null;
  dualApprovalThreshold_MIN_LT?: number | null;
  dualApprovalThreshold_MIN_LTE?: number | null;
  dualApprovalThreshold_SUM_EQUAL?: number | null;
  dualApprovalThreshold_SUM_GT?: number | null;
  dualApprovalThreshold_SUM_GTE?: number | null;
  dualApprovalThreshold_SUM_LT?: number | null;
  dualApprovalThreshold_SUM_LTE?: number | null;
  eIN_AVERAGE_EQUAL?: number | null;
  eIN_AVERAGE_GT?: number | null;
  eIN_AVERAGE_GTE?: number | null;
  eIN_AVERAGE_LT?: number | null;
  eIN_AVERAGE_LTE?: number | null;
  eIN_EQUAL?: string | null;
  eIN_GT?: number | null;
  eIN_GTE?: number | null;
  eIN_LONGEST_EQUAL?: number | null;
  eIN_LONGEST_GT?: number | null;
  eIN_LONGEST_GTE?: number | null;
  eIN_LONGEST_LT?: number | null;
  eIN_LONGEST_LTE?: number | null;
  eIN_LT?: number | null;
  eIN_LTE?: number | null;
  eIN_SHORTEST_EQUAL?: number | null;
  eIN_SHORTEST_GT?: number | null;
  eIN_SHORTEST_GTE?: number | null;
  eIN_SHORTEST_LT?: number | null;
  eIN_SHORTEST_LTE?: number | null;
  fax_AVERAGE_EQUAL?: number | null;
  fax_AVERAGE_GT?: number | null;
  fax_AVERAGE_GTE?: number | null;
  fax_AVERAGE_LT?: number | null;
  fax_AVERAGE_LTE?: number | null;
  fax_EQUAL?: string | null;
  fax_GT?: number | null;
  fax_GTE?: number | null;
  fax_LONGEST_EQUAL?: number | null;
  fax_LONGEST_GT?: number | null;
  fax_LONGEST_GTE?: number | null;
  fax_LONGEST_LT?: number | null;
  fax_LONGEST_LTE?: number | null;
  fax_LT?: number | null;
  fax_LTE?: number | null;
  fax_SHORTEST_EQUAL?: number | null;
  fax_SHORTEST_GT?: number | null;
  fax_SHORTEST_GTE?: number | null;
  fax_SHORTEST_LT?: number | null;
  fax_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  legalName_AVERAGE_EQUAL?: number | null;
  legalName_AVERAGE_GT?: number | null;
  legalName_AVERAGE_GTE?: number | null;
  legalName_AVERAGE_LT?: number | null;
  legalName_AVERAGE_LTE?: number | null;
  legalName_EQUAL?: string | null;
  legalName_GT?: number | null;
  legalName_GTE?: number | null;
  legalName_LONGEST_EQUAL?: number | null;
  legalName_LONGEST_GT?: number | null;
  legalName_LONGEST_GTE?: number | null;
  legalName_LONGEST_LT?: number | null;
  legalName_LONGEST_LTE?: number | null;
  legalName_LT?: number | null;
  legalName_LTE?: number | null;
  legalName_SHORTEST_EQUAL?: number | null;
  legalName_SHORTEST_GT?: number | null;
  legalName_SHORTEST_GTE?: number | null;
  legalName_SHORTEST_LT?: number | null;
  legalName_SHORTEST_LTE?: number | null;
  logo_AVERAGE_EQUAL?: number | null;
  logo_AVERAGE_GT?: number | null;
  logo_AVERAGE_GTE?: number | null;
  logo_AVERAGE_LT?: number | null;
  logo_AVERAGE_LTE?: number | null;
  logo_EQUAL?: string | null;
  logo_GT?: number | null;
  logo_GTE?: number | null;
  logo_LONGEST_EQUAL?: number | null;
  logo_LONGEST_GT?: number | null;
  logo_LONGEST_GTE?: number | null;
  logo_LONGEST_LT?: number | null;
  logo_LONGEST_LTE?: number | null;
  logo_LT?: number | null;
  logo_LTE?: number | null;
  logo_SHORTEST_EQUAL?: number | null;
  logo_SHORTEST_GT?: number | null;
  logo_SHORTEST_GTE?: number | null;
  logo_SHORTEST_LT?: number | null;
  logo_SHORTEST_LTE?: number | null;
  name_AVERAGE_EQUAL?: number | null;
  name_AVERAGE_GT?: number | null;
  name_AVERAGE_GTE?: number | null;
  name_AVERAGE_LT?: number | null;
  name_AVERAGE_LTE?: number | null;
  name_EQUAL?: string | null;
  name_GT?: number | null;
  name_GTE?: number | null;
  name_LONGEST_EQUAL?: number | null;
  name_LONGEST_GT?: number | null;
  name_LONGEST_GTE?: number | null;
  name_LONGEST_LT?: number | null;
  name_LONGEST_LTE?: number | null;
  name_LT?: number | null;
  name_LTE?: number | null;
  name_SHORTEST_EQUAL?: number | null;
  name_SHORTEST_GT?: number | null;
  name_SHORTEST_GTE?: number | null;
  name_SHORTEST_LT?: number | null;
  name_SHORTEST_LTE?: number | null;
  paymentTerms_AVERAGE_EQUAL?: number | null;
  paymentTerms_AVERAGE_GT?: number | null;
  paymentTerms_AVERAGE_GTE?: number | null;
  paymentTerms_AVERAGE_LT?: number | null;
  paymentTerms_AVERAGE_LTE?: number | null;
  paymentTerms_EQUAL?: number | null;
  paymentTerms_GT?: number | null;
  paymentTerms_GTE?: number | null;
  paymentTerms_LT?: number | null;
  paymentTerms_LTE?: number | null;
  paymentTerms_MAX_EQUAL?: number | null;
  paymentTerms_MAX_GT?: number | null;
  paymentTerms_MAX_GTE?: number | null;
  paymentTerms_MAX_LT?: number | null;
  paymentTerms_MAX_LTE?: number | null;
  paymentTerms_MIN_EQUAL?: number | null;
  paymentTerms_MIN_GT?: number | null;
  paymentTerms_MIN_GTE?: number | null;
  paymentTerms_MIN_LT?: number | null;
  paymentTerms_MIN_LTE?: number | null;
  paymentTerms_SUM_EQUAL?: number | null;
  paymentTerms_SUM_GT?: number | null;
  paymentTerms_SUM_GTE?: number | null;
  paymentTerms_SUM_LT?: number | null;
  paymentTerms_SUM_LTE?: number | null;
  phone_AVERAGE_EQUAL?: number | null;
  phone_AVERAGE_GT?: number | null;
  phone_AVERAGE_GTE?: number | null;
  phone_AVERAGE_LT?: number | null;
  phone_AVERAGE_LTE?: number | null;
  phone_EQUAL?: string | null;
  phone_GT?: number | null;
  phone_GTE?: number | null;
  phone_LONGEST_EQUAL?: number | null;
  phone_LONGEST_GT?: number | null;
  phone_LONGEST_GTE?: number | null;
  phone_LONGEST_LT?: number | null;
  phone_LONGEST_LTE?: number | null;
  phone_LT?: number | null;
  phone_LTE?: number | null;
  phone_SHORTEST_EQUAL?: number | null;
  phone_SHORTEST_GT?: number | null;
  phone_SHORTEST_GTE?: number | null;
  phone_SHORTEST_LT?: number | null;
  phone_SHORTEST_LTE?: number | null;
  tenantId_AVERAGE_EQUAL?: number | null;
  tenantId_AVERAGE_GT?: number | null;
  tenantId_AVERAGE_GTE?: number | null;
  tenantId_AVERAGE_LT?: number | null;
  tenantId_AVERAGE_LTE?: number | null;
  tenantId_EQUAL?: string | null;
  tenantId_GT?: number | null;
  tenantId_GTE?: number | null;
  tenantId_LONGEST_EQUAL?: number | null;
  tenantId_LONGEST_GT?: number | null;
  tenantId_LONGEST_GTE?: number | null;
  tenantId_LONGEST_LT?: number | null;
  tenantId_LONGEST_LTE?: number | null;
  tenantId_LT?: number | null;
  tenantId_LTE?: number | null;
  tenantId_SHORTEST_EQUAL?: number | null;
  tenantId_SHORTEST_GT?: number | null;
  tenantId_SHORTEST_GTE?: number | null;
  tenantId_SHORTEST_LT?: number | null;
  tenantId_SHORTEST_LTE?: number | null;
  website_AVERAGE_EQUAL?: number | null;
  website_AVERAGE_GT?: number | null;
  website_AVERAGE_GTE?: number | null;
  website_AVERAGE_LT?: number | null;
  website_AVERAGE_LTE?: number | null;
  website_EQUAL?: string | null;
  website_GT?: number | null;
  website_GTE?: number | null;
  website_LONGEST_EQUAL?: number | null;
  website_LONGEST_GT?: number | null;
  website_LONGEST_GTE?: number | null;
  website_LONGEST_LT?: number | null;
  website_LONGEST_LTE?: number | null;
  website_LT?: number | null;
  website_LTE?: number | null;
  website_SHORTEST_EQUAL?: number | null;
  website_SHORTEST_GT?: number | null;
  website_SHORTEST_GTE?: number | null;
  website_SHORTEST_LT?: number | null;
  website_SHORTEST_LTE?: number | null;
}

export interface BaseAgreementCounterpartyRelationshipWhere {
  AND?: BaseAgreementCounterpartyRelationshipWhere[] | null;
  OR?: BaseAgreementCounterpartyRelationshipWhere[] | null;
  isApprovalRequired?: boolean | null;
  isApprovalRequired_NOT?: boolean | null;
  role?: CounterpartyRole | null;
  role_IN?: (CounterpartyRole | null)[] | null;
  role_NOT?: CounterpartyRole | null;
  role_NOT_IN?: (CounterpartyRole | null)[] | null;
}

export interface BaseAgreementCurrencyAggregateInput {
  AND?: BaseAgreementCurrencyAggregateInput[] | null;
  OR?: BaseAgreementCurrencyAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: BaseAgreementCurrencyNodeAggregationWhereInput | null;
}

export interface BaseAgreementCurrencyConnectionWhere {
  AND?: BaseAgreementCurrencyConnectionWhere[] | null;
  OR?: BaseAgreementCurrencyConnectionWhere[] | null;
  node?: CurrencyWhere | null;
  node_NOT?: CurrencyWhere | null;
}

export interface BaseAgreementCurrencyNodeAggregationWhereInput {
  AND?: BaseAgreementCurrencyNodeAggregationWhereInput[] | null;
  Code_AVERAGE_EQUAL?: number | null;
  Code_AVERAGE_GT?: number | null;
  Code_AVERAGE_GTE?: number | null;
  Code_AVERAGE_LT?: number | null;
  Code_AVERAGE_LTE?: number | null;
  Code_EQUAL?: string | null;
  Code_GT?: number | null;
  Code_GTE?: number | null;
  Code_LONGEST_EQUAL?: number | null;
  Code_LONGEST_GT?: number | null;
  Code_LONGEST_GTE?: number | null;
  Code_LONGEST_LT?: number | null;
  Code_LONGEST_LTE?: number | null;
  Code_LT?: number | null;
  Code_LTE?: number | null;
  Code_SHORTEST_EQUAL?: number | null;
  Code_SHORTEST_GT?: number | null;
  Code_SHORTEST_GTE?: number | null;
  Code_SHORTEST_LT?: number | null;
  Code_SHORTEST_LTE?: number | null;
  Name_AVERAGE_EQUAL?: number | null;
  Name_AVERAGE_GT?: number | null;
  Name_AVERAGE_GTE?: number | null;
  Name_AVERAGE_LT?: number | null;
  Name_AVERAGE_LTE?: number | null;
  Name_EQUAL?: string | null;
  Name_GT?: number | null;
  Name_GTE?: number | null;
  Name_LONGEST_EQUAL?: number | null;
  Name_LONGEST_GT?: number | null;
  Name_LONGEST_GTE?: number | null;
  Name_LONGEST_LT?: number | null;
  Name_LONGEST_LTE?: number | null;
  Name_LT?: number | null;
  Name_LTE?: number | null;
  Name_SHORTEST_EQUAL?: number | null;
  Name_SHORTEST_GT?: number | null;
  Name_SHORTEST_GTE?: number | null;
  Name_SHORTEST_LT?: number | null;
  Name_SHORTEST_LTE?: number | null;
  OR?: BaseAgreementCurrencyNodeAggregationWhereInput[] | null;
  symbol_AVERAGE_EQUAL?: number | null;
  symbol_AVERAGE_GT?: number | null;
  symbol_AVERAGE_GTE?: number | null;
  symbol_AVERAGE_LT?: number | null;
  symbol_AVERAGE_LTE?: number | null;
  symbol_EQUAL?: string | null;
  symbol_GT?: number | null;
  symbol_GTE?: number | null;
  symbol_LONGEST_EQUAL?: number | null;
  symbol_LONGEST_GT?: number | null;
  symbol_LONGEST_GTE?: number | null;
  symbol_LONGEST_LT?: number | null;
  symbol_LONGEST_LTE?: number | null;
  symbol_LT?: number | null;
  symbol_LTE?: number | null;
  symbol_SHORTEST_EQUAL?: number | null;
  symbol_SHORTEST_GT?: number | null;
  symbol_SHORTEST_GTE?: number | null;
  symbol_SHORTEST_LT?: number | null;
  symbol_SHORTEST_LTE?: number | null;
}

export interface BaseAgreementCyclesAggregateInput {
  AND?: BaseAgreementCyclesAggregateInput[] | null;
  OR?: BaseAgreementCyclesAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: BaseAgreementCyclesNodeAggregationWhereInput | null;
}

export interface BaseAgreementCyclesConnectionWhere {
  AND?: BaseAgreementCyclesConnectionWhere[] | null;
  OR?: BaseAgreementCyclesConnectionWhere[] | null;
  node?: CycleConfigurationWhere | null;
  node_NOT?: CycleConfigurationWhere | null;
}

export interface BaseAgreementCyclesNodeAggregationWhereInput {
  AND?: BaseAgreementCyclesNodeAggregationWhereInput[] | null;
  OR?: BaseAgreementCyclesNodeAggregationWhereInput[] | null;
  lengthFrom_AVERAGE_EQUAL?: number | null;
  lengthFrom_AVERAGE_GT?: number | null;
  lengthFrom_AVERAGE_GTE?: number | null;
  lengthFrom_AVERAGE_LT?: number | null;
  lengthFrom_AVERAGE_LTE?: number | null;
  lengthFrom_EQUAL?: number | null;
  lengthFrom_GT?: number | null;
  lengthFrom_GTE?: number | null;
  lengthFrom_LT?: number | null;
  lengthFrom_LTE?: number | null;
  lengthFrom_MAX_EQUAL?: number | null;
  lengthFrom_MAX_GT?: number | null;
  lengthFrom_MAX_GTE?: number | null;
  lengthFrom_MAX_LT?: number | null;
  lengthFrom_MAX_LTE?: number | null;
  lengthFrom_MIN_EQUAL?: number | null;
  lengthFrom_MIN_GT?: number | null;
  lengthFrom_MIN_GTE?: number | null;
  lengthFrom_MIN_LT?: number | null;
  lengthFrom_MIN_LTE?: number | null;
  lengthFrom_SUM_EQUAL?: number | null;
  lengthFrom_SUM_GT?: number | null;
  lengthFrom_SUM_GTE?: number | null;
  lengthFrom_SUM_LT?: number | null;
  lengthFrom_SUM_LTE?: number | null;
  lengthTo_AVERAGE_EQUAL?: number | null;
  lengthTo_AVERAGE_GT?: number | null;
  lengthTo_AVERAGE_GTE?: number | null;
  lengthTo_AVERAGE_LT?: number | null;
  lengthTo_AVERAGE_LTE?: number | null;
  lengthTo_EQUAL?: number | null;
  lengthTo_GT?: number | null;
  lengthTo_GTE?: number | null;
  lengthTo_LT?: number | null;
  lengthTo_LTE?: number | null;
  lengthTo_MAX_EQUAL?: number | null;
  lengthTo_MAX_GT?: number | null;
  lengthTo_MAX_GTE?: number | null;
  lengthTo_MAX_LT?: number | null;
  lengthTo_MAX_LTE?: number | null;
  lengthTo_MIN_EQUAL?: number | null;
  lengthTo_MIN_GT?: number | null;
  lengthTo_MIN_GTE?: number | null;
  lengthTo_MIN_LT?: number | null;
  lengthTo_MIN_LTE?: number | null;
  lengthTo_SUM_EQUAL?: number | null;
  lengthTo_SUM_GT?: number | null;
  lengthTo_SUM_GTE?: number | null;
  lengthTo_SUM_LT?: number | null;
  lengthTo_SUM_LTE?: number | null;
  name_AVERAGE_EQUAL?: number | null;
  name_AVERAGE_GT?: number | null;
  name_AVERAGE_GTE?: number | null;
  name_AVERAGE_LT?: number | null;
  name_AVERAGE_LTE?: number | null;
  name_EQUAL?: string | null;
  name_GT?: number | null;
  name_GTE?: number | null;
  name_LONGEST_EQUAL?: number | null;
  name_LONGEST_GT?: number | null;
  name_LONGEST_GTE?: number | null;
  name_LONGEST_LT?: number | null;
  name_LONGEST_LTE?: number | null;
  name_LT?: number | null;
  name_LTE?: number | null;
  name_SHORTEST_EQUAL?: number | null;
  name_SHORTEST_GT?: number | null;
  name_SHORTEST_GTE?: number | null;
  name_SHORTEST_LT?: number | null;
  name_SHORTEST_LTE?: number | null;
  order_AVERAGE_EQUAL?: number | null;
  order_AVERAGE_GT?: number | null;
  order_AVERAGE_GTE?: number | null;
  order_AVERAGE_LT?: number | null;
  order_AVERAGE_LTE?: number | null;
  order_EQUAL?: number | null;
  order_GT?: number | null;
  order_GTE?: number | null;
  order_LT?: number | null;
  order_LTE?: number | null;
  order_MAX_EQUAL?: number | null;
  order_MAX_GT?: number | null;
  order_MAX_GTE?: number | null;
  order_MAX_LT?: number | null;
  order_MAX_LTE?: number | null;
  order_MIN_EQUAL?: number | null;
  order_MIN_GT?: number | null;
  order_MIN_GTE?: number | null;
  order_MIN_LT?: number | null;
  order_MIN_LTE?: number | null;
  order_SUM_EQUAL?: number | null;
  order_SUM_GT?: number | null;
  order_SUM_GTE?: number | null;
  order_SUM_LT?: number | null;
  order_SUM_LTE?: number | null;
}

export interface BaseAgreementDataContainersAggregateInput {
  AND?: BaseAgreementDataContainersAggregateInput[] | null;
  OR?: BaseAgreementDataContainersAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: BaseAgreementDataContainersNodeAggregationWhereInput | null;
}

export interface BaseAgreementDataContainersConnectionWhere {
  AND?: BaseAgreementDataContainersConnectionWhere[] | null;
  OR?: BaseAgreementDataContainersConnectionWhere[] | null;
  node?: DataContainerWhere | null;
  node_NOT?: DataContainerWhere | null;
}

export interface BaseAgreementDataContainersNodeAggregationWhereInput {
  AND?: BaseAgreementDataContainersNodeAggregationWhereInput[] | null;
  OR?: BaseAgreementDataContainersNodeAggregationWhereInput[] | null;
  subType_AVERAGE_EQUAL?: number | null;
  subType_AVERAGE_GT?: number | null;
  subType_AVERAGE_GTE?: number | null;
  subType_AVERAGE_LT?: number | null;
  subType_AVERAGE_LTE?: number | null;
  subType_EQUAL?: string | null;
  subType_GT?: number | null;
  subType_GTE?: number | null;
  subType_LONGEST_EQUAL?: number | null;
  subType_LONGEST_GT?: number | null;
  subType_LONGEST_GTE?: number | null;
  subType_LONGEST_LT?: number | null;
  subType_LONGEST_LTE?: number | null;
  subType_LT?: number | null;
  subType_LTE?: number | null;
  subType_SHORTEST_EQUAL?: number | null;
  subType_SHORTEST_GT?: number | null;
  subType_SHORTEST_GTE?: number | null;
  subType_SHORTEST_LT?: number | null;
  subType_SHORTEST_LTE?: number | null;
  timeframeEnd_AVERAGE_EQUAL?: number | null;
  timeframeEnd_AVERAGE_GT?: number | null;
  timeframeEnd_AVERAGE_GTE?: number | null;
  timeframeEnd_AVERAGE_LT?: number | null;
  timeframeEnd_AVERAGE_LTE?: number | null;
  timeframeEnd_EQUAL?: number | null;
  timeframeEnd_GT?: number | null;
  timeframeEnd_GTE?: number | null;
  timeframeEnd_LT?: number | null;
  timeframeEnd_LTE?: number | null;
  timeframeEnd_MAX_EQUAL?: number | null;
  timeframeEnd_MAX_GT?: number | null;
  timeframeEnd_MAX_GTE?: number | null;
  timeframeEnd_MAX_LT?: number | null;
  timeframeEnd_MAX_LTE?: number | null;
  timeframeEnd_MIN_EQUAL?: number | null;
  timeframeEnd_MIN_GT?: number | null;
  timeframeEnd_MIN_GTE?: number | null;
  timeframeEnd_MIN_LT?: number | null;
  timeframeEnd_MIN_LTE?: number | null;
  timeframeEnd_SUM_EQUAL?: number | null;
  timeframeEnd_SUM_GT?: number | null;
  timeframeEnd_SUM_GTE?: number | null;
  timeframeEnd_SUM_LT?: number | null;
  timeframeEnd_SUM_LTE?: number | null;
  timeframeStart_AVERAGE_EQUAL?: number | null;
  timeframeStart_AVERAGE_GT?: number | null;
  timeframeStart_AVERAGE_GTE?: number | null;
  timeframeStart_AVERAGE_LT?: number | null;
  timeframeStart_AVERAGE_LTE?: number | null;
  timeframeStart_EQUAL?: number | null;
  timeframeStart_GT?: number | null;
  timeframeStart_GTE?: number | null;
  timeframeStart_LT?: number | null;
  timeframeStart_LTE?: number | null;
  timeframeStart_MAX_EQUAL?: number | null;
  timeframeStart_MAX_GT?: number | null;
  timeframeStart_MAX_GTE?: number | null;
  timeframeStart_MAX_LT?: number | null;
  timeframeStart_MAX_LTE?: number | null;
  timeframeStart_MIN_EQUAL?: number | null;
  timeframeStart_MIN_GT?: number | null;
  timeframeStart_MIN_GTE?: number | null;
  timeframeStart_MIN_LT?: number | null;
  timeframeStart_MIN_LTE?: number | null;
  timeframeStart_SUM_EQUAL?: number | null;
  timeframeStart_SUM_GT?: number | null;
  timeframeStart_SUM_GTE?: number | null;
  timeframeStart_SUM_LT?: number | null;
  timeframeStart_SUM_LTE?: number | null;
}

export interface BaseAgreementDataSourceAggregateInput {
  AND?: BaseAgreementDataSourceAggregateInput[] | null;
  OR?: BaseAgreementDataSourceAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: BaseAgreementDataSourceNodeAggregationWhereInput | null;
}

export interface BaseAgreementDataSourceConnectionWhere {
  AND?: BaseAgreementDataSourceConnectionWhere[] | null;
  OR?: BaseAgreementDataSourceConnectionWhere[] | null;
  node?: DataSourceWhere | null;
  node_NOT?: DataSourceWhere | null;
}

export interface BaseAgreementDataSourceNodeAggregationWhereInput {
  AND?: BaseAgreementDataSourceNodeAggregationWhereInput[] | null;
  OR?: BaseAgreementDataSourceNodeAggregationWhereInput[] | null;
  id_EQUAL?: string | null;
  name_AVERAGE_EQUAL?: number | null;
  name_AVERAGE_GT?: number | null;
  name_AVERAGE_GTE?: number | null;
  name_AVERAGE_LT?: number | null;
  name_AVERAGE_LTE?: number | null;
  name_EQUAL?: string | null;
  name_GT?: number | null;
  name_GTE?: number | null;
  name_LONGEST_EQUAL?: number | null;
  name_LONGEST_GT?: number | null;
  name_LONGEST_GTE?: number | null;
  name_LONGEST_LT?: number | null;
  name_LONGEST_LTE?: number | null;
  name_LT?: number | null;
  name_LTE?: number | null;
  name_SHORTEST_EQUAL?: number | null;
  name_SHORTEST_GT?: number | null;
  name_SHORTEST_GTE?: number | null;
  name_SHORTEST_LT?: number | null;
  name_SHORTEST_LTE?: number | null;
}

export interface BaseAgreementDecisionsAggregateInput {
  AND?: BaseAgreementDecisionsAggregateInput[] | null;
  OR?: BaseAgreementDecisionsAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: BaseAgreementDecisionsNodeAggregationWhereInput | null;
}

export interface BaseAgreementDecisionsConnectionWhere {
  AND?: BaseAgreementDecisionsConnectionWhere[] | null;
  OR?: BaseAgreementDecisionsConnectionWhere[] | null;
  node?: AgreementDecisionWhere | null;
  node_NOT?: AgreementDecisionWhere | null;
}

export interface BaseAgreementDecisionsNodeAggregationWhereInput {
  AND?: BaseAgreementDecisionsNodeAggregationWhereInput[] | null;
  OR?: BaseAgreementDecisionsNodeAggregationWhereInput[] | null;
  createdOn_EQUAL?: any | null;
  createdOn_GT?: any | null;
  createdOn_GTE?: any | null;
  createdOn_LT?: any | null;
  createdOn_LTE?: any | null;
  createdOn_MAX_EQUAL?: any | null;
  createdOn_MAX_GT?: any | null;
  createdOn_MAX_GTE?: any | null;
  createdOn_MAX_LT?: any | null;
  createdOn_MAX_LTE?: any | null;
  createdOn_MIN_EQUAL?: any | null;
  createdOn_MIN_GT?: any | null;
  createdOn_MIN_GTE?: any | null;
  createdOn_MIN_LT?: any | null;
  createdOn_MIN_LTE?: any | null;
}

export interface BaseAgreementDeviceAlternativeSetsAggregateInput {
  AND?: BaseAgreementDeviceAlternativeSetsAggregateInput[] | null;
  OR?: BaseAgreementDeviceAlternativeSetsAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: BaseAgreementDeviceAlternativeSetsNodeAggregationWhereInput | null;
}

export interface BaseAgreementDeviceAlternativeSetsConnectionWhere {
  AND?: BaseAgreementDeviceAlternativeSetsConnectionWhere[] | null;
  OR?: BaseAgreementDeviceAlternativeSetsConnectionWhere[] | null;
  node?: DeviceAlternativeWhere | null;
  node_NOT?: DeviceAlternativeWhere | null;
}

export interface BaseAgreementDeviceAlternativeSetsNodeAggregationWhereInput {
  AND?: BaseAgreementDeviceAlternativeSetsNodeAggregationWhereInput[] | null;
  OR?: BaseAgreementDeviceAlternativeSetsNodeAggregationWhereInput[] | null;
  code_AVERAGE_EQUAL?: number | null;
  code_AVERAGE_GT?: number | null;
  code_AVERAGE_GTE?: number | null;
  code_AVERAGE_LT?: number | null;
  code_AVERAGE_LTE?: number | null;
  code_EQUAL?: string | null;
  code_GT?: number | null;
  code_GTE?: number | null;
  code_LONGEST_EQUAL?: number | null;
  code_LONGEST_GT?: number | null;
  code_LONGEST_GTE?: number | null;
  code_LONGEST_LT?: number | null;
  code_LONGEST_LTE?: number | null;
  code_LT?: number | null;
  code_LTE?: number | null;
  code_SHORTEST_EQUAL?: number | null;
  code_SHORTEST_GT?: number | null;
  code_SHORTEST_GTE?: number | null;
  code_SHORTEST_LT?: number | null;
  code_SHORTEST_LTE?: number | null;
}

export interface BaseAgreementDotChartConfigAggregateInput {
  AND?: BaseAgreementDotChartConfigAggregateInput[] | null;
  OR?: BaseAgreementDotChartConfigAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  edge?: BaseAgreementDotChartConfigEdgeAggregationWhereInput | null;
}

export interface BaseAgreementDotChartConfigConnectionWhere {
  AND?: BaseAgreementDotChartConfigConnectionWhere[] | null;
  OR?: BaseAgreementDotChartConfigConnectionWhere[] | null;
  edge?: ChartRangeConfigurationRelationshipWhere | null;
  edge_NOT?: ChartRangeConfigurationRelationshipWhere | null;
  node?: ChartRangeConfigurationWhere | null;
  node_NOT?: ChartRangeConfigurationWhere | null;
}

export interface BaseAgreementDotChartConfigEdgeAggregationWhereInput {
  AND?: BaseAgreementDotChartConfigEdgeAggregationWhereInput[] | null;
  OR?: BaseAgreementDotChartConfigEdgeAggregationWhereInput[] | null;
  from_AVERAGE_EQUAL?: number | null;
  from_AVERAGE_GT?: number | null;
  from_AVERAGE_GTE?: number | null;
  from_AVERAGE_LT?: number | null;
  from_AVERAGE_LTE?: number | null;
  from_EQUAL?: number | null;
  from_GT?: number | null;
  from_GTE?: number | null;
  from_LT?: number | null;
  from_LTE?: number | null;
  from_MAX_EQUAL?: number | null;
  from_MAX_GT?: number | null;
  from_MAX_GTE?: number | null;
  from_MAX_LT?: number | null;
  from_MAX_LTE?: number | null;
  from_MIN_EQUAL?: number | null;
  from_MIN_GT?: number | null;
  from_MIN_GTE?: number | null;
  from_MIN_LT?: number | null;
  from_MIN_LTE?: number | null;
  from_SUM_EQUAL?: number | null;
  from_SUM_GT?: number | null;
  from_SUM_GTE?: number | null;
  from_SUM_LT?: number | null;
  from_SUM_LTE?: number | null;
  name_AVERAGE_EQUAL?: number | null;
  name_AVERAGE_GT?: number | null;
  name_AVERAGE_GTE?: number | null;
  name_AVERAGE_LT?: number | null;
  name_AVERAGE_LTE?: number | null;
  name_EQUAL?: string | null;
  name_GT?: number | null;
  name_GTE?: number | null;
  name_LONGEST_EQUAL?: number | null;
  name_LONGEST_GT?: number | null;
  name_LONGEST_GTE?: number | null;
  name_LONGEST_LT?: number | null;
  name_LONGEST_LTE?: number | null;
  name_LT?: number | null;
  name_LTE?: number | null;
  name_SHORTEST_EQUAL?: number | null;
  name_SHORTEST_GT?: number | null;
  name_SHORTEST_GTE?: number | null;
  name_SHORTEST_LT?: number | null;
  name_SHORTEST_LTE?: number | null;
  order_AVERAGE_EQUAL?: number | null;
  order_AVERAGE_GT?: number | null;
  order_AVERAGE_GTE?: number | null;
  order_AVERAGE_LT?: number | null;
  order_AVERAGE_LTE?: number | null;
  order_EQUAL?: number | null;
  order_GT?: number | null;
  order_GTE?: number | null;
  order_LT?: number | null;
  order_LTE?: number | null;
  order_MAX_EQUAL?: number | null;
  order_MAX_GT?: number | null;
  order_MAX_GTE?: number | null;
  order_MAX_LT?: number | null;
  order_MAX_LTE?: number | null;
  order_MIN_EQUAL?: number | null;
  order_MIN_GT?: number | null;
  order_MIN_GTE?: number | null;
  order_MIN_LT?: number | null;
  order_MIN_LTE?: number | null;
  order_SUM_EQUAL?: number | null;
  order_SUM_GT?: number | null;
  order_SUM_GTE?: number | null;
  order_SUM_LT?: number | null;
  order_SUM_LTE?: number | null;
  to_AVERAGE_EQUAL?: number | null;
  to_AVERAGE_GT?: number | null;
  to_AVERAGE_GTE?: number | null;
  to_AVERAGE_LT?: number | null;
  to_AVERAGE_LTE?: number | null;
  to_EQUAL?: number | null;
  to_GT?: number | null;
  to_GTE?: number | null;
  to_LT?: number | null;
  to_LTE?: number | null;
  to_MAX_EQUAL?: number | null;
  to_MAX_GT?: number | null;
  to_MAX_GTE?: number | null;
  to_MAX_LT?: number | null;
  to_MAX_LTE?: number | null;
  to_MIN_EQUAL?: number | null;
  to_MIN_GT?: number | null;
  to_MIN_GTE?: number | null;
  to_MIN_LT?: number | null;
  to_MIN_LTE?: number | null;
  to_SUM_EQUAL?: number | null;
  to_SUM_GT?: number | null;
  to_SUM_GTE?: number | null;
  to_SUM_LT?: number | null;
  to_SUM_LTE?: number | null;
}

export interface BaseAgreementDotThresholdsAggregateInput {
  AND?: BaseAgreementDotThresholdsAggregateInput[] | null;
  OR?: BaseAgreementDotThresholdsAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  edge?: BaseAgreementDotThresholdsEdgeAggregationWhereInput | null;
}

export interface BaseAgreementDotThresholdsConnectionWhere {
  AND?: BaseAgreementDotThresholdsConnectionWhere[] | null;
  OR?: BaseAgreementDotThresholdsConnectionWhere[] | null;
  edge?: ThresholdConfigurationRelationshipWhere | null;
  edge_NOT?: ThresholdConfigurationRelationshipWhere | null;
  node?: ChartRangeConfigurationWhere | null;
  node_NOT?: ChartRangeConfigurationWhere | null;
}

export interface BaseAgreementDotThresholdsEdgeAggregationWhereInput {
  AND?: BaseAgreementDotThresholdsEdgeAggregationWhereInput[] | null;
  OR?: BaseAgreementDotThresholdsEdgeAggregationWhereInput[] | null;
  threshold_AVERAGE_EQUAL?: number | null;
  threshold_AVERAGE_GT?: number | null;
  threshold_AVERAGE_GTE?: number | null;
  threshold_AVERAGE_LT?: number | null;
  threshold_AVERAGE_LTE?: number | null;
  threshold_EQUAL?: number | null;
  threshold_GT?: number | null;
  threshold_GTE?: number | null;
  threshold_LT?: number | null;
  threshold_LTE?: number | null;
  threshold_MAX_EQUAL?: number | null;
  threshold_MAX_GT?: number | null;
  threshold_MAX_GTE?: number | null;
  threshold_MAX_LT?: number | null;
  threshold_MAX_LTE?: number | null;
  threshold_MIN_EQUAL?: number | null;
  threshold_MIN_GT?: number | null;
  threshold_MIN_GTE?: number | null;
  threshold_MIN_LT?: number | null;
  threshold_MIN_LTE?: number | null;
  threshold_SUM_EQUAL?: number | null;
  threshold_SUM_GT?: number | null;
  threshold_SUM_GTE?: number | null;
  threshold_SUM_LT?: number | null;
  threshold_SUM_LTE?: number | null;
}

export interface BaseAgreementEligibilityConditionRelationshipWhere {
  AND?: BaseAgreementEligibilityConditionRelationshipWhere[] | null;
  OR?: BaseAgreementEligibilityConditionRelationshipWhere[] | null;
  cycleAdherence?: CycleAdherence | null;
  cycleAdherence_IN?: (CycleAdherence | null)[] | null;
  cycleAdherence_NOT?: CycleAdherence | null;
  cycleAdherence_NOT_IN?: (CycleAdherence | null)[] | null;
  days?: number | null;
  days_GT?: number | null;
  days_GTE?: number | null;
  days_IN?: (number | null)[] | null;
  days_LT?: number | null;
  days_LTE?: number | null;
  days_NOT?: number | null;
  days_NOT_IN?: (number | null)[] | null;
  minimumPercentage?: number | null;
  minimumPercentage_GT?: number | null;
  minimumPercentage_GTE?: number | null;
  minimumPercentage_IN?: (number | null)[] | null;
  minimumPercentage_LT?: number | null;
  minimumPercentage_LTE?: number | null;
  minimumPercentage_NOT?: number | null;
  minimumPercentage_NOT_IN?: (number | null)[] | null;
  numberOfAdministeredRangeDays?: (number | null)[] | null;
  numberOfAdministeredRangeDays_INCLUDES?: number | null;
  numberOfAdministeredRangeDays_NOT?: (number | null)[] | null;
  numberOfAdministeredRangeDays_NOT_INCLUDES?: number | null;
  numberOfAdministeredTreatments?: number | null;
  numberOfAdministeredTreatmentsOperator?: ArithmeticalOperator | null;
  numberOfAdministeredTreatmentsOperator_IN?: (ArithmeticalOperator | null)[] | null;
  numberOfAdministeredTreatmentsOperator_NOT?: ArithmeticalOperator | null;
  numberOfAdministeredTreatmentsOperator_NOT_IN?: (ArithmeticalOperator | null)[] | null;
  numberOfAdministeredTreatments_GT?: number | null;
  numberOfAdministeredTreatments_GTE?: number | null;
  numberOfAdministeredTreatments_IN?: (number | null)[] | null;
  numberOfAdministeredTreatments_LT?: number | null;
  numberOfAdministeredTreatments_LTE?: number | null;
  numberOfAdministeredTreatments_NOT?: number | null;
  numberOfAdministeredTreatments_NOT_IN?: (number | null)[] | null;
  previousTestNumber?: number | null;
  previousTestNumber_GT?: number | null;
  previousTestNumber_GTE?: number | null;
  previousTestNumber_IN?: (number | null)[] | null;
  previousTestNumber_LT?: number | null;
  previousTestNumber_LTE?: number | null;
  previousTestNumber_NOT?: number | null;
  previousTestNumber_NOT_IN?: (number | null)[] | null;
  referenceAdministrationSequenceNumber?: number | null;
  referenceAdministrationSequenceNumber_GT?: number | null;
  referenceAdministrationSequenceNumber_GTE?: number | null;
  referenceAdministrationSequenceNumber_IN?: (number | null)[] | null;
  referenceAdministrationSequenceNumber_LT?: number | null;
  referenceAdministrationSequenceNumber_LTE?: number | null;
  referenceAdministrationSequenceNumber_NOT?: number | null;
  referenceAdministrationSequenceNumber_NOT_IN?: (number | null)[] | null;
  referenceTestRangeDays?: (number | null)[] | null;
  referenceTestRangeDays_INCLUDES?: number | null;
  referenceTestRangeDays_NOT?: (number | null)[] | null;
  referenceTestRangeDays_NOT_INCLUDES?: number | null;
  treatments?: (string | null)[] | null;
  treatments_INCLUDES?: string | null;
  treatments_NOT?: (string | null)[] | null;
  treatments_NOT_INCLUDES?: string | null;
  value?: number | null;
  value_GT?: number | null;
  value_GTE?: number | null;
  value_IN?: (number | null)[] | null;
  value_LT?: number | null;
  value_LTE?: number | null;
  value_NOT?: number | null;
  value_NOT_IN?: (number | null)[] | null;
}

export interface BaseAgreementEligibilityConditionSetsAggregateInput {
  AND?: BaseAgreementEligibilityConditionSetsAggregateInput[] | null;
  OR?: BaseAgreementEligibilityConditionSetsAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  edge?: BaseAgreementEligibilityConditionSetsEdgeAggregationWhereInput | null;
  node?: BaseAgreementEligibilityConditionSetsNodeAggregationWhereInput | null;
}

export interface BaseAgreementEligibilityConditionSetsConnectionWhere {
  AND?: BaseAgreementEligibilityConditionSetsConnectionWhere[] | null;
  OR?: BaseAgreementEligibilityConditionSetsConnectionWhere[] | null;
  edge?: BaseAgreementEligibilityConditionRelationshipWhere | null;
  edge_NOT?: BaseAgreementEligibilityConditionRelationshipWhere | null;
  node?: EligibilityConditionSetWhere | null;
  node_NOT?: EligibilityConditionSetWhere | null;
}

export interface BaseAgreementEligibilityConditionSetsEdgeAggregationWhereInput {
  AND?: BaseAgreementEligibilityConditionSetsEdgeAggregationWhereInput[] | null;
  OR?: BaseAgreementEligibilityConditionSetsEdgeAggregationWhereInput[] | null;
  days_AVERAGE_EQUAL?: number | null;
  days_AVERAGE_GT?: number | null;
  days_AVERAGE_GTE?: number | null;
  days_AVERAGE_LT?: number | null;
  days_AVERAGE_LTE?: number | null;
  days_EQUAL?: number | null;
  days_GT?: number | null;
  days_GTE?: number | null;
  days_LT?: number | null;
  days_LTE?: number | null;
  days_MAX_EQUAL?: number | null;
  days_MAX_GT?: number | null;
  days_MAX_GTE?: number | null;
  days_MAX_LT?: number | null;
  days_MAX_LTE?: number | null;
  days_MIN_EQUAL?: number | null;
  days_MIN_GT?: number | null;
  days_MIN_GTE?: number | null;
  days_MIN_LT?: number | null;
  days_MIN_LTE?: number | null;
  days_SUM_EQUAL?: number | null;
  days_SUM_GT?: number | null;
  days_SUM_GTE?: number | null;
  days_SUM_LT?: number | null;
  days_SUM_LTE?: number | null;
  minimumPercentage_AVERAGE_EQUAL?: number | null;
  minimumPercentage_AVERAGE_GT?: number | null;
  minimumPercentage_AVERAGE_GTE?: number | null;
  minimumPercentage_AVERAGE_LT?: number | null;
  minimumPercentage_AVERAGE_LTE?: number | null;
  minimumPercentage_EQUAL?: number | null;
  minimumPercentage_GT?: number | null;
  minimumPercentage_GTE?: number | null;
  minimumPercentage_LT?: number | null;
  minimumPercentage_LTE?: number | null;
  minimumPercentage_MAX_EQUAL?: number | null;
  minimumPercentage_MAX_GT?: number | null;
  minimumPercentage_MAX_GTE?: number | null;
  minimumPercentage_MAX_LT?: number | null;
  minimumPercentage_MAX_LTE?: number | null;
  minimumPercentage_MIN_EQUAL?: number | null;
  minimumPercentage_MIN_GT?: number | null;
  minimumPercentage_MIN_GTE?: number | null;
  minimumPercentage_MIN_LT?: number | null;
  minimumPercentage_MIN_LTE?: number | null;
  minimumPercentage_SUM_EQUAL?: number | null;
  minimumPercentage_SUM_GT?: number | null;
  minimumPercentage_SUM_GTE?: number | null;
  minimumPercentage_SUM_LT?: number | null;
  minimumPercentage_SUM_LTE?: number | null;
  numberOfAdministeredTreatments_AVERAGE_EQUAL?: number | null;
  numberOfAdministeredTreatments_AVERAGE_GT?: number | null;
  numberOfAdministeredTreatments_AVERAGE_GTE?: number | null;
  numberOfAdministeredTreatments_AVERAGE_LT?: number | null;
  numberOfAdministeredTreatments_AVERAGE_LTE?: number | null;
  numberOfAdministeredTreatments_EQUAL?: number | null;
  numberOfAdministeredTreatments_GT?: number | null;
  numberOfAdministeredTreatments_GTE?: number | null;
  numberOfAdministeredTreatments_LT?: number | null;
  numberOfAdministeredTreatments_LTE?: number | null;
  numberOfAdministeredTreatments_MAX_EQUAL?: number | null;
  numberOfAdministeredTreatments_MAX_GT?: number | null;
  numberOfAdministeredTreatments_MAX_GTE?: number | null;
  numberOfAdministeredTreatments_MAX_LT?: number | null;
  numberOfAdministeredTreatments_MAX_LTE?: number | null;
  numberOfAdministeredTreatments_MIN_EQUAL?: number | null;
  numberOfAdministeredTreatments_MIN_GT?: number | null;
  numberOfAdministeredTreatments_MIN_GTE?: number | null;
  numberOfAdministeredTreatments_MIN_LT?: number | null;
  numberOfAdministeredTreatments_MIN_LTE?: number | null;
  numberOfAdministeredTreatments_SUM_EQUAL?: number | null;
  numberOfAdministeredTreatments_SUM_GT?: number | null;
  numberOfAdministeredTreatments_SUM_GTE?: number | null;
  numberOfAdministeredTreatments_SUM_LT?: number | null;
  numberOfAdministeredTreatments_SUM_LTE?: number | null;
  previousTestNumber_AVERAGE_EQUAL?: number | null;
  previousTestNumber_AVERAGE_GT?: number | null;
  previousTestNumber_AVERAGE_GTE?: number | null;
  previousTestNumber_AVERAGE_LT?: number | null;
  previousTestNumber_AVERAGE_LTE?: number | null;
  previousTestNumber_EQUAL?: number | null;
  previousTestNumber_GT?: number | null;
  previousTestNumber_GTE?: number | null;
  previousTestNumber_LT?: number | null;
  previousTestNumber_LTE?: number | null;
  previousTestNumber_MAX_EQUAL?: number | null;
  previousTestNumber_MAX_GT?: number | null;
  previousTestNumber_MAX_GTE?: number | null;
  previousTestNumber_MAX_LT?: number | null;
  previousTestNumber_MAX_LTE?: number | null;
  previousTestNumber_MIN_EQUAL?: number | null;
  previousTestNumber_MIN_GT?: number | null;
  previousTestNumber_MIN_GTE?: number | null;
  previousTestNumber_MIN_LT?: number | null;
  previousTestNumber_MIN_LTE?: number | null;
  previousTestNumber_SUM_EQUAL?: number | null;
  previousTestNumber_SUM_GT?: number | null;
  previousTestNumber_SUM_GTE?: number | null;
  previousTestNumber_SUM_LT?: number | null;
  previousTestNumber_SUM_LTE?: number | null;
  referenceAdministrationSequenceNumber_AVERAGE_EQUAL?: number | null;
  referenceAdministrationSequenceNumber_AVERAGE_GT?: number | null;
  referenceAdministrationSequenceNumber_AVERAGE_GTE?: number | null;
  referenceAdministrationSequenceNumber_AVERAGE_LT?: number | null;
  referenceAdministrationSequenceNumber_AVERAGE_LTE?: number | null;
  referenceAdministrationSequenceNumber_EQUAL?: number | null;
  referenceAdministrationSequenceNumber_GT?: number | null;
  referenceAdministrationSequenceNumber_GTE?: number | null;
  referenceAdministrationSequenceNumber_LT?: number | null;
  referenceAdministrationSequenceNumber_LTE?: number | null;
  referenceAdministrationSequenceNumber_MAX_EQUAL?: number | null;
  referenceAdministrationSequenceNumber_MAX_GT?: number | null;
  referenceAdministrationSequenceNumber_MAX_GTE?: number | null;
  referenceAdministrationSequenceNumber_MAX_LT?: number | null;
  referenceAdministrationSequenceNumber_MAX_LTE?: number | null;
  referenceAdministrationSequenceNumber_MIN_EQUAL?: number | null;
  referenceAdministrationSequenceNumber_MIN_GT?: number | null;
  referenceAdministrationSequenceNumber_MIN_GTE?: number | null;
  referenceAdministrationSequenceNumber_MIN_LT?: number | null;
  referenceAdministrationSequenceNumber_MIN_LTE?: number | null;
  referenceAdministrationSequenceNumber_SUM_EQUAL?: number | null;
  referenceAdministrationSequenceNumber_SUM_GT?: number | null;
  referenceAdministrationSequenceNumber_SUM_GTE?: number | null;
  referenceAdministrationSequenceNumber_SUM_LT?: number | null;
  referenceAdministrationSequenceNumber_SUM_LTE?: number | null;
  value_AVERAGE_EQUAL?: number | null;
  value_AVERAGE_GT?: number | null;
  value_AVERAGE_GTE?: number | null;
  value_AVERAGE_LT?: number | null;
  value_AVERAGE_LTE?: number | null;
  value_EQUAL?: number | null;
  value_GT?: number | null;
  value_GTE?: number | null;
  value_LT?: number | null;
  value_LTE?: number | null;
  value_MAX_EQUAL?: number | null;
  value_MAX_GT?: number | null;
  value_MAX_GTE?: number | null;
  value_MAX_LT?: number | null;
  value_MAX_LTE?: number | null;
  value_MIN_EQUAL?: number | null;
  value_MIN_GT?: number | null;
  value_MIN_GTE?: number | null;
  value_MIN_LT?: number | null;
  value_MIN_LTE?: number | null;
  value_SUM_EQUAL?: number | null;
  value_SUM_GT?: number | null;
  value_SUM_GTE?: number | null;
  value_SUM_LT?: number | null;
  value_SUM_LTE?: number | null;
}

export interface BaseAgreementEligibilityConditionSetsNodeAggregationWhereInput {
  AND?: BaseAgreementEligibilityConditionSetsNodeAggregationWhereInput[] | null;
  OR?: BaseAgreementEligibilityConditionSetsNodeAggregationWhereInput[] | null;
  code_AVERAGE_EQUAL?: number | null;
  code_AVERAGE_GT?: number | null;
  code_AVERAGE_GTE?: number | null;
  code_AVERAGE_LT?: number | null;
  code_AVERAGE_LTE?: number | null;
  code_EQUAL?: string | null;
  code_GT?: number | null;
  code_GTE?: number | null;
  code_LONGEST_EQUAL?: number | null;
  code_LONGEST_GT?: number | null;
  code_LONGEST_GTE?: number | null;
  code_LONGEST_LT?: number | null;
  code_LONGEST_LTE?: number | null;
  code_LT?: number | null;
  code_LTE?: number | null;
  code_SHORTEST_EQUAL?: number | null;
  code_SHORTEST_GT?: number | null;
  code_SHORTEST_GTE?: number | null;
  code_SHORTEST_LT?: number | null;
  code_SHORTEST_LTE?: number | null;
  inputLabel_AVERAGE_EQUAL?: number | null;
  inputLabel_AVERAGE_GT?: number | null;
  inputLabel_AVERAGE_GTE?: number | null;
  inputLabel_AVERAGE_LT?: number | null;
  inputLabel_AVERAGE_LTE?: number | null;
  inputLabel_EQUAL?: string | null;
  inputLabel_GT?: number | null;
  inputLabel_GTE?: number | null;
  inputLabel_LONGEST_EQUAL?: number | null;
  inputLabel_LONGEST_GT?: number | null;
  inputLabel_LONGEST_GTE?: number | null;
  inputLabel_LONGEST_LT?: number | null;
  inputLabel_LONGEST_LTE?: number | null;
  inputLabel_LT?: number | null;
  inputLabel_LTE?: number | null;
  inputLabel_SHORTEST_EQUAL?: number | null;
  inputLabel_SHORTEST_GT?: number | null;
  inputLabel_SHORTEST_GTE?: number | null;
  inputLabel_SHORTEST_LT?: number | null;
  inputLabel_SHORTEST_LTE?: number | null;
  name_AVERAGE_EQUAL?: number | null;
  name_AVERAGE_GT?: number | null;
  name_AVERAGE_GTE?: number | null;
  name_AVERAGE_LT?: number | null;
  name_AVERAGE_LTE?: number | null;
  name_EQUAL?: string | null;
  name_GT?: number | null;
  name_GTE?: number | null;
  name_LONGEST_EQUAL?: number | null;
  name_LONGEST_GT?: number | null;
  name_LONGEST_GTE?: number | null;
  name_LONGEST_LT?: number | null;
  name_LONGEST_LTE?: number | null;
  name_LT?: number | null;
  name_LTE?: number | null;
  name_SHORTEST_EQUAL?: number | null;
  name_SHORTEST_GT?: number | null;
  name_SHORTEST_GTE?: number | null;
  name_SHORTEST_LT?: number | null;
  name_SHORTEST_LTE?: number | null;
}

export interface BaseAgreementEnrollingConditionSetsAggregateInput {
  AND?: BaseAgreementEnrollingConditionSetsAggregateInput[] | null;
  OR?: BaseAgreementEnrollingConditionSetsAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: BaseAgreementEnrollingConditionSetsNodeAggregationWhereInput | null;
}

export interface BaseAgreementEnrollingConditionSetsConnectionWhere {
  AND?: BaseAgreementEnrollingConditionSetsConnectionWhere[] | null;
  OR?: BaseAgreementEnrollingConditionSetsConnectionWhere[] | null;
  node?: EnrollingConditionSetWhere | null;
  node_NOT?: EnrollingConditionSetWhere | null;
}

export interface BaseAgreementEnrollingConditionSetsNodeAggregationWhereInput {
  AND?: BaseAgreementEnrollingConditionSetsNodeAggregationWhereInput[] | null;
  OR?: BaseAgreementEnrollingConditionSetsNodeAggregationWhereInput[] | null;
  order_AVERAGE_EQUAL?: number | null;
  order_AVERAGE_GT?: number | null;
  order_AVERAGE_GTE?: number | null;
  order_AVERAGE_LT?: number | null;
  order_AVERAGE_LTE?: number | null;
  order_EQUAL?: number | null;
  order_GT?: number | null;
  order_GTE?: number | null;
  order_LT?: number | null;
  order_LTE?: number | null;
  order_MAX_EQUAL?: number | null;
  order_MAX_GT?: number | null;
  order_MAX_GTE?: number | null;
  order_MAX_LT?: number | null;
  order_MAX_LTE?: number | null;
  order_MIN_EQUAL?: number | null;
  order_MIN_GT?: number | null;
  order_MIN_GTE?: number | null;
  order_MIN_LT?: number | null;
  order_MIN_LTE?: number | null;
  order_SUM_EQUAL?: number | null;
  order_SUM_GT?: number | null;
  order_SUM_GTE?: number | null;
  order_SUM_LT?: number | null;
  order_SUM_LTE?: number | null;
}

export interface BaseAgreementEnrollingPeriodsAggregateInput {
  AND?: BaseAgreementEnrollingPeriodsAggregateInput[] | null;
  OR?: BaseAgreementEnrollingPeriodsAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
}

export interface BaseAgreementEnrollingPeriodsConnectionWhere {
  AND?: BaseAgreementEnrollingPeriodsConnectionWhere[] | null;
  OR?: BaseAgreementEnrollingPeriodsConnectionWhere[] | null;
  node?: EnrollingPeriodWhere | null;
  node_NOT?: EnrollingPeriodWhere | null;
}

export interface BaseAgreementFinancialSummaryConfigAggregateInput {
  AND?: BaseAgreementFinancialSummaryConfigAggregateInput[] | null;
  OR?: BaseAgreementFinancialSummaryConfigAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  edge?: BaseAgreementFinancialSummaryConfigEdgeAggregationWhereInput | null;
  node?: BaseAgreementFinancialSummaryConfigNodeAggregationWhereInput | null;
}

export interface BaseAgreementFinancialSummaryConfigConnectionWhere {
  AND?: BaseAgreementFinancialSummaryConfigConnectionWhere[] | null;
  OR?: BaseAgreementFinancialSummaryConfigConnectionWhere[] | null;
  edge?: AgreementFinancialSummaryColumnRelationshipWhere | null;
  edge_NOT?: AgreementFinancialSummaryColumnRelationshipWhere | null;
  node?: FinancialSummaryColumnWhere | null;
  node_NOT?: FinancialSummaryColumnWhere | null;
}

export interface BaseAgreementFinancialSummaryConfigEdgeAggregationWhereInput {
  AND?: BaseAgreementFinancialSummaryConfigEdgeAggregationWhereInput[] | null;
  OR?: BaseAgreementFinancialSummaryConfigEdgeAggregationWhereInput[] | null;
  localizationKey_AVERAGE_EQUAL?: number | null;
  localizationKey_AVERAGE_GT?: number | null;
  localizationKey_AVERAGE_GTE?: number | null;
  localizationKey_AVERAGE_LT?: number | null;
  localizationKey_AVERAGE_LTE?: number | null;
  localizationKey_EQUAL?: string | null;
  localizationKey_GT?: number | null;
  localizationKey_GTE?: number | null;
  localizationKey_LONGEST_EQUAL?: number | null;
  localizationKey_LONGEST_GT?: number | null;
  localizationKey_LONGEST_GTE?: number | null;
  localizationKey_LONGEST_LT?: number | null;
  localizationKey_LONGEST_LTE?: number | null;
  localizationKey_LT?: number | null;
  localizationKey_LTE?: number | null;
  localizationKey_SHORTEST_EQUAL?: number | null;
  localizationKey_SHORTEST_GT?: number | null;
  localizationKey_SHORTEST_GTE?: number | null;
  localizationKey_SHORTEST_LT?: number | null;
  localizationKey_SHORTEST_LTE?: number | null;
  position_AVERAGE_EQUAL?: number | null;
  position_AVERAGE_GT?: number | null;
  position_AVERAGE_GTE?: number | null;
  position_AVERAGE_LT?: number | null;
  position_AVERAGE_LTE?: number | null;
  position_EQUAL?: number | null;
  position_GT?: number | null;
  position_GTE?: number | null;
  position_LT?: number | null;
  position_LTE?: number | null;
  position_MAX_EQUAL?: number | null;
  position_MAX_GT?: number | null;
  position_MAX_GTE?: number | null;
  position_MAX_LT?: number | null;
  position_MAX_LTE?: number | null;
  position_MIN_EQUAL?: number | null;
  position_MIN_GT?: number | null;
  position_MIN_GTE?: number | null;
  position_MIN_LT?: number | null;
  position_MIN_LTE?: number | null;
  position_SUM_EQUAL?: number | null;
  position_SUM_GT?: number | null;
  position_SUM_GTE?: number | null;
  position_SUM_LT?: number | null;
  position_SUM_LTE?: number | null;
}

export interface BaseAgreementFinancialSummaryConfigNodeAggregationWhereInput {
  AND?: BaseAgreementFinancialSummaryConfigNodeAggregationWhereInput[] | null;
  OR?: BaseAgreementFinancialSummaryConfigNodeAggregationWhereInput[] | null;
  id_EQUAL?: string | null;
}

export interface BaseAgreementInitialVersionAggregateInput {
  AND?: BaseAgreementInitialVersionAggregateInput[] | null;
  OR?: BaseAgreementInitialVersionAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: BaseAgreementInitialVersionNodeAggregationWhereInput | null;
}

export interface BaseAgreementInitialVersionConnectionWhere {
  AND?: BaseAgreementInitialVersionConnectionWhere[] | null;
  OR?: BaseAgreementInitialVersionConnectionWhere[] | null;
  node?: BaseAgreementWhere | null;
  node_NOT?: BaseAgreementWhere | null;
}

export interface BaseAgreementInitialVersionNodeAggregationWhereInput {
  AND?: BaseAgreementInitialVersionNodeAggregationWhereInput[] | null;
  OR?: BaseAgreementInitialVersionNodeAggregationWhereInput[] | null;
  caseSuspensionIntervalDays_AVERAGE_EQUAL?: number | null;
  caseSuspensionIntervalDays_AVERAGE_GT?: number | null;
  caseSuspensionIntervalDays_AVERAGE_GTE?: number | null;
  caseSuspensionIntervalDays_AVERAGE_LT?: number | null;
  caseSuspensionIntervalDays_AVERAGE_LTE?: number | null;
  caseSuspensionIntervalDays_EQUAL?: number | null;
  caseSuspensionIntervalDays_GT?: number | null;
  caseSuspensionIntervalDays_GTE?: number | null;
  caseSuspensionIntervalDays_LT?: number | null;
  caseSuspensionIntervalDays_LTE?: number | null;
  caseSuspensionIntervalDays_MAX_EQUAL?: number | null;
  caseSuspensionIntervalDays_MAX_GT?: number | null;
  caseSuspensionIntervalDays_MAX_GTE?: number | null;
  caseSuspensionIntervalDays_MAX_LT?: number | null;
  caseSuspensionIntervalDays_MAX_LTE?: number | null;
  caseSuspensionIntervalDays_MIN_EQUAL?: number | null;
  caseSuspensionIntervalDays_MIN_GT?: number | null;
  caseSuspensionIntervalDays_MIN_GTE?: number | null;
  caseSuspensionIntervalDays_MIN_LT?: number | null;
  caseSuspensionIntervalDays_MIN_LTE?: number | null;
  caseSuspensionIntervalDays_SUM_EQUAL?: number | null;
  caseSuspensionIntervalDays_SUM_GT?: number | null;
  caseSuspensionIntervalDays_SUM_GTE?: number | null;
  caseSuspensionIntervalDays_SUM_LT?: number | null;
  caseSuspensionIntervalDays_SUM_LTE?: number | null;
  coveringFormWaitInterval_AVERAGE_EQUAL?: number | null;
  coveringFormWaitInterval_AVERAGE_GT?: number | null;
  coveringFormWaitInterval_AVERAGE_GTE?: number | null;
  coveringFormWaitInterval_AVERAGE_LT?: number | null;
  coveringFormWaitInterval_AVERAGE_LTE?: number | null;
  coveringFormWaitInterval_EQUAL?: number | null;
  coveringFormWaitInterval_GT?: number | null;
  coveringFormWaitInterval_GTE?: number | null;
  coveringFormWaitInterval_LT?: number | null;
  coveringFormWaitInterval_LTE?: number | null;
  coveringFormWaitInterval_MAX_EQUAL?: number | null;
  coveringFormWaitInterval_MAX_GT?: number | null;
  coveringFormWaitInterval_MAX_GTE?: number | null;
  coveringFormWaitInterval_MAX_LT?: number | null;
  coveringFormWaitInterval_MAX_LTE?: number | null;
  coveringFormWaitInterval_MIN_EQUAL?: number | null;
  coveringFormWaitInterval_MIN_GT?: number | null;
  coveringFormWaitInterval_MIN_GTE?: number | null;
  coveringFormWaitInterval_MIN_LT?: number | null;
  coveringFormWaitInterval_MIN_LTE?: number | null;
  coveringFormWaitInterval_SUM_EQUAL?: number | null;
  coveringFormWaitInterval_SUM_GT?: number | null;
  coveringFormWaitInterval_SUM_GTE?: number | null;
  coveringFormWaitInterval_SUM_LT?: number | null;
  coveringFormWaitInterval_SUM_LTE?: number | null;
  createdOn_EQUAL?: any | null;
  createdOn_GT?: any | null;
  createdOn_GTE?: any | null;
  createdOn_LT?: any | null;
  createdOn_LTE?: any | null;
  createdOn_MAX_EQUAL?: any | null;
  createdOn_MAX_GT?: any | null;
  createdOn_MAX_GTE?: any | null;
  createdOn_MAX_LT?: any | null;
  createdOn_MAX_LTE?: any | null;
  createdOn_MIN_EQUAL?: any | null;
  createdOn_MIN_GT?: any | null;
  createdOn_MIN_GTE?: any | null;
  createdOn_MIN_LT?: any | null;
  createdOn_MIN_LTE?: any | null;
  defaultPriceRate_AVERAGE_EQUAL?: number | null;
  defaultPriceRate_AVERAGE_GT?: number | null;
  defaultPriceRate_AVERAGE_GTE?: number | null;
  defaultPriceRate_AVERAGE_LT?: number | null;
  defaultPriceRate_AVERAGE_LTE?: number | null;
  defaultPriceRate_EQUAL?: number | null;
  defaultPriceRate_GT?: number | null;
  defaultPriceRate_GTE?: number | null;
  defaultPriceRate_LT?: number | null;
  defaultPriceRate_LTE?: number | null;
  defaultPriceRate_MAX_EQUAL?: number | null;
  defaultPriceRate_MAX_GT?: number | null;
  defaultPriceRate_MAX_GTE?: number | null;
  defaultPriceRate_MAX_LT?: number | null;
  defaultPriceRate_MAX_LTE?: number | null;
  defaultPriceRate_MIN_EQUAL?: number | null;
  defaultPriceRate_MIN_GT?: number | null;
  defaultPriceRate_MIN_GTE?: number | null;
  defaultPriceRate_MIN_LT?: number | null;
  defaultPriceRate_MIN_LTE?: number | null;
  defaultPriceRate_SUM_EQUAL?: number | null;
  defaultPriceRate_SUM_GT?: number | null;
  defaultPriceRate_SUM_GTE?: number | null;
  defaultPriceRate_SUM_LT?: number | null;
  defaultPriceRate_SUM_LTE?: number | null;
  firstExecutionDate_EQUAL?: any | null;
  firstExecutionDate_GT?: any | null;
  firstExecutionDate_GTE?: any | null;
  firstExecutionDate_LT?: any | null;
  firstExecutionDate_LTE?: any | null;
  firstExecutionDate_MAX_EQUAL?: any | null;
  firstExecutionDate_MAX_GT?: any | null;
  firstExecutionDate_MAX_GTE?: any | null;
  firstExecutionDate_MAX_LT?: any | null;
  firstExecutionDate_MAX_LTE?: any | null;
  firstExecutionDate_MIN_EQUAL?: any | null;
  firstExecutionDate_MIN_GT?: any | null;
  firstExecutionDate_MIN_GTE?: any | null;
  firstExecutionDate_MIN_LT?: any | null;
  firstExecutionDate_MIN_LTE?: any | null;
  formattedAmount_AVERAGE_EQUAL?: number | null;
  formattedAmount_AVERAGE_GT?: number | null;
  formattedAmount_AVERAGE_GTE?: number | null;
  formattedAmount_AVERAGE_LT?: number | null;
  formattedAmount_AVERAGE_LTE?: number | null;
  formattedAmount_EQUAL?: string | null;
  formattedAmount_GT?: number | null;
  formattedAmount_GTE?: number | null;
  formattedAmount_LONGEST_EQUAL?: number | null;
  formattedAmount_LONGEST_GT?: number | null;
  formattedAmount_LONGEST_GTE?: number | null;
  formattedAmount_LONGEST_LT?: number | null;
  formattedAmount_LONGEST_LTE?: number | null;
  formattedAmount_LT?: number | null;
  formattedAmount_LTE?: number | null;
  formattedAmount_SHORTEST_EQUAL?: number | null;
  formattedAmount_SHORTEST_GT?: number | null;
  formattedAmount_SHORTEST_GTE?: number | null;
  formattedAmount_SHORTEST_LT?: number | null;
  formattedAmount_SHORTEST_LTE?: number | null;
  formattedCounterparties_AVERAGE_EQUAL?: number | null;
  formattedCounterparties_AVERAGE_GT?: number | null;
  formattedCounterparties_AVERAGE_GTE?: number | null;
  formattedCounterparties_AVERAGE_LT?: number | null;
  formattedCounterparties_AVERAGE_LTE?: number | null;
  formattedCounterparties_EQUAL?: string | null;
  formattedCounterparties_GT?: number | null;
  formattedCounterparties_GTE?: number | null;
  formattedCounterparties_LONGEST_EQUAL?: number | null;
  formattedCounterparties_LONGEST_GT?: number | null;
  formattedCounterparties_LONGEST_GTE?: number | null;
  formattedCounterparties_LONGEST_LT?: number | null;
  formattedCounterparties_LONGEST_LTE?: number | null;
  formattedCounterparties_LT?: number | null;
  formattedCounterparties_LTE?: number | null;
  formattedCounterparties_SHORTEST_EQUAL?: number | null;
  formattedCounterparties_SHORTEST_GT?: number | null;
  formattedCounterparties_SHORTEST_GTE?: number | null;
  formattedCounterparties_SHORTEST_LT?: number | null;
  formattedCounterparties_SHORTEST_LTE?: number | null;
  formattedDiseases_AVERAGE_EQUAL?: number | null;
  formattedDiseases_AVERAGE_GT?: number | null;
  formattedDiseases_AVERAGE_GTE?: number | null;
  formattedDiseases_AVERAGE_LT?: number | null;
  formattedDiseases_AVERAGE_LTE?: number | null;
  formattedDiseases_EQUAL?: string | null;
  formattedDiseases_GT?: number | null;
  formattedDiseases_GTE?: number | null;
  formattedDiseases_LONGEST_EQUAL?: number | null;
  formattedDiseases_LONGEST_GT?: number | null;
  formattedDiseases_LONGEST_GTE?: number | null;
  formattedDiseases_LONGEST_LT?: number | null;
  formattedDiseases_LONGEST_LTE?: number | null;
  formattedDiseases_LT?: number | null;
  formattedDiseases_LTE?: number | null;
  formattedDiseases_SHORTEST_EQUAL?: number | null;
  formattedDiseases_SHORTEST_GT?: number | null;
  formattedDiseases_SHORTEST_GTE?: number | null;
  formattedDiseases_SHORTEST_LT?: number | null;
  formattedDiseases_SHORTEST_LTE?: number | null;
  formattedIndications_AVERAGE_EQUAL?: number | null;
  formattedIndications_AVERAGE_GT?: number | null;
  formattedIndications_AVERAGE_GTE?: number | null;
  formattedIndications_AVERAGE_LT?: number | null;
  formattedIndications_AVERAGE_LTE?: number | null;
  formattedIndications_EQUAL?: string | null;
  formattedIndications_GT?: number | null;
  formattedIndications_GTE?: number | null;
  formattedIndications_LONGEST_EQUAL?: number | null;
  formattedIndications_LONGEST_GT?: number | null;
  formattedIndications_LONGEST_GTE?: number | null;
  formattedIndications_LONGEST_LT?: number | null;
  formattedIndications_LONGEST_LTE?: number | null;
  formattedIndications_LT?: number | null;
  formattedIndications_LTE?: number | null;
  formattedIndications_SHORTEST_EQUAL?: number | null;
  formattedIndications_SHORTEST_GT?: number | null;
  formattedIndications_SHORTEST_GTE?: number | null;
  formattedIndications_SHORTEST_LT?: number | null;
  formattedIndications_SHORTEST_LTE?: number | null;
  formattedProducts_AVERAGE_EQUAL?: number | null;
  formattedProducts_AVERAGE_GT?: number | null;
  formattedProducts_AVERAGE_GTE?: number | null;
  formattedProducts_AVERAGE_LT?: number | null;
  formattedProducts_AVERAGE_LTE?: number | null;
  formattedProducts_EQUAL?: string | null;
  formattedProducts_GT?: number | null;
  formattedProducts_GTE?: number | null;
  formattedProducts_LONGEST_EQUAL?: number | null;
  formattedProducts_LONGEST_GT?: number | null;
  formattedProducts_LONGEST_GTE?: number | null;
  formattedProducts_LONGEST_LT?: number | null;
  formattedProducts_LONGEST_LTE?: number | null;
  formattedProducts_LT?: number | null;
  formattedProducts_LTE?: number | null;
  formattedProducts_SHORTEST_EQUAL?: number | null;
  formattedProducts_SHORTEST_GT?: number | null;
  formattedProducts_SHORTEST_GTE?: number | null;
  formattedProducts_SHORTEST_LT?: number | null;
  formattedProducts_SHORTEST_LTE?: number | null;
  formattedTags_AVERAGE_EQUAL?: number | null;
  formattedTags_AVERAGE_GT?: number | null;
  formattedTags_AVERAGE_GTE?: number | null;
  formattedTags_AVERAGE_LT?: number | null;
  formattedTags_AVERAGE_LTE?: number | null;
  formattedTags_EQUAL?: string | null;
  formattedTags_GT?: number | null;
  formattedTags_GTE?: number | null;
  formattedTags_LONGEST_EQUAL?: number | null;
  formattedTags_LONGEST_GT?: number | null;
  formattedTags_LONGEST_GTE?: number | null;
  formattedTags_LONGEST_LT?: number | null;
  formattedTags_LONGEST_LTE?: number | null;
  formattedTags_LT?: number | null;
  formattedTags_LTE?: number | null;
  formattedTags_SHORTEST_EQUAL?: number | null;
  formattedTags_SHORTEST_GT?: number | null;
  formattedTags_SHORTEST_GTE?: number | null;
  formattedTags_SHORTEST_LT?: number | null;
  formattedTags_SHORTEST_LTE?: number | null;
  formattedValidityPeriod_AVERAGE_EQUAL?: number | null;
  formattedValidityPeriod_AVERAGE_GT?: number | null;
  formattedValidityPeriod_AVERAGE_GTE?: number | null;
  formattedValidityPeriod_AVERAGE_LT?: number | null;
  formattedValidityPeriod_AVERAGE_LTE?: number | null;
  formattedValidityPeriod_EQUAL?: string | null;
  formattedValidityPeriod_GT?: number | null;
  formattedValidityPeriod_GTE?: number | null;
  formattedValidityPeriod_LONGEST_EQUAL?: number | null;
  formattedValidityPeriod_LONGEST_GT?: number | null;
  formattedValidityPeriod_LONGEST_GTE?: number | null;
  formattedValidityPeriod_LONGEST_LT?: number | null;
  formattedValidityPeriod_LONGEST_LTE?: number | null;
  formattedValidityPeriod_LT?: number | null;
  formattedValidityPeriod_LTE?: number | null;
  formattedValidityPeriod_SHORTEST_EQUAL?: number | null;
  formattedValidityPeriod_SHORTEST_GT?: number | null;
  formattedValidityPeriod_SHORTEST_GTE?: number | null;
  formattedValidityPeriod_SHORTEST_LT?: number | null;
  formattedValidityPeriod_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  initialVersionId_AVERAGE_EQUAL?: number | null;
  initialVersionId_AVERAGE_GT?: number | null;
  initialVersionId_AVERAGE_GTE?: number | null;
  initialVersionId_AVERAGE_LT?: number | null;
  initialVersionId_AVERAGE_LTE?: number | null;
  initialVersionId_EQUAL?: string | null;
  initialVersionId_GT?: number | null;
  initialVersionId_GTE?: number | null;
  initialVersionId_LONGEST_EQUAL?: number | null;
  initialVersionId_LONGEST_GT?: number | null;
  initialVersionId_LONGEST_GTE?: number | null;
  initialVersionId_LONGEST_LT?: number | null;
  initialVersionId_LONGEST_LTE?: number | null;
  initialVersionId_LT?: number | null;
  initialVersionId_LTE?: number | null;
  initialVersionId_SHORTEST_EQUAL?: number | null;
  initialVersionId_SHORTEST_GT?: number | null;
  initialVersionId_SHORTEST_GTE?: number | null;
  initialVersionId_SHORTEST_LT?: number | null;
  initialVersionId_SHORTEST_LTE?: number | null;
  lastExecutionDate_EQUAL?: any | null;
  lastExecutionDate_GT?: any | null;
  lastExecutionDate_GTE?: any | null;
  lastExecutionDate_LT?: any | null;
  lastExecutionDate_LTE?: any | null;
  lastExecutionDate_MAX_EQUAL?: any | null;
  lastExecutionDate_MAX_GT?: any | null;
  lastExecutionDate_MAX_GTE?: any | null;
  lastExecutionDate_MAX_LT?: any | null;
  lastExecutionDate_MAX_LTE?: any | null;
  lastExecutionDate_MIN_EQUAL?: any | null;
  lastExecutionDate_MIN_GT?: any | null;
  lastExecutionDate_MIN_GTE?: any | null;
  lastExecutionDate_MIN_LT?: any | null;
  lastExecutionDate_MIN_LTE?: any | null;
  lastUpdatedOn_AVERAGE_EQUAL?: number | null;
  lastUpdatedOn_AVERAGE_GT?: number | null;
  lastUpdatedOn_AVERAGE_GTE?: number | null;
  lastUpdatedOn_AVERAGE_LT?: number | null;
  lastUpdatedOn_AVERAGE_LTE?: number | null;
  lastUpdatedOn_EQUAL?: number | null;
  lastUpdatedOn_GT?: number | null;
  lastUpdatedOn_GTE?: number | null;
  lastUpdatedOn_LT?: number | null;
  lastUpdatedOn_LTE?: number | null;
  lastUpdatedOn_MAX_EQUAL?: number | null;
  lastUpdatedOn_MAX_GT?: number | null;
  lastUpdatedOn_MAX_GTE?: number | null;
  lastUpdatedOn_MAX_LT?: number | null;
  lastUpdatedOn_MAX_LTE?: number | null;
  lastUpdatedOn_MIN_EQUAL?: number | null;
  lastUpdatedOn_MIN_GT?: number | null;
  lastUpdatedOn_MIN_GTE?: number | null;
  lastUpdatedOn_MIN_LT?: number | null;
  lastUpdatedOn_MIN_LTE?: number | null;
  lastUpdatedOn_SUM_EQUAL?: number | null;
  lastUpdatedOn_SUM_GT?: number | null;
  lastUpdatedOn_SUM_GTE?: number | null;
  lastUpdatedOn_SUM_LT?: number | null;
  lastUpdatedOn_SUM_LTE?: number | null;
  name_AVERAGE_EQUAL?: number | null;
  name_AVERAGE_GT?: number | null;
  name_AVERAGE_GTE?: number | null;
  name_AVERAGE_LT?: number | null;
  name_AVERAGE_LTE?: number | null;
  name_EQUAL?: string | null;
  name_GT?: number | null;
  name_GTE?: number | null;
  name_LONGEST_EQUAL?: number | null;
  name_LONGEST_GT?: number | null;
  name_LONGEST_GTE?: number | null;
  name_LONGEST_LT?: number | null;
  name_LONGEST_LTE?: number | null;
  name_LT?: number | null;
  name_LTE?: number | null;
  name_SHORTEST_EQUAL?: number | null;
  name_SHORTEST_GT?: number | null;
  name_SHORTEST_GTE?: number | null;
  name_SHORTEST_LT?: number | null;
  name_SHORTEST_LTE?: number | null;
  pushedOn_EQUAL?: any | null;
  pushedOn_GT?: any | null;
  pushedOn_GTE?: any | null;
  pushedOn_LT?: any | null;
  pushedOn_LTE?: any | null;
  pushedOn_MAX_EQUAL?: any | null;
  pushedOn_MAX_GT?: any | null;
  pushedOn_MAX_GTE?: any | null;
  pushedOn_MAX_LT?: any | null;
  pushedOn_MAX_LTE?: any | null;
  pushedOn_MIN_EQUAL?: any | null;
  pushedOn_MIN_GT?: any | null;
  pushedOn_MIN_GTE?: any | null;
  pushedOn_MIN_LT?: any | null;
  pushedOn_MIN_LTE?: any | null;
  reportData_AVERAGE_EQUAL?: number | null;
  reportData_AVERAGE_GT?: number | null;
  reportData_AVERAGE_GTE?: number | null;
  reportData_AVERAGE_LT?: number | null;
  reportData_AVERAGE_LTE?: number | null;
  reportData_EQUAL?: string | null;
  reportData_GT?: number | null;
  reportData_GTE?: number | null;
  reportData_LONGEST_EQUAL?: number | null;
  reportData_LONGEST_GT?: number | null;
  reportData_LONGEST_GTE?: number | null;
  reportData_LONGEST_LT?: number | null;
  reportData_LONGEST_LTE?: number | null;
  reportData_LT?: number | null;
  reportData_LTE?: number | null;
  reportData_SHORTEST_EQUAL?: number | null;
  reportData_SHORTEST_GT?: number | null;
  reportData_SHORTEST_GTE?: number | null;
  reportData_SHORTEST_LT?: number | null;
  reportData_SHORTEST_LTE?: number | null;
  totalAmount_AVERAGE_EQUAL?: number | null;
  totalAmount_AVERAGE_GT?: number | null;
  totalAmount_AVERAGE_GTE?: number | null;
  totalAmount_AVERAGE_LT?: number | null;
  totalAmount_AVERAGE_LTE?: number | null;
  totalAmount_EQUAL?: number | null;
  totalAmount_GT?: number | null;
  totalAmount_GTE?: number | null;
  totalAmount_LT?: number | null;
  totalAmount_LTE?: number | null;
  totalAmount_MAX_EQUAL?: number | null;
  totalAmount_MAX_GT?: number | null;
  totalAmount_MAX_GTE?: number | null;
  totalAmount_MAX_LT?: number | null;
  totalAmount_MAX_LTE?: number | null;
  totalAmount_MIN_EQUAL?: number | null;
  totalAmount_MIN_GT?: number | null;
  totalAmount_MIN_GTE?: number | null;
  totalAmount_MIN_LT?: number | null;
  totalAmount_MIN_LTE?: number | null;
  totalAmount_SUM_EQUAL?: number | null;
  totalAmount_SUM_GT?: number | null;
  totalAmount_SUM_GTE?: number | null;
  totalAmount_SUM_LT?: number | null;
  totalAmount_SUM_LTE?: number | null;
  version_AVERAGE_EQUAL?: number | null;
  version_AVERAGE_GT?: number | null;
  version_AVERAGE_GTE?: number | null;
  version_AVERAGE_LT?: number | null;
  version_AVERAGE_LTE?: number | null;
  version_EQUAL?: number | null;
  version_GT?: number | null;
  version_GTE?: number | null;
  version_LT?: number | null;
  version_LTE?: number | null;
  version_MAX_EQUAL?: number | null;
  version_MAX_GT?: number | null;
  version_MAX_GTE?: number | null;
  version_MAX_LT?: number | null;
  version_MAX_LTE?: number | null;
  version_MIN_EQUAL?: number | null;
  version_MIN_GT?: number | null;
  version_MIN_GTE?: number | null;
  version_MIN_LT?: number | null;
  version_MIN_LTE?: number | null;
  version_SUM_EQUAL?: number | null;
  version_SUM_GT?: number | null;
  version_SUM_GTE?: number | null;
  version_SUM_LT?: number | null;
  version_SUM_LTE?: number | null;
}

export interface BaseAgreementLdlChartConfigAggregateInput {
  AND?: BaseAgreementLdlChartConfigAggregateInput[] | null;
  OR?: BaseAgreementLdlChartConfigAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  edge?: BaseAgreementLdlChartConfigEdgeAggregationWhereInput | null;
}

export interface BaseAgreementLdlChartConfigConnectionWhere {
  AND?: BaseAgreementLdlChartConfigConnectionWhere[] | null;
  OR?: BaseAgreementLdlChartConfigConnectionWhere[] | null;
  edge?: ChartRangeConfigurationRelationshipWhere | null;
  edge_NOT?: ChartRangeConfigurationRelationshipWhere | null;
  node?: ChartRangeConfigurationWhere | null;
  node_NOT?: ChartRangeConfigurationWhere | null;
}

export interface BaseAgreementLdlChartConfigEdgeAggregationWhereInput {
  AND?: BaseAgreementLdlChartConfigEdgeAggregationWhereInput[] | null;
  OR?: BaseAgreementLdlChartConfigEdgeAggregationWhereInput[] | null;
  from_AVERAGE_EQUAL?: number | null;
  from_AVERAGE_GT?: number | null;
  from_AVERAGE_GTE?: number | null;
  from_AVERAGE_LT?: number | null;
  from_AVERAGE_LTE?: number | null;
  from_EQUAL?: number | null;
  from_GT?: number | null;
  from_GTE?: number | null;
  from_LT?: number | null;
  from_LTE?: number | null;
  from_MAX_EQUAL?: number | null;
  from_MAX_GT?: number | null;
  from_MAX_GTE?: number | null;
  from_MAX_LT?: number | null;
  from_MAX_LTE?: number | null;
  from_MIN_EQUAL?: number | null;
  from_MIN_GT?: number | null;
  from_MIN_GTE?: number | null;
  from_MIN_LT?: number | null;
  from_MIN_LTE?: number | null;
  from_SUM_EQUAL?: number | null;
  from_SUM_GT?: number | null;
  from_SUM_GTE?: number | null;
  from_SUM_LT?: number | null;
  from_SUM_LTE?: number | null;
  name_AVERAGE_EQUAL?: number | null;
  name_AVERAGE_GT?: number | null;
  name_AVERAGE_GTE?: number | null;
  name_AVERAGE_LT?: number | null;
  name_AVERAGE_LTE?: number | null;
  name_EQUAL?: string | null;
  name_GT?: number | null;
  name_GTE?: number | null;
  name_LONGEST_EQUAL?: number | null;
  name_LONGEST_GT?: number | null;
  name_LONGEST_GTE?: number | null;
  name_LONGEST_LT?: number | null;
  name_LONGEST_LTE?: number | null;
  name_LT?: number | null;
  name_LTE?: number | null;
  name_SHORTEST_EQUAL?: number | null;
  name_SHORTEST_GT?: number | null;
  name_SHORTEST_GTE?: number | null;
  name_SHORTEST_LT?: number | null;
  name_SHORTEST_LTE?: number | null;
  order_AVERAGE_EQUAL?: number | null;
  order_AVERAGE_GT?: number | null;
  order_AVERAGE_GTE?: number | null;
  order_AVERAGE_LT?: number | null;
  order_AVERAGE_LTE?: number | null;
  order_EQUAL?: number | null;
  order_GT?: number | null;
  order_GTE?: number | null;
  order_LT?: number | null;
  order_LTE?: number | null;
  order_MAX_EQUAL?: number | null;
  order_MAX_GT?: number | null;
  order_MAX_GTE?: number | null;
  order_MAX_LT?: number | null;
  order_MAX_LTE?: number | null;
  order_MIN_EQUAL?: number | null;
  order_MIN_GT?: number | null;
  order_MIN_GTE?: number | null;
  order_MIN_LT?: number | null;
  order_MIN_LTE?: number | null;
  order_SUM_EQUAL?: number | null;
  order_SUM_GT?: number | null;
  order_SUM_GTE?: number | null;
  order_SUM_LT?: number | null;
  order_SUM_LTE?: number | null;
  to_AVERAGE_EQUAL?: number | null;
  to_AVERAGE_GT?: number | null;
  to_AVERAGE_GTE?: number | null;
  to_AVERAGE_LT?: number | null;
  to_AVERAGE_LTE?: number | null;
  to_EQUAL?: number | null;
  to_GT?: number | null;
  to_GTE?: number | null;
  to_LT?: number | null;
  to_LTE?: number | null;
  to_MAX_EQUAL?: number | null;
  to_MAX_GT?: number | null;
  to_MAX_GTE?: number | null;
  to_MAX_LT?: number | null;
  to_MAX_LTE?: number | null;
  to_MIN_EQUAL?: number | null;
  to_MIN_GT?: number | null;
  to_MIN_GTE?: number | null;
  to_MIN_LT?: number | null;
  to_MIN_LTE?: number | null;
  to_SUM_EQUAL?: number | null;
  to_SUM_GT?: number | null;
  to_SUM_GTE?: number | null;
  to_SUM_LT?: number | null;
  to_SUM_LTE?: number | null;
}

export interface BaseAgreementNegotiableAttributesAggregateInput {
  AND?: BaseAgreementNegotiableAttributesAggregateInput[] | null;
  OR?: BaseAgreementNegotiableAttributesAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: BaseAgreementNegotiableAttributesNodeAggregationWhereInput | null;
}

export interface BaseAgreementNegotiableAttributesConnectionWhere {
  AND?: BaseAgreementNegotiableAttributesConnectionWhere[] | null;
  OR?: BaseAgreementNegotiableAttributesConnectionWhere[] | null;
  node?: CatalogueAttributeWhere | null;
  node_NOT?: CatalogueAttributeWhere | null;
}

export interface BaseAgreementNegotiableAttributesNodeAggregationWhereInput {
  AND?: BaseAgreementNegotiableAttributesNodeAggregationWhereInput[] | null;
  OR?: BaseAgreementNegotiableAttributesNodeAggregationWhereInput[] | null;
  caption_AVERAGE_EQUAL?: number | null;
  caption_AVERAGE_GT?: number | null;
  caption_AVERAGE_GTE?: number | null;
  caption_AVERAGE_LT?: number | null;
  caption_AVERAGE_LTE?: number | null;
  caption_EQUAL?: string | null;
  caption_GT?: number | null;
  caption_GTE?: number | null;
  caption_LONGEST_EQUAL?: number | null;
  caption_LONGEST_GT?: number | null;
  caption_LONGEST_GTE?: number | null;
  caption_LONGEST_LT?: number | null;
  caption_LONGEST_LTE?: number | null;
  caption_LT?: number | null;
  caption_LTE?: number | null;
  caption_SHORTEST_EQUAL?: number | null;
  caption_SHORTEST_GT?: number | null;
  caption_SHORTEST_GTE?: number | null;
  caption_SHORTEST_LT?: number | null;
  caption_SHORTEST_LTE?: number | null;
  decimalPrecision_AVERAGE_EQUAL?: number | null;
  decimalPrecision_AVERAGE_GT?: number | null;
  decimalPrecision_AVERAGE_GTE?: number | null;
  decimalPrecision_AVERAGE_LT?: number | null;
  decimalPrecision_AVERAGE_LTE?: number | null;
  decimalPrecision_EQUAL?: number | null;
  decimalPrecision_GT?: number | null;
  decimalPrecision_GTE?: number | null;
  decimalPrecision_LT?: number | null;
  decimalPrecision_LTE?: number | null;
  decimalPrecision_MAX_EQUAL?: number | null;
  decimalPrecision_MAX_GT?: number | null;
  decimalPrecision_MAX_GTE?: number | null;
  decimalPrecision_MAX_LT?: number | null;
  decimalPrecision_MAX_LTE?: number | null;
  decimalPrecision_MIN_EQUAL?: number | null;
  decimalPrecision_MIN_GT?: number | null;
  decimalPrecision_MIN_GTE?: number | null;
  decimalPrecision_MIN_LT?: number | null;
  decimalPrecision_MIN_LTE?: number | null;
  decimalPrecision_SUM_EQUAL?: number | null;
  decimalPrecision_SUM_GT?: number | null;
  decimalPrecision_SUM_GTE?: number | null;
  decimalPrecision_SUM_LT?: number | null;
  decimalPrecision_SUM_LTE?: number | null;
  defaultValue_AVERAGE_EQUAL?: number | null;
  defaultValue_AVERAGE_GT?: number | null;
  defaultValue_AVERAGE_GTE?: number | null;
  defaultValue_AVERAGE_LT?: number | null;
  defaultValue_AVERAGE_LTE?: number | null;
  defaultValue_EQUAL?: string | null;
  defaultValue_GT?: number | null;
  defaultValue_GTE?: number | null;
  defaultValue_LONGEST_EQUAL?: number | null;
  defaultValue_LONGEST_GT?: number | null;
  defaultValue_LONGEST_GTE?: number | null;
  defaultValue_LONGEST_LT?: number | null;
  defaultValue_LONGEST_LTE?: number | null;
  defaultValue_LT?: number | null;
  defaultValue_LTE?: number | null;
  defaultValue_SHORTEST_EQUAL?: number | null;
  defaultValue_SHORTEST_GT?: number | null;
  defaultValue_SHORTEST_GTE?: number | null;
  defaultValue_SHORTEST_LT?: number | null;
  defaultValue_SHORTEST_LTE?: number | null;
  id_AVERAGE_EQUAL?: number | null;
  id_AVERAGE_GT?: number | null;
  id_AVERAGE_GTE?: number | null;
  id_AVERAGE_LT?: number | null;
  id_AVERAGE_LTE?: number | null;
  id_EQUAL?: string | null;
  id_GT?: number | null;
  id_GTE?: number | null;
  id_LONGEST_EQUAL?: number | null;
  id_LONGEST_GT?: number | null;
  id_LONGEST_GTE?: number | null;
  id_LONGEST_LT?: number | null;
  id_LONGEST_LTE?: number | null;
  id_LT?: number | null;
  id_LTE?: number | null;
  id_SHORTEST_EQUAL?: number | null;
  id_SHORTEST_GT?: number | null;
  id_SHORTEST_GTE?: number | null;
  id_SHORTEST_LT?: number | null;
  id_SHORTEST_LTE?: number | null;
  identifier_AVERAGE_EQUAL?: number | null;
  identifier_AVERAGE_GT?: number | null;
  identifier_AVERAGE_GTE?: number | null;
  identifier_AVERAGE_LT?: number | null;
  identifier_AVERAGE_LTE?: number | null;
  identifier_EQUAL?: string | null;
  identifier_GT?: number | null;
  identifier_GTE?: number | null;
  identifier_LONGEST_EQUAL?: number | null;
  identifier_LONGEST_GT?: number | null;
  identifier_LONGEST_GTE?: number | null;
  identifier_LONGEST_LT?: number | null;
  identifier_LONGEST_LTE?: number | null;
  identifier_LT?: number | null;
  identifier_LTE?: number | null;
  identifier_SHORTEST_EQUAL?: number | null;
  identifier_SHORTEST_GT?: number | null;
  identifier_SHORTEST_GTE?: number | null;
  identifier_SHORTEST_LT?: number | null;
  identifier_SHORTEST_LTE?: number | null;
  longLabelLocalizationKey_AVERAGE_EQUAL?: number | null;
  longLabelLocalizationKey_AVERAGE_GT?: number | null;
  longLabelLocalizationKey_AVERAGE_GTE?: number | null;
  longLabelLocalizationKey_AVERAGE_LT?: number | null;
  longLabelLocalizationKey_AVERAGE_LTE?: number | null;
  longLabelLocalizationKey_EQUAL?: string | null;
  longLabelLocalizationKey_GT?: number | null;
  longLabelLocalizationKey_GTE?: number | null;
  longLabelLocalizationKey_LONGEST_EQUAL?: number | null;
  longLabelLocalizationKey_LONGEST_GT?: number | null;
  longLabelLocalizationKey_LONGEST_GTE?: number | null;
  longLabelLocalizationKey_LONGEST_LT?: number | null;
  longLabelLocalizationKey_LONGEST_LTE?: number | null;
  longLabelLocalizationKey_LT?: number | null;
  longLabelLocalizationKey_LTE?: number | null;
  longLabelLocalizationKey_SHORTEST_EQUAL?: number | null;
  longLabelLocalizationKey_SHORTEST_GT?: number | null;
  longLabelLocalizationKey_SHORTEST_GTE?: number | null;
  longLabelLocalizationKey_SHORTEST_LT?: number | null;
  longLabelLocalizationKey_SHORTEST_LTE?: number | null;
  maxLength_AVERAGE_EQUAL?: number | null;
  maxLength_AVERAGE_GT?: number | null;
  maxLength_AVERAGE_GTE?: number | null;
  maxLength_AVERAGE_LT?: number | null;
  maxLength_AVERAGE_LTE?: number | null;
  maxLength_EQUAL?: number | null;
  maxLength_GT?: number | null;
  maxLength_GTE?: number | null;
  maxLength_LT?: number | null;
  maxLength_LTE?: number | null;
  maxLength_MAX_EQUAL?: number | null;
  maxLength_MAX_GT?: number | null;
  maxLength_MAX_GTE?: number | null;
  maxLength_MAX_LT?: number | null;
  maxLength_MAX_LTE?: number | null;
  maxLength_MIN_EQUAL?: number | null;
  maxLength_MIN_GT?: number | null;
  maxLength_MIN_GTE?: number | null;
  maxLength_MIN_LT?: number | null;
  maxLength_MIN_LTE?: number | null;
  maxLength_SUM_EQUAL?: number | null;
  maxLength_SUM_GT?: number | null;
  maxLength_SUM_GTE?: number | null;
  maxLength_SUM_LT?: number | null;
  maxLength_SUM_LTE?: number | null;
  minLength_AVERAGE_EQUAL?: number | null;
  minLength_AVERAGE_GT?: number | null;
  minLength_AVERAGE_GTE?: number | null;
  minLength_AVERAGE_LT?: number | null;
  minLength_AVERAGE_LTE?: number | null;
  minLength_EQUAL?: number | null;
  minLength_GT?: number | null;
  minLength_GTE?: number | null;
  minLength_LT?: number | null;
  minLength_LTE?: number | null;
  minLength_MAX_EQUAL?: number | null;
  minLength_MAX_GT?: number | null;
  minLength_MAX_GTE?: number | null;
  minLength_MAX_LT?: number | null;
  minLength_MAX_LTE?: number | null;
  minLength_MIN_EQUAL?: number | null;
  minLength_MIN_GT?: number | null;
  minLength_MIN_GTE?: number | null;
  minLength_MIN_LT?: number | null;
  minLength_MIN_LTE?: number | null;
  minLength_SUM_EQUAL?: number | null;
  minLength_SUM_GT?: number | null;
  minLength_SUM_GTE?: number | null;
  minLength_SUM_LT?: number | null;
  minLength_SUM_LTE?: number | null;
  rules_AVERAGE_EQUAL?: number | null;
  rules_AVERAGE_GT?: number | null;
  rules_AVERAGE_GTE?: number | null;
  rules_AVERAGE_LT?: number | null;
  rules_AVERAGE_LTE?: number | null;
  rules_EQUAL?: string | null;
  rules_GT?: number | null;
  rules_GTE?: number | null;
  rules_LONGEST_EQUAL?: number | null;
  rules_LONGEST_GT?: number | null;
  rules_LONGEST_GTE?: number | null;
  rules_LONGEST_LT?: number | null;
  rules_LONGEST_LTE?: number | null;
  rules_LT?: number | null;
  rules_LTE?: number | null;
  rules_SHORTEST_EQUAL?: number | null;
  rules_SHORTEST_GT?: number | null;
  rules_SHORTEST_GTE?: number | null;
  rules_SHORTEST_LT?: number | null;
  rules_SHORTEST_LTE?: number | null;
  shortLabelLocalizationKey_AVERAGE_EQUAL?: number | null;
  shortLabelLocalizationKey_AVERAGE_GT?: number | null;
  shortLabelLocalizationKey_AVERAGE_GTE?: number | null;
  shortLabelLocalizationKey_AVERAGE_LT?: number | null;
  shortLabelLocalizationKey_AVERAGE_LTE?: number | null;
  shortLabelLocalizationKey_EQUAL?: string | null;
  shortLabelLocalizationKey_GT?: number | null;
  shortLabelLocalizationKey_GTE?: number | null;
  shortLabelLocalizationKey_LONGEST_EQUAL?: number | null;
  shortLabelLocalizationKey_LONGEST_GT?: number | null;
  shortLabelLocalizationKey_LONGEST_GTE?: number | null;
  shortLabelLocalizationKey_LONGEST_LT?: number | null;
  shortLabelLocalizationKey_LONGEST_LTE?: number | null;
  shortLabelLocalizationKey_LT?: number | null;
  shortLabelLocalizationKey_LTE?: number | null;
  shortLabelLocalizationKey_SHORTEST_EQUAL?: number | null;
  shortLabelLocalizationKey_SHORTEST_GT?: number | null;
  shortLabelLocalizationKey_SHORTEST_GTE?: number | null;
  shortLabelLocalizationKey_SHORTEST_LT?: number | null;
  shortLabelLocalizationKey_SHORTEST_LTE?: number | null;
  values_AVERAGE_EQUAL?: number | null;
  values_AVERAGE_GT?: number | null;
  values_AVERAGE_GTE?: number | null;
  values_AVERAGE_LT?: number | null;
  values_AVERAGE_LTE?: number | null;
  values_EQUAL?: string | null;
  values_GT?: number | null;
  values_GTE?: number | null;
  values_LONGEST_EQUAL?: number | null;
  values_LONGEST_GT?: number | null;
  values_LONGEST_GTE?: number | null;
  values_LONGEST_LT?: number | null;
  values_LONGEST_LTE?: number | null;
  values_LT?: number | null;
  values_LTE?: number | null;
  values_SHORTEST_EQUAL?: number | null;
  values_SHORTEST_GT?: number | null;
  values_SHORTEST_GTE?: number | null;
  values_SHORTEST_LT?: number | null;
  values_SHORTEST_LTE?: number | null;
}

export interface BaseAgreementNextVersionsAggregateInput {
  AND?: BaseAgreementNextVersionsAggregateInput[] | null;
  OR?: BaseAgreementNextVersionsAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: BaseAgreementNextVersionsNodeAggregationWhereInput | null;
}

export interface BaseAgreementNextVersionsConnectionWhere {
  AND?: BaseAgreementNextVersionsConnectionWhere[] | null;
  OR?: BaseAgreementNextVersionsConnectionWhere[] | null;
  node?: BaseAgreementWhere | null;
  node_NOT?: BaseAgreementWhere | null;
}

export interface BaseAgreementNextVersionsNodeAggregationWhereInput {
  AND?: BaseAgreementNextVersionsNodeAggregationWhereInput[] | null;
  OR?: BaseAgreementNextVersionsNodeAggregationWhereInput[] | null;
  caseSuspensionIntervalDays_AVERAGE_EQUAL?: number | null;
  caseSuspensionIntervalDays_AVERAGE_GT?: number | null;
  caseSuspensionIntervalDays_AVERAGE_GTE?: number | null;
  caseSuspensionIntervalDays_AVERAGE_LT?: number | null;
  caseSuspensionIntervalDays_AVERAGE_LTE?: number | null;
  caseSuspensionIntervalDays_EQUAL?: number | null;
  caseSuspensionIntervalDays_GT?: number | null;
  caseSuspensionIntervalDays_GTE?: number | null;
  caseSuspensionIntervalDays_LT?: number | null;
  caseSuspensionIntervalDays_LTE?: number | null;
  caseSuspensionIntervalDays_MAX_EQUAL?: number | null;
  caseSuspensionIntervalDays_MAX_GT?: number | null;
  caseSuspensionIntervalDays_MAX_GTE?: number | null;
  caseSuspensionIntervalDays_MAX_LT?: number | null;
  caseSuspensionIntervalDays_MAX_LTE?: number | null;
  caseSuspensionIntervalDays_MIN_EQUAL?: number | null;
  caseSuspensionIntervalDays_MIN_GT?: number | null;
  caseSuspensionIntervalDays_MIN_GTE?: number | null;
  caseSuspensionIntervalDays_MIN_LT?: number | null;
  caseSuspensionIntervalDays_MIN_LTE?: number | null;
  caseSuspensionIntervalDays_SUM_EQUAL?: number | null;
  caseSuspensionIntervalDays_SUM_GT?: number | null;
  caseSuspensionIntervalDays_SUM_GTE?: number | null;
  caseSuspensionIntervalDays_SUM_LT?: number | null;
  caseSuspensionIntervalDays_SUM_LTE?: number | null;
  coveringFormWaitInterval_AVERAGE_EQUAL?: number | null;
  coveringFormWaitInterval_AVERAGE_GT?: number | null;
  coveringFormWaitInterval_AVERAGE_GTE?: number | null;
  coveringFormWaitInterval_AVERAGE_LT?: number | null;
  coveringFormWaitInterval_AVERAGE_LTE?: number | null;
  coveringFormWaitInterval_EQUAL?: number | null;
  coveringFormWaitInterval_GT?: number | null;
  coveringFormWaitInterval_GTE?: number | null;
  coveringFormWaitInterval_LT?: number | null;
  coveringFormWaitInterval_LTE?: number | null;
  coveringFormWaitInterval_MAX_EQUAL?: number | null;
  coveringFormWaitInterval_MAX_GT?: number | null;
  coveringFormWaitInterval_MAX_GTE?: number | null;
  coveringFormWaitInterval_MAX_LT?: number | null;
  coveringFormWaitInterval_MAX_LTE?: number | null;
  coveringFormWaitInterval_MIN_EQUAL?: number | null;
  coveringFormWaitInterval_MIN_GT?: number | null;
  coveringFormWaitInterval_MIN_GTE?: number | null;
  coveringFormWaitInterval_MIN_LT?: number | null;
  coveringFormWaitInterval_MIN_LTE?: number | null;
  coveringFormWaitInterval_SUM_EQUAL?: number | null;
  coveringFormWaitInterval_SUM_GT?: number | null;
  coveringFormWaitInterval_SUM_GTE?: number | null;
  coveringFormWaitInterval_SUM_LT?: number | null;
  coveringFormWaitInterval_SUM_LTE?: number | null;
  createdOn_EQUAL?: any | null;
  createdOn_GT?: any | null;
  createdOn_GTE?: any | null;
  createdOn_LT?: any | null;
  createdOn_LTE?: any | null;
  createdOn_MAX_EQUAL?: any | null;
  createdOn_MAX_GT?: any | null;
  createdOn_MAX_GTE?: any | null;
  createdOn_MAX_LT?: any | null;
  createdOn_MAX_LTE?: any | null;
  createdOn_MIN_EQUAL?: any | null;
  createdOn_MIN_GT?: any | null;
  createdOn_MIN_GTE?: any | null;
  createdOn_MIN_LT?: any | null;
  createdOn_MIN_LTE?: any | null;
  defaultPriceRate_AVERAGE_EQUAL?: number | null;
  defaultPriceRate_AVERAGE_GT?: number | null;
  defaultPriceRate_AVERAGE_GTE?: number | null;
  defaultPriceRate_AVERAGE_LT?: number | null;
  defaultPriceRate_AVERAGE_LTE?: number | null;
  defaultPriceRate_EQUAL?: number | null;
  defaultPriceRate_GT?: number | null;
  defaultPriceRate_GTE?: number | null;
  defaultPriceRate_LT?: number | null;
  defaultPriceRate_LTE?: number | null;
  defaultPriceRate_MAX_EQUAL?: number | null;
  defaultPriceRate_MAX_GT?: number | null;
  defaultPriceRate_MAX_GTE?: number | null;
  defaultPriceRate_MAX_LT?: number | null;
  defaultPriceRate_MAX_LTE?: number | null;
  defaultPriceRate_MIN_EQUAL?: number | null;
  defaultPriceRate_MIN_GT?: number | null;
  defaultPriceRate_MIN_GTE?: number | null;
  defaultPriceRate_MIN_LT?: number | null;
  defaultPriceRate_MIN_LTE?: number | null;
  defaultPriceRate_SUM_EQUAL?: number | null;
  defaultPriceRate_SUM_GT?: number | null;
  defaultPriceRate_SUM_GTE?: number | null;
  defaultPriceRate_SUM_LT?: number | null;
  defaultPriceRate_SUM_LTE?: number | null;
  firstExecutionDate_EQUAL?: any | null;
  firstExecutionDate_GT?: any | null;
  firstExecutionDate_GTE?: any | null;
  firstExecutionDate_LT?: any | null;
  firstExecutionDate_LTE?: any | null;
  firstExecutionDate_MAX_EQUAL?: any | null;
  firstExecutionDate_MAX_GT?: any | null;
  firstExecutionDate_MAX_GTE?: any | null;
  firstExecutionDate_MAX_LT?: any | null;
  firstExecutionDate_MAX_LTE?: any | null;
  firstExecutionDate_MIN_EQUAL?: any | null;
  firstExecutionDate_MIN_GT?: any | null;
  firstExecutionDate_MIN_GTE?: any | null;
  firstExecutionDate_MIN_LT?: any | null;
  firstExecutionDate_MIN_LTE?: any | null;
  formattedAmount_AVERAGE_EQUAL?: number | null;
  formattedAmount_AVERAGE_GT?: number | null;
  formattedAmount_AVERAGE_GTE?: number | null;
  formattedAmount_AVERAGE_LT?: number | null;
  formattedAmount_AVERAGE_LTE?: number | null;
  formattedAmount_EQUAL?: string | null;
  formattedAmount_GT?: number | null;
  formattedAmount_GTE?: number | null;
  formattedAmount_LONGEST_EQUAL?: number | null;
  formattedAmount_LONGEST_GT?: number | null;
  formattedAmount_LONGEST_GTE?: number | null;
  formattedAmount_LONGEST_LT?: number | null;
  formattedAmount_LONGEST_LTE?: number | null;
  formattedAmount_LT?: number | null;
  formattedAmount_LTE?: number | null;
  formattedAmount_SHORTEST_EQUAL?: number | null;
  formattedAmount_SHORTEST_GT?: number | null;
  formattedAmount_SHORTEST_GTE?: number | null;
  formattedAmount_SHORTEST_LT?: number | null;
  formattedAmount_SHORTEST_LTE?: number | null;
  formattedCounterparties_AVERAGE_EQUAL?: number | null;
  formattedCounterparties_AVERAGE_GT?: number | null;
  formattedCounterparties_AVERAGE_GTE?: number | null;
  formattedCounterparties_AVERAGE_LT?: number | null;
  formattedCounterparties_AVERAGE_LTE?: number | null;
  formattedCounterparties_EQUAL?: string | null;
  formattedCounterparties_GT?: number | null;
  formattedCounterparties_GTE?: number | null;
  formattedCounterparties_LONGEST_EQUAL?: number | null;
  formattedCounterparties_LONGEST_GT?: number | null;
  formattedCounterparties_LONGEST_GTE?: number | null;
  formattedCounterparties_LONGEST_LT?: number | null;
  formattedCounterparties_LONGEST_LTE?: number | null;
  formattedCounterparties_LT?: number | null;
  formattedCounterparties_LTE?: number | null;
  formattedCounterparties_SHORTEST_EQUAL?: number | null;
  formattedCounterparties_SHORTEST_GT?: number | null;
  formattedCounterparties_SHORTEST_GTE?: number | null;
  formattedCounterparties_SHORTEST_LT?: number | null;
  formattedCounterparties_SHORTEST_LTE?: number | null;
  formattedDiseases_AVERAGE_EQUAL?: number | null;
  formattedDiseases_AVERAGE_GT?: number | null;
  formattedDiseases_AVERAGE_GTE?: number | null;
  formattedDiseases_AVERAGE_LT?: number | null;
  formattedDiseases_AVERAGE_LTE?: number | null;
  formattedDiseases_EQUAL?: string | null;
  formattedDiseases_GT?: number | null;
  formattedDiseases_GTE?: number | null;
  formattedDiseases_LONGEST_EQUAL?: number | null;
  formattedDiseases_LONGEST_GT?: number | null;
  formattedDiseases_LONGEST_GTE?: number | null;
  formattedDiseases_LONGEST_LT?: number | null;
  formattedDiseases_LONGEST_LTE?: number | null;
  formattedDiseases_LT?: number | null;
  formattedDiseases_LTE?: number | null;
  formattedDiseases_SHORTEST_EQUAL?: number | null;
  formattedDiseases_SHORTEST_GT?: number | null;
  formattedDiseases_SHORTEST_GTE?: number | null;
  formattedDiseases_SHORTEST_LT?: number | null;
  formattedDiseases_SHORTEST_LTE?: number | null;
  formattedIndications_AVERAGE_EQUAL?: number | null;
  formattedIndications_AVERAGE_GT?: number | null;
  formattedIndications_AVERAGE_GTE?: number | null;
  formattedIndications_AVERAGE_LT?: number | null;
  formattedIndications_AVERAGE_LTE?: number | null;
  formattedIndications_EQUAL?: string | null;
  formattedIndications_GT?: number | null;
  formattedIndications_GTE?: number | null;
  formattedIndications_LONGEST_EQUAL?: number | null;
  formattedIndications_LONGEST_GT?: number | null;
  formattedIndications_LONGEST_GTE?: number | null;
  formattedIndications_LONGEST_LT?: number | null;
  formattedIndications_LONGEST_LTE?: number | null;
  formattedIndications_LT?: number | null;
  formattedIndications_LTE?: number | null;
  formattedIndications_SHORTEST_EQUAL?: number | null;
  formattedIndications_SHORTEST_GT?: number | null;
  formattedIndications_SHORTEST_GTE?: number | null;
  formattedIndications_SHORTEST_LT?: number | null;
  formattedIndications_SHORTEST_LTE?: number | null;
  formattedProducts_AVERAGE_EQUAL?: number | null;
  formattedProducts_AVERAGE_GT?: number | null;
  formattedProducts_AVERAGE_GTE?: number | null;
  formattedProducts_AVERAGE_LT?: number | null;
  formattedProducts_AVERAGE_LTE?: number | null;
  formattedProducts_EQUAL?: string | null;
  formattedProducts_GT?: number | null;
  formattedProducts_GTE?: number | null;
  formattedProducts_LONGEST_EQUAL?: number | null;
  formattedProducts_LONGEST_GT?: number | null;
  formattedProducts_LONGEST_GTE?: number | null;
  formattedProducts_LONGEST_LT?: number | null;
  formattedProducts_LONGEST_LTE?: number | null;
  formattedProducts_LT?: number | null;
  formattedProducts_LTE?: number | null;
  formattedProducts_SHORTEST_EQUAL?: number | null;
  formattedProducts_SHORTEST_GT?: number | null;
  formattedProducts_SHORTEST_GTE?: number | null;
  formattedProducts_SHORTEST_LT?: number | null;
  formattedProducts_SHORTEST_LTE?: number | null;
  formattedTags_AVERAGE_EQUAL?: number | null;
  formattedTags_AVERAGE_GT?: number | null;
  formattedTags_AVERAGE_GTE?: number | null;
  formattedTags_AVERAGE_LT?: number | null;
  formattedTags_AVERAGE_LTE?: number | null;
  formattedTags_EQUAL?: string | null;
  formattedTags_GT?: number | null;
  formattedTags_GTE?: number | null;
  formattedTags_LONGEST_EQUAL?: number | null;
  formattedTags_LONGEST_GT?: number | null;
  formattedTags_LONGEST_GTE?: number | null;
  formattedTags_LONGEST_LT?: number | null;
  formattedTags_LONGEST_LTE?: number | null;
  formattedTags_LT?: number | null;
  formattedTags_LTE?: number | null;
  formattedTags_SHORTEST_EQUAL?: number | null;
  formattedTags_SHORTEST_GT?: number | null;
  formattedTags_SHORTEST_GTE?: number | null;
  formattedTags_SHORTEST_LT?: number | null;
  formattedTags_SHORTEST_LTE?: number | null;
  formattedValidityPeriod_AVERAGE_EQUAL?: number | null;
  formattedValidityPeriod_AVERAGE_GT?: number | null;
  formattedValidityPeriod_AVERAGE_GTE?: number | null;
  formattedValidityPeriod_AVERAGE_LT?: number | null;
  formattedValidityPeriod_AVERAGE_LTE?: number | null;
  formattedValidityPeriod_EQUAL?: string | null;
  formattedValidityPeriod_GT?: number | null;
  formattedValidityPeriod_GTE?: number | null;
  formattedValidityPeriod_LONGEST_EQUAL?: number | null;
  formattedValidityPeriod_LONGEST_GT?: number | null;
  formattedValidityPeriod_LONGEST_GTE?: number | null;
  formattedValidityPeriod_LONGEST_LT?: number | null;
  formattedValidityPeriod_LONGEST_LTE?: number | null;
  formattedValidityPeriod_LT?: number | null;
  formattedValidityPeriod_LTE?: number | null;
  formattedValidityPeriod_SHORTEST_EQUAL?: number | null;
  formattedValidityPeriod_SHORTEST_GT?: number | null;
  formattedValidityPeriod_SHORTEST_GTE?: number | null;
  formattedValidityPeriod_SHORTEST_LT?: number | null;
  formattedValidityPeriod_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  initialVersionId_AVERAGE_EQUAL?: number | null;
  initialVersionId_AVERAGE_GT?: number | null;
  initialVersionId_AVERAGE_GTE?: number | null;
  initialVersionId_AVERAGE_LT?: number | null;
  initialVersionId_AVERAGE_LTE?: number | null;
  initialVersionId_EQUAL?: string | null;
  initialVersionId_GT?: number | null;
  initialVersionId_GTE?: number | null;
  initialVersionId_LONGEST_EQUAL?: number | null;
  initialVersionId_LONGEST_GT?: number | null;
  initialVersionId_LONGEST_GTE?: number | null;
  initialVersionId_LONGEST_LT?: number | null;
  initialVersionId_LONGEST_LTE?: number | null;
  initialVersionId_LT?: number | null;
  initialVersionId_LTE?: number | null;
  initialVersionId_SHORTEST_EQUAL?: number | null;
  initialVersionId_SHORTEST_GT?: number | null;
  initialVersionId_SHORTEST_GTE?: number | null;
  initialVersionId_SHORTEST_LT?: number | null;
  initialVersionId_SHORTEST_LTE?: number | null;
  lastExecutionDate_EQUAL?: any | null;
  lastExecutionDate_GT?: any | null;
  lastExecutionDate_GTE?: any | null;
  lastExecutionDate_LT?: any | null;
  lastExecutionDate_LTE?: any | null;
  lastExecutionDate_MAX_EQUAL?: any | null;
  lastExecutionDate_MAX_GT?: any | null;
  lastExecutionDate_MAX_GTE?: any | null;
  lastExecutionDate_MAX_LT?: any | null;
  lastExecutionDate_MAX_LTE?: any | null;
  lastExecutionDate_MIN_EQUAL?: any | null;
  lastExecutionDate_MIN_GT?: any | null;
  lastExecutionDate_MIN_GTE?: any | null;
  lastExecutionDate_MIN_LT?: any | null;
  lastExecutionDate_MIN_LTE?: any | null;
  lastUpdatedOn_AVERAGE_EQUAL?: number | null;
  lastUpdatedOn_AVERAGE_GT?: number | null;
  lastUpdatedOn_AVERAGE_GTE?: number | null;
  lastUpdatedOn_AVERAGE_LT?: number | null;
  lastUpdatedOn_AVERAGE_LTE?: number | null;
  lastUpdatedOn_EQUAL?: number | null;
  lastUpdatedOn_GT?: number | null;
  lastUpdatedOn_GTE?: number | null;
  lastUpdatedOn_LT?: number | null;
  lastUpdatedOn_LTE?: number | null;
  lastUpdatedOn_MAX_EQUAL?: number | null;
  lastUpdatedOn_MAX_GT?: number | null;
  lastUpdatedOn_MAX_GTE?: number | null;
  lastUpdatedOn_MAX_LT?: number | null;
  lastUpdatedOn_MAX_LTE?: number | null;
  lastUpdatedOn_MIN_EQUAL?: number | null;
  lastUpdatedOn_MIN_GT?: number | null;
  lastUpdatedOn_MIN_GTE?: number | null;
  lastUpdatedOn_MIN_LT?: number | null;
  lastUpdatedOn_MIN_LTE?: number | null;
  lastUpdatedOn_SUM_EQUAL?: number | null;
  lastUpdatedOn_SUM_GT?: number | null;
  lastUpdatedOn_SUM_GTE?: number | null;
  lastUpdatedOn_SUM_LT?: number | null;
  lastUpdatedOn_SUM_LTE?: number | null;
  name_AVERAGE_EQUAL?: number | null;
  name_AVERAGE_GT?: number | null;
  name_AVERAGE_GTE?: number | null;
  name_AVERAGE_LT?: number | null;
  name_AVERAGE_LTE?: number | null;
  name_EQUAL?: string | null;
  name_GT?: number | null;
  name_GTE?: number | null;
  name_LONGEST_EQUAL?: number | null;
  name_LONGEST_GT?: number | null;
  name_LONGEST_GTE?: number | null;
  name_LONGEST_LT?: number | null;
  name_LONGEST_LTE?: number | null;
  name_LT?: number | null;
  name_LTE?: number | null;
  name_SHORTEST_EQUAL?: number | null;
  name_SHORTEST_GT?: number | null;
  name_SHORTEST_GTE?: number | null;
  name_SHORTEST_LT?: number | null;
  name_SHORTEST_LTE?: number | null;
  pushedOn_EQUAL?: any | null;
  pushedOn_GT?: any | null;
  pushedOn_GTE?: any | null;
  pushedOn_LT?: any | null;
  pushedOn_LTE?: any | null;
  pushedOn_MAX_EQUAL?: any | null;
  pushedOn_MAX_GT?: any | null;
  pushedOn_MAX_GTE?: any | null;
  pushedOn_MAX_LT?: any | null;
  pushedOn_MAX_LTE?: any | null;
  pushedOn_MIN_EQUAL?: any | null;
  pushedOn_MIN_GT?: any | null;
  pushedOn_MIN_GTE?: any | null;
  pushedOn_MIN_LT?: any | null;
  pushedOn_MIN_LTE?: any | null;
  reportData_AVERAGE_EQUAL?: number | null;
  reportData_AVERAGE_GT?: number | null;
  reportData_AVERAGE_GTE?: number | null;
  reportData_AVERAGE_LT?: number | null;
  reportData_AVERAGE_LTE?: number | null;
  reportData_EQUAL?: string | null;
  reportData_GT?: number | null;
  reportData_GTE?: number | null;
  reportData_LONGEST_EQUAL?: number | null;
  reportData_LONGEST_GT?: number | null;
  reportData_LONGEST_GTE?: number | null;
  reportData_LONGEST_LT?: number | null;
  reportData_LONGEST_LTE?: number | null;
  reportData_LT?: number | null;
  reportData_LTE?: number | null;
  reportData_SHORTEST_EQUAL?: number | null;
  reportData_SHORTEST_GT?: number | null;
  reportData_SHORTEST_GTE?: number | null;
  reportData_SHORTEST_LT?: number | null;
  reportData_SHORTEST_LTE?: number | null;
  totalAmount_AVERAGE_EQUAL?: number | null;
  totalAmount_AVERAGE_GT?: number | null;
  totalAmount_AVERAGE_GTE?: number | null;
  totalAmount_AVERAGE_LT?: number | null;
  totalAmount_AVERAGE_LTE?: number | null;
  totalAmount_EQUAL?: number | null;
  totalAmount_GT?: number | null;
  totalAmount_GTE?: number | null;
  totalAmount_LT?: number | null;
  totalAmount_LTE?: number | null;
  totalAmount_MAX_EQUAL?: number | null;
  totalAmount_MAX_GT?: number | null;
  totalAmount_MAX_GTE?: number | null;
  totalAmount_MAX_LT?: number | null;
  totalAmount_MAX_LTE?: number | null;
  totalAmount_MIN_EQUAL?: number | null;
  totalAmount_MIN_GT?: number | null;
  totalAmount_MIN_GTE?: number | null;
  totalAmount_MIN_LT?: number | null;
  totalAmount_MIN_LTE?: number | null;
  totalAmount_SUM_EQUAL?: number | null;
  totalAmount_SUM_GT?: number | null;
  totalAmount_SUM_GTE?: number | null;
  totalAmount_SUM_LT?: number | null;
  totalAmount_SUM_LTE?: number | null;
  version_AVERAGE_EQUAL?: number | null;
  version_AVERAGE_GT?: number | null;
  version_AVERAGE_GTE?: number | null;
  version_AVERAGE_LT?: number | null;
  version_AVERAGE_LTE?: number | null;
  version_EQUAL?: number | null;
  version_GT?: number | null;
  version_GTE?: number | null;
  version_LT?: number | null;
  version_LTE?: number | null;
  version_MAX_EQUAL?: number | null;
  version_MAX_GT?: number | null;
  version_MAX_GTE?: number | null;
  version_MAX_LT?: number | null;
  version_MAX_LTE?: number | null;
  version_MIN_EQUAL?: number | null;
  version_MIN_GT?: number | null;
  version_MIN_GTE?: number | null;
  version_MIN_LT?: number | null;
  version_MIN_LTE?: number | null;
  version_SUM_EQUAL?: number | null;
  version_SUM_GT?: number | null;
  version_SUM_GTE?: number | null;
  version_SUM_LT?: number | null;
  version_SUM_LTE?: number | null;
}

export interface BaseAgreementPushedByAggregateInput {
  AND?: BaseAgreementPushedByAggregateInput[] | null;
  OR?: BaseAgreementPushedByAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: BaseAgreementPushedByNodeAggregationWhereInput | null;
}

export interface BaseAgreementPushedByConnectionWhere {
  AND?: BaseAgreementPushedByConnectionWhere[] | null;
  OR?: BaseAgreementPushedByConnectionWhere[] | null;
  node?: UserWhere | null;
  node_NOT?: UserWhere | null;
}

export interface BaseAgreementPushedByNodeAggregationWhereInput {
  AND?: BaseAgreementPushedByNodeAggregationWhereInput[] | null;
  OR?: BaseAgreementPushedByNodeAggregationWhereInput[] | null;
  deletedOn_EQUAL?: any | null;
  deletedOn_GT?: any | null;
  deletedOn_GTE?: any | null;
  deletedOn_LT?: any | null;
  deletedOn_LTE?: any | null;
  deletedOn_MAX_EQUAL?: any | null;
  deletedOn_MAX_GT?: any | null;
  deletedOn_MAX_GTE?: any | null;
  deletedOn_MAX_LT?: any | null;
  deletedOn_MAX_LTE?: any | null;
  deletedOn_MIN_EQUAL?: any | null;
  deletedOn_MIN_GT?: any | null;
  deletedOn_MIN_GTE?: any | null;
  deletedOn_MIN_LT?: any | null;
  deletedOn_MIN_LTE?: any | null;
  department_AVERAGE_EQUAL?: number | null;
  department_AVERAGE_GT?: number | null;
  department_AVERAGE_GTE?: number | null;
  department_AVERAGE_LT?: number | null;
  department_AVERAGE_LTE?: number | null;
  department_EQUAL?: string | null;
  department_GT?: number | null;
  department_GTE?: number | null;
  department_LONGEST_EQUAL?: number | null;
  department_LONGEST_GT?: number | null;
  department_LONGEST_GTE?: number | null;
  department_LONGEST_LT?: number | null;
  department_LONGEST_LTE?: number | null;
  department_LT?: number | null;
  department_LTE?: number | null;
  department_SHORTEST_EQUAL?: number | null;
  department_SHORTEST_GT?: number | null;
  department_SHORTEST_GTE?: number | null;
  department_SHORTEST_LT?: number | null;
  department_SHORTEST_LTE?: number | null;
  email_AVERAGE_EQUAL?: number | null;
  email_AVERAGE_GT?: number | null;
  email_AVERAGE_GTE?: number | null;
  email_AVERAGE_LT?: number | null;
  email_AVERAGE_LTE?: number | null;
  email_EQUAL?: string | null;
  email_GT?: number | null;
  email_GTE?: number | null;
  email_LONGEST_EQUAL?: number | null;
  email_LONGEST_GT?: number | null;
  email_LONGEST_GTE?: number | null;
  email_LONGEST_LT?: number | null;
  email_LONGEST_LTE?: number | null;
  email_LT?: number | null;
  email_LTE?: number | null;
  email_SHORTEST_EQUAL?: number | null;
  email_SHORTEST_GT?: number | null;
  email_SHORTEST_GTE?: number | null;
  email_SHORTEST_LT?: number | null;
  email_SHORTEST_LTE?: number | null;
  firstName_AVERAGE_EQUAL?: number | null;
  firstName_AVERAGE_GT?: number | null;
  firstName_AVERAGE_GTE?: number | null;
  firstName_AVERAGE_LT?: number | null;
  firstName_AVERAGE_LTE?: number | null;
  firstName_EQUAL?: string | null;
  firstName_GT?: number | null;
  firstName_GTE?: number | null;
  firstName_LONGEST_EQUAL?: number | null;
  firstName_LONGEST_GT?: number | null;
  firstName_LONGEST_GTE?: number | null;
  firstName_LONGEST_LT?: number | null;
  firstName_LONGEST_LTE?: number | null;
  firstName_LT?: number | null;
  firstName_LTE?: number | null;
  firstName_SHORTEST_EQUAL?: number | null;
  firstName_SHORTEST_GT?: number | null;
  firstName_SHORTEST_GTE?: number | null;
  firstName_SHORTEST_LT?: number | null;
  firstName_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  lastName_AVERAGE_EQUAL?: number | null;
  lastName_AVERAGE_GT?: number | null;
  lastName_AVERAGE_GTE?: number | null;
  lastName_AVERAGE_LT?: number | null;
  lastName_AVERAGE_LTE?: number | null;
  lastName_EQUAL?: string | null;
  lastName_GT?: number | null;
  lastName_GTE?: number | null;
  lastName_LONGEST_EQUAL?: number | null;
  lastName_LONGEST_GT?: number | null;
  lastName_LONGEST_GTE?: number | null;
  lastName_LONGEST_LT?: number | null;
  lastName_LONGEST_LTE?: number | null;
  lastName_LT?: number | null;
  lastName_LTE?: number | null;
  lastName_SHORTEST_EQUAL?: number | null;
  lastName_SHORTEST_GT?: number | null;
  lastName_SHORTEST_GTE?: number | null;
  lastName_SHORTEST_LT?: number | null;
  lastName_SHORTEST_LTE?: number | null;
  position_AVERAGE_EQUAL?: number | null;
  position_AVERAGE_GT?: number | null;
  position_AVERAGE_GTE?: number | null;
  position_AVERAGE_LT?: number | null;
  position_AVERAGE_LTE?: number | null;
  position_EQUAL?: string | null;
  position_GT?: number | null;
  position_GTE?: number | null;
  position_LONGEST_EQUAL?: number | null;
  position_LONGEST_GT?: number | null;
  position_LONGEST_GTE?: number | null;
  position_LONGEST_LT?: number | null;
  position_LONGEST_LTE?: number | null;
  position_LT?: number | null;
  position_LTE?: number | null;
  position_SHORTEST_EQUAL?: number | null;
  position_SHORTEST_GT?: number | null;
  position_SHORTEST_GTE?: number | null;
  position_SHORTEST_LT?: number | null;
  position_SHORTEST_LTE?: number | null;
  preferredLanguage_AVERAGE_EQUAL?: number | null;
  preferredLanguage_AVERAGE_GT?: number | null;
  preferredLanguage_AVERAGE_GTE?: number | null;
  preferredLanguage_AVERAGE_LT?: number | null;
  preferredLanguage_AVERAGE_LTE?: number | null;
  preferredLanguage_EQUAL?: string | null;
  preferredLanguage_GT?: number | null;
  preferredLanguage_GTE?: number | null;
  preferredLanguage_LONGEST_EQUAL?: number | null;
  preferredLanguage_LONGEST_GT?: number | null;
  preferredLanguage_LONGEST_GTE?: number | null;
  preferredLanguage_LONGEST_LT?: number | null;
  preferredLanguage_LONGEST_LTE?: number | null;
  preferredLanguage_LT?: number | null;
  preferredLanguage_LTE?: number | null;
  preferredLanguage_SHORTEST_EQUAL?: number | null;
  preferredLanguage_SHORTEST_GT?: number | null;
  preferredLanguage_SHORTEST_GTE?: number | null;
  preferredLanguage_SHORTEST_LT?: number | null;
  preferredLanguage_SHORTEST_LTE?: number | null;
  tenantId_AVERAGE_EQUAL?: number | null;
  tenantId_AVERAGE_GT?: number | null;
  tenantId_AVERAGE_GTE?: number | null;
  tenantId_AVERAGE_LT?: number | null;
  tenantId_AVERAGE_LTE?: number | null;
  tenantId_EQUAL?: string | null;
  tenantId_GT?: number | null;
  tenantId_GTE?: number | null;
  tenantId_LONGEST_EQUAL?: number | null;
  tenantId_LONGEST_GT?: number | null;
  tenantId_LONGEST_GTE?: number | null;
  tenantId_LONGEST_LT?: number | null;
  tenantId_LONGEST_LTE?: number | null;
  tenantId_LT?: number | null;
  tenantId_LTE?: number | null;
  tenantId_SHORTEST_EQUAL?: number | null;
  tenantId_SHORTEST_GT?: number | null;
  tenantId_SHORTEST_GTE?: number | null;
  tenantId_SHORTEST_LT?: number | null;
  tenantId_SHORTEST_LTE?: number | null;
}

export interface BaseAgreementScenariosAggregateInput {
  AND?: BaseAgreementScenariosAggregateInput[] | null;
  OR?: BaseAgreementScenariosAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: BaseAgreementScenariosNodeAggregationWhereInput | null;
}

export interface BaseAgreementScenariosConnectionWhere {
  AND?: BaseAgreementScenariosConnectionWhere[] | null;
  OR?: BaseAgreementScenariosConnectionWhere[] | null;
  node?: ScenarioWhere | null;
  node_NOT?: ScenarioWhere | null;
}

export interface BaseAgreementScenariosNodeAggregationWhereInput {
  AND?: BaseAgreementScenariosNodeAggregationWhereInput[] | null;
  OR?: BaseAgreementScenariosNodeAggregationWhereInput[] | null;
  group_AVERAGE_EQUAL?: number | null;
  group_AVERAGE_GT?: number | null;
  group_AVERAGE_GTE?: number | null;
  group_AVERAGE_LT?: number | null;
  group_AVERAGE_LTE?: number | null;
  group_EQUAL?: number | null;
  group_GT?: number | null;
  group_GTE?: number | null;
  group_LT?: number | null;
  group_LTE?: number | null;
  group_MAX_EQUAL?: number | null;
  group_MAX_GT?: number | null;
  group_MAX_GTE?: number | null;
  group_MAX_LT?: number | null;
  group_MAX_LTE?: number | null;
  group_MIN_EQUAL?: number | null;
  group_MIN_GT?: number | null;
  group_MIN_GTE?: number | null;
  group_MIN_LT?: number | null;
  group_MIN_LTE?: number | null;
  group_SUM_EQUAL?: number | null;
  group_SUM_GT?: number | null;
  group_SUM_GTE?: number | null;
  group_SUM_LT?: number | null;
  group_SUM_LTE?: number | null;
  order_AVERAGE_EQUAL?: number | null;
  order_AVERAGE_GT?: number | null;
  order_AVERAGE_GTE?: number | null;
  order_AVERAGE_LT?: number | null;
  order_AVERAGE_LTE?: number | null;
  order_EQUAL?: number | null;
  order_GT?: number | null;
  order_GTE?: number | null;
  order_LT?: number | null;
  order_LTE?: number | null;
  order_MAX_EQUAL?: number | null;
  order_MAX_GT?: number | null;
  order_MAX_GTE?: number | null;
  order_MAX_LT?: number | null;
  order_MAX_LTE?: number | null;
  order_MIN_EQUAL?: number | null;
  order_MIN_GT?: number | null;
  order_MIN_GTE?: number | null;
  order_MIN_LT?: number | null;
  order_MIN_LTE?: number | null;
  order_SUM_EQUAL?: number | null;
  order_SUM_GT?: number | null;
  order_SUM_GTE?: number | null;
  order_SUM_LT?: number | null;
  order_SUM_LTE?: number | null;
}

export interface BaseAgreementScenariosRelevantBrandsAggregateInput {
  AND?: BaseAgreementScenariosRelevantBrandsAggregateInput[] | null;
  OR?: BaseAgreementScenariosRelevantBrandsAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: BaseAgreementScenariosRelevantBrandsNodeAggregationWhereInput | null;
}

export interface BaseAgreementScenariosRelevantBrandsConnectionWhere {
  AND?: BaseAgreementScenariosRelevantBrandsConnectionWhere[] | null;
  OR?: BaseAgreementScenariosRelevantBrandsConnectionWhere[] | null;
  node?: BrandWhere | null;
  node_NOT?: BrandWhere | null;
}

export interface BaseAgreementScenariosRelevantBrandsNodeAggregationWhereInput {
  AND?: BaseAgreementScenariosRelevantBrandsNodeAggregationWhereInput[] | null;
  Name_AVERAGE_EQUAL?: number | null;
  Name_AVERAGE_GT?: number | null;
  Name_AVERAGE_GTE?: number | null;
  Name_AVERAGE_LT?: number | null;
  Name_AVERAGE_LTE?: number | null;
  Name_EQUAL?: string | null;
  Name_GT?: number | null;
  Name_GTE?: number | null;
  Name_LONGEST_EQUAL?: number | null;
  Name_LONGEST_GT?: number | null;
  Name_LONGEST_GTE?: number | null;
  Name_LONGEST_LT?: number | null;
  Name_LONGEST_LTE?: number | null;
  Name_LT?: number | null;
  Name_LTE?: number | null;
  Name_SHORTEST_EQUAL?: number | null;
  Name_SHORTEST_GT?: number | null;
  Name_SHORTEST_GTE?: number | null;
  Name_SHORTEST_LT?: number | null;
  Name_SHORTEST_LTE?: number | null;
  OR?: BaseAgreementScenariosRelevantBrandsNodeAggregationWhereInput[] | null;
  id_EQUAL?: string | null;
}

export interface BaseAgreementStatusTransitionsAggregateInput {
  AND?: BaseAgreementStatusTransitionsAggregateInput[] | null;
  OR?: BaseAgreementStatusTransitionsAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: BaseAgreementStatusTransitionsNodeAggregationWhereInput | null;
}

export interface BaseAgreementStatusTransitionsConnectionWhere {
  AND?: BaseAgreementStatusTransitionsConnectionWhere[] | null;
  OR?: BaseAgreementStatusTransitionsConnectionWhere[] | null;
  node?: AgreementStatusTransitionWhere | null;
  node_NOT?: AgreementStatusTransitionWhere | null;
}

export interface BaseAgreementStatusTransitionsNodeAggregationWhereInput {
  AND?: BaseAgreementStatusTransitionsNodeAggregationWhereInput[] | null;
  OR?: BaseAgreementStatusTransitionsNodeAggregationWhereInput[] | null;
  createdOn_EQUAL?: any | null;
  createdOn_GT?: any | null;
  createdOn_GTE?: any | null;
  createdOn_LT?: any | null;
  createdOn_LTE?: any | null;
  createdOn_MAX_EQUAL?: any | null;
  createdOn_MAX_GT?: any | null;
  createdOn_MAX_GTE?: any | null;
  createdOn_MAX_LT?: any | null;
  createdOn_MAX_LTE?: any | null;
  createdOn_MIN_EQUAL?: any | null;
  createdOn_MIN_GT?: any | null;
  createdOn_MIN_GTE?: any | null;
  createdOn_MIN_LT?: any | null;
  createdOn_MIN_LTE?: any | null;
}

export interface BaseAgreementTagsAggregateInput {
  AND?: BaseAgreementTagsAggregateInput[] | null;
  OR?: BaseAgreementTagsAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: BaseAgreementTagsNodeAggregationWhereInput | null;
}

export interface BaseAgreementTagsConnectionWhere {
  AND?: BaseAgreementTagsConnectionWhere[] | null;
  OR?: BaseAgreementTagsConnectionWhere[] | null;
  node?: AgreementTagWhere | null;
  node_NOT?: AgreementTagWhere | null;
}

export interface BaseAgreementTagsNodeAggregationWhereInput {
  AND?: BaseAgreementTagsNodeAggregationWhereInput[] | null;
  OR?: BaseAgreementTagsNodeAggregationWhereInput[] | null;
  id_AVERAGE_EQUAL?: number | null;
  id_AVERAGE_GT?: number | null;
  id_AVERAGE_GTE?: number | null;
  id_AVERAGE_LT?: number | null;
  id_AVERAGE_LTE?: number | null;
  id_EQUAL?: number | null;
  id_GT?: number | null;
  id_GTE?: number | null;
  id_LT?: number | null;
  id_LTE?: number | null;
  id_MAX_EQUAL?: number | null;
  id_MAX_GT?: number | null;
  id_MAX_GTE?: number | null;
  id_MAX_LT?: number | null;
  id_MAX_LTE?: number | null;
  id_MIN_EQUAL?: number | null;
  id_MIN_GT?: number | null;
  id_MIN_GTE?: number | null;
  id_MIN_LT?: number | null;
  id_MIN_LTE?: number | null;
  id_SUM_EQUAL?: number | null;
  id_SUM_GT?: number | null;
  id_SUM_GTE?: number | null;
  id_SUM_LT?: number | null;
  id_SUM_LTE?: number | null;
  name_AVERAGE_EQUAL?: number | null;
  name_AVERAGE_GT?: number | null;
  name_AVERAGE_GTE?: number | null;
  name_AVERAGE_LT?: number | null;
  name_AVERAGE_LTE?: number | null;
  name_EQUAL?: string | null;
  name_GT?: number | null;
  name_GTE?: number | null;
  name_LONGEST_EQUAL?: number | null;
  name_LONGEST_GT?: number | null;
  name_LONGEST_GTE?: number | null;
  name_LONGEST_LT?: number | null;
  name_LONGEST_LTE?: number | null;
  name_LT?: number | null;
  name_LTE?: number | null;
  name_SHORTEST_EQUAL?: number | null;
  name_SHORTEST_GT?: number | null;
  name_SHORTEST_GTE?: number | null;
  name_SHORTEST_LT?: number | null;
  name_SHORTEST_LTE?: number | null;
}

export interface BaseAgreementTreatmentPriceRelationshipWhere {
  AND?: BaseAgreementTreatmentPriceRelationshipWhere[] | null;
  OR?: BaseAgreementTreatmentPriceRelationshipWhere[] | null;
  basePriceType?: PriceType | null;
  basePriceType_IN?: (PriceType | null)[] | null;
  basePriceType_NOT?: PriceType | null;
  basePriceType_NOT_IN?: (PriceType | null)[] | null;
  price?: number | null;
  price_GT?: number | null;
  price_GTE?: number | null;
  price_IN?: (number | null)[] | null;
  price_LT?: number | null;
  price_LTE?: number | null;
  price_NOT?: number | null;
  price_NOT_IN?: (number | null)[] | null;
}

export interface BaseAgreementTreatmentPricesAggregateInput {
  AND?: BaseAgreementTreatmentPricesAggregateInput[] | null;
  OR?: BaseAgreementTreatmentPricesAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  edge?: BaseAgreementTreatmentPricesEdgeAggregationWhereInput | null;
  node?: BaseAgreementTreatmentPricesNodeAggregationWhereInput | null;
}

export interface BaseAgreementTreatmentPricesConnectionWhere {
  AND?: BaseAgreementTreatmentPricesConnectionWhere[] | null;
  OR?: BaseAgreementTreatmentPricesConnectionWhere[] | null;
  edge?: BaseAgreementTreatmentPriceRelationshipWhere | null;
  edge_NOT?: BaseAgreementTreatmentPriceRelationshipWhere | null;
  node?: TreatmentWhere | null;
  node_NOT?: TreatmentWhere | null;
}

export interface BaseAgreementTreatmentPricesEdgeAggregationWhereInput {
  AND?: BaseAgreementTreatmentPricesEdgeAggregationWhereInput[] | null;
  OR?: BaseAgreementTreatmentPricesEdgeAggregationWhereInput[] | null;
  price_AVERAGE_EQUAL?: number | null;
  price_AVERAGE_GT?: number | null;
  price_AVERAGE_GTE?: number | null;
  price_AVERAGE_LT?: number | null;
  price_AVERAGE_LTE?: number | null;
  price_EQUAL?: number | null;
  price_GT?: number | null;
  price_GTE?: number | null;
  price_LT?: number | null;
  price_LTE?: number | null;
  price_MAX_EQUAL?: number | null;
  price_MAX_GT?: number | null;
  price_MAX_GTE?: number | null;
  price_MAX_LT?: number | null;
  price_MAX_LTE?: number | null;
  price_MIN_EQUAL?: number | null;
  price_MIN_GT?: number | null;
  price_MIN_GTE?: number | null;
  price_MIN_LT?: number | null;
  price_MIN_LTE?: number | null;
  price_SUM_EQUAL?: number | null;
  price_SUM_GT?: number | null;
  price_SUM_GTE?: number | null;
  price_SUM_LT?: number | null;
  price_SUM_LTE?: number | null;
}

export interface BaseAgreementTreatmentPricesNodeAggregationWhereInput {
  AND?: BaseAgreementTreatmentPricesNodeAggregationWhereInput[] | null;
  BagDossierNo_AVERAGE_EQUAL?: number | null;
  BagDossierNo_AVERAGE_GT?: number | null;
  BagDossierNo_AVERAGE_GTE?: number | null;
  BagDossierNo_AVERAGE_LT?: number | null;
  BagDossierNo_AVERAGE_LTE?: number | null;
  BagDossierNo_EQUAL?: string | null;
  BagDossierNo_GT?: number | null;
  BagDossierNo_GTE?: number | null;
  BagDossierNo_LONGEST_EQUAL?: number | null;
  BagDossierNo_LONGEST_GT?: number | null;
  BagDossierNo_LONGEST_GTE?: number | null;
  BagDossierNo_LONGEST_LT?: number | null;
  BagDossierNo_LONGEST_LTE?: number | null;
  BagDossierNo_LT?: number | null;
  BagDossierNo_LTE?: number | null;
  BagDossierNo_SHORTEST_EQUAL?: number | null;
  BagDossierNo_SHORTEST_GT?: number | null;
  BagDossierNo_SHORTEST_GTE?: number | null;
  BagDossierNo_SHORTEST_LT?: number | null;
  BagDossierNo_SHORTEST_LTE?: number | null;
  Code_AVERAGE_EQUAL?: number | null;
  Code_AVERAGE_GT?: number | null;
  Code_AVERAGE_GTE?: number | null;
  Code_AVERAGE_LT?: number | null;
  Code_AVERAGE_LTE?: number | null;
  Code_EQUAL?: string | null;
  Code_GT?: number | null;
  Code_GTE?: number | null;
  Code_LONGEST_EQUAL?: number | null;
  Code_LONGEST_GT?: number | null;
  Code_LONGEST_GTE?: number | null;
  Code_LONGEST_LT?: number | null;
  Code_LONGEST_LTE?: number | null;
  Code_LT?: number | null;
  Code_LTE?: number | null;
  Code_SHORTEST_EQUAL?: number | null;
  Code_SHORTEST_GT?: number | null;
  Code_SHORTEST_GTE?: number | null;
  Code_SHORTEST_LT?: number | null;
  Code_SHORTEST_LTE?: number | null;
  FlagModal_AVERAGE_EQUAL?: number | null;
  FlagModal_AVERAGE_GT?: number | null;
  FlagModal_AVERAGE_GTE?: number | null;
  FlagModal_AVERAGE_LT?: number | null;
  FlagModal_AVERAGE_LTE?: number | null;
  FlagModal_EQUAL?: string | null;
  FlagModal_GT?: number | null;
  FlagModal_GTE?: number | null;
  FlagModal_LONGEST_EQUAL?: number | null;
  FlagModal_LONGEST_GT?: number | null;
  FlagModal_LONGEST_GTE?: number | null;
  FlagModal_LONGEST_LT?: number | null;
  FlagModal_LONGEST_LTE?: number | null;
  FlagModal_LT?: number | null;
  FlagModal_LTE?: number | null;
  FlagModal_SHORTEST_EQUAL?: number | null;
  FlagModal_SHORTEST_GT?: number | null;
  FlagModal_SHORTEST_GTE?: number | null;
  FlagModal_SHORTEST_LT?: number | null;
  FlagModal_SHORTEST_LTE?: number | null;
  FlagNarcosis_AVERAGE_EQUAL?: number | null;
  FlagNarcosis_AVERAGE_GT?: number | null;
  FlagNarcosis_AVERAGE_GTE?: number | null;
  FlagNarcosis_AVERAGE_LT?: number | null;
  FlagNarcosis_AVERAGE_LTE?: number | null;
  FlagNarcosis_EQUAL?: string | null;
  FlagNarcosis_GT?: number | null;
  FlagNarcosis_GTE?: number | null;
  FlagNarcosis_LONGEST_EQUAL?: number | null;
  FlagNarcosis_LONGEST_GT?: number | null;
  FlagNarcosis_LONGEST_GTE?: number | null;
  FlagNarcosis_LONGEST_LT?: number | null;
  FlagNarcosis_LONGEST_LTE?: number | null;
  FlagNarcosis_LT?: number | null;
  FlagNarcosis_LTE?: number | null;
  FlagNarcosis_SHORTEST_EQUAL?: number | null;
  FlagNarcosis_SHORTEST_GT?: number | null;
  FlagNarcosis_SHORTEST_GTE?: number | null;
  FlagNarcosis_SHORTEST_LT?: number | null;
  FlagNarcosis_SHORTEST_LTE?: number | null;
  GTIN_AVERAGE_EQUAL?: number | null;
  GTIN_AVERAGE_GT?: number | null;
  GTIN_AVERAGE_GTE?: number | null;
  GTIN_AVERAGE_LT?: number | null;
  GTIN_AVERAGE_LTE?: number | null;
  GTIN_EQUAL?: string | null;
  GTIN_GT?: number | null;
  GTIN_GTE?: number | null;
  GTIN_LONGEST_EQUAL?: number | null;
  GTIN_LONGEST_GT?: number | null;
  GTIN_LONGEST_GTE?: number | null;
  GTIN_LONGEST_LT?: number | null;
  GTIN_LONGEST_LTE?: number | null;
  GTIN_LT?: number | null;
  GTIN_LTE?: number | null;
  GTIN_SHORTEST_EQUAL?: number | null;
  GTIN_SHORTEST_GT?: number | null;
  GTIN_SHORTEST_GTE?: number | null;
  GTIN_SHORTEST_LT?: number | null;
  GTIN_SHORTEST_LTE?: number | null;
  LOT_AVERAGE_EQUAL?: number | null;
  LOT_AVERAGE_GT?: number | null;
  LOT_AVERAGE_GTE?: number | null;
  LOT_AVERAGE_LT?: number | null;
  LOT_AVERAGE_LTE?: number | null;
  LOT_EQUAL?: string | null;
  LOT_GT?: number | null;
  LOT_GTE?: number | null;
  LOT_LONGEST_EQUAL?: number | null;
  LOT_LONGEST_GT?: number | null;
  LOT_LONGEST_GTE?: number | null;
  LOT_LONGEST_LT?: number | null;
  LOT_LONGEST_LTE?: number | null;
  LOT_LT?: number | null;
  LOT_LTE?: number | null;
  LOT_SHORTEST_EQUAL?: number | null;
  LOT_SHORTEST_GT?: number | null;
  LOT_SHORTEST_GTE?: number | null;
  LOT_SHORTEST_LT?: number | null;
  LOT_SHORTEST_LTE?: number | null;
  Name_AVERAGE_EQUAL?: number | null;
  Name_AVERAGE_GT?: number | null;
  Name_AVERAGE_GTE?: number | null;
  Name_AVERAGE_LT?: number | null;
  Name_AVERAGE_LTE?: number | null;
  Name_EQUAL?: string | null;
  Name_GT?: number | null;
  Name_GTE?: number | null;
  Name_LONGEST_EQUAL?: number | null;
  Name_LONGEST_GT?: number | null;
  Name_LONGEST_GTE?: number | null;
  Name_LONGEST_LT?: number | null;
  Name_LONGEST_LTE?: number | null;
  Name_LT?: number | null;
  Name_LTE?: number | null;
  Name_SHORTEST_EQUAL?: number | null;
  Name_SHORTEST_GT?: number | null;
  Name_SHORTEST_GTE?: number | null;
  Name_SHORTEST_LT?: number | null;
  Name_SHORTEST_LTE?: number | null;
  OR?: BaseAgreementTreatmentPricesNodeAggregationWhereInput[] | null;
  PharmaCode_AVERAGE_EQUAL?: number | null;
  PharmaCode_AVERAGE_GT?: number | null;
  PharmaCode_AVERAGE_GTE?: number | null;
  PharmaCode_AVERAGE_LT?: number | null;
  PharmaCode_AVERAGE_LTE?: number | null;
  PharmaCode_EQUAL?: string | null;
  PharmaCode_GT?: number | null;
  PharmaCode_GTE?: number | null;
  PharmaCode_LONGEST_EQUAL?: number | null;
  PharmaCode_LONGEST_GT?: number | null;
  PharmaCode_LONGEST_GTE?: number | null;
  PharmaCode_LONGEST_LT?: number | null;
  PharmaCode_LONGEST_LTE?: number | null;
  PharmaCode_LT?: number | null;
  PharmaCode_LTE?: number | null;
  PharmaCode_SHORTEST_EQUAL?: number | null;
  PharmaCode_SHORTEST_GT?: number | null;
  PharmaCode_SHORTEST_GTE?: number | null;
  PharmaCode_SHORTEST_LT?: number | null;
  PharmaCode_SHORTEST_LTE?: number | null;
  PrevPharmacode_AVERAGE_EQUAL?: number | null;
  PrevPharmacode_AVERAGE_GT?: number | null;
  PrevPharmacode_AVERAGE_GTE?: number | null;
  PrevPharmacode_AVERAGE_LT?: number | null;
  PrevPharmacode_AVERAGE_LTE?: number | null;
  PrevPharmacode_EQUAL?: string | null;
  PrevPharmacode_GT?: number | null;
  PrevPharmacode_GTE?: number | null;
  PrevPharmacode_LONGEST_EQUAL?: number | null;
  PrevPharmacode_LONGEST_GT?: number | null;
  PrevPharmacode_LONGEST_GTE?: number | null;
  PrevPharmacode_LONGEST_LT?: number | null;
  PrevPharmacode_LONGEST_LTE?: number | null;
  PrevPharmacode_LT?: number | null;
  PrevPharmacode_LTE?: number | null;
  PrevPharmacode_SHORTEST_EQUAL?: number | null;
  PrevPharmacode_SHORTEST_GT?: number | null;
  PrevPharmacode_SHORTEST_GTE?: number | null;
  PrevPharmacode_SHORTEST_LT?: number | null;
  PrevPharmacode_SHORTEST_LTE?: number | null;
  REF_AVERAGE_EQUAL?: number | null;
  REF_AVERAGE_GT?: number | null;
  REF_AVERAGE_GTE?: number | null;
  REF_AVERAGE_LT?: number | null;
  REF_AVERAGE_LTE?: number | null;
  REF_EQUAL?: string | null;
  REF_GT?: number | null;
  REF_GTE?: number | null;
  REF_LONGEST_EQUAL?: number | null;
  REF_LONGEST_GT?: number | null;
  REF_LONGEST_GTE?: number | null;
  REF_LONGEST_LT?: number | null;
  REF_LONGEST_LTE?: number | null;
  REF_LT?: number | null;
  REF_LTE?: number | null;
  REF_SHORTEST_EQUAL?: number | null;
  REF_SHORTEST_GT?: number | null;
  REF_SHORTEST_GTE?: number | null;
  REF_SHORTEST_LT?: number | null;
  REF_SHORTEST_LTE?: number | null;
  SwissmedicCategory_AVERAGE_EQUAL?: number | null;
  SwissmedicCategory_AVERAGE_GT?: number | null;
  SwissmedicCategory_AVERAGE_GTE?: number | null;
  SwissmedicCategory_AVERAGE_LT?: number | null;
  SwissmedicCategory_AVERAGE_LTE?: number | null;
  SwissmedicCategory_EQUAL?: string | null;
  SwissmedicCategory_GT?: number | null;
  SwissmedicCategory_GTE?: number | null;
  SwissmedicCategory_LONGEST_EQUAL?: number | null;
  SwissmedicCategory_LONGEST_GT?: number | null;
  SwissmedicCategory_LONGEST_GTE?: number | null;
  SwissmedicCategory_LONGEST_LT?: number | null;
  SwissmedicCategory_LONGEST_LTE?: number | null;
  SwissmedicCategory_LT?: number | null;
  SwissmedicCategory_LTE?: number | null;
  SwissmedicCategory_SHORTEST_EQUAL?: number | null;
  SwissmedicCategory_SHORTEST_GT?: number | null;
  SwissmedicCategory_SHORTEST_GTE?: number | null;
  SwissmedicCategory_SHORTEST_LT?: number | null;
  SwissmedicCategory_SHORTEST_LTE?: number | null;
  SwissmedicNo8_AVERAGE_EQUAL?: number | null;
  SwissmedicNo8_AVERAGE_GT?: number | null;
  SwissmedicNo8_AVERAGE_GTE?: number | null;
  SwissmedicNo8_AVERAGE_LT?: number | null;
  SwissmedicNo8_AVERAGE_LTE?: number | null;
  SwissmedicNo8_EQUAL?: string | null;
  SwissmedicNo8_GT?: number | null;
  SwissmedicNo8_GTE?: number | null;
  SwissmedicNo8_LONGEST_EQUAL?: number | null;
  SwissmedicNo8_LONGEST_GT?: number | null;
  SwissmedicNo8_LONGEST_GTE?: number | null;
  SwissmedicNo8_LONGEST_LT?: number | null;
  SwissmedicNo8_LONGEST_LTE?: number | null;
  SwissmedicNo8_LT?: number | null;
  SwissmedicNo8_LTE?: number | null;
  SwissmedicNo8_SHORTEST_EQUAL?: number | null;
  SwissmedicNo8_SHORTEST_GT?: number | null;
  SwissmedicNo8_SHORTEST_GTE?: number | null;
  SwissmedicNo8_SHORTEST_LT?: number | null;
  SwissmedicNo8_SHORTEST_LTE?: number | null;
  UDI_AVERAGE_EQUAL?: number | null;
  UDI_AVERAGE_GT?: number | null;
  UDI_AVERAGE_GTE?: number | null;
  UDI_AVERAGE_LT?: number | null;
  UDI_AVERAGE_LTE?: number | null;
  UDI_EQUAL?: string | null;
  UDI_GT?: number | null;
  UDI_GTE?: number | null;
  UDI_LONGEST_EQUAL?: number | null;
  UDI_LONGEST_GT?: number | null;
  UDI_LONGEST_GTE?: number | null;
  UDI_LONGEST_LT?: number | null;
  UDI_LONGEST_LTE?: number | null;
  UDI_LT?: number | null;
  UDI_LTE?: number | null;
  UDI_SHORTEST_EQUAL?: number | null;
  UDI_SHORTEST_GT?: number | null;
  UDI_SHORTEST_GTE?: number | null;
  UDI_SHORTEST_LT?: number | null;
  UDI_SHORTEST_LTE?: number | null;
  activeIngredientQuantity_AVERAGE_EQUAL?: number | null;
  activeIngredientQuantity_AVERAGE_GT?: number | null;
  activeIngredientQuantity_AVERAGE_GTE?: number | null;
  activeIngredientQuantity_AVERAGE_LT?: number | null;
  activeIngredientQuantity_AVERAGE_LTE?: number | null;
  activeIngredientQuantity_EQUAL?: number | null;
  activeIngredientQuantity_GT?: number | null;
  activeIngredientQuantity_GTE?: number | null;
  activeIngredientQuantity_LT?: number | null;
  activeIngredientQuantity_LTE?: number | null;
  activeIngredientQuantity_MAX_EQUAL?: number | null;
  activeIngredientQuantity_MAX_GT?: number | null;
  activeIngredientQuantity_MAX_GTE?: number | null;
  activeIngredientQuantity_MAX_LT?: number | null;
  activeIngredientQuantity_MAX_LTE?: number | null;
  activeIngredientQuantity_MIN_EQUAL?: number | null;
  activeIngredientQuantity_MIN_GT?: number | null;
  activeIngredientQuantity_MIN_GTE?: number | null;
  activeIngredientQuantity_MIN_LT?: number | null;
  activeIngredientQuantity_MIN_LTE?: number | null;
  activeIngredientQuantity_SUM_EQUAL?: number | null;
  activeIngredientQuantity_SUM_GT?: number | null;
  activeIngredientQuantity_SUM_GTE?: number | null;
  activeIngredientQuantity_SUM_LT?: number | null;
  activeIngredientQuantity_SUM_LTE?: number | null;
  classificationSystem_AVERAGE_EQUAL?: number | null;
  classificationSystem_AVERAGE_GT?: number | null;
  classificationSystem_AVERAGE_GTE?: number | null;
  classificationSystem_AVERAGE_LT?: number | null;
  classificationSystem_AVERAGE_LTE?: number | null;
  classificationSystem_EQUAL?: string | null;
  classificationSystem_GT?: number | null;
  classificationSystem_GTE?: number | null;
  classificationSystem_LONGEST_EQUAL?: number | null;
  classificationSystem_LONGEST_GT?: number | null;
  classificationSystem_LONGEST_GTE?: number | null;
  classificationSystem_LONGEST_LT?: number | null;
  classificationSystem_LONGEST_LTE?: number | null;
  classificationSystem_LT?: number | null;
  classificationSystem_LTE?: number | null;
  classificationSystem_SHORTEST_EQUAL?: number | null;
  classificationSystem_SHORTEST_GT?: number | null;
  classificationSystem_SHORTEST_GTE?: number | null;
  classificationSystem_SHORTEST_LT?: number | null;
  classificationSystem_SHORTEST_LTE?: number | null;
  concentration_AVERAGE_EQUAL?: number | null;
  concentration_AVERAGE_GT?: number | null;
  concentration_AVERAGE_GTE?: number | null;
  concentration_AVERAGE_LT?: number | null;
  concentration_AVERAGE_LTE?: number | null;
  concentration_EQUAL?: string | null;
  concentration_GT?: number | null;
  concentration_GTE?: number | null;
  concentration_LONGEST_EQUAL?: number | null;
  concentration_LONGEST_GT?: number | null;
  concentration_LONGEST_GTE?: number | null;
  concentration_LONGEST_LT?: number | null;
  concentration_LONGEST_LTE?: number | null;
  concentration_LT?: number | null;
  concentration_LTE?: number | null;
  concentration_SHORTEST_EQUAL?: number | null;
  concentration_SHORTEST_GT?: number | null;
  concentration_SHORTEST_GTE?: number | null;
  concentration_SHORTEST_LT?: number | null;
  concentration_SHORTEST_LTE?: number | null;
  packVolume_AVERAGE_EQUAL?: number | null;
  packVolume_AVERAGE_GT?: number | null;
  packVolume_AVERAGE_GTE?: number | null;
  packVolume_AVERAGE_LT?: number | null;
  packVolume_AVERAGE_LTE?: number | null;
  packVolume_EQUAL?: string | null;
  packVolume_GT?: number | null;
  packVolume_GTE?: number | null;
  packVolume_LONGEST_EQUAL?: number | null;
  packVolume_LONGEST_GT?: number | null;
  packVolume_LONGEST_GTE?: number | null;
  packVolume_LONGEST_LT?: number | null;
  packVolume_LONGEST_LTE?: number | null;
  packVolume_LT?: number | null;
  packVolume_LTE?: number | null;
  packVolume_SHORTEST_EQUAL?: number | null;
  packVolume_SHORTEST_GT?: number | null;
  packVolume_SHORTEST_GTE?: number | null;
  packVolume_SHORTEST_LT?: number | null;
  packVolume_SHORTEST_LTE?: number | null;
}

export interface BaseAgreementUserContextsAggregateInput {
  AND?: BaseAgreementUserContextsAggregateInput[] | null;
  OR?: BaseAgreementUserContextsAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  edge?: BaseAgreementUserContextsEdgeAggregationWhereInput | null;
  node?: BaseAgreementUserContextsNodeAggregationWhereInput | null;
}

export interface BaseAgreementUserContextsConnectionWhere {
  AND?: BaseAgreementUserContextsConnectionWhere[] | null;
  OR?: BaseAgreementUserContextsConnectionWhere[] | null;
  edge?: ScenarioInsightsUserContextWhere | null;
  edge_NOT?: ScenarioInsightsUserContextWhere | null;
  node?: UserContextWhere | null;
  node_NOT?: UserContextWhere | null;
}

export interface BaseAgreementUserContextsEdgeAggregationWhereInput {
  AND?: BaseAgreementUserContextsEdgeAggregationWhereInput[] | null;
  OR?: BaseAgreementUserContextsEdgeAggregationWhereInput[] | null;
  categoryInput_AVERAGE_EQUAL?: number | null;
  categoryInput_AVERAGE_GT?: number | null;
  categoryInput_AVERAGE_GTE?: number | null;
  categoryInput_AVERAGE_LT?: number | null;
  categoryInput_AVERAGE_LTE?: number | null;
  categoryInput_EQUAL?: string | null;
  categoryInput_GT?: number | null;
  categoryInput_GTE?: number | null;
  categoryInput_LONGEST_EQUAL?: number | null;
  categoryInput_LONGEST_GT?: number | null;
  categoryInput_LONGEST_GTE?: number | null;
  categoryInput_LONGEST_LT?: number | null;
  categoryInput_LONGEST_LTE?: number | null;
  categoryInput_LT?: number | null;
  categoryInput_LTE?: number | null;
  categoryInput_SHORTEST_EQUAL?: number | null;
  categoryInput_SHORTEST_GT?: number | null;
  categoryInput_SHORTEST_GTE?: number | null;
  categoryInput_SHORTEST_LT?: number | null;
  categoryInput_SHORTEST_LTE?: number | null;
  rebateObjective_AVERAGE_EQUAL?: number | null;
  rebateObjective_AVERAGE_GT?: number | null;
  rebateObjective_AVERAGE_GTE?: number | null;
  rebateObjective_AVERAGE_LT?: number | null;
  rebateObjective_AVERAGE_LTE?: number | null;
  rebateObjective_EQUAL?: string | null;
  rebateObjective_GT?: number | null;
  rebateObjective_GTE?: number | null;
  rebateObjective_LONGEST_EQUAL?: number | null;
  rebateObjective_LONGEST_GT?: number | null;
  rebateObjective_LONGEST_GTE?: number | null;
  rebateObjective_LONGEST_LT?: number | null;
  rebateObjective_LONGEST_LTE?: number | null;
  rebateObjective_LT?: number | null;
  rebateObjective_LTE?: number | null;
  rebateObjective_SHORTEST_EQUAL?: number | null;
  rebateObjective_SHORTEST_GT?: number | null;
  rebateObjective_SHORTEST_GTE?: number | null;
  rebateObjective_SHORTEST_LT?: number | null;
  rebateObjective_SHORTEST_LTE?: number | null;
  timeframeLabel_AVERAGE_EQUAL?: number | null;
  timeframeLabel_AVERAGE_GT?: number | null;
  timeframeLabel_AVERAGE_GTE?: number | null;
  timeframeLabel_AVERAGE_LT?: number | null;
  timeframeLabel_AVERAGE_LTE?: number | null;
  timeframeLabel_EQUAL?: string | null;
  timeframeLabel_GT?: number | null;
  timeframeLabel_GTE?: number | null;
  timeframeLabel_LONGEST_EQUAL?: number | null;
  timeframeLabel_LONGEST_GT?: number | null;
  timeframeLabel_LONGEST_GTE?: number | null;
  timeframeLabel_LONGEST_LT?: number | null;
  timeframeLabel_LONGEST_LTE?: number | null;
  timeframeLabel_LT?: number | null;
  timeframeLabel_LTE?: number | null;
  timeframeLabel_SHORTEST_EQUAL?: number | null;
  timeframeLabel_SHORTEST_GT?: number | null;
  timeframeLabel_SHORTEST_GTE?: number | null;
  timeframeLabel_SHORTEST_LT?: number | null;
  timeframeLabel_SHORTEST_LTE?: number | null;
}

export interface BaseAgreementUserContextsNodeAggregationWhereInput {
  AND?: BaseAgreementUserContextsNodeAggregationWhereInput[] | null;
  OR?: BaseAgreementUserContextsNodeAggregationWhereInput[] | null;
  email_AVERAGE_EQUAL?: number | null;
  email_AVERAGE_GT?: number | null;
  email_AVERAGE_GTE?: number | null;
  email_AVERAGE_LT?: number | null;
  email_AVERAGE_LTE?: number | null;
  email_EQUAL?: string | null;
  email_GT?: number | null;
  email_GTE?: number | null;
  email_LONGEST_EQUAL?: number | null;
  email_LONGEST_GT?: number | null;
  email_LONGEST_GTE?: number | null;
  email_LONGEST_LT?: number | null;
  email_LONGEST_LTE?: number | null;
  email_LT?: number | null;
  email_LTE?: number | null;
  email_SHORTEST_EQUAL?: number | null;
  email_SHORTEST_GT?: number | null;
  email_SHORTEST_GTE?: number | null;
  email_SHORTEST_LT?: number | null;
  email_SHORTEST_LTE?: number | null;
  filterCaseLogs_AVERAGE_EQUAL?: number | null;
  filterCaseLogs_AVERAGE_GT?: number | null;
  filterCaseLogs_AVERAGE_GTE?: number | null;
  filterCaseLogs_AVERAGE_LT?: number | null;
  filterCaseLogs_AVERAGE_LTE?: number | null;
  filterCaseLogs_EQUAL?: string | null;
  filterCaseLogs_GT?: number | null;
  filterCaseLogs_GTE?: number | null;
  filterCaseLogs_LONGEST_EQUAL?: number | null;
  filterCaseLogs_LONGEST_GT?: number | null;
  filterCaseLogs_LONGEST_GTE?: number | null;
  filterCaseLogs_LONGEST_LT?: number | null;
  filterCaseLogs_LONGEST_LTE?: number | null;
  filterCaseLogs_LT?: number | null;
  filterCaseLogs_LTE?: number | null;
  filterCaseLogs_SHORTEST_EQUAL?: number | null;
  filterCaseLogs_SHORTEST_GT?: number | null;
  filterCaseLogs_SHORTEST_GTE?: number | null;
  filterCaseLogs_SHORTEST_LT?: number | null;
  filterCaseLogs_SHORTEST_LTE?: number | null;
  filtersAgreements_AVERAGE_EQUAL?: number | null;
  filtersAgreements_AVERAGE_GT?: number | null;
  filtersAgreements_AVERAGE_GTE?: number | null;
  filtersAgreements_AVERAGE_LT?: number | null;
  filtersAgreements_AVERAGE_LTE?: number | null;
  filtersAgreements_EQUAL?: string | null;
  filtersAgreements_GT?: number | null;
  filtersAgreements_GTE?: number | null;
  filtersAgreements_LONGEST_EQUAL?: number | null;
  filtersAgreements_LONGEST_GT?: number | null;
  filtersAgreements_LONGEST_GTE?: number | null;
  filtersAgreements_LONGEST_LT?: number | null;
  filtersAgreements_LONGEST_LTE?: number | null;
  filtersAgreements_LT?: number | null;
  filtersAgreements_LTE?: number | null;
  filtersAgreements_SHORTEST_EQUAL?: number | null;
  filtersAgreements_SHORTEST_GT?: number | null;
  filtersAgreements_SHORTEST_GTE?: number | null;
  filtersAgreements_SHORTEST_LT?: number | null;
  filtersAgreements_SHORTEST_LTE?: number | null;
  filtersCases_AVERAGE_EQUAL?: number | null;
  filtersCases_AVERAGE_GT?: number | null;
  filtersCases_AVERAGE_GTE?: number | null;
  filtersCases_AVERAGE_LT?: number | null;
  filtersCases_AVERAGE_LTE?: number | null;
  filtersCases_EQUAL?: string | null;
  filtersCases_GT?: number | null;
  filtersCases_GTE?: number | null;
  filtersCases_LONGEST_EQUAL?: number | null;
  filtersCases_LONGEST_GT?: number | null;
  filtersCases_LONGEST_GTE?: number | null;
  filtersCases_LONGEST_LT?: number | null;
  filtersCases_LONGEST_LTE?: number | null;
  filtersCases_LT?: number | null;
  filtersCases_LTE?: number | null;
  filtersCases_SHORTEST_EQUAL?: number | null;
  filtersCases_SHORTEST_GT?: number | null;
  filtersCases_SHORTEST_GTE?: number | null;
  filtersCases_SHORTEST_LT?: number | null;
  filtersCases_SHORTEST_LTE?: number | null;
  filtersDataForms_AVERAGE_EQUAL?: number | null;
  filtersDataForms_AVERAGE_GT?: number | null;
  filtersDataForms_AVERAGE_GTE?: number | null;
  filtersDataForms_AVERAGE_LT?: number | null;
  filtersDataForms_AVERAGE_LTE?: number | null;
  filtersDataForms_EQUAL?: string | null;
  filtersDataForms_GT?: number | null;
  filtersDataForms_GTE?: number | null;
  filtersDataForms_LONGEST_EQUAL?: number | null;
  filtersDataForms_LONGEST_GT?: number | null;
  filtersDataForms_LONGEST_GTE?: number | null;
  filtersDataForms_LONGEST_LT?: number | null;
  filtersDataForms_LONGEST_LTE?: number | null;
  filtersDataForms_LT?: number | null;
  filtersDataForms_LTE?: number | null;
  filtersDataForms_SHORTEST_EQUAL?: number | null;
  filtersDataForms_SHORTEST_GT?: number | null;
  filtersDataForms_SHORTEST_GTE?: number | null;
  filtersDataForms_SHORTEST_LT?: number | null;
  filtersDataForms_SHORTEST_LTE?: number | null;
  filtersDataRecords_AVERAGE_EQUAL?: number | null;
  filtersDataRecords_AVERAGE_GT?: number | null;
  filtersDataRecords_AVERAGE_GTE?: number | null;
  filtersDataRecords_AVERAGE_LT?: number | null;
  filtersDataRecords_AVERAGE_LTE?: number | null;
  filtersDataRecords_EQUAL?: string | null;
  filtersDataRecords_GT?: number | null;
  filtersDataRecords_GTE?: number | null;
  filtersDataRecords_LONGEST_EQUAL?: number | null;
  filtersDataRecords_LONGEST_GT?: number | null;
  filtersDataRecords_LONGEST_GTE?: number | null;
  filtersDataRecords_LONGEST_LT?: number | null;
  filtersDataRecords_LONGEST_LTE?: number | null;
  filtersDataRecords_LT?: number | null;
  filtersDataRecords_LTE?: number | null;
  filtersDataRecords_SHORTEST_EQUAL?: number | null;
  filtersDataRecords_SHORTEST_GT?: number | null;
  filtersDataRecords_SHORTEST_GTE?: number | null;
  filtersDataRecords_SHORTEST_LT?: number | null;
  filtersDataRecords_SHORTEST_LTE?: number | null;
  filtersDocuments_AVERAGE_EQUAL?: number | null;
  filtersDocuments_AVERAGE_GT?: number | null;
  filtersDocuments_AVERAGE_GTE?: number | null;
  filtersDocuments_AVERAGE_LT?: number | null;
  filtersDocuments_AVERAGE_LTE?: number | null;
  filtersDocuments_EQUAL?: string | null;
  filtersDocuments_GT?: number | null;
  filtersDocuments_GTE?: number | null;
  filtersDocuments_LONGEST_EQUAL?: number | null;
  filtersDocuments_LONGEST_GT?: number | null;
  filtersDocuments_LONGEST_GTE?: number | null;
  filtersDocuments_LONGEST_LT?: number | null;
  filtersDocuments_LONGEST_LTE?: number | null;
  filtersDocuments_LT?: number | null;
  filtersDocuments_LTE?: number | null;
  filtersDocuments_SHORTEST_EQUAL?: number | null;
  filtersDocuments_SHORTEST_GT?: number | null;
  filtersDocuments_SHORTEST_GTE?: number | null;
  filtersDocuments_SHORTEST_LT?: number | null;
  filtersDocuments_SHORTEST_LTE?: number | null;
  filtersRefunds_AVERAGE_EQUAL?: number | null;
  filtersRefunds_AVERAGE_GT?: number | null;
  filtersRefunds_AVERAGE_GTE?: number | null;
  filtersRefunds_AVERAGE_LT?: number | null;
  filtersRefunds_AVERAGE_LTE?: number | null;
  filtersRefunds_EQUAL?: string | null;
  filtersRefunds_GT?: number | null;
  filtersRefunds_GTE?: number | null;
  filtersRefunds_LONGEST_EQUAL?: number | null;
  filtersRefunds_LONGEST_GT?: number | null;
  filtersRefunds_LONGEST_GTE?: number | null;
  filtersRefunds_LONGEST_LT?: number | null;
  filtersRefunds_LONGEST_LTE?: number | null;
  filtersRefunds_LT?: number | null;
  filtersRefunds_LTE?: number | null;
  filtersRefunds_SHORTEST_EQUAL?: number | null;
  filtersRefunds_SHORTEST_GT?: number | null;
  filtersRefunds_SHORTEST_GTE?: number | null;
  filtersRefunds_SHORTEST_LT?: number | null;
  filtersRefunds_SHORTEST_LTE?: number | null;
  filtersSimulations_AVERAGE_EQUAL?: number | null;
  filtersSimulations_AVERAGE_GT?: number | null;
  filtersSimulations_AVERAGE_GTE?: number | null;
  filtersSimulations_AVERAGE_LT?: number | null;
  filtersSimulations_AVERAGE_LTE?: number | null;
  filtersSimulations_EQUAL?: string | null;
  filtersSimulations_GT?: number | null;
  filtersSimulations_GTE?: number | null;
  filtersSimulations_LONGEST_EQUAL?: number | null;
  filtersSimulations_LONGEST_GT?: number | null;
  filtersSimulations_LONGEST_GTE?: number | null;
  filtersSimulations_LONGEST_LT?: number | null;
  filtersSimulations_LONGEST_LTE?: number | null;
  filtersSimulations_LT?: number | null;
  filtersSimulations_LTE?: number | null;
  filtersSimulations_SHORTEST_EQUAL?: number | null;
  filtersSimulations_SHORTEST_GT?: number | null;
  filtersSimulations_SHORTEST_GTE?: number | null;
  filtersSimulations_SHORTEST_LT?: number | null;
  filtersSimulations_SHORTEST_LTE?: number | null;
  timePeriodCaseDetails_AVERAGE_EQUAL?: number | null;
  timePeriodCaseDetails_AVERAGE_GT?: number | null;
  timePeriodCaseDetails_AVERAGE_GTE?: number | null;
  timePeriodCaseDetails_AVERAGE_LT?: number | null;
  timePeriodCaseDetails_AVERAGE_LTE?: number | null;
  timePeriodCaseDetails_EQUAL?: string | null;
  timePeriodCaseDetails_GT?: number | null;
  timePeriodCaseDetails_GTE?: number | null;
  timePeriodCaseDetails_LONGEST_EQUAL?: number | null;
  timePeriodCaseDetails_LONGEST_GT?: number | null;
  timePeriodCaseDetails_LONGEST_GTE?: number | null;
  timePeriodCaseDetails_LONGEST_LT?: number | null;
  timePeriodCaseDetails_LONGEST_LTE?: number | null;
  timePeriodCaseDetails_LT?: number | null;
  timePeriodCaseDetails_LTE?: number | null;
  timePeriodCaseDetails_SHORTEST_EQUAL?: number | null;
  timePeriodCaseDetails_SHORTEST_GT?: number | null;
  timePeriodCaseDetails_SHORTEST_GTE?: number | null;
  timePeriodCaseDetails_SHORTEST_LT?: number | null;
  timePeriodCaseDetails_SHORTEST_LTE?: number | null;
  timePeriodFilterDashboard_AVERAGE_EQUAL?: number | null;
  timePeriodFilterDashboard_AVERAGE_GT?: number | null;
  timePeriodFilterDashboard_AVERAGE_GTE?: number | null;
  timePeriodFilterDashboard_AVERAGE_LT?: number | null;
  timePeriodFilterDashboard_AVERAGE_LTE?: number | null;
  timePeriodFilterDashboard_EQUAL?: string | null;
  timePeriodFilterDashboard_GT?: number | null;
  timePeriodFilterDashboard_GTE?: number | null;
  timePeriodFilterDashboard_LONGEST_EQUAL?: number | null;
  timePeriodFilterDashboard_LONGEST_GT?: number | null;
  timePeriodFilterDashboard_LONGEST_GTE?: number | null;
  timePeriodFilterDashboard_LONGEST_LT?: number | null;
  timePeriodFilterDashboard_LONGEST_LTE?: number | null;
  timePeriodFilterDashboard_LT?: number | null;
  timePeriodFilterDashboard_LTE?: number | null;
  timePeriodFilterDashboard_SHORTEST_EQUAL?: number | null;
  timePeriodFilterDashboard_SHORTEST_GT?: number | null;
  timePeriodFilterDashboard_SHORTEST_GTE?: number | null;
  timePeriodFilterDashboard_SHORTEST_LT?: number | null;
  timePeriodFilterDashboard_SHORTEST_LTE?: number | null;
  timePeriodFilterHome_AVERAGE_EQUAL?: number | null;
  timePeriodFilterHome_AVERAGE_GT?: number | null;
  timePeriodFilterHome_AVERAGE_GTE?: number | null;
  timePeriodFilterHome_AVERAGE_LT?: number | null;
  timePeriodFilterHome_AVERAGE_LTE?: number | null;
  timePeriodFilterHome_EQUAL?: string | null;
  timePeriodFilterHome_GT?: number | null;
  timePeriodFilterHome_GTE?: number | null;
  timePeriodFilterHome_LONGEST_EQUAL?: number | null;
  timePeriodFilterHome_LONGEST_GT?: number | null;
  timePeriodFilterHome_LONGEST_GTE?: number | null;
  timePeriodFilterHome_LONGEST_LT?: number | null;
  timePeriodFilterHome_LONGEST_LTE?: number | null;
  timePeriodFilterHome_LT?: number | null;
  timePeriodFilterHome_LTE?: number | null;
  timePeriodFilterHome_SHORTEST_EQUAL?: number | null;
  timePeriodFilterHome_SHORTEST_GT?: number | null;
  timePeriodFilterHome_SHORTEST_GTE?: number | null;
  timePeriodFilterHome_SHORTEST_LT?: number | null;
  timePeriodFilterHome_SHORTEST_LTE?: number | null;
  timePeriodFilterReporting_AVERAGE_EQUAL?: number | null;
  timePeriodFilterReporting_AVERAGE_GT?: number | null;
  timePeriodFilterReporting_AVERAGE_GTE?: number | null;
  timePeriodFilterReporting_AVERAGE_LT?: number | null;
  timePeriodFilterReporting_AVERAGE_LTE?: number | null;
  timePeriodFilterReporting_EQUAL?: string | null;
  timePeriodFilterReporting_GT?: number | null;
  timePeriodFilterReporting_GTE?: number | null;
  timePeriodFilterReporting_LONGEST_EQUAL?: number | null;
  timePeriodFilterReporting_LONGEST_GT?: number | null;
  timePeriodFilterReporting_LONGEST_GTE?: number | null;
  timePeriodFilterReporting_LONGEST_LT?: number | null;
  timePeriodFilterReporting_LONGEST_LTE?: number | null;
  timePeriodFilterReporting_LT?: number | null;
  timePeriodFilterReporting_LTE?: number | null;
  timePeriodFilterReporting_SHORTEST_EQUAL?: number | null;
  timePeriodFilterReporting_SHORTEST_GT?: number | null;
  timePeriodFilterReporting_SHORTEST_GTE?: number | null;
  timePeriodFilterReporting_SHORTEST_LT?: number | null;
  timePeriodFilterReporting_SHORTEST_LTE?: number | null;
}

export interface BaseAgreementUserRoleRelationshipWhere {
  AND?: BaseAgreementUserRoleRelationshipWhere[] | null;
  OR?: BaseAgreementUserRoleRelationshipWhere[] | null;
  canApprove?: boolean | null;
  canApprove_NOT?: boolean | null;
  canModifyFinancials?: boolean | null;
  canModifyFinancials_NOT?: boolean | null;
  canViewFinancials?: boolean | null;
  canViewFinancials_NOT?: boolean | null;
  isAssignee?: boolean | null;
  isAssignee_NOT?: boolean | null;
  role?: AgreementUserRole | null;
  role_IN?: (AgreementUserRole | null)[] | null;
  role_NOT?: AgreementUserRole | null;
  role_NOT_IN?: (AgreementUserRole | null)[] | null;
}

export interface BaseAgreementUserRolesAggregateInput {
  AND?: BaseAgreementUserRolesAggregateInput[] | null;
  OR?: BaseAgreementUserRolesAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: BaseAgreementUserRolesNodeAggregationWhereInput | null;
}

export interface BaseAgreementUserRolesConnectionWhere {
  AND?: BaseAgreementUserRolesConnectionWhere[] | null;
  OR?: BaseAgreementUserRolesConnectionWhere[] | null;
  edge?: BaseAgreementUserRoleRelationshipWhere | null;
  edge_NOT?: BaseAgreementUserRoleRelationshipWhere | null;
  node?: UserWhere | null;
  node_NOT?: UserWhere | null;
}

export interface BaseAgreementUserRolesNodeAggregationWhereInput {
  AND?: BaseAgreementUserRolesNodeAggregationWhereInput[] | null;
  OR?: BaseAgreementUserRolesNodeAggregationWhereInput[] | null;
  deletedOn_EQUAL?: any | null;
  deletedOn_GT?: any | null;
  deletedOn_GTE?: any | null;
  deletedOn_LT?: any | null;
  deletedOn_LTE?: any | null;
  deletedOn_MAX_EQUAL?: any | null;
  deletedOn_MAX_GT?: any | null;
  deletedOn_MAX_GTE?: any | null;
  deletedOn_MAX_LT?: any | null;
  deletedOn_MAX_LTE?: any | null;
  deletedOn_MIN_EQUAL?: any | null;
  deletedOn_MIN_GT?: any | null;
  deletedOn_MIN_GTE?: any | null;
  deletedOn_MIN_LT?: any | null;
  deletedOn_MIN_LTE?: any | null;
  department_AVERAGE_EQUAL?: number | null;
  department_AVERAGE_GT?: number | null;
  department_AVERAGE_GTE?: number | null;
  department_AVERAGE_LT?: number | null;
  department_AVERAGE_LTE?: number | null;
  department_EQUAL?: string | null;
  department_GT?: number | null;
  department_GTE?: number | null;
  department_LONGEST_EQUAL?: number | null;
  department_LONGEST_GT?: number | null;
  department_LONGEST_GTE?: number | null;
  department_LONGEST_LT?: number | null;
  department_LONGEST_LTE?: number | null;
  department_LT?: number | null;
  department_LTE?: number | null;
  department_SHORTEST_EQUAL?: number | null;
  department_SHORTEST_GT?: number | null;
  department_SHORTEST_GTE?: number | null;
  department_SHORTEST_LT?: number | null;
  department_SHORTEST_LTE?: number | null;
  email_AVERAGE_EQUAL?: number | null;
  email_AVERAGE_GT?: number | null;
  email_AVERAGE_GTE?: number | null;
  email_AVERAGE_LT?: number | null;
  email_AVERAGE_LTE?: number | null;
  email_EQUAL?: string | null;
  email_GT?: number | null;
  email_GTE?: number | null;
  email_LONGEST_EQUAL?: number | null;
  email_LONGEST_GT?: number | null;
  email_LONGEST_GTE?: number | null;
  email_LONGEST_LT?: number | null;
  email_LONGEST_LTE?: number | null;
  email_LT?: number | null;
  email_LTE?: number | null;
  email_SHORTEST_EQUAL?: number | null;
  email_SHORTEST_GT?: number | null;
  email_SHORTEST_GTE?: number | null;
  email_SHORTEST_LT?: number | null;
  email_SHORTEST_LTE?: number | null;
  firstName_AVERAGE_EQUAL?: number | null;
  firstName_AVERAGE_GT?: number | null;
  firstName_AVERAGE_GTE?: number | null;
  firstName_AVERAGE_LT?: number | null;
  firstName_AVERAGE_LTE?: number | null;
  firstName_EQUAL?: string | null;
  firstName_GT?: number | null;
  firstName_GTE?: number | null;
  firstName_LONGEST_EQUAL?: number | null;
  firstName_LONGEST_GT?: number | null;
  firstName_LONGEST_GTE?: number | null;
  firstName_LONGEST_LT?: number | null;
  firstName_LONGEST_LTE?: number | null;
  firstName_LT?: number | null;
  firstName_LTE?: number | null;
  firstName_SHORTEST_EQUAL?: number | null;
  firstName_SHORTEST_GT?: number | null;
  firstName_SHORTEST_GTE?: number | null;
  firstName_SHORTEST_LT?: number | null;
  firstName_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  lastName_AVERAGE_EQUAL?: number | null;
  lastName_AVERAGE_GT?: number | null;
  lastName_AVERAGE_GTE?: number | null;
  lastName_AVERAGE_LT?: number | null;
  lastName_AVERAGE_LTE?: number | null;
  lastName_EQUAL?: string | null;
  lastName_GT?: number | null;
  lastName_GTE?: number | null;
  lastName_LONGEST_EQUAL?: number | null;
  lastName_LONGEST_GT?: number | null;
  lastName_LONGEST_GTE?: number | null;
  lastName_LONGEST_LT?: number | null;
  lastName_LONGEST_LTE?: number | null;
  lastName_LT?: number | null;
  lastName_LTE?: number | null;
  lastName_SHORTEST_EQUAL?: number | null;
  lastName_SHORTEST_GT?: number | null;
  lastName_SHORTEST_GTE?: number | null;
  lastName_SHORTEST_LT?: number | null;
  lastName_SHORTEST_LTE?: number | null;
  position_AVERAGE_EQUAL?: number | null;
  position_AVERAGE_GT?: number | null;
  position_AVERAGE_GTE?: number | null;
  position_AVERAGE_LT?: number | null;
  position_AVERAGE_LTE?: number | null;
  position_EQUAL?: string | null;
  position_GT?: number | null;
  position_GTE?: number | null;
  position_LONGEST_EQUAL?: number | null;
  position_LONGEST_GT?: number | null;
  position_LONGEST_GTE?: number | null;
  position_LONGEST_LT?: number | null;
  position_LONGEST_LTE?: number | null;
  position_LT?: number | null;
  position_LTE?: number | null;
  position_SHORTEST_EQUAL?: number | null;
  position_SHORTEST_GT?: number | null;
  position_SHORTEST_GTE?: number | null;
  position_SHORTEST_LT?: number | null;
  position_SHORTEST_LTE?: number | null;
  preferredLanguage_AVERAGE_EQUAL?: number | null;
  preferredLanguage_AVERAGE_GT?: number | null;
  preferredLanguage_AVERAGE_GTE?: number | null;
  preferredLanguage_AVERAGE_LT?: number | null;
  preferredLanguage_AVERAGE_LTE?: number | null;
  preferredLanguage_EQUAL?: string | null;
  preferredLanguage_GT?: number | null;
  preferredLanguage_GTE?: number | null;
  preferredLanguage_LONGEST_EQUAL?: number | null;
  preferredLanguage_LONGEST_GT?: number | null;
  preferredLanguage_LONGEST_GTE?: number | null;
  preferredLanguage_LONGEST_LT?: number | null;
  preferredLanguage_LONGEST_LTE?: number | null;
  preferredLanguage_LT?: number | null;
  preferredLanguage_LTE?: number | null;
  preferredLanguage_SHORTEST_EQUAL?: number | null;
  preferredLanguage_SHORTEST_GT?: number | null;
  preferredLanguage_SHORTEST_GTE?: number | null;
  preferredLanguage_SHORTEST_LT?: number | null;
  preferredLanguage_SHORTEST_LTE?: number | null;
  tenantId_AVERAGE_EQUAL?: number | null;
  tenantId_AVERAGE_GT?: number | null;
  tenantId_AVERAGE_GTE?: number | null;
  tenantId_AVERAGE_LT?: number | null;
  tenantId_AVERAGE_LTE?: number | null;
  tenantId_EQUAL?: string | null;
  tenantId_GT?: number | null;
  tenantId_GTE?: number | null;
  tenantId_LONGEST_EQUAL?: number | null;
  tenantId_LONGEST_GT?: number | null;
  tenantId_LONGEST_GTE?: number | null;
  tenantId_LONGEST_LT?: number | null;
  tenantId_LONGEST_LTE?: number | null;
  tenantId_LT?: number | null;
  tenantId_LTE?: number | null;
  tenantId_SHORTEST_EQUAL?: number | null;
  tenantId_SHORTEST_GT?: number | null;
  tenantId_SHORTEST_GTE?: number | null;
  tenantId_SHORTEST_LT?: number | null;
  tenantId_SHORTEST_LTE?: number | null;
}

export interface BaseAgreementWhere {
  AND?: BaseAgreementWhere[] | null;
  OR?: BaseAgreementWhere[] | null;
  addedBy?: UserWhere | null;
  addedByAggregate?: BaseAgreementAddedByAggregateInput | null;
  addedByConnection?: BaseAgreementAddedByConnectionWhere | null;
  addedByConnection_NOT?: BaseAgreementAddedByConnectionWhere | null;
  addedBy_NOT?: UserWhere | null;
  allowedForms?: string[] | null;
  allowedForms_INCLUDES?: string | null;
  allowedForms_NOT?: string[] | null;
  allowedForms_NOT_INCLUDES?: string | null;
  allowedRecords?: string[] | null;
  allowedRecords_INCLUDES?: string | null;
  allowedRecords_NOT?: string[] | null;
  allowedRecords_NOT_INCLUDES?: string | null;
  caseSuspensionIntervalDays?: number | null;
  caseSuspensionIntervalDays_GT?: number | null;
  caseSuspensionIntervalDays_GTE?: number | null;
  caseSuspensionIntervalDays_IN?: (number | null)[] | null;
  caseSuspensionIntervalDays_LT?: number | null;
  caseSuspensionIntervalDays_LTE?: number | null;
  caseSuspensionIntervalDays_NOT?: number | null;
  caseSuspensionIntervalDays_NOT_IN?: (number | null)[] | null;
  counterparties?: OrganizationWhere | null;
  counterpartiesAggregate?: BaseAgreementCounterpartiesAggregateInput | null;
  counterpartiesConnection?: BaseAgreementCounterpartiesConnectionWhere | null;
  counterpartiesConnection_NOT?: BaseAgreementCounterpartiesConnectionWhere | null;
  counterparties_NOT?: OrganizationWhere | null;
  coveringFormWaitInterval?: number | null;
  coveringFormWaitInterval_GT?: number | null;
  coveringFormWaitInterval_GTE?: number | null;
  coveringFormWaitInterval_IN?: (number | null)[] | null;
  coveringFormWaitInterval_LT?: number | null;
  coveringFormWaitInterval_LTE?: number | null;
  coveringFormWaitInterval_NOT?: number | null;
  coveringFormWaitInterval_NOT_IN?: (number | null)[] | null;
  createdOn?: any | null;
  createdOn_GT?: any | null;
  createdOn_GTE?: any | null;
  createdOn_IN?: (any | null)[] | null;
  createdOn_LT?: any | null;
  createdOn_LTE?: any | null;
  createdOn_NOT?: any | null;
  createdOn_NOT_IN?: (any | null)[] | null;
  currency?: CurrencyWhere | null;
  currencyAggregate?: BaseAgreementCurrencyAggregateInput | null;
  currencyConnection?: BaseAgreementCurrencyConnectionWhere | null;
  currencyConnection_NOT?: BaseAgreementCurrencyConnectionWhere | null;
  currency_NOT?: CurrencyWhere | null;
  cycles?: CycleConfigurationWhere | null;
  cyclesAggregate?: BaseAgreementCyclesAggregateInput | null;
  cyclesConnection?: BaseAgreementCyclesConnectionWhere | null;
  cyclesConnection_NOT?: BaseAgreementCyclesConnectionWhere | null;
  cycles_NOT?: CycleConfigurationWhere | null;
  dataContainers?: DataContainerWhere | null;
  dataContainersAggregate?: BaseAgreementDataContainersAggregateInput | null;
  dataContainersConnection?: BaseAgreementDataContainersConnectionWhere | null;
  dataContainersConnection_NOT?: BaseAgreementDataContainersConnectionWhere | null;
  dataContainers_NOT?: DataContainerWhere | null;
  dataSource?: DataSourceWhere | null;
  dataSourceAggregate?: BaseAgreementDataSourceAggregateInput | null;
  dataSourceConnection?: BaseAgreementDataSourceConnectionWhere | null;
  dataSourceConnection_NOT?: BaseAgreementDataSourceConnectionWhere | null;
  dataSource_NOT?: DataSourceWhere | null;
  decisions?: AgreementDecisionWhere | null;
  decisionsAggregate?: BaseAgreementDecisionsAggregateInput | null;
  decisionsConnection?: BaseAgreementDecisionsConnectionWhere | null;
  decisionsConnection_NOT?: BaseAgreementDecisionsConnectionWhere | null;
  decisions_NOT?: AgreementDecisionWhere | null;
  defaultPriceRate?: number | null;
  defaultPriceRate_GT?: number | null;
  defaultPriceRate_GTE?: number | null;
  defaultPriceRate_IN?: (number | null)[] | null;
  defaultPriceRate_LT?: number | null;
  defaultPriceRate_LTE?: number | null;
  defaultPriceRate_NOT?: number | null;
  defaultPriceRate_NOT_IN?: (number | null)[] | null;
  deviceAlternativeSets?: DeviceAlternativeWhere | null;
  deviceAlternativeSetsAggregate?: BaseAgreementDeviceAlternativeSetsAggregateInput | null;
  deviceAlternativeSetsConnection?: BaseAgreementDeviceAlternativeSetsConnectionWhere | null;
  deviceAlternativeSetsConnection_NOT?: BaseAgreementDeviceAlternativeSetsConnectionWhere | null;
  deviceAlternativeSets_NOT?: DeviceAlternativeWhere | null;
  dotChartConfig?: ChartRangeConfigurationWhere | null;
  dotChartConfigAggregate?: BaseAgreementDotChartConfigAggregateInput | null;
  dotChartConfigConnection?: BaseAgreementDotChartConfigConnectionWhere | null;
  dotChartConfigConnection_NOT?: BaseAgreementDotChartConfigConnectionWhere | null;
  dotChartConfig_NOT?: ChartRangeConfigurationWhere | null;
  dotThresholds?: ChartRangeConfigurationWhere | null;
  dotThresholdsAggregate?: BaseAgreementDotThresholdsAggregateInput | null;
  dotThresholdsConnection?: BaseAgreementDotThresholdsConnectionWhere | null;
  dotThresholdsConnection_NOT?: BaseAgreementDotThresholdsConnectionWhere | null;
  dotThresholds_NOT?: ChartRangeConfigurationWhere | null;
  eligibilityConditionSets?: EligibilityConditionSetWhere | null;
  eligibilityConditionSetsAggregate?: BaseAgreementEligibilityConditionSetsAggregateInput | null;
  eligibilityConditionSetsConnection?: BaseAgreementEligibilityConditionSetsConnectionWhere | null;
  eligibilityConditionSetsConnection_NOT?: BaseAgreementEligibilityConditionSetsConnectionWhere | null;
  eligibilityConditionSets_NOT?: EligibilityConditionSetWhere | null;
  enrollingConditionSets?: EnrollingConditionSetWhere | null;
  enrollingConditionSetsAggregate?: BaseAgreementEnrollingConditionSetsAggregateInput | null;
  enrollingConditionSetsConnection?: BaseAgreementEnrollingConditionSetsConnectionWhere | null;
  enrollingConditionSetsConnection_NOT?: BaseAgreementEnrollingConditionSetsConnectionWhere | null;
  enrollingConditionSets_NOT?: EnrollingConditionSetWhere | null;
  enrollingPeriods?: EnrollingPeriodWhere | null;
  enrollingPeriodsAggregate?: BaseAgreementEnrollingPeriodsAggregateInput | null;
  enrollingPeriodsConnection?: BaseAgreementEnrollingPeriodsConnectionWhere | null;
  enrollingPeriodsConnection_NOT?: BaseAgreementEnrollingPeriodsConnectionWhere | null;
  enrollingPeriods_NOT?: EnrollingPeriodWhere | null;
  enrolmentDateType?: EnrolmentDateType | null;
  enrolmentDateType_IN?: (EnrolmentDateType | null)[] | null;
  enrolmentDateType_NOT?: EnrolmentDateType | null;
  enrolmentDateType_NOT_IN?: (EnrolmentDateType | null)[] | null;
  expectedDocument?: DocumentType | null;
  expectedDocument_IN?: (DocumentType | null)[] | null;
  expectedDocument_NOT?: DocumentType | null;
  expectedDocument_NOT_IN?: (DocumentType | null)[] | null;
  financialSummaryConfig?: FinancialSummaryColumnWhere | null;
  financialSummaryConfigAggregate?: BaseAgreementFinancialSummaryConfigAggregateInput | null;
  financialSummaryConfigConnection?: BaseAgreementFinancialSummaryConfigConnectionWhere | null;
  financialSummaryConfigConnection_NOT?: BaseAgreementFinancialSummaryConfigConnectionWhere | null;
  financialSummaryConfig_NOT?: FinancialSummaryColumnWhere | null;
  firstExecutionDate?: any | null;
  firstExecutionDate_GT?: any | null;
  firstExecutionDate_GTE?: any | null;
  firstExecutionDate_IN?: (any | null)[] | null;
  firstExecutionDate_LT?: any | null;
  firstExecutionDate_LTE?: any | null;
  firstExecutionDate_NOT?: any | null;
  firstExecutionDate_NOT_IN?: (any | null)[] | null;
  formattedAmount?: string | null;
  formattedAmount_CONTAINS?: string | null;
  formattedAmount_ENDS_WITH?: string | null;
  formattedAmount_IN?: (string | null)[] | null;
  formattedAmount_MATCHES?: string | null;
  formattedAmount_NOT?: string | null;
  formattedAmount_NOT_CONTAINS?: string | null;
  formattedAmount_NOT_ENDS_WITH?: string | null;
  formattedAmount_NOT_IN?: (string | null)[] | null;
  formattedAmount_NOT_STARTS_WITH?: string | null;
  formattedAmount_STARTS_WITH?: string | null;
  formattedCounterparties?: string | null;
  formattedCounterparties_CONTAINS?: string | null;
  formattedCounterparties_ENDS_WITH?: string | null;
  formattedCounterparties_IN?: (string | null)[] | null;
  formattedCounterparties_MATCHES?: string | null;
  formattedCounterparties_NOT?: string | null;
  formattedCounterparties_NOT_CONTAINS?: string | null;
  formattedCounterparties_NOT_ENDS_WITH?: string | null;
  formattedCounterparties_NOT_IN?: (string | null)[] | null;
  formattedCounterparties_NOT_STARTS_WITH?: string | null;
  formattedCounterparties_STARTS_WITH?: string | null;
  formattedDiseases?: string | null;
  formattedDiseases_CONTAINS?: string | null;
  formattedDiseases_ENDS_WITH?: string | null;
  formattedDiseases_IN?: (string | null)[] | null;
  formattedDiseases_MATCHES?: string | null;
  formattedDiseases_NOT?: string | null;
  formattedDiseases_NOT_CONTAINS?: string | null;
  formattedDiseases_NOT_ENDS_WITH?: string | null;
  formattedDiseases_NOT_IN?: (string | null)[] | null;
  formattedDiseases_NOT_STARTS_WITH?: string | null;
  formattedDiseases_STARTS_WITH?: string | null;
  formattedIndications?: string | null;
  formattedIndications_CONTAINS?: string | null;
  formattedIndications_ENDS_WITH?: string | null;
  formattedIndications_IN?: (string | null)[] | null;
  formattedIndications_MATCHES?: string | null;
  formattedIndications_NOT?: string | null;
  formattedIndications_NOT_CONTAINS?: string | null;
  formattedIndications_NOT_ENDS_WITH?: string | null;
  formattedIndications_NOT_IN?: (string | null)[] | null;
  formattedIndications_NOT_STARTS_WITH?: string | null;
  formattedIndications_STARTS_WITH?: string | null;
  formattedProducts?: string | null;
  formattedProducts_CONTAINS?: string | null;
  formattedProducts_ENDS_WITH?: string | null;
  formattedProducts_IN?: (string | null)[] | null;
  formattedProducts_MATCHES?: string | null;
  formattedProducts_NOT?: string | null;
  formattedProducts_NOT_CONTAINS?: string | null;
  formattedProducts_NOT_ENDS_WITH?: string | null;
  formattedProducts_NOT_IN?: (string | null)[] | null;
  formattedProducts_NOT_STARTS_WITH?: string | null;
  formattedProducts_STARTS_WITH?: string | null;
  formattedTags?: string | null;
  formattedTags_CONTAINS?: string | null;
  formattedTags_ENDS_WITH?: string | null;
  formattedTags_IN?: (string | null)[] | null;
  formattedTags_MATCHES?: string | null;
  formattedTags_NOT?: string | null;
  formattedTags_NOT_CONTAINS?: string | null;
  formattedTags_NOT_ENDS_WITH?: string | null;
  formattedTags_NOT_IN?: (string | null)[] | null;
  formattedTags_NOT_STARTS_WITH?: string | null;
  formattedTags_STARTS_WITH?: string | null;
  formattedValidityPeriod?: string | null;
  formattedValidityPeriod_CONTAINS?: string | null;
  formattedValidityPeriod_ENDS_WITH?: string | null;
  formattedValidityPeriod_IN?: (string | null)[] | null;
  formattedValidityPeriod_MATCHES?: string | null;
  formattedValidityPeriod_NOT?: string | null;
  formattedValidityPeriod_NOT_CONTAINS?: string | null;
  formattedValidityPeriod_NOT_ENDS_WITH?: string | null;
  formattedValidityPeriod_NOT_IN?: (string | null)[] | null;
  formattedValidityPeriod_NOT_STARTS_WITH?: string | null;
  formattedValidityPeriod_STARTS_WITH?: string | null;
  id?: string | null;
  id_CONTAINS?: string | null;
  id_ENDS_WITH?: string | null;
  id_IN?: (string | null)[] | null;
  id_MATCHES?: string | null;
  id_NOT?: string | null;
  id_NOT_CONTAINS?: string | null;
  id_NOT_ENDS_WITH?: string | null;
  id_NOT_IN?: (string | null)[] | null;
  id_NOT_STARTS_WITH?: string | null;
  id_STARTS_WITH?: string | null;
  initialVersion?: BaseAgreementWhere | null;
  initialVersionAggregate?: BaseAgreementInitialVersionAggregateInput | null;
  initialVersionConnection?: BaseAgreementInitialVersionConnectionWhere | null;
  initialVersionConnection_NOT?: BaseAgreementInitialVersionConnectionWhere | null;
  initialVersionId?: string | null;
  initialVersionId_CONTAINS?: string | null;
  initialVersionId_ENDS_WITH?: string | null;
  initialVersionId_IN?: (string | null)[] | null;
  initialVersionId_MATCHES?: string | null;
  initialVersionId_NOT?: string | null;
  initialVersionId_NOT_CONTAINS?: string | null;
  initialVersionId_NOT_ENDS_WITH?: string | null;
  initialVersionId_NOT_IN?: (string | null)[] | null;
  initialVersionId_NOT_STARTS_WITH?: string | null;
  initialVersionId_STARTS_WITH?: string | null;
  initialVersion_NOT?: BaseAgreementWhere | null;
  isAllowedFormsEnabled?: boolean | null;
  isAllowedFormsEnabled_NOT?: boolean | null;
  isAllowedRecordsEnabled?: boolean | null;
  isAllowedRecordsEnabled_NOT?: boolean | null;
  isCoveringIntervalEnabled?: boolean | null;
  isCoveringIntervalEnabled_NOT?: boolean | null;
  isDeleted?: boolean | null;
  isDeleted_NOT?: boolean | null;
  isExtended?: boolean | null;
  isExtended_NOT?: boolean | null;
  isFirstVersion?: boolean | null;
  isFirstVersion_NOT?: boolean | null;
  isHidden?: boolean | null;
  isHidden_NOT?: boolean | null;
  isInsightsAvailable?: boolean | null;
  isInsightsAvailable_NOT?: boolean | null;
  isLastVersion?: boolean | null;
  isLastVersion_NOT?: boolean | null;
  isRequiredFormsEnabled?: boolean | null;
  isRequiredFormsEnabled_NOT?: boolean | null;
  isRequiredRecordsEnabled?: boolean | null;
  isRequiredRecordsEnabled_NOT?: boolean | null;
  isScenariosInSync?: boolean | null;
  isScenariosInSync_NOT?: boolean | null;
  isScopeSync?: boolean | null;
  isScopeSync_NOT?: boolean | null;
  isValidityPeriodInSync?: boolean | null;
  isValidityPeriodInSync_NOT?: boolean | null;
  lastExecutionDate?: any | null;
  lastExecutionDate_GT?: any | null;
  lastExecutionDate_GTE?: any | null;
  lastExecutionDate_IN?: (any | null)[] | null;
  lastExecutionDate_LT?: any | null;
  lastExecutionDate_LTE?: any | null;
  lastExecutionDate_NOT?: any | null;
  lastExecutionDate_NOT_IN?: (any | null)[] | null;
  lastUpdatedOn?: number | null;
  lastUpdatedOn_GT?: number | null;
  lastUpdatedOn_GTE?: number | null;
  lastUpdatedOn_IN?: (number | null)[] | null;
  lastUpdatedOn_LT?: number | null;
  lastUpdatedOn_LTE?: number | null;
  lastUpdatedOn_NOT?: number | null;
  lastUpdatedOn_NOT_IN?: (number | null)[] | null;
  ldlChartConfig?: ChartRangeConfigurationWhere | null;
  ldlChartConfigAggregate?: BaseAgreementLdlChartConfigAggregateInput | null;
  ldlChartConfigConnection?: BaseAgreementLdlChartConfigConnectionWhere | null;
  ldlChartConfigConnection_NOT?: BaseAgreementLdlChartConfigConnectionWhere | null;
  ldlChartConfig_NOT?: ChartRangeConfigurationWhere | null;
  name?: string | null;
  name_CONTAINS?: string | null;
  name_ENDS_WITH?: string | null;
  name_IN?: (string | null)[] | null;
  name_MATCHES?: string | null;
  name_NOT?: string | null;
  name_NOT_CONTAINS?: string | null;
  name_NOT_ENDS_WITH?: string | null;
  name_NOT_IN?: (string | null)[] | null;
  name_NOT_STARTS_WITH?: string | null;
  name_STARTS_WITH?: string | null;
  negotiableAttributes?: CatalogueAttributeWhere | null;
  negotiableAttributesAggregate?: BaseAgreementNegotiableAttributesAggregateInput | null;
  negotiableAttributesConnection?: BaseAgreementNegotiableAttributesConnectionWhere | null;
  negotiableAttributesConnection_NOT?: BaseAgreementNegotiableAttributesConnectionWhere | null;
  negotiableAttributes_NOT?: CatalogueAttributeWhere | null;
  nextVersions?: BaseAgreementWhere | null;
  nextVersionsAggregate?: BaseAgreementNextVersionsAggregateInput | null;
  nextVersionsConnection?: BaseAgreementNextVersionsConnectionWhere | null;
  nextVersionsConnection_NOT?: BaseAgreementNextVersionsConnectionWhere | null;
  nextVersions_NOT?: BaseAgreementWhere | null;
  pushedBy?: UserWhere | null;
  pushedByAggregate?: BaseAgreementPushedByAggregateInput | null;
  pushedByConnection?: BaseAgreementPushedByConnectionWhere | null;
  pushedByConnection_NOT?: BaseAgreementPushedByConnectionWhere | null;
  pushedBy_NOT?: UserWhere | null;
  pushedOn?: any | null;
  pushedOn_GT?: any | null;
  pushedOn_GTE?: any | null;
  pushedOn_IN?: (any | null)[] | null;
  pushedOn_LT?: any | null;
  pushedOn_LTE?: any | null;
  pushedOn_NOT?: any | null;
  pushedOn_NOT_IN?: (any | null)[] | null;
  reportData?: string | null;
  reportData_CONTAINS?: string | null;
  reportData_ENDS_WITH?: string | null;
  reportData_IN?: (string | null)[] | null;
  reportData_MATCHES?: string | null;
  reportData_NOT?: string | null;
  reportData_NOT_CONTAINS?: string | null;
  reportData_NOT_ENDS_WITH?: string | null;
  reportData_NOT_IN?: (string | null)[] | null;
  reportData_NOT_STARTS_WITH?: string | null;
  reportData_STARTS_WITH?: string | null;
  requiredForms?: string[] | null;
  requiredForms_INCLUDES?: string | null;
  requiredForms_NOT?: string[] | null;
  requiredForms_NOT_INCLUDES?: string | null;
  requiredRecords?: string[] | null;
  requiredRecords_INCLUDES?: string | null;
  requiredRecords_NOT?: string[] | null;
  requiredRecords_NOT_INCLUDES?: string | null;
  scenarios?: ScenarioWhere | null;
  scenariosAggregate?: BaseAgreementScenariosAggregateInput | null;
  scenariosConnection?: BaseAgreementScenariosConnectionWhere | null;
  scenariosConnection_NOT?: BaseAgreementScenariosConnectionWhere | null;
  scenariosRelevantBrands?: BrandWhere | null;
  scenariosRelevantBrandsAggregate?: BaseAgreementScenariosRelevantBrandsAggregateInput | null;
  scenariosRelevantBrandsConnection?: BaseAgreementScenariosRelevantBrandsConnectionWhere | null;
  scenariosRelevantBrandsConnection_NOT?: BaseAgreementScenariosRelevantBrandsConnectionWhere | null;
  scenariosRelevantBrands_NOT?: BrandWhere | null;
  scenarios_NOT?: ScenarioWhere | null;
  status?: ContractStatus | null;
  statusTransitions?: AgreementStatusTransitionWhere | null;
  statusTransitionsAggregate?: BaseAgreementStatusTransitionsAggregateInput | null;
  statusTransitionsConnection?: BaseAgreementStatusTransitionsConnectionWhere | null;
  statusTransitionsConnection_NOT?: BaseAgreementStatusTransitionsConnectionWhere | null;
  statusTransitions_NOT?: AgreementStatusTransitionWhere | null;
  status_IN?: (ContractStatus | null)[] | null;
  status_NOT?: ContractStatus | null;
  status_NOT_IN?: (ContractStatus | null)[] | null;
  subjectMatter?: AgreementSubjectMatter | null;
  subjectMatter_IN?: (AgreementSubjectMatter | null)[] | null;
  subjectMatter_NOT?: AgreementSubjectMatter | null;
  subjectMatter_NOT_IN?: (AgreementSubjectMatter | null)[] | null;
  tags?: AgreementTagWhere | null;
  tagsAggregate?: BaseAgreementTagsAggregateInput | null;
  tagsConnection?: BaseAgreementTagsConnectionWhere | null;
  tagsConnection_NOT?: BaseAgreementTagsConnectionWhere | null;
  tags_NOT?: AgreementTagWhere | null;
  tenantIds?: string[] | null;
  tenantIds_INCLUDES?: string | null;
  tenantIds_NOT?: string[] | null;
  tenantIds_NOT_INCLUDES?: string | null;
  totalAmount?: number | null;
  totalAmount_GT?: number | null;
  totalAmount_GTE?: number | null;
  totalAmount_IN?: (number | null)[] | null;
  totalAmount_LT?: number | null;
  totalAmount_LTE?: number | null;
  totalAmount_NOT?: number | null;
  totalAmount_NOT_IN?: (number | null)[] | null;
  treatmentPrices?: TreatmentWhere | null;
  treatmentPricesAggregate?: BaseAgreementTreatmentPricesAggregateInput | null;
  treatmentPricesConnection?: BaseAgreementTreatmentPricesConnectionWhere | null;
  treatmentPricesConnection_NOT?: BaseAgreementTreatmentPricesConnectionWhere | null;
  treatmentPrices_NOT?: TreatmentWhere | null;
  userContexts?: UserContextWhere | null;
  userContextsAggregate?: BaseAgreementUserContextsAggregateInput | null;
  userContextsConnection?: BaseAgreementUserContextsConnectionWhere | null;
  userContextsConnection_NOT?: BaseAgreementUserContextsConnectionWhere | null;
  userContexts_NOT?: UserContextWhere | null;
  userRoles?: UserWhere | null;
  userRolesAggregate?: BaseAgreementUserRolesAggregateInput | null;
  userRolesConnection?: BaseAgreementUserRolesConnectionWhere | null;
  userRolesConnection_NOT?: BaseAgreementUserRolesConnectionWhere | null;
  userRoles_NOT?: UserWhere | null;
  validFromDate?: any | null;
  validFromDate_GT?: any | null;
  validFromDate_GTE?: any | null;
  validFromDate_IN?: (any | null)[] | null;
  validFromDate_LT?: any | null;
  validFromDate_LTE?: any | null;
  validFromDate_NOT?: any | null;
  validFromDate_NOT_IN?: (any | null)[] | null;
  validToDate?: any | null;
  validToDate_GT?: any | null;
  validToDate_GTE?: any | null;
  validToDate_IN?: (any | null)[] | null;
  validToDate_LT?: any | null;
  validToDate_LTE?: any | null;
  validToDate_NOT?: any | null;
  validToDate_NOT_IN?: (any | null)[] | null;
  version?: number | null;
  version_GT?: number | null;
  version_GTE?: number | null;
  version_IN?: (number | null)[] | null;
  version_LT?: number | null;
  version_LTE?: number | null;
  version_NOT?: number | null;
  version_NOT_IN?: (number | null)[] | null;
}

export interface BookDemoInput {
  book_a_demo?: string | null;
  company: string;
  email: string;
  firstname: string;
  lastname: string;
  message?: string | null;
  newsletter_signup?: string | null;
}

export interface BrandPreparationsAggregateInput {
  AND?: BrandPreparationsAggregateInput[] | null;
  OR?: BrandPreparationsAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: BrandPreparationsNodeAggregationWhereInput | null;
}

export interface BrandPreparationsConnectionWhere {
  AND?: BrandPreparationsConnectionWhere[] | null;
  OR?: BrandPreparationsConnectionWhere[] | null;
  node?: PreparationWhere | null;
  node_NOT?: PreparationWhere | null;
}

export interface BrandPreparationsNodeAggregationWhereInput {
  AND?: BrandPreparationsNodeAggregationWhereInput[] | null;
  AtcCode_AVERAGE_EQUAL?: number | null;
  AtcCode_AVERAGE_GT?: number | null;
  AtcCode_AVERAGE_GTE?: number | null;
  AtcCode_AVERAGE_LT?: number | null;
  AtcCode_AVERAGE_LTE?: number | null;
  AtcCode_EQUAL?: string | null;
  AtcCode_GT?: number | null;
  AtcCode_GTE?: number | null;
  AtcCode_LONGEST_EQUAL?: number | null;
  AtcCode_LONGEST_GT?: number | null;
  AtcCode_LONGEST_GTE?: number | null;
  AtcCode_LONGEST_LT?: number | null;
  AtcCode_LONGEST_LTE?: number | null;
  AtcCode_LT?: number | null;
  AtcCode_LTE?: number | null;
  AtcCode_SHORTEST_EQUAL?: number | null;
  AtcCode_SHORTEST_GT?: number | null;
  AtcCode_SHORTEST_GTE?: number | null;
  AtcCode_SHORTEST_LT?: number | null;
  AtcCode_SHORTEST_LTE?: number | null;
  BrandName_AVERAGE_EQUAL?: number | null;
  BrandName_AVERAGE_GT?: number | null;
  BrandName_AVERAGE_GTE?: number | null;
  BrandName_AVERAGE_LT?: number | null;
  BrandName_AVERAGE_LTE?: number | null;
  BrandName_EQUAL?: string | null;
  BrandName_GT?: number | null;
  BrandName_GTE?: number | null;
  BrandName_LONGEST_EQUAL?: number | null;
  BrandName_LONGEST_GT?: number | null;
  BrandName_LONGEST_GTE?: number | null;
  BrandName_LONGEST_LT?: number | null;
  BrandName_LONGEST_LTE?: number | null;
  BrandName_LT?: number | null;
  BrandName_LTE?: number | null;
  BrandName_SHORTEST_EQUAL?: number | null;
  BrandName_SHORTEST_GT?: number | null;
  BrandName_SHORTEST_GTE?: number | null;
  BrandName_SHORTEST_LT?: number | null;
  BrandName_SHORTEST_LTE?: number | null;
  DescriptionDe_AVERAGE_EQUAL?: number | null;
  DescriptionDe_AVERAGE_GT?: number | null;
  DescriptionDe_AVERAGE_GTE?: number | null;
  DescriptionDe_AVERAGE_LT?: number | null;
  DescriptionDe_AVERAGE_LTE?: number | null;
  DescriptionDe_EQUAL?: string | null;
  DescriptionDe_GT?: number | null;
  DescriptionDe_GTE?: number | null;
  DescriptionDe_LONGEST_EQUAL?: number | null;
  DescriptionDe_LONGEST_GT?: number | null;
  DescriptionDe_LONGEST_GTE?: number | null;
  DescriptionDe_LONGEST_LT?: number | null;
  DescriptionDe_LONGEST_LTE?: number | null;
  DescriptionDe_LT?: number | null;
  DescriptionDe_LTE?: number | null;
  DescriptionDe_SHORTEST_EQUAL?: number | null;
  DescriptionDe_SHORTEST_GT?: number | null;
  DescriptionDe_SHORTEST_GTE?: number | null;
  DescriptionDe_SHORTEST_LT?: number | null;
  DescriptionDe_SHORTEST_LTE?: number | null;
  DescriptionFr_AVERAGE_EQUAL?: number | null;
  DescriptionFr_AVERAGE_GT?: number | null;
  DescriptionFr_AVERAGE_GTE?: number | null;
  DescriptionFr_AVERAGE_LT?: number | null;
  DescriptionFr_AVERAGE_LTE?: number | null;
  DescriptionFr_EQUAL?: string | null;
  DescriptionFr_GT?: number | null;
  DescriptionFr_GTE?: number | null;
  DescriptionFr_LONGEST_EQUAL?: number | null;
  DescriptionFr_LONGEST_GT?: number | null;
  DescriptionFr_LONGEST_GTE?: number | null;
  DescriptionFr_LONGEST_LT?: number | null;
  DescriptionFr_LONGEST_LTE?: number | null;
  DescriptionFr_LT?: number | null;
  DescriptionFr_LTE?: number | null;
  DescriptionFr_SHORTEST_EQUAL?: number | null;
  DescriptionFr_SHORTEST_GT?: number | null;
  DescriptionFr_SHORTEST_GTE?: number | null;
  DescriptionFr_SHORTEST_LT?: number | null;
  DescriptionFr_SHORTEST_LTE?: number | null;
  DescriptionIt_AVERAGE_EQUAL?: number | null;
  DescriptionIt_AVERAGE_GT?: number | null;
  DescriptionIt_AVERAGE_GTE?: number | null;
  DescriptionIt_AVERAGE_LT?: number | null;
  DescriptionIt_AVERAGE_LTE?: number | null;
  DescriptionIt_EQUAL?: string | null;
  DescriptionIt_GT?: number | null;
  DescriptionIt_GTE?: number | null;
  DescriptionIt_LONGEST_EQUAL?: number | null;
  DescriptionIt_LONGEST_GT?: number | null;
  DescriptionIt_LONGEST_GTE?: number | null;
  DescriptionIt_LONGEST_LT?: number | null;
  DescriptionIt_LONGEST_LTE?: number | null;
  DescriptionIt_LT?: number | null;
  DescriptionIt_LTE?: number | null;
  DescriptionIt_SHORTEST_EQUAL?: number | null;
  DescriptionIt_SHORTEST_GT?: number | null;
  DescriptionIt_SHORTEST_GTE?: number | null;
  DescriptionIt_SHORTEST_LT?: number | null;
  DescriptionIt_SHORTEST_LTE?: number | null;
  GenericName_AVERAGE_EQUAL?: number | null;
  GenericName_AVERAGE_GT?: number | null;
  GenericName_AVERAGE_GTE?: number | null;
  GenericName_AVERAGE_LT?: number | null;
  GenericName_AVERAGE_LTE?: number | null;
  GenericName_EQUAL?: string | null;
  GenericName_GT?: number | null;
  GenericName_GTE?: number | null;
  GenericName_LONGEST_EQUAL?: number | null;
  GenericName_LONGEST_GT?: number | null;
  GenericName_LONGEST_GTE?: number | null;
  GenericName_LONGEST_LT?: number | null;
  GenericName_LONGEST_LTE?: number | null;
  GenericName_LT?: number | null;
  GenericName_LTE?: number | null;
  GenericName_SHORTEST_EQUAL?: number | null;
  GenericName_SHORTEST_GT?: number | null;
  GenericName_SHORTEST_GTE?: number | null;
  GenericName_SHORTEST_LT?: number | null;
  GenericName_SHORTEST_LTE?: number | null;
  OR?: BrandPreparationsNodeAggregationWhereInput[] | null;
  SwissmedicNo5_AVERAGE_EQUAL?: number | null;
  SwissmedicNo5_AVERAGE_GT?: number | null;
  SwissmedicNo5_AVERAGE_GTE?: number | null;
  SwissmedicNo5_AVERAGE_LT?: number | null;
  SwissmedicNo5_AVERAGE_LTE?: number | null;
  SwissmedicNo5_EQUAL?: string | null;
  SwissmedicNo5_GT?: number | null;
  SwissmedicNo5_GTE?: number | null;
  SwissmedicNo5_LONGEST_EQUAL?: number | null;
  SwissmedicNo5_LONGEST_GT?: number | null;
  SwissmedicNo5_LONGEST_GTE?: number | null;
  SwissmedicNo5_LONGEST_LT?: number | null;
  SwissmedicNo5_LONGEST_LTE?: number | null;
  SwissmedicNo5_LT?: number | null;
  SwissmedicNo5_LTE?: number | null;
  SwissmedicNo5_SHORTEST_EQUAL?: number | null;
  SwissmedicNo5_SHORTEST_GT?: number | null;
  SwissmedicNo5_SHORTEST_GTE?: number | null;
  SwissmedicNo5_SHORTEST_LT?: number | null;
  SwissmedicNo5_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
}

export interface BrandWhere {
  AND?: BrandWhere[] | null;
  Name?: string | null;
  Name_CONTAINS?: string | null;
  Name_ENDS_WITH?: string | null;
  Name_IN?: (string | null)[] | null;
  Name_MATCHES?: string | null;
  Name_NOT?: string | null;
  Name_NOT_CONTAINS?: string | null;
  Name_NOT_ENDS_WITH?: string | null;
  Name_NOT_IN?: (string | null)[] | null;
  Name_NOT_STARTS_WITH?: string | null;
  Name_STARTS_WITH?: string | null;
  OR?: BrandWhere[] | null;
  id?: string | null;
  id_CONTAINS?: string | null;
  id_ENDS_WITH?: string | null;
  id_IN?: (string | null)[] | null;
  id_MATCHES?: string | null;
  id_NOT?: string | null;
  id_NOT_CONTAINS?: string | null;
  id_NOT_ENDS_WITH?: string | null;
  id_NOT_IN?: (string | null)[] | null;
  id_NOT_STARTS_WITH?: string | null;
  id_STARTS_WITH?: string | null;
  preparations?: PreparationWhere | null;
  preparationsAggregate?: BrandPreparationsAggregateInput | null;
  preparationsConnection?: BrandPreparationsConnectionWhere | null;
  preparationsConnection_NOT?: BrandPreparationsConnectionWhere | null;
  preparations_NOT?: PreparationWhere | null;
}

export interface CaseAssigneeDataInput {
  email?: string | null;
  userId: string;
}

export interface CaseBaseAgreementAggregateInput {
  AND?: CaseBaseAgreementAggregateInput[] | null;
  OR?: CaseBaseAgreementAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: CaseBaseAgreementNodeAggregationWhereInput | null;
}

export interface CaseBaseAgreementConnectionWhere {
  AND?: CaseBaseAgreementConnectionWhere[] | null;
  OR?: CaseBaseAgreementConnectionWhere[] | null;
  node?: BaseAgreementWhere | null;
  node_NOT?: BaseAgreementWhere | null;
}

export interface CaseBaseAgreementNodeAggregationWhereInput {
  AND?: CaseBaseAgreementNodeAggregationWhereInput[] | null;
  OR?: CaseBaseAgreementNodeAggregationWhereInput[] | null;
  caseSuspensionIntervalDays_AVERAGE_EQUAL?: number | null;
  caseSuspensionIntervalDays_AVERAGE_GT?: number | null;
  caseSuspensionIntervalDays_AVERAGE_GTE?: number | null;
  caseSuspensionIntervalDays_AVERAGE_LT?: number | null;
  caseSuspensionIntervalDays_AVERAGE_LTE?: number | null;
  caseSuspensionIntervalDays_EQUAL?: number | null;
  caseSuspensionIntervalDays_GT?: number | null;
  caseSuspensionIntervalDays_GTE?: number | null;
  caseSuspensionIntervalDays_LT?: number | null;
  caseSuspensionIntervalDays_LTE?: number | null;
  caseSuspensionIntervalDays_MAX_EQUAL?: number | null;
  caseSuspensionIntervalDays_MAX_GT?: number | null;
  caseSuspensionIntervalDays_MAX_GTE?: number | null;
  caseSuspensionIntervalDays_MAX_LT?: number | null;
  caseSuspensionIntervalDays_MAX_LTE?: number | null;
  caseSuspensionIntervalDays_MIN_EQUAL?: number | null;
  caseSuspensionIntervalDays_MIN_GT?: number | null;
  caseSuspensionIntervalDays_MIN_GTE?: number | null;
  caseSuspensionIntervalDays_MIN_LT?: number | null;
  caseSuspensionIntervalDays_MIN_LTE?: number | null;
  caseSuspensionIntervalDays_SUM_EQUAL?: number | null;
  caseSuspensionIntervalDays_SUM_GT?: number | null;
  caseSuspensionIntervalDays_SUM_GTE?: number | null;
  caseSuspensionIntervalDays_SUM_LT?: number | null;
  caseSuspensionIntervalDays_SUM_LTE?: number | null;
  coveringFormWaitInterval_AVERAGE_EQUAL?: number | null;
  coveringFormWaitInterval_AVERAGE_GT?: number | null;
  coveringFormWaitInterval_AVERAGE_GTE?: number | null;
  coveringFormWaitInterval_AVERAGE_LT?: number | null;
  coveringFormWaitInterval_AVERAGE_LTE?: number | null;
  coveringFormWaitInterval_EQUAL?: number | null;
  coveringFormWaitInterval_GT?: number | null;
  coveringFormWaitInterval_GTE?: number | null;
  coveringFormWaitInterval_LT?: number | null;
  coveringFormWaitInterval_LTE?: number | null;
  coveringFormWaitInterval_MAX_EQUAL?: number | null;
  coveringFormWaitInterval_MAX_GT?: number | null;
  coveringFormWaitInterval_MAX_GTE?: number | null;
  coveringFormWaitInterval_MAX_LT?: number | null;
  coveringFormWaitInterval_MAX_LTE?: number | null;
  coveringFormWaitInterval_MIN_EQUAL?: number | null;
  coveringFormWaitInterval_MIN_GT?: number | null;
  coveringFormWaitInterval_MIN_GTE?: number | null;
  coveringFormWaitInterval_MIN_LT?: number | null;
  coveringFormWaitInterval_MIN_LTE?: number | null;
  coveringFormWaitInterval_SUM_EQUAL?: number | null;
  coveringFormWaitInterval_SUM_GT?: number | null;
  coveringFormWaitInterval_SUM_GTE?: number | null;
  coveringFormWaitInterval_SUM_LT?: number | null;
  coveringFormWaitInterval_SUM_LTE?: number | null;
  createdOn_EQUAL?: any | null;
  createdOn_GT?: any | null;
  createdOn_GTE?: any | null;
  createdOn_LT?: any | null;
  createdOn_LTE?: any | null;
  createdOn_MAX_EQUAL?: any | null;
  createdOn_MAX_GT?: any | null;
  createdOn_MAX_GTE?: any | null;
  createdOn_MAX_LT?: any | null;
  createdOn_MAX_LTE?: any | null;
  createdOn_MIN_EQUAL?: any | null;
  createdOn_MIN_GT?: any | null;
  createdOn_MIN_GTE?: any | null;
  createdOn_MIN_LT?: any | null;
  createdOn_MIN_LTE?: any | null;
  defaultPriceRate_AVERAGE_EQUAL?: number | null;
  defaultPriceRate_AVERAGE_GT?: number | null;
  defaultPriceRate_AVERAGE_GTE?: number | null;
  defaultPriceRate_AVERAGE_LT?: number | null;
  defaultPriceRate_AVERAGE_LTE?: number | null;
  defaultPriceRate_EQUAL?: number | null;
  defaultPriceRate_GT?: number | null;
  defaultPriceRate_GTE?: number | null;
  defaultPriceRate_LT?: number | null;
  defaultPriceRate_LTE?: number | null;
  defaultPriceRate_MAX_EQUAL?: number | null;
  defaultPriceRate_MAX_GT?: number | null;
  defaultPriceRate_MAX_GTE?: number | null;
  defaultPriceRate_MAX_LT?: number | null;
  defaultPriceRate_MAX_LTE?: number | null;
  defaultPriceRate_MIN_EQUAL?: number | null;
  defaultPriceRate_MIN_GT?: number | null;
  defaultPriceRate_MIN_GTE?: number | null;
  defaultPriceRate_MIN_LT?: number | null;
  defaultPriceRate_MIN_LTE?: number | null;
  defaultPriceRate_SUM_EQUAL?: number | null;
  defaultPriceRate_SUM_GT?: number | null;
  defaultPriceRate_SUM_GTE?: number | null;
  defaultPriceRate_SUM_LT?: number | null;
  defaultPriceRate_SUM_LTE?: number | null;
  firstExecutionDate_EQUAL?: any | null;
  firstExecutionDate_GT?: any | null;
  firstExecutionDate_GTE?: any | null;
  firstExecutionDate_LT?: any | null;
  firstExecutionDate_LTE?: any | null;
  firstExecutionDate_MAX_EQUAL?: any | null;
  firstExecutionDate_MAX_GT?: any | null;
  firstExecutionDate_MAX_GTE?: any | null;
  firstExecutionDate_MAX_LT?: any | null;
  firstExecutionDate_MAX_LTE?: any | null;
  firstExecutionDate_MIN_EQUAL?: any | null;
  firstExecutionDate_MIN_GT?: any | null;
  firstExecutionDate_MIN_GTE?: any | null;
  firstExecutionDate_MIN_LT?: any | null;
  firstExecutionDate_MIN_LTE?: any | null;
  formattedAmount_AVERAGE_EQUAL?: number | null;
  formattedAmount_AVERAGE_GT?: number | null;
  formattedAmount_AVERAGE_GTE?: number | null;
  formattedAmount_AVERAGE_LT?: number | null;
  formattedAmount_AVERAGE_LTE?: number | null;
  formattedAmount_EQUAL?: string | null;
  formattedAmount_GT?: number | null;
  formattedAmount_GTE?: number | null;
  formattedAmount_LONGEST_EQUAL?: number | null;
  formattedAmount_LONGEST_GT?: number | null;
  formattedAmount_LONGEST_GTE?: number | null;
  formattedAmount_LONGEST_LT?: number | null;
  formattedAmount_LONGEST_LTE?: number | null;
  formattedAmount_LT?: number | null;
  formattedAmount_LTE?: number | null;
  formattedAmount_SHORTEST_EQUAL?: number | null;
  formattedAmount_SHORTEST_GT?: number | null;
  formattedAmount_SHORTEST_GTE?: number | null;
  formattedAmount_SHORTEST_LT?: number | null;
  formattedAmount_SHORTEST_LTE?: number | null;
  formattedCounterparties_AVERAGE_EQUAL?: number | null;
  formattedCounterparties_AVERAGE_GT?: number | null;
  formattedCounterparties_AVERAGE_GTE?: number | null;
  formattedCounterparties_AVERAGE_LT?: number | null;
  formattedCounterparties_AVERAGE_LTE?: number | null;
  formattedCounterparties_EQUAL?: string | null;
  formattedCounterparties_GT?: number | null;
  formattedCounterparties_GTE?: number | null;
  formattedCounterparties_LONGEST_EQUAL?: number | null;
  formattedCounterparties_LONGEST_GT?: number | null;
  formattedCounterparties_LONGEST_GTE?: number | null;
  formattedCounterparties_LONGEST_LT?: number | null;
  formattedCounterparties_LONGEST_LTE?: number | null;
  formattedCounterparties_LT?: number | null;
  formattedCounterparties_LTE?: number | null;
  formattedCounterparties_SHORTEST_EQUAL?: number | null;
  formattedCounterparties_SHORTEST_GT?: number | null;
  formattedCounterparties_SHORTEST_GTE?: number | null;
  formattedCounterparties_SHORTEST_LT?: number | null;
  formattedCounterparties_SHORTEST_LTE?: number | null;
  formattedDiseases_AVERAGE_EQUAL?: number | null;
  formattedDiseases_AVERAGE_GT?: number | null;
  formattedDiseases_AVERAGE_GTE?: number | null;
  formattedDiseases_AVERAGE_LT?: number | null;
  formattedDiseases_AVERAGE_LTE?: number | null;
  formattedDiseases_EQUAL?: string | null;
  formattedDiseases_GT?: number | null;
  formattedDiseases_GTE?: number | null;
  formattedDiseases_LONGEST_EQUAL?: number | null;
  formattedDiseases_LONGEST_GT?: number | null;
  formattedDiseases_LONGEST_GTE?: number | null;
  formattedDiseases_LONGEST_LT?: number | null;
  formattedDiseases_LONGEST_LTE?: number | null;
  formattedDiseases_LT?: number | null;
  formattedDiseases_LTE?: number | null;
  formattedDiseases_SHORTEST_EQUAL?: number | null;
  formattedDiseases_SHORTEST_GT?: number | null;
  formattedDiseases_SHORTEST_GTE?: number | null;
  formattedDiseases_SHORTEST_LT?: number | null;
  formattedDiseases_SHORTEST_LTE?: number | null;
  formattedIndications_AVERAGE_EQUAL?: number | null;
  formattedIndications_AVERAGE_GT?: number | null;
  formattedIndications_AVERAGE_GTE?: number | null;
  formattedIndications_AVERAGE_LT?: number | null;
  formattedIndications_AVERAGE_LTE?: number | null;
  formattedIndications_EQUAL?: string | null;
  formattedIndications_GT?: number | null;
  formattedIndications_GTE?: number | null;
  formattedIndications_LONGEST_EQUAL?: number | null;
  formattedIndications_LONGEST_GT?: number | null;
  formattedIndications_LONGEST_GTE?: number | null;
  formattedIndications_LONGEST_LT?: number | null;
  formattedIndications_LONGEST_LTE?: number | null;
  formattedIndications_LT?: number | null;
  formattedIndications_LTE?: number | null;
  formattedIndications_SHORTEST_EQUAL?: number | null;
  formattedIndications_SHORTEST_GT?: number | null;
  formattedIndications_SHORTEST_GTE?: number | null;
  formattedIndications_SHORTEST_LT?: number | null;
  formattedIndications_SHORTEST_LTE?: number | null;
  formattedProducts_AVERAGE_EQUAL?: number | null;
  formattedProducts_AVERAGE_GT?: number | null;
  formattedProducts_AVERAGE_GTE?: number | null;
  formattedProducts_AVERAGE_LT?: number | null;
  formattedProducts_AVERAGE_LTE?: number | null;
  formattedProducts_EQUAL?: string | null;
  formattedProducts_GT?: number | null;
  formattedProducts_GTE?: number | null;
  formattedProducts_LONGEST_EQUAL?: number | null;
  formattedProducts_LONGEST_GT?: number | null;
  formattedProducts_LONGEST_GTE?: number | null;
  formattedProducts_LONGEST_LT?: number | null;
  formattedProducts_LONGEST_LTE?: number | null;
  formattedProducts_LT?: number | null;
  formattedProducts_LTE?: number | null;
  formattedProducts_SHORTEST_EQUAL?: number | null;
  formattedProducts_SHORTEST_GT?: number | null;
  formattedProducts_SHORTEST_GTE?: number | null;
  formattedProducts_SHORTEST_LT?: number | null;
  formattedProducts_SHORTEST_LTE?: number | null;
  formattedTags_AVERAGE_EQUAL?: number | null;
  formattedTags_AVERAGE_GT?: number | null;
  formattedTags_AVERAGE_GTE?: number | null;
  formattedTags_AVERAGE_LT?: number | null;
  formattedTags_AVERAGE_LTE?: number | null;
  formattedTags_EQUAL?: string | null;
  formattedTags_GT?: number | null;
  formattedTags_GTE?: number | null;
  formattedTags_LONGEST_EQUAL?: number | null;
  formattedTags_LONGEST_GT?: number | null;
  formattedTags_LONGEST_GTE?: number | null;
  formattedTags_LONGEST_LT?: number | null;
  formattedTags_LONGEST_LTE?: number | null;
  formattedTags_LT?: number | null;
  formattedTags_LTE?: number | null;
  formattedTags_SHORTEST_EQUAL?: number | null;
  formattedTags_SHORTEST_GT?: number | null;
  formattedTags_SHORTEST_GTE?: number | null;
  formattedTags_SHORTEST_LT?: number | null;
  formattedTags_SHORTEST_LTE?: number | null;
  formattedValidityPeriod_AVERAGE_EQUAL?: number | null;
  formattedValidityPeriod_AVERAGE_GT?: number | null;
  formattedValidityPeriod_AVERAGE_GTE?: number | null;
  formattedValidityPeriod_AVERAGE_LT?: number | null;
  formattedValidityPeriod_AVERAGE_LTE?: number | null;
  formattedValidityPeriod_EQUAL?: string | null;
  formattedValidityPeriod_GT?: number | null;
  formattedValidityPeriod_GTE?: number | null;
  formattedValidityPeriod_LONGEST_EQUAL?: number | null;
  formattedValidityPeriod_LONGEST_GT?: number | null;
  formattedValidityPeriod_LONGEST_GTE?: number | null;
  formattedValidityPeriod_LONGEST_LT?: number | null;
  formattedValidityPeriod_LONGEST_LTE?: number | null;
  formattedValidityPeriod_LT?: number | null;
  formattedValidityPeriod_LTE?: number | null;
  formattedValidityPeriod_SHORTEST_EQUAL?: number | null;
  formattedValidityPeriod_SHORTEST_GT?: number | null;
  formattedValidityPeriod_SHORTEST_GTE?: number | null;
  formattedValidityPeriod_SHORTEST_LT?: number | null;
  formattedValidityPeriod_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  initialVersionId_AVERAGE_EQUAL?: number | null;
  initialVersionId_AVERAGE_GT?: number | null;
  initialVersionId_AVERAGE_GTE?: number | null;
  initialVersionId_AVERAGE_LT?: number | null;
  initialVersionId_AVERAGE_LTE?: number | null;
  initialVersionId_EQUAL?: string | null;
  initialVersionId_GT?: number | null;
  initialVersionId_GTE?: number | null;
  initialVersionId_LONGEST_EQUAL?: number | null;
  initialVersionId_LONGEST_GT?: number | null;
  initialVersionId_LONGEST_GTE?: number | null;
  initialVersionId_LONGEST_LT?: number | null;
  initialVersionId_LONGEST_LTE?: number | null;
  initialVersionId_LT?: number | null;
  initialVersionId_LTE?: number | null;
  initialVersionId_SHORTEST_EQUAL?: number | null;
  initialVersionId_SHORTEST_GT?: number | null;
  initialVersionId_SHORTEST_GTE?: number | null;
  initialVersionId_SHORTEST_LT?: number | null;
  initialVersionId_SHORTEST_LTE?: number | null;
  lastExecutionDate_EQUAL?: any | null;
  lastExecutionDate_GT?: any | null;
  lastExecutionDate_GTE?: any | null;
  lastExecutionDate_LT?: any | null;
  lastExecutionDate_LTE?: any | null;
  lastExecutionDate_MAX_EQUAL?: any | null;
  lastExecutionDate_MAX_GT?: any | null;
  lastExecutionDate_MAX_GTE?: any | null;
  lastExecutionDate_MAX_LT?: any | null;
  lastExecutionDate_MAX_LTE?: any | null;
  lastExecutionDate_MIN_EQUAL?: any | null;
  lastExecutionDate_MIN_GT?: any | null;
  lastExecutionDate_MIN_GTE?: any | null;
  lastExecutionDate_MIN_LT?: any | null;
  lastExecutionDate_MIN_LTE?: any | null;
  lastUpdatedOn_AVERAGE_EQUAL?: number | null;
  lastUpdatedOn_AVERAGE_GT?: number | null;
  lastUpdatedOn_AVERAGE_GTE?: number | null;
  lastUpdatedOn_AVERAGE_LT?: number | null;
  lastUpdatedOn_AVERAGE_LTE?: number | null;
  lastUpdatedOn_EQUAL?: number | null;
  lastUpdatedOn_GT?: number | null;
  lastUpdatedOn_GTE?: number | null;
  lastUpdatedOn_LT?: number | null;
  lastUpdatedOn_LTE?: number | null;
  lastUpdatedOn_MAX_EQUAL?: number | null;
  lastUpdatedOn_MAX_GT?: number | null;
  lastUpdatedOn_MAX_GTE?: number | null;
  lastUpdatedOn_MAX_LT?: number | null;
  lastUpdatedOn_MAX_LTE?: number | null;
  lastUpdatedOn_MIN_EQUAL?: number | null;
  lastUpdatedOn_MIN_GT?: number | null;
  lastUpdatedOn_MIN_GTE?: number | null;
  lastUpdatedOn_MIN_LT?: number | null;
  lastUpdatedOn_MIN_LTE?: number | null;
  lastUpdatedOn_SUM_EQUAL?: number | null;
  lastUpdatedOn_SUM_GT?: number | null;
  lastUpdatedOn_SUM_GTE?: number | null;
  lastUpdatedOn_SUM_LT?: number | null;
  lastUpdatedOn_SUM_LTE?: number | null;
  name_AVERAGE_EQUAL?: number | null;
  name_AVERAGE_GT?: number | null;
  name_AVERAGE_GTE?: number | null;
  name_AVERAGE_LT?: number | null;
  name_AVERAGE_LTE?: number | null;
  name_EQUAL?: string | null;
  name_GT?: number | null;
  name_GTE?: number | null;
  name_LONGEST_EQUAL?: number | null;
  name_LONGEST_GT?: number | null;
  name_LONGEST_GTE?: number | null;
  name_LONGEST_LT?: number | null;
  name_LONGEST_LTE?: number | null;
  name_LT?: number | null;
  name_LTE?: number | null;
  name_SHORTEST_EQUAL?: number | null;
  name_SHORTEST_GT?: number | null;
  name_SHORTEST_GTE?: number | null;
  name_SHORTEST_LT?: number | null;
  name_SHORTEST_LTE?: number | null;
  pushedOn_EQUAL?: any | null;
  pushedOn_GT?: any | null;
  pushedOn_GTE?: any | null;
  pushedOn_LT?: any | null;
  pushedOn_LTE?: any | null;
  pushedOn_MAX_EQUAL?: any | null;
  pushedOn_MAX_GT?: any | null;
  pushedOn_MAX_GTE?: any | null;
  pushedOn_MAX_LT?: any | null;
  pushedOn_MAX_LTE?: any | null;
  pushedOn_MIN_EQUAL?: any | null;
  pushedOn_MIN_GT?: any | null;
  pushedOn_MIN_GTE?: any | null;
  pushedOn_MIN_LT?: any | null;
  pushedOn_MIN_LTE?: any | null;
  reportData_AVERAGE_EQUAL?: number | null;
  reportData_AVERAGE_GT?: number | null;
  reportData_AVERAGE_GTE?: number | null;
  reportData_AVERAGE_LT?: number | null;
  reportData_AVERAGE_LTE?: number | null;
  reportData_EQUAL?: string | null;
  reportData_GT?: number | null;
  reportData_GTE?: number | null;
  reportData_LONGEST_EQUAL?: number | null;
  reportData_LONGEST_GT?: number | null;
  reportData_LONGEST_GTE?: number | null;
  reportData_LONGEST_LT?: number | null;
  reportData_LONGEST_LTE?: number | null;
  reportData_LT?: number | null;
  reportData_LTE?: number | null;
  reportData_SHORTEST_EQUAL?: number | null;
  reportData_SHORTEST_GT?: number | null;
  reportData_SHORTEST_GTE?: number | null;
  reportData_SHORTEST_LT?: number | null;
  reportData_SHORTEST_LTE?: number | null;
  totalAmount_AVERAGE_EQUAL?: number | null;
  totalAmount_AVERAGE_GT?: number | null;
  totalAmount_AVERAGE_GTE?: number | null;
  totalAmount_AVERAGE_LT?: number | null;
  totalAmount_AVERAGE_LTE?: number | null;
  totalAmount_EQUAL?: number | null;
  totalAmount_GT?: number | null;
  totalAmount_GTE?: number | null;
  totalAmount_LT?: number | null;
  totalAmount_LTE?: number | null;
  totalAmount_MAX_EQUAL?: number | null;
  totalAmount_MAX_GT?: number | null;
  totalAmount_MAX_GTE?: number | null;
  totalAmount_MAX_LT?: number | null;
  totalAmount_MAX_LTE?: number | null;
  totalAmount_MIN_EQUAL?: number | null;
  totalAmount_MIN_GT?: number | null;
  totalAmount_MIN_GTE?: number | null;
  totalAmount_MIN_LT?: number | null;
  totalAmount_MIN_LTE?: number | null;
  totalAmount_SUM_EQUAL?: number | null;
  totalAmount_SUM_GT?: number | null;
  totalAmount_SUM_GTE?: number | null;
  totalAmount_SUM_LT?: number | null;
  totalAmount_SUM_LTE?: number | null;
  version_AVERAGE_EQUAL?: number | null;
  version_AVERAGE_GT?: number | null;
  version_AVERAGE_GTE?: number | null;
  version_AVERAGE_LT?: number | null;
  version_AVERAGE_LTE?: number | null;
  version_EQUAL?: number | null;
  version_GT?: number | null;
  version_GTE?: number | null;
  version_LT?: number | null;
  version_LTE?: number | null;
  version_MAX_EQUAL?: number | null;
  version_MAX_GT?: number | null;
  version_MAX_GTE?: number | null;
  version_MAX_LT?: number | null;
  version_MAX_LTE?: number | null;
  version_MIN_EQUAL?: number | null;
  version_MIN_GT?: number | null;
  version_MIN_GTE?: number | null;
  version_MIN_LT?: number | null;
  version_MIN_LTE?: number | null;
  version_SUM_EQUAL?: number | null;
  version_SUM_GT?: number | null;
  version_SUM_GTE?: number | null;
  version_SUM_LT?: number | null;
  version_SUM_LTE?: number | null;
}

export interface CaseCaseAssigneeAggregateInput {
  AND?: CaseCaseAssigneeAggregateInput[] | null;
  OR?: CaseCaseAssigneeAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: CaseCaseAssigneeNodeAggregationWhereInput | null;
}

export interface CaseCaseAssigneeConnectionWhere {
  AND?: CaseCaseAssigneeConnectionWhere[] | null;
  OR?: CaseCaseAssigneeConnectionWhere[] | null;
  node?: UserWhere | null;
  node_NOT?: UserWhere | null;
}

export interface CaseCaseAssigneeNodeAggregationWhereInput {
  AND?: CaseCaseAssigneeNodeAggregationWhereInput[] | null;
  OR?: CaseCaseAssigneeNodeAggregationWhereInput[] | null;
  deletedOn_EQUAL?: any | null;
  deletedOn_GT?: any | null;
  deletedOn_GTE?: any | null;
  deletedOn_LT?: any | null;
  deletedOn_LTE?: any | null;
  deletedOn_MAX_EQUAL?: any | null;
  deletedOn_MAX_GT?: any | null;
  deletedOn_MAX_GTE?: any | null;
  deletedOn_MAX_LT?: any | null;
  deletedOn_MAX_LTE?: any | null;
  deletedOn_MIN_EQUAL?: any | null;
  deletedOn_MIN_GT?: any | null;
  deletedOn_MIN_GTE?: any | null;
  deletedOn_MIN_LT?: any | null;
  deletedOn_MIN_LTE?: any | null;
  department_AVERAGE_EQUAL?: number | null;
  department_AVERAGE_GT?: number | null;
  department_AVERAGE_GTE?: number | null;
  department_AVERAGE_LT?: number | null;
  department_AVERAGE_LTE?: number | null;
  department_EQUAL?: string | null;
  department_GT?: number | null;
  department_GTE?: number | null;
  department_LONGEST_EQUAL?: number | null;
  department_LONGEST_GT?: number | null;
  department_LONGEST_GTE?: number | null;
  department_LONGEST_LT?: number | null;
  department_LONGEST_LTE?: number | null;
  department_LT?: number | null;
  department_LTE?: number | null;
  department_SHORTEST_EQUAL?: number | null;
  department_SHORTEST_GT?: number | null;
  department_SHORTEST_GTE?: number | null;
  department_SHORTEST_LT?: number | null;
  department_SHORTEST_LTE?: number | null;
  email_AVERAGE_EQUAL?: number | null;
  email_AVERAGE_GT?: number | null;
  email_AVERAGE_GTE?: number | null;
  email_AVERAGE_LT?: number | null;
  email_AVERAGE_LTE?: number | null;
  email_EQUAL?: string | null;
  email_GT?: number | null;
  email_GTE?: number | null;
  email_LONGEST_EQUAL?: number | null;
  email_LONGEST_GT?: number | null;
  email_LONGEST_GTE?: number | null;
  email_LONGEST_LT?: number | null;
  email_LONGEST_LTE?: number | null;
  email_LT?: number | null;
  email_LTE?: number | null;
  email_SHORTEST_EQUAL?: number | null;
  email_SHORTEST_GT?: number | null;
  email_SHORTEST_GTE?: number | null;
  email_SHORTEST_LT?: number | null;
  email_SHORTEST_LTE?: number | null;
  firstName_AVERAGE_EQUAL?: number | null;
  firstName_AVERAGE_GT?: number | null;
  firstName_AVERAGE_GTE?: number | null;
  firstName_AVERAGE_LT?: number | null;
  firstName_AVERAGE_LTE?: number | null;
  firstName_EQUAL?: string | null;
  firstName_GT?: number | null;
  firstName_GTE?: number | null;
  firstName_LONGEST_EQUAL?: number | null;
  firstName_LONGEST_GT?: number | null;
  firstName_LONGEST_GTE?: number | null;
  firstName_LONGEST_LT?: number | null;
  firstName_LONGEST_LTE?: number | null;
  firstName_LT?: number | null;
  firstName_LTE?: number | null;
  firstName_SHORTEST_EQUAL?: number | null;
  firstName_SHORTEST_GT?: number | null;
  firstName_SHORTEST_GTE?: number | null;
  firstName_SHORTEST_LT?: number | null;
  firstName_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  lastName_AVERAGE_EQUAL?: number | null;
  lastName_AVERAGE_GT?: number | null;
  lastName_AVERAGE_GTE?: number | null;
  lastName_AVERAGE_LT?: number | null;
  lastName_AVERAGE_LTE?: number | null;
  lastName_EQUAL?: string | null;
  lastName_GT?: number | null;
  lastName_GTE?: number | null;
  lastName_LONGEST_EQUAL?: number | null;
  lastName_LONGEST_GT?: number | null;
  lastName_LONGEST_GTE?: number | null;
  lastName_LONGEST_LT?: number | null;
  lastName_LONGEST_LTE?: number | null;
  lastName_LT?: number | null;
  lastName_LTE?: number | null;
  lastName_SHORTEST_EQUAL?: number | null;
  lastName_SHORTEST_GT?: number | null;
  lastName_SHORTEST_GTE?: number | null;
  lastName_SHORTEST_LT?: number | null;
  lastName_SHORTEST_LTE?: number | null;
  position_AVERAGE_EQUAL?: number | null;
  position_AVERAGE_GT?: number | null;
  position_AVERAGE_GTE?: number | null;
  position_AVERAGE_LT?: number | null;
  position_AVERAGE_LTE?: number | null;
  position_EQUAL?: string | null;
  position_GT?: number | null;
  position_GTE?: number | null;
  position_LONGEST_EQUAL?: number | null;
  position_LONGEST_GT?: number | null;
  position_LONGEST_GTE?: number | null;
  position_LONGEST_LT?: number | null;
  position_LONGEST_LTE?: number | null;
  position_LT?: number | null;
  position_LTE?: number | null;
  position_SHORTEST_EQUAL?: number | null;
  position_SHORTEST_GT?: number | null;
  position_SHORTEST_GTE?: number | null;
  position_SHORTEST_LT?: number | null;
  position_SHORTEST_LTE?: number | null;
  preferredLanguage_AVERAGE_EQUAL?: number | null;
  preferredLanguage_AVERAGE_GT?: number | null;
  preferredLanguage_AVERAGE_GTE?: number | null;
  preferredLanguage_AVERAGE_LT?: number | null;
  preferredLanguage_AVERAGE_LTE?: number | null;
  preferredLanguage_EQUAL?: string | null;
  preferredLanguage_GT?: number | null;
  preferredLanguage_GTE?: number | null;
  preferredLanguage_LONGEST_EQUAL?: number | null;
  preferredLanguage_LONGEST_GT?: number | null;
  preferredLanguage_LONGEST_GTE?: number | null;
  preferredLanguage_LONGEST_LT?: number | null;
  preferredLanguage_LONGEST_LTE?: number | null;
  preferredLanguage_LT?: number | null;
  preferredLanguage_LTE?: number | null;
  preferredLanguage_SHORTEST_EQUAL?: number | null;
  preferredLanguage_SHORTEST_GT?: number | null;
  preferredLanguage_SHORTEST_GTE?: number | null;
  preferredLanguage_SHORTEST_LT?: number | null;
  preferredLanguage_SHORTEST_LTE?: number | null;
  tenantId_AVERAGE_EQUAL?: number | null;
  tenantId_AVERAGE_GT?: number | null;
  tenantId_AVERAGE_GTE?: number | null;
  tenantId_AVERAGE_LT?: number | null;
  tenantId_AVERAGE_LTE?: number | null;
  tenantId_EQUAL?: string | null;
  tenantId_GT?: number | null;
  tenantId_GTE?: number | null;
  tenantId_LONGEST_EQUAL?: number | null;
  tenantId_LONGEST_GT?: number | null;
  tenantId_LONGEST_GTE?: number | null;
  tenantId_LONGEST_LT?: number | null;
  tenantId_LONGEST_LTE?: number | null;
  tenantId_LT?: number | null;
  tenantId_LTE?: number | null;
  tenantId_SHORTEST_EQUAL?: number | null;
  tenantId_SHORTEST_GT?: number | null;
  tenantId_SHORTEST_GTE?: number | null;
  tenantId_SHORTEST_LT?: number | null;
  tenantId_SHORTEST_LTE?: number | null;
}

export interface CaseCaseEventLogsAggregateInput {
  AND?: CaseCaseEventLogsAggregateInput[] | null;
  OR?: CaseCaseEventLogsAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: CaseCaseEventLogsNodeAggregationWhereInput | null;
}

export interface CaseCaseEventLogsConnectionWhere {
  AND?: CaseCaseEventLogsConnectionWhere[] | null;
  OR?: CaseCaseEventLogsConnectionWhere[] | null;
  node?: CaseEventLogWhere | null;
  node_NOT?: CaseEventLogWhere | null;
}

export interface CaseCaseEventLogsNodeAggregationWhereInput {
  AND?: CaseCaseEventLogsNodeAggregationWhereInput[] | null;
  OR?: CaseCaseEventLogsNodeAggregationWhereInput[] | null;
  data_AVERAGE_EQUAL?: number | null;
  data_AVERAGE_GT?: number | null;
  data_AVERAGE_GTE?: number | null;
  data_AVERAGE_LT?: number | null;
  data_AVERAGE_LTE?: number | null;
  data_EQUAL?: string | null;
  data_GT?: number | null;
  data_GTE?: number | null;
  data_LONGEST_EQUAL?: number | null;
  data_LONGEST_GT?: number | null;
  data_LONGEST_GTE?: number | null;
  data_LONGEST_LT?: number | null;
  data_LONGEST_LTE?: number | null;
  data_LT?: number | null;
  data_LTE?: number | null;
  data_SHORTEST_EQUAL?: number | null;
  data_SHORTEST_GT?: number | null;
  data_SHORTEST_GTE?: number | null;
  data_SHORTEST_LT?: number | null;
  data_SHORTEST_LTE?: number | null;
  triggeredOn_EQUAL?: any | null;
  triggeredOn_GT?: any | null;
  triggeredOn_GTE?: any | null;
  triggeredOn_LT?: any | null;
  triggeredOn_LTE?: any | null;
  triggeredOn_MAX_EQUAL?: any | null;
  triggeredOn_MAX_GT?: any | null;
  triggeredOn_MAX_GTE?: any | null;
  triggeredOn_MAX_LT?: any | null;
  triggeredOn_MAX_LTE?: any | null;
  triggeredOn_MIN_EQUAL?: any | null;
  triggeredOn_MIN_GT?: any | null;
  triggeredOn_MIN_GTE?: any | null;
  triggeredOn_MIN_LT?: any | null;
  triggeredOn_MIN_LTE?: any | null;
}

export interface CaseCaseReportingDataAggregateInput {
  AND?: CaseCaseReportingDataAggregateInput[] | null;
  OR?: CaseCaseReportingDataAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: CaseCaseReportingDataNodeAggregationWhereInput | null;
}

export interface CaseCaseReportingDataConnectionWhere {
  AND?: CaseCaseReportingDataConnectionWhere[] | null;
  OR?: CaseCaseReportingDataConnectionWhere[] | null;
  node?: CaseReportingDataWhere | null;
  node_NOT?: CaseReportingDataWhere | null;
}

export interface CaseCaseReportingDataNodeAggregationWhereInput {
  AND?: CaseCaseReportingDataNodeAggregationWhereInput[] | null;
  OR?: CaseCaseReportingDataNodeAggregationWhereInput[] | null;
  createdOn_EQUAL?: any | null;
  createdOn_GT?: any | null;
  createdOn_GTE?: any | null;
  createdOn_LT?: any | null;
  createdOn_LTE?: any | null;
  createdOn_MAX_EQUAL?: any | null;
  createdOn_MAX_GT?: any | null;
  createdOn_MAX_GTE?: any | null;
  createdOn_MAX_LT?: any | null;
  createdOn_MAX_LTE?: any | null;
  createdOn_MIN_EQUAL?: any | null;
  createdOn_MIN_GT?: any | null;
  createdOn_MIN_GTE?: any | null;
  createdOn_MIN_LT?: any | null;
  createdOn_MIN_LTE?: any | null;
  lastUpdatedOn_EQUAL?: any | null;
  lastUpdatedOn_GT?: any | null;
  lastUpdatedOn_GTE?: any | null;
  lastUpdatedOn_LT?: any | null;
  lastUpdatedOn_LTE?: any | null;
  lastUpdatedOn_MAX_EQUAL?: any | null;
  lastUpdatedOn_MAX_GT?: any | null;
  lastUpdatedOn_MAX_GTE?: any | null;
  lastUpdatedOn_MAX_LT?: any | null;
  lastUpdatedOn_MAX_LTE?: any | null;
  lastUpdatedOn_MIN_EQUAL?: any | null;
  lastUpdatedOn_MIN_GT?: any | null;
  lastUpdatedOn_MIN_GTE?: any | null;
  lastUpdatedOn_MIN_LT?: any | null;
  lastUpdatedOn_MIN_LTE?: any | null;
  ldlDelta_AVERAGE_EQUAL?: number | null;
  ldlDelta_AVERAGE_GT?: number | null;
  ldlDelta_AVERAGE_GTE?: number | null;
  ldlDelta_AVERAGE_LT?: number | null;
  ldlDelta_AVERAGE_LTE?: number | null;
  ldlDelta_EQUAL?: number | null;
  ldlDelta_GT?: number | null;
  ldlDelta_GTE?: number | null;
  ldlDelta_LT?: number | null;
  ldlDelta_LTE?: number | null;
  ldlDelta_MAX_EQUAL?: number | null;
  ldlDelta_MAX_GT?: number | null;
  ldlDelta_MAX_GTE?: number | null;
  ldlDelta_MAX_LT?: number | null;
  ldlDelta_MAX_LTE?: number | null;
  ldlDelta_MIN_EQUAL?: number | null;
  ldlDelta_MIN_GT?: number | null;
  ldlDelta_MIN_GTE?: number | null;
  ldlDelta_MIN_LT?: number | null;
  ldlDelta_MIN_LTE?: number | null;
  ldlDelta_SUM_EQUAL?: number | null;
  ldlDelta_SUM_GT?: number | null;
  ldlDelta_SUM_GTE?: number | null;
  ldlDelta_SUM_LT?: number | null;
  ldlDelta_SUM_LTE?: number | null;
  snapshot_AVERAGE_EQUAL?: number | null;
  snapshot_AVERAGE_GT?: number | null;
  snapshot_AVERAGE_GTE?: number | null;
  snapshot_AVERAGE_LT?: number | null;
  snapshot_AVERAGE_LTE?: number | null;
  snapshot_EQUAL?: string | null;
  snapshot_GT?: number | null;
  snapshot_GTE?: number | null;
  snapshot_LONGEST_EQUAL?: number | null;
  snapshot_LONGEST_GT?: number | null;
  snapshot_LONGEST_GTE?: number | null;
  snapshot_LONGEST_LT?: number | null;
  snapshot_LONGEST_LTE?: number | null;
  snapshot_LT?: number | null;
  snapshot_LTE?: number | null;
  snapshot_SHORTEST_EQUAL?: number | null;
  snapshot_SHORTEST_GT?: number | null;
  snapshot_SHORTEST_GTE?: number | null;
  snapshot_SHORTEST_LT?: number | null;
  snapshot_SHORTEST_LTE?: number | null;
}

export interface CaseCohortAggregateInput {
  AND?: CaseCohortAggregateInput[] | null;
  OR?: CaseCohortAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
}

export interface CaseCohortConnectionWhere {
  AND?: CaseCohortConnectionWhere[] | null;
  OR?: CaseCohortConnectionWhere[] | null;
  node?: EnrollingPeriodWhere | null;
  node_NOT?: EnrollingPeriodWhere | null;
}

export interface CaseDiseaseAggregateInput {
  AND?: CaseDiseaseAggregateInput[] | null;
  OR?: CaseDiseaseAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: CaseDiseaseNodeAggregationWhereInput | null;
}

export interface CaseDiseaseConnectionWhere {
  AND?: CaseDiseaseConnectionWhere[] | null;
  OR?: CaseDiseaseConnectionWhere[] | null;
  node?: DiseaseWhere | null;
  node_NOT?: DiseaseWhere | null;
}

export interface CaseDiseaseNodeAggregationWhereInput {
  AND?: CaseDiseaseNodeAggregationWhereInput[] | null;
  Icd10Code_AVERAGE_EQUAL?: number | null;
  Icd10Code_AVERAGE_GT?: number | null;
  Icd10Code_AVERAGE_GTE?: number | null;
  Icd10Code_AVERAGE_LT?: number | null;
  Icd10Code_AVERAGE_LTE?: number | null;
  Icd10Code_EQUAL?: string | null;
  Icd10Code_GT?: number | null;
  Icd10Code_GTE?: number | null;
  Icd10Code_LONGEST_EQUAL?: number | null;
  Icd10Code_LONGEST_GT?: number | null;
  Icd10Code_LONGEST_GTE?: number | null;
  Icd10Code_LONGEST_LT?: number | null;
  Icd10Code_LONGEST_LTE?: number | null;
  Icd10Code_LT?: number | null;
  Icd10Code_LTE?: number | null;
  Icd10Code_SHORTEST_EQUAL?: number | null;
  Icd10Code_SHORTEST_GT?: number | null;
  Icd10Code_SHORTEST_GTE?: number | null;
  Icd10Code_SHORTEST_LT?: number | null;
  Icd10Code_SHORTEST_LTE?: number | null;
  Name_AVERAGE_EQUAL?: number | null;
  Name_AVERAGE_GT?: number | null;
  Name_AVERAGE_GTE?: number | null;
  Name_AVERAGE_LT?: number | null;
  Name_AVERAGE_LTE?: number | null;
  Name_EQUAL?: string | null;
  Name_GT?: number | null;
  Name_GTE?: number | null;
  Name_LONGEST_EQUAL?: number | null;
  Name_LONGEST_GT?: number | null;
  Name_LONGEST_GTE?: number | null;
  Name_LONGEST_LT?: number | null;
  Name_LONGEST_LTE?: number | null;
  Name_LT?: number | null;
  Name_LTE?: number | null;
  Name_SHORTEST_EQUAL?: number | null;
  Name_SHORTEST_GT?: number | null;
  Name_SHORTEST_GTE?: number | null;
  Name_SHORTEST_LT?: number | null;
  Name_SHORTEST_LTE?: number | null;
  OR?: CaseDiseaseNodeAggregationWhereInput[] | null;
}

export interface CaseEventLogTriggeredByAggregateInput {
  AND?: CaseEventLogTriggeredByAggregateInput[] | null;
  OR?: CaseEventLogTriggeredByAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: CaseEventLogTriggeredByNodeAggregationWhereInput | null;
}

export interface CaseEventLogTriggeredByConnectionWhere {
  AND?: CaseEventLogTriggeredByConnectionWhere[] | null;
  OR?: CaseEventLogTriggeredByConnectionWhere[] | null;
  node?: UserWhere | null;
  node_NOT?: UserWhere | null;
}

export interface CaseEventLogTriggeredByNodeAggregationWhereInput {
  AND?: CaseEventLogTriggeredByNodeAggregationWhereInput[] | null;
  OR?: CaseEventLogTriggeredByNodeAggregationWhereInput[] | null;
  deletedOn_EQUAL?: any | null;
  deletedOn_GT?: any | null;
  deletedOn_GTE?: any | null;
  deletedOn_LT?: any | null;
  deletedOn_LTE?: any | null;
  deletedOn_MAX_EQUAL?: any | null;
  deletedOn_MAX_GT?: any | null;
  deletedOn_MAX_GTE?: any | null;
  deletedOn_MAX_LT?: any | null;
  deletedOn_MAX_LTE?: any | null;
  deletedOn_MIN_EQUAL?: any | null;
  deletedOn_MIN_GT?: any | null;
  deletedOn_MIN_GTE?: any | null;
  deletedOn_MIN_LT?: any | null;
  deletedOn_MIN_LTE?: any | null;
  department_AVERAGE_EQUAL?: number | null;
  department_AVERAGE_GT?: number | null;
  department_AVERAGE_GTE?: number | null;
  department_AVERAGE_LT?: number | null;
  department_AVERAGE_LTE?: number | null;
  department_EQUAL?: string | null;
  department_GT?: number | null;
  department_GTE?: number | null;
  department_LONGEST_EQUAL?: number | null;
  department_LONGEST_GT?: number | null;
  department_LONGEST_GTE?: number | null;
  department_LONGEST_LT?: number | null;
  department_LONGEST_LTE?: number | null;
  department_LT?: number | null;
  department_LTE?: number | null;
  department_SHORTEST_EQUAL?: number | null;
  department_SHORTEST_GT?: number | null;
  department_SHORTEST_GTE?: number | null;
  department_SHORTEST_LT?: number | null;
  department_SHORTEST_LTE?: number | null;
  email_AVERAGE_EQUAL?: number | null;
  email_AVERAGE_GT?: number | null;
  email_AVERAGE_GTE?: number | null;
  email_AVERAGE_LT?: number | null;
  email_AVERAGE_LTE?: number | null;
  email_EQUAL?: string | null;
  email_GT?: number | null;
  email_GTE?: number | null;
  email_LONGEST_EQUAL?: number | null;
  email_LONGEST_GT?: number | null;
  email_LONGEST_GTE?: number | null;
  email_LONGEST_LT?: number | null;
  email_LONGEST_LTE?: number | null;
  email_LT?: number | null;
  email_LTE?: number | null;
  email_SHORTEST_EQUAL?: number | null;
  email_SHORTEST_GT?: number | null;
  email_SHORTEST_GTE?: number | null;
  email_SHORTEST_LT?: number | null;
  email_SHORTEST_LTE?: number | null;
  firstName_AVERAGE_EQUAL?: number | null;
  firstName_AVERAGE_GT?: number | null;
  firstName_AVERAGE_GTE?: number | null;
  firstName_AVERAGE_LT?: number | null;
  firstName_AVERAGE_LTE?: number | null;
  firstName_EQUAL?: string | null;
  firstName_GT?: number | null;
  firstName_GTE?: number | null;
  firstName_LONGEST_EQUAL?: number | null;
  firstName_LONGEST_GT?: number | null;
  firstName_LONGEST_GTE?: number | null;
  firstName_LONGEST_LT?: number | null;
  firstName_LONGEST_LTE?: number | null;
  firstName_LT?: number | null;
  firstName_LTE?: number | null;
  firstName_SHORTEST_EQUAL?: number | null;
  firstName_SHORTEST_GT?: number | null;
  firstName_SHORTEST_GTE?: number | null;
  firstName_SHORTEST_LT?: number | null;
  firstName_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  lastName_AVERAGE_EQUAL?: number | null;
  lastName_AVERAGE_GT?: number | null;
  lastName_AVERAGE_GTE?: number | null;
  lastName_AVERAGE_LT?: number | null;
  lastName_AVERAGE_LTE?: number | null;
  lastName_EQUAL?: string | null;
  lastName_GT?: number | null;
  lastName_GTE?: number | null;
  lastName_LONGEST_EQUAL?: number | null;
  lastName_LONGEST_GT?: number | null;
  lastName_LONGEST_GTE?: number | null;
  lastName_LONGEST_LT?: number | null;
  lastName_LONGEST_LTE?: number | null;
  lastName_LT?: number | null;
  lastName_LTE?: number | null;
  lastName_SHORTEST_EQUAL?: number | null;
  lastName_SHORTEST_GT?: number | null;
  lastName_SHORTEST_GTE?: number | null;
  lastName_SHORTEST_LT?: number | null;
  lastName_SHORTEST_LTE?: number | null;
  position_AVERAGE_EQUAL?: number | null;
  position_AVERAGE_GT?: number | null;
  position_AVERAGE_GTE?: number | null;
  position_AVERAGE_LT?: number | null;
  position_AVERAGE_LTE?: number | null;
  position_EQUAL?: string | null;
  position_GT?: number | null;
  position_GTE?: number | null;
  position_LONGEST_EQUAL?: number | null;
  position_LONGEST_GT?: number | null;
  position_LONGEST_GTE?: number | null;
  position_LONGEST_LT?: number | null;
  position_LONGEST_LTE?: number | null;
  position_LT?: number | null;
  position_LTE?: number | null;
  position_SHORTEST_EQUAL?: number | null;
  position_SHORTEST_GT?: number | null;
  position_SHORTEST_GTE?: number | null;
  position_SHORTEST_LT?: number | null;
  position_SHORTEST_LTE?: number | null;
  preferredLanguage_AVERAGE_EQUAL?: number | null;
  preferredLanguage_AVERAGE_GT?: number | null;
  preferredLanguage_AVERAGE_GTE?: number | null;
  preferredLanguage_AVERAGE_LT?: number | null;
  preferredLanguage_AVERAGE_LTE?: number | null;
  preferredLanguage_EQUAL?: string | null;
  preferredLanguage_GT?: number | null;
  preferredLanguage_GTE?: number | null;
  preferredLanguage_LONGEST_EQUAL?: number | null;
  preferredLanguage_LONGEST_GT?: number | null;
  preferredLanguage_LONGEST_GTE?: number | null;
  preferredLanguage_LONGEST_LT?: number | null;
  preferredLanguage_LONGEST_LTE?: number | null;
  preferredLanguage_LT?: number | null;
  preferredLanguage_LTE?: number | null;
  preferredLanguage_SHORTEST_EQUAL?: number | null;
  preferredLanguage_SHORTEST_GT?: number | null;
  preferredLanguage_SHORTEST_GTE?: number | null;
  preferredLanguage_SHORTEST_LT?: number | null;
  preferredLanguage_SHORTEST_LTE?: number | null;
  tenantId_AVERAGE_EQUAL?: number | null;
  tenantId_AVERAGE_GT?: number | null;
  tenantId_AVERAGE_GTE?: number | null;
  tenantId_AVERAGE_LT?: number | null;
  tenantId_AVERAGE_LTE?: number | null;
  tenantId_EQUAL?: string | null;
  tenantId_GT?: number | null;
  tenantId_GTE?: number | null;
  tenantId_LONGEST_EQUAL?: number | null;
  tenantId_LONGEST_GT?: number | null;
  tenantId_LONGEST_GTE?: number | null;
  tenantId_LONGEST_LT?: number | null;
  tenantId_LONGEST_LTE?: number | null;
  tenantId_LT?: number | null;
  tenantId_LTE?: number | null;
  tenantId_SHORTEST_EQUAL?: number | null;
  tenantId_SHORTEST_GT?: number | null;
  tenantId_SHORTEST_GTE?: number | null;
  tenantId_SHORTEST_LT?: number | null;
  tenantId_SHORTEST_LTE?: number | null;
}

export interface CaseEventLogWhere {
  AND?: CaseEventLogWhere[] | null;
  OR?: CaseEventLogWhere[] | null;
  data?: string | null;
  data_CONTAINS?: string | null;
  data_ENDS_WITH?: string | null;
  data_IN?: (string | null)[] | null;
  data_MATCHES?: string | null;
  data_NOT?: string | null;
  data_NOT_CONTAINS?: string | null;
  data_NOT_ENDS_WITH?: string | null;
  data_NOT_IN?: (string | null)[] | null;
  data_NOT_STARTS_WITH?: string | null;
  data_STARTS_WITH?: string | null;
  eventCategory?: CaseEventCategory | null;
  eventCategory_IN?: (CaseEventCategory | null)[] | null;
  eventCategory_NOT?: CaseEventCategory | null;
  eventCategory_NOT_IN?: (CaseEventCategory | null)[] | null;
  eventType?: CaseEventType | null;
  eventType_IN?: (CaseEventType | null)[] | null;
  eventType_NOT?: CaseEventType | null;
  eventType_NOT_IN?: (CaseEventType | null)[] | null;
  trigger?: CaseEventTrigger | null;
  trigger_IN?: (CaseEventTrigger | null)[] | null;
  trigger_NOT?: CaseEventTrigger | null;
  trigger_NOT_IN?: (CaseEventTrigger | null)[] | null;
  triggeredBy?: UserWhere | null;
  triggeredByAggregate?: CaseEventLogTriggeredByAggregateInput | null;
  triggeredByConnection?: CaseEventLogTriggeredByConnectionWhere | null;
  triggeredByConnection_NOT?: CaseEventLogTriggeredByConnectionWhere | null;
  triggeredBy_NOT?: UserWhere | null;
  triggeredOn?: any | null;
  triggeredOn_GT?: any | null;
  triggeredOn_GTE?: any | null;
  triggeredOn_IN?: (any | null)[] | null;
  triggeredOn_LT?: any | null;
  triggeredOn_LTE?: any | null;
  triggeredOn_NOT?: any | null;
  triggeredOn_NOT_IN?: (any | null)[] | null;
}

export interface CaseFinancialDataPointsAggregateInput {
  AND?: CaseFinancialDataPointsAggregateInput[] | null;
  OR?: CaseFinancialDataPointsAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: CaseFinancialDataPointsNodeAggregationWhereInput | null;
}

export interface CaseFinancialDataPointsConnectionWhere {
  AND?: CaseFinancialDataPointsConnectionWhere[] | null;
  OR?: CaseFinancialDataPointsConnectionWhere[] | null;
  node?: FlexFinancialDataPointWhere | null;
  node_NOT?: FlexFinancialDataPointWhere | null;
}

export interface CaseFinancialDataPointsNodeAggregationWhereInput {
  AND?: CaseFinancialDataPointsNodeAggregationWhereInput[] | null;
  OR?: CaseFinancialDataPointsNodeAggregationWhereInput[] | null;
  basePrice_AVERAGE_EQUAL?: number | null;
  basePrice_AVERAGE_GT?: number | null;
  basePrice_AVERAGE_GTE?: number | null;
  basePrice_AVERAGE_LT?: number | null;
  basePrice_AVERAGE_LTE?: number | null;
  basePrice_EQUAL?: number | null;
  basePrice_GT?: number | null;
  basePrice_GTE?: number | null;
  basePrice_LT?: number | null;
  basePrice_LTE?: number | null;
  basePrice_MAX_EQUAL?: number | null;
  basePrice_MAX_GT?: number | null;
  basePrice_MAX_GTE?: number | null;
  basePrice_MAX_LT?: number | null;
  basePrice_MAX_LTE?: number | null;
  basePrice_MIN_EQUAL?: number | null;
  basePrice_MIN_GT?: number | null;
  basePrice_MIN_GTE?: number | null;
  basePrice_MIN_LT?: number | null;
  basePrice_MIN_LTE?: number | null;
  basePrice_SUM_EQUAL?: number | null;
  basePrice_SUM_GT?: number | null;
  basePrice_SUM_GTE?: number | null;
  basePrice_SUM_LT?: number | null;
  basePrice_SUM_LTE?: number | null;
  createdOn_EQUAL?: any | null;
  createdOn_GT?: any | null;
  createdOn_GTE?: any | null;
  createdOn_LT?: any | null;
  createdOn_LTE?: any | null;
  createdOn_MAX_EQUAL?: any | null;
  createdOn_MAX_GT?: any | null;
  createdOn_MAX_GTE?: any | null;
  createdOn_MAX_LT?: any | null;
  createdOn_MAX_LTE?: any | null;
  createdOn_MIN_EQUAL?: any | null;
  createdOn_MIN_GT?: any | null;
  createdOn_MIN_GTE?: any | null;
  createdOn_MIN_LT?: any | null;
  createdOn_MIN_LTE?: any | null;
  currencyCode_AVERAGE_EQUAL?: number | null;
  currencyCode_AVERAGE_GT?: number | null;
  currencyCode_AVERAGE_GTE?: number | null;
  currencyCode_AVERAGE_LT?: number | null;
  currencyCode_AVERAGE_LTE?: number | null;
  currencyCode_EQUAL?: string | null;
  currencyCode_GT?: number | null;
  currencyCode_GTE?: number | null;
  currencyCode_LONGEST_EQUAL?: number | null;
  currencyCode_LONGEST_GT?: number | null;
  currencyCode_LONGEST_GTE?: number | null;
  currencyCode_LONGEST_LT?: number | null;
  currencyCode_LONGEST_LTE?: number | null;
  currencyCode_LT?: number | null;
  currencyCode_LTE?: number | null;
  currencyCode_SHORTEST_EQUAL?: number | null;
  currencyCode_SHORTEST_GT?: number | null;
  currencyCode_SHORTEST_GTE?: number | null;
  currencyCode_SHORTEST_LT?: number | null;
  currencyCode_SHORTEST_LTE?: number | null;
  evaluationSnapshot_AVERAGE_EQUAL?: number | null;
  evaluationSnapshot_AVERAGE_GT?: number | null;
  evaluationSnapshot_AVERAGE_GTE?: number | null;
  evaluationSnapshot_AVERAGE_LT?: number | null;
  evaluationSnapshot_AVERAGE_LTE?: number | null;
  evaluationSnapshot_EQUAL?: string | null;
  evaluationSnapshot_GT?: number | null;
  evaluationSnapshot_GTE?: number | null;
  evaluationSnapshot_LONGEST_EQUAL?: number | null;
  evaluationSnapshot_LONGEST_GT?: number | null;
  evaluationSnapshot_LONGEST_GTE?: number | null;
  evaluationSnapshot_LONGEST_LT?: number | null;
  evaluationSnapshot_LONGEST_LTE?: number | null;
  evaluationSnapshot_LT?: number | null;
  evaluationSnapshot_LTE?: number | null;
  evaluationSnapshot_SHORTEST_EQUAL?: number | null;
  evaluationSnapshot_SHORTEST_GT?: number | null;
  evaluationSnapshot_SHORTEST_GTE?: number | null;
  evaluationSnapshot_SHORTEST_LT?: number | null;
  evaluationSnapshot_SHORTEST_LTE?: number | null;
  generatedUuid_EQUAL?: string | null;
  payablePercentage_AVERAGE_EQUAL?: number | null;
  payablePercentage_AVERAGE_GT?: number | null;
  payablePercentage_AVERAGE_GTE?: number | null;
  payablePercentage_AVERAGE_LT?: number | null;
  payablePercentage_AVERAGE_LTE?: number | null;
  payablePercentage_EQUAL?: number | null;
  payablePercentage_GT?: number | null;
  payablePercentage_GTE?: number | null;
  payablePercentage_LT?: number | null;
  payablePercentage_LTE?: number | null;
  payablePercentage_MAX_EQUAL?: number | null;
  payablePercentage_MAX_GT?: number | null;
  payablePercentage_MAX_GTE?: number | null;
  payablePercentage_MAX_LT?: number | null;
  payablePercentage_MAX_LTE?: number | null;
  payablePercentage_MIN_EQUAL?: number | null;
  payablePercentage_MIN_GT?: number | null;
  payablePercentage_MIN_GTE?: number | null;
  payablePercentage_MIN_LT?: number | null;
  payablePercentage_MIN_LTE?: number | null;
  payablePercentage_SUM_EQUAL?: number | null;
  payablePercentage_SUM_GT?: number | null;
  payablePercentage_SUM_GTE?: number | null;
  payablePercentage_SUM_LT?: number | null;
  payablePercentage_SUM_LTE?: number | null;
  payable_AVERAGE_EQUAL?: number | null;
  payable_AVERAGE_GT?: number | null;
  payable_AVERAGE_GTE?: number | null;
  payable_AVERAGE_LT?: number | null;
  payable_AVERAGE_LTE?: number | null;
  payable_EQUAL?: number | null;
  payable_GT?: number | null;
  payable_GTE?: number | null;
  payable_LT?: number | null;
  payable_LTE?: number | null;
  payable_MAX_EQUAL?: number | null;
  payable_MAX_GT?: number | null;
  payable_MAX_GTE?: number | null;
  payable_MAX_LT?: number | null;
  payable_MAX_LTE?: number | null;
  payable_MIN_EQUAL?: number | null;
  payable_MIN_GT?: number | null;
  payable_MIN_GTE?: number | null;
  payable_MIN_LT?: number | null;
  payable_MIN_LTE?: number | null;
  payable_SUM_EQUAL?: number | null;
  payable_SUM_GT?: number | null;
  payable_SUM_GTE?: number | null;
  payable_SUM_LT?: number | null;
  payable_SUM_LTE?: number | null;
  quantity_AVERAGE_EQUAL?: number | null;
  quantity_AVERAGE_GT?: number | null;
  quantity_AVERAGE_GTE?: number | null;
  quantity_AVERAGE_LT?: number | null;
  quantity_AVERAGE_LTE?: number | null;
  quantity_EQUAL?: number | null;
  quantity_GT?: number | null;
  quantity_GTE?: number | null;
  quantity_LT?: number | null;
  quantity_LTE?: number | null;
  quantity_MAX_EQUAL?: number | null;
  quantity_MAX_GT?: number | null;
  quantity_MAX_GTE?: number | null;
  quantity_MAX_LT?: number | null;
  quantity_MAX_LTE?: number | null;
  quantity_MIN_EQUAL?: number | null;
  quantity_MIN_GT?: number | null;
  quantity_MIN_GTE?: number | null;
  quantity_MIN_LT?: number | null;
  quantity_MIN_LTE?: number | null;
  quantity_SUM_EQUAL?: number | null;
  quantity_SUM_GT?: number | null;
  quantity_SUM_GTE?: number | null;
  quantity_SUM_LT?: number | null;
  quantity_SUM_LTE?: number | null;
  refundDeltaNumber_AVERAGE_EQUAL?: number | null;
  refundDeltaNumber_AVERAGE_GT?: number | null;
  refundDeltaNumber_AVERAGE_GTE?: number | null;
  refundDeltaNumber_AVERAGE_LT?: number | null;
  refundDeltaNumber_AVERAGE_LTE?: number | null;
  refundDeltaNumber_EQUAL?: number | null;
  refundDeltaNumber_GT?: number | null;
  refundDeltaNumber_GTE?: number | null;
  refundDeltaNumber_LT?: number | null;
  refundDeltaNumber_LTE?: number | null;
  refundDeltaNumber_MAX_EQUAL?: number | null;
  refundDeltaNumber_MAX_GT?: number | null;
  refundDeltaNumber_MAX_GTE?: number | null;
  refundDeltaNumber_MAX_LT?: number | null;
  refundDeltaNumber_MAX_LTE?: number | null;
  refundDeltaNumber_MIN_EQUAL?: number | null;
  refundDeltaNumber_MIN_GT?: number | null;
  refundDeltaNumber_MIN_GTE?: number | null;
  refundDeltaNumber_MIN_LT?: number | null;
  refundDeltaNumber_MIN_LTE?: number | null;
  refundDeltaNumber_SUM_EQUAL?: number | null;
  refundDeltaNumber_SUM_GT?: number | null;
  refundDeltaNumber_SUM_GTE?: number | null;
  refundDeltaNumber_SUM_LT?: number | null;
  refundDeltaNumber_SUM_LTE?: number | null;
  refundablePercentage_AVERAGE_EQUAL?: number | null;
  refundablePercentage_AVERAGE_GT?: number | null;
  refundablePercentage_AVERAGE_GTE?: number | null;
  refundablePercentage_AVERAGE_LT?: number | null;
  refundablePercentage_AVERAGE_LTE?: number | null;
  refundablePercentage_EQUAL?: number | null;
  refundablePercentage_GT?: number | null;
  refundablePercentage_GTE?: number | null;
  refundablePercentage_LT?: number | null;
  refundablePercentage_LTE?: number | null;
  refundablePercentage_MAX_EQUAL?: number | null;
  refundablePercentage_MAX_GT?: number | null;
  refundablePercentage_MAX_GTE?: number | null;
  refundablePercentage_MAX_LT?: number | null;
  refundablePercentage_MAX_LTE?: number | null;
  refundablePercentage_MIN_EQUAL?: number | null;
  refundablePercentage_MIN_GT?: number | null;
  refundablePercentage_MIN_GTE?: number | null;
  refundablePercentage_MIN_LT?: number | null;
  refundablePercentage_MIN_LTE?: number | null;
  refundablePercentage_SUM_EQUAL?: number | null;
  refundablePercentage_SUM_GT?: number | null;
  refundablePercentage_SUM_GTE?: number | null;
  refundablePercentage_SUM_LT?: number | null;
  refundablePercentage_SUM_LTE?: number | null;
  refundable_AVERAGE_EQUAL?: number | null;
  refundable_AVERAGE_GT?: number | null;
  refundable_AVERAGE_GTE?: number | null;
  refundable_AVERAGE_LT?: number | null;
  refundable_AVERAGE_LTE?: number | null;
  refundable_EQUAL?: number | null;
  refundable_GT?: number | null;
  refundable_GTE?: number | null;
  refundable_LT?: number | null;
  refundable_LTE?: number | null;
  refundable_MAX_EQUAL?: number | null;
  refundable_MAX_GT?: number | null;
  refundable_MAX_GTE?: number | null;
  refundable_MAX_LT?: number | null;
  refundable_MAX_LTE?: number | null;
  refundable_MIN_EQUAL?: number | null;
  refundable_MIN_GT?: number | null;
  refundable_MIN_GTE?: number | null;
  refundable_MIN_LT?: number | null;
  refundable_MIN_LTE?: number | null;
  refundable_SUM_EQUAL?: number | null;
  refundable_SUM_GT?: number | null;
  refundable_SUM_GTE?: number | null;
  refundable_SUM_LT?: number | null;
  refundable_SUM_LTE?: number | null;
  revokedOn_EQUAL?: any | null;
  revokedOn_GT?: any | null;
  revokedOn_GTE?: any | null;
  revokedOn_LT?: any | null;
  revokedOn_LTE?: any | null;
  revokedOn_MAX_EQUAL?: any | null;
  revokedOn_MAX_GT?: any | null;
  revokedOn_MAX_GTE?: any | null;
  revokedOn_MAX_LT?: any | null;
  revokedOn_MAX_LTE?: any | null;
  revokedOn_MIN_EQUAL?: any | null;
  revokedOn_MIN_GT?: any | null;
  revokedOn_MIN_GTE?: any | null;
  revokedOn_MIN_LT?: any | null;
  revokedOn_MIN_LTE?: any | null;
  uuid_EQUAL?: string | null;
  variablePercentage_AVERAGE_EQUAL?: number | null;
  variablePercentage_AVERAGE_GT?: number | null;
  variablePercentage_AVERAGE_GTE?: number | null;
  variablePercentage_AVERAGE_LT?: number | null;
  variablePercentage_AVERAGE_LTE?: number | null;
  variablePercentage_EQUAL?: number | null;
  variablePercentage_GT?: number | null;
  variablePercentage_GTE?: number | null;
  variablePercentage_LT?: number | null;
  variablePercentage_LTE?: number | null;
  variablePercentage_MAX_EQUAL?: number | null;
  variablePercentage_MAX_GT?: number | null;
  variablePercentage_MAX_GTE?: number | null;
  variablePercentage_MAX_LT?: number | null;
  variablePercentage_MAX_LTE?: number | null;
  variablePercentage_MIN_EQUAL?: number | null;
  variablePercentage_MIN_GT?: number | null;
  variablePercentage_MIN_GTE?: number | null;
  variablePercentage_MIN_LT?: number | null;
  variablePercentage_MIN_LTE?: number | null;
  variablePercentage_SUM_EQUAL?: number | null;
  variablePercentage_SUM_GT?: number | null;
  variablePercentage_SUM_GTE?: number | null;
  variablePercentage_SUM_LT?: number | null;
  variablePercentage_SUM_LTE?: number | null;
  variable_AVERAGE_EQUAL?: number | null;
  variable_AVERAGE_GT?: number | null;
  variable_AVERAGE_GTE?: number | null;
  variable_AVERAGE_LT?: number | null;
  variable_AVERAGE_LTE?: number | null;
  variable_EQUAL?: number | null;
  variable_GT?: number | null;
  variable_GTE?: number | null;
  variable_LT?: number | null;
  variable_LTE?: number | null;
  variable_MAX_EQUAL?: number | null;
  variable_MAX_GT?: number | null;
  variable_MAX_GTE?: number | null;
  variable_MAX_LT?: number | null;
  variable_MAX_LTE?: number | null;
  variable_MIN_EQUAL?: number | null;
  variable_MIN_GT?: number | null;
  variable_MIN_GTE?: number | null;
  variable_MIN_LT?: number | null;
  variable_MIN_LTE?: number | null;
  variable_SUM_EQUAL?: number | null;
  variable_SUM_GT?: number | null;
  variable_SUM_GTE?: number | null;
  variable_SUM_LT?: number | null;
  variable_SUM_LTE?: number | null;
}

export interface CaseFlexEntitiesAggregateInput {
  AND?: CaseFlexEntitiesAggregateInput[] | null;
  OR?: CaseFlexEntitiesAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: CaseFlexEntitiesNodeAggregationWhereInput | null;
}

export interface CaseFlexEntitiesConnectionWhere {
  AND?: CaseFlexEntitiesConnectionWhere[] | null;
  OR?: CaseFlexEntitiesConnectionWhere[] | null;
  edge?: CaseFlexEntityRelationshipWhere | null;
  edge_NOT?: CaseFlexEntityRelationshipWhere | null;
  node?: FlexEntityWhere | null;
  node_NOT?: FlexEntityWhere | null;
}

export interface CaseFlexEntitiesNodeAggregationWhereInput {
  AND?: CaseFlexEntitiesNodeAggregationWhereInput[] | null;
  OR?: CaseFlexEntitiesNodeAggregationWhereInput[] | null;
  createdByEmail_AVERAGE_EQUAL?: number | null;
  createdByEmail_AVERAGE_GT?: number | null;
  createdByEmail_AVERAGE_GTE?: number | null;
  createdByEmail_AVERAGE_LT?: number | null;
  createdByEmail_AVERAGE_LTE?: number | null;
  createdByEmail_EQUAL?: string | null;
  createdByEmail_GT?: number | null;
  createdByEmail_GTE?: number | null;
  createdByEmail_LONGEST_EQUAL?: number | null;
  createdByEmail_LONGEST_GT?: number | null;
  createdByEmail_LONGEST_GTE?: number | null;
  createdByEmail_LONGEST_LT?: number | null;
  createdByEmail_LONGEST_LTE?: number | null;
  createdByEmail_LT?: number | null;
  createdByEmail_LTE?: number | null;
  createdByEmail_SHORTEST_EQUAL?: number | null;
  createdByEmail_SHORTEST_GT?: number | null;
  createdByEmail_SHORTEST_GTE?: number | null;
  createdByEmail_SHORTEST_LT?: number | null;
  createdByEmail_SHORTEST_LTE?: number | null;
  createdByName_AVERAGE_EQUAL?: number | null;
  createdByName_AVERAGE_GT?: number | null;
  createdByName_AVERAGE_GTE?: number | null;
  createdByName_AVERAGE_LT?: number | null;
  createdByName_AVERAGE_LTE?: number | null;
  createdByName_EQUAL?: string | null;
  createdByName_GT?: number | null;
  createdByName_GTE?: number | null;
  createdByName_LONGEST_EQUAL?: number | null;
  createdByName_LONGEST_GT?: number | null;
  createdByName_LONGEST_GTE?: number | null;
  createdByName_LONGEST_LT?: number | null;
  createdByName_LONGEST_LTE?: number | null;
  createdByName_LT?: number | null;
  createdByName_LTE?: number | null;
  createdByName_SHORTEST_EQUAL?: number | null;
  createdByName_SHORTEST_GT?: number | null;
  createdByName_SHORTEST_GTE?: number | null;
  createdByName_SHORTEST_LT?: number | null;
  createdByName_SHORTEST_LTE?: number | null;
  createdOn_EQUAL?: any | null;
  createdOn_GT?: any | null;
  createdOn_GTE?: any | null;
  createdOn_LT?: any | null;
  createdOn_LTE?: any | null;
  createdOn_MAX_EQUAL?: any | null;
  createdOn_MAX_GT?: any | null;
  createdOn_MAX_GTE?: any | null;
  createdOn_MAX_LT?: any | null;
  createdOn_MAX_LTE?: any | null;
  createdOn_MIN_EQUAL?: any | null;
  createdOn_MIN_GT?: any | null;
  createdOn_MIN_GTE?: any | null;
  createdOn_MIN_LT?: any | null;
  createdOn_MIN_LTE?: any | null;
  dataKeys_AVERAGE_EQUAL?: number | null;
  dataKeys_AVERAGE_GT?: number | null;
  dataKeys_AVERAGE_GTE?: number | null;
  dataKeys_AVERAGE_LT?: number | null;
  dataKeys_AVERAGE_LTE?: number | null;
  dataKeys_EQUAL?: string | null;
  dataKeys_GT?: number | null;
  dataKeys_GTE?: number | null;
  dataKeys_LONGEST_EQUAL?: number | null;
  dataKeys_LONGEST_GT?: number | null;
  dataKeys_LONGEST_GTE?: number | null;
  dataKeys_LONGEST_LT?: number | null;
  dataKeys_LONGEST_LTE?: number | null;
  dataKeys_LT?: number | null;
  dataKeys_LTE?: number | null;
  dataKeys_SHORTEST_EQUAL?: number | null;
  dataKeys_SHORTEST_GT?: number | null;
  dataKeys_SHORTEST_GTE?: number | null;
  dataKeys_SHORTEST_LT?: number | null;
  dataKeys_SHORTEST_LTE?: number | null;
  data_AVERAGE_EQUAL?: number | null;
  data_AVERAGE_GT?: number | null;
  data_AVERAGE_GTE?: number | null;
  data_AVERAGE_LT?: number | null;
  data_AVERAGE_LTE?: number | null;
  data_EQUAL?: string | null;
  data_GT?: number | null;
  data_GTE?: number | null;
  data_LONGEST_EQUAL?: number | null;
  data_LONGEST_GT?: number | null;
  data_LONGEST_GTE?: number | null;
  data_LONGEST_LT?: number | null;
  data_LONGEST_LTE?: number | null;
  data_LT?: number | null;
  data_LTE?: number | null;
  data_SHORTEST_EQUAL?: number | null;
  data_SHORTEST_GT?: number | null;
  data_SHORTEST_GTE?: number | null;
  data_SHORTEST_LT?: number | null;
  data_SHORTEST_LTE?: number | null;
  flexEntityName_AVERAGE_EQUAL?: number | null;
  flexEntityName_AVERAGE_GT?: number | null;
  flexEntityName_AVERAGE_GTE?: number | null;
  flexEntityName_AVERAGE_LT?: number | null;
  flexEntityName_AVERAGE_LTE?: number | null;
  flexEntityName_EQUAL?: string | null;
  flexEntityName_GT?: number | null;
  flexEntityName_GTE?: number | null;
  flexEntityName_LONGEST_EQUAL?: number | null;
  flexEntityName_LONGEST_GT?: number | null;
  flexEntityName_LONGEST_GTE?: number | null;
  flexEntityName_LONGEST_LT?: number | null;
  flexEntityName_LONGEST_LTE?: number | null;
  flexEntityName_LT?: number | null;
  flexEntityName_LTE?: number | null;
  flexEntityName_SHORTEST_EQUAL?: number | null;
  flexEntityName_SHORTEST_GT?: number | null;
  flexEntityName_SHORTEST_GTE?: number | null;
  flexEntityName_SHORTEST_LT?: number | null;
  flexEntityName_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  lastUpdatedOn_EQUAL?: any | null;
  lastUpdatedOn_GT?: any | null;
  lastUpdatedOn_GTE?: any | null;
  lastUpdatedOn_LT?: any | null;
  lastUpdatedOn_LTE?: any | null;
  lastUpdatedOn_MAX_EQUAL?: any | null;
  lastUpdatedOn_MAX_GT?: any | null;
  lastUpdatedOn_MAX_GTE?: any | null;
  lastUpdatedOn_MAX_LT?: any | null;
  lastUpdatedOn_MAX_LTE?: any | null;
  lastUpdatedOn_MIN_EQUAL?: any | null;
  lastUpdatedOn_MIN_GT?: any | null;
  lastUpdatedOn_MIN_GTE?: any | null;
  lastUpdatedOn_MIN_LT?: any | null;
  lastUpdatedOn_MIN_LTE?: any | null;
  patientId_AVERAGE_EQUAL?: number | null;
  patientId_AVERAGE_GT?: number | null;
  patientId_AVERAGE_GTE?: number | null;
  patientId_AVERAGE_LT?: number | null;
  patientId_AVERAGE_LTE?: number | null;
  patientId_EQUAL?: string | null;
  patientId_GT?: number | null;
  patientId_GTE?: number | null;
  patientId_LONGEST_EQUAL?: number | null;
  patientId_LONGEST_GT?: number | null;
  patientId_LONGEST_GTE?: number | null;
  patientId_LONGEST_LT?: number | null;
  patientId_LONGEST_LTE?: number | null;
  patientId_LT?: number | null;
  patientId_LTE?: number | null;
  patientId_SHORTEST_EQUAL?: number | null;
  patientId_SHORTEST_GT?: number | null;
  patientId_SHORTEST_GTE?: number | null;
  patientId_SHORTEST_LT?: number | null;
  patientId_SHORTEST_LTE?: number | null;
  preparationBrandNames_AVERAGE_EQUAL?: number | null;
  preparationBrandNames_AVERAGE_GT?: number | null;
  preparationBrandNames_AVERAGE_GTE?: number | null;
  preparationBrandNames_AVERAGE_LT?: number | null;
  preparationBrandNames_AVERAGE_LTE?: number | null;
  preparationBrandNames_EQUAL?: string | null;
  preparationBrandNames_GT?: number | null;
  preparationBrandNames_GTE?: number | null;
  preparationBrandNames_LONGEST_EQUAL?: number | null;
  preparationBrandNames_LONGEST_GT?: number | null;
  preparationBrandNames_LONGEST_GTE?: number | null;
  preparationBrandNames_LONGEST_LT?: number | null;
  preparationBrandNames_LONGEST_LTE?: number | null;
  preparationBrandNames_LT?: number | null;
  preparationBrandNames_LTE?: number | null;
  preparationBrandNames_SHORTEST_EQUAL?: number | null;
  preparationBrandNames_SHORTEST_GT?: number | null;
  preparationBrandNames_SHORTEST_GTE?: number | null;
  preparationBrandNames_SHORTEST_LT?: number | null;
  preparationBrandNames_SHORTEST_LTE?: number | null;
  preparationGenericNames_AVERAGE_EQUAL?: number | null;
  preparationGenericNames_AVERAGE_GT?: number | null;
  preparationGenericNames_AVERAGE_GTE?: number | null;
  preparationGenericNames_AVERAGE_LT?: number | null;
  preparationGenericNames_AVERAGE_LTE?: number | null;
  preparationGenericNames_EQUAL?: string | null;
  preparationGenericNames_GT?: number | null;
  preparationGenericNames_GTE?: number | null;
  preparationGenericNames_LONGEST_EQUAL?: number | null;
  preparationGenericNames_LONGEST_GT?: number | null;
  preparationGenericNames_LONGEST_GTE?: number | null;
  preparationGenericNames_LONGEST_LT?: number | null;
  preparationGenericNames_LONGEST_LTE?: number | null;
  preparationGenericNames_LT?: number | null;
  preparationGenericNames_LTE?: number | null;
  preparationGenericNames_SHORTEST_EQUAL?: number | null;
  preparationGenericNames_SHORTEST_GT?: number | null;
  preparationGenericNames_SHORTEST_GTE?: number | null;
  preparationGenericNames_SHORTEST_LT?: number | null;
  preparationGenericNames_SHORTEST_LTE?: number | null;
  quantity_AVERAGE_EQUAL?: number | null;
  quantity_AVERAGE_GT?: number | null;
  quantity_AVERAGE_GTE?: number | null;
  quantity_AVERAGE_LT?: number | null;
  quantity_AVERAGE_LTE?: number | null;
  quantity_EQUAL?: number | null;
  quantity_GT?: number | null;
  quantity_GTE?: number | null;
  quantity_LT?: number | null;
  quantity_LTE?: number | null;
  quantity_MAX_EQUAL?: number | null;
  quantity_MAX_GT?: number | null;
  quantity_MAX_GTE?: number | null;
  quantity_MAX_LT?: number | null;
  quantity_MAX_LTE?: number | null;
  quantity_MIN_EQUAL?: number | null;
  quantity_MIN_GT?: number | null;
  quantity_MIN_GTE?: number | null;
  quantity_MIN_LT?: number | null;
  quantity_MIN_LTE?: number | null;
  quantity_SUM_EQUAL?: number | null;
  quantity_SUM_GT?: number | null;
  quantity_SUM_GTE?: number | null;
  quantity_SUM_LT?: number | null;
  quantity_SUM_LTE?: number | null;
  tenantId_AVERAGE_EQUAL?: number | null;
  tenantId_AVERAGE_GT?: number | null;
  tenantId_AVERAGE_GTE?: number | null;
  tenantId_AVERAGE_LT?: number | null;
  tenantId_AVERAGE_LTE?: number | null;
  tenantId_EQUAL?: string | null;
  tenantId_GT?: number | null;
  tenantId_GTE?: number | null;
  tenantId_LONGEST_EQUAL?: number | null;
  tenantId_LONGEST_GT?: number | null;
  tenantId_LONGEST_GTE?: number | null;
  tenantId_LONGEST_LT?: number | null;
  tenantId_LONGEST_LTE?: number | null;
  tenantId_LT?: number | null;
  tenantId_LTE?: number | null;
  tenantId_SHORTEST_EQUAL?: number | null;
  tenantId_SHORTEST_GT?: number | null;
  tenantId_SHORTEST_GTE?: number | null;
  tenantId_SHORTEST_LT?: number | null;
  tenantId_SHORTEST_LTE?: number | null;
  unlimited_AVERAGE_EQUAL?: number | null;
  unlimited_AVERAGE_GT?: number | null;
  unlimited_AVERAGE_GTE?: number | null;
  unlimited_AVERAGE_LT?: number | null;
  unlimited_AVERAGE_LTE?: number | null;
  unlimited_EQUAL?: number | null;
  unlimited_GT?: number | null;
  unlimited_GTE?: number | null;
  unlimited_LT?: number | null;
  unlimited_LTE?: number | null;
  unlimited_MAX_EQUAL?: number | null;
  unlimited_MAX_GT?: number | null;
  unlimited_MAX_GTE?: number | null;
  unlimited_MAX_LT?: number | null;
  unlimited_MAX_LTE?: number | null;
  unlimited_MIN_EQUAL?: number | null;
  unlimited_MIN_GT?: number | null;
  unlimited_MIN_GTE?: number | null;
  unlimited_MIN_LT?: number | null;
  unlimited_MIN_LTE?: number | null;
  unlimited_SUM_EQUAL?: number | null;
  unlimited_SUM_GT?: number | null;
  unlimited_SUM_GTE?: number | null;
  unlimited_SUM_LT?: number | null;
  unlimited_SUM_LTE?: number | null;
  uuid_AVERAGE_EQUAL?: number | null;
  uuid_AVERAGE_GT?: number | null;
  uuid_AVERAGE_GTE?: number | null;
  uuid_AVERAGE_LT?: number | null;
  uuid_AVERAGE_LTE?: number | null;
  uuid_EQUAL?: string | null;
  uuid_GT?: number | null;
  uuid_GTE?: number | null;
  uuid_LONGEST_EQUAL?: number | null;
  uuid_LONGEST_GT?: number | null;
  uuid_LONGEST_GTE?: number | null;
  uuid_LONGEST_LT?: number | null;
  uuid_LONGEST_LTE?: number | null;
  uuid_LT?: number | null;
  uuid_LTE?: number | null;
  uuid_SHORTEST_EQUAL?: number | null;
  uuid_SHORTEST_GT?: number | null;
  uuid_SHORTEST_GTE?: number | null;
  uuid_SHORTEST_LT?: number | null;
  uuid_SHORTEST_LTE?: number | null;
}

export interface CaseFlexEntityRelationshipWhere {
  AND?: CaseFlexEntityRelationshipWhere[] | null;
  OR?: CaseFlexEntityRelationshipWhere[] | null;
  isStartingPoint?: boolean | null;
  isStartingPoint_NOT?: boolean | null;
}

export interface CaseHistoryAggregateInput {
  AND?: CaseHistoryAggregateInput[] | null;
  OR?: CaseHistoryAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: CaseHistoryNodeAggregationWhereInput | null;
}

export interface CaseHistoryConnectionWhere {
  AND?: CaseHistoryConnectionWhere[] | null;
  OR?: CaseHistoryConnectionWhere[] | null;
  node?: CaseHistoryRecordWhere | null;
  node_NOT?: CaseHistoryRecordWhere | null;
}

export interface CaseHistoryNodeAggregationWhereInput {
  AND?: CaseHistoryNodeAggregationWhereInput[] | null;
  OR?: CaseHistoryNodeAggregationWhereInput[] | null;
  changedOn_EQUAL?: any | null;
  changedOn_GT?: any | null;
  changedOn_GTE?: any | null;
  changedOn_LT?: any | null;
  changedOn_LTE?: any | null;
  changedOn_MAX_EQUAL?: any | null;
  changedOn_MAX_GT?: any | null;
  changedOn_MAX_GTE?: any | null;
  changedOn_MAX_LT?: any | null;
  changedOn_MAX_LTE?: any | null;
  changedOn_MIN_EQUAL?: any | null;
  changedOn_MIN_GT?: any | null;
  changedOn_MIN_GTE?: any | null;
  changedOn_MIN_LT?: any | null;
  changedOn_MIN_LTE?: any | null;
  reason_AVERAGE_EQUAL?: number | null;
  reason_AVERAGE_GT?: number | null;
  reason_AVERAGE_GTE?: number | null;
  reason_AVERAGE_LT?: number | null;
  reason_AVERAGE_LTE?: number | null;
  reason_EQUAL?: string | null;
  reason_GT?: number | null;
  reason_GTE?: number | null;
  reason_LONGEST_EQUAL?: number | null;
  reason_LONGEST_GT?: number | null;
  reason_LONGEST_GTE?: number | null;
  reason_LONGEST_LT?: number | null;
  reason_LONGEST_LTE?: number | null;
  reason_LT?: number | null;
  reason_LTE?: number | null;
  reason_SHORTEST_EQUAL?: number | null;
  reason_SHORTEST_GT?: number | null;
  reason_SHORTEST_GTE?: number | null;
  reason_SHORTEST_LT?: number | null;
  reason_SHORTEST_LTE?: number | null;
}

export interface CaseHistoryRecordChangeByAggregateInput {
  AND?: CaseHistoryRecordChangeByAggregateInput[] | null;
  OR?: CaseHistoryRecordChangeByAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: CaseHistoryRecordChangeByNodeAggregationWhereInput | null;
}

export interface CaseHistoryRecordChangeByConnectionWhere {
  AND?: CaseHistoryRecordChangeByConnectionWhere[] | null;
  OR?: CaseHistoryRecordChangeByConnectionWhere[] | null;
  node?: UserWhere | null;
  node_NOT?: UserWhere | null;
}

export interface CaseHistoryRecordChangeByNodeAggregationWhereInput {
  AND?: CaseHistoryRecordChangeByNodeAggregationWhereInput[] | null;
  OR?: CaseHistoryRecordChangeByNodeAggregationWhereInput[] | null;
  deletedOn_EQUAL?: any | null;
  deletedOn_GT?: any | null;
  deletedOn_GTE?: any | null;
  deletedOn_LT?: any | null;
  deletedOn_LTE?: any | null;
  deletedOn_MAX_EQUAL?: any | null;
  deletedOn_MAX_GT?: any | null;
  deletedOn_MAX_GTE?: any | null;
  deletedOn_MAX_LT?: any | null;
  deletedOn_MAX_LTE?: any | null;
  deletedOn_MIN_EQUAL?: any | null;
  deletedOn_MIN_GT?: any | null;
  deletedOn_MIN_GTE?: any | null;
  deletedOn_MIN_LT?: any | null;
  deletedOn_MIN_LTE?: any | null;
  department_AVERAGE_EQUAL?: number | null;
  department_AVERAGE_GT?: number | null;
  department_AVERAGE_GTE?: number | null;
  department_AVERAGE_LT?: number | null;
  department_AVERAGE_LTE?: number | null;
  department_EQUAL?: string | null;
  department_GT?: number | null;
  department_GTE?: number | null;
  department_LONGEST_EQUAL?: number | null;
  department_LONGEST_GT?: number | null;
  department_LONGEST_GTE?: number | null;
  department_LONGEST_LT?: number | null;
  department_LONGEST_LTE?: number | null;
  department_LT?: number | null;
  department_LTE?: number | null;
  department_SHORTEST_EQUAL?: number | null;
  department_SHORTEST_GT?: number | null;
  department_SHORTEST_GTE?: number | null;
  department_SHORTEST_LT?: number | null;
  department_SHORTEST_LTE?: number | null;
  email_AVERAGE_EQUAL?: number | null;
  email_AVERAGE_GT?: number | null;
  email_AVERAGE_GTE?: number | null;
  email_AVERAGE_LT?: number | null;
  email_AVERAGE_LTE?: number | null;
  email_EQUAL?: string | null;
  email_GT?: number | null;
  email_GTE?: number | null;
  email_LONGEST_EQUAL?: number | null;
  email_LONGEST_GT?: number | null;
  email_LONGEST_GTE?: number | null;
  email_LONGEST_LT?: number | null;
  email_LONGEST_LTE?: number | null;
  email_LT?: number | null;
  email_LTE?: number | null;
  email_SHORTEST_EQUAL?: number | null;
  email_SHORTEST_GT?: number | null;
  email_SHORTEST_GTE?: number | null;
  email_SHORTEST_LT?: number | null;
  email_SHORTEST_LTE?: number | null;
  firstName_AVERAGE_EQUAL?: number | null;
  firstName_AVERAGE_GT?: number | null;
  firstName_AVERAGE_GTE?: number | null;
  firstName_AVERAGE_LT?: number | null;
  firstName_AVERAGE_LTE?: number | null;
  firstName_EQUAL?: string | null;
  firstName_GT?: number | null;
  firstName_GTE?: number | null;
  firstName_LONGEST_EQUAL?: number | null;
  firstName_LONGEST_GT?: number | null;
  firstName_LONGEST_GTE?: number | null;
  firstName_LONGEST_LT?: number | null;
  firstName_LONGEST_LTE?: number | null;
  firstName_LT?: number | null;
  firstName_LTE?: number | null;
  firstName_SHORTEST_EQUAL?: number | null;
  firstName_SHORTEST_GT?: number | null;
  firstName_SHORTEST_GTE?: number | null;
  firstName_SHORTEST_LT?: number | null;
  firstName_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  lastName_AVERAGE_EQUAL?: number | null;
  lastName_AVERAGE_GT?: number | null;
  lastName_AVERAGE_GTE?: number | null;
  lastName_AVERAGE_LT?: number | null;
  lastName_AVERAGE_LTE?: number | null;
  lastName_EQUAL?: string | null;
  lastName_GT?: number | null;
  lastName_GTE?: number | null;
  lastName_LONGEST_EQUAL?: number | null;
  lastName_LONGEST_GT?: number | null;
  lastName_LONGEST_GTE?: number | null;
  lastName_LONGEST_LT?: number | null;
  lastName_LONGEST_LTE?: number | null;
  lastName_LT?: number | null;
  lastName_LTE?: number | null;
  lastName_SHORTEST_EQUAL?: number | null;
  lastName_SHORTEST_GT?: number | null;
  lastName_SHORTEST_GTE?: number | null;
  lastName_SHORTEST_LT?: number | null;
  lastName_SHORTEST_LTE?: number | null;
  position_AVERAGE_EQUAL?: number | null;
  position_AVERAGE_GT?: number | null;
  position_AVERAGE_GTE?: number | null;
  position_AVERAGE_LT?: number | null;
  position_AVERAGE_LTE?: number | null;
  position_EQUAL?: string | null;
  position_GT?: number | null;
  position_GTE?: number | null;
  position_LONGEST_EQUAL?: number | null;
  position_LONGEST_GT?: number | null;
  position_LONGEST_GTE?: number | null;
  position_LONGEST_LT?: number | null;
  position_LONGEST_LTE?: number | null;
  position_LT?: number | null;
  position_LTE?: number | null;
  position_SHORTEST_EQUAL?: number | null;
  position_SHORTEST_GT?: number | null;
  position_SHORTEST_GTE?: number | null;
  position_SHORTEST_LT?: number | null;
  position_SHORTEST_LTE?: number | null;
  preferredLanguage_AVERAGE_EQUAL?: number | null;
  preferredLanguage_AVERAGE_GT?: number | null;
  preferredLanguage_AVERAGE_GTE?: number | null;
  preferredLanguage_AVERAGE_LT?: number | null;
  preferredLanguage_AVERAGE_LTE?: number | null;
  preferredLanguage_EQUAL?: string | null;
  preferredLanguage_GT?: number | null;
  preferredLanguage_GTE?: number | null;
  preferredLanguage_LONGEST_EQUAL?: number | null;
  preferredLanguage_LONGEST_GT?: number | null;
  preferredLanguage_LONGEST_GTE?: number | null;
  preferredLanguage_LONGEST_LT?: number | null;
  preferredLanguage_LONGEST_LTE?: number | null;
  preferredLanguage_LT?: number | null;
  preferredLanguage_LTE?: number | null;
  preferredLanguage_SHORTEST_EQUAL?: number | null;
  preferredLanguage_SHORTEST_GT?: number | null;
  preferredLanguage_SHORTEST_GTE?: number | null;
  preferredLanguage_SHORTEST_LT?: number | null;
  preferredLanguage_SHORTEST_LTE?: number | null;
  tenantId_AVERAGE_EQUAL?: number | null;
  tenantId_AVERAGE_GT?: number | null;
  tenantId_AVERAGE_GTE?: number | null;
  tenantId_AVERAGE_LT?: number | null;
  tenantId_AVERAGE_LTE?: number | null;
  tenantId_EQUAL?: string | null;
  tenantId_GT?: number | null;
  tenantId_GTE?: number | null;
  tenantId_LONGEST_EQUAL?: number | null;
  tenantId_LONGEST_GT?: number | null;
  tenantId_LONGEST_GTE?: number | null;
  tenantId_LONGEST_LT?: number | null;
  tenantId_LONGEST_LTE?: number | null;
  tenantId_LT?: number | null;
  tenantId_LTE?: number | null;
  tenantId_SHORTEST_EQUAL?: number | null;
  tenantId_SHORTEST_GT?: number | null;
  tenantId_SHORTEST_GTE?: number | null;
  tenantId_SHORTEST_LT?: number | null;
  tenantId_SHORTEST_LTE?: number | null;
}

export interface CaseHistoryRecordWhere {
  AND?: CaseHistoryRecordWhere[] | null;
  OR?: CaseHistoryRecordWhere[] | null;
  changeBy?: UserWhere | null;
  changeByAggregate?: CaseHistoryRecordChangeByAggregateInput | null;
  changeByConnection?: CaseHistoryRecordChangeByConnectionWhere | null;
  changeByConnection_NOT?: CaseHistoryRecordChangeByConnectionWhere | null;
  changeBy_NOT?: UserWhere | null;
  changedOn?: any | null;
  changedOn_GT?: any | null;
  changedOn_GTE?: any | null;
  changedOn_IN?: (any | null)[] | null;
  changedOn_LT?: any | null;
  changedOn_LTE?: any | null;
  changedOn_NOT?: any | null;
  changedOn_NOT_IN?: (any | null)[] | null;
  reason?: string | null;
  reason_CONTAINS?: string | null;
  reason_ENDS_WITH?: string | null;
  reason_IN?: (string | null)[] | null;
  reason_MATCHES?: string | null;
  reason_NOT?: string | null;
  reason_NOT_CONTAINS?: string | null;
  reason_NOT_ENDS_WITH?: string | null;
  reason_NOT_IN?: (string | null)[] | null;
  reason_NOT_STARTS_WITH?: string | null;
  reason_STARTS_WITH?: string | null;
  status?: CaseStatus | null;
  status_IN?: (CaseStatus | null)[] | null;
  status_NOT?: CaseStatus | null;
  status_NOT_IN?: (CaseStatus | null)[] | null;
}

export interface CaseIndicationAggregateInput {
  AND?: CaseIndicationAggregateInput[] | null;
  OR?: CaseIndicationAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: CaseIndicationNodeAggregationWhereInput | null;
}

export interface CaseIndicationConnectionWhere {
  AND?: CaseIndicationConnectionWhere[] | null;
  OR?: CaseIndicationConnectionWhere[] | null;
  node?: IndicationWhere | null;
  node_NOT?: IndicationWhere | null;
}

export interface CaseIndicationNodeAggregationWhereInput {
  AND?: CaseIndicationNodeAggregationWhereInput[] | null;
  OR?: CaseIndicationNodeAggregationWhereInput[] | null;
  code_AVERAGE_EQUAL?: number | null;
  code_AVERAGE_GT?: number | null;
  code_AVERAGE_GTE?: number | null;
  code_AVERAGE_LT?: number | null;
  code_AVERAGE_LTE?: number | null;
  code_EQUAL?: string | null;
  code_GT?: number | null;
  code_GTE?: number | null;
  code_LONGEST_EQUAL?: number | null;
  code_LONGEST_GT?: number | null;
  code_LONGEST_GTE?: number | null;
  code_LONGEST_LT?: number | null;
  code_LONGEST_LTE?: number | null;
  code_LT?: number | null;
  code_LTE?: number | null;
  code_SHORTEST_EQUAL?: number | null;
  code_SHORTEST_GT?: number | null;
  code_SHORTEST_GTE?: number | null;
  code_SHORTEST_LT?: number | null;
  code_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  intentLocalizationKey_AVERAGE_EQUAL?: number | null;
  intentLocalizationKey_AVERAGE_GT?: number | null;
  intentLocalizationKey_AVERAGE_GTE?: number | null;
  intentLocalizationKey_AVERAGE_LT?: number | null;
  intentLocalizationKey_AVERAGE_LTE?: number | null;
  intentLocalizationKey_EQUAL?: string | null;
  intentLocalizationKey_GT?: number | null;
  intentLocalizationKey_GTE?: number | null;
  intentLocalizationKey_LONGEST_EQUAL?: number | null;
  intentLocalizationKey_LONGEST_GT?: number | null;
  intentLocalizationKey_LONGEST_GTE?: number | null;
  intentLocalizationKey_LONGEST_LT?: number | null;
  intentLocalizationKey_LONGEST_LTE?: number | null;
  intentLocalizationKey_LT?: number | null;
  intentLocalizationKey_LTE?: number | null;
  intentLocalizationKey_SHORTEST_EQUAL?: number | null;
  intentLocalizationKey_SHORTEST_GT?: number | null;
  intentLocalizationKey_SHORTEST_GTE?: number | null;
  intentLocalizationKey_SHORTEST_LT?: number | null;
  intentLocalizationKey_SHORTEST_LTE?: number | null;
  intent_AVERAGE_EQUAL?: number | null;
  intent_AVERAGE_GT?: number | null;
  intent_AVERAGE_GTE?: number | null;
  intent_AVERAGE_LT?: number | null;
  intent_AVERAGE_LTE?: number | null;
  intent_EQUAL?: string | null;
  intent_GT?: number | null;
  intent_GTE?: number | null;
  intent_LONGEST_EQUAL?: number | null;
  intent_LONGEST_GT?: number | null;
  intent_LONGEST_GTE?: number | null;
  intent_LONGEST_LT?: number | null;
  intent_LONGEST_LTE?: number | null;
  intent_LT?: number | null;
  intent_LTE?: number | null;
  intent_SHORTEST_EQUAL?: number | null;
  intent_SHORTEST_GT?: number | null;
  intent_SHORTEST_GTE?: number | null;
  intent_SHORTEST_LT?: number | null;
  intent_SHORTEST_LTE?: number | null;
  lineLocalizationKey_AVERAGE_EQUAL?: number | null;
  lineLocalizationKey_AVERAGE_GT?: number | null;
  lineLocalizationKey_AVERAGE_GTE?: number | null;
  lineLocalizationKey_AVERAGE_LT?: number | null;
  lineLocalizationKey_AVERAGE_LTE?: number | null;
  lineLocalizationKey_EQUAL?: string | null;
  lineLocalizationKey_GT?: number | null;
  lineLocalizationKey_GTE?: number | null;
  lineLocalizationKey_LONGEST_EQUAL?: number | null;
  lineLocalizationKey_LONGEST_GT?: number | null;
  lineLocalizationKey_LONGEST_GTE?: number | null;
  lineLocalizationKey_LONGEST_LT?: number | null;
  lineLocalizationKey_LONGEST_LTE?: number | null;
  lineLocalizationKey_LT?: number | null;
  lineLocalizationKey_LTE?: number | null;
  lineLocalizationKey_SHORTEST_EQUAL?: number | null;
  lineLocalizationKey_SHORTEST_GT?: number | null;
  lineLocalizationKey_SHORTEST_GTE?: number | null;
  lineLocalizationKey_SHORTEST_LT?: number | null;
  lineLocalizationKey_SHORTEST_LTE?: number | null;
  line_AVERAGE_EQUAL?: number | null;
  line_AVERAGE_GT?: number | null;
  line_AVERAGE_GTE?: number | null;
  line_AVERAGE_LT?: number | null;
  line_AVERAGE_LTE?: number | null;
  line_EQUAL?: string | null;
  line_GT?: number | null;
  line_GTE?: number | null;
  line_LONGEST_EQUAL?: number | null;
  line_LONGEST_GT?: number | null;
  line_LONGEST_GTE?: number | null;
  line_LONGEST_LT?: number | null;
  line_LONGEST_LTE?: number | null;
  line_LT?: number | null;
  line_LTE?: number | null;
  line_SHORTEST_EQUAL?: number | null;
  line_SHORTEST_GT?: number | null;
  line_SHORTEST_GTE?: number | null;
  line_SHORTEST_LT?: number | null;
  line_SHORTEST_LTE?: number | null;
  mutationLocalizationKey_AVERAGE_EQUAL?: number | null;
  mutationLocalizationKey_AVERAGE_GT?: number | null;
  mutationLocalizationKey_AVERAGE_GTE?: number | null;
  mutationLocalizationKey_AVERAGE_LT?: number | null;
  mutationLocalizationKey_AVERAGE_LTE?: number | null;
  mutationLocalizationKey_EQUAL?: string | null;
  mutationLocalizationKey_GT?: number | null;
  mutationLocalizationKey_GTE?: number | null;
  mutationLocalizationKey_LONGEST_EQUAL?: number | null;
  mutationLocalizationKey_LONGEST_GT?: number | null;
  mutationLocalizationKey_LONGEST_GTE?: number | null;
  mutationLocalizationKey_LONGEST_LT?: number | null;
  mutationLocalizationKey_LONGEST_LTE?: number | null;
  mutationLocalizationKey_LT?: number | null;
  mutationLocalizationKey_LTE?: number | null;
  mutationLocalizationKey_SHORTEST_EQUAL?: number | null;
  mutationLocalizationKey_SHORTEST_GT?: number | null;
  mutationLocalizationKey_SHORTEST_GTE?: number | null;
  mutationLocalizationKey_SHORTEST_LT?: number | null;
  mutationLocalizationKey_SHORTEST_LTE?: number | null;
  mutation_AVERAGE_EQUAL?: number | null;
  mutation_AVERAGE_GT?: number | null;
  mutation_AVERAGE_GTE?: number | null;
  mutation_AVERAGE_LT?: number | null;
  mutation_AVERAGE_LTE?: number | null;
  mutation_EQUAL?: string | null;
  mutation_GT?: number | null;
  mutation_GTE?: number | null;
  mutation_LONGEST_EQUAL?: number | null;
  mutation_LONGEST_GT?: number | null;
  mutation_LONGEST_GTE?: number | null;
  mutation_LONGEST_LT?: number | null;
  mutation_LONGEST_LTE?: number | null;
  mutation_LT?: number | null;
  mutation_LTE?: number | null;
  mutation_SHORTEST_EQUAL?: number | null;
  mutation_SHORTEST_GT?: number | null;
  mutation_SHORTEST_GTE?: number | null;
  mutation_SHORTEST_LT?: number | null;
  mutation_SHORTEST_LTE?: number | null;
  typeLocalizationKey_AVERAGE_EQUAL?: number | null;
  typeLocalizationKey_AVERAGE_GT?: number | null;
  typeLocalizationKey_AVERAGE_GTE?: number | null;
  typeLocalizationKey_AVERAGE_LT?: number | null;
  typeLocalizationKey_AVERAGE_LTE?: number | null;
  typeLocalizationKey_EQUAL?: string | null;
  typeLocalizationKey_GT?: number | null;
  typeLocalizationKey_GTE?: number | null;
  typeLocalizationKey_LONGEST_EQUAL?: number | null;
  typeLocalizationKey_LONGEST_GT?: number | null;
  typeLocalizationKey_LONGEST_GTE?: number | null;
  typeLocalizationKey_LONGEST_LT?: number | null;
  typeLocalizationKey_LONGEST_LTE?: number | null;
  typeLocalizationKey_LT?: number | null;
  typeLocalizationKey_LTE?: number | null;
  typeLocalizationKey_SHORTEST_EQUAL?: number | null;
  typeLocalizationKey_SHORTEST_GT?: number | null;
  typeLocalizationKey_SHORTEST_GTE?: number | null;
  typeLocalizationKey_SHORTEST_LT?: number | null;
  typeLocalizationKey_SHORTEST_LTE?: number | null;
  type_AVERAGE_EQUAL?: number | null;
  type_AVERAGE_GT?: number | null;
  type_AVERAGE_GTE?: number | null;
  type_AVERAGE_LT?: number | null;
  type_AVERAGE_LTE?: number | null;
  type_EQUAL?: string | null;
  type_GT?: number | null;
  type_GTE?: number | null;
  type_LONGEST_EQUAL?: number | null;
  type_LONGEST_GT?: number | null;
  type_LONGEST_GTE?: number | null;
  type_LONGEST_LT?: number | null;
  type_LONGEST_LTE?: number | null;
  type_LT?: number | null;
  type_LTE?: number | null;
  type_SHORTEST_EQUAL?: number | null;
  type_SHORTEST_GT?: number | null;
  type_SHORTEST_GTE?: number | null;
  type_SHORTEST_LT?: number | null;
  type_SHORTEST_LTE?: number | null;
}

export interface CaseLegalEntityAggregateInput {
  AND?: CaseLegalEntityAggregateInput[] | null;
  OR?: CaseLegalEntityAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: CaseLegalEntityNodeAggregationWhereInput | null;
}

export interface CaseLegalEntityConnectionWhere {
  AND?: CaseLegalEntityConnectionWhere[] | null;
  OR?: CaseLegalEntityConnectionWhere[] | null;
  node?: OrganizationWhere | null;
  node_NOT?: OrganizationWhere | null;
}

export interface CaseLegalEntityNodeAggregationWhereInput {
  AND?: CaseLegalEntityNodeAggregationWhereInput[] | null;
  BIC_AVERAGE_EQUAL?: number | null;
  BIC_AVERAGE_GT?: number | null;
  BIC_AVERAGE_GTE?: number | null;
  BIC_AVERAGE_LT?: number | null;
  BIC_AVERAGE_LTE?: number | null;
  BIC_EQUAL?: string | null;
  BIC_GT?: number | null;
  BIC_GTE?: number | null;
  BIC_LONGEST_EQUAL?: number | null;
  BIC_LONGEST_GT?: number | null;
  BIC_LONGEST_GTE?: number | null;
  BIC_LONGEST_LT?: number | null;
  BIC_LONGEST_LTE?: number | null;
  BIC_LT?: number | null;
  BIC_LTE?: number | null;
  BIC_SHORTEST_EQUAL?: number | null;
  BIC_SHORTEST_GT?: number | null;
  BIC_SHORTEST_GTE?: number | null;
  BIC_SHORTEST_LT?: number | null;
  BIC_SHORTEST_LTE?: number | null;
  IBAN_AVERAGE_EQUAL?: number | null;
  IBAN_AVERAGE_GT?: number | null;
  IBAN_AVERAGE_GTE?: number | null;
  IBAN_AVERAGE_LT?: number | null;
  IBAN_AVERAGE_LTE?: number | null;
  IBAN_EQUAL?: string | null;
  IBAN_GT?: number | null;
  IBAN_GTE?: number | null;
  IBAN_LONGEST_EQUAL?: number | null;
  IBAN_LONGEST_GT?: number | null;
  IBAN_LONGEST_GTE?: number | null;
  IBAN_LONGEST_LT?: number | null;
  IBAN_LONGEST_LTE?: number | null;
  IBAN_LT?: number | null;
  IBAN_LTE?: number | null;
  IBAN_SHORTEST_EQUAL?: number | null;
  IBAN_SHORTEST_GT?: number | null;
  IBAN_SHORTEST_GTE?: number | null;
  IBAN_SHORTEST_LT?: number | null;
  IBAN_SHORTEST_LTE?: number | null;
  OR?: CaseLegalEntityNodeAggregationWhereInput[] | null;
  accountName_AVERAGE_EQUAL?: number | null;
  accountName_AVERAGE_GT?: number | null;
  accountName_AVERAGE_GTE?: number | null;
  accountName_AVERAGE_LT?: number | null;
  accountName_AVERAGE_LTE?: number | null;
  accountName_EQUAL?: string | null;
  accountName_GT?: number | null;
  accountName_GTE?: number | null;
  accountName_LONGEST_EQUAL?: number | null;
  accountName_LONGEST_GT?: number | null;
  accountName_LONGEST_GTE?: number | null;
  accountName_LONGEST_LT?: number | null;
  accountName_LONGEST_LTE?: number | null;
  accountName_LT?: number | null;
  accountName_LTE?: number | null;
  accountName_SHORTEST_EQUAL?: number | null;
  accountName_SHORTEST_GT?: number | null;
  accountName_SHORTEST_GTE?: number | null;
  accountName_SHORTEST_LT?: number | null;
  accountName_SHORTEST_LTE?: number | null;
  accountNumber_AVERAGE_EQUAL?: number | null;
  accountNumber_AVERAGE_GT?: number | null;
  accountNumber_AVERAGE_GTE?: number | null;
  accountNumber_AVERAGE_LT?: number | null;
  accountNumber_AVERAGE_LTE?: number | null;
  accountNumber_EQUAL?: string | null;
  accountNumber_GT?: number | null;
  accountNumber_GTE?: number | null;
  accountNumber_LONGEST_EQUAL?: number | null;
  accountNumber_LONGEST_GT?: number | null;
  accountNumber_LONGEST_GTE?: number | null;
  accountNumber_LONGEST_LT?: number | null;
  accountNumber_LONGEST_LTE?: number | null;
  accountNumber_LT?: number | null;
  accountNumber_LTE?: number | null;
  accountNumber_SHORTEST_EQUAL?: number | null;
  accountNumber_SHORTEST_GT?: number | null;
  accountNumber_SHORTEST_GTE?: number | null;
  accountNumber_SHORTEST_LT?: number | null;
  accountNumber_SHORTEST_LTE?: number | null;
  billingAddress_AVERAGE_EQUAL?: number | null;
  billingAddress_AVERAGE_GT?: number | null;
  billingAddress_AVERAGE_GTE?: number | null;
  billingAddress_AVERAGE_LT?: number | null;
  billingAddress_AVERAGE_LTE?: number | null;
  billingAddress_EQUAL?: string | null;
  billingAddress_GT?: number | null;
  billingAddress_GTE?: number | null;
  billingAddress_LONGEST_EQUAL?: number | null;
  billingAddress_LONGEST_GT?: number | null;
  billingAddress_LONGEST_GTE?: number | null;
  billingAddress_LONGEST_LT?: number | null;
  billingAddress_LONGEST_LTE?: number | null;
  billingAddress_LT?: number | null;
  billingAddress_LTE?: number | null;
  billingAddress_SHORTEST_EQUAL?: number | null;
  billingAddress_SHORTEST_GT?: number | null;
  billingAddress_SHORTEST_GTE?: number | null;
  billingAddress_SHORTEST_LT?: number | null;
  billingAddress_SHORTEST_LTE?: number | null;
  contactEmail_AVERAGE_EQUAL?: number | null;
  contactEmail_AVERAGE_GT?: number | null;
  contactEmail_AVERAGE_GTE?: number | null;
  contactEmail_AVERAGE_LT?: number | null;
  contactEmail_AVERAGE_LTE?: number | null;
  contactEmail_EQUAL?: string | null;
  contactEmail_GT?: number | null;
  contactEmail_GTE?: number | null;
  contactEmail_LONGEST_EQUAL?: number | null;
  contactEmail_LONGEST_GT?: number | null;
  contactEmail_LONGEST_GTE?: number | null;
  contactEmail_LONGEST_LT?: number | null;
  contactEmail_LONGEST_LTE?: number | null;
  contactEmail_LT?: number | null;
  contactEmail_LTE?: number | null;
  contactEmail_SHORTEST_EQUAL?: number | null;
  contactEmail_SHORTEST_GT?: number | null;
  contactEmail_SHORTEST_GTE?: number | null;
  contactEmail_SHORTEST_LT?: number | null;
  contactEmail_SHORTEST_LTE?: number | null;
  contactFirstName_AVERAGE_EQUAL?: number | null;
  contactFirstName_AVERAGE_GT?: number | null;
  contactFirstName_AVERAGE_GTE?: number | null;
  contactFirstName_AVERAGE_LT?: number | null;
  contactFirstName_AVERAGE_LTE?: number | null;
  contactFirstName_EQUAL?: string | null;
  contactFirstName_GT?: number | null;
  contactFirstName_GTE?: number | null;
  contactFirstName_LONGEST_EQUAL?: number | null;
  contactFirstName_LONGEST_GT?: number | null;
  contactFirstName_LONGEST_GTE?: number | null;
  contactFirstName_LONGEST_LT?: number | null;
  contactFirstName_LONGEST_LTE?: number | null;
  contactFirstName_LT?: number | null;
  contactFirstName_LTE?: number | null;
  contactFirstName_SHORTEST_EQUAL?: number | null;
  contactFirstName_SHORTEST_GT?: number | null;
  contactFirstName_SHORTEST_GTE?: number | null;
  contactFirstName_SHORTEST_LT?: number | null;
  contactFirstName_SHORTEST_LTE?: number | null;
  contactLastName_AVERAGE_EQUAL?: number | null;
  contactLastName_AVERAGE_GT?: number | null;
  contactLastName_AVERAGE_GTE?: number | null;
  contactLastName_AVERAGE_LT?: number | null;
  contactLastName_AVERAGE_LTE?: number | null;
  contactLastName_EQUAL?: string | null;
  contactLastName_GT?: number | null;
  contactLastName_GTE?: number | null;
  contactLastName_LONGEST_EQUAL?: number | null;
  contactLastName_LONGEST_GT?: number | null;
  contactLastName_LONGEST_GTE?: number | null;
  contactLastName_LONGEST_LT?: number | null;
  contactLastName_LONGEST_LTE?: number | null;
  contactLastName_LT?: number | null;
  contactLastName_LTE?: number | null;
  contactLastName_SHORTEST_EQUAL?: number | null;
  contactLastName_SHORTEST_GT?: number | null;
  contactLastName_SHORTEST_GTE?: number | null;
  contactLastName_SHORTEST_LT?: number | null;
  contactLastName_SHORTEST_LTE?: number | null;
  contactOccupation_AVERAGE_EQUAL?: number | null;
  contactOccupation_AVERAGE_GT?: number | null;
  contactOccupation_AVERAGE_GTE?: number | null;
  contactOccupation_AVERAGE_LT?: number | null;
  contactOccupation_AVERAGE_LTE?: number | null;
  contactOccupation_EQUAL?: string | null;
  contactOccupation_GT?: number | null;
  contactOccupation_GTE?: number | null;
  contactOccupation_LONGEST_EQUAL?: number | null;
  contactOccupation_LONGEST_GT?: number | null;
  contactOccupation_LONGEST_GTE?: number | null;
  contactOccupation_LONGEST_LT?: number | null;
  contactOccupation_LONGEST_LTE?: number | null;
  contactOccupation_LT?: number | null;
  contactOccupation_LTE?: number | null;
  contactOccupation_SHORTEST_EQUAL?: number | null;
  contactOccupation_SHORTEST_GT?: number | null;
  contactOccupation_SHORTEST_GTE?: number | null;
  contactOccupation_SHORTEST_LT?: number | null;
  contactOccupation_SHORTEST_LTE?: number | null;
  contactPhone_AVERAGE_EQUAL?: number | null;
  contactPhone_AVERAGE_GT?: number | null;
  contactPhone_AVERAGE_GTE?: number | null;
  contactPhone_AVERAGE_LT?: number | null;
  contactPhone_AVERAGE_LTE?: number | null;
  contactPhone_EQUAL?: string | null;
  contactPhone_GT?: number | null;
  contactPhone_GTE?: number | null;
  contactPhone_LONGEST_EQUAL?: number | null;
  contactPhone_LONGEST_GT?: number | null;
  contactPhone_LONGEST_GTE?: number | null;
  contactPhone_LONGEST_LT?: number | null;
  contactPhone_LONGEST_LTE?: number | null;
  contactPhone_LT?: number | null;
  contactPhone_LTE?: number | null;
  contactPhone_SHORTEST_EQUAL?: number | null;
  contactPhone_SHORTEST_GT?: number | null;
  contactPhone_SHORTEST_GTE?: number | null;
  contactPhone_SHORTEST_LT?: number | null;
  contactPhone_SHORTEST_LTE?: number | null;
  createdOn_AVERAGE_EQUAL?: number | null;
  createdOn_AVERAGE_GT?: number | null;
  createdOn_AVERAGE_GTE?: number | null;
  createdOn_AVERAGE_LT?: number | null;
  createdOn_AVERAGE_LTE?: number | null;
  createdOn_EQUAL?: number | null;
  createdOn_GT?: number | null;
  createdOn_GTE?: number | null;
  createdOn_LT?: number | null;
  createdOn_LTE?: number | null;
  createdOn_MAX_EQUAL?: number | null;
  createdOn_MAX_GT?: number | null;
  createdOn_MAX_GTE?: number | null;
  createdOn_MAX_LT?: number | null;
  createdOn_MAX_LTE?: number | null;
  createdOn_MIN_EQUAL?: number | null;
  createdOn_MIN_GT?: number | null;
  createdOn_MIN_GTE?: number | null;
  createdOn_MIN_LT?: number | null;
  createdOn_MIN_LTE?: number | null;
  createdOn_SUM_EQUAL?: number | null;
  createdOn_SUM_GT?: number | null;
  createdOn_SUM_GTE?: number | null;
  createdOn_SUM_LT?: number | null;
  createdOn_SUM_LTE?: number | null;
  deliveryAddress_AVERAGE_EQUAL?: number | null;
  deliveryAddress_AVERAGE_GT?: number | null;
  deliveryAddress_AVERAGE_GTE?: number | null;
  deliveryAddress_AVERAGE_LT?: number | null;
  deliveryAddress_AVERAGE_LTE?: number | null;
  deliveryAddress_EQUAL?: string | null;
  deliveryAddress_GT?: number | null;
  deliveryAddress_GTE?: number | null;
  deliveryAddress_LONGEST_EQUAL?: number | null;
  deliveryAddress_LONGEST_GT?: number | null;
  deliveryAddress_LONGEST_GTE?: number | null;
  deliveryAddress_LONGEST_LT?: number | null;
  deliveryAddress_LONGEST_LTE?: number | null;
  deliveryAddress_LT?: number | null;
  deliveryAddress_LTE?: number | null;
  deliveryAddress_SHORTEST_EQUAL?: number | null;
  deliveryAddress_SHORTEST_GT?: number | null;
  deliveryAddress_SHORTEST_GTE?: number | null;
  deliveryAddress_SHORTEST_LT?: number | null;
  deliveryAddress_SHORTEST_LTE?: number | null;
  domicile_AVERAGE_EQUAL?: number | null;
  domicile_AVERAGE_GT?: number | null;
  domicile_AVERAGE_GTE?: number | null;
  domicile_AVERAGE_LT?: number | null;
  domicile_AVERAGE_LTE?: number | null;
  domicile_EQUAL?: string | null;
  domicile_GT?: number | null;
  domicile_GTE?: number | null;
  domicile_LONGEST_EQUAL?: number | null;
  domicile_LONGEST_GT?: number | null;
  domicile_LONGEST_GTE?: number | null;
  domicile_LONGEST_LT?: number | null;
  domicile_LONGEST_LTE?: number | null;
  domicile_LT?: number | null;
  domicile_LTE?: number | null;
  domicile_SHORTEST_EQUAL?: number | null;
  domicile_SHORTEST_GT?: number | null;
  domicile_SHORTEST_GTE?: number | null;
  domicile_SHORTEST_LT?: number | null;
  domicile_SHORTEST_LTE?: number | null;
  dualApprovalThreshold_AVERAGE_EQUAL?: number | null;
  dualApprovalThreshold_AVERAGE_GT?: number | null;
  dualApprovalThreshold_AVERAGE_GTE?: number | null;
  dualApprovalThreshold_AVERAGE_LT?: number | null;
  dualApprovalThreshold_AVERAGE_LTE?: number | null;
  dualApprovalThreshold_EQUAL?: number | null;
  dualApprovalThreshold_GT?: number | null;
  dualApprovalThreshold_GTE?: number | null;
  dualApprovalThreshold_LT?: number | null;
  dualApprovalThreshold_LTE?: number | null;
  dualApprovalThreshold_MAX_EQUAL?: number | null;
  dualApprovalThreshold_MAX_GT?: number | null;
  dualApprovalThreshold_MAX_GTE?: number | null;
  dualApprovalThreshold_MAX_LT?: number | null;
  dualApprovalThreshold_MAX_LTE?: number | null;
  dualApprovalThreshold_MIN_EQUAL?: number | null;
  dualApprovalThreshold_MIN_GT?: number | null;
  dualApprovalThreshold_MIN_GTE?: number | null;
  dualApprovalThreshold_MIN_LT?: number | null;
  dualApprovalThreshold_MIN_LTE?: number | null;
  dualApprovalThreshold_SUM_EQUAL?: number | null;
  dualApprovalThreshold_SUM_GT?: number | null;
  dualApprovalThreshold_SUM_GTE?: number | null;
  dualApprovalThreshold_SUM_LT?: number | null;
  dualApprovalThreshold_SUM_LTE?: number | null;
  eIN_AVERAGE_EQUAL?: number | null;
  eIN_AVERAGE_GT?: number | null;
  eIN_AVERAGE_GTE?: number | null;
  eIN_AVERAGE_LT?: number | null;
  eIN_AVERAGE_LTE?: number | null;
  eIN_EQUAL?: string | null;
  eIN_GT?: number | null;
  eIN_GTE?: number | null;
  eIN_LONGEST_EQUAL?: number | null;
  eIN_LONGEST_GT?: number | null;
  eIN_LONGEST_GTE?: number | null;
  eIN_LONGEST_LT?: number | null;
  eIN_LONGEST_LTE?: number | null;
  eIN_LT?: number | null;
  eIN_LTE?: number | null;
  eIN_SHORTEST_EQUAL?: number | null;
  eIN_SHORTEST_GT?: number | null;
  eIN_SHORTEST_GTE?: number | null;
  eIN_SHORTEST_LT?: number | null;
  eIN_SHORTEST_LTE?: number | null;
  fax_AVERAGE_EQUAL?: number | null;
  fax_AVERAGE_GT?: number | null;
  fax_AVERAGE_GTE?: number | null;
  fax_AVERAGE_LT?: number | null;
  fax_AVERAGE_LTE?: number | null;
  fax_EQUAL?: string | null;
  fax_GT?: number | null;
  fax_GTE?: number | null;
  fax_LONGEST_EQUAL?: number | null;
  fax_LONGEST_GT?: number | null;
  fax_LONGEST_GTE?: number | null;
  fax_LONGEST_LT?: number | null;
  fax_LONGEST_LTE?: number | null;
  fax_LT?: number | null;
  fax_LTE?: number | null;
  fax_SHORTEST_EQUAL?: number | null;
  fax_SHORTEST_GT?: number | null;
  fax_SHORTEST_GTE?: number | null;
  fax_SHORTEST_LT?: number | null;
  fax_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  legalName_AVERAGE_EQUAL?: number | null;
  legalName_AVERAGE_GT?: number | null;
  legalName_AVERAGE_GTE?: number | null;
  legalName_AVERAGE_LT?: number | null;
  legalName_AVERAGE_LTE?: number | null;
  legalName_EQUAL?: string | null;
  legalName_GT?: number | null;
  legalName_GTE?: number | null;
  legalName_LONGEST_EQUAL?: number | null;
  legalName_LONGEST_GT?: number | null;
  legalName_LONGEST_GTE?: number | null;
  legalName_LONGEST_LT?: number | null;
  legalName_LONGEST_LTE?: number | null;
  legalName_LT?: number | null;
  legalName_LTE?: number | null;
  legalName_SHORTEST_EQUAL?: number | null;
  legalName_SHORTEST_GT?: number | null;
  legalName_SHORTEST_GTE?: number | null;
  legalName_SHORTEST_LT?: number | null;
  legalName_SHORTEST_LTE?: number | null;
  logo_AVERAGE_EQUAL?: number | null;
  logo_AVERAGE_GT?: number | null;
  logo_AVERAGE_GTE?: number | null;
  logo_AVERAGE_LT?: number | null;
  logo_AVERAGE_LTE?: number | null;
  logo_EQUAL?: string | null;
  logo_GT?: number | null;
  logo_GTE?: number | null;
  logo_LONGEST_EQUAL?: number | null;
  logo_LONGEST_GT?: number | null;
  logo_LONGEST_GTE?: number | null;
  logo_LONGEST_LT?: number | null;
  logo_LONGEST_LTE?: number | null;
  logo_LT?: number | null;
  logo_LTE?: number | null;
  logo_SHORTEST_EQUAL?: number | null;
  logo_SHORTEST_GT?: number | null;
  logo_SHORTEST_GTE?: number | null;
  logo_SHORTEST_LT?: number | null;
  logo_SHORTEST_LTE?: number | null;
  name_AVERAGE_EQUAL?: number | null;
  name_AVERAGE_GT?: number | null;
  name_AVERAGE_GTE?: number | null;
  name_AVERAGE_LT?: number | null;
  name_AVERAGE_LTE?: number | null;
  name_EQUAL?: string | null;
  name_GT?: number | null;
  name_GTE?: number | null;
  name_LONGEST_EQUAL?: number | null;
  name_LONGEST_GT?: number | null;
  name_LONGEST_GTE?: number | null;
  name_LONGEST_LT?: number | null;
  name_LONGEST_LTE?: number | null;
  name_LT?: number | null;
  name_LTE?: number | null;
  name_SHORTEST_EQUAL?: number | null;
  name_SHORTEST_GT?: number | null;
  name_SHORTEST_GTE?: number | null;
  name_SHORTEST_LT?: number | null;
  name_SHORTEST_LTE?: number | null;
  paymentTerms_AVERAGE_EQUAL?: number | null;
  paymentTerms_AVERAGE_GT?: number | null;
  paymentTerms_AVERAGE_GTE?: number | null;
  paymentTerms_AVERAGE_LT?: number | null;
  paymentTerms_AVERAGE_LTE?: number | null;
  paymentTerms_EQUAL?: number | null;
  paymentTerms_GT?: number | null;
  paymentTerms_GTE?: number | null;
  paymentTerms_LT?: number | null;
  paymentTerms_LTE?: number | null;
  paymentTerms_MAX_EQUAL?: number | null;
  paymentTerms_MAX_GT?: number | null;
  paymentTerms_MAX_GTE?: number | null;
  paymentTerms_MAX_LT?: number | null;
  paymentTerms_MAX_LTE?: number | null;
  paymentTerms_MIN_EQUAL?: number | null;
  paymentTerms_MIN_GT?: number | null;
  paymentTerms_MIN_GTE?: number | null;
  paymentTerms_MIN_LT?: number | null;
  paymentTerms_MIN_LTE?: number | null;
  paymentTerms_SUM_EQUAL?: number | null;
  paymentTerms_SUM_GT?: number | null;
  paymentTerms_SUM_GTE?: number | null;
  paymentTerms_SUM_LT?: number | null;
  paymentTerms_SUM_LTE?: number | null;
  phone_AVERAGE_EQUAL?: number | null;
  phone_AVERAGE_GT?: number | null;
  phone_AVERAGE_GTE?: number | null;
  phone_AVERAGE_LT?: number | null;
  phone_AVERAGE_LTE?: number | null;
  phone_EQUAL?: string | null;
  phone_GT?: number | null;
  phone_GTE?: number | null;
  phone_LONGEST_EQUAL?: number | null;
  phone_LONGEST_GT?: number | null;
  phone_LONGEST_GTE?: number | null;
  phone_LONGEST_LT?: number | null;
  phone_LONGEST_LTE?: number | null;
  phone_LT?: number | null;
  phone_LTE?: number | null;
  phone_SHORTEST_EQUAL?: number | null;
  phone_SHORTEST_GT?: number | null;
  phone_SHORTEST_GTE?: number | null;
  phone_SHORTEST_LT?: number | null;
  phone_SHORTEST_LTE?: number | null;
  tenantId_AVERAGE_EQUAL?: number | null;
  tenantId_AVERAGE_GT?: number | null;
  tenantId_AVERAGE_GTE?: number | null;
  tenantId_AVERAGE_LT?: number | null;
  tenantId_AVERAGE_LTE?: number | null;
  tenantId_EQUAL?: string | null;
  tenantId_GT?: number | null;
  tenantId_GTE?: number | null;
  tenantId_LONGEST_EQUAL?: number | null;
  tenantId_LONGEST_GT?: number | null;
  tenantId_LONGEST_GTE?: number | null;
  tenantId_LONGEST_LT?: number | null;
  tenantId_LONGEST_LTE?: number | null;
  tenantId_LT?: number | null;
  tenantId_LTE?: number | null;
  tenantId_SHORTEST_EQUAL?: number | null;
  tenantId_SHORTEST_GT?: number | null;
  tenantId_SHORTEST_GTE?: number | null;
  tenantId_SHORTEST_LT?: number | null;
  tenantId_SHORTEST_LTE?: number | null;
  website_AVERAGE_EQUAL?: number | null;
  website_AVERAGE_GT?: number | null;
  website_AVERAGE_GTE?: number | null;
  website_AVERAGE_LT?: number | null;
  website_AVERAGE_LTE?: number | null;
  website_EQUAL?: string | null;
  website_GT?: number | null;
  website_GTE?: number | null;
  website_LONGEST_EQUAL?: number | null;
  website_LONGEST_GT?: number | null;
  website_LONGEST_GTE?: number | null;
  website_LONGEST_LT?: number | null;
  website_LONGEST_LTE?: number | null;
  website_LT?: number | null;
  website_LTE?: number | null;
  website_SHORTEST_EQUAL?: number | null;
  website_SHORTEST_GT?: number | null;
  website_SHORTEST_GTE?: number | null;
  website_SHORTEST_LT?: number | null;
  website_SHORTEST_LTE?: number | null;
}

export interface CaseMessageAggregateInput {
  AND?: CaseMessageAggregateInput[] | null;
  OR?: CaseMessageAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: CaseMessageNodeAggregationWhereInput | null;
}

export interface CaseMessageConnectionWhere {
  AND?: CaseMessageConnectionWhere[] | null;
  OR?: CaseMessageConnectionWhere[] | null;
  node?: MessageWhere | null;
  node_NOT?: MessageWhere | null;
}

export interface CaseMessageNodeAggregationWhereInput {
  AND?: CaseMessageNodeAggregationWhereInput[] | null;
  OR?: CaseMessageNodeAggregationWhereInput[] | null;
  content_AVERAGE_EQUAL?: number | null;
  content_AVERAGE_GT?: number | null;
  content_AVERAGE_GTE?: number | null;
  content_AVERAGE_LT?: number | null;
  content_AVERAGE_LTE?: number | null;
  content_EQUAL?: string | null;
  content_GT?: number | null;
  content_GTE?: number | null;
  content_LONGEST_EQUAL?: number | null;
  content_LONGEST_GT?: number | null;
  content_LONGEST_GTE?: number | null;
  content_LONGEST_LT?: number | null;
  content_LONGEST_LTE?: number | null;
  content_LT?: number | null;
  content_LTE?: number | null;
  content_SHORTEST_EQUAL?: number | null;
  content_SHORTEST_GT?: number | null;
  content_SHORTEST_GTE?: number | null;
  content_SHORTEST_LT?: number | null;
  content_SHORTEST_LTE?: number | null;
  createdOn_AVERAGE_EQUAL?: number | null;
  createdOn_AVERAGE_GT?: number | null;
  createdOn_AVERAGE_GTE?: number | null;
  createdOn_AVERAGE_LT?: number | null;
  createdOn_AVERAGE_LTE?: number | null;
  createdOn_EQUAL?: number | null;
  createdOn_GT?: number | null;
  createdOn_GTE?: number | null;
  createdOn_LT?: number | null;
  createdOn_LTE?: number | null;
  createdOn_MAX_EQUAL?: number | null;
  createdOn_MAX_GT?: number | null;
  createdOn_MAX_GTE?: number | null;
  createdOn_MAX_LT?: number | null;
  createdOn_MAX_LTE?: number | null;
  createdOn_MIN_EQUAL?: number | null;
  createdOn_MIN_GT?: number | null;
  createdOn_MIN_GTE?: number | null;
  createdOn_MIN_LT?: number | null;
  createdOn_MIN_LTE?: number | null;
  createdOn_SUM_EQUAL?: number | null;
  createdOn_SUM_GT?: number | null;
  createdOn_SUM_GTE?: number | null;
  createdOn_SUM_LT?: number | null;
  createdOn_SUM_LTE?: number | null;
}

export interface CaseNegotiationRoundsAggregateInput {
  AND?: CaseNegotiationRoundsAggregateInput[] | null;
  OR?: CaseNegotiationRoundsAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: CaseNegotiationRoundsNodeAggregationWhereInput | null;
}

export interface CaseNegotiationRoundsConnectionWhere {
  AND?: CaseNegotiationRoundsConnectionWhere[] | null;
  OR?: CaseNegotiationRoundsConnectionWhere[] | null;
  node?: NegotiationRoundWhere | null;
  node_NOT?: NegotiationRoundWhere | null;
}

export interface CaseNegotiationRoundsNodeAggregationWhereInput {
  AND?: CaseNegotiationRoundsNodeAggregationWhereInput[] | null;
  OR?: CaseNegotiationRoundsNodeAggregationWhereInput[] | null;
  changedOn_EQUAL?: any | null;
  changedOn_GT?: any | null;
  changedOn_GTE?: any | null;
  changedOn_LT?: any | null;
  changedOn_LTE?: any | null;
  changedOn_MAX_EQUAL?: any | null;
  changedOn_MAX_GT?: any | null;
  changedOn_MAX_GTE?: any | null;
  changedOn_MAX_LT?: any | null;
  changedOn_MAX_LTE?: any | null;
  changedOn_MIN_EQUAL?: any | null;
  changedOn_MIN_GT?: any | null;
  changedOn_MIN_GTE?: any | null;
  changedOn_MIN_LT?: any | null;
  changedOn_MIN_LTE?: any | null;
  data_AVERAGE_EQUAL?: number | null;
  data_AVERAGE_GT?: number | null;
  data_AVERAGE_GTE?: number | null;
  data_AVERAGE_LT?: number | null;
  data_AVERAGE_LTE?: number | null;
  data_EQUAL?: string | null;
  data_GT?: number | null;
  data_GTE?: number | null;
  data_LONGEST_EQUAL?: number | null;
  data_LONGEST_GT?: number | null;
  data_LONGEST_GTE?: number | null;
  data_LONGEST_LT?: number | null;
  data_LONGEST_LTE?: number | null;
  data_LT?: number | null;
  data_LTE?: number | null;
  data_SHORTEST_EQUAL?: number | null;
  data_SHORTEST_GT?: number | null;
  data_SHORTEST_GTE?: number | null;
  data_SHORTEST_LT?: number | null;
  data_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
}

export interface CaseOptions {
  limit?: number | null;
  offset?: number | null;
  sort?: (CaseSort | null)[] | null;
}

export interface CasePatientAggregateInput {
  AND?: CasePatientAggregateInput[] | null;
  OR?: CasePatientAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: CasePatientNodeAggregationWhereInput | null;
}

export interface CasePatientConnectionWhere {
  AND?: CasePatientConnectionWhere[] | null;
  OR?: CasePatientConnectionWhere[] | null;
  node?: PatientWhere | null;
  node_NOT?: PatientWhere | null;
}

export interface CasePatientNodeAggregationWhereInput {
  AND?: CasePatientNodeAggregationWhereInput[] | null;
  OR?: CasePatientNodeAggregationWhereInput[] | null;
  id_EQUAL?: string | null;
  initials_AVERAGE_EQUAL?: number | null;
  initials_AVERAGE_GT?: number | null;
  initials_AVERAGE_GTE?: number | null;
  initials_AVERAGE_LT?: number | null;
  initials_AVERAGE_LTE?: number | null;
  initials_EQUAL?: string | null;
  initials_GT?: number | null;
  initials_GTE?: number | null;
  initials_LONGEST_EQUAL?: number | null;
  initials_LONGEST_GT?: number | null;
  initials_LONGEST_GTE?: number | null;
  initials_LONGEST_LT?: number | null;
  initials_LONGEST_LTE?: number | null;
  initials_LT?: number | null;
  initials_LTE?: number | null;
  initials_SHORTEST_EQUAL?: number | null;
  initials_SHORTEST_GT?: number | null;
  initials_SHORTEST_GTE?: number | null;
  initials_SHORTEST_LT?: number | null;
  initials_SHORTEST_LTE?: number | null;
  insuranceId_AVERAGE_EQUAL?: number | null;
  insuranceId_AVERAGE_GT?: number | null;
  insuranceId_AVERAGE_GTE?: number | null;
  insuranceId_AVERAGE_LT?: number | null;
  insuranceId_AVERAGE_LTE?: number | null;
  insuranceId_EQUAL?: string | null;
  insuranceId_GT?: number | null;
  insuranceId_GTE?: number | null;
  insuranceId_LONGEST_EQUAL?: number | null;
  insuranceId_LONGEST_GT?: number | null;
  insuranceId_LONGEST_GTE?: number | null;
  insuranceId_LONGEST_LT?: number | null;
  insuranceId_LONGEST_LTE?: number | null;
  insuranceId_LT?: number | null;
  insuranceId_LTE?: number | null;
  insuranceId_SHORTEST_EQUAL?: number | null;
  insuranceId_SHORTEST_GT?: number | null;
  insuranceId_SHORTEST_GTE?: number | null;
  insuranceId_SHORTEST_LT?: number | null;
  insuranceId_SHORTEST_LTE?: number | null;
  tenantId_AVERAGE_EQUAL?: number | null;
  tenantId_AVERAGE_GT?: number | null;
  tenantId_AVERAGE_GTE?: number | null;
  tenantId_AVERAGE_LT?: number | null;
  tenantId_AVERAGE_LTE?: number | null;
  tenantId_EQUAL?: string | null;
  tenantId_GT?: number | null;
  tenantId_GTE?: number | null;
  tenantId_LONGEST_EQUAL?: number | null;
  tenantId_LONGEST_GT?: number | null;
  tenantId_LONGEST_GTE?: number | null;
  tenantId_LONGEST_LT?: number | null;
  tenantId_LONGEST_LTE?: number | null;
  tenantId_LT?: number | null;
  tenantId_LTE?: number | null;
  tenantId_SHORTEST_EQUAL?: number | null;
  tenantId_SHORTEST_GT?: number | null;
  tenantId_SHORTEST_GTE?: number | null;
  tenantId_SHORTEST_LT?: number | null;
  tenantId_SHORTEST_LTE?: number | null;
  timeStamp_EQUAL?: any | null;
  timeStamp_GT?: any | null;
  timeStamp_GTE?: any | null;
  timeStamp_LT?: any | null;
  timeStamp_LTE?: any | null;
  timeStamp_MAX_EQUAL?: any | null;
  timeStamp_MAX_GT?: any | null;
  timeStamp_MAX_GTE?: any | null;
  timeStamp_MAX_LT?: any | null;
  timeStamp_MAX_LTE?: any | null;
  timeStamp_MIN_EQUAL?: any | null;
  timeStamp_MIN_GT?: any | null;
  timeStamp_MIN_GTE?: any | null;
  timeStamp_MIN_LT?: any | null;
  timeStamp_MIN_LTE?: any | null;
  yearOfBirth_AVERAGE_EQUAL?: number | null;
  yearOfBirth_AVERAGE_GT?: number | null;
  yearOfBirth_AVERAGE_GTE?: number | null;
  yearOfBirth_AVERAGE_LT?: number | null;
  yearOfBirth_AVERAGE_LTE?: number | null;
  yearOfBirth_EQUAL?: number | null;
  yearOfBirth_GT?: number | null;
  yearOfBirth_GTE?: number | null;
  yearOfBirth_LT?: number | null;
  yearOfBirth_LTE?: number | null;
  yearOfBirth_MAX_EQUAL?: number | null;
  yearOfBirth_MAX_GT?: number | null;
  yearOfBirth_MAX_GTE?: number | null;
  yearOfBirth_MAX_LT?: number | null;
  yearOfBirth_MAX_LTE?: number | null;
  yearOfBirth_MIN_EQUAL?: number | null;
  yearOfBirth_MIN_GT?: number | null;
  yearOfBirth_MIN_GTE?: number | null;
  yearOfBirth_MIN_LT?: number | null;
  yearOfBirth_MIN_LTE?: number | null;
  yearOfBirth_SUM_EQUAL?: number | null;
  yearOfBirth_SUM_GT?: number | null;
  yearOfBirth_SUM_GTE?: number | null;
  yearOfBirth_SUM_LT?: number | null;
  yearOfBirth_SUM_LTE?: number | null;
}

export interface CasePreparationsAggregateInput {
  AND?: CasePreparationsAggregateInput[] | null;
  OR?: CasePreparationsAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: CasePreparationsNodeAggregationWhereInput | null;
}

export interface CasePreparationsConnectionWhere {
  AND?: CasePreparationsConnectionWhere[] | null;
  OR?: CasePreparationsConnectionWhere[] | null;
  node?: PreparationWhere | null;
  node_NOT?: PreparationWhere | null;
}

export interface CasePreparationsNodeAggregationWhereInput {
  AND?: CasePreparationsNodeAggregationWhereInput[] | null;
  AtcCode_AVERAGE_EQUAL?: number | null;
  AtcCode_AVERAGE_GT?: number | null;
  AtcCode_AVERAGE_GTE?: number | null;
  AtcCode_AVERAGE_LT?: number | null;
  AtcCode_AVERAGE_LTE?: number | null;
  AtcCode_EQUAL?: string | null;
  AtcCode_GT?: number | null;
  AtcCode_GTE?: number | null;
  AtcCode_LONGEST_EQUAL?: number | null;
  AtcCode_LONGEST_GT?: number | null;
  AtcCode_LONGEST_GTE?: number | null;
  AtcCode_LONGEST_LT?: number | null;
  AtcCode_LONGEST_LTE?: number | null;
  AtcCode_LT?: number | null;
  AtcCode_LTE?: number | null;
  AtcCode_SHORTEST_EQUAL?: number | null;
  AtcCode_SHORTEST_GT?: number | null;
  AtcCode_SHORTEST_GTE?: number | null;
  AtcCode_SHORTEST_LT?: number | null;
  AtcCode_SHORTEST_LTE?: number | null;
  BrandName_AVERAGE_EQUAL?: number | null;
  BrandName_AVERAGE_GT?: number | null;
  BrandName_AVERAGE_GTE?: number | null;
  BrandName_AVERAGE_LT?: number | null;
  BrandName_AVERAGE_LTE?: number | null;
  BrandName_EQUAL?: string | null;
  BrandName_GT?: number | null;
  BrandName_GTE?: number | null;
  BrandName_LONGEST_EQUAL?: number | null;
  BrandName_LONGEST_GT?: number | null;
  BrandName_LONGEST_GTE?: number | null;
  BrandName_LONGEST_LT?: number | null;
  BrandName_LONGEST_LTE?: number | null;
  BrandName_LT?: number | null;
  BrandName_LTE?: number | null;
  BrandName_SHORTEST_EQUAL?: number | null;
  BrandName_SHORTEST_GT?: number | null;
  BrandName_SHORTEST_GTE?: number | null;
  BrandName_SHORTEST_LT?: number | null;
  BrandName_SHORTEST_LTE?: number | null;
  DescriptionDe_AVERAGE_EQUAL?: number | null;
  DescriptionDe_AVERAGE_GT?: number | null;
  DescriptionDe_AVERAGE_GTE?: number | null;
  DescriptionDe_AVERAGE_LT?: number | null;
  DescriptionDe_AVERAGE_LTE?: number | null;
  DescriptionDe_EQUAL?: string | null;
  DescriptionDe_GT?: number | null;
  DescriptionDe_GTE?: number | null;
  DescriptionDe_LONGEST_EQUAL?: number | null;
  DescriptionDe_LONGEST_GT?: number | null;
  DescriptionDe_LONGEST_GTE?: number | null;
  DescriptionDe_LONGEST_LT?: number | null;
  DescriptionDe_LONGEST_LTE?: number | null;
  DescriptionDe_LT?: number | null;
  DescriptionDe_LTE?: number | null;
  DescriptionDe_SHORTEST_EQUAL?: number | null;
  DescriptionDe_SHORTEST_GT?: number | null;
  DescriptionDe_SHORTEST_GTE?: number | null;
  DescriptionDe_SHORTEST_LT?: number | null;
  DescriptionDe_SHORTEST_LTE?: number | null;
  DescriptionFr_AVERAGE_EQUAL?: number | null;
  DescriptionFr_AVERAGE_GT?: number | null;
  DescriptionFr_AVERAGE_GTE?: number | null;
  DescriptionFr_AVERAGE_LT?: number | null;
  DescriptionFr_AVERAGE_LTE?: number | null;
  DescriptionFr_EQUAL?: string | null;
  DescriptionFr_GT?: number | null;
  DescriptionFr_GTE?: number | null;
  DescriptionFr_LONGEST_EQUAL?: number | null;
  DescriptionFr_LONGEST_GT?: number | null;
  DescriptionFr_LONGEST_GTE?: number | null;
  DescriptionFr_LONGEST_LT?: number | null;
  DescriptionFr_LONGEST_LTE?: number | null;
  DescriptionFr_LT?: number | null;
  DescriptionFr_LTE?: number | null;
  DescriptionFr_SHORTEST_EQUAL?: number | null;
  DescriptionFr_SHORTEST_GT?: number | null;
  DescriptionFr_SHORTEST_GTE?: number | null;
  DescriptionFr_SHORTEST_LT?: number | null;
  DescriptionFr_SHORTEST_LTE?: number | null;
  DescriptionIt_AVERAGE_EQUAL?: number | null;
  DescriptionIt_AVERAGE_GT?: number | null;
  DescriptionIt_AVERAGE_GTE?: number | null;
  DescriptionIt_AVERAGE_LT?: number | null;
  DescriptionIt_AVERAGE_LTE?: number | null;
  DescriptionIt_EQUAL?: string | null;
  DescriptionIt_GT?: number | null;
  DescriptionIt_GTE?: number | null;
  DescriptionIt_LONGEST_EQUAL?: number | null;
  DescriptionIt_LONGEST_GT?: number | null;
  DescriptionIt_LONGEST_GTE?: number | null;
  DescriptionIt_LONGEST_LT?: number | null;
  DescriptionIt_LONGEST_LTE?: number | null;
  DescriptionIt_LT?: number | null;
  DescriptionIt_LTE?: number | null;
  DescriptionIt_SHORTEST_EQUAL?: number | null;
  DescriptionIt_SHORTEST_GT?: number | null;
  DescriptionIt_SHORTEST_GTE?: number | null;
  DescriptionIt_SHORTEST_LT?: number | null;
  DescriptionIt_SHORTEST_LTE?: number | null;
  GenericName_AVERAGE_EQUAL?: number | null;
  GenericName_AVERAGE_GT?: number | null;
  GenericName_AVERAGE_GTE?: number | null;
  GenericName_AVERAGE_LT?: number | null;
  GenericName_AVERAGE_LTE?: number | null;
  GenericName_EQUAL?: string | null;
  GenericName_GT?: number | null;
  GenericName_GTE?: number | null;
  GenericName_LONGEST_EQUAL?: number | null;
  GenericName_LONGEST_GT?: number | null;
  GenericName_LONGEST_GTE?: number | null;
  GenericName_LONGEST_LT?: number | null;
  GenericName_LONGEST_LTE?: number | null;
  GenericName_LT?: number | null;
  GenericName_LTE?: number | null;
  GenericName_SHORTEST_EQUAL?: number | null;
  GenericName_SHORTEST_GT?: number | null;
  GenericName_SHORTEST_GTE?: number | null;
  GenericName_SHORTEST_LT?: number | null;
  GenericName_SHORTEST_LTE?: number | null;
  OR?: CasePreparationsNodeAggregationWhereInput[] | null;
  SwissmedicNo5_AVERAGE_EQUAL?: number | null;
  SwissmedicNo5_AVERAGE_GT?: number | null;
  SwissmedicNo5_AVERAGE_GTE?: number | null;
  SwissmedicNo5_AVERAGE_LT?: number | null;
  SwissmedicNo5_AVERAGE_LTE?: number | null;
  SwissmedicNo5_EQUAL?: string | null;
  SwissmedicNo5_GT?: number | null;
  SwissmedicNo5_GTE?: number | null;
  SwissmedicNo5_LONGEST_EQUAL?: number | null;
  SwissmedicNo5_LONGEST_GT?: number | null;
  SwissmedicNo5_LONGEST_GTE?: number | null;
  SwissmedicNo5_LONGEST_LT?: number | null;
  SwissmedicNo5_LONGEST_LTE?: number | null;
  SwissmedicNo5_LT?: number | null;
  SwissmedicNo5_LTE?: number | null;
  SwissmedicNo5_SHORTEST_EQUAL?: number | null;
  SwissmedicNo5_SHORTEST_GT?: number | null;
  SwissmedicNo5_SHORTEST_GTE?: number | null;
  SwissmedicNo5_SHORTEST_LT?: number | null;
  SwissmedicNo5_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
}

export interface CaseRefundCaseAggregateInput {
  AND?: CaseRefundCaseAggregateInput[] | null;
  OR?: CaseRefundCaseAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: CaseRefundCaseNodeAggregationWhereInput | null;
}

export interface CaseRefundCaseConnectionWhere {
  AND?: CaseRefundCaseConnectionWhere[] | null;
  OR?: CaseRefundCaseConnectionWhere[] | null;
  node?: RefundCaseWhere | null;
  node_NOT?: RefundCaseWhere | null;
}

export interface CaseRefundCaseNodeAggregationWhereInput {
  AND?: CaseRefundCaseNodeAggregationWhereInput[] | null;
  OR?: CaseRefundCaseNodeAggregationWhereInput[] | null;
  id_EQUAL?: string | null;
}

export interface CaseRefundsAggregateInput {
  AND?: CaseRefundsAggregateInput[] | null;
  OR?: CaseRefundsAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: CaseRefundsNodeAggregationWhereInput | null;
}

export interface CaseRefundsConnectionWhere {
  AND?: CaseRefundsConnectionWhere[] | null;
  OR?: CaseRefundsConnectionWhere[] | null;
  node?: RefundWhere | null;
  node_NOT?: RefundWhere | null;
}

export interface CaseRefundsNodeAggregationWhereInput {
  AND?: CaseRefundsNodeAggregationWhereInput[] | null;
  OR?: CaseRefundsNodeAggregationWhereInput[] | null;
  agreementName_AVERAGE_EQUAL?: number | null;
  agreementName_AVERAGE_GT?: number | null;
  agreementName_AVERAGE_GTE?: number | null;
  agreementName_AVERAGE_LT?: number | null;
  agreementName_AVERAGE_LTE?: number | null;
  agreementName_EQUAL?: string | null;
  agreementName_GT?: number | null;
  agreementName_GTE?: number | null;
  agreementName_LONGEST_EQUAL?: number | null;
  agreementName_LONGEST_GT?: number | null;
  agreementName_LONGEST_GTE?: number | null;
  agreementName_LONGEST_LT?: number | null;
  agreementName_LONGEST_LTE?: number | null;
  agreementName_LT?: number | null;
  agreementName_LTE?: number | null;
  agreementName_SHORTEST_EQUAL?: number | null;
  agreementName_SHORTEST_GT?: number | null;
  agreementName_SHORTEST_GTE?: number | null;
  agreementName_SHORTEST_LT?: number | null;
  agreementName_SHORTEST_LTE?: number | null;
  amount_AVERAGE_EQUAL?: number | null;
  amount_AVERAGE_GT?: number | null;
  amount_AVERAGE_GTE?: number | null;
  amount_AVERAGE_LT?: number | null;
  amount_AVERAGE_LTE?: number | null;
  amount_EQUAL?: number | null;
  amount_GT?: number | null;
  amount_GTE?: number | null;
  amount_LT?: number | null;
  amount_LTE?: number | null;
  amount_MAX_EQUAL?: number | null;
  amount_MAX_GT?: number | null;
  amount_MAX_GTE?: number | null;
  amount_MAX_LT?: number | null;
  amount_MAX_LTE?: number | null;
  amount_MIN_EQUAL?: number | null;
  amount_MIN_GT?: number | null;
  amount_MIN_GTE?: number | null;
  amount_MIN_LT?: number | null;
  amount_MIN_LTE?: number | null;
  amount_SUM_EQUAL?: number | null;
  amount_SUM_GT?: number | null;
  amount_SUM_GTE?: number | null;
  amount_SUM_LT?: number | null;
  amount_SUM_LTE?: number | null;
  caseId_AVERAGE_EQUAL?: number | null;
  caseId_AVERAGE_GT?: number | null;
  caseId_AVERAGE_GTE?: number | null;
  caseId_AVERAGE_LT?: number | null;
  caseId_AVERAGE_LTE?: number | null;
  caseId_EQUAL?: string | null;
  caseId_GT?: number | null;
  caseId_GTE?: number | null;
  caseId_LONGEST_EQUAL?: number | null;
  caseId_LONGEST_GT?: number | null;
  caseId_LONGEST_GTE?: number | null;
  caseId_LONGEST_LT?: number | null;
  caseId_LONGEST_LTE?: number | null;
  caseId_LT?: number | null;
  caseId_LTE?: number | null;
  caseId_SHORTEST_EQUAL?: number | null;
  caseId_SHORTEST_GT?: number | null;
  caseId_SHORTEST_GTE?: number | null;
  caseId_SHORTEST_LT?: number | null;
  caseId_SHORTEST_LTE?: number | null;
  counterParties_AVERAGE_EQUAL?: number | null;
  counterParties_AVERAGE_GT?: number | null;
  counterParties_AVERAGE_GTE?: number | null;
  counterParties_AVERAGE_LT?: number | null;
  counterParties_AVERAGE_LTE?: number | null;
  counterParties_EQUAL?: string | null;
  counterParties_GT?: number | null;
  counterParties_GTE?: number | null;
  counterParties_LONGEST_EQUAL?: number | null;
  counterParties_LONGEST_GT?: number | null;
  counterParties_LONGEST_GTE?: number | null;
  counterParties_LONGEST_LT?: number | null;
  counterParties_LONGEST_LTE?: number | null;
  counterParties_LT?: number | null;
  counterParties_LTE?: number | null;
  counterParties_SHORTEST_EQUAL?: number | null;
  counterParties_SHORTEST_GT?: number | null;
  counterParties_SHORTEST_GTE?: number | null;
  counterParties_SHORTEST_LT?: number | null;
  counterParties_SHORTEST_LTE?: number | null;
  currency_AVERAGE_EQUAL?: number | null;
  currency_AVERAGE_GT?: number | null;
  currency_AVERAGE_GTE?: number | null;
  currency_AVERAGE_LT?: number | null;
  currency_AVERAGE_LTE?: number | null;
  currency_EQUAL?: string | null;
  currency_GT?: number | null;
  currency_GTE?: number | null;
  currency_LONGEST_EQUAL?: number | null;
  currency_LONGEST_GT?: number | null;
  currency_LONGEST_GTE?: number | null;
  currency_LONGEST_LT?: number | null;
  currency_LONGEST_LTE?: number | null;
  currency_LT?: number | null;
  currency_LTE?: number | null;
  currency_SHORTEST_EQUAL?: number | null;
  currency_SHORTEST_GT?: number | null;
  currency_SHORTEST_GTE?: number | null;
  currency_SHORTEST_LT?: number | null;
  currency_SHORTEST_LTE?: number | null;
  formattedTags_AVERAGE_EQUAL?: number | null;
  formattedTags_AVERAGE_GT?: number | null;
  formattedTags_AVERAGE_GTE?: number | null;
  formattedTags_AVERAGE_LT?: number | null;
  formattedTags_AVERAGE_LTE?: number | null;
  formattedTags_EQUAL?: string | null;
  formattedTags_GT?: number | null;
  formattedTags_GTE?: number | null;
  formattedTags_LONGEST_EQUAL?: number | null;
  formattedTags_LONGEST_GT?: number | null;
  formattedTags_LONGEST_GTE?: number | null;
  formattedTags_LONGEST_LT?: number | null;
  formattedTags_LONGEST_LTE?: number | null;
  formattedTags_LT?: number | null;
  formattedTags_LTE?: number | null;
  formattedTags_SHORTEST_EQUAL?: number | null;
  formattedTags_SHORTEST_GT?: number | null;
  formattedTags_SHORTEST_GTE?: number | null;
  formattedTags_SHORTEST_LT?: number | null;
  formattedTags_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  iin_AVERAGE_EQUAL?: number | null;
  iin_AVERAGE_GT?: number | null;
  iin_AVERAGE_GTE?: number | null;
  iin_AVERAGE_LT?: number | null;
  iin_AVERAGE_LTE?: number | null;
  iin_EQUAL?: string | null;
  iin_GT?: number | null;
  iin_GTE?: number | null;
  iin_LONGEST_EQUAL?: number | null;
  iin_LONGEST_GT?: number | null;
  iin_LONGEST_GTE?: number | null;
  iin_LONGEST_LT?: number | null;
  iin_LONGEST_LTE?: number | null;
  iin_LT?: number | null;
  iin_LTE?: number | null;
  iin_SHORTEST_EQUAL?: number | null;
  iin_SHORTEST_GT?: number | null;
  iin_SHORTEST_GTE?: number | null;
  iin_SHORTEST_LT?: number | null;
  iin_SHORTEST_LTE?: number | null;
  product_AVERAGE_EQUAL?: number | null;
  product_AVERAGE_GT?: number | null;
  product_AVERAGE_GTE?: number | null;
  product_AVERAGE_LT?: number | null;
  product_AVERAGE_LTE?: number | null;
  product_EQUAL?: string | null;
  product_GT?: number | null;
  product_GTE?: number | null;
  product_LONGEST_EQUAL?: number | null;
  product_LONGEST_GT?: number | null;
  product_LONGEST_GTE?: number | null;
  product_LONGEST_LT?: number | null;
  product_LONGEST_LTE?: number | null;
  product_LT?: number | null;
  product_LTE?: number | null;
  product_SHORTEST_EQUAL?: number | null;
  product_SHORTEST_GT?: number | null;
  product_SHORTEST_GTE?: number | null;
  product_SHORTEST_LT?: number | null;
  product_SHORTEST_LTE?: number | null;
  refundRate_AVERAGE_EQUAL?: number | null;
  refundRate_AVERAGE_GT?: number | null;
  refundRate_AVERAGE_GTE?: number | null;
  refundRate_AVERAGE_LT?: number | null;
  refundRate_AVERAGE_LTE?: number | null;
  refundRate_EQUAL?: number | null;
  refundRate_GT?: number | null;
  refundRate_GTE?: number | null;
  refundRate_LT?: number | null;
  refundRate_LTE?: number | null;
  refundRate_MAX_EQUAL?: number | null;
  refundRate_MAX_GT?: number | null;
  refundRate_MAX_GTE?: number | null;
  refundRate_MAX_LT?: number | null;
  refundRate_MAX_LTE?: number | null;
  refundRate_MIN_EQUAL?: number | null;
  refundRate_MIN_GT?: number | null;
  refundRate_MIN_GTE?: number | null;
  refundRate_MIN_LT?: number | null;
  refundRate_MIN_LTE?: number | null;
  refundRate_SUM_EQUAL?: number | null;
  refundRate_SUM_GT?: number | null;
  refundRate_SUM_GTE?: number | null;
  refundRate_SUM_LT?: number | null;
  refundRate_SUM_LTE?: number | null;
  revokedOn_EQUAL?: any | null;
  revokedOn_GT?: any | null;
  revokedOn_GTE?: any | null;
  revokedOn_LT?: any | null;
  revokedOn_LTE?: any | null;
  revokedOn_MAX_EQUAL?: any | null;
  revokedOn_MAX_GT?: any | null;
  revokedOn_MAX_GTE?: any | null;
  revokedOn_MAX_LT?: any | null;
  revokedOn_MAX_LTE?: any | null;
  revokedOn_MIN_EQUAL?: any | null;
  revokedOn_MIN_GT?: any | null;
  revokedOn_MIN_GTE?: any | null;
  revokedOn_MIN_LT?: any | null;
  revokedOn_MIN_LTE?: any | null;
  unlimited_AVERAGE_EQUAL?: number | null;
  unlimited_AVERAGE_GT?: number | null;
  unlimited_AVERAGE_GTE?: number | null;
  unlimited_AVERAGE_LT?: number | null;
  unlimited_AVERAGE_LTE?: number | null;
  unlimited_EQUAL?: number | null;
  unlimited_GT?: number | null;
  unlimited_GTE?: number | null;
  unlimited_LT?: number | null;
  unlimited_LTE?: number | null;
  unlimited_MAX_EQUAL?: number | null;
  unlimited_MAX_GT?: number | null;
  unlimited_MAX_GTE?: number | null;
  unlimited_MAX_LT?: number | null;
  unlimited_MAX_LTE?: number | null;
  unlimited_MIN_EQUAL?: number | null;
  unlimited_MIN_GT?: number | null;
  unlimited_MIN_GTE?: number | null;
  unlimited_MIN_LT?: number | null;
  unlimited_MIN_LTE?: number | null;
  unlimited_SUM_EQUAL?: number | null;
  unlimited_SUM_GT?: number | null;
  unlimited_SUM_GTE?: number | null;
  unlimited_SUM_LT?: number | null;
  unlimited_SUM_LTE?: number | null;
}

export interface CaseReportingDataWhere {
  AND?: CaseReportingDataWhere[] | null;
  OR?: CaseReportingDataWhere[] | null;
  createdOn?: any | null;
  createdOn_GT?: any | null;
  createdOn_GTE?: any | null;
  createdOn_IN?: (any | null)[] | null;
  createdOn_LT?: any | null;
  createdOn_LTE?: any | null;
  createdOn_NOT?: any | null;
  createdOn_NOT_IN?: (any | null)[] | null;
  lastUpdatedOn?: any | null;
  lastUpdatedOn_GT?: any | null;
  lastUpdatedOn_GTE?: any | null;
  lastUpdatedOn_IN?: (any | null)[] | null;
  lastUpdatedOn_LT?: any | null;
  lastUpdatedOn_LTE?: any | null;
  lastUpdatedOn_NOT?: any | null;
  lastUpdatedOn_NOT_IN?: (any | null)[] | null;
  ldlDelta?: number | null;
  ldlDeltaType?: DeltaType | null;
  ldlDeltaType_IN?: (DeltaType | null)[] | null;
  ldlDeltaType_NOT?: DeltaType | null;
  ldlDeltaType_NOT_IN?: (DeltaType | null)[] | null;
  ldlDelta_GT?: number | null;
  ldlDelta_GTE?: number | null;
  ldlDelta_IN?: (number | null)[] | null;
  ldlDelta_LT?: number | null;
  ldlDelta_LTE?: number | null;
  ldlDelta_NOT?: number | null;
  ldlDelta_NOT_IN?: (number | null)[] | null;
  snapshot?: string | null;
  snapshot_CONTAINS?: string | null;
  snapshot_ENDS_WITH?: string | null;
  snapshot_IN?: (string | null)[] | null;
  snapshot_MATCHES?: string | null;
  snapshot_NOT?: string | null;
  snapshot_NOT_CONTAINS?: string | null;
  snapshot_NOT_ENDS_WITH?: string | null;
  snapshot_NOT_IN?: (string | null)[] | null;
  snapshot_NOT_STARTS_WITH?: string | null;
  snapshot_STARTS_WITH?: string | null;
}

/**
 * Fields to sort Cases by. The order in which sorts are applied is not guaranteed when specifying many fields in one CaseSort object.
 */
export interface CaseSort {
  actualAgreementId?: SortDirection | null;
  agreementName?: SortDirection | null;
  canUserViewFinancials?: SortDirection | null;
  counterpartyInReview?: SortDirection | null;
  creationDate?: SortDirection | null;
  enrolmentDate?: SortDirection | null;
  formattedRefundRate?: SortDirection | null;
  id?: SortDirection | null;
  isArchived?: SortDirection | null;
  isDeleted?: SortDirection | null;
  isFormOwner?: SortDirection | null;
  isTreatmentDiscontinued?: SortDirection | null;
  lastFinancialUpdateDate?: SortDirection | null;
  lastStatusChangeDate?: SortDirection | null;
  lastUpdateDate?: SortDirection | null;
  messageCount?: SortDirection | null;
  patientInitials?: SortDirection | null;
  patientInsuranceId?: SortDirection | null;
  preparationBrandName?: SortDirection | null;
  preparationGenericName?: SortDirection | null;
  rating?: SortDirection | null;
  sourceTenantId?: SortDirection | null;
  status?: SortDirection | null;
  submissionDate?: SortDirection | null;
  suspensionReason?: SortDirection | null;
  totalAmount?: SortDirection | null;
  unlimited?: SortDirection | null;
}

export interface CaseTaskRelationshipWhere {
  AND?: CaseTaskRelationshipWhere[] | null;
  OR?: CaseTaskRelationshipWhere[] | null;
  formDueOrOverdue?: string | null;
  formDueOrOverdue_CONTAINS?: string | null;
  formDueOrOverdue_ENDS_WITH?: string | null;
  formDueOrOverdue_IN?: (string | null)[] | null;
  formDueOrOverdue_MATCHES?: string | null;
  formDueOrOverdue_NOT?: string | null;
  formDueOrOverdue_NOT_CONTAINS?: string | null;
  formDueOrOverdue_NOT_ENDS_WITH?: string | null;
  formDueOrOverdue_NOT_IN?: (string | null)[] | null;
  formDueOrOverdue_NOT_STARTS_WITH?: string | null;
  formDueOrOverdue_STARTS_WITH?: string | null;
}

export interface CaseWhere {
  AND?: CaseWhere[] | null;
  OR?: CaseWhere[] | null;
  actualAgreementId?: string | null;
  actualAgreementId_CONTAINS?: string | null;
  actualAgreementId_ENDS_WITH?: string | null;
  actualAgreementId_IN?: (string | null)[] | null;
  actualAgreementId_MATCHES?: string | null;
  actualAgreementId_NOT?: string | null;
  actualAgreementId_NOT_CONTAINS?: string | null;
  actualAgreementId_NOT_ENDS_WITH?: string | null;
  actualAgreementId_NOT_IN?: (string | null)[] | null;
  actualAgreementId_NOT_STARTS_WITH?: string | null;
  actualAgreementId_STARTS_WITH?: string | null;
  agreementName?: string | null;
  agreementName_CONTAINS?: string | null;
  agreementName_ENDS_WITH?: string | null;
  agreementName_IN?: (string | null)[] | null;
  agreementName_MATCHES?: string | null;
  agreementName_NOT?: string | null;
  agreementName_NOT_CONTAINS?: string | null;
  agreementName_NOT_ENDS_WITH?: string | null;
  agreementName_NOT_IN?: (string | null)[] | null;
  agreementName_NOT_STARTS_WITH?: string | null;
  agreementName_STARTS_WITH?: string | null;
  baseAgreement?: BaseAgreementWhere | null;
  baseAgreementAggregate?: CaseBaseAgreementAggregateInput | null;
  baseAgreementConnection?: CaseBaseAgreementConnectionWhere | null;
  baseAgreementConnection_NOT?: CaseBaseAgreementConnectionWhere | null;
  baseAgreement_NOT?: BaseAgreementWhere | null;
  caseAssignee?: UserWhere | null;
  caseAssigneeAggregate?: CaseCaseAssigneeAggregateInput | null;
  caseAssigneeConnection?: CaseCaseAssigneeConnectionWhere | null;
  caseAssigneeConnection_NOT?: CaseCaseAssigneeConnectionWhere | null;
  caseAssignee_NOT?: UserWhere | null;
  caseEventLogs?: CaseEventLogWhere | null;
  caseEventLogsAggregate?: CaseCaseEventLogsAggregateInput | null;
  caseEventLogsConnection?: CaseCaseEventLogsConnectionWhere | null;
  caseEventLogsConnection_NOT?: CaseCaseEventLogsConnectionWhere | null;
  caseEventLogs_NOT?: CaseEventLogWhere | null;
  caseReportingData?: CaseReportingDataWhere | null;
  caseReportingDataAggregate?: CaseCaseReportingDataAggregateInput | null;
  caseReportingDataConnection?: CaseCaseReportingDataConnectionWhere | null;
  caseReportingDataConnection_NOT?: CaseCaseReportingDataConnectionWhere | null;
  caseReportingData_NOT?: CaseReportingDataWhere | null;
  cohort?: EnrollingPeriodWhere | null;
  cohortAggregate?: CaseCohortAggregateInput | null;
  cohortConnection?: CaseCohortConnectionWhere | null;
  cohortConnection_NOT?: CaseCohortConnectionWhere | null;
  cohort_NOT?: EnrollingPeriodWhere | null;
  counterpartyInReview?: string | null;
  counterpartyInReview_CONTAINS?: string | null;
  counterpartyInReview_ENDS_WITH?: string | null;
  counterpartyInReview_IN?: (string | null)[] | null;
  counterpartyInReview_MATCHES?: string | null;
  counterpartyInReview_NOT?: string | null;
  counterpartyInReview_NOT_CONTAINS?: string | null;
  counterpartyInReview_NOT_ENDS_WITH?: string | null;
  counterpartyInReview_NOT_IN?: (string | null)[] | null;
  counterpartyInReview_NOT_STARTS_WITH?: string | null;
  counterpartyInReview_STARTS_WITH?: string | null;
  creationDate?: any | null;
  creationDate_GT?: any | null;
  creationDate_GTE?: any | null;
  creationDate_IN?: (any | null)[] | null;
  creationDate_LT?: any | null;
  creationDate_LTE?: any | null;
  creationDate_NOT?: any | null;
  creationDate_NOT_IN?: (any | null)[] | null;
  disease?: DiseaseWhere | null;
  diseaseAggregate?: CaseDiseaseAggregateInput | null;
  diseaseConnection?: CaseDiseaseConnectionWhere | null;
  diseaseConnection_NOT?: CaseDiseaseConnectionWhere | null;
  disease_NOT?: DiseaseWhere | null;
  enrolmentDate?: any | null;
  enrolmentDate_GT?: any | null;
  enrolmentDate_GTE?: any | null;
  enrolmentDate_IN?: (any | null)[] | null;
  enrolmentDate_LT?: any | null;
  enrolmentDate_LTE?: any | null;
  enrolmentDate_NOT?: any | null;
  enrolmentDate_NOT_IN?: (any | null)[] | null;
  financialDataPoints?: FlexFinancialDataPointWhere | null;
  financialDataPointsAggregate?: CaseFinancialDataPointsAggregateInput | null;
  financialDataPointsConnection?: CaseFinancialDataPointsConnectionWhere | null;
  financialDataPointsConnection_NOT?: CaseFinancialDataPointsConnectionWhere | null;
  financialDataPoints_NOT?: FlexFinancialDataPointWhere | null;
  flexEntities?: FlexEntityWhere | null;
  flexEntitiesAggregate?: CaseFlexEntitiesAggregateInput | null;
  flexEntitiesConnection?: CaseFlexEntitiesConnectionWhere | null;
  flexEntitiesConnection_NOT?: CaseFlexEntitiesConnectionWhere | null;
  flexEntities_NOT?: FlexEntityWhere | null;
  history?: CaseHistoryRecordWhere | null;
  historyAggregate?: CaseHistoryAggregateInput | null;
  historyConnection?: CaseHistoryConnectionWhere | null;
  historyConnection_NOT?: CaseHistoryConnectionWhere | null;
  history_NOT?: CaseHistoryRecordWhere | null;
  id?: string | null;
  id_CONTAINS?: string | null;
  id_ENDS_WITH?: string | null;
  id_IN?: (string | null)[] | null;
  id_MATCHES?: string | null;
  id_NOT?: string | null;
  id_NOT_CONTAINS?: string | null;
  id_NOT_ENDS_WITH?: string | null;
  id_NOT_IN?: (string | null)[] | null;
  id_NOT_STARTS_WITH?: string | null;
  id_STARTS_WITH?: string | null;
  indication?: IndicationWhere | null;
  indicationAggregate?: CaseIndicationAggregateInput | null;
  indicationConnection?: CaseIndicationConnectionWhere | null;
  indicationConnection_NOT?: CaseIndicationConnectionWhere | null;
  indication_NOT?: IndicationWhere | null;
  isArchived?: boolean | null;
  isArchived_NOT?: boolean | null;
  isDeleted?: boolean | null;
  isDeleted_NOT?: boolean | null;
  lastStatusChangeDate?: any | null;
  lastStatusChangeDate_GT?: any | null;
  lastStatusChangeDate_GTE?: any | null;
  lastStatusChangeDate_IN?: (any | null)[] | null;
  lastStatusChangeDate_LT?: any | null;
  lastStatusChangeDate_LTE?: any | null;
  lastStatusChangeDate_NOT?: any | null;
  lastStatusChangeDate_NOT_IN?: (any | null)[] | null;
  lastUpdateDate?: any | null;
  lastUpdateDate_GT?: any | null;
  lastUpdateDate_GTE?: any | null;
  lastUpdateDate_IN?: (any | null)[] | null;
  lastUpdateDate_LT?: any | null;
  lastUpdateDate_LTE?: any | null;
  lastUpdateDate_NOT?: any | null;
  lastUpdateDate_NOT_IN?: (any | null)[] | null;
  legalEntity?: OrganizationWhere | null;
  legalEntityAggregate?: CaseLegalEntityAggregateInput | null;
  legalEntityConnection?: CaseLegalEntityConnectionWhere | null;
  legalEntityConnection_NOT?: CaseLegalEntityConnectionWhere | null;
  legalEntity_NOT?: OrganizationWhere | null;
  message?: MessageWhere | null;
  messageAggregate?: CaseMessageAggregateInput | null;
  messageConnection?: CaseMessageConnectionWhere | null;
  messageConnection_NOT?: CaseMessageConnectionWhere | null;
  message_NOT?: MessageWhere | null;
  negotiationRounds?: NegotiationRoundWhere | null;
  negotiationRoundsAggregate?: CaseNegotiationRoundsAggregateInput | null;
  negotiationRoundsConnection?: CaseNegotiationRoundsConnectionWhere | null;
  negotiationRoundsConnection_NOT?: CaseNegotiationRoundsConnectionWhere | null;
  negotiationRounds_NOT?: NegotiationRoundWhere | null;
  patient?: PatientWhere | null;
  patientAggregate?: CasePatientAggregateInput | null;
  patientConnection?: CasePatientConnectionWhere | null;
  patientConnection_NOT?: CasePatientConnectionWhere | null;
  patientInitials?: string | null;
  patientInitials_CONTAINS?: string | null;
  patientInitials_ENDS_WITH?: string | null;
  patientInitials_IN?: (string | null)[] | null;
  patientInitials_MATCHES?: string | null;
  patientInitials_NOT?: string | null;
  patientInitials_NOT_CONTAINS?: string | null;
  patientInitials_NOT_ENDS_WITH?: string | null;
  patientInitials_NOT_IN?: (string | null)[] | null;
  patientInitials_NOT_STARTS_WITH?: string | null;
  patientInitials_STARTS_WITH?: string | null;
  patientInsuranceId?: string | null;
  patientInsuranceId_CONTAINS?: string | null;
  patientInsuranceId_ENDS_WITH?: string | null;
  patientInsuranceId_IN?: (string | null)[] | null;
  patientInsuranceId_MATCHES?: string | null;
  patientInsuranceId_NOT?: string | null;
  patientInsuranceId_NOT_CONTAINS?: string | null;
  patientInsuranceId_NOT_ENDS_WITH?: string | null;
  patientInsuranceId_NOT_IN?: (string | null)[] | null;
  patientInsuranceId_NOT_STARTS_WITH?: string | null;
  patientInsuranceId_STARTS_WITH?: string | null;
  patient_NOT?: PatientWhere | null;
  preparationBrandName?: string | null;
  preparationBrandName_CONTAINS?: string | null;
  preparationBrandName_ENDS_WITH?: string | null;
  preparationBrandName_IN?: (string | null)[] | null;
  preparationBrandName_MATCHES?: string | null;
  preparationBrandName_NOT?: string | null;
  preparationBrandName_NOT_CONTAINS?: string | null;
  preparationBrandName_NOT_ENDS_WITH?: string | null;
  preparationBrandName_NOT_IN?: (string | null)[] | null;
  preparationBrandName_NOT_STARTS_WITH?: string | null;
  preparationBrandName_STARTS_WITH?: string | null;
  preparationGenericName?: string | null;
  preparationGenericName_CONTAINS?: string | null;
  preparationGenericName_ENDS_WITH?: string | null;
  preparationGenericName_IN?: (string | null)[] | null;
  preparationGenericName_MATCHES?: string | null;
  preparationGenericName_NOT?: string | null;
  preparationGenericName_NOT_CONTAINS?: string | null;
  preparationGenericName_NOT_ENDS_WITH?: string | null;
  preparationGenericName_NOT_IN?: (string | null)[] | null;
  preparationGenericName_NOT_STARTS_WITH?: string | null;
  preparationGenericName_STARTS_WITH?: string | null;
  preparations?: PreparationWhere | null;
  preparationsAggregate?: CasePreparationsAggregateInput | null;
  preparationsConnection?: CasePreparationsConnectionWhere | null;
  preparationsConnection_NOT?: CasePreparationsConnectionWhere | null;
  preparations_NOT?: PreparationWhere | null;
  rating?: CoverageRequestRating | null;
  rating_IN?: (CoverageRequestRating | null)[] | null;
  rating_NOT?: CoverageRequestRating | null;
  rating_NOT_IN?: (CoverageRequestRating | null)[] | null;
  refundCase?: RefundCaseWhere | null;
  refundCaseAggregate?: CaseRefundCaseAggregateInput | null;
  refundCaseConnection?: CaseRefundCaseConnectionWhere | null;
  refundCaseConnection_NOT?: CaseRefundCaseConnectionWhere | null;
  refundCase_NOT?: RefundCaseWhere | null;
  refunds?: RefundWhere | null;
  refundsAggregate?: CaseRefundsAggregateInput | null;
  refundsConnection?: CaseRefundsConnectionWhere | null;
  refundsConnection_NOT?: CaseRefundsConnectionWhere | null;
  refunds_NOT?: RefundWhere | null;
  sourceTenantId?: string | null;
  sourceTenantId_CONTAINS?: string | null;
  sourceTenantId_ENDS_WITH?: string | null;
  sourceTenantId_IN?: (string | null)[] | null;
  sourceTenantId_MATCHES?: string | null;
  sourceTenantId_NOT?: string | null;
  sourceTenantId_NOT_CONTAINS?: string | null;
  sourceTenantId_NOT_ENDS_WITH?: string | null;
  sourceTenantId_NOT_IN?: (string | null)[] | null;
  sourceTenantId_NOT_STARTS_WITH?: string | null;
  sourceTenantId_STARTS_WITH?: string | null;
  status?: CaseStatus | null;
  status_IN?: (CaseStatus | null)[] | null;
  status_NOT?: CaseStatus | null;
  status_NOT_IN?: (CaseStatus | null)[] | null;
  submissionDate?: any | null;
  submissionDate_GT?: any | null;
  submissionDate_GTE?: any | null;
  submissionDate_IN?: (any | null)[] | null;
  submissionDate_LT?: any | null;
  submissionDate_LTE?: any | null;
  submissionDate_NOT?: any | null;
  submissionDate_NOT_IN?: (any | null)[] | null;
  suspensionReason?: string | null;
  suspensionReason_CONTAINS?: string | null;
  suspensionReason_ENDS_WITH?: string | null;
  suspensionReason_IN?: (string | null)[] | null;
  suspensionReason_MATCHES?: string | null;
  suspensionReason_NOT?: string | null;
  suspensionReason_NOT_CONTAINS?: string | null;
  suspensionReason_NOT_ENDS_WITH?: string | null;
  suspensionReason_NOT_IN?: (string | null)[] | null;
  suspensionReason_NOT_STARTS_WITH?: string | null;
  suspensionReason_STARTS_WITH?: string | null;
  tenantIds?: string[] | null;
  tenantIds_INCLUDES?: string | null;
  tenantIds_NOT?: string[] | null;
  tenantIds_NOT_INCLUDES?: string | null;
  totalAmount?: number | null;
  totalAmount_GT?: number | null;
  totalAmount_GTE?: number | null;
  totalAmount_IN?: (number | null)[] | null;
  totalAmount_LT?: number | null;
  totalAmount_LTE?: number | null;
  totalAmount_NOT?: number | null;
  totalAmount_NOT_IN?: (number | null)[] | null;
  unlimited?: number | null;
  unlimited_GT?: number | null;
  unlimited_GTE?: number | null;
  unlimited_IN?: (number | null)[] | null;
  unlimited_LT?: number | null;
  unlimited_LTE?: number | null;
  unlimited_NOT?: number | null;
  unlimited_NOT_IN?: (number | null)[] | null;
}

export interface CatalogueAttributeCustomConditionAggregateInput {
  AND?: CatalogueAttributeCustomConditionAggregateInput[] | null;
  OR?: CatalogueAttributeCustomConditionAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: CatalogueAttributeCustomConditionNodeAggregationWhereInput | null;
}

export interface CatalogueAttributeCustomConditionConnectionWhere {
  AND?: CatalogueAttributeCustomConditionConnectionWhere[] | null;
  OR?: CatalogueAttributeCustomConditionConnectionWhere[] | null;
  node?: CustomEnrollingConditionWhere | null;
  node_NOT?: CustomEnrollingConditionWhere | null;
}

export interface CatalogueAttributeCustomConditionNodeAggregationWhereInput {
  AND?: CatalogueAttributeCustomConditionNodeAggregationWhereInput[] | null;
  OR?: CatalogueAttributeCustomConditionNodeAggregationWhereInput[] | null;
  createdOn_EQUAL?: any | null;
  createdOn_GT?: any | null;
  createdOn_GTE?: any | null;
  createdOn_LT?: any | null;
  createdOn_LTE?: any | null;
  createdOn_MAX_EQUAL?: any | null;
  createdOn_MAX_GT?: any | null;
  createdOn_MAX_GTE?: any | null;
  createdOn_MAX_LT?: any | null;
  createdOn_MAX_LTE?: any | null;
  createdOn_MIN_EQUAL?: any | null;
  createdOn_MIN_GT?: any | null;
  createdOn_MIN_GTE?: any | null;
  createdOn_MIN_LT?: any | null;
  createdOn_MIN_LTE?: any | null;
  description_AVERAGE_EQUAL?: number | null;
  description_AVERAGE_GT?: number | null;
  description_AVERAGE_GTE?: number | null;
  description_AVERAGE_LT?: number | null;
  description_AVERAGE_LTE?: number | null;
  description_EQUAL?: string | null;
  description_GT?: number | null;
  description_GTE?: number | null;
  description_LONGEST_EQUAL?: number | null;
  description_LONGEST_GT?: number | null;
  description_LONGEST_GTE?: number | null;
  description_LONGEST_LT?: number | null;
  description_LONGEST_LTE?: number | null;
  description_LT?: number | null;
  description_LTE?: number | null;
  description_SHORTEST_EQUAL?: number | null;
  description_SHORTEST_GT?: number | null;
  description_SHORTEST_GTE?: number | null;
  description_SHORTEST_LT?: number | null;
  description_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  name_AVERAGE_EQUAL?: number | null;
  name_AVERAGE_GT?: number | null;
  name_AVERAGE_GTE?: number | null;
  name_AVERAGE_LT?: number | null;
  name_AVERAGE_LTE?: number | null;
  name_EQUAL?: string | null;
  name_GT?: number | null;
  name_GTE?: number | null;
  name_LONGEST_EQUAL?: number | null;
  name_LONGEST_GT?: number | null;
  name_LONGEST_GTE?: number | null;
  name_LONGEST_LT?: number | null;
  name_LONGEST_LTE?: number | null;
  name_LT?: number | null;
  name_LTE?: number | null;
  name_SHORTEST_EQUAL?: number | null;
  name_SHORTEST_GT?: number | null;
  name_SHORTEST_GTE?: number | null;
  name_SHORTEST_LT?: number | null;
  name_SHORTEST_LTE?: number | null;
  type_AVERAGE_EQUAL?: number | null;
  type_AVERAGE_GT?: number | null;
  type_AVERAGE_GTE?: number | null;
  type_AVERAGE_LT?: number | null;
  type_AVERAGE_LTE?: number | null;
  type_EQUAL?: string | null;
  type_GT?: number | null;
  type_GTE?: number | null;
  type_LONGEST_EQUAL?: number | null;
  type_LONGEST_GT?: number | null;
  type_LONGEST_GTE?: number | null;
  type_LONGEST_LT?: number | null;
  type_LONGEST_LTE?: number | null;
  type_LT?: number | null;
  type_LTE?: number | null;
  type_SHORTEST_EQUAL?: number | null;
  type_SHORTEST_GT?: number | null;
  type_SHORTEST_GTE?: number | null;
  type_SHORTEST_LT?: number | null;
  type_SHORTEST_LTE?: number | null;
}

export interface CatalogueAttributeDependsOnAggregateInput {
  AND?: CatalogueAttributeDependsOnAggregateInput[] | null;
  OR?: CatalogueAttributeDependsOnAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  edge?: CatalogueAttributeDependsOnEdgeAggregationWhereInput | null;
  node?: CatalogueAttributeDependsOnNodeAggregationWhereInput | null;
}

export interface CatalogueAttributeDependsOnConnectionWhere {
  AND?: CatalogueAttributeDependsOnConnectionWhere[] | null;
  OR?: CatalogueAttributeDependsOnConnectionWhere[] | null;
  edge?: DependencyAttributeWhere | null;
  edge_NOT?: DependencyAttributeWhere | null;
  node?: CatalogueAttributeWhere | null;
  node_NOT?: CatalogueAttributeWhere | null;
}

export interface CatalogueAttributeDependsOnEdgeAggregationWhereInput {
  AND?: CatalogueAttributeDependsOnEdgeAggregationWhereInput[] | null;
  OR?: CatalogueAttributeDependsOnEdgeAggregationWhereInput[] | null;
  comment_AVERAGE_EQUAL?: number | null;
  comment_AVERAGE_GT?: number | null;
  comment_AVERAGE_GTE?: number | null;
  comment_AVERAGE_LT?: number | null;
  comment_AVERAGE_LTE?: number | null;
  comment_EQUAL?: string | null;
  comment_GT?: number | null;
  comment_GTE?: number | null;
  comment_LONGEST_EQUAL?: number | null;
  comment_LONGEST_GT?: number | null;
  comment_LONGEST_GTE?: number | null;
  comment_LONGEST_LT?: number | null;
  comment_LONGEST_LTE?: number | null;
  comment_LT?: number | null;
  comment_LTE?: number | null;
  comment_SHORTEST_EQUAL?: number | null;
  comment_SHORTEST_GT?: number | null;
  comment_SHORTEST_GTE?: number | null;
  comment_SHORTEST_LT?: number | null;
  comment_SHORTEST_LTE?: number | null;
  rules_AVERAGE_EQUAL?: number | null;
  rules_AVERAGE_GT?: number | null;
  rules_AVERAGE_GTE?: number | null;
  rules_AVERAGE_LT?: number | null;
  rules_AVERAGE_LTE?: number | null;
  rules_EQUAL?: string | null;
  rules_GT?: number | null;
  rules_GTE?: number | null;
  rules_LONGEST_EQUAL?: number | null;
  rules_LONGEST_GT?: number | null;
  rules_LONGEST_GTE?: number | null;
  rules_LONGEST_LT?: number | null;
  rules_LONGEST_LTE?: number | null;
  rules_LT?: number | null;
  rules_LTE?: number | null;
  rules_SHORTEST_EQUAL?: number | null;
  rules_SHORTEST_GT?: number | null;
  rules_SHORTEST_GTE?: number | null;
  rules_SHORTEST_LT?: number | null;
  rules_SHORTEST_LTE?: number | null;
}

export interface CatalogueAttributeDependsOnNodeAggregationWhereInput {
  AND?: CatalogueAttributeDependsOnNodeAggregationWhereInput[] | null;
  OR?: CatalogueAttributeDependsOnNodeAggregationWhereInput[] | null;
  caption_AVERAGE_EQUAL?: number | null;
  caption_AVERAGE_GT?: number | null;
  caption_AVERAGE_GTE?: number | null;
  caption_AVERAGE_LT?: number | null;
  caption_AVERAGE_LTE?: number | null;
  caption_EQUAL?: string | null;
  caption_GT?: number | null;
  caption_GTE?: number | null;
  caption_LONGEST_EQUAL?: number | null;
  caption_LONGEST_GT?: number | null;
  caption_LONGEST_GTE?: number | null;
  caption_LONGEST_LT?: number | null;
  caption_LONGEST_LTE?: number | null;
  caption_LT?: number | null;
  caption_LTE?: number | null;
  caption_SHORTEST_EQUAL?: number | null;
  caption_SHORTEST_GT?: number | null;
  caption_SHORTEST_GTE?: number | null;
  caption_SHORTEST_LT?: number | null;
  caption_SHORTEST_LTE?: number | null;
  decimalPrecision_AVERAGE_EQUAL?: number | null;
  decimalPrecision_AVERAGE_GT?: number | null;
  decimalPrecision_AVERAGE_GTE?: number | null;
  decimalPrecision_AVERAGE_LT?: number | null;
  decimalPrecision_AVERAGE_LTE?: number | null;
  decimalPrecision_EQUAL?: number | null;
  decimalPrecision_GT?: number | null;
  decimalPrecision_GTE?: number | null;
  decimalPrecision_LT?: number | null;
  decimalPrecision_LTE?: number | null;
  decimalPrecision_MAX_EQUAL?: number | null;
  decimalPrecision_MAX_GT?: number | null;
  decimalPrecision_MAX_GTE?: number | null;
  decimalPrecision_MAX_LT?: number | null;
  decimalPrecision_MAX_LTE?: number | null;
  decimalPrecision_MIN_EQUAL?: number | null;
  decimalPrecision_MIN_GT?: number | null;
  decimalPrecision_MIN_GTE?: number | null;
  decimalPrecision_MIN_LT?: number | null;
  decimalPrecision_MIN_LTE?: number | null;
  decimalPrecision_SUM_EQUAL?: number | null;
  decimalPrecision_SUM_GT?: number | null;
  decimalPrecision_SUM_GTE?: number | null;
  decimalPrecision_SUM_LT?: number | null;
  decimalPrecision_SUM_LTE?: number | null;
  defaultValue_AVERAGE_EQUAL?: number | null;
  defaultValue_AVERAGE_GT?: number | null;
  defaultValue_AVERAGE_GTE?: number | null;
  defaultValue_AVERAGE_LT?: number | null;
  defaultValue_AVERAGE_LTE?: number | null;
  defaultValue_EQUAL?: string | null;
  defaultValue_GT?: number | null;
  defaultValue_GTE?: number | null;
  defaultValue_LONGEST_EQUAL?: number | null;
  defaultValue_LONGEST_GT?: number | null;
  defaultValue_LONGEST_GTE?: number | null;
  defaultValue_LONGEST_LT?: number | null;
  defaultValue_LONGEST_LTE?: number | null;
  defaultValue_LT?: number | null;
  defaultValue_LTE?: number | null;
  defaultValue_SHORTEST_EQUAL?: number | null;
  defaultValue_SHORTEST_GT?: number | null;
  defaultValue_SHORTEST_GTE?: number | null;
  defaultValue_SHORTEST_LT?: number | null;
  defaultValue_SHORTEST_LTE?: number | null;
  id_AVERAGE_EQUAL?: number | null;
  id_AVERAGE_GT?: number | null;
  id_AVERAGE_GTE?: number | null;
  id_AVERAGE_LT?: number | null;
  id_AVERAGE_LTE?: number | null;
  id_EQUAL?: string | null;
  id_GT?: number | null;
  id_GTE?: number | null;
  id_LONGEST_EQUAL?: number | null;
  id_LONGEST_GT?: number | null;
  id_LONGEST_GTE?: number | null;
  id_LONGEST_LT?: number | null;
  id_LONGEST_LTE?: number | null;
  id_LT?: number | null;
  id_LTE?: number | null;
  id_SHORTEST_EQUAL?: number | null;
  id_SHORTEST_GT?: number | null;
  id_SHORTEST_GTE?: number | null;
  id_SHORTEST_LT?: number | null;
  id_SHORTEST_LTE?: number | null;
  identifier_AVERAGE_EQUAL?: number | null;
  identifier_AVERAGE_GT?: number | null;
  identifier_AVERAGE_GTE?: number | null;
  identifier_AVERAGE_LT?: number | null;
  identifier_AVERAGE_LTE?: number | null;
  identifier_EQUAL?: string | null;
  identifier_GT?: number | null;
  identifier_GTE?: number | null;
  identifier_LONGEST_EQUAL?: number | null;
  identifier_LONGEST_GT?: number | null;
  identifier_LONGEST_GTE?: number | null;
  identifier_LONGEST_LT?: number | null;
  identifier_LONGEST_LTE?: number | null;
  identifier_LT?: number | null;
  identifier_LTE?: number | null;
  identifier_SHORTEST_EQUAL?: number | null;
  identifier_SHORTEST_GT?: number | null;
  identifier_SHORTEST_GTE?: number | null;
  identifier_SHORTEST_LT?: number | null;
  identifier_SHORTEST_LTE?: number | null;
  longLabelLocalizationKey_AVERAGE_EQUAL?: number | null;
  longLabelLocalizationKey_AVERAGE_GT?: number | null;
  longLabelLocalizationKey_AVERAGE_GTE?: number | null;
  longLabelLocalizationKey_AVERAGE_LT?: number | null;
  longLabelLocalizationKey_AVERAGE_LTE?: number | null;
  longLabelLocalizationKey_EQUAL?: string | null;
  longLabelLocalizationKey_GT?: number | null;
  longLabelLocalizationKey_GTE?: number | null;
  longLabelLocalizationKey_LONGEST_EQUAL?: number | null;
  longLabelLocalizationKey_LONGEST_GT?: number | null;
  longLabelLocalizationKey_LONGEST_GTE?: number | null;
  longLabelLocalizationKey_LONGEST_LT?: number | null;
  longLabelLocalizationKey_LONGEST_LTE?: number | null;
  longLabelLocalizationKey_LT?: number | null;
  longLabelLocalizationKey_LTE?: number | null;
  longLabelLocalizationKey_SHORTEST_EQUAL?: number | null;
  longLabelLocalizationKey_SHORTEST_GT?: number | null;
  longLabelLocalizationKey_SHORTEST_GTE?: number | null;
  longLabelLocalizationKey_SHORTEST_LT?: number | null;
  longLabelLocalizationKey_SHORTEST_LTE?: number | null;
  maxLength_AVERAGE_EQUAL?: number | null;
  maxLength_AVERAGE_GT?: number | null;
  maxLength_AVERAGE_GTE?: number | null;
  maxLength_AVERAGE_LT?: number | null;
  maxLength_AVERAGE_LTE?: number | null;
  maxLength_EQUAL?: number | null;
  maxLength_GT?: number | null;
  maxLength_GTE?: number | null;
  maxLength_LT?: number | null;
  maxLength_LTE?: number | null;
  maxLength_MAX_EQUAL?: number | null;
  maxLength_MAX_GT?: number | null;
  maxLength_MAX_GTE?: number | null;
  maxLength_MAX_LT?: number | null;
  maxLength_MAX_LTE?: number | null;
  maxLength_MIN_EQUAL?: number | null;
  maxLength_MIN_GT?: number | null;
  maxLength_MIN_GTE?: number | null;
  maxLength_MIN_LT?: number | null;
  maxLength_MIN_LTE?: number | null;
  maxLength_SUM_EQUAL?: number | null;
  maxLength_SUM_GT?: number | null;
  maxLength_SUM_GTE?: number | null;
  maxLength_SUM_LT?: number | null;
  maxLength_SUM_LTE?: number | null;
  minLength_AVERAGE_EQUAL?: number | null;
  minLength_AVERAGE_GT?: number | null;
  minLength_AVERAGE_GTE?: number | null;
  minLength_AVERAGE_LT?: number | null;
  minLength_AVERAGE_LTE?: number | null;
  minLength_EQUAL?: number | null;
  minLength_GT?: number | null;
  minLength_GTE?: number | null;
  minLength_LT?: number | null;
  minLength_LTE?: number | null;
  minLength_MAX_EQUAL?: number | null;
  minLength_MAX_GT?: number | null;
  minLength_MAX_GTE?: number | null;
  minLength_MAX_LT?: number | null;
  minLength_MAX_LTE?: number | null;
  minLength_MIN_EQUAL?: number | null;
  minLength_MIN_GT?: number | null;
  minLength_MIN_GTE?: number | null;
  minLength_MIN_LT?: number | null;
  minLength_MIN_LTE?: number | null;
  minLength_SUM_EQUAL?: number | null;
  minLength_SUM_GT?: number | null;
  minLength_SUM_GTE?: number | null;
  minLength_SUM_LT?: number | null;
  minLength_SUM_LTE?: number | null;
  rules_AVERAGE_EQUAL?: number | null;
  rules_AVERAGE_GT?: number | null;
  rules_AVERAGE_GTE?: number | null;
  rules_AVERAGE_LT?: number | null;
  rules_AVERAGE_LTE?: number | null;
  rules_EQUAL?: string | null;
  rules_GT?: number | null;
  rules_GTE?: number | null;
  rules_LONGEST_EQUAL?: number | null;
  rules_LONGEST_GT?: number | null;
  rules_LONGEST_GTE?: number | null;
  rules_LONGEST_LT?: number | null;
  rules_LONGEST_LTE?: number | null;
  rules_LT?: number | null;
  rules_LTE?: number | null;
  rules_SHORTEST_EQUAL?: number | null;
  rules_SHORTEST_GT?: number | null;
  rules_SHORTEST_GTE?: number | null;
  rules_SHORTEST_LT?: number | null;
  rules_SHORTEST_LTE?: number | null;
  shortLabelLocalizationKey_AVERAGE_EQUAL?: number | null;
  shortLabelLocalizationKey_AVERAGE_GT?: number | null;
  shortLabelLocalizationKey_AVERAGE_GTE?: number | null;
  shortLabelLocalizationKey_AVERAGE_LT?: number | null;
  shortLabelLocalizationKey_AVERAGE_LTE?: number | null;
  shortLabelLocalizationKey_EQUAL?: string | null;
  shortLabelLocalizationKey_GT?: number | null;
  shortLabelLocalizationKey_GTE?: number | null;
  shortLabelLocalizationKey_LONGEST_EQUAL?: number | null;
  shortLabelLocalizationKey_LONGEST_GT?: number | null;
  shortLabelLocalizationKey_LONGEST_GTE?: number | null;
  shortLabelLocalizationKey_LONGEST_LT?: number | null;
  shortLabelLocalizationKey_LONGEST_LTE?: number | null;
  shortLabelLocalizationKey_LT?: number | null;
  shortLabelLocalizationKey_LTE?: number | null;
  shortLabelLocalizationKey_SHORTEST_EQUAL?: number | null;
  shortLabelLocalizationKey_SHORTEST_GT?: number | null;
  shortLabelLocalizationKey_SHORTEST_GTE?: number | null;
  shortLabelLocalizationKey_SHORTEST_LT?: number | null;
  shortLabelLocalizationKey_SHORTEST_LTE?: number | null;
  values_AVERAGE_EQUAL?: number | null;
  values_AVERAGE_GT?: number | null;
  values_AVERAGE_GTE?: number | null;
  values_AVERAGE_LT?: number | null;
  values_AVERAGE_LTE?: number | null;
  values_EQUAL?: string | null;
  values_GT?: number | null;
  values_GTE?: number | null;
  values_LONGEST_EQUAL?: number | null;
  values_LONGEST_GT?: number | null;
  values_LONGEST_GTE?: number | null;
  values_LONGEST_LT?: number | null;
  values_LONGEST_LTE?: number | null;
  values_LT?: number | null;
  values_LTE?: number | null;
  values_SHORTEST_EQUAL?: number | null;
  values_SHORTEST_GT?: number | null;
  values_SHORTEST_GTE?: number | null;
  values_SHORTEST_LT?: number | null;
  values_SHORTEST_LTE?: number | null;
}

export interface CatalogueAttributeFlexEntityTypesAggregateInput {
  AND?: CatalogueAttributeFlexEntityTypesAggregateInput[] | null;
  OR?: CatalogueAttributeFlexEntityTypesAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: CatalogueAttributeFlexEntityTypesNodeAggregationWhereInput | null;
}

export interface CatalogueAttributeFlexEntityTypesConnectionWhere {
  AND?: CatalogueAttributeFlexEntityTypesConnectionWhere[] | null;
  OR?: CatalogueAttributeFlexEntityTypesConnectionWhere[] | null;
  edge?: FlexEntityTypeCatalogueAttributeRelationshipWhere | null;
  edge_NOT?: FlexEntityTypeCatalogueAttributeRelationshipWhere | null;
  node?: FlexEntityTypeWhere | null;
  node_NOT?: FlexEntityTypeWhere | null;
}

export interface CatalogueAttributeFlexEntityTypesNodeAggregationWhereInput {
  AND?: CatalogueAttributeFlexEntityTypesNodeAggregationWhereInput[] | null;
  OR?: CatalogueAttributeFlexEntityTypesNodeAggregationWhereInput[] | null;
  addedByName_AVERAGE_EQUAL?: number | null;
  addedByName_AVERAGE_GT?: number | null;
  addedByName_AVERAGE_GTE?: number | null;
  addedByName_AVERAGE_LT?: number | null;
  addedByName_AVERAGE_LTE?: number | null;
  addedByName_EQUAL?: string | null;
  addedByName_GT?: number | null;
  addedByName_GTE?: number | null;
  addedByName_LONGEST_EQUAL?: number | null;
  addedByName_LONGEST_GT?: number | null;
  addedByName_LONGEST_GTE?: number | null;
  addedByName_LONGEST_LT?: number | null;
  addedByName_LONGEST_LTE?: number | null;
  addedByName_LT?: number | null;
  addedByName_LTE?: number | null;
  addedByName_SHORTEST_EQUAL?: number | null;
  addedByName_SHORTEST_GT?: number | null;
  addedByName_SHORTEST_GTE?: number | null;
  addedByName_SHORTEST_LT?: number | null;
  addedByName_SHORTEST_LTE?: number | null;
  attributeCount_AVERAGE_EQUAL?: number | null;
  attributeCount_AVERAGE_GT?: number | null;
  attributeCount_AVERAGE_GTE?: number | null;
  attributeCount_AVERAGE_LT?: number | null;
  attributeCount_AVERAGE_LTE?: number | null;
  attributeCount_EQUAL?: number | null;
  attributeCount_GT?: number | null;
  attributeCount_GTE?: number | null;
  attributeCount_LT?: number | null;
  attributeCount_LTE?: number | null;
  attributeCount_MAX_EQUAL?: number | null;
  attributeCount_MAX_GT?: number | null;
  attributeCount_MAX_GTE?: number | null;
  attributeCount_MAX_LT?: number | null;
  attributeCount_MAX_LTE?: number | null;
  attributeCount_MIN_EQUAL?: number | null;
  attributeCount_MIN_GT?: number | null;
  attributeCount_MIN_GTE?: number | null;
  attributeCount_MIN_LT?: number | null;
  attributeCount_MIN_LTE?: number | null;
  attributeCount_SUM_EQUAL?: number | null;
  attributeCount_SUM_GT?: number | null;
  attributeCount_SUM_GTE?: number | null;
  attributeCount_SUM_LT?: number | null;
  attributeCount_SUM_LTE?: number | null;
  createdOn_EQUAL?: any | null;
  createdOn_GT?: any | null;
  createdOn_GTE?: any | null;
  createdOn_LT?: any | null;
  createdOn_LTE?: any | null;
  createdOn_MAX_EQUAL?: any | null;
  createdOn_MAX_GT?: any | null;
  createdOn_MAX_GTE?: any | null;
  createdOn_MAX_LT?: any | null;
  createdOn_MAX_LTE?: any | null;
  createdOn_MIN_EQUAL?: any | null;
  createdOn_MIN_GT?: any | null;
  createdOn_MIN_GTE?: any | null;
  createdOn_MIN_LT?: any | null;
  createdOn_MIN_LTE?: any | null;
  data_AVERAGE_EQUAL?: number | null;
  data_AVERAGE_GT?: number | null;
  data_AVERAGE_GTE?: number | null;
  data_AVERAGE_LT?: number | null;
  data_AVERAGE_LTE?: number | null;
  data_EQUAL?: string | null;
  data_GT?: number | null;
  data_GTE?: number | null;
  data_LONGEST_EQUAL?: number | null;
  data_LONGEST_GT?: number | null;
  data_LONGEST_GTE?: number | null;
  data_LONGEST_LT?: number | null;
  data_LONGEST_LTE?: number | null;
  data_LT?: number | null;
  data_LTE?: number | null;
  data_SHORTEST_EQUAL?: number | null;
  data_SHORTEST_GT?: number | null;
  data_SHORTEST_GTE?: number | null;
  data_SHORTEST_LT?: number | null;
  data_SHORTEST_LTE?: number | null;
  description_AVERAGE_EQUAL?: number | null;
  description_AVERAGE_GT?: number | null;
  description_AVERAGE_GTE?: number | null;
  description_AVERAGE_LT?: number | null;
  description_AVERAGE_LTE?: number | null;
  description_EQUAL?: string | null;
  description_GT?: number | null;
  description_GTE?: number | null;
  description_LONGEST_EQUAL?: number | null;
  description_LONGEST_GT?: number | null;
  description_LONGEST_GTE?: number | null;
  description_LONGEST_LT?: number | null;
  description_LONGEST_LTE?: number | null;
  description_LT?: number | null;
  description_LTE?: number | null;
  description_SHORTEST_EQUAL?: number | null;
  description_SHORTEST_GT?: number | null;
  description_SHORTEST_GTE?: number | null;
  description_SHORTEST_LT?: number | null;
  description_SHORTEST_LTE?: number | null;
  idPrefix_AVERAGE_EQUAL?: number | null;
  idPrefix_AVERAGE_GT?: number | null;
  idPrefix_AVERAGE_GTE?: number | null;
  idPrefix_AVERAGE_LT?: number | null;
  idPrefix_AVERAGE_LTE?: number | null;
  idPrefix_EQUAL?: string | null;
  idPrefix_GT?: number | null;
  idPrefix_GTE?: number | null;
  idPrefix_LONGEST_EQUAL?: number | null;
  idPrefix_LONGEST_GT?: number | null;
  idPrefix_LONGEST_GTE?: number | null;
  idPrefix_LONGEST_LT?: number | null;
  idPrefix_LONGEST_LTE?: number | null;
  idPrefix_LT?: number | null;
  idPrefix_LTE?: number | null;
  idPrefix_SHORTEST_EQUAL?: number | null;
  idPrefix_SHORTEST_GT?: number | null;
  idPrefix_SHORTEST_GTE?: number | null;
  idPrefix_SHORTEST_LT?: number | null;
  idPrefix_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  localizationKey_AVERAGE_EQUAL?: number | null;
  localizationKey_AVERAGE_GT?: number | null;
  localizationKey_AVERAGE_GTE?: number | null;
  localizationKey_AVERAGE_LT?: number | null;
  localizationKey_AVERAGE_LTE?: number | null;
  localizationKey_EQUAL?: string | null;
  localizationKey_GT?: number | null;
  localizationKey_GTE?: number | null;
  localizationKey_LONGEST_EQUAL?: number | null;
  localizationKey_LONGEST_GT?: number | null;
  localizationKey_LONGEST_GTE?: number | null;
  localizationKey_LONGEST_LT?: number | null;
  localizationKey_LONGEST_LTE?: number | null;
  localizationKey_LT?: number | null;
  localizationKey_LTE?: number | null;
  localizationKey_SHORTEST_EQUAL?: number | null;
  localizationKey_SHORTEST_GT?: number | null;
  localizationKey_SHORTEST_GTE?: number | null;
  localizationKey_SHORTEST_LT?: number | null;
  localizationKey_SHORTEST_LTE?: number | null;
  name_AVERAGE_EQUAL?: number | null;
  name_AVERAGE_GT?: number | null;
  name_AVERAGE_GTE?: number | null;
  name_AVERAGE_LT?: number | null;
  name_AVERAGE_LTE?: number | null;
  name_EQUAL?: string | null;
  name_GT?: number | null;
  name_GTE?: number | null;
  name_LONGEST_EQUAL?: number | null;
  name_LONGEST_GT?: number | null;
  name_LONGEST_GTE?: number | null;
  name_LONGEST_LT?: number | null;
  name_LONGEST_LTE?: number | null;
  name_LT?: number | null;
  name_LTE?: number | null;
  name_SHORTEST_EQUAL?: number | null;
  name_SHORTEST_GT?: number | null;
  name_SHORTEST_GTE?: number | null;
  name_SHORTEST_LT?: number | null;
  name_SHORTEST_LTE?: number | null;
  tooltipText_AVERAGE_EQUAL?: number | null;
  tooltipText_AVERAGE_GT?: number | null;
  tooltipText_AVERAGE_GTE?: number | null;
  tooltipText_AVERAGE_LT?: number | null;
  tooltipText_AVERAGE_LTE?: number | null;
  tooltipText_EQUAL?: string | null;
  tooltipText_GT?: number | null;
  tooltipText_GTE?: number | null;
  tooltipText_LONGEST_EQUAL?: number | null;
  tooltipText_LONGEST_GT?: number | null;
  tooltipText_LONGEST_GTE?: number | null;
  tooltipText_LONGEST_LT?: number | null;
  tooltipText_LONGEST_LTE?: number | null;
  tooltipText_LT?: number | null;
  tooltipText_LTE?: number | null;
  tooltipText_SHORTEST_EQUAL?: number | null;
  tooltipText_SHORTEST_GT?: number | null;
  tooltipText_SHORTEST_GTE?: number | null;
  tooltipText_SHORTEST_LT?: number | null;
  tooltipText_SHORTEST_LTE?: number | null;
}

export interface CatalogueAttributeHasDependantAggregateInput {
  AND?: CatalogueAttributeHasDependantAggregateInput[] | null;
  OR?: CatalogueAttributeHasDependantAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  edge?: CatalogueAttributeHasDependantEdgeAggregationWhereInput | null;
  node?: CatalogueAttributeHasDependantNodeAggregationWhereInput | null;
}

export interface CatalogueAttributeHasDependantConnectionWhere {
  AND?: CatalogueAttributeHasDependantConnectionWhere[] | null;
  OR?: CatalogueAttributeHasDependantConnectionWhere[] | null;
  edge?: DependencyAttributeWhere | null;
  edge_NOT?: DependencyAttributeWhere | null;
  node?: CatalogueAttributeWhere | null;
  node_NOT?: CatalogueAttributeWhere | null;
}

export interface CatalogueAttributeHasDependantEdgeAggregationWhereInput {
  AND?: CatalogueAttributeHasDependantEdgeAggregationWhereInput[] | null;
  OR?: CatalogueAttributeHasDependantEdgeAggregationWhereInput[] | null;
  comment_AVERAGE_EQUAL?: number | null;
  comment_AVERAGE_GT?: number | null;
  comment_AVERAGE_GTE?: number | null;
  comment_AVERAGE_LT?: number | null;
  comment_AVERAGE_LTE?: number | null;
  comment_EQUAL?: string | null;
  comment_GT?: number | null;
  comment_GTE?: number | null;
  comment_LONGEST_EQUAL?: number | null;
  comment_LONGEST_GT?: number | null;
  comment_LONGEST_GTE?: number | null;
  comment_LONGEST_LT?: number | null;
  comment_LONGEST_LTE?: number | null;
  comment_LT?: number | null;
  comment_LTE?: number | null;
  comment_SHORTEST_EQUAL?: number | null;
  comment_SHORTEST_GT?: number | null;
  comment_SHORTEST_GTE?: number | null;
  comment_SHORTEST_LT?: number | null;
  comment_SHORTEST_LTE?: number | null;
  rules_AVERAGE_EQUAL?: number | null;
  rules_AVERAGE_GT?: number | null;
  rules_AVERAGE_GTE?: number | null;
  rules_AVERAGE_LT?: number | null;
  rules_AVERAGE_LTE?: number | null;
  rules_EQUAL?: string | null;
  rules_GT?: number | null;
  rules_GTE?: number | null;
  rules_LONGEST_EQUAL?: number | null;
  rules_LONGEST_GT?: number | null;
  rules_LONGEST_GTE?: number | null;
  rules_LONGEST_LT?: number | null;
  rules_LONGEST_LTE?: number | null;
  rules_LT?: number | null;
  rules_LTE?: number | null;
  rules_SHORTEST_EQUAL?: number | null;
  rules_SHORTEST_GT?: number | null;
  rules_SHORTEST_GTE?: number | null;
  rules_SHORTEST_LT?: number | null;
  rules_SHORTEST_LTE?: number | null;
}

export interface CatalogueAttributeHasDependantNodeAggregationWhereInput {
  AND?: CatalogueAttributeHasDependantNodeAggregationWhereInput[] | null;
  OR?: CatalogueAttributeHasDependantNodeAggregationWhereInput[] | null;
  caption_AVERAGE_EQUAL?: number | null;
  caption_AVERAGE_GT?: number | null;
  caption_AVERAGE_GTE?: number | null;
  caption_AVERAGE_LT?: number | null;
  caption_AVERAGE_LTE?: number | null;
  caption_EQUAL?: string | null;
  caption_GT?: number | null;
  caption_GTE?: number | null;
  caption_LONGEST_EQUAL?: number | null;
  caption_LONGEST_GT?: number | null;
  caption_LONGEST_GTE?: number | null;
  caption_LONGEST_LT?: number | null;
  caption_LONGEST_LTE?: number | null;
  caption_LT?: number | null;
  caption_LTE?: number | null;
  caption_SHORTEST_EQUAL?: number | null;
  caption_SHORTEST_GT?: number | null;
  caption_SHORTEST_GTE?: number | null;
  caption_SHORTEST_LT?: number | null;
  caption_SHORTEST_LTE?: number | null;
  decimalPrecision_AVERAGE_EQUAL?: number | null;
  decimalPrecision_AVERAGE_GT?: number | null;
  decimalPrecision_AVERAGE_GTE?: number | null;
  decimalPrecision_AVERAGE_LT?: number | null;
  decimalPrecision_AVERAGE_LTE?: number | null;
  decimalPrecision_EQUAL?: number | null;
  decimalPrecision_GT?: number | null;
  decimalPrecision_GTE?: number | null;
  decimalPrecision_LT?: number | null;
  decimalPrecision_LTE?: number | null;
  decimalPrecision_MAX_EQUAL?: number | null;
  decimalPrecision_MAX_GT?: number | null;
  decimalPrecision_MAX_GTE?: number | null;
  decimalPrecision_MAX_LT?: number | null;
  decimalPrecision_MAX_LTE?: number | null;
  decimalPrecision_MIN_EQUAL?: number | null;
  decimalPrecision_MIN_GT?: number | null;
  decimalPrecision_MIN_GTE?: number | null;
  decimalPrecision_MIN_LT?: number | null;
  decimalPrecision_MIN_LTE?: number | null;
  decimalPrecision_SUM_EQUAL?: number | null;
  decimalPrecision_SUM_GT?: number | null;
  decimalPrecision_SUM_GTE?: number | null;
  decimalPrecision_SUM_LT?: number | null;
  decimalPrecision_SUM_LTE?: number | null;
  defaultValue_AVERAGE_EQUAL?: number | null;
  defaultValue_AVERAGE_GT?: number | null;
  defaultValue_AVERAGE_GTE?: number | null;
  defaultValue_AVERAGE_LT?: number | null;
  defaultValue_AVERAGE_LTE?: number | null;
  defaultValue_EQUAL?: string | null;
  defaultValue_GT?: number | null;
  defaultValue_GTE?: number | null;
  defaultValue_LONGEST_EQUAL?: number | null;
  defaultValue_LONGEST_GT?: number | null;
  defaultValue_LONGEST_GTE?: number | null;
  defaultValue_LONGEST_LT?: number | null;
  defaultValue_LONGEST_LTE?: number | null;
  defaultValue_LT?: number | null;
  defaultValue_LTE?: number | null;
  defaultValue_SHORTEST_EQUAL?: number | null;
  defaultValue_SHORTEST_GT?: number | null;
  defaultValue_SHORTEST_GTE?: number | null;
  defaultValue_SHORTEST_LT?: number | null;
  defaultValue_SHORTEST_LTE?: number | null;
  id_AVERAGE_EQUAL?: number | null;
  id_AVERAGE_GT?: number | null;
  id_AVERAGE_GTE?: number | null;
  id_AVERAGE_LT?: number | null;
  id_AVERAGE_LTE?: number | null;
  id_EQUAL?: string | null;
  id_GT?: number | null;
  id_GTE?: number | null;
  id_LONGEST_EQUAL?: number | null;
  id_LONGEST_GT?: number | null;
  id_LONGEST_GTE?: number | null;
  id_LONGEST_LT?: number | null;
  id_LONGEST_LTE?: number | null;
  id_LT?: number | null;
  id_LTE?: number | null;
  id_SHORTEST_EQUAL?: number | null;
  id_SHORTEST_GT?: number | null;
  id_SHORTEST_GTE?: number | null;
  id_SHORTEST_LT?: number | null;
  id_SHORTEST_LTE?: number | null;
  identifier_AVERAGE_EQUAL?: number | null;
  identifier_AVERAGE_GT?: number | null;
  identifier_AVERAGE_GTE?: number | null;
  identifier_AVERAGE_LT?: number | null;
  identifier_AVERAGE_LTE?: number | null;
  identifier_EQUAL?: string | null;
  identifier_GT?: number | null;
  identifier_GTE?: number | null;
  identifier_LONGEST_EQUAL?: number | null;
  identifier_LONGEST_GT?: number | null;
  identifier_LONGEST_GTE?: number | null;
  identifier_LONGEST_LT?: number | null;
  identifier_LONGEST_LTE?: number | null;
  identifier_LT?: number | null;
  identifier_LTE?: number | null;
  identifier_SHORTEST_EQUAL?: number | null;
  identifier_SHORTEST_GT?: number | null;
  identifier_SHORTEST_GTE?: number | null;
  identifier_SHORTEST_LT?: number | null;
  identifier_SHORTEST_LTE?: number | null;
  longLabelLocalizationKey_AVERAGE_EQUAL?: number | null;
  longLabelLocalizationKey_AVERAGE_GT?: number | null;
  longLabelLocalizationKey_AVERAGE_GTE?: number | null;
  longLabelLocalizationKey_AVERAGE_LT?: number | null;
  longLabelLocalizationKey_AVERAGE_LTE?: number | null;
  longLabelLocalizationKey_EQUAL?: string | null;
  longLabelLocalizationKey_GT?: number | null;
  longLabelLocalizationKey_GTE?: number | null;
  longLabelLocalizationKey_LONGEST_EQUAL?: number | null;
  longLabelLocalizationKey_LONGEST_GT?: number | null;
  longLabelLocalizationKey_LONGEST_GTE?: number | null;
  longLabelLocalizationKey_LONGEST_LT?: number | null;
  longLabelLocalizationKey_LONGEST_LTE?: number | null;
  longLabelLocalizationKey_LT?: number | null;
  longLabelLocalizationKey_LTE?: number | null;
  longLabelLocalizationKey_SHORTEST_EQUAL?: number | null;
  longLabelLocalizationKey_SHORTEST_GT?: number | null;
  longLabelLocalizationKey_SHORTEST_GTE?: number | null;
  longLabelLocalizationKey_SHORTEST_LT?: number | null;
  longLabelLocalizationKey_SHORTEST_LTE?: number | null;
  maxLength_AVERAGE_EQUAL?: number | null;
  maxLength_AVERAGE_GT?: number | null;
  maxLength_AVERAGE_GTE?: number | null;
  maxLength_AVERAGE_LT?: number | null;
  maxLength_AVERAGE_LTE?: number | null;
  maxLength_EQUAL?: number | null;
  maxLength_GT?: number | null;
  maxLength_GTE?: number | null;
  maxLength_LT?: number | null;
  maxLength_LTE?: number | null;
  maxLength_MAX_EQUAL?: number | null;
  maxLength_MAX_GT?: number | null;
  maxLength_MAX_GTE?: number | null;
  maxLength_MAX_LT?: number | null;
  maxLength_MAX_LTE?: number | null;
  maxLength_MIN_EQUAL?: number | null;
  maxLength_MIN_GT?: number | null;
  maxLength_MIN_GTE?: number | null;
  maxLength_MIN_LT?: number | null;
  maxLength_MIN_LTE?: number | null;
  maxLength_SUM_EQUAL?: number | null;
  maxLength_SUM_GT?: number | null;
  maxLength_SUM_GTE?: number | null;
  maxLength_SUM_LT?: number | null;
  maxLength_SUM_LTE?: number | null;
  minLength_AVERAGE_EQUAL?: number | null;
  minLength_AVERAGE_GT?: number | null;
  minLength_AVERAGE_GTE?: number | null;
  minLength_AVERAGE_LT?: number | null;
  minLength_AVERAGE_LTE?: number | null;
  minLength_EQUAL?: number | null;
  minLength_GT?: number | null;
  minLength_GTE?: number | null;
  minLength_LT?: number | null;
  minLength_LTE?: number | null;
  minLength_MAX_EQUAL?: number | null;
  minLength_MAX_GT?: number | null;
  minLength_MAX_GTE?: number | null;
  minLength_MAX_LT?: number | null;
  minLength_MAX_LTE?: number | null;
  minLength_MIN_EQUAL?: number | null;
  minLength_MIN_GT?: number | null;
  minLength_MIN_GTE?: number | null;
  minLength_MIN_LT?: number | null;
  minLength_MIN_LTE?: number | null;
  minLength_SUM_EQUAL?: number | null;
  minLength_SUM_GT?: number | null;
  minLength_SUM_GTE?: number | null;
  minLength_SUM_LT?: number | null;
  minLength_SUM_LTE?: number | null;
  rules_AVERAGE_EQUAL?: number | null;
  rules_AVERAGE_GT?: number | null;
  rules_AVERAGE_GTE?: number | null;
  rules_AVERAGE_LT?: number | null;
  rules_AVERAGE_LTE?: number | null;
  rules_EQUAL?: string | null;
  rules_GT?: number | null;
  rules_GTE?: number | null;
  rules_LONGEST_EQUAL?: number | null;
  rules_LONGEST_GT?: number | null;
  rules_LONGEST_GTE?: number | null;
  rules_LONGEST_LT?: number | null;
  rules_LONGEST_LTE?: number | null;
  rules_LT?: number | null;
  rules_LTE?: number | null;
  rules_SHORTEST_EQUAL?: number | null;
  rules_SHORTEST_GT?: number | null;
  rules_SHORTEST_GTE?: number | null;
  rules_SHORTEST_LT?: number | null;
  rules_SHORTEST_LTE?: number | null;
  shortLabelLocalizationKey_AVERAGE_EQUAL?: number | null;
  shortLabelLocalizationKey_AVERAGE_GT?: number | null;
  shortLabelLocalizationKey_AVERAGE_GTE?: number | null;
  shortLabelLocalizationKey_AVERAGE_LT?: number | null;
  shortLabelLocalizationKey_AVERAGE_LTE?: number | null;
  shortLabelLocalizationKey_EQUAL?: string | null;
  shortLabelLocalizationKey_GT?: number | null;
  shortLabelLocalizationKey_GTE?: number | null;
  shortLabelLocalizationKey_LONGEST_EQUAL?: number | null;
  shortLabelLocalizationKey_LONGEST_GT?: number | null;
  shortLabelLocalizationKey_LONGEST_GTE?: number | null;
  shortLabelLocalizationKey_LONGEST_LT?: number | null;
  shortLabelLocalizationKey_LONGEST_LTE?: number | null;
  shortLabelLocalizationKey_LT?: number | null;
  shortLabelLocalizationKey_LTE?: number | null;
  shortLabelLocalizationKey_SHORTEST_EQUAL?: number | null;
  shortLabelLocalizationKey_SHORTEST_GT?: number | null;
  shortLabelLocalizationKey_SHORTEST_GTE?: number | null;
  shortLabelLocalizationKey_SHORTEST_LT?: number | null;
  shortLabelLocalizationKey_SHORTEST_LTE?: number | null;
  values_AVERAGE_EQUAL?: number | null;
  values_AVERAGE_GT?: number | null;
  values_AVERAGE_GTE?: number | null;
  values_AVERAGE_LT?: number | null;
  values_AVERAGE_LTE?: number | null;
  values_EQUAL?: string | null;
  values_GT?: number | null;
  values_GTE?: number | null;
  values_LONGEST_EQUAL?: number | null;
  values_LONGEST_GT?: number | null;
  values_LONGEST_GTE?: number | null;
  values_LONGEST_LT?: number | null;
  values_LONGEST_LTE?: number | null;
  values_LT?: number | null;
  values_LTE?: number | null;
  values_SHORTEST_EQUAL?: number | null;
  values_SHORTEST_GT?: number | null;
  values_SHORTEST_GTE?: number | null;
  values_SHORTEST_LT?: number | null;
  values_SHORTEST_LTE?: number | null;
}

export interface CatalogueAttributeMutuallyRelevantAggregateInput {
  AND?: CatalogueAttributeMutuallyRelevantAggregateInput[] | null;
  OR?: CatalogueAttributeMutuallyRelevantAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  edge?: CatalogueAttributeMutuallyRelevantEdgeAggregationWhereInput | null;
  node?: CatalogueAttributeMutuallyRelevantNodeAggregationWhereInput | null;
}

export interface CatalogueAttributeMutuallyRelevantConnectionWhere {
  AND?: CatalogueAttributeMutuallyRelevantConnectionWhere[] | null;
  OR?: CatalogueAttributeMutuallyRelevantConnectionWhere[] | null;
  edge?: DependencyAttributeWhere | null;
  edge_NOT?: DependencyAttributeWhere | null;
  node?: CatalogueAttributeWhere | null;
  node_NOT?: CatalogueAttributeWhere | null;
}

export interface CatalogueAttributeMutuallyRelevantEdgeAggregationWhereInput {
  AND?: CatalogueAttributeMutuallyRelevantEdgeAggregationWhereInput[] | null;
  OR?: CatalogueAttributeMutuallyRelevantEdgeAggregationWhereInput[] | null;
  comment_AVERAGE_EQUAL?: number | null;
  comment_AVERAGE_GT?: number | null;
  comment_AVERAGE_GTE?: number | null;
  comment_AVERAGE_LT?: number | null;
  comment_AVERAGE_LTE?: number | null;
  comment_EQUAL?: string | null;
  comment_GT?: number | null;
  comment_GTE?: number | null;
  comment_LONGEST_EQUAL?: number | null;
  comment_LONGEST_GT?: number | null;
  comment_LONGEST_GTE?: number | null;
  comment_LONGEST_LT?: number | null;
  comment_LONGEST_LTE?: number | null;
  comment_LT?: number | null;
  comment_LTE?: number | null;
  comment_SHORTEST_EQUAL?: number | null;
  comment_SHORTEST_GT?: number | null;
  comment_SHORTEST_GTE?: number | null;
  comment_SHORTEST_LT?: number | null;
  comment_SHORTEST_LTE?: number | null;
  rules_AVERAGE_EQUAL?: number | null;
  rules_AVERAGE_GT?: number | null;
  rules_AVERAGE_GTE?: number | null;
  rules_AVERAGE_LT?: number | null;
  rules_AVERAGE_LTE?: number | null;
  rules_EQUAL?: string | null;
  rules_GT?: number | null;
  rules_GTE?: number | null;
  rules_LONGEST_EQUAL?: number | null;
  rules_LONGEST_GT?: number | null;
  rules_LONGEST_GTE?: number | null;
  rules_LONGEST_LT?: number | null;
  rules_LONGEST_LTE?: number | null;
  rules_LT?: number | null;
  rules_LTE?: number | null;
  rules_SHORTEST_EQUAL?: number | null;
  rules_SHORTEST_GT?: number | null;
  rules_SHORTEST_GTE?: number | null;
  rules_SHORTEST_LT?: number | null;
  rules_SHORTEST_LTE?: number | null;
}

export interface CatalogueAttributeMutuallyRelevantNodeAggregationWhereInput {
  AND?: CatalogueAttributeMutuallyRelevantNodeAggregationWhereInput[] | null;
  OR?: CatalogueAttributeMutuallyRelevantNodeAggregationWhereInput[] | null;
  caption_AVERAGE_EQUAL?: number | null;
  caption_AVERAGE_GT?: number | null;
  caption_AVERAGE_GTE?: number | null;
  caption_AVERAGE_LT?: number | null;
  caption_AVERAGE_LTE?: number | null;
  caption_EQUAL?: string | null;
  caption_GT?: number | null;
  caption_GTE?: number | null;
  caption_LONGEST_EQUAL?: number | null;
  caption_LONGEST_GT?: number | null;
  caption_LONGEST_GTE?: number | null;
  caption_LONGEST_LT?: number | null;
  caption_LONGEST_LTE?: number | null;
  caption_LT?: number | null;
  caption_LTE?: number | null;
  caption_SHORTEST_EQUAL?: number | null;
  caption_SHORTEST_GT?: number | null;
  caption_SHORTEST_GTE?: number | null;
  caption_SHORTEST_LT?: number | null;
  caption_SHORTEST_LTE?: number | null;
  decimalPrecision_AVERAGE_EQUAL?: number | null;
  decimalPrecision_AVERAGE_GT?: number | null;
  decimalPrecision_AVERAGE_GTE?: number | null;
  decimalPrecision_AVERAGE_LT?: number | null;
  decimalPrecision_AVERAGE_LTE?: number | null;
  decimalPrecision_EQUAL?: number | null;
  decimalPrecision_GT?: number | null;
  decimalPrecision_GTE?: number | null;
  decimalPrecision_LT?: number | null;
  decimalPrecision_LTE?: number | null;
  decimalPrecision_MAX_EQUAL?: number | null;
  decimalPrecision_MAX_GT?: number | null;
  decimalPrecision_MAX_GTE?: number | null;
  decimalPrecision_MAX_LT?: number | null;
  decimalPrecision_MAX_LTE?: number | null;
  decimalPrecision_MIN_EQUAL?: number | null;
  decimalPrecision_MIN_GT?: number | null;
  decimalPrecision_MIN_GTE?: number | null;
  decimalPrecision_MIN_LT?: number | null;
  decimalPrecision_MIN_LTE?: number | null;
  decimalPrecision_SUM_EQUAL?: number | null;
  decimalPrecision_SUM_GT?: number | null;
  decimalPrecision_SUM_GTE?: number | null;
  decimalPrecision_SUM_LT?: number | null;
  decimalPrecision_SUM_LTE?: number | null;
  defaultValue_AVERAGE_EQUAL?: number | null;
  defaultValue_AVERAGE_GT?: number | null;
  defaultValue_AVERAGE_GTE?: number | null;
  defaultValue_AVERAGE_LT?: number | null;
  defaultValue_AVERAGE_LTE?: number | null;
  defaultValue_EQUAL?: string | null;
  defaultValue_GT?: number | null;
  defaultValue_GTE?: number | null;
  defaultValue_LONGEST_EQUAL?: number | null;
  defaultValue_LONGEST_GT?: number | null;
  defaultValue_LONGEST_GTE?: number | null;
  defaultValue_LONGEST_LT?: number | null;
  defaultValue_LONGEST_LTE?: number | null;
  defaultValue_LT?: number | null;
  defaultValue_LTE?: number | null;
  defaultValue_SHORTEST_EQUAL?: number | null;
  defaultValue_SHORTEST_GT?: number | null;
  defaultValue_SHORTEST_GTE?: number | null;
  defaultValue_SHORTEST_LT?: number | null;
  defaultValue_SHORTEST_LTE?: number | null;
  id_AVERAGE_EQUAL?: number | null;
  id_AVERAGE_GT?: number | null;
  id_AVERAGE_GTE?: number | null;
  id_AVERAGE_LT?: number | null;
  id_AVERAGE_LTE?: number | null;
  id_EQUAL?: string | null;
  id_GT?: number | null;
  id_GTE?: number | null;
  id_LONGEST_EQUAL?: number | null;
  id_LONGEST_GT?: number | null;
  id_LONGEST_GTE?: number | null;
  id_LONGEST_LT?: number | null;
  id_LONGEST_LTE?: number | null;
  id_LT?: number | null;
  id_LTE?: number | null;
  id_SHORTEST_EQUAL?: number | null;
  id_SHORTEST_GT?: number | null;
  id_SHORTEST_GTE?: number | null;
  id_SHORTEST_LT?: number | null;
  id_SHORTEST_LTE?: number | null;
  identifier_AVERAGE_EQUAL?: number | null;
  identifier_AVERAGE_GT?: number | null;
  identifier_AVERAGE_GTE?: number | null;
  identifier_AVERAGE_LT?: number | null;
  identifier_AVERAGE_LTE?: number | null;
  identifier_EQUAL?: string | null;
  identifier_GT?: number | null;
  identifier_GTE?: number | null;
  identifier_LONGEST_EQUAL?: number | null;
  identifier_LONGEST_GT?: number | null;
  identifier_LONGEST_GTE?: number | null;
  identifier_LONGEST_LT?: number | null;
  identifier_LONGEST_LTE?: number | null;
  identifier_LT?: number | null;
  identifier_LTE?: number | null;
  identifier_SHORTEST_EQUAL?: number | null;
  identifier_SHORTEST_GT?: number | null;
  identifier_SHORTEST_GTE?: number | null;
  identifier_SHORTEST_LT?: number | null;
  identifier_SHORTEST_LTE?: number | null;
  longLabelLocalizationKey_AVERAGE_EQUAL?: number | null;
  longLabelLocalizationKey_AVERAGE_GT?: number | null;
  longLabelLocalizationKey_AVERAGE_GTE?: number | null;
  longLabelLocalizationKey_AVERAGE_LT?: number | null;
  longLabelLocalizationKey_AVERAGE_LTE?: number | null;
  longLabelLocalizationKey_EQUAL?: string | null;
  longLabelLocalizationKey_GT?: number | null;
  longLabelLocalizationKey_GTE?: number | null;
  longLabelLocalizationKey_LONGEST_EQUAL?: number | null;
  longLabelLocalizationKey_LONGEST_GT?: number | null;
  longLabelLocalizationKey_LONGEST_GTE?: number | null;
  longLabelLocalizationKey_LONGEST_LT?: number | null;
  longLabelLocalizationKey_LONGEST_LTE?: number | null;
  longLabelLocalizationKey_LT?: number | null;
  longLabelLocalizationKey_LTE?: number | null;
  longLabelLocalizationKey_SHORTEST_EQUAL?: number | null;
  longLabelLocalizationKey_SHORTEST_GT?: number | null;
  longLabelLocalizationKey_SHORTEST_GTE?: number | null;
  longLabelLocalizationKey_SHORTEST_LT?: number | null;
  longLabelLocalizationKey_SHORTEST_LTE?: number | null;
  maxLength_AVERAGE_EQUAL?: number | null;
  maxLength_AVERAGE_GT?: number | null;
  maxLength_AVERAGE_GTE?: number | null;
  maxLength_AVERAGE_LT?: number | null;
  maxLength_AVERAGE_LTE?: number | null;
  maxLength_EQUAL?: number | null;
  maxLength_GT?: number | null;
  maxLength_GTE?: number | null;
  maxLength_LT?: number | null;
  maxLength_LTE?: number | null;
  maxLength_MAX_EQUAL?: number | null;
  maxLength_MAX_GT?: number | null;
  maxLength_MAX_GTE?: number | null;
  maxLength_MAX_LT?: number | null;
  maxLength_MAX_LTE?: number | null;
  maxLength_MIN_EQUAL?: number | null;
  maxLength_MIN_GT?: number | null;
  maxLength_MIN_GTE?: number | null;
  maxLength_MIN_LT?: number | null;
  maxLength_MIN_LTE?: number | null;
  maxLength_SUM_EQUAL?: number | null;
  maxLength_SUM_GT?: number | null;
  maxLength_SUM_GTE?: number | null;
  maxLength_SUM_LT?: number | null;
  maxLength_SUM_LTE?: number | null;
  minLength_AVERAGE_EQUAL?: number | null;
  minLength_AVERAGE_GT?: number | null;
  minLength_AVERAGE_GTE?: number | null;
  minLength_AVERAGE_LT?: number | null;
  minLength_AVERAGE_LTE?: number | null;
  minLength_EQUAL?: number | null;
  minLength_GT?: number | null;
  minLength_GTE?: number | null;
  minLength_LT?: number | null;
  minLength_LTE?: number | null;
  minLength_MAX_EQUAL?: number | null;
  minLength_MAX_GT?: number | null;
  minLength_MAX_GTE?: number | null;
  minLength_MAX_LT?: number | null;
  minLength_MAX_LTE?: number | null;
  minLength_MIN_EQUAL?: number | null;
  minLength_MIN_GT?: number | null;
  minLength_MIN_GTE?: number | null;
  minLength_MIN_LT?: number | null;
  minLength_MIN_LTE?: number | null;
  minLength_SUM_EQUAL?: number | null;
  minLength_SUM_GT?: number | null;
  minLength_SUM_GTE?: number | null;
  minLength_SUM_LT?: number | null;
  minLength_SUM_LTE?: number | null;
  rules_AVERAGE_EQUAL?: number | null;
  rules_AVERAGE_GT?: number | null;
  rules_AVERAGE_GTE?: number | null;
  rules_AVERAGE_LT?: number | null;
  rules_AVERAGE_LTE?: number | null;
  rules_EQUAL?: string | null;
  rules_GT?: number | null;
  rules_GTE?: number | null;
  rules_LONGEST_EQUAL?: number | null;
  rules_LONGEST_GT?: number | null;
  rules_LONGEST_GTE?: number | null;
  rules_LONGEST_LT?: number | null;
  rules_LONGEST_LTE?: number | null;
  rules_LT?: number | null;
  rules_LTE?: number | null;
  rules_SHORTEST_EQUAL?: number | null;
  rules_SHORTEST_GT?: number | null;
  rules_SHORTEST_GTE?: number | null;
  rules_SHORTEST_LT?: number | null;
  rules_SHORTEST_LTE?: number | null;
  shortLabelLocalizationKey_AVERAGE_EQUAL?: number | null;
  shortLabelLocalizationKey_AVERAGE_GT?: number | null;
  shortLabelLocalizationKey_AVERAGE_GTE?: number | null;
  shortLabelLocalizationKey_AVERAGE_LT?: number | null;
  shortLabelLocalizationKey_AVERAGE_LTE?: number | null;
  shortLabelLocalizationKey_EQUAL?: string | null;
  shortLabelLocalizationKey_GT?: number | null;
  shortLabelLocalizationKey_GTE?: number | null;
  shortLabelLocalizationKey_LONGEST_EQUAL?: number | null;
  shortLabelLocalizationKey_LONGEST_GT?: number | null;
  shortLabelLocalizationKey_LONGEST_GTE?: number | null;
  shortLabelLocalizationKey_LONGEST_LT?: number | null;
  shortLabelLocalizationKey_LONGEST_LTE?: number | null;
  shortLabelLocalizationKey_LT?: number | null;
  shortLabelLocalizationKey_LTE?: number | null;
  shortLabelLocalizationKey_SHORTEST_EQUAL?: number | null;
  shortLabelLocalizationKey_SHORTEST_GT?: number | null;
  shortLabelLocalizationKey_SHORTEST_GTE?: number | null;
  shortLabelLocalizationKey_SHORTEST_LT?: number | null;
  shortLabelLocalizationKey_SHORTEST_LTE?: number | null;
  values_AVERAGE_EQUAL?: number | null;
  values_AVERAGE_GT?: number | null;
  values_AVERAGE_GTE?: number | null;
  values_AVERAGE_LT?: number | null;
  values_AVERAGE_LTE?: number | null;
  values_EQUAL?: string | null;
  values_GT?: number | null;
  values_GTE?: number | null;
  values_LONGEST_EQUAL?: number | null;
  values_LONGEST_GT?: number | null;
  values_LONGEST_GTE?: number | null;
  values_LONGEST_LT?: number | null;
  values_LONGEST_LTE?: number | null;
  values_LT?: number | null;
  values_LTE?: number | null;
  values_SHORTEST_EQUAL?: number | null;
  values_SHORTEST_GT?: number | null;
  values_SHORTEST_GTE?: number | null;
  values_SHORTEST_LT?: number | null;
  values_SHORTEST_LTE?: number | null;
}

export interface CatalogueAttributeWhere {
  AND?: CatalogueAttributeWhere[] | null;
  OR?: CatalogueAttributeWhere[] | null;
  arrayPossible?: boolean | null;
  arrayPossible_NOT?: boolean | null;
  attributeClasses?: (string | null)[] | null;
  attributeClasses_INCLUDES?: string | null;
  attributeClasses_NOT?: (string | null)[] | null;
  attributeClasses_NOT_INCLUDES?: string | null;
  caption?: string | null;
  caption_CONTAINS?: string | null;
  caption_ENDS_WITH?: string | null;
  caption_IN?: (string | null)[] | null;
  caption_MATCHES?: string | null;
  caption_NOT?: string | null;
  caption_NOT_CONTAINS?: string | null;
  caption_NOT_ENDS_WITH?: string | null;
  caption_NOT_IN?: (string | null)[] | null;
  caption_NOT_STARTS_WITH?: string | null;
  caption_STARTS_WITH?: string | null;
  customCondition?: CustomEnrollingConditionWhere | null;
  customConditionAggregate?: CatalogueAttributeCustomConditionAggregateInput | null;
  customConditionConnection?: CatalogueAttributeCustomConditionConnectionWhere | null;
  customConditionConnection_NOT?: CatalogueAttributeCustomConditionConnectionWhere | null;
  customCondition_NOT?: CustomEnrollingConditionWhere | null;
  dataSubType?: DataSubType | null;
  dataSubType_IN?: (DataSubType | null)[] | null;
  dataSubType_NOT?: DataSubType | null;
  dataSubType_NOT_IN?: (DataSubType | null)[] | null;
  dataType?: DataType | null;
  dataType_IN?: (DataType | null)[] | null;
  dataType_NOT?: DataType | null;
  dataType_NOT_IN?: (DataType | null)[] | null;
  decimalPrecision?: number | null;
  decimalPrecision_GT?: number | null;
  decimalPrecision_GTE?: number | null;
  decimalPrecision_IN?: (number | null)[] | null;
  decimalPrecision_LT?: number | null;
  decimalPrecision_LTE?: number | null;
  decimalPrecision_NOT?: number | null;
  decimalPrecision_NOT_IN?: (number | null)[] | null;
  defaultValue?: string | null;
  defaultValue_CONTAINS?: string | null;
  defaultValue_ENDS_WITH?: string | null;
  defaultValue_IN?: (string | null)[] | null;
  defaultValue_MATCHES?: string | null;
  defaultValue_NOT?: string | null;
  defaultValue_NOT_CONTAINS?: string | null;
  defaultValue_NOT_ENDS_WITH?: string | null;
  defaultValue_NOT_IN?: (string | null)[] | null;
  defaultValue_NOT_STARTS_WITH?: string | null;
  defaultValue_STARTS_WITH?: string | null;
  dependsOn?: CatalogueAttributeWhere | null;
  dependsOnAggregate?: CatalogueAttributeDependsOnAggregateInput | null;
  dependsOnConnection?: CatalogueAttributeDependsOnConnectionWhere | null;
  dependsOnConnection_NOT?: CatalogueAttributeDependsOnConnectionWhere | null;
  dependsOn_NOT?: CatalogueAttributeWhere | null;
  expectedWidth?: AttributeSize | null;
  expectedWidth_IN?: (AttributeSize | null)[] | null;
  expectedWidth_NOT?: AttributeSize | null;
  expectedWidth_NOT_IN?: (AttributeSize | null)[] | null;
  flexEntityTypes?: FlexEntityTypeWhere | null;
  flexEntityTypesAggregate?: CatalogueAttributeFlexEntityTypesAggregateInput | null;
  flexEntityTypesConnection?: CatalogueAttributeFlexEntityTypesConnectionWhere | null;
  flexEntityTypesConnection_NOT?: CatalogueAttributeFlexEntityTypesConnectionWhere | null;
  flexEntityTypes_NOT?: FlexEntityTypeWhere | null;
  hasDependant?: CatalogueAttributeWhere | null;
  hasDependantAggregate?: CatalogueAttributeHasDependantAggregateInput | null;
  hasDependantConnection?: CatalogueAttributeHasDependantConnectionWhere | null;
  hasDependantConnection_NOT?: CatalogueAttributeHasDependantConnectionWhere | null;
  hasDependant_NOT?: CatalogueAttributeWhere | null;
  id?: string | null;
  id_CONTAINS?: string | null;
  id_ENDS_WITH?: string | null;
  id_IN?: (string | null)[] | null;
  id_MATCHES?: string | null;
  id_NOT?: string | null;
  id_NOT_CONTAINS?: string | null;
  id_NOT_ENDS_WITH?: string | null;
  id_NOT_IN?: (string | null)[] | null;
  id_NOT_STARTS_WITH?: string | null;
  id_STARTS_WITH?: string | null;
  identifier?: string | null;
  identifier_CONTAINS?: string | null;
  identifier_ENDS_WITH?: string | null;
  identifier_IN?: (string | null)[] | null;
  identifier_MATCHES?: string | null;
  identifier_NOT?: string | null;
  identifier_NOT_CONTAINS?: string | null;
  identifier_NOT_ENDS_WITH?: string | null;
  identifier_NOT_IN?: (string | null)[] | null;
  identifier_NOT_STARTS_WITH?: string | null;
  identifier_STARTS_WITH?: string | null;
  isNegotiable?: boolean | null;
  isNegotiable_NOT?: boolean | null;
  longLabelLocalizationKey?: string | null;
  longLabelLocalizationKey_CONTAINS?: string | null;
  longLabelLocalizationKey_ENDS_WITH?: string | null;
  longLabelLocalizationKey_IN?: (string | null)[] | null;
  longLabelLocalizationKey_MATCHES?: string | null;
  longLabelLocalizationKey_NOT?: string | null;
  longLabelLocalizationKey_NOT_CONTAINS?: string | null;
  longLabelLocalizationKey_NOT_ENDS_WITH?: string | null;
  longLabelLocalizationKey_NOT_IN?: (string | null)[] | null;
  longLabelLocalizationKey_NOT_STARTS_WITH?: string | null;
  longLabelLocalizationKey_STARTS_WITH?: string | null;
  maxLength?: number | null;
  maxLength_GT?: number | null;
  maxLength_GTE?: number | null;
  maxLength_IN?: (number | null)[] | null;
  maxLength_LT?: number | null;
  maxLength_LTE?: number | null;
  maxLength_NOT?: number | null;
  maxLength_NOT_IN?: (number | null)[] | null;
  minLength?: number | null;
  minLength_GT?: number | null;
  minLength_GTE?: number | null;
  minLength_IN?: (number | null)[] | null;
  minLength_LT?: number | null;
  minLength_LTE?: number | null;
  minLength_NOT?: number | null;
  minLength_NOT_IN?: (number | null)[] | null;
  mutuallyRelevant?: CatalogueAttributeWhere | null;
  mutuallyRelevantAggregate?: CatalogueAttributeMutuallyRelevantAggregateInput | null;
  mutuallyRelevantConnection?: CatalogueAttributeMutuallyRelevantConnectionWhere | null;
  mutuallyRelevantConnection_NOT?: CatalogueAttributeMutuallyRelevantConnectionWhere | null;
  mutuallyRelevant_NOT?: CatalogueAttributeWhere | null;
  rules?: string | null;
  rules_CONTAINS?: string | null;
  rules_ENDS_WITH?: string | null;
  rules_IN?: (string | null)[] | null;
  rules_MATCHES?: string | null;
  rules_NOT?: string | null;
  rules_NOT_CONTAINS?: string | null;
  rules_NOT_ENDS_WITH?: string | null;
  rules_NOT_IN?: (string | null)[] | null;
  rules_NOT_STARTS_WITH?: string | null;
  rules_STARTS_WITH?: string | null;
  shortLabelLocalizationKey?: string | null;
  shortLabelLocalizationKey_CONTAINS?: string | null;
  shortLabelLocalizationKey_ENDS_WITH?: string | null;
  shortLabelLocalizationKey_IN?: (string | null)[] | null;
  shortLabelLocalizationKey_MATCHES?: string | null;
  shortLabelLocalizationKey_NOT?: string | null;
  shortLabelLocalizationKey_NOT_CONTAINS?: string | null;
  shortLabelLocalizationKey_NOT_ENDS_WITH?: string | null;
  shortLabelLocalizationKey_NOT_IN?: (string | null)[] | null;
  shortLabelLocalizationKey_NOT_STARTS_WITH?: string | null;
  shortLabelLocalizationKey_STARTS_WITH?: string | null;
  type?: CatalogueAttributeType | null;
  type_IN?: (CatalogueAttributeType | null)[] | null;
  type_NOT?: CatalogueAttributeType | null;
  type_NOT_IN?: (CatalogueAttributeType | null)[] | null;
  validation?: StatusHistorical | null;
  validation_IN?: (StatusHistorical | null)[] | null;
  validation_NOT?: StatusHistorical | null;
  validation_NOT_IN?: (StatusHistorical | null)[] | null;
  values?: string | null;
  values_CONTAINS?: string | null;
  values_ENDS_WITH?: string | null;
  values_IN?: (string | null)[] | null;
  values_MATCHES?: string | null;
  values_NOT?: string | null;
  values_NOT_CONTAINS?: string | null;
  values_NOT_ENDS_WITH?: string | null;
  values_NOT_IN?: (string | null)[] | null;
  values_NOT_STARTS_WITH?: string | null;
  values_STARTS_WITH?: string | null;
}

export interface ChartRangeConfigurationRelationshipWhere {
  AND?: ChartRangeConfigurationRelationshipWhere[] | null;
  OR?: ChartRangeConfigurationRelationshipWhere[] | null;
  from?: number | null;
  from_GT?: number | null;
  from_GTE?: number | null;
  from_IN?: (number | null)[] | null;
  from_LT?: number | null;
  from_LTE?: number | null;
  from_NOT?: number | null;
  from_NOT_IN?: (number | null)[] | null;
  name?: string | null;
  name_CONTAINS?: string | null;
  name_ENDS_WITH?: string | null;
  name_IN?: (string | null)[] | null;
  name_MATCHES?: string | null;
  name_NOT?: string | null;
  name_NOT_CONTAINS?: string | null;
  name_NOT_ENDS_WITH?: string | null;
  name_NOT_IN?: (string | null)[] | null;
  name_NOT_STARTS_WITH?: string | null;
  name_STARTS_WITH?: string | null;
  order?: number | null;
  order_GT?: number | null;
  order_GTE?: number | null;
  order_IN?: (number | null)[] | null;
  order_LT?: number | null;
  order_LTE?: number | null;
  order_NOT?: number | null;
  order_NOT_IN?: (number | null)[] | null;
  to?: number | null;
  to_GT?: number | null;
  to_GTE?: number | null;
  to_IN?: (number | null)[] | null;
  to_LT?: number | null;
  to_LTE?: number | null;
  to_NOT?: number | null;
  to_NOT_IN?: (number | null)[] | null;
}

export interface ChartRangeConfigurationWhere {
  AND?: ChartRangeConfigurationWhere[] | null;
  OR?: ChartRangeConfigurationWhere[] | null;
  chartType?: ConfigurableChartType | null;
  chartType_IN?: (ConfigurableChartType | null)[] | null;
  chartType_NOT?: ConfigurableChartType | null;
  chartType_NOT_IN?: (ConfigurableChartType | null)[] | null;
}

export interface ContractWorkflowOrganizationAggregateInput {
  AND?: ContractWorkflowOrganizationAggregateInput[] | null;
  OR?: ContractWorkflowOrganizationAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: ContractWorkflowOrganizationNodeAggregationWhereInput | null;
}

export interface ContractWorkflowOrganizationConnectionWhere {
  AND?: ContractWorkflowOrganizationConnectionWhere[] | null;
  OR?: ContractWorkflowOrganizationConnectionWhere[] | null;
  node?: OrganizationWhere | null;
  node_NOT?: OrganizationWhere | null;
}

export interface ContractWorkflowOrganizationNodeAggregationWhereInput {
  AND?: ContractWorkflowOrganizationNodeAggregationWhereInput[] | null;
  BIC_AVERAGE_EQUAL?: number | null;
  BIC_AVERAGE_GT?: number | null;
  BIC_AVERAGE_GTE?: number | null;
  BIC_AVERAGE_LT?: number | null;
  BIC_AVERAGE_LTE?: number | null;
  BIC_EQUAL?: string | null;
  BIC_GT?: number | null;
  BIC_GTE?: number | null;
  BIC_LONGEST_EQUAL?: number | null;
  BIC_LONGEST_GT?: number | null;
  BIC_LONGEST_GTE?: number | null;
  BIC_LONGEST_LT?: number | null;
  BIC_LONGEST_LTE?: number | null;
  BIC_LT?: number | null;
  BIC_LTE?: number | null;
  BIC_SHORTEST_EQUAL?: number | null;
  BIC_SHORTEST_GT?: number | null;
  BIC_SHORTEST_GTE?: number | null;
  BIC_SHORTEST_LT?: number | null;
  BIC_SHORTEST_LTE?: number | null;
  IBAN_AVERAGE_EQUAL?: number | null;
  IBAN_AVERAGE_GT?: number | null;
  IBAN_AVERAGE_GTE?: number | null;
  IBAN_AVERAGE_LT?: number | null;
  IBAN_AVERAGE_LTE?: number | null;
  IBAN_EQUAL?: string | null;
  IBAN_GT?: number | null;
  IBAN_GTE?: number | null;
  IBAN_LONGEST_EQUAL?: number | null;
  IBAN_LONGEST_GT?: number | null;
  IBAN_LONGEST_GTE?: number | null;
  IBAN_LONGEST_LT?: number | null;
  IBAN_LONGEST_LTE?: number | null;
  IBAN_LT?: number | null;
  IBAN_LTE?: number | null;
  IBAN_SHORTEST_EQUAL?: number | null;
  IBAN_SHORTEST_GT?: number | null;
  IBAN_SHORTEST_GTE?: number | null;
  IBAN_SHORTEST_LT?: number | null;
  IBAN_SHORTEST_LTE?: number | null;
  OR?: ContractWorkflowOrganizationNodeAggregationWhereInput[] | null;
  accountName_AVERAGE_EQUAL?: number | null;
  accountName_AVERAGE_GT?: number | null;
  accountName_AVERAGE_GTE?: number | null;
  accountName_AVERAGE_LT?: number | null;
  accountName_AVERAGE_LTE?: number | null;
  accountName_EQUAL?: string | null;
  accountName_GT?: number | null;
  accountName_GTE?: number | null;
  accountName_LONGEST_EQUAL?: number | null;
  accountName_LONGEST_GT?: number | null;
  accountName_LONGEST_GTE?: number | null;
  accountName_LONGEST_LT?: number | null;
  accountName_LONGEST_LTE?: number | null;
  accountName_LT?: number | null;
  accountName_LTE?: number | null;
  accountName_SHORTEST_EQUAL?: number | null;
  accountName_SHORTEST_GT?: number | null;
  accountName_SHORTEST_GTE?: number | null;
  accountName_SHORTEST_LT?: number | null;
  accountName_SHORTEST_LTE?: number | null;
  accountNumber_AVERAGE_EQUAL?: number | null;
  accountNumber_AVERAGE_GT?: number | null;
  accountNumber_AVERAGE_GTE?: number | null;
  accountNumber_AVERAGE_LT?: number | null;
  accountNumber_AVERAGE_LTE?: number | null;
  accountNumber_EQUAL?: string | null;
  accountNumber_GT?: number | null;
  accountNumber_GTE?: number | null;
  accountNumber_LONGEST_EQUAL?: number | null;
  accountNumber_LONGEST_GT?: number | null;
  accountNumber_LONGEST_GTE?: number | null;
  accountNumber_LONGEST_LT?: number | null;
  accountNumber_LONGEST_LTE?: number | null;
  accountNumber_LT?: number | null;
  accountNumber_LTE?: number | null;
  accountNumber_SHORTEST_EQUAL?: number | null;
  accountNumber_SHORTEST_GT?: number | null;
  accountNumber_SHORTEST_GTE?: number | null;
  accountNumber_SHORTEST_LT?: number | null;
  accountNumber_SHORTEST_LTE?: number | null;
  billingAddress_AVERAGE_EQUAL?: number | null;
  billingAddress_AVERAGE_GT?: number | null;
  billingAddress_AVERAGE_GTE?: number | null;
  billingAddress_AVERAGE_LT?: number | null;
  billingAddress_AVERAGE_LTE?: number | null;
  billingAddress_EQUAL?: string | null;
  billingAddress_GT?: number | null;
  billingAddress_GTE?: number | null;
  billingAddress_LONGEST_EQUAL?: number | null;
  billingAddress_LONGEST_GT?: number | null;
  billingAddress_LONGEST_GTE?: number | null;
  billingAddress_LONGEST_LT?: number | null;
  billingAddress_LONGEST_LTE?: number | null;
  billingAddress_LT?: number | null;
  billingAddress_LTE?: number | null;
  billingAddress_SHORTEST_EQUAL?: number | null;
  billingAddress_SHORTEST_GT?: number | null;
  billingAddress_SHORTEST_GTE?: number | null;
  billingAddress_SHORTEST_LT?: number | null;
  billingAddress_SHORTEST_LTE?: number | null;
  contactEmail_AVERAGE_EQUAL?: number | null;
  contactEmail_AVERAGE_GT?: number | null;
  contactEmail_AVERAGE_GTE?: number | null;
  contactEmail_AVERAGE_LT?: number | null;
  contactEmail_AVERAGE_LTE?: number | null;
  contactEmail_EQUAL?: string | null;
  contactEmail_GT?: number | null;
  contactEmail_GTE?: number | null;
  contactEmail_LONGEST_EQUAL?: number | null;
  contactEmail_LONGEST_GT?: number | null;
  contactEmail_LONGEST_GTE?: number | null;
  contactEmail_LONGEST_LT?: number | null;
  contactEmail_LONGEST_LTE?: number | null;
  contactEmail_LT?: number | null;
  contactEmail_LTE?: number | null;
  contactEmail_SHORTEST_EQUAL?: number | null;
  contactEmail_SHORTEST_GT?: number | null;
  contactEmail_SHORTEST_GTE?: number | null;
  contactEmail_SHORTEST_LT?: number | null;
  contactEmail_SHORTEST_LTE?: number | null;
  contactFirstName_AVERAGE_EQUAL?: number | null;
  contactFirstName_AVERAGE_GT?: number | null;
  contactFirstName_AVERAGE_GTE?: number | null;
  contactFirstName_AVERAGE_LT?: number | null;
  contactFirstName_AVERAGE_LTE?: number | null;
  contactFirstName_EQUAL?: string | null;
  contactFirstName_GT?: number | null;
  contactFirstName_GTE?: number | null;
  contactFirstName_LONGEST_EQUAL?: number | null;
  contactFirstName_LONGEST_GT?: number | null;
  contactFirstName_LONGEST_GTE?: number | null;
  contactFirstName_LONGEST_LT?: number | null;
  contactFirstName_LONGEST_LTE?: number | null;
  contactFirstName_LT?: number | null;
  contactFirstName_LTE?: number | null;
  contactFirstName_SHORTEST_EQUAL?: number | null;
  contactFirstName_SHORTEST_GT?: number | null;
  contactFirstName_SHORTEST_GTE?: number | null;
  contactFirstName_SHORTEST_LT?: number | null;
  contactFirstName_SHORTEST_LTE?: number | null;
  contactLastName_AVERAGE_EQUAL?: number | null;
  contactLastName_AVERAGE_GT?: number | null;
  contactLastName_AVERAGE_GTE?: number | null;
  contactLastName_AVERAGE_LT?: number | null;
  contactLastName_AVERAGE_LTE?: number | null;
  contactLastName_EQUAL?: string | null;
  contactLastName_GT?: number | null;
  contactLastName_GTE?: number | null;
  contactLastName_LONGEST_EQUAL?: number | null;
  contactLastName_LONGEST_GT?: number | null;
  contactLastName_LONGEST_GTE?: number | null;
  contactLastName_LONGEST_LT?: number | null;
  contactLastName_LONGEST_LTE?: number | null;
  contactLastName_LT?: number | null;
  contactLastName_LTE?: number | null;
  contactLastName_SHORTEST_EQUAL?: number | null;
  contactLastName_SHORTEST_GT?: number | null;
  contactLastName_SHORTEST_GTE?: number | null;
  contactLastName_SHORTEST_LT?: number | null;
  contactLastName_SHORTEST_LTE?: number | null;
  contactOccupation_AVERAGE_EQUAL?: number | null;
  contactOccupation_AVERAGE_GT?: number | null;
  contactOccupation_AVERAGE_GTE?: number | null;
  contactOccupation_AVERAGE_LT?: number | null;
  contactOccupation_AVERAGE_LTE?: number | null;
  contactOccupation_EQUAL?: string | null;
  contactOccupation_GT?: number | null;
  contactOccupation_GTE?: number | null;
  contactOccupation_LONGEST_EQUAL?: number | null;
  contactOccupation_LONGEST_GT?: number | null;
  contactOccupation_LONGEST_GTE?: number | null;
  contactOccupation_LONGEST_LT?: number | null;
  contactOccupation_LONGEST_LTE?: number | null;
  contactOccupation_LT?: number | null;
  contactOccupation_LTE?: number | null;
  contactOccupation_SHORTEST_EQUAL?: number | null;
  contactOccupation_SHORTEST_GT?: number | null;
  contactOccupation_SHORTEST_GTE?: number | null;
  contactOccupation_SHORTEST_LT?: number | null;
  contactOccupation_SHORTEST_LTE?: number | null;
  contactPhone_AVERAGE_EQUAL?: number | null;
  contactPhone_AVERAGE_GT?: number | null;
  contactPhone_AVERAGE_GTE?: number | null;
  contactPhone_AVERAGE_LT?: number | null;
  contactPhone_AVERAGE_LTE?: number | null;
  contactPhone_EQUAL?: string | null;
  contactPhone_GT?: number | null;
  contactPhone_GTE?: number | null;
  contactPhone_LONGEST_EQUAL?: number | null;
  contactPhone_LONGEST_GT?: number | null;
  contactPhone_LONGEST_GTE?: number | null;
  contactPhone_LONGEST_LT?: number | null;
  contactPhone_LONGEST_LTE?: number | null;
  contactPhone_LT?: number | null;
  contactPhone_LTE?: number | null;
  contactPhone_SHORTEST_EQUAL?: number | null;
  contactPhone_SHORTEST_GT?: number | null;
  contactPhone_SHORTEST_GTE?: number | null;
  contactPhone_SHORTEST_LT?: number | null;
  contactPhone_SHORTEST_LTE?: number | null;
  createdOn_AVERAGE_EQUAL?: number | null;
  createdOn_AVERAGE_GT?: number | null;
  createdOn_AVERAGE_GTE?: number | null;
  createdOn_AVERAGE_LT?: number | null;
  createdOn_AVERAGE_LTE?: number | null;
  createdOn_EQUAL?: number | null;
  createdOn_GT?: number | null;
  createdOn_GTE?: number | null;
  createdOn_LT?: number | null;
  createdOn_LTE?: number | null;
  createdOn_MAX_EQUAL?: number | null;
  createdOn_MAX_GT?: number | null;
  createdOn_MAX_GTE?: number | null;
  createdOn_MAX_LT?: number | null;
  createdOn_MAX_LTE?: number | null;
  createdOn_MIN_EQUAL?: number | null;
  createdOn_MIN_GT?: number | null;
  createdOn_MIN_GTE?: number | null;
  createdOn_MIN_LT?: number | null;
  createdOn_MIN_LTE?: number | null;
  createdOn_SUM_EQUAL?: number | null;
  createdOn_SUM_GT?: number | null;
  createdOn_SUM_GTE?: number | null;
  createdOn_SUM_LT?: number | null;
  createdOn_SUM_LTE?: number | null;
  deliveryAddress_AVERAGE_EQUAL?: number | null;
  deliveryAddress_AVERAGE_GT?: number | null;
  deliveryAddress_AVERAGE_GTE?: number | null;
  deliveryAddress_AVERAGE_LT?: number | null;
  deliveryAddress_AVERAGE_LTE?: number | null;
  deliveryAddress_EQUAL?: string | null;
  deliveryAddress_GT?: number | null;
  deliveryAddress_GTE?: number | null;
  deliveryAddress_LONGEST_EQUAL?: number | null;
  deliveryAddress_LONGEST_GT?: number | null;
  deliveryAddress_LONGEST_GTE?: number | null;
  deliveryAddress_LONGEST_LT?: number | null;
  deliveryAddress_LONGEST_LTE?: number | null;
  deliveryAddress_LT?: number | null;
  deliveryAddress_LTE?: number | null;
  deliveryAddress_SHORTEST_EQUAL?: number | null;
  deliveryAddress_SHORTEST_GT?: number | null;
  deliveryAddress_SHORTEST_GTE?: number | null;
  deliveryAddress_SHORTEST_LT?: number | null;
  deliveryAddress_SHORTEST_LTE?: number | null;
  domicile_AVERAGE_EQUAL?: number | null;
  domicile_AVERAGE_GT?: number | null;
  domicile_AVERAGE_GTE?: number | null;
  domicile_AVERAGE_LT?: number | null;
  domicile_AVERAGE_LTE?: number | null;
  domicile_EQUAL?: string | null;
  domicile_GT?: number | null;
  domicile_GTE?: number | null;
  domicile_LONGEST_EQUAL?: number | null;
  domicile_LONGEST_GT?: number | null;
  domicile_LONGEST_GTE?: number | null;
  domicile_LONGEST_LT?: number | null;
  domicile_LONGEST_LTE?: number | null;
  domicile_LT?: number | null;
  domicile_LTE?: number | null;
  domicile_SHORTEST_EQUAL?: number | null;
  domicile_SHORTEST_GT?: number | null;
  domicile_SHORTEST_GTE?: number | null;
  domicile_SHORTEST_LT?: number | null;
  domicile_SHORTEST_LTE?: number | null;
  dualApprovalThreshold_AVERAGE_EQUAL?: number | null;
  dualApprovalThreshold_AVERAGE_GT?: number | null;
  dualApprovalThreshold_AVERAGE_GTE?: number | null;
  dualApprovalThreshold_AVERAGE_LT?: number | null;
  dualApprovalThreshold_AVERAGE_LTE?: number | null;
  dualApprovalThreshold_EQUAL?: number | null;
  dualApprovalThreshold_GT?: number | null;
  dualApprovalThreshold_GTE?: number | null;
  dualApprovalThreshold_LT?: number | null;
  dualApprovalThreshold_LTE?: number | null;
  dualApprovalThreshold_MAX_EQUAL?: number | null;
  dualApprovalThreshold_MAX_GT?: number | null;
  dualApprovalThreshold_MAX_GTE?: number | null;
  dualApprovalThreshold_MAX_LT?: number | null;
  dualApprovalThreshold_MAX_LTE?: number | null;
  dualApprovalThreshold_MIN_EQUAL?: number | null;
  dualApprovalThreshold_MIN_GT?: number | null;
  dualApprovalThreshold_MIN_GTE?: number | null;
  dualApprovalThreshold_MIN_LT?: number | null;
  dualApprovalThreshold_MIN_LTE?: number | null;
  dualApprovalThreshold_SUM_EQUAL?: number | null;
  dualApprovalThreshold_SUM_GT?: number | null;
  dualApprovalThreshold_SUM_GTE?: number | null;
  dualApprovalThreshold_SUM_LT?: number | null;
  dualApprovalThreshold_SUM_LTE?: number | null;
  eIN_AVERAGE_EQUAL?: number | null;
  eIN_AVERAGE_GT?: number | null;
  eIN_AVERAGE_GTE?: number | null;
  eIN_AVERAGE_LT?: number | null;
  eIN_AVERAGE_LTE?: number | null;
  eIN_EQUAL?: string | null;
  eIN_GT?: number | null;
  eIN_GTE?: number | null;
  eIN_LONGEST_EQUAL?: number | null;
  eIN_LONGEST_GT?: number | null;
  eIN_LONGEST_GTE?: number | null;
  eIN_LONGEST_LT?: number | null;
  eIN_LONGEST_LTE?: number | null;
  eIN_LT?: number | null;
  eIN_LTE?: number | null;
  eIN_SHORTEST_EQUAL?: number | null;
  eIN_SHORTEST_GT?: number | null;
  eIN_SHORTEST_GTE?: number | null;
  eIN_SHORTEST_LT?: number | null;
  eIN_SHORTEST_LTE?: number | null;
  fax_AVERAGE_EQUAL?: number | null;
  fax_AVERAGE_GT?: number | null;
  fax_AVERAGE_GTE?: number | null;
  fax_AVERAGE_LT?: number | null;
  fax_AVERAGE_LTE?: number | null;
  fax_EQUAL?: string | null;
  fax_GT?: number | null;
  fax_GTE?: number | null;
  fax_LONGEST_EQUAL?: number | null;
  fax_LONGEST_GT?: number | null;
  fax_LONGEST_GTE?: number | null;
  fax_LONGEST_LT?: number | null;
  fax_LONGEST_LTE?: number | null;
  fax_LT?: number | null;
  fax_LTE?: number | null;
  fax_SHORTEST_EQUAL?: number | null;
  fax_SHORTEST_GT?: number | null;
  fax_SHORTEST_GTE?: number | null;
  fax_SHORTEST_LT?: number | null;
  fax_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  legalName_AVERAGE_EQUAL?: number | null;
  legalName_AVERAGE_GT?: number | null;
  legalName_AVERAGE_GTE?: number | null;
  legalName_AVERAGE_LT?: number | null;
  legalName_AVERAGE_LTE?: number | null;
  legalName_EQUAL?: string | null;
  legalName_GT?: number | null;
  legalName_GTE?: number | null;
  legalName_LONGEST_EQUAL?: number | null;
  legalName_LONGEST_GT?: number | null;
  legalName_LONGEST_GTE?: number | null;
  legalName_LONGEST_LT?: number | null;
  legalName_LONGEST_LTE?: number | null;
  legalName_LT?: number | null;
  legalName_LTE?: number | null;
  legalName_SHORTEST_EQUAL?: number | null;
  legalName_SHORTEST_GT?: number | null;
  legalName_SHORTEST_GTE?: number | null;
  legalName_SHORTEST_LT?: number | null;
  legalName_SHORTEST_LTE?: number | null;
  logo_AVERAGE_EQUAL?: number | null;
  logo_AVERAGE_GT?: number | null;
  logo_AVERAGE_GTE?: number | null;
  logo_AVERAGE_LT?: number | null;
  logo_AVERAGE_LTE?: number | null;
  logo_EQUAL?: string | null;
  logo_GT?: number | null;
  logo_GTE?: number | null;
  logo_LONGEST_EQUAL?: number | null;
  logo_LONGEST_GT?: number | null;
  logo_LONGEST_GTE?: number | null;
  logo_LONGEST_LT?: number | null;
  logo_LONGEST_LTE?: number | null;
  logo_LT?: number | null;
  logo_LTE?: number | null;
  logo_SHORTEST_EQUAL?: number | null;
  logo_SHORTEST_GT?: number | null;
  logo_SHORTEST_GTE?: number | null;
  logo_SHORTEST_LT?: number | null;
  logo_SHORTEST_LTE?: number | null;
  name_AVERAGE_EQUAL?: number | null;
  name_AVERAGE_GT?: number | null;
  name_AVERAGE_GTE?: number | null;
  name_AVERAGE_LT?: number | null;
  name_AVERAGE_LTE?: number | null;
  name_EQUAL?: string | null;
  name_GT?: number | null;
  name_GTE?: number | null;
  name_LONGEST_EQUAL?: number | null;
  name_LONGEST_GT?: number | null;
  name_LONGEST_GTE?: number | null;
  name_LONGEST_LT?: number | null;
  name_LONGEST_LTE?: number | null;
  name_LT?: number | null;
  name_LTE?: number | null;
  name_SHORTEST_EQUAL?: number | null;
  name_SHORTEST_GT?: number | null;
  name_SHORTEST_GTE?: number | null;
  name_SHORTEST_LT?: number | null;
  name_SHORTEST_LTE?: number | null;
  paymentTerms_AVERAGE_EQUAL?: number | null;
  paymentTerms_AVERAGE_GT?: number | null;
  paymentTerms_AVERAGE_GTE?: number | null;
  paymentTerms_AVERAGE_LT?: number | null;
  paymentTerms_AVERAGE_LTE?: number | null;
  paymentTerms_EQUAL?: number | null;
  paymentTerms_GT?: number | null;
  paymentTerms_GTE?: number | null;
  paymentTerms_LT?: number | null;
  paymentTerms_LTE?: number | null;
  paymentTerms_MAX_EQUAL?: number | null;
  paymentTerms_MAX_GT?: number | null;
  paymentTerms_MAX_GTE?: number | null;
  paymentTerms_MAX_LT?: number | null;
  paymentTerms_MAX_LTE?: number | null;
  paymentTerms_MIN_EQUAL?: number | null;
  paymentTerms_MIN_GT?: number | null;
  paymentTerms_MIN_GTE?: number | null;
  paymentTerms_MIN_LT?: number | null;
  paymentTerms_MIN_LTE?: number | null;
  paymentTerms_SUM_EQUAL?: number | null;
  paymentTerms_SUM_GT?: number | null;
  paymentTerms_SUM_GTE?: number | null;
  paymentTerms_SUM_LT?: number | null;
  paymentTerms_SUM_LTE?: number | null;
  phone_AVERAGE_EQUAL?: number | null;
  phone_AVERAGE_GT?: number | null;
  phone_AVERAGE_GTE?: number | null;
  phone_AVERAGE_LT?: number | null;
  phone_AVERAGE_LTE?: number | null;
  phone_EQUAL?: string | null;
  phone_GT?: number | null;
  phone_GTE?: number | null;
  phone_LONGEST_EQUAL?: number | null;
  phone_LONGEST_GT?: number | null;
  phone_LONGEST_GTE?: number | null;
  phone_LONGEST_LT?: number | null;
  phone_LONGEST_LTE?: number | null;
  phone_LT?: number | null;
  phone_LTE?: number | null;
  phone_SHORTEST_EQUAL?: number | null;
  phone_SHORTEST_GT?: number | null;
  phone_SHORTEST_GTE?: number | null;
  phone_SHORTEST_LT?: number | null;
  phone_SHORTEST_LTE?: number | null;
  tenantId_AVERAGE_EQUAL?: number | null;
  tenantId_AVERAGE_GT?: number | null;
  tenantId_AVERAGE_GTE?: number | null;
  tenantId_AVERAGE_LT?: number | null;
  tenantId_AVERAGE_LTE?: number | null;
  tenantId_EQUAL?: string | null;
  tenantId_GT?: number | null;
  tenantId_GTE?: number | null;
  tenantId_LONGEST_EQUAL?: number | null;
  tenantId_LONGEST_GT?: number | null;
  tenantId_LONGEST_GTE?: number | null;
  tenantId_LONGEST_LT?: number | null;
  tenantId_LONGEST_LTE?: number | null;
  tenantId_LT?: number | null;
  tenantId_LTE?: number | null;
  tenantId_SHORTEST_EQUAL?: number | null;
  tenantId_SHORTEST_GT?: number | null;
  tenantId_SHORTEST_GTE?: number | null;
  tenantId_SHORTEST_LT?: number | null;
  tenantId_SHORTEST_LTE?: number | null;
  website_AVERAGE_EQUAL?: number | null;
  website_AVERAGE_GT?: number | null;
  website_AVERAGE_GTE?: number | null;
  website_AVERAGE_LT?: number | null;
  website_AVERAGE_LTE?: number | null;
  website_EQUAL?: string | null;
  website_GT?: number | null;
  website_GTE?: number | null;
  website_LONGEST_EQUAL?: number | null;
  website_LONGEST_GT?: number | null;
  website_LONGEST_GTE?: number | null;
  website_LONGEST_LT?: number | null;
  website_LONGEST_LTE?: number | null;
  website_LT?: number | null;
  website_LTE?: number | null;
  website_SHORTEST_EQUAL?: number | null;
  website_SHORTEST_GT?: number | null;
  website_SHORTEST_GTE?: number | null;
  website_SHORTEST_LT?: number | null;
  website_SHORTEST_LTE?: number | null;
}

export interface ContractWorkflowStepResponsiblePersonAggregateInput {
  AND?: ContractWorkflowStepResponsiblePersonAggregateInput[] | null;
  OR?: ContractWorkflowStepResponsiblePersonAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: ContractWorkflowStepResponsiblePersonNodeAggregationWhereInput | null;
}

export interface ContractWorkflowStepResponsiblePersonConnectionWhere {
  AND?: ContractWorkflowStepResponsiblePersonConnectionWhere[] | null;
  OR?: ContractWorkflowStepResponsiblePersonConnectionWhere[] | null;
  node?: UserWhere | null;
  node_NOT?: UserWhere | null;
}

export interface ContractWorkflowStepResponsiblePersonNodeAggregationWhereInput {
  AND?: ContractWorkflowStepResponsiblePersonNodeAggregationWhereInput[] | null;
  OR?: ContractWorkflowStepResponsiblePersonNodeAggregationWhereInput[] | null;
  deletedOn_EQUAL?: any | null;
  deletedOn_GT?: any | null;
  deletedOn_GTE?: any | null;
  deletedOn_LT?: any | null;
  deletedOn_LTE?: any | null;
  deletedOn_MAX_EQUAL?: any | null;
  deletedOn_MAX_GT?: any | null;
  deletedOn_MAX_GTE?: any | null;
  deletedOn_MAX_LT?: any | null;
  deletedOn_MAX_LTE?: any | null;
  deletedOn_MIN_EQUAL?: any | null;
  deletedOn_MIN_GT?: any | null;
  deletedOn_MIN_GTE?: any | null;
  deletedOn_MIN_LT?: any | null;
  deletedOn_MIN_LTE?: any | null;
  department_AVERAGE_EQUAL?: number | null;
  department_AVERAGE_GT?: number | null;
  department_AVERAGE_GTE?: number | null;
  department_AVERAGE_LT?: number | null;
  department_AVERAGE_LTE?: number | null;
  department_EQUAL?: string | null;
  department_GT?: number | null;
  department_GTE?: number | null;
  department_LONGEST_EQUAL?: number | null;
  department_LONGEST_GT?: number | null;
  department_LONGEST_GTE?: number | null;
  department_LONGEST_LT?: number | null;
  department_LONGEST_LTE?: number | null;
  department_LT?: number | null;
  department_LTE?: number | null;
  department_SHORTEST_EQUAL?: number | null;
  department_SHORTEST_GT?: number | null;
  department_SHORTEST_GTE?: number | null;
  department_SHORTEST_LT?: number | null;
  department_SHORTEST_LTE?: number | null;
  email_AVERAGE_EQUAL?: number | null;
  email_AVERAGE_GT?: number | null;
  email_AVERAGE_GTE?: number | null;
  email_AVERAGE_LT?: number | null;
  email_AVERAGE_LTE?: number | null;
  email_EQUAL?: string | null;
  email_GT?: number | null;
  email_GTE?: number | null;
  email_LONGEST_EQUAL?: number | null;
  email_LONGEST_GT?: number | null;
  email_LONGEST_GTE?: number | null;
  email_LONGEST_LT?: number | null;
  email_LONGEST_LTE?: number | null;
  email_LT?: number | null;
  email_LTE?: number | null;
  email_SHORTEST_EQUAL?: number | null;
  email_SHORTEST_GT?: number | null;
  email_SHORTEST_GTE?: number | null;
  email_SHORTEST_LT?: number | null;
  email_SHORTEST_LTE?: number | null;
  firstName_AVERAGE_EQUAL?: number | null;
  firstName_AVERAGE_GT?: number | null;
  firstName_AVERAGE_GTE?: number | null;
  firstName_AVERAGE_LT?: number | null;
  firstName_AVERAGE_LTE?: number | null;
  firstName_EQUAL?: string | null;
  firstName_GT?: number | null;
  firstName_GTE?: number | null;
  firstName_LONGEST_EQUAL?: number | null;
  firstName_LONGEST_GT?: number | null;
  firstName_LONGEST_GTE?: number | null;
  firstName_LONGEST_LT?: number | null;
  firstName_LONGEST_LTE?: number | null;
  firstName_LT?: number | null;
  firstName_LTE?: number | null;
  firstName_SHORTEST_EQUAL?: number | null;
  firstName_SHORTEST_GT?: number | null;
  firstName_SHORTEST_GTE?: number | null;
  firstName_SHORTEST_LT?: number | null;
  firstName_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  lastName_AVERAGE_EQUAL?: number | null;
  lastName_AVERAGE_GT?: number | null;
  lastName_AVERAGE_GTE?: number | null;
  lastName_AVERAGE_LT?: number | null;
  lastName_AVERAGE_LTE?: number | null;
  lastName_EQUAL?: string | null;
  lastName_GT?: number | null;
  lastName_GTE?: number | null;
  lastName_LONGEST_EQUAL?: number | null;
  lastName_LONGEST_GT?: number | null;
  lastName_LONGEST_GTE?: number | null;
  lastName_LONGEST_LT?: number | null;
  lastName_LONGEST_LTE?: number | null;
  lastName_LT?: number | null;
  lastName_LTE?: number | null;
  lastName_SHORTEST_EQUAL?: number | null;
  lastName_SHORTEST_GT?: number | null;
  lastName_SHORTEST_GTE?: number | null;
  lastName_SHORTEST_LT?: number | null;
  lastName_SHORTEST_LTE?: number | null;
  position_AVERAGE_EQUAL?: number | null;
  position_AVERAGE_GT?: number | null;
  position_AVERAGE_GTE?: number | null;
  position_AVERAGE_LT?: number | null;
  position_AVERAGE_LTE?: number | null;
  position_EQUAL?: string | null;
  position_GT?: number | null;
  position_GTE?: number | null;
  position_LONGEST_EQUAL?: number | null;
  position_LONGEST_GT?: number | null;
  position_LONGEST_GTE?: number | null;
  position_LONGEST_LT?: number | null;
  position_LONGEST_LTE?: number | null;
  position_LT?: number | null;
  position_LTE?: number | null;
  position_SHORTEST_EQUAL?: number | null;
  position_SHORTEST_GT?: number | null;
  position_SHORTEST_GTE?: number | null;
  position_SHORTEST_LT?: number | null;
  position_SHORTEST_LTE?: number | null;
  preferredLanguage_AVERAGE_EQUAL?: number | null;
  preferredLanguage_AVERAGE_GT?: number | null;
  preferredLanguage_AVERAGE_GTE?: number | null;
  preferredLanguage_AVERAGE_LT?: number | null;
  preferredLanguage_AVERAGE_LTE?: number | null;
  preferredLanguage_EQUAL?: string | null;
  preferredLanguage_GT?: number | null;
  preferredLanguage_GTE?: number | null;
  preferredLanguage_LONGEST_EQUAL?: number | null;
  preferredLanguage_LONGEST_GT?: number | null;
  preferredLanguage_LONGEST_GTE?: number | null;
  preferredLanguage_LONGEST_LT?: number | null;
  preferredLanguage_LONGEST_LTE?: number | null;
  preferredLanguage_LT?: number | null;
  preferredLanguage_LTE?: number | null;
  preferredLanguage_SHORTEST_EQUAL?: number | null;
  preferredLanguage_SHORTEST_GT?: number | null;
  preferredLanguage_SHORTEST_GTE?: number | null;
  preferredLanguage_SHORTEST_LT?: number | null;
  preferredLanguage_SHORTEST_LTE?: number | null;
  tenantId_AVERAGE_EQUAL?: number | null;
  tenantId_AVERAGE_GT?: number | null;
  tenantId_AVERAGE_GTE?: number | null;
  tenantId_AVERAGE_LT?: number | null;
  tenantId_AVERAGE_LTE?: number | null;
  tenantId_EQUAL?: string | null;
  tenantId_GT?: number | null;
  tenantId_GTE?: number | null;
  tenantId_LONGEST_EQUAL?: number | null;
  tenantId_LONGEST_GT?: number | null;
  tenantId_LONGEST_GTE?: number | null;
  tenantId_LONGEST_LT?: number | null;
  tenantId_LONGEST_LTE?: number | null;
  tenantId_LT?: number | null;
  tenantId_LTE?: number | null;
  tenantId_SHORTEST_EQUAL?: number | null;
  tenantId_SHORTEST_GT?: number | null;
  tenantId_SHORTEST_GTE?: number | null;
  tenantId_SHORTEST_LT?: number | null;
  tenantId_SHORTEST_LTE?: number | null;
}

export interface ContractWorkflowStepWhere {
  AND?: ContractWorkflowStepWhere[] | null;
  OR?: ContractWorkflowStepWhere[] | null;
  contractPartType?: ContractPartType | null;
  contractPartType_IN?: (ContractPartType | null)[] | null;
  contractPartType_NOT?: ContractPartType | null;
  contractPartType_NOT_IN?: (ContractPartType | null)[] | null;
  contractWorkflowStepType?: ContractWorkflowStepType | null;
  contractWorkflowStepType_IN?: (ContractWorkflowStepType | null)[] | null;
  contractWorkflowStepType_NOT?: ContractWorkflowStepType | null;
  contractWorkflowStepType_NOT_IN?: (ContractWorkflowStepType | null)[] | null;
  isAmended?: boolean | null;
  isAmended_NOT?: boolean | null;
  order?: number | null;
  order_GT?: number | null;
  order_GTE?: number | null;
  order_IN?: (number | null)[] | null;
  order_LT?: number | null;
  order_LTE?: number | null;
  order_NOT?: number | null;
  order_NOT_IN?: (number | null)[] | null;
  responsiblePerson?: UserWhere | null;
  responsiblePersonAggregate?: ContractWorkflowStepResponsiblePersonAggregateInput | null;
  responsiblePersonConnection?: ContractWorkflowStepResponsiblePersonConnectionWhere | null;
  responsiblePersonConnection_NOT?: ContractWorkflowStepResponsiblePersonConnectionWhere | null;
  responsiblePerson_NOT?: UserWhere | null;
  status?: ContractWorkflowStatus | null;
  status_IN?: (ContractWorkflowStatus | null)[] | null;
  status_NOT?: ContractWorkflowStatus | null;
  status_NOT_IN?: (ContractWorkflowStatus | null)[] | null;
  title?: string | null;
  title_CONTAINS?: string | null;
  title_ENDS_WITH?: string | null;
  title_IN?: (string | null)[] | null;
  title_MATCHES?: string | null;
  title_NOT?: string | null;
  title_NOT_CONTAINS?: string | null;
  title_NOT_ENDS_WITH?: string | null;
  title_NOT_IN?: (string | null)[] | null;
  title_NOT_STARTS_WITH?: string | null;
  title_STARTS_WITH?: string | null;
}

export interface ContractWorkflowStepsAggregateInput {
  AND?: ContractWorkflowStepsAggregateInput[] | null;
  OR?: ContractWorkflowStepsAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: ContractWorkflowStepsNodeAggregationWhereInput | null;
}

export interface ContractWorkflowStepsConnectionWhere {
  AND?: ContractWorkflowStepsConnectionWhere[] | null;
  OR?: ContractWorkflowStepsConnectionWhere[] | null;
  node?: ContractWorkflowStepWhere | null;
  node_NOT?: ContractWorkflowStepWhere | null;
}

export interface ContractWorkflowStepsNodeAggregationWhereInput {
  AND?: ContractWorkflowStepsNodeAggregationWhereInput[] | null;
  OR?: ContractWorkflowStepsNodeAggregationWhereInput[] | null;
  order_AVERAGE_EQUAL?: number | null;
  order_AVERAGE_GT?: number | null;
  order_AVERAGE_GTE?: number | null;
  order_AVERAGE_LT?: number | null;
  order_AVERAGE_LTE?: number | null;
  order_EQUAL?: number | null;
  order_GT?: number | null;
  order_GTE?: number | null;
  order_LT?: number | null;
  order_LTE?: number | null;
  order_MAX_EQUAL?: number | null;
  order_MAX_GT?: number | null;
  order_MAX_GTE?: number | null;
  order_MAX_LT?: number | null;
  order_MAX_LTE?: number | null;
  order_MIN_EQUAL?: number | null;
  order_MIN_GT?: number | null;
  order_MIN_GTE?: number | null;
  order_MIN_LT?: number | null;
  order_MIN_LTE?: number | null;
  order_SUM_EQUAL?: number | null;
  order_SUM_GT?: number | null;
  order_SUM_GTE?: number | null;
  order_SUM_LT?: number | null;
  order_SUM_LTE?: number | null;
  title_AVERAGE_EQUAL?: number | null;
  title_AVERAGE_GT?: number | null;
  title_AVERAGE_GTE?: number | null;
  title_AVERAGE_LT?: number | null;
  title_AVERAGE_LTE?: number | null;
  title_EQUAL?: string | null;
  title_GT?: number | null;
  title_GTE?: number | null;
  title_LONGEST_EQUAL?: number | null;
  title_LONGEST_GT?: number | null;
  title_LONGEST_GTE?: number | null;
  title_LONGEST_LT?: number | null;
  title_LONGEST_LTE?: number | null;
  title_LT?: number | null;
  title_LTE?: number | null;
  title_SHORTEST_EQUAL?: number | null;
  title_SHORTEST_GT?: number | null;
  title_SHORTEST_GTE?: number | null;
  title_SHORTEST_LT?: number | null;
  title_SHORTEST_LTE?: number | null;
}

export interface ContractWorkflowWhere {
  AND?: ContractWorkflowWhere[] | null;
  OR?: ContractWorkflowWhere[] | null;
  organization?: OrganizationWhere | null;
  organizationAggregate?: ContractWorkflowOrganizationAggregateInput | null;
  organizationConnection?: ContractWorkflowOrganizationConnectionWhere | null;
  organizationConnection_NOT?: ContractWorkflowOrganizationConnectionWhere | null;
  organization_NOT?: OrganizationWhere | null;
  status?: ContractWorkflowStatus | null;
  status_IN?: (ContractWorkflowStatus | null)[] | null;
  status_NOT?: ContractWorkflowStatus | null;
  status_NOT_IN?: (ContractWorkflowStatus | null)[] | null;
  steps?: ContractWorkflowStepWhere | null;
  stepsAggregate?: ContractWorkflowStepsAggregateInput | null;
  stepsAreOrdered?: boolean | null;
  stepsAreOrdered_NOT?: boolean | null;
  stepsConnection?: ContractWorkflowStepsConnectionWhere | null;
  stepsConnection_NOT?: ContractWorkflowStepsConnectionWhere | null;
  steps_NOT?: ContractWorkflowStepWhere | null;
  workflowType?: ContractWorkflowType | null;
  workflowType_IN?: (ContractWorkflowType | null)[] | null;
  workflowType_NOT?: ContractWorkflowType | null;
  workflowType_NOT_IN?: (ContractWorkflowType | null)[] | null;
}

export interface CounterpartyRoleRelationshipWhere {
  AND?: CounterpartyRoleRelationshipWhere[] | null;
  OR?: CounterpartyRoleRelationshipWhere[] | null;
  role?: CounterpartyRole | null;
  role_IN?: (CounterpartyRole | null)[] | null;
  role_NOT?: CounterpartyRole | null;
  role_NOT_IN?: (CounterpartyRole | null)[] | null;
}

export interface CountriesInAgreementWhere {
  AND?: CountriesInAgreementWhere[] | null;
  ISO_A3?: string | null;
  ISO_A3_CONTAINS?: string | null;
  ISO_A3_ENDS_WITH?: string | null;
  ISO_A3_IN?: (string | null)[] | null;
  ISO_A3_MATCHES?: string | null;
  ISO_A3_NOT?: string | null;
  ISO_A3_NOT_CONTAINS?: string | null;
  ISO_A3_NOT_ENDS_WITH?: string | null;
  ISO_A3_NOT_IN?: (string | null)[] | null;
  ISO_A3_NOT_STARTS_WITH?: string | null;
  ISO_A3_STARTS_WITH?: string | null;
  OR?: CountriesInAgreementWhere[] | null;
  id?: string | null;
  id_CONTAINS?: string | null;
  id_ENDS_WITH?: string | null;
  id_IN?: (string | null)[] | null;
  id_MATCHES?: string | null;
  id_NOT?: string | null;
  id_NOT_CONTAINS?: string | null;
  id_NOT_ENDS_WITH?: string | null;
  id_NOT_IN?: (string | null)[] | null;
  id_NOT_STARTS_WITH?: string | null;
  id_STARTS_WITH?: string | null;
  name?: string | null;
  name_CONTAINS?: string | null;
  name_ENDS_WITH?: string | null;
  name_IN?: (string | null)[] | null;
  name_MATCHES?: string | null;
  name_NOT?: string | null;
  name_NOT_CONTAINS?: string | null;
  name_NOT_ENDS_WITH?: string | null;
  name_NOT_IN?: (string | null)[] | null;
  name_NOT_STARTS_WITH?: string | null;
  name_STARTS_WITH?: string | null;
  region?: string | null;
  region_CONTAINS?: string | null;
  region_ENDS_WITH?: string | null;
  region_IN?: (string | null)[] | null;
  region_MATCHES?: string | null;
  region_NOT?: string | null;
  region_NOT_CONTAINS?: string | null;
  region_NOT_ENDS_WITH?: string | null;
  region_NOT_IN?: (string | null)[] | null;
  region_NOT_STARTS_WITH?: string | null;
  region_STARTS_WITH?: string | null;
}

export interface CountryCurrencyAggregateInput {
  AND?: CountryCurrencyAggregateInput[] | null;
  OR?: CountryCurrencyAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: CountryCurrencyNodeAggregationWhereInput | null;
}

export interface CountryCurrencyConnectionWhere {
  AND?: CountryCurrencyConnectionWhere[] | null;
  OR?: CountryCurrencyConnectionWhere[] | null;
  node?: CurrencyWhere | null;
  node_NOT?: CurrencyWhere | null;
}

export interface CountryCurrencyNodeAggregationWhereInput {
  AND?: CountryCurrencyNodeAggregationWhereInput[] | null;
  Code_AVERAGE_EQUAL?: number | null;
  Code_AVERAGE_GT?: number | null;
  Code_AVERAGE_GTE?: number | null;
  Code_AVERAGE_LT?: number | null;
  Code_AVERAGE_LTE?: number | null;
  Code_EQUAL?: string | null;
  Code_GT?: number | null;
  Code_GTE?: number | null;
  Code_LONGEST_EQUAL?: number | null;
  Code_LONGEST_GT?: number | null;
  Code_LONGEST_GTE?: number | null;
  Code_LONGEST_LT?: number | null;
  Code_LONGEST_LTE?: number | null;
  Code_LT?: number | null;
  Code_LTE?: number | null;
  Code_SHORTEST_EQUAL?: number | null;
  Code_SHORTEST_GT?: number | null;
  Code_SHORTEST_GTE?: number | null;
  Code_SHORTEST_LT?: number | null;
  Code_SHORTEST_LTE?: number | null;
  Name_AVERAGE_EQUAL?: number | null;
  Name_AVERAGE_GT?: number | null;
  Name_AVERAGE_GTE?: number | null;
  Name_AVERAGE_LT?: number | null;
  Name_AVERAGE_LTE?: number | null;
  Name_EQUAL?: string | null;
  Name_GT?: number | null;
  Name_GTE?: number | null;
  Name_LONGEST_EQUAL?: number | null;
  Name_LONGEST_GT?: number | null;
  Name_LONGEST_GTE?: number | null;
  Name_LONGEST_LT?: number | null;
  Name_LONGEST_LTE?: number | null;
  Name_LT?: number | null;
  Name_LTE?: number | null;
  Name_SHORTEST_EQUAL?: number | null;
  Name_SHORTEST_GT?: number | null;
  Name_SHORTEST_GTE?: number | null;
  Name_SHORTEST_LT?: number | null;
  Name_SHORTEST_LTE?: number | null;
  OR?: CountryCurrencyNodeAggregationWhereInput[] | null;
  symbol_AVERAGE_EQUAL?: number | null;
  symbol_AVERAGE_GT?: number | null;
  symbol_AVERAGE_GTE?: number | null;
  symbol_AVERAGE_LT?: number | null;
  symbol_AVERAGE_LTE?: number | null;
  symbol_EQUAL?: string | null;
  symbol_GT?: number | null;
  symbol_GTE?: number | null;
  symbol_LONGEST_EQUAL?: number | null;
  symbol_LONGEST_GT?: number | null;
  symbol_LONGEST_GTE?: number | null;
  symbol_LONGEST_LT?: number | null;
  symbol_LONGEST_LTE?: number | null;
  symbol_LT?: number | null;
  symbol_LTE?: number | null;
  symbol_SHORTEST_EQUAL?: number | null;
  symbol_SHORTEST_GT?: number | null;
  symbol_SHORTEST_GTE?: number | null;
  symbol_SHORTEST_LT?: number | null;
  symbol_SHORTEST_LTE?: number | null;
}

export interface CountryScopeRelationshipWhere {
  AND?: CountryScopeRelationshipWhere[] | null;
  OR?: CountryScopeRelationshipWhere[] | null;
  countryScopeId?: string | null;
  countryScopeId_CONTAINS?: string | null;
  countryScopeId_ENDS_WITH?: string | null;
  countryScopeId_IN?: (string | null)[] | null;
  countryScopeId_MATCHES?: string | null;
  countryScopeId_NOT?: string | null;
  countryScopeId_NOT_CONTAINS?: string | null;
  countryScopeId_NOT_ENDS_WITH?: string | null;
  countryScopeId_NOT_IN?: (string | null)[] | null;
  countryScopeId_NOT_STARTS_WITH?: string | null;
  countryScopeId_STARTS_WITH?: string | null;
}

export interface CountryWhere {
  AND?: CountryWhere[] | null;
  CallingCodes?: string[] | null;
  CallingCodes_INCLUDES?: string | null;
  CallingCodes_NOT?: string[] | null;
  CallingCodes_NOT_INCLUDES?: string | null;
  OR?: CountryWhere[] | null;
  alpha2Code?: string | null;
  alpha2Code_CONTAINS?: string | null;
  alpha2Code_ENDS_WITH?: string | null;
  alpha2Code_IN?: (string | null)[] | null;
  alpha2Code_MATCHES?: string | null;
  alpha2Code_NOT?: string | null;
  alpha2Code_NOT_CONTAINS?: string | null;
  alpha2Code_NOT_ENDS_WITH?: string | null;
  alpha2Code_NOT_IN?: (string | null)[] | null;
  alpha2Code_NOT_STARTS_WITH?: string | null;
  alpha2Code_STARTS_WITH?: string | null;
  alpha3Code?: string | null;
  alpha3Code_CONTAINS?: string | null;
  alpha3Code_ENDS_WITH?: string | null;
  alpha3Code_IN?: (string | null)[] | null;
  alpha3Code_MATCHES?: string | null;
  alpha3Code_NOT?: string | null;
  alpha3Code_NOT_CONTAINS?: string | null;
  alpha3Code_NOT_ENDS_WITH?: string | null;
  alpha3Code_NOT_IN?: (string | null)[] | null;
  alpha3Code_NOT_STARTS_WITH?: string | null;
  alpha3Code_STARTS_WITH?: string | null;
  currency?: CurrencyWhere | null;
  currencyAggregate?: CountryCurrencyAggregateInput | null;
  currencyConnection?: CountryCurrencyConnectionWhere | null;
  currencyConnection_NOT?: CountryCurrencyConnectionWhere | null;
  currency_NOT?: CurrencyWhere | null;
  flag?: string | null;
  flag_CONTAINS?: string | null;
  flag_ENDS_WITH?: string | null;
  flag_IN?: (string | null)[] | null;
  flag_MATCHES?: string | null;
  flag_NOT?: string | null;
  flag_NOT_CONTAINS?: string | null;
  flag_NOT_ENDS_WITH?: string | null;
  flag_NOT_IN?: (string | null)[] | null;
  flag_NOT_STARTS_WITH?: string | null;
  flag_STARTS_WITH?: string | null;
  name?: string | null;
  name_CONTAINS?: string | null;
  name_ENDS_WITH?: string | null;
  name_IN?: (string | null)[] | null;
  name_MATCHES?: string | null;
  name_NOT?: string | null;
  name_NOT_CONTAINS?: string | null;
  name_NOT_ENDS_WITH?: string | null;
  name_NOT_IN?: (string | null)[] | null;
  name_NOT_STARTS_WITH?: string | null;
  name_STARTS_WITH?: string | null;
  numericCode?: string | null;
  numericCode_CONTAINS?: string | null;
  numericCode_ENDS_WITH?: string | null;
  numericCode_IN?: (string | null)[] | null;
  numericCode_MATCHES?: string | null;
  numericCode_NOT?: string | null;
  numericCode_NOT_CONTAINS?: string | null;
  numericCode_NOT_ENDS_WITH?: string | null;
  numericCode_NOT_IN?: (string | null)[] | null;
  numericCode_NOT_STARTS_WITH?: string | null;
  numericCode_STARTS_WITH?: string | null;
}

export interface CreateDocumentInput {
  documentType?: DocumentType | null;
  refundIds: string[];
}

export interface CreateThreadMessageInput {
  content: string;
  externalFlowDocumentId?: string | null;
  id: string;
  isExternalFlow?: boolean | null;
  mentionsUserIds?: (string | null)[] | null;
  nodeLabel: SupportedMessageNodes;
  sentByUserId: string;
}

export interface CurrencyAgreementsAggregateInput {
  AND?: CurrencyAgreementsAggregateInput[] | null;
  OR?: CurrencyAgreementsAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: CurrencyAgreementsNodeAggregationWhereInput | null;
}

export interface CurrencyAgreementsConnectionWhere {
  AND?: CurrencyAgreementsConnectionWhere[] | null;
  OR?: CurrencyAgreementsConnectionWhere[] | null;
  node?: AgreementWhere | null;
  node_NOT?: AgreementWhere | null;
}

export interface CurrencyAgreementsNodeAggregationWhereInput {
  AND?: CurrencyAgreementsNodeAggregationWhereInput[] | null;
  OR?: CurrencyAgreementsNodeAggregationWhereInput[] | null;
  description_AVERAGE_EQUAL?: number | null;
  description_AVERAGE_GT?: number | null;
  description_AVERAGE_GTE?: number | null;
  description_AVERAGE_LT?: number | null;
  description_AVERAGE_LTE?: number | null;
  description_EQUAL?: string | null;
  description_GT?: number | null;
  description_GTE?: number | null;
  description_LONGEST_EQUAL?: number | null;
  description_LONGEST_GT?: number | null;
  description_LONGEST_GTE?: number | null;
  description_LONGEST_LT?: number | null;
  description_LONGEST_LTE?: number | null;
  description_LT?: number | null;
  description_LTE?: number | null;
  description_SHORTEST_EQUAL?: number | null;
  description_SHORTEST_GT?: number | null;
  description_SHORTEST_GTE?: number | null;
  description_SHORTEST_LT?: number | null;
  description_SHORTEST_LTE?: number | null;
  formattedAmount_AVERAGE_EQUAL?: number | null;
  formattedAmount_AVERAGE_GT?: number | null;
  formattedAmount_AVERAGE_GTE?: number | null;
  formattedAmount_AVERAGE_LT?: number | null;
  formattedAmount_AVERAGE_LTE?: number | null;
  formattedAmount_EQUAL?: string | null;
  formattedAmount_GT?: number | null;
  formattedAmount_GTE?: number | null;
  formattedAmount_LONGEST_EQUAL?: number | null;
  formattedAmount_LONGEST_GT?: number | null;
  formattedAmount_LONGEST_GTE?: number | null;
  formattedAmount_LONGEST_LT?: number | null;
  formattedAmount_LONGEST_LTE?: number | null;
  formattedAmount_LT?: number | null;
  formattedAmount_LTE?: number | null;
  formattedAmount_SHORTEST_EQUAL?: number | null;
  formattedAmount_SHORTEST_GT?: number | null;
  formattedAmount_SHORTEST_GTE?: number | null;
  formattedAmount_SHORTEST_LT?: number | null;
  formattedAmount_SHORTEST_LTE?: number | null;
  formattedCounterparties_AVERAGE_EQUAL?: number | null;
  formattedCounterparties_AVERAGE_GT?: number | null;
  formattedCounterparties_AVERAGE_GTE?: number | null;
  formattedCounterparties_AVERAGE_LT?: number | null;
  formattedCounterparties_AVERAGE_LTE?: number | null;
  formattedCounterparties_EQUAL?: string | null;
  formattedCounterparties_GT?: number | null;
  formattedCounterparties_GTE?: number | null;
  formattedCounterparties_LONGEST_EQUAL?: number | null;
  formattedCounterparties_LONGEST_GT?: number | null;
  formattedCounterparties_LONGEST_GTE?: number | null;
  formattedCounterparties_LONGEST_LT?: number | null;
  formattedCounterparties_LONGEST_LTE?: number | null;
  formattedCounterparties_LT?: number | null;
  formattedCounterparties_LTE?: number | null;
  formattedCounterparties_SHORTEST_EQUAL?: number | null;
  formattedCounterparties_SHORTEST_GT?: number | null;
  formattedCounterparties_SHORTEST_GTE?: number | null;
  formattedCounterparties_SHORTEST_LT?: number | null;
  formattedCounterparties_SHORTEST_LTE?: number | null;
  formattedDiseases_AVERAGE_EQUAL?: number | null;
  formattedDiseases_AVERAGE_GT?: number | null;
  formattedDiseases_AVERAGE_GTE?: number | null;
  formattedDiseases_AVERAGE_LT?: number | null;
  formattedDiseases_AVERAGE_LTE?: number | null;
  formattedDiseases_EQUAL?: string | null;
  formattedDiseases_GT?: number | null;
  formattedDiseases_GTE?: number | null;
  formattedDiseases_LONGEST_EQUAL?: number | null;
  formattedDiseases_LONGEST_GT?: number | null;
  formattedDiseases_LONGEST_GTE?: number | null;
  formattedDiseases_LONGEST_LT?: number | null;
  formattedDiseases_LONGEST_LTE?: number | null;
  formattedDiseases_LT?: number | null;
  formattedDiseases_LTE?: number | null;
  formattedDiseases_SHORTEST_EQUAL?: number | null;
  formattedDiseases_SHORTEST_GT?: number | null;
  formattedDiseases_SHORTEST_GTE?: number | null;
  formattedDiseases_SHORTEST_LT?: number | null;
  formattedDiseases_SHORTEST_LTE?: number | null;
  formattedIndications_AVERAGE_EQUAL?: number | null;
  formattedIndications_AVERAGE_GT?: number | null;
  formattedIndications_AVERAGE_GTE?: number | null;
  formattedIndications_AVERAGE_LT?: number | null;
  formattedIndications_AVERAGE_LTE?: number | null;
  formattedIndications_EQUAL?: string | null;
  formattedIndications_GT?: number | null;
  formattedIndications_GTE?: number | null;
  formattedIndications_LONGEST_EQUAL?: number | null;
  formattedIndications_LONGEST_GT?: number | null;
  formattedIndications_LONGEST_GTE?: number | null;
  formattedIndications_LONGEST_LT?: number | null;
  formattedIndications_LONGEST_LTE?: number | null;
  formattedIndications_LT?: number | null;
  formattedIndications_LTE?: number | null;
  formattedIndications_SHORTEST_EQUAL?: number | null;
  formattedIndications_SHORTEST_GT?: number | null;
  formattedIndications_SHORTEST_GTE?: number | null;
  formattedIndications_SHORTEST_LT?: number | null;
  formattedIndications_SHORTEST_LTE?: number | null;
  formattedProducts_AVERAGE_EQUAL?: number | null;
  formattedProducts_AVERAGE_GT?: number | null;
  formattedProducts_AVERAGE_GTE?: number | null;
  formattedProducts_AVERAGE_LT?: number | null;
  formattedProducts_AVERAGE_LTE?: number | null;
  formattedProducts_EQUAL?: string | null;
  formattedProducts_GT?: number | null;
  formattedProducts_GTE?: number | null;
  formattedProducts_LONGEST_EQUAL?: number | null;
  formattedProducts_LONGEST_GT?: number | null;
  formattedProducts_LONGEST_GTE?: number | null;
  formattedProducts_LONGEST_LT?: number | null;
  formattedProducts_LONGEST_LTE?: number | null;
  formattedProducts_LT?: number | null;
  formattedProducts_LTE?: number | null;
  formattedProducts_SHORTEST_EQUAL?: number | null;
  formattedProducts_SHORTEST_GT?: number | null;
  formattedProducts_SHORTEST_GTE?: number | null;
  formattedProducts_SHORTEST_LT?: number | null;
  formattedProducts_SHORTEST_LTE?: number | null;
  formattedTags_AVERAGE_EQUAL?: number | null;
  formattedTags_AVERAGE_GT?: number | null;
  formattedTags_AVERAGE_GTE?: number | null;
  formattedTags_AVERAGE_LT?: number | null;
  formattedTags_AVERAGE_LTE?: number | null;
  formattedTags_EQUAL?: string | null;
  formattedTags_GT?: number | null;
  formattedTags_GTE?: number | null;
  formattedTags_LONGEST_EQUAL?: number | null;
  formattedTags_LONGEST_GT?: number | null;
  formattedTags_LONGEST_GTE?: number | null;
  formattedTags_LONGEST_LT?: number | null;
  formattedTags_LONGEST_LTE?: number | null;
  formattedTags_LT?: number | null;
  formattedTags_LTE?: number | null;
  formattedTags_SHORTEST_EQUAL?: number | null;
  formattedTags_SHORTEST_GT?: number | null;
  formattedTags_SHORTEST_GTE?: number | null;
  formattedTags_SHORTEST_LT?: number | null;
  formattedTags_SHORTEST_LTE?: number | null;
  formattedValidityPeriod_AVERAGE_EQUAL?: number | null;
  formattedValidityPeriod_AVERAGE_GT?: number | null;
  formattedValidityPeriod_AVERAGE_GTE?: number | null;
  formattedValidityPeriod_AVERAGE_LT?: number | null;
  formattedValidityPeriod_AVERAGE_LTE?: number | null;
  formattedValidityPeriod_EQUAL?: string | null;
  formattedValidityPeriod_GT?: number | null;
  formattedValidityPeriod_GTE?: number | null;
  formattedValidityPeriod_LONGEST_EQUAL?: number | null;
  formattedValidityPeriod_LONGEST_GT?: number | null;
  formattedValidityPeriod_LONGEST_GTE?: number | null;
  formattedValidityPeriod_LONGEST_LT?: number | null;
  formattedValidityPeriod_LONGEST_LTE?: number | null;
  formattedValidityPeriod_LT?: number | null;
  formattedValidityPeriod_LTE?: number | null;
  formattedValidityPeriod_SHORTEST_EQUAL?: number | null;
  formattedValidityPeriod_SHORTEST_GT?: number | null;
  formattedValidityPeriod_SHORTEST_GTE?: number | null;
  formattedValidityPeriod_SHORTEST_LT?: number | null;
  formattedValidityPeriod_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  initialVersionId_AVERAGE_EQUAL?: number | null;
  initialVersionId_AVERAGE_GT?: number | null;
  initialVersionId_AVERAGE_GTE?: number | null;
  initialVersionId_AVERAGE_LT?: number | null;
  initialVersionId_AVERAGE_LTE?: number | null;
  initialVersionId_EQUAL?: string | null;
  initialVersionId_GT?: number | null;
  initialVersionId_GTE?: number | null;
  initialVersionId_LONGEST_EQUAL?: number | null;
  initialVersionId_LONGEST_GT?: number | null;
  initialVersionId_LONGEST_GTE?: number | null;
  initialVersionId_LONGEST_LT?: number | null;
  initialVersionId_LONGEST_LTE?: number | null;
  initialVersionId_LT?: number | null;
  initialVersionId_LTE?: number | null;
  initialVersionId_SHORTEST_EQUAL?: number | null;
  initialVersionId_SHORTEST_GT?: number | null;
  initialVersionId_SHORTEST_GTE?: number | null;
  initialVersionId_SHORTEST_LT?: number | null;
  initialVersionId_SHORTEST_LTE?: number | null;
  name_AVERAGE_EQUAL?: number | null;
  name_AVERAGE_GT?: number | null;
  name_AVERAGE_GTE?: number | null;
  name_AVERAGE_LT?: number | null;
  name_AVERAGE_LTE?: number | null;
  name_EQUAL?: string | null;
  name_GT?: number | null;
  name_GTE?: number | null;
  name_LONGEST_EQUAL?: number | null;
  name_LONGEST_GT?: number | null;
  name_LONGEST_GTE?: number | null;
  name_LONGEST_LT?: number | null;
  name_LONGEST_LTE?: number | null;
  name_LT?: number | null;
  name_LTE?: number | null;
  name_SHORTEST_EQUAL?: number | null;
  name_SHORTEST_GT?: number | null;
  name_SHORTEST_GTE?: number | null;
  name_SHORTEST_LT?: number | null;
  name_SHORTEST_LTE?: number | null;
  searchTerm_AVERAGE_EQUAL?: number | null;
  searchTerm_AVERAGE_GT?: number | null;
  searchTerm_AVERAGE_GTE?: number | null;
  searchTerm_AVERAGE_LT?: number | null;
  searchTerm_AVERAGE_LTE?: number | null;
  searchTerm_EQUAL?: string | null;
  searchTerm_GT?: number | null;
  searchTerm_GTE?: number | null;
  searchTerm_LONGEST_EQUAL?: number | null;
  searchTerm_LONGEST_GT?: number | null;
  searchTerm_LONGEST_GTE?: number | null;
  searchTerm_LONGEST_LT?: number | null;
  searchTerm_LONGEST_LTE?: number | null;
  searchTerm_LT?: number | null;
  searchTerm_LTE?: number | null;
  searchTerm_SHORTEST_EQUAL?: number | null;
  searchTerm_SHORTEST_GT?: number | null;
  searchTerm_SHORTEST_GTE?: number | null;
  searchTerm_SHORTEST_LT?: number | null;
  searchTerm_SHORTEST_LTE?: number | null;
  totalAmount_AVERAGE_EQUAL?: number | null;
  totalAmount_AVERAGE_GT?: number | null;
  totalAmount_AVERAGE_GTE?: number | null;
  totalAmount_AVERAGE_LT?: number | null;
  totalAmount_AVERAGE_LTE?: number | null;
  totalAmount_EQUAL?: number | null;
  totalAmount_GT?: number | null;
  totalAmount_GTE?: number | null;
  totalAmount_LT?: number | null;
  totalAmount_LTE?: number | null;
  totalAmount_MAX_EQUAL?: number | null;
  totalAmount_MAX_GT?: number | null;
  totalAmount_MAX_GTE?: number | null;
  totalAmount_MAX_LT?: number | null;
  totalAmount_MAX_LTE?: number | null;
  totalAmount_MIN_EQUAL?: number | null;
  totalAmount_MIN_GT?: number | null;
  totalAmount_MIN_GTE?: number | null;
  totalAmount_MIN_LT?: number | null;
  totalAmount_MIN_LTE?: number | null;
  totalAmount_SUM_EQUAL?: number | null;
  totalAmount_SUM_GT?: number | null;
  totalAmount_SUM_GTE?: number | null;
  totalAmount_SUM_LT?: number | null;
  totalAmount_SUM_LTE?: number | null;
  unlimited_AVERAGE_EQUAL?: number | null;
  unlimited_AVERAGE_GT?: number | null;
  unlimited_AVERAGE_GTE?: number | null;
  unlimited_AVERAGE_LT?: number | null;
  unlimited_AVERAGE_LTE?: number | null;
  unlimited_EQUAL?: number | null;
  unlimited_GT?: number | null;
  unlimited_GTE?: number | null;
  unlimited_LT?: number | null;
  unlimited_LTE?: number | null;
  unlimited_MAX_EQUAL?: number | null;
  unlimited_MAX_GT?: number | null;
  unlimited_MAX_GTE?: number | null;
  unlimited_MAX_LT?: number | null;
  unlimited_MAX_LTE?: number | null;
  unlimited_MIN_EQUAL?: number | null;
  unlimited_MIN_GT?: number | null;
  unlimited_MIN_GTE?: number | null;
  unlimited_MIN_LT?: number | null;
  unlimited_MIN_LTE?: number | null;
  unlimited_SUM_EQUAL?: number | null;
  unlimited_SUM_GT?: number | null;
  unlimited_SUM_GTE?: number | null;
  unlimited_SUM_LT?: number | null;
  unlimited_SUM_LTE?: number | null;
  version_AVERAGE_EQUAL?: number | null;
  version_AVERAGE_GT?: number | null;
  version_AVERAGE_GTE?: number | null;
  version_AVERAGE_LT?: number | null;
  version_AVERAGE_LTE?: number | null;
  version_EQUAL?: number | null;
  version_GT?: number | null;
  version_GTE?: number | null;
  version_LT?: number | null;
  version_LTE?: number | null;
  version_MAX_EQUAL?: number | null;
  version_MAX_GT?: number | null;
  version_MAX_GTE?: number | null;
  version_MAX_LT?: number | null;
  version_MAX_LTE?: number | null;
  version_MIN_EQUAL?: number | null;
  version_MIN_GT?: number | null;
  version_MIN_GTE?: number | null;
  version_MIN_LT?: number | null;
  version_MIN_LTE?: number | null;
  version_SUM_EQUAL?: number | null;
  version_SUM_GT?: number | null;
  version_SUM_GTE?: number | null;
  version_SUM_LT?: number | null;
  version_SUM_LTE?: number | null;
}

export interface CurrencyScopesAggregateInput {
  AND?: CurrencyScopesAggregateInput[] | null;
  OR?: CurrencyScopesAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  edge?: CurrencyScopesEdgeAggregationWhereInput | null;
  node?: CurrencyScopesNodeAggregationWhereInput | null;
}

export interface CurrencyScopesConnectionWhere {
  AND?: CurrencyScopesConnectionWhere[] | null;
  OR?: CurrencyScopesConnectionWhere[] | null;
  edge?: CountryScopeRelationshipWhere | null;
  edge_NOT?: CountryScopeRelationshipWhere | null;
  node?: AgreementScopeWhere | null;
  node_NOT?: AgreementScopeWhere | null;
}

export interface CurrencyScopesEdgeAggregationWhereInput {
  AND?: CurrencyScopesEdgeAggregationWhereInput[] | null;
  OR?: CurrencyScopesEdgeAggregationWhereInput[] | null;
  countryScopeId_AVERAGE_EQUAL?: number | null;
  countryScopeId_AVERAGE_GT?: number | null;
  countryScopeId_AVERAGE_GTE?: number | null;
  countryScopeId_AVERAGE_LT?: number | null;
  countryScopeId_AVERAGE_LTE?: number | null;
  countryScopeId_EQUAL?: string | null;
  countryScopeId_GT?: number | null;
  countryScopeId_GTE?: number | null;
  countryScopeId_LONGEST_EQUAL?: number | null;
  countryScopeId_LONGEST_GT?: number | null;
  countryScopeId_LONGEST_GTE?: number | null;
  countryScopeId_LONGEST_LT?: number | null;
  countryScopeId_LONGEST_LTE?: number | null;
  countryScopeId_LT?: number | null;
  countryScopeId_LTE?: number | null;
  countryScopeId_SHORTEST_EQUAL?: number | null;
  countryScopeId_SHORTEST_GT?: number | null;
  countryScopeId_SHORTEST_GTE?: number | null;
  countryScopeId_SHORTEST_LT?: number | null;
  countryScopeId_SHORTEST_LTE?: number | null;
}

export interface CurrencyScopesNodeAggregationWhereInput {
  AND?: CurrencyScopesNodeAggregationWhereInput[] | null;
  OR?: CurrencyScopesNodeAggregationWhereInput[] | null;
  code_AVERAGE_EQUAL?: number | null;
  code_AVERAGE_GT?: number | null;
  code_AVERAGE_GTE?: number | null;
  code_AVERAGE_LT?: number | null;
  code_AVERAGE_LTE?: number | null;
  code_EQUAL?: string | null;
  code_GT?: number | null;
  code_GTE?: number | null;
  code_LONGEST_EQUAL?: number | null;
  code_LONGEST_GT?: number | null;
  code_LONGEST_GTE?: number | null;
  code_LONGEST_LT?: number | null;
  code_LONGEST_LTE?: number | null;
  code_LT?: number | null;
  code_LTE?: number | null;
  code_SHORTEST_EQUAL?: number | null;
  code_SHORTEST_GT?: number | null;
  code_SHORTEST_GTE?: number | null;
  code_SHORTEST_LT?: number | null;
  code_SHORTEST_LTE?: number | null;
  order_AVERAGE_EQUAL?: number | null;
  order_AVERAGE_GT?: number | null;
  order_AVERAGE_GTE?: number | null;
  order_AVERAGE_LT?: number | null;
  order_AVERAGE_LTE?: number | null;
  order_EQUAL?: number | null;
  order_GT?: number | null;
  order_GTE?: number | null;
  order_LT?: number | null;
  order_LTE?: number | null;
  order_MAX_EQUAL?: number | null;
  order_MAX_GT?: number | null;
  order_MAX_GTE?: number | null;
  order_MAX_LT?: number | null;
  order_MAX_LTE?: number | null;
  order_MIN_EQUAL?: number | null;
  order_MIN_GT?: number | null;
  order_MIN_GTE?: number | null;
  order_MIN_LT?: number | null;
  order_MIN_LTE?: number | null;
  order_SUM_EQUAL?: number | null;
  order_SUM_GT?: number | null;
  order_SUM_GTE?: number | null;
  order_SUM_LT?: number | null;
  order_SUM_LTE?: number | null;
  scopeId_AVERAGE_EQUAL?: number | null;
  scopeId_AVERAGE_GT?: number | null;
  scopeId_AVERAGE_GTE?: number | null;
  scopeId_AVERAGE_LT?: number | null;
  scopeId_AVERAGE_LTE?: number | null;
  scopeId_EQUAL?: string | null;
  scopeId_GT?: number | null;
  scopeId_GTE?: number | null;
  scopeId_LONGEST_EQUAL?: number | null;
  scopeId_LONGEST_GT?: number | null;
  scopeId_LONGEST_GTE?: number | null;
  scopeId_LONGEST_LT?: number | null;
  scopeId_LONGEST_LTE?: number | null;
  scopeId_LT?: number | null;
  scopeId_LTE?: number | null;
  scopeId_SHORTEST_EQUAL?: number | null;
  scopeId_SHORTEST_GT?: number | null;
  scopeId_SHORTEST_GTE?: number | null;
  scopeId_SHORTEST_LT?: number | null;
  scopeId_SHORTEST_LTE?: number | null;
}

export interface CurrencyWhere {
  AND?: CurrencyWhere[] | null;
  Code?: string | null;
  Code_CONTAINS?: string | null;
  Code_ENDS_WITH?: string | null;
  Code_IN?: (string | null)[] | null;
  Code_MATCHES?: string | null;
  Code_NOT?: string | null;
  Code_NOT_CONTAINS?: string | null;
  Code_NOT_ENDS_WITH?: string | null;
  Code_NOT_IN?: (string | null)[] | null;
  Code_NOT_STARTS_WITH?: string | null;
  Code_STARTS_WITH?: string | null;
  Name?: string | null;
  Name_CONTAINS?: string | null;
  Name_ENDS_WITH?: string | null;
  Name_IN?: (string | null)[] | null;
  Name_MATCHES?: string | null;
  Name_NOT?: string | null;
  Name_NOT_CONTAINS?: string | null;
  Name_NOT_ENDS_WITH?: string | null;
  Name_NOT_IN?: (string | null)[] | null;
  Name_NOT_STARTS_WITH?: string | null;
  Name_STARTS_WITH?: string | null;
  OR?: CurrencyWhere[] | null;
  agreements?: AgreementWhere | null;
  agreementsAggregate?: CurrencyAgreementsAggregateInput | null;
  agreementsConnection?: CurrencyAgreementsConnectionWhere | null;
  agreementsConnection_NOT?: CurrencyAgreementsConnectionWhere | null;
  agreements_NOT?: AgreementWhere | null;
  scopes?: AgreementScopeWhere | null;
  scopesAggregate?: CurrencyScopesAggregateInput | null;
  scopesConnection?: CurrencyScopesConnectionWhere | null;
  scopesConnection_NOT?: CurrencyScopesConnectionWhere | null;
  scopes_NOT?: AgreementScopeWhere | null;
  symbol?: string | null;
  symbol_CONTAINS?: string | null;
  symbol_ENDS_WITH?: string | null;
  symbol_IN?: (string | null)[] | null;
  symbol_MATCHES?: string | null;
  symbol_NOT?: string | null;
  symbol_NOT_CONTAINS?: string | null;
  symbol_NOT_ENDS_WITH?: string | null;
  symbol_NOT_IN?: (string | null)[] | null;
  symbol_NOT_STARTS_WITH?: string | null;
  symbol_STARTS_WITH?: string | null;
}

export interface CustomEnrollingConditionAttributeAggregateInput {
  AND?: CustomEnrollingConditionAttributeAggregateInput[] | null;
  OR?: CustomEnrollingConditionAttributeAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: CustomEnrollingConditionAttributeNodeAggregationWhereInput | null;
}

export interface CustomEnrollingConditionAttributeConnectionWhere {
  AND?: CustomEnrollingConditionAttributeConnectionWhere[] | null;
  OR?: CustomEnrollingConditionAttributeConnectionWhere[] | null;
  node?: CatalogueAttributeWhere | null;
  node_NOT?: CatalogueAttributeWhere | null;
}

export interface CustomEnrollingConditionAttributeNodeAggregationWhereInput {
  AND?: CustomEnrollingConditionAttributeNodeAggregationWhereInput[] | null;
  OR?: CustomEnrollingConditionAttributeNodeAggregationWhereInput[] | null;
  caption_AVERAGE_EQUAL?: number | null;
  caption_AVERAGE_GT?: number | null;
  caption_AVERAGE_GTE?: number | null;
  caption_AVERAGE_LT?: number | null;
  caption_AVERAGE_LTE?: number | null;
  caption_EQUAL?: string | null;
  caption_GT?: number | null;
  caption_GTE?: number | null;
  caption_LONGEST_EQUAL?: number | null;
  caption_LONGEST_GT?: number | null;
  caption_LONGEST_GTE?: number | null;
  caption_LONGEST_LT?: number | null;
  caption_LONGEST_LTE?: number | null;
  caption_LT?: number | null;
  caption_LTE?: number | null;
  caption_SHORTEST_EQUAL?: number | null;
  caption_SHORTEST_GT?: number | null;
  caption_SHORTEST_GTE?: number | null;
  caption_SHORTEST_LT?: number | null;
  caption_SHORTEST_LTE?: number | null;
  decimalPrecision_AVERAGE_EQUAL?: number | null;
  decimalPrecision_AVERAGE_GT?: number | null;
  decimalPrecision_AVERAGE_GTE?: number | null;
  decimalPrecision_AVERAGE_LT?: number | null;
  decimalPrecision_AVERAGE_LTE?: number | null;
  decimalPrecision_EQUAL?: number | null;
  decimalPrecision_GT?: number | null;
  decimalPrecision_GTE?: number | null;
  decimalPrecision_LT?: number | null;
  decimalPrecision_LTE?: number | null;
  decimalPrecision_MAX_EQUAL?: number | null;
  decimalPrecision_MAX_GT?: number | null;
  decimalPrecision_MAX_GTE?: number | null;
  decimalPrecision_MAX_LT?: number | null;
  decimalPrecision_MAX_LTE?: number | null;
  decimalPrecision_MIN_EQUAL?: number | null;
  decimalPrecision_MIN_GT?: number | null;
  decimalPrecision_MIN_GTE?: number | null;
  decimalPrecision_MIN_LT?: number | null;
  decimalPrecision_MIN_LTE?: number | null;
  decimalPrecision_SUM_EQUAL?: number | null;
  decimalPrecision_SUM_GT?: number | null;
  decimalPrecision_SUM_GTE?: number | null;
  decimalPrecision_SUM_LT?: number | null;
  decimalPrecision_SUM_LTE?: number | null;
  defaultValue_AVERAGE_EQUAL?: number | null;
  defaultValue_AVERAGE_GT?: number | null;
  defaultValue_AVERAGE_GTE?: number | null;
  defaultValue_AVERAGE_LT?: number | null;
  defaultValue_AVERAGE_LTE?: number | null;
  defaultValue_EQUAL?: string | null;
  defaultValue_GT?: number | null;
  defaultValue_GTE?: number | null;
  defaultValue_LONGEST_EQUAL?: number | null;
  defaultValue_LONGEST_GT?: number | null;
  defaultValue_LONGEST_GTE?: number | null;
  defaultValue_LONGEST_LT?: number | null;
  defaultValue_LONGEST_LTE?: number | null;
  defaultValue_LT?: number | null;
  defaultValue_LTE?: number | null;
  defaultValue_SHORTEST_EQUAL?: number | null;
  defaultValue_SHORTEST_GT?: number | null;
  defaultValue_SHORTEST_GTE?: number | null;
  defaultValue_SHORTEST_LT?: number | null;
  defaultValue_SHORTEST_LTE?: number | null;
  id_AVERAGE_EQUAL?: number | null;
  id_AVERAGE_GT?: number | null;
  id_AVERAGE_GTE?: number | null;
  id_AVERAGE_LT?: number | null;
  id_AVERAGE_LTE?: number | null;
  id_EQUAL?: string | null;
  id_GT?: number | null;
  id_GTE?: number | null;
  id_LONGEST_EQUAL?: number | null;
  id_LONGEST_GT?: number | null;
  id_LONGEST_GTE?: number | null;
  id_LONGEST_LT?: number | null;
  id_LONGEST_LTE?: number | null;
  id_LT?: number | null;
  id_LTE?: number | null;
  id_SHORTEST_EQUAL?: number | null;
  id_SHORTEST_GT?: number | null;
  id_SHORTEST_GTE?: number | null;
  id_SHORTEST_LT?: number | null;
  id_SHORTEST_LTE?: number | null;
  identifier_AVERAGE_EQUAL?: number | null;
  identifier_AVERAGE_GT?: number | null;
  identifier_AVERAGE_GTE?: number | null;
  identifier_AVERAGE_LT?: number | null;
  identifier_AVERAGE_LTE?: number | null;
  identifier_EQUAL?: string | null;
  identifier_GT?: number | null;
  identifier_GTE?: number | null;
  identifier_LONGEST_EQUAL?: number | null;
  identifier_LONGEST_GT?: number | null;
  identifier_LONGEST_GTE?: number | null;
  identifier_LONGEST_LT?: number | null;
  identifier_LONGEST_LTE?: number | null;
  identifier_LT?: number | null;
  identifier_LTE?: number | null;
  identifier_SHORTEST_EQUAL?: number | null;
  identifier_SHORTEST_GT?: number | null;
  identifier_SHORTEST_GTE?: number | null;
  identifier_SHORTEST_LT?: number | null;
  identifier_SHORTEST_LTE?: number | null;
  longLabelLocalizationKey_AVERAGE_EQUAL?: number | null;
  longLabelLocalizationKey_AVERAGE_GT?: number | null;
  longLabelLocalizationKey_AVERAGE_GTE?: number | null;
  longLabelLocalizationKey_AVERAGE_LT?: number | null;
  longLabelLocalizationKey_AVERAGE_LTE?: number | null;
  longLabelLocalizationKey_EQUAL?: string | null;
  longLabelLocalizationKey_GT?: number | null;
  longLabelLocalizationKey_GTE?: number | null;
  longLabelLocalizationKey_LONGEST_EQUAL?: number | null;
  longLabelLocalizationKey_LONGEST_GT?: number | null;
  longLabelLocalizationKey_LONGEST_GTE?: number | null;
  longLabelLocalizationKey_LONGEST_LT?: number | null;
  longLabelLocalizationKey_LONGEST_LTE?: number | null;
  longLabelLocalizationKey_LT?: number | null;
  longLabelLocalizationKey_LTE?: number | null;
  longLabelLocalizationKey_SHORTEST_EQUAL?: number | null;
  longLabelLocalizationKey_SHORTEST_GT?: number | null;
  longLabelLocalizationKey_SHORTEST_GTE?: number | null;
  longLabelLocalizationKey_SHORTEST_LT?: number | null;
  longLabelLocalizationKey_SHORTEST_LTE?: number | null;
  maxLength_AVERAGE_EQUAL?: number | null;
  maxLength_AVERAGE_GT?: number | null;
  maxLength_AVERAGE_GTE?: number | null;
  maxLength_AVERAGE_LT?: number | null;
  maxLength_AVERAGE_LTE?: number | null;
  maxLength_EQUAL?: number | null;
  maxLength_GT?: number | null;
  maxLength_GTE?: number | null;
  maxLength_LT?: number | null;
  maxLength_LTE?: number | null;
  maxLength_MAX_EQUAL?: number | null;
  maxLength_MAX_GT?: number | null;
  maxLength_MAX_GTE?: number | null;
  maxLength_MAX_LT?: number | null;
  maxLength_MAX_LTE?: number | null;
  maxLength_MIN_EQUAL?: number | null;
  maxLength_MIN_GT?: number | null;
  maxLength_MIN_GTE?: number | null;
  maxLength_MIN_LT?: number | null;
  maxLength_MIN_LTE?: number | null;
  maxLength_SUM_EQUAL?: number | null;
  maxLength_SUM_GT?: number | null;
  maxLength_SUM_GTE?: number | null;
  maxLength_SUM_LT?: number | null;
  maxLength_SUM_LTE?: number | null;
  minLength_AVERAGE_EQUAL?: number | null;
  minLength_AVERAGE_GT?: number | null;
  minLength_AVERAGE_GTE?: number | null;
  minLength_AVERAGE_LT?: number | null;
  minLength_AVERAGE_LTE?: number | null;
  minLength_EQUAL?: number | null;
  minLength_GT?: number | null;
  minLength_GTE?: number | null;
  minLength_LT?: number | null;
  minLength_LTE?: number | null;
  minLength_MAX_EQUAL?: number | null;
  minLength_MAX_GT?: number | null;
  minLength_MAX_GTE?: number | null;
  minLength_MAX_LT?: number | null;
  minLength_MAX_LTE?: number | null;
  minLength_MIN_EQUAL?: number | null;
  minLength_MIN_GT?: number | null;
  minLength_MIN_GTE?: number | null;
  minLength_MIN_LT?: number | null;
  minLength_MIN_LTE?: number | null;
  minLength_SUM_EQUAL?: number | null;
  minLength_SUM_GT?: number | null;
  minLength_SUM_GTE?: number | null;
  minLength_SUM_LT?: number | null;
  minLength_SUM_LTE?: number | null;
  rules_AVERAGE_EQUAL?: number | null;
  rules_AVERAGE_GT?: number | null;
  rules_AVERAGE_GTE?: number | null;
  rules_AVERAGE_LT?: number | null;
  rules_AVERAGE_LTE?: number | null;
  rules_EQUAL?: string | null;
  rules_GT?: number | null;
  rules_GTE?: number | null;
  rules_LONGEST_EQUAL?: number | null;
  rules_LONGEST_GT?: number | null;
  rules_LONGEST_GTE?: number | null;
  rules_LONGEST_LT?: number | null;
  rules_LONGEST_LTE?: number | null;
  rules_LT?: number | null;
  rules_LTE?: number | null;
  rules_SHORTEST_EQUAL?: number | null;
  rules_SHORTEST_GT?: number | null;
  rules_SHORTEST_GTE?: number | null;
  rules_SHORTEST_LT?: number | null;
  rules_SHORTEST_LTE?: number | null;
  shortLabelLocalizationKey_AVERAGE_EQUAL?: number | null;
  shortLabelLocalizationKey_AVERAGE_GT?: number | null;
  shortLabelLocalizationKey_AVERAGE_GTE?: number | null;
  shortLabelLocalizationKey_AVERAGE_LT?: number | null;
  shortLabelLocalizationKey_AVERAGE_LTE?: number | null;
  shortLabelLocalizationKey_EQUAL?: string | null;
  shortLabelLocalizationKey_GT?: number | null;
  shortLabelLocalizationKey_GTE?: number | null;
  shortLabelLocalizationKey_LONGEST_EQUAL?: number | null;
  shortLabelLocalizationKey_LONGEST_GT?: number | null;
  shortLabelLocalizationKey_LONGEST_GTE?: number | null;
  shortLabelLocalizationKey_LONGEST_LT?: number | null;
  shortLabelLocalizationKey_LONGEST_LTE?: number | null;
  shortLabelLocalizationKey_LT?: number | null;
  shortLabelLocalizationKey_LTE?: number | null;
  shortLabelLocalizationKey_SHORTEST_EQUAL?: number | null;
  shortLabelLocalizationKey_SHORTEST_GT?: number | null;
  shortLabelLocalizationKey_SHORTEST_GTE?: number | null;
  shortLabelLocalizationKey_SHORTEST_LT?: number | null;
  shortLabelLocalizationKey_SHORTEST_LTE?: number | null;
  values_AVERAGE_EQUAL?: number | null;
  values_AVERAGE_GT?: number | null;
  values_AVERAGE_GTE?: number | null;
  values_AVERAGE_LT?: number | null;
  values_AVERAGE_LTE?: number | null;
  values_EQUAL?: string | null;
  values_GT?: number | null;
  values_GTE?: number | null;
  values_LONGEST_EQUAL?: number | null;
  values_LONGEST_GT?: number | null;
  values_LONGEST_GTE?: number | null;
  values_LONGEST_LT?: number | null;
  values_LONGEST_LTE?: number | null;
  values_LT?: number | null;
  values_LTE?: number | null;
  values_SHORTEST_EQUAL?: number | null;
  values_SHORTEST_GT?: number | null;
  values_SHORTEST_GTE?: number | null;
  values_SHORTEST_LT?: number | null;
  values_SHORTEST_LTE?: number | null;
}

export interface CustomEnrollingConditionCreatedByAggregateInput {
  AND?: CustomEnrollingConditionCreatedByAggregateInput[] | null;
  OR?: CustomEnrollingConditionCreatedByAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: CustomEnrollingConditionCreatedByNodeAggregationWhereInput | null;
}

export interface CustomEnrollingConditionCreatedByConnectionWhere {
  AND?: CustomEnrollingConditionCreatedByConnectionWhere[] | null;
  OR?: CustomEnrollingConditionCreatedByConnectionWhere[] | null;
  node?: UserWhere | null;
  node_NOT?: UserWhere | null;
}

export interface CustomEnrollingConditionCreatedByNodeAggregationWhereInput {
  AND?: CustomEnrollingConditionCreatedByNodeAggregationWhereInput[] | null;
  OR?: CustomEnrollingConditionCreatedByNodeAggregationWhereInput[] | null;
  deletedOn_EQUAL?: any | null;
  deletedOn_GT?: any | null;
  deletedOn_GTE?: any | null;
  deletedOn_LT?: any | null;
  deletedOn_LTE?: any | null;
  deletedOn_MAX_EQUAL?: any | null;
  deletedOn_MAX_GT?: any | null;
  deletedOn_MAX_GTE?: any | null;
  deletedOn_MAX_LT?: any | null;
  deletedOn_MAX_LTE?: any | null;
  deletedOn_MIN_EQUAL?: any | null;
  deletedOn_MIN_GT?: any | null;
  deletedOn_MIN_GTE?: any | null;
  deletedOn_MIN_LT?: any | null;
  deletedOn_MIN_LTE?: any | null;
  department_AVERAGE_EQUAL?: number | null;
  department_AVERAGE_GT?: number | null;
  department_AVERAGE_GTE?: number | null;
  department_AVERAGE_LT?: number | null;
  department_AVERAGE_LTE?: number | null;
  department_EQUAL?: string | null;
  department_GT?: number | null;
  department_GTE?: number | null;
  department_LONGEST_EQUAL?: number | null;
  department_LONGEST_GT?: number | null;
  department_LONGEST_GTE?: number | null;
  department_LONGEST_LT?: number | null;
  department_LONGEST_LTE?: number | null;
  department_LT?: number | null;
  department_LTE?: number | null;
  department_SHORTEST_EQUAL?: number | null;
  department_SHORTEST_GT?: number | null;
  department_SHORTEST_GTE?: number | null;
  department_SHORTEST_LT?: number | null;
  department_SHORTEST_LTE?: number | null;
  email_AVERAGE_EQUAL?: number | null;
  email_AVERAGE_GT?: number | null;
  email_AVERAGE_GTE?: number | null;
  email_AVERAGE_LT?: number | null;
  email_AVERAGE_LTE?: number | null;
  email_EQUAL?: string | null;
  email_GT?: number | null;
  email_GTE?: number | null;
  email_LONGEST_EQUAL?: number | null;
  email_LONGEST_GT?: number | null;
  email_LONGEST_GTE?: number | null;
  email_LONGEST_LT?: number | null;
  email_LONGEST_LTE?: number | null;
  email_LT?: number | null;
  email_LTE?: number | null;
  email_SHORTEST_EQUAL?: number | null;
  email_SHORTEST_GT?: number | null;
  email_SHORTEST_GTE?: number | null;
  email_SHORTEST_LT?: number | null;
  email_SHORTEST_LTE?: number | null;
  firstName_AVERAGE_EQUAL?: number | null;
  firstName_AVERAGE_GT?: number | null;
  firstName_AVERAGE_GTE?: number | null;
  firstName_AVERAGE_LT?: number | null;
  firstName_AVERAGE_LTE?: number | null;
  firstName_EQUAL?: string | null;
  firstName_GT?: number | null;
  firstName_GTE?: number | null;
  firstName_LONGEST_EQUAL?: number | null;
  firstName_LONGEST_GT?: number | null;
  firstName_LONGEST_GTE?: number | null;
  firstName_LONGEST_LT?: number | null;
  firstName_LONGEST_LTE?: number | null;
  firstName_LT?: number | null;
  firstName_LTE?: number | null;
  firstName_SHORTEST_EQUAL?: number | null;
  firstName_SHORTEST_GT?: number | null;
  firstName_SHORTEST_GTE?: number | null;
  firstName_SHORTEST_LT?: number | null;
  firstName_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  lastName_AVERAGE_EQUAL?: number | null;
  lastName_AVERAGE_GT?: number | null;
  lastName_AVERAGE_GTE?: number | null;
  lastName_AVERAGE_LT?: number | null;
  lastName_AVERAGE_LTE?: number | null;
  lastName_EQUAL?: string | null;
  lastName_GT?: number | null;
  lastName_GTE?: number | null;
  lastName_LONGEST_EQUAL?: number | null;
  lastName_LONGEST_GT?: number | null;
  lastName_LONGEST_GTE?: number | null;
  lastName_LONGEST_LT?: number | null;
  lastName_LONGEST_LTE?: number | null;
  lastName_LT?: number | null;
  lastName_LTE?: number | null;
  lastName_SHORTEST_EQUAL?: number | null;
  lastName_SHORTEST_GT?: number | null;
  lastName_SHORTEST_GTE?: number | null;
  lastName_SHORTEST_LT?: number | null;
  lastName_SHORTEST_LTE?: number | null;
  position_AVERAGE_EQUAL?: number | null;
  position_AVERAGE_GT?: number | null;
  position_AVERAGE_GTE?: number | null;
  position_AVERAGE_LT?: number | null;
  position_AVERAGE_LTE?: number | null;
  position_EQUAL?: string | null;
  position_GT?: number | null;
  position_GTE?: number | null;
  position_LONGEST_EQUAL?: number | null;
  position_LONGEST_GT?: number | null;
  position_LONGEST_GTE?: number | null;
  position_LONGEST_LT?: number | null;
  position_LONGEST_LTE?: number | null;
  position_LT?: number | null;
  position_LTE?: number | null;
  position_SHORTEST_EQUAL?: number | null;
  position_SHORTEST_GT?: number | null;
  position_SHORTEST_GTE?: number | null;
  position_SHORTEST_LT?: number | null;
  position_SHORTEST_LTE?: number | null;
  preferredLanguage_AVERAGE_EQUAL?: number | null;
  preferredLanguage_AVERAGE_GT?: number | null;
  preferredLanguage_AVERAGE_GTE?: number | null;
  preferredLanguage_AVERAGE_LT?: number | null;
  preferredLanguage_AVERAGE_LTE?: number | null;
  preferredLanguage_EQUAL?: string | null;
  preferredLanguage_GT?: number | null;
  preferredLanguage_GTE?: number | null;
  preferredLanguage_LONGEST_EQUAL?: number | null;
  preferredLanguage_LONGEST_GT?: number | null;
  preferredLanguage_LONGEST_GTE?: number | null;
  preferredLanguage_LONGEST_LT?: number | null;
  preferredLanguage_LONGEST_LTE?: number | null;
  preferredLanguage_LT?: number | null;
  preferredLanguage_LTE?: number | null;
  preferredLanguage_SHORTEST_EQUAL?: number | null;
  preferredLanguage_SHORTEST_GT?: number | null;
  preferredLanguage_SHORTEST_GTE?: number | null;
  preferredLanguage_SHORTEST_LT?: number | null;
  preferredLanguage_SHORTEST_LTE?: number | null;
  tenantId_AVERAGE_EQUAL?: number | null;
  tenantId_AVERAGE_GT?: number | null;
  tenantId_AVERAGE_GTE?: number | null;
  tenantId_AVERAGE_LT?: number | null;
  tenantId_AVERAGE_LTE?: number | null;
  tenantId_EQUAL?: string | null;
  tenantId_GT?: number | null;
  tenantId_GTE?: number | null;
  tenantId_LONGEST_EQUAL?: number | null;
  tenantId_LONGEST_GT?: number | null;
  tenantId_LONGEST_GTE?: number | null;
  tenantId_LONGEST_LT?: number | null;
  tenantId_LONGEST_LTE?: number | null;
  tenantId_LT?: number | null;
  tenantId_LTE?: number | null;
  tenantId_SHORTEST_EQUAL?: number | null;
  tenantId_SHORTEST_GT?: number | null;
  tenantId_SHORTEST_GTE?: number | null;
  tenantId_SHORTEST_LT?: number | null;
  tenantId_SHORTEST_LTE?: number | null;
}

export interface CustomEnrollingConditionWhere {
  AND?: CustomEnrollingConditionWhere[] | null;
  OR?: CustomEnrollingConditionWhere[] | null;
  attribute?: CatalogueAttributeWhere | null;
  attributeAggregate?: CustomEnrollingConditionAttributeAggregateInput | null;
  attributeConnection?: CustomEnrollingConditionAttributeConnectionWhere | null;
  attributeConnection_NOT?: CustomEnrollingConditionAttributeConnectionWhere | null;
  attribute_NOT?: CatalogueAttributeWhere | null;
  createdBy?: UserWhere | null;
  createdByAggregate?: CustomEnrollingConditionCreatedByAggregateInput | null;
  createdByConnection?: CustomEnrollingConditionCreatedByConnectionWhere | null;
  createdByConnection_NOT?: CustomEnrollingConditionCreatedByConnectionWhere | null;
  createdBy_NOT?: UserWhere | null;
  createdOn?: any | null;
  createdOn_GT?: any | null;
  createdOn_GTE?: any | null;
  createdOn_IN?: (any | null)[] | null;
  createdOn_LT?: any | null;
  createdOn_LTE?: any | null;
  createdOn_NOT?: any | null;
  createdOn_NOT_IN?: (any | null)[] | null;
  description?: string | null;
  description_CONTAINS?: string | null;
  description_ENDS_WITH?: string | null;
  description_IN?: (string | null)[] | null;
  description_MATCHES?: string | null;
  description_NOT?: string | null;
  description_NOT_CONTAINS?: string | null;
  description_NOT_ENDS_WITH?: string | null;
  description_NOT_IN?: (string | null)[] | null;
  description_NOT_STARTS_WITH?: string | null;
  description_STARTS_WITH?: string | null;
  id?: string | null;
  id_CONTAINS?: string | null;
  id_ENDS_WITH?: string | null;
  id_IN?: (string | null)[] | null;
  id_MATCHES?: string | null;
  id_NOT?: string | null;
  id_NOT_CONTAINS?: string | null;
  id_NOT_ENDS_WITH?: string | null;
  id_NOT_IN?: (string | null)[] | null;
  id_NOT_STARTS_WITH?: string | null;
  id_STARTS_WITH?: string | null;
  name?: string | null;
  name_CONTAINS?: string | null;
  name_ENDS_WITH?: string | null;
  name_IN?: (string | null)[] | null;
  name_MATCHES?: string | null;
  name_NOT?: string | null;
  name_NOT_CONTAINS?: string | null;
  name_NOT_ENDS_WITH?: string | null;
  name_NOT_IN?: (string | null)[] | null;
  name_NOT_STARTS_WITH?: string | null;
  name_STARTS_WITH?: string | null;
  type?: string | null;
  type_CONTAINS?: string | null;
  type_ENDS_WITH?: string | null;
  type_IN?: (string | null)[] | null;
  type_MATCHES?: string | null;
  type_NOT?: string | null;
  type_NOT_CONTAINS?: string | null;
  type_NOT_ENDS_WITH?: string | null;
  type_NOT_IN?: (string | null)[] | null;
  type_NOT_STARTS_WITH?: string | null;
  type_STARTS_WITH?: string | null;
}

export interface CycleConfigurationRecordTypeAggregateInput {
  AND?: CycleConfigurationRecordTypeAggregateInput[] | null;
  OR?: CycleConfigurationRecordTypeAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: CycleConfigurationRecordTypeNodeAggregationWhereInput | null;
}

export interface CycleConfigurationRecordTypeConnectionWhere {
  AND?: CycleConfigurationRecordTypeConnectionWhere[] | null;
  OR?: CycleConfigurationRecordTypeConnectionWhere[] | null;
  node?: FlexEntityTypeWhere | null;
  node_NOT?: FlexEntityTypeWhere | null;
}

export interface CycleConfigurationRecordTypeNodeAggregationWhereInput {
  AND?: CycleConfigurationRecordTypeNodeAggregationWhereInput[] | null;
  OR?: CycleConfigurationRecordTypeNodeAggregationWhereInput[] | null;
  addedByName_AVERAGE_EQUAL?: number | null;
  addedByName_AVERAGE_GT?: number | null;
  addedByName_AVERAGE_GTE?: number | null;
  addedByName_AVERAGE_LT?: number | null;
  addedByName_AVERAGE_LTE?: number | null;
  addedByName_EQUAL?: string | null;
  addedByName_GT?: number | null;
  addedByName_GTE?: number | null;
  addedByName_LONGEST_EQUAL?: number | null;
  addedByName_LONGEST_GT?: number | null;
  addedByName_LONGEST_GTE?: number | null;
  addedByName_LONGEST_LT?: number | null;
  addedByName_LONGEST_LTE?: number | null;
  addedByName_LT?: number | null;
  addedByName_LTE?: number | null;
  addedByName_SHORTEST_EQUAL?: number | null;
  addedByName_SHORTEST_GT?: number | null;
  addedByName_SHORTEST_GTE?: number | null;
  addedByName_SHORTEST_LT?: number | null;
  addedByName_SHORTEST_LTE?: number | null;
  attributeCount_AVERAGE_EQUAL?: number | null;
  attributeCount_AVERAGE_GT?: number | null;
  attributeCount_AVERAGE_GTE?: number | null;
  attributeCount_AVERAGE_LT?: number | null;
  attributeCount_AVERAGE_LTE?: number | null;
  attributeCount_EQUAL?: number | null;
  attributeCount_GT?: number | null;
  attributeCount_GTE?: number | null;
  attributeCount_LT?: number | null;
  attributeCount_LTE?: number | null;
  attributeCount_MAX_EQUAL?: number | null;
  attributeCount_MAX_GT?: number | null;
  attributeCount_MAX_GTE?: number | null;
  attributeCount_MAX_LT?: number | null;
  attributeCount_MAX_LTE?: number | null;
  attributeCount_MIN_EQUAL?: number | null;
  attributeCount_MIN_GT?: number | null;
  attributeCount_MIN_GTE?: number | null;
  attributeCount_MIN_LT?: number | null;
  attributeCount_MIN_LTE?: number | null;
  attributeCount_SUM_EQUAL?: number | null;
  attributeCount_SUM_GT?: number | null;
  attributeCount_SUM_GTE?: number | null;
  attributeCount_SUM_LT?: number | null;
  attributeCount_SUM_LTE?: number | null;
  createdOn_EQUAL?: any | null;
  createdOn_GT?: any | null;
  createdOn_GTE?: any | null;
  createdOn_LT?: any | null;
  createdOn_LTE?: any | null;
  createdOn_MAX_EQUAL?: any | null;
  createdOn_MAX_GT?: any | null;
  createdOn_MAX_GTE?: any | null;
  createdOn_MAX_LT?: any | null;
  createdOn_MAX_LTE?: any | null;
  createdOn_MIN_EQUAL?: any | null;
  createdOn_MIN_GT?: any | null;
  createdOn_MIN_GTE?: any | null;
  createdOn_MIN_LT?: any | null;
  createdOn_MIN_LTE?: any | null;
  data_AVERAGE_EQUAL?: number | null;
  data_AVERAGE_GT?: number | null;
  data_AVERAGE_GTE?: number | null;
  data_AVERAGE_LT?: number | null;
  data_AVERAGE_LTE?: number | null;
  data_EQUAL?: string | null;
  data_GT?: number | null;
  data_GTE?: number | null;
  data_LONGEST_EQUAL?: number | null;
  data_LONGEST_GT?: number | null;
  data_LONGEST_GTE?: number | null;
  data_LONGEST_LT?: number | null;
  data_LONGEST_LTE?: number | null;
  data_LT?: number | null;
  data_LTE?: number | null;
  data_SHORTEST_EQUAL?: number | null;
  data_SHORTEST_GT?: number | null;
  data_SHORTEST_GTE?: number | null;
  data_SHORTEST_LT?: number | null;
  data_SHORTEST_LTE?: number | null;
  description_AVERAGE_EQUAL?: number | null;
  description_AVERAGE_GT?: number | null;
  description_AVERAGE_GTE?: number | null;
  description_AVERAGE_LT?: number | null;
  description_AVERAGE_LTE?: number | null;
  description_EQUAL?: string | null;
  description_GT?: number | null;
  description_GTE?: number | null;
  description_LONGEST_EQUAL?: number | null;
  description_LONGEST_GT?: number | null;
  description_LONGEST_GTE?: number | null;
  description_LONGEST_LT?: number | null;
  description_LONGEST_LTE?: number | null;
  description_LT?: number | null;
  description_LTE?: number | null;
  description_SHORTEST_EQUAL?: number | null;
  description_SHORTEST_GT?: number | null;
  description_SHORTEST_GTE?: number | null;
  description_SHORTEST_LT?: number | null;
  description_SHORTEST_LTE?: number | null;
  idPrefix_AVERAGE_EQUAL?: number | null;
  idPrefix_AVERAGE_GT?: number | null;
  idPrefix_AVERAGE_GTE?: number | null;
  idPrefix_AVERAGE_LT?: number | null;
  idPrefix_AVERAGE_LTE?: number | null;
  idPrefix_EQUAL?: string | null;
  idPrefix_GT?: number | null;
  idPrefix_GTE?: number | null;
  idPrefix_LONGEST_EQUAL?: number | null;
  idPrefix_LONGEST_GT?: number | null;
  idPrefix_LONGEST_GTE?: number | null;
  idPrefix_LONGEST_LT?: number | null;
  idPrefix_LONGEST_LTE?: number | null;
  idPrefix_LT?: number | null;
  idPrefix_LTE?: number | null;
  idPrefix_SHORTEST_EQUAL?: number | null;
  idPrefix_SHORTEST_GT?: number | null;
  idPrefix_SHORTEST_GTE?: number | null;
  idPrefix_SHORTEST_LT?: number | null;
  idPrefix_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  localizationKey_AVERAGE_EQUAL?: number | null;
  localizationKey_AVERAGE_GT?: number | null;
  localizationKey_AVERAGE_GTE?: number | null;
  localizationKey_AVERAGE_LT?: number | null;
  localizationKey_AVERAGE_LTE?: number | null;
  localizationKey_EQUAL?: string | null;
  localizationKey_GT?: number | null;
  localizationKey_GTE?: number | null;
  localizationKey_LONGEST_EQUAL?: number | null;
  localizationKey_LONGEST_GT?: number | null;
  localizationKey_LONGEST_GTE?: number | null;
  localizationKey_LONGEST_LT?: number | null;
  localizationKey_LONGEST_LTE?: number | null;
  localizationKey_LT?: number | null;
  localizationKey_LTE?: number | null;
  localizationKey_SHORTEST_EQUAL?: number | null;
  localizationKey_SHORTEST_GT?: number | null;
  localizationKey_SHORTEST_GTE?: number | null;
  localizationKey_SHORTEST_LT?: number | null;
  localizationKey_SHORTEST_LTE?: number | null;
  name_AVERAGE_EQUAL?: number | null;
  name_AVERAGE_GT?: number | null;
  name_AVERAGE_GTE?: number | null;
  name_AVERAGE_LT?: number | null;
  name_AVERAGE_LTE?: number | null;
  name_EQUAL?: string | null;
  name_GT?: number | null;
  name_GTE?: number | null;
  name_LONGEST_EQUAL?: number | null;
  name_LONGEST_GT?: number | null;
  name_LONGEST_GTE?: number | null;
  name_LONGEST_LT?: number | null;
  name_LONGEST_LTE?: number | null;
  name_LT?: number | null;
  name_LTE?: number | null;
  name_SHORTEST_EQUAL?: number | null;
  name_SHORTEST_GT?: number | null;
  name_SHORTEST_GTE?: number | null;
  name_SHORTEST_LT?: number | null;
  name_SHORTEST_LTE?: number | null;
  tooltipText_AVERAGE_EQUAL?: number | null;
  tooltipText_AVERAGE_GT?: number | null;
  tooltipText_AVERAGE_GTE?: number | null;
  tooltipText_AVERAGE_LT?: number | null;
  tooltipText_AVERAGE_LTE?: number | null;
  tooltipText_EQUAL?: string | null;
  tooltipText_GT?: number | null;
  tooltipText_GTE?: number | null;
  tooltipText_LONGEST_EQUAL?: number | null;
  tooltipText_LONGEST_GT?: number | null;
  tooltipText_LONGEST_GTE?: number | null;
  tooltipText_LONGEST_LT?: number | null;
  tooltipText_LONGEST_LTE?: number | null;
  tooltipText_LT?: number | null;
  tooltipText_LTE?: number | null;
  tooltipText_SHORTEST_EQUAL?: number | null;
  tooltipText_SHORTEST_GT?: number | null;
  tooltipText_SHORTEST_GTE?: number | null;
  tooltipText_SHORTEST_LT?: number | null;
  tooltipText_SHORTEST_LTE?: number | null;
}

export interface CycleConfigurationScopeAggregateInput {
  AND?: CycleConfigurationScopeAggregateInput[] | null;
  OR?: CycleConfigurationScopeAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: CycleConfigurationScopeNodeAggregationWhereInput | null;
}

export interface CycleConfigurationScopeConnectionWhere {
  AND?: CycleConfigurationScopeConnectionWhere[] | null;
  OR?: CycleConfigurationScopeConnectionWhere[] | null;
  node?: AgreementScopeWhere | null;
  node_NOT?: AgreementScopeWhere | null;
}

export interface CycleConfigurationScopeNodeAggregationWhereInput {
  AND?: CycleConfigurationScopeNodeAggregationWhereInput[] | null;
  OR?: CycleConfigurationScopeNodeAggregationWhereInput[] | null;
  code_AVERAGE_EQUAL?: number | null;
  code_AVERAGE_GT?: number | null;
  code_AVERAGE_GTE?: number | null;
  code_AVERAGE_LT?: number | null;
  code_AVERAGE_LTE?: number | null;
  code_EQUAL?: string | null;
  code_GT?: number | null;
  code_GTE?: number | null;
  code_LONGEST_EQUAL?: number | null;
  code_LONGEST_GT?: number | null;
  code_LONGEST_GTE?: number | null;
  code_LONGEST_LT?: number | null;
  code_LONGEST_LTE?: number | null;
  code_LT?: number | null;
  code_LTE?: number | null;
  code_SHORTEST_EQUAL?: number | null;
  code_SHORTEST_GT?: number | null;
  code_SHORTEST_GTE?: number | null;
  code_SHORTEST_LT?: number | null;
  code_SHORTEST_LTE?: number | null;
  order_AVERAGE_EQUAL?: number | null;
  order_AVERAGE_GT?: number | null;
  order_AVERAGE_GTE?: number | null;
  order_AVERAGE_LT?: number | null;
  order_AVERAGE_LTE?: number | null;
  order_EQUAL?: number | null;
  order_GT?: number | null;
  order_GTE?: number | null;
  order_LT?: number | null;
  order_LTE?: number | null;
  order_MAX_EQUAL?: number | null;
  order_MAX_GT?: number | null;
  order_MAX_GTE?: number | null;
  order_MAX_LT?: number | null;
  order_MAX_LTE?: number | null;
  order_MIN_EQUAL?: number | null;
  order_MIN_GT?: number | null;
  order_MIN_GTE?: number | null;
  order_MIN_LT?: number | null;
  order_MIN_LTE?: number | null;
  order_SUM_EQUAL?: number | null;
  order_SUM_GT?: number | null;
  order_SUM_GTE?: number | null;
  order_SUM_LT?: number | null;
  order_SUM_LTE?: number | null;
  scopeId_AVERAGE_EQUAL?: number | null;
  scopeId_AVERAGE_GT?: number | null;
  scopeId_AVERAGE_GTE?: number | null;
  scopeId_AVERAGE_LT?: number | null;
  scopeId_AVERAGE_LTE?: number | null;
  scopeId_EQUAL?: string | null;
  scopeId_GT?: number | null;
  scopeId_GTE?: number | null;
  scopeId_LONGEST_EQUAL?: number | null;
  scopeId_LONGEST_GT?: number | null;
  scopeId_LONGEST_GTE?: number | null;
  scopeId_LONGEST_LT?: number | null;
  scopeId_LONGEST_LTE?: number | null;
  scopeId_LT?: number | null;
  scopeId_LTE?: number | null;
  scopeId_SHORTEST_EQUAL?: number | null;
  scopeId_SHORTEST_GT?: number | null;
  scopeId_SHORTEST_GTE?: number | null;
  scopeId_SHORTEST_LT?: number | null;
  scopeId_SHORTEST_LTE?: number | null;
}

export interface CycleConfigurationStartingTreatmentAggregateInput {
  AND?: CycleConfigurationStartingTreatmentAggregateInput[] | null;
  OR?: CycleConfigurationStartingTreatmentAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: CycleConfigurationStartingTreatmentNodeAggregationWhereInput | null;
}

export interface CycleConfigurationStartingTreatmentBrandAggregateInput {
  AND?: CycleConfigurationStartingTreatmentBrandAggregateInput[] | null;
  OR?: CycleConfigurationStartingTreatmentBrandAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: CycleConfigurationStartingTreatmentBrandNodeAggregationWhereInput | null;
}

export interface CycleConfigurationStartingTreatmentBrandConnectionWhere {
  AND?: CycleConfigurationStartingTreatmentBrandConnectionWhere[] | null;
  OR?: CycleConfigurationStartingTreatmentBrandConnectionWhere[] | null;
  node?: BrandWhere | null;
  node_NOT?: BrandWhere | null;
}

export interface CycleConfigurationStartingTreatmentBrandNodeAggregationWhereInput {
  AND?: CycleConfigurationStartingTreatmentBrandNodeAggregationWhereInput[] | null;
  Name_AVERAGE_EQUAL?: number | null;
  Name_AVERAGE_GT?: number | null;
  Name_AVERAGE_GTE?: number | null;
  Name_AVERAGE_LT?: number | null;
  Name_AVERAGE_LTE?: number | null;
  Name_EQUAL?: string | null;
  Name_GT?: number | null;
  Name_GTE?: number | null;
  Name_LONGEST_EQUAL?: number | null;
  Name_LONGEST_GT?: number | null;
  Name_LONGEST_GTE?: number | null;
  Name_LONGEST_LT?: number | null;
  Name_LONGEST_LTE?: number | null;
  Name_LT?: number | null;
  Name_LTE?: number | null;
  Name_SHORTEST_EQUAL?: number | null;
  Name_SHORTEST_GT?: number | null;
  Name_SHORTEST_GTE?: number | null;
  Name_SHORTEST_LT?: number | null;
  Name_SHORTEST_LTE?: number | null;
  OR?: CycleConfigurationStartingTreatmentBrandNodeAggregationWhereInput[] | null;
  id_EQUAL?: string | null;
}

export interface CycleConfigurationStartingTreatmentConnectionWhere {
  AND?: CycleConfigurationStartingTreatmentConnectionWhere[] | null;
  OR?: CycleConfigurationStartingTreatmentConnectionWhere[] | null;
  node?: TreatmentWhere | null;
  node_NOT?: TreatmentWhere | null;
}

export interface CycleConfigurationStartingTreatmentGenericAggregateInput {
  AND?: CycleConfigurationStartingTreatmentGenericAggregateInput[] | null;
  OR?: CycleConfigurationStartingTreatmentGenericAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: CycleConfigurationStartingTreatmentGenericNodeAggregationWhereInput | null;
}

export interface CycleConfigurationStartingTreatmentGenericConnectionWhere {
  AND?: CycleConfigurationStartingTreatmentGenericConnectionWhere[] | null;
  OR?: CycleConfigurationStartingTreatmentGenericConnectionWhere[] | null;
  node?: GenericWhere | null;
  node_NOT?: GenericWhere | null;
}

export interface CycleConfigurationStartingTreatmentGenericNodeAggregationWhereInput {
  AND?: CycleConfigurationStartingTreatmentGenericNodeAggregationWhereInput[] | null;
  Name_AVERAGE_EQUAL?: number | null;
  Name_AVERAGE_GT?: number | null;
  Name_AVERAGE_GTE?: number | null;
  Name_AVERAGE_LT?: number | null;
  Name_AVERAGE_LTE?: number | null;
  Name_EQUAL?: string | null;
  Name_GT?: number | null;
  Name_GTE?: number | null;
  Name_LONGEST_EQUAL?: number | null;
  Name_LONGEST_GT?: number | null;
  Name_LONGEST_GTE?: number | null;
  Name_LONGEST_LT?: number | null;
  Name_LONGEST_LTE?: number | null;
  Name_LT?: number | null;
  Name_LTE?: number | null;
  Name_SHORTEST_EQUAL?: number | null;
  Name_SHORTEST_GT?: number | null;
  Name_SHORTEST_GTE?: number | null;
  Name_SHORTEST_LT?: number | null;
  Name_SHORTEST_LTE?: number | null;
  OR?: CycleConfigurationStartingTreatmentGenericNodeAggregationWhereInput[] | null;
  id_EQUAL?: string | null;
}

export interface CycleConfigurationStartingTreatmentNodeAggregationWhereInput {
  AND?: CycleConfigurationStartingTreatmentNodeAggregationWhereInput[] | null;
  BagDossierNo_AVERAGE_EQUAL?: number | null;
  BagDossierNo_AVERAGE_GT?: number | null;
  BagDossierNo_AVERAGE_GTE?: number | null;
  BagDossierNo_AVERAGE_LT?: number | null;
  BagDossierNo_AVERAGE_LTE?: number | null;
  BagDossierNo_EQUAL?: string | null;
  BagDossierNo_GT?: number | null;
  BagDossierNo_GTE?: number | null;
  BagDossierNo_LONGEST_EQUAL?: number | null;
  BagDossierNo_LONGEST_GT?: number | null;
  BagDossierNo_LONGEST_GTE?: number | null;
  BagDossierNo_LONGEST_LT?: number | null;
  BagDossierNo_LONGEST_LTE?: number | null;
  BagDossierNo_LT?: number | null;
  BagDossierNo_LTE?: number | null;
  BagDossierNo_SHORTEST_EQUAL?: number | null;
  BagDossierNo_SHORTEST_GT?: number | null;
  BagDossierNo_SHORTEST_GTE?: number | null;
  BagDossierNo_SHORTEST_LT?: number | null;
  BagDossierNo_SHORTEST_LTE?: number | null;
  Code_AVERAGE_EQUAL?: number | null;
  Code_AVERAGE_GT?: number | null;
  Code_AVERAGE_GTE?: number | null;
  Code_AVERAGE_LT?: number | null;
  Code_AVERAGE_LTE?: number | null;
  Code_EQUAL?: string | null;
  Code_GT?: number | null;
  Code_GTE?: number | null;
  Code_LONGEST_EQUAL?: number | null;
  Code_LONGEST_GT?: number | null;
  Code_LONGEST_GTE?: number | null;
  Code_LONGEST_LT?: number | null;
  Code_LONGEST_LTE?: number | null;
  Code_LT?: number | null;
  Code_LTE?: number | null;
  Code_SHORTEST_EQUAL?: number | null;
  Code_SHORTEST_GT?: number | null;
  Code_SHORTEST_GTE?: number | null;
  Code_SHORTEST_LT?: number | null;
  Code_SHORTEST_LTE?: number | null;
  FlagModal_AVERAGE_EQUAL?: number | null;
  FlagModal_AVERAGE_GT?: number | null;
  FlagModal_AVERAGE_GTE?: number | null;
  FlagModal_AVERAGE_LT?: number | null;
  FlagModal_AVERAGE_LTE?: number | null;
  FlagModal_EQUAL?: string | null;
  FlagModal_GT?: number | null;
  FlagModal_GTE?: number | null;
  FlagModal_LONGEST_EQUAL?: number | null;
  FlagModal_LONGEST_GT?: number | null;
  FlagModal_LONGEST_GTE?: number | null;
  FlagModal_LONGEST_LT?: number | null;
  FlagModal_LONGEST_LTE?: number | null;
  FlagModal_LT?: number | null;
  FlagModal_LTE?: number | null;
  FlagModal_SHORTEST_EQUAL?: number | null;
  FlagModal_SHORTEST_GT?: number | null;
  FlagModal_SHORTEST_GTE?: number | null;
  FlagModal_SHORTEST_LT?: number | null;
  FlagModal_SHORTEST_LTE?: number | null;
  FlagNarcosis_AVERAGE_EQUAL?: number | null;
  FlagNarcosis_AVERAGE_GT?: number | null;
  FlagNarcosis_AVERAGE_GTE?: number | null;
  FlagNarcosis_AVERAGE_LT?: number | null;
  FlagNarcosis_AVERAGE_LTE?: number | null;
  FlagNarcosis_EQUAL?: string | null;
  FlagNarcosis_GT?: number | null;
  FlagNarcosis_GTE?: number | null;
  FlagNarcosis_LONGEST_EQUAL?: number | null;
  FlagNarcosis_LONGEST_GT?: number | null;
  FlagNarcosis_LONGEST_GTE?: number | null;
  FlagNarcosis_LONGEST_LT?: number | null;
  FlagNarcosis_LONGEST_LTE?: number | null;
  FlagNarcosis_LT?: number | null;
  FlagNarcosis_LTE?: number | null;
  FlagNarcosis_SHORTEST_EQUAL?: number | null;
  FlagNarcosis_SHORTEST_GT?: number | null;
  FlagNarcosis_SHORTEST_GTE?: number | null;
  FlagNarcosis_SHORTEST_LT?: number | null;
  FlagNarcosis_SHORTEST_LTE?: number | null;
  GTIN_AVERAGE_EQUAL?: number | null;
  GTIN_AVERAGE_GT?: number | null;
  GTIN_AVERAGE_GTE?: number | null;
  GTIN_AVERAGE_LT?: number | null;
  GTIN_AVERAGE_LTE?: number | null;
  GTIN_EQUAL?: string | null;
  GTIN_GT?: number | null;
  GTIN_GTE?: number | null;
  GTIN_LONGEST_EQUAL?: number | null;
  GTIN_LONGEST_GT?: number | null;
  GTIN_LONGEST_GTE?: number | null;
  GTIN_LONGEST_LT?: number | null;
  GTIN_LONGEST_LTE?: number | null;
  GTIN_LT?: number | null;
  GTIN_LTE?: number | null;
  GTIN_SHORTEST_EQUAL?: number | null;
  GTIN_SHORTEST_GT?: number | null;
  GTIN_SHORTEST_GTE?: number | null;
  GTIN_SHORTEST_LT?: number | null;
  GTIN_SHORTEST_LTE?: number | null;
  LOT_AVERAGE_EQUAL?: number | null;
  LOT_AVERAGE_GT?: number | null;
  LOT_AVERAGE_GTE?: number | null;
  LOT_AVERAGE_LT?: number | null;
  LOT_AVERAGE_LTE?: number | null;
  LOT_EQUAL?: string | null;
  LOT_GT?: number | null;
  LOT_GTE?: number | null;
  LOT_LONGEST_EQUAL?: number | null;
  LOT_LONGEST_GT?: number | null;
  LOT_LONGEST_GTE?: number | null;
  LOT_LONGEST_LT?: number | null;
  LOT_LONGEST_LTE?: number | null;
  LOT_LT?: number | null;
  LOT_LTE?: number | null;
  LOT_SHORTEST_EQUAL?: number | null;
  LOT_SHORTEST_GT?: number | null;
  LOT_SHORTEST_GTE?: number | null;
  LOT_SHORTEST_LT?: number | null;
  LOT_SHORTEST_LTE?: number | null;
  Name_AVERAGE_EQUAL?: number | null;
  Name_AVERAGE_GT?: number | null;
  Name_AVERAGE_GTE?: number | null;
  Name_AVERAGE_LT?: number | null;
  Name_AVERAGE_LTE?: number | null;
  Name_EQUAL?: string | null;
  Name_GT?: number | null;
  Name_GTE?: number | null;
  Name_LONGEST_EQUAL?: number | null;
  Name_LONGEST_GT?: number | null;
  Name_LONGEST_GTE?: number | null;
  Name_LONGEST_LT?: number | null;
  Name_LONGEST_LTE?: number | null;
  Name_LT?: number | null;
  Name_LTE?: number | null;
  Name_SHORTEST_EQUAL?: number | null;
  Name_SHORTEST_GT?: number | null;
  Name_SHORTEST_GTE?: number | null;
  Name_SHORTEST_LT?: number | null;
  Name_SHORTEST_LTE?: number | null;
  OR?: CycleConfigurationStartingTreatmentNodeAggregationWhereInput[] | null;
  PharmaCode_AVERAGE_EQUAL?: number | null;
  PharmaCode_AVERAGE_GT?: number | null;
  PharmaCode_AVERAGE_GTE?: number | null;
  PharmaCode_AVERAGE_LT?: number | null;
  PharmaCode_AVERAGE_LTE?: number | null;
  PharmaCode_EQUAL?: string | null;
  PharmaCode_GT?: number | null;
  PharmaCode_GTE?: number | null;
  PharmaCode_LONGEST_EQUAL?: number | null;
  PharmaCode_LONGEST_GT?: number | null;
  PharmaCode_LONGEST_GTE?: number | null;
  PharmaCode_LONGEST_LT?: number | null;
  PharmaCode_LONGEST_LTE?: number | null;
  PharmaCode_LT?: number | null;
  PharmaCode_LTE?: number | null;
  PharmaCode_SHORTEST_EQUAL?: number | null;
  PharmaCode_SHORTEST_GT?: number | null;
  PharmaCode_SHORTEST_GTE?: number | null;
  PharmaCode_SHORTEST_LT?: number | null;
  PharmaCode_SHORTEST_LTE?: number | null;
  PrevPharmacode_AVERAGE_EQUAL?: number | null;
  PrevPharmacode_AVERAGE_GT?: number | null;
  PrevPharmacode_AVERAGE_GTE?: number | null;
  PrevPharmacode_AVERAGE_LT?: number | null;
  PrevPharmacode_AVERAGE_LTE?: number | null;
  PrevPharmacode_EQUAL?: string | null;
  PrevPharmacode_GT?: number | null;
  PrevPharmacode_GTE?: number | null;
  PrevPharmacode_LONGEST_EQUAL?: number | null;
  PrevPharmacode_LONGEST_GT?: number | null;
  PrevPharmacode_LONGEST_GTE?: number | null;
  PrevPharmacode_LONGEST_LT?: number | null;
  PrevPharmacode_LONGEST_LTE?: number | null;
  PrevPharmacode_LT?: number | null;
  PrevPharmacode_LTE?: number | null;
  PrevPharmacode_SHORTEST_EQUAL?: number | null;
  PrevPharmacode_SHORTEST_GT?: number | null;
  PrevPharmacode_SHORTEST_GTE?: number | null;
  PrevPharmacode_SHORTEST_LT?: number | null;
  PrevPharmacode_SHORTEST_LTE?: number | null;
  REF_AVERAGE_EQUAL?: number | null;
  REF_AVERAGE_GT?: number | null;
  REF_AVERAGE_GTE?: number | null;
  REF_AVERAGE_LT?: number | null;
  REF_AVERAGE_LTE?: number | null;
  REF_EQUAL?: string | null;
  REF_GT?: number | null;
  REF_GTE?: number | null;
  REF_LONGEST_EQUAL?: number | null;
  REF_LONGEST_GT?: number | null;
  REF_LONGEST_GTE?: number | null;
  REF_LONGEST_LT?: number | null;
  REF_LONGEST_LTE?: number | null;
  REF_LT?: number | null;
  REF_LTE?: number | null;
  REF_SHORTEST_EQUAL?: number | null;
  REF_SHORTEST_GT?: number | null;
  REF_SHORTEST_GTE?: number | null;
  REF_SHORTEST_LT?: number | null;
  REF_SHORTEST_LTE?: number | null;
  SwissmedicCategory_AVERAGE_EQUAL?: number | null;
  SwissmedicCategory_AVERAGE_GT?: number | null;
  SwissmedicCategory_AVERAGE_GTE?: number | null;
  SwissmedicCategory_AVERAGE_LT?: number | null;
  SwissmedicCategory_AVERAGE_LTE?: number | null;
  SwissmedicCategory_EQUAL?: string | null;
  SwissmedicCategory_GT?: number | null;
  SwissmedicCategory_GTE?: number | null;
  SwissmedicCategory_LONGEST_EQUAL?: number | null;
  SwissmedicCategory_LONGEST_GT?: number | null;
  SwissmedicCategory_LONGEST_GTE?: number | null;
  SwissmedicCategory_LONGEST_LT?: number | null;
  SwissmedicCategory_LONGEST_LTE?: number | null;
  SwissmedicCategory_LT?: number | null;
  SwissmedicCategory_LTE?: number | null;
  SwissmedicCategory_SHORTEST_EQUAL?: number | null;
  SwissmedicCategory_SHORTEST_GT?: number | null;
  SwissmedicCategory_SHORTEST_GTE?: number | null;
  SwissmedicCategory_SHORTEST_LT?: number | null;
  SwissmedicCategory_SHORTEST_LTE?: number | null;
  SwissmedicNo8_AVERAGE_EQUAL?: number | null;
  SwissmedicNo8_AVERAGE_GT?: number | null;
  SwissmedicNo8_AVERAGE_GTE?: number | null;
  SwissmedicNo8_AVERAGE_LT?: number | null;
  SwissmedicNo8_AVERAGE_LTE?: number | null;
  SwissmedicNo8_EQUAL?: string | null;
  SwissmedicNo8_GT?: number | null;
  SwissmedicNo8_GTE?: number | null;
  SwissmedicNo8_LONGEST_EQUAL?: number | null;
  SwissmedicNo8_LONGEST_GT?: number | null;
  SwissmedicNo8_LONGEST_GTE?: number | null;
  SwissmedicNo8_LONGEST_LT?: number | null;
  SwissmedicNo8_LONGEST_LTE?: number | null;
  SwissmedicNo8_LT?: number | null;
  SwissmedicNo8_LTE?: number | null;
  SwissmedicNo8_SHORTEST_EQUAL?: number | null;
  SwissmedicNo8_SHORTEST_GT?: number | null;
  SwissmedicNo8_SHORTEST_GTE?: number | null;
  SwissmedicNo8_SHORTEST_LT?: number | null;
  SwissmedicNo8_SHORTEST_LTE?: number | null;
  UDI_AVERAGE_EQUAL?: number | null;
  UDI_AVERAGE_GT?: number | null;
  UDI_AVERAGE_GTE?: number | null;
  UDI_AVERAGE_LT?: number | null;
  UDI_AVERAGE_LTE?: number | null;
  UDI_EQUAL?: string | null;
  UDI_GT?: number | null;
  UDI_GTE?: number | null;
  UDI_LONGEST_EQUAL?: number | null;
  UDI_LONGEST_GT?: number | null;
  UDI_LONGEST_GTE?: number | null;
  UDI_LONGEST_LT?: number | null;
  UDI_LONGEST_LTE?: number | null;
  UDI_LT?: number | null;
  UDI_LTE?: number | null;
  UDI_SHORTEST_EQUAL?: number | null;
  UDI_SHORTEST_GT?: number | null;
  UDI_SHORTEST_GTE?: number | null;
  UDI_SHORTEST_LT?: number | null;
  UDI_SHORTEST_LTE?: number | null;
  activeIngredientQuantity_AVERAGE_EQUAL?: number | null;
  activeIngredientQuantity_AVERAGE_GT?: number | null;
  activeIngredientQuantity_AVERAGE_GTE?: number | null;
  activeIngredientQuantity_AVERAGE_LT?: number | null;
  activeIngredientQuantity_AVERAGE_LTE?: number | null;
  activeIngredientQuantity_EQUAL?: number | null;
  activeIngredientQuantity_GT?: number | null;
  activeIngredientQuantity_GTE?: number | null;
  activeIngredientQuantity_LT?: number | null;
  activeIngredientQuantity_LTE?: number | null;
  activeIngredientQuantity_MAX_EQUAL?: number | null;
  activeIngredientQuantity_MAX_GT?: number | null;
  activeIngredientQuantity_MAX_GTE?: number | null;
  activeIngredientQuantity_MAX_LT?: number | null;
  activeIngredientQuantity_MAX_LTE?: number | null;
  activeIngredientQuantity_MIN_EQUAL?: number | null;
  activeIngredientQuantity_MIN_GT?: number | null;
  activeIngredientQuantity_MIN_GTE?: number | null;
  activeIngredientQuantity_MIN_LT?: number | null;
  activeIngredientQuantity_MIN_LTE?: number | null;
  activeIngredientQuantity_SUM_EQUAL?: number | null;
  activeIngredientQuantity_SUM_GT?: number | null;
  activeIngredientQuantity_SUM_GTE?: number | null;
  activeIngredientQuantity_SUM_LT?: number | null;
  activeIngredientQuantity_SUM_LTE?: number | null;
  classificationSystem_AVERAGE_EQUAL?: number | null;
  classificationSystem_AVERAGE_GT?: number | null;
  classificationSystem_AVERAGE_GTE?: number | null;
  classificationSystem_AVERAGE_LT?: number | null;
  classificationSystem_AVERAGE_LTE?: number | null;
  classificationSystem_EQUAL?: string | null;
  classificationSystem_GT?: number | null;
  classificationSystem_GTE?: number | null;
  classificationSystem_LONGEST_EQUAL?: number | null;
  classificationSystem_LONGEST_GT?: number | null;
  classificationSystem_LONGEST_GTE?: number | null;
  classificationSystem_LONGEST_LT?: number | null;
  classificationSystem_LONGEST_LTE?: number | null;
  classificationSystem_LT?: number | null;
  classificationSystem_LTE?: number | null;
  classificationSystem_SHORTEST_EQUAL?: number | null;
  classificationSystem_SHORTEST_GT?: number | null;
  classificationSystem_SHORTEST_GTE?: number | null;
  classificationSystem_SHORTEST_LT?: number | null;
  classificationSystem_SHORTEST_LTE?: number | null;
  concentration_AVERAGE_EQUAL?: number | null;
  concentration_AVERAGE_GT?: number | null;
  concentration_AVERAGE_GTE?: number | null;
  concentration_AVERAGE_LT?: number | null;
  concentration_AVERAGE_LTE?: number | null;
  concentration_EQUAL?: string | null;
  concentration_GT?: number | null;
  concentration_GTE?: number | null;
  concentration_LONGEST_EQUAL?: number | null;
  concentration_LONGEST_GT?: number | null;
  concentration_LONGEST_GTE?: number | null;
  concentration_LONGEST_LT?: number | null;
  concentration_LONGEST_LTE?: number | null;
  concentration_LT?: number | null;
  concentration_LTE?: number | null;
  concentration_SHORTEST_EQUAL?: number | null;
  concentration_SHORTEST_GT?: number | null;
  concentration_SHORTEST_GTE?: number | null;
  concentration_SHORTEST_LT?: number | null;
  concentration_SHORTEST_LTE?: number | null;
  packVolume_AVERAGE_EQUAL?: number | null;
  packVolume_AVERAGE_GT?: number | null;
  packVolume_AVERAGE_GTE?: number | null;
  packVolume_AVERAGE_LT?: number | null;
  packVolume_AVERAGE_LTE?: number | null;
  packVolume_EQUAL?: string | null;
  packVolume_GT?: number | null;
  packVolume_GTE?: number | null;
  packVolume_LONGEST_EQUAL?: number | null;
  packVolume_LONGEST_GT?: number | null;
  packVolume_LONGEST_GTE?: number | null;
  packVolume_LONGEST_LT?: number | null;
  packVolume_LONGEST_LTE?: number | null;
  packVolume_LT?: number | null;
  packVolume_LTE?: number | null;
  packVolume_SHORTEST_EQUAL?: number | null;
  packVolume_SHORTEST_GT?: number | null;
  packVolume_SHORTEST_GTE?: number | null;
  packVolume_SHORTEST_LT?: number | null;
  packVolume_SHORTEST_LTE?: number | null;
}

export interface CycleConfigurationTherapiesAggregateInput {
  AND?: CycleConfigurationTherapiesAggregateInput[] | null;
  OR?: CycleConfigurationTherapiesAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: CycleConfigurationTherapiesNodeAggregationWhereInput | null;
}

export interface CycleConfigurationTherapiesConnectionWhere {
  AND?: CycleConfigurationTherapiesConnectionWhere[] | null;
  OR?: CycleConfigurationTherapiesConnectionWhere[] | null;
  node?: CycleTherapyConfigurationWhere | null;
  node_NOT?: CycleTherapyConfigurationWhere | null;
}

export interface CycleConfigurationTherapiesNodeAggregationWhereInput {
  AND?: CycleConfigurationTherapiesNodeAggregationWhereInput[] | null;
  OR?: CycleConfigurationTherapiesNodeAggregationWhereInput[] | null;
  cycleToleranceFrom_AVERAGE_EQUAL?: number | null;
  cycleToleranceFrom_AVERAGE_GT?: number | null;
  cycleToleranceFrom_AVERAGE_GTE?: number | null;
  cycleToleranceFrom_AVERAGE_LT?: number | null;
  cycleToleranceFrom_AVERAGE_LTE?: number | null;
  cycleToleranceFrom_EQUAL?: number | null;
  cycleToleranceFrom_GT?: number | null;
  cycleToleranceFrom_GTE?: number | null;
  cycleToleranceFrom_LT?: number | null;
  cycleToleranceFrom_LTE?: number | null;
  cycleToleranceFrom_MAX_EQUAL?: number | null;
  cycleToleranceFrom_MAX_GT?: number | null;
  cycleToleranceFrom_MAX_GTE?: number | null;
  cycleToleranceFrom_MAX_LT?: number | null;
  cycleToleranceFrom_MAX_LTE?: number | null;
  cycleToleranceFrom_MIN_EQUAL?: number | null;
  cycleToleranceFrom_MIN_GT?: number | null;
  cycleToleranceFrom_MIN_GTE?: number | null;
  cycleToleranceFrom_MIN_LT?: number | null;
  cycleToleranceFrom_MIN_LTE?: number | null;
  cycleToleranceFrom_SUM_EQUAL?: number | null;
  cycleToleranceFrom_SUM_GT?: number | null;
  cycleToleranceFrom_SUM_GTE?: number | null;
  cycleToleranceFrom_SUM_LT?: number | null;
  cycleToleranceFrom_SUM_LTE?: number | null;
  cycleToleranceTo_AVERAGE_EQUAL?: number | null;
  cycleToleranceTo_AVERAGE_GT?: number | null;
  cycleToleranceTo_AVERAGE_GTE?: number | null;
  cycleToleranceTo_AVERAGE_LT?: number | null;
  cycleToleranceTo_AVERAGE_LTE?: number | null;
  cycleToleranceTo_EQUAL?: number | null;
  cycleToleranceTo_GT?: number | null;
  cycleToleranceTo_GTE?: number | null;
  cycleToleranceTo_LT?: number | null;
  cycleToleranceTo_LTE?: number | null;
  cycleToleranceTo_MAX_EQUAL?: number | null;
  cycleToleranceTo_MAX_GT?: number | null;
  cycleToleranceTo_MAX_GTE?: number | null;
  cycleToleranceTo_MAX_LT?: number | null;
  cycleToleranceTo_MAX_LTE?: number | null;
  cycleToleranceTo_MIN_EQUAL?: number | null;
  cycleToleranceTo_MIN_GT?: number | null;
  cycleToleranceTo_MIN_GTE?: number | null;
  cycleToleranceTo_MIN_LT?: number | null;
  cycleToleranceTo_MIN_LTE?: number | null;
  cycleToleranceTo_SUM_EQUAL?: number | null;
  cycleToleranceTo_SUM_GT?: number | null;
  cycleToleranceTo_SUM_GTE?: number | null;
  cycleToleranceTo_SUM_LT?: number | null;
  cycleToleranceTo_SUM_LTE?: number | null;
  dosageFrom_AVERAGE_EQUAL?: number | null;
  dosageFrom_AVERAGE_GT?: number | null;
  dosageFrom_AVERAGE_GTE?: number | null;
  dosageFrom_AVERAGE_LT?: number | null;
  dosageFrom_AVERAGE_LTE?: number | null;
  dosageFrom_EQUAL?: number | null;
  dosageFrom_GT?: number | null;
  dosageFrom_GTE?: number | null;
  dosageFrom_LT?: number | null;
  dosageFrom_LTE?: number | null;
  dosageFrom_MAX_EQUAL?: number | null;
  dosageFrom_MAX_GT?: number | null;
  dosageFrom_MAX_GTE?: number | null;
  dosageFrom_MAX_LT?: number | null;
  dosageFrom_MAX_LTE?: number | null;
  dosageFrom_MIN_EQUAL?: number | null;
  dosageFrom_MIN_GT?: number | null;
  dosageFrom_MIN_GTE?: number | null;
  dosageFrom_MIN_LT?: number | null;
  dosageFrom_MIN_LTE?: number | null;
  dosageFrom_SUM_EQUAL?: number | null;
  dosageFrom_SUM_GT?: number | null;
  dosageFrom_SUM_GTE?: number | null;
  dosageFrom_SUM_LT?: number | null;
  dosageFrom_SUM_LTE?: number | null;
  dosageTo_AVERAGE_EQUAL?: number | null;
  dosageTo_AVERAGE_GT?: number | null;
  dosageTo_AVERAGE_GTE?: number | null;
  dosageTo_AVERAGE_LT?: number | null;
  dosageTo_AVERAGE_LTE?: number | null;
  dosageTo_EQUAL?: number | null;
  dosageTo_GT?: number | null;
  dosageTo_GTE?: number | null;
  dosageTo_LT?: number | null;
  dosageTo_LTE?: number | null;
  dosageTo_MAX_EQUAL?: number | null;
  dosageTo_MAX_GT?: number | null;
  dosageTo_MAX_GTE?: number | null;
  dosageTo_MAX_LT?: number | null;
  dosageTo_MAX_LTE?: number | null;
  dosageTo_MIN_EQUAL?: number | null;
  dosageTo_MIN_GT?: number | null;
  dosageTo_MIN_GTE?: number | null;
  dosageTo_MIN_LT?: number | null;
  dosageTo_MIN_LTE?: number | null;
  dosageTo_SUM_EQUAL?: number | null;
  dosageTo_SUM_GT?: number | null;
  dosageTo_SUM_GTE?: number | null;
  dosageTo_SUM_LT?: number | null;
  dosageTo_SUM_LTE?: number | null;
  packQuantityFrom_AVERAGE_EQUAL?: number | null;
  packQuantityFrom_AVERAGE_GT?: number | null;
  packQuantityFrom_AVERAGE_GTE?: number | null;
  packQuantityFrom_AVERAGE_LT?: number | null;
  packQuantityFrom_AVERAGE_LTE?: number | null;
  packQuantityFrom_EQUAL?: number | null;
  packQuantityFrom_GT?: number | null;
  packQuantityFrom_GTE?: number | null;
  packQuantityFrom_LT?: number | null;
  packQuantityFrom_LTE?: number | null;
  packQuantityFrom_MAX_EQUAL?: number | null;
  packQuantityFrom_MAX_GT?: number | null;
  packQuantityFrom_MAX_GTE?: number | null;
  packQuantityFrom_MAX_LT?: number | null;
  packQuantityFrom_MAX_LTE?: number | null;
  packQuantityFrom_MIN_EQUAL?: number | null;
  packQuantityFrom_MIN_GT?: number | null;
  packQuantityFrom_MIN_GTE?: number | null;
  packQuantityFrom_MIN_LT?: number | null;
  packQuantityFrom_MIN_LTE?: number | null;
  packQuantityFrom_SUM_EQUAL?: number | null;
  packQuantityFrom_SUM_GT?: number | null;
  packQuantityFrom_SUM_GTE?: number | null;
  packQuantityFrom_SUM_LT?: number | null;
  packQuantityFrom_SUM_LTE?: number | null;
  packQuantityTo_AVERAGE_EQUAL?: number | null;
  packQuantityTo_AVERAGE_GT?: number | null;
  packQuantityTo_AVERAGE_GTE?: number | null;
  packQuantityTo_AVERAGE_LT?: number | null;
  packQuantityTo_AVERAGE_LTE?: number | null;
  packQuantityTo_EQUAL?: number | null;
  packQuantityTo_GT?: number | null;
  packQuantityTo_GTE?: number | null;
  packQuantityTo_LT?: number | null;
  packQuantityTo_LTE?: number | null;
  packQuantityTo_MAX_EQUAL?: number | null;
  packQuantityTo_MAX_GT?: number | null;
  packQuantityTo_MAX_GTE?: number | null;
  packQuantityTo_MAX_LT?: number | null;
  packQuantityTo_MAX_LTE?: number | null;
  packQuantityTo_MIN_EQUAL?: number | null;
  packQuantityTo_MIN_GT?: number | null;
  packQuantityTo_MIN_GTE?: number | null;
  packQuantityTo_MIN_LT?: number | null;
  packQuantityTo_MIN_LTE?: number | null;
  packQuantityTo_SUM_EQUAL?: number | null;
  packQuantityTo_SUM_GT?: number | null;
  packQuantityTo_SUM_GTE?: number | null;
  packQuantityTo_SUM_LT?: number | null;
  packQuantityTo_SUM_LTE?: number | null;
  recordGapFrom_AVERAGE_EQUAL?: number | null;
  recordGapFrom_AVERAGE_GT?: number | null;
  recordGapFrom_AVERAGE_GTE?: number | null;
  recordGapFrom_AVERAGE_LT?: number | null;
  recordGapFrom_AVERAGE_LTE?: number | null;
  recordGapFrom_EQUAL?: number | null;
  recordGapFrom_GT?: number | null;
  recordGapFrom_GTE?: number | null;
  recordGapFrom_LT?: number | null;
  recordGapFrom_LTE?: number | null;
  recordGapFrom_MAX_EQUAL?: number | null;
  recordGapFrom_MAX_GT?: number | null;
  recordGapFrom_MAX_GTE?: number | null;
  recordGapFrom_MAX_LT?: number | null;
  recordGapFrom_MAX_LTE?: number | null;
  recordGapFrom_MIN_EQUAL?: number | null;
  recordGapFrom_MIN_GT?: number | null;
  recordGapFrom_MIN_GTE?: number | null;
  recordGapFrom_MIN_LT?: number | null;
  recordGapFrom_MIN_LTE?: number | null;
  recordGapFrom_SUM_EQUAL?: number | null;
  recordGapFrom_SUM_GT?: number | null;
  recordGapFrom_SUM_GTE?: number | null;
  recordGapFrom_SUM_LT?: number | null;
  recordGapFrom_SUM_LTE?: number | null;
  recordGapTo_AVERAGE_EQUAL?: number | null;
  recordGapTo_AVERAGE_GT?: number | null;
  recordGapTo_AVERAGE_GTE?: number | null;
  recordGapTo_AVERAGE_LT?: number | null;
  recordGapTo_AVERAGE_LTE?: number | null;
  recordGapTo_EQUAL?: number | null;
  recordGapTo_GT?: number | null;
  recordGapTo_GTE?: number | null;
  recordGapTo_LT?: number | null;
  recordGapTo_LTE?: number | null;
  recordGapTo_MAX_EQUAL?: number | null;
  recordGapTo_MAX_GT?: number | null;
  recordGapTo_MAX_GTE?: number | null;
  recordGapTo_MAX_LT?: number | null;
  recordGapTo_MAX_LTE?: number | null;
  recordGapTo_MIN_EQUAL?: number | null;
  recordGapTo_MIN_GT?: number | null;
  recordGapTo_MIN_GTE?: number | null;
  recordGapTo_MIN_LT?: number | null;
  recordGapTo_MIN_LTE?: number | null;
  recordGapTo_SUM_EQUAL?: number | null;
  recordGapTo_SUM_GT?: number | null;
  recordGapTo_SUM_GTE?: number | null;
  recordGapTo_SUM_LT?: number | null;
  recordGapTo_SUM_LTE?: number | null;
  recordQuantityFrom_AVERAGE_EQUAL?: number | null;
  recordQuantityFrom_AVERAGE_GT?: number | null;
  recordQuantityFrom_AVERAGE_GTE?: number | null;
  recordQuantityFrom_AVERAGE_LT?: number | null;
  recordQuantityFrom_AVERAGE_LTE?: number | null;
  recordQuantityFrom_EQUAL?: number | null;
  recordQuantityFrom_GT?: number | null;
  recordQuantityFrom_GTE?: number | null;
  recordQuantityFrom_LT?: number | null;
  recordQuantityFrom_LTE?: number | null;
  recordQuantityFrom_MAX_EQUAL?: number | null;
  recordQuantityFrom_MAX_GT?: number | null;
  recordQuantityFrom_MAX_GTE?: number | null;
  recordQuantityFrom_MAX_LT?: number | null;
  recordQuantityFrom_MAX_LTE?: number | null;
  recordQuantityFrom_MIN_EQUAL?: number | null;
  recordQuantityFrom_MIN_GT?: number | null;
  recordQuantityFrom_MIN_GTE?: number | null;
  recordQuantityFrom_MIN_LT?: number | null;
  recordQuantityFrom_MIN_LTE?: number | null;
  recordQuantityFrom_SUM_EQUAL?: number | null;
  recordQuantityFrom_SUM_GT?: number | null;
  recordQuantityFrom_SUM_GTE?: number | null;
  recordQuantityFrom_SUM_LT?: number | null;
  recordQuantityFrom_SUM_LTE?: number | null;
  recordQuantityTo_AVERAGE_EQUAL?: number | null;
  recordQuantityTo_AVERAGE_GT?: number | null;
  recordQuantityTo_AVERAGE_GTE?: number | null;
  recordQuantityTo_AVERAGE_LT?: number | null;
  recordQuantityTo_AVERAGE_LTE?: number | null;
  recordQuantityTo_EQUAL?: number | null;
  recordQuantityTo_GT?: number | null;
  recordQuantityTo_GTE?: number | null;
  recordQuantityTo_LT?: number | null;
  recordQuantityTo_LTE?: number | null;
  recordQuantityTo_MAX_EQUAL?: number | null;
  recordQuantityTo_MAX_GT?: number | null;
  recordQuantityTo_MAX_GTE?: number | null;
  recordQuantityTo_MAX_LT?: number | null;
  recordQuantityTo_MAX_LTE?: number | null;
  recordQuantityTo_MIN_EQUAL?: number | null;
  recordQuantityTo_MIN_GT?: number | null;
  recordQuantityTo_MIN_GTE?: number | null;
  recordQuantityTo_MIN_LT?: number | null;
  recordQuantityTo_MIN_LTE?: number | null;
  recordQuantityTo_SUM_EQUAL?: number | null;
  recordQuantityTo_SUM_GT?: number | null;
  recordQuantityTo_SUM_GTE?: number | null;
  recordQuantityTo_SUM_LT?: number | null;
  recordQuantityTo_SUM_LTE?: number | null;
}

export interface CycleConfigurationWhere {
  AND?: CycleConfigurationWhere[] | null;
  OR?: CycleConfigurationWhere[] | null;
  cycleStartingPoint?: CycleStartingPoint | null;
  cycleStartingPoint_IN?: (CycleStartingPoint | null)[] | null;
  cycleStartingPoint_NOT?: CycleStartingPoint | null;
  cycleStartingPoint_NOT_IN?: (CycleStartingPoint | null)[] | null;
  lengthFrom?: number | null;
  lengthFrom_GT?: number | null;
  lengthFrom_GTE?: number | null;
  lengthFrom_IN?: (number | null)[] | null;
  lengthFrom_LT?: number | null;
  lengthFrom_LTE?: number | null;
  lengthFrom_NOT?: number | null;
  lengthFrom_NOT_IN?: (number | null)[] | null;
  lengthTo?: number | null;
  lengthTo_GT?: number | null;
  lengthTo_GTE?: number | null;
  lengthTo_IN?: (number | null)[] | null;
  lengthTo_LT?: number | null;
  lengthTo_LTE?: number | null;
  lengthTo_NOT?: number | null;
  lengthTo_NOT_IN?: (number | null)[] | null;
  name?: string | null;
  name_CONTAINS?: string | null;
  name_ENDS_WITH?: string | null;
  name_IN?: (string | null)[] | null;
  name_MATCHES?: string | null;
  name_NOT?: string | null;
  name_NOT_CONTAINS?: string | null;
  name_NOT_ENDS_WITH?: string | null;
  name_NOT_IN?: (string | null)[] | null;
  name_NOT_STARTS_WITH?: string | null;
  name_STARTS_WITH?: string | null;
  order?: number | null;
  order_GT?: number | null;
  order_GTE?: number | null;
  order_IN?: (number | null)[] | null;
  order_LT?: number | null;
  order_LTE?: number | null;
  order_NOT?: number | null;
  order_NOT_IN?: (number | null)[] | null;
  recordType?: FlexEntityTypeWhere | null;
  recordTypeAggregate?: CycleConfigurationRecordTypeAggregateInput | null;
  recordTypeConnection?: CycleConfigurationRecordTypeConnectionWhere | null;
  recordTypeConnection_NOT?: CycleConfigurationRecordTypeConnectionWhere | null;
  recordType_NOT?: FlexEntityTypeWhere | null;
  scope?: AgreementScopeWhere | null;
  scopeAggregate?: CycleConfigurationScopeAggregateInput | null;
  scopeConnection?: CycleConfigurationScopeConnectionWhere | null;
  scopeConnection_NOT?: CycleConfigurationScopeConnectionWhere | null;
  scope_NOT?: AgreementScopeWhere | null;
  startingTreatment?: TreatmentWhere | null;
  startingTreatmentAggregate?: CycleConfigurationStartingTreatmentAggregateInput | null;
  startingTreatmentBrand?: BrandWhere | null;
  startingTreatmentBrandAggregate?: CycleConfigurationStartingTreatmentBrandAggregateInput | null;
  startingTreatmentBrandConnection?: CycleConfigurationStartingTreatmentBrandConnectionWhere | null;
  startingTreatmentBrandConnection_NOT?: CycleConfigurationStartingTreatmentBrandConnectionWhere | null;
  startingTreatmentBrand_NOT?: BrandWhere | null;
  startingTreatmentConnection?: CycleConfigurationStartingTreatmentConnectionWhere | null;
  startingTreatmentConnection_NOT?: CycleConfigurationStartingTreatmentConnectionWhere | null;
  startingTreatmentGeneric?: GenericWhere | null;
  startingTreatmentGenericAggregate?: CycleConfigurationStartingTreatmentGenericAggregateInput | null;
  startingTreatmentGenericConnection?: CycleConfigurationStartingTreatmentGenericConnectionWhere | null;
  startingTreatmentGenericConnection_NOT?: CycleConfigurationStartingTreatmentGenericConnectionWhere | null;
  startingTreatmentGeneric_NOT?: GenericWhere | null;
  startingTreatment_NOT?: TreatmentWhere | null;
  therapies?: CycleTherapyConfigurationWhere | null;
  therapiesAggregate?: CycleConfigurationTherapiesAggregateInput | null;
  therapiesConnection?: CycleConfigurationTherapiesConnectionWhere | null;
  therapiesConnection_NOT?: CycleConfigurationTherapiesConnectionWhere | null;
  therapies_NOT?: CycleTherapyConfigurationWhere | null;
}

export interface CycleTherapyConfigurationTreatmentSetAggregateInput {
  AND?: CycleTherapyConfigurationTreatmentSetAggregateInput[] | null;
  OR?: CycleTherapyConfigurationTreatmentSetAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: CycleTherapyConfigurationTreatmentSetNodeAggregationWhereInput | null;
}

export interface CycleTherapyConfigurationTreatmentSetConnectionWhere {
  AND?: CycleTherapyConfigurationTreatmentSetConnectionWhere[] | null;
  OR?: CycleTherapyConfigurationTreatmentSetConnectionWhere[] | null;
  node?: TreatmentSetWhere | null;
  node_NOT?: TreatmentSetWhere | null;
}

export interface CycleTherapyConfigurationTreatmentSetNodeAggregationWhereInput {
  AND?: CycleTherapyConfigurationTreatmentSetNodeAggregationWhereInput[] | null;
  OR?: CycleTherapyConfigurationTreatmentSetNodeAggregationWhereInput[] | null;
  order_AVERAGE_EQUAL?: number | null;
  order_AVERAGE_GT?: number | null;
  order_AVERAGE_GTE?: number | null;
  order_AVERAGE_LT?: number | null;
  order_AVERAGE_LTE?: number | null;
  order_EQUAL?: number | null;
  order_GT?: number | null;
  order_GTE?: number | null;
  order_LT?: number | null;
  order_LTE?: number | null;
  order_MAX_EQUAL?: number | null;
  order_MAX_GT?: number | null;
  order_MAX_GTE?: number | null;
  order_MAX_LT?: number | null;
  order_MAX_LTE?: number | null;
  order_MIN_EQUAL?: number | null;
  order_MIN_GT?: number | null;
  order_MIN_GTE?: number | null;
  order_MIN_LT?: number | null;
  order_MIN_LTE?: number | null;
  order_SUM_EQUAL?: number | null;
  order_SUM_GT?: number | null;
  order_SUM_GTE?: number | null;
  order_SUM_LT?: number | null;
  order_SUM_LTE?: number | null;
}

export interface CycleTherapyConfigurationWhere {
  AND?: CycleTherapyConfigurationWhere[] | null;
  OR?: CycleTherapyConfigurationWhere[] | null;
  cycleToleranceFrom?: number | null;
  cycleToleranceFrom_GT?: number | null;
  cycleToleranceFrom_GTE?: number | null;
  cycleToleranceFrom_IN?: (number | null)[] | null;
  cycleToleranceFrom_LT?: number | null;
  cycleToleranceFrom_LTE?: number | null;
  cycleToleranceFrom_NOT?: number | null;
  cycleToleranceFrom_NOT_IN?: (number | null)[] | null;
  cycleToleranceTo?: number | null;
  cycleToleranceTo_GT?: number | null;
  cycleToleranceTo_GTE?: number | null;
  cycleToleranceTo_IN?: (number | null)[] | null;
  cycleToleranceTo_LT?: number | null;
  cycleToleranceTo_LTE?: number | null;
  cycleToleranceTo_NOT?: number | null;
  cycleToleranceTo_NOT_IN?: (number | null)[] | null;
  dosageFrom?: number | null;
  dosageFrom_GT?: number | null;
  dosageFrom_GTE?: number | null;
  dosageFrom_IN?: (number | null)[] | null;
  dosageFrom_LT?: number | null;
  dosageFrom_LTE?: number | null;
  dosageFrom_NOT?: number | null;
  dosageFrom_NOT_IN?: (number | null)[] | null;
  dosageTo?: number | null;
  dosageTo_GT?: number | null;
  dosageTo_GTE?: number | null;
  dosageTo_IN?: (number | null)[] | null;
  dosageTo_LT?: number | null;
  dosageTo_LTE?: number | null;
  dosageTo_NOT?: number | null;
  dosageTo_NOT_IN?: (number | null)[] | null;
  expectedDays?: number[] | null;
  expectedDays_INCLUDES?: number | null;
  expectedDays_NOT?: number[] | null;
  expectedDays_NOT_INCLUDES?: number | null;
  packQuantityFrom?: number | null;
  packQuantityFrom_GT?: number | null;
  packQuantityFrom_GTE?: number | null;
  packQuantityFrom_IN?: (number | null)[] | null;
  packQuantityFrom_LT?: number | null;
  packQuantityFrom_LTE?: number | null;
  packQuantityFrom_NOT?: number | null;
  packQuantityFrom_NOT_IN?: (number | null)[] | null;
  packQuantityTo?: number | null;
  packQuantityTo_GT?: number | null;
  packQuantityTo_GTE?: number | null;
  packQuantityTo_IN?: (number | null)[] | null;
  packQuantityTo_LT?: number | null;
  packQuantityTo_LTE?: number | null;
  packQuantityTo_NOT?: number | null;
  packQuantityTo_NOT_IN?: (number | null)[] | null;
  recordGapFrom?: number | null;
  recordGapFrom_GT?: number | null;
  recordGapFrom_GTE?: number | null;
  recordGapFrom_IN?: (number | null)[] | null;
  recordGapFrom_LT?: number | null;
  recordGapFrom_LTE?: number | null;
  recordGapFrom_NOT?: number | null;
  recordGapFrom_NOT_IN?: (number | null)[] | null;
  recordGapTo?: number | null;
  recordGapTo_GT?: number | null;
  recordGapTo_GTE?: number | null;
  recordGapTo_IN?: (number | null)[] | null;
  recordGapTo_LT?: number | null;
  recordGapTo_LTE?: number | null;
  recordGapTo_NOT?: number | null;
  recordGapTo_NOT_IN?: (number | null)[] | null;
  recordQuantityFrom?: number | null;
  recordQuantityFrom_GT?: number | null;
  recordQuantityFrom_GTE?: number | null;
  recordQuantityFrom_IN?: (number | null)[] | null;
  recordQuantityFrom_LT?: number | null;
  recordQuantityFrom_LTE?: number | null;
  recordQuantityFrom_NOT?: number | null;
  recordQuantityFrom_NOT_IN?: (number | null)[] | null;
  recordQuantityTo?: number | null;
  recordQuantityTo_GT?: number | null;
  recordQuantityTo_GTE?: number | null;
  recordQuantityTo_IN?: (number | null)[] | null;
  recordQuantityTo_LT?: number | null;
  recordQuantityTo_LTE?: number | null;
  recordQuantityTo_NOT?: number | null;
  recordQuantityTo_NOT_IN?: (number | null)[] | null;
  treatmentSet?: TreatmentSetWhere | null;
  treatmentSetAggregate?: CycleTherapyConfigurationTreatmentSetAggregateInput | null;
  treatmentSetConnection?: CycleTherapyConfigurationTreatmentSetConnectionWhere | null;
  treatmentSetConnection_NOT?: CycleTherapyConfigurationTreatmentSetConnectionWhere | null;
  treatmentSet_NOT?: TreatmentSetWhere | null;
}

export interface DataContainerProvidersAggregateInput {
  AND?: DataContainerProvidersAggregateInput[] | null;
  OR?: DataContainerProvidersAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: DataContainerProvidersNodeAggregationWhereInput | null;
}

export interface DataContainerProvidersConnectionWhere {
  AND?: DataContainerProvidersConnectionWhere[] | null;
  OR?: DataContainerProvidersConnectionWhere[] | null;
  node?: OrganizationWhere | null;
  node_NOT?: OrganizationWhere | null;
}

export interface DataContainerProvidersNodeAggregationWhereInput {
  AND?: DataContainerProvidersNodeAggregationWhereInput[] | null;
  BIC_AVERAGE_EQUAL?: number | null;
  BIC_AVERAGE_GT?: number | null;
  BIC_AVERAGE_GTE?: number | null;
  BIC_AVERAGE_LT?: number | null;
  BIC_AVERAGE_LTE?: number | null;
  BIC_EQUAL?: string | null;
  BIC_GT?: number | null;
  BIC_GTE?: number | null;
  BIC_LONGEST_EQUAL?: number | null;
  BIC_LONGEST_GT?: number | null;
  BIC_LONGEST_GTE?: number | null;
  BIC_LONGEST_LT?: number | null;
  BIC_LONGEST_LTE?: number | null;
  BIC_LT?: number | null;
  BIC_LTE?: number | null;
  BIC_SHORTEST_EQUAL?: number | null;
  BIC_SHORTEST_GT?: number | null;
  BIC_SHORTEST_GTE?: number | null;
  BIC_SHORTEST_LT?: number | null;
  BIC_SHORTEST_LTE?: number | null;
  IBAN_AVERAGE_EQUAL?: number | null;
  IBAN_AVERAGE_GT?: number | null;
  IBAN_AVERAGE_GTE?: number | null;
  IBAN_AVERAGE_LT?: number | null;
  IBAN_AVERAGE_LTE?: number | null;
  IBAN_EQUAL?: string | null;
  IBAN_GT?: number | null;
  IBAN_GTE?: number | null;
  IBAN_LONGEST_EQUAL?: number | null;
  IBAN_LONGEST_GT?: number | null;
  IBAN_LONGEST_GTE?: number | null;
  IBAN_LONGEST_LT?: number | null;
  IBAN_LONGEST_LTE?: number | null;
  IBAN_LT?: number | null;
  IBAN_LTE?: number | null;
  IBAN_SHORTEST_EQUAL?: number | null;
  IBAN_SHORTEST_GT?: number | null;
  IBAN_SHORTEST_GTE?: number | null;
  IBAN_SHORTEST_LT?: number | null;
  IBAN_SHORTEST_LTE?: number | null;
  OR?: DataContainerProvidersNodeAggregationWhereInput[] | null;
  accountName_AVERAGE_EQUAL?: number | null;
  accountName_AVERAGE_GT?: number | null;
  accountName_AVERAGE_GTE?: number | null;
  accountName_AVERAGE_LT?: number | null;
  accountName_AVERAGE_LTE?: number | null;
  accountName_EQUAL?: string | null;
  accountName_GT?: number | null;
  accountName_GTE?: number | null;
  accountName_LONGEST_EQUAL?: number | null;
  accountName_LONGEST_GT?: number | null;
  accountName_LONGEST_GTE?: number | null;
  accountName_LONGEST_LT?: number | null;
  accountName_LONGEST_LTE?: number | null;
  accountName_LT?: number | null;
  accountName_LTE?: number | null;
  accountName_SHORTEST_EQUAL?: number | null;
  accountName_SHORTEST_GT?: number | null;
  accountName_SHORTEST_GTE?: number | null;
  accountName_SHORTEST_LT?: number | null;
  accountName_SHORTEST_LTE?: number | null;
  accountNumber_AVERAGE_EQUAL?: number | null;
  accountNumber_AVERAGE_GT?: number | null;
  accountNumber_AVERAGE_GTE?: number | null;
  accountNumber_AVERAGE_LT?: number | null;
  accountNumber_AVERAGE_LTE?: number | null;
  accountNumber_EQUAL?: string | null;
  accountNumber_GT?: number | null;
  accountNumber_GTE?: number | null;
  accountNumber_LONGEST_EQUAL?: number | null;
  accountNumber_LONGEST_GT?: number | null;
  accountNumber_LONGEST_GTE?: number | null;
  accountNumber_LONGEST_LT?: number | null;
  accountNumber_LONGEST_LTE?: number | null;
  accountNumber_LT?: number | null;
  accountNumber_LTE?: number | null;
  accountNumber_SHORTEST_EQUAL?: number | null;
  accountNumber_SHORTEST_GT?: number | null;
  accountNumber_SHORTEST_GTE?: number | null;
  accountNumber_SHORTEST_LT?: number | null;
  accountNumber_SHORTEST_LTE?: number | null;
  billingAddress_AVERAGE_EQUAL?: number | null;
  billingAddress_AVERAGE_GT?: number | null;
  billingAddress_AVERAGE_GTE?: number | null;
  billingAddress_AVERAGE_LT?: number | null;
  billingAddress_AVERAGE_LTE?: number | null;
  billingAddress_EQUAL?: string | null;
  billingAddress_GT?: number | null;
  billingAddress_GTE?: number | null;
  billingAddress_LONGEST_EQUAL?: number | null;
  billingAddress_LONGEST_GT?: number | null;
  billingAddress_LONGEST_GTE?: number | null;
  billingAddress_LONGEST_LT?: number | null;
  billingAddress_LONGEST_LTE?: number | null;
  billingAddress_LT?: number | null;
  billingAddress_LTE?: number | null;
  billingAddress_SHORTEST_EQUAL?: number | null;
  billingAddress_SHORTEST_GT?: number | null;
  billingAddress_SHORTEST_GTE?: number | null;
  billingAddress_SHORTEST_LT?: number | null;
  billingAddress_SHORTEST_LTE?: number | null;
  contactEmail_AVERAGE_EQUAL?: number | null;
  contactEmail_AVERAGE_GT?: number | null;
  contactEmail_AVERAGE_GTE?: number | null;
  contactEmail_AVERAGE_LT?: number | null;
  contactEmail_AVERAGE_LTE?: number | null;
  contactEmail_EQUAL?: string | null;
  contactEmail_GT?: number | null;
  contactEmail_GTE?: number | null;
  contactEmail_LONGEST_EQUAL?: number | null;
  contactEmail_LONGEST_GT?: number | null;
  contactEmail_LONGEST_GTE?: number | null;
  contactEmail_LONGEST_LT?: number | null;
  contactEmail_LONGEST_LTE?: number | null;
  contactEmail_LT?: number | null;
  contactEmail_LTE?: number | null;
  contactEmail_SHORTEST_EQUAL?: number | null;
  contactEmail_SHORTEST_GT?: number | null;
  contactEmail_SHORTEST_GTE?: number | null;
  contactEmail_SHORTEST_LT?: number | null;
  contactEmail_SHORTEST_LTE?: number | null;
  contactFirstName_AVERAGE_EQUAL?: number | null;
  contactFirstName_AVERAGE_GT?: number | null;
  contactFirstName_AVERAGE_GTE?: number | null;
  contactFirstName_AVERAGE_LT?: number | null;
  contactFirstName_AVERAGE_LTE?: number | null;
  contactFirstName_EQUAL?: string | null;
  contactFirstName_GT?: number | null;
  contactFirstName_GTE?: number | null;
  contactFirstName_LONGEST_EQUAL?: number | null;
  contactFirstName_LONGEST_GT?: number | null;
  contactFirstName_LONGEST_GTE?: number | null;
  contactFirstName_LONGEST_LT?: number | null;
  contactFirstName_LONGEST_LTE?: number | null;
  contactFirstName_LT?: number | null;
  contactFirstName_LTE?: number | null;
  contactFirstName_SHORTEST_EQUAL?: number | null;
  contactFirstName_SHORTEST_GT?: number | null;
  contactFirstName_SHORTEST_GTE?: number | null;
  contactFirstName_SHORTEST_LT?: number | null;
  contactFirstName_SHORTEST_LTE?: number | null;
  contactLastName_AVERAGE_EQUAL?: number | null;
  contactLastName_AVERAGE_GT?: number | null;
  contactLastName_AVERAGE_GTE?: number | null;
  contactLastName_AVERAGE_LT?: number | null;
  contactLastName_AVERAGE_LTE?: number | null;
  contactLastName_EQUAL?: string | null;
  contactLastName_GT?: number | null;
  contactLastName_GTE?: number | null;
  contactLastName_LONGEST_EQUAL?: number | null;
  contactLastName_LONGEST_GT?: number | null;
  contactLastName_LONGEST_GTE?: number | null;
  contactLastName_LONGEST_LT?: number | null;
  contactLastName_LONGEST_LTE?: number | null;
  contactLastName_LT?: number | null;
  contactLastName_LTE?: number | null;
  contactLastName_SHORTEST_EQUAL?: number | null;
  contactLastName_SHORTEST_GT?: number | null;
  contactLastName_SHORTEST_GTE?: number | null;
  contactLastName_SHORTEST_LT?: number | null;
  contactLastName_SHORTEST_LTE?: number | null;
  contactOccupation_AVERAGE_EQUAL?: number | null;
  contactOccupation_AVERAGE_GT?: number | null;
  contactOccupation_AVERAGE_GTE?: number | null;
  contactOccupation_AVERAGE_LT?: number | null;
  contactOccupation_AVERAGE_LTE?: number | null;
  contactOccupation_EQUAL?: string | null;
  contactOccupation_GT?: number | null;
  contactOccupation_GTE?: number | null;
  contactOccupation_LONGEST_EQUAL?: number | null;
  contactOccupation_LONGEST_GT?: number | null;
  contactOccupation_LONGEST_GTE?: number | null;
  contactOccupation_LONGEST_LT?: number | null;
  contactOccupation_LONGEST_LTE?: number | null;
  contactOccupation_LT?: number | null;
  contactOccupation_LTE?: number | null;
  contactOccupation_SHORTEST_EQUAL?: number | null;
  contactOccupation_SHORTEST_GT?: number | null;
  contactOccupation_SHORTEST_GTE?: number | null;
  contactOccupation_SHORTEST_LT?: number | null;
  contactOccupation_SHORTEST_LTE?: number | null;
  contactPhone_AVERAGE_EQUAL?: number | null;
  contactPhone_AVERAGE_GT?: number | null;
  contactPhone_AVERAGE_GTE?: number | null;
  contactPhone_AVERAGE_LT?: number | null;
  contactPhone_AVERAGE_LTE?: number | null;
  contactPhone_EQUAL?: string | null;
  contactPhone_GT?: number | null;
  contactPhone_GTE?: number | null;
  contactPhone_LONGEST_EQUAL?: number | null;
  contactPhone_LONGEST_GT?: number | null;
  contactPhone_LONGEST_GTE?: number | null;
  contactPhone_LONGEST_LT?: number | null;
  contactPhone_LONGEST_LTE?: number | null;
  contactPhone_LT?: number | null;
  contactPhone_LTE?: number | null;
  contactPhone_SHORTEST_EQUAL?: number | null;
  contactPhone_SHORTEST_GT?: number | null;
  contactPhone_SHORTEST_GTE?: number | null;
  contactPhone_SHORTEST_LT?: number | null;
  contactPhone_SHORTEST_LTE?: number | null;
  createdOn_AVERAGE_EQUAL?: number | null;
  createdOn_AVERAGE_GT?: number | null;
  createdOn_AVERAGE_GTE?: number | null;
  createdOn_AVERAGE_LT?: number | null;
  createdOn_AVERAGE_LTE?: number | null;
  createdOn_EQUAL?: number | null;
  createdOn_GT?: number | null;
  createdOn_GTE?: number | null;
  createdOn_LT?: number | null;
  createdOn_LTE?: number | null;
  createdOn_MAX_EQUAL?: number | null;
  createdOn_MAX_GT?: number | null;
  createdOn_MAX_GTE?: number | null;
  createdOn_MAX_LT?: number | null;
  createdOn_MAX_LTE?: number | null;
  createdOn_MIN_EQUAL?: number | null;
  createdOn_MIN_GT?: number | null;
  createdOn_MIN_GTE?: number | null;
  createdOn_MIN_LT?: number | null;
  createdOn_MIN_LTE?: number | null;
  createdOn_SUM_EQUAL?: number | null;
  createdOn_SUM_GT?: number | null;
  createdOn_SUM_GTE?: number | null;
  createdOn_SUM_LT?: number | null;
  createdOn_SUM_LTE?: number | null;
  deliveryAddress_AVERAGE_EQUAL?: number | null;
  deliveryAddress_AVERAGE_GT?: number | null;
  deliveryAddress_AVERAGE_GTE?: number | null;
  deliveryAddress_AVERAGE_LT?: number | null;
  deliveryAddress_AVERAGE_LTE?: number | null;
  deliveryAddress_EQUAL?: string | null;
  deliveryAddress_GT?: number | null;
  deliveryAddress_GTE?: number | null;
  deliveryAddress_LONGEST_EQUAL?: number | null;
  deliveryAddress_LONGEST_GT?: number | null;
  deliveryAddress_LONGEST_GTE?: number | null;
  deliveryAddress_LONGEST_LT?: number | null;
  deliveryAddress_LONGEST_LTE?: number | null;
  deliveryAddress_LT?: number | null;
  deliveryAddress_LTE?: number | null;
  deliveryAddress_SHORTEST_EQUAL?: number | null;
  deliveryAddress_SHORTEST_GT?: number | null;
  deliveryAddress_SHORTEST_GTE?: number | null;
  deliveryAddress_SHORTEST_LT?: number | null;
  deliveryAddress_SHORTEST_LTE?: number | null;
  domicile_AVERAGE_EQUAL?: number | null;
  domicile_AVERAGE_GT?: number | null;
  domicile_AVERAGE_GTE?: number | null;
  domicile_AVERAGE_LT?: number | null;
  domicile_AVERAGE_LTE?: number | null;
  domicile_EQUAL?: string | null;
  domicile_GT?: number | null;
  domicile_GTE?: number | null;
  domicile_LONGEST_EQUAL?: number | null;
  domicile_LONGEST_GT?: number | null;
  domicile_LONGEST_GTE?: number | null;
  domicile_LONGEST_LT?: number | null;
  domicile_LONGEST_LTE?: number | null;
  domicile_LT?: number | null;
  domicile_LTE?: number | null;
  domicile_SHORTEST_EQUAL?: number | null;
  domicile_SHORTEST_GT?: number | null;
  domicile_SHORTEST_GTE?: number | null;
  domicile_SHORTEST_LT?: number | null;
  domicile_SHORTEST_LTE?: number | null;
  dualApprovalThreshold_AVERAGE_EQUAL?: number | null;
  dualApprovalThreshold_AVERAGE_GT?: number | null;
  dualApprovalThreshold_AVERAGE_GTE?: number | null;
  dualApprovalThreshold_AVERAGE_LT?: number | null;
  dualApprovalThreshold_AVERAGE_LTE?: number | null;
  dualApprovalThreshold_EQUAL?: number | null;
  dualApprovalThreshold_GT?: number | null;
  dualApprovalThreshold_GTE?: number | null;
  dualApprovalThreshold_LT?: number | null;
  dualApprovalThreshold_LTE?: number | null;
  dualApprovalThreshold_MAX_EQUAL?: number | null;
  dualApprovalThreshold_MAX_GT?: number | null;
  dualApprovalThreshold_MAX_GTE?: number | null;
  dualApprovalThreshold_MAX_LT?: number | null;
  dualApprovalThreshold_MAX_LTE?: number | null;
  dualApprovalThreshold_MIN_EQUAL?: number | null;
  dualApprovalThreshold_MIN_GT?: number | null;
  dualApprovalThreshold_MIN_GTE?: number | null;
  dualApprovalThreshold_MIN_LT?: number | null;
  dualApprovalThreshold_MIN_LTE?: number | null;
  dualApprovalThreshold_SUM_EQUAL?: number | null;
  dualApprovalThreshold_SUM_GT?: number | null;
  dualApprovalThreshold_SUM_GTE?: number | null;
  dualApprovalThreshold_SUM_LT?: number | null;
  dualApprovalThreshold_SUM_LTE?: number | null;
  eIN_AVERAGE_EQUAL?: number | null;
  eIN_AVERAGE_GT?: number | null;
  eIN_AVERAGE_GTE?: number | null;
  eIN_AVERAGE_LT?: number | null;
  eIN_AVERAGE_LTE?: number | null;
  eIN_EQUAL?: string | null;
  eIN_GT?: number | null;
  eIN_GTE?: number | null;
  eIN_LONGEST_EQUAL?: number | null;
  eIN_LONGEST_GT?: number | null;
  eIN_LONGEST_GTE?: number | null;
  eIN_LONGEST_LT?: number | null;
  eIN_LONGEST_LTE?: number | null;
  eIN_LT?: number | null;
  eIN_LTE?: number | null;
  eIN_SHORTEST_EQUAL?: number | null;
  eIN_SHORTEST_GT?: number | null;
  eIN_SHORTEST_GTE?: number | null;
  eIN_SHORTEST_LT?: number | null;
  eIN_SHORTEST_LTE?: number | null;
  fax_AVERAGE_EQUAL?: number | null;
  fax_AVERAGE_GT?: number | null;
  fax_AVERAGE_GTE?: number | null;
  fax_AVERAGE_LT?: number | null;
  fax_AVERAGE_LTE?: number | null;
  fax_EQUAL?: string | null;
  fax_GT?: number | null;
  fax_GTE?: number | null;
  fax_LONGEST_EQUAL?: number | null;
  fax_LONGEST_GT?: number | null;
  fax_LONGEST_GTE?: number | null;
  fax_LONGEST_LT?: number | null;
  fax_LONGEST_LTE?: number | null;
  fax_LT?: number | null;
  fax_LTE?: number | null;
  fax_SHORTEST_EQUAL?: number | null;
  fax_SHORTEST_GT?: number | null;
  fax_SHORTEST_GTE?: number | null;
  fax_SHORTEST_LT?: number | null;
  fax_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  legalName_AVERAGE_EQUAL?: number | null;
  legalName_AVERAGE_GT?: number | null;
  legalName_AVERAGE_GTE?: number | null;
  legalName_AVERAGE_LT?: number | null;
  legalName_AVERAGE_LTE?: number | null;
  legalName_EQUAL?: string | null;
  legalName_GT?: number | null;
  legalName_GTE?: number | null;
  legalName_LONGEST_EQUAL?: number | null;
  legalName_LONGEST_GT?: number | null;
  legalName_LONGEST_GTE?: number | null;
  legalName_LONGEST_LT?: number | null;
  legalName_LONGEST_LTE?: number | null;
  legalName_LT?: number | null;
  legalName_LTE?: number | null;
  legalName_SHORTEST_EQUAL?: number | null;
  legalName_SHORTEST_GT?: number | null;
  legalName_SHORTEST_GTE?: number | null;
  legalName_SHORTEST_LT?: number | null;
  legalName_SHORTEST_LTE?: number | null;
  logo_AVERAGE_EQUAL?: number | null;
  logo_AVERAGE_GT?: number | null;
  logo_AVERAGE_GTE?: number | null;
  logo_AVERAGE_LT?: number | null;
  logo_AVERAGE_LTE?: number | null;
  logo_EQUAL?: string | null;
  logo_GT?: number | null;
  logo_GTE?: number | null;
  logo_LONGEST_EQUAL?: number | null;
  logo_LONGEST_GT?: number | null;
  logo_LONGEST_GTE?: number | null;
  logo_LONGEST_LT?: number | null;
  logo_LONGEST_LTE?: number | null;
  logo_LT?: number | null;
  logo_LTE?: number | null;
  logo_SHORTEST_EQUAL?: number | null;
  logo_SHORTEST_GT?: number | null;
  logo_SHORTEST_GTE?: number | null;
  logo_SHORTEST_LT?: number | null;
  logo_SHORTEST_LTE?: number | null;
  name_AVERAGE_EQUAL?: number | null;
  name_AVERAGE_GT?: number | null;
  name_AVERAGE_GTE?: number | null;
  name_AVERAGE_LT?: number | null;
  name_AVERAGE_LTE?: number | null;
  name_EQUAL?: string | null;
  name_GT?: number | null;
  name_GTE?: number | null;
  name_LONGEST_EQUAL?: number | null;
  name_LONGEST_GT?: number | null;
  name_LONGEST_GTE?: number | null;
  name_LONGEST_LT?: number | null;
  name_LONGEST_LTE?: number | null;
  name_LT?: number | null;
  name_LTE?: number | null;
  name_SHORTEST_EQUAL?: number | null;
  name_SHORTEST_GT?: number | null;
  name_SHORTEST_GTE?: number | null;
  name_SHORTEST_LT?: number | null;
  name_SHORTEST_LTE?: number | null;
  paymentTerms_AVERAGE_EQUAL?: number | null;
  paymentTerms_AVERAGE_GT?: number | null;
  paymentTerms_AVERAGE_GTE?: number | null;
  paymentTerms_AVERAGE_LT?: number | null;
  paymentTerms_AVERAGE_LTE?: number | null;
  paymentTerms_EQUAL?: number | null;
  paymentTerms_GT?: number | null;
  paymentTerms_GTE?: number | null;
  paymentTerms_LT?: number | null;
  paymentTerms_LTE?: number | null;
  paymentTerms_MAX_EQUAL?: number | null;
  paymentTerms_MAX_GT?: number | null;
  paymentTerms_MAX_GTE?: number | null;
  paymentTerms_MAX_LT?: number | null;
  paymentTerms_MAX_LTE?: number | null;
  paymentTerms_MIN_EQUAL?: number | null;
  paymentTerms_MIN_GT?: number | null;
  paymentTerms_MIN_GTE?: number | null;
  paymentTerms_MIN_LT?: number | null;
  paymentTerms_MIN_LTE?: number | null;
  paymentTerms_SUM_EQUAL?: number | null;
  paymentTerms_SUM_GT?: number | null;
  paymentTerms_SUM_GTE?: number | null;
  paymentTerms_SUM_LT?: number | null;
  paymentTerms_SUM_LTE?: number | null;
  phone_AVERAGE_EQUAL?: number | null;
  phone_AVERAGE_GT?: number | null;
  phone_AVERAGE_GTE?: number | null;
  phone_AVERAGE_LT?: number | null;
  phone_AVERAGE_LTE?: number | null;
  phone_EQUAL?: string | null;
  phone_GT?: number | null;
  phone_GTE?: number | null;
  phone_LONGEST_EQUAL?: number | null;
  phone_LONGEST_GT?: number | null;
  phone_LONGEST_GTE?: number | null;
  phone_LONGEST_LT?: number | null;
  phone_LONGEST_LTE?: number | null;
  phone_LT?: number | null;
  phone_LTE?: number | null;
  phone_SHORTEST_EQUAL?: number | null;
  phone_SHORTEST_GT?: number | null;
  phone_SHORTEST_GTE?: number | null;
  phone_SHORTEST_LT?: number | null;
  phone_SHORTEST_LTE?: number | null;
  tenantId_AVERAGE_EQUAL?: number | null;
  tenantId_AVERAGE_GT?: number | null;
  tenantId_AVERAGE_GTE?: number | null;
  tenantId_AVERAGE_LT?: number | null;
  tenantId_AVERAGE_LTE?: number | null;
  tenantId_EQUAL?: string | null;
  tenantId_GT?: number | null;
  tenantId_GTE?: number | null;
  tenantId_LONGEST_EQUAL?: number | null;
  tenantId_LONGEST_GT?: number | null;
  tenantId_LONGEST_GTE?: number | null;
  tenantId_LONGEST_LT?: number | null;
  tenantId_LONGEST_LTE?: number | null;
  tenantId_LT?: number | null;
  tenantId_LTE?: number | null;
  tenantId_SHORTEST_EQUAL?: number | null;
  tenantId_SHORTEST_GT?: number | null;
  tenantId_SHORTEST_GTE?: number | null;
  tenantId_SHORTEST_LT?: number | null;
  tenantId_SHORTEST_LTE?: number | null;
  website_AVERAGE_EQUAL?: number | null;
  website_AVERAGE_GT?: number | null;
  website_AVERAGE_GTE?: number | null;
  website_AVERAGE_LT?: number | null;
  website_AVERAGE_LTE?: number | null;
  website_EQUAL?: string | null;
  website_GT?: number | null;
  website_GTE?: number | null;
  website_LONGEST_EQUAL?: number | null;
  website_LONGEST_GT?: number | null;
  website_LONGEST_GTE?: number | null;
  website_LONGEST_LT?: number | null;
  website_LONGEST_LTE?: number | null;
  website_LT?: number | null;
  website_LTE?: number | null;
  website_SHORTEST_EQUAL?: number | null;
  website_SHORTEST_GT?: number | null;
  website_SHORTEST_GTE?: number | null;
  website_SHORTEST_LT?: number | null;
  website_SHORTEST_LTE?: number | null;
}

export interface DataContainerWhere {
  AND?: DataContainerWhere[] | null;
  OR?: DataContainerWhere[] | null;
  creationWays?: DataContainerCreationWay[] | null;
  creationWays_INCLUDES?: DataContainerCreationWay | null;
  creationWays_NOT?: DataContainerCreationWay[] | null;
  creationWays_NOT_INCLUDES?: DataContainerCreationWay | null;
  isStartingPoint?: boolean | null;
  isStartingPoint_NOT?: boolean | null;
  providers?: OrganizationWhere | null;
  providersAggregate?: DataContainerProvidersAggregateInput | null;
  providersConnection?: DataContainerProvidersConnectionWhere | null;
  providersConnection_NOT?: DataContainerProvidersConnectionWhere | null;
  providers_NOT?: OrganizationWhere | null;
  restrictedDataPointNames?: string[] | null;
  restrictedDataPointNames_INCLUDES?: string | null;
  restrictedDataPointNames_NOT?: string[] | null;
  restrictedDataPointNames_NOT_INCLUDES?: string | null;
  sharedDataPointNames?: string[] | null;
  sharedDataPointNames_INCLUDES?: string | null;
  sharedDataPointNames_NOT?: string[] | null;
  sharedDataPointNames_NOT_INCLUDES?: string | null;
  sharingTrigger?: DataContainerSharingTrigger | null;
  sharingTrigger_IN?: (DataContainerSharingTrigger | null)[] | null;
  sharingTrigger_NOT?: DataContainerSharingTrigger | null;
  sharingTrigger_NOT_IN?: (DataContainerSharingTrigger | null)[] | null;
  subType?: string | null;
  subType_CONTAINS?: string | null;
  subType_ENDS_WITH?: string | null;
  subType_IN?: (string | null)[] | null;
  subType_MATCHES?: string | null;
  subType_NOT?: string | null;
  subType_NOT_CONTAINS?: string | null;
  subType_NOT_ENDS_WITH?: string | null;
  subType_NOT_IN?: (string | null)[] | null;
  subType_NOT_STARTS_WITH?: string | null;
  subType_STARTS_WITH?: string | null;
  timeframeEnd?: number | null;
  timeframeEnd_GT?: number | null;
  timeframeEnd_GTE?: number | null;
  timeframeEnd_IN?: (number | null)[] | null;
  timeframeEnd_LT?: number | null;
  timeframeEnd_LTE?: number | null;
  timeframeEnd_NOT?: number | null;
  timeframeEnd_NOT_IN?: (number | null)[] | null;
  timeframeRangeType?: TimeframeRangeType | null;
  timeframeRangeType_IN?: (TimeframeRangeType | null)[] | null;
  timeframeRangeType_NOT?: TimeframeRangeType | null;
  timeframeRangeType_NOT_IN?: (TimeframeRangeType | null)[] | null;
  timeframeStart?: number | null;
  timeframeStart_GT?: number | null;
  timeframeStart_GTE?: number | null;
  timeframeStart_IN?: (number | null)[] | null;
  timeframeStart_LT?: number | null;
  timeframeStart_LTE?: number | null;
  timeframeStart_NOT?: number | null;
  timeframeStart_NOT_IN?: (number | null)[] | null;
  timeframeStartingPoint?: TimeframeStartingPoint | null;
  timeframeStartingPoint_IN?: (TimeframeStartingPoint | null)[] | null;
  timeframeStartingPoint_NOT?: TimeframeStartingPoint | null;
  timeframeStartingPoint_NOT_IN?: (TimeframeStartingPoint | null)[] | null;
  type?: FlexContainerType | null;
  type_IN?: (FlexContainerType | null)[] | null;
  type_NOT?: FlexContainerType | null;
  type_NOT_IN?: (FlexContainerType | null)[] | null;
}

export interface DataSourceWhere {
  AND?: DataSourceWhere[] | null;
  OR?: DataSourceWhere[] | null;
  id?: string | null;
  id_CONTAINS?: string | null;
  id_ENDS_WITH?: string | null;
  id_IN?: (string | null)[] | null;
  id_MATCHES?: string | null;
  id_NOT?: string | null;
  id_NOT_CONTAINS?: string | null;
  id_NOT_ENDS_WITH?: string | null;
  id_NOT_IN?: (string | null)[] | null;
  id_NOT_STARTS_WITH?: string | null;
  id_STARTS_WITH?: string | null;
  name?: string | null;
  name_CONTAINS?: string | null;
  name_ENDS_WITH?: string | null;
  name_IN?: (string | null)[] | null;
  name_MATCHES?: string | null;
  name_NOT?: string | null;
  name_NOT_CONTAINS?: string | null;
  name_NOT_ENDS_WITH?: string | null;
  name_NOT_IN?: (string | null)[] | null;
  name_NOT_STARTS_WITH?: string | null;
  name_STARTS_WITH?: string | null;
}

export interface DefaultUserRoleUpdateInput {
  agreementAssignee?: boolean | null;
  agreementTag: AgreementTagType;
  caseAssignee?: AssigneeStatus | null;
  documentAssignee?: AssigneeStatus | null;
  role: string;
  userId: string;
}

export interface DeleteInvoiceInput {
  invoiceId: string;
}

export interface DeleteThreadMessageInput {
  createdOn: number;
  id: string;
  nodeLabel: SupportedMessageNodes;
}

export interface DependencyAttributeWhere {
  AND?: DependencyAttributeWhere[] | null;
  OR?: DependencyAttributeWhere[] | null;
  comment?: string | null;
  comment_CONTAINS?: string | null;
  comment_ENDS_WITH?: string | null;
  comment_IN?: (string | null)[] | null;
  comment_MATCHES?: string | null;
  comment_NOT?: string | null;
  comment_NOT_CONTAINS?: string | null;
  comment_NOT_ENDS_WITH?: string | null;
  comment_NOT_IN?: (string | null)[] | null;
  comment_NOT_STARTS_WITH?: string | null;
  comment_STARTS_WITH?: string | null;
  rules?: string | null;
  rules_CONTAINS?: string | null;
  rules_ENDS_WITH?: string | null;
  rules_IN?: (string | null)[] | null;
  rules_MATCHES?: string | null;
  rules_NOT?: string | null;
  rules_NOT_CONTAINS?: string | null;
  rules_NOT_ENDS_WITH?: string | null;
  rules_NOT_IN?: (string | null)[] | null;
  rules_NOT_STARTS_WITH?: string | null;
  rules_STARTS_WITH?: string | null;
}

export interface DeviceAlternativeAlternativesAggregateInput {
  AND?: DeviceAlternativeAlternativesAggregateInput[] | null;
  OR?: DeviceAlternativeAlternativesAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: DeviceAlternativeAlternativesNodeAggregationWhereInput | null;
}

export interface DeviceAlternativeAlternativesConnectionWhere {
  AND?: DeviceAlternativeAlternativesConnectionWhere[] | null;
  OR?: DeviceAlternativeAlternativesConnectionWhere[] | null;
  node?: TreatmentWhere | null;
  node_NOT?: TreatmentWhere | null;
}

export interface DeviceAlternativeAlternativesNodeAggregationWhereInput {
  AND?: DeviceAlternativeAlternativesNodeAggregationWhereInput[] | null;
  BagDossierNo_AVERAGE_EQUAL?: number | null;
  BagDossierNo_AVERAGE_GT?: number | null;
  BagDossierNo_AVERAGE_GTE?: number | null;
  BagDossierNo_AVERAGE_LT?: number | null;
  BagDossierNo_AVERAGE_LTE?: number | null;
  BagDossierNo_EQUAL?: string | null;
  BagDossierNo_GT?: number | null;
  BagDossierNo_GTE?: number | null;
  BagDossierNo_LONGEST_EQUAL?: number | null;
  BagDossierNo_LONGEST_GT?: number | null;
  BagDossierNo_LONGEST_GTE?: number | null;
  BagDossierNo_LONGEST_LT?: number | null;
  BagDossierNo_LONGEST_LTE?: number | null;
  BagDossierNo_LT?: number | null;
  BagDossierNo_LTE?: number | null;
  BagDossierNo_SHORTEST_EQUAL?: number | null;
  BagDossierNo_SHORTEST_GT?: number | null;
  BagDossierNo_SHORTEST_GTE?: number | null;
  BagDossierNo_SHORTEST_LT?: number | null;
  BagDossierNo_SHORTEST_LTE?: number | null;
  Code_AVERAGE_EQUAL?: number | null;
  Code_AVERAGE_GT?: number | null;
  Code_AVERAGE_GTE?: number | null;
  Code_AVERAGE_LT?: number | null;
  Code_AVERAGE_LTE?: number | null;
  Code_EQUAL?: string | null;
  Code_GT?: number | null;
  Code_GTE?: number | null;
  Code_LONGEST_EQUAL?: number | null;
  Code_LONGEST_GT?: number | null;
  Code_LONGEST_GTE?: number | null;
  Code_LONGEST_LT?: number | null;
  Code_LONGEST_LTE?: number | null;
  Code_LT?: number | null;
  Code_LTE?: number | null;
  Code_SHORTEST_EQUAL?: number | null;
  Code_SHORTEST_GT?: number | null;
  Code_SHORTEST_GTE?: number | null;
  Code_SHORTEST_LT?: number | null;
  Code_SHORTEST_LTE?: number | null;
  FlagModal_AVERAGE_EQUAL?: number | null;
  FlagModal_AVERAGE_GT?: number | null;
  FlagModal_AVERAGE_GTE?: number | null;
  FlagModal_AVERAGE_LT?: number | null;
  FlagModal_AVERAGE_LTE?: number | null;
  FlagModal_EQUAL?: string | null;
  FlagModal_GT?: number | null;
  FlagModal_GTE?: number | null;
  FlagModal_LONGEST_EQUAL?: number | null;
  FlagModal_LONGEST_GT?: number | null;
  FlagModal_LONGEST_GTE?: number | null;
  FlagModal_LONGEST_LT?: number | null;
  FlagModal_LONGEST_LTE?: number | null;
  FlagModal_LT?: number | null;
  FlagModal_LTE?: number | null;
  FlagModal_SHORTEST_EQUAL?: number | null;
  FlagModal_SHORTEST_GT?: number | null;
  FlagModal_SHORTEST_GTE?: number | null;
  FlagModal_SHORTEST_LT?: number | null;
  FlagModal_SHORTEST_LTE?: number | null;
  FlagNarcosis_AVERAGE_EQUAL?: number | null;
  FlagNarcosis_AVERAGE_GT?: number | null;
  FlagNarcosis_AVERAGE_GTE?: number | null;
  FlagNarcosis_AVERAGE_LT?: number | null;
  FlagNarcosis_AVERAGE_LTE?: number | null;
  FlagNarcosis_EQUAL?: string | null;
  FlagNarcosis_GT?: number | null;
  FlagNarcosis_GTE?: number | null;
  FlagNarcosis_LONGEST_EQUAL?: number | null;
  FlagNarcosis_LONGEST_GT?: number | null;
  FlagNarcosis_LONGEST_GTE?: number | null;
  FlagNarcosis_LONGEST_LT?: number | null;
  FlagNarcosis_LONGEST_LTE?: number | null;
  FlagNarcosis_LT?: number | null;
  FlagNarcosis_LTE?: number | null;
  FlagNarcosis_SHORTEST_EQUAL?: number | null;
  FlagNarcosis_SHORTEST_GT?: number | null;
  FlagNarcosis_SHORTEST_GTE?: number | null;
  FlagNarcosis_SHORTEST_LT?: number | null;
  FlagNarcosis_SHORTEST_LTE?: number | null;
  GTIN_AVERAGE_EQUAL?: number | null;
  GTIN_AVERAGE_GT?: number | null;
  GTIN_AVERAGE_GTE?: number | null;
  GTIN_AVERAGE_LT?: number | null;
  GTIN_AVERAGE_LTE?: number | null;
  GTIN_EQUAL?: string | null;
  GTIN_GT?: number | null;
  GTIN_GTE?: number | null;
  GTIN_LONGEST_EQUAL?: number | null;
  GTIN_LONGEST_GT?: number | null;
  GTIN_LONGEST_GTE?: number | null;
  GTIN_LONGEST_LT?: number | null;
  GTIN_LONGEST_LTE?: number | null;
  GTIN_LT?: number | null;
  GTIN_LTE?: number | null;
  GTIN_SHORTEST_EQUAL?: number | null;
  GTIN_SHORTEST_GT?: number | null;
  GTIN_SHORTEST_GTE?: number | null;
  GTIN_SHORTEST_LT?: number | null;
  GTIN_SHORTEST_LTE?: number | null;
  LOT_AVERAGE_EQUAL?: number | null;
  LOT_AVERAGE_GT?: number | null;
  LOT_AVERAGE_GTE?: number | null;
  LOT_AVERAGE_LT?: number | null;
  LOT_AVERAGE_LTE?: number | null;
  LOT_EQUAL?: string | null;
  LOT_GT?: number | null;
  LOT_GTE?: number | null;
  LOT_LONGEST_EQUAL?: number | null;
  LOT_LONGEST_GT?: number | null;
  LOT_LONGEST_GTE?: number | null;
  LOT_LONGEST_LT?: number | null;
  LOT_LONGEST_LTE?: number | null;
  LOT_LT?: number | null;
  LOT_LTE?: number | null;
  LOT_SHORTEST_EQUAL?: number | null;
  LOT_SHORTEST_GT?: number | null;
  LOT_SHORTEST_GTE?: number | null;
  LOT_SHORTEST_LT?: number | null;
  LOT_SHORTEST_LTE?: number | null;
  Name_AVERAGE_EQUAL?: number | null;
  Name_AVERAGE_GT?: number | null;
  Name_AVERAGE_GTE?: number | null;
  Name_AVERAGE_LT?: number | null;
  Name_AVERAGE_LTE?: number | null;
  Name_EQUAL?: string | null;
  Name_GT?: number | null;
  Name_GTE?: number | null;
  Name_LONGEST_EQUAL?: number | null;
  Name_LONGEST_GT?: number | null;
  Name_LONGEST_GTE?: number | null;
  Name_LONGEST_LT?: number | null;
  Name_LONGEST_LTE?: number | null;
  Name_LT?: number | null;
  Name_LTE?: number | null;
  Name_SHORTEST_EQUAL?: number | null;
  Name_SHORTEST_GT?: number | null;
  Name_SHORTEST_GTE?: number | null;
  Name_SHORTEST_LT?: number | null;
  Name_SHORTEST_LTE?: number | null;
  OR?: DeviceAlternativeAlternativesNodeAggregationWhereInput[] | null;
  PharmaCode_AVERAGE_EQUAL?: number | null;
  PharmaCode_AVERAGE_GT?: number | null;
  PharmaCode_AVERAGE_GTE?: number | null;
  PharmaCode_AVERAGE_LT?: number | null;
  PharmaCode_AVERAGE_LTE?: number | null;
  PharmaCode_EQUAL?: string | null;
  PharmaCode_GT?: number | null;
  PharmaCode_GTE?: number | null;
  PharmaCode_LONGEST_EQUAL?: number | null;
  PharmaCode_LONGEST_GT?: number | null;
  PharmaCode_LONGEST_GTE?: number | null;
  PharmaCode_LONGEST_LT?: number | null;
  PharmaCode_LONGEST_LTE?: number | null;
  PharmaCode_LT?: number | null;
  PharmaCode_LTE?: number | null;
  PharmaCode_SHORTEST_EQUAL?: number | null;
  PharmaCode_SHORTEST_GT?: number | null;
  PharmaCode_SHORTEST_GTE?: number | null;
  PharmaCode_SHORTEST_LT?: number | null;
  PharmaCode_SHORTEST_LTE?: number | null;
  PrevPharmacode_AVERAGE_EQUAL?: number | null;
  PrevPharmacode_AVERAGE_GT?: number | null;
  PrevPharmacode_AVERAGE_GTE?: number | null;
  PrevPharmacode_AVERAGE_LT?: number | null;
  PrevPharmacode_AVERAGE_LTE?: number | null;
  PrevPharmacode_EQUAL?: string | null;
  PrevPharmacode_GT?: number | null;
  PrevPharmacode_GTE?: number | null;
  PrevPharmacode_LONGEST_EQUAL?: number | null;
  PrevPharmacode_LONGEST_GT?: number | null;
  PrevPharmacode_LONGEST_GTE?: number | null;
  PrevPharmacode_LONGEST_LT?: number | null;
  PrevPharmacode_LONGEST_LTE?: number | null;
  PrevPharmacode_LT?: number | null;
  PrevPharmacode_LTE?: number | null;
  PrevPharmacode_SHORTEST_EQUAL?: number | null;
  PrevPharmacode_SHORTEST_GT?: number | null;
  PrevPharmacode_SHORTEST_GTE?: number | null;
  PrevPharmacode_SHORTEST_LT?: number | null;
  PrevPharmacode_SHORTEST_LTE?: number | null;
  REF_AVERAGE_EQUAL?: number | null;
  REF_AVERAGE_GT?: number | null;
  REF_AVERAGE_GTE?: number | null;
  REF_AVERAGE_LT?: number | null;
  REF_AVERAGE_LTE?: number | null;
  REF_EQUAL?: string | null;
  REF_GT?: number | null;
  REF_GTE?: number | null;
  REF_LONGEST_EQUAL?: number | null;
  REF_LONGEST_GT?: number | null;
  REF_LONGEST_GTE?: number | null;
  REF_LONGEST_LT?: number | null;
  REF_LONGEST_LTE?: number | null;
  REF_LT?: number | null;
  REF_LTE?: number | null;
  REF_SHORTEST_EQUAL?: number | null;
  REF_SHORTEST_GT?: number | null;
  REF_SHORTEST_GTE?: number | null;
  REF_SHORTEST_LT?: number | null;
  REF_SHORTEST_LTE?: number | null;
  SwissmedicCategory_AVERAGE_EQUAL?: number | null;
  SwissmedicCategory_AVERAGE_GT?: number | null;
  SwissmedicCategory_AVERAGE_GTE?: number | null;
  SwissmedicCategory_AVERAGE_LT?: number | null;
  SwissmedicCategory_AVERAGE_LTE?: number | null;
  SwissmedicCategory_EQUAL?: string | null;
  SwissmedicCategory_GT?: number | null;
  SwissmedicCategory_GTE?: number | null;
  SwissmedicCategory_LONGEST_EQUAL?: number | null;
  SwissmedicCategory_LONGEST_GT?: number | null;
  SwissmedicCategory_LONGEST_GTE?: number | null;
  SwissmedicCategory_LONGEST_LT?: number | null;
  SwissmedicCategory_LONGEST_LTE?: number | null;
  SwissmedicCategory_LT?: number | null;
  SwissmedicCategory_LTE?: number | null;
  SwissmedicCategory_SHORTEST_EQUAL?: number | null;
  SwissmedicCategory_SHORTEST_GT?: number | null;
  SwissmedicCategory_SHORTEST_GTE?: number | null;
  SwissmedicCategory_SHORTEST_LT?: number | null;
  SwissmedicCategory_SHORTEST_LTE?: number | null;
  SwissmedicNo8_AVERAGE_EQUAL?: number | null;
  SwissmedicNo8_AVERAGE_GT?: number | null;
  SwissmedicNo8_AVERAGE_GTE?: number | null;
  SwissmedicNo8_AVERAGE_LT?: number | null;
  SwissmedicNo8_AVERAGE_LTE?: number | null;
  SwissmedicNo8_EQUAL?: string | null;
  SwissmedicNo8_GT?: number | null;
  SwissmedicNo8_GTE?: number | null;
  SwissmedicNo8_LONGEST_EQUAL?: number | null;
  SwissmedicNo8_LONGEST_GT?: number | null;
  SwissmedicNo8_LONGEST_GTE?: number | null;
  SwissmedicNo8_LONGEST_LT?: number | null;
  SwissmedicNo8_LONGEST_LTE?: number | null;
  SwissmedicNo8_LT?: number | null;
  SwissmedicNo8_LTE?: number | null;
  SwissmedicNo8_SHORTEST_EQUAL?: number | null;
  SwissmedicNo8_SHORTEST_GT?: number | null;
  SwissmedicNo8_SHORTEST_GTE?: number | null;
  SwissmedicNo8_SHORTEST_LT?: number | null;
  SwissmedicNo8_SHORTEST_LTE?: number | null;
  UDI_AVERAGE_EQUAL?: number | null;
  UDI_AVERAGE_GT?: number | null;
  UDI_AVERAGE_GTE?: number | null;
  UDI_AVERAGE_LT?: number | null;
  UDI_AVERAGE_LTE?: number | null;
  UDI_EQUAL?: string | null;
  UDI_GT?: number | null;
  UDI_GTE?: number | null;
  UDI_LONGEST_EQUAL?: number | null;
  UDI_LONGEST_GT?: number | null;
  UDI_LONGEST_GTE?: number | null;
  UDI_LONGEST_LT?: number | null;
  UDI_LONGEST_LTE?: number | null;
  UDI_LT?: number | null;
  UDI_LTE?: number | null;
  UDI_SHORTEST_EQUAL?: number | null;
  UDI_SHORTEST_GT?: number | null;
  UDI_SHORTEST_GTE?: number | null;
  UDI_SHORTEST_LT?: number | null;
  UDI_SHORTEST_LTE?: number | null;
  activeIngredientQuantity_AVERAGE_EQUAL?: number | null;
  activeIngredientQuantity_AVERAGE_GT?: number | null;
  activeIngredientQuantity_AVERAGE_GTE?: number | null;
  activeIngredientQuantity_AVERAGE_LT?: number | null;
  activeIngredientQuantity_AVERAGE_LTE?: number | null;
  activeIngredientQuantity_EQUAL?: number | null;
  activeIngredientQuantity_GT?: number | null;
  activeIngredientQuantity_GTE?: number | null;
  activeIngredientQuantity_LT?: number | null;
  activeIngredientQuantity_LTE?: number | null;
  activeIngredientQuantity_MAX_EQUAL?: number | null;
  activeIngredientQuantity_MAX_GT?: number | null;
  activeIngredientQuantity_MAX_GTE?: number | null;
  activeIngredientQuantity_MAX_LT?: number | null;
  activeIngredientQuantity_MAX_LTE?: number | null;
  activeIngredientQuantity_MIN_EQUAL?: number | null;
  activeIngredientQuantity_MIN_GT?: number | null;
  activeIngredientQuantity_MIN_GTE?: number | null;
  activeIngredientQuantity_MIN_LT?: number | null;
  activeIngredientQuantity_MIN_LTE?: number | null;
  activeIngredientQuantity_SUM_EQUAL?: number | null;
  activeIngredientQuantity_SUM_GT?: number | null;
  activeIngredientQuantity_SUM_GTE?: number | null;
  activeIngredientQuantity_SUM_LT?: number | null;
  activeIngredientQuantity_SUM_LTE?: number | null;
  classificationSystem_AVERAGE_EQUAL?: number | null;
  classificationSystem_AVERAGE_GT?: number | null;
  classificationSystem_AVERAGE_GTE?: number | null;
  classificationSystem_AVERAGE_LT?: number | null;
  classificationSystem_AVERAGE_LTE?: number | null;
  classificationSystem_EQUAL?: string | null;
  classificationSystem_GT?: number | null;
  classificationSystem_GTE?: number | null;
  classificationSystem_LONGEST_EQUAL?: number | null;
  classificationSystem_LONGEST_GT?: number | null;
  classificationSystem_LONGEST_GTE?: number | null;
  classificationSystem_LONGEST_LT?: number | null;
  classificationSystem_LONGEST_LTE?: number | null;
  classificationSystem_LT?: number | null;
  classificationSystem_LTE?: number | null;
  classificationSystem_SHORTEST_EQUAL?: number | null;
  classificationSystem_SHORTEST_GT?: number | null;
  classificationSystem_SHORTEST_GTE?: number | null;
  classificationSystem_SHORTEST_LT?: number | null;
  classificationSystem_SHORTEST_LTE?: number | null;
  concentration_AVERAGE_EQUAL?: number | null;
  concentration_AVERAGE_GT?: number | null;
  concentration_AVERAGE_GTE?: number | null;
  concentration_AVERAGE_LT?: number | null;
  concentration_AVERAGE_LTE?: number | null;
  concentration_EQUAL?: string | null;
  concentration_GT?: number | null;
  concentration_GTE?: number | null;
  concentration_LONGEST_EQUAL?: number | null;
  concentration_LONGEST_GT?: number | null;
  concentration_LONGEST_GTE?: number | null;
  concentration_LONGEST_LT?: number | null;
  concentration_LONGEST_LTE?: number | null;
  concentration_LT?: number | null;
  concentration_LTE?: number | null;
  concentration_SHORTEST_EQUAL?: number | null;
  concentration_SHORTEST_GT?: number | null;
  concentration_SHORTEST_GTE?: number | null;
  concentration_SHORTEST_LT?: number | null;
  concentration_SHORTEST_LTE?: number | null;
  packVolume_AVERAGE_EQUAL?: number | null;
  packVolume_AVERAGE_GT?: number | null;
  packVolume_AVERAGE_GTE?: number | null;
  packVolume_AVERAGE_LT?: number | null;
  packVolume_AVERAGE_LTE?: number | null;
  packVolume_EQUAL?: string | null;
  packVolume_GT?: number | null;
  packVolume_GTE?: number | null;
  packVolume_LONGEST_EQUAL?: number | null;
  packVolume_LONGEST_GT?: number | null;
  packVolume_LONGEST_GTE?: number | null;
  packVolume_LONGEST_LT?: number | null;
  packVolume_LONGEST_LTE?: number | null;
  packVolume_LT?: number | null;
  packVolume_LTE?: number | null;
  packVolume_SHORTEST_EQUAL?: number | null;
  packVolume_SHORTEST_GT?: number | null;
  packVolume_SHORTEST_GTE?: number | null;
  packVolume_SHORTEST_LT?: number | null;
  packVolume_SHORTEST_LTE?: number | null;
}

export interface DeviceAlternativeDeviceProductAggregateInput {
  AND?: DeviceAlternativeDeviceProductAggregateInput[] | null;
  OR?: DeviceAlternativeDeviceProductAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: DeviceAlternativeDeviceProductNodeAggregationWhereInput | null;
}

export interface DeviceAlternativeDeviceProductConnectionWhere {
  AND?: DeviceAlternativeDeviceProductConnectionWhere[] | null;
  OR?: DeviceAlternativeDeviceProductConnectionWhere[] | null;
  node?: TreatmentWhere | null;
  node_NOT?: TreatmentWhere | null;
}

export interface DeviceAlternativeDeviceProductNodeAggregationWhereInput {
  AND?: DeviceAlternativeDeviceProductNodeAggregationWhereInput[] | null;
  BagDossierNo_AVERAGE_EQUAL?: number | null;
  BagDossierNo_AVERAGE_GT?: number | null;
  BagDossierNo_AVERAGE_GTE?: number | null;
  BagDossierNo_AVERAGE_LT?: number | null;
  BagDossierNo_AVERAGE_LTE?: number | null;
  BagDossierNo_EQUAL?: string | null;
  BagDossierNo_GT?: number | null;
  BagDossierNo_GTE?: number | null;
  BagDossierNo_LONGEST_EQUAL?: number | null;
  BagDossierNo_LONGEST_GT?: number | null;
  BagDossierNo_LONGEST_GTE?: number | null;
  BagDossierNo_LONGEST_LT?: number | null;
  BagDossierNo_LONGEST_LTE?: number | null;
  BagDossierNo_LT?: number | null;
  BagDossierNo_LTE?: number | null;
  BagDossierNo_SHORTEST_EQUAL?: number | null;
  BagDossierNo_SHORTEST_GT?: number | null;
  BagDossierNo_SHORTEST_GTE?: number | null;
  BagDossierNo_SHORTEST_LT?: number | null;
  BagDossierNo_SHORTEST_LTE?: number | null;
  Code_AVERAGE_EQUAL?: number | null;
  Code_AVERAGE_GT?: number | null;
  Code_AVERAGE_GTE?: number | null;
  Code_AVERAGE_LT?: number | null;
  Code_AVERAGE_LTE?: number | null;
  Code_EQUAL?: string | null;
  Code_GT?: number | null;
  Code_GTE?: number | null;
  Code_LONGEST_EQUAL?: number | null;
  Code_LONGEST_GT?: number | null;
  Code_LONGEST_GTE?: number | null;
  Code_LONGEST_LT?: number | null;
  Code_LONGEST_LTE?: number | null;
  Code_LT?: number | null;
  Code_LTE?: number | null;
  Code_SHORTEST_EQUAL?: number | null;
  Code_SHORTEST_GT?: number | null;
  Code_SHORTEST_GTE?: number | null;
  Code_SHORTEST_LT?: number | null;
  Code_SHORTEST_LTE?: number | null;
  FlagModal_AVERAGE_EQUAL?: number | null;
  FlagModal_AVERAGE_GT?: number | null;
  FlagModal_AVERAGE_GTE?: number | null;
  FlagModal_AVERAGE_LT?: number | null;
  FlagModal_AVERAGE_LTE?: number | null;
  FlagModal_EQUAL?: string | null;
  FlagModal_GT?: number | null;
  FlagModal_GTE?: number | null;
  FlagModal_LONGEST_EQUAL?: number | null;
  FlagModal_LONGEST_GT?: number | null;
  FlagModal_LONGEST_GTE?: number | null;
  FlagModal_LONGEST_LT?: number | null;
  FlagModal_LONGEST_LTE?: number | null;
  FlagModal_LT?: number | null;
  FlagModal_LTE?: number | null;
  FlagModal_SHORTEST_EQUAL?: number | null;
  FlagModal_SHORTEST_GT?: number | null;
  FlagModal_SHORTEST_GTE?: number | null;
  FlagModal_SHORTEST_LT?: number | null;
  FlagModal_SHORTEST_LTE?: number | null;
  FlagNarcosis_AVERAGE_EQUAL?: number | null;
  FlagNarcosis_AVERAGE_GT?: number | null;
  FlagNarcosis_AVERAGE_GTE?: number | null;
  FlagNarcosis_AVERAGE_LT?: number | null;
  FlagNarcosis_AVERAGE_LTE?: number | null;
  FlagNarcosis_EQUAL?: string | null;
  FlagNarcosis_GT?: number | null;
  FlagNarcosis_GTE?: number | null;
  FlagNarcosis_LONGEST_EQUAL?: number | null;
  FlagNarcosis_LONGEST_GT?: number | null;
  FlagNarcosis_LONGEST_GTE?: number | null;
  FlagNarcosis_LONGEST_LT?: number | null;
  FlagNarcosis_LONGEST_LTE?: number | null;
  FlagNarcosis_LT?: number | null;
  FlagNarcosis_LTE?: number | null;
  FlagNarcosis_SHORTEST_EQUAL?: number | null;
  FlagNarcosis_SHORTEST_GT?: number | null;
  FlagNarcosis_SHORTEST_GTE?: number | null;
  FlagNarcosis_SHORTEST_LT?: number | null;
  FlagNarcosis_SHORTEST_LTE?: number | null;
  GTIN_AVERAGE_EQUAL?: number | null;
  GTIN_AVERAGE_GT?: number | null;
  GTIN_AVERAGE_GTE?: number | null;
  GTIN_AVERAGE_LT?: number | null;
  GTIN_AVERAGE_LTE?: number | null;
  GTIN_EQUAL?: string | null;
  GTIN_GT?: number | null;
  GTIN_GTE?: number | null;
  GTIN_LONGEST_EQUAL?: number | null;
  GTIN_LONGEST_GT?: number | null;
  GTIN_LONGEST_GTE?: number | null;
  GTIN_LONGEST_LT?: number | null;
  GTIN_LONGEST_LTE?: number | null;
  GTIN_LT?: number | null;
  GTIN_LTE?: number | null;
  GTIN_SHORTEST_EQUAL?: number | null;
  GTIN_SHORTEST_GT?: number | null;
  GTIN_SHORTEST_GTE?: number | null;
  GTIN_SHORTEST_LT?: number | null;
  GTIN_SHORTEST_LTE?: number | null;
  LOT_AVERAGE_EQUAL?: number | null;
  LOT_AVERAGE_GT?: number | null;
  LOT_AVERAGE_GTE?: number | null;
  LOT_AVERAGE_LT?: number | null;
  LOT_AVERAGE_LTE?: number | null;
  LOT_EQUAL?: string | null;
  LOT_GT?: number | null;
  LOT_GTE?: number | null;
  LOT_LONGEST_EQUAL?: number | null;
  LOT_LONGEST_GT?: number | null;
  LOT_LONGEST_GTE?: number | null;
  LOT_LONGEST_LT?: number | null;
  LOT_LONGEST_LTE?: number | null;
  LOT_LT?: number | null;
  LOT_LTE?: number | null;
  LOT_SHORTEST_EQUAL?: number | null;
  LOT_SHORTEST_GT?: number | null;
  LOT_SHORTEST_GTE?: number | null;
  LOT_SHORTEST_LT?: number | null;
  LOT_SHORTEST_LTE?: number | null;
  Name_AVERAGE_EQUAL?: number | null;
  Name_AVERAGE_GT?: number | null;
  Name_AVERAGE_GTE?: number | null;
  Name_AVERAGE_LT?: number | null;
  Name_AVERAGE_LTE?: number | null;
  Name_EQUAL?: string | null;
  Name_GT?: number | null;
  Name_GTE?: number | null;
  Name_LONGEST_EQUAL?: number | null;
  Name_LONGEST_GT?: number | null;
  Name_LONGEST_GTE?: number | null;
  Name_LONGEST_LT?: number | null;
  Name_LONGEST_LTE?: number | null;
  Name_LT?: number | null;
  Name_LTE?: number | null;
  Name_SHORTEST_EQUAL?: number | null;
  Name_SHORTEST_GT?: number | null;
  Name_SHORTEST_GTE?: number | null;
  Name_SHORTEST_LT?: number | null;
  Name_SHORTEST_LTE?: number | null;
  OR?: DeviceAlternativeDeviceProductNodeAggregationWhereInput[] | null;
  PharmaCode_AVERAGE_EQUAL?: number | null;
  PharmaCode_AVERAGE_GT?: number | null;
  PharmaCode_AVERAGE_GTE?: number | null;
  PharmaCode_AVERAGE_LT?: number | null;
  PharmaCode_AVERAGE_LTE?: number | null;
  PharmaCode_EQUAL?: string | null;
  PharmaCode_GT?: number | null;
  PharmaCode_GTE?: number | null;
  PharmaCode_LONGEST_EQUAL?: number | null;
  PharmaCode_LONGEST_GT?: number | null;
  PharmaCode_LONGEST_GTE?: number | null;
  PharmaCode_LONGEST_LT?: number | null;
  PharmaCode_LONGEST_LTE?: number | null;
  PharmaCode_LT?: number | null;
  PharmaCode_LTE?: number | null;
  PharmaCode_SHORTEST_EQUAL?: number | null;
  PharmaCode_SHORTEST_GT?: number | null;
  PharmaCode_SHORTEST_GTE?: number | null;
  PharmaCode_SHORTEST_LT?: number | null;
  PharmaCode_SHORTEST_LTE?: number | null;
  PrevPharmacode_AVERAGE_EQUAL?: number | null;
  PrevPharmacode_AVERAGE_GT?: number | null;
  PrevPharmacode_AVERAGE_GTE?: number | null;
  PrevPharmacode_AVERAGE_LT?: number | null;
  PrevPharmacode_AVERAGE_LTE?: number | null;
  PrevPharmacode_EQUAL?: string | null;
  PrevPharmacode_GT?: number | null;
  PrevPharmacode_GTE?: number | null;
  PrevPharmacode_LONGEST_EQUAL?: number | null;
  PrevPharmacode_LONGEST_GT?: number | null;
  PrevPharmacode_LONGEST_GTE?: number | null;
  PrevPharmacode_LONGEST_LT?: number | null;
  PrevPharmacode_LONGEST_LTE?: number | null;
  PrevPharmacode_LT?: number | null;
  PrevPharmacode_LTE?: number | null;
  PrevPharmacode_SHORTEST_EQUAL?: number | null;
  PrevPharmacode_SHORTEST_GT?: number | null;
  PrevPharmacode_SHORTEST_GTE?: number | null;
  PrevPharmacode_SHORTEST_LT?: number | null;
  PrevPharmacode_SHORTEST_LTE?: number | null;
  REF_AVERAGE_EQUAL?: number | null;
  REF_AVERAGE_GT?: number | null;
  REF_AVERAGE_GTE?: number | null;
  REF_AVERAGE_LT?: number | null;
  REF_AVERAGE_LTE?: number | null;
  REF_EQUAL?: string | null;
  REF_GT?: number | null;
  REF_GTE?: number | null;
  REF_LONGEST_EQUAL?: number | null;
  REF_LONGEST_GT?: number | null;
  REF_LONGEST_GTE?: number | null;
  REF_LONGEST_LT?: number | null;
  REF_LONGEST_LTE?: number | null;
  REF_LT?: number | null;
  REF_LTE?: number | null;
  REF_SHORTEST_EQUAL?: number | null;
  REF_SHORTEST_GT?: number | null;
  REF_SHORTEST_GTE?: number | null;
  REF_SHORTEST_LT?: number | null;
  REF_SHORTEST_LTE?: number | null;
  SwissmedicCategory_AVERAGE_EQUAL?: number | null;
  SwissmedicCategory_AVERAGE_GT?: number | null;
  SwissmedicCategory_AVERAGE_GTE?: number | null;
  SwissmedicCategory_AVERAGE_LT?: number | null;
  SwissmedicCategory_AVERAGE_LTE?: number | null;
  SwissmedicCategory_EQUAL?: string | null;
  SwissmedicCategory_GT?: number | null;
  SwissmedicCategory_GTE?: number | null;
  SwissmedicCategory_LONGEST_EQUAL?: number | null;
  SwissmedicCategory_LONGEST_GT?: number | null;
  SwissmedicCategory_LONGEST_GTE?: number | null;
  SwissmedicCategory_LONGEST_LT?: number | null;
  SwissmedicCategory_LONGEST_LTE?: number | null;
  SwissmedicCategory_LT?: number | null;
  SwissmedicCategory_LTE?: number | null;
  SwissmedicCategory_SHORTEST_EQUAL?: number | null;
  SwissmedicCategory_SHORTEST_GT?: number | null;
  SwissmedicCategory_SHORTEST_GTE?: number | null;
  SwissmedicCategory_SHORTEST_LT?: number | null;
  SwissmedicCategory_SHORTEST_LTE?: number | null;
  SwissmedicNo8_AVERAGE_EQUAL?: number | null;
  SwissmedicNo8_AVERAGE_GT?: number | null;
  SwissmedicNo8_AVERAGE_GTE?: number | null;
  SwissmedicNo8_AVERAGE_LT?: number | null;
  SwissmedicNo8_AVERAGE_LTE?: number | null;
  SwissmedicNo8_EQUAL?: string | null;
  SwissmedicNo8_GT?: number | null;
  SwissmedicNo8_GTE?: number | null;
  SwissmedicNo8_LONGEST_EQUAL?: number | null;
  SwissmedicNo8_LONGEST_GT?: number | null;
  SwissmedicNo8_LONGEST_GTE?: number | null;
  SwissmedicNo8_LONGEST_LT?: number | null;
  SwissmedicNo8_LONGEST_LTE?: number | null;
  SwissmedicNo8_LT?: number | null;
  SwissmedicNo8_LTE?: number | null;
  SwissmedicNo8_SHORTEST_EQUAL?: number | null;
  SwissmedicNo8_SHORTEST_GT?: number | null;
  SwissmedicNo8_SHORTEST_GTE?: number | null;
  SwissmedicNo8_SHORTEST_LT?: number | null;
  SwissmedicNo8_SHORTEST_LTE?: number | null;
  UDI_AVERAGE_EQUAL?: number | null;
  UDI_AVERAGE_GT?: number | null;
  UDI_AVERAGE_GTE?: number | null;
  UDI_AVERAGE_LT?: number | null;
  UDI_AVERAGE_LTE?: number | null;
  UDI_EQUAL?: string | null;
  UDI_GT?: number | null;
  UDI_GTE?: number | null;
  UDI_LONGEST_EQUAL?: number | null;
  UDI_LONGEST_GT?: number | null;
  UDI_LONGEST_GTE?: number | null;
  UDI_LONGEST_LT?: number | null;
  UDI_LONGEST_LTE?: number | null;
  UDI_LT?: number | null;
  UDI_LTE?: number | null;
  UDI_SHORTEST_EQUAL?: number | null;
  UDI_SHORTEST_GT?: number | null;
  UDI_SHORTEST_GTE?: number | null;
  UDI_SHORTEST_LT?: number | null;
  UDI_SHORTEST_LTE?: number | null;
  activeIngredientQuantity_AVERAGE_EQUAL?: number | null;
  activeIngredientQuantity_AVERAGE_GT?: number | null;
  activeIngredientQuantity_AVERAGE_GTE?: number | null;
  activeIngredientQuantity_AVERAGE_LT?: number | null;
  activeIngredientQuantity_AVERAGE_LTE?: number | null;
  activeIngredientQuantity_EQUAL?: number | null;
  activeIngredientQuantity_GT?: number | null;
  activeIngredientQuantity_GTE?: number | null;
  activeIngredientQuantity_LT?: number | null;
  activeIngredientQuantity_LTE?: number | null;
  activeIngredientQuantity_MAX_EQUAL?: number | null;
  activeIngredientQuantity_MAX_GT?: number | null;
  activeIngredientQuantity_MAX_GTE?: number | null;
  activeIngredientQuantity_MAX_LT?: number | null;
  activeIngredientQuantity_MAX_LTE?: number | null;
  activeIngredientQuantity_MIN_EQUAL?: number | null;
  activeIngredientQuantity_MIN_GT?: number | null;
  activeIngredientQuantity_MIN_GTE?: number | null;
  activeIngredientQuantity_MIN_LT?: number | null;
  activeIngredientQuantity_MIN_LTE?: number | null;
  activeIngredientQuantity_SUM_EQUAL?: number | null;
  activeIngredientQuantity_SUM_GT?: number | null;
  activeIngredientQuantity_SUM_GTE?: number | null;
  activeIngredientQuantity_SUM_LT?: number | null;
  activeIngredientQuantity_SUM_LTE?: number | null;
  classificationSystem_AVERAGE_EQUAL?: number | null;
  classificationSystem_AVERAGE_GT?: number | null;
  classificationSystem_AVERAGE_GTE?: number | null;
  classificationSystem_AVERAGE_LT?: number | null;
  classificationSystem_AVERAGE_LTE?: number | null;
  classificationSystem_EQUAL?: string | null;
  classificationSystem_GT?: number | null;
  classificationSystem_GTE?: number | null;
  classificationSystem_LONGEST_EQUAL?: number | null;
  classificationSystem_LONGEST_GT?: number | null;
  classificationSystem_LONGEST_GTE?: number | null;
  classificationSystem_LONGEST_LT?: number | null;
  classificationSystem_LONGEST_LTE?: number | null;
  classificationSystem_LT?: number | null;
  classificationSystem_LTE?: number | null;
  classificationSystem_SHORTEST_EQUAL?: number | null;
  classificationSystem_SHORTEST_GT?: number | null;
  classificationSystem_SHORTEST_GTE?: number | null;
  classificationSystem_SHORTEST_LT?: number | null;
  classificationSystem_SHORTEST_LTE?: number | null;
  concentration_AVERAGE_EQUAL?: number | null;
  concentration_AVERAGE_GT?: number | null;
  concentration_AVERAGE_GTE?: number | null;
  concentration_AVERAGE_LT?: number | null;
  concentration_AVERAGE_LTE?: number | null;
  concentration_EQUAL?: string | null;
  concentration_GT?: number | null;
  concentration_GTE?: number | null;
  concentration_LONGEST_EQUAL?: number | null;
  concentration_LONGEST_GT?: number | null;
  concentration_LONGEST_GTE?: number | null;
  concentration_LONGEST_LT?: number | null;
  concentration_LONGEST_LTE?: number | null;
  concentration_LT?: number | null;
  concentration_LTE?: number | null;
  concentration_SHORTEST_EQUAL?: number | null;
  concentration_SHORTEST_GT?: number | null;
  concentration_SHORTEST_GTE?: number | null;
  concentration_SHORTEST_LT?: number | null;
  concentration_SHORTEST_LTE?: number | null;
  packVolume_AVERAGE_EQUAL?: number | null;
  packVolume_AVERAGE_GT?: number | null;
  packVolume_AVERAGE_GTE?: number | null;
  packVolume_AVERAGE_LT?: number | null;
  packVolume_AVERAGE_LTE?: number | null;
  packVolume_EQUAL?: string | null;
  packVolume_GT?: number | null;
  packVolume_GTE?: number | null;
  packVolume_LONGEST_EQUAL?: number | null;
  packVolume_LONGEST_GT?: number | null;
  packVolume_LONGEST_GTE?: number | null;
  packVolume_LONGEST_LT?: number | null;
  packVolume_LONGEST_LTE?: number | null;
  packVolume_LT?: number | null;
  packVolume_LTE?: number | null;
  packVolume_SHORTEST_EQUAL?: number | null;
  packVolume_SHORTEST_GT?: number | null;
  packVolume_SHORTEST_GTE?: number | null;
  packVolume_SHORTEST_LT?: number | null;
  packVolume_SHORTEST_LTE?: number | null;
}

export interface DeviceAlternativeWhere {
  AND?: DeviceAlternativeWhere[] | null;
  OR?: DeviceAlternativeWhere[] | null;
  alternatives?: TreatmentWhere | null;
  alternativesAggregate?: DeviceAlternativeAlternativesAggregateInput | null;
  alternativesConnection?: DeviceAlternativeAlternativesConnectionWhere | null;
  alternativesConnection_NOT?: DeviceAlternativeAlternativesConnectionWhere | null;
  alternatives_NOT?: TreatmentWhere | null;
  code?: string | null;
  code_CONTAINS?: string | null;
  code_ENDS_WITH?: string | null;
  code_IN?: (string | null)[] | null;
  code_MATCHES?: string | null;
  code_NOT?: string | null;
  code_NOT_CONTAINS?: string | null;
  code_NOT_ENDS_WITH?: string | null;
  code_NOT_IN?: (string | null)[] | null;
  code_NOT_STARTS_WITH?: string | null;
  code_STARTS_WITH?: string | null;
  deviceProduct?: TreatmentWhere | null;
  deviceProductAggregate?: DeviceAlternativeDeviceProductAggregateInput | null;
  deviceProductConnection?: DeviceAlternativeDeviceProductConnectionWhere | null;
  deviceProductConnection_NOT?: DeviceAlternativeDeviceProductConnectionWhere | null;
  deviceProduct_NOT?: TreatmentWhere | null;
}

export interface DiseaseWhere {
  AND?: DiseaseWhere[] | null;
  Icd10Code?: string | null;
  Icd10Code_CONTAINS?: string | null;
  Icd10Code_ENDS_WITH?: string | null;
  Icd10Code_IN?: (string | null)[] | null;
  Icd10Code_MATCHES?: string | null;
  Icd10Code_NOT?: string | null;
  Icd10Code_NOT_CONTAINS?: string | null;
  Icd10Code_NOT_ENDS_WITH?: string | null;
  Icd10Code_NOT_IN?: (string | null)[] | null;
  Icd10Code_NOT_STARTS_WITH?: string | null;
  Icd10Code_STARTS_WITH?: string | null;
  Name?: string | null;
  Name_CONTAINS?: string | null;
  Name_ENDS_WITH?: string | null;
  Name_IN?: (string | null)[] | null;
  Name_MATCHES?: string | null;
  Name_NOT?: string | null;
  Name_NOT_CONTAINS?: string | null;
  Name_NOT_ENDS_WITH?: string | null;
  Name_NOT_IN?: (string | null)[] | null;
  Name_NOT_STARTS_WITH?: string | null;
  Name_STARTS_WITH?: string | null;
  OR?: DiseaseWhere[] | null;
  id?: string | null;
  id_CONTAINS?: string | null;
  id_ENDS_WITH?: string | null;
  id_IN?: (string | null)[] | null;
  id_MATCHES?: string | null;
  id_NOT?: string | null;
  id_NOT_CONTAINS?: string | null;
  id_NOT_ENDS_WITH?: string | null;
  id_NOT_IN?: (string | null)[] | null;
  id_NOT_STARTS_WITH?: string | null;
  id_STARTS_WITH?: string | null;
  name?: string | null;
  name_CONTAINS?: string | null;
  name_ENDS_WITH?: string | null;
  name_IN?: (string | null)[] | null;
  name_MATCHES?: string | null;
  name_NOT?: string | null;
  name_NOT_CONTAINS?: string | null;
  name_NOT_ENDS_WITH?: string | null;
  name_NOT_IN?: (string | null)[] | null;
  name_NOT_STARTS_WITH?: string | null;
  name_STARTS_WITH?: string | null;
  therapeuticArea?: string | null;
  therapeuticArea_CONTAINS?: string | null;
  therapeuticArea_ENDS_WITH?: string | null;
  therapeuticArea_IN?: (string | null)[] | null;
  therapeuticArea_MATCHES?: string | null;
  therapeuticArea_NOT?: string | null;
  therapeuticArea_NOT_CONTAINS?: string | null;
  therapeuticArea_NOT_ENDS_WITH?: string | null;
  therapeuticArea_NOT_IN?: (string | null)[] | null;
  therapeuticArea_NOT_STARTS_WITH?: string | null;
  therapeuticArea_STARTS_WITH?: string | null;
}

export interface DocumentApprovedByAggregateInput {
  AND?: DocumentApprovedByAggregateInput[] | null;
  OR?: DocumentApprovedByAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: DocumentApprovedByNodeAggregationWhereInput | null;
}

export interface DocumentApprovedByConnectionWhere {
  AND?: DocumentApprovedByConnectionWhere[] | null;
  OR?: DocumentApprovedByConnectionWhere[] | null;
  node?: UserWhere | null;
  node_NOT?: UserWhere | null;
}

export interface DocumentApprovedByNodeAggregationWhereInput {
  AND?: DocumentApprovedByNodeAggregationWhereInput[] | null;
  OR?: DocumentApprovedByNodeAggregationWhereInput[] | null;
  deletedOn_EQUAL?: any | null;
  deletedOn_GT?: any | null;
  deletedOn_GTE?: any | null;
  deletedOn_LT?: any | null;
  deletedOn_LTE?: any | null;
  deletedOn_MAX_EQUAL?: any | null;
  deletedOn_MAX_GT?: any | null;
  deletedOn_MAX_GTE?: any | null;
  deletedOn_MAX_LT?: any | null;
  deletedOn_MAX_LTE?: any | null;
  deletedOn_MIN_EQUAL?: any | null;
  deletedOn_MIN_GT?: any | null;
  deletedOn_MIN_GTE?: any | null;
  deletedOn_MIN_LT?: any | null;
  deletedOn_MIN_LTE?: any | null;
  department_AVERAGE_EQUAL?: number | null;
  department_AVERAGE_GT?: number | null;
  department_AVERAGE_GTE?: number | null;
  department_AVERAGE_LT?: number | null;
  department_AVERAGE_LTE?: number | null;
  department_EQUAL?: string | null;
  department_GT?: number | null;
  department_GTE?: number | null;
  department_LONGEST_EQUAL?: number | null;
  department_LONGEST_GT?: number | null;
  department_LONGEST_GTE?: number | null;
  department_LONGEST_LT?: number | null;
  department_LONGEST_LTE?: number | null;
  department_LT?: number | null;
  department_LTE?: number | null;
  department_SHORTEST_EQUAL?: number | null;
  department_SHORTEST_GT?: number | null;
  department_SHORTEST_GTE?: number | null;
  department_SHORTEST_LT?: number | null;
  department_SHORTEST_LTE?: number | null;
  email_AVERAGE_EQUAL?: number | null;
  email_AVERAGE_GT?: number | null;
  email_AVERAGE_GTE?: number | null;
  email_AVERAGE_LT?: number | null;
  email_AVERAGE_LTE?: number | null;
  email_EQUAL?: string | null;
  email_GT?: number | null;
  email_GTE?: number | null;
  email_LONGEST_EQUAL?: number | null;
  email_LONGEST_GT?: number | null;
  email_LONGEST_GTE?: number | null;
  email_LONGEST_LT?: number | null;
  email_LONGEST_LTE?: number | null;
  email_LT?: number | null;
  email_LTE?: number | null;
  email_SHORTEST_EQUAL?: number | null;
  email_SHORTEST_GT?: number | null;
  email_SHORTEST_GTE?: number | null;
  email_SHORTEST_LT?: number | null;
  email_SHORTEST_LTE?: number | null;
  firstName_AVERAGE_EQUAL?: number | null;
  firstName_AVERAGE_GT?: number | null;
  firstName_AVERAGE_GTE?: number | null;
  firstName_AVERAGE_LT?: number | null;
  firstName_AVERAGE_LTE?: number | null;
  firstName_EQUAL?: string | null;
  firstName_GT?: number | null;
  firstName_GTE?: number | null;
  firstName_LONGEST_EQUAL?: number | null;
  firstName_LONGEST_GT?: number | null;
  firstName_LONGEST_GTE?: number | null;
  firstName_LONGEST_LT?: number | null;
  firstName_LONGEST_LTE?: number | null;
  firstName_LT?: number | null;
  firstName_LTE?: number | null;
  firstName_SHORTEST_EQUAL?: number | null;
  firstName_SHORTEST_GT?: number | null;
  firstName_SHORTEST_GTE?: number | null;
  firstName_SHORTEST_LT?: number | null;
  firstName_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  lastName_AVERAGE_EQUAL?: number | null;
  lastName_AVERAGE_GT?: number | null;
  lastName_AVERAGE_GTE?: number | null;
  lastName_AVERAGE_LT?: number | null;
  lastName_AVERAGE_LTE?: number | null;
  lastName_EQUAL?: string | null;
  lastName_GT?: number | null;
  lastName_GTE?: number | null;
  lastName_LONGEST_EQUAL?: number | null;
  lastName_LONGEST_GT?: number | null;
  lastName_LONGEST_GTE?: number | null;
  lastName_LONGEST_LT?: number | null;
  lastName_LONGEST_LTE?: number | null;
  lastName_LT?: number | null;
  lastName_LTE?: number | null;
  lastName_SHORTEST_EQUAL?: number | null;
  lastName_SHORTEST_GT?: number | null;
  lastName_SHORTEST_GTE?: number | null;
  lastName_SHORTEST_LT?: number | null;
  lastName_SHORTEST_LTE?: number | null;
  position_AVERAGE_EQUAL?: number | null;
  position_AVERAGE_GT?: number | null;
  position_AVERAGE_GTE?: number | null;
  position_AVERAGE_LT?: number | null;
  position_AVERAGE_LTE?: number | null;
  position_EQUAL?: string | null;
  position_GT?: number | null;
  position_GTE?: number | null;
  position_LONGEST_EQUAL?: number | null;
  position_LONGEST_GT?: number | null;
  position_LONGEST_GTE?: number | null;
  position_LONGEST_LT?: number | null;
  position_LONGEST_LTE?: number | null;
  position_LT?: number | null;
  position_LTE?: number | null;
  position_SHORTEST_EQUAL?: number | null;
  position_SHORTEST_GT?: number | null;
  position_SHORTEST_GTE?: number | null;
  position_SHORTEST_LT?: number | null;
  position_SHORTEST_LTE?: number | null;
  preferredLanguage_AVERAGE_EQUAL?: number | null;
  preferredLanguage_AVERAGE_GT?: number | null;
  preferredLanguage_AVERAGE_GTE?: number | null;
  preferredLanguage_AVERAGE_LT?: number | null;
  preferredLanguage_AVERAGE_LTE?: number | null;
  preferredLanguage_EQUAL?: string | null;
  preferredLanguage_GT?: number | null;
  preferredLanguage_GTE?: number | null;
  preferredLanguage_LONGEST_EQUAL?: number | null;
  preferredLanguage_LONGEST_GT?: number | null;
  preferredLanguage_LONGEST_GTE?: number | null;
  preferredLanguage_LONGEST_LT?: number | null;
  preferredLanguage_LONGEST_LTE?: number | null;
  preferredLanguage_LT?: number | null;
  preferredLanguage_LTE?: number | null;
  preferredLanguage_SHORTEST_EQUAL?: number | null;
  preferredLanguage_SHORTEST_GT?: number | null;
  preferredLanguage_SHORTEST_GTE?: number | null;
  preferredLanguage_SHORTEST_LT?: number | null;
  preferredLanguage_SHORTEST_LTE?: number | null;
  tenantId_AVERAGE_EQUAL?: number | null;
  tenantId_AVERAGE_GT?: number | null;
  tenantId_AVERAGE_GTE?: number | null;
  tenantId_AVERAGE_LT?: number | null;
  tenantId_AVERAGE_LTE?: number | null;
  tenantId_EQUAL?: string | null;
  tenantId_GT?: number | null;
  tenantId_GTE?: number | null;
  tenantId_LONGEST_EQUAL?: number | null;
  tenantId_LONGEST_GT?: number | null;
  tenantId_LONGEST_GTE?: number | null;
  tenantId_LONGEST_LT?: number | null;
  tenantId_LONGEST_LTE?: number | null;
  tenantId_LT?: number | null;
  tenantId_LTE?: number | null;
  tenantId_SHORTEST_EQUAL?: number | null;
  tenantId_SHORTEST_GT?: number | null;
  tenantId_SHORTEST_GTE?: number | null;
  tenantId_SHORTEST_LT?: number | null;
  tenantId_SHORTEST_LTE?: number | null;
}

export interface DocumentAssignedToAggregateInput {
  AND?: DocumentAssignedToAggregateInput[] | null;
  OR?: DocumentAssignedToAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: DocumentAssignedToNodeAggregationWhereInput | null;
}

export interface DocumentAssignedToConnectionWhere {
  AND?: DocumentAssignedToConnectionWhere[] | null;
  OR?: DocumentAssignedToConnectionWhere[] | null;
  node?: UserWhere | null;
  node_NOT?: UserWhere | null;
}

export interface DocumentAssignedToNodeAggregationWhereInput {
  AND?: DocumentAssignedToNodeAggregationWhereInput[] | null;
  OR?: DocumentAssignedToNodeAggregationWhereInput[] | null;
  deletedOn_EQUAL?: any | null;
  deletedOn_GT?: any | null;
  deletedOn_GTE?: any | null;
  deletedOn_LT?: any | null;
  deletedOn_LTE?: any | null;
  deletedOn_MAX_EQUAL?: any | null;
  deletedOn_MAX_GT?: any | null;
  deletedOn_MAX_GTE?: any | null;
  deletedOn_MAX_LT?: any | null;
  deletedOn_MAX_LTE?: any | null;
  deletedOn_MIN_EQUAL?: any | null;
  deletedOn_MIN_GT?: any | null;
  deletedOn_MIN_GTE?: any | null;
  deletedOn_MIN_LT?: any | null;
  deletedOn_MIN_LTE?: any | null;
  department_AVERAGE_EQUAL?: number | null;
  department_AVERAGE_GT?: number | null;
  department_AVERAGE_GTE?: number | null;
  department_AVERAGE_LT?: number | null;
  department_AVERAGE_LTE?: number | null;
  department_EQUAL?: string | null;
  department_GT?: number | null;
  department_GTE?: number | null;
  department_LONGEST_EQUAL?: number | null;
  department_LONGEST_GT?: number | null;
  department_LONGEST_GTE?: number | null;
  department_LONGEST_LT?: number | null;
  department_LONGEST_LTE?: number | null;
  department_LT?: number | null;
  department_LTE?: number | null;
  department_SHORTEST_EQUAL?: number | null;
  department_SHORTEST_GT?: number | null;
  department_SHORTEST_GTE?: number | null;
  department_SHORTEST_LT?: number | null;
  department_SHORTEST_LTE?: number | null;
  email_AVERAGE_EQUAL?: number | null;
  email_AVERAGE_GT?: number | null;
  email_AVERAGE_GTE?: number | null;
  email_AVERAGE_LT?: number | null;
  email_AVERAGE_LTE?: number | null;
  email_EQUAL?: string | null;
  email_GT?: number | null;
  email_GTE?: number | null;
  email_LONGEST_EQUAL?: number | null;
  email_LONGEST_GT?: number | null;
  email_LONGEST_GTE?: number | null;
  email_LONGEST_LT?: number | null;
  email_LONGEST_LTE?: number | null;
  email_LT?: number | null;
  email_LTE?: number | null;
  email_SHORTEST_EQUAL?: number | null;
  email_SHORTEST_GT?: number | null;
  email_SHORTEST_GTE?: number | null;
  email_SHORTEST_LT?: number | null;
  email_SHORTEST_LTE?: number | null;
  firstName_AVERAGE_EQUAL?: number | null;
  firstName_AVERAGE_GT?: number | null;
  firstName_AVERAGE_GTE?: number | null;
  firstName_AVERAGE_LT?: number | null;
  firstName_AVERAGE_LTE?: number | null;
  firstName_EQUAL?: string | null;
  firstName_GT?: number | null;
  firstName_GTE?: number | null;
  firstName_LONGEST_EQUAL?: number | null;
  firstName_LONGEST_GT?: number | null;
  firstName_LONGEST_GTE?: number | null;
  firstName_LONGEST_LT?: number | null;
  firstName_LONGEST_LTE?: number | null;
  firstName_LT?: number | null;
  firstName_LTE?: number | null;
  firstName_SHORTEST_EQUAL?: number | null;
  firstName_SHORTEST_GT?: number | null;
  firstName_SHORTEST_GTE?: number | null;
  firstName_SHORTEST_LT?: number | null;
  firstName_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  lastName_AVERAGE_EQUAL?: number | null;
  lastName_AVERAGE_GT?: number | null;
  lastName_AVERAGE_GTE?: number | null;
  lastName_AVERAGE_LT?: number | null;
  lastName_AVERAGE_LTE?: number | null;
  lastName_EQUAL?: string | null;
  lastName_GT?: number | null;
  lastName_GTE?: number | null;
  lastName_LONGEST_EQUAL?: number | null;
  lastName_LONGEST_GT?: number | null;
  lastName_LONGEST_GTE?: number | null;
  lastName_LONGEST_LT?: number | null;
  lastName_LONGEST_LTE?: number | null;
  lastName_LT?: number | null;
  lastName_LTE?: number | null;
  lastName_SHORTEST_EQUAL?: number | null;
  lastName_SHORTEST_GT?: number | null;
  lastName_SHORTEST_GTE?: number | null;
  lastName_SHORTEST_LT?: number | null;
  lastName_SHORTEST_LTE?: number | null;
  position_AVERAGE_EQUAL?: number | null;
  position_AVERAGE_GT?: number | null;
  position_AVERAGE_GTE?: number | null;
  position_AVERAGE_LT?: number | null;
  position_AVERAGE_LTE?: number | null;
  position_EQUAL?: string | null;
  position_GT?: number | null;
  position_GTE?: number | null;
  position_LONGEST_EQUAL?: number | null;
  position_LONGEST_GT?: number | null;
  position_LONGEST_GTE?: number | null;
  position_LONGEST_LT?: number | null;
  position_LONGEST_LTE?: number | null;
  position_LT?: number | null;
  position_LTE?: number | null;
  position_SHORTEST_EQUAL?: number | null;
  position_SHORTEST_GT?: number | null;
  position_SHORTEST_GTE?: number | null;
  position_SHORTEST_LT?: number | null;
  position_SHORTEST_LTE?: number | null;
  preferredLanguage_AVERAGE_EQUAL?: number | null;
  preferredLanguage_AVERAGE_GT?: number | null;
  preferredLanguage_AVERAGE_GTE?: number | null;
  preferredLanguage_AVERAGE_LT?: number | null;
  preferredLanguage_AVERAGE_LTE?: number | null;
  preferredLanguage_EQUAL?: string | null;
  preferredLanguage_GT?: number | null;
  preferredLanguage_GTE?: number | null;
  preferredLanguage_LONGEST_EQUAL?: number | null;
  preferredLanguage_LONGEST_GT?: number | null;
  preferredLanguage_LONGEST_GTE?: number | null;
  preferredLanguage_LONGEST_LT?: number | null;
  preferredLanguage_LONGEST_LTE?: number | null;
  preferredLanguage_LT?: number | null;
  preferredLanguage_LTE?: number | null;
  preferredLanguage_SHORTEST_EQUAL?: number | null;
  preferredLanguage_SHORTEST_GT?: number | null;
  preferredLanguage_SHORTEST_GTE?: number | null;
  preferredLanguage_SHORTEST_LT?: number | null;
  preferredLanguage_SHORTEST_LTE?: number | null;
  tenantId_AVERAGE_EQUAL?: number | null;
  tenantId_AVERAGE_GT?: number | null;
  tenantId_AVERAGE_GTE?: number | null;
  tenantId_AVERAGE_LT?: number | null;
  tenantId_AVERAGE_LTE?: number | null;
  tenantId_EQUAL?: string | null;
  tenantId_GT?: number | null;
  tenantId_GTE?: number | null;
  tenantId_LONGEST_EQUAL?: number | null;
  tenantId_LONGEST_GT?: number | null;
  tenantId_LONGEST_GTE?: number | null;
  tenantId_LONGEST_LT?: number | null;
  tenantId_LONGEST_LTE?: number | null;
  tenantId_LT?: number | null;
  tenantId_LTE?: number | null;
  tenantId_SHORTEST_EQUAL?: number | null;
  tenantId_SHORTEST_GT?: number | null;
  tenantId_SHORTEST_GTE?: number | null;
  tenantId_SHORTEST_LT?: number | null;
  tenantId_SHORTEST_LTE?: number | null;
}

export interface DocumentConfirmedByAggregateInput {
  AND?: DocumentConfirmedByAggregateInput[] | null;
  OR?: DocumentConfirmedByAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: DocumentConfirmedByNodeAggregationWhereInput | null;
}

export interface DocumentConfirmedByConnectionWhere {
  AND?: DocumentConfirmedByConnectionWhere[] | null;
  OR?: DocumentConfirmedByConnectionWhere[] | null;
  node?: UserWhere | null;
  node_NOT?: UserWhere | null;
}

export interface DocumentConfirmedByNodeAggregationWhereInput {
  AND?: DocumentConfirmedByNodeAggregationWhereInput[] | null;
  OR?: DocumentConfirmedByNodeAggregationWhereInput[] | null;
  deletedOn_EQUAL?: any | null;
  deletedOn_GT?: any | null;
  deletedOn_GTE?: any | null;
  deletedOn_LT?: any | null;
  deletedOn_LTE?: any | null;
  deletedOn_MAX_EQUAL?: any | null;
  deletedOn_MAX_GT?: any | null;
  deletedOn_MAX_GTE?: any | null;
  deletedOn_MAX_LT?: any | null;
  deletedOn_MAX_LTE?: any | null;
  deletedOn_MIN_EQUAL?: any | null;
  deletedOn_MIN_GT?: any | null;
  deletedOn_MIN_GTE?: any | null;
  deletedOn_MIN_LT?: any | null;
  deletedOn_MIN_LTE?: any | null;
  department_AVERAGE_EQUAL?: number | null;
  department_AVERAGE_GT?: number | null;
  department_AVERAGE_GTE?: number | null;
  department_AVERAGE_LT?: number | null;
  department_AVERAGE_LTE?: number | null;
  department_EQUAL?: string | null;
  department_GT?: number | null;
  department_GTE?: number | null;
  department_LONGEST_EQUAL?: number | null;
  department_LONGEST_GT?: number | null;
  department_LONGEST_GTE?: number | null;
  department_LONGEST_LT?: number | null;
  department_LONGEST_LTE?: number | null;
  department_LT?: number | null;
  department_LTE?: number | null;
  department_SHORTEST_EQUAL?: number | null;
  department_SHORTEST_GT?: number | null;
  department_SHORTEST_GTE?: number | null;
  department_SHORTEST_LT?: number | null;
  department_SHORTEST_LTE?: number | null;
  email_AVERAGE_EQUAL?: number | null;
  email_AVERAGE_GT?: number | null;
  email_AVERAGE_GTE?: number | null;
  email_AVERAGE_LT?: number | null;
  email_AVERAGE_LTE?: number | null;
  email_EQUAL?: string | null;
  email_GT?: number | null;
  email_GTE?: number | null;
  email_LONGEST_EQUAL?: number | null;
  email_LONGEST_GT?: number | null;
  email_LONGEST_GTE?: number | null;
  email_LONGEST_LT?: number | null;
  email_LONGEST_LTE?: number | null;
  email_LT?: number | null;
  email_LTE?: number | null;
  email_SHORTEST_EQUAL?: number | null;
  email_SHORTEST_GT?: number | null;
  email_SHORTEST_GTE?: number | null;
  email_SHORTEST_LT?: number | null;
  email_SHORTEST_LTE?: number | null;
  firstName_AVERAGE_EQUAL?: number | null;
  firstName_AVERAGE_GT?: number | null;
  firstName_AVERAGE_GTE?: number | null;
  firstName_AVERAGE_LT?: number | null;
  firstName_AVERAGE_LTE?: number | null;
  firstName_EQUAL?: string | null;
  firstName_GT?: number | null;
  firstName_GTE?: number | null;
  firstName_LONGEST_EQUAL?: number | null;
  firstName_LONGEST_GT?: number | null;
  firstName_LONGEST_GTE?: number | null;
  firstName_LONGEST_LT?: number | null;
  firstName_LONGEST_LTE?: number | null;
  firstName_LT?: number | null;
  firstName_LTE?: number | null;
  firstName_SHORTEST_EQUAL?: number | null;
  firstName_SHORTEST_GT?: number | null;
  firstName_SHORTEST_GTE?: number | null;
  firstName_SHORTEST_LT?: number | null;
  firstName_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  lastName_AVERAGE_EQUAL?: number | null;
  lastName_AVERAGE_GT?: number | null;
  lastName_AVERAGE_GTE?: number | null;
  lastName_AVERAGE_LT?: number | null;
  lastName_AVERAGE_LTE?: number | null;
  lastName_EQUAL?: string | null;
  lastName_GT?: number | null;
  lastName_GTE?: number | null;
  lastName_LONGEST_EQUAL?: number | null;
  lastName_LONGEST_GT?: number | null;
  lastName_LONGEST_GTE?: number | null;
  lastName_LONGEST_LT?: number | null;
  lastName_LONGEST_LTE?: number | null;
  lastName_LT?: number | null;
  lastName_LTE?: number | null;
  lastName_SHORTEST_EQUAL?: number | null;
  lastName_SHORTEST_GT?: number | null;
  lastName_SHORTEST_GTE?: number | null;
  lastName_SHORTEST_LT?: number | null;
  lastName_SHORTEST_LTE?: number | null;
  position_AVERAGE_EQUAL?: number | null;
  position_AVERAGE_GT?: number | null;
  position_AVERAGE_GTE?: number | null;
  position_AVERAGE_LT?: number | null;
  position_AVERAGE_LTE?: number | null;
  position_EQUAL?: string | null;
  position_GT?: number | null;
  position_GTE?: number | null;
  position_LONGEST_EQUAL?: number | null;
  position_LONGEST_GT?: number | null;
  position_LONGEST_GTE?: number | null;
  position_LONGEST_LT?: number | null;
  position_LONGEST_LTE?: number | null;
  position_LT?: number | null;
  position_LTE?: number | null;
  position_SHORTEST_EQUAL?: number | null;
  position_SHORTEST_GT?: number | null;
  position_SHORTEST_GTE?: number | null;
  position_SHORTEST_LT?: number | null;
  position_SHORTEST_LTE?: number | null;
  preferredLanguage_AVERAGE_EQUAL?: number | null;
  preferredLanguage_AVERAGE_GT?: number | null;
  preferredLanguage_AVERAGE_GTE?: number | null;
  preferredLanguage_AVERAGE_LT?: number | null;
  preferredLanguage_AVERAGE_LTE?: number | null;
  preferredLanguage_EQUAL?: string | null;
  preferredLanguage_GT?: number | null;
  preferredLanguage_GTE?: number | null;
  preferredLanguage_LONGEST_EQUAL?: number | null;
  preferredLanguage_LONGEST_GT?: number | null;
  preferredLanguage_LONGEST_GTE?: number | null;
  preferredLanguage_LONGEST_LT?: number | null;
  preferredLanguage_LONGEST_LTE?: number | null;
  preferredLanguage_LT?: number | null;
  preferredLanguage_LTE?: number | null;
  preferredLanguage_SHORTEST_EQUAL?: number | null;
  preferredLanguage_SHORTEST_GT?: number | null;
  preferredLanguage_SHORTEST_GTE?: number | null;
  preferredLanguage_SHORTEST_LT?: number | null;
  preferredLanguage_SHORTEST_LTE?: number | null;
  tenantId_AVERAGE_EQUAL?: number | null;
  tenantId_AVERAGE_GT?: number | null;
  tenantId_AVERAGE_GTE?: number | null;
  tenantId_AVERAGE_LT?: number | null;
  tenantId_AVERAGE_LTE?: number | null;
  tenantId_EQUAL?: string | null;
  tenantId_GT?: number | null;
  tenantId_GTE?: number | null;
  tenantId_LONGEST_EQUAL?: number | null;
  tenantId_LONGEST_GT?: number | null;
  tenantId_LONGEST_GTE?: number | null;
  tenantId_LONGEST_LT?: number | null;
  tenantId_LONGEST_LTE?: number | null;
  tenantId_LT?: number | null;
  tenantId_LTE?: number | null;
  tenantId_SHORTEST_EQUAL?: number | null;
  tenantId_SHORTEST_GT?: number | null;
  tenantId_SHORTEST_GTE?: number | null;
  tenantId_SHORTEST_LT?: number | null;
  tenantId_SHORTEST_LTE?: number | null;
}

export interface DocumentOptions {
  limit?: number | null;
  offset?: number | null;
  sort?: (DocumentSort | null)[] | null;
}

export interface DocumentRefundCasesAggregateInput {
  AND?: DocumentRefundCasesAggregateInput[] | null;
  OR?: DocumentRefundCasesAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: DocumentRefundCasesNodeAggregationWhereInput | null;
}

export interface DocumentRefundCasesConnectionWhere {
  AND?: DocumentRefundCasesConnectionWhere[] | null;
  OR?: DocumentRefundCasesConnectionWhere[] | null;
  node?: RefundCaseWhere | null;
  node_NOT?: RefundCaseWhere | null;
}

export interface DocumentRefundCasesNodeAggregationWhereInput {
  AND?: DocumentRefundCasesNodeAggregationWhereInput[] | null;
  OR?: DocumentRefundCasesNodeAggregationWhereInput[] | null;
  id_EQUAL?: string | null;
}

export interface DocumentRefundFinancialDataPointWhere {
  AND?: DocumentRefundFinancialDataPointWhere[] | null;
  OR?: DocumentRefundFinancialDataPointWhere[] | null;
  connectionId?: string | null;
  connectionId_CONTAINS?: string | null;
  connectionId_ENDS_WITH?: string | null;
  connectionId_IN?: (string | null)[] | null;
  connectionId_MATCHES?: string | null;
  connectionId_NOT?: string | null;
  connectionId_NOT_CONTAINS?: string | null;
  connectionId_NOT_ENDS_WITH?: string | null;
  connectionId_NOT_IN?: (string | null)[] | null;
  connectionId_NOT_STARTS_WITH?: string | null;
  connectionId_STARTS_WITH?: string | null;
  status?: FinancialDataPointStatus | null;
  status_IN?: (FinancialDataPointStatus | null)[] | null;
  status_NOT?: FinancialDataPointStatus | null;
  status_NOT_IN?: (FinancialDataPointStatus | null)[] | null;
}

export interface DocumentRefundsAggregateInput {
  AND?: DocumentRefundsAggregateInput[] | null;
  OR?: DocumentRefundsAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: DocumentRefundsNodeAggregationWhereInput | null;
}

export interface DocumentRefundsConnectionWhere {
  AND?: DocumentRefundsConnectionWhere[] | null;
  OR?: DocumentRefundsConnectionWhere[] | null;
  node?: RefundWhere | null;
  node_NOT?: RefundWhere | null;
}

export interface DocumentRefundsNodeAggregationWhereInput {
  AND?: DocumentRefundsNodeAggregationWhereInput[] | null;
  OR?: DocumentRefundsNodeAggregationWhereInput[] | null;
  agreementName_AVERAGE_EQUAL?: number | null;
  agreementName_AVERAGE_GT?: number | null;
  agreementName_AVERAGE_GTE?: number | null;
  agreementName_AVERAGE_LT?: number | null;
  agreementName_AVERAGE_LTE?: number | null;
  agreementName_EQUAL?: string | null;
  agreementName_GT?: number | null;
  agreementName_GTE?: number | null;
  agreementName_LONGEST_EQUAL?: number | null;
  agreementName_LONGEST_GT?: number | null;
  agreementName_LONGEST_GTE?: number | null;
  agreementName_LONGEST_LT?: number | null;
  agreementName_LONGEST_LTE?: number | null;
  agreementName_LT?: number | null;
  agreementName_LTE?: number | null;
  agreementName_SHORTEST_EQUAL?: number | null;
  agreementName_SHORTEST_GT?: number | null;
  agreementName_SHORTEST_GTE?: number | null;
  agreementName_SHORTEST_LT?: number | null;
  agreementName_SHORTEST_LTE?: number | null;
  amount_AVERAGE_EQUAL?: number | null;
  amount_AVERAGE_GT?: number | null;
  amount_AVERAGE_GTE?: number | null;
  amount_AVERAGE_LT?: number | null;
  amount_AVERAGE_LTE?: number | null;
  amount_EQUAL?: number | null;
  amount_GT?: number | null;
  amount_GTE?: number | null;
  amount_LT?: number | null;
  amount_LTE?: number | null;
  amount_MAX_EQUAL?: number | null;
  amount_MAX_GT?: number | null;
  amount_MAX_GTE?: number | null;
  amount_MAX_LT?: number | null;
  amount_MAX_LTE?: number | null;
  amount_MIN_EQUAL?: number | null;
  amount_MIN_GT?: number | null;
  amount_MIN_GTE?: number | null;
  amount_MIN_LT?: number | null;
  amount_MIN_LTE?: number | null;
  amount_SUM_EQUAL?: number | null;
  amount_SUM_GT?: number | null;
  amount_SUM_GTE?: number | null;
  amount_SUM_LT?: number | null;
  amount_SUM_LTE?: number | null;
  caseId_AVERAGE_EQUAL?: number | null;
  caseId_AVERAGE_GT?: number | null;
  caseId_AVERAGE_GTE?: number | null;
  caseId_AVERAGE_LT?: number | null;
  caseId_AVERAGE_LTE?: number | null;
  caseId_EQUAL?: string | null;
  caseId_GT?: number | null;
  caseId_GTE?: number | null;
  caseId_LONGEST_EQUAL?: number | null;
  caseId_LONGEST_GT?: number | null;
  caseId_LONGEST_GTE?: number | null;
  caseId_LONGEST_LT?: number | null;
  caseId_LONGEST_LTE?: number | null;
  caseId_LT?: number | null;
  caseId_LTE?: number | null;
  caseId_SHORTEST_EQUAL?: number | null;
  caseId_SHORTEST_GT?: number | null;
  caseId_SHORTEST_GTE?: number | null;
  caseId_SHORTEST_LT?: number | null;
  caseId_SHORTEST_LTE?: number | null;
  counterParties_AVERAGE_EQUAL?: number | null;
  counterParties_AVERAGE_GT?: number | null;
  counterParties_AVERAGE_GTE?: number | null;
  counterParties_AVERAGE_LT?: number | null;
  counterParties_AVERAGE_LTE?: number | null;
  counterParties_EQUAL?: string | null;
  counterParties_GT?: number | null;
  counterParties_GTE?: number | null;
  counterParties_LONGEST_EQUAL?: number | null;
  counterParties_LONGEST_GT?: number | null;
  counterParties_LONGEST_GTE?: number | null;
  counterParties_LONGEST_LT?: number | null;
  counterParties_LONGEST_LTE?: number | null;
  counterParties_LT?: number | null;
  counterParties_LTE?: number | null;
  counterParties_SHORTEST_EQUAL?: number | null;
  counterParties_SHORTEST_GT?: number | null;
  counterParties_SHORTEST_GTE?: number | null;
  counterParties_SHORTEST_LT?: number | null;
  counterParties_SHORTEST_LTE?: number | null;
  currency_AVERAGE_EQUAL?: number | null;
  currency_AVERAGE_GT?: number | null;
  currency_AVERAGE_GTE?: number | null;
  currency_AVERAGE_LT?: number | null;
  currency_AVERAGE_LTE?: number | null;
  currency_EQUAL?: string | null;
  currency_GT?: number | null;
  currency_GTE?: number | null;
  currency_LONGEST_EQUAL?: number | null;
  currency_LONGEST_GT?: number | null;
  currency_LONGEST_GTE?: number | null;
  currency_LONGEST_LT?: number | null;
  currency_LONGEST_LTE?: number | null;
  currency_LT?: number | null;
  currency_LTE?: number | null;
  currency_SHORTEST_EQUAL?: number | null;
  currency_SHORTEST_GT?: number | null;
  currency_SHORTEST_GTE?: number | null;
  currency_SHORTEST_LT?: number | null;
  currency_SHORTEST_LTE?: number | null;
  formattedTags_AVERAGE_EQUAL?: number | null;
  formattedTags_AVERAGE_GT?: number | null;
  formattedTags_AVERAGE_GTE?: number | null;
  formattedTags_AVERAGE_LT?: number | null;
  formattedTags_AVERAGE_LTE?: number | null;
  formattedTags_EQUAL?: string | null;
  formattedTags_GT?: number | null;
  formattedTags_GTE?: number | null;
  formattedTags_LONGEST_EQUAL?: number | null;
  formattedTags_LONGEST_GT?: number | null;
  formattedTags_LONGEST_GTE?: number | null;
  formattedTags_LONGEST_LT?: number | null;
  formattedTags_LONGEST_LTE?: number | null;
  formattedTags_LT?: number | null;
  formattedTags_LTE?: number | null;
  formattedTags_SHORTEST_EQUAL?: number | null;
  formattedTags_SHORTEST_GT?: number | null;
  formattedTags_SHORTEST_GTE?: number | null;
  formattedTags_SHORTEST_LT?: number | null;
  formattedTags_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  iin_AVERAGE_EQUAL?: number | null;
  iin_AVERAGE_GT?: number | null;
  iin_AVERAGE_GTE?: number | null;
  iin_AVERAGE_LT?: number | null;
  iin_AVERAGE_LTE?: number | null;
  iin_EQUAL?: string | null;
  iin_GT?: number | null;
  iin_GTE?: number | null;
  iin_LONGEST_EQUAL?: number | null;
  iin_LONGEST_GT?: number | null;
  iin_LONGEST_GTE?: number | null;
  iin_LONGEST_LT?: number | null;
  iin_LONGEST_LTE?: number | null;
  iin_LT?: number | null;
  iin_LTE?: number | null;
  iin_SHORTEST_EQUAL?: number | null;
  iin_SHORTEST_GT?: number | null;
  iin_SHORTEST_GTE?: number | null;
  iin_SHORTEST_LT?: number | null;
  iin_SHORTEST_LTE?: number | null;
  product_AVERAGE_EQUAL?: number | null;
  product_AVERAGE_GT?: number | null;
  product_AVERAGE_GTE?: number | null;
  product_AVERAGE_LT?: number | null;
  product_AVERAGE_LTE?: number | null;
  product_EQUAL?: string | null;
  product_GT?: number | null;
  product_GTE?: number | null;
  product_LONGEST_EQUAL?: number | null;
  product_LONGEST_GT?: number | null;
  product_LONGEST_GTE?: number | null;
  product_LONGEST_LT?: number | null;
  product_LONGEST_LTE?: number | null;
  product_LT?: number | null;
  product_LTE?: number | null;
  product_SHORTEST_EQUAL?: number | null;
  product_SHORTEST_GT?: number | null;
  product_SHORTEST_GTE?: number | null;
  product_SHORTEST_LT?: number | null;
  product_SHORTEST_LTE?: number | null;
  refundRate_AVERAGE_EQUAL?: number | null;
  refundRate_AVERAGE_GT?: number | null;
  refundRate_AVERAGE_GTE?: number | null;
  refundRate_AVERAGE_LT?: number | null;
  refundRate_AVERAGE_LTE?: number | null;
  refundRate_EQUAL?: number | null;
  refundRate_GT?: number | null;
  refundRate_GTE?: number | null;
  refundRate_LT?: number | null;
  refundRate_LTE?: number | null;
  refundRate_MAX_EQUAL?: number | null;
  refundRate_MAX_GT?: number | null;
  refundRate_MAX_GTE?: number | null;
  refundRate_MAX_LT?: number | null;
  refundRate_MAX_LTE?: number | null;
  refundRate_MIN_EQUAL?: number | null;
  refundRate_MIN_GT?: number | null;
  refundRate_MIN_GTE?: number | null;
  refundRate_MIN_LT?: number | null;
  refundRate_MIN_LTE?: number | null;
  refundRate_SUM_EQUAL?: number | null;
  refundRate_SUM_GT?: number | null;
  refundRate_SUM_GTE?: number | null;
  refundRate_SUM_LT?: number | null;
  refundRate_SUM_LTE?: number | null;
  revokedOn_EQUAL?: any | null;
  revokedOn_GT?: any | null;
  revokedOn_GTE?: any | null;
  revokedOn_LT?: any | null;
  revokedOn_LTE?: any | null;
  revokedOn_MAX_EQUAL?: any | null;
  revokedOn_MAX_GT?: any | null;
  revokedOn_MAX_GTE?: any | null;
  revokedOn_MAX_LT?: any | null;
  revokedOn_MAX_LTE?: any | null;
  revokedOn_MIN_EQUAL?: any | null;
  revokedOn_MIN_GT?: any | null;
  revokedOn_MIN_GTE?: any | null;
  revokedOn_MIN_LT?: any | null;
  revokedOn_MIN_LTE?: any | null;
  unlimited_AVERAGE_EQUAL?: number | null;
  unlimited_AVERAGE_GT?: number | null;
  unlimited_AVERAGE_GTE?: number | null;
  unlimited_AVERAGE_LT?: number | null;
  unlimited_AVERAGE_LTE?: number | null;
  unlimited_EQUAL?: number | null;
  unlimited_GT?: number | null;
  unlimited_GTE?: number | null;
  unlimited_LT?: number | null;
  unlimited_LTE?: number | null;
  unlimited_MAX_EQUAL?: number | null;
  unlimited_MAX_GT?: number | null;
  unlimited_MAX_GTE?: number | null;
  unlimited_MAX_LT?: number | null;
  unlimited_MAX_LTE?: number | null;
  unlimited_MIN_EQUAL?: number | null;
  unlimited_MIN_GT?: number | null;
  unlimited_MIN_GTE?: number | null;
  unlimited_MIN_LT?: number | null;
  unlimited_MIN_LTE?: number | null;
  unlimited_SUM_EQUAL?: number | null;
  unlimited_SUM_GT?: number | null;
  unlimited_SUM_GTE?: number | null;
  unlimited_SUM_LT?: number | null;
  unlimited_SUM_LTE?: number | null;
}

export interface DocumentRejectedByAggregateInput {
  AND?: DocumentRejectedByAggregateInput[] | null;
  OR?: DocumentRejectedByAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: DocumentRejectedByNodeAggregationWhereInput | null;
}

export interface DocumentRejectedByConnectionWhere {
  AND?: DocumentRejectedByConnectionWhere[] | null;
  OR?: DocumentRejectedByConnectionWhere[] | null;
  node?: UserWhere | null;
  node_NOT?: UserWhere | null;
}

export interface DocumentRejectedByNodeAggregationWhereInput {
  AND?: DocumentRejectedByNodeAggregationWhereInput[] | null;
  OR?: DocumentRejectedByNodeAggregationWhereInput[] | null;
  deletedOn_EQUAL?: any | null;
  deletedOn_GT?: any | null;
  deletedOn_GTE?: any | null;
  deletedOn_LT?: any | null;
  deletedOn_LTE?: any | null;
  deletedOn_MAX_EQUAL?: any | null;
  deletedOn_MAX_GT?: any | null;
  deletedOn_MAX_GTE?: any | null;
  deletedOn_MAX_LT?: any | null;
  deletedOn_MAX_LTE?: any | null;
  deletedOn_MIN_EQUAL?: any | null;
  deletedOn_MIN_GT?: any | null;
  deletedOn_MIN_GTE?: any | null;
  deletedOn_MIN_LT?: any | null;
  deletedOn_MIN_LTE?: any | null;
  department_AVERAGE_EQUAL?: number | null;
  department_AVERAGE_GT?: number | null;
  department_AVERAGE_GTE?: number | null;
  department_AVERAGE_LT?: number | null;
  department_AVERAGE_LTE?: number | null;
  department_EQUAL?: string | null;
  department_GT?: number | null;
  department_GTE?: number | null;
  department_LONGEST_EQUAL?: number | null;
  department_LONGEST_GT?: number | null;
  department_LONGEST_GTE?: number | null;
  department_LONGEST_LT?: number | null;
  department_LONGEST_LTE?: number | null;
  department_LT?: number | null;
  department_LTE?: number | null;
  department_SHORTEST_EQUAL?: number | null;
  department_SHORTEST_GT?: number | null;
  department_SHORTEST_GTE?: number | null;
  department_SHORTEST_LT?: number | null;
  department_SHORTEST_LTE?: number | null;
  email_AVERAGE_EQUAL?: number | null;
  email_AVERAGE_GT?: number | null;
  email_AVERAGE_GTE?: number | null;
  email_AVERAGE_LT?: number | null;
  email_AVERAGE_LTE?: number | null;
  email_EQUAL?: string | null;
  email_GT?: number | null;
  email_GTE?: number | null;
  email_LONGEST_EQUAL?: number | null;
  email_LONGEST_GT?: number | null;
  email_LONGEST_GTE?: number | null;
  email_LONGEST_LT?: number | null;
  email_LONGEST_LTE?: number | null;
  email_LT?: number | null;
  email_LTE?: number | null;
  email_SHORTEST_EQUAL?: number | null;
  email_SHORTEST_GT?: number | null;
  email_SHORTEST_GTE?: number | null;
  email_SHORTEST_LT?: number | null;
  email_SHORTEST_LTE?: number | null;
  firstName_AVERAGE_EQUAL?: number | null;
  firstName_AVERAGE_GT?: number | null;
  firstName_AVERAGE_GTE?: number | null;
  firstName_AVERAGE_LT?: number | null;
  firstName_AVERAGE_LTE?: number | null;
  firstName_EQUAL?: string | null;
  firstName_GT?: number | null;
  firstName_GTE?: number | null;
  firstName_LONGEST_EQUAL?: number | null;
  firstName_LONGEST_GT?: number | null;
  firstName_LONGEST_GTE?: number | null;
  firstName_LONGEST_LT?: number | null;
  firstName_LONGEST_LTE?: number | null;
  firstName_LT?: number | null;
  firstName_LTE?: number | null;
  firstName_SHORTEST_EQUAL?: number | null;
  firstName_SHORTEST_GT?: number | null;
  firstName_SHORTEST_GTE?: number | null;
  firstName_SHORTEST_LT?: number | null;
  firstName_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  lastName_AVERAGE_EQUAL?: number | null;
  lastName_AVERAGE_GT?: number | null;
  lastName_AVERAGE_GTE?: number | null;
  lastName_AVERAGE_LT?: number | null;
  lastName_AVERAGE_LTE?: number | null;
  lastName_EQUAL?: string | null;
  lastName_GT?: number | null;
  lastName_GTE?: number | null;
  lastName_LONGEST_EQUAL?: number | null;
  lastName_LONGEST_GT?: number | null;
  lastName_LONGEST_GTE?: number | null;
  lastName_LONGEST_LT?: number | null;
  lastName_LONGEST_LTE?: number | null;
  lastName_LT?: number | null;
  lastName_LTE?: number | null;
  lastName_SHORTEST_EQUAL?: number | null;
  lastName_SHORTEST_GT?: number | null;
  lastName_SHORTEST_GTE?: number | null;
  lastName_SHORTEST_LT?: number | null;
  lastName_SHORTEST_LTE?: number | null;
  position_AVERAGE_EQUAL?: number | null;
  position_AVERAGE_GT?: number | null;
  position_AVERAGE_GTE?: number | null;
  position_AVERAGE_LT?: number | null;
  position_AVERAGE_LTE?: number | null;
  position_EQUAL?: string | null;
  position_GT?: number | null;
  position_GTE?: number | null;
  position_LONGEST_EQUAL?: number | null;
  position_LONGEST_GT?: number | null;
  position_LONGEST_GTE?: number | null;
  position_LONGEST_LT?: number | null;
  position_LONGEST_LTE?: number | null;
  position_LT?: number | null;
  position_LTE?: number | null;
  position_SHORTEST_EQUAL?: number | null;
  position_SHORTEST_GT?: number | null;
  position_SHORTEST_GTE?: number | null;
  position_SHORTEST_LT?: number | null;
  position_SHORTEST_LTE?: number | null;
  preferredLanguage_AVERAGE_EQUAL?: number | null;
  preferredLanguage_AVERAGE_GT?: number | null;
  preferredLanguage_AVERAGE_GTE?: number | null;
  preferredLanguage_AVERAGE_LT?: number | null;
  preferredLanguage_AVERAGE_LTE?: number | null;
  preferredLanguage_EQUAL?: string | null;
  preferredLanguage_GT?: number | null;
  preferredLanguage_GTE?: number | null;
  preferredLanguage_LONGEST_EQUAL?: number | null;
  preferredLanguage_LONGEST_GT?: number | null;
  preferredLanguage_LONGEST_GTE?: number | null;
  preferredLanguage_LONGEST_LT?: number | null;
  preferredLanguage_LONGEST_LTE?: number | null;
  preferredLanguage_LT?: number | null;
  preferredLanguage_LTE?: number | null;
  preferredLanguage_SHORTEST_EQUAL?: number | null;
  preferredLanguage_SHORTEST_GT?: number | null;
  preferredLanguage_SHORTEST_GTE?: number | null;
  preferredLanguage_SHORTEST_LT?: number | null;
  preferredLanguage_SHORTEST_LTE?: number | null;
  tenantId_AVERAGE_EQUAL?: number | null;
  tenantId_AVERAGE_GT?: number | null;
  tenantId_AVERAGE_GTE?: number | null;
  tenantId_AVERAGE_LT?: number | null;
  tenantId_AVERAGE_LTE?: number | null;
  tenantId_EQUAL?: string | null;
  tenantId_GT?: number | null;
  tenantId_GTE?: number | null;
  tenantId_LONGEST_EQUAL?: number | null;
  tenantId_LONGEST_GT?: number | null;
  tenantId_LONGEST_GTE?: number | null;
  tenantId_LONGEST_LT?: number | null;
  tenantId_LONGEST_LTE?: number | null;
  tenantId_LT?: number | null;
  tenantId_LTE?: number | null;
  tenantId_SHORTEST_EQUAL?: number | null;
  tenantId_SHORTEST_GT?: number | null;
  tenantId_SHORTEST_GTE?: number | null;
  tenantId_SHORTEST_LT?: number | null;
  tenantId_SHORTEST_LTE?: number | null;
}

/**
 * Fields to sort Documents by. The order in which sorts are applied is not guaranteed when specifying many fields in one DocumentSort object.
 */
export interface DocumentSort {
  canApprove?: SortDirection | null;
  canAssignUser?: SortDirection | null;
  canConfirm?: SortDirection | null;
  canUserDelete?: SortDirection | null;
  counterParties?: SortDirection | null;
  coveragePeriod?: SortDirection | null;
  coveragePeriodEnd?: SortDirection | null;
  coveragePeriodStart?: SortDirection | null;
  createdByEmail?: SortDirection | null;
  createdOn?: SortDirection | null;
  creatorOrgName?: SortDirection | null;
  creatorTenantId?: SortDirection | null;
  formattedTags?: SortDirection | null;
  id?: SortDirection | null;
  invoiceAmount?: SortDirection | null;
  isAgreementBuyer?: SortDirection | null;
  isAgreementOwner?: SortDirection | null;
  isAgreementSeller?: SortDirection | null;
  isAssignee?: SortDirection | null;
  isConfirmedByBuyer?: SortDirection | null;
  isConfirmedByExternalParty?: SortDirection | null;
  isConfirmedBySeller?: SortDirection | null;
  isDeleted?: SortDirection | null;
  isSentForExternalReview?: SortDirection | null;
  issuedOn?: SortDirection | null;
  lastChangedOn?: SortDirection | null;
  lastRemindedOn?: SortDirection | null;
  lastUpdatedOn?: SortDirection | null;
  product?: SortDirection | null;
  settledOn?: SortDirection | null;
  status?: SortDirection | null;
  type?: SortDirection | null;
  unlimited?: SortDirection | null;
}

export interface DocumentTagsAggregateInput {
  AND?: DocumentTagsAggregateInput[] | null;
  OR?: DocumentTagsAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: DocumentTagsNodeAggregationWhereInput | null;
}

export interface DocumentTagsConnectionWhere {
  AND?: DocumentTagsConnectionWhere[] | null;
  OR?: DocumentTagsConnectionWhere[] | null;
  node?: AgreementTagWhere | null;
  node_NOT?: AgreementTagWhere | null;
}

export interface DocumentTagsNodeAggregationWhereInput {
  AND?: DocumentTagsNodeAggregationWhereInput[] | null;
  OR?: DocumentTagsNodeAggregationWhereInput[] | null;
  id_AVERAGE_EQUAL?: number | null;
  id_AVERAGE_GT?: number | null;
  id_AVERAGE_GTE?: number | null;
  id_AVERAGE_LT?: number | null;
  id_AVERAGE_LTE?: number | null;
  id_EQUAL?: number | null;
  id_GT?: number | null;
  id_GTE?: number | null;
  id_LT?: number | null;
  id_LTE?: number | null;
  id_MAX_EQUAL?: number | null;
  id_MAX_GT?: number | null;
  id_MAX_GTE?: number | null;
  id_MAX_LT?: number | null;
  id_MAX_LTE?: number | null;
  id_MIN_EQUAL?: number | null;
  id_MIN_GT?: number | null;
  id_MIN_GTE?: number | null;
  id_MIN_LT?: number | null;
  id_MIN_LTE?: number | null;
  id_SUM_EQUAL?: number | null;
  id_SUM_GT?: number | null;
  id_SUM_GTE?: number | null;
  id_SUM_LT?: number | null;
  id_SUM_LTE?: number | null;
  name_AVERAGE_EQUAL?: number | null;
  name_AVERAGE_GT?: number | null;
  name_AVERAGE_GTE?: number | null;
  name_AVERAGE_LT?: number | null;
  name_AVERAGE_LTE?: number | null;
  name_EQUAL?: string | null;
  name_GT?: number | null;
  name_GTE?: number | null;
  name_LONGEST_EQUAL?: number | null;
  name_LONGEST_GT?: number | null;
  name_LONGEST_GTE?: number | null;
  name_LONGEST_LT?: number | null;
  name_LONGEST_LTE?: number | null;
  name_LT?: number | null;
  name_LTE?: number | null;
  name_SHORTEST_EQUAL?: number | null;
  name_SHORTEST_GT?: number | null;
  name_SHORTEST_GTE?: number | null;
  name_SHORTEST_LT?: number | null;
  name_SHORTEST_LTE?: number | null;
}

export interface DocumentWhere {
  AND?: DocumentWhere[] | null;
  OR?: DocumentWhere[] | null;
  approvedBy?: UserWhere | null;
  approvedByAggregate?: DocumentApprovedByAggregateInput | null;
  approvedByConnection?: DocumentApprovedByConnectionWhere | null;
  approvedByConnection_NOT?: DocumentApprovedByConnectionWhere | null;
  approvedBy_NOT?: UserWhere | null;
  assignedTo?: UserWhere | null;
  assignedToAggregate?: DocumentAssignedToAggregateInput | null;
  assignedToConnection?: DocumentAssignedToConnectionWhere | null;
  assignedToConnection_NOT?: DocumentAssignedToConnectionWhere | null;
  assignedTo_NOT?: UserWhere | null;
  canApprove?: boolean | null;
  canApprove_NOT?: boolean | null;
  canConfirm?: boolean | null;
  canConfirm_NOT?: boolean | null;
  confirmedBy?: UserWhere | null;
  confirmedByAggregate?: DocumentConfirmedByAggregateInput | null;
  confirmedByConnection?: DocumentConfirmedByConnectionWhere | null;
  confirmedByConnection_NOT?: DocumentConfirmedByConnectionWhere | null;
  confirmedBy_NOT?: UserWhere | null;
  counterParties?: string | null;
  counterParties_CONTAINS?: string | null;
  counterParties_ENDS_WITH?: string | null;
  counterParties_IN?: (string | null)[] | null;
  counterParties_MATCHES?: string | null;
  counterParties_NOT?: string | null;
  counterParties_NOT_CONTAINS?: string | null;
  counterParties_NOT_ENDS_WITH?: string | null;
  counterParties_NOT_IN?: (string | null)[] | null;
  counterParties_NOT_STARTS_WITH?: string | null;
  counterParties_STARTS_WITH?: string | null;
  coveragePeriod?: string | null;
  coveragePeriodEnd?: any | null;
  coveragePeriodEnd_GT?: any | null;
  coveragePeriodEnd_GTE?: any | null;
  coveragePeriodEnd_IN?: (any | null)[] | null;
  coveragePeriodEnd_LT?: any | null;
  coveragePeriodEnd_LTE?: any | null;
  coveragePeriodEnd_NOT?: any | null;
  coveragePeriodEnd_NOT_IN?: (any | null)[] | null;
  coveragePeriodStart?: any | null;
  coveragePeriodStart_GT?: any | null;
  coveragePeriodStart_GTE?: any | null;
  coveragePeriodStart_IN?: (any | null)[] | null;
  coveragePeriodStart_LT?: any | null;
  coveragePeriodStart_LTE?: any | null;
  coveragePeriodStart_NOT?: any | null;
  coveragePeriodStart_NOT_IN?: (any | null)[] | null;
  coveragePeriod_CONTAINS?: string | null;
  coveragePeriod_ENDS_WITH?: string | null;
  coveragePeriod_IN?: (string | null)[] | null;
  coveragePeriod_MATCHES?: string | null;
  coveragePeriod_NOT?: string | null;
  coveragePeriod_NOT_CONTAINS?: string | null;
  coveragePeriod_NOT_ENDS_WITH?: string | null;
  coveragePeriod_NOT_IN?: (string | null)[] | null;
  coveragePeriod_NOT_STARTS_WITH?: string | null;
  coveragePeriod_STARTS_WITH?: string | null;
  createdByEmail?: string | null;
  createdByEmail_CONTAINS?: string | null;
  createdByEmail_ENDS_WITH?: string | null;
  createdByEmail_IN?: (string | null)[] | null;
  createdByEmail_MATCHES?: string | null;
  createdByEmail_NOT?: string | null;
  createdByEmail_NOT_CONTAINS?: string | null;
  createdByEmail_NOT_ENDS_WITH?: string | null;
  createdByEmail_NOT_IN?: (string | null)[] | null;
  createdByEmail_NOT_STARTS_WITH?: string | null;
  createdByEmail_STARTS_WITH?: string | null;
  createdOn?: any | null;
  createdOn_GT?: any | null;
  createdOn_GTE?: any | null;
  createdOn_IN?: (any | null)[] | null;
  createdOn_LT?: any | null;
  createdOn_LTE?: any | null;
  createdOn_NOT?: any | null;
  createdOn_NOT_IN?: (any | null)[] | null;
  creatorOrgName?: string | null;
  creatorOrgName_CONTAINS?: string | null;
  creatorOrgName_ENDS_WITH?: string | null;
  creatorOrgName_IN?: (string | null)[] | null;
  creatorOrgName_MATCHES?: string | null;
  creatorOrgName_NOT?: string | null;
  creatorOrgName_NOT_CONTAINS?: string | null;
  creatorOrgName_NOT_ENDS_WITH?: string | null;
  creatorOrgName_NOT_IN?: (string | null)[] | null;
  creatorOrgName_NOT_STARTS_WITH?: string | null;
  creatorOrgName_STARTS_WITH?: string | null;
  creatorTenantId?: string | null;
  creatorTenantId_CONTAINS?: string | null;
  creatorTenantId_ENDS_WITH?: string | null;
  creatorTenantId_IN?: (string | null)[] | null;
  creatorTenantId_MATCHES?: string | null;
  creatorTenantId_NOT?: string | null;
  creatorTenantId_NOT_CONTAINS?: string | null;
  creatorTenantId_NOT_ENDS_WITH?: string | null;
  creatorTenantId_NOT_IN?: (string | null)[] | null;
  creatorTenantId_NOT_STARTS_WITH?: string | null;
  creatorTenantId_STARTS_WITH?: string | null;
  formattedTags?: string | null;
  formattedTags_CONTAINS?: string | null;
  formattedTags_ENDS_WITH?: string | null;
  formattedTags_IN?: (string | null)[] | null;
  formattedTags_MATCHES?: string | null;
  formattedTags_NOT?: string | null;
  formattedTags_NOT_CONTAINS?: string | null;
  formattedTags_NOT_ENDS_WITH?: string | null;
  formattedTags_NOT_IN?: (string | null)[] | null;
  formattedTags_NOT_STARTS_WITH?: string | null;
  formattedTags_STARTS_WITH?: string | null;
  id?: string | null;
  id_CONTAINS?: string | null;
  id_ENDS_WITH?: string | null;
  id_IN?: (string | null)[] | null;
  id_MATCHES?: string | null;
  id_NOT?: string | null;
  id_NOT_CONTAINS?: string | null;
  id_NOT_ENDS_WITH?: string | null;
  id_NOT_IN?: (string | null)[] | null;
  id_NOT_STARTS_WITH?: string | null;
  id_STARTS_WITH?: string | null;
  invoiceAmount?: number | null;
  invoiceAmount_GT?: number | null;
  invoiceAmount_GTE?: number | null;
  invoiceAmount_IN?: (number | null)[] | null;
  invoiceAmount_LT?: number | null;
  invoiceAmount_LTE?: number | null;
  invoiceAmount_NOT?: number | null;
  invoiceAmount_NOT_IN?: (number | null)[] | null;
  isConfirmedByBuyer?: boolean | null;
  isConfirmedByBuyer_NOT?: boolean | null;
  isConfirmedByExternalParty?: boolean | null;
  isConfirmedByExternalParty_NOT?: boolean | null;
  isConfirmedBySeller?: boolean | null;
  isConfirmedBySeller_NOT?: boolean | null;
  isDeleted?: boolean | null;
  isDeleted_NOT?: boolean | null;
  isSentForExternalReview?: boolean | null;
  isSentForExternalReview_NOT?: boolean | null;
  issuedOn?: any | null;
  issuedOn_GT?: any | null;
  issuedOn_GTE?: any | null;
  issuedOn_IN?: (any | null)[] | null;
  issuedOn_LT?: any | null;
  issuedOn_LTE?: any | null;
  issuedOn_NOT?: any | null;
  issuedOn_NOT_IN?: (any | null)[] | null;
  lastChangedOn?: any | null;
  lastChangedOn_GT?: any | null;
  lastChangedOn_GTE?: any | null;
  lastChangedOn_IN?: (any | null)[] | null;
  lastChangedOn_LT?: any | null;
  lastChangedOn_LTE?: any | null;
  lastChangedOn_NOT?: any | null;
  lastChangedOn_NOT_IN?: (any | null)[] | null;
  lastRemindedOn?: any | null;
  lastRemindedOn_GT?: any | null;
  lastRemindedOn_GTE?: any | null;
  lastRemindedOn_IN?: (any | null)[] | null;
  lastRemindedOn_LT?: any | null;
  lastRemindedOn_LTE?: any | null;
  lastRemindedOn_NOT?: any | null;
  lastRemindedOn_NOT_IN?: (any | null)[] | null;
  lastUpdatedOn?: any | null;
  lastUpdatedOn_GT?: any | null;
  lastUpdatedOn_GTE?: any | null;
  lastUpdatedOn_IN?: (any | null)[] | null;
  lastUpdatedOn_LT?: any | null;
  lastUpdatedOn_LTE?: any | null;
  lastUpdatedOn_NOT?: any | null;
  lastUpdatedOn_NOT_IN?: (any | null)[] | null;
  product?: string | null;
  product_CONTAINS?: string | null;
  product_ENDS_WITH?: string | null;
  product_IN?: (string | null)[] | null;
  product_MATCHES?: string | null;
  product_NOT?: string | null;
  product_NOT_CONTAINS?: string | null;
  product_NOT_ENDS_WITH?: string | null;
  product_NOT_IN?: (string | null)[] | null;
  product_NOT_STARTS_WITH?: string | null;
  product_STARTS_WITH?: string | null;
  refundCases?: RefundCaseWhere | null;
  refundCasesAggregate?: DocumentRefundCasesAggregateInput | null;
  refundCasesConnection?: DocumentRefundCasesConnectionWhere | null;
  refundCasesConnection_NOT?: DocumentRefundCasesConnectionWhere | null;
  refundCases_NOT?: RefundCaseWhere | null;
  refunds?: RefundWhere | null;
  refundsAggregate?: DocumentRefundsAggregateInput | null;
  refundsConnection?: DocumentRefundsConnectionWhere | null;
  refundsConnection_NOT?: DocumentRefundsConnectionWhere | null;
  refunds_NOT?: RefundWhere | null;
  rejectedBy?: UserWhere | null;
  rejectedByAggregate?: DocumentRejectedByAggregateInput | null;
  rejectedByConnection?: DocumentRejectedByConnectionWhere | null;
  rejectedByConnection_NOT?: DocumentRejectedByConnectionWhere | null;
  rejectedBy_NOT?: UserWhere | null;
  settledOn?: any | null;
  settledOn_GT?: any | null;
  settledOn_GTE?: any | null;
  settledOn_IN?: (any | null)[] | null;
  settledOn_LT?: any | null;
  settledOn_LTE?: any | null;
  settledOn_NOT?: any | null;
  settledOn_NOT_IN?: (any | null)[] | null;
  status?: DocumentStatus | null;
  status_IN?: (DocumentStatus | null)[] | null;
  status_NOT?: DocumentStatus | null;
  status_NOT_IN?: (DocumentStatus | null)[] | null;
  tags?: AgreementTagWhere | null;
  tagsAggregate?: DocumentTagsAggregateInput | null;
  tagsConnection?: DocumentTagsConnectionWhere | null;
  tagsConnection_NOT?: DocumentTagsConnectionWhere | null;
  tags_NOT?: AgreementTagWhere | null;
  tenantIds?: string[] | null;
  tenantIds_INCLUDES?: string | null;
  tenantIds_NOT?: string[] | null;
  tenantIds_NOT_INCLUDES?: string | null;
  type?: DocumentType | null;
  type_IN?: (DocumentType | null)[] | null;
  type_NOT?: DocumentType | null;
  type_NOT_IN?: (DocumentType | null)[] | null;
  unlimited?: number | null;
  unlimited_GT?: number | null;
  unlimited_GTE?: number | null;
  unlimited_IN?: (number | null)[] | null;
  unlimited_LT?: number | null;
  unlimited_LTE?: number | null;
  unlimited_NOT?: number | null;
  unlimited_NOT_IN?: (number | null)[] | null;
}

export interface EligibilityConditionSetTreatmentsAggregateInput {
  AND?: EligibilityConditionSetTreatmentsAggregateInput[] | null;
  OR?: EligibilityConditionSetTreatmentsAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: EligibilityConditionSetTreatmentsNodeAggregationWhereInput | null;
}

export interface EligibilityConditionSetTreatmentsConnectionWhere {
  AND?: EligibilityConditionSetTreatmentsConnectionWhere[] | null;
  OR?: EligibilityConditionSetTreatmentsConnectionWhere[] | null;
  node?: TreatmentWhere | null;
  node_NOT?: TreatmentWhere | null;
}

export interface EligibilityConditionSetTreatmentsNodeAggregationWhereInput {
  AND?: EligibilityConditionSetTreatmentsNodeAggregationWhereInput[] | null;
  BagDossierNo_AVERAGE_EQUAL?: number | null;
  BagDossierNo_AVERAGE_GT?: number | null;
  BagDossierNo_AVERAGE_GTE?: number | null;
  BagDossierNo_AVERAGE_LT?: number | null;
  BagDossierNo_AVERAGE_LTE?: number | null;
  BagDossierNo_EQUAL?: string | null;
  BagDossierNo_GT?: number | null;
  BagDossierNo_GTE?: number | null;
  BagDossierNo_LONGEST_EQUAL?: number | null;
  BagDossierNo_LONGEST_GT?: number | null;
  BagDossierNo_LONGEST_GTE?: number | null;
  BagDossierNo_LONGEST_LT?: number | null;
  BagDossierNo_LONGEST_LTE?: number | null;
  BagDossierNo_LT?: number | null;
  BagDossierNo_LTE?: number | null;
  BagDossierNo_SHORTEST_EQUAL?: number | null;
  BagDossierNo_SHORTEST_GT?: number | null;
  BagDossierNo_SHORTEST_GTE?: number | null;
  BagDossierNo_SHORTEST_LT?: number | null;
  BagDossierNo_SHORTEST_LTE?: number | null;
  Code_AVERAGE_EQUAL?: number | null;
  Code_AVERAGE_GT?: number | null;
  Code_AVERAGE_GTE?: number | null;
  Code_AVERAGE_LT?: number | null;
  Code_AVERAGE_LTE?: number | null;
  Code_EQUAL?: string | null;
  Code_GT?: number | null;
  Code_GTE?: number | null;
  Code_LONGEST_EQUAL?: number | null;
  Code_LONGEST_GT?: number | null;
  Code_LONGEST_GTE?: number | null;
  Code_LONGEST_LT?: number | null;
  Code_LONGEST_LTE?: number | null;
  Code_LT?: number | null;
  Code_LTE?: number | null;
  Code_SHORTEST_EQUAL?: number | null;
  Code_SHORTEST_GT?: number | null;
  Code_SHORTEST_GTE?: number | null;
  Code_SHORTEST_LT?: number | null;
  Code_SHORTEST_LTE?: number | null;
  FlagModal_AVERAGE_EQUAL?: number | null;
  FlagModal_AVERAGE_GT?: number | null;
  FlagModal_AVERAGE_GTE?: number | null;
  FlagModal_AVERAGE_LT?: number | null;
  FlagModal_AVERAGE_LTE?: number | null;
  FlagModal_EQUAL?: string | null;
  FlagModal_GT?: number | null;
  FlagModal_GTE?: number | null;
  FlagModal_LONGEST_EQUAL?: number | null;
  FlagModal_LONGEST_GT?: number | null;
  FlagModal_LONGEST_GTE?: number | null;
  FlagModal_LONGEST_LT?: number | null;
  FlagModal_LONGEST_LTE?: number | null;
  FlagModal_LT?: number | null;
  FlagModal_LTE?: number | null;
  FlagModal_SHORTEST_EQUAL?: number | null;
  FlagModal_SHORTEST_GT?: number | null;
  FlagModal_SHORTEST_GTE?: number | null;
  FlagModal_SHORTEST_LT?: number | null;
  FlagModal_SHORTEST_LTE?: number | null;
  FlagNarcosis_AVERAGE_EQUAL?: number | null;
  FlagNarcosis_AVERAGE_GT?: number | null;
  FlagNarcosis_AVERAGE_GTE?: number | null;
  FlagNarcosis_AVERAGE_LT?: number | null;
  FlagNarcosis_AVERAGE_LTE?: number | null;
  FlagNarcosis_EQUAL?: string | null;
  FlagNarcosis_GT?: number | null;
  FlagNarcosis_GTE?: number | null;
  FlagNarcosis_LONGEST_EQUAL?: number | null;
  FlagNarcosis_LONGEST_GT?: number | null;
  FlagNarcosis_LONGEST_GTE?: number | null;
  FlagNarcosis_LONGEST_LT?: number | null;
  FlagNarcosis_LONGEST_LTE?: number | null;
  FlagNarcosis_LT?: number | null;
  FlagNarcosis_LTE?: number | null;
  FlagNarcosis_SHORTEST_EQUAL?: number | null;
  FlagNarcosis_SHORTEST_GT?: number | null;
  FlagNarcosis_SHORTEST_GTE?: number | null;
  FlagNarcosis_SHORTEST_LT?: number | null;
  FlagNarcosis_SHORTEST_LTE?: number | null;
  GTIN_AVERAGE_EQUAL?: number | null;
  GTIN_AVERAGE_GT?: number | null;
  GTIN_AVERAGE_GTE?: number | null;
  GTIN_AVERAGE_LT?: number | null;
  GTIN_AVERAGE_LTE?: number | null;
  GTIN_EQUAL?: string | null;
  GTIN_GT?: number | null;
  GTIN_GTE?: number | null;
  GTIN_LONGEST_EQUAL?: number | null;
  GTIN_LONGEST_GT?: number | null;
  GTIN_LONGEST_GTE?: number | null;
  GTIN_LONGEST_LT?: number | null;
  GTIN_LONGEST_LTE?: number | null;
  GTIN_LT?: number | null;
  GTIN_LTE?: number | null;
  GTIN_SHORTEST_EQUAL?: number | null;
  GTIN_SHORTEST_GT?: number | null;
  GTIN_SHORTEST_GTE?: number | null;
  GTIN_SHORTEST_LT?: number | null;
  GTIN_SHORTEST_LTE?: number | null;
  LOT_AVERAGE_EQUAL?: number | null;
  LOT_AVERAGE_GT?: number | null;
  LOT_AVERAGE_GTE?: number | null;
  LOT_AVERAGE_LT?: number | null;
  LOT_AVERAGE_LTE?: number | null;
  LOT_EQUAL?: string | null;
  LOT_GT?: number | null;
  LOT_GTE?: number | null;
  LOT_LONGEST_EQUAL?: number | null;
  LOT_LONGEST_GT?: number | null;
  LOT_LONGEST_GTE?: number | null;
  LOT_LONGEST_LT?: number | null;
  LOT_LONGEST_LTE?: number | null;
  LOT_LT?: number | null;
  LOT_LTE?: number | null;
  LOT_SHORTEST_EQUAL?: number | null;
  LOT_SHORTEST_GT?: number | null;
  LOT_SHORTEST_GTE?: number | null;
  LOT_SHORTEST_LT?: number | null;
  LOT_SHORTEST_LTE?: number | null;
  Name_AVERAGE_EQUAL?: number | null;
  Name_AVERAGE_GT?: number | null;
  Name_AVERAGE_GTE?: number | null;
  Name_AVERAGE_LT?: number | null;
  Name_AVERAGE_LTE?: number | null;
  Name_EQUAL?: string | null;
  Name_GT?: number | null;
  Name_GTE?: number | null;
  Name_LONGEST_EQUAL?: number | null;
  Name_LONGEST_GT?: number | null;
  Name_LONGEST_GTE?: number | null;
  Name_LONGEST_LT?: number | null;
  Name_LONGEST_LTE?: number | null;
  Name_LT?: number | null;
  Name_LTE?: number | null;
  Name_SHORTEST_EQUAL?: number | null;
  Name_SHORTEST_GT?: number | null;
  Name_SHORTEST_GTE?: number | null;
  Name_SHORTEST_LT?: number | null;
  Name_SHORTEST_LTE?: number | null;
  OR?: EligibilityConditionSetTreatmentsNodeAggregationWhereInput[] | null;
  PharmaCode_AVERAGE_EQUAL?: number | null;
  PharmaCode_AVERAGE_GT?: number | null;
  PharmaCode_AVERAGE_GTE?: number | null;
  PharmaCode_AVERAGE_LT?: number | null;
  PharmaCode_AVERAGE_LTE?: number | null;
  PharmaCode_EQUAL?: string | null;
  PharmaCode_GT?: number | null;
  PharmaCode_GTE?: number | null;
  PharmaCode_LONGEST_EQUAL?: number | null;
  PharmaCode_LONGEST_GT?: number | null;
  PharmaCode_LONGEST_GTE?: number | null;
  PharmaCode_LONGEST_LT?: number | null;
  PharmaCode_LONGEST_LTE?: number | null;
  PharmaCode_LT?: number | null;
  PharmaCode_LTE?: number | null;
  PharmaCode_SHORTEST_EQUAL?: number | null;
  PharmaCode_SHORTEST_GT?: number | null;
  PharmaCode_SHORTEST_GTE?: number | null;
  PharmaCode_SHORTEST_LT?: number | null;
  PharmaCode_SHORTEST_LTE?: number | null;
  PrevPharmacode_AVERAGE_EQUAL?: number | null;
  PrevPharmacode_AVERAGE_GT?: number | null;
  PrevPharmacode_AVERAGE_GTE?: number | null;
  PrevPharmacode_AVERAGE_LT?: number | null;
  PrevPharmacode_AVERAGE_LTE?: number | null;
  PrevPharmacode_EQUAL?: string | null;
  PrevPharmacode_GT?: number | null;
  PrevPharmacode_GTE?: number | null;
  PrevPharmacode_LONGEST_EQUAL?: number | null;
  PrevPharmacode_LONGEST_GT?: number | null;
  PrevPharmacode_LONGEST_GTE?: number | null;
  PrevPharmacode_LONGEST_LT?: number | null;
  PrevPharmacode_LONGEST_LTE?: number | null;
  PrevPharmacode_LT?: number | null;
  PrevPharmacode_LTE?: number | null;
  PrevPharmacode_SHORTEST_EQUAL?: number | null;
  PrevPharmacode_SHORTEST_GT?: number | null;
  PrevPharmacode_SHORTEST_GTE?: number | null;
  PrevPharmacode_SHORTEST_LT?: number | null;
  PrevPharmacode_SHORTEST_LTE?: number | null;
  REF_AVERAGE_EQUAL?: number | null;
  REF_AVERAGE_GT?: number | null;
  REF_AVERAGE_GTE?: number | null;
  REF_AVERAGE_LT?: number | null;
  REF_AVERAGE_LTE?: number | null;
  REF_EQUAL?: string | null;
  REF_GT?: number | null;
  REF_GTE?: number | null;
  REF_LONGEST_EQUAL?: number | null;
  REF_LONGEST_GT?: number | null;
  REF_LONGEST_GTE?: number | null;
  REF_LONGEST_LT?: number | null;
  REF_LONGEST_LTE?: number | null;
  REF_LT?: number | null;
  REF_LTE?: number | null;
  REF_SHORTEST_EQUAL?: number | null;
  REF_SHORTEST_GT?: number | null;
  REF_SHORTEST_GTE?: number | null;
  REF_SHORTEST_LT?: number | null;
  REF_SHORTEST_LTE?: number | null;
  SwissmedicCategory_AVERAGE_EQUAL?: number | null;
  SwissmedicCategory_AVERAGE_GT?: number | null;
  SwissmedicCategory_AVERAGE_GTE?: number | null;
  SwissmedicCategory_AVERAGE_LT?: number | null;
  SwissmedicCategory_AVERAGE_LTE?: number | null;
  SwissmedicCategory_EQUAL?: string | null;
  SwissmedicCategory_GT?: number | null;
  SwissmedicCategory_GTE?: number | null;
  SwissmedicCategory_LONGEST_EQUAL?: number | null;
  SwissmedicCategory_LONGEST_GT?: number | null;
  SwissmedicCategory_LONGEST_GTE?: number | null;
  SwissmedicCategory_LONGEST_LT?: number | null;
  SwissmedicCategory_LONGEST_LTE?: number | null;
  SwissmedicCategory_LT?: number | null;
  SwissmedicCategory_LTE?: number | null;
  SwissmedicCategory_SHORTEST_EQUAL?: number | null;
  SwissmedicCategory_SHORTEST_GT?: number | null;
  SwissmedicCategory_SHORTEST_GTE?: number | null;
  SwissmedicCategory_SHORTEST_LT?: number | null;
  SwissmedicCategory_SHORTEST_LTE?: number | null;
  SwissmedicNo8_AVERAGE_EQUAL?: number | null;
  SwissmedicNo8_AVERAGE_GT?: number | null;
  SwissmedicNo8_AVERAGE_GTE?: number | null;
  SwissmedicNo8_AVERAGE_LT?: number | null;
  SwissmedicNo8_AVERAGE_LTE?: number | null;
  SwissmedicNo8_EQUAL?: string | null;
  SwissmedicNo8_GT?: number | null;
  SwissmedicNo8_GTE?: number | null;
  SwissmedicNo8_LONGEST_EQUAL?: number | null;
  SwissmedicNo8_LONGEST_GT?: number | null;
  SwissmedicNo8_LONGEST_GTE?: number | null;
  SwissmedicNo8_LONGEST_LT?: number | null;
  SwissmedicNo8_LONGEST_LTE?: number | null;
  SwissmedicNo8_LT?: number | null;
  SwissmedicNo8_LTE?: number | null;
  SwissmedicNo8_SHORTEST_EQUAL?: number | null;
  SwissmedicNo8_SHORTEST_GT?: number | null;
  SwissmedicNo8_SHORTEST_GTE?: number | null;
  SwissmedicNo8_SHORTEST_LT?: number | null;
  SwissmedicNo8_SHORTEST_LTE?: number | null;
  UDI_AVERAGE_EQUAL?: number | null;
  UDI_AVERAGE_GT?: number | null;
  UDI_AVERAGE_GTE?: number | null;
  UDI_AVERAGE_LT?: number | null;
  UDI_AVERAGE_LTE?: number | null;
  UDI_EQUAL?: string | null;
  UDI_GT?: number | null;
  UDI_GTE?: number | null;
  UDI_LONGEST_EQUAL?: number | null;
  UDI_LONGEST_GT?: number | null;
  UDI_LONGEST_GTE?: number | null;
  UDI_LONGEST_LT?: number | null;
  UDI_LONGEST_LTE?: number | null;
  UDI_LT?: number | null;
  UDI_LTE?: number | null;
  UDI_SHORTEST_EQUAL?: number | null;
  UDI_SHORTEST_GT?: number | null;
  UDI_SHORTEST_GTE?: number | null;
  UDI_SHORTEST_LT?: number | null;
  UDI_SHORTEST_LTE?: number | null;
  activeIngredientQuantity_AVERAGE_EQUAL?: number | null;
  activeIngredientQuantity_AVERAGE_GT?: number | null;
  activeIngredientQuantity_AVERAGE_GTE?: number | null;
  activeIngredientQuantity_AVERAGE_LT?: number | null;
  activeIngredientQuantity_AVERAGE_LTE?: number | null;
  activeIngredientQuantity_EQUAL?: number | null;
  activeIngredientQuantity_GT?: number | null;
  activeIngredientQuantity_GTE?: number | null;
  activeIngredientQuantity_LT?: number | null;
  activeIngredientQuantity_LTE?: number | null;
  activeIngredientQuantity_MAX_EQUAL?: number | null;
  activeIngredientQuantity_MAX_GT?: number | null;
  activeIngredientQuantity_MAX_GTE?: number | null;
  activeIngredientQuantity_MAX_LT?: number | null;
  activeIngredientQuantity_MAX_LTE?: number | null;
  activeIngredientQuantity_MIN_EQUAL?: number | null;
  activeIngredientQuantity_MIN_GT?: number | null;
  activeIngredientQuantity_MIN_GTE?: number | null;
  activeIngredientQuantity_MIN_LT?: number | null;
  activeIngredientQuantity_MIN_LTE?: number | null;
  activeIngredientQuantity_SUM_EQUAL?: number | null;
  activeIngredientQuantity_SUM_GT?: number | null;
  activeIngredientQuantity_SUM_GTE?: number | null;
  activeIngredientQuantity_SUM_LT?: number | null;
  activeIngredientQuantity_SUM_LTE?: number | null;
  classificationSystem_AVERAGE_EQUAL?: number | null;
  classificationSystem_AVERAGE_GT?: number | null;
  classificationSystem_AVERAGE_GTE?: number | null;
  classificationSystem_AVERAGE_LT?: number | null;
  classificationSystem_AVERAGE_LTE?: number | null;
  classificationSystem_EQUAL?: string | null;
  classificationSystem_GT?: number | null;
  classificationSystem_GTE?: number | null;
  classificationSystem_LONGEST_EQUAL?: number | null;
  classificationSystem_LONGEST_GT?: number | null;
  classificationSystem_LONGEST_GTE?: number | null;
  classificationSystem_LONGEST_LT?: number | null;
  classificationSystem_LONGEST_LTE?: number | null;
  classificationSystem_LT?: number | null;
  classificationSystem_LTE?: number | null;
  classificationSystem_SHORTEST_EQUAL?: number | null;
  classificationSystem_SHORTEST_GT?: number | null;
  classificationSystem_SHORTEST_GTE?: number | null;
  classificationSystem_SHORTEST_LT?: number | null;
  classificationSystem_SHORTEST_LTE?: number | null;
  concentration_AVERAGE_EQUAL?: number | null;
  concentration_AVERAGE_GT?: number | null;
  concentration_AVERAGE_GTE?: number | null;
  concentration_AVERAGE_LT?: number | null;
  concentration_AVERAGE_LTE?: number | null;
  concentration_EQUAL?: string | null;
  concentration_GT?: number | null;
  concentration_GTE?: number | null;
  concentration_LONGEST_EQUAL?: number | null;
  concentration_LONGEST_GT?: number | null;
  concentration_LONGEST_GTE?: number | null;
  concentration_LONGEST_LT?: number | null;
  concentration_LONGEST_LTE?: number | null;
  concentration_LT?: number | null;
  concentration_LTE?: number | null;
  concentration_SHORTEST_EQUAL?: number | null;
  concentration_SHORTEST_GT?: number | null;
  concentration_SHORTEST_GTE?: number | null;
  concentration_SHORTEST_LT?: number | null;
  concentration_SHORTEST_LTE?: number | null;
  packVolume_AVERAGE_EQUAL?: number | null;
  packVolume_AVERAGE_GT?: number | null;
  packVolume_AVERAGE_GTE?: number | null;
  packVolume_AVERAGE_LT?: number | null;
  packVolume_AVERAGE_LTE?: number | null;
  packVolume_EQUAL?: string | null;
  packVolume_GT?: number | null;
  packVolume_GTE?: number | null;
  packVolume_LONGEST_EQUAL?: number | null;
  packVolume_LONGEST_GT?: number | null;
  packVolume_LONGEST_GTE?: number | null;
  packVolume_LONGEST_LT?: number | null;
  packVolume_LONGEST_LTE?: number | null;
  packVolume_LT?: number | null;
  packVolume_LTE?: number | null;
  packVolume_SHORTEST_EQUAL?: number | null;
  packVolume_SHORTEST_GT?: number | null;
  packVolume_SHORTEST_GTE?: number | null;
  packVolume_SHORTEST_LT?: number | null;
  packVolume_SHORTEST_LTE?: number | null;
}

export interface EligibilityConditionSetWhere {
  AND?: EligibilityConditionSetWhere[] | null;
  OR?: EligibilityConditionSetWhere[] | null;
  code?: string | null;
  code_CONTAINS?: string | null;
  code_ENDS_WITH?: string | null;
  code_IN?: (string | null)[] | null;
  code_MATCHES?: string | null;
  code_NOT?: string | null;
  code_NOT_CONTAINS?: string | null;
  code_NOT_ENDS_WITH?: string | null;
  code_NOT_IN?: (string | null)[] | null;
  code_NOT_STARTS_WITH?: string | null;
  code_STARTS_WITH?: string | null;
  inputLabel?: string | null;
  inputLabel_CONTAINS?: string | null;
  inputLabel_ENDS_WITH?: string | null;
  inputLabel_IN?: (string | null)[] | null;
  inputLabel_MATCHES?: string | null;
  inputLabel_NOT?: string | null;
  inputLabel_NOT_CONTAINS?: string | null;
  inputLabel_NOT_ENDS_WITH?: string | null;
  inputLabel_NOT_IN?: (string | null)[] | null;
  inputLabel_NOT_STARTS_WITH?: string | null;
  inputLabel_STARTS_WITH?: string | null;
  name?: string | null;
  name_CONTAINS?: string | null;
  name_ENDS_WITH?: string | null;
  name_IN?: (string | null)[] | null;
  name_MATCHES?: string | null;
  name_NOT?: string | null;
  name_NOT_CONTAINS?: string | null;
  name_NOT_ENDS_WITH?: string | null;
  name_NOT_IN?: (string | null)[] | null;
  name_NOT_STARTS_WITH?: string | null;
  name_STARTS_WITH?: string | null;
  treatments?: TreatmentWhere | null;
  treatmentsAggregate?: EligibilityConditionSetTreatmentsAggregateInput | null;
  treatmentsConnection?: EligibilityConditionSetTreatmentsConnectionWhere | null;
  treatmentsConnection_NOT?: EligibilityConditionSetTreatmentsConnectionWhere | null;
  treatments_NOT?: TreatmentWhere | null;
}

export interface EncapsulatedFeatureConfigurationOfTypeAggregateInput {
  AND?: EncapsulatedFeatureConfigurationOfTypeAggregateInput[] | null;
  OR?: EncapsulatedFeatureConfigurationOfTypeAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: EncapsulatedFeatureConfigurationOfTypeNodeAggregationWhereInput | null;
}

export interface EncapsulatedFeatureConfigurationOfTypeConnectionWhere {
  AND?: EncapsulatedFeatureConfigurationOfTypeConnectionWhere[] | null;
  OR?: EncapsulatedFeatureConfigurationOfTypeConnectionWhere[] | null;
  node?: EncapsulatedFeatureWhere | null;
  node_NOT?: EncapsulatedFeatureWhere | null;
}

export interface EncapsulatedFeatureConfigurationOfTypeNodeAggregationWhereInput {
  AND?: EncapsulatedFeatureConfigurationOfTypeNodeAggregationWhereInput[] | null;
  OR?: EncapsulatedFeatureConfigurationOfTypeNodeAggregationWhereInput[] | null;
  key_AVERAGE_EQUAL?: number | null;
  key_AVERAGE_GT?: number | null;
  key_AVERAGE_GTE?: number | null;
  key_AVERAGE_LT?: number | null;
  key_AVERAGE_LTE?: number | null;
  key_EQUAL?: string | null;
  key_GT?: number | null;
  key_GTE?: number | null;
  key_LONGEST_EQUAL?: number | null;
  key_LONGEST_GT?: number | null;
  key_LONGEST_GTE?: number | null;
  key_LONGEST_LT?: number | null;
  key_LONGEST_LTE?: number | null;
  key_LT?: number | null;
  key_LTE?: number | null;
  key_SHORTEST_EQUAL?: number | null;
  key_SHORTEST_GT?: number | null;
  key_SHORTEST_GTE?: number | null;
  key_SHORTEST_LT?: number | null;
  key_SHORTEST_LTE?: number | null;
  title_AVERAGE_EQUAL?: number | null;
  title_AVERAGE_GT?: number | null;
  title_AVERAGE_GTE?: number | null;
  title_AVERAGE_LT?: number | null;
  title_AVERAGE_LTE?: number | null;
  title_EQUAL?: string | null;
  title_GT?: number | null;
  title_GTE?: number | null;
  title_LONGEST_EQUAL?: number | null;
  title_LONGEST_GT?: number | null;
  title_LONGEST_GTE?: number | null;
  title_LONGEST_LT?: number | null;
  title_LONGEST_LTE?: number | null;
  title_LT?: number | null;
  title_LTE?: number | null;
  title_SHORTEST_EQUAL?: number | null;
  title_SHORTEST_GT?: number | null;
  title_SHORTEST_GTE?: number | null;
  title_SHORTEST_LT?: number | null;
  title_SHORTEST_LTE?: number | null;
}

export interface EncapsulatedFeatureConfigurationSetForAggregateInput {
  AND?: EncapsulatedFeatureConfigurationSetForAggregateInput[] | null;
  OR?: EncapsulatedFeatureConfigurationSetForAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: EncapsulatedFeatureConfigurationSetForNodeAggregationWhereInput | null;
}

export interface EncapsulatedFeatureConfigurationSetForConnectionWhere {
  AND?: EncapsulatedFeatureConfigurationSetForConnectionWhere[] | null;
  OR?: EncapsulatedFeatureConfigurationSetForConnectionWhere[] | null;
  node?: OrganizationWhere | null;
  node_NOT?: OrganizationWhere | null;
}

export interface EncapsulatedFeatureConfigurationSetForNodeAggregationWhereInput {
  AND?: EncapsulatedFeatureConfigurationSetForNodeAggregationWhereInput[] | null;
  BIC_AVERAGE_EQUAL?: number | null;
  BIC_AVERAGE_GT?: number | null;
  BIC_AVERAGE_GTE?: number | null;
  BIC_AVERAGE_LT?: number | null;
  BIC_AVERAGE_LTE?: number | null;
  BIC_EQUAL?: string | null;
  BIC_GT?: number | null;
  BIC_GTE?: number | null;
  BIC_LONGEST_EQUAL?: number | null;
  BIC_LONGEST_GT?: number | null;
  BIC_LONGEST_GTE?: number | null;
  BIC_LONGEST_LT?: number | null;
  BIC_LONGEST_LTE?: number | null;
  BIC_LT?: number | null;
  BIC_LTE?: number | null;
  BIC_SHORTEST_EQUAL?: number | null;
  BIC_SHORTEST_GT?: number | null;
  BIC_SHORTEST_GTE?: number | null;
  BIC_SHORTEST_LT?: number | null;
  BIC_SHORTEST_LTE?: number | null;
  IBAN_AVERAGE_EQUAL?: number | null;
  IBAN_AVERAGE_GT?: number | null;
  IBAN_AVERAGE_GTE?: number | null;
  IBAN_AVERAGE_LT?: number | null;
  IBAN_AVERAGE_LTE?: number | null;
  IBAN_EQUAL?: string | null;
  IBAN_GT?: number | null;
  IBAN_GTE?: number | null;
  IBAN_LONGEST_EQUAL?: number | null;
  IBAN_LONGEST_GT?: number | null;
  IBAN_LONGEST_GTE?: number | null;
  IBAN_LONGEST_LT?: number | null;
  IBAN_LONGEST_LTE?: number | null;
  IBAN_LT?: number | null;
  IBAN_LTE?: number | null;
  IBAN_SHORTEST_EQUAL?: number | null;
  IBAN_SHORTEST_GT?: number | null;
  IBAN_SHORTEST_GTE?: number | null;
  IBAN_SHORTEST_LT?: number | null;
  IBAN_SHORTEST_LTE?: number | null;
  OR?: EncapsulatedFeatureConfigurationSetForNodeAggregationWhereInput[] | null;
  accountName_AVERAGE_EQUAL?: number | null;
  accountName_AVERAGE_GT?: number | null;
  accountName_AVERAGE_GTE?: number | null;
  accountName_AVERAGE_LT?: number | null;
  accountName_AVERAGE_LTE?: number | null;
  accountName_EQUAL?: string | null;
  accountName_GT?: number | null;
  accountName_GTE?: number | null;
  accountName_LONGEST_EQUAL?: number | null;
  accountName_LONGEST_GT?: number | null;
  accountName_LONGEST_GTE?: number | null;
  accountName_LONGEST_LT?: number | null;
  accountName_LONGEST_LTE?: number | null;
  accountName_LT?: number | null;
  accountName_LTE?: number | null;
  accountName_SHORTEST_EQUAL?: number | null;
  accountName_SHORTEST_GT?: number | null;
  accountName_SHORTEST_GTE?: number | null;
  accountName_SHORTEST_LT?: number | null;
  accountName_SHORTEST_LTE?: number | null;
  accountNumber_AVERAGE_EQUAL?: number | null;
  accountNumber_AVERAGE_GT?: number | null;
  accountNumber_AVERAGE_GTE?: number | null;
  accountNumber_AVERAGE_LT?: number | null;
  accountNumber_AVERAGE_LTE?: number | null;
  accountNumber_EQUAL?: string | null;
  accountNumber_GT?: number | null;
  accountNumber_GTE?: number | null;
  accountNumber_LONGEST_EQUAL?: number | null;
  accountNumber_LONGEST_GT?: number | null;
  accountNumber_LONGEST_GTE?: number | null;
  accountNumber_LONGEST_LT?: number | null;
  accountNumber_LONGEST_LTE?: number | null;
  accountNumber_LT?: number | null;
  accountNumber_LTE?: number | null;
  accountNumber_SHORTEST_EQUAL?: number | null;
  accountNumber_SHORTEST_GT?: number | null;
  accountNumber_SHORTEST_GTE?: number | null;
  accountNumber_SHORTEST_LT?: number | null;
  accountNumber_SHORTEST_LTE?: number | null;
  billingAddress_AVERAGE_EQUAL?: number | null;
  billingAddress_AVERAGE_GT?: number | null;
  billingAddress_AVERAGE_GTE?: number | null;
  billingAddress_AVERAGE_LT?: number | null;
  billingAddress_AVERAGE_LTE?: number | null;
  billingAddress_EQUAL?: string | null;
  billingAddress_GT?: number | null;
  billingAddress_GTE?: number | null;
  billingAddress_LONGEST_EQUAL?: number | null;
  billingAddress_LONGEST_GT?: number | null;
  billingAddress_LONGEST_GTE?: number | null;
  billingAddress_LONGEST_LT?: number | null;
  billingAddress_LONGEST_LTE?: number | null;
  billingAddress_LT?: number | null;
  billingAddress_LTE?: number | null;
  billingAddress_SHORTEST_EQUAL?: number | null;
  billingAddress_SHORTEST_GT?: number | null;
  billingAddress_SHORTEST_GTE?: number | null;
  billingAddress_SHORTEST_LT?: number | null;
  billingAddress_SHORTEST_LTE?: number | null;
  contactEmail_AVERAGE_EQUAL?: number | null;
  contactEmail_AVERAGE_GT?: number | null;
  contactEmail_AVERAGE_GTE?: number | null;
  contactEmail_AVERAGE_LT?: number | null;
  contactEmail_AVERAGE_LTE?: number | null;
  contactEmail_EQUAL?: string | null;
  contactEmail_GT?: number | null;
  contactEmail_GTE?: number | null;
  contactEmail_LONGEST_EQUAL?: number | null;
  contactEmail_LONGEST_GT?: number | null;
  contactEmail_LONGEST_GTE?: number | null;
  contactEmail_LONGEST_LT?: number | null;
  contactEmail_LONGEST_LTE?: number | null;
  contactEmail_LT?: number | null;
  contactEmail_LTE?: number | null;
  contactEmail_SHORTEST_EQUAL?: number | null;
  contactEmail_SHORTEST_GT?: number | null;
  contactEmail_SHORTEST_GTE?: number | null;
  contactEmail_SHORTEST_LT?: number | null;
  contactEmail_SHORTEST_LTE?: number | null;
  contactFirstName_AVERAGE_EQUAL?: number | null;
  contactFirstName_AVERAGE_GT?: number | null;
  contactFirstName_AVERAGE_GTE?: number | null;
  contactFirstName_AVERAGE_LT?: number | null;
  contactFirstName_AVERAGE_LTE?: number | null;
  contactFirstName_EQUAL?: string | null;
  contactFirstName_GT?: number | null;
  contactFirstName_GTE?: number | null;
  contactFirstName_LONGEST_EQUAL?: number | null;
  contactFirstName_LONGEST_GT?: number | null;
  contactFirstName_LONGEST_GTE?: number | null;
  contactFirstName_LONGEST_LT?: number | null;
  contactFirstName_LONGEST_LTE?: number | null;
  contactFirstName_LT?: number | null;
  contactFirstName_LTE?: number | null;
  contactFirstName_SHORTEST_EQUAL?: number | null;
  contactFirstName_SHORTEST_GT?: number | null;
  contactFirstName_SHORTEST_GTE?: number | null;
  contactFirstName_SHORTEST_LT?: number | null;
  contactFirstName_SHORTEST_LTE?: number | null;
  contactLastName_AVERAGE_EQUAL?: number | null;
  contactLastName_AVERAGE_GT?: number | null;
  contactLastName_AVERAGE_GTE?: number | null;
  contactLastName_AVERAGE_LT?: number | null;
  contactLastName_AVERAGE_LTE?: number | null;
  contactLastName_EQUAL?: string | null;
  contactLastName_GT?: number | null;
  contactLastName_GTE?: number | null;
  contactLastName_LONGEST_EQUAL?: number | null;
  contactLastName_LONGEST_GT?: number | null;
  contactLastName_LONGEST_GTE?: number | null;
  contactLastName_LONGEST_LT?: number | null;
  contactLastName_LONGEST_LTE?: number | null;
  contactLastName_LT?: number | null;
  contactLastName_LTE?: number | null;
  contactLastName_SHORTEST_EQUAL?: number | null;
  contactLastName_SHORTEST_GT?: number | null;
  contactLastName_SHORTEST_GTE?: number | null;
  contactLastName_SHORTEST_LT?: number | null;
  contactLastName_SHORTEST_LTE?: number | null;
  contactOccupation_AVERAGE_EQUAL?: number | null;
  contactOccupation_AVERAGE_GT?: number | null;
  contactOccupation_AVERAGE_GTE?: number | null;
  contactOccupation_AVERAGE_LT?: number | null;
  contactOccupation_AVERAGE_LTE?: number | null;
  contactOccupation_EQUAL?: string | null;
  contactOccupation_GT?: number | null;
  contactOccupation_GTE?: number | null;
  contactOccupation_LONGEST_EQUAL?: number | null;
  contactOccupation_LONGEST_GT?: number | null;
  contactOccupation_LONGEST_GTE?: number | null;
  contactOccupation_LONGEST_LT?: number | null;
  contactOccupation_LONGEST_LTE?: number | null;
  contactOccupation_LT?: number | null;
  contactOccupation_LTE?: number | null;
  contactOccupation_SHORTEST_EQUAL?: number | null;
  contactOccupation_SHORTEST_GT?: number | null;
  contactOccupation_SHORTEST_GTE?: number | null;
  contactOccupation_SHORTEST_LT?: number | null;
  contactOccupation_SHORTEST_LTE?: number | null;
  contactPhone_AVERAGE_EQUAL?: number | null;
  contactPhone_AVERAGE_GT?: number | null;
  contactPhone_AVERAGE_GTE?: number | null;
  contactPhone_AVERAGE_LT?: number | null;
  contactPhone_AVERAGE_LTE?: number | null;
  contactPhone_EQUAL?: string | null;
  contactPhone_GT?: number | null;
  contactPhone_GTE?: number | null;
  contactPhone_LONGEST_EQUAL?: number | null;
  contactPhone_LONGEST_GT?: number | null;
  contactPhone_LONGEST_GTE?: number | null;
  contactPhone_LONGEST_LT?: number | null;
  contactPhone_LONGEST_LTE?: number | null;
  contactPhone_LT?: number | null;
  contactPhone_LTE?: number | null;
  contactPhone_SHORTEST_EQUAL?: number | null;
  contactPhone_SHORTEST_GT?: number | null;
  contactPhone_SHORTEST_GTE?: number | null;
  contactPhone_SHORTEST_LT?: number | null;
  contactPhone_SHORTEST_LTE?: number | null;
  createdOn_AVERAGE_EQUAL?: number | null;
  createdOn_AVERAGE_GT?: number | null;
  createdOn_AVERAGE_GTE?: number | null;
  createdOn_AVERAGE_LT?: number | null;
  createdOn_AVERAGE_LTE?: number | null;
  createdOn_EQUAL?: number | null;
  createdOn_GT?: number | null;
  createdOn_GTE?: number | null;
  createdOn_LT?: number | null;
  createdOn_LTE?: number | null;
  createdOn_MAX_EQUAL?: number | null;
  createdOn_MAX_GT?: number | null;
  createdOn_MAX_GTE?: number | null;
  createdOn_MAX_LT?: number | null;
  createdOn_MAX_LTE?: number | null;
  createdOn_MIN_EQUAL?: number | null;
  createdOn_MIN_GT?: number | null;
  createdOn_MIN_GTE?: number | null;
  createdOn_MIN_LT?: number | null;
  createdOn_MIN_LTE?: number | null;
  createdOn_SUM_EQUAL?: number | null;
  createdOn_SUM_GT?: number | null;
  createdOn_SUM_GTE?: number | null;
  createdOn_SUM_LT?: number | null;
  createdOn_SUM_LTE?: number | null;
  deliveryAddress_AVERAGE_EQUAL?: number | null;
  deliveryAddress_AVERAGE_GT?: number | null;
  deliveryAddress_AVERAGE_GTE?: number | null;
  deliveryAddress_AVERAGE_LT?: number | null;
  deliveryAddress_AVERAGE_LTE?: number | null;
  deliveryAddress_EQUAL?: string | null;
  deliveryAddress_GT?: number | null;
  deliveryAddress_GTE?: number | null;
  deliveryAddress_LONGEST_EQUAL?: number | null;
  deliveryAddress_LONGEST_GT?: number | null;
  deliveryAddress_LONGEST_GTE?: number | null;
  deliveryAddress_LONGEST_LT?: number | null;
  deliveryAddress_LONGEST_LTE?: number | null;
  deliveryAddress_LT?: number | null;
  deliveryAddress_LTE?: number | null;
  deliveryAddress_SHORTEST_EQUAL?: number | null;
  deliveryAddress_SHORTEST_GT?: number | null;
  deliveryAddress_SHORTEST_GTE?: number | null;
  deliveryAddress_SHORTEST_LT?: number | null;
  deliveryAddress_SHORTEST_LTE?: number | null;
  domicile_AVERAGE_EQUAL?: number | null;
  domicile_AVERAGE_GT?: number | null;
  domicile_AVERAGE_GTE?: number | null;
  domicile_AVERAGE_LT?: number | null;
  domicile_AVERAGE_LTE?: number | null;
  domicile_EQUAL?: string | null;
  domicile_GT?: number | null;
  domicile_GTE?: number | null;
  domicile_LONGEST_EQUAL?: number | null;
  domicile_LONGEST_GT?: number | null;
  domicile_LONGEST_GTE?: number | null;
  domicile_LONGEST_LT?: number | null;
  domicile_LONGEST_LTE?: number | null;
  domicile_LT?: number | null;
  domicile_LTE?: number | null;
  domicile_SHORTEST_EQUAL?: number | null;
  domicile_SHORTEST_GT?: number | null;
  domicile_SHORTEST_GTE?: number | null;
  domicile_SHORTEST_LT?: number | null;
  domicile_SHORTEST_LTE?: number | null;
  dualApprovalThreshold_AVERAGE_EQUAL?: number | null;
  dualApprovalThreshold_AVERAGE_GT?: number | null;
  dualApprovalThreshold_AVERAGE_GTE?: number | null;
  dualApprovalThreshold_AVERAGE_LT?: number | null;
  dualApprovalThreshold_AVERAGE_LTE?: number | null;
  dualApprovalThreshold_EQUAL?: number | null;
  dualApprovalThreshold_GT?: number | null;
  dualApprovalThreshold_GTE?: number | null;
  dualApprovalThreshold_LT?: number | null;
  dualApprovalThreshold_LTE?: number | null;
  dualApprovalThreshold_MAX_EQUAL?: number | null;
  dualApprovalThreshold_MAX_GT?: number | null;
  dualApprovalThreshold_MAX_GTE?: number | null;
  dualApprovalThreshold_MAX_LT?: number | null;
  dualApprovalThreshold_MAX_LTE?: number | null;
  dualApprovalThreshold_MIN_EQUAL?: number | null;
  dualApprovalThreshold_MIN_GT?: number | null;
  dualApprovalThreshold_MIN_GTE?: number | null;
  dualApprovalThreshold_MIN_LT?: number | null;
  dualApprovalThreshold_MIN_LTE?: number | null;
  dualApprovalThreshold_SUM_EQUAL?: number | null;
  dualApprovalThreshold_SUM_GT?: number | null;
  dualApprovalThreshold_SUM_GTE?: number | null;
  dualApprovalThreshold_SUM_LT?: number | null;
  dualApprovalThreshold_SUM_LTE?: number | null;
  eIN_AVERAGE_EQUAL?: number | null;
  eIN_AVERAGE_GT?: number | null;
  eIN_AVERAGE_GTE?: number | null;
  eIN_AVERAGE_LT?: number | null;
  eIN_AVERAGE_LTE?: number | null;
  eIN_EQUAL?: string | null;
  eIN_GT?: number | null;
  eIN_GTE?: number | null;
  eIN_LONGEST_EQUAL?: number | null;
  eIN_LONGEST_GT?: number | null;
  eIN_LONGEST_GTE?: number | null;
  eIN_LONGEST_LT?: number | null;
  eIN_LONGEST_LTE?: number | null;
  eIN_LT?: number | null;
  eIN_LTE?: number | null;
  eIN_SHORTEST_EQUAL?: number | null;
  eIN_SHORTEST_GT?: number | null;
  eIN_SHORTEST_GTE?: number | null;
  eIN_SHORTEST_LT?: number | null;
  eIN_SHORTEST_LTE?: number | null;
  fax_AVERAGE_EQUAL?: number | null;
  fax_AVERAGE_GT?: number | null;
  fax_AVERAGE_GTE?: number | null;
  fax_AVERAGE_LT?: number | null;
  fax_AVERAGE_LTE?: number | null;
  fax_EQUAL?: string | null;
  fax_GT?: number | null;
  fax_GTE?: number | null;
  fax_LONGEST_EQUAL?: number | null;
  fax_LONGEST_GT?: number | null;
  fax_LONGEST_GTE?: number | null;
  fax_LONGEST_LT?: number | null;
  fax_LONGEST_LTE?: number | null;
  fax_LT?: number | null;
  fax_LTE?: number | null;
  fax_SHORTEST_EQUAL?: number | null;
  fax_SHORTEST_GT?: number | null;
  fax_SHORTEST_GTE?: number | null;
  fax_SHORTEST_LT?: number | null;
  fax_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  legalName_AVERAGE_EQUAL?: number | null;
  legalName_AVERAGE_GT?: number | null;
  legalName_AVERAGE_GTE?: number | null;
  legalName_AVERAGE_LT?: number | null;
  legalName_AVERAGE_LTE?: number | null;
  legalName_EQUAL?: string | null;
  legalName_GT?: number | null;
  legalName_GTE?: number | null;
  legalName_LONGEST_EQUAL?: number | null;
  legalName_LONGEST_GT?: number | null;
  legalName_LONGEST_GTE?: number | null;
  legalName_LONGEST_LT?: number | null;
  legalName_LONGEST_LTE?: number | null;
  legalName_LT?: number | null;
  legalName_LTE?: number | null;
  legalName_SHORTEST_EQUAL?: number | null;
  legalName_SHORTEST_GT?: number | null;
  legalName_SHORTEST_GTE?: number | null;
  legalName_SHORTEST_LT?: number | null;
  legalName_SHORTEST_LTE?: number | null;
  logo_AVERAGE_EQUAL?: number | null;
  logo_AVERAGE_GT?: number | null;
  logo_AVERAGE_GTE?: number | null;
  logo_AVERAGE_LT?: number | null;
  logo_AVERAGE_LTE?: number | null;
  logo_EQUAL?: string | null;
  logo_GT?: number | null;
  logo_GTE?: number | null;
  logo_LONGEST_EQUAL?: number | null;
  logo_LONGEST_GT?: number | null;
  logo_LONGEST_GTE?: number | null;
  logo_LONGEST_LT?: number | null;
  logo_LONGEST_LTE?: number | null;
  logo_LT?: number | null;
  logo_LTE?: number | null;
  logo_SHORTEST_EQUAL?: number | null;
  logo_SHORTEST_GT?: number | null;
  logo_SHORTEST_GTE?: number | null;
  logo_SHORTEST_LT?: number | null;
  logo_SHORTEST_LTE?: number | null;
  name_AVERAGE_EQUAL?: number | null;
  name_AVERAGE_GT?: number | null;
  name_AVERAGE_GTE?: number | null;
  name_AVERAGE_LT?: number | null;
  name_AVERAGE_LTE?: number | null;
  name_EQUAL?: string | null;
  name_GT?: number | null;
  name_GTE?: number | null;
  name_LONGEST_EQUAL?: number | null;
  name_LONGEST_GT?: number | null;
  name_LONGEST_GTE?: number | null;
  name_LONGEST_LT?: number | null;
  name_LONGEST_LTE?: number | null;
  name_LT?: number | null;
  name_LTE?: number | null;
  name_SHORTEST_EQUAL?: number | null;
  name_SHORTEST_GT?: number | null;
  name_SHORTEST_GTE?: number | null;
  name_SHORTEST_LT?: number | null;
  name_SHORTEST_LTE?: number | null;
  paymentTerms_AVERAGE_EQUAL?: number | null;
  paymentTerms_AVERAGE_GT?: number | null;
  paymentTerms_AVERAGE_GTE?: number | null;
  paymentTerms_AVERAGE_LT?: number | null;
  paymentTerms_AVERAGE_LTE?: number | null;
  paymentTerms_EQUAL?: number | null;
  paymentTerms_GT?: number | null;
  paymentTerms_GTE?: number | null;
  paymentTerms_LT?: number | null;
  paymentTerms_LTE?: number | null;
  paymentTerms_MAX_EQUAL?: number | null;
  paymentTerms_MAX_GT?: number | null;
  paymentTerms_MAX_GTE?: number | null;
  paymentTerms_MAX_LT?: number | null;
  paymentTerms_MAX_LTE?: number | null;
  paymentTerms_MIN_EQUAL?: number | null;
  paymentTerms_MIN_GT?: number | null;
  paymentTerms_MIN_GTE?: number | null;
  paymentTerms_MIN_LT?: number | null;
  paymentTerms_MIN_LTE?: number | null;
  paymentTerms_SUM_EQUAL?: number | null;
  paymentTerms_SUM_GT?: number | null;
  paymentTerms_SUM_GTE?: number | null;
  paymentTerms_SUM_LT?: number | null;
  paymentTerms_SUM_LTE?: number | null;
  phone_AVERAGE_EQUAL?: number | null;
  phone_AVERAGE_GT?: number | null;
  phone_AVERAGE_GTE?: number | null;
  phone_AVERAGE_LT?: number | null;
  phone_AVERAGE_LTE?: number | null;
  phone_EQUAL?: string | null;
  phone_GT?: number | null;
  phone_GTE?: number | null;
  phone_LONGEST_EQUAL?: number | null;
  phone_LONGEST_GT?: number | null;
  phone_LONGEST_GTE?: number | null;
  phone_LONGEST_LT?: number | null;
  phone_LONGEST_LTE?: number | null;
  phone_LT?: number | null;
  phone_LTE?: number | null;
  phone_SHORTEST_EQUAL?: number | null;
  phone_SHORTEST_GT?: number | null;
  phone_SHORTEST_GTE?: number | null;
  phone_SHORTEST_LT?: number | null;
  phone_SHORTEST_LTE?: number | null;
  tenantId_AVERAGE_EQUAL?: number | null;
  tenantId_AVERAGE_GT?: number | null;
  tenantId_AVERAGE_GTE?: number | null;
  tenantId_AVERAGE_LT?: number | null;
  tenantId_AVERAGE_LTE?: number | null;
  tenantId_EQUAL?: string | null;
  tenantId_GT?: number | null;
  tenantId_GTE?: number | null;
  tenantId_LONGEST_EQUAL?: number | null;
  tenantId_LONGEST_GT?: number | null;
  tenantId_LONGEST_GTE?: number | null;
  tenantId_LONGEST_LT?: number | null;
  tenantId_LONGEST_LTE?: number | null;
  tenantId_LT?: number | null;
  tenantId_LTE?: number | null;
  tenantId_SHORTEST_EQUAL?: number | null;
  tenantId_SHORTEST_GT?: number | null;
  tenantId_SHORTEST_GTE?: number | null;
  tenantId_SHORTEST_LT?: number | null;
  tenantId_SHORTEST_LTE?: number | null;
  website_AVERAGE_EQUAL?: number | null;
  website_AVERAGE_GT?: number | null;
  website_AVERAGE_GTE?: number | null;
  website_AVERAGE_LT?: number | null;
  website_AVERAGE_LTE?: number | null;
  website_EQUAL?: string | null;
  website_GT?: number | null;
  website_GTE?: number | null;
  website_LONGEST_EQUAL?: number | null;
  website_LONGEST_GT?: number | null;
  website_LONGEST_GTE?: number | null;
  website_LONGEST_LT?: number | null;
  website_LONGEST_LTE?: number | null;
  website_LT?: number | null;
  website_LTE?: number | null;
  website_SHORTEST_EQUAL?: number | null;
  website_SHORTEST_GT?: number | null;
  website_SHORTEST_GTE?: number | null;
  website_SHORTEST_LT?: number | null;
  website_SHORTEST_LTE?: number | null;
}

export interface EncapsulatedFeatureConfigurationWhere {
  AND?: EncapsulatedFeatureConfigurationWhere[] | null;
  OR?: EncapsulatedFeatureConfigurationWhere[] | null;
  isEnabled?: boolean | null;
  isEnabled_NOT?: boolean | null;
  ofType?: EncapsulatedFeatureWhere | null;
  ofTypeAggregate?: EncapsulatedFeatureConfigurationOfTypeAggregateInput | null;
  ofTypeConnection?: EncapsulatedFeatureConfigurationOfTypeConnectionWhere | null;
  ofTypeConnection_NOT?: EncapsulatedFeatureConfigurationOfTypeConnectionWhere | null;
  ofType_NOT?: EncapsulatedFeatureWhere | null;
  setFor?: OrganizationWhere | null;
  setForAggregate?: EncapsulatedFeatureConfigurationSetForAggregateInput | null;
  setForConnection?: EncapsulatedFeatureConfigurationSetForConnectionWhere | null;
  setForConnection_NOT?: EncapsulatedFeatureConfigurationSetForConnectionWhere | null;
  setFor_NOT?: OrganizationWhere | null;
}

export interface EncapsulatedFeatureWhere {
  AND?: EncapsulatedFeatureWhere[] | null;
  OR?: EncapsulatedFeatureWhere[] | null;
  key?: string | null;
  key_CONTAINS?: string | null;
  key_ENDS_WITH?: string | null;
  key_IN?: (string | null)[] | null;
  key_MATCHES?: string | null;
  key_NOT?: string | null;
  key_NOT_CONTAINS?: string | null;
  key_NOT_ENDS_WITH?: string | null;
  key_NOT_IN?: (string | null)[] | null;
  key_NOT_STARTS_WITH?: string | null;
  key_STARTS_WITH?: string | null;
  title?: string | null;
  title_CONTAINS?: string | null;
  title_ENDS_WITH?: string | null;
  title_IN?: (string | null)[] | null;
  title_MATCHES?: string | null;
  title_NOT?: string | null;
  title_NOT_CONTAINS?: string | null;
  title_NOT_ENDS_WITH?: string | null;
  title_NOT_IN?: (string | null)[] | null;
  title_NOT_STARTS_WITH?: string | null;
  title_STARTS_WITH?: string | null;
}

export interface EnrollingConditionCustomConditionAggregateInput {
  AND?: EnrollingConditionCustomConditionAggregateInput[] | null;
  OR?: EnrollingConditionCustomConditionAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: EnrollingConditionCustomConditionNodeAggregationWhereInput | null;
}

export interface EnrollingConditionCustomConditionConnectionWhere {
  AND?: EnrollingConditionCustomConditionConnectionWhere[] | null;
  OR?: EnrollingConditionCustomConditionConnectionWhere[] | null;
  node?: CustomEnrollingConditionWhere | null;
  node_NOT?: CustomEnrollingConditionWhere | null;
}

export interface EnrollingConditionCustomConditionNodeAggregationWhereInput {
  AND?: EnrollingConditionCustomConditionNodeAggregationWhereInput[] | null;
  OR?: EnrollingConditionCustomConditionNodeAggregationWhereInput[] | null;
  createdOn_EQUAL?: any | null;
  createdOn_GT?: any | null;
  createdOn_GTE?: any | null;
  createdOn_LT?: any | null;
  createdOn_LTE?: any | null;
  createdOn_MAX_EQUAL?: any | null;
  createdOn_MAX_GT?: any | null;
  createdOn_MAX_GTE?: any | null;
  createdOn_MAX_LT?: any | null;
  createdOn_MAX_LTE?: any | null;
  createdOn_MIN_EQUAL?: any | null;
  createdOn_MIN_GT?: any | null;
  createdOn_MIN_GTE?: any | null;
  createdOn_MIN_LT?: any | null;
  createdOn_MIN_LTE?: any | null;
  description_AVERAGE_EQUAL?: number | null;
  description_AVERAGE_GT?: number | null;
  description_AVERAGE_GTE?: number | null;
  description_AVERAGE_LT?: number | null;
  description_AVERAGE_LTE?: number | null;
  description_EQUAL?: string | null;
  description_GT?: number | null;
  description_GTE?: number | null;
  description_LONGEST_EQUAL?: number | null;
  description_LONGEST_GT?: number | null;
  description_LONGEST_GTE?: number | null;
  description_LONGEST_LT?: number | null;
  description_LONGEST_LTE?: number | null;
  description_LT?: number | null;
  description_LTE?: number | null;
  description_SHORTEST_EQUAL?: number | null;
  description_SHORTEST_GT?: number | null;
  description_SHORTEST_GTE?: number | null;
  description_SHORTEST_LT?: number | null;
  description_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  name_AVERAGE_EQUAL?: number | null;
  name_AVERAGE_GT?: number | null;
  name_AVERAGE_GTE?: number | null;
  name_AVERAGE_LT?: number | null;
  name_AVERAGE_LTE?: number | null;
  name_EQUAL?: string | null;
  name_GT?: number | null;
  name_GTE?: number | null;
  name_LONGEST_EQUAL?: number | null;
  name_LONGEST_GT?: number | null;
  name_LONGEST_GTE?: number | null;
  name_LONGEST_LT?: number | null;
  name_LONGEST_LTE?: number | null;
  name_LT?: number | null;
  name_LTE?: number | null;
  name_SHORTEST_EQUAL?: number | null;
  name_SHORTEST_GT?: number | null;
  name_SHORTEST_GTE?: number | null;
  name_SHORTEST_LT?: number | null;
  name_SHORTEST_LTE?: number | null;
  type_AVERAGE_EQUAL?: number | null;
  type_AVERAGE_GT?: number | null;
  type_AVERAGE_GTE?: number | null;
  type_AVERAGE_LT?: number | null;
  type_AVERAGE_LTE?: number | null;
  type_EQUAL?: string | null;
  type_GT?: number | null;
  type_GTE?: number | null;
  type_LONGEST_EQUAL?: number | null;
  type_LONGEST_GT?: number | null;
  type_LONGEST_GTE?: number | null;
  type_LONGEST_LT?: number | null;
  type_LONGEST_LTE?: number | null;
  type_LT?: number | null;
  type_LTE?: number | null;
  type_SHORTEST_EQUAL?: number | null;
  type_SHORTEST_GT?: number | null;
  type_SHORTEST_GTE?: number | null;
  type_SHORTEST_LT?: number | null;
  type_SHORTEST_LTE?: number | null;
}

export interface EnrollingConditionDiseaseRelationshipWhere {
  AND?: EnrollingConditionDiseaseRelationshipWhere[] | null;
  OR?: EnrollingConditionDiseaseRelationshipWhere[] | null;
  Score?: number | null;
  Score_GT?: number | null;
  Score_GTE?: number | null;
  Score_IN?: (number | null)[] | null;
  Score_LT?: number | null;
  Score_LTE?: number | null;
  Score_NOT?: number | null;
  Score_NOT_IN?: (number | null)[] | null;
}

export interface EnrollingConditionIncludedGenericsAggregateInput {
  AND?: EnrollingConditionIncludedGenericsAggregateInput[] | null;
  OR?: EnrollingConditionIncludedGenericsAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: EnrollingConditionIncludedGenericsNodeAggregationWhereInput | null;
}

export interface EnrollingConditionIncludedGenericsConnectionWhere {
  AND?: EnrollingConditionIncludedGenericsConnectionWhere[] | null;
  OR?: EnrollingConditionIncludedGenericsConnectionWhere[] | null;
  node?: GenericWhere | null;
  node_NOT?: GenericWhere | null;
}

export interface EnrollingConditionIncludedGenericsNodeAggregationWhereInput {
  AND?: EnrollingConditionIncludedGenericsNodeAggregationWhereInput[] | null;
  Name_AVERAGE_EQUAL?: number | null;
  Name_AVERAGE_GT?: number | null;
  Name_AVERAGE_GTE?: number | null;
  Name_AVERAGE_LT?: number | null;
  Name_AVERAGE_LTE?: number | null;
  Name_EQUAL?: string | null;
  Name_GT?: number | null;
  Name_GTE?: number | null;
  Name_LONGEST_EQUAL?: number | null;
  Name_LONGEST_GT?: number | null;
  Name_LONGEST_GTE?: number | null;
  Name_LONGEST_LT?: number | null;
  Name_LONGEST_LTE?: number | null;
  Name_LT?: number | null;
  Name_LTE?: number | null;
  Name_SHORTEST_EQUAL?: number | null;
  Name_SHORTEST_GT?: number | null;
  Name_SHORTEST_GTE?: number | null;
  Name_SHORTEST_LT?: number | null;
  Name_SHORTEST_LTE?: number | null;
  OR?: EnrollingConditionIncludedGenericsNodeAggregationWhereInput[] | null;
  id_EQUAL?: string | null;
}

export interface EnrollingConditionSetAgreementAggregateInput {
  AND?: EnrollingConditionSetAgreementAggregateInput[] | null;
  OR?: EnrollingConditionSetAgreementAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: EnrollingConditionSetAgreementNodeAggregationWhereInput | null;
}

export interface EnrollingConditionSetAgreementConnectionWhere {
  AND?: EnrollingConditionSetAgreementConnectionWhere[] | null;
  OR?: EnrollingConditionSetAgreementConnectionWhere[] | null;
  node?: AgreementWhere | null;
  node_NOT?: AgreementWhere | null;
}

export interface EnrollingConditionSetAgreementNodeAggregationWhereInput {
  AND?: EnrollingConditionSetAgreementNodeAggregationWhereInput[] | null;
  OR?: EnrollingConditionSetAgreementNodeAggregationWhereInput[] | null;
  description_AVERAGE_EQUAL?: number | null;
  description_AVERAGE_GT?: number | null;
  description_AVERAGE_GTE?: number | null;
  description_AVERAGE_LT?: number | null;
  description_AVERAGE_LTE?: number | null;
  description_EQUAL?: string | null;
  description_GT?: number | null;
  description_GTE?: number | null;
  description_LONGEST_EQUAL?: number | null;
  description_LONGEST_GT?: number | null;
  description_LONGEST_GTE?: number | null;
  description_LONGEST_LT?: number | null;
  description_LONGEST_LTE?: number | null;
  description_LT?: number | null;
  description_LTE?: number | null;
  description_SHORTEST_EQUAL?: number | null;
  description_SHORTEST_GT?: number | null;
  description_SHORTEST_GTE?: number | null;
  description_SHORTEST_LT?: number | null;
  description_SHORTEST_LTE?: number | null;
  formattedAmount_AVERAGE_EQUAL?: number | null;
  formattedAmount_AVERAGE_GT?: number | null;
  formattedAmount_AVERAGE_GTE?: number | null;
  formattedAmount_AVERAGE_LT?: number | null;
  formattedAmount_AVERAGE_LTE?: number | null;
  formattedAmount_EQUAL?: string | null;
  formattedAmount_GT?: number | null;
  formattedAmount_GTE?: number | null;
  formattedAmount_LONGEST_EQUAL?: number | null;
  formattedAmount_LONGEST_GT?: number | null;
  formattedAmount_LONGEST_GTE?: number | null;
  formattedAmount_LONGEST_LT?: number | null;
  formattedAmount_LONGEST_LTE?: number | null;
  formattedAmount_LT?: number | null;
  formattedAmount_LTE?: number | null;
  formattedAmount_SHORTEST_EQUAL?: number | null;
  formattedAmount_SHORTEST_GT?: number | null;
  formattedAmount_SHORTEST_GTE?: number | null;
  formattedAmount_SHORTEST_LT?: number | null;
  formattedAmount_SHORTEST_LTE?: number | null;
  formattedCounterparties_AVERAGE_EQUAL?: number | null;
  formattedCounterparties_AVERAGE_GT?: number | null;
  formattedCounterparties_AVERAGE_GTE?: number | null;
  formattedCounterparties_AVERAGE_LT?: number | null;
  formattedCounterparties_AVERAGE_LTE?: number | null;
  formattedCounterparties_EQUAL?: string | null;
  formattedCounterparties_GT?: number | null;
  formattedCounterparties_GTE?: number | null;
  formattedCounterparties_LONGEST_EQUAL?: number | null;
  formattedCounterparties_LONGEST_GT?: number | null;
  formattedCounterparties_LONGEST_GTE?: number | null;
  formattedCounterparties_LONGEST_LT?: number | null;
  formattedCounterparties_LONGEST_LTE?: number | null;
  formattedCounterparties_LT?: number | null;
  formattedCounterparties_LTE?: number | null;
  formattedCounterparties_SHORTEST_EQUAL?: number | null;
  formattedCounterparties_SHORTEST_GT?: number | null;
  formattedCounterparties_SHORTEST_GTE?: number | null;
  formattedCounterparties_SHORTEST_LT?: number | null;
  formattedCounterparties_SHORTEST_LTE?: number | null;
  formattedDiseases_AVERAGE_EQUAL?: number | null;
  formattedDiseases_AVERAGE_GT?: number | null;
  formattedDiseases_AVERAGE_GTE?: number | null;
  formattedDiseases_AVERAGE_LT?: number | null;
  formattedDiseases_AVERAGE_LTE?: number | null;
  formattedDiseases_EQUAL?: string | null;
  formattedDiseases_GT?: number | null;
  formattedDiseases_GTE?: number | null;
  formattedDiseases_LONGEST_EQUAL?: number | null;
  formattedDiseases_LONGEST_GT?: number | null;
  formattedDiseases_LONGEST_GTE?: number | null;
  formattedDiseases_LONGEST_LT?: number | null;
  formattedDiseases_LONGEST_LTE?: number | null;
  formattedDiseases_LT?: number | null;
  formattedDiseases_LTE?: number | null;
  formattedDiseases_SHORTEST_EQUAL?: number | null;
  formattedDiseases_SHORTEST_GT?: number | null;
  formattedDiseases_SHORTEST_GTE?: number | null;
  formattedDiseases_SHORTEST_LT?: number | null;
  formattedDiseases_SHORTEST_LTE?: number | null;
  formattedIndications_AVERAGE_EQUAL?: number | null;
  formattedIndications_AVERAGE_GT?: number | null;
  formattedIndications_AVERAGE_GTE?: number | null;
  formattedIndications_AVERAGE_LT?: number | null;
  formattedIndications_AVERAGE_LTE?: number | null;
  formattedIndications_EQUAL?: string | null;
  formattedIndications_GT?: number | null;
  formattedIndications_GTE?: number | null;
  formattedIndications_LONGEST_EQUAL?: number | null;
  formattedIndications_LONGEST_GT?: number | null;
  formattedIndications_LONGEST_GTE?: number | null;
  formattedIndications_LONGEST_LT?: number | null;
  formattedIndications_LONGEST_LTE?: number | null;
  formattedIndications_LT?: number | null;
  formattedIndications_LTE?: number | null;
  formattedIndications_SHORTEST_EQUAL?: number | null;
  formattedIndications_SHORTEST_GT?: number | null;
  formattedIndications_SHORTEST_GTE?: number | null;
  formattedIndications_SHORTEST_LT?: number | null;
  formattedIndications_SHORTEST_LTE?: number | null;
  formattedProducts_AVERAGE_EQUAL?: number | null;
  formattedProducts_AVERAGE_GT?: number | null;
  formattedProducts_AVERAGE_GTE?: number | null;
  formattedProducts_AVERAGE_LT?: number | null;
  formattedProducts_AVERAGE_LTE?: number | null;
  formattedProducts_EQUAL?: string | null;
  formattedProducts_GT?: number | null;
  formattedProducts_GTE?: number | null;
  formattedProducts_LONGEST_EQUAL?: number | null;
  formattedProducts_LONGEST_GT?: number | null;
  formattedProducts_LONGEST_GTE?: number | null;
  formattedProducts_LONGEST_LT?: number | null;
  formattedProducts_LONGEST_LTE?: number | null;
  formattedProducts_LT?: number | null;
  formattedProducts_LTE?: number | null;
  formattedProducts_SHORTEST_EQUAL?: number | null;
  formattedProducts_SHORTEST_GT?: number | null;
  formattedProducts_SHORTEST_GTE?: number | null;
  formattedProducts_SHORTEST_LT?: number | null;
  formattedProducts_SHORTEST_LTE?: number | null;
  formattedTags_AVERAGE_EQUAL?: number | null;
  formattedTags_AVERAGE_GT?: number | null;
  formattedTags_AVERAGE_GTE?: number | null;
  formattedTags_AVERAGE_LT?: number | null;
  formattedTags_AVERAGE_LTE?: number | null;
  formattedTags_EQUAL?: string | null;
  formattedTags_GT?: number | null;
  formattedTags_GTE?: number | null;
  formattedTags_LONGEST_EQUAL?: number | null;
  formattedTags_LONGEST_GT?: number | null;
  formattedTags_LONGEST_GTE?: number | null;
  formattedTags_LONGEST_LT?: number | null;
  formattedTags_LONGEST_LTE?: number | null;
  formattedTags_LT?: number | null;
  formattedTags_LTE?: number | null;
  formattedTags_SHORTEST_EQUAL?: number | null;
  formattedTags_SHORTEST_GT?: number | null;
  formattedTags_SHORTEST_GTE?: number | null;
  formattedTags_SHORTEST_LT?: number | null;
  formattedTags_SHORTEST_LTE?: number | null;
  formattedValidityPeriod_AVERAGE_EQUAL?: number | null;
  formattedValidityPeriod_AVERAGE_GT?: number | null;
  formattedValidityPeriod_AVERAGE_GTE?: number | null;
  formattedValidityPeriod_AVERAGE_LT?: number | null;
  formattedValidityPeriod_AVERAGE_LTE?: number | null;
  formattedValidityPeriod_EQUAL?: string | null;
  formattedValidityPeriod_GT?: number | null;
  formattedValidityPeriod_GTE?: number | null;
  formattedValidityPeriod_LONGEST_EQUAL?: number | null;
  formattedValidityPeriod_LONGEST_GT?: number | null;
  formattedValidityPeriod_LONGEST_GTE?: number | null;
  formattedValidityPeriod_LONGEST_LT?: number | null;
  formattedValidityPeriod_LONGEST_LTE?: number | null;
  formattedValidityPeriod_LT?: number | null;
  formattedValidityPeriod_LTE?: number | null;
  formattedValidityPeriod_SHORTEST_EQUAL?: number | null;
  formattedValidityPeriod_SHORTEST_GT?: number | null;
  formattedValidityPeriod_SHORTEST_GTE?: number | null;
  formattedValidityPeriod_SHORTEST_LT?: number | null;
  formattedValidityPeriod_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  initialVersionId_AVERAGE_EQUAL?: number | null;
  initialVersionId_AVERAGE_GT?: number | null;
  initialVersionId_AVERAGE_GTE?: number | null;
  initialVersionId_AVERAGE_LT?: number | null;
  initialVersionId_AVERAGE_LTE?: number | null;
  initialVersionId_EQUAL?: string | null;
  initialVersionId_GT?: number | null;
  initialVersionId_GTE?: number | null;
  initialVersionId_LONGEST_EQUAL?: number | null;
  initialVersionId_LONGEST_GT?: number | null;
  initialVersionId_LONGEST_GTE?: number | null;
  initialVersionId_LONGEST_LT?: number | null;
  initialVersionId_LONGEST_LTE?: number | null;
  initialVersionId_LT?: number | null;
  initialVersionId_LTE?: number | null;
  initialVersionId_SHORTEST_EQUAL?: number | null;
  initialVersionId_SHORTEST_GT?: number | null;
  initialVersionId_SHORTEST_GTE?: number | null;
  initialVersionId_SHORTEST_LT?: number | null;
  initialVersionId_SHORTEST_LTE?: number | null;
  name_AVERAGE_EQUAL?: number | null;
  name_AVERAGE_GT?: number | null;
  name_AVERAGE_GTE?: number | null;
  name_AVERAGE_LT?: number | null;
  name_AVERAGE_LTE?: number | null;
  name_EQUAL?: string | null;
  name_GT?: number | null;
  name_GTE?: number | null;
  name_LONGEST_EQUAL?: number | null;
  name_LONGEST_GT?: number | null;
  name_LONGEST_GTE?: number | null;
  name_LONGEST_LT?: number | null;
  name_LONGEST_LTE?: number | null;
  name_LT?: number | null;
  name_LTE?: number | null;
  name_SHORTEST_EQUAL?: number | null;
  name_SHORTEST_GT?: number | null;
  name_SHORTEST_GTE?: number | null;
  name_SHORTEST_LT?: number | null;
  name_SHORTEST_LTE?: number | null;
  searchTerm_AVERAGE_EQUAL?: number | null;
  searchTerm_AVERAGE_GT?: number | null;
  searchTerm_AVERAGE_GTE?: number | null;
  searchTerm_AVERAGE_LT?: number | null;
  searchTerm_AVERAGE_LTE?: number | null;
  searchTerm_EQUAL?: string | null;
  searchTerm_GT?: number | null;
  searchTerm_GTE?: number | null;
  searchTerm_LONGEST_EQUAL?: number | null;
  searchTerm_LONGEST_GT?: number | null;
  searchTerm_LONGEST_GTE?: number | null;
  searchTerm_LONGEST_LT?: number | null;
  searchTerm_LONGEST_LTE?: number | null;
  searchTerm_LT?: number | null;
  searchTerm_LTE?: number | null;
  searchTerm_SHORTEST_EQUAL?: number | null;
  searchTerm_SHORTEST_GT?: number | null;
  searchTerm_SHORTEST_GTE?: number | null;
  searchTerm_SHORTEST_LT?: number | null;
  searchTerm_SHORTEST_LTE?: number | null;
  totalAmount_AVERAGE_EQUAL?: number | null;
  totalAmount_AVERAGE_GT?: number | null;
  totalAmount_AVERAGE_GTE?: number | null;
  totalAmount_AVERAGE_LT?: number | null;
  totalAmount_AVERAGE_LTE?: number | null;
  totalAmount_EQUAL?: number | null;
  totalAmount_GT?: number | null;
  totalAmount_GTE?: number | null;
  totalAmount_LT?: number | null;
  totalAmount_LTE?: number | null;
  totalAmount_MAX_EQUAL?: number | null;
  totalAmount_MAX_GT?: number | null;
  totalAmount_MAX_GTE?: number | null;
  totalAmount_MAX_LT?: number | null;
  totalAmount_MAX_LTE?: number | null;
  totalAmount_MIN_EQUAL?: number | null;
  totalAmount_MIN_GT?: number | null;
  totalAmount_MIN_GTE?: number | null;
  totalAmount_MIN_LT?: number | null;
  totalAmount_MIN_LTE?: number | null;
  totalAmount_SUM_EQUAL?: number | null;
  totalAmount_SUM_GT?: number | null;
  totalAmount_SUM_GTE?: number | null;
  totalAmount_SUM_LT?: number | null;
  totalAmount_SUM_LTE?: number | null;
  unlimited_AVERAGE_EQUAL?: number | null;
  unlimited_AVERAGE_GT?: number | null;
  unlimited_AVERAGE_GTE?: number | null;
  unlimited_AVERAGE_LT?: number | null;
  unlimited_AVERAGE_LTE?: number | null;
  unlimited_EQUAL?: number | null;
  unlimited_GT?: number | null;
  unlimited_GTE?: number | null;
  unlimited_LT?: number | null;
  unlimited_LTE?: number | null;
  unlimited_MAX_EQUAL?: number | null;
  unlimited_MAX_GT?: number | null;
  unlimited_MAX_GTE?: number | null;
  unlimited_MAX_LT?: number | null;
  unlimited_MAX_LTE?: number | null;
  unlimited_MIN_EQUAL?: number | null;
  unlimited_MIN_GT?: number | null;
  unlimited_MIN_GTE?: number | null;
  unlimited_MIN_LT?: number | null;
  unlimited_MIN_LTE?: number | null;
  unlimited_SUM_EQUAL?: number | null;
  unlimited_SUM_GT?: number | null;
  unlimited_SUM_GTE?: number | null;
  unlimited_SUM_LT?: number | null;
  unlimited_SUM_LTE?: number | null;
  version_AVERAGE_EQUAL?: number | null;
  version_AVERAGE_GT?: number | null;
  version_AVERAGE_GTE?: number | null;
  version_AVERAGE_LT?: number | null;
  version_AVERAGE_LTE?: number | null;
  version_EQUAL?: number | null;
  version_GT?: number | null;
  version_GTE?: number | null;
  version_LT?: number | null;
  version_LTE?: number | null;
  version_MAX_EQUAL?: number | null;
  version_MAX_GT?: number | null;
  version_MAX_GTE?: number | null;
  version_MAX_LT?: number | null;
  version_MAX_LTE?: number | null;
  version_MIN_EQUAL?: number | null;
  version_MIN_GT?: number | null;
  version_MIN_GTE?: number | null;
  version_MIN_LT?: number | null;
  version_MIN_LTE?: number | null;
  version_SUM_EQUAL?: number | null;
  version_SUM_GT?: number | null;
  version_SUM_GTE?: number | null;
  version_SUM_LT?: number | null;
  version_SUM_LTE?: number | null;
}

export interface EnrollingConditionSetConditionsAggregateInput {
  AND?: EnrollingConditionSetConditionsAggregateInput[] | null;
  OR?: EnrollingConditionSetConditionsAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: EnrollingConditionSetConditionsNodeAggregationWhereInput | null;
}

export interface EnrollingConditionSetConditionsConnectionWhere {
  AND?: EnrollingConditionSetConditionsConnectionWhere[] | null;
  OR?: EnrollingConditionSetConditionsConnectionWhere[] | null;
  node?: EnrollingConditionWhere | null;
  node_NOT?: EnrollingConditionWhere | null;
}

export interface EnrollingConditionSetConditionsNodeAggregationWhereInput {
  AND?: EnrollingConditionSetConditionsNodeAggregationWhereInput[] | null;
  OR?: EnrollingConditionSetConditionsNodeAggregationWhereInput[] | null;
  attributeValue_AVERAGE_EQUAL?: number | null;
  attributeValue_AVERAGE_GT?: number | null;
  attributeValue_AVERAGE_GTE?: number | null;
  attributeValue_AVERAGE_LT?: number | null;
  attributeValue_AVERAGE_LTE?: number | null;
  attributeValue_EQUAL?: string | null;
  attributeValue_GT?: number | null;
  attributeValue_GTE?: number | null;
  attributeValue_LONGEST_EQUAL?: number | null;
  attributeValue_LONGEST_GT?: number | null;
  attributeValue_LONGEST_GTE?: number | null;
  attributeValue_LONGEST_LT?: number | null;
  attributeValue_LONGEST_LTE?: number | null;
  attributeValue_LT?: number | null;
  attributeValue_LTE?: number | null;
  attributeValue_SHORTEST_EQUAL?: number | null;
  attributeValue_SHORTEST_GT?: number | null;
  attributeValue_SHORTEST_GTE?: number | null;
  attributeValue_SHORTEST_LT?: number | null;
  attributeValue_SHORTEST_LTE?: number | null;
  cycleLimitFrom_AVERAGE_EQUAL?: number | null;
  cycleLimitFrom_AVERAGE_GT?: number | null;
  cycleLimitFrom_AVERAGE_GTE?: number | null;
  cycleLimitFrom_AVERAGE_LT?: number | null;
  cycleLimitFrom_AVERAGE_LTE?: number | null;
  cycleLimitFrom_EQUAL?: number | null;
  cycleLimitFrom_GT?: number | null;
  cycleLimitFrom_GTE?: number | null;
  cycleLimitFrom_LT?: number | null;
  cycleLimitFrom_LTE?: number | null;
  cycleLimitFrom_MAX_EQUAL?: number | null;
  cycleLimitFrom_MAX_GT?: number | null;
  cycleLimitFrom_MAX_GTE?: number | null;
  cycleLimitFrom_MAX_LT?: number | null;
  cycleLimitFrom_MAX_LTE?: number | null;
  cycleLimitFrom_MIN_EQUAL?: number | null;
  cycleLimitFrom_MIN_GT?: number | null;
  cycleLimitFrom_MIN_GTE?: number | null;
  cycleLimitFrom_MIN_LT?: number | null;
  cycleLimitFrom_MIN_LTE?: number | null;
  cycleLimitFrom_SUM_EQUAL?: number | null;
  cycleLimitFrom_SUM_GT?: number | null;
  cycleLimitFrom_SUM_GTE?: number | null;
  cycleLimitFrom_SUM_LT?: number | null;
  cycleLimitFrom_SUM_LTE?: number | null;
  cycleLimitTo_AVERAGE_EQUAL?: number | null;
  cycleLimitTo_AVERAGE_GT?: number | null;
  cycleLimitTo_AVERAGE_GTE?: number | null;
  cycleLimitTo_AVERAGE_LT?: number | null;
  cycleLimitTo_AVERAGE_LTE?: number | null;
  cycleLimitTo_EQUAL?: number | null;
  cycleLimitTo_GT?: number | null;
  cycleLimitTo_GTE?: number | null;
  cycleLimitTo_LT?: number | null;
  cycleLimitTo_LTE?: number | null;
  cycleLimitTo_MAX_EQUAL?: number | null;
  cycleLimitTo_MAX_GT?: number | null;
  cycleLimitTo_MAX_GTE?: number | null;
  cycleLimitTo_MAX_LT?: number | null;
  cycleLimitTo_MAX_LTE?: number | null;
  cycleLimitTo_MIN_EQUAL?: number | null;
  cycleLimitTo_MIN_GT?: number | null;
  cycleLimitTo_MIN_GTE?: number | null;
  cycleLimitTo_MIN_LT?: number | null;
  cycleLimitTo_MIN_LTE?: number | null;
  cycleLimitTo_SUM_EQUAL?: number | null;
  cycleLimitTo_SUM_GT?: number | null;
  cycleLimitTo_SUM_GTE?: number | null;
  cycleLimitTo_SUM_LT?: number | null;
  cycleLimitTo_SUM_LTE?: number | null;
  rangeInputEnd_AVERAGE_EQUAL?: number | null;
  rangeInputEnd_AVERAGE_GT?: number | null;
  rangeInputEnd_AVERAGE_GTE?: number | null;
  rangeInputEnd_AVERAGE_LT?: number | null;
  rangeInputEnd_AVERAGE_LTE?: number | null;
  rangeInputEnd_EQUAL?: number | null;
  rangeInputEnd_GT?: number | null;
  rangeInputEnd_GTE?: number | null;
  rangeInputEnd_LT?: number | null;
  rangeInputEnd_LTE?: number | null;
  rangeInputEnd_MAX_EQUAL?: number | null;
  rangeInputEnd_MAX_GT?: number | null;
  rangeInputEnd_MAX_GTE?: number | null;
  rangeInputEnd_MAX_LT?: number | null;
  rangeInputEnd_MAX_LTE?: number | null;
  rangeInputEnd_MIN_EQUAL?: number | null;
  rangeInputEnd_MIN_GT?: number | null;
  rangeInputEnd_MIN_GTE?: number | null;
  rangeInputEnd_MIN_LT?: number | null;
  rangeInputEnd_MIN_LTE?: number | null;
  rangeInputEnd_SUM_EQUAL?: number | null;
  rangeInputEnd_SUM_GT?: number | null;
  rangeInputEnd_SUM_GTE?: number | null;
  rangeInputEnd_SUM_LT?: number | null;
  rangeInputEnd_SUM_LTE?: number | null;
  rangeInputStart_AVERAGE_EQUAL?: number | null;
  rangeInputStart_AVERAGE_GT?: number | null;
  rangeInputStart_AVERAGE_GTE?: number | null;
  rangeInputStart_AVERAGE_LT?: number | null;
  rangeInputStart_AVERAGE_LTE?: number | null;
  rangeInputStart_EQUAL?: number | null;
  rangeInputStart_GT?: number | null;
  rangeInputStart_GTE?: number | null;
  rangeInputStart_LT?: number | null;
  rangeInputStart_LTE?: number | null;
  rangeInputStart_MAX_EQUAL?: number | null;
  rangeInputStart_MAX_GT?: number | null;
  rangeInputStart_MAX_GTE?: number | null;
  rangeInputStart_MAX_LT?: number | null;
  rangeInputStart_MAX_LTE?: number | null;
  rangeInputStart_MIN_EQUAL?: number | null;
  rangeInputStart_MIN_GT?: number | null;
  rangeInputStart_MIN_GTE?: number | null;
  rangeInputStart_MIN_LT?: number | null;
  rangeInputStart_MIN_LTE?: number | null;
  rangeInputStart_SUM_EQUAL?: number | null;
  rangeInputStart_SUM_GT?: number | null;
  rangeInputStart_SUM_GTE?: number | null;
  rangeInputStart_SUM_LT?: number | null;
  rangeInputStart_SUM_LTE?: number | null;
  timeframeRangeEnd_AVERAGE_EQUAL?: number | null;
  timeframeRangeEnd_AVERAGE_GT?: number | null;
  timeframeRangeEnd_AVERAGE_GTE?: number | null;
  timeframeRangeEnd_AVERAGE_LT?: number | null;
  timeframeRangeEnd_AVERAGE_LTE?: number | null;
  timeframeRangeEnd_EQUAL?: number | null;
  timeframeRangeEnd_GT?: number | null;
  timeframeRangeEnd_GTE?: number | null;
  timeframeRangeEnd_LT?: number | null;
  timeframeRangeEnd_LTE?: number | null;
  timeframeRangeEnd_MAX_EQUAL?: number | null;
  timeframeRangeEnd_MAX_GT?: number | null;
  timeframeRangeEnd_MAX_GTE?: number | null;
  timeframeRangeEnd_MAX_LT?: number | null;
  timeframeRangeEnd_MAX_LTE?: number | null;
  timeframeRangeEnd_MIN_EQUAL?: number | null;
  timeframeRangeEnd_MIN_GT?: number | null;
  timeframeRangeEnd_MIN_GTE?: number | null;
  timeframeRangeEnd_MIN_LT?: number | null;
  timeframeRangeEnd_MIN_LTE?: number | null;
  timeframeRangeEnd_SUM_EQUAL?: number | null;
  timeframeRangeEnd_SUM_GT?: number | null;
  timeframeRangeEnd_SUM_GTE?: number | null;
  timeframeRangeEnd_SUM_LT?: number | null;
  timeframeRangeEnd_SUM_LTE?: number | null;
  timeframeRangeStart_AVERAGE_EQUAL?: number | null;
  timeframeRangeStart_AVERAGE_GT?: number | null;
  timeframeRangeStart_AVERAGE_GTE?: number | null;
  timeframeRangeStart_AVERAGE_LT?: number | null;
  timeframeRangeStart_AVERAGE_LTE?: number | null;
  timeframeRangeStart_EQUAL?: number | null;
  timeframeRangeStart_GT?: number | null;
  timeframeRangeStart_GTE?: number | null;
  timeframeRangeStart_LT?: number | null;
  timeframeRangeStart_LTE?: number | null;
  timeframeRangeStart_MAX_EQUAL?: number | null;
  timeframeRangeStart_MAX_GT?: number | null;
  timeframeRangeStart_MAX_GTE?: number | null;
  timeframeRangeStart_MAX_LT?: number | null;
  timeframeRangeStart_MAX_LTE?: number | null;
  timeframeRangeStart_MIN_EQUAL?: number | null;
  timeframeRangeStart_MIN_GT?: number | null;
  timeframeRangeStart_MIN_GTE?: number | null;
  timeframeRangeStart_MIN_LT?: number | null;
  timeframeRangeStart_MIN_LTE?: number | null;
  timeframeRangeStart_SUM_EQUAL?: number | null;
  timeframeRangeStart_SUM_GT?: number | null;
  timeframeRangeStart_SUM_GTE?: number | null;
  timeframeRangeStart_SUM_LT?: number | null;
  timeframeRangeStart_SUM_LTE?: number | null;
}

export interface EnrollingConditionSetScopesAggregateInput {
  AND?: EnrollingConditionSetScopesAggregateInput[] | null;
  OR?: EnrollingConditionSetScopesAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: EnrollingConditionSetScopesNodeAggregationWhereInput | null;
}

export interface EnrollingConditionSetScopesConnectionWhere {
  AND?: EnrollingConditionSetScopesConnectionWhere[] | null;
  OR?: EnrollingConditionSetScopesConnectionWhere[] | null;
  edge?: AgreementScopeRelationshipWhere | null;
  edge_NOT?: AgreementScopeRelationshipWhere | null;
  node?: AgreementScopeWhere | null;
  node_NOT?: AgreementScopeWhere | null;
}

export interface EnrollingConditionSetScopesNodeAggregationWhereInput {
  AND?: EnrollingConditionSetScopesNodeAggregationWhereInput[] | null;
  OR?: EnrollingConditionSetScopesNodeAggregationWhereInput[] | null;
  code_AVERAGE_EQUAL?: number | null;
  code_AVERAGE_GT?: number | null;
  code_AVERAGE_GTE?: number | null;
  code_AVERAGE_LT?: number | null;
  code_AVERAGE_LTE?: number | null;
  code_EQUAL?: string | null;
  code_GT?: number | null;
  code_GTE?: number | null;
  code_LONGEST_EQUAL?: number | null;
  code_LONGEST_GT?: number | null;
  code_LONGEST_GTE?: number | null;
  code_LONGEST_LT?: number | null;
  code_LONGEST_LTE?: number | null;
  code_LT?: number | null;
  code_LTE?: number | null;
  code_SHORTEST_EQUAL?: number | null;
  code_SHORTEST_GT?: number | null;
  code_SHORTEST_GTE?: number | null;
  code_SHORTEST_LT?: number | null;
  code_SHORTEST_LTE?: number | null;
  order_AVERAGE_EQUAL?: number | null;
  order_AVERAGE_GT?: number | null;
  order_AVERAGE_GTE?: number | null;
  order_AVERAGE_LT?: number | null;
  order_AVERAGE_LTE?: number | null;
  order_EQUAL?: number | null;
  order_GT?: number | null;
  order_GTE?: number | null;
  order_LT?: number | null;
  order_LTE?: number | null;
  order_MAX_EQUAL?: number | null;
  order_MAX_GT?: number | null;
  order_MAX_GTE?: number | null;
  order_MAX_LT?: number | null;
  order_MAX_LTE?: number | null;
  order_MIN_EQUAL?: number | null;
  order_MIN_GT?: number | null;
  order_MIN_GTE?: number | null;
  order_MIN_LT?: number | null;
  order_MIN_LTE?: number | null;
  order_SUM_EQUAL?: number | null;
  order_SUM_GT?: number | null;
  order_SUM_GTE?: number | null;
  order_SUM_LT?: number | null;
  order_SUM_LTE?: number | null;
  scopeId_AVERAGE_EQUAL?: number | null;
  scopeId_AVERAGE_GT?: number | null;
  scopeId_AVERAGE_GTE?: number | null;
  scopeId_AVERAGE_LT?: number | null;
  scopeId_AVERAGE_LTE?: number | null;
  scopeId_EQUAL?: string | null;
  scopeId_GT?: number | null;
  scopeId_GTE?: number | null;
  scopeId_LONGEST_EQUAL?: number | null;
  scopeId_LONGEST_GT?: number | null;
  scopeId_LONGEST_GTE?: number | null;
  scopeId_LONGEST_LT?: number | null;
  scopeId_LONGEST_LTE?: number | null;
  scopeId_LT?: number | null;
  scopeId_LTE?: number | null;
  scopeId_SHORTEST_EQUAL?: number | null;
  scopeId_SHORTEST_GT?: number | null;
  scopeId_SHORTEST_GTE?: number | null;
  scopeId_SHORTEST_LT?: number | null;
  scopeId_SHORTEST_LTE?: number | null;
}

export interface EnrollingConditionSetWhere {
  AND?: EnrollingConditionSetWhere[] | null;
  OR?: EnrollingConditionSetWhere[] | null;
  agreement?: AgreementWhere | null;
  agreementAggregate?: EnrollingConditionSetAgreementAggregateInput | null;
  agreementConnection?: EnrollingConditionSetAgreementConnectionWhere | null;
  agreementConnection_NOT?: EnrollingConditionSetAgreementConnectionWhere | null;
  agreement_NOT?: AgreementWhere | null;
  conditions?: EnrollingConditionWhere | null;
  conditionsAggregate?: EnrollingConditionSetConditionsAggregateInput | null;
  conditionsConnection?: EnrollingConditionSetConditionsConnectionWhere | null;
  conditionsConnection_NOT?: EnrollingConditionSetConditionsConnectionWhere | null;
  conditions_NOT?: EnrollingConditionWhere | null;
  isDiseaseNotEnrollingCondition?: boolean | null;
  isDiseaseNotEnrollingCondition_NOT?: boolean | null;
  isIndicationNotEnrollingCondition?: boolean | null;
  isIndicationNotEnrollingCondition_NOT?: boolean | null;
  order?: number | null;
  order_GT?: number | null;
  order_GTE?: number | null;
  order_IN?: (number | null)[] | null;
  order_LT?: number | null;
  order_LTE?: number | null;
  order_NOT?: number | null;
  order_NOT_IN?: (number | null)[] | null;
  scopes?: AgreementScopeWhere | null;
  scopesAggregate?: EnrollingConditionSetScopesAggregateInput | null;
  scopesConnection?: EnrollingConditionSetScopesConnectionWhere | null;
  scopesConnection_NOT?: EnrollingConditionSetScopesConnectionWhere | null;
  scopes_NOT?: AgreementScopeWhere | null;
}

export interface EnrollingConditionWhere {
  AND?: EnrollingConditionWhere[] | null;
  OR?: EnrollingConditionWhere[] | null;
  attributeValue?: string | null;
  attributeValue_CONTAINS?: string | null;
  attributeValue_ENDS_WITH?: string | null;
  attributeValue_IN?: (string | null)[] | null;
  attributeValue_MATCHES?: string | null;
  attributeValue_NOT?: string | null;
  attributeValue_NOT_CONTAINS?: string | null;
  attributeValue_NOT_ENDS_WITH?: string | null;
  attributeValue_NOT_IN?: (string | null)[] | null;
  attributeValue_NOT_STARTS_WITH?: string | null;
  attributeValue_STARTS_WITH?: string | null;
  bothOperatorFirst?: ArithmeticalOperator | null;
  bothOperatorFirst_IN?: (ArithmeticalOperator | null)[] | null;
  bothOperatorFirst_NOT?: ArithmeticalOperator | null;
  bothOperatorFirst_NOT_IN?: (ArithmeticalOperator | null)[] | null;
  bothOperatorSecond?: ArithmeticalOperator | null;
  bothOperatorSecond_IN?: (ArithmeticalOperator | null)[] | null;
  bothOperatorSecond_NOT?: ArithmeticalOperator | null;
  bothOperatorSecond_NOT_IN?: (ArithmeticalOperator | null)[] | null;
  conditionType?: EnrollingConditionType | null;
  conditionType_IN?: (EnrollingConditionType | null)[] | null;
  conditionType_NOT?: EnrollingConditionType | null;
  conditionType_NOT_IN?: (EnrollingConditionType | null)[] | null;
  countdownOperator?: CountdownOperator | null;
  countdownOperator_IN?: (CountdownOperator | null)[] | null;
  countdownOperator_NOT?: CountdownOperator | null;
  countdownOperator_NOT_IN?: (CountdownOperator | null)[] | null;
  customCondition?: CustomEnrollingConditionWhere | null;
  customConditionAggregate?: EnrollingConditionCustomConditionAggregateInput | null;
  customConditionConnection?: EnrollingConditionCustomConditionConnectionWhere | null;
  customConditionConnection_NOT?: EnrollingConditionCustomConditionConnectionWhere | null;
  customCondition_NOT?: CustomEnrollingConditionWhere | null;
  cycleLimitFrom?: number | null;
  cycleLimitFrom_GT?: number | null;
  cycleLimitFrom_GTE?: number | null;
  cycleLimitFrom_IN?: (number | null)[] | null;
  cycleLimitFrom_LT?: number | null;
  cycleLimitFrom_LTE?: number | null;
  cycleLimitFrom_NOT?: number | null;
  cycleLimitFrom_NOT_IN?: (number | null)[] | null;
  cycleLimitTo?: number | null;
  cycleLimitTo_GT?: number | null;
  cycleLimitTo_GTE?: number | null;
  cycleLimitTo_IN?: (number | null)[] | null;
  cycleLimitTo_LT?: number | null;
  cycleLimitTo_LTE?: number | null;
  cycleLimitTo_NOT?: number | null;
  cycleLimitTo_NOT_IN?: (number | null)[] | null;
  includedGenerics?: GenericWhere | null;
  includedGenericsAggregate?: EnrollingConditionIncludedGenericsAggregateInput | null;
  includedGenericsConnection?: EnrollingConditionIncludedGenericsConnectionWhere | null;
  includedGenericsConnection_NOT?: EnrollingConditionIncludedGenericsConnectionWhere | null;
  includedGenerics_NOT?: GenericWhere | null;
  inclusionType?: InclusionType | null;
  inclusionType_IN?: (InclusionType | null)[] | null;
  inclusionType_NOT?: InclusionType | null;
  inclusionType_NOT_IN?: (InclusionType | null)[] | null;
  operator?: ArithmeticalOperator | null;
  operator_IN?: (ArithmeticalOperator | null)[] | null;
  operator_NOT?: ArithmeticalOperator | null;
  operator_NOT_IN?: (ArithmeticalOperator | null)[] | null;
  rangeInputEnd?: number | null;
  rangeInputEnd_GT?: number | null;
  rangeInputEnd_GTE?: number | null;
  rangeInputEnd_IN?: (number | null)[] | null;
  rangeInputEnd_LT?: number | null;
  rangeInputEnd_LTE?: number | null;
  rangeInputEnd_NOT?: number | null;
  rangeInputEnd_NOT_IN?: (number | null)[] | null;
  rangeInputStart?: number | null;
  rangeInputStart_GT?: number | null;
  rangeInputStart_GTE?: number | null;
  rangeInputStart_IN?: (number | null)[] | null;
  rangeInputStart_LT?: number | null;
  rangeInputStart_LTE?: number | null;
  rangeInputStart_NOT?: number | null;
  rangeInputStart_NOT_IN?: (number | null)[] | null;
  rating?: CoverageRequestRating[] | null;
  rating_INCLUDES?: CoverageRequestRating | null;
  rating_NOT?: CoverageRequestRating[] | null;
  rating_NOT_INCLUDES?: CoverageRequestRating | null;
  resultSelectionType?: ResultSelectionType | null;
  resultSelectionType_IN?: (ResultSelectionType | null)[] | null;
  resultSelectionType_NOT?: ResultSelectionType | null;
  resultSelectionType_NOT_IN?: (ResultSelectionType | null)[] | null;
  therapyDecision?: CoverageRequestTherapyDecision[] | null;
  therapyDecision_INCLUDES?: CoverageRequestTherapyDecision | null;
  therapyDecision_NOT?: CoverageRequestTherapyDecision[] | null;
  therapyDecision_NOT_INCLUDES?: CoverageRequestTherapyDecision | null;
  timeframeRangeEnd?: number | null;
  timeframeRangeEnd_GT?: number | null;
  timeframeRangeEnd_GTE?: number | null;
  timeframeRangeEnd_IN?: (number | null)[] | null;
  timeframeRangeEnd_LT?: number | null;
  timeframeRangeEnd_LTE?: number | null;
  timeframeRangeEnd_NOT?: number | null;
  timeframeRangeEnd_NOT_IN?: (number | null)[] | null;
  timeframeRangeStart?: number | null;
  timeframeRangeStart_GT?: number | null;
  timeframeRangeStart_GTE?: number | null;
  timeframeRangeStart_IN?: (number | null)[] | null;
  timeframeRangeStart_LT?: number | null;
  timeframeRangeStart_LTE?: number | null;
  timeframeRangeStart_NOT?: number | null;
  timeframeRangeStart_NOT_IN?: (number | null)[] | null;
  timeframeRangeType?: TimeframeRangeType | null;
  timeframeRangeType_IN?: (TimeframeRangeType | null)[] | null;
  timeframeRangeType_NOT?: TimeframeRangeType | null;
  timeframeRangeType_NOT_IN?: (TimeframeRangeType | null)[] | null;
  timeframeStartingPoint?: TimeframeStartingPoint | null;
  timeframeStartingPoint_IN?: (TimeframeStartingPoint | null)[] | null;
  timeframeStartingPoint_NOT?: TimeframeStartingPoint | null;
  timeframeStartingPoint_NOT_IN?: (TimeframeStartingPoint | null)[] | null;
}

export interface EnrollingPeriodWhere {
  AND?: EnrollingPeriodWhere[] | null;
  OR?: EnrollingPeriodWhere[] | null;
  from?: any | null;
  from_GT?: any | null;
  from_GTE?: any | null;
  from_IN?: (any | null)[] | null;
  from_LT?: any | null;
  from_LTE?: any | null;
  from_NOT?: any | null;
  from_NOT_IN?: (any | null)[] | null;
  to?: any | null;
  to_GT?: any | null;
  to_GTE?: any | null;
  to_IN?: (any | null)[] | null;
  to_LT?: any | null;
  to_LTE?: any | null;
  to_NOT?: any | null;
  to_NOT_IN?: (any | null)[] | null;
}

export interface EntityTypeMappingRelationshipWhere {
  AND?: EntityTypeMappingRelationshipWhere[] | null;
  OR?: EntityTypeMappingRelationshipWhere[] | null;
  data?: string | null;
  data_CONTAINS?: string | null;
  data_ENDS_WITH?: string | null;
  data_IN?: (string | null)[] | null;
  data_MATCHES?: string | null;
  data_NOT?: string | null;
  data_NOT_CONTAINS?: string | null;
  data_NOT_ENDS_WITH?: string | null;
  data_NOT_IN?: (string | null)[] | null;
  data_NOT_STARTS_WITH?: string | null;
  data_STARTS_WITH?: string | null;
}

export interface FinancialDataPointInput {
  amount?: number | null;
  status?: FinancialDataPointStatus | null;
  uuid: string;
}

export interface FinancialSummaryColumnWhere {
  AND?: FinancialSummaryColumnWhere[] | null;
  OR?: FinancialSummaryColumnWhere[] | null;
  id?: string | null;
  id_CONTAINS?: string | null;
  id_ENDS_WITH?: string | null;
  id_IN?: (string | null)[] | null;
  id_MATCHES?: string | null;
  id_NOT?: string | null;
  id_NOT_CONTAINS?: string | null;
  id_NOT_ENDS_WITH?: string | null;
  id_NOT_IN?: (string | null)[] | null;
  id_NOT_STARTS_WITH?: string | null;
  id_STARTS_WITH?: string | null;
  name?: FinancialSummaryColumnName | null;
  name_IN?: (FinancialSummaryColumnName | null)[] | null;
  name_NOT?: FinancialSummaryColumnName | null;
  name_NOT_IN?: (FinancialSummaryColumnName | null)[] | null;
}

export interface FlexEntityCasesAggregateInput {
  AND?: FlexEntityCasesAggregateInput[] | null;
  OR?: FlexEntityCasesAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: FlexEntityCasesNodeAggregationWhereInput | null;
}

export interface FlexEntityCasesConnectionWhere {
  AND?: FlexEntityCasesConnectionWhere[] | null;
  OR?: FlexEntityCasesConnectionWhere[] | null;
  node?: CaseWhere | null;
  node_NOT?: CaseWhere | null;
}

export interface FlexEntityCasesNodeAggregationWhereInput {
  AND?: FlexEntityCasesNodeAggregationWhereInput[] | null;
  OR?: FlexEntityCasesNodeAggregationWhereInput[] | null;
  actualAgreementId_AVERAGE_EQUAL?: number | null;
  actualAgreementId_AVERAGE_GT?: number | null;
  actualAgreementId_AVERAGE_GTE?: number | null;
  actualAgreementId_AVERAGE_LT?: number | null;
  actualAgreementId_AVERAGE_LTE?: number | null;
  actualAgreementId_EQUAL?: string | null;
  actualAgreementId_GT?: number | null;
  actualAgreementId_GTE?: number | null;
  actualAgreementId_LONGEST_EQUAL?: number | null;
  actualAgreementId_LONGEST_GT?: number | null;
  actualAgreementId_LONGEST_GTE?: number | null;
  actualAgreementId_LONGEST_LT?: number | null;
  actualAgreementId_LONGEST_LTE?: number | null;
  actualAgreementId_LT?: number | null;
  actualAgreementId_LTE?: number | null;
  actualAgreementId_SHORTEST_EQUAL?: number | null;
  actualAgreementId_SHORTEST_GT?: number | null;
  actualAgreementId_SHORTEST_GTE?: number | null;
  actualAgreementId_SHORTEST_LT?: number | null;
  actualAgreementId_SHORTEST_LTE?: number | null;
  agreementName_AVERAGE_EQUAL?: number | null;
  agreementName_AVERAGE_GT?: number | null;
  agreementName_AVERAGE_GTE?: number | null;
  agreementName_AVERAGE_LT?: number | null;
  agreementName_AVERAGE_LTE?: number | null;
  agreementName_EQUAL?: string | null;
  agreementName_GT?: number | null;
  agreementName_GTE?: number | null;
  agreementName_LONGEST_EQUAL?: number | null;
  agreementName_LONGEST_GT?: number | null;
  agreementName_LONGEST_GTE?: number | null;
  agreementName_LONGEST_LT?: number | null;
  agreementName_LONGEST_LTE?: number | null;
  agreementName_LT?: number | null;
  agreementName_LTE?: number | null;
  agreementName_SHORTEST_EQUAL?: number | null;
  agreementName_SHORTEST_GT?: number | null;
  agreementName_SHORTEST_GTE?: number | null;
  agreementName_SHORTEST_LT?: number | null;
  agreementName_SHORTEST_LTE?: number | null;
  counterpartyInReview_AVERAGE_EQUAL?: number | null;
  counterpartyInReview_AVERAGE_GT?: number | null;
  counterpartyInReview_AVERAGE_GTE?: number | null;
  counterpartyInReview_AVERAGE_LT?: number | null;
  counterpartyInReview_AVERAGE_LTE?: number | null;
  counterpartyInReview_EQUAL?: string | null;
  counterpartyInReview_GT?: number | null;
  counterpartyInReview_GTE?: number | null;
  counterpartyInReview_LONGEST_EQUAL?: number | null;
  counterpartyInReview_LONGEST_GT?: number | null;
  counterpartyInReview_LONGEST_GTE?: number | null;
  counterpartyInReview_LONGEST_LT?: number | null;
  counterpartyInReview_LONGEST_LTE?: number | null;
  counterpartyInReview_LT?: number | null;
  counterpartyInReview_LTE?: number | null;
  counterpartyInReview_SHORTEST_EQUAL?: number | null;
  counterpartyInReview_SHORTEST_GT?: number | null;
  counterpartyInReview_SHORTEST_GTE?: number | null;
  counterpartyInReview_SHORTEST_LT?: number | null;
  counterpartyInReview_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  lastStatusChangeDate_EQUAL?: any | null;
  lastStatusChangeDate_GT?: any | null;
  lastStatusChangeDate_GTE?: any | null;
  lastStatusChangeDate_LT?: any | null;
  lastStatusChangeDate_LTE?: any | null;
  lastStatusChangeDate_MAX_EQUAL?: any | null;
  lastStatusChangeDate_MAX_GT?: any | null;
  lastStatusChangeDate_MAX_GTE?: any | null;
  lastStatusChangeDate_MAX_LT?: any | null;
  lastStatusChangeDate_MAX_LTE?: any | null;
  lastStatusChangeDate_MIN_EQUAL?: any | null;
  lastStatusChangeDate_MIN_GT?: any | null;
  lastStatusChangeDate_MIN_GTE?: any | null;
  lastStatusChangeDate_MIN_LT?: any | null;
  lastStatusChangeDate_MIN_LTE?: any | null;
  patientInitials_AVERAGE_EQUAL?: number | null;
  patientInitials_AVERAGE_GT?: number | null;
  patientInitials_AVERAGE_GTE?: number | null;
  patientInitials_AVERAGE_LT?: number | null;
  patientInitials_AVERAGE_LTE?: number | null;
  patientInitials_EQUAL?: string | null;
  patientInitials_GT?: number | null;
  patientInitials_GTE?: number | null;
  patientInitials_LONGEST_EQUAL?: number | null;
  patientInitials_LONGEST_GT?: number | null;
  patientInitials_LONGEST_GTE?: number | null;
  patientInitials_LONGEST_LT?: number | null;
  patientInitials_LONGEST_LTE?: number | null;
  patientInitials_LT?: number | null;
  patientInitials_LTE?: number | null;
  patientInitials_SHORTEST_EQUAL?: number | null;
  patientInitials_SHORTEST_GT?: number | null;
  patientInitials_SHORTEST_GTE?: number | null;
  patientInitials_SHORTEST_LT?: number | null;
  patientInitials_SHORTEST_LTE?: number | null;
  patientInsuranceId_AVERAGE_EQUAL?: number | null;
  patientInsuranceId_AVERAGE_GT?: number | null;
  patientInsuranceId_AVERAGE_GTE?: number | null;
  patientInsuranceId_AVERAGE_LT?: number | null;
  patientInsuranceId_AVERAGE_LTE?: number | null;
  patientInsuranceId_EQUAL?: string | null;
  patientInsuranceId_GT?: number | null;
  patientInsuranceId_GTE?: number | null;
  patientInsuranceId_LONGEST_EQUAL?: number | null;
  patientInsuranceId_LONGEST_GT?: number | null;
  patientInsuranceId_LONGEST_GTE?: number | null;
  patientInsuranceId_LONGEST_LT?: number | null;
  patientInsuranceId_LONGEST_LTE?: number | null;
  patientInsuranceId_LT?: number | null;
  patientInsuranceId_LTE?: number | null;
  patientInsuranceId_SHORTEST_EQUAL?: number | null;
  patientInsuranceId_SHORTEST_GT?: number | null;
  patientInsuranceId_SHORTEST_GTE?: number | null;
  patientInsuranceId_SHORTEST_LT?: number | null;
  patientInsuranceId_SHORTEST_LTE?: number | null;
  preparationBrandName_AVERAGE_EQUAL?: number | null;
  preparationBrandName_AVERAGE_GT?: number | null;
  preparationBrandName_AVERAGE_GTE?: number | null;
  preparationBrandName_AVERAGE_LT?: number | null;
  preparationBrandName_AVERAGE_LTE?: number | null;
  preparationBrandName_EQUAL?: string | null;
  preparationBrandName_GT?: number | null;
  preparationBrandName_GTE?: number | null;
  preparationBrandName_LONGEST_EQUAL?: number | null;
  preparationBrandName_LONGEST_GT?: number | null;
  preparationBrandName_LONGEST_GTE?: number | null;
  preparationBrandName_LONGEST_LT?: number | null;
  preparationBrandName_LONGEST_LTE?: number | null;
  preparationBrandName_LT?: number | null;
  preparationBrandName_LTE?: number | null;
  preparationBrandName_SHORTEST_EQUAL?: number | null;
  preparationBrandName_SHORTEST_GT?: number | null;
  preparationBrandName_SHORTEST_GTE?: number | null;
  preparationBrandName_SHORTEST_LT?: number | null;
  preparationBrandName_SHORTEST_LTE?: number | null;
  preparationGenericName_AVERAGE_EQUAL?: number | null;
  preparationGenericName_AVERAGE_GT?: number | null;
  preparationGenericName_AVERAGE_GTE?: number | null;
  preparationGenericName_AVERAGE_LT?: number | null;
  preparationGenericName_AVERAGE_LTE?: number | null;
  preparationGenericName_EQUAL?: string | null;
  preparationGenericName_GT?: number | null;
  preparationGenericName_GTE?: number | null;
  preparationGenericName_LONGEST_EQUAL?: number | null;
  preparationGenericName_LONGEST_GT?: number | null;
  preparationGenericName_LONGEST_GTE?: number | null;
  preparationGenericName_LONGEST_LT?: number | null;
  preparationGenericName_LONGEST_LTE?: number | null;
  preparationGenericName_LT?: number | null;
  preparationGenericName_LTE?: number | null;
  preparationGenericName_SHORTEST_EQUAL?: number | null;
  preparationGenericName_SHORTEST_GT?: number | null;
  preparationGenericName_SHORTEST_GTE?: number | null;
  preparationGenericName_SHORTEST_LT?: number | null;
  preparationGenericName_SHORTEST_LTE?: number | null;
  sourceTenantId_AVERAGE_EQUAL?: number | null;
  sourceTenantId_AVERAGE_GT?: number | null;
  sourceTenantId_AVERAGE_GTE?: number | null;
  sourceTenantId_AVERAGE_LT?: number | null;
  sourceTenantId_AVERAGE_LTE?: number | null;
  sourceTenantId_EQUAL?: string | null;
  sourceTenantId_GT?: number | null;
  sourceTenantId_GTE?: number | null;
  sourceTenantId_LONGEST_EQUAL?: number | null;
  sourceTenantId_LONGEST_GT?: number | null;
  sourceTenantId_LONGEST_GTE?: number | null;
  sourceTenantId_LONGEST_LT?: number | null;
  sourceTenantId_LONGEST_LTE?: number | null;
  sourceTenantId_LT?: number | null;
  sourceTenantId_LTE?: number | null;
  sourceTenantId_SHORTEST_EQUAL?: number | null;
  sourceTenantId_SHORTEST_GT?: number | null;
  sourceTenantId_SHORTEST_GTE?: number | null;
  sourceTenantId_SHORTEST_LT?: number | null;
  sourceTenantId_SHORTEST_LTE?: number | null;
  submissionDate_EQUAL?: any | null;
  submissionDate_GT?: any | null;
  submissionDate_GTE?: any | null;
  submissionDate_LT?: any | null;
  submissionDate_LTE?: any | null;
  submissionDate_MAX_EQUAL?: any | null;
  submissionDate_MAX_GT?: any | null;
  submissionDate_MAX_GTE?: any | null;
  submissionDate_MAX_LT?: any | null;
  submissionDate_MAX_LTE?: any | null;
  submissionDate_MIN_EQUAL?: any | null;
  submissionDate_MIN_GT?: any | null;
  submissionDate_MIN_GTE?: any | null;
  submissionDate_MIN_LT?: any | null;
  submissionDate_MIN_LTE?: any | null;
  suspensionReason_AVERAGE_EQUAL?: number | null;
  suspensionReason_AVERAGE_GT?: number | null;
  suspensionReason_AVERAGE_GTE?: number | null;
  suspensionReason_AVERAGE_LT?: number | null;
  suspensionReason_AVERAGE_LTE?: number | null;
  suspensionReason_EQUAL?: string | null;
  suspensionReason_GT?: number | null;
  suspensionReason_GTE?: number | null;
  suspensionReason_LONGEST_EQUAL?: number | null;
  suspensionReason_LONGEST_GT?: number | null;
  suspensionReason_LONGEST_GTE?: number | null;
  suspensionReason_LONGEST_LT?: number | null;
  suspensionReason_LONGEST_LTE?: number | null;
  suspensionReason_LT?: number | null;
  suspensionReason_LTE?: number | null;
  suspensionReason_SHORTEST_EQUAL?: number | null;
  suspensionReason_SHORTEST_GT?: number | null;
  suspensionReason_SHORTEST_GTE?: number | null;
  suspensionReason_SHORTEST_LT?: number | null;
  suspensionReason_SHORTEST_LTE?: number | null;
  totalAmount_AVERAGE_EQUAL?: number | null;
  totalAmount_AVERAGE_GT?: number | null;
  totalAmount_AVERAGE_GTE?: number | null;
  totalAmount_AVERAGE_LT?: number | null;
  totalAmount_AVERAGE_LTE?: number | null;
  totalAmount_EQUAL?: number | null;
  totalAmount_GT?: number | null;
  totalAmount_GTE?: number | null;
  totalAmount_LT?: number | null;
  totalAmount_LTE?: number | null;
  totalAmount_MAX_EQUAL?: number | null;
  totalAmount_MAX_GT?: number | null;
  totalAmount_MAX_GTE?: number | null;
  totalAmount_MAX_LT?: number | null;
  totalAmount_MAX_LTE?: number | null;
  totalAmount_MIN_EQUAL?: number | null;
  totalAmount_MIN_GT?: number | null;
  totalAmount_MIN_GTE?: number | null;
  totalAmount_MIN_LT?: number | null;
  totalAmount_MIN_LTE?: number | null;
  totalAmount_SUM_EQUAL?: number | null;
  totalAmount_SUM_GT?: number | null;
  totalAmount_SUM_GTE?: number | null;
  totalAmount_SUM_LT?: number | null;
  totalAmount_SUM_LTE?: number | null;
  unlimited_AVERAGE_EQUAL?: number | null;
  unlimited_AVERAGE_GT?: number | null;
  unlimited_AVERAGE_GTE?: number | null;
  unlimited_AVERAGE_LT?: number | null;
  unlimited_AVERAGE_LTE?: number | null;
  unlimited_EQUAL?: number | null;
  unlimited_GT?: number | null;
  unlimited_GTE?: number | null;
  unlimited_LT?: number | null;
  unlimited_LTE?: number | null;
  unlimited_MAX_EQUAL?: number | null;
  unlimited_MAX_GT?: number | null;
  unlimited_MAX_GTE?: number | null;
  unlimited_MAX_LT?: number | null;
  unlimited_MAX_LTE?: number | null;
  unlimited_MIN_EQUAL?: number | null;
  unlimited_MIN_GT?: number | null;
  unlimited_MIN_GTE?: number | null;
  unlimited_MIN_LT?: number | null;
  unlimited_MIN_LTE?: number | null;
  unlimited_SUM_EQUAL?: number | null;
  unlimited_SUM_GT?: number | null;
  unlimited_SUM_GTE?: number | null;
  unlimited_SUM_LT?: number | null;
  unlimited_SUM_LTE?: number | null;
}

export interface FlexEntityCreatedByAggregateInput {
  AND?: FlexEntityCreatedByAggregateInput[] | null;
  OR?: FlexEntityCreatedByAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: FlexEntityCreatedByNodeAggregationWhereInput | null;
}

export interface FlexEntityCreatedByConnectionWhere {
  AND?: FlexEntityCreatedByConnectionWhere[] | null;
  OR?: FlexEntityCreatedByConnectionWhere[] | null;
  node?: UserWhere | null;
  node_NOT?: UserWhere | null;
}

export interface FlexEntityCreatedByNodeAggregationWhereInput {
  AND?: FlexEntityCreatedByNodeAggregationWhereInput[] | null;
  OR?: FlexEntityCreatedByNodeAggregationWhereInput[] | null;
  deletedOn_EQUAL?: any | null;
  deletedOn_GT?: any | null;
  deletedOn_GTE?: any | null;
  deletedOn_LT?: any | null;
  deletedOn_LTE?: any | null;
  deletedOn_MAX_EQUAL?: any | null;
  deletedOn_MAX_GT?: any | null;
  deletedOn_MAX_GTE?: any | null;
  deletedOn_MAX_LT?: any | null;
  deletedOn_MAX_LTE?: any | null;
  deletedOn_MIN_EQUAL?: any | null;
  deletedOn_MIN_GT?: any | null;
  deletedOn_MIN_GTE?: any | null;
  deletedOn_MIN_LT?: any | null;
  deletedOn_MIN_LTE?: any | null;
  department_AVERAGE_EQUAL?: number | null;
  department_AVERAGE_GT?: number | null;
  department_AVERAGE_GTE?: number | null;
  department_AVERAGE_LT?: number | null;
  department_AVERAGE_LTE?: number | null;
  department_EQUAL?: string | null;
  department_GT?: number | null;
  department_GTE?: number | null;
  department_LONGEST_EQUAL?: number | null;
  department_LONGEST_GT?: number | null;
  department_LONGEST_GTE?: number | null;
  department_LONGEST_LT?: number | null;
  department_LONGEST_LTE?: number | null;
  department_LT?: number | null;
  department_LTE?: number | null;
  department_SHORTEST_EQUAL?: number | null;
  department_SHORTEST_GT?: number | null;
  department_SHORTEST_GTE?: number | null;
  department_SHORTEST_LT?: number | null;
  department_SHORTEST_LTE?: number | null;
  email_AVERAGE_EQUAL?: number | null;
  email_AVERAGE_GT?: number | null;
  email_AVERAGE_GTE?: number | null;
  email_AVERAGE_LT?: number | null;
  email_AVERAGE_LTE?: number | null;
  email_EQUAL?: string | null;
  email_GT?: number | null;
  email_GTE?: number | null;
  email_LONGEST_EQUAL?: number | null;
  email_LONGEST_GT?: number | null;
  email_LONGEST_GTE?: number | null;
  email_LONGEST_LT?: number | null;
  email_LONGEST_LTE?: number | null;
  email_LT?: number | null;
  email_LTE?: number | null;
  email_SHORTEST_EQUAL?: number | null;
  email_SHORTEST_GT?: number | null;
  email_SHORTEST_GTE?: number | null;
  email_SHORTEST_LT?: number | null;
  email_SHORTEST_LTE?: number | null;
  firstName_AVERAGE_EQUAL?: number | null;
  firstName_AVERAGE_GT?: number | null;
  firstName_AVERAGE_GTE?: number | null;
  firstName_AVERAGE_LT?: number | null;
  firstName_AVERAGE_LTE?: number | null;
  firstName_EQUAL?: string | null;
  firstName_GT?: number | null;
  firstName_GTE?: number | null;
  firstName_LONGEST_EQUAL?: number | null;
  firstName_LONGEST_GT?: number | null;
  firstName_LONGEST_GTE?: number | null;
  firstName_LONGEST_LT?: number | null;
  firstName_LONGEST_LTE?: number | null;
  firstName_LT?: number | null;
  firstName_LTE?: number | null;
  firstName_SHORTEST_EQUAL?: number | null;
  firstName_SHORTEST_GT?: number | null;
  firstName_SHORTEST_GTE?: number | null;
  firstName_SHORTEST_LT?: number | null;
  firstName_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  lastName_AVERAGE_EQUAL?: number | null;
  lastName_AVERAGE_GT?: number | null;
  lastName_AVERAGE_GTE?: number | null;
  lastName_AVERAGE_LT?: number | null;
  lastName_AVERAGE_LTE?: number | null;
  lastName_EQUAL?: string | null;
  lastName_GT?: number | null;
  lastName_GTE?: number | null;
  lastName_LONGEST_EQUAL?: number | null;
  lastName_LONGEST_GT?: number | null;
  lastName_LONGEST_GTE?: number | null;
  lastName_LONGEST_LT?: number | null;
  lastName_LONGEST_LTE?: number | null;
  lastName_LT?: number | null;
  lastName_LTE?: number | null;
  lastName_SHORTEST_EQUAL?: number | null;
  lastName_SHORTEST_GT?: number | null;
  lastName_SHORTEST_GTE?: number | null;
  lastName_SHORTEST_LT?: number | null;
  lastName_SHORTEST_LTE?: number | null;
  position_AVERAGE_EQUAL?: number | null;
  position_AVERAGE_GT?: number | null;
  position_AVERAGE_GTE?: number | null;
  position_AVERAGE_LT?: number | null;
  position_AVERAGE_LTE?: number | null;
  position_EQUAL?: string | null;
  position_GT?: number | null;
  position_GTE?: number | null;
  position_LONGEST_EQUAL?: number | null;
  position_LONGEST_GT?: number | null;
  position_LONGEST_GTE?: number | null;
  position_LONGEST_LT?: number | null;
  position_LONGEST_LTE?: number | null;
  position_LT?: number | null;
  position_LTE?: number | null;
  position_SHORTEST_EQUAL?: number | null;
  position_SHORTEST_GT?: number | null;
  position_SHORTEST_GTE?: number | null;
  position_SHORTEST_LT?: number | null;
  position_SHORTEST_LTE?: number | null;
  preferredLanguage_AVERAGE_EQUAL?: number | null;
  preferredLanguage_AVERAGE_GT?: number | null;
  preferredLanguage_AVERAGE_GTE?: number | null;
  preferredLanguage_AVERAGE_LT?: number | null;
  preferredLanguage_AVERAGE_LTE?: number | null;
  preferredLanguage_EQUAL?: string | null;
  preferredLanguage_GT?: number | null;
  preferredLanguage_GTE?: number | null;
  preferredLanguage_LONGEST_EQUAL?: number | null;
  preferredLanguage_LONGEST_GT?: number | null;
  preferredLanguage_LONGEST_GTE?: number | null;
  preferredLanguage_LONGEST_LT?: number | null;
  preferredLanguage_LONGEST_LTE?: number | null;
  preferredLanguage_LT?: number | null;
  preferredLanguage_LTE?: number | null;
  preferredLanguage_SHORTEST_EQUAL?: number | null;
  preferredLanguage_SHORTEST_GT?: number | null;
  preferredLanguage_SHORTEST_GTE?: number | null;
  preferredLanguage_SHORTEST_LT?: number | null;
  preferredLanguage_SHORTEST_LTE?: number | null;
  tenantId_AVERAGE_EQUAL?: number | null;
  tenantId_AVERAGE_GT?: number | null;
  tenantId_AVERAGE_GTE?: number | null;
  tenantId_AVERAGE_LT?: number | null;
  tenantId_AVERAGE_LTE?: number | null;
  tenantId_EQUAL?: string | null;
  tenantId_GT?: number | null;
  tenantId_GTE?: number | null;
  tenantId_LONGEST_EQUAL?: number | null;
  tenantId_LONGEST_GT?: number | null;
  tenantId_LONGEST_GTE?: number | null;
  tenantId_LONGEST_LT?: number | null;
  tenantId_LONGEST_LTE?: number | null;
  tenantId_LT?: number | null;
  tenantId_LTE?: number | null;
  tenantId_SHORTEST_EQUAL?: number | null;
  tenantId_SHORTEST_GT?: number | null;
  tenantId_SHORTEST_GTE?: number | null;
  tenantId_SHORTEST_LT?: number | null;
  tenantId_SHORTEST_LTE?: number | null;
}

export interface FlexEntityEvaluatedByAggregateInput {
  AND?: FlexEntityEvaluatedByAggregateInput[] | null;
  OR?: FlexEntityEvaluatedByAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: FlexEntityEvaluatedByNodeAggregationWhereInput | null;
}

export interface FlexEntityEvaluatedByConnectionWhere {
  AND?: FlexEntityEvaluatedByConnectionWhere[] | null;
  OR?: FlexEntityEvaluatedByConnectionWhere[] | null;
  node?: FlexFinancialDataPointWhere | null;
  node_NOT?: FlexFinancialDataPointWhere | null;
}

export interface FlexEntityEvaluatedByNodeAggregationWhereInput {
  AND?: FlexEntityEvaluatedByNodeAggregationWhereInput[] | null;
  OR?: FlexEntityEvaluatedByNodeAggregationWhereInput[] | null;
  basePrice_AVERAGE_EQUAL?: number | null;
  basePrice_AVERAGE_GT?: number | null;
  basePrice_AVERAGE_GTE?: number | null;
  basePrice_AVERAGE_LT?: number | null;
  basePrice_AVERAGE_LTE?: number | null;
  basePrice_EQUAL?: number | null;
  basePrice_GT?: number | null;
  basePrice_GTE?: number | null;
  basePrice_LT?: number | null;
  basePrice_LTE?: number | null;
  basePrice_MAX_EQUAL?: number | null;
  basePrice_MAX_GT?: number | null;
  basePrice_MAX_GTE?: number | null;
  basePrice_MAX_LT?: number | null;
  basePrice_MAX_LTE?: number | null;
  basePrice_MIN_EQUAL?: number | null;
  basePrice_MIN_GT?: number | null;
  basePrice_MIN_GTE?: number | null;
  basePrice_MIN_LT?: number | null;
  basePrice_MIN_LTE?: number | null;
  basePrice_SUM_EQUAL?: number | null;
  basePrice_SUM_GT?: number | null;
  basePrice_SUM_GTE?: number | null;
  basePrice_SUM_LT?: number | null;
  basePrice_SUM_LTE?: number | null;
  createdOn_EQUAL?: any | null;
  createdOn_GT?: any | null;
  createdOn_GTE?: any | null;
  createdOn_LT?: any | null;
  createdOn_LTE?: any | null;
  createdOn_MAX_EQUAL?: any | null;
  createdOn_MAX_GT?: any | null;
  createdOn_MAX_GTE?: any | null;
  createdOn_MAX_LT?: any | null;
  createdOn_MAX_LTE?: any | null;
  createdOn_MIN_EQUAL?: any | null;
  createdOn_MIN_GT?: any | null;
  createdOn_MIN_GTE?: any | null;
  createdOn_MIN_LT?: any | null;
  createdOn_MIN_LTE?: any | null;
  currencyCode_AVERAGE_EQUAL?: number | null;
  currencyCode_AVERAGE_GT?: number | null;
  currencyCode_AVERAGE_GTE?: number | null;
  currencyCode_AVERAGE_LT?: number | null;
  currencyCode_AVERAGE_LTE?: number | null;
  currencyCode_EQUAL?: string | null;
  currencyCode_GT?: number | null;
  currencyCode_GTE?: number | null;
  currencyCode_LONGEST_EQUAL?: number | null;
  currencyCode_LONGEST_GT?: number | null;
  currencyCode_LONGEST_GTE?: number | null;
  currencyCode_LONGEST_LT?: number | null;
  currencyCode_LONGEST_LTE?: number | null;
  currencyCode_LT?: number | null;
  currencyCode_LTE?: number | null;
  currencyCode_SHORTEST_EQUAL?: number | null;
  currencyCode_SHORTEST_GT?: number | null;
  currencyCode_SHORTEST_GTE?: number | null;
  currencyCode_SHORTEST_LT?: number | null;
  currencyCode_SHORTEST_LTE?: number | null;
  evaluationSnapshot_AVERAGE_EQUAL?: number | null;
  evaluationSnapshot_AVERAGE_GT?: number | null;
  evaluationSnapshot_AVERAGE_GTE?: number | null;
  evaluationSnapshot_AVERAGE_LT?: number | null;
  evaluationSnapshot_AVERAGE_LTE?: number | null;
  evaluationSnapshot_EQUAL?: string | null;
  evaluationSnapshot_GT?: number | null;
  evaluationSnapshot_GTE?: number | null;
  evaluationSnapshot_LONGEST_EQUAL?: number | null;
  evaluationSnapshot_LONGEST_GT?: number | null;
  evaluationSnapshot_LONGEST_GTE?: number | null;
  evaluationSnapshot_LONGEST_LT?: number | null;
  evaluationSnapshot_LONGEST_LTE?: number | null;
  evaluationSnapshot_LT?: number | null;
  evaluationSnapshot_LTE?: number | null;
  evaluationSnapshot_SHORTEST_EQUAL?: number | null;
  evaluationSnapshot_SHORTEST_GT?: number | null;
  evaluationSnapshot_SHORTEST_GTE?: number | null;
  evaluationSnapshot_SHORTEST_LT?: number | null;
  evaluationSnapshot_SHORTEST_LTE?: number | null;
  generatedUuid_EQUAL?: string | null;
  payablePercentage_AVERAGE_EQUAL?: number | null;
  payablePercentage_AVERAGE_GT?: number | null;
  payablePercentage_AVERAGE_GTE?: number | null;
  payablePercentage_AVERAGE_LT?: number | null;
  payablePercentage_AVERAGE_LTE?: number | null;
  payablePercentage_EQUAL?: number | null;
  payablePercentage_GT?: number | null;
  payablePercentage_GTE?: number | null;
  payablePercentage_LT?: number | null;
  payablePercentage_LTE?: number | null;
  payablePercentage_MAX_EQUAL?: number | null;
  payablePercentage_MAX_GT?: number | null;
  payablePercentage_MAX_GTE?: number | null;
  payablePercentage_MAX_LT?: number | null;
  payablePercentage_MAX_LTE?: number | null;
  payablePercentage_MIN_EQUAL?: number | null;
  payablePercentage_MIN_GT?: number | null;
  payablePercentage_MIN_GTE?: number | null;
  payablePercentage_MIN_LT?: number | null;
  payablePercentage_MIN_LTE?: number | null;
  payablePercentage_SUM_EQUAL?: number | null;
  payablePercentage_SUM_GT?: number | null;
  payablePercentage_SUM_GTE?: number | null;
  payablePercentage_SUM_LT?: number | null;
  payablePercentage_SUM_LTE?: number | null;
  payable_AVERAGE_EQUAL?: number | null;
  payable_AVERAGE_GT?: number | null;
  payable_AVERAGE_GTE?: number | null;
  payable_AVERAGE_LT?: number | null;
  payable_AVERAGE_LTE?: number | null;
  payable_EQUAL?: number | null;
  payable_GT?: number | null;
  payable_GTE?: number | null;
  payable_LT?: number | null;
  payable_LTE?: number | null;
  payable_MAX_EQUAL?: number | null;
  payable_MAX_GT?: number | null;
  payable_MAX_GTE?: number | null;
  payable_MAX_LT?: number | null;
  payable_MAX_LTE?: number | null;
  payable_MIN_EQUAL?: number | null;
  payable_MIN_GT?: number | null;
  payable_MIN_GTE?: number | null;
  payable_MIN_LT?: number | null;
  payable_MIN_LTE?: number | null;
  payable_SUM_EQUAL?: number | null;
  payable_SUM_GT?: number | null;
  payable_SUM_GTE?: number | null;
  payable_SUM_LT?: number | null;
  payable_SUM_LTE?: number | null;
  quantity_AVERAGE_EQUAL?: number | null;
  quantity_AVERAGE_GT?: number | null;
  quantity_AVERAGE_GTE?: number | null;
  quantity_AVERAGE_LT?: number | null;
  quantity_AVERAGE_LTE?: number | null;
  quantity_EQUAL?: number | null;
  quantity_GT?: number | null;
  quantity_GTE?: number | null;
  quantity_LT?: number | null;
  quantity_LTE?: number | null;
  quantity_MAX_EQUAL?: number | null;
  quantity_MAX_GT?: number | null;
  quantity_MAX_GTE?: number | null;
  quantity_MAX_LT?: number | null;
  quantity_MAX_LTE?: number | null;
  quantity_MIN_EQUAL?: number | null;
  quantity_MIN_GT?: number | null;
  quantity_MIN_GTE?: number | null;
  quantity_MIN_LT?: number | null;
  quantity_MIN_LTE?: number | null;
  quantity_SUM_EQUAL?: number | null;
  quantity_SUM_GT?: number | null;
  quantity_SUM_GTE?: number | null;
  quantity_SUM_LT?: number | null;
  quantity_SUM_LTE?: number | null;
  refundDeltaNumber_AVERAGE_EQUAL?: number | null;
  refundDeltaNumber_AVERAGE_GT?: number | null;
  refundDeltaNumber_AVERAGE_GTE?: number | null;
  refundDeltaNumber_AVERAGE_LT?: number | null;
  refundDeltaNumber_AVERAGE_LTE?: number | null;
  refundDeltaNumber_EQUAL?: number | null;
  refundDeltaNumber_GT?: number | null;
  refundDeltaNumber_GTE?: number | null;
  refundDeltaNumber_LT?: number | null;
  refundDeltaNumber_LTE?: number | null;
  refundDeltaNumber_MAX_EQUAL?: number | null;
  refundDeltaNumber_MAX_GT?: number | null;
  refundDeltaNumber_MAX_GTE?: number | null;
  refundDeltaNumber_MAX_LT?: number | null;
  refundDeltaNumber_MAX_LTE?: number | null;
  refundDeltaNumber_MIN_EQUAL?: number | null;
  refundDeltaNumber_MIN_GT?: number | null;
  refundDeltaNumber_MIN_GTE?: number | null;
  refundDeltaNumber_MIN_LT?: number | null;
  refundDeltaNumber_MIN_LTE?: number | null;
  refundDeltaNumber_SUM_EQUAL?: number | null;
  refundDeltaNumber_SUM_GT?: number | null;
  refundDeltaNumber_SUM_GTE?: number | null;
  refundDeltaNumber_SUM_LT?: number | null;
  refundDeltaNumber_SUM_LTE?: number | null;
  refundablePercentage_AVERAGE_EQUAL?: number | null;
  refundablePercentage_AVERAGE_GT?: number | null;
  refundablePercentage_AVERAGE_GTE?: number | null;
  refundablePercentage_AVERAGE_LT?: number | null;
  refundablePercentage_AVERAGE_LTE?: number | null;
  refundablePercentage_EQUAL?: number | null;
  refundablePercentage_GT?: number | null;
  refundablePercentage_GTE?: number | null;
  refundablePercentage_LT?: number | null;
  refundablePercentage_LTE?: number | null;
  refundablePercentage_MAX_EQUAL?: number | null;
  refundablePercentage_MAX_GT?: number | null;
  refundablePercentage_MAX_GTE?: number | null;
  refundablePercentage_MAX_LT?: number | null;
  refundablePercentage_MAX_LTE?: number | null;
  refundablePercentage_MIN_EQUAL?: number | null;
  refundablePercentage_MIN_GT?: number | null;
  refundablePercentage_MIN_GTE?: number | null;
  refundablePercentage_MIN_LT?: number | null;
  refundablePercentage_MIN_LTE?: number | null;
  refundablePercentage_SUM_EQUAL?: number | null;
  refundablePercentage_SUM_GT?: number | null;
  refundablePercentage_SUM_GTE?: number | null;
  refundablePercentage_SUM_LT?: number | null;
  refundablePercentage_SUM_LTE?: number | null;
  refundable_AVERAGE_EQUAL?: number | null;
  refundable_AVERAGE_GT?: number | null;
  refundable_AVERAGE_GTE?: number | null;
  refundable_AVERAGE_LT?: number | null;
  refundable_AVERAGE_LTE?: number | null;
  refundable_EQUAL?: number | null;
  refundable_GT?: number | null;
  refundable_GTE?: number | null;
  refundable_LT?: number | null;
  refundable_LTE?: number | null;
  refundable_MAX_EQUAL?: number | null;
  refundable_MAX_GT?: number | null;
  refundable_MAX_GTE?: number | null;
  refundable_MAX_LT?: number | null;
  refundable_MAX_LTE?: number | null;
  refundable_MIN_EQUAL?: number | null;
  refundable_MIN_GT?: number | null;
  refundable_MIN_GTE?: number | null;
  refundable_MIN_LT?: number | null;
  refundable_MIN_LTE?: number | null;
  refundable_SUM_EQUAL?: number | null;
  refundable_SUM_GT?: number | null;
  refundable_SUM_GTE?: number | null;
  refundable_SUM_LT?: number | null;
  refundable_SUM_LTE?: number | null;
  revokedOn_EQUAL?: any | null;
  revokedOn_GT?: any | null;
  revokedOn_GTE?: any | null;
  revokedOn_LT?: any | null;
  revokedOn_LTE?: any | null;
  revokedOn_MAX_EQUAL?: any | null;
  revokedOn_MAX_GT?: any | null;
  revokedOn_MAX_GTE?: any | null;
  revokedOn_MAX_LT?: any | null;
  revokedOn_MAX_LTE?: any | null;
  revokedOn_MIN_EQUAL?: any | null;
  revokedOn_MIN_GT?: any | null;
  revokedOn_MIN_GTE?: any | null;
  revokedOn_MIN_LT?: any | null;
  revokedOn_MIN_LTE?: any | null;
  uuid_EQUAL?: string | null;
  variablePercentage_AVERAGE_EQUAL?: number | null;
  variablePercentage_AVERAGE_GT?: number | null;
  variablePercentage_AVERAGE_GTE?: number | null;
  variablePercentage_AVERAGE_LT?: number | null;
  variablePercentage_AVERAGE_LTE?: number | null;
  variablePercentage_EQUAL?: number | null;
  variablePercentage_GT?: number | null;
  variablePercentage_GTE?: number | null;
  variablePercentage_LT?: number | null;
  variablePercentage_LTE?: number | null;
  variablePercentage_MAX_EQUAL?: number | null;
  variablePercentage_MAX_GT?: number | null;
  variablePercentage_MAX_GTE?: number | null;
  variablePercentage_MAX_LT?: number | null;
  variablePercentage_MAX_LTE?: number | null;
  variablePercentage_MIN_EQUAL?: number | null;
  variablePercentage_MIN_GT?: number | null;
  variablePercentage_MIN_GTE?: number | null;
  variablePercentage_MIN_LT?: number | null;
  variablePercentage_MIN_LTE?: number | null;
  variablePercentage_SUM_EQUAL?: number | null;
  variablePercentage_SUM_GT?: number | null;
  variablePercentage_SUM_GTE?: number | null;
  variablePercentage_SUM_LT?: number | null;
  variablePercentage_SUM_LTE?: number | null;
  variable_AVERAGE_EQUAL?: number | null;
  variable_AVERAGE_GT?: number | null;
  variable_AVERAGE_GTE?: number | null;
  variable_AVERAGE_LT?: number | null;
  variable_AVERAGE_LTE?: number | null;
  variable_EQUAL?: number | null;
  variable_GT?: number | null;
  variable_GTE?: number | null;
  variable_LT?: number | null;
  variable_LTE?: number | null;
  variable_MAX_EQUAL?: number | null;
  variable_MAX_GT?: number | null;
  variable_MAX_GTE?: number | null;
  variable_MAX_LT?: number | null;
  variable_MAX_LTE?: number | null;
  variable_MIN_EQUAL?: number | null;
  variable_MIN_GT?: number | null;
  variable_MIN_GTE?: number | null;
  variable_MIN_LT?: number | null;
  variable_MIN_LTE?: number | null;
  variable_SUM_EQUAL?: number | null;
  variable_SUM_GT?: number | null;
  variable_SUM_GTE?: number | null;
  variable_SUM_LT?: number | null;
  variable_SUM_LTE?: number | null;
}

export interface FlexEntityFinancialDataPointsAggregateInput {
  AND?: FlexEntityFinancialDataPointsAggregateInput[] | null;
  OR?: FlexEntityFinancialDataPointsAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: FlexEntityFinancialDataPointsNodeAggregationWhereInput | null;
}

export interface FlexEntityFinancialDataPointsConnectionWhere {
  AND?: FlexEntityFinancialDataPointsConnectionWhere[] | null;
  OR?: FlexEntityFinancialDataPointsConnectionWhere[] | null;
  node?: FlexFinancialDataPointWhere | null;
  node_NOT?: FlexFinancialDataPointWhere | null;
}

export interface FlexEntityFinancialDataPointsNodeAggregationWhereInput {
  AND?: FlexEntityFinancialDataPointsNodeAggregationWhereInput[] | null;
  OR?: FlexEntityFinancialDataPointsNodeAggregationWhereInput[] | null;
  basePrice_AVERAGE_EQUAL?: number | null;
  basePrice_AVERAGE_GT?: number | null;
  basePrice_AVERAGE_GTE?: number | null;
  basePrice_AVERAGE_LT?: number | null;
  basePrice_AVERAGE_LTE?: number | null;
  basePrice_EQUAL?: number | null;
  basePrice_GT?: number | null;
  basePrice_GTE?: number | null;
  basePrice_LT?: number | null;
  basePrice_LTE?: number | null;
  basePrice_MAX_EQUAL?: number | null;
  basePrice_MAX_GT?: number | null;
  basePrice_MAX_GTE?: number | null;
  basePrice_MAX_LT?: number | null;
  basePrice_MAX_LTE?: number | null;
  basePrice_MIN_EQUAL?: number | null;
  basePrice_MIN_GT?: number | null;
  basePrice_MIN_GTE?: number | null;
  basePrice_MIN_LT?: number | null;
  basePrice_MIN_LTE?: number | null;
  basePrice_SUM_EQUAL?: number | null;
  basePrice_SUM_GT?: number | null;
  basePrice_SUM_GTE?: number | null;
  basePrice_SUM_LT?: number | null;
  basePrice_SUM_LTE?: number | null;
  createdOn_EQUAL?: any | null;
  createdOn_GT?: any | null;
  createdOn_GTE?: any | null;
  createdOn_LT?: any | null;
  createdOn_LTE?: any | null;
  createdOn_MAX_EQUAL?: any | null;
  createdOn_MAX_GT?: any | null;
  createdOn_MAX_GTE?: any | null;
  createdOn_MAX_LT?: any | null;
  createdOn_MAX_LTE?: any | null;
  createdOn_MIN_EQUAL?: any | null;
  createdOn_MIN_GT?: any | null;
  createdOn_MIN_GTE?: any | null;
  createdOn_MIN_LT?: any | null;
  createdOn_MIN_LTE?: any | null;
  currencyCode_AVERAGE_EQUAL?: number | null;
  currencyCode_AVERAGE_GT?: number | null;
  currencyCode_AVERAGE_GTE?: number | null;
  currencyCode_AVERAGE_LT?: number | null;
  currencyCode_AVERAGE_LTE?: number | null;
  currencyCode_EQUAL?: string | null;
  currencyCode_GT?: number | null;
  currencyCode_GTE?: number | null;
  currencyCode_LONGEST_EQUAL?: number | null;
  currencyCode_LONGEST_GT?: number | null;
  currencyCode_LONGEST_GTE?: number | null;
  currencyCode_LONGEST_LT?: number | null;
  currencyCode_LONGEST_LTE?: number | null;
  currencyCode_LT?: number | null;
  currencyCode_LTE?: number | null;
  currencyCode_SHORTEST_EQUAL?: number | null;
  currencyCode_SHORTEST_GT?: number | null;
  currencyCode_SHORTEST_GTE?: number | null;
  currencyCode_SHORTEST_LT?: number | null;
  currencyCode_SHORTEST_LTE?: number | null;
  evaluationSnapshot_AVERAGE_EQUAL?: number | null;
  evaluationSnapshot_AVERAGE_GT?: number | null;
  evaluationSnapshot_AVERAGE_GTE?: number | null;
  evaluationSnapshot_AVERAGE_LT?: number | null;
  evaluationSnapshot_AVERAGE_LTE?: number | null;
  evaluationSnapshot_EQUAL?: string | null;
  evaluationSnapshot_GT?: number | null;
  evaluationSnapshot_GTE?: number | null;
  evaluationSnapshot_LONGEST_EQUAL?: number | null;
  evaluationSnapshot_LONGEST_GT?: number | null;
  evaluationSnapshot_LONGEST_GTE?: number | null;
  evaluationSnapshot_LONGEST_LT?: number | null;
  evaluationSnapshot_LONGEST_LTE?: number | null;
  evaluationSnapshot_LT?: number | null;
  evaluationSnapshot_LTE?: number | null;
  evaluationSnapshot_SHORTEST_EQUAL?: number | null;
  evaluationSnapshot_SHORTEST_GT?: number | null;
  evaluationSnapshot_SHORTEST_GTE?: number | null;
  evaluationSnapshot_SHORTEST_LT?: number | null;
  evaluationSnapshot_SHORTEST_LTE?: number | null;
  generatedUuid_EQUAL?: string | null;
  payablePercentage_AVERAGE_EQUAL?: number | null;
  payablePercentage_AVERAGE_GT?: number | null;
  payablePercentage_AVERAGE_GTE?: number | null;
  payablePercentage_AVERAGE_LT?: number | null;
  payablePercentage_AVERAGE_LTE?: number | null;
  payablePercentage_EQUAL?: number | null;
  payablePercentage_GT?: number | null;
  payablePercentage_GTE?: number | null;
  payablePercentage_LT?: number | null;
  payablePercentage_LTE?: number | null;
  payablePercentage_MAX_EQUAL?: number | null;
  payablePercentage_MAX_GT?: number | null;
  payablePercentage_MAX_GTE?: number | null;
  payablePercentage_MAX_LT?: number | null;
  payablePercentage_MAX_LTE?: number | null;
  payablePercentage_MIN_EQUAL?: number | null;
  payablePercentage_MIN_GT?: number | null;
  payablePercentage_MIN_GTE?: number | null;
  payablePercentage_MIN_LT?: number | null;
  payablePercentage_MIN_LTE?: number | null;
  payablePercentage_SUM_EQUAL?: number | null;
  payablePercentage_SUM_GT?: number | null;
  payablePercentage_SUM_GTE?: number | null;
  payablePercentage_SUM_LT?: number | null;
  payablePercentage_SUM_LTE?: number | null;
  payable_AVERAGE_EQUAL?: number | null;
  payable_AVERAGE_GT?: number | null;
  payable_AVERAGE_GTE?: number | null;
  payable_AVERAGE_LT?: number | null;
  payable_AVERAGE_LTE?: number | null;
  payable_EQUAL?: number | null;
  payable_GT?: number | null;
  payable_GTE?: number | null;
  payable_LT?: number | null;
  payable_LTE?: number | null;
  payable_MAX_EQUAL?: number | null;
  payable_MAX_GT?: number | null;
  payable_MAX_GTE?: number | null;
  payable_MAX_LT?: number | null;
  payable_MAX_LTE?: number | null;
  payable_MIN_EQUAL?: number | null;
  payable_MIN_GT?: number | null;
  payable_MIN_GTE?: number | null;
  payable_MIN_LT?: number | null;
  payable_MIN_LTE?: number | null;
  payable_SUM_EQUAL?: number | null;
  payable_SUM_GT?: number | null;
  payable_SUM_GTE?: number | null;
  payable_SUM_LT?: number | null;
  payable_SUM_LTE?: number | null;
  quantity_AVERAGE_EQUAL?: number | null;
  quantity_AVERAGE_GT?: number | null;
  quantity_AVERAGE_GTE?: number | null;
  quantity_AVERAGE_LT?: number | null;
  quantity_AVERAGE_LTE?: number | null;
  quantity_EQUAL?: number | null;
  quantity_GT?: number | null;
  quantity_GTE?: number | null;
  quantity_LT?: number | null;
  quantity_LTE?: number | null;
  quantity_MAX_EQUAL?: number | null;
  quantity_MAX_GT?: number | null;
  quantity_MAX_GTE?: number | null;
  quantity_MAX_LT?: number | null;
  quantity_MAX_LTE?: number | null;
  quantity_MIN_EQUAL?: number | null;
  quantity_MIN_GT?: number | null;
  quantity_MIN_GTE?: number | null;
  quantity_MIN_LT?: number | null;
  quantity_MIN_LTE?: number | null;
  quantity_SUM_EQUAL?: number | null;
  quantity_SUM_GT?: number | null;
  quantity_SUM_GTE?: number | null;
  quantity_SUM_LT?: number | null;
  quantity_SUM_LTE?: number | null;
  refundDeltaNumber_AVERAGE_EQUAL?: number | null;
  refundDeltaNumber_AVERAGE_GT?: number | null;
  refundDeltaNumber_AVERAGE_GTE?: number | null;
  refundDeltaNumber_AVERAGE_LT?: number | null;
  refundDeltaNumber_AVERAGE_LTE?: number | null;
  refundDeltaNumber_EQUAL?: number | null;
  refundDeltaNumber_GT?: number | null;
  refundDeltaNumber_GTE?: number | null;
  refundDeltaNumber_LT?: number | null;
  refundDeltaNumber_LTE?: number | null;
  refundDeltaNumber_MAX_EQUAL?: number | null;
  refundDeltaNumber_MAX_GT?: number | null;
  refundDeltaNumber_MAX_GTE?: number | null;
  refundDeltaNumber_MAX_LT?: number | null;
  refundDeltaNumber_MAX_LTE?: number | null;
  refundDeltaNumber_MIN_EQUAL?: number | null;
  refundDeltaNumber_MIN_GT?: number | null;
  refundDeltaNumber_MIN_GTE?: number | null;
  refundDeltaNumber_MIN_LT?: number | null;
  refundDeltaNumber_MIN_LTE?: number | null;
  refundDeltaNumber_SUM_EQUAL?: number | null;
  refundDeltaNumber_SUM_GT?: number | null;
  refundDeltaNumber_SUM_GTE?: number | null;
  refundDeltaNumber_SUM_LT?: number | null;
  refundDeltaNumber_SUM_LTE?: number | null;
  refundablePercentage_AVERAGE_EQUAL?: number | null;
  refundablePercentage_AVERAGE_GT?: number | null;
  refundablePercentage_AVERAGE_GTE?: number | null;
  refundablePercentage_AVERAGE_LT?: number | null;
  refundablePercentage_AVERAGE_LTE?: number | null;
  refundablePercentage_EQUAL?: number | null;
  refundablePercentage_GT?: number | null;
  refundablePercentage_GTE?: number | null;
  refundablePercentage_LT?: number | null;
  refundablePercentage_LTE?: number | null;
  refundablePercentage_MAX_EQUAL?: number | null;
  refundablePercentage_MAX_GT?: number | null;
  refundablePercentage_MAX_GTE?: number | null;
  refundablePercentage_MAX_LT?: number | null;
  refundablePercentage_MAX_LTE?: number | null;
  refundablePercentage_MIN_EQUAL?: number | null;
  refundablePercentage_MIN_GT?: number | null;
  refundablePercentage_MIN_GTE?: number | null;
  refundablePercentage_MIN_LT?: number | null;
  refundablePercentage_MIN_LTE?: number | null;
  refundablePercentage_SUM_EQUAL?: number | null;
  refundablePercentage_SUM_GT?: number | null;
  refundablePercentage_SUM_GTE?: number | null;
  refundablePercentage_SUM_LT?: number | null;
  refundablePercentage_SUM_LTE?: number | null;
  refundable_AVERAGE_EQUAL?: number | null;
  refundable_AVERAGE_GT?: number | null;
  refundable_AVERAGE_GTE?: number | null;
  refundable_AVERAGE_LT?: number | null;
  refundable_AVERAGE_LTE?: number | null;
  refundable_EQUAL?: number | null;
  refundable_GT?: number | null;
  refundable_GTE?: number | null;
  refundable_LT?: number | null;
  refundable_LTE?: number | null;
  refundable_MAX_EQUAL?: number | null;
  refundable_MAX_GT?: number | null;
  refundable_MAX_GTE?: number | null;
  refundable_MAX_LT?: number | null;
  refundable_MAX_LTE?: number | null;
  refundable_MIN_EQUAL?: number | null;
  refundable_MIN_GT?: number | null;
  refundable_MIN_GTE?: number | null;
  refundable_MIN_LT?: number | null;
  refundable_MIN_LTE?: number | null;
  refundable_SUM_EQUAL?: number | null;
  refundable_SUM_GT?: number | null;
  refundable_SUM_GTE?: number | null;
  refundable_SUM_LT?: number | null;
  refundable_SUM_LTE?: number | null;
  revokedOn_EQUAL?: any | null;
  revokedOn_GT?: any | null;
  revokedOn_GTE?: any | null;
  revokedOn_LT?: any | null;
  revokedOn_LTE?: any | null;
  revokedOn_MAX_EQUAL?: any | null;
  revokedOn_MAX_GT?: any | null;
  revokedOn_MAX_GTE?: any | null;
  revokedOn_MAX_LT?: any | null;
  revokedOn_MAX_LTE?: any | null;
  revokedOn_MIN_EQUAL?: any | null;
  revokedOn_MIN_GT?: any | null;
  revokedOn_MIN_GTE?: any | null;
  revokedOn_MIN_LT?: any | null;
  revokedOn_MIN_LTE?: any | null;
  uuid_EQUAL?: string | null;
  variablePercentage_AVERAGE_EQUAL?: number | null;
  variablePercentage_AVERAGE_GT?: number | null;
  variablePercentage_AVERAGE_GTE?: number | null;
  variablePercentage_AVERAGE_LT?: number | null;
  variablePercentage_AVERAGE_LTE?: number | null;
  variablePercentage_EQUAL?: number | null;
  variablePercentage_GT?: number | null;
  variablePercentage_GTE?: number | null;
  variablePercentage_LT?: number | null;
  variablePercentage_LTE?: number | null;
  variablePercentage_MAX_EQUAL?: number | null;
  variablePercentage_MAX_GT?: number | null;
  variablePercentage_MAX_GTE?: number | null;
  variablePercentage_MAX_LT?: number | null;
  variablePercentage_MAX_LTE?: number | null;
  variablePercentage_MIN_EQUAL?: number | null;
  variablePercentage_MIN_GT?: number | null;
  variablePercentage_MIN_GTE?: number | null;
  variablePercentage_MIN_LT?: number | null;
  variablePercentage_MIN_LTE?: number | null;
  variablePercentage_SUM_EQUAL?: number | null;
  variablePercentage_SUM_GT?: number | null;
  variablePercentage_SUM_GTE?: number | null;
  variablePercentage_SUM_LT?: number | null;
  variablePercentage_SUM_LTE?: number | null;
  variable_AVERAGE_EQUAL?: number | null;
  variable_AVERAGE_GT?: number | null;
  variable_AVERAGE_GTE?: number | null;
  variable_AVERAGE_LT?: number | null;
  variable_AVERAGE_LTE?: number | null;
  variable_EQUAL?: number | null;
  variable_GT?: number | null;
  variable_GTE?: number | null;
  variable_LT?: number | null;
  variable_LTE?: number | null;
  variable_MAX_EQUAL?: number | null;
  variable_MAX_GT?: number | null;
  variable_MAX_GTE?: number | null;
  variable_MAX_LT?: number | null;
  variable_MAX_LTE?: number | null;
  variable_MIN_EQUAL?: number | null;
  variable_MIN_GT?: number | null;
  variable_MIN_GTE?: number | null;
  variable_MIN_LT?: number | null;
  variable_MIN_LTE?: number | null;
  variable_SUM_EQUAL?: number | null;
  variable_SUM_GT?: number | null;
  variable_SUM_GTE?: number | null;
  variable_SUM_LT?: number | null;
  variable_SUM_LTE?: number | null;
}

export interface FlexEntityGenericsAggregateInput {
  AND?: FlexEntityGenericsAggregateInput[] | null;
  OR?: FlexEntityGenericsAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: FlexEntityGenericsNodeAggregationWhereInput | null;
}

export interface FlexEntityGenericsConnectionWhere {
  AND?: FlexEntityGenericsConnectionWhere[] | null;
  OR?: FlexEntityGenericsConnectionWhere[] | null;
  node?: GenericWhere | null;
  node_NOT?: GenericWhere | null;
}

export interface FlexEntityGenericsNodeAggregationWhereInput {
  AND?: FlexEntityGenericsNodeAggregationWhereInput[] | null;
  Name_AVERAGE_EQUAL?: number | null;
  Name_AVERAGE_GT?: number | null;
  Name_AVERAGE_GTE?: number | null;
  Name_AVERAGE_LT?: number | null;
  Name_AVERAGE_LTE?: number | null;
  Name_EQUAL?: string | null;
  Name_GT?: number | null;
  Name_GTE?: number | null;
  Name_LONGEST_EQUAL?: number | null;
  Name_LONGEST_GT?: number | null;
  Name_LONGEST_GTE?: number | null;
  Name_LONGEST_LT?: number | null;
  Name_LONGEST_LTE?: number | null;
  Name_LT?: number | null;
  Name_LTE?: number | null;
  Name_SHORTEST_EQUAL?: number | null;
  Name_SHORTEST_GT?: number | null;
  Name_SHORTEST_GTE?: number | null;
  Name_SHORTEST_LT?: number | null;
  Name_SHORTEST_LTE?: number | null;
  OR?: FlexEntityGenericsNodeAggregationWhereInput[] | null;
  id_EQUAL?: string | null;
}

export interface FlexEntityOptions {
  limit?: number | null;
  offset?: number | null;
  sort?: (FlexEntitySort | null)[] | null;
}

export interface FlexEntityPatientAggregateInput {
  AND?: FlexEntityPatientAggregateInput[] | null;
  OR?: FlexEntityPatientAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: FlexEntityPatientNodeAggregationWhereInput | null;
}

export interface FlexEntityPatientConnectionWhere {
  AND?: FlexEntityPatientConnectionWhere[] | null;
  OR?: FlexEntityPatientConnectionWhere[] | null;
  node?: PatientWhere | null;
  node_NOT?: PatientWhere | null;
}

export interface FlexEntityPatientNodeAggregationWhereInput {
  AND?: FlexEntityPatientNodeAggregationWhereInput[] | null;
  OR?: FlexEntityPatientNodeAggregationWhereInput[] | null;
  id_EQUAL?: string | null;
  initials_AVERAGE_EQUAL?: number | null;
  initials_AVERAGE_GT?: number | null;
  initials_AVERAGE_GTE?: number | null;
  initials_AVERAGE_LT?: number | null;
  initials_AVERAGE_LTE?: number | null;
  initials_EQUAL?: string | null;
  initials_GT?: number | null;
  initials_GTE?: number | null;
  initials_LONGEST_EQUAL?: number | null;
  initials_LONGEST_GT?: number | null;
  initials_LONGEST_GTE?: number | null;
  initials_LONGEST_LT?: number | null;
  initials_LONGEST_LTE?: number | null;
  initials_LT?: number | null;
  initials_LTE?: number | null;
  initials_SHORTEST_EQUAL?: number | null;
  initials_SHORTEST_GT?: number | null;
  initials_SHORTEST_GTE?: number | null;
  initials_SHORTEST_LT?: number | null;
  initials_SHORTEST_LTE?: number | null;
  insuranceId_AVERAGE_EQUAL?: number | null;
  insuranceId_AVERAGE_GT?: number | null;
  insuranceId_AVERAGE_GTE?: number | null;
  insuranceId_AVERAGE_LT?: number | null;
  insuranceId_AVERAGE_LTE?: number | null;
  insuranceId_EQUAL?: string | null;
  insuranceId_GT?: number | null;
  insuranceId_GTE?: number | null;
  insuranceId_LONGEST_EQUAL?: number | null;
  insuranceId_LONGEST_GT?: number | null;
  insuranceId_LONGEST_GTE?: number | null;
  insuranceId_LONGEST_LT?: number | null;
  insuranceId_LONGEST_LTE?: number | null;
  insuranceId_LT?: number | null;
  insuranceId_LTE?: number | null;
  insuranceId_SHORTEST_EQUAL?: number | null;
  insuranceId_SHORTEST_GT?: number | null;
  insuranceId_SHORTEST_GTE?: number | null;
  insuranceId_SHORTEST_LT?: number | null;
  insuranceId_SHORTEST_LTE?: number | null;
  tenantId_AVERAGE_EQUAL?: number | null;
  tenantId_AVERAGE_GT?: number | null;
  tenantId_AVERAGE_GTE?: number | null;
  tenantId_AVERAGE_LT?: number | null;
  tenantId_AVERAGE_LTE?: number | null;
  tenantId_EQUAL?: string | null;
  tenantId_GT?: number | null;
  tenantId_GTE?: number | null;
  tenantId_LONGEST_EQUAL?: number | null;
  tenantId_LONGEST_GT?: number | null;
  tenantId_LONGEST_GTE?: number | null;
  tenantId_LONGEST_LT?: number | null;
  tenantId_LONGEST_LTE?: number | null;
  tenantId_LT?: number | null;
  tenantId_LTE?: number | null;
  tenantId_SHORTEST_EQUAL?: number | null;
  tenantId_SHORTEST_GT?: number | null;
  tenantId_SHORTEST_GTE?: number | null;
  tenantId_SHORTEST_LT?: number | null;
  tenantId_SHORTEST_LTE?: number | null;
  timeStamp_EQUAL?: any | null;
  timeStamp_GT?: any | null;
  timeStamp_GTE?: any | null;
  timeStamp_LT?: any | null;
  timeStamp_LTE?: any | null;
  timeStamp_MAX_EQUAL?: any | null;
  timeStamp_MAX_GT?: any | null;
  timeStamp_MAX_GTE?: any | null;
  timeStamp_MAX_LT?: any | null;
  timeStamp_MAX_LTE?: any | null;
  timeStamp_MIN_EQUAL?: any | null;
  timeStamp_MIN_GT?: any | null;
  timeStamp_MIN_GTE?: any | null;
  timeStamp_MIN_LT?: any | null;
  timeStamp_MIN_LTE?: any | null;
  yearOfBirth_AVERAGE_EQUAL?: number | null;
  yearOfBirth_AVERAGE_GT?: number | null;
  yearOfBirth_AVERAGE_GTE?: number | null;
  yearOfBirth_AVERAGE_LT?: number | null;
  yearOfBirth_AVERAGE_LTE?: number | null;
  yearOfBirth_EQUAL?: number | null;
  yearOfBirth_GT?: number | null;
  yearOfBirth_GTE?: number | null;
  yearOfBirth_LT?: number | null;
  yearOfBirth_LTE?: number | null;
  yearOfBirth_MAX_EQUAL?: number | null;
  yearOfBirth_MAX_GT?: number | null;
  yearOfBirth_MAX_GTE?: number | null;
  yearOfBirth_MAX_LT?: number | null;
  yearOfBirth_MAX_LTE?: number | null;
  yearOfBirth_MIN_EQUAL?: number | null;
  yearOfBirth_MIN_GT?: number | null;
  yearOfBirth_MIN_GTE?: number | null;
  yearOfBirth_MIN_LT?: number | null;
  yearOfBirth_MIN_LTE?: number | null;
  yearOfBirth_SUM_EQUAL?: number | null;
  yearOfBirth_SUM_GT?: number | null;
  yearOfBirth_SUM_GTE?: number | null;
  yearOfBirth_SUM_LT?: number | null;
  yearOfBirth_SUM_LTE?: number | null;
}

export interface FlexEntityPredecessorAggregateInput {
  AND?: FlexEntityPredecessorAggregateInput[] | null;
  OR?: FlexEntityPredecessorAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: FlexEntityPredecessorNodeAggregationWhereInput | null;
}

export interface FlexEntityPredecessorConnectionWhere {
  AND?: FlexEntityPredecessorConnectionWhere[] | null;
  OR?: FlexEntityPredecessorConnectionWhere[] | null;
  node?: FlexEntityWhere | null;
  node_NOT?: FlexEntityWhere | null;
}

export interface FlexEntityPredecessorNodeAggregationWhereInput {
  AND?: FlexEntityPredecessorNodeAggregationWhereInput[] | null;
  OR?: FlexEntityPredecessorNodeAggregationWhereInput[] | null;
  createdByEmail_AVERAGE_EQUAL?: number | null;
  createdByEmail_AVERAGE_GT?: number | null;
  createdByEmail_AVERAGE_GTE?: number | null;
  createdByEmail_AVERAGE_LT?: number | null;
  createdByEmail_AVERAGE_LTE?: number | null;
  createdByEmail_EQUAL?: string | null;
  createdByEmail_GT?: number | null;
  createdByEmail_GTE?: number | null;
  createdByEmail_LONGEST_EQUAL?: number | null;
  createdByEmail_LONGEST_GT?: number | null;
  createdByEmail_LONGEST_GTE?: number | null;
  createdByEmail_LONGEST_LT?: number | null;
  createdByEmail_LONGEST_LTE?: number | null;
  createdByEmail_LT?: number | null;
  createdByEmail_LTE?: number | null;
  createdByEmail_SHORTEST_EQUAL?: number | null;
  createdByEmail_SHORTEST_GT?: number | null;
  createdByEmail_SHORTEST_GTE?: number | null;
  createdByEmail_SHORTEST_LT?: number | null;
  createdByEmail_SHORTEST_LTE?: number | null;
  createdByName_AVERAGE_EQUAL?: number | null;
  createdByName_AVERAGE_GT?: number | null;
  createdByName_AVERAGE_GTE?: number | null;
  createdByName_AVERAGE_LT?: number | null;
  createdByName_AVERAGE_LTE?: number | null;
  createdByName_EQUAL?: string | null;
  createdByName_GT?: number | null;
  createdByName_GTE?: number | null;
  createdByName_LONGEST_EQUAL?: number | null;
  createdByName_LONGEST_GT?: number | null;
  createdByName_LONGEST_GTE?: number | null;
  createdByName_LONGEST_LT?: number | null;
  createdByName_LONGEST_LTE?: number | null;
  createdByName_LT?: number | null;
  createdByName_LTE?: number | null;
  createdByName_SHORTEST_EQUAL?: number | null;
  createdByName_SHORTEST_GT?: number | null;
  createdByName_SHORTEST_GTE?: number | null;
  createdByName_SHORTEST_LT?: number | null;
  createdByName_SHORTEST_LTE?: number | null;
  createdOn_EQUAL?: any | null;
  createdOn_GT?: any | null;
  createdOn_GTE?: any | null;
  createdOn_LT?: any | null;
  createdOn_LTE?: any | null;
  createdOn_MAX_EQUAL?: any | null;
  createdOn_MAX_GT?: any | null;
  createdOn_MAX_GTE?: any | null;
  createdOn_MAX_LT?: any | null;
  createdOn_MAX_LTE?: any | null;
  createdOn_MIN_EQUAL?: any | null;
  createdOn_MIN_GT?: any | null;
  createdOn_MIN_GTE?: any | null;
  createdOn_MIN_LT?: any | null;
  createdOn_MIN_LTE?: any | null;
  dataKeys_AVERAGE_EQUAL?: number | null;
  dataKeys_AVERAGE_GT?: number | null;
  dataKeys_AVERAGE_GTE?: number | null;
  dataKeys_AVERAGE_LT?: number | null;
  dataKeys_AVERAGE_LTE?: number | null;
  dataKeys_EQUAL?: string | null;
  dataKeys_GT?: number | null;
  dataKeys_GTE?: number | null;
  dataKeys_LONGEST_EQUAL?: number | null;
  dataKeys_LONGEST_GT?: number | null;
  dataKeys_LONGEST_GTE?: number | null;
  dataKeys_LONGEST_LT?: number | null;
  dataKeys_LONGEST_LTE?: number | null;
  dataKeys_LT?: number | null;
  dataKeys_LTE?: number | null;
  dataKeys_SHORTEST_EQUAL?: number | null;
  dataKeys_SHORTEST_GT?: number | null;
  dataKeys_SHORTEST_GTE?: number | null;
  dataKeys_SHORTEST_LT?: number | null;
  dataKeys_SHORTEST_LTE?: number | null;
  data_AVERAGE_EQUAL?: number | null;
  data_AVERAGE_GT?: number | null;
  data_AVERAGE_GTE?: number | null;
  data_AVERAGE_LT?: number | null;
  data_AVERAGE_LTE?: number | null;
  data_EQUAL?: string | null;
  data_GT?: number | null;
  data_GTE?: number | null;
  data_LONGEST_EQUAL?: number | null;
  data_LONGEST_GT?: number | null;
  data_LONGEST_GTE?: number | null;
  data_LONGEST_LT?: number | null;
  data_LONGEST_LTE?: number | null;
  data_LT?: number | null;
  data_LTE?: number | null;
  data_SHORTEST_EQUAL?: number | null;
  data_SHORTEST_GT?: number | null;
  data_SHORTEST_GTE?: number | null;
  data_SHORTEST_LT?: number | null;
  data_SHORTEST_LTE?: number | null;
  flexEntityName_AVERAGE_EQUAL?: number | null;
  flexEntityName_AVERAGE_GT?: number | null;
  flexEntityName_AVERAGE_GTE?: number | null;
  flexEntityName_AVERAGE_LT?: number | null;
  flexEntityName_AVERAGE_LTE?: number | null;
  flexEntityName_EQUAL?: string | null;
  flexEntityName_GT?: number | null;
  flexEntityName_GTE?: number | null;
  flexEntityName_LONGEST_EQUAL?: number | null;
  flexEntityName_LONGEST_GT?: number | null;
  flexEntityName_LONGEST_GTE?: number | null;
  flexEntityName_LONGEST_LT?: number | null;
  flexEntityName_LONGEST_LTE?: number | null;
  flexEntityName_LT?: number | null;
  flexEntityName_LTE?: number | null;
  flexEntityName_SHORTEST_EQUAL?: number | null;
  flexEntityName_SHORTEST_GT?: number | null;
  flexEntityName_SHORTEST_GTE?: number | null;
  flexEntityName_SHORTEST_LT?: number | null;
  flexEntityName_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  lastUpdatedOn_EQUAL?: any | null;
  lastUpdatedOn_GT?: any | null;
  lastUpdatedOn_GTE?: any | null;
  lastUpdatedOn_LT?: any | null;
  lastUpdatedOn_LTE?: any | null;
  lastUpdatedOn_MAX_EQUAL?: any | null;
  lastUpdatedOn_MAX_GT?: any | null;
  lastUpdatedOn_MAX_GTE?: any | null;
  lastUpdatedOn_MAX_LT?: any | null;
  lastUpdatedOn_MAX_LTE?: any | null;
  lastUpdatedOn_MIN_EQUAL?: any | null;
  lastUpdatedOn_MIN_GT?: any | null;
  lastUpdatedOn_MIN_GTE?: any | null;
  lastUpdatedOn_MIN_LT?: any | null;
  lastUpdatedOn_MIN_LTE?: any | null;
  patientId_AVERAGE_EQUAL?: number | null;
  patientId_AVERAGE_GT?: number | null;
  patientId_AVERAGE_GTE?: number | null;
  patientId_AVERAGE_LT?: number | null;
  patientId_AVERAGE_LTE?: number | null;
  patientId_EQUAL?: string | null;
  patientId_GT?: number | null;
  patientId_GTE?: number | null;
  patientId_LONGEST_EQUAL?: number | null;
  patientId_LONGEST_GT?: number | null;
  patientId_LONGEST_GTE?: number | null;
  patientId_LONGEST_LT?: number | null;
  patientId_LONGEST_LTE?: number | null;
  patientId_LT?: number | null;
  patientId_LTE?: number | null;
  patientId_SHORTEST_EQUAL?: number | null;
  patientId_SHORTEST_GT?: number | null;
  patientId_SHORTEST_GTE?: number | null;
  patientId_SHORTEST_LT?: number | null;
  patientId_SHORTEST_LTE?: number | null;
  preparationBrandNames_AVERAGE_EQUAL?: number | null;
  preparationBrandNames_AVERAGE_GT?: number | null;
  preparationBrandNames_AVERAGE_GTE?: number | null;
  preparationBrandNames_AVERAGE_LT?: number | null;
  preparationBrandNames_AVERAGE_LTE?: number | null;
  preparationBrandNames_EQUAL?: string | null;
  preparationBrandNames_GT?: number | null;
  preparationBrandNames_GTE?: number | null;
  preparationBrandNames_LONGEST_EQUAL?: number | null;
  preparationBrandNames_LONGEST_GT?: number | null;
  preparationBrandNames_LONGEST_GTE?: number | null;
  preparationBrandNames_LONGEST_LT?: number | null;
  preparationBrandNames_LONGEST_LTE?: number | null;
  preparationBrandNames_LT?: number | null;
  preparationBrandNames_LTE?: number | null;
  preparationBrandNames_SHORTEST_EQUAL?: number | null;
  preparationBrandNames_SHORTEST_GT?: number | null;
  preparationBrandNames_SHORTEST_GTE?: number | null;
  preparationBrandNames_SHORTEST_LT?: number | null;
  preparationBrandNames_SHORTEST_LTE?: number | null;
  preparationGenericNames_AVERAGE_EQUAL?: number | null;
  preparationGenericNames_AVERAGE_GT?: number | null;
  preparationGenericNames_AVERAGE_GTE?: number | null;
  preparationGenericNames_AVERAGE_LT?: number | null;
  preparationGenericNames_AVERAGE_LTE?: number | null;
  preparationGenericNames_EQUAL?: string | null;
  preparationGenericNames_GT?: number | null;
  preparationGenericNames_GTE?: number | null;
  preparationGenericNames_LONGEST_EQUAL?: number | null;
  preparationGenericNames_LONGEST_GT?: number | null;
  preparationGenericNames_LONGEST_GTE?: number | null;
  preparationGenericNames_LONGEST_LT?: number | null;
  preparationGenericNames_LONGEST_LTE?: number | null;
  preparationGenericNames_LT?: number | null;
  preparationGenericNames_LTE?: number | null;
  preparationGenericNames_SHORTEST_EQUAL?: number | null;
  preparationGenericNames_SHORTEST_GT?: number | null;
  preparationGenericNames_SHORTEST_GTE?: number | null;
  preparationGenericNames_SHORTEST_LT?: number | null;
  preparationGenericNames_SHORTEST_LTE?: number | null;
  quantity_AVERAGE_EQUAL?: number | null;
  quantity_AVERAGE_GT?: number | null;
  quantity_AVERAGE_GTE?: number | null;
  quantity_AVERAGE_LT?: number | null;
  quantity_AVERAGE_LTE?: number | null;
  quantity_EQUAL?: number | null;
  quantity_GT?: number | null;
  quantity_GTE?: number | null;
  quantity_LT?: number | null;
  quantity_LTE?: number | null;
  quantity_MAX_EQUAL?: number | null;
  quantity_MAX_GT?: number | null;
  quantity_MAX_GTE?: number | null;
  quantity_MAX_LT?: number | null;
  quantity_MAX_LTE?: number | null;
  quantity_MIN_EQUAL?: number | null;
  quantity_MIN_GT?: number | null;
  quantity_MIN_GTE?: number | null;
  quantity_MIN_LT?: number | null;
  quantity_MIN_LTE?: number | null;
  quantity_SUM_EQUAL?: number | null;
  quantity_SUM_GT?: number | null;
  quantity_SUM_GTE?: number | null;
  quantity_SUM_LT?: number | null;
  quantity_SUM_LTE?: number | null;
  tenantId_AVERAGE_EQUAL?: number | null;
  tenantId_AVERAGE_GT?: number | null;
  tenantId_AVERAGE_GTE?: number | null;
  tenantId_AVERAGE_LT?: number | null;
  tenantId_AVERAGE_LTE?: number | null;
  tenantId_EQUAL?: string | null;
  tenantId_GT?: number | null;
  tenantId_GTE?: number | null;
  tenantId_LONGEST_EQUAL?: number | null;
  tenantId_LONGEST_GT?: number | null;
  tenantId_LONGEST_GTE?: number | null;
  tenantId_LONGEST_LT?: number | null;
  tenantId_LONGEST_LTE?: number | null;
  tenantId_LT?: number | null;
  tenantId_LTE?: number | null;
  tenantId_SHORTEST_EQUAL?: number | null;
  tenantId_SHORTEST_GT?: number | null;
  tenantId_SHORTEST_GTE?: number | null;
  tenantId_SHORTEST_LT?: number | null;
  tenantId_SHORTEST_LTE?: number | null;
  unlimited_AVERAGE_EQUAL?: number | null;
  unlimited_AVERAGE_GT?: number | null;
  unlimited_AVERAGE_GTE?: number | null;
  unlimited_AVERAGE_LT?: number | null;
  unlimited_AVERAGE_LTE?: number | null;
  unlimited_EQUAL?: number | null;
  unlimited_GT?: number | null;
  unlimited_GTE?: number | null;
  unlimited_LT?: number | null;
  unlimited_LTE?: number | null;
  unlimited_MAX_EQUAL?: number | null;
  unlimited_MAX_GT?: number | null;
  unlimited_MAX_GTE?: number | null;
  unlimited_MAX_LT?: number | null;
  unlimited_MAX_LTE?: number | null;
  unlimited_MIN_EQUAL?: number | null;
  unlimited_MIN_GT?: number | null;
  unlimited_MIN_GTE?: number | null;
  unlimited_MIN_LT?: number | null;
  unlimited_MIN_LTE?: number | null;
  unlimited_SUM_EQUAL?: number | null;
  unlimited_SUM_GT?: number | null;
  unlimited_SUM_GTE?: number | null;
  unlimited_SUM_LT?: number | null;
  unlimited_SUM_LTE?: number | null;
  uuid_AVERAGE_EQUAL?: number | null;
  uuid_AVERAGE_GT?: number | null;
  uuid_AVERAGE_GTE?: number | null;
  uuid_AVERAGE_LT?: number | null;
  uuid_AVERAGE_LTE?: number | null;
  uuid_EQUAL?: string | null;
  uuid_GT?: number | null;
  uuid_GTE?: number | null;
  uuid_LONGEST_EQUAL?: number | null;
  uuid_LONGEST_GT?: number | null;
  uuid_LONGEST_GTE?: number | null;
  uuid_LONGEST_LT?: number | null;
  uuid_LONGEST_LTE?: number | null;
  uuid_LT?: number | null;
  uuid_LTE?: number | null;
  uuid_SHORTEST_EQUAL?: number | null;
  uuid_SHORTEST_GT?: number | null;
  uuid_SHORTEST_GTE?: number | null;
  uuid_SHORTEST_LT?: number | null;
  uuid_SHORTEST_LTE?: number | null;
}

/**
 * Fields to sort FlexEntities by. The order in which sorts are applied is not guaranteed when specifying many fields in one FlexEntitySort object.
 */
export interface FlexEntitySort {
  containerType?: SortDirection | null;
  createdByEmail?: SortDirection | null;
  createdByName?: SortDirection | null;
  createdOn?: SortDirection | null;
  data?: SortDirection | null;
  dataKeys?: SortDirection | null;
  date?: SortDirection | null;
  firstPrescriptionDate?: SortDirection | null;
  flexEntityName?: SortDirection | null;
  hasRefunds?: SortDirection | null;
  id?: SortDirection | null;
  invoiceDate?: SortDirection | null;
  isArchived?: SortDirection | null;
  isDeleted?: SortDirection | null;
  isOrphaned?: SortDirection | null;
  isRevoked?: SortDirection | null;
  isUploaded?: SortDirection | null;
  lastUpdatedOn?: SortDirection | null;
  occurrence?: SortDirection | null;
  patientId?: SortDirection | null;
  preparationBrandNames?: SortDirection | null;
  preparationGenericNames?: SortDirection | null;
  quantity?: SortDirection | null;
  rating?: SortDirection | null;
  status?: SortDirection | null;
  tenantId?: SortDirection | null;
  unlimited?: SortDirection | null;
  uuid?: SortDirection | null;
}

export interface FlexEntitySourceAggregateInput {
  AND?: FlexEntitySourceAggregateInput[] | null;
  OR?: FlexEntitySourceAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: FlexEntitySourceNodeAggregationWhereInput | null;
}

export interface FlexEntitySourceConnectionWhere {
  AND?: FlexEntitySourceConnectionWhere[] | null;
  OR?: FlexEntitySourceConnectionWhere[] | null;
  node?: FlexEntityWhere | null;
  node_NOT?: FlexEntityWhere | null;
}

export interface FlexEntitySourceNodeAggregationWhereInput {
  AND?: FlexEntitySourceNodeAggregationWhereInput[] | null;
  OR?: FlexEntitySourceNodeAggregationWhereInput[] | null;
  createdByEmail_AVERAGE_EQUAL?: number | null;
  createdByEmail_AVERAGE_GT?: number | null;
  createdByEmail_AVERAGE_GTE?: number | null;
  createdByEmail_AVERAGE_LT?: number | null;
  createdByEmail_AVERAGE_LTE?: number | null;
  createdByEmail_EQUAL?: string | null;
  createdByEmail_GT?: number | null;
  createdByEmail_GTE?: number | null;
  createdByEmail_LONGEST_EQUAL?: number | null;
  createdByEmail_LONGEST_GT?: number | null;
  createdByEmail_LONGEST_GTE?: number | null;
  createdByEmail_LONGEST_LT?: number | null;
  createdByEmail_LONGEST_LTE?: number | null;
  createdByEmail_LT?: number | null;
  createdByEmail_LTE?: number | null;
  createdByEmail_SHORTEST_EQUAL?: number | null;
  createdByEmail_SHORTEST_GT?: number | null;
  createdByEmail_SHORTEST_GTE?: number | null;
  createdByEmail_SHORTEST_LT?: number | null;
  createdByEmail_SHORTEST_LTE?: number | null;
  createdByName_AVERAGE_EQUAL?: number | null;
  createdByName_AVERAGE_GT?: number | null;
  createdByName_AVERAGE_GTE?: number | null;
  createdByName_AVERAGE_LT?: number | null;
  createdByName_AVERAGE_LTE?: number | null;
  createdByName_EQUAL?: string | null;
  createdByName_GT?: number | null;
  createdByName_GTE?: number | null;
  createdByName_LONGEST_EQUAL?: number | null;
  createdByName_LONGEST_GT?: number | null;
  createdByName_LONGEST_GTE?: number | null;
  createdByName_LONGEST_LT?: number | null;
  createdByName_LONGEST_LTE?: number | null;
  createdByName_LT?: number | null;
  createdByName_LTE?: number | null;
  createdByName_SHORTEST_EQUAL?: number | null;
  createdByName_SHORTEST_GT?: number | null;
  createdByName_SHORTEST_GTE?: number | null;
  createdByName_SHORTEST_LT?: number | null;
  createdByName_SHORTEST_LTE?: number | null;
  createdOn_EQUAL?: any | null;
  createdOn_GT?: any | null;
  createdOn_GTE?: any | null;
  createdOn_LT?: any | null;
  createdOn_LTE?: any | null;
  createdOn_MAX_EQUAL?: any | null;
  createdOn_MAX_GT?: any | null;
  createdOn_MAX_GTE?: any | null;
  createdOn_MAX_LT?: any | null;
  createdOn_MAX_LTE?: any | null;
  createdOn_MIN_EQUAL?: any | null;
  createdOn_MIN_GT?: any | null;
  createdOn_MIN_GTE?: any | null;
  createdOn_MIN_LT?: any | null;
  createdOn_MIN_LTE?: any | null;
  dataKeys_AVERAGE_EQUAL?: number | null;
  dataKeys_AVERAGE_GT?: number | null;
  dataKeys_AVERAGE_GTE?: number | null;
  dataKeys_AVERAGE_LT?: number | null;
  dataKeys_AVERAGE_LTE?: number | null;
  dataKeys_EQUAL?: string | null;
  dataKeys_GT?: number | null;
  dataKeys_GTE?: number | null;
  dataKeys_LONGEST_EQUAL?: number | null;
  dataKeys_LONGEST_GT?: number | null;
  dataKeys_LONGEST_GTE?: number | null;
  dataKeys_LONGEST_LT?: number | null;
  dataKeys_LONGEST_LTE?: number | null;
  dataKeys_LT?: number | null;
  dataKeys_LTE?: number | null;
  dataKeys_SHORTEST_EQUAL?: number | null;
  dataKeys_SHORTEST_GT?: number | null;
  dataKeys_SHORTEST_GTE?: number | null;
  dataKeys_SHORTEST_LT?: number | null;
  dataKeys_SHORTEST_LTE?: number | null;
  data_AVERAGE_EQUAL?: number | null;
  data_AVERAGE_GT?: number | null;
  data_AVERAGE_GTE?: number | null;
  data_AVERAGE_LT?: number | null;
  data_AVERAGE_LTE?: number | null;
  data_EQUAL?: string | null;
  data_GT?: number | null;
  data_GTE?: number | null;
  data_LONGEST_EQUAL?: number | null;
  data_LONGEST_GT?: number | null;
  data_LONGEST_GTE?: number | null;
  data_LONGEST_LT?: number | null;
  data_LONGEST_LTE?: number | null;
  data_LT?: number | null;
  data_LTE?: number | null;
  data_SHORTEST_EQUAL?: number | null;
  data_SHORTEST_GT?: number | null;
  data_SHORTEST_GTE?: number | null;
  data_SHORTEST_LT?: number | null;
  data_SHORTEST_LTE?: number | null;
  flexEntityName_AVERAGE_EQUAL?: number | null;
  flexEntityName_AVERAGE_GT?: number | null;
  flexEntityName_AVERAGE_GTE?: number | null;
  flexEntityName_AVERAGE_LT?: number | null;
  flexEntityName_AVERAGE_LTE?: number | null;
  flexEntityName_EQUAL?: string | null;
  flexEntityName_GT?: number | null;
  flexEntityName_GTE?: number | null;
  flexEntityName_LONGEST_EQUAL?: number | null;
  flexEntityName_LONGEST_GT?: number | null;
  flexEntityName_LONGEST_GTE?: number | null;
  flexEntityName_LONGEST_LT?: number | null;
  flexEntityName_LONGEST_LTE?: number | null;
  flexEntityName_LT?: number | null;
  flexEntityName_LTE?: number | null;
  flexEntityName_SHORTEST_EQUAL?: number | null;
  flexEntityName_SHORTEST_GT?: number | null;
  flexEntityName_SHORTEST_GTE?: number | null;
  flexEntityName_SHORTEST_LT?: number | null;
  flexEntityName_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  lastUpdatedOn_EQUAL?: any | null;
  lastUpdatedOn_GT?: any | null;
  lastUpdatedOn_GTE?: any | null;
  lastUpdatedOn_LT?: any | null;
  lastUpdatedOn_LTE?: any | null;
  lastUpdatedOn_MAX_EQUAL?: any | null;
  lastUpdatedOn_MAX_GT?: any | null;
  lastUpdatedOn_MAX_GTE?: any | null;
  lastUpdatedOn_MAX_LT?: any | null;
  lastUpdatedOn_MAX_LTE?: any | null;
  lastUpdatedOn_MIN_EQUAL?: any | null;
  lastUpdatedOn_MIN_GT?: any | null;
  lastUpdatedOn_MIN_GTE?: any | null;
  lastUpdatedOn_MIN_LT?: any | null;
  lastUpdatedOn_MIN_LTE?: any | null;
  patientId_AVERAGE_EQUAL?: number | null;
  patientId_AVERAGE_GT?: number | null;
  patientId_AVERAGE_GTE?: number | null;
  patientId_AVERAGE_LT?: number | null;
  patientId_AVERAGE_LTE?: number | null;
  patientId_EQUAL?: string | null;
  patientId_GT?: number | null;
  patientId_GTE?: number | null;
  patientId_LONGEST_EQUAL?: number | null;
  patientId_LONGEST_GT?: number | null;
  patientId_LONGEST_GTE?: number | null;
  patientId_LONGEST_LT?: number | null;
  patientId_LONGEST_LTE?: number | null;
  patientId_LT?: number | null;
  patientId_LTE?: number | null;
  patientId_SHORTEST_EQUAL?: number | null;
  patientId_SHORTEST_GT?: number | null;
  patientId_SHORTEST_GTE?: number | null;
  patientId_SHORTEST_LT?: number | null;
  patientId_SHORTEST_LTE?: number | null;
  preparationBrandNames_AVERAGE_EQUAL?: number | null;
  preparationBrandNames_AVERAGE_GT?: number | null;
  preparationBrandNames_AVERAGE_GTE?: number | null;
  preparationBrandNames_AVERAGE_LT?: number | null;
  preparationBrandNames_AVERAGE_LTE?: number | null;
  preparationBrandNames_EQUAL?: string | null;
  preparationBrandNames_GT?: number | null;
  preparationBrandNames_GTE?: number | null;
  preparationBrandNames_LONGEST_EQUAL?: number | null;
  preparationBrandNames_LONGEST_GT?: number | null;
  preparationBrandNames_LONGEST_GTE?: number | null;
  preparationBrandNames_LONGEST_LT?: number | null;
  preparationBrandNames_LONGEST_LTE?: number | null;
  preparationBrandNames_LT?: number | null;
  preparationBrandNames_LTE?: number | null;
  preparationBrandNames_SHORTEST_EQUAL?: number | null;
  preparationBrandNames_SHORTEST_GT?: number | null;
  preparationBrandNames_SHORTEST_GTE?: number | null;
  preparationBrandNames_SHORTEST_LT?: number | null;
  preparationBrandNames_SHORTEST_LTE?: number | null;
  preparationGenericNames_AVERAGE_EQUAL?: number | null;
  preparationGenericNames_AVERAGE_GT?: number | null;
  preparationGenericNames_AVERAGE_GTE?: number | null;
  preparationGenericNames_AVERAGE_LT?: number | null;
  preparationGenericNames_AVERAGE_LTE?: number | null;
  preparationGenericNames_EQUAL?: string | null;
  preparationGenericNames_GT?: number | null;
  preparationGenericNames_GTE?: number | null;
  preparationGenericNames_LONGEST_EQUAL?: number | null;
  preparationGenericNames_LONGEST_GT?: number | null;
  preparationGenericNames_LONGEST_GTE?: number | null;
  preparationGenericNames_LONGEST_LT?: number | null;
  preparationGenericNames_LONGEST_LTE?: number | null;
  preparationGenericNames_LT?: number | null;
  preparationGenericNames_LTE?: number | null;
  preparationGenericNames_SHORTEST_EQUAL?: number | null;
  preparationGenericNames_SHORTEST_GT?: number | null;
  preparationGenericNames_SHORTEST_GTE?: number | null;
  preparationGenericNames_SHORTEST_LT?: number | null;
  preparationGenericNames_SHORTEST_LTE?: number | null;
  quantity_AVERAGE_EQUAL?: number | null;
  quantity_AVERAGE_GT?: number | null;
  quantity_AVERAGE_GTE?: number | null;
  quantity_AVERAGE_LT?: number | null;
  quantity_AVERAGE_LTE?: number | null;
  quantity_EQUAL?: number | null;
  quantity_GT?: number | null;
  quantity_GTE?: number | null;
  quantity_LT?: number | null;
  quantity_LTE?: number | null;
  quantity_MAX_EQUAL?: number | null;
  quantity_MAX_GT?: number | null;
  quantity_MAX_GTE?: number | null;
  quantity_MAX_LT?: number | null;
  quantity_MAX_LTE?: number | null;
  quantity_MIN_EQUAL?: number | null;
  quantity_MIN_GT?: number | null;
  quantity_MIN_GTE?: number | null;
  quantity_MIN_LT?: number | null;
  quantity_MIN_LTE?: number | null;
  quantity_SUM_EQUAL?: number | null;
  quantity_SUM_GT?: number | null;
  quantity_SUM_GTE?: number | null;
  quantity_SUM_LT?: number | null;
  quantity_SUM_LTE?: number | null;
  tenantId_AVERAGE_EQUAL?: number | null;
  tenantId_AVERAGE_GT?: number | null;
  tenantId_AVERAGE_GTE?: number | null;
  tenantId_AVERAGE_LT?: number | null;
  tenantId_AVERAGE_LTE?: number | null;
  tenantId_EQUAL?: string | null;
  tenantId_GT?: number | null;
  tenantId_GTE?: number | null;
  tenantId_LONGEST_EQUAL?: number | null;
  tenantId_LONGEST_GT?: number | null;
  tenantId_LONGEST_GTE?: number | null;
  tenantId_LONGEST_LT?: number | null;
  tenantId_LONGEST_LTE?: number | null;
  tenantId_LT?: number | null;
  tenantId_LTE?: number | null;
  tenantId_SHORTEST_EQUAL?: number | null;
  tenantId_SHORTEST_GT?: number | null;
  tenantId_SHORTEST_GTE?: number | null;
  tenantId_SHORTEST_LT?: number | null;
  tenantId_SHORTEST_LTE?: number | null;
  unlimited_AVERAGE_EQUAL?: number | null;
  unlimited_AVERAGE_GT?: number | null;
  unlimited_AVERAGE_GTE?: number | null;
  unlimited_AVERAGE_LT?: number | null;
  unlimited_AVERAGE_LTE?: number | null;
  unlimited_EQUAL?: number | null;
  unlimited_GT?: number | null;
  unlimited_GTE?: number | null;
  unlimited_LT?: number | null;
  unlimited_LTE?: number | null;
  unlimited_MAX_EQUAL?: number | null;
  unlimited_MAX_GT?: number | null;
  unlimited_MAX_GTE?: number | null;
  unlimited_MAX_LT?: number | null;
  unlimited_MAX_LTE?: number | null;
  unlimited_MIN_EQUAL?: number | null;
  unlimited_MIN_GT?: number | null;
  unlimited_MIN_GTE?: number | null;
  unlimited_MIN_LT?: number | null;
  unlimited_MIN_LTE?: number | null;
  unlimited_SUM_EQUAL?: number | null;
  unlimited_SUM_GT?: number | null;
  unlimited_SUM_GTE?: number | null;
  unlimited_SUM_LT?: number | null;
  unlimited_SUM_LTE?: number | null;
  uuid_AVERAGE_EQUAL?: number | null;
  uuid_AVERAGE_GT?: number | null;
  uuid_AVERAGE_GTE?: number | null;
  uuid_AVERAGE_LT?: number | null;
  uuid_AVERAGE_LTE?: number | null;
  uuid_EQUAL?: string | null;
  uuid_GT?: number | null;
  uuid_GTE?: number | null;
  uuid_LONGEST_EQUAL?: number | null;
  uuid_LONGEST_GT?: number | null;
  uuid_LONGEST_GTE?: number | null;
  uuid_LONGEST_LT?: number | null;
  uuid_LONGEST_LTE?: number | null;
  uuid_LT?: number | null;
  uuid_LTE?: number | null;
  uuid_SHORTEST_EQUAL?: number | null;
  uuid_SHORTEST_GT?: number | null;
  uuid_SHORTEST_GTE?: number | null;
  uuid_SHORTEST_LT?: number | null;
  uuid_SHORTEST_LTE?: number | null;
}

export interface FlexEntitySourcedAggregateInput {
  AND?: FlexEntitySourcedAggregateInput[] | null;
  OR?: FlexEntitySourcedAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: FlexEntitySourcedNodeAggregationWhereInput | null;
}

export interface FlexEntitySourcedConnectionWhere {
  AND?: FlexEntitySourcedConnectionWhere[] | null;
  OR?: FlexEntitySourcedConnectionWhere[] | null;
  node?: FlexEntityWhere | null;
  node_NOT?: FlexEntityWhere | null;
}

export interface FlexEntitySourcedNodeAggregationWhereInput {
  AND?: FlexEntitySourcedNodeAggregationWhereInput[] | null;
  OR?: FlexEntitySourcedNodeAggregationWhereInput[] | null;
  createdByEmail_AVERAGE_EQUAL?: number | null;
  createdByEmail_AVERAGE_GT?: number | null;
  createdByEmail_AVERAGE_GTE?: number | null;
  createdByEmail_AVERAGE_LT?: number | null;
  createdByEmail_AVERAGE_LTE?: number | null;
  createdByEmail_EQUAL?: string | null;
  createdByEmail_GT?: number | null;
  createdByEmail_GTE?: number | null;
  createdByEmail_LONGEST_EQUAL?: number | null;
  createdByEmail_LONGEST_GT?: number | null;
  createdByEmail_LONGEST_GTE?: number | null;
  createdByEmail_LONGEST_LT?: number | null;
  createdByEmail_LONGEST_LTE?: number | null;
  createdByEmail_LT?: number | null;
  createdByEmail_LTE?: number | null;
  createdByEmail_SHORTEST_EQUAL?: number | null;
  createdByEmail_SHORTEST_GT?: number | null;
  createdByEmail_SHORTEST_GTE?: number | null;
  createdByEmail_SHORTEST_LT?: number | null;
  createdByEmail_SHORTEST_LTE?: number | null;
  createdByName_AVERAGE_EQUAL?: number | null;
  createdByName_AVERAGE_GT?: number | null;
  createdByName_AVERAGE_GTE?: number | null;
  createdByName_AVERAGE_LT?: number | null;
  createdByName_AVERAGE_LTE?: number | null;
  createdByName_EQUAL?: string | null;
  createdByName_GT?: number | null;
  createdByName_GTE?: number | null;
  createdByName_LONGEST_EQUAL?: number | null;
  createdByName_LONGEST_GT?: number | null;
  createdByName_LONGEST_GTE?: number | null;
  createdByName_LONGEST_LT?: number | null;
  createdByName_LONGEST_LTE?: number | null;
  createdByName_LT?: number | null;
  createdByName_LTE?: number | null;
  createdByName_SHORTEST_EQUAL?: number | null;
  createdByName_SHORTEST_GT?: number | null;
  createdByName_SHORTEST_GTE?: number | null;
  createdByName_SHORTEST_LT?: number | null;
  createdByName_SHORTEST_LTE?: number | null;
  createdOn_EQUAL?: any | null;
  createdOn_GT?: any | null;
  createdOn_GTE?: any | null;
  createdOn_LT?: any | null;
  createdOn_LTE?: any | null;
  createdOn_MAX_EQUAL?: any | null;
  createdOn_MAX_GT?: any | null;
  createdOn_MAX_GTE?: any | null;
  createdOn_MAX_LT?: any | null;
  createdOn_MAX_LTE?: any | null;
  createdOn_MIN_EQUAL?: any | null;
  createdOn_MIN_GT?: any | null;
  createdOn_MIN_GTE?: any | null;
  createdOn_MIN_LT?: any | null;
  createdOn_MIN_LTE?: any | null;
  dataKeys_AVERAGE_EQUAL?: number | null;
  dataKeys_AVERAGE_GT?: number | null;
  dataKeys_AVERAGE_GTE?: number | null;
  dataKeys_AVERAGE_LT?: number | null;
  dataKeys_AVERAGE_LTE?: number | null;
  dataKeys_EQUAL?: string | null;
  dataKeys_GT?: number | null;
  dataKeys_GTE?: number | null;
  dataKeys_LONGEST_EQUAL?: number | null;
  dataKeys_LONGEST_GT?: number | null;
  dataKeys_LONGEST_GTE?: number | null;
  dataKeys_LONGEST_LT?: number | null;
  dataKeys_LONGEST_LTE?: number | null;
  dataKeys_LT?: number | null;
  dataKeys_LTE?: number | null;
  dataKeys_SHORTEST_EQUAL?: number | null;
  dataKeys_SHORTEST_GT?: number | null;
  dataKeys_SHORTEST_GTE?: number | null;
  dataKeys_SHORTEST_LT?: number | null;
  dataKeys_SHORTEST_LTE?: number | null;
  data_AVERAGE_EQUAL?: number | null;
  data_AVERAGE_GT?: number | null;
  data_AVERAGE_GTE?: number | null;
  data_AVERAGE_LT?: number | null;
  data_AVERAGE_LTE?: number | null;
  data_EQUAL?: string | null;
  data_GT?: number | null;
  data_GTE?: number | null;
  data_LONGEST_EQUAL?: number | null;
  data_LONGEST_GT?: number | null;
  data_LONGEST_GTE?: number | null;
  data_LONGEST_LT?: number | null;
  data_LONGEST_LTE?: number | null;
  data_LT?: number | null;
  data_LTE?: number | null;
  data_SHORTEST_EQUAL?: number | null;
  data_SHORTEST_GT?: number | null;
  data_SHORTEST_GTE?: number | null;
  data_SHORTEST_LT?: number | null;
  data_SHORTEST_LTE?: number | null;
  flexEntityName_AVERAGE_EQUAL?: number | null;
  flexEntityName_AVERAGE_GT?: number | null;
  flexEntityName_AVERAGE_GTE?: number | null;
  flexEntityName_AVERAGE_LT?: number | null;
  flexEntityName_AVERAGE_LTE?: number | null;
  flexEntityName_EQUAL?: string | null;
  flexEntityName_GT?: number | null;
  flexEntityName_GTE?: number | null;
  flexEntityName_LONGEST_EQUAL?: number | null;
  flexEntityName_LONGEST_GT?: number | null;
  flexEntityName_LONGEST_GTE?: number | null;
  flexEntityName_LONGEST_LT?: number | null;
  flexEntityName_LONGEST_LTE?: number | null;
  flexEntityName_LT?: number | null;
  flexEntityName_LTE?: number | null;
  flexEntityName_SHORTEST_EQUAL?: number | null;
  flexEntityName_SHORTEST_GT?: number | null;
  flexEntityName_SHORTEST_GTE?: number | null;
  flexEntityName_SHORTEST_LT?: number | null;
  flexEntityName_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  lastUpdatedOn_EQUAL?: any | null;
  lastUpdatedOn_GT?: any | null;
  lastUpdatedOn_GTE?: any | null;
  lastUpdatedOn_LT?: any | null;
  lastUpdatedOn_LTE?: any | null;
  lastUpdatedOn_MAX_EQUAL?: any | null;
  lastUpdatedOn_MAX_GT?: any | null;
  lastUpdatedOn_MAX_GTE?: any | null;
  lastUpdatedOn_MAX_LT?: any | null;
  lastUpdatedOn_MAX_LTE?: any | null;
  lastUpdatedOn_MIN_EQUAL?: any | null;
  lastUpdatedOn_MIN_GT?: any | null;
  lastUpdatedOn_MIN_GTE?: any | null;
  lastUpdatedOn_MIN_LT?: any | null;
  lastUpdatedOn_MIN_LTE?: any | null;
  patientId_AVERAGE_EQUAL?: number | null;
  patientId_AVERAGE_GT?: number | null;
  patientId_AVERAGE_GTE?: number | null;
  patientId_AVERAGE_LT?: number | null;
  patientId_AVERAGE_LTE?: number | null;
  patientId_EQUAL?: string | null;
  patientId_GT?: number | null;
  patientId_GTE?: number | null;
  patientId_LONGEST_EQUAL?: number | null;
  patientId_LONGEST_GT?: number | null;
  patientId_LONGEST_GTE?: number | null;
  patientId_LONGEST_LT?: number | null;
  patientId_LONGEST_LTE?: number | null;
  patientId_LT?: number | null;
  patientId_LTE?: number | null;
  patientId_SHORTEST_EQUAL?: number | null;
  patientId_SHORTEST_GT?: number | null;
  patientId_SHORTEST_GTE?: number | null;
  patientId_SHORTEST_LT?: number | null;
  patientId_SHORTEST_LTE?: number | null;
  preparationBrandNames_AVERAGE_EQUAL?: number | null;
  preparationBrandNames_AVERAGE_GT?: number | null;
  preparationBrandNames_AVERAGE_GTE?: number | null;
  preparationBrandNames_AVERAGE_LT?: number | null;
  preparationBrandNames_AVERAGE_LTE?: number | null;
  preparationBrandNames_EQUAL?: string | null;
  preparationBrandNames_GT?: number | null;
  preparationBrandNames_GTE?: number | null;
  preparationBrandNames_LONGEST_EQUAL?: number | null;
  preparationBrandNames_LONGEST_GT?: number | null;
  preparationBrandNames_LONGEST_GTE?: number | null;
  preparationBrandNames_LONGEST_LT?: number | null;
  preparationBrandNames_LONGEST_LTE?: number | null;
  preparationBrandNames_LT?: number | null;
  preparationBrandNames_LTE?: number | null;
  preparationBrandNames_SHORTEST_EQUAL?: number | null;
  preparationBrandNames_SHORTEST_GT?: number | null;
  preparationBrandNames_SHORTEST_GTE?: number | null;
  preparationBrandNames_SHORTEST_LT?: number | null;
  preparationBrandNames_SHORTEST_LTE?: number | null;
  preparationGenericNames_AVERAGE_EQUAL?: number | null;
  preparationGenericNames_AVERAGE_GT?: number | null;
  preparationGenericNames_AVERAGE_GTE?: number | null;
  preparationGenericNames_AVERAGE_LT?: number | null;
  preparationGenericNames_AVERAGE_LTE?: number | null;
  preparationGenericNames_EQUAL?: string | null;
  preparationGenericNames_GT?: number | null;
  preparationGenericNames_GTE?: number | null;
  preparationGenericNames_LONGEST_EQUAL?: number | null;
  preparationGenericNames_LONGEST_GT?: number | null;
  preparationGenericNames_LONGEST_GTE?: number | null;
  preparationGenericNames_LONGEST_LT?: number | null;
  preparationGenericNames_LONGEST_LTE?: number | null;
  preparationGenericNames_LT?: number | null;
  preparationGenericNames_LTE?: number | null;
  preparationGenericNames_SHORTEST_EQUAL?: number | null;
  preparationGenericNames_SHORTEST_GT?: number | null;
  preparationGenericNames_SHORTEST_GTE?: number | null;
  preparationGenericNames_SHORTEST_LT?: number | null;
  preparationGenericNames_SHORTEST_LTE?: number | null;
  quantity_AVERAGE_EQUAL?: number | null;
  quantity_AVERAGE_GT?: number | null;
  quantity_AVERAGE_GTE?: number | null;
  quantity_AVERAGE_LT?: number | null;
  quantity_AVERAGE_LTE?: number | null;
  quantity_EQUAL?: number | null;
  quantity_GT?: number | null;
  quantity_GTE?: number | null;
  quantity_LT?: number | null;
  quantity_LTE?: number | null;
  quantity_MAX_EQUAL?: number | null;
  quantity_MAX_GT?: number | null;
  quantity_MAX_GTE?: number | null;
  quantity_MAX_LT?: number | null;
  quantity_MAX_LTE?: number | null;
  quantity_MIN_EQUAL?: number | null;
  quantity_MIN_GT?: number | null;
  quantity_MIN_GTE?: number | null;
  quantity_MIN_LT?: number | null;
  quantity_MIN_LTE?: number | null;
  quantity_SUM_EQUAL?: number | null;
  quantity_SUM_GT?: number | null;
  quantity_SUM_GTE?: number | null;
  quantity_SUM_LT?: number | null;
  quantity_SUM_LTE?: number | null;
  tenantId_AVERAGE_EQUAL?: number | null;
  tenantId_AVERAGE_GT?: number | null;
  tenantId_AVERAGE_GTE?: number | null;
  tenantId_AVERAGE_LT?: number | null;
  tenantId_AVERAGE_LTE?: number | null;
  tenantId_EQUAL?: string | null;
  tenantId_GT?: number | null;
  tenantId_GTE?: number | null;
  tenantId_LONGEST_EQUAL?: number | null;
  tenantId_LONGEST_GT?: number | null;
  tenantId_LONGEST_GTE?: number | null;
  tenantId_LONGEST_LT?: number | null;
  tenantId_LONGEST_LTE?: number | null;
  tenantId_LT?: number | null;
  tenantId_LTE?: number | null;
  tenantId_SHORTEST_EQUAL?: number | null;
  tenantId_SHORTEST_GT?: number | null;
  tenantId_SHORTEST_GTE?: number | null;
  tenantId_SHORTEST_LT?: number | null;
  tenantId_SHORTEST_LTE?: number | null;
  unlimited_AVERAGE_EQUAL?: number | null;
  unlimited_AVERAGE_GT?: number | null;
  unlimited_AVERAGE_GTE?: number | null;
  unlimited_AVERAGE_LT?: number | null;
  unlimited_AVERAGE_LTE?: number | null;
  unlimited_EQUAL?: number | null;
  unlimited_GT?: number | null;
  unlimited_GTE?: number | null;
  unlimited_LT?: number | null;
  unlimited_LTE?: number | null;
  unlimited_MAX_EQUAL?: number | null;
  unlimited_MAX_GT?: number | null;
  unlimited_MAX_GTE?: number | null;
  unlimited_MAX_LT?: number | null;
  unlimited_MAX_LTE?: number | null;
  unlimited_MIN_EQUAL?: number | null;
  unlimited_MIN_GT?: number | null;
  unlimited_MIN_GTE?: number | null;
  unlimited_MIN_LT?: number | null;
  unlimited_MIN_LTE?: number | null;
  unlimited_SUM_EQUAL?: number | null;
  unlimited_SUM_GT?: number | null;
  unlimited_SUM_GTE?: number | null;
  unlimited_SUM_LT?: number | null;
  unlimited_SUM_LTE?: number | null;
  uuid_AVERAGE_EQUAL?: number | null;
  uuid_AVERAGE_GT?: number | null;
  uuid_AVERAGE_GTE?: number | null;
  uuid_AVERAGE_LT?: number | null;
  uuid_AVERAGE_LTE?: number | null;
  uuid_EQUAL?: string | null;
  uuid_GT?: number | null;
  uuid_GTE?: number | null;
  uuid_LONGEST_EQUAL?: number | null;
  uuid_LONGEST_GT?: number | null;
  uuid_LONGEST_GTE?: number | null;
  uuid_LONGEST_LT?: number | null;
  uuid_LONGEST_LTE?: number | null;
  uuid_LT?: number | null;
  uuid_LTE?: number | null;
  uuid_SHORTEST_EQUAL?: number | null;
  uuid_SHORTEST_GT?: number | null;
  uuid_SHORTEST_GTE?: number | null;
  uuid_SHORTEST_LT?: number | null;
  uuid_SHORTEST_LTE?: number | null;
}

export interface FlexEntitySuccessorAggregateInput {
  AND?: FlexEntitySuccessorAggregateInput[] | null;
  OR?: FlexEntitySuccessorAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: FlexEntitySuccessorNodeAggregationWhereInput | null;
}

export interface FlexEntitySuccessorConnectionWhere {
  AND?: FlexEntitySuccessorConnectionWhere[] | null;
  OR?: FlexEntitySuccessorConnectionWhere[] | null;
  node?: FlexEntityWhere | null;
  node_NOT?: FlexEntityWhere | null;
}

export interface FlexEntitySuccessorNodeAggregationWhereInput {
  AND?: FlexEntitySuccessorNodeAggregationWhereInput[] | null;
  OR?: FlexEntitySuccessorNodeAggregationWhereInput[] | null;
  createdByEmail_AVERAGE_EQUAL?: number | null;
  createdByEmail_AVERAGE_GT?: number | null;
  createdByEmail_AVERAGE_GTE?: number | null;
  createdByEmail_AVERAGE_LT?: number | null;
  createdByEmail_AVERAGE_LTE?: number | null;
  createdByEmail_EQUAL?: string | null;
  createdByEmail_GT?: number | null;
  createdByEmail_GTE?: number | null;
  createdByEmail_LONGEST_EQUAL?: number | null;
  createdByEmail_LONGEST_GT?: number | null;
  createdByEmail_LONGEST_GTE?: number | null;
  createdByEmail_LONGEST_LT?: number | null;
  createdByEmail_LONGEST_LTE?: number | null;
  createdByEmail_LT?: number | null;
  createdByEmail_LTE?: number | null;
  createdByEmail_SHORTEST_EQUAL?: number | null;
  createdByEmail_SHORTEST_GT?: number | null;
  createdByEmail_SHORTEST_GTE?: number | null;
  createdByEmail_SHORTEST_LT?: number | null;
  createdByEmail_SHORTEST_LTE?: number | null;
  createdByName_AVERAGE_EQUAL?: number | null;
  createdByName_AVERAGE_GT?: number | null;
  createdByName_AVERAGE_GTE?: number | null;
  createdByName_AVERAGE_LT?: number | null;
  createdByName_AVERAGE_LTE?: number | null;
  createdByName_EQUAL?: string | null;
  createdByName_GT?: number | null;
  createdByName_GTE?: number | null;
  createdByName_LONGEST_EQUAL?: number | null;
  createdByName_LONGEST_GT?: number | null;
  createdByName_LONGEST_GTE?: number | null;
  createdByName_LONGEST_LT?: number | null;
  createdByName_LONGEST_LTE?: number | null;
  createdByName_LT?: number | null;
  createdByName_LTE?: number | null;
  createdByName_SHORTEST_EQUAL?: number | null;
  createdByName_SHORTEST_GT?: number | null;
  createdByName_SHORTEST_GTE?: number | null;
  createdByName_SHORTEST_LT?: number | null;
  createdByName_SHORTEST_LTE?: number | null;
  createdOn_EQUAL?: any | null;
  createdOn_GT?: any | null;
  createdOn_GTE?: any | null;
  createdOn_LT?: any | null;
  createdOn_LTE?: any | null;
  createdOn_MAX_EQUAL?: any | null;
  createdOn_MAX_GT?: any | null;
  createdOn_MAX_GTE?: any | null;
  createdOn_MAX_LT?: any | null;
  createdOn_MAX_LTE?: any | null;
  createdOn_MIN_EQUAL?: any | null;
  createdOn_MIN_GT?: any | null;
  createdOn_MIN_GTE?: any | null;
  createdOn_MIN_LT?: any | null;
  createdOn_MIN_LTE?: any | null;
  dataKeys_AVERAGE_EQUAL?: number | null;
  dataKeys_AVERAGE_GT?: number | null;
  dataKeys_AVERAGE_GTE?: number | null;
  dataKeys_AVERAGE_LT?: number | null;
  dataKeys_AVERAGE_LTE?: number | null;
  dataKeys_EQUAL?: string | null;
  dataKeys_GT?: number | null;
  dataKeys_GTE?: number | null;
  dataKeys_LONGEST_EQUAL?: number | null;
  dataKeys_LONGEST_GT?: number | null;
  dataKeys_LONGEST_GTE?: number | null;
  dataKeys_LONGEST_LT?: number | null;
  dataKeys_LONGEST_LTE?: number | null;
  dataKeys_LT?: number | null;
  dataKeys_LTE?: number | null;
  dataKeys_SHORTEST_EQUAL?: number | null;
  dataKeys_SHORTEST_GT?: number | null;
  dataKeys_SHORTEST_GTE?: number | null;
  dataKeys_SHORTEST_LT?: number | null;
  dataKeys_SHORTEST_LTE?: number | null;
  data_AVERAGE_EQUAL?: number | null;
  data_AVERAGE_GT?: number | null;
  data_AVERAGE_GTE?: number | null;
  data_AVERAGE_LT?: number | null;
  data_AVERAGE_LTE?: number | null;
  data_EQUAL?: string | null;
  data_GT?: number | null;
  data_GTE?: number | null;
  data_LONGEST_EQUAL?: number | null;
  data_LONGEST_GT?: number | null;
  data_LONGEST_GTE?: number | null;
  data_LONGEST_LT?: number | null;
  data_LONGEST_LTE?: number | null;
  data_LT?: number | null;
  data_LTE?: number | null;
  data_SHORTEST_EQUAL?: number | null;
  data_SHORTEST_GT?: number | null;
  data_SHORTEST_GTE?: number | null;
  data_SHORTEST_LT?: number | null;
  data_SHORTEST_LTE?: number | null;
  flexEntityName_AVERAGE_EQUAL?: number | null;
  flexEntityName_AVERAGE_GT?: number | null;
  flexEntityName_AVERAGE_GTE?: number | null;
  flexEntityName_AVERAGE_LT?: number | null;
  flexEntityName_AVERAGE_LTE?: number | null;
  flexEntityName_EQUAL?: string | null;
  flexEntityName_GT?: number | null;
  flexEntityName_GTE?: number | null;
  flexEntityName_LONGEST_EQUAL?: number | null;
  flexEntityName_LONGEST_GT?: number | null;
  flexEntityName_LONGEST_GTE?: number | null;
  flexEntityName_LONGEST_LT?: number | null;
  flexEntityName_LONGEST_LTE?: number | null;
  flexEntityName_LT?: number | null;
  flexEntityName_LTE?: number | null;
  flexEntityName_SHORTEST_EQUAL?: number | null;
  flexEntityName_SHORTEST_GT?: number | null;
  flexEntityName_SHORTEST_GTE?: number | null;
  flexEntityName_SHORTEST_LT?: number | null;
  flexEntityName_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  lastUpdatedOn_EQUAL?: any | null;
  lastUpdatedOn_GT?: any | null;
  lastUpdatedOn_GTE?: any | null;
  lastUpdatedOn_LT?: any | null;
  lastUpdatedOn_LTE?: any | null;
  lastUpdatedOn_MAX_EQUAL?: any | null;
  lastUpdatedOn_MAX_GT?: any | null;
  lastUpdatedOn_MAX_GTE?: any | null;
  lastUpdatedOn_MAX_LT?: any | null;
  lastUpdatedOn_MAX_LTE?: any | null;
  lastUpdatedOn_MIN_EQUAL?: any | null;
  lastUpdatedOn_MIN_GT?: any | null;
  lastUpdatedOn_MIN_GTE?: any | null;
  lastUpdatedOn_MIN_LT?: any | null;
  lastUpdatedOn_MIN_LTE?: any | null;
  patientId_AVERAGE_EQUAL?: number | null;
  patientId_AVERAGE_GT?: number | null;
  patientId_AVERAGE_GTE?: number | null;
  patientId_AVERAGE_LT?: number | null;
  patientId_AVERAGE_LTE?: number | null;
  patientId_EQUAL?: string | null;
  patientId_GT?: number | null;
  patientId_GTE?: number | null;
  patientId_LONGEST_EQUAL?: number | null;
  patientId_LONGEST_GT?: number | null;
  patientId_LONGEST_GTE?: number | null;
  patientId_LONGEST_LT?: number | null;
  patientId_LONGEST_LTE?: number | null;
  patientId_LT?: number | null;
  patientId_LTE?: number | null;
  patientId_SHORTEST_EQUAL?: number | null;
  patientId_SHORTEST_GT?: number | null;
  patientId_SHORTEST_GTE?: number | null;
  patientId_SHORTEST_LT?: number | null;
  patientId_SHORTEST_LTE?: number | null;
  preparationBrandNames_AVERAGE_EQUAL?: number | null;
  preparationBrandNames_AVERAGE_GT?: number | null;
  preparationBrandNames_AVERAGE_GTE?: number | null;
  preparationBrandNames_AVERAGE_LT?: number | null;
  preparationBrandNames_AVERAGE_LTE?: number | null;
  preparationBrandNames_EQUAL?: string | null;
  preparationBrandNames_GT?: number | null;
  preparationBrandNames_GTE?: number | null;
  preparationBrandNames_LONGEST_EQUAL?: number | null;
  preparationBrandNames_LONGEST_GT?: number | null;
  preparationBrandNames_LONGEST_GTE?: number | null;
  preparationBrandNames_LONGEST_LT?: number | null;
  preparationBrandNames_LONGEST_LTE?: number | null;
  preparationBrandNames_LT?: number | null;
  preparationBrandNames_LTE?: number | null;
  preparationBrandNames_SHORTEST_EQUAL?: number | null;
  preparationBrandNames_SHORTEST_GT?: number | null;
  preparationBrandNames_SHORTEST_GTE?: number | null;
  preparationBrandNames_SHORTEST_LT?: number | null;
  preparationBrandNames_SHORTEST_LTE?: number | null;
  preparationGenericNames_AVERAGE_EQUAL?: number | null;
  preparationGenericNames_AVERAGE_GT?: number | null;
  preparationGenericNames_AVERAGE_GTE?: number | null;
  preparationGenericNames_AVERAGE_LT?: number | null;
  preparationGenericNames_AVERAGE_LTE?: number | null;
  preparationGenericNames_EQUAL?: string | null;
  preparationGenericNames_GT?: number | null;
  preparationGenericNames_GTE?: number | null;
  preparationGenericNames_LONGEST_EQUAL?: number | null;
  preparationGenericNames_LONGEST_GT?: number | null;
  preparationGenericNames_LONGEST_GTE?: number | null;
  preparationGenericNames_LONGEST_LT?: number | null;
  preparationGenericNames_LONGEST_LTE?: number | null;
  preparationGenericNames_LT?: number | null;
  preparationGenericNames_LTE?: number | null;
  preparationGenericNames_SHORTEST_EQUAL?: number | null;
  preparationGenericNames_SHORTEST_GT?: number | null;
  preparationGenericNames_SHORTEST_GTE?: number | null;
  preparationGenericNames_SHORTEST_LT?: number | null;
  preparationGenericNames_SHORTEST_LTE?: number | null;
  quantity_AVERAGE_EQUAL?: number | null;
  quantity_AVERAGE_GT?: number | null;
  quantity_AVERAGE_GTE?: number | null;
  quantity_AVERAGE_LT?: number | null;
  quantity_AVERAGE_LTE?: number | null;
  quantity_EQUAL?: number | null;
  quantity_GT?: number | null;
  quantity_GTE?: number | null;
  quantity_LT?: number | null;
  quantity_LTE?: number | null;
  quantity_MAX_EQUAL?: number | null;
  quantity_MAX_GT?: number | null;
  quantity_MAX_GTE?: number | null;
  quantity_MAX_LT?: number | null;
  quantity_MAX_LTE?: number | null;
  quantity_MIN_EQUAL?: number | null;
  quantity_MIN_GT?: number | null;
  quantity_MIN_GTE?: number | null;
  quantity_MIN_LT?: number | null;
  quantity_MIN_LTE?: number | null;
  quantity_SUM_EQUAL?: number | null;
  quantity_SUM_GT?: number | null;
  quantity_SUM_GTE?: number | null;
  quantity_SUM_LT?: number | null;
  quantity_SUM_LTE?: number | null;
  tenantId_AVERAGE_EQUAL?: number | null;
  tenantId_AVERAGE_GT?: number | null;
  tenantId_AVERAGE_GTE?: number | null;
  tenantId_AVERAGE_LT?: number | null;
  tenantId_AVERAGE_LTE?: number | null;
  tenantId_EQUAL?: string | null;
  tenantId_GT?: number | null;
  tenantId_GTE?: number | null;
  tenantId_LONGEST_EQUAL?: number | null;
  tenantId_LONGEST_GT?: number | null;
  tenantId_LONGEST_GTE?: number | null;
  tenantId_LONGEST_LT?: number | null;
  tenantId_LONGEST_LTE?: number | null;
  tenantId_LT?: number | null;
  tenantId_LTE?: number | null;
  tenantId_SHORTEST_EQUAL?: number | null;
  tenantId_SHORTEST_GT?: number | null;
  tenantId_SHORTEST_GTE?: number | null;
  tenantId_SHORTEST_LT?: number | null;
  tenantId_SHORTEST_LTE?: number | null;
  unlimited_AVERAGE_EQUAL?: number | null;
  unlimited_AVERAGE_GT?: number | null;
  unlimited_AVERAGE_GTE?: number | null;
  unlimited_AVERAGE_LT?: number | null;
  unlimited_AVERAGE_LTE?: number | null;
  unlimited_EQUAL?: number | null;
  unlimited_GT?: number | null;
  unlimited_GTE?: number | null;
  unlimited_LT?: number | null;
  unlimited_LTE?: number | null;
  unlimited_MAX_EQUAL?: number | null;
  unlimited_MAX_GT?: number | null;
  unlimited_MAX_GTE?: number | null;
  unlimited_MAX_LT?: number | null;
  unlimited_MAX_LTE?: number | null;
  unlimited_MIN_EQUAL?: number | null;
  unlimited_MIN_GT?: number | null;
  unlimited_MIN_GTE?: number | null;
  unlimited_MIN_LT?: number | null;
  unlimited_MIN_LTE?: number | null;
  unlimited_SUM_EQUAL?: number | null;
  unlimited_SUM_GT?: number | null;
  unlimited_SUM_GTE?: number | null;
  unlimited_SUM_LT?: number | null;
  unlimited_SUM_LTE?: number | null;
  uuid_AVERAGE_EQUAL?: number | null;
  uuid_AVERAGE_GT?: number | null;
  uuid_AVERAGE_GTE?: number | null;
  uuid_AVERAGE_LT?: number | null;
  uuid_AVERAGE_LTE?: number | null;
  uuid_EQUAL?: string | null;
  uuid_GT?: number | null;
  uuid_GTE?: number | null;
  uuid_LONGEST_EQUAL?: number | null;
  uuid_LONGEST_GT?: number | null;
  uuid_LONGEST_GTE?: number | null;
  uuid_LONGEST_LT?: number | null;
  uuid_LONGEST_LTE?: number | null;
  uuid_LT?: number | null;
  uuid_LTE?: number | null;
  uuid_SHORTEST_EQUAL?: number | null;
  uuid_SHORTEST_GT?: number | null;
  uuid_SHORTEST_GTE?: number | null;
  uuid_SHORTEST_LT?: number | null;
  uuid_SHORTEST_LTE?: number | null;
}

export interface FlexEntityTypeAddedByAggregateInput {
  AND?: FlexEntityTypeAddedByAggregateInput[] | null;
  OR?: FlexEntityTypeAddedByAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: FlexEntityTypeAddedByNodeAggregationWhereInput | null;
}

export interface FlexEntityTypeAddedByConnectionWhere {
  AND?: FlexEntityTypeAddedByConnectionWhere[] | null;
  OR?: FlexEntityTypeAddedByConnectionWhere[] | null;
  node?: UserWhere | null;
  node_NOT?: UserWhere | null;
}

export interface FlexEntityTypeAddedByNodeAggregationWhereInput {
  AND?: FlexEntityTypeAddedByNodeAggregationWhereInput[] | null;
  OR?: FlexEntityTypeAddedByNodeAggregationWhereInput[] | null;
  deletedOn_EQUAL?: any | null;
  deletedOn_GT?: any | null;
  deletedOn_GTE?: any | null;
  deletedOn_LT?: any | null;
  deletedOn_LTE?: any | null;
  deletedOn_MAX_EQUAL?: any | null;
  deletedOn_MAX_GT?: any | null;
  deletedOn_MAX_GTE?: any | null;
  deletedOn_MAX_LT?: any | null;
  deletedOn_MAX_LTE?: any | null;
  deletedOn_MIN_EQUAL?: any | null;
  deletedOn_MIN_GT?: any | null;
  deletedOn_MIN_GTE?: any | null;
  deletedOn_MIN_LT?: any | null;
  deletedOn_MIN_LTE?: any | null;
  department_AVERAGE_EQUAL?: number | null;
  department_AVERAGE_GT?: number | null;
  department_AVERAGE_GTE?: number | null;
  department_AVERAGE_LT?: number | null;
  department_AVERAGE_LTE?: number | null;
  department_EQUAL?: string | null;
  department_GT?: number | null;
  department_GTE?: number | null;
  department_LONGEST_EQUAL?: number | null;
  department_LONGEST_GT?: number | null;
  department_LONGEST_GTE?: number | null;
  department_LONGEST_LT?: number | null;
  department_LONGEST_LTE?: number | null;
  department_LT?: number | null;
  department_LTE?: number | null;
  department_SHORTEST_EQUAL?: number | null;
  department_SHORTEST_GT?: number | null;
  department_SHORTEST_GTE?: number | null;
  department_SHORTEST_LT?: number | null;
  department_SHORTEST_LTE?: number | null;
  email_AVERAGE_EQUAL?: number | null;
  email_AVERAGE_GT?: number | null;
  email_AVERAGE_GTE?: number | null;
  email_AVERAGE_LT?: number | null;
  email_AVERAGE_LTE?: number | null;
  email_EQUAL?: string | null;
  email_GT?: number | null;
  email_GTE?: number | null;
  email_LONGEST_EQUAL?: number | null;
  email_LONGEST_GT?: number | null;
  email_LONGEST_GTE?: number | null;
  email_LONGEST_LT?: number | null;
  email_LONGEST_LTE?: number | null;
  email_LT?: number | null;
  email_LTE?: number | null;
  email_SHORTEST_EQUAL?: number | null;
  email_SHORTEST_GT?: number | null;
  email_SHORTEST_GTE?: number | null;
  email_SHORTEST_LT?: number | null;
  email_SHORTEST_LTE?: number | null;
  firstName_AVERAGE_EQUAL?: number | null;
  firstName_AVERAGE_GT?: number | null;
  firstName_AVERAGE_GTE?: number | null;
  firstName_AVERAGE_LT?: number | null;
  firstName_AVERAGE_LTE?: number | null;
  firstName_EQUAL?: string | null;
  firstName_GT?: number | null;
  firstName_GTE?: number | null;
  firstName_LONGEST_EQUAL?: number | null;
  firstName_LONGEST_GT?: number | null;
  firstName_LONGEST_GTE?: number | null;
  firstName_LONGEST_LT?: number | null;
  firstName_LONGEST_LTE?: number | null;
  firstName_LT?: number | null;
  firstName_LTE?: number | null;
  firstName_SHORTEST_EQUAL?: number | null;
  firstName_SHORTEST_GT?: number | null;
  firstName_SHORTEST_GTE?: number | null;
  firstName_SHORTEST_LT?: number | null;
  firstName_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  lastName_AVERAGE_EQUAL?: number | null;
  lastName_AVERAGE_GT?: number | null;
  lastName_AVERAGE_GTE?: number | null;
  lastName_AVERAGE_LT?: number | null;
  lastName_AVERAGE_LTE?: number | null;
  lastName_EQUAL?: string | null;
  lastName_GT?: number | null;
  lastName_GTE?: number | null;
  lastName_LONGEST_EQUAL?: number | null;
  lastName_LONGEST_GT?: number | null;
  lastName_LONGEST_GTE?: number | null;
  lastName_LONGEST_LT?: number | null;
  lastName_LONGEST_LTE?: number | null;
  lastName_LT?: number | null;
  lastName_LTE?: number | null;
  lastName_SHORTEST_EQUAL?: number | null;
  lastName_SHORTEST_GT?: number | null;
  lastName_SHORTEST_GTE?: number | null;
  lastName_SHORTEST_LT?: number | null;
  lastName_SHORTEST_LTE?: number | null;
  position_AVERAGE_EQUAL?: number | null;
  position_AVERAGE_GT?: number | null;
  position_AVERAGE_GTE?: number | null;
  position_AVERAGE_LT?: number | null;
  position_AVERAGE_LTE?: number | null;
  position_EQUAL?: string | null;
  position_GT?: number | null;
  position_GTE?: number | null;
  position_LONGEST_EQUAL?: number | null;
  position_LONGEST_GT?: number | null;
  position_LONGEST_GTE?: number | null;
  position_LONGEST_LT?: number | null;
  position_LONGEST_LTE?: number | null;
  position_LT?: number | null;
  position_LTE?: number | null;
  position_SHORTEST_EQUAL?: number | null;
  position_SHORTEST_GT?: number | null;
  position_SHORTEST_GTE?: number | null;
  position_SHORTEST_LT?: number | null;
  position_SHORTEST_LTE?: number | null;
  preferredLanguage_AVERAGE_EQUAL?: number | null;
  preferredLanguage_AVERAGE_GT?: number | null;
  preferredLanguage_AVERAGE_GTE?: number | null;
  preferredLanguage_AVERAGE_LT?: number | null;
  preferredLanguage_AVERAGE_LTE?: number | null;
  preferredLanguage_EQUAL?: string | null;
  preferredLanguage_GT?: number | null;
  preferredLanguage_GTE?: number | null;
  preferredLanguage_LONGEST_EQUAL?: number | null;
  preferredLanguage_LONGEST_GT?: number | null;
  preferredLanguage_LONGEST_GTE?: number | null;
  preferredLanguage_LONGEST_LT?: number | null;
  preferredLanguage_LONGEST_LTE?: number | null;
  preferredLanguage_LT?: number | null;
  preferredLanguage_LTE?: number | null;
  preferredLanguage_SHORTEST_EQUAL?: number | null;
  preferredLanguage_SHORTEST_GT?: number | null;
  preferredLanguage_SHORTEST_GTE?: number | null;
  preferredLanguage_SHORTEST_LT?: number | null;
  preferredLanguage_SHORTEST_LTE?: number | null;
  tenantId_AVERAGE_EQUAL?: number | null;
  tenantId_AVERAGE_GT?: number | null;
  tenantId_AVERAGE_GTE?: number | null;
  tenantId_AVERAGE_LT?: number | null;
  tenantId_AVERAGE_LTE?: number | null;
  tenantId_EQUAL?: string | null;
  tenantId_GT?: number | null;
  tenantId_GTE?: number | null;
  tenantId_LONGEST_EQUAL?: number | null;
  tenantId_LONGEST_GT?: number | null;
  tenantId_LONGEST_GTE?: number | null;
  tenantId_LONGEST_LT?: number | null;
  tenantId_LONGEST_LTE?: number | null;
  tenantId_LT?: number | null;
  tenantId_LTE?: number | null;
  tenantId_SHORTEST_EQUAL?: number | null;
  tenantId_SHORTEST_GT?: number | null;
  tenantId_SHORTEST_GTE?: number | null;
  tenantId_SHORTEST_LT?: number | null;
  tenantId_SHORTEST_LTE?: number | null;
}

export interface FlexEntityTypeAggregateInput {
  AND?: FlexEntityTypeAggregateInput[] | null;
  OR?: FlexEntityTypeAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: FlexEntityTypeNodeAggregationWhereInput | null;
}

export interface FlexEntityTypeCatalogueAttributeRelationshipWhere {
  AND?: FlexEntityTypeCatalogueAttributeRelationshipWhere[] | null;
  OR?: FlexEntityTypeCatalogueAttributeRelationshipWhere[] | null;
  isDisplayedInCaseDetails?: boolean | null;
  isDisplayedInCaseDetails_NOT?: boolean | null;
  isDisplayedInCaseTable?: boolean | null;
  isDisplayedInCaseTable_NOT?: boolean | null;
}

export interface FlexEntityTypeCatalogueAttributesAggregateInput {
  AND?: FlexEntityTypeCatalogueAttributesAggregateInput[] | null;
  OR?: FlexEntityTypeCatalogueAttributesAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: FlexEntityTypeCatalogueAttributesNodeAggregationWhereInput | null;
}

export interface FlexEntityTypeCatalogueAttributesConnectionWhere {
  AND?: FlexEntityTypeCatalogueAttributesConnectionWhere[] | null;
  OR?: FlexEntityTypeCatalogueAttributesConnectionWhere[] | null;
  edge?: FlexEntityTypeCatalogueAttributeRelationshipWhere | null;
  edge_NOT?: FlexEntityTypeCatalogueAttributeRelationshipWhere | null;
  node?: CatalogueAttributeWhere | null;
  node_NOT?: CatalogueAttributeWhere | null;
}

export interface FlexEntityTypeCatalogueAttributesNodeAggregationWhereInput {
  AND?: FlexEntityTypeCatalogueAttributesNodeAggregationWhereInput[] | null;
  OR?: FlexEntityTypeCatalogueAttributesNodeAggregationWhereInput[] | null;
  caption_AVERAGE_EQUAL?: number | null;
  caption_AVERAGE_GT?: number | null;
  caption_AVERAGE_GTE?: number | null;
  caption_AVERAGE_LT?: number | null;
  caption_AVERAGE_LTE?: number | null;
  caption_EQUAL?: string | null;
  caption_GT?: number | null;
  caption_GTE?: number | null;
  caption_LONGEST_EQUAL?: number | null;
  caption_LONGEST_GT?: number | null;
  caption_LONGEST_GTE?: number | null;
  caption_LONGEST_LT?: number | null;
  caption_LONGEST_LTE?: number | null;
  caption_LT?: number | null;
  caption_LTE?: number | null;
  caption_SHORTEST_EQUAL?: number | null;
  caption_SHORTEST_GT?: number | null;
  caption_SHORTEST_GTE?: number | null;
  caption_SHORTEST_LT?: number | null;
  caption_SHORTEST_LTE?: number | null;
  decimalPrecision_AVERAGE_EQUAL?: number | null;
  decimalPrecision_AVERAGE_GT?: number | null;
  decimalPrecision_AVERAGE_GTE?: number | null;
  decimalPrecision_AVERAGE_LT?: number | null;
  decimalPrecision_AVERAGE_LTE?: number | null;
  decimalPrecision_EQUAL?: number | null;
  decimalPrecision_GT?: number | null;
  decimalPrecision_GTE?: number | null;
  decimalPrecision_LT?: number | null;
  decimalPrecision_LTE?: number | null;
  decimalPrecision_MAX_EQUAL?: number | null;
  decimalPrecision_MAX_GT?: number | null;
  decimalPrecision_MAX_GTE?: number | null;
  decimalPrecision_MAX_LT?: number | null;
  decimalPrecision_MAX_LTE?: number | null;
  decimalPrecision_MIN_EQUAL?: number | null;
  decimalPrecision_MIN_GT?: number | null;
  decimalPrecision_MIN_GTE?: number | null;
  decimalPrecision_MIN_LT?: number | null;
  decimalPrecision_MIN_LTE?: number | null;
  decimalPrecision_SUM_EQUAL?: number | null;
  decimalPrecision_SUM_GT?: number | null;
  decimalPrecision_SUM_GTE?: number | null;
  decimalPrecision_SUM_LT?: number | null;
  decimalPrecision_SUM_LTE?: number | null;
  defaultValue_AVERAGE_EQUAL?: number | null;
  defaultValue_AVERAGE_GT?: number | null;
  defaultValue_AVERAGE_GTE?: number | null;
  defaultValue_AVERAGE_LT?: number | null;
  defaultValue_AVERAGE_LTE?: number | null;
  defaultValue_EQUAL?: string | null;
  defaultValue_GT?: number | null;
  defaultValue_GTE?: number | null;
  defaultValue_LONGEST_EQUAL?: number | null;
  defaultValue_LONGEST_GT?: number | null;
  defaultValue_LONGEST_GTE?: number | null;
  defaultValue_LONGEST_LT?: number | null;
  defaultValue_LONGEST_LTE?: number | null;
  defaultValue_LT?: number | null;
  defaultValue_LTE?: number | null;
  defaultValue_SHORTEST_EQUAL?: number | null;
  defaultValue_SHORTEST_GT?: number | null;
  defaultValue_SHORTEST_GTE?: number | null;
  defaultValue_SHORTEST_LT?: number | null;
  defaultValue_SHORTEST_LTE?: number | null;
  id_AVERAGE_EQUAL?: number | null;
  id_AVERAGE_GT?: number | null;
  id_AVERAGE_GTE?: number | null;
  id_AVERAGE_LT?: number | null;
  id_AVERAGE_LTE?: number | null;
  id_EQUAL?: string | null;
  id_GT?: number | null;
  id_GTE?: number | null;
  id_LONGEST_EQUAL?: number | null;
  id_LONGEST_GT?: number | null;
  id_LONGEST_GTE?: number | null;
  id_LONGEST_LT?: number | null;
  id_LONGEST_LTE?: number | null;
  id_LT?: number | null;
  id_LTE?: number | null;
  id_SHORTEST_EQUAL?: number | null;
  id_SHORTEST_GT?: number | null;
  id_SHORTEST_GTE?: number | null;
  id_SHORTEST_LT?: number | null;
  id_SHORTEST_LTE?: number | null;
  identifier_AVERAGE_EQUAL?: number | null;
  identifier_AVERAGE_GT?: number | null;
  identifier_AVERAGE_GTE?: number | null;
  identifier_AVERAGE_LT?: number | null;
  identifier_AVERAGE_LTE?: number | null;
  identifier_EQUAL?: string | null;
  identifier_GT?: number | null;
  identifier_GTE?: number | null;
  identifier_LONGEST_EQUAL?: number | null;
  identifier_LONGEST_GT?: number | null;
  identifier_LONGEST_GTE?: number | null;
  identifier_LONGEST_LT?: number | null;
  identifier_LONGEST_LTE?: number | null;
  identifier_LT?: number | null;
  identifier_LTE?: number | null;
  identifier_SHORTEST_EQUAL?: number | null;
  identifier_SHORTEST_GT?: number | null;
  identifier_SHORTEST_GTE?: number | null;
  identifier_SHORTEST_LT?: number | null;
  identifier_SHORTEST_LTE?: number | null;
  longLabelLocalizationKey_AVERAGE_EQUAL?: number | null;
  longLabelLocalizationKey_AVERAGE_GT?: number | null;
  longLabelLocalizationKey_AVERAGE_GTE?: number | null;
  longLabelLocalizationKey_AVERAGE_LT?: number | null;
  longLabelLocalizationKey_AVERAGE_LTE?: number | null;
  longLabelLocalizationKey_EQUAL?: string | null;
  longLabelLocalizationKey_GT?: number | null;
  longLabelLocalizationKey_GTE?: number | null;
  longLabelLocalizationKey_LONGEST_EQUAL?: number | null;
  longLabelLocalizationKey_LONGEST_GT?: number | null;
  longLabelLocalizationKey_LONGEST_GTE?: number | null;
  longLabelLocalizationKey_LONGEST_LT?: number | null;
  longLabelLocalizationKey_LONGEST_LTE?: number | null;
  longLabelLocalizationKey_LT?: number | null;
  longLabelLocalizationKey_LTE?: number | null;
  longLabelLocalizationKey_SHORTEST_EQUAL?: number | null;
  longLabelLocalizationKey_SHORTEST_GT?: number | null;
  longLabelLocalizationKey_SHORTEST_GTE?: number | null;
  longLabelLocalizationKey_SHORTEST_LT?: number | null;
  longLabelLocalizationKey_SHORTEST_LTE?: number | null;
  maxLength_AVERAGE_EQUAL?: number | null;
  maxLength_AVERAGE_GT?: number | null;
  maxLength_AVERAGE_GTE?: number | null;
  maxLength_AVERAGE_LT?: number | null;
  maxLength_AVERAGE_LTE?: number | null;
  maxLength_EQUAL?: number | null;
  maxLength_GT?: number | null;
  maxLength_GTE?: number | null;
  maxLength_LT?: number | null;
  maxLength_LTE?: number | null;
  maxLength_MAX_EQUAL?: number | null;
  maxLength_MAX_GT?: number | null;
  maxLength_MAX_GTE?: number | null;
  maxLength_MAX_LT?: number | null;
  maxLength_MAX_LTE?: number | null;
  maxLength_MIN_EQUAL?: number | null;
  maxLength_MIN_GT?: number | null;
  maxLength_MIN_GTE?: number | null;
  maxLength_MIN_LT?: number | null;
  maxLength_MIN_LTE?: number | null;
  maxLength_SUM_EQUAL?: number | null;
  maxLength_SUM_GT?: number | null;
  maxLength_SUM_GTE?: number | null;
  maxLength_SUM_LT?: number | null;
  maxLength_SUM_LTE?: number | null;
  minLength_AVERAGE_EQUAL?: number | null;
  minLength_AVERAGE_GT?: number | null;
  minLength_AVERAGE_GTE?: number | null;
  minLength_AVERAGE_LT?: number | null;
  minLength_AVERAGE_LTE?: number | null;
  minLength_EQUAL?: number | null;
  minLength_GT?: number | null;
  minLength_GTE?: number | null;
  minLength_LT?: number | null;
  minLength_LTE?: number | null;
  minLength_MAX_EQUAL?: number | null;
  minLength_MAX_GT?: number | null;
  minLength_MAX_GTE?: number | null;
  minLength_MAX_LT?: number | null;
  minLength_MAX_LTE?: number | null;
  minLength_MIN_EQUAL?: number | null;
  minLength_MIN_GT?: number | null;
  minLength_MIN_GTE?: number | null;
  minLength_MIN_LT?: number | null;
  minLength_MIN_LTE?: number | null;
  minLength_SUM_EQUAL?: number | null;
  minLength_SUM_GT?: number | null;
  minLength_SUM_GTE?: number | null;
  minLength_SUM_LT?: number | null;
  minLength_SUM_LTE?: number | null;
  rules_AVERAGE_EQUAL?: number | null;
  rules_AVERAGE_GT?: number | null;
  rules_AVERAGE_GTE?: number | null;
  rules_AVERAGE_LT?: number | null;
  rules_AVERAGE_LTE?: number | null;
  rules_EQUAL?: string | null;
  rules_GT?: number | null;
  rules_GTE?: number | null;
  rules_LONGEST_EQUAL?: number | null;
  rules_LONGEST_GT?: number | null;
  rules_LONGEST_GTE?: number | null;
  rules_LONGEST_LT?: number | null;
  rules_LONGEST_LTE?: number | null;
  rules_LT?: number | null;
  rules_LTE?: number | null;
  rules_SHORTEST_EQUAL?: number | null;
  rules_SHORTEST_GT?: number | null;
  rules_SHORTEST_GTE?: number | null;
  rules_SHORTEST_LT?: number | null;
  rules_SHORTEST_LTE?: number | null;
  shortLabelLocalizationKey_AVERAGE_EQUAL?: number | null;
  shortLabelLocalizationKey_AVERAGE_GT?: number | null;
  shortLabelLocalizationKey_AVERAGE_GTE?: number | null;
  shortLabelLocalizationKey_AVERAGE_LT?: number | null;
  shortLabelLocalizationKey_AVERAGE_LTE?: number | null;
  shortLabelLocalizationKey_EQUAL?: string | null;
  shortLabelLocalizationKey_GT?: number | null;
  shortLabelLocalizationKey_GTE?: number | null;
  shortLabelLocalizationKey_LONGEST_EQUAL?: number | null;
  shortLabelLocalizationKey_LONGEST_GT?: number | null;
  shortLabelLocalizationKey_LONGEST_GTE?: number | null;
  shortLabelLocalizationKey_LONGEST_LT?: number | null;
  shortLabelLocalizationKey_LONGEST_LTE?: number | null;
  shortLabelLocalizationKey_LT?: number | null;
  shortLabelLocalizationKey_LTE?: number | null;
  shortLabelLocalizationKey_SHORTEST_EQUAL?: number | null;
  shortLabelLocalizationKey_SHORTEST_GT?: number | null;
  shortLabelLocalizationKey_SHORTEST_GTE?: number | null;
  shortLabelLocalizationKey_SHORTEST_LT?: number | null;
  shortLabelLocalizationKey_SHORTEST_LTE?: number | null;
  values_AVERAGE_EQUAL?: number | null;
  values_AVERAGE_GT?: number | null;
  values_AVERAGE_GTE?: number | null;
  values_AVERAGE_LT?: number | null;
  values_AVERAGE_LTE?: number | null;
  values_EQUAL?: string | null;
  values_GT?: number | null;
  values_GTE?: number | null;
  values_LONGEST_EQUAL?: number | null;
  values_LONGEST_GT?: number | null;
  values_LONGEST_GTE?: number | null;
  values_LONGEST_LT?: number | null;
  values_LONGEST_LTE?: number | null;
  values_LT?: number | null;
  values_LTE?: number | null;
  values_SHORTEST_EQUAL?: number | null;
  values_SHORTEST_GT?: number | null;
  values_SHORTEST_GTE?: number | null;
  values_SHORTEST_LT?: number | null;
  values_SHORTEST_LTE?: number | null;
}

export interface FlexEntityTypeConnectionWhere {
  AND?: FlexEntityTypeConnectionWhere[] | null;
  OR?: FlexEntityTypeConnectionWhere[] | null;
  node?: FlexEntityTypeWhere | null;
  node_NOT?: FlexEntityTypeWhere | null;
}

export interface FlexEntityTypeInstancesAggregateInput {
  AND?: FlexEntityTypeInstancesAggregateInput[] | null;
  OR?: FlexEntityTypeInstancesAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: FlexEntityTypeInstancesNodeAggregationWhereInput | null;
}

export interface FlexEntityTypeInstancesConnectionWhere {
  AND?: FlexEntityTypeInstancesConnectionWhere[] | null;
  OR?: FlexEntityTypeInstancesConnectionWhere[] | null;
  node?: FlexEntityWhere | null;
  node_NOT?: FlexEntityWhere | null;
}

export interface FlexEntityTypeInstancesNodeAggregationWhereInput {
  AND?: FlexEntityTypeInstancesNodeAggregationWhereInput[] | null;
  OR?: FlexEntityTypeInstancesNodeAggregationWhereInput[] | null;
  createdByEmail_AVERAGE_EQUAL?: number | null;
  createdByEmail_AVERAGE_GT?: number | null;
  createdByEmail_AVERAGE_GTE?: number | null;
  createdByEmail_AVERAGE_LT?: number | null;
  createdByEmail_AVERAGE_LTE?: number | null;
  createdByEmail_EQUAL?: string | null;
  createdByEmail_GT?: number | null;
  createdByEmail_GTE?: number | null;
  createdByEmail_LONGEST_EQUAL?: number | null;
  createdByEmail_LONGEST_GT?: number | null;
  createdByEmail_LONGEST_GTE?: number | null;
  createdByEmail_LONGEST_LT?: number | null;
  createdByEmail_LONGEST_LTE?: number | null;
  createdByEmail_LT?: number | null;
  createdByEmail_LTE?: number | null;
  createdByEmail_SHORTEST_EQUAL?: number | null;
  createdByEmail_SHORTEST_GT?: number | null;
  createdByEmail_SHORTEST_GTE?: number | null;
  createdByEmail_SHORTEST_LT?: number | null;
  createdByEmail_SHORTEST_LTE?: number | null;
  createdByName_AVERAGE_EQUAL?: number | null;
  createdByName_AVERAGE_GT?: number | null;
  createdByName_AVERAGE_GTE?: number | null;
  createdByName_AVERAGE_LT?: number | null;
  createdByName_AVERAGE_LTE?: number | null;
  createdByName_EQUAL?: string | null;
  createdByName_GT?: number | null;
  createdByName_GTE?: number | null;
  createdByName_LONGEST_EQUAL?: number | null;
  createdByName_LONGEST_GT?: number | null;
  createdByName_LONGEST_GTE?: number | null;
  createdByName_LONGEST_LT?: number | null;
  createdByName_LONGEST_LTE?: number | null;
  createdByName_LT?: number | null;
  createdByName_LTE?: number | null;
  createdByName_SHORTEST_EQUAL?: number | null;
  createdByName_SHORTEST_GT?: number | null;
  createdByName_SHORTEST_GTE?: number | null;
  createdByName_SHORTEST_LT?: number | null;
  createdByName_SHORTEST_LTE?: number | null;
  createdOn_EQUAL?: any | null;
  createdOn_GT?: any | null;
  createdOn_GTE?: any | null;
  createdOn_LT?: any | null;
  createdOn_LTE?: any | null;
  createdOn_MAX_EQUAL?: any | null;
  createdOn_MAX_GT?: any | null;
  createdOn_MAX_GTE?: any | null;
  createdOn_MAX_LT?: any | null;
  createdOn_MAX_LTE?: any | null;
  createdOn_MIN_EQUAL?: any | null;
  createdOn_MIN_GT?: any | null;
  createdOn_MIN_GTE?: any | null;
  createdOn_MIN_LT?: any | null;
  createdOn_MIN_LTE?: any | null;
  dataKeys_AVERAGE_EQUAL?: number | null;
  dataKeys_AVERAGE_GT?: number | null;
  dataKeys_AVERAGE_GTE?: number | null;
  dataKeys_AVERAGE_LT?: number | null;
  dataKeys_AVERAGE_LTE?: number | null;
  dataKeys_EQUAL?: string | null;
  dataKeys_GT?: number | null;
  dataKeys_GTE?: number | null;
  dataKeys_LONGEST_EQUAL?: number | null;
  dataKeys_LONGEST_GT?: number | null;
  dataKeys_LONGEST_GTE?: number | null;
  dataKeys_LONGEST_LT?: number | null;
  dataKeys_LONGEST_LTE?: number | null;
  dataKeys_LT?: number | null;
  dataKeys_LTE?: number | null;
  dataKeys_SHORTEST_EQUAL?: number | null;
  dataKeys_SHORTEST_GT?: number | null;
  dataKeys_SHORTEST_GTE?: number | null;
  dataKeys_SHORTEST_LT?: number | null;
  dataKeys_SHORTEST_LTE?: number | null;
  data_AVERAGE_EQUAL?: number | null;
  data_AVERAGE_GT?: number | null;
  data_AVERAGE_GTE?: number | null;
  data_AVERAGE_LT?: number | null;
  data_AVERAGE_LTE?: number | null;
  data_EQUAL?: string | null;
  data_GT?: number | null;
  data_GTE?: number | null;
  data_LONGEST_EQUAL?: number | null;
  data_LONGEST_GT?: number | null;
  data_LONGEST_GTE?: number | null;
  data_LONGEST_LT?: number | null;
  data_LONGEST_LTE?: number | null;
  data_LT?: number | null;
  data_LTE?: number | null;
  data_SHORTEST_EQUAL?: number | null;
  data_SHORTEST_GT?: number | null;
  data_SHORTEST_GTE?: number | null;
  data_SHORTEST_LT?: number | null;
  data_SHORTEST_LTE?: number | null;
  flexEntityName_AVERAGE_EQUAL?: number | null;
  flexEntityName_AVERAGE_GT?: number | null;
  flexEntityName_AVERAGE_GTE?: number | null;
  flexEntityName_AVERAGE_LT?: number | null;
  flexEntityName_AVERAGE_LTE?: number | null;
  flexEntityName_EQUAL?: string | null;
  flexEntityName_GT?: number | null;
  flexEntityName_GTE?: number | null;
  flexEntityName_LONGEST_EQUAL?: number | null;
  flexEntityName_LONGEST_GT?: number | null;
  flexEntityName_LONGEST_GTE?: number | null;
  flexEntityName_LONGEST_LT?: number | null;
  flexEntityName_LONGEST_LTE?: number | null;
  flexEntityName_LT?: number | null;
  flexEntityName_LTE?: number | null;
  flexEntityName_SHORTEST_EQUAL?: number | null;
  flexEntityName_SHORTEST_GT?: number | null;
  flexEntityName_SHORTEST_GTE?: number | null;
  flexEntityName_SHORTEST_LT?: number | null;
  flexEntityName_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  lastUpdatedOn_EQUAL?: any | null;
  lastUpdatedOn_GT?: any | null;
  lastUpdatedOn_GTE?: any | null;
  lastUpdatedOn_LT?: any | null;
  lastUpdatedOn_LTE?: any | null;
  lastUpdatedOn_MAX_EQUAL?: any | null;
  lastUpdatedOn_MAX_GT?: any | null;
  lastUpdatedOn_MAX_GTE?: any | null;
  lastUpdatedOn_MAX_LT?: any | null;
  lastUpdatedOn_MAX_LTE?: any | null;
  lastUpdatedOn_MIN_EQUAL?: any | null;
  lastUpdatedOn_MIN_GT?: any | null;
  lastUpdatedOn_MIN_GTE?: any | null;
  lastUpdatedOn_MIN_LT?: any | null;
  lastUpdatedOn_MIN_LTE?: any | null;
  patientId_AVERAGE_EQUAL?: number | null;
  patientId_AVERAGE_GT?: number | null;
  patientId_AVERAGE_GTE?: number | null;
  patientId_AVERAGE_LT?: number | null;
  patientId_AVERAGE_LTE?: number | null;
  patientId_EQUAL?: string | null;
  patientId_GT?: number | null;
  patientId_GTE?: number | null;
  patientId_LONGEST_EQUAL?: number | null;
  patientId_LONGEST_GT?: number | null;
  patientId_LONGEST_GTE?: number | null;
  patientId_LONGEST_LT?: number | null;
  patientId_LONGEST_LTE?: number | null;
  patientId_LT?: number | null;
  patientId_LTE?: number | null;
  patientId_SHORTEST_EQUAL?: number | null;
  patientId_SHORTEST_GT?: number | null;
  patientId_SHORTEST_GTE?: number | null;
  patientId_SHORTEST_LT?: number | null;
  patientId_SHORTEST_LTE?: number | null;
  preparationBrandNames_AVERAGE_EQUAL?: number | null;
  preparationBrandNames_AVERAGE_GT?: number | null;
  preparationBrandNames_AVERAGE_GTE?: number | null;
  preparationBrandNames_AVERAGE_LT?: number | null;
  preparationBrandNames_AVERAGE_LTE?: number | null;
  preparationBrandNames_EQUAL?: string | null;
  preparationBrandNames_GT?: number | null;
  preparationBrandNames_GTE?: number | null;
  preparationBrandNames_LONGEST_EQUAL?: number | null;
  preparationBrandNames_LONGEST_GT?: number | null;
  preparationBrandNames_LONGEST_GTE?: number | null;
  preparationBrandNames_LONGEST_LT?: number | null;
  preparationBrandNames_LONGEST_LTE?: number | null;
  preparationBrandNames_LT?: number | null;
  preparationBrandNames_LTE?: number | null;
  preparationBrandNames_SHORTEST_EQUAL?: number | null;
  preparationBrandNames_SHORTEST_GT?: number | null;
  preparationBrandNames_SHORTEST_GTE?: number | null;
  preparationBrandNames_SHORTEST_LT?: number | null;
  preparationBrandNames_SHORTEST_LTE?: number | null;
  preparationGenericNames_AVERAGE_EQUAL?: number | null;
  preparationGenericNames_AVERAGE_GT?: number | null;
  preparationGenericNames_AVERAGE_GTE?: number | null;
  preparationGenericNames_AVERAGE_LT?: number | null;
  preparationGenericNames_AVERAGE_LTE?: number | null;
  preparationGenericNames_EQUAL?: string | null;
  preparationGenericNames_GT?: number | null;
  preparationGenericNames_GTE?: number | null;
  preparationGenericNames_LONGEST_EQUAL?: number | null;
  preparationGenericNames_LONGEST_GT?: number | null;
  preparationGenericNames_LONGEST_GTE?: number | null;
  preparationGenericNames_LONGEST_LT?: number | null;
  preparationGenericNames_LONGEST_LTE?: number | null;
  preparationGenericNames_LT?: number | null;
  preparationGenericNames_LTE?: number | null;
  preparationGenericNames_SHORTEST_EQUAL?: number | null;
  preparationGenericNames_SHORTEST_GT?: number | null;
  preparationGenericNames_SHORTEST_GTE?: number | null;
  preparationGenericNames_SHORTEST_LT?: number | null;
  preparationGenericNames_SHORTEST_LTE?: number | null;
  quantity_AVERAGE_EQUAL?: number | null;
  quantity_AVERAGE_GT?: number | null;
  quantity_AVERAGE_GTE?: number | null;
  quantity_AVERAGE_LT?: number | null;
  quantity_AVERAGE_LTE?: number | null;
  quantity_EQUAL?: number | null;
  quantity_GT?: number | null;
  quantity_GTE?: number | null;
  quantity_LT?: number | null;
  quantity_LTE?: number | null;
  quantity_MAX_EQUAL?: number | null;
  quantity_MAX_GT?: number | null;
  quantity_MAX_GTE?: number | null;
  quantity_MAX_LT?: number | null;
  quantity_MAX_LTE?: number | null;
  quantity_MIN_EQUAL?: number | null;
  quantity_MIN_GT?: number | null;
  quantity_MIN_GTE?: number | null;
  quantity_MIN_LT?: number | null;
  quantity_MIN_LTE?: number | null;
  quantity_SUM_EQUAL?: number | null;
  quantity_SUM_GT?: number | null;
  quantity_SUM_GTE?: number | null;
  quantity_SUM_LT?: number | null;
  quantity_SUM_LTE?: number | null;
  tenantId_AVERAGE_EQUAL?: number | null;
  tenantId_AVERAGE_GT?: number | null;
  tenantId_AVERAGE_GTE?: number | null;
  tenantId_AVERAGE_LT?: number | null;
  tenantId_AVERAGE_LTE?: number | null;
  tenantId_EQUAL?: string | null;
  tenantId_GT?: number | null;
  tenantId_GTE?: number | null;
  tenantId_LONGEST_EQUAL?: number | null;
  tenantId_LONGEST_GT?: number | null;
  tenantId_LONGEST_GTE?: number | null;
  tenantId_LONGEST_LT?: number | null;
  tenantId_LONGEST_LTE?: number | null;
  tenantId_LT?: number | null;
  tenantId_LTE?: number | null;
  tenantId_SHORTEST_EQUAL?: number | null;
  tenantId_SHORTEST_GT?: number | null;
  tenantId_SHORTEST_GTE?: number | null;
  tenantId_SHORTEST_LT?: number | null;
  tenantId_SHORTEST_LTE?: number | null;
  unlimited_AVERAGE_EQUAL?: number | null;
  unlimited_AVERAGE_GT?: number | null;
  unlimited_AVERAGE_GTE?: number | null;
  unlimited_AVERAGE_LT?: number | null;
  unlimited_AVERAGE_LTE?: number | null;
  unlimited_EQUAL?: number | null;
  unlimited_GT?: number | null;
  unlimited_GTE?: number | null;
  unlimited_LT?: number | null;
  unlimited_LTE?: number | null;
  unlimited_MAX_EQUAL?: number | null;
  unlimited_MAX_GT?: number | null;
  unlimited_MAX_GTE?: number | null;
  unlimited_MAX_LT?: number | null;
  unlimited_MAX_LTE?: number | null;
  unlimited_MIN_EQUAL?: number | null;
  unlimited_MIN_GT?: number | null;
  unlimited_MIN_GTE?: number | null;
  unlimited_MIN_LT?: number | null;
  unlimited_MIN_LTE?: number | null;
  unlimited_SUM_EQUAL?: number | null;
  unlimited_SUM_GT?: number | null;
  unlimited_SUM_GTE?: number | null;
  unlimited_SUM_LT?: number | null;
  unlimited_SUM_LTE?: number | null;
  uuid_AVERAGE_EQUAL?: number | null;
  uuid_AVERAGE_GT?: number | null;
  uuid_AVERAGE_GTE?: number | null;
  uuid_AVERAGE_LT?: number | null;
  uuid_AVERAGE_LTE?: number | null;
  uuid_EQUAL?: string | null;
  uuid_GT?: number | null;
  uuid_GTE?: number | null;
  uuid_LONGEST_EQUAL?: number | null;
  uuid_LONGEST_GT?: number | null;
  uuid_LONGEST_GTE?: number | null;
  uuid_LONGEST_LT?: number | null;
  uuid_LONGEST_LTE?: number | null;
  uuid_LT?: number | null;
  uuid_LTE?: number | null;
  uuid_SHORTEST_EQUAL?: number | null;
  uuid_SHORTEST_GT?: number | null;
  uuid_SHORTEST_GTE?: number | null;
  uuid_SHORTEST_LT?: number | null;
  uuid_SHORTEST_LTE?: number | null;
}

export interface FlexEntityTypeMappingInstancesAggregateInput {
  AND?: FlexEntityTypeMappingInstancesAggregateInput[] | null;
  OR?: FlexEntityTypeMappingInstancesAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  edge?: FlexEntityTypeMappingInstancesEdgeAggregationWhereInput | null;
  node?: FlexEntityTypeMappingInstancesNodeAggregationWhereInput | null;
}

export interface FlexEntityTypeMappingInstancesConnectionWhere {
  AND?: FlexEntityTypeMappingInstancesConnectionWhere[] | null;
  OR?: FlexEntityTypeMappingInstancesConnectionWhere[] | null;
  edge?: EntityTypeMappingRelationshipWhere | null;
  edge_NOT?: EntityTypeMappingRelationshipWhere | null;
  node?: OrganizationWhere | null;
  node_NOT?: OrganizationWhere | null;
}

export interface FlexEntityTypeMappingInstancesEdgeAggregationWhereInput {
  AND?: FlexEntityTypeMappingInstancesEdgeAggregationWhereInput[] | null;
  OR?: FlexEntityTypeMappingInstancesEdgeAggregationWhereInput[] | null;
  data_AVERAGE_EQUAL?: number | null;
  data_AVERAGE_GT?: number | null;
  data_AVERAGE_GTE?: number | null;
  data_AVERAGE_LT?: number | null;
  data_AVERAGE_LTE?: number | null;
  data_EQUAL?: string | null;
  data_GT?: number | null;
  data_GTE?: number | null;
  data_LONGEST_EQUAL?: number | null;
  data_LONGEST_GT?: number | null;
  data_LONGEST_GTE?: number | null;
  data_LONGEST_LT?: number | null;
  data_LONGEST_LTE?: number | null;
  data_LT?: number | null;
  data_LTE?: number | null;
  data_SHORTEST_EQUAL?: number | null;
  data_SHORTEST_GT?: number | null;
  data_SHORTEST_GTE?: number | null;
  data_SHORTEST_LT?: number | null;
  data_SHORTEST_LTE?: number | null;
}

export interface FlexEntityTypeMappingInstancesNodeAggregationWhereInput {
  AND?: FlexEntityTypeMappingInstancesNodeAggregationWhereInput[] | null;
  BIC_AVERAGE_EQUAL?: number | null;
  BIC_AVERAGE_GT?: number | null;
  BIC_AVERAGE_GTE?: number | null;
  BIC_AVERAGE_LT?: number | null;
  BIC_AVERAGE_LTE?: number | null;
  BIC_EQUAL?: string | null;
  BIC_GT?: number | null;
  BIC_GTE?: number | null;
  BIC_LONGEST_EQUAL?: number | null;
  BIC_LONGEST_GT?: number | null;
  BIC_LONGEST_GTE?: number | null;
  BIC_LONGEST_LT?: number | null;
  BIC_LONGEST_LTE?: number | null;
  BIC_LT?: number | null;
  BIC_LTE?: number | null;
  BIC_SHORTEST_EQUAL?: number | null;
  BIC_SHORTEST_GT?: number | null;
  BIC_SHORTEST_GTE?: number | null;
  BIC_SHORTEST_LT?: number | null;
  BIC_SHORTEST_LTE?: number | null;
  IBAN_AVERAGE_EQUAL?: number | null;
  IBAN_AVERAGE_GT?: number | null;
  IBAN_AVERAGE_GTE?: number | null;
  IBAN_AVERAGE_LT?: number | null;
  IBAN_AVERAGE_LTE?: number | null;
  IBAN_EQUAL?: string | null;
  IBAN_GT?: number | null;
  IBAN_GTE?: number | null;
  IBAN_LONGEST_EQUAL?: number | null;
  IBAN_LONGEST_GT?: number | null;
  IBAN_LONGEST_GTE?: number | null;
  IBAN_LONGEST_LT?: number | null;
  IBAN_LONGEST_LTE?: number | null;
  IBAN_LT?: number | null;
  IBAN_LTE?: number | null;
  IBAN_SHORTEST_EQUAL?: number | null;
  IBAN_SHORTEST_GT?: number | null;
  IBAN_SHORTEST_GTE?: number | null;
  IBAN_SHORTEST_LT?: number | null;
  IBAN_SHORTEST_LTE?: number | null;
  OR?: FlexEntityTypeMappingInstancesNodeAggregationWhereInput[] | null;
  accountName_AVERAGE_EQUAL?: number | null;
  accountName_AVERAGE_GT?: number | null;
  accountName_AVERAGE_GTE?: number | null;
  accountName_AVERAGE_LT?: number | null;
  accountName_AVERAGE_LTE?: number | null;
  accountName_EQUAL?: string | null;
  accountName_GT?: number | null;
  accountName_GTE?: number | null;
  accountName_LONGEST_EQUAL?: number | null;
  accountName_LONGEST_GT?: number | null;
  accountName_LONGEST_GTE?: number | null;
  accountName_LONGEST_LT?: number | null;
  accountName_LONGEST_LTE?: number | null;
  accountName_LT?: number | null;
  accountName_LTE?: number | null;
  accountName_SHORTEST_EQUAL?: number | null;
  accountName_SHORTEST_GT?: number | null;
  accountName_SHORTEST_GTE?: number | null;
  accountName_SHORTEST_LT?: number | null;
  accountName_SHORTEST_LTE?: number | null;
  accountNumber_AVERAGE_EQUAL?: number | null;
  accountNumber_AVERAGE_GT?: number | null;
  accountNumber_AVERAGE_GTE?: number | null;
  accountNumber_AVERAGE_LT?: number | null;
  accountNumber_AVERAGE_LTE?: number | null;
  accountNumber_EQUAL?: string | null;
  accountNumber_GT?: number | null;
  accountNumber_GTE?: number | null;
  accountNumber_LONGEST_EQUAL?: number | null;
  accountNumber_LONGEST_GT?: number | null;
  accountNumber_LONGEST_GTE?: number | null;
  accountNumber_LONGEST_LT?: number | null;
  accountNumber_LONGEST_LTE?: number | null;
  accountNumber_LT?: number | null;
  accountNumber_LTE?: number | null;
  accountNumber_SHORTEST_EQUAL?: number | null;
  accountNumber_SHORTEST_GT?: number | null;
  accountNumber_SHORTEST_GTE?: number | null;
  accountNumber_SHORTEST_LT?: number | null;
  accountNumber_SHORTEST_LTE?: number | null;
  billingAddress_AVERAGE_EQUAL?: number | null;
  billingAddress_AVERAGE_GT?: number | null;
  billingAddress_AVERAGE_GTE?: number | null;
  billingAddress_AVERAGE_LT?: number | null;
  billingAddress_AVERAGE_LTE?: number | null;
  billingAddress_EQUAL?: string | null;
  billingAddress_GT?: number | null;
  billingAddress_GTE?: number | null;
  billingAddress_LONGEST_EQUAL?: number | null;
  billingAddress_LONGEST_GT?: number | null;
  billingAddress_LONGEST_GTE?: number | null;
  billingAddress_LONGEST_LT?: number | null;
  billingAddress_LONGEST_LTE?: number | null;
  billingAddress_LT?: number | null;
  billingAddress_LTE?: number | null;
  billingAddress_SHORTEST_EQUAL?: number | null;
  billingAddress_SHORTEST_GT?: number | null;
  billingAddress_SHORTEST_GTE?: number | null;
  billingAddress_SHORTEST_LT?: number | null;
  billingAddress_SHORTEST_LTE?: number | null;
  contactEmail_AVERAGE_EQUAL?: number | null;
  contactEmail_AVERAGE_GT?: number | null;
  contactEmail_AVERAGE_GTE?: number | null;
  contactEmail_AVERAGE_LT?: number | null;
  contactEmail_AVERAGE_LTE?: number | null;
  contactEmail_EQUAL?: string | null;
  contactEmail_GT?: number | null;
  contactEmail_GTE?: number | null;
  contactEmail_LONGEST_EQUAL?: number | null;
  contactEmail_LONGEST_GT?: number | null;
  contactEmail_LONGEST_GTE?: number | null;
  contactEmail_LONGEST_LT?: number | null;
  contactEmail_LONGEST_LTE?: number | null;
  contactEmail_LT?: number | null;
  contactEmail_LTE?: number | null;
  contactEmail_SHORTEST_EQUAL?: number | null;
  contactEmail_SHORTEST_GT?: number | null;
  contactEmail_SHORTEST_GTE?: number | null;
  contactEmail_SHORTEST_LT?: number | null;
  contactEmail_SHORTEST_LTE?: number | null;
  contactFirstName_AVERAGE_EQUAL?: number | null;
  contactFirstName_AVERAGE_GT?: number | null;
  contactFirstName_AVERAGE_GTE?: number | null;
  contactFirstName_AVERAGE_LT?: number | null;
  contactFirstName_AVERAGE_LTE?: number | null;
  contactFirstName_EQUAL?: string | null;
  contactFirstName_GT?: number | null;
  contactFirstName_GTE?: number | null;
  contactFirstName_LONGEST_EQUAL?: number | null;
  contactFirstName_LONGEST_GT?: number | null;
  contactFirstName_LONGEST_GTE?: number | null;
  contactFirstName_LONGEST_LT?: number | null;
  contactFirstName_LONGEST_LTE?: number | null;
  contactFirstName_LT?: number | null;
  contactFirstName_LTE?: number | null;
  contactFirstName_SHORTEST_EQUAL?: number | null;
  contactFirstName_SHORTEST_GT?: number | null;
  contactFirstName_SHORTEST_GTE?: number | null;
  contactFirstName_SHORTEST_LT?: number | null;
  contactFirstName_SHORTEST_LTE?: number | null;
  contactLastName_AVERAGE_EQUAL?: number | null;
  contactLastName_AVERAGE_GT?: number | null;
  contactLastName_AVERAGE_GTE?: number | null;
  contactLastName_AVERAGE_LT?: number | null;
  contactLastName_AVERAGE_LTE?: number | null;
  contactLastName_EQUAL?: string | null;
  contactLastName_GT?: number | null;
  contactLastName_GTE?: number | null;
  contactLastName_LONGEST_EQUAL?: number | null;
  contactLastName_LONGEST_GT?: number | null;
  contactLastName_LONGEST_GTE?: number | null;
  contactLastName_LONGEST_LT?: number | null;
  contactLastName_LONGEST_LTE?: number | null;
  contactLastName_LT?: number | null;
  contactLastName_LTE?: number | null;
  contactLastName_SHORTEST_EQUAL?: number | null;
  contactLastName_SHORTEST_GT?: number | null;
  contactLastName_SHORTEST_GTE?: number | null;
  contactLastName_SHORTEST_LT?: number | null;
  contactLastName_SHORTEST_LTE?: number | null;
  contactOccupation_AVERAGE_EQUAL?: number | null;
  contactOccupation_AVERAGE_GT?: number | null;
  contactOccupation_AVERAGE_GTE?: number | null;
  contactOccupation_AVERAGE_LT?: number | null;
  contactOccupation_AVERAGE_LTE?: number | null;
  contactOccupation_EQUAL?: string | null;
  contactOccupation_GT?: number | null;
  contactOccupation_GTE?: number | null;
  contactOccupation_LONGEST_EQUAL?: number | null;
  contactOccupation_LONGEST_GT?: number | null;
  contactOccupation_LONGEST_GTE?: number | null;
  contactOccupation_LONGEST_LT?: number | null;
  contactOccupation_LONGEST_LTE?: number | null;
  contactOccupation_LT?: number | null;
  contactOccupation_LTE?: number | null;
  contactOccupation_SHORTEST_EQUAL?: number | null;
  contactOccupation_SHORTEST_GT?: number | null;
  contactOccupation_SHORTEST_GTE?: number | null;
  contactOccupation_SHORTEST_LT?: number | null;
  contactOccupation_SHORTEST_LTE?: number | null;
  contactPhone_AVERAGE_EQUAL?: number | null;
  contactPhone_AVERAGE_GT?: number | null;
  contactPhone_AVERAGE_GTE?: number | null;
  contactPhone_AVERAGE_LT?: number | null;
  contactPhone_AVERAGE_LTE?: number | null;
  contactPhone_EQUAL?: string | null;
  contactPhone_GT?: number | null;
  contactPhone_GTE?: number | null;
  contactPhone_LONGEST_EQUAL?: number | null;
  contactPhone_LONGEST_GT?: number | null;
  contactPhone_LONGEST_GTE?: number | null;
  contactPhone_LONGEST_LT?: number | null;
  contactPhone_LONGEST_LTE?: number | null;
  contactPhone_LT?: number | null;
  contactPhone_LTE?: number | null;
  contactPhone_SHORTEST_EQUAL?: number | null;
  contactPhone_SHORTEST_GT?: number | null;
  contactPhone_SHORTEST_GTE?: number | null;
  contactPhone_SHORTEST_LT?: number | null;
  contactPhone_SHORTEST_LTE?: number | null;
  createdOn_AVERAGE_EQUAL?: number | null;
  createdOn_AVERAGE_GT?: number | null;
  createdOn_AVERAGE_GTE?: number | null;
  createdOn_AVERAGE_LT?: number | null;
  createdOn_AVERAGE_LTE?: number | null;
  createdOn_EQUAL?: number | null;
  createdOn_GT?: number | null;
  createdOn_GTE?: number | null;
  createdOn_LT?: number | null;
  createdOn_LTE?: number | null;
  createdOn_MAX_EQUAL?: number | null;
  createdOn_MAX_GT?: number | null;
  createdOn_MAX_GTE?: number | null;
  createdOn_MAX_LT?: number | null;
  createdOn_MAX_LTE?: number | null;
  createdOn_MIN_EQUAL?: number | null;
  createdOn_MIN_GT?: number | null;
  createdOn_MIN_GTE?: number | null;
  createdOn_MIN_LT?: number | null;
  createdOn_MIN_LTE?: number | null;
  createdOn_SUM_EQUAL?: number | null;
  createdOn_SUM_GT?: number | null;
  createdOn_SUM_GTE?: number | null;
  createdOn_SUM_LT?: number | null;
  createdOn_SUM_LTE?: number | null;
  deliveryAddress_AVERAGE_EQUAL?: number | null;
  deliveryAddress_AVERAGE_GT?: number | null;
  deliveryAddress_AVERAGE_GTE?: number | null;
  deliveryAddress_AVERAGE_LT?: number | null;
  deliveryAddress_AVERAGE_LTE?: number | null;
  deliveryAddress_EQUAL?: string | null;
  deliveryAddress_GT?: number | null;
  deliveryAddress_GTE?: number | null;
  deliveryAddress_LONGEST_EQUAL?: number | null;
  deliveryAddress_LONGEST_GT?: number | null;
  deliveryAddress_LONGEST_GTE?: number | null;
  deliveryAddress_LONGEST_LT?: number | null;
  deliveryAddress_LONGEST_LTE?: number | null;
  deliveryAddress_LT?: number | null;
  deliveryAddress_LTE?: number | null;
  deliveryAddress_SHORTEST_EQUAL?: number | null;
  deliveryAddress_SHORTEST_GT?: number | null;
  deliveryAddress_SHORTEST_GTE?: number | null;
  deliveryAddress_SHORTEST_LT?: number | null;
  deliveryAddress_SHORTEST_LTE?: number | null;
  domicile_AVERAGE_EQUAL?: number | null;
  domicile_AVERAGE_GT?: number | null;
  domicile_AVERAGE_GTE?: number | null;
  domicile_AVERAGE_LT?: number | null;
  domicile_AVERAGE_LTE?: number | null;
  domicile_EQUAL?: string | null;
  domicile_GT?: number | null;
  domicile_GTE?: number | null;
  domicile_LONGEST_EQUAL?: number | null;
  domicile_LONGEST_GT?: number | null;
  domicile_LONGEST_GTE?: number | null;
  domicile_LONGEST_LT?: number | null;
  domicile_LONGEST_LTE?: number | null;
  domicile_LT?: number | null;
  domicile_LTE?: number | null;
  domicile_SHORTEST_EQUAL?: number | null;
  domicile_SHORTEST_GT?: number | null;
  domicile_SHORTEST_GTE?: number | null;
  domicile_SHORTEST_LT?: number | null;
  domicile_SHORTEST_LTE?: number | null;
  dualApprovalThreshold_AVERAGE_EQUAL?: number | null;
  dualApprovalThreshold_AVERAGE_GT?: number | null;
  dualApprovalThreshold_AVERAGE_GTE?: number | null;
  dualApprovalThreshold_AVERAGE_LT?: number | null;
  dualApprovalThreshold_AVERAGE_LTE?: number | null;
  dualApprovalThreshold_EQUAL?: number | null;
  dualApprovalThreshold_GT?: number | null;
  dualApprovalThreshold_GTE?: number | null;
  dualApprovalThreshold_LT?: number | null;
  dualApprovalThreshold_LTE?: number | null;
  dualApprovalThreshold_MAX_EQUAL?: number | null;
  dualApprovalThreshold_MAX_GT?: number | null;
  dualApprovalThreshold_MAX_GTE?: number | null;
  dualApprovalThreshold_MAX_LT?: number | null;
  dualApprovalThreshold_MAX_LTE?: number | null;
  dualApprovalThreshold_MIN_EQUAL?: number | null;
  dualApprovalThreshold_MIN_GT?: number | null;
  dualApprovalThreshold_MIN_GTE?: number | null;
  dualApprovalThreshold_MIN_LT?: number | null;
  dualApprovalThreshold_MIN_LTE?: number | null;
  dualApprovalThreshold_SUM_EQUAL?: number | null;
  dualApprovalThreshold_SUM_GT?: number | null;
  dualApprovalThreshold_SUM_GTE?: number | null;
  dualApprovalThreshold_SUM_LT?: number | null;
  dualApprovalThreshold_SUM_LTE?: number | null;
  eIN_AVERAGE_EQUAL?: number | null;
  eIN_AVERAGE_GT?: number | null;
  eIN_AVERAGE_GTE?: number | null;
  eIN_AVERAGE_LT?: number | null;
  eIN_AVERAGE_LTE?: number | null;
  eIN_EQUAL?: string | null;
  eIN_GT?: number | null;
  eIN_GTE?: number | null;
  eIN_LONGEST_EQUAL?: number | null;
  eIN_LONGEST_GT?: number | null;
  eIN_LONGEST_GTE?: number | null;
  eIN_LONGEST_LT?: number | null;
  eIN_LONGEST_LTE?: number | null;
  eIN_LT?: number | null;
  eIN_LTE?: number | null;
  eIN_SHORTEST_EQUAL?: number | null;
  eIN_SHORTEST_GT?: number | null;
  eIN_SHORTEST_GTE?: number | null;
  eIN_SHORTEST_LT?: number | null;
  eIN_SHORTEST_LTE?: number | null;
  fax_AVERAGE_EQUAL?: number | null;
  fax_AVERAGE_GT?: number | null;
  fax_AVERAGE_GTE?: number | null;
  fax_AVERAGE_LT?: number | null;
  fax_AVERAGE_LTE?: number | null;
  fax_EQUAL?: string | null;
  fax_GT?: number | null;
  fax_GTE?: number | null;
  fax_LONGEST_EQUAL?: number | null;
  fax_LONGEST_GT?: number | null;
  fax_LONGEST_GTE?: number | null;
  fax_LONGEST_LT?: number | null;
  fax_LONGEST_LTE?: number | null;
  fax_LT?: number | null;
  fax_LTE?: number | null;
  fax_SHORTEST_EQUAL?: number | null;
  fax_SHORTEST_GT?: number | null;
  fax_SHORTEST_GTE?: number | null;
  fax_SHORTEST_LT?: number | null;
  fax_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  legalName_AVERAGE_EQUAL?: number | null;
  legalName_AVERAGE_GT?: number | null;
  legalName_AVERAGE_GTE?: number | null;
  legalName_AVERAGE_LT?: number | null;
  legalName_AVERAGE_LTE?: number | null;
  legalName_EQUAL?: string | null;
  legalName_GT?: number | null;
  legalName_GTE?: number | null;
  legalName_LONGEST_EQUAL?: number | null;
  legalName_LONGEST_GT?: number | null;
  legalName_LONGEST_GTE?: number | null;
  legalName_LONGEST_LT?: number | null;
  legalName_LONGEST_LTE?: number | null;
  legalName_LT?: number | null;
  legalName_LTE?: number | null;
  legalName_SHORTEST_EQUAL?: number | null;
  legalName_SHORTEST_GT?: number | null;
  legalName_SHORTEST_GTE?: number | null;
  legalName_SHORTEST_LT?: number | null;
  legalName_SHORTEST_LTE?: number | null;
  logo_AVERAGE_EQUAL?: number | null;
  logo_AVERAGE_GT?: number | null;
  logo_AVERAGE_GTE?: number | null;
  logo_AVERAGE_LT?: number | null;
  logo_AVERAGE_LTE?: number | null;
  logo_EQUAL?: string | null;
  logo_GT?: number | null;
  logo_GTE?: number | null;
  logo_LONGEST_EQUAL?: number | null;
  logo_LONGEST_GT?: number | null;
  logo_LONGEST_GTE?: number | null;
  logo_LONGEST_LT?: number | null;
  logo_LONGEST_LTE?: number | null;
  logo_LT?: number | null;
  logo_LTE?: number | null;
  logo_SHORTEST_EQUAL?: number | null;
  logo_SHORTEST_GT?: number | null;
  logo_SHORTEST_GTE?: number | null;
  logo_SHORTEST_LT?: number | null;
  logo_SHORTEST_LTE?: number | null;
  name_AVERAGE_EQUAL?: number | null;
  name_AVERAGE_GT?: number | null;
  name_AVERAGE_GTE?: number | null;
  name_AVERAGE_LT?: number | null;
  name_AVERAGE_LTE?: number | null;
  name_EQUAL?: string | null;
  name_GT?: number | null;
  name_GTE?: number | null;
  name_LONGEST_EQUAL?: number | null;
  name_LONGEST_GT?: number | null;
  name_LONGEST_GTE?: number | null;
  name_LONGEST_LT?: number | null;
  name_LONGEST_LTE?: number | null;
  name_LT?: number | null;
  name_LTE?: number | null;
  name_SHORTEST_EQUAL?: number | null;
  name_SHORTEST_GT?: number | null;
  name_SHORTEST_GTE?: number | null;
  name_SHORTEST_LT?: number | null;
  name_SHORTEST_LTE?: number | null;
  paymentTerms_AVERAGE_EQUAL?: number | null;
  paymentTerms_AVERAGE_GT?: number | null;
  paymentTerms_AVERAGE_GTE?: number | null;
  paymentTerms_AVERAGE_LT?: number | null;
  paymentTerms_AVERAGE_LTE?: number | null;
  paymentTerms_EQUAL?: number | null;
  paymentTerms_GT?: number | null;
  paymentTerms_GTE?: number | null;
  paymentTerms_LT?: number | null;
  paymentTerms_LTE?: number | null;
  paymentTerms_MAX_EQUAL?: number | null;
  paymentTerms_MAX_GT?: number | null;
  paymentTerms_MAX_GTE?: number | null;
  paymentTerms_MAX_LT?: number | null;
  paymentTerms_MAX_LTE?: number | null;
  paymentTerms_MIN_EQUAL?: number | null;
  paymentTerms_MIN_GT?: number | null;
  paymentTerms_MIN_GTE?: number | null;
  paymentTerms_MIN_LT?: number | null;
  paymentTerms_MIN_LTE?: number | null;
  paymentTerms_SUM_EQUAL?: number | null;
  paymentTerms_SUM_GT?: number | null;
  paymentTerms_SUM_GTE?: number | null;
  paymentTerms_SUM_LT?: number | null;
  paymentTerms_SUM_LTE?: number | null;
  phone_AVERAGE_EQUAL?: number | null;
  phone_AVERAGE_GT?: number | null;
  phone_AVERAGE_GTE?: number | null;
  phone_AVERAGE_LT?: number | null;
  phone_AVERAGE_LTE?: number | null;
  phone_EQUAL?: string | null;
  phone_GT?: number | null;
  phone_GTE?: number | null;
  phone_LONGEST_EQUAL?: number | null;
  phone_LONGEST_GT?: number | null;
  phone_LONGEST_GTE?: number | null;
  phone_LONGEST_LT?: number | null;
  phone_LONGEST_LTE?: number | null;
  phone_LT?: number | null;
  phone_LTE?: number | null;
  phone_SHORTEST_EQUAL?: number | null;
  phone_SHORTEST_GT?: number | null;
  phone_SHORTEST_GTE?: number | null;
  phone_SHORTEST_LT?: number | null;
  phone_SHORTEST_LTE?: number | null;
  tenantId_AVERAGE_EQUAL?: number | null;
  tenantId_AVERAGE_GT?: number | null;
  tenantId_AVERAGE_GTE?: number | null;
  tenantId_AVERAGE_LT?: number | null;
  tenantId_AVERAGE_LTE?: number | null;
  tenantId_EQUAL?: string | null;
  tenantId_GT?: number | null;
  tenantId_GTE?: number | null;
  tenantId_LONGEST_EQUAL?: number | null;
  tenantId_LONGEST_GT?: number | null;
  tenantId_LONGEST_GTE?: number | null;
  tenantId_LONGEST_LT?: number | null;
  tenantId_LONGEST_LTE?: number | null;
  tenantId_LT?: number | null;
  tenantId_LTE?: number | null;
  tenantId_SHORTEST_EQUAL?: number | null;
  tenantId_SHORTEST_GT?: number | null;
  tenantId_SHORTEST_GTE?: number | null;
  tenantId_SHORTEST_LT?: number | null;
  tenantId_SHORTEST_LTE?: number | null;
  website_AVERAGE_EQUAL?: number | null;
  website_AVERAGE_GT?: number | null;
  website_AVERAGE_GTE?: number | null;
  website_AVERAGE_LT?: number | null;
  website_AVERAGE_LTE?: number | null;
  website_EQUAL?: string | null;
  website_GT?: number | null;
  website_GTE?: number | null;
  website_LONGEST_EQUAL?: number | null;
  website_LONGEST_GT?: number | null;
  website_LONGEST_GTE?: number | null;
  website_LONGEST_LT?: number | null;
  website_LONGEST_LTE?: number | null;
  website_LT?: number | null;
  website_LTE?: number | null;
  website_SHORTEST_EQUAL?: number | null;
  website_SHORTEST_GT?: number | null;
  website_SHORTEST_GTE?: number | null;
  website_SHORTEST_LT?: number | null;
  website_SHORTEST_LTE?: number | null;
}

export interface FlexEntityTypeNodeAggregationWhereInput {
  AND?: FlexEntityTypeNodeAggregationWhereInput[] | null;
  OR?: FlexEntityTypeNodeAggregationWhereInput[] | null;
  addedByName_AVERAGE_EQUAL?: number | null;
  addedByName_AVERAGE_GT?: number | null;
  addedByName_AVERAGE_GTE?: number | null;
  addedByName_AVERAGE_LT?: number | null;
  addedByName_AVERAGE_LTE?: number | null;
  addedByName_EQUAL?: string | null;
  addedByName_GT?: number | null;
  addedByName_GTE?: number | null;
  addedByName_LONGEST_EQUAL?: number | null;
  addedByName_LONGEST_GT?: number | null;
  addedByName_LONGEST_GTE?: number | null;
  addedByName_LONGEST_LT?: number | null;
  addedByName_LONGEST_LTE?: number | null;
  addedByName_LT?: number | null;
  addedByName_LTE?: number | null;
  addedByName_SHORTEST_EQUAL?: number | null;
  addedByName_SHORTEST_GT?: number | null;
  addedByName_SHORTEST_GTE?: number | null;
  addedByName_SHORTEST_LT?: number | null;
  addedByName_SHORTEST_LTE?: number | null;
  attributeCount_AVERAGE_EQUAL?: number | null;
  attributeCount_AVERAGE_GT?: number | null;
  attributeCount_AVERAGE_GTE?: number | null;
  attributeCount_AVERAGE_LT?: number | null;
  attributeCount_AVERAGE_LTE?: number | null;
  attributeCount_EQUAL?: number | null;
  attributeCount_GT?: number | null;
  attributeCount_GTE?: number | null;
  attributeCount_LT?: number | null;
  attributeCount_LTE?: number | null;
  attributeCount_MAX_EQUAL?: number | null;
  attributeCount_MAX_GT?: number | null;
  attributeCount_MAX_GTE?: number | null;
  attributeCount_MAX_LT?: number | null;
  attributeCount_MAX_LTE?: number | null;
  attributeCount_MIN_EQUAL?: number | null;
  attributeCount_MIN_GT?: number | null;
  attributeCount_MIN_GTE?: number | null;
  attributeCount_MIN_LT?: number | null;
  attributeCount_MIN_LTE?: number | null;
  attributeCount_SUM_EQUAL?: number | null;
  attributeCount_SUM_GT?: number | null;
  attributeCount_SUM_GTE?: number | null;
  attributeCount_SUM_LT?: number | null;
  attributeCount_SUM_LTE?: number | null;
  createdOn_EQUAL?: any | null;
  createdOn_GT?: any | null;
  createdOn_GTE?: any | null;
  createdOn_LT?: any | null;
  createdOn_LTE?: any | null;
  createdOn_MAX_EQUAL?: any | null;
  createdOn_MAX_GT?: any | null;
  createdOn_MAX_GTE?: any | null;
  createdOn_MAX_LT?: any | null;
  createdOn_MAX_LTE?: any | null;
  createdOn_MIN_EQUAL?: any | null;
  createdOn_MIN_GT?: any | null;
  createdOn_MIN_GTE?: any | null;
  createdOn_MIN_LT?: any | null;
  createdOn_MIN_LTE?: any | null;
  data_AVERAGE_EQUAL?: number | null;
  data_AVERAGE_GT?: number | null;
  data_AVERAGE_GTE?: number | null;
  data_AVERAGE_LT?: number | null;
  data_AVERAGE_LTE?: number | null;
  data_EQUAL?: string | null;
  data_GT?: number | null;
  data_GTE?: number | null;
  data_LONGEST_EQUAL?: number | null;
  data_LONGEST_GT?: number | null;
  data_LONGEST_GTE?: number | null;
  data_LONGEST_LT?: number | null;
  data_LONGEST_LTE?: number | null;
  data_LT?: number | null;
  data_LTE?: number | null;
  data_SHORTEST_EQUAL?: number | null;
  data_SHORTEST_GT?: number | null;
  data_SHORTEST_GTE?: number | null;
  data_SHORTEST_LT?: number | null;
  data_SHORTEST_LTE?: number | null;
  description_AVERAGE_EQUAL?: number | null;
  description_AVERAGE_GT?: number | null;
  description_AVERAGE_GTE?: number | null;
  description_AVERAGE_LT?: number | null;
  description_AVERAGE_LTE?: number | null;
  description_EQUAL?: string | null;
  description_GT?: number | null;
  description_GTE?: number | null;
  description_LONGEST_EQUAL?: number | null;
  description_LONGEST_GT?: number | null;
  description_LONGEST_GTE?: number | null;
  description_LONGEST_LT?: number | null;
  description_LONGEST_LTE?: number | null;
  description_LT?: number | null;
  description_LTE?: number | null;
  description_SHORTEST_EQUAL?: number | null;
  description_SHORTEST_GT?: number | null;
  description_SHORTEST_GTE?: number | null;
  description_SHORTEST_LT?: number | null;
  description_SHORTEST_LTE?: number | null;
  idPrefix_AVERAGE_EQUAL?: number | null;
  idPrefix_AVERAGE_GT?: number | null;
  idPrefix_AVERAGE_GTE?: number | null;
  idPrefix_AVERAGE_LT?: number | null;
  idPrefix_AVERAGE_LTE?: number | null;
  idPrefix_EQUAL?: string | null;
  idPrefix_GT?: number | null;
  idPrefix_GTE?: number | null;
  idPrefix_LONGEST_EQUAL?: number | null;
  idPrefix_LONGEST_GT?: number | null;
  idPrefix_LONGEST_GTE?: number | null;
  idPrefix_LONGEST_LT?: number | null;
  idPrefix_LONGEST_LTE?: number | null;
  idPrefix_LT?: number | null;
  idPrefix_LTE?: number | null;
  idPrefix_SHORTEST_EQUAL?: number | null;
  idPrefix_SHORTEST_GT?: number | null;
  idPrefix_SHORTEST_GTE?: number | null;
  idPrefix_SHORTEST_LT?: number | null;
  idPrefix_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  localizationKey_AVERAGE_EQUAL?: number | null;
  localizationKey_AVERAGE_GT?: number | null;
  localizationKey_AVERAGE_GTE?: number | null;
  localizationKey_AVERAGE_LT?: number | null;
  localizationKey_AVERAGE_LTE?: number | null;
  localizationKey_EQUAL?: string | null;
  localizationKey_GT?: number | null;
  localizationKey_GTE?: number | null;
  localizationKey_LONGEST_EQUAL?: number | null;
  localizationKey_LONGEST_GT?: number | null;
  localizationKey_LONGEST_GTE?: number | null;
  localizationKey_LONGEST_LT?: number | null;
  localizationKey_LONGEST_LTE?: number | null;
  localizationKey_LT?: number | null;
  localizationKey_LTE?: number | null;
  localizationKey_SHORTEST_EQUAL?: number | null;
  localizationKey_SHORTEST_GT?: number | null;
  localizationKey_SHORTEST_GTE?: number | null;
  localizationKey_SHORTEST_LT?: number | null;
  localizationKey_SHORTEST_LTE?: number | null;
  name_AVERAGE_EQUAL?: number | null;
  name_AVERAGE_GT?: number | null;
  name_AVERAGE_GTE?: number | null;
  name_AVERAGE_LT?: number | null;
  name_AVERAGE_LTE?: number | null;
  name_EQUAL?: string | null;
  name_GT?: number | null;
  name_GTE?: number | null;
  name_LONGEST_EQUAL?: number | null;
  name_LONGEST_GT?: number | null;
  name_LONGEST_GTE?: number | null;
  name_LONGEST_LT?: number | null;
  name_LONGEST_LTE?: number | null;
  name_LT?: number | null;
  name_LTE?: number | null;
  name_SHORTEST_EQUAL?: number | null;
  name_SHORTEST_GT?: number | null;
  name_SHORTEST_GTE?: number | null;
  name_SHORTEST_LT?: number | null;
  name_SHORTEST_LTE?: number | null;
  tooltipText_AVERAGE_EQUAL?: number | null;
  tooltipText_AVERAGE_GT?: number | null;
  tooltipText_AVERAGE_GTE?: number | null;
  tooltipText_AVERAGE_LT?: number | null;
  tooltipText_AVERAGE_LTE?: number | null;
  tooltipText_EQUAL?: string | null;
  tooltipText_GT?: number | null;
  tooltipText_GTE?: number | null;
  tooltipText_LONGEST_EQUAL?: number | null;
  tooltipText_LONGEST_GT?: number | null;
  tooltipText_LONGEST_GTE?: number | null;
  tooltipText_LONGEST_LT?: number | null;
  tooltipText_LONGEST_LTE?: number | null;
  tooltipText_LT?: number | null;
  tooltipText_LTE?: number | null;
  tooltipText_SHORTEST_EQUAL?: number | null;
  tooltipText_SHORTEST_GT?: number | null;
  tooltipText_SHORTEST_GTE?: number | null;
  tooltipText_SHORTEST_LT?: number | null;
  tooltipText_SHORTEST_LTE?: number | null;
}

export interface FlexEntityTypeRecordTypesAggregateInput {
  AND?: FlexEntityTypeRecordTypesAggregateInput[] | null;
  OR?: FlexEntityTypeRecordTypesAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: FlexEntityTypeRecordTypesNodeAggregationWhereInput | null;
}

export interface FlexEntityTypeRecordTypesConnectionWhere {
  AND?: FlexEntityTypeRecordTypesConnectionWhere[] | null;
  OR?: FlexEntityTypeRecordTypesConnectionWhere[] | null;
  node?: FlexEntityTypeWhere | null;
  node_NOT?: FlexEntityTypeWhere | null;
}

export interface FlexEntityTypeRecordTypesNodeAggregationWhereInput {
  AND?: FlexEntityTypeRecordTypesNodeAggregationWhereInput[] | null;
  OR?: FlexEntityTypeRecordTypesNodeAggregationWhereInput[] | null;
  addedByName_AVERAGE_EQUAL?: number | null;
  addedByName_AVERAGE_GT?: number | null;
  addedByName_AVERAGE_GTE?: number | null;
  addedByName_AVERAGE_LT?: number | null;
  addedByName_AVERAGE_LTE?: number | null;
  addedByName_EQUAL?: string | null;
  addedByName_GT?: number | null;
  addedByName_GTE?: number | null;
  addedByName_LONGEST_EQUAL?: number | null;
  addedByName_LONGEST_GT?: number | null;
  addedByName_LONGEST_GTE?: number | null;
  addedByName_LONGEST_LT?: number | null;
  addedByName_LONGEST_LTE?: number | null;
  addedByName_LT?: number | null;
  addedByName_LTE?: number | null;
  addedByName_SHORTEST_EQUAL?: number | null;
  addedByName_SHORTEST_GT?: number | null;
  addedByName_SHORTEST_GTE?: number | null;
  addedByName_SHORTEST_LT?: number | null;
  addedByName_SHORTEST_LTE?: number | null;
  attributeCount_AVERAGE_EQUAL?: number | null;
  attributeCount_AVERAGE_GT?: number | null;
  attributeCount_AVERAGE_GTE?: number | null;
  attributeCount_AVERAGE_LT?: number | null;
  attributeCount_AVERAGE_LTE?: number | null;
  attributeCount_EQUAL?: number | null;
  attributeCount_GT?: number | null;
  attributeCount_GTE?: number | null;
  attributeCount_LT?: number | null;
  attributeCount_LTE?: number | null;
  attributeCount_MAX_EQUAL?: number | null;
  attributeCount_MAX_GT?: number | null;
  attributeCount_MAX_GTE?: number | null;
  attributeCount_MAX_LT?: number | null;
  attributeCount_MAX_LTE?: number | null;
  attributeCount_MIN_EQUAL?: number | null;
  attributeCount_MIN_GT?: number | null;
  attributeCount_MIN_GTE?: number | null;
  attributeCount_MIN_LT?: number | null;
  attributeCount_MIN_LTE?: number | null;
  attributeCount_SUM_EQUAL?: number | null;
  attributeCount_SUM_GT?: number | null;
  attributeCount_SUM_GTE?: number | null;
  attributeCount_SUM_LT?: number | null;
  attributeCount_SUM_LTE?: number | null;
  createdOn_EQUAL?: any | null;
  createdOn_GT?: any | null;
  createdOn_GTE?: any | null;
  createdOn_LT?: any | null;
  createdOn_LTE?: any | null;
  createdOn_MAX_EQUAL?: any | null;
  createdOn_MAX_GT?: any | null;
  createdOn_MAX_GTE?: any | null;
  createdOn_MAX_LT?: any | null;
  createdOn_MAX_LTE?: any | null;
  createdOn_MIN_EQUAL?: any | null;
  createdOn_MIN_GT?: any | null;
  createdOn_MIN_GTE?: any | null;
  createdOn_MIN_LT?: any | null;
  createdOn_MIN_LTE?: any | null;
  data_AVERAGE_EQUAL?: number | null;
  data_AVERAGE_GT?: number | null;
  data_AVERAGE_GTE?: number | null;
  data_AVERAGE_LT?: number | null;
  data_AVERAGE_LTE?: number | null;
  data_EQUAL?: string | null;
  data_GT?: number | null;
  data_GTE?: number | null;
  data_LONGEST_EQUAL?: number | null;
  data_LONGEST_GT?: number | null;
  data_LONGEST_GTE?: number | null;
  data_LONGEST_LT?: number | null;
  data_LONGEST_LTE?: number | null;
  data_LT?: number | null;
  data_LTE?: number | null;
  data_SHORTEST_EQUAL?: number | null;
  data_SHORTEST_GT?: number | null;
  data_SHORTEST_GTE?: number | null;
  data_SHORTEST_LT?: number | null;
  data_SHORTEST_LTE?: number | null;
  description_AVERAGE_EQUAL?: number | null;
  description_AVERAGE_GT?: number | null;
  description_AVERAGE_GTE?: number | null;
  description_AVERAGE_LT?: number | null;
  description_AVERAGE_LTE?: number | null;
  description_EQUAL?: string | null;
  description_GT?: number | null;
  description_GTE?: number | null;
  description_LONGEST_EQUAL?: number | null;
  description_LONGEST_GT?: number | null;
  description_LONGEST_GTE?: number | null;
  description_LONGEST_LT?: number | null;
  description_LONGEST_LTE?: number | null;
  description_LT?: number | null;
  description_LTE?: number | null;
  description_SHORTEST_EQUAL?: number | null;
  description_SHORTEST_GT?: number | null;
  description_SHORTEST_GTE?: number | null;
  description_SHORTEST_LT?: number | null;
  description_SHORTEST_LTE?: number | null;
  idPrefix_AVERAGE_EQUAL?: number | null;
  idPrefix_AVERAGE_GT?: number | null;
  idPrefix_AVERAGE_GTE?: number | null;
  idPrefix_AVERAGE_LT?: number | null;
  idPrefix_AVERAGE_LTE?: number | null;
  idPrefix_EQUAL?: string | null;
  idPrefix_GT?: number | null;
  idPrefix_GTE?: number | null;
  idPrefix_LONGEST_EQUAL?: number | null;
  idPrefix_LONGEST_GT?: number | null;
  idPrefix_LONGEST_GTE?: number | null;
  idPrefix_LONGEST_LT?: number | null;
  idPrefix_LONGEST_LTE?: number | null;
  idPrefix_LT?: number | null;
  idPrefix_LTE?: number | null;
  idPrefix_SHORTEST_EQUAL?: number | null;
  idPrefix_SHORTEST_GT?: number | null;
  idPrefix_SHORTEST_GTE?: number | null;
  idPrefix_SHORTEST_LT?: number | null;
  idPrefix_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  localizationKey_AVERAGE_EQUAL?: number | null;
  localizationKey_AVERAGE_GT?: number | null;
  localizationKey_AVERAGE_GTE?: number | null;
  localizationKey_AVERAGE_LT?: number | null;
  localizationKey_AVERAGE_LTE?: number | null;
  localizationKey_EQUAL?: string | null;
  localizationKey_GT?: number | null;
  localizationKey_GTE?: number | null;
  localizationKey_LONGEST_EQUAL?: number | null;
  localizationKey_LONGEST_GT?: number | null;
  localizationKey_LONGEST_GTE?: number | null;
  localizationKey_LONGEST_LT?: number | null;
  localizationKey_LONGEST_LTE?: number | null;
  localizationKey_LT?: number | null;
  localizationKey_LTE?: number | null;
  localizationKey_SHORTEST_EQUAL?: number | null;
  localizationKey_SHORTEST_GT?: number | null;
  localizationKey_SHORTEST_GTE?: number | null;
  localizationKey_SHORTEST_LT?: number | null;
  localizationKey_SHORTEST_LTE?: number | null;
  name_AVERAGE_EQUAL?: number | null;
  name_AVERAGE_GT?: number | null;
  name_AVERAGE_GTE?: number | null;
  name_AVERAGE_LT?: number | null;
  name_AVERAGE_LTE?: number | null;
  name_EQUAL?: string | null;
  name_GT?: number | null;
  name_GTE?: number | null;
  name_LONGEST_EQUAL?: number | null;
  name_LONGEST_GT?: number | null;
  name_LONGEST_GTE?: number | null;
  name_LONGEST_LT?: number | null;
  name_LONGEST_LTE?: number | null;
  name_LT?: number | null;
  name_LTE?: number | null;
  name_SHORTEST_EQUAL?: number | null;
  name_SHORTEST_GT?: number | null;
  name_SHORTEST_GTE?: number | null;
  name_SHORTEST_LT?: number | null;
  name_SHORTEST_LTE?: number | null;
  tooltipText_AVERAGE_EQUAL?: number | null;
  tooltipText_AVERAGE_GT?: number | null;
  tooltipText_AVERAGE_GTE?: number | null;
  tooltipText_AVERAGE_LT?: number | null;
  tooltipText_AVERAGE_LTE?: number | null;
  tooltipText_EQUAL?: string | null;
  tooltipText_GT?: number | null;
  tooltipText_GTE?: number | null;
  tooltipText_LONGEST_EQUAL?: number | null;
  tooltipText_LONGEST_GT?: number | null;
  tooltipText_LONGEST_GTE?: number | null;
  tooltipText_LONGEST_LT?: number | null;
  tooltipText_LONGEST_LTE?: number | null;
  tooltipText_LT?: number | null;
  tooltipText_LTE?: number | null;
  tooltipText_SHORTEST_EQUAL?: number | null;
  tooltipText_SHORTEST_GT?: number | null;
  tooltipText_SHORTEST_GTE?: number | null;
  tooltipText_SHORTEST_LT?: number | null;
  tooltipText_SHORTEST_LTE?: number | null;
}

export interface FlexEntityTypeWhere {
  AND?: FlexEntityTypeWhere[] | null;
  OR?: FlexEntityTypeWhere[] | null;
  addedBy?: UserWhere | null;
  addedByAggregate?: FlexEntityTypeAddedByAggregateInput | null;
  addedByConnection?: FlexEntityTypeAddedByConnectionWhere | null;
  addedByConnection_NOT?: FlexEntityTypeAddedByConnectionWhere | null;
  addedByName?: string | null;
  addedByName_CONTAINS?: string | null;
  addedByName_ENDS_WITH?: string | null;
  addedByName_IN?: (string | null)[] | null;
  addedByName_MATCHES?: string | null;
  addedByName_NOT?: string | null;
  addedByName_NOT_CONTAINS?: string | null;
  addedByName_NOT_ENDS_WITH?: string | null;
  addedByName_NOT_IN?: (string | null)[] | null;
  addedByName_NOT_STARTS_WITH?: string | null;
  addedByName_STARTS_WITH?: string | null;
  addedBy_NOT?: UserWhere | null;
  attributeCount?: number | null;
  attributeCount_GT?: number | null;
  attributeCount_GTE?: number | null;
  attributeCount_IN?: (number | null)[] | null;
  attributeCount_LT?: number | null;
  attributeCount_LTE?: number | null;
  attributeCount_NOT?: number | null;
  attributeCount_NOT_IN?: (number | null)[] | null;
  catalogueAttributes?: CatalogueAttributeWhere | null;
  catalogueAttributesAggregate?: FlexEntityTypeCatalogueAttributesAggregateInput | null;
  catalogueAttributesConnection?: FlexEntityTypeCatalogueAttributesConnectionWhere | null;
  catalogueAttributesConnection_NOT?: FlexEntityTypeCatalogueAttributesConnectionWhere | null;
  catalogueAttributes_NOT?: CatalogueAttributeWhere | null;
  containerType?: FlexContainerType | null;
  containerType_IN?: (FlexContainerType | null)[] | null;
  containerType_NOT?: FlexContainerType | null;
  containerType_NOT_IN?: (FlexContainerType | null)[] | null;
  createdOn?: any | null;
  createdOn_GT?: any | null;
  createdOn_GTE?: any | null;
  createdOn_IN?: (any | null)[] | null;
  createdOn_LT?: any | null;
  createdOn_LTE?: any | null;
  createdOn_NOT?: any | null;
  createdOn_NOT_IN?: (any | null)[] | null;
  creationWays?: DataContainerCreationWay[] | null;
  creationWays_INCLUDES?: DataContainerCreationWay | null;
  creationWays_NOT?: DataContainerCreationWay[] | null;
  creationWays_NOT_INCLUDES?: DataContainerCreationWay | null;
  data?: string | null;
  data_CONTAINS?: string | null;
  data_ENDS_WITH?: string | null;
  data_IN?: (string | null)[] | null;
  data_MATCHES?: string | null;
  data_NOT?: string | null;
  data_NOT_CONTAINS?: string | null;
  data_NOT_ENDS_WITH?: string | null;
  data_NOT_IN?: (string | null)[] | null;
  data_NOT_STARTS_WITH?: string | null;
  data_STARTS_WITH?: string | null;
  description?: string | null;
  description_CONTAINS?: string | null;
  description_ENDS_WITH?: string | null;
  description_IN?: (string | null)[] | null;
  description_MATCHES?: string | null;
  description_NOT?: string | null;
  description_NOT_CONTAINS?: string | null;
  description_NOT_ENDS_WITH?: string | null;
  description_NOT_IN?: (string | null)[] | null;
  description_NOT_STARTS_WITH?: string | null;
  description_STARTS_WITH?: string | null;
  features?: FlexEntityFeature[] | null;
  features_INCLUDES?: FlexEntityFeature | null;
  features_NOT?: FlexEntityFeature[] | null;
  features_NOT_INCLUDES?: FlexEntityFeature | null;
  id?: string | null;
  idPrefix?: string | null;
  idPrefix_CONTAINS?: string | null;
  idPrefix_ENDS_WITH?: string | null;
  idPrefix_IN?: (string | null)[] | null;
  idPrefix_MATCHES?: string | null;
  idPrefix_NOT?: string | null;
  idPrefix_NOT_CONTAINS?: string | null;
  idPrefix_NOT_ENDS_WITH?: string | null;
  idPrefix_NOT_IN?: (string | null)[] | null;
  idPrefix_NOT_STARTS_WITH?: string | null;
  idPrefix_STARTS_WITH?: string | null;
  id_CONTAINS?: string | null;
  id_ENDS_WITH?: string | null;
  id_IN?: (string | null)[] | null;
  id_MATCHES?: string | null;
  id_NOT?: string | null;
  id_NOT_CONTAINS?: string | null;
  id_NOT_ENDS_WITH?: string | null;
  id_NOT_IN?: (string | null)[] | null;
  id_NOT_STARTS_WITH?: string | null;
  id_STARTS_WITH?: string | null;
  instances?: FlexEntityWhere | null;
  instancesAggregate?: FlexEntityTypeInstancesAggregateInput | null;
  instancesConnection?: FlexEntityTypeInstancesConnectionWhere | null;
  instancesConnection_NOT?: FlexEntityTypeInstancesConnectionWhere | null;
  instances_NOT?: FlexEntityWhere | null;
  isArchived?: boolean | null;
  isArchived_NOT?: boolean | null;
  isOptional?: boolean | null;
  isOptional_NOT?: boolean | null;
  isReadOnly?: boolean | null;
  isReadOnly_NOT?: boolean | null;
  isStartingPoint?: boolean | null;
  isStartingPoint_NOT?: boolean | null;
  localizationKey?: string | null;
  localizationKey_CONTAINS?: string | null;
  localizationKey_ENDS_WITH?: string | null;
  localizationKey_IN?: (string | null)[] | null;
  localizationKey_MATCHES?: string | null;
  localizationKey_NOT?: string | null;
  localizationKey_NOT_CONTAINS?: string | null;
  localizationKey_NOT_ENDS_WITH?: string | null;
  localizationKey_NOT_IN?: (string | null)[] | null;
  localizationKey_NOT_STARTS_WITH?: string | null;
  localizationKey_STARTS_WITH?: string | null;
  mappingInstances?: OrganizationWhere | null;
  mappingInstancesAggregate?: FlexEntityTypeMappingInstancesAggregateInput | null;
  mappingInstancesConnection?: FlexEntityTypeMappingInstancesConnectionWhere | null;
  mappingInstancesConnection_NOT?: FlexEntityTypeMappingInstancesConnectionWhere | null;
  mappingInstances_NOT?: OrganizationWhere | null;
  name?: string | null;
  name_CONTAINS?: string | null;
  name_ENDS_WITH?: string | null;
  name_IN?: (string | null)[] | null;
  name_MATCHES?: string | null;
  name_NOT?: string | null;
  name_NOT_CONTAINS?: string | null;
  name_NOT_ENDS_WITH?: string | null;
  name_NOT_IN?: (string | null)[] | null;
  name_NOT_STARTS_WITH?: string | null;
  name_STARTS_WITH?: string | null;
  orgDataMappings?: string[] | null;
  orgDataMappings_INCLUDES?: string | null;
  orgDataMappings_NOT?: string[] | null;
  orgDataMappings_NOT_INCLUDES?: string | null;
  recordTypes?: FlexEntityTypeWhere | null;
  recordTypesAggregate?: FlexEntityTypeRecordTypesAggregateInput | null;
  recordTypesConnection?: FlexEntityTypeRecordTypesConnectionWhere | null;
  recordTypesConnection_NOT?: FlexEntityTypeRecordTypesConnectionWhere | null;
  recordTypes_NOT?: FlexEntityTypeWhere | null;
  tooltipText?: string | null;
  tooltipText_CONTAINS?: string | null;
  tooltipText_ENDS_WITH?: string | null;
  tooltipText_IN?: (string | null)[] | null;
  tooltipText_MATCHES?: string | null;
  tooltipText_NOT?: string | null;
  tooltipText_NOT_CONTAINS?: string | null;
  tooltipText_NOT_ENDS_WITH?: string | null;
  tooltipText_NOT_IN?: (string | null)[] | null;
  tooltipText_NOT_STARTS_WITH?: string | null;
  tooltipText_STARTS_WITH?: string | null;
}

export interface FlexEntityUploadAggregateInput {
  AND?: FlexEntityUploadAggregateInput[] | null;
  OR?: FlexEntityUploadAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: FlexEntityUploadNodeAggregationWhereInput | null;
}

export interface FlexEntityUploadConnectionWhere {
  AND?: FlexEntityUploadConnectionWhere[] | null;
  OR?: FlexEntityUploadConnectionWhere[] | null;
  node?: UploadWhere | null;
  node_NOT?: UploadWhere | null;
}

export interface FlexEntityUploadInput {
  data: string;
  patientId: string;
  patientIdKeys: string[];
}

export interface FlexEntityUploadNodeAggregationWhereInput {
  AND?: FlexEntityUploadNodeAggregationWhereInput[] | null;
  OR?: FlexEntityUploadNodeAggregationWhereInput[] | null;
  id_EQUAL?: string | null;
  timestamp_EQUAL?: any | null;
  timestamp_GT?: any | null;
  timestamp_GTE?: any | null;
  timestamp_LT?: any | null;
  timestamp_LTE?: any | null;
  timestamp_MAX_EQUAL?: any | null;
  timestamp_MAX_GT?: any | null;
  timestamp_MAX_GTE?: any | null;
  timestamp_MAX_LT?: any | null;
  timestamp_MAX_LTE?: any | null;
  timestamp_MIN_EQUAL?: any | null;
  timestamp_MIN_GT?: any | null;
  timestamp_MIN_GTE?: any | null;
  timestamp_MIN_LT?: any | null;
  timestamp_MIN_LTE?: any | null;
}

export interface FlexEntityWhere {
  AND?: FlexEntityWhere[] | null;
  OR?: FlexEntityWhere[] | null;
  cases?: CaseWhere | null;
  casesAggregate?: FlexEntityCasesAggregateInput | null;
  casesConnection?: FlexEntityCasesConnectionWhere | null;
  casesConnection_NOT?: FlexEntityCasesConnectionWhere | null;
  cases_NOT?: CaseWhere | null;
  containerType?: FlexContainerType | null;
  containerType_IN?: (FlexContainerType | null)[] | null;
  containerType_NOT?: FlexContainerType | null;
  containerType_NOT_IN?: (FlexContainerType | null)[] | null;
  createdBy?: UserWhere | null;
  createdByAggregate?: FlexEntityCreatedByAggregateInput | null;
  createdByConnection?: FlexEntityCreatedByConnectionWhere | null;
  createdByConnection_NOT?: FlexEntityCreatedByConnectionWhere | null;
  createdByEmail?: string | null;
  createdByEmail_CONTAINS?: string | null;
  createdByEmail_ENDS_WITH?: string | null;
  createdByEmail_IN?: (string | null)[] | null;
  createdByEmail_MATCHES?: string | null;
  createdByEmail_NOT?: string | null;
  createdByEmail_NOT_CONTAINS?: string | null;
  createdByEmail_NOT_ENDS_WITH?: string | null;
  createdByEmail_NOT_IN?: (string | null)[] | null;
  createdByEmail_NOT_STARTS_WITH?: string | null;
  createdByEmail_STARTS_WITH?: string | null;
  createdByName?: string | null;
  createdByName_CONTAINS?: string | null;
  createdByName_ENDS_WITH?: string | null;
  createdByName_IN?: (string | null)[] | null;
  createdByName_MATCHES?: string | null;
  createdByName_NOT?: string | null;
  createdByName_NOT_CONTAINS?: string | null;
  createdByName_NOT_ENDS_WITH?: string | null;
  createdByName_NOT_IN?: (string | null)[] | null;
  createdByName_NOT_STARTS_WITH?: string | null;
  createdByName_STARTS_WITH?: string | null;
  createdBy_NOT?: UserWhere | null;
  createdOn?: any | null;
  createdOn_GT?: any | null;
  createdOn_GTE?: any | null;
  createdOn_IN?: (any | null)[] | null;
  createdOn_LT?: any | null;
  createdOn_LTE?: any | null;
  createdOn_NOT?: any | null;
  createdOn_NOT_IN?: (any | null)[] | null;
  data?: string | null;
  dataKeys?: string | null;
  dataKeys_CONTAINS?: string | null;
  dataKeys_ENDS_WITH?: string | null;
  dataKeys_IN?: (string | null)[] | null;
  dataKeys_MATCHES?: string | null;
  dataKeys_NOT?: string | null;
  dataKeys_NOT_CONTAINS?: string | null;
  dataKeys_NOT_ENDS_WITH?: string | null;
  dataKeys_NOT_IN?: (string | null)[] | null;
  dataKeys_NOT_STARTS_WITH?: string | null;
  dataKeys_STARTS_WITH?: string | null;
  data_CONTAINS?: string | null;
  data_ENDS_WITH?: string | null;
  data_IN?: (string | null)[] | null;
  data_MATCHES?: string | null;
  data_NOT?: string | null;
  data_NOT_CONTAINS?: string | null;
  data_NOT_ENDS_WITH?: string | null;
  data_NOT_IN?: (string | null)[] | null;
  data_NOT_STARTS_WITH?: string | null;
  data_STARTS_WITH?: string | null;
  date?: any | null;
  date_GT?: any | null;
  date_GTE?: any | null;
  date_IN?: (any | null)[] | null;
  date_LT?: any | null;
  date_LTE?: any | null;
  date_NOT?: any | null;
  date_NOT_IN?: (any | null)[] | null;
  evaluatedBy?: FlexFinancialDataPointWhere | null;
  evaluatedByAggregate?: FlexEntityEvaluatedByAggregateInput | null;
  evaluatedByConnection?: FlexEntityEvaluatedByConnectionWhere | null;
  evaluatedByConnection_NOT?: FlexEntityEvaluatedByConnectionWhere | null;
  evaluatedBy_NOT?: FlexFinancialDataPointWhere | null;
  financialDataPoints?: FlexFinancialDataPointWhere | null;
  financialDataPointsAggregate?: FlexEntityFinancialDataPointsAggregateInput | null;
  financialDataPointsConnection?: FlexEntityFinancialDataPointsConnectionWhere | null;
  financialDataPointsConnection_NOT?: FlexEntityFinancialDataPointsConnectionWhere | null;
  financialDataPoints_NOT?: FlexFinancialDataPointWhere | null;
  flexEntityName?: string | null;
  flexEntityName_CONTAINS?: string | null;
  flexEntityName_ENDS_WITH?: string | null;
  flexEntityName_IN?: (string | null)[] | null;
  flexEntityName_MATCHES?: string | null;
  flexEntityName_NOT?: string | null;
  flexEntityName_NOT_CONTAINS?: string | null;
  flexEntityName_NOT_ENDS_WITH?: string | null;
  flexEntityName_NOT_IN?: (string | null)[] | null;
  flexEntityName_NOT_STARTS_WITH?: string | null;
  flexEntityName_STARTS_WITH?: string | null;
  generics?: GenericWhere | null;
  genericsAggregate?: FlexEntityGenericsAggregateInput | null;
  genericsConnection?: FlexEntityGenericsConnectionWhere | null;
  genericsConnection_NOT?: FlexEntityGenericsConnectionWhere | null;
  generics_NOT?: GenericWhere | null;
  id?: string | null;
  id_CONTAINS?: string | null;
  id_ENDS_WITH?: string | null;
  id_IN?: (string | null)[] | null;
  id_MATCHES?: string | null;
  id_NOT?: string | null;
  id_NOT_CONTAINS?: string | null;
  id_NOT_ENDS_WITH?: string | null;
  id_NOT_IN?: (string | null)[] | null;
  id_NOT_STARTS_WITH?: string | null;
  id_STARTS_WITH?: string | null;
  invoiceDate?: any | null;
  invoiceDate_GT?: any | null;
  invoiceDate_GTE?: any | null;
  invoiceDate_IN?: (any | null)[] | null;
  invoiceDate_LT?: any | null;
  invoiceDate_LTE?: any | null;
  invoiceDate_NOT?: any | null;
  invoiceDate_NOT_IN?: (any | null)[] | null;
  isArchived?: boolean | null;
  isArchived_NOT?: boolean | null;
  isDeleted?: boolean | null;
  isDeleted_NOT?: boolean | null;
  isRevoked?: boolean | null;
  isRevoked_NOT?: boolean | null;
  isUploaded?: boolean | null;
  isUploaded_NOT?: boolean | null;
  lastUpdatedOn?: any | null;
  lastUpdatedOn_GT?: any | null;
  lastUpdatedOn_GTE?: any | null;
  lastUpdatedOn_IN?: (any | null)[] | null;
  lastUpdatedOn_LT?: any | null;
  lastUpdatedOn_LTE?: any | null;
  lastUpdatedOn_NOT?: any | null;
  lastUpdatedOn_NOT_IN?: (any | null)[] | null;
  occurrence?: OccurrenceEnum | null;
  occurrence_IN?: (OccurrenceEnum | null)[] | null;
  occurrence_NOT?: OccurrenceEnum | null;
  occurrence_NOT_IN?: (OccurrenceEnum | null)[] | null;
  patient?: PatientWhere | null;
  patientAggregate?: FlexEntityPatientAggregateInput | null;
  patientConnection?: FlexEntityPatientConnectionWhere | null;
  patientConnection_NOT?: FlexEntityPatientConnectionWhere | null;
  patientId?: string | null;
  patientIdKeys?: string[] | null;
  patientIdKeys_INCLUDES?: string | null;
  patientIdKeys_NOT?: string[] | null;
  patientIdKeys_NOT_INCLUDES?: string | null;
  patientId_CONTAINS?: string | null;
  patientId_ENDS_WITH?: string | null;
  patientId_IN?: (string | null)[] | null;
  patientId_MATCHES?: string | null;
  patientId_NOT?: string | null;
  patientId_NOT_CONTAINS?: string | null;
  patientId_NOT_ENDS_WITH?: string | null;
  patientId_NOT_IN?: (string | null)[] | null;
  patientId_NOT_STARTS_WITH?: string | null;
  patientId_STARTS_WITH?: string | null;
  patient_NOT?: PatientWhere | null;
  predecessor?: FlexEntityWhere | null;
  predecessorAggregate?: FlexEntityPredecessorAggregateInput | null;
  predecessorConnection?: FlexEntityPredecessorConnectionWhere | null;
  predecessorConnection_NOT?: FlexEntityPredecessorConnectionWhere | null;
  predecessor_NOT?: FlexEntityWhere | null;
  preparationBrandNames?: string | null;
  preparationBrandNames_CONTAINS?: string | null;
  preparationBrandNames_ENDS_WITH?: string | null;
  preparationBrandNames_IN?: (string | null)[] | null;
  preparationBrandNames_MATCHES?: string | null;
  preparationBrandNames_NOT?: string | null;
  preparationBrandNames_NOT_CONTAINS?: string | null;
  preparationBrandNames_NOT_ENDS_WITH?: string | null;
  preparationBrandNames_NOT_IN?: (string | null)[] | null;
  preparationBrandNames_NOT_STARTS_WITH?: string | null;
  preparationBrandNames_STARTS_WITH?: string | null;
  preparationGenericNames?: string | null;
  preparationGenericNames_CONTAINS?: string | null;
  preparationGenericNames_ENDS_WITH?: string | null;
  preparationGenericNames_IN?: (string | null)[] | null;
  preparationGenericNames_MATCHES?: string | null;
  preparationGenericNames_NOT?: string | null;
  preparationGenericNames_NOT_CONTAINS?: string | null;
  preparationGenericNames_NOT_ENDS_WITH?: string | null;
  preparationGenericNames_NOT_IN?: (string | null)[] | null;
  preparationGenericNames_NOT_STARTS_WITH?: string | null;
  preparationGenericNames_STARTS_WITH?: string | null;
  quantity?: number | null;
  quantity_GT?: number | null;
  quantity_GTE?: number | null;
  quantity_IN?: (number | null)[] | null;
  quantity_LT?: number | null;
  quantity_LTE?: number | null;
  quantity_NOT?: number | null;
  quantity_NOT_IN?: (number | null)[] | null;
  rating?: CoverageRequestRating | null;
  rating_IN?: (CoverageRequestRating | null)[] | null;
  rating_NOT?: CoverageRequestRating | null;
  rating_NOT_IN?: (CoverageRequestRating | null)[] | null;
  source?: FlexEntityWhere | null;
  sourceAggregate?: FlexEntitySourceAggregateInput | null;
  sourceConnection?: FlexEntitySourceConnectionWhere | null;
  sourceConnection_NOT?: FlexEntitySourceConnectionWhere | null;
  source_NOT?: FlexEntityWhere | null;
  sourced?: FlexEntityWhere | null;
  sourcedAggregate?: FlexEntitySourcedAggregateInput | null;
  sourcedConnection?: FlexEntitySourcedConnectionWhere | null;
  sourcedConnection_NOT?: FlexEntitySourcedConnectionWhere | null;
  sourced_NOT?: FlexEntityWhere | null;
  status?: FlexFormStatus | null;
  status_IN?: (FlexFormStatus | null)[] | null;
  status_NOT?: FlexFormStatus | null;
  status_NOT_IN?: (FlexFormStatus | null)[] | null;
  successor?: FlexEntityWhere | null;
  successorAggregate?: FlexEntitySuccessorAggregateInput | null;
  successorConnection?: FlexEntitySuccessorConnectionWhere | null;
  successorConnection_NOT?: FlexEntitySuccessorConnectionWhere | null;
  successor_NOT?: FlexEntityWhere | null;
  tenantId?: string | null;
  tenantId_CONTAINS?: string | null;
  tenantId_ENDS_WITH?: string | null;
  tenantId_IN?: (string | null)[] | null;
  tenantId_MATCHES?: string | null;
  tenantId_NOT?: string | null;
  tenantId_NOT_CONTAINS?: string | null;
  tenantId_NOT_ENDS_WITH?: string | null;
  tenantId_NOT_IN?: (string | null)[] | null;
  tenantId_NOT_STARTS_WITH?: string | null;
  tenantId_STARTS_WITH?: string | null;
  type?: FlexEntityTypeWhere | null;
  typeAggregate?: FlexEntityTypeAggregateInput | null;
  typeConnection?: FlexEntityTypeConnectionWhere | null;
  typeConnection_NOT?: FlexEntityTypeConnectionWhere | null;
  type_NOT?: FlexEntityTypeWhere | null;
  unlimited?: number | null;
  unlimited_GT?: number | null;
  unlimited_GTE?: number | null;
  unlimited_IN?: (number | null)[] | null;
  unlimited_LT?: number | null;
  unlimited_LTE?: number | null;
  unlimited_NOT?: number | null;
  unlimited_NOT_IN?: (number | null)[] | null;
  upload?: UploadWhere | null;
  uploadAggregate?: FlexEntityUploadAggregateInput | null;
  uploadConnection?: FlexEntityUploadConnectionWhere | null;
  uploadConnection_NOT?: FlexEntityUploadConnectionWhere | null;
  upload_NOT?: UploadWhere | null;
  uuid?: string | null;
  uuid_CONTAINS?: string | null;
  uuid_ENDS_WITH?: string | null;
  uuid_IN?: (string | null)[] | null;
  uuid_MATCHES?: string | null;
  uuid_NOT?: string | null;
  uuid_NOT_CONTAINS?: string | null;
  uuid_NOT_ENDS_WITH?: string | null;
  uuid_NOT_IN?: (string | null)[] | null;
  uuid_NOT_STARTS_WITH?: string | null;
  uuid_STARTS_WITH?: string | null;
}

export interface FlexFinancialDataPointAgreementAggregateInput {
  AND?: FlexFinancialDataPointAgreementAggregateInput[] | null;
  OR?: FlexFinancialDataPointAgreementAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: FlexFinancialDataPointAgreementNodeAggregationWhereInput | null;
}

export interface FlexFinancialDataPointAgreementConnectionWhere {
  AND?: FlexFinancialDataPointAgreementConnectionWhere[] | null;
  OR?: FlexFinancialDataPointAgreementConnectionWhere[] | null;
  node?: AgreementWhere | null;
  node_NOT?: AgreementWhere | null;
}

export interface FlexFinancialDataPointAgreementNodeAggregationWhereInput {
  AND?: FlexFinancialDataPointAgreementNodeAggregationWhereInput[] | null;
  OR?: FlexFinancialDataPointAgreementNodeAggregationWhereInput[] | null;
  description_AVERAGE_EQUAL?: number | null;
  description_AVERAGE_GT?: number | null;
  description_AVERAGE_GTE?: number | null;
  description_AVERAGE_LT?: number | null;
  description_AVERAGE_LTE?: number | null;
  description_EQUAL?: string | null;
  description_GT?: number | null;
  description_GTE?: number | null;
  description_LONGEST_EQUAL?: number | null;
  description_LONGEST_GT?: number | null;
  description_LONGEST_GTE?: number | null;
  description_LONGEST_LT?: number | null;
  description_LONGEST_LTE?: number | null;
  description_LT?: number | null;
  description_LTE?: number | null;
  description_SHORTEST_EQUAL?: number | null;
  description_SHORTEST_GT?: number | null;
  description_SHORTEST_GTE?: number | null;
  description_SHORTEST_LT?: number | null;
  description_SHORTEST_LTE?: number | null;
  formattedAmount_AVERAGE_EQUAL?: number | null;
  formattedAmount_AVERAGE_GT?: number | null;
  formattedAmount_AVERAGE_GTE?: number | null;
  formattedAmount_AVERAGE_LT?: number | null;
  formattedAmount_AVERAGE_LTE?: number | null;
  formattedAmount_EQUAL?: string | null;
  formattedAmount_GT?: number | null;
  formattedAmount_GTE?: number | null;
  formattedAmount_LONGEST_EQUAL?: number | null;
  formattedAmount_LONGEST_GT?: number | null;
  formattedAmount_LONGEST_GTE?: number | null;
  formattedAmount_LONGEST_LT?: number | null;
  formattedAmount_LONGEST_LTE?: number | null;
  formattedAmount_LT?: number | null;
  formattedAmount_LTE?: number | null;
  formattedAmount_SHORTEST_EQUAL?: number | null;
  formattedAmount_SHORTEST_GT?: number | null;
  formattedAmount_SHORTEST_GTE?: number | null;
  formattedAmount_SHORTEST_LT?: number | null;
  formattedAmount_SHORTEST_LTE?: number | null;
  formattedCounterparties_AVERAGE_EQUAL?: number | null;
  formattedCounterparties_AVERAGE_GT?: number | null;
  formattedCounterparties_AVERAGE_GTE?: number | null;
  formattedCounterparties_AVERAGE_LT?: number | null;
  formattedCounterparties_AVERAGE_LTE?: number | null;
  formattedCounterparties_EQUAL?: string | null;
  formattedCounterparties_GT?: number | null;
  formattedCounterparties_GTE?: number | null;
  formattedCounterparties_LONGEST_EQUAL?: number | null;
  formattedCounterparties_LONGEST_GT?: number | null;
  formattedCounterparties_LONGEST_GTE?: number | null;
  formattedCounterparties_LONGEST_LT?: number | null;
  formattedCounterparties_LONGEST_LTE?: number | null;
  formattedCounterparties_LT?: number | null;
  formattedCounterparties_LTE?: number | null;
  formattedCounterparties_SHORTEST_EQUAL?: number | null;
  formattedCounterparties_SHORTEST_GT?: number | null;
  formattedCounterparties_SHORTEST_GTE?: number | null;
  formattedCounterparties_SHORTEST_LT?: number | null;
  formattedCounterparties_SHORTEST_LTE?: number | null;
  formattedDiseases_AVERAGE_EQUAL?: number | null;
  formattedDiseases_AVERAGE_GT?: number | null;
  formattedDiseases_AVERAGE_GTE?: number | null;
  formattedDiseases_AVERAGE_LT?: number | null;
  formattedDiseases_AVERAGE_LTE?: number | null;
  formattedDiseases_EQUAL?: string | null;
  formattedDiseases_GT?: number | null;
  formattedDiseases_GTE?: number | null;
  formattedDiseases_LONGEST_EQUAL?: number | null;
  formattedDiseases_LONGEST_GT?: number | null;
  formattedDiseases_LONGEST_GTE?: number | null;
  formattedDiseases_LONGEST_LT?: number | null;
  formattedDiseases_LONGEST_LTE?: number | null;
  formattedDiseases_LT?: number | null;
  formattedDiseases_LTE?: number | null;
  formattedDiseases_SHORTEST_EQUAL?: number | null;
  formattedDiseases_SHORTEST_GT?: number | null;
  formattedDiseases_SHORTEST_GTE?: number | null;
  formattedDiseases_SHORTEST_LT?: number | null;
  formattedDiseases_SHORTEST_LTE?: number | null;
  formattedIndications_AVERAGE_EQUAL?: number | null;
  formattedIndications_AVERAGE_GT?: number | null;
  formattedIndications_AVERAGE_GTE?: number | null;
  formattedIndications_AVERAGE_LT?: number | null;
  formattedIndications_AVERAGE_LTE?: number | null;
  formattedIndications_EQUAL?: string | null;
  formattedIndications_GT?: number | null;
  formattedIndications_GTE?: number | null;
  formattedIndications_LONGEST_EQUAL?: number | null;
  formattedIndications_LONGEST_GT?: number | null;
  formattedIndications_LONGEST_GTE?: number | null;
  formattedIndications_LONGEST_LT?: number | null;
  formattedIndications_LONGEST_LTE?: number | null;
  formattedIndications_LT?: number | null;
  formattedIndications_LTE?: number | null;
  formattedIndications_SHORTEST_EQUAL?: number | null;
  formattedIndications_SHORTEST_GT?: number | null;
  formattedIndications_SHORTEST_GTE?: number | null;
  formattedIndications_SHORTEST_LT?: number | null;
  formattedIndications_SHORTEST_LTE?: number | null;
  formattedProducts_AVERAGE_EQUAL?: number | null;
  formattedProducts_AVERAGE_GT?: number | null;
  formattedProducts_AVERAGE_GTE?: number | null;
  formattedProducts_AVERAGE_LT?: number | null;
  formattedProducts_AVERAGE_LTE?: number | null;
  formattedProducts_EQUAL?: string | null;
  formattedProducts_GT?: number | null;
  formattedProducts_GTE?: number | null;
  formattedProducts_LONGEST_EQUAL?: number | null;
  formattedProducts_LONGEST_GT?: number | null;
  formattedProducts_LONGEST_GTE?: number | null;
  formattedProducts_LONGEST_LT?: number | null;
  formattedProducts_LONGEST_LTE?: number | null;
  formattedProducts_LT?: number | null;
  formattedProducts_LTE?: number | null;
  formattedProducts_SHORTEST_EQUAL?: number | null;
  formattedProducts_SHORTEST_GT?: number | null;
  formattedProducts_SHORTEST_GTE?: number | null;
  formattedProducts_SHORTEST_LT?: number | null;
  formattedProducts_SHORTEST_LTE?: number | null;
  formattedTags_AVERAGE_EQUAL?: number | null;
  formattedTags_AVERAGE_GT?: number | null;
  formattedTags_AVERAGE_GTE?: number | null;
  formattedTags_AVERAGE_LT?: number | null;
  formattedTags_AVERAGE_LTE?: number | null;
  formattedTags_EQUAL?: string | null;
  formattedTags_GT?: number | null;
  formattedTags_GTE?: number | null;
  formattedTags_LONGEST_EQUAL?: number | null;
  formattedTags_LONGEST_GT?: number | null;
  formattedTags_LONGEST_GTE?: number | null;
  formattedTags_LONGEST_LT?: number | null;
  formattedTags_LONGEST_LTE?: number | null;
  formattedTags_LT?: number | null;
  formattedTags_LTE?: number | null;
  formattedTags_SHORTEST_EQUAL?: number | null;
  formattedTags_SHORTEST_GT?: number | null;
  formattedTags_SHORTEST_GTE?: number | null;
  formattedTags_SHORTEST_LT?: number | null;
  formattedTags_SHORTEST_LTE?: number | null;
  formattedValidityPeriod_AVERAGE_EQUAL?: number | null;
  formattedValidityPeriod_AVERAGE_GT?: number | null;
  formattedValidityPeriod_AVERAGE_GTE?: number | null;
  formattedValidityPeriod_AVERAGE_LT?: number | null;
  formattedValidityPeriod_AVERAGE_LTE?: number | null;
  formattedValidityPeriod_EQUAL?: string | null;
  formattedValidityPeriod_GT?: number | null;
  formattedValidityPeriod_GTE?: number | null;
  formattedValidityPeriod_LONGEST_EQUAL?: number | null;
  formattedValidityPeriod_LONGEST_GT?: number | null;
  formattedValidityPeriod_LONGEST_GTE?: number | null;
  formattedValidityPeriod_LONGEST_LT?: number | null;
  formattedValidityPeriod_LONGEST_LTE?: number | null;
  formattedValidityPeriod_LT?: number | null;
  formattedValidityPeriod_LTE?: number | null;
  formattedValidityPeriod_SHORTEST_EQUAL?: number | null;
  formattedValidityPeriod_SHORTEST_GT?: number | null;
  formattedValidityPeriod_SHORTEST_GTE?: number | null;
  formattedValidityPeriod_SHORTEST_LT?: number | null;
  formattedValidityPeriod_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  initialVersionId_AVERAGE_EQUAL?: number | null;
  initialVersionId_AVERAGE_GT?: number | null;
  initialVersionId_AVERAGE_GTE?: number | null;
  initialVersionId_AVERAGE_LT?: number | null;
  initialVersionId_AVERAGE_LTE?: number | null;
  initialVersionId_EQUAL?: string | null;
  initialVersionId_GT?: number | null;
  initialVersionId_GTE?: number | null;
  initialVersionId_LONGEST_EQUAL?: number | null;
  initialVersionId_LONGEST_GT?: number | null;
  initialVersionId_LONGEST_GTE?: number | null;
  initialVersionId_LONGEST_LT?: number | null;
  initialVersionId_LONGEST_LTE?: number | null;
  initialVersionId_LT?: number | null;
  initialVersionId_LTE?: number | null;
  initialVersionId_SHORTEST_EQUAL?: number | null;
  initialVersionId_SHORTEST_GT?: number | null;
  initialVersionId_SHORTEST_GTE?: number | null;
  initialVersionId_SHORTEST_LT?: number | null;
  initialVersionId_SHORTEST_LTE?: number | null;
  name_AVERAGE_EQUAL?: number | null;
  name_AVERAGE_GT?: number | null;
  name_AVERAGE_GTE?: number | null;
  name_AVERAGE_LT?: number | null;
  name_AVERAGE_LTE?: number | null;
  name_EQUAL?: string | null;
  name_GT?: number | null;
  name_GTE?: number | null;
  name_LONGEST_EQUAL?: number | null;
  name_LONGEST_GT?: number | null;
  name_LONGEST_GTE?: number | null;
  name_LONGEST_LT?: number | null;
  name_LONGEST_LTE?: number | null;
  name_LT?: number | null;
  name_LTE?: number | null;
  name_SHORTEST_EQUAL?: number | null;
  name_SHORTEST_GT?: number | null;
  name_SHORTEST_GTE?: number | null;
  name_SHORTEST_LT?: number | null;
  name_SHORTEST_LTE?: number | null;
  searchTerm_AVERAGE_EQUAL?: number | null;
  searchTerm_AVERAGE_GT?: number | null;
  searchTerm_AVERAGE_GTE?: number | null;
  searchTerm_AVERAGE_LT?: number | null;
  searchTerm_AVERAGE_LTE?: number | null;
  searchTerm_EQUAL?: string | null;
  searchTerm_GT?: number | null;
  searchTerm_GTE?: number | null;
  searchTerm_LONGEST_EQUAL?: number | null;
  searchTerm_LONGEST_GT?: number | null;
  searchTerm_LONGEST_GTE?: number | null;
  searchTerm_LONGEST_LT?: number | null;
  searchTerm_LONGEST_LTE?: number | null;
  searchTerm_LT?: number | null;
  searchTerm_LTE?: number | null;
  searchTerm_SHORTEST_EQUAL?: number | null;
  searchTerm_SHORTEST_GT?: number | null;
  searchTerm_SHORTEST_GTE?: number | null;
  searchTerm_SHORTEST_LT?: number | null;
  searchTerm_SHORTEST_LTE?: number | null;
  totalAmount_AVERAGE_EQUAL?: number | null;
  totalAmount_AVERAGE_GT?: number | null;
  totalAmount_AVERAGE_GTE?: number | null;
  totalAmount_AVERAGE_LT?: number | null;
  totalAmount_AVERAGE_LTE?: number | null;
  totalAmount_EQUAL?: number | null;
  totalAmount_GT?: number | null;
  totalAmount_GTE?: number | null;
  totalAmount_LT?: number | null;
  totalAmount_LTE?: number | null;
  totalAmount_MAX_EQUAL?: number | null;
  totalAmount_MAX_GT?: number | null;
  totalAmount_MAX_GTE?: number | null;
  totalAmount_MAX_LT?: number | null;
  totalAmount_MAX_LTE?: number | null;
  totalAmount_MIN_EQUAL?: number | null;
  totalAmount_MIN_GT?: number | null;
  totalAmount_MIN_GTE?: number | null;
  totalAmount_MIN_LT?: number | null;
  totalAmount_MIN_LTE?: number | null;
  totalAmount_SUM_EQUAL?: number | null;
  totalAmount_SUM_GT?: number | null;
  totalAmount_SUM_GTE?: number | null;
  totalAmount_SUM_LT?: number | null;
  totalAmount_SUM_LTE?: number | null;
  unlimited_AVERAGE_EQUAL?: number | null;
  unlimited_AVERAGE_GT?: number | null;
  unlimited_AVERAGE_GTE?: number | null;
  unlimited_AVERAGE_LT?: number | null;
  unlimited_AVERAGE_LTE?: number | null;
  unlimited_EQUAL?: number | null;
  unlimited_GT?: number | null;
  unlimited_GTE?: number | null;
  unlimited_LT?: number | null;
  unlimited_LTE?: number | null;
  unlimited_MAX_EQUAL?: number | null;
  unlimited_MAX_GT?: number | null;
  unlimited_MAX_GTE?: number | null;
  unlimited_MAX_LT?: number | null;
  unlimited_MAX_LTE?: number | null;
  unlimited_MIN_EQUAL?: number | null;
  unlimited_MIN_GT?: number | null;
  unlimited_MIN_GTE?: number | null;
  unlimited_MIN_LT?: number | null;
  unlimited_MIN_LTE?: number | null;
  unlimited_SUM_EQUAL?: number | null;
  unlimited_SUM_GT?: number | null;
  unlimited_SUM_GTE?: number | null;
  unlimited_SUM_LT?: number | null;
  unlimited_SUM_LTE?: number | null;
  version_AVERAGE_EQUAL?: number | null;
  version_AVERAGE_GT?: number | null;
  version_AVERAGE_GTE?: number | null;
  version_AVERAGE_LT?: number | null;
  version_AVERAGE_LTE?: number | null;
  version_EQUAL?: number | null;
  version_GT?: number | null;
  version_GTE?: number | null;
  version_LT?: number | null;
  version_LTE?: number | null;
  version_MAX_EQUAL?: number | null;
  version_MAX_GT?: number | null;
  version_MAX_GTE?: number | null;
  version_MAX_LT?: number | null;
  version_MAX_LTE?: number | null;
  version_MIN_EQUAL?: number | null;
  version_MIN_GT?: number | null;
  version_MIN_GTE?: number | null;
  version_MIN_LT?: number | null;
  version_MIN_LTE?: number | null;
  version_SUM_EQUAL?: number | null;
  version_SUM_GT?: number | null;
  version_SUM_GTE?: number | null;
  version_SUM_LT?: number | null;
  version_SUM_LTE?: number | null;
}

export interface FlexFinancialDataPointEvaluatesAggregateInput {
  AND?: FlexFinancialDataPointEvaluatesAggregateInput[] | null;
  OR?: FlexFinancialDataPointEvaluatesAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: FlexFinancialDataPointEvaluatesNodeAggregationWhereInput | null;
}

export interface FlexFinancialDataPointEvaluatesConnectionWhere {
  AND?: FlexFinancialDataPointEvaluatesConnectionWhere[] | null;
  OR?: FlexFinancialDataPointEvaluatesConnectionWhere[] | null;
  node?: FlexEntityWhere | null;
  node_NOT?: FlexEntityWhere | null;
}

export interface FlexFinancialDataPointEvaluatesNodeAggregationWhereInput {
  AND?: FlexFinancialDataPointEvaluatesNodeAggregationWhereInput[] | null;
  OR?: FlexFinancialDataPointEvaluatesNodeAggregationWhereInput[] | null;
  createdByEmail_AVERAGE_EQUAL?: number | null;
  createdByEmail_AVERAGE_GT?: number | null;
  createdByEmail_AVERAGE_GTE?: number | null;
  createdByEmail_AVERAGE_LT?: number | null;
  createdByEmail_AVERAGE_LTE?: number | null;
  createdByEmail_EQUAL?: string | null;
  createdByEmail_GT?: number | null;
  createdByEmail_GTE?: number | null;
  createdByEmail_LONGEST_EQUAL?: number | null;
  createdByEmail_LONGEST_GT?: number | null;
  createdByEmail_LONGEST_GTE?: number | null;
  createdByEmail_LONGEST_LT?: number | null;
  createdByEmail_LONGEST_LTE?: number | null;
  createdByEmail_LT?: number | null;
  createdByEmail_LTE?: number | null;
  createdByEmail_SHORTEST_EQUAL?: number | null;
  createdByEmail_SHORTEST_GT?: number | null;
  createdByEmail_SHORTEST_GTE?: number | null;
  createdByEmail_SHORTEST_LT?: number | null;
  createdByEmail_SHORTEST_LTE?: number | null;
  createdByName_AVERAGE_EQUAL?: number | null;
  createdByName_AVERAGE_GT?: number | null;
  createdByName_AVERAGE_GTE?: number | null;
  createdByName_AVERAGE_LT?: number | null;
  createdByName_AVERAGE_LTE?: number | null;
  createdByName_EQUAL?: string | null;
  createdByName_GT?: number | null;
  createdByName_GTE?: number | null;
  createdByName_LONGEST_EQUAL?: number | null;
  createdByName_LONGEST_GT?: number | null;
  createdByName_LONGEST_GTE?: number | null;
  createdByName_LONGEST_LT?: number | null;
  createdByName_LONGEST_LTE?: number | null;
  createdByName_LT?: number | null;
  createdByName_LTE?: number | null;
  createdByName_SHORTEST_EQUAL?: number | null;
  createdByName_SHORTEST_GT?: number | null;
  createdByName_SHORTEST_GTE?: number | null;
  createdByName_SHORTEST_LT?: number | null;
  createdByName_SHORTEST_LTE?: number | null;
  createdOn_EQUAL?: any | null;
  createdOn_GT?: any | null;
  createdOn_GTE?: any | null;
  createdOn_LT?: any | null;
  createdOn_LTE?: any | null;
  createdOn_MAX_EQUAL?: any | null;
  createdOn_MAX_GT?: any | null;
  createdOn_MAX_GTE?: any | null;
  createdOn_MAX_LT?: any | null;
  createdOn_MAX_LTE?: any | null;
  createdOn_MIN_EQUAL?: any | null;
  createdOn_MIN_GT?: any | null;
  createdOn_MIN_GTE?: any | null;
  createdOn_MIN_LT?: any | null;
  createdOn_MIN_LTE?: any | null;
  dataKeys_AVERAGE_EQUAL?: number | null;
  dataKeys_AVERAGE_GT?: number | null;
  dataKeys_AVERAGE_GTE?: number | null;
  dataKeys_AVERAGE_LT?: number | null;
  dataKeys_AVERAGE_LTE?: number | null;
  dataKeys_EQUAL?: string | null;
  dataKeys_GT?: number | null;
  dataKeys_GTE?: number | null;
  dataKeys_LONGEST_EQUAL?: number | null;
  dataKeys_LONGEST_GT?: number | null;
  dataKeys_LONGEST_GTE?: number | null;
  dataKeys_LONGEST_LT?: number | null;
  dataKeys_LONGEST_LTE?: number | null;
  dataKeys_LT?: number | null;
  dataKeys_LTE?: number | null;
  dataKeys_SHORTEST_EQUAL?: number | null;
  dataKeys_SHORTEST_GT?: number | null;
  dataKeys_SHORTEST_GTE?: number | null;
  dataKeys_SHORTEST_LT?: number | null;
  dataKeys_SHORTEST_LTE?: number | null;
  data_AVERAGE_EQUAL?: number | null;
  data_AVERAGE_GT?: number | null;
  data_AVERAGE_GTE?: number | null;
  data_AVERAGE_LT?: number | null;
  data_AVERAGE_LTE?: number | null;
  data_EQUAL?: string | null;
  data_GT?: number | null;
  data_GTE?: number | null;
  data_LONGEST_EQUAL?: number | null;
  data_LONGEST_GT?: number | null;
  data_LONGEST_GTE?: number | null;
  data_LONGEST_LT?: number | null;
  data_LONGEST_LTE?: number | null;
  data_LT?: number | null;
  data_LTE?: number | null;
  data_SHORTEST_EQUAL?: number | null;
  data_SHORTEST_GT?: number | null;
  data_SHORTEST_GTE?: number | null;
  data_SHORTEST_LT?: number | null;
  data_SHORTEST_LTE?: number | null;
  flexEntityName_AVERAGE_EQUAL?: number | null;
  flexEntityName_AVERAGE_GT?: number | null;
  flexEntityName_AVERAGE_GTE?: number | null;
  flexEntityName_AVERAGE_LT?: number | null;
  flexEntityName_AVERAGE_LTE?: number | null;
  flexEntityName_EQUAL?: string | null;
  flexEntityName_GT?: number | null;
  flexEntityName_GTE?: number | null;
  flexEntityName_LONGEST_EQUAL?: number | null;
  flexEntityName_LONGEST_GT?: number | null;
  flexEntityName_LONGEST_GTE?: number | null;
  flexEntityName_LONGEST_LT?: number | null;
  flexEntityName_LONGEST_LTE?: number | null;
  flexEntityName_LT?: number | null;
  flexEntityName_LTE?: number | null;
  flexEntityName_SHORTEST_EQUAL?: number | null;
  flexEntityName_SHORTEST_GT?: number | null;
  flexEntityName_SHORTEST_GTE?: number | null;
  flexEntityName_SHORTEST_LT?: number | null;
  flexEntityName_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  lastUpdatedOn_EQUAL?: any | null;
  lastUpdatedOn_GT?: any | null;
  lastUpdatedOn_GTE?: any | null;
  lastUpdatedOn_LT?: any | null;
  lastUpdatedOn_LTE?: any | null;
  lastUpdatedOn_MAX_EQUAL?: any | null;
  lastUpdatedOn_MAX_GT?: any | null;
  lastUpdatedOn_MAX_GTE?: any | null;
  lastUpdatedOn_MAX_LT?: any | null;
  lastUpdatedOn_MAX_LTE?: any | null;
  lastUpdatedOn_MIN_EQUAL?: any | null;
  lastUpdatedOn_MIN_GT?: any | null;
  lastUpdatedOn_MIN_GTE?: any | null;
  lastUpdatedOn_MIN_LT?: any | null;
  lastUpdatedOn_MIN_LTE?: any | null;
  patientId_AVERAGE_EQUAL?: number | null;
  patientId_AVERAGE_GT?: number | null;
  patientId_AVERAGE_GTE?: number | null;
  patientId_AVERAGE_LT?: number | null;
  patientId_AVERAGE_LTE?: number | null;
  patientId_EQUAL?: string | null;
  patientId_GT?: number | null;
  patientId_GTE?: number | null;
  patientId_LONGEST_EQUAL?: number | null;
  patientId_LONGEST_GT?: number | null;
  patientId_LONGEST_GTE?: number | null;
  patientId_LONGEST_LT?: number | null;
  patientId_LONGEST_LTE?: number | null;
  patientId_LT?: number | null;
  patientId_LTE?: number | null;
  patientId_SHORTEST_EQUAL?: number | null;
  patientId_SHORTEST_GT?: number | null;
  patientId_SHORTEST_GTE?: number | null;
  patientId_SHORTEST_LT?: number | null;
  patientId_SHORTEST_LTE?: number | null;
  preparationBrandNames_AVERAGE_EQUAL?: number | null;
  preparationBrandNames_AVERAGE_GT?: number | null;
  preparationBrandNames_AVERAGE_GTE?: number | null;
  preparationBrandNames_AVERAGE_LT?: number | null;
  preparationBrandNames_AVERAGE_LTE?: number | null;
  preparationBrandNames_EQUAL?: string | null;
  preparationBrandNames_GT?: number | null;
  preparationBrandNames_GTE?: number | null;
  preparationBrandNames_LONGEST_EQUAL?: number | null;
  preparationBrandNames_LONGEST_GT?: number | null;
  preparationBrandNames_LONGEST_GTE?: number | null;
  preparationBrandNames_LONGEST_LT?: number | null;
  preparationBrandNames_LONGEST_LTE?: number | null;
  preparationBrandNames_LT?: number | null;
  preparationBrandNames_LTE?: number | null;
  preparationBrandNames_SHORTEST_EQUAL?: number | null;
  preparationBrandNames_SHORTEST_GT?: number | null;
  preparationBrandNames_SHORTEST_GTE?: number | null;
  preparationBrandNames_SHORTEST_LT?: number | null;
  preparationBrandNames_SHORTEST_LTE?: number | null;
  preparationGenericNames_AVERAGE_EQUAL?: number | null;
  preparationGenericNames_AVERAGE_GT?: number | null;
  preparationGenericNames_AVERAGE_GTE?: number | null;
  preparationGenericNames_AVERAGE_LT?: number | null;
  preparationGenericNames_AVERAGE_LTE?: number | null;
  preparationGenericNames_EQUAL?: string | null;
  preparationGenericNames_GT?: number | null;
  preparationGenericNames_GTE?: number | null;
  preparationGenericNames_LONGEST_EQUAL?: number | null;
  preparationGenericNames_LONGEST_GT?: number | null;
  preparationGenericNames_LONGEST_GTE?: number | null;
  preparationGenericNames_LONGEST_LT?: number | null;
  preparationGenericNames_LONGEST_LTE?: number | null;
  preparationGenericNames_LT?: number | null;
  preparationGenericNames_LTE?: number | null;
  preparationGenericNames_SHORTEST_EQUAL?: number | null;
  preparationGenericNames_SHORTEST_GT?: number | null;
  preparationGenericNames_SHORTEST_GTE?: number | null;
  preparationGenericNames_SHORTEST_LT?: number | null;
  preparationGenericNames_SHORTEST_LTE?: number | null;
  quantity_AVERAGE_EQUAL?: number | null;
  quantity_AVERAGE_GT?: number | null;
  quantity_AVERAGE_GTE?: number | null;
  quantity_AVERAGE_LT?: number | null;
  quantity_AVERAGE_LTE?: number | null;
  quantity_EQUAL?: number | null;
  quantity_GT?: number | null;
  quantity_GTE?: number | null;
  quantity_LT?: number | null;
  quantity_LTE?: number | null;
  quantity_MAX_EQUAL?: number | null;
  quantity_MAX_GT?: number | null;
  quantity_MAX_GTE?: number | null;
  quantity_MAX_LT?: number | null;
  quantity_MAX_LTE?: number | null;
  quantity_MIN_EQUAL?: number | null;
  quantity_MIN_GT?: number | null;
  quantity_MIN_GTE?: number | null;
  quantity_MIN_LT?: number | null;
  quantity_MIN_LTE?: number | null;
  quantity_SUM_EQUAL?: number | null;
  quantity_SUM_GT?: number | null;
  quantity_SUM_GTE?: number | null;
  quantity_SUM_LT?: number | null;
  quantity_SUM_LTE?: number | null;
  tenantId_AVERAGE_EQUAL?: number | null;
  tenantId_AVERAGE_GT?: number | null;
  tenantId_AVERAGE_GTE?: number | null;
  tenantId_AVERAGE_LT?: number | null;
  tenantId_AVERAGE_LTE?: number | null;
  tenantId_EQUAL?: string | null;
  tenantId_GT?: number | null;
  tenantId_GTE?: number | null;
  tenantId_LONGEST_EQUAL?: number | null;
  tenantId_LONGEST_GT?: number | null;
  tenantId_LONGEST_GTE?: number | null;
  tenantId_LONGEST_LT?: number | null;
  tenantId_LONGEST_LTE?: number | null;
  tenantId_LT?: number | null;
  tenantId_LTE?: number | null;
  tenantId_SHORTEST_EQUAL?: number | null;
  tenantId_SHORTEST_GT?: number | null;
  tenantId_SHORTEST_GTE?: number | null;
  tenantId_SHORTEST_LT?: number | null;
  tenantId_SHORTEST_LTE?: number | null;
  unlimited_AVERAGE_EQUAL?: number | null;
  unlimited_AVERAGE_GT?: number | null;
  unlimited_AVERAGE_GTE?: number | null;
  unlimited_AVERAGE_LT?: number | null;
  unlimited_AVERAGE_LTE?: number | null;
  unlimited_EQUAL?: number | null;
  unlimited_GT?: number | null;
  unlimited_GTE?: number | null;
  unlimited_LT?: number | null;
  unlimited_LTE?: number | null;
  unlimited_MAX_EQUAL?: number | null;
  unlimited_MAX_GT?: number | null;
  unlimited_MAX_GTE?: number | null;
  unlimited_MAX_LT?: number | null;
  unlimited_MAX_LTE?: number | null;
  unlimited_MIN_EQUAL?: number | null;
  unlimited_MIN_GT?: number | null;
  unlimited_MIN_GTE?: number | null;
  unlimited_MIN_LT?: number | null;
  unlimited_MIN_LTE?: number | null;
  unlimited_SUM_EQUAL?: number | null;
  unlimited_SUM_GT?: number | null;
  unlimited_SUM_GTE?: number | null;
  unlimited_SUM_LT?: number | null;
  unlimited_SUM_LTE?: number | null;
  uuid_AVERAGE_EQUAL?: number | null;
  uuid_AVERAGE_GT?: number | null;
  uuid_AVERAGE_GTE?: number | null;
  uuid_AVERAGE_LT?: number | null;
  uuid_AVERAGE_LTE?: number | null;
  uuid_EQUAL?: string | null;
  uuid_GT?: number | null;
  uuid_GTE?: number | null;
  uuid_LONGEST_EQUAL?: number | null;
  uuid_LONGEST_GT?: number | null;
  uuid_LONGEST_GTE?: number | null;
  uuid_LONGEST_LT?: number | null;
  uuid_LONGEST_LTE?: number | null;
  uuid_LT?: number | null;
  uuid_LTE?: number | null;
  uuid_SHORTEST_EQUAL?: number | null;
  uuid_SHORTEST_GT?: number | null;
  uuid_SHORTEST_GTE?: number | null;
  uuid_SHORTEST_LT?: number | null;
  uuid_SHORTEST_LTE?: number | null;
}

export interface FlexFinancialDataPointGeneratedForAggregateInput {
  AND?: FlexFinancialDataPointGeneratedForAggregateInput[] | null;
  OR?: FlexFinancialDataPointGeneratedForAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: FlexFinancialDataPointGeneratedForNodeAggregationWhereInput | null;
}

export interface FlexFinancialDataPointGeneratedForConnectionWhere {
  AND?: FlexFinancialDataPointGeneratedForConnectionWhere[] | null;
  OR?: FlexFinancialDataPointGeneratedForConnectionWhere[] | null;
  node?: CaseWhere | null;
  node_NOT?: CaseWhere | null;
}

export interface FlexFinancialDataPointGeneratedForNodeAggregationWhereInput {
  AND?: FlexFinancialDataPointGeneratedForNodeAggregationWhereInput[] | null;
  OR?: FlexFinancialDataPointGeneratedForNodeAggregationWhereInput[] | null;
  actualAgreementId_AVERAGE_EQUAL?: number | null;
  actualAgreementId_AVERAGE_GT?: number | null;
  actualAgreementId_AVERAGE_GTE?: number | null;
  actualAgreementId_AVERAGE_LT?: number | null;
  actualAgreementId_AVERAGE_LTE?: number | null;
  actualAgreementId_EQUAL?: string | null;
  actualAgreementId_GT?: number | null;
  actualAgreementId_GTE?: number | null;
  actualAgreementId_LONGEST_EQUAL?: number | null;
  actualAgreementId_LONGEST_GT?: number | null;
  actualAgreementId_LONGEST_GTE?: number | null;
  actualAgreementId_LONGEST_LT?: number | null;
  actualAgreementId_LONGEST_LTE?: number | null;
  actualAgreementId_LT?: number | null;
  actualAgreementId_LTE?: number | null;
  actualAgreementId_SHORTEST_EQUAL?: number | null;
  actualAgreementId_SHORTEST_GT?: number | null;
  actualAgreementId_SHORTEST_GTE?: number | null;
  actualAgreementId_SHORTEST_LT?: number | null;
  actualAgreementId_SHORTEST_LTE?: number | null;
  agreementName_AVERAGE_EQUAL?: number | null;
  agreementName_AVERAGE_GT?: number | null;
  agreementName_AVERAGE_GTE?: number | null;
  agreementName_AVERAGE_LT?: number | null;
  agreementName_AVERAGE_LTE?: number | null;
  agreementName_EQUAL?: string | null;
  agreementName_GT?: number | null;
  agreementName_GTE?: number | null;
  agreementName_LONGEST_EQUAL?: number | null;
  agreementName_LONGEST_GT?: number | null;
  agreementName_LONGEST_GTE?: number | null;
  agreementName_LONGEST_LT?: number | null;
  agreementName_LONGEST_LTE?: number | null;
  agreementName_LT?: number | null;
  agreementName_LTE?: number | null;
  agreementName_SHORTEST_EQUAL?: number | null;
  agreementName_SHORTEST_GT?: number | null;
  agreementName_SHORTEST_GTE?: number | null;
  agreementName_SHORTEST_LT?: number | null;
  agreementName_SHORTEST_LTE?: number | null;
  counterpartyInReview_AVERAGE_EQUAL?: number | null;
  counterpartyInReview_AVERAGE_GT?: number | null;
  counterpartyInReview_AVERAGE_GTE?: number | null;
  counterpartyInReview_AVERAGE_LT?: number | null;
  counterpartyInReview_AVERAGE_LTE?: number | null;
  counterpartyInReview_EQUAL?: string | null;
  counterpartyInReview_GT?: number | null;
  counterpartyInReview_GTE?: number | null;
  counterpartyInReview_LONGEST_EQUAL?: number | null;
  counterpartyInReview_LONGEST_GT?: number | null;
  counterpartyInReview_LONGEST_GTE?: number | null;
  counterpartyInReview_LONGEST_LT?: number | null;
  counterpartyInReview_LONGEST_LTE?: number | null;
  counterpartyInReview_LT?: number | null;
  counterpartyInReview_LTE?: number | null;
  counterpartyInReview_SHORTEST_EQUAL?: number | null;
  counterpartyInReview_SHORTEST_GT?: number | null;
  counterpartyInReview_SHORTEST_GTE?: number | null;
  counterpartyInReview_SHORTEST_LT?: number | null;
  counterpartyInReview_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  lastStatusChangeDate_EQUAL?: any | null;
  lastStatusChangeDate_GT?: any | null;
  lastStatusChangeDate_GTE?: any | null;
  lastStatusChangeDate_LT?: any | null;
  lastStatusChangeDate_LTE?: any | null;
  lastStatusChangeDate_MAX_EQUAL?: any | null;
  lastStatusChangeDate_MAX_GT?: any | null;
  lastStatusChangeDate_MAX_GTE?: any | null;
  lastStatusChangeDate_MAX_LT?: any | null;
  lastStatusChangeDate_MAX_LTE?: any | null;
  lastStatusChangeDate_MIN_EQUAL?: any | null;
  lastStatusChangeDate_MIN_GT?: any | null;
  lastStatusChangeDate_MIN_GTE?: any | null;
  lastStatusChangeDate_MIN_LT?: any | null;
  lastStatusChangeDate_MIN_LTE?: any | null;
  patientInitials_AVERAGE_EQUAL?: number | null;
  patientInitials_AVERAGE_GT?: number | null;
  patientInitials_AVERAGE_GTE?: number | null;
  patientInitials_AVERAGE_LT?: number | null;
  patientInitials_AVERAGE_LTE?: number | null;
  patientInitials_EQUAL?: string | null;
  patientInitials_GT?: number | null;
  patientInitials_GTE?: number | null;
  patientInitials_LONGEST_EQUAL?: number | null;
  patientInitials_LONGEST_GT?: number | null;
  patientInitials_LONGEST_GTE?: number | null;
  patientInitials_LONGEST_LT?: number | null;
  patientInitials_LONGEST_LTE?: number | null;
  patientInitials_LT?: number | null;
  patientInitials_LTE?: number | null;
  patientInitials_SHORTEST_EQUAL?: number | null;
  patientInitials_SHORTEST_GT?: number | null;
  patientInitials_SHORTEST_GTE?: number | null;
  patientInitials_SHORTEST_LT?: number | null;
  patientInitials_SHORTEST_LTE?: number | null;
  patientInsuranceId_AVERAGE_EQUAL?: number | null;
  patientInsuranceId_AVERAGE_GT?: number | null;
  patientInsuranceId_AVERAGE_GTE?: number | null;
  patientInsuranceId_AVERAGE_LT?: number | null;
  patientInsuranceId_AVERAGE_LTE?: number | null;
  patientInsuranceId_EQUAL?: string | null;
  patientInsuranceId_GT?: number | null;
  patientInsuranceId_GTE?: number | null;
  patientInsuranceId_LONGEST_EQUAL?: number | null;
  patientInsuranceId_LONGEST_GT?: number | null;
  patientInsuranceId_LONGEST_GTE?: number | null;
  patientInsuranceId_LONGEST_LT?: number | null;
  patientInsuranceId_LONGEST_LTE?: number | null;
  patientInsuranceId_LT?: number | null;
  patientInsuranceId_LTE?: number | null;
  patientInsuranceId_SHORTEST_EQUAL?: number | null;
  patientInsuranceId_SHORTEST_GT?: number | null;
  patientInsuranceId_SHORTEST_GTE?: number | null;
  patientInsuranceId_SHORTEST_LT?: number | null;
  patientInsuranceId_SHORTEST_LTE?: number | null;
  preparationBrandName_AVERAGE_EQUAL?: number | null;
  preparationBrandName_AVERAGE_GT?: number | null;
  preparationBrandName_AVERAGE_GTE?: number | null;
  preparationBrandName_AVERAGE_LT?: number | null;
  preparationBrandName_AVERAGE_LTE?: number | null;
  preparationBrandName_EQUAL?: string | null;
  preparationBrandName_GT?: number | null;
  preparationBrandName_GTE?: number | null;
  preparationBrandName_LONGEST_EQUAL?: number | null;
  preparationBrandName_LONGEST_GT?: number | null;
  preparationBrandName_LONGEST_GTE?: number | null;
  preparationBrandName_LONGEST_LT?: number | null;
  preparationBrandName_LONGEST_LTE?: number | null;
  preparationBrandName_LT?: number | null;
  preparationBrandName_LTE?: number | null;
  preparationBrandName_SHORTEST_EQUAL?: number | null;
  preparationBrandName_SHORTEST_GT?: number | null;
  preparationBrandName_SHORTEST_GTE?: number | null;
  preparationBrandName_SHORTEST_LT?: number | null;
  preparationBrandName_SHORTEST_LTE?: number | null;
  preparationGenericName_AVERAGE_EQUAL?: number | null;
  preparationGenericName_AVERAGE_GT?: number | null;
  preparationGenericName_AVERAGE_GTE?: number | null;
  preparationGenericName_AVERAGE_LT?: number | null;
  preparationGenericName_AVERAGE_LTE?: number | null;
  preparationGenericName_EQUAL?: string | null;
  preparationGenericName_GT?: number | null;
  preparationGenericName_GTE?: number | null;
  preparationGenericName_LONGEST_EQUAL?: number | null;
  preparationGenericName_LONGEST_GT?: number | null;
  preparationGenericName_LONGEST_GTE?: number | null;
  preparationGenericName_LONGEST_LT?: number | null;
  preparationGenericName_LONGEST_LTE?: number | null;
  preparationGenericName_LT?: number | null;
  preparationGenericName_LTE?: number | null;
  preparationGenericName_SHORTEST_EQUAL?: number | null;
  preparationGenericName_SHORTEST_GT?: number | null;
  preparationGenericName_SHORTEST_GTE?: number | null;
  preparationGenericName_SHORTEST_LT?: number | null;
  preparationGenericName_SHORTEST_LTE?: number | null;
  sourceTenantId_AVERAGE_EQUAL?: number | null;
  sourceTenantId_AVERAGE_GT?: number | null;
  sourceTenantId_AVERAGE_GTE?: number | null;
  sourceTenantId_AVERAGE_LT?: number | null;
  sourceTenantId_AVERAGE_LTE?: number | null;
  sourceTenantId_EQUAL?: string | null;
  sourceTenantId_GT?: number | null;
  sourceTenantId_GTE?: number | null;
  sourceTenantId_LONGEST_EQUAL?: number | null;
  sourceTenantId_LONGEST_GT?: number | null;
  sourceTenantId_LONGEST_GTE?: number | null;
  sourceTenantId_LONGEST_LT?: number | null;
  sourceTenantId_LONGEST_LTE?: number | null;
  sourceTenantId_LT?: number | null;
  sourceTenantId_LTE?: number | null;
  sourceTenantId_SHORTEST_EQUAL?: number | null;
  sourceTenantId_SHORTEST_GT?: number | null;
  sourceTenantId_SHORTEST_GTE?: number | null;
  sourceTenantId_SHORTEST_LT?: number | null;
  sourceTenantId_SHORTEST_LTE?: number | null;
  submissionDate_EQUAL?: any | null;
  submissionDate_GT?: any | null;
  submissionDate_GTE?: any | null;
  submissionDate_LT?: any | null;
  submissionDate_LTE?: any | null;
  submissionDate_MAX_EQUAL?: any | null;
  submissionDate_MAX_GT?: any | null;
  submissionDate_MAX_GTE?: any | null;
  submissionDate_MAX_LT?: any | null;
  submissionDate_MAX_LTE?: any | null;
  submissionDate_MIN_EQUAL?: any | null;
  submissionDate_MIN_GT?: any | null;
  submissionDate_MIN_GTE?: any | null;
  submissionDate_MIN_LT?: any | null;
  submissionDate_MIN_LTE?: any | null;
  suspensionReason_AVERAGE_EQUAL?: number | null;
  suspensionReason_AVERAGE_GT?: number | null;
  suspensionReason_AVERAGE_GTE?: number | null;
  suspensionReason_AVERAGE_LT?: number | null;
  suspensionReason_AVERAGE_LTE?: number | null;
  suspensionReason_EQUAL?: string | null;
  suspensionReason_GT?: number | null;
  suspensionReason_GTE?: number | null;
  suspensionReason_LONGEST_EQUAL?: number | null;
  suspensionReason_LONGEST_GT?: number | null;
  suspensionReason_LONGEST_GTE?: number | null;
  suspensionReason_LONGEST_LT?: number | null;
  suspensionReason_LONGEST_LTE?: number | null;
  suspensionReason_LT?: number | null;
  suspensionReason_LTE?: number | null;
  suspensionReason_SHORTEST_EQUAL?: number | null;
  suspensionReason_SHORTEST_GT?: number | null;
  suspensionReason_SHORTEST_GTE?: number | null;
  suspensionReason_SHORTEST_LT?: number | null;
  suspensionReason_SHORTEST_LTE?: number | null;
  totalAmount_AVERAGE_EQUAL?: number | null;
  totalAmount_AVERAGE_GT?: number | null;
  totalAmount_AVERAGE_GTE?: number | null;
  totalAmount_AVERAGE_LT?: number | null;
  totalAmount_AVERAGE_LTE?: number | null;
  totalAmount_EQUAL?: number | null;
  totalAmount_GT?: number | null;
  totalAmount_GTE?: number | null;
  totalAmount_LT?: number | null;
  totalAmount_LTE?: number | null;
  totalAmount_MAX_EQUAL?: number | null;
  totalAmount_MAX_GT?: number | null;
  totalAmount_MAX_GTE?: number | null;
  totalAmount_MAX_LT?: number | null;
  totalAmount_MAX_LTE?: number | null;
  totalAmount_MIN_EQUAL?: number | null;
  totalAmount_MIN_GT?: number | null;
  totalAmount_MIN_GTE?: number | null;
  totalAmount_MIN_LT?: number | null;
  totalAmount_MIN_LTE?: number | null;
  totalAmount_SUM_EQUAL?: number | null;
  totalAmount_SUM_GT?: number | null;
  totalAmount_SUM_GTE?: number | null;
  totalAmount_SUM_LT?: number | null;
  totalAmount_SUM_LTE?: number | null;
  unlimited_AVERAGE_EQUAL?: number | null;
  unlimited_AVERAGE_GT?: number | null;
  unlimited_AVERAGE_GTE?: number | null;
  unlimited_AVERAGE_LT?: number | null;
  unlimited_AVERAGE_LTE?: number | null;
  unlimited_EQUAL?: number | null;
  unlimited_GT?: number | null;
  unlimited_GTE?: number | null;
  unlimited_LT?: number | null;
  unlimited_LTE?: number | null;
  unlimited_MAX_EQUAL?: number | null;
  unlimited_MAX_GT?: number | null;
  unlimited_MAX_GTE?: number | null;
  unlimited_MAX_LT?: number | null;
  unlimited_MAX_LTE?: number | null;
  unlimited_MIN_EQUAL?: number | null;
  unlimited_MIN_GT?: number | null;
  unlimited_MIN_GTE?: number | null;
  unlimited_MIN_LT?: number | null;
  unlimited_MIN_LTE?: number | null;
  unlimited_SUM_EQUAL?: number | null;
  unlimited_SUM_GT?: number | null;
  unlimited_SUM_GTE?: number | null;
  unlimited_SUM_LT?: number | null;
  unlimited_SUM_LTE?: number | null;
}

export interface FlexFinancialDataPointIncludedInAggregateInput {
  AND?: FlexFinancialDataPointIncludedInAggregateInput[] | null;
  OR?: FlexFinancialDataPointIncludedInAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: FlexFinancialDataPointIncludedInNodeAggregationWhereInput | null;
}

export interface FlexFinancialDataPointIncludedInConnectionWhere {
  AND?: FlexFinancialDataPointIncludedInConnectionWhere[] | null;
  OR?: FlexFinancialDataPointIncludedInConnectionWhere[] | null;
  node?: CaseWhere | null;
  node_NOT?: CaseWhere | null;
}

export interface FlexFinancialDataPointIncludedInNodeAggregationWhereInput {
  AND?: FlexFinancialDataPointIncludedInNodeAggregationWhereInput[] | null;
  OR?: FlexFinancialDataPointIncludedInNodeAggregationWhereInput[] | null;
  actualAgreementId_AVERAGE_EQUAL?: number | null;
  actualAgreementId_AVERAGE_GT?: number | null;
  actualAgreementId_AVERAGE_GTE?: number | null;
  actualAgreementId_AVERAGE_LT?: number | null;
  actualAgreementId_AVERAGE_LTE?: number | null;
  actualAgreementId_EQUAL?: string | null;
  actualAgreementId_GT?: number | null;
  actualAgreementId_GTE?: number | null;
  actualAgreementId_LONGEST_EQUAL?: number | null;
  actualAgreementId_LONGEST_GT?: number | null;
  actualAgreementId_LONGEST_GTE?: number | null;
  actualAgreementId_LONGEST_LT?: number | null;
  actualAgreementId_LONGEST_LTE?: number | null;
  actualAgreementId_LT?: number | null;
  actualAgreementId_LTE?: number | null;
  actualAgreementId_SHORTEST_EQUAL?: number | null;
  actualAgreementId_SHORTEST_GT?: number | null;
  actualAgreementId_SHORTEST_GTE?: number | null;
  actualAgreementId_SHORTEST_LT?: number | null;
  actualAgreementId_SHORTEST_LTE?: number | null;
  agreementName_AVERAGE_EQUAL?: number | null;
  agreementName_AVERAGE_GT?: number | null;
  agreementName_AVERAGE_GTE?: number | null;
  agreementName_AVERAGE_LT?: number | null;
  agreementName_AVERAGE_LTE?: number | null;
  agreementName_EQUAL?: string | null;
  agreementName_GT?: number | null;
  agreementName_GTE?: number | null;
  agreementName_LONGEST_EQUAL?: number | null;
  agreementName_LONGEST_GT?: number | null;
  agreementName_LONGEST_GTE?: number | null;
  agreementName_LONGEST_LT?: number | null;
  agreementName_LONGEST_LTE?: number | null;
  agreementName_LT?: number | null;
  agreementName_LTE?: number | null;
  agreementName_SHORTEST_EQUAL?: number | null;
  agreementName_SHORTEST_GT?: number | null;
  agreementName_SHORTEST_GTE?: number | null;
  agreementName_SHORTEST_LT?: number | null;
  agreementName_SHORTEST_LTE?: number | null;
  counterpartyInReview_AVERAGE_EQUAL?: number | null;
  counterpartyInReview_AVERAGE_GT?: number | null;
  counterpartyInReview_AVERAGE_GTE?: number | null;
  counterpartyInReview_AVERAGE_LT?: number | null;
  counterpartyInReview_AVERAGE_LTE?: number | null;
  counterpartyInReview_EQUAL?: string | null;
  counterpartyInReview_GT?: number | null;
  counterpartyInReview_GTE?: number | null;
  counterpartyInReview_LONGEST_EQUAL?: number | null;
  counterpartyInReview_LONGEST_GT?: number | null;
  counterpartyInReview_LONGEST_GTE?: number | null;
  counterpartyInReview_LONGEST_LT?: number | null;
  counterpartyInReview_LONGEST_LTE?: number | null;
  counterpartyInReview_LT?: number | null;
  counterpartyInReview_LTE?: number | null;
  counterpartyInReview_SHORTEST_EQUAL?: number | null;
  counterpartyInReview_SHORTEST_GT?: number | null;
  counterpartyInReview_SHORTEST_GTE?: number | null;
  counterpartyInReview_SHORTEST_LT?: number | null;
  counterpartyInReview_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  lastStatusChangeDate_EQUAL?: any | null;
  lastStatusChangeDate_GT?: any | null;
  lastStatusChangeDate_GTE?: any | null;
  lastStatusChangeDate_LT?: any | null;
  lastStatusChangeDate_LTE?: any | null;
  lastStatusChangeDate_MAX_EQUAL?: any | null;
  lastStatusChangeDate_MAX_GT?: any | null;
  lastStatusChangeDate_MAX_GTE?: any | null;
  lastStatusChangeDate_MAX_LT?: any | null;
  lastStatusChangeDate_MAX_LTE?: any | null;
  lastStatusChangeDate_MIN_EQUAL?: any | null;
  lastStatusChangeDate_MIN_GT?: any | null;
  lastStatusChangeDate_MIN_GTE?: any | null;
  lastStatusChangeDate_MIN_LT?: any | null;
  lastStatusChangeDate_MIN_LTE?: any | null;
  patientInitials_AVERAGE_EQUAL?: number | null;
  patientInitials_AVERAGE_GT?: number | null;
  patientInitials_AVERAGE_GTE?: number | null;
  patientInitials_AVERAGE_LT?: number | null;
  patientInitials_AVERAGE_LTE?: number | null;
  patientInitials_EQUAL?: string | null;
  patientInitials_GT?: number | null;
  patientInitials_GTE?: number | null;
  patientInitials_LONGEST_EQUAL?: number | null;
  patientInitials_LONGEST_GT?: number | null;
  patientInitials_LONGEST_GTE?: number | null;
  patientInitials_LONGEST_LT?: number | null;
  patientInitials_LONGEST_LTE?: number | null;
  patientInitials_LT?: number | null;
  patientInitials_LTE?: number | null;
  patientInitials_SHORTEST_EQUAL?: number | null;
  patientInitials_SHORTEST_GT?: number | null;
  patientInitials_SHORTEST_GTE?: number | null;
  patientInitials_SHORTEST_LT?: number | null;
  patientInitials_SHORTEST_LTE?: number | null;
  patientInsuranceId_AVERAGE_EQUAL?: number | null;
  patientInsuranceId_AVERAGE_GT?: number | null;
  patientInsuranceId_AVERAGE_GTE?: number | null;
  patientInsuranceId_AVERAGE_LT?: number | null;
  patientInsuranceId_AVERAGE_LTE?: number | null;
  patientInsuranceId_EQUAL?: string | null;
  patientInsuranceId_GT?: number | null;
  patientInsuranceId_GTE?: number | null;
  patientInsuranceId_LONGEST_EQUAL?: number | null;
  patientInsuranceId_LONGEST_GT?: number | null;
  patientInsuranceId_LONGEST_GTE?: number | null;
  patientInsuranceId_LONGEST_LT?: number | null;
  patientInsuranceId_LONGEST_LTE?: number | null;
  patientInsuranceId_LT?: number | null;
  patientInsuranceId_LTE?: number | null;
  patientInsuranceId_SHORTEST_EQUAL?: number | null;
  patientInsuranceId_SHORTEST_GT?: number | null;
  patientInsuranceId_SHORTEST_GTE?: number | null;
  patientInsuranceId_SHORTEST_LT?: number | null;
  patientInsuranceId_SHORTEST_LTE?: number | null;
  preparationBrandName_AVERAGE_EQUAL?: number | null;
  preparationBrandName_AVERAGE_GT?: number | null;
  preparationBrandName_AVERAGE_GTE?: number | null;
  preparationBrandName_AVERAGE_LT?: number | null;
  preparationBrandName_AVERAGE_LTE?: number | null;
  preparationBrandName_EQUAL?: string | null;
  preparationBrandName_GT?: number | null;
  preparationBrandName_GTE?: number | null;
  preparationBrandName_LONGEST_EQUAL?: number | null;
  preparationBrandName_LONGEST_GT?: number | null;
  preparationBrandName_LONGEST_GTE?: number | null;
  preparationBrandName_LONGEST_LT?: number | null;
  preparationBrandName_LONGEST_LTE?: number | null;
  preparationBrandName_LT?: number | null;
  preparationBrandName_LTE?: number | null;
  preparationBrandName_SHORTEST_EQUAL?: number | null;
  preparationBrandName_SHORTEST_GT?: number | null;
  preparationBrandName_SHORTEST_GTE?: number | null;
  preparationBrandName_SHORTEST_LT?: number | null;
  preparationBrandName_SHORTEST_LTE?: number | null;
  preparationGenericName_AVERAGE_EQUAL?: number | null;
  preparationGenericName_AVERAGE_GT?: number | null;
  preparationGenericName_AVERAGE_GTE?: number | null;
  preparationGenericName_AVERAGE_LT?: number | null;
  preparationGenericName_AVERAGE_LTE?: number | null;
  preparationGenericName_EQUAL?: string | null;
  preparationGenericName_GT?: number | null;
  preparationGenericName_GTE?: number | null;
  preparationGenericName_LONGEST_EQUAL?: number | null;
  preparationGenericName_LONGEST_GT?: number | null;
  preparationGenericName_LONGEST_GTE?: number | null;
  preparationGenericName_LONGEST_LT?: number | null;
  preparationGenericName_LONGEST_LTE?: number | null;
  preparationGenericName_LT?: number | null;
  preparationGenericName_LTE?: number | null;
  preparationGenericName_SHORTEST_EQUAL?: number | null;
  preparationGenericName_SHORTEST_GT?: number | null;
  preparationGenericName_SHORTEST_GTE?: number | null;
  preparationGenericName_SHORTEST_LT?: number | null;
  preparationGenericName_SHORTEST_LTE?: number | null;
  sourceTenantId_AVERAGE_EQUAL?: number | null;
  sourceTenantId_AVERAGE_GT?: number | null;
  sourceTenantId_AVERAGE_GTE?: number | null;
  sourceTenantId_AVERAGE_LT?: number | null;
  sourceTenantId_AVERAGE_LTE?: number | null;
  sourceTenantId_EQUAL?: string | null;
  sourceTenantId_GT?: number | null;
  sourceTenantId_GTE?: number | null;
  sourceTenantId_LONGEST_EQUAL?: number | null;
  sourceTenantId_LONGEST_GT?: number | null;
  sourceTenantId_LONGEST_GTE?: number | null;
  sourceTenantId_LONGEST_LT?: number | null;
  sourceTenantId_LONGEST_LTE?: number | null;
  sourceTenantId_LT?: number | null;
  sourceTenantId_LTE?: number | null;
  sourceTenantId_SHORTEST_EQUAL?: number | null;
  sourceTenantId_SHORTEST_GT?: number | null;
  sourceTenantId_SHORTEST_GTE?: number | null;
  sourceTenantId_SHORTEST_LT?: number | null;
  sourceTenantId_SHORTEST_LTE?: number | null;
  submissionDate_EQUAL?: any | null;
  submissionDate_GT?: any | null;
  submissionDate_GTE?: any | null;
  submissionDate_LT?: any | null;
  submissionDate_LTE?: any | null;
  submissionDate_MAX_EQUAL?: any | null;
  submissionDate_MAX_GT?: any | null;
  submissionDate_MAX_GTE?: any | null;
  submissionDate_MAX_LT?: any | null;
  submissionDate_MAX_LTE?: any | null;
  submissionDate_MIN_EQUAL?: any | null;
  submissionDate_MIN_GT?: any | null;
  submissionDate_MIN_GTE?: any | null;
  submissionDate_MIN_LT?: any | null;
  submissionDate_MIN_LTE?: any | null;
  suspensionReason_AVERAGE_EQUAL?: number | null;
  suspensionReason_AVERAGE_GT?: number | null;
  suspensionReason_AVERAGE_GTE?: number | null;
  suspensionReason_AVERAGE_LT?: number | null;
  suspensionReason_AVERAGE_LTE?: number | null;
  suspensionReason_EQUAL?: string | null;
  suspensionReason_GT?: number | null;
  suspensionReason_GTE?: number | null;
  suspensionReason_LONGEST_EQUAL?: number | null;
  suspensionReason_LONGEST_GT?: number | null;
  suspensionReason_LONGEST_GTE?: number | null;
  suspensionReason_LONGEST_LT?: number | null;
  suspensionReason_LONGEST_LTE?: number | null;
  suspensionReason_LT?: number | null;
  suspensionReason_LTE?: number | null;
  suspensionReason_SHORTEST_EQUAL?: number | null;
  suspensionReason_SHORTEST_GT?: number | null;
  suspensionReason_SHORTEST_GTE?: number | null;
  suspensionReason_SHORTEST_LT?: number | null;
  suspensionReason_SHORTEST_LTE?: number | null;
  totalAmount_AVERAGE_EQUAL?: number | null;
  totalAmount_AVERAGE_GT?: number | null;
  totalAmount_AVERAGE_GTE?: number | null;
  totalAmount_AVERAGE_LT?: number | null;
  totalAmount_AVERAGE_LTE?: number | null;
  totalAmount_EQUAL?: number | null;
  totalAmount_GT?: number | null;
  totalAmount_GTE?: number | null;
  totalAmount_LT?: number | null;
  totalAmount_LTE?: number | null;
  totalAmount_MAX_EQUAL?: number | null;
  totalAmount_MAX_GT?: number | null;
  totalAmount_MAX_GTE?: number | null;
  totalAmount_MAX_LT?: number | null;
  totalAmount_MAX_LTE?: number | null;
  totalAmount_MIN_EQUAL?: number | null;
  totalAmount_MIN_GT?: number | null;
  totalAmount_MIN_GTE?: number | null;
  totalAmount_MIN_LT?: number | null;
  totalAmount_MIN_LTE?: number | null;
  totalAmount_SUM_EQUAL?: number | null;
  totalAmount_SUM_GT?: number | null;
  totalAmount_SUM_GTE?: number | null;
  totalAmount_SUM_LT?: number | null;
  totalAmount_SUM_LTE?: number | null;
  unlimited_AVERAGE_EQUAL?: number | null;
  unlimited_AVERAGE_GT?: number | null;
  unlimited_AVERAGE_GTE?: number | null;
  unlimited_AVERAGE_LT?: number | null;
  unlimited_AVERAGE_LTE?: number | null;
  unlimited_EQUAL?: number | null;
  unlimited_GT?: number | null;
  unlimited_GTE?: number | null;
  unlimited_LT?: number | null;
  unlimited_LTE?: number | null;
  unlimited_MAX_EQUAL?: number | null;
  unlimited_MAX_GT?: number | null;
  unlimited_MAX_GTE?: number | null;
  unlimited_MAX_LT?: number | null;
  unlimited_MAX_LTE?: number | null;
  unlimited_MIN_EQUAL?: number | null;
  unlimited_MIN_GT?: number | null;
  unlimited_MIN_GTE?: number | null;
  unlimited_MIN_LT?: number | null;
  unlimited_MIN_LTE?: number | null;
  unlimited_SUM_EQUAL?: number | null;
  unlimited_SUM_GT?: number | null;
  unlimited_SUM_GTE?: number | null;
  unlimited_SUM_LT?: number | null;
  unlimited_SUM_LTE?: number | null;
}

export interface FlexFinancialDataPointSourceDocumentAggregateInput {
  AND?: FlexFinancialDataPointSourceDocumentAggregateInput[] | null;
  OR?: FlexFinancialDataPointSourceDocumentAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: FlexFinancialDataPointSourceDocumentNodeAggregationWhereInput | null;
}

export interface FlexFinancialDataPointSourceDocumentConnectionWhere {
  AND?: FlexFinancialDataPointSourceDocumentConnectionWhere[] | null;
  OR?: FlexFinancialDataPointSourceDocumentConnectionWhere[] | null;
  node?: RefundWhere | null;
  node_NOT?: RefundWhere | null;
}

export interface FlexFinancialDataPointSourceDocumentNodeAggregationWhereInput {
  AND?: FlexFinancialDataPointSourceDocumentNodeAggregationWhereInput[] | null;
  OR?: FlexFinancialDataPointSourceDocumentNodeAggregationWhereInput[] | null;
  agreementName_AVERAGE_EQUAL?: number | null;
  agreementName_AVERAGE_GT?: number | null;
  agreementName_AVERAGE_GTE?: number | null;
  agreementName_AVERAGE_LT?: number | null;
  agreementName_AVERAGE_LTE?: number | null;
  agreementName_EQUAL?: string | null;
  agreementName_GT?: number | null;
  agreementName_GTE?: number | null;
  agreementName_LONGEST_EQUAL?: number | null;
  agreementName_LONGEST_GT?: number | null;
  agreementName_LONGEST_GTE?: number | null;
  agreementName_LONGEST_LT?: number | null;
  agreementName_LONGEST_LTE?: number | null;
  agreementName_LT?: number | null;
  agreementName_LTE?: number | null;
  agreementName_SHORTEST_EQUAL?: number | null;
  agreementName_SHORTEST_GT?: number | null;
  agreementName_SHORTEST_GTE?: number | null;
  agreementName_SHORTEST_LT?: number | null;
  agreementName_SHORTEST_LTE?: number | null;
  amount_AVERAGE_EQUAL?: number | null;
  amount_AVERAGE_GT?: number | null;
  amount_AVERAGE_GTE?: number | null;
  amount_AVERAGE_LT?: number | null;
  amount_AVERAGE_LTE?: number | null;
  amount_EQUAL?: number | null;
  amount_GT?: number | null;
  amount_GTE?: number | null;
  amount_LT?: number | null;
  amount_LTE?: number | null;
  amount_MAX_EQUAL?: number | null;
  amount_MAX_GT?: number | null;
  amount_MAX_GTE?: number | null;
  amount_MAX_LT?: number | null;
  amount_MAX_LTE?: number | null;
  amount_MIN_EQUAL?: number | null;
  amount_MIN_GT?: number | null;
  amount_MIN_GTE?: number | null;
  amount_MIN_LT?: number | null;
  amount_MIN_LTE?: number | null;
  amount_SUM_EQUAL?: number | null;
  amount_SUM_GT?: number | null;
  amount_SUM_GTE?: number | null;
  amount_SUM_LT?: number | null;
  amount_SUM_LTE?: number | null;
  caseId_AVERAGE_EQUAL?: number | null;
  caseId_AVERAGE_GT?: number | null;
  caseId_AVERAGE_GTE?: number | null;
  caseId_AVERAGE_LT?: number | null;
  caseId_AVERAGE_LTE?: number | null;
  caseId_EQUAL?: string | null;
  caseId_GT?: number | null;
  caseId_GTE?: number | null;
  caseId_LONGEST_EQUAL?: number | null;
  caseId_LONGEST_GT?: number | null;
  caseId_LONGEST_GTE?: number | null;
  caseId_LONGEST_LT?: number | null;
  caseId_LONGEST_LTE?: number | null;
  caseId_LT?: number | null;
  caseId_LTE?: number | null;
  caseId_SHORTEST_EQUAL?: number | null;
  caseId_SHORTEST_GT?: number | null;
  caseId_SHORTEST_GTE?: number | null;
  caseId_SHORTEST_LT?: number | null;
  caseId_SHORTEST_LTE?: number | null;
  counterParties_AVERAGE_EQUAL?: number | null;
  counterParties_AVERAGE_GT?: number | null;
  counterParties_AVERAGE_GTE?: number | null;
  counterParties_AVERAGE_LT?: number | null;
  counterParties_AVERAGE_LTE?: number | null;
  counterParties_EQUAL?: string | null;
  counterParties_GT?: number | null;
  counterParties_GTE?: number | null;
  counterParties_LONGEST_EQUAL?: number | null;
  counterParties_LONGEST_GT?: number | null;
  counterParties_LONGEST_GTE?: number | null;
  counterParties_LONGEST_LT?: number | null;
  counterParties_LONGEST_LTE?: number | null;
  counterParties_LT?: number | null;
  counterParties_LTE?: number | null;
  counterParties_SHORTEST_EQUAL?: number | null;
  counterParties_SHORTEST_GT?: number | null;
  counterParties_SHORTEST_GTE?: number | null;
  counterParties_SHORTEST_LT?: number | null;
  counterParties_SHORTEST_LTE?: number | null;
  currency_AVERAGE_EQUAL?: number | null;
  currency_AVERAGE_GT?: number | null;
  currency_AVERAGE_GTE?: number | null;
  currency_AVERAGE_LT?: number | null;
  currency_AVERAGE_LTE?: number | null;
  currency_EQUAL?: string | null;
  currency_GT?: number | null;
  currency_GTE?: number | null;
  currency_LONGEST_EQUAL?: number | null;
  currency_LONGEST_GT?: number | null;
  currency_LONGEST_GTE?: number | null;
  currency_LONGEST_LT?: number | null;
  currency_LONGEST_LTE?: number | null;
  currency_LT?: number | null;
  currency_LTE?: number | null;
  currency_SHORTEST_EQUAL?: number | null;
  currency_SHORTEST_GT?: number | null;
  currency_SHORTEST_GTE?: number | null;
  currency_SHORTEST_LT?: number | null;
  currency_SHORTEST_LTE?: number | null;
  formattedTags_AVERAGE_EQUAL?: number | null;
  formattedTags_AVERAGE_GT?: number | null;
  formattedTags_AVERAGE_GTE?: number | null;
  formattedTags_AVERAGE_LT?: number | null;
  formattedTags_AVERAGE_LTE?: number | null;
  formattedTags_EQUAL?: string | null;
  formattedTags_GT?: number | null;
  formattedTags_GTE?: number | null;
  formattedTags_LONGEST_EQUAL?: number | null;
  formattedTags_LONGEST_GT?: number | null;
  formattedTags_LONGEST_GTE?: number | null;
  formattedTags_LONGEST_LT?: number | null;
  formattedTags_LONGEST_LTE?: number | null;
  formattedTags_LT?: number | null;
  formattedTags_LTE?: number | null;
  formattedTags_SHORTEST_EQUAL?: number | null;
  formattedTags_SHORTEST_GT?: number | null;
  formattedTags_SHORTEST_GTE?: number | null;
  formattedTags_SHORTEST_LT?: number | null;
  formattedTags_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  iin_AVERAGE_EQUAL?: number | null;
  iin_AVERAGE_GT?: number | null;
  iin_AVERAGE_GTE?: number | null;
  iin_AVERAGE_LT?: number | null;
  iin_AVERAGE_LTE?: number | null;
  iin_EQUAL?: string | null;
  iin_GT?: number | null;
  iin_GTE?: number | null;
  iin_LONGEST_EQUAL?: number | null;
  iin_LONGEST_GT?: number | null;
  iin_LONGEST_GTE?: number | null;
  iin_LONGEST_LT?: number | null;
  iin_LONGEST_LTE?: number | null;
  iin_LT?: number | null;
  iin_LTE?: number | null;
  iin_SHORTEST_EQUAL?: number | null;
  iin_SHORTEST_GT?: number | null;
  iin_SHORTEST_GTE?: number | null;
  iin_SHORTEST_LT?: number | null;
  iin_SHORTEST_LTE?: number | null;
  product_AVERAGE_EQUAL?: number | null;
  product_AVERAGE_GT?: number | null;
  product_AVERAGE_GTE?: number | null;
  product_AVERAGE_LT?: number | null;
  product_AVERAGE_LTE?: number | null;
  product_EQUAL?: string | null;
  product_GT?: number | null;
  product_GTE?: number | null;
  product_LONGEST_EQUAL?: number | null;
  product_LONGEST_GT?: number | null;
  product_LONGEST_GTE?: number | null;
  product_LONGEST_LT?: number | null;
  product_LONGEST_LTE?: number | null;
  product_LT?: number | null;
  product_LTE?: number | null;
  product_SHORTEST_EQUAL?: number | null;
  product_SHORTEST_GT?: number | null;
  product_SHORTEST_GTE?: number | null;
  product_SHORTEST_LT?: number | null;
  product_SHORTEST_LTE?: number | null;
  refundRate_AVERAGE_EQUAL?: number | null;
  refundRate_AVERAGE_GT?: number | null;
  refundRate_AVERAGE_GTE?: number | null;
  refundRate_AVERAGE_LT?: number | null;
  refundRate_AVERAGE_LTE?: number | null;
  refundRate_EQUAL?: number | null;
  refundRate_GT?: number | null;
  refundRate_GTE?: number | null;
  refundRate_LT?: number | null;
  refundRate_LTE?: number | null;
  refundRate_MAX_EQUAL?: number | null;
  refundRate_MAX_GT?: number | null;
  refundRate_MAX_GTE?: number | null;
  refundRate_MAX_LT?: number | null;
  refundRate_MAX_LTE?: number | null;
  refundRate_MIN_EQUAL?: number | null;
  refundRate_MIN_GT?: number | null;
  refundRate_MIN_GTE?: number | null;
  refundRate_MIN_LT?: number | null;
  refundRate_MIN_LTE?: number | null;
  refundRate_SUM_EQUAL?: number | null;
  refundRate_SUM_GT?: number | null;
  refundRate_SUM_GTE?: number | null;
  refundRate_SUM_LT?: number | null;
  refundRate_SUM_LTE?: number | null;
  revokedOn_EQUAL?: any | null;
  revokedOn_GT?: any | null;
  revokedOn_GTE?: any | null;
  revokedOn_LT?: any | null;
  revokedOn_LTE?: any | null;
  revokedOn_MAX_EQUAL?: any | null;
  revokedOn_MAX_GT?: any | null;
  revokedOn_MAX_GTE?: any | null;
  revokedOn_MAX_LT?: any | null;
  revokedOn_MAX_LTE?: any | null;
  revokedOn_MIN_EQUAL?: any | null;
  revokedOn_MIN_GT?: any | null;
  revokedOn_MIN_GTE?: any | null;
  revokedOn_MIN_LT?: any | null;
  revokedOn_MIN_LTE?: any | null;
  unlimited_AVERAGE_EQUAL?: number | null;
  unlimited_AVERAGE_GT?: number | null;
  unlimited_AVERAGE_GTE?: number | null;
  unlimited_AVERAGE_LT?: number | null;
  unlimited_AVERAGE_LTE?: number | null;
  unlimited_EQUAL?: number | null;
  unlimited_GT?: number | null;
  unlimited_GTE?: number | null;
  unlimited_LT?: number | null;
  unlimited_LTE?: number | null;
  unlimited_MAX_EQUAL?: number | null;
  unlimited_MAX_GT?: number | null;
  unlimited_MAX_GTE?: number | null;
  unlimited_MAX_LT?: number | null;
  unlimited_MAX_LTE?: number | null;
  unlimited_MIN_EQUAL?: number | null;
  unlimited_MIN_GT?: number | null;
  unlimited_MIN_GTE?: number | null;
  unlimited_MIN_LT?: number | null;
  unlimited_MIN_LTE?: number | null;
  unlimited_SUM_EQUAL?: number | null;
  unlimited_SUM_GT?: number | null;
  unlimited_SUM_GTE?: number | null;
  unlimited_SUM_LT?: number | null;
  unlimited_SUM_LTE?: number | null;
}

export interface FlexFinancialDataPointSourceRefundAggregateInput {
  AND?: FlexFinancialDataPointSourceRefundAggregateInput[] | null;
  OR?: FlexFinancialDataPointSourceRefundAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: FlexFinancialDataPointSourceRefundNodeAggregationWhereInput | null;
}

export interface FlexFinancialDataPointSourceRefundConnectionWhere {
  AND?: FlexFinancialDataPointSourceRefundConnectionWhere[] | null;
  OR?: FlexFinancialDataPointSourceRefundConnectionWhere[] | null;
  node?: RefundWhere | null;
  node_NOT?: RefundWhere | null;
}

export interface FlexFinancialDataPointSourceRefundNodeAggregationWhereInput {
  AND?: FlexFinancialDataPointSourceRefundNodeAggregationWhereInput[] | null;
  OR?: FlexFinancialDataPointSourceRefundNodeAggregationWhereInput[] | null;
  agreementName_AVERAGE_EQUAL?: number | null;
  agreementName_AVERAGE_GT?: number | null;
  agreementName_AVERAGE_GTE?: number | null;
  agreementName_AVERAGE_LT?: number | null;
  agreementName_AVERAGE_LTE?: number | null;
  agreementName_EQUAL?: string | null;
  agreementName_GT?: number | null;
  agreementName_GTE?: number | null;
  agreementName_LONGEST_EQUAL?: number | null;
  agreementName_LONGEST_GT?: number | null;
  agreementName_LONGEST_GTE?: number | null;
  agreementName_LONGEST_LT?: number | null;
  agreementName_LONGEST_LTE?: number | null;
  agreementName_LT?: number | null;
  agreementName_LTE?: number | null;
  agreementName_SHORTEST_EQUAL?: number | null;
  agreementName_SHORTEST_GT?: number | null;
  agreementName_SHORTEST_GTE?: number | null;
  agreementName_SHORTEST_LT?: number | null;
  agreementName_SHORTEST_LTE?: number | null;
  amount_AVERAGE_EQUAL?: number | null;
  amount_AVERAGE_GT?: number | null;
  amount_AVERAGE_GTE?: number | null;
  amount_AVERAGE_LT?: number | null;
  amount_AVERAGE_LTE?: number | null;
  amount_EQUAL?: number | null;
  amount_GT?: number | null;
  amount_GTE?: number | null;
  amount_LT?: number | null;
  amount_LTE?: number | null;
  amount_MAX_EQUAL?: number | null;
  amount_MAX_GT?: number | null;
  amount_MAX_GTE?: number | null;
  amount_MAX_LT?: number | null;
  amount_MAX_LTE?: number | null;
  amount_MIN_EQUAL?: number | null;
  amount_MIN_GT?: number | null;
  amount_MIN_GTE?: number | null;
  amount_MIN_LT?: number | null;
  amount_MIN_LTE?: number | null;
  amount_SUM_EQUAL?: number | null;
  amount_SUM_GT?: number | null;
  amount_SUM_GTE?: number | null;
  amount_SUM_LT?: number | null;
  amount_SUM_LTE?: number | null;
  caseId_AVERAGE_EQUAL?: number | null;
  caseId_AVERAGE_GT?: number | null;
  caseId_AVERAGE_GTE?: number | null;
  caseId_AVERAGE_LT?: number | null;
  caseId_AVERAGE_LTE?: number | null;
  caseId_EQUAL?: string | null;
  caseId_GT?: number | null;
  caseId_GTE?: number | null;
  caseId_LONGEST_EQUAL?: number | null;
  caseId_LONGEST_GT?: number | null;
  caseId_LONGEST_GTE?: number | null;
  caseId_LONGEST_LT?: number | null;
  caseId_LONGEST_LTE?: number | null;
  caseId_LT?: number | null;
  caseId_LTE?: number | null;
  caseId_SHORTEST_EQUAL?: number | null;
  caseId_SHORTEST_GT?: number | null;
  caseId_SHORTEST_GTE?: number | null;
  caseId_SHORTEST_LT?: number | null;
  caseId_SHORTEST_LTE?: number | null;
  counterParties_AVERAGE_EQUAL?: number | null;
  counterParties_AVERAGE_GT?: number | null;
  counterParties_AVERAGE_GTE?: number | null;
  counterParties_AVERAGE_LT?: number | null;
  counterParties_AVERAGE_LTE?: number | null;
  counterParties_EQUAL?: string | null;
  counterParties_GT?: number | null;
  counterParties_GTE?: number | null;
  counterParties_LONGEST_EQUAL?: number | null;
  counterParties_LONGEST_GT?: number | null;
  counterParties_LONGEST_GTE?: number | null;
  counterParties_LONGEST_LT?: number | null;
  counterParties_LONGEST_LTE?: number | null;
  counterParties_LT?: number | null;
  counterParties_LTE?: number | null;
  counterParties_SHORTEST_EQUAL?: number | null;
  counterParties_SHORTEST_GT?: number | null;
  counterParties_SHORTEST_GTE?: number | null;
  counterParties_SHORTEST_LT?: number | null;
  counterParties_SHORTEST_LTE?: number | null;
  currency_AVERAGE_EQUAL?: number | null;
  currency_AVERAGE_GT?: number | null;
  currency_AVERAGE_GTE?: number | null;
  currency_AVERAGE_LT?: number | null;
  currency_AVERAGE_LTE?: number | null;
  currency_EQUAL?: string | null;
  currency_GT?: number | null;
  currency_GTE?: number | null;
  currency_LONGEST_EQUAL?: number | null;
  currency_LONGEST_GT?: number | null;
  currency_LONGEST_GTE?: number | null;
  currency_LONGEST_LT?: number | null;
  currency_LONGEST_LTE?: number | null;
  currency_LT?: number | null;
  currency_LTE?: number | null;
  currency_SHORTEST_EQUAL?: number | null;
  currency_SHORTEST_GT?: number | null;
  currency_SHORTEST_GTE?: number | null;
  currency_SHORTEST_LT?: number | null;
  currency_SHORTEST_LTE?: number | null;
  formattedTags_AVERAGE_EQUAL?: number | null;
  formattedTags_AVERAGE_GT?: number | null;
  formattedTags_AVERAGE_GTE?: number | null;
  formattedTags_AVERAGE_LT?: number | null;
  formattedTags_AVERAGE_LTE?: number | null;
  formattedTags_EQUAL?: string | null;
  formattedTags_GT?: number | null;
  formattedTags_GTE?: number | null;
  formattedTags_LONGEST_EQUAL?: number | null;
  formattedTags_LONGEST_GT?: number | null;
  formattedTags_LONGEST_GTE?: number | null;
  formattedTags_LONGEST_LT?: number | null;
  formattedTags_LONGEST_LTE?: number | null;
  formattedTags_LT?: number | null;
  formattedTags_LTE?: number | null;
  formattedTags_SHORTEST_EQUAL?: number | null;
  formattedTags_SHORTEST_GT?: number | null;
  formattedTags_SHORTEST_GTE?: number | null;
  formattedTags_SHORTEST_LT?: number | null;
  formattedTags_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  iin_AVERAGE_EQUAL?: number | null;
  iin_AVERAGE_GT?: number | null;
  iin_AVERAGE_GTE?: number | null;
  iin_AVERAGE_LT?: number | null;
  iin_AVERAGE_LTE?: number | null;
  iin_EQUAL?: string | null;
  iin_GT?: number | null;
  iin_GTE?: number | null;
  iin_LONGEST_EQUAL?: number | null;
  iin_LONGEST_GT?: number | null;
  iin_LONGEST_GTE?: number | null;
  iin_LONGEST_LT?: number | null;
  iin_LONGEST_LTE?: number | null;
  iin_LT?: number | null;
  iin_LTE?: number | null;
  iin_SHORTEST_EQUAL?: number | null;
  iin_SHORTEST_GT?: number | null;
  iin_SHORTEST_GTE?: number | null;
  iin_SHORTEST_LT?: number | null;
  iin_SHORTEST_LTE?: number | null;
  product_AVERAGE_EQUAL?: number | null;
  product_AVERAGE_GT?: number | null;
  product_AVERAGE_GTE?: number | null;
  product_AVERAGE_LT?: number | null;
  product_AVERAGE_LTE?: number | null;
  product_EQUAL?: string | null;
  product_GT?: number | null;
  product_GTE?: number | null;
  product_LONGEST_EQUAL?: number | null;
  product_LONGEST_GT?: number | null;
  product_LONGEST_GTE?: number | null;
  product_LONGEST_LT?: number | null;
  product_LONGEST_LTE?: number | null;
  product_LT?: number | null;
  product_LTE?: number | null;
  product_SHORTEST_EQUAL?: number | null;
  product_SHORTEST_GT?: number | null;
  product_SHORTEST_GTE?: number | null;
  product_SHORTEST_LT?: number | null;
  product_SHORTEST_LTE?: number | null;
  refundRate_AVERAGE_EQUAL?: number | null;
  refundRate_AVERAGE_GT?: number | null;
  refundRate_AVERAGE_GTE?: number | null;
  refundRate_AVERAGE_LT?: number | null;
  refundRate_AVERAGE_LTE?: number | null;
  refundRate_EQUAL?: number | null;
  refundRate_GT?: number | null;
  refundRate_GTE?: number | null;
  refundRate_LT?: number | null;
  refundRate_LTE?: number | null;
  refundRate_MAX_EQUAL?: number | null;
  refundRate_MAX_GT?: number | null;
  refundRate_MAX_GTE?: number | null;
  refundRate_MAX_LT?: number | null;
  refundRate_MAX_LTE?: number | null;
  refundRate_MIN_EQUAL?: number | null;
  refundRate_MIN_GT?: number | null;
  refundRate_MIN_GTE?: number | null;
  refundRate_MIN_LT?: number | null;
  refundRate_MIN_LTE?: number | null;
  refundRate_SUM_EQUAL?: number | null;
  refundRate_SUM_GT?: number | null;
  refundRate_SUM_GTE?: number | null;
  refundRate_SUM_LT?: number | null;
  refundRate_SUM_LTE?: number | null;
  revokedOn_EQUAL?: any | null;
  revokedOn_GT?: any | null;
  revokedOn_GTE?: any | null;
  revokedOn_LT?: any | null;
  revokedOn_LTE?: any | null;
  revokedOn_MAX_EQUAL?: any | null;
  revokedOn_MAX_GT?: any | null;
  revokedOn_MAX_GTE?: any | null;
  revokedOn_MAX_LT?: any | null;
  revokedOn_MAX_LTE?: any | null;
  revokedOn_MIN_EQUAL?: any | null;
  revokedOn_MIN_GT?: any | null;
  revokedOn_MIN_GTE?: any | null;
  revokedOn_MIN_LT?: any | null;
  revokedOn_MIN_LTE?: any | null;
  unlimited_AVERAGE_EQUAL?: number | null;
  unlimited_AVERAGE_GT?: number | null;
  unlimited_AVERAGE_GTE?: number | null;
  unlimited_AVERAGE_LT?: number | null;
  unlimited_AVERAGE_LTE?: number | null;
  unlimited_EQUAL?: number | null;
  unlimited_GT?: number | null;
  unlimited_GTE?: number | null;
  unlimited_LT?: number | null;
  unlimited_LTE?: number | null;
  unlimited_MAX_EQUAL?: number | null;
  unlimited_MAX_GT?: number | null;
  unlimited_MAX_GTE?: number | null;
  unlimited_MAX_LT?: number | null;
  unlimited_MAX_LTE?: number | null;
  unlimited_MIN_EQUAL?: number | null;
  unlimited_MIN_GT?: number | null;
  unlimited_MIN_GTE?: number | null;
  unlimited_MIN_LT?: number | null;
  unlimited_MIN_LTE?: number | null;
  unlimited_SUM_EQUAL?: number | null;
  unlimited_SUM_GT?: number | null;
  unlimited_SUM_GTE?: number | null;
  unlimited_SUM_LT?: number | null;
  unlimited_SUM_LTE?: number | null;
}

export interface FlexFinancialDataPointTreatmentAggregateInput {
  AND?: FlexFinancialDataPointTreatmentAggregateInput[] | null;
  OR?: FlexFinancialDataPointTreatmentAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: FlexFinancialDataPointTreatmentNodeAggregationWhereInput | null;
}

export interface FlexFinancialDataPointTreatmentConnectionWhere {
  AND?: FlexFinancialDataPointTreatmentConnectionWhere[] | null;
  OR?: FlexFinancialDataPointTreatmentConnectionWhere[] | null;
  node?: TreatmentWhere | null;
  node_NOT?: TreatmentWhere | null;
}

export interface FlexFinancialDataPointTreatmentNodeAggregationWhereInput {
  AND?: FlexFinancialDataPointTreatmentNodeAggregationWhereInput[] | null;
  BagDossierNo_AVERAGE_EQUAL?: number | null;
  BagDossierNo_AVERAGE_GT?: number | null;
  BagDossierNo_AVERAGE_GTE?: number | null;
  BagDossierNo_AVERAGE_LT?: number | null;
  BagDossierNo_AVERAGE_LTE?: number | null;
  BagDossierNo_EQUAL?: string | null;
  BagDossierNo_GT?: number | null;
  BagDossierNo_GTE?: number | null;
  BagDossierNo_LONGEST_EQUAL?: number | null;
  BagDossierNo_LONGEST_GT?: number | null;
  BagDossierNo_LONGEST_GTE?: number | null;
  BagDossierNo_LONGEST_LT?: number | null;
  BagDossierNo_LONGEST_LTE?: number | null;
  BagDossierNo_LT?: number | null;
  BagDossierNo_LTE?: number | null;
  BagDossierNo_SHORTEST_EQUAL?: number | null;
  BagDossierNo_SHORTEST_GT?: number | null;
  BagDossierNo_SHORTEST_GTE?: number | null;
  BagDossierNo_SHORTEST_LT?: number | null;
  BagDossierNo_SHORTEST_LTE?: number | null;
  Code_AVERAGE_EQUAL?: number | null;
  Code_AVERAGE_GT?: number | null;
  Code_AVERAGE_GTE?: number | null;
  Code_AVERAGE_LT?: number | null;
  Code_AVERAGE_LTE?: number | null;
  Code_EQUAL?: string | null;
  Code_GT?: number | null;
  Code_GTE?: number | null;
  Code_LONGEST_EQUAL?: number | null;
  Code_LONGEST_GT?: number | null;
  Code_LONGEST_GTE?: number | null;
  Code_LONGEST_LT?: number | null;
  Code_LONGEST_LTE?: number | null;
  Code_LT?: number | null;
  Code_LTE?: number | null;
  Code_SHORTEST_EQUAL?: number | null;
  Code_SHORTEST_GT?: number | null;
  Code_SHORTEST_GTE?: number | null;
  Code_SHORTEST_LT?: number | null;
  Code_SHORTEST_LTE?: number | null;
  FlagModal_AVERAGE_EQUAL?: number | null;
  FlagModal_AVERAGE_GT?: number | null;
  FlagModal_AVERAGE_GTE?: number | null;
  FlagModal_AVERAGE_LT?: number | null;
  FlagModal_AVERAGE_LTE?: number | null;
  FlagModal_EQUAL?: string | null;
  FlagModal_GT?: number | null;
  FlagModal_GTE?: number | null;
  FlagModal_LONGEST_EQUAL?: number | null;
  FlagModal_LONGEST_GT?: number | null;
  FlagModal_LONGEST_GTE?: number | null;
  FlagModal_LONGEST_LT?: number | null;
  FlagModal_LONGEST_LTE?: number | null;
  FlagModal_LT?: number | null;
  FlagModal_LTE?: number | null;
  FlagModal_SHORTEST_EQUAL?: number | null;
  FlagModal_SHORTEST_GT?: number | null;
  FlagModal_SHORTEST_GTE?: number | null;
  FlagModal_SHORTEST_LT?: number | null;
  FlagModal_SHORTEST_LTE?: number | null;
  FlagNarcosis_AVERAGE_EQUAL?: number | null;
  FlagNarcosis_AVERAGE_GT?: number | null;
  FlagNarcosis_AVERAGE_GTE?: number | null;
  FlagNarcosis_AVERAGE_LT?: number | null;
  FlagNarcosis_AVERAGE_LTE?: number | null;
  FlagNarcosis_EQUAL?: string | null;
  FlagNarcosis_GT?: number | null;
  FlagNarcosis_GTE?: number | null;
  FlagNarcosis_LONGEST_EQUAL?: number | null;
  FlagNarcosis_LONGEST_GT?: number | null;
  FlagNarcosis_LONGEST_GTE?: number | null;
  FlagNarcosis_LONGEST_LT?: number | null;
  FlagNarcosis_LONGEST_LTE?: number | null;
  FlagNarcosis_LT?: number | null;
  FlagNarcosis_LTE?: number | null;
  FlagNarcosis_SHORTEST_EQUAL?: number | null;
  FlagNarcosis_SHORTEST_GT?: number | null;
  FlagNarcosis_SHORTEST_GTE?: number | null;
  FlagNarcosis_SHORTEST_LT?: number | null;
  FlagNarcosis_SHORTEST_LTE?: number | null;
  GTIN_AVERAGE_EQUAL?: number | null;
  GTIN_AVERAGE_GT?: number | null;
  GTIN_AVERAGE_GTE?: number | null;
  GTIN_AVERAGE_LT?: number | null;
  GTIN_AVERAGE_LTE?: number | null;
  GTIN_EQUAL?: string | null;
  GTIN_GT?: number | null;
  GTIN_GTE?: number | null;
  GTIN_LONGEST_EQUAL?: number | null;
  GTIN_LONGEST_GT?: number | null;
  GTIN_LONGEST_GTE?: number | null;
  GTIN_LONGEST_LT?: number | null;
  GTIN_LONGEST_LTE?: number | null;
  GTIN_LT?: number | null;
  GTIN_LTE?: number | null;
  GTIN_SHORTEST_EQUAL?: number | null;
  GTIN_SHORTEST_GT?: number | null;
  GTIN_SHORTEST_GTE?: number | null;
  GTIN_SHORTEST_LT?: number | null;
  GTIN_SHORTEST_LTE?: number | null;
  LOT_AVERAGE_EQUAL?: number | null;
  LOT_AVERAGE_GT?: number | null;
  LOT_AVERAGE_GTE?: number | null;
  LOT_AVERAGE_LT?: number | null;
  LOT_AVERAGE_LTE?: number | null;
  LOT_EQUAL?: string | null;
  LOT_GT?: number | null;
  LOT_GTE?: number | null;
  LOT_LONGEST_EQUAL?: number | null;
  LOT_LONGEST_GT?: number | null;
  LOT_LONGEST_GTE?: number | null;
  LOT_LONGEST_LT?: number | null;
  LOT_LONGEST_LTE?: number | null;
  LOT_LT?: number | null;
  LOT_LTE?: number | null;
  LOT_SHORTEST_EQUAL?: number | null;
  LOT_SHORTEST_GT?: number | null;
  LOT_SHORTEST_GTE?: number | null;
  LOT_SHORTEST_LT?: number | null;
  LOT_SHORTEST_LTE?: number | null;
  Name_AVERAGE_EQUAL?: number | null;
  Name_AVERAGE_GT?: number | null;
  Name_AVERAGE_GTE?: number | null;
  Name_AVERAGE_LT?: number | null;
  Name_AVERAGE_LTE?: number | null;
  Name_EQUAL?: string | null;
  Name_GT?: number | null;
  Name_GTE?: number | null;
  Name_LONGEST_EQUAL?: number | null;
  Name_LONGEST_GT?: number | null;
  Name_LONGEST_GTE?: number | null;
  Name_LONGEST_LT?: number | null;
  Name_LONGEST_LTE?: number | null;
  Name_LT?: number | null;
  Name_LTE?: number | null;
  Name_SHORTEST_EQUAL?: number | null;
  Name_SHORTEST_GT?: number | null;
  Name_SHORTEST_GTE?: number | null;
  Name_SHORTEST_LT?: number | null;
  Name_SHORTEST_LTE?: number | null;
  OR?: FlexFinancialDataPointTreatmentNodeAggregationWhereInput[] | null;
  PharmaCode_AVERAGE_EQUAL?: number | null;
  PharmaCode_AVERAGE_GT?: number | null;
  PharmaCode_AVERAGE_GTE?: number | null;
  PharmaCode_AVERAGE_LT?: number | null;
  PharmaCode_AVERAGE_LTE?: number | null;
  PharmaCode_EQUAL?: string | null;
  PharmaCode_GT?: number | null;
  PharmaCode_GTE?: number | null;
  PharmaCode_LONGEST_EQUAL?: number | null;
  PharmaCode_LONGEST_GT?: number | null;
  PharmaCode_LONGEST_GTE?: number | null;
  PharmaCode_LONGEST_LT?: number | null;
  PharmaCode_LONGEST_LTE?: number | null;
  PharmaCode_LT?: number | null;
  PharmaCode_LTE?: number | null;
  PharmaCode_SHORTEST_EQUAL?: number | null;
  PharmaCode_SHORTEST_GT?: number | null;
  PharmaCode_SHORTEST_GTE?: number | null;
  PharmaCode_SHORTEST_LT?: number | null;
  PharmaCode_SHORTEST_LTE?: number | null;
  PrevPharmacode_AVERAGE_EQUAL?: number | null;
  PrevPharmacode_AVERAGE_GT?: number | null;
  PrevPharmacode_AVERAGE_GTE?: number | null;
  PrevPharmacode_AVERAGE_LT?: number | null;
  PrevPharmacode_AVERAGE_LTE?: number | null;
  PrevPharmacode_EQUAL?: string | null;
  PrevPharmacode_GT?: number | null;
  PrevPharmacode_GTE?: number | null;
  PrevPharmacode_LONGEST_EQUAL?: number | null;
  PrevPharmacode_LONGEST_GT?: number | null;
  PrevPharmacode_LONGEST_GTE?: number | null;
  PrevPharmacode_LONGEST_LT?: number | null;
  PrevPharmacode_LONGEST_LTE?: number | null;
  PrevPharmacode_LT?: number | null;
  PrevPharmacode_LTE?: number | null;
  PrevPharmacode_SHORTEST_EQUAL?: number | null;
  PrevPharmacode_SHORTEST_GT?: number | null;
  PrevPharmacode_SHORTEST_GTE?: number | null;
  PrevPharmacode_SHORTEST_LT?: number | null;
  PrevPharmacode_SHORTEST_LTE?: number | null;
  REF_AVERAGE_EQUAL?: number | null;
  REF_AVERAGE_GT?: number | null;
  REF_AVERAGE_GTE?: number | null;
  REF_AVERAGE_LT?: number | null;
  REF_AVERAGE_LTE?: number | null;
  REF_EQUAL?: string | null;
  REF_GT?: number | null;
  REF_GTE?: number | null;
  REF_LONGEST_EQUAL?: number | null;
  REF_LONGEST_GT?: number | null;
  REF_LONGEST_GTE?: number | null;
  REF_LONGEST_LT?: number | null;
  REF_LONGEST_LTE?: number | null;
  REF_LT?: number | null;
  REF_LTE?: number | null;
  REF_SHORTEST_EQUAL?: number | null;
  REF_SHORTEST_GT?: number | null;
  REF_SHORTEST_GTE?: number | null;
  REF_SHORTEST_LT?: number | null;
  REF_SHORTEST_LTE?: number | null;
  SwissmedicCategory_AVERAGE_EQUAL?: number | null;
  SwissmedicCategory_AVERAGE_GT?: number | null;
  SwissmedicCategory_AVERAGE_GTE?: number | null;
  SwissmedicCategory_AVERAGE_LT?: number | null;
  SwissmedicCategory_AVERAGE_LTE?: number | null;
  SwissmedicCategory_EQUAL?: string | null;
  SwissmedicCategory_GT?: number | null;
  SwissmedicCategory_GTE?: number | null;
  SwissmedicCategory_LONGEST_EQUAL?: number | null;
  SwissmedicCategory_LONGEST_GT?: number | null;
  SwissmedicCategory_LONGEST_GTE?: number | null;
  SwissmedicCategory_LONGEST_LT?: number | null;
  SwissmedicCategory_LONGEST_LTE?: number | null;
  SwissmedicCategory_LT?: number | null;
  SwissmedicCategory_LTE?: number | null;
  SwissmedicCategory_SHORTEST_EQUAL?: number | null;
  SwissmedicCategory_SHORTEST_GT?: number | null;
  SwissmedicCategory_SHORTEST_GTE?: number | null;
  SwissmedicCategory_SHORTEST_LT?: number | null;
  SwissmedicCategory_SHORTEST_LTE?: number | null;
  SwissmedicNo8_AVERAGE_EQUAL?: number | null;
  SwissmedicNo8_AVERAGE_GT?: number | null;
  SwissmedicNo8_AVERAGE_GTE?: number | null;
  SwissmedicNo8_AVERAGE_LT?: number | null;
  SwissmedicNo8_AVERAGE_LTE?: number | null;
  SwissmedicNo8_EQUAL?: string | null;
  SwissmedicNo8_GT?: number | null;
  SwissmedicNo8_GTE?: number | null;
  SwissmedicNo8_LONGEST_EQUAL?: number | null;
  SwissmedicNo8_LONGEST_GT?: number | null;
  SwissmedicNo8_LONGEST_GTE?: number | null;
  SwissmedicNo8_LONGEST_LT?: number | null;
  SwissmedicNo8_LONGEST_LTE?: number | null;
  SwissmedicNo8_LT?: number | null;
  SwissmedicNo8_LTE?: number | null;
  SwissmedicNo8_SHORTEST_EQUAL?: number | null;
  SwissmedicNo8_SHORTEST_GT?: number | null;
  SwissmedicNo8_SHORTEST_GTE?: number | null;
  SwissmedicNo8_SHORTEST_LT?: number | null;
  SwissmedicNo8_SHORTEST_LTE?: number | null;
  UDI_AVERAGE_EQUAL?: number | null;
  UDI_AVERAGE_GT?: number | null;
  UDI_AVERAGE_GTE?: number | null;
  UDI_AVERAGE_LT?: number | null;
  UDI_AVERAGE_LTE?: number | null;
  UDI_EQUAL?: string | null;
  UDI_GT?: number | null;
  UDI_GTE?: number | null;
  UDI_LONGEST_EQUAL?: number | null;
  UDI_LONGEST_GT?: number | null;
  UDI_LONGEST_GTE?: number | null;
  UDI_LONGEST_LT?: number | null;
  UDI_LONGEST_LTE?: number | null;
  UDI_LT?: number | null;
  UDI_LTE?: number | null;
  UDI_SHORTEST_EQUAL?: number | null;
  UDI_SHORTEST_GT?: number | null;
  UDI_SHORTEST_GTE?: number | null;
  UDI_SHORTEST_LT?: number | null;
  UDI_SHORTEST_LTE?: number | null;
  activeIngredientQuantity_AVERAGE_EQUAL?: number | null;
  activeIngredientQuantity_AVERAGE_GT?: number | null;
  activeIngredientQuantity_AVERAGE_GTE?: number | null;
  activeIngredientQuantity_AVERAGE_LT?: number | null;
  activeIngredientQuantity_AVERAGE_LTE?: number | null;
  activeIngredientQuantity_EQUAL?: number | null;
  activeIngredientQuantity_GT?: number | null;
  activeIngredientQuantity_GTE?: number | null;
  activeIngredientQuantity_LT?: number | null;
  activeIngredientQuantity_LTE?: number | null;
  activeIngredientQuantity_MAX_EQUAL?: number | null;
  activeIngredientQuantity_MAX_GT?: number | null;
  activeIngredientQuantity_MAX_GTE?: number | null;
  activeIngredientQuantity_MAX_LT?: number | null;
  activeIngredientQuantity_MAX_LTE?: number | null;
  activeIngredientQuantity_MIN_EQUAL?: number | null;
  activeIngredientQuantity_MIN_GT?: number | null;
  activeIngredientQuantity_MIN_GTE?: number | null;
  activeIngredientQuantity_MIN_LT?: number | null;
  activeIngredientQuantity_MIN_LTE?: number | null;
  activeIngredientQuantity_SUM_EQUAL?: number | null;
  activeIngredientQuantity_SUM_GT?: number | null;
  activeIngredientQuantity_SUM_GTE?: number | null;
  activeIngredientQuantity_SUM_LT?: number | null;
  activeIngredientQuantity_SUM_LTE?: number | null;
  classificationSystem_AVERAGE_EQUAL?: number | null;
  classificationSystem_AVERAGE_GT?: number | null;
  classificationSystem_AVERAGE_GTE?: number | null;
  classificationSystem_AVERAGE_LT?: number | null;
  classificationSystem_AVERAGE_LTE?: number | null;
  classificationSystem_EQUAL?: string | null;
  classificationSystem_GT?: number | null;
  classificationSystem_GTE?: number | null;
  classificationSystem_LONGEST_EQUAL?: number | null;
  classificationSystem_LONGEST_GT?: number | null;
  classificationSystem_LONGEST_GTE?: number | null;
  classificationSystem_LONGEST_LT?: number | null;
  classificationSystem_LONGEST_LTE?: number | null;
  classificationSystem_LT?: number | null;
  classificationSystem_LTE?: number | null;
  classificationSystem_SHORTEST_EQUAL?: number | null;
  classificationSystem_SHORTEST_GT?: number | null;
  classificationSystem_SHORTEST_GTE?: number | null;
  classificationSystem_SHORTEST_LT?: number | null;
  classificationSystem_SHORTEST_LTE?: number | null;
  concentration_AVERAGE_EQUAL?: number | null;
  concentration_AVERAGE_GT?: number | null;
  concentration_AVERAGE_GTE?: number | null;
  concentration_AVERAGE_LT?: number | null;
  concentration_AVERAGE_LTE?: number | null;
  concentration_EQUAL?: string | null;
  concentration_GT?: number | null;
  concentration_GTE?: number | null;
  concentration_LONGEST_EQUAL?: number | null;
  concentration_LONGEST_GT?: number | null;
  concentration_LONGEST_GTE?: number | null;
  concentration_LONGEST_LT?: number | null;
  concentration_LONGEST_LTE?: number | null;
  concentration_LT?: number | null;
  concentration_LTE?: number | null;
  concentration_SHORTEST_EQUAL?: number | null;
  concentration_SHORTEST_GT?: number | null;
  concentration_SHORTEST_GTE?: number | null;
  concentration_SHORTEST_LT?: number | null;
  concentration_SHORTEST_LTE?: number | null;
  packVolume_AVERAGE_EQUAL?: number | null;
  packVolume_AVERAGE_GT?: number | null;
  packVolume_AVERAGE_GTE?: number | null;
  packVolume_AVERAGE_LT?: number | null;
  packVolume_AVERAGE_LTE?: number | null;
  packVolume_EQUAL?: string | null;
  packVolume_GT?: number | null;
  packVolume_GTE?: number | null;
  packVolume_LONGEST_EQUAL?: number | null;
  packVolume_LONGEST_GT?: number | null;
  packVolume_LONGEST_GTE?: number | null;
  packVolume_LONGEST_LT?: number | null;
  packVolume_LONGEST_LTE?: number | null;
  packVolume_LT?: number | null;
  packVolume_LTE?: number | null;
  packVolume_SHORTEST_EQUAL?: number | null;
  packVolume_SHORTEST_GT?: number | null;
  packVolume_SHORTEST_GTE?: number | null;
  packVolume_SHORTEST_LT?: number | null;
  packVolume_SHORTEST_LTE?: number | null;
}

export interface FlexFinancialDataPointWhere {
  AND?: FlexFinancialDataPointWhere[] | null;
  OR?: FlexFinancialDataPointWhere[] | null;
  agreement?: AgreementWhere | null;
  agreementAggregate?: FlexFinancialDataPointAgreementAggregateInput | null;
  agreementConnection?: FlexFinancialDataPointAgreementConnectionWhere | null;
  agreementConnection_NOT?: FlexFinancialDataPointAgreementConnectionWhere | null;
  agreement_NOT?: AgreementWhere | null;
  basePrice?: number | null;
  basePrice_GT?: number | null;
  basePrice_GTE?: number | null;
  basePrice_IN?: (number | null)[] | null;
  basePrice_LT?: number | null;
  basePrice_LTE?: number | null;
  basePrice_NOT?: number | null;
  basePrice_NOT_IN?: (number | null)[] | null;
  createdOn?: any | null;
  createdOn_GT?: any | null;
  createdOn_GTE?: any | null;
  createdOn_IN?: (any | null)[] | null;
  createdOn_LT?: any | null;
  createdOn_LTE?: any | null;
  createdOn_NOT?: any | null;
  createdOn_NOT_IN?: (any | null)[] | null;
  currencyCode?: string | null;
  currencyCode_CONTAINS?: string | null;
  currencyCode_ENDS_WITH?: string | null;
  currencyCode_IN?: (string | null)[] | null;
  currencyCode_MATCHES?: string | null;
  currencyCode_NOT?: string | null;
  currencyCode_NOT_CONTAINS?: string | null;
  currencyCode_NOT_ENDS_WITH?: string | null;
  currencyCode_NOT_IN?: (string | null)[] | null;
  currencyCode_NOT_STARTS_WITH?: string | null;
  currencyCode_STARTS_WITH?: string | null;
  date?: any | null;
  date_GT?: any | null;
  date_GTE?: any | null;
  date_IN?: (any | null)[] | null;
  date_LT?: any | null;
  date_LTE?: any | null;
  date_NOT?: any | null;
  date_NOT_IN?: (any | null)[] | null;
  evaluates?: FlexEntityWhere | null;
  evaluatesAggregate?: FlexFinancialDataPointEvaluatesAggregateInput | null;
  evaluatesConnection?: FlexFinancialDataPointEvaluatesConnectionWhere | null;
  evaluatesConnection_NOT?: FlexFinancialDataPointEvaluatesConnectionWhere | null;
  evaluates_NOT?: FlexEntityWhere | null;
  evaluationSnapshot?: string | null;
  evaluationSnapshot_CONTAINS?: string | null;
  evaluationSnapshot_ENDS_WITH?: string | null;
  evaluationSnapshot_IN?: (string | null)[] | null;
  evaluationSnapshot_MATCHES?: string | null;
  evaluationSnapshot_NOT?: string | null;
  evaluationSnapshot_NOT_CONTAINS?: string | null;
  evaluationSnapshot_NOT_ENDS_WITH?: string | null;
  evaluationSnapshot_NOT_IN?: (string | null)[] | null;
  evaluationSnapshot_NOT_STARTS_WITH?: string | null;
  evaluationSnapshot_STARTS_WITH?: string | null;
  generatedFor?: CaseWhere | null;
  generatedForAggregate?: FlexFinancialDataPointGeneratedForAggregateInput | null;
  generatedForConnection?: FlexFinancialDataPointGeneratedForConnectionWhere | null;
  generatedForConnection_NOT?: FlexFinancialDataPointGeneratedForConnectionWhere | null;
  generatedFor_NOT?: CaseWhere | null;
  generatedUuid?: string | null;
  generatedUuid_CONTAINS?: string | null;
  generatedUuid_ENDS_WITH?: string | null;
  generatedUuid_IN?: (string | null)[] | null;
  generatedUuid_MATCHES?: string | null;
  generatedUuid_NOT?: string | null;
  generatedUuid_NOT_CONTAINS?: string | null;
  generatedUuid_NOT_ENDS_WITH?: string | null;
  generatedUuid_NOT_IN?: (string | null)[] | null;
  generatedUuid_NOT_STARTS_WITH?: string | null;
  generatedUuid_STARTS_WITH?: string | null;
  includedIn?: CaseWhere | null;
  includedInAggregate?: FlexFinancialDataPointIncludedInAggregateInput | null;
  includedInConnection?: FlexFinancialDataPointIncludedInConnectionWhere | null;
  includedInConnection_NOT?: FlexFinancialDataPointIncludedInConnectionWhere | null;
  includedIn_NOT?: CaseWhere | null;
  isDefaultPriceRateApplied?: boolean | null;
  isDefaultPriceRateApplied_NOT?: boolean | null;
  isDeleted?: boolean | null;
  isDeleted_NOT?: boolean | null;
  isDelta?: boolean | null;
  isDelta_NOT?: boolean | null;
  isLast?: boolean | null;
  isLast_NOT?: boolean | null;
  payable?: number | null;
  payablePercentage?: number | null;
  payablePercentage_GT?: number | null;
  payablePercentage_GTE?: number | null;
  payablePercentage_IN?: (number | null)[] | null;
  payablePercentage_LT?: number | null;
  payablePercentage_LTE?: number | null;
  payablePercentage_NOT?: number | null;
  payablePercentage_NOT_IN?: (number | null)[] | null;
  payable_GT?: number | null;
  payable_GTE?: number | null;
  payable_IN?: (number | null)[] | null;
  payable_LT?: number | null;
  payable_LTE?: number | null;
  payable_NOT?: number | null;
  payable_NOT_IN?: (number | null)[] | null;
  prescriptionDate?: any | null;
  prescriptionDate_GT?: any | null;
  prescriptionDate_GTE?: any | null;
  prescriptionDate_IN?: (any | null)[] | null;
  prescriptionDate_LT?: any | null;
  prescriptionDate_LTE?: any | null;
  prescriptionDate_NOT?: any | null;
  prescriptionDate_NOT_IN?: (any | null)[] | null;
  quantity?: number | null;
  quantity_GT?: number | null;
  quantity_GTE?: number | null;
  quantity_IN?: (number | null)[] | null;
  quantity_LT?: number | null;
  quantity_LTE?: number | null;
  quantity_NOT?: number | null;
  quantity_NOT_IN?: (number | null)[] | null;
  refundDeltaNumber?: number | null;
  refundDeltaNumber_GT?: number | null;
  refundDeltaNumber_GTE?: number | null;
  refundDeltaNumber_IN?: (number | null)[] | null;
  refundDeltaNumber_LT?: number | null;
  refundDeltaNumber_LTE?: number | null;
  refundDeltaNumber_NOT?: number | null;
  refundDeltaNumber_NOT_IN?: (number | null)[] | null;
  refundable?: number | null;
  refundablePercentage?: number | null;
  refundablePercentage_GT?: number | null;
  refundablePercentage_GTE?: number | null;
  refundablePercentage_IN?: (number | null)[] | null;
  refundablePercentage_LT?: number | null;
  refundablePercentage_LTE?: number | null;
  refundablePercentage_NOT?: number | null;
  refundablePercentage_NOT_IN?: (number | null)[] | null;
  refundable_GT?: number | null;
  refundable_GTE?: number | null;
  refundable_IN?: (number | null)[] | null;
  refundable_LT?: number | null;
  refundable_LTE?: number | null;
  refundable_NOT?: number | null;
  refundable_NOT_IN?: (number | null)[] | null;
  revokedOn?: any | null;
  revokedOn_GT?: any | null;
  revokedOn_GTE?: any | null;
  revokedOn_IN?: (any | null)[] | null;
  revokedOn_LT?: any | null;
  revokedOn_LTE?: any | null;
  revokedOn_NOT?: any | null;
  revokedOn_NOT_IN?: (any | null)[] | null;
  sourceDocument?: RefundWhere | null;
  sourceDocumentAggregate?: FlexFinancialDataPointSourceDocumentAggregateInput | null;
  sourceDocumentConnection?: FlexFinancialDataPointSourceDocumentConnectionWhere | null;
  sourceDocumentConnection_NOT?: FlexFinancialDataPointSourceDocumentConnectionWhere | null;
  sourceDocument_NOT?: RefundWhere | null;
  sourceRefund?: RefundWhere | null;
  sourceRefundAggregate?: FlexFinancialDataPointSourceRefundAggregateInput | null;
  sourceRefundConnection?: FlexFinancialDataPointSourceRefundConnectionWhere | null;
  sourceRefundConnection_NOT?: FlexFinancialDataPointSourceRefundConnectionWhere | null;
  sourceRefund_NOT?: RefundWhere | null;
  treatment?: TreatmentWhere | null;
  treatmentAggregate?: FlexFinancialDataPointTreatmentAggregateInput | null;
  treatmentConnection?: FlexFinancialDataPointTreatmentConnectionWhere | null;
  treatmentConnection_NOT?: FlexFinancialDataPointTreatmentConnectionWhere | null;
  treatment_NOT?: TreatmentWhere | null;
  uuid?: string | null;
  uuid_CONTAINS?: string | null;
  uuid_ENDS_WITH?: string | null;
  uuid_IN?: (string | null)[] | null;
  uuid_MATCHES?: string | null;
  uuid_NOT?: string | null;
  uuid_NOT_CONTAINS?: string | null;
  uuid_NOT_ENDS_WITH?: string | null;
  uuid_NOT_IN?: (string | null)[] | null;
  uuid_NOT_STARTS_WITH?: string | null;
  uuid_STARTS_WITH?: string | null;
  variable?: number | null;
  variablePercentage?: number | null;
  variablePercentage_GT?: number | null;
  variablePercentage_GTE?: number | null;
  variablePercentage_IN?: (number | null)[] | null;
  variablePercentage_LT?: number | null;
  variablePercentage_LTE?: number | null;
  variablePercentage_NOT?: number | null;
  variablePercentage_NOT_IN?: (number | null)[] | null;
  variable_GT?: number | null;
  variable_GTE?: number | null;
  variable_IN?: (number | null)[] | null;
  variable_LT?: number | null;
  variable_LTE?: number | null;
  variable_NOT?: number | null;
  variable_NOT_IN?: (number | null)[] | null;
}

export interface GenericCreatedByAggregateInput {
  AND?: GenericCreatedByAggregateInput[] | null;
  OR?: GenericCreatedByAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: GenericCreatedByNodeAggregationWhereInput | null;
}

export interface GenericCreatedByConnectionWhere {
  AND?: GenericCreatedByConnectionWhere[] | null;
  OR?: GenericCreatedByConnectionWhere[] | null;
  node?: UserWhere | null;
  node_NOT?: UserWhere | null;
}

export interface GenericCreatedByNodeAggregationWhereInput {
  AND?: GenericCreatedByNodeAggregationWhereInput[] | null;
  OR?: GenericCreatedByNodeAggregationWhereInput[] | null;
  deletedOn_EQUAL?: any | null;
  deletedOn_GT?: any | null;
  deletedOn_GTE?: any | null;
  deletedOn_LT?: any | null;
  deletedOn_LTE?: any | null;
  deletedOn_MAX_EQUAL?: any | null;
  deletedOn_MAX_GT?: any | null;
  deletedOn_MAX_GTE?: any | null;
  deletedOn_MAX_LT?: any | null;
  deletedOn_MAX_LTE?: any | null;
  deletedOn_MIN_EQUAL?: any | null;
  deletedOn_MIN_GT?: any | null;
  deletedOn_MIN_GTE?: any | null;
  deletedOn_MIN_LT?: any | null;
  deletedOn_MIN_LTE?: any | null;
  department_AVERAGE_EQUAL?: number | null;
  department_AVERAGE_GT?: number | null;
  department_AVERAGE_GTE?: number | null;
  department_AVERAGE_LT?: number | null;
  department_AVERAGE_LTE?: number | null;
  department_EQUAL?: string | null;
  department_GT?: number | null;
  department_GTE?: number | null;
  department_LONGEST_EQUAL?: number | null;
  department_LONGEST_GT?: number | null;
  department_LONGEST_GTE?: number | null;
  department_LONGEST_LT?: number | null;
  department_LONGEST_LTE?: number | null;
  department_LT?: number | null;
  department_LTE?: number | null;
  department_SHORTEST_EQUAL?: number | null;
  department_SHORTEST_GT?: number | null;
  department_SHORTEST_GTE?: number | null;
  department_SHORTEST_LT?: number | null;
  department_SHORTEST_LTE?: number | null;
  email_AVERAGE_EQUAL?: number | null;
  email_AVERAGE_GT?: number | null;
  email_AVERAGE_GTE?: number | null;
  email_AVERAGE_LT?: number | null;
  email_AVERAGE_LTE?: number | null;
  email_EQUAL?: string | null;
  email_GT?: number | null;
  email_GTE?: number | null;
  email_LONGEST_EQUAL?: number | null;
  email_LONGEST_GT?: number | null;
  email_LONGEST_GTE?: number | null;
  email_LONGEST_LT?: number | null;
  email_LONGEST_LTE?: number | null;
  email_LT?: number | null;
  email_LTE?: number | null;
  email_SHORTEST_EQUAL?: number | null;
  email_SHORTEST_GT?: number | null;
  email_SHORTEST_GTE?: number | null;
  email_SHORTEST_LT?: number | null;
  email_SHORTEST_LTE?: number | null;
  firstName_AVERAGE_EQUAL?: number | null;
  firstName_AVERAGE_GT?: number | null;
  firstName_AVERAGE_GTE?: number | null;
  firstName_AVERAGE_LT?: number | null;
  firstName_AVERAGE_LTE?: number | null;
  firstName_EQUAL?: string | null;
  firstName_GT?: number | null;
  firstName_GTE?: number | null;
  firstName_LONGEST_EQUAL?: number | null;
  firstName_LONGEST_GT?: number | null;
  firstName_LONGEST_GTE?: number | null;
  firstName_LONGEST_LT?: number | null;
  firstName_LONGEST_LTE?: number | null;
  firstName_LT?: number | null;
  firstName_LTE?: number | null;
  firstName_SHORTEST_EQUAL?: number | null;
  firstName_SHORTEST_GT?: number | null;
  firstName_SHORTEST_GTE?: number | null;
  firstName_SHORTEST_LT?: number | null;
  firstName_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  lastName_AVERAGE_EQUAL?: number | null;
  lastName_AVERAGE_GT?: number | null;
  lastName_AVERAGE_GTE?: number | null;
  lastName_AVERAGE_LT?: number | null;
  lastName_AVERAGE_LTE?: number | null;
  lastName_EQUAL?: string | null;
  lastName_GT?: number | null;
  lastName_GTE?: number | null;
  lastName_LONGEST_EQUAL?: number | null;
  lastName_LONGEST_GT?: number | null;
  lastName_LONGEST_GTE?: number | null;
  lastName_LONGEST_LT?: number | null;
  lastName_LONGEST_LTE?: number | null;
  lastName_LT?: number | null;
  lastName_LTE?: number | null;
  lastName_SHORTEST_EQUAL?: number | null;
  lastName_SHORTEST_GT?: number | null;
  lastName_SHORTEST_GTE?: number | null;
  lastName_SHORTEST_LT?: number | null;
  lastName_SHORTEST_LTE?: number | null;
  position_AVERAGE_EQUAL?: number | null;
  position_AVERAGE_GT?: number | null;
  position_AVERAGE_GTE?: number | null;
  position_AVERAGE_LT?: number | null;
  position_AVERAGE_LTE?: number | null;
  position_EQUAL?: string | null;
  position_GT?: number | null;
  position_GTE?: number | null;
  position_LONGEST_EQUAL?: number | null;
  position_LONGEST_GT?: number | null;
  position_LONGEST_GTE?: number | null;
  position_LONGEST_LT?: number | null;
  position_LONGEST_LTE?: number | null;
  position_LT?: number | null;
  position_LTE?: number | null;
  position_SHORTEST_EQUAL?: number | null;
  position_SHORTEST_GT?: number | null;
  position_SHORTEST_GTE?: number | null;
  position_SHORTEST_LT?: number | null;
  position_SHORTEST_LTE?: number | null;
  preferredLanguage_AVERAGE_EQUAL?: number | null;
  preferredLanguage_AVERAGE_GT?: number | null;
  preferredLanguage_AVERAGE_GTE?: number | null;
  preferredLanguage_AVERAGE_LT?: number | null;
  preferredLanguage_AVERAGE_LTE?: number | null;
  preferredLanguage_EQUAL?: string | null;
  preferredLanguage_GT?: number | null;
  preferredLanguage_GTE?: number | null;
  preferredLanguage_LONGEST_EQUAL?: number | null;
  preferredLanguage_LONGEST_GT?: number | null;
  preferredLanguage_LONGEST_GTE?: number | null;
  preferredLanguage_LONGEST_LT?: number | null;
  preferredLanguage_LONGEST_LTE?: number | null;
  preferredLanguage_LT?: number | null;
  preferredLanguage_LTE?: number | null;
  preferredLanguage_SHORTEST_EQUAL?: number | null;
  preferredLanguage_SHORTEST_GT?: number | null;
  preferredLanguage_SHORTEST_GTE?: number | null;
  preferredLanguage_SHORTEST_LT?: number | null;
  preferredLanguage_SHORTEST_LTE?: number | null;
  tenantId_AVERAGE_EQUAL?: number | null;
  tenantId_AVERAGE_GT?: number | null;
  tenantId_AVERAGE_GTE?: number | null;
  tenantId_AVERAGE_LT?: number | null;
  tenantId_AVERAGE_LTE?: number | null;
  tenantId_EQUAL?: string | null;
  tenantId_GT?: number | null;
  tenantId_GTE?: number | null;
  tenantId_LONGEST_EQUAL?: number | null;
  tenantId_LONGEST_GT?: number | null;
  tenantId_LONGEST_GTE?: number | null;
  tenantId_LONGEST_LT?: number | null;
  tenantId_LONGEST_LTE?: number | null;
  tenantId_LT?: number | null;
  tenantId_LTE?: number | null;
  tenantId_SHORTEST_EQUAL?: number | null;
  tenantId_SHORTEST_GT?: number | null;
  tenantId_SHORTEST_GTE?: number | null;
  tenantId_SHORTEST_LT?: number | null;
  tenantId_SHORTEST_LTE?: number | null;
}

export interface GenericPreparationsAggregateInput {
  AND?: GenericPreparationsAggregateInput[] | null;
  OR?: GenericPreparationsAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: GenericPreparationsNodeAggregationWhereInput | null;
}

export interface GenericPreparationsConnectionWhere {
  AND?: GenericPreparationsConnectionWhere[] | null;
  OR?: GenericPreparationsConnectionWhere[] | null;
  node?: PreparationWhere | null;
  node_NOT?: PreparationWhere | null;
}

export interface GenericPreparationsNodeAggregationWhereInput {
  AND?: GenericPreparationsNodeAggregationWhereInput[] | null;
  AtcCode_AVERAGE_EQUAL?: number | null;
  AtcCode_AVERAGE_GT?: number | null;
  AtcCode_AVERAGE_GTE?: number | null;
  AtcCode_AVERAGE_LT?: number | null;
  AtcCode_AVERAGE_LTE?: number | null;
  AtcCode_EQUAL?: string | null;
  AtcCode_GT?: number | null;
  AtcCode_GTE?: number | null;
  AtcCode_LONGEST_EQUAL?: number | null;
  AtcCode_LONGEST_GT?: number | null;
  AtcCode_LONGEST_GTE?: number | null;
  AtcCode_LONGEST_LT?: number | null;
  AtcCode_LONGEST_LTE?: number | null;
  AtcCode_LT?: number | null;
  AtcCode_LTE?: number | null;
  AtcCode_SHORTEST_EQUAL?: number | null;
  AtcCode_SHORTEST_GT?: number | null;
  AtcCode_SHORTEST_GTE?: number | null;
  AtcCode_SHORTEST_LT?: number | null;
  AtcCode_SHORTEST_LTE?: number | null;
  BrandName_AVERAGE_EQUAL?: number | null;
  BrandName_AVERAGE_GT?: number | null;
  BrandName_AVERAGE_GTE?: number | null;
  BrandName_AVERAGE_LT?: number | null;
  BrandName_AVERAGE_LTE?: number | null;
  BrandName_EQUAL?: string | null;
  BrandName_GT?: number | null;
  BrandName_GTE?: number | null;
  BrandName_LONGEST_EQUAL?: number | null;
  BrandName_LONGEST_GT?: number | null;
  BrandName_LONGEST_GTE?: number | null;
  BrandName_LONGEST_LT?: number | null;
  BrandName_LONGEST_LTE?: number | null;
  BrandName_LT?: number | null;
  BrandName_LTE?: number | null;
  BrandName_SHORTEST_EQUAL?: number | null;
  BrandName_SHORTEST_GT?: number | null;
  BrandName_SHORTEST_GTE?: number | null;
  BrandName_SHORTEST_LT?: number | null;
  BrandName_SHORTEST_LTE?: number | null;
  DescriptionDe_AVERAGE_EQUAL?: number | null;
  DescriptionDe_AVERAGE_GT?: number | null;
  DescriptionDe_AVERAGE_GTE?: number | null;
  DescriptionDe_AVERAGE_LT?: number | null;
  DescriptionDe_AVERAGE_LTE?: number | null;
  DescriptionDe_EQUAL?: string | null;
  DescriptionDe_GT?: number | null;
  DescriptionDe_GTE?: number | null;
  DescriptionDe_LONGEST_EQUAL?: number | null;
  DescriptionDe_LONGEST_GT?: number | null;
  DescriptionDe_LONGEST_GTE?: number | null;
  DescriptionDe_LONGEST_LT?: number | null;
  DescriptionDe_LONGEST_LTE?: number | null;
  DescriptionDe_LT?: number | null;
  DescriptionDe_LTE?: number | null;
  DescriptionDe_SHORTEST_EQUAL?: number | null;
  DescriptionDe_SHORTEST_GT?: number | null;
  DescriptionDe_SHORTEST_GTE?: number | null;
  DescriptionDe_SHORTEST_LT?: number | null;
  DescriptionDe_SHORTEST_LTE?: number | null;
  DescriptionFr_AVERAGE_EQUAL?: number | null;
  DescriptionFr_AVERAGE_GT?: number | null;
  DescriptionFr_AVERAGE_GTE?: number | null;
  DescriptionFr_AVERAGE_LT?: number | null;
  DescriptionFr_AVERAGE_LTE?: number | null;
  DescriptionFr_EQUAL?: string | null;
  DescriptionFr_GT?: number | null;
  DescriptionFr_GTE?: number | null;
  DescriptionFr_LONGEST_EQUAL?: number | null;
  DescriptionFr_LONGEST_GT?: number | null;
  DescriptionFr_LONGEST_GTE?: number | null;
  DescriptionFr_LONGEST_LT?: number | null;
  DescriptionFr_LONGEST_LTE?: number | null;
  DescriptionFr_LT?: number | null;
  DescriptionFr_LTE?: number | null;
  DescriptionFr_SHORTEST_EQUAL?: number | null;
  DescriptionFr_SHORTEST_GT?: number | null;
  DescriptionFr_SHORTEST_GTE?: number | null;
  DescriptionFr_SHORTEST_LT?: number | null;
  DescriptionFr_SHORTEST_LTE?: number | null;
  DescriptionIt_AVERAGE_EQUAL?: number | null;
  DescriptionIt_AVERAGE_GT?: number | null;
  DescriptionIt_AVERAGE_GTE?: number | null;
  DescriptionIt_AVERAGE_LT?: number | null;
  DescriptionIt_AVERAGE_LTE?: number | null;
  DescriptionIt_EQUAL?: string | null;
  DescriptionIt_GT?: number | null;
  DescriptionIt_GTE?: number | null;
  DescriptionIt_LONGEST_EQUAL?: number | null;
  DescriptionIt_LONGEST_GT?: number | null;
  DescriptionIt_LONGEST_GTE?: number | null;
  DescriptionIt_LONGEST_LT?: number | null;
  DescriptionIt_LONGEST_LTE?: number | null;
  DescriptionIt_LT?: number | null;
  DescriptionIt_LTE?: number | null;
  DescriptionIt_SHORTEST_EQUAL?: number | null;
  DescriptionIt_SHORTEST_GT?: number | null;
  DescriptionIt_SHORTEST_GTE?: number | null;
  DescriptionIt_SHORTEST_LT?: number | null;
  DescriptionIt_SHORTEST_LTE?: number | null;
  GenericName_AVERAGE_EQUAL?: number | null;
  GenericName_AVERAGE_GT?: number | null;
  GenericName_AVERAGE_GTE?: number | null;
  GenericName_AVERAGE_LT?: number | null;
  GenericName_AVERAGE_LTE?: number | null;
  GenericName_EQUAL?: string | null;
  GenericName_GT?: number | null;
  GenericName_GTE?: number | null;
  GenericName_LONGEST_EQUAL?: number | null;
  GenericName_LONGEST_GT?: number | null;
  GenericName_LONGEST_GTE?: number | null;
  GenericName_LONGEST_LT?: number | null;
  GenericName_LONGEST_LTE?: number | null;
  GenericName_LT?: number | null;
  GenericName_LTE?: number | null;
  GenericName_SHORTEST_EQUAL?: number | null;
  GenericName_SHORTEST_GT?: number | null;
  GenericName_SHORTEST_GTE?: number | null;
  GenericName_SHORTEST_LT?: number | null;
  GenericName_SHORTEST_LTE?: number | null;
  OR?: GenericPreparationsNodeAggregationWhereInput[] | null;
  SwissmedicNo5_AVERAGE_EQUAL?: number | null;
  SwissmedicNo5_AVERAGE_GT?: number | null;
  SwissmedicNo5_AVERAGE_GTE?: number | null;
  SwissmedicNo5_AVERAGE_LT?: number | null;
  SwissmedicNo5_AVERAGE_LTE?: number | null;
  SwissmedicNo5_EQUAL?: string | null;
  SwissmedicNo5_GT?: number | null;
  SwissmedicNo5_GTE?: number | null;
  SwissmedicNo5_LONGEST_EQUAL?: number | null;
  SwissmedicNo5_LONGEST_GT?: number | null;
  SwissmedicNo5_LONGEST_GTE?: number | null;
  SwissmedicNo5_LONGEST_LT?: number | null;
  SwissmedicNo5_LONGEST_LTE?: number | null;
  SwissmedicNo5_LT?: number | null;
  SwissmedicNo5_LTE?: number | null;
  SwissmedicNo5_SHORTEST_EQUAL?: number | null;
  SwissmedicNo5_SHORTEST_GT?: number | null;
  SwissmedicNo5_SHORTEST_GTE?: number | null;
  SwissmedicNo5_SHORTEST_LT?: number | null;
  SwissmedicNo5_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
}

export interface GenericWhere {
  AND?: GenericWhere[] | null;
  Name?: string | null;
  Name_CONTAINS?: string | null;
  Name_ENDS_WITH?: string | null;
  Name_IN?: (string | null)[] | null;
  Name_MATCHES?: string | null;
  Name_NOT?: string | null;
  Name_NOT_CONTAINS?: string | null;
  Name_NOT_ENDS_WITH?: string | null;
  Name_NOT_IN?: (string | null)[] | null;
  Name_NOT_STARTS_WITH?: string | null;
  Name_STARTS_WITH?: string | null;
  OR?: GenericWhere[] | null;
  createdBy?: UserWhere | null;
  createdByAggregate?: GenericCreatedByAggregateInput | null;
  createdByConnection?: GenericCreatedByConnectionWhere | null;
  createdByConnection_NOT?: GenericCreatedByConnectionWhere | null;
  createdBy_NOT?: UserWhere | null;
  creationWay?: MasterDataCreationWay | null;
  creationWay_IN?: (MasterDataCreationWay | null)[] | null;
  creationWay_NOT?: MasterDataCreationWay | null;
  creationWay_NOT_IN?: (MasterDataCreationWay | null)[] | null;
  id?: string | null;
  id_CONTAINS?: string | null;
  id_ENDS_WITH?: string | null;
  id_IN?: (string | null)[] | null;
  id_MATCHES?: string | null;
  id_NOT?: string | null;
  id_NOT_CONTAINS?: string | null;
  id_NOT_ENDS_WITH?: string | null;
  id_NOT_IN?: (string | null)[] | null;
  id_NOT_STARTS_WITH?: string | null;
  id_STARTS_WITH?: string | null;
  preparations?: PreparationWhere | null;
  preparationsAggregate?: GenericPreparationsAggregateInput | null;
  preparationsConnection?: GenericPreparationsConnectionWhere | null;
  preparationsConnection_NOT?: GenericPreparationsConnectionWhere | null;
  preparations_NOT?: PreparationWhere | null;
}

export interface IndicationWhere {
  AND?: IndicationWhere[] | null;
  OR?: IndicationWhere[] | null;
  code?: string | null;
  code_CONTAINS?: string | null;
  code_ENDS_WITH?: string | null;
  code_IN?: (string | null)[] | null;
  code_MATCHES?: string | null;
  code_NOT?: string | null;
  code_NOT_CONTAINS?: string | null;
  code_NOT_ENDS_WITH?: string | null;
  code_NOT_IN?: (string | null)[] | null;
  code_NOT_STARTS_WITH?: string | null;
  code_STARTS_WITH?: string | null;
  id?: string | null;
  id_CONTAINS?: string | null;
  id_ENDS_WITH?: string | null;
  id_IN?: (string | null)[] | null;
  id_MATCHES?: string | null;
  id_NOT?: string | null;
  id_NOT_CONTAINS?: string | null;
  id_NOT_ENDS_WITH?: string | null;
  id_NOT_IN?: (string | null)[] | null;
  id_NOT_STARTS_WITH?: string | null;
  id_STARTS_WITH?: string | null;
  intent?: string | null;
  intentLocalizationKey?: string | null;
  intentLocalizationKey_CONTAINS?: string | null;
  intentLocalizationKey_ENDS_WITH?: string | null;
  intentLocalizationKey_IN?: (string | null)[] | null;
  intentLocalizationKey_MATCHES?: string | null;
  intentLocalizationKey_NOT?: string | null;
  intentLocalizationKey_NOT_CONTAINS?: string | null;
  intentLocalizationKey_NOT_ENDS_WITH?: string | null;
  intentLocalizationKey_NOT_IN?: (string | null)[] | null;
  intentLocalizationKey_NOT_STARTS_WITH?: string | null;
  intentLocalizationKey_STARTS_WITH?: string | null;
  intent_CONTAINS?: string | null;
  intent_ENDS_WITH?: string | null;
  intent_IN?: (string | null)[] | null;
  intent_MATCHES?: string | null;
  intent_NOT?: string | null;
  intent_NOT_CONTAINS?: string | null;
  intent_NOT_ENDS_WITH?: string | null;
  intent_NOT_IN?: (string | null)[] | null;
  intent_NOT_STARTS_WITH?: string | null;
  intent_STARTS_WITH?: string | null;
  line?: string | null;
  lineLocalizationKey?: string | null;
  lineLocalizationKey_CONTAINS?: string | null;
  lineLocalizationKey_ENDS_WITH?: string | null;
  lineLocalizationKey_IN?: (string | null)[] | null;
  lineLocalizationKey_MATCHES?: string | null;
  lineLocalizationKey_NOT?: string | null;
  lineLocalizationKey_NOT_CONTAINS?: string | null;
  lineLocalizationKey_NOT_ENDS_WITH?: string | null;
  lineLocalizationKey_NOT_IN?: (string | null)[] | null;
  lineLocalizationKey_NOT_STARTS_WITH?: string | null;
  lineLocalizationKey_STARTS_WITH?: string | null;
  line_CONTAINS?: string | null;
  line_ENDS_WITH?: string | null;
  line_IN?: (string | null)[] | null;
  line_MATCHES?: string | null;
  line_NOT?: string | null;
  line_NOT_CONTAINS?: string | null;
  line_NOT_ENDS_WITH?: string | null;
  line_NOT_IN?: (string | null)[] | null;
  line_NOT_STARTS_WITH?: string | null;
  line_STARTS_WITH?: string | null;
  mutation?: string | null;
  mutationLocalizationKey?: string | null;
  mutationLocalizationKey_CONTAINS?: string | null;
  mutationLocalizationKey_ENDS_WITH?: string | null;
  mutationLocalizationKey_IN?: (string | null)[] | null;
  mutationLocalizationKey_MATCHES?: string | null;
  mutationLocalizationKey_NOT?: string | null;
  mutationLocalizationKey_NOT_CONTAINS?: string | null;
  mutationLocalizationKey_NOT_ENDS_WITH?: string | null;
  mutationLocalizationKey_NOT_IN?: (string | null)[] | null;
  mutationLocalizationKey_NOT_STARTS_WITH?: string | null;
  mutationLocalizationKey_STARTS_WITH?: string | null;
  mutation_CONTAINS?: string | null;
  mutation_ENDS_WITH?: string | null;
  mutation_IN?: (string | null)[] | null;
  mutation_MATCHES?: string | null;
  mutation_NOT?: string | null;
  mutation_NOT_CONTAINS?: string | null;
  mutation_NOT_ENDS_WITH?: string | null;
  mutation_NOT_IN?: (string | null)[] | null;
  mutation_NOT_STARTS_WITH?: string | null;
  mutation_STARTS_WITH?: string | null;
  type?: string | null;
  typeLocalizationKey?: string | null;
  typeLocalizationKey_CONTAINS?: string | null;
  typeLocalizationKey_ENDS_WITH?: string | null;
  typeLocalizationKey_IN?: (string | null)[] | null;
  typeLocalizationKey_MATCHES?: string | null;
  typeLocalizationKey_NOT?: string | null;
  typeLocalizationKey_NOT_CONTAINS?: string | null;
  typeLocalizationKey_NOT_ENDS_WITH?: string | null;
  typeLocalizationKey_NOT_IN?: (string | null)[] | null;
  typeLocalizationKey_NOT_STARTS_WITH?: string | null;
  typeLocalizationKey_STARTS_WITH?: string | null;
  type_CONTAINS?: string | null;
  type_ENDS_WITH?: string | null;
  type_IN?: (string | null)[] | null;
  type_MATCHES?: string | null;
  type_NOT?: string | null;
  type_NOT_CONTAINS?: string | null;
  type_NOT_ENDS_WITH?: string | null;
  type_NOT_IN?: (string | null)[] | null;
  type_NOT_STARTS_WITH?: string | null;
  type_STARTS_WITH?: string | null;
}

export interface InterventionReportStatusUpdateInput {
  formId: string;
  reportStatus: RefundStatus;
}

export interface IssueInvoiceWithoutReviewInput {
  assignees?: (string | null)[] | null;
  coveragePeriod?: string | null;
  documentType: DocumentType;
  financialDataPoints: FinancialDataPointInput[];
  invoiceAmount: number;
  invoiceId: string;
  invoiceStatus: DocumentStatus;
  operation?: string | null;
}

export interface LimitationLimitsPreparationsAggregateInput {
  AND?: LimitationLimitsPreparationsAggregateInput[] | null;
  OR?: LimitationLimitsPreparationsAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: LimitationLimitsPreparationsNodeAggregationWhereInput | null;
}

export interface LimitationLimitsPreparationsConnectionWhere {
  AND?: LimitationLimitsPreparationsConnectionWhere[] | null;
  OR?: LimitationLimitsPreparationsConnectionWhere[] | null;
  node?: PreparationWhere | null;
  node_NOT?: PreparationWhere | null;
}

export interface LimitationLimitsPreparationsNodeAggregationWhereInput {
  AND?: LimitationLimitsPreparationsNodeAggregationWhereInput[] | null;
  AtcCode_AVERAGE_EQUAL?: number | null;
  AtcCode_AVERAGE_GT?: number | null;
  AtcCode_AVERAGE_GTE?: number | null;
  AtcCode_AVERAGE_LT?: number | null;
  AtcCode_AVERAGE_LTE?: number | null;
  AtcCode_EQUAL?: string | null;
  AtcCode_GT?: number | null;
  AtcCode_GTE?: number | null;
  AtcCode_LONGEST_EQUAL?: number | null;
  AtcCode_LONGEST_GT?: number | null;
  AtcCode_LONGEST_GTE?: number | null;
  AtcCode_LONGEST_LT?: number | null;
  AtcCode_LONGEST_LTE?: number | null;
  AtcCode_LT?: number | null;
  AtcCode_LTE?: number | null;
  AtcCode_SHORTEST_EQUAL?: number | null;
  AtcCode_SHORTEST_GT?: number | null;
  AtcCode_SHORTEST_GTE?: number | null;
  AtcCode_SHORTEST_LT?: number | null;
  AtcCode_SHORTEST_LTE?: number | null;
  BrandName_AVERAGE_EQUAL?: number | null;
  BrandName_AVERAGE_GT?: number | null;
  BrandName_AVERAGE_GTE?: number | null;
  BrandName_AVERAGE_LT?: number | null;
  BrandName_AVERAGE_LTE?: number | null;
  BrandName_EQUAL?: string | null;
  BrandName_GT?: number | null;
  BrandName_GTE?: number | null;
  BrandName_LONGEST_EQUAL?: number | null;
  BrandName_LONGEST_GT?: number | null;
  BrandName_LONGEST_GTE?: number | null;
  BrandName_LONGEST_LT?: number | null;
  BrandName_LONGEST_LTE?: number | null;
  BrandName_LT?: number | null;
  BrandName_LTE?: number | null;
  BrandName_SHORTEST_EQUAL?: number | null;
  BrandName_SHORTEST_GT?: number | null;
  BrandName_SHORTEST_GTE?: number | null;
  BrandName_SHORTEST_LT?: number | null;
  BrandName_SHORTEST_LTE?: number | null;
  DescriptionDe_AVERAGE_EQUAL?: number | null;
  DescriptionDe_AVERAGE_GT?: number | null;
  DescriptionDe_AVERAGE_GTE?: number | null;
  DescriptionDe_AVERAGE_LT?: number | null;
  DescriptionDe_AVERAGE_LTE?: number | null;
  DescriptionDe_EQUAL?: string | null;
  DescriptionDe_GT?: number | null;
  DescriptionDe_GTE?: number | null;
  DescriptionDe_LONGEST_EQUAL?: number | null;
  DescriptionDe_LONGEST_GT?: number | null;
  DescriptionDe_LONGEST_GTE?: number | null;
  DescriptionDe_LONGEST_LT?: number | null;
  DescriptionDe_LONGEST_LTE?: number | null;
  DescriptionDe_LT?: number | null;
  DescriptionDe_LTE?: number | null;
  DescriptionDe_SHORTEST_EQUAL?: number | null;
  DescriptionDe_SHORTEST_GT?: number | null;
  DescriptionDe_SHORTEST_GTE?: number | null;
  DescriptionDe_SHORTEST_LT?: number | null;
  DescriptionDe_SHORTEST_LTE?: number | null;
  DescriptionFr_AVERAGE_EQUAL?: number | null;
  DescriptionFr_AVERAGE_GT?: number | null;
  DescriptionFr_AVERAGE_GTE?: number | null;
  DescriptionFr_AVERAGE_LT?: number | null;
  DescriptionFr_AVERAGE_LTE?: number | null;
  DescriptionFr_EQUAL?: string | null;
  DescriptionFr_GT?: number | null;
  DescriptionFr_GTE?: number | null;
  DescriptionFr_LONGEST_EQUAL?: number | null;
  DescriptionFr_LONGEST_GT?: number | null;
  DescriptionFr_LONGEST_GTE?: number | null;
  DescriptionFr_LONGEST_LT?: number | null;
  DescriptionFr_LONGEST_LTE?: number | null;
  DescriptionFr_LT?: number | null;
  DescriptionFr_LTE?: number | null;
  DescriptionFr_SHORTEST_EQUAL?: number | null;
  DescriptionFr_SHORTEST_GT?: number | null;
  DescriptionFr_SHORTEST_GTE?: number | null;
  DescriptionFr_SHORTEST_LT?: number | null;
  DescriptionFr_SHORTEST_LTE?: number | null;
  DescriptionIt_AVERAGE_EQUAL?: number | null;
  DescriptionIt_AVERAGE_GT?: number | null;
  DescriptionIt_AVERAGE_GTE?: number | null;
  DescriptionIt_AVERAGE_LT?: number | null;
  DescriptionIt_AVERAGE_LTE?: number | null;
  DescriptionIt_EQUAL?: string | null;
  DescriptionIt_GT?: number | null;
  DescriptionIt_GTE?: number | null;
  DescriptionIt_LONGEST_EQUAL?: number | null;
  DescriptionIt_LONGEST_GT?: number | null;
  DescriptionIt_LONGEST_GTE?: number | null;
  DescriptionIt_LONGEST_LT?: number | null;
  DescriptionIt_LONGEST_LTE?: number | null;
  DescriptionIt_LT?: number | null;
  DescriptionIt_LTE?: number | null;
  DescriptionIt_SHORTEST_EQUAL?: number | null;
  DescriptionIt_SHORTEST_GT?: number | null;
  DescriptionIt_SHORTEST_GTE?: number | null;
  DescriptionIt_SHORTEST_LT?: number | null;
  DescriptionIt_SHORTEST_LTE?: number | null;
  GenericName_AVERAGE_EQUAL?: number | null;
  GenericName_AVERAGE_GT?: number | null;
  GenericName_AVERAGE_GTE?: number | null;
  GenericName_AVERAGE_LT?: number | null;
  GenericName_AVERAGE_LTE?: number | null;
  GenericName_EQUAL?: string | null;
  GenericName_GT?: number | null;
  GenericName_GTE?: number | null;
  GenericName_LONGEST_EQUAL?: number | null;
  GenericName_LONGEST_GT?: number | null;
  GenericName_LONGEST_GTE?: number | null;
  GenericName_LONGEST_LT?: number | null;
  GenericName_LONGEST_LTE?: number | null;
  GenericName_LT?: number | null;
  GenericName_LTE?: number | null;
  GenericName_SHORTEST_EQUAL?: number | null;
  GenericName_SHORTEST_GT?: number | null;
  GenericName_SHORTEST_GTE?: number | null;
  GenericName_SHORTEST_LT?: number | null;
  GenericName_SHORTEST_LTE?: number | null;
  OR?: LimitationLimitsPreparationsNodeAggregationWhereInput[] | null;
  SwissmedicNo5_AVERAGE_EQUAL?: number | null;
  SwissmedicNo5_AVERAGE_GT?: number | null;
  SwissmedicNo5_AVERAGE_GTE?: number | null;
  SwissmedicNo5_AVERAGE_LT?: number | null;
  SwissmedicNo5_AVERAGE_LTE?: number | null;
  SwissmedicNo5_EQUAL?: string | null;
  SwissmedicNo5_GT?: number | null;
  SwissmedicNo5_GTE?: number | null;
  SwissmedicNo5_LONGEST_EQUAL?: number | null;
  SwissmedicNo5_LONGEST_GT?: number | null;
  SwissmedicNo5_LONGEST_GTE?: number | null;
  SwissmedicNo5_LONGEST_LT?: number | null;
  SwissmedicNo5_LONGEST_LTE?: number | null;
  SwissmedicNo5_LT?: number | null;
  SwissmedicNo5_LTE?: number | null;
  SwissmedicNo5_SHORTEST_EQUAL?: number | null;
  SwissmedicNo5_SHORTEST_GT?: number | null;
  SwissmedicNo5_SHORTEST_GTE?: number | null;
  SwissmedicNo5_SHORTEST_LT?: number | null;
  SwissmedicNo5_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
}

export interface LimitationLimitsTreatmentAggregateInput {
  AND?: LimitationLimitsTreatmentAggregateInput[] | null;
  OR?: LimitationLimitsTreatmentAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: LimitationLimitsTreatmentNodeAggregationWhereInput | null;
}

export interface LimitationLimitsTreatmentConnectionWhere {
  AND?: LimitationLimitsTreatmentConnectionWhere[] | null;
  OR?: LimitationLimitsTreatmentConnectionWhere[] | null;
  node?: TreatmentWhere | null;
  node_NOT?: TreatmentWhere | null;
}

export interface LimitationLimitsTreatmentNodeAggregationWhereInput {
  AND?: LimitationLimitsTreatmentNodeAggregationWhereInput[] | null;
  BagDossierNo_AVERAGE_EQUAL?: number | null;
  BagDossierNo_AVERAGE_GT?: number | null;
  BagDossierNo_AVERAGE_GTE?: number | null;
  BagDossierNo_AVERAGE_LT?: number | null;
  BagDossierNo_AVERAGE_LTE?: number | null;
  BagDossierNo_EQUAL?: string | null;
  BagDossierNo_GT?: number | null;
  BagDossierNo_GTE?: number | null;
  BagDossierNo_LONGEST_EQUAL?: number | null;
  BagDossierNo_LONGEST_GT?: number | null;
  BagDossierNo_LONGEST_GTE?: number | null;
  BagDossierNo_LONGEST_LT?: number | null;
  BagDossierNo_LONGEST_LTE?: number | null;
  BagDossierNo_LT?: number | null;
  BagDossierNo_LTE?: number | null;
  BagDossierNo_SHORTEST_EQUAL?: number | null;
  BagDossierNo_SHORTEST_GT?: number | null;
  BagDossierNo_SHORTEST_GTE?: number | null;
  BagDossierNo_SHORTEST_LT?: number | null;
  BagDossierNo_SHORTEST_LTE?: number | null;
  Code_AVERAGE_EQUAL?: number | null;
  Code_AVERAGE_GT?: number | null;
  Code_AVERAGE_GTE?: number | null;
  Code_AVERAGE_LT?: number | null;
  Code_AVERAGE_LTE?: number | null;
  Code_EQUAL?: string | null;
  Code_GT?: number | null;
  Code_GTE?: number | null;
  Code_LONGEST_EQUAL?: number | null;
  Code_LONGEST_GT?: number | null;
  Code_LONGEST_GTE?: number | null;
  Code_LONGEST_LT?: number | null;
  Code_LONGEST_LTE?: number | null;
  Code_LT?: number | null;
  Code_LTE?: number | null;
  Code_SHORTEST_EQUAL?: number | null;
  Code_SHORTEST_GT?: number | null;
  Code_SHORTEST_GTE?: number | null;
  Code_SHORTEST_LT?: number | null;
  Code_SHORTEST_LTE?: number | null;
  FlagModal_AVERAGE_EQUAL?: number | null;
  FlagModal_AVERAGE_GT?: number | null;
  FlagModal_AVERAGE_GTE?: number | null;
  FlagModal_AVERAGE_LT?: number | null;
  FlagModal_AVERAGE_LTE?: number | null;
  FlagModal_EQUAL?: string | null;
  FlagModal_GT?: number | null;
  FlagModal_GTE?: number | null;
  FlagModal_LONGEST_EQUAL?: number | null;
  FlagModal_LONGEST_GT?: number | null;
  FlagModal_LONGEST_GTE?: number | null;
  FlagModal_LONGEST_LT?: number | null;
  FlagModal_LONGEST_LTE?: number | null;
  FlagModal_LT?: number | null;
  FlagModal_LTE?: number | null;
  FlagModal_SHORTEST_EQUAL?: number | null;
  FlagModal_SHORTEST_GT?: number | null;
  FlagModal_SHORTEST_GTE?: number | null;
  FlagModal_SHORTEST_LT?: number | null;
  FlagModal_SHORTEST_LTE?: number | null;
  FlagNarcosis_AVERAGE_EQUAL?: number | null;
  FlagNarcosis_AVERAGE_GT?: number | null;
  FlagNarcosis_AVERAGE_GTE?: number | null;
  FlagNarcosis_AVERAGE_LT?: number | null;
  FlagNarcosis_AVERAGE_LTE?: number | null;
  FlagNarcosis_EQUAL?: string | null;
  FlagNarcosis_GT?: number | null;
  FlagNarcosis_GTE?: number | null;
  FlagNarcosis_LONGEST_EQUAL?: number | null;
  FlagNarcosis_LONGEST_GT?: number | null;
  FlagNarcosis_LONGEST_GTE?: number | null;
  FlagNarcosis_LONGEST_LT?: number | null;
  FlagNarcosis_LONGEST_LTE?: number | null;
  FlagNarcosis_LT?: number | null;
  FlagNarcosis_LTE?: number | null;
  FlagNarcosis_SHORTEST_EQUAL?: number | null;
  FlagNarcosis_SHORTEST_GT?: number | null;
  FlagNarcosis_SHORTEST_GTE?: number | null;
  FlagNarcosis_SHORTEST_LT?: number | null;
  FlagNarcosis_SHORTEST_LTE?: number | null;
  GTIN_AVERAGE_EQUAL?: number | null;
  GTIN_AVERAGE_GT?: number | null;
  GTIN_AVERAGE_GTE?: number | null;
  GTIN_AVERAGE_LT?: number | null;
  GTIN_AVERAGE_LTE?: number | null;
  GTIN_EQUAL?: string | null;
  GTIN_GT?: number | null;
  GTIN_GTE?: number | null;
  GTIN_LONGEST_EQUAL?: number | null;
  GTIN_LONGEST_GT?: number | null;
  GTIN_LONGEST_GTE?: number | null;
  GTIN_LONGEST_LT?: number | null;
  GTIN_LONGEST_LTE?: number | null;
  GTIN_LT?: number | null;
  GTIN_LTE?: number | null;
  GTIN_SHORTEST_EQUAL?: number | null;
  GTIN_SHORTEST_GT?: number | null;
  GTIN_SHORTEST_GTE?: number | null;
  GTIN_SHORTEST_LT?: number | null;
  GTIN_SHORTEST_LTE?: number | null;
  LOT_AVERAGE_EQUAL?: number | null;
  LOT_AVERAGE_GT?: number | null;
  LOT_AVERAGE_GTE?: number | null;
  LOT_AVERAGE_LT?: number | null;
  LOT_AVERAGE_LTE?: number | null;
  LOT_EQUAL?: string | null;
  LOT_GT?: number | null;
  LOT_GTE?: number | null;
  LOT_LONGEST_EQUAL?: number | null;
  LOT_LONGEST_GT?: number | null;
  LOT_LONGEST_GTE?: number | null;
  LOT_LONGEST_LT?: number | null;
  LOT_LONGEST_LTE?: number | null;
  LOT_LT?: number | null;
  LOT_LTE?: number | null;
  LOT_SHORTEST_EQUAL?: number | null;
  LOT_SHORTEST_GT?: number | null;
  LOT_SHORTEST_GTE?: number | null;
  LOT_SHORTEST_LT?: number | null;
  LOT_SHORTEST_LTE?: number | null;
  Name_AVERAGE_EQUAL?: number | null;
  Name_AVERAGE_GT?: number | null;
  Name_AVERAGE_GTE?: number | null;
  Name_AVERAGE_LT?: number | null;
  Name_AVERAGE_LTE?: number | null;
  Name_EQUAL?: string | null;
  Name_GT?: number | null;
  Name_GTE?: number | null;
  Name_LONGEST_EQUAL?: number | null;
  Name_LONGEST_GT?: number | null;
  Name_LONGEST_GTE?: number | null;
  Name_LONGEST_LT?: number | null;
  Name_LONGEST_LTE?: number | null;
  Name_LT?: number | null;
  Name_LTE?: number | null;
  Name_SHORTEST_EQUAL?: number | null;
  Name_SHORTEST_GT?: number | null;
  Name_SHORTEST_GTE?: number | null;
  Name_SHORTEST_LT?: number | null;
  Name_SHORTEST_LTE?: number | null;
  OR?: LimitationLimitsTreatmentNodeAggregationWhereInput[] | null;
  PharmaCode_AVERAGE_EQUAL?: number | null;
  PharmaCode_AVERAGE_GT?: number | null;
  PharmaCode_AVERAGE_GTE?: number | null;
  PharmaCode_AVERAGE_LT?: number | null;
  PharmaCode_AVERAGE_LTE?: number | null;
  PharmaCode_EQUAL?: string | null;
  PharmaCode_GT?: number | null;
  PharmaCode_GTE?: number | null;
  PharmaCode_LONGEST_EQUAL?: number | null;
  PharmaCode_LONGEST_GT?: number | null;
  PharmaCode_LONGEST_GTE?: number | null;
  PharmaCode_LONGEST_LT?: number | null;
  PharmaCode_LONGEST_LTE?: number | null;
  PharmaCode_LT?: number | null;
  PharmaCode_LTE?: number | null;
  PharmaCode_SHORTEST_EQUAL?: number | null;
  PharmaCode_SHORTEST_GT?: number | null;
  PharmaCode_SHORTEST_GTE?: number | null;
  PharmaCode_SHORTEST_LT?: number | null;
  PharmaCode_SHORTEST_LTE?: number | null;
  PrevPharmacode_AVERAGE_EQUAL?: number | null;
  PrevPharmacode_AVERAGE_GT?: number | null;
  PrevPharmacode_AVERAGE_GTE?: number | null;
  PrevPharmacode_AVERAGE_LT?: number | null;
  PrevPharmacode_AVERAGE_LTE?: number | null;
  PrevPharmacode_EQUAL?: string | null;
  PrevPharmacode_GT?: number | null;
  PrevPharmacode_GTE?: number | null;
  PrevPharmacode_LONGEST_EQUAL?: number | null;
  PrevPharmacode_LONGEST_GT?: number | null;
  PrevPharmacode_LONGEST_GTE?: number | null;
  PrevPharmacode_LONGEST_LT?: number | null;
  PrevPharmacode_LONGEST_LTE?: number | null;
  PrevPharmacode_LT?: number | null;
  PrevPharmacode_LTE?: number | null;
  PrevPharmacode_SHORTEST_EQUAL?: number | null;
  PrevPharmacode_SHORTEST_GT?: number | null;
  PrevPharmacode_SHORTEST_GTE?: number | null;
  PrevPharmacode_SHORTEST_LT?: number | null;
  PrevPharmacode_SHORTEST_LTE?: number | null;
  REF_AVERAGE_EQUAL?: number | null;
  REF_AVERAGE_GT?: number | null;
  REF_AVERAGE_GTE?: number | null;
  REF_AVERAGE_LT?: number | null;
  REF_AVERAGE_LTE?: number | null;
  REF_EQUAL?: string | null;
  REF_GT?: number | null;
  REF_GTE?: number | null;
  REF_LONGEST_EQUAL?: number | null;
  REF_LONGEST_GT?: number | null;
  REF_LONGEST_GTE?: number | null;
  REF_LONGEST_LT?: number | null;
  REF_LONGEST_LTE?: number | null;
  REF_LT?: number | null;
  REF_LTE?: number | null;
  REF_SHORTEST_EQUAL?: number | null;
  REF_SHORTEST_GT?: number | null;
  REF_SHORTEST_GTE?: number | null;
  REF_SHORTEST_LT?: number | null;
  REF_SHORTEST_LTE?: number | null;
  SwissmedicCategory_AVERAGE_EQUAL?: number | null;
  SwissmedicCategory_AVERAGE_GT?: number | null;
  SwissmedicCategory_AVERAGE_GTE?: number | null;
  SwissmedicCategory_AVERAGE_LT?: number | null;
  SwissmedicCategory_AVERAGE_LTE?: number | null;
  SwissmedicCategory_EQUAL?: string | null;
  SwissmedicCategory_GT?: number | null;
  SwissmedicCategory_GTE?: number | null;
  SwissmedicCategory_LONGEST_EQUAL?: number | null;
  SwissmedicCategory_LONGEST_GT?: number | null;
  SwissmedicCategory_LONGEST_GTE?: number | null;
  SwissmedicCategory_LONGEST_LT?: number | null;
  SwissmedicCategory_LONGEST_LTE?: number | null;
  SwissmedicCategory_LT?: number | null;
  SwissmedicCategory_LTE?: number | null;
  SwissmedicCategory_SHORTEST_EQUAL?: number | null;
  SwissmedicCategory_SHORTEST_GT?: number | null;
  SwissmedicCategory_SHORTEST_GTE?: number | null;
  SwissmedicCategory_SHORTEST_LT?: number | null;
  SwissmedicCategory_SHORTEST_LTE?: number | null;
  SwissmedicNo8_AVERAGE_EQUAL?: number | null;
  SwissmedicNo8_AVERAGE_GT?: number | null;
  SwissmedicNo8_AVERAGE_GTE?: number | null;
  SwissmedicNo8_AVERAGE_LT?: number | null;
  SwissmedicNo8_AVERAGE_LTE?: number | null;
  SwissmedicNo8_EQUAL?: string | null;
  SwissmedicNo8_GT?: number | null;
  SwissmedicNo8_GTE?: number | null;
  SwissmedicNo8_LONGEST_EQUAL?: number | null;
  SwissmedicNo8_LONGEST_GT?: number | null;
  SwissmedicNo8_LONGEST_GTE?: number | null;
  SwissmedicNo8_LONGEST_LT?: number | null;
  SwissmedicNo8_LONGEST_LTE?: number | null;
  SwissmedicNo8_LT?: number | null;
  SwissmedicNo8_LTE?: number | null;
  SwissmedicNo8_SHORTEST_EQUAL?: number | null;
  SwissmedicNo8_SHORTEST_GT?: number | null;
  SwissmedicNo8_SHORTEST_GTE?: number | null;
  SwissmedicNo8_SHORTEST_LT?: number | null;
  SwissmedicNo8_SHORTEST_LTE?: number | null;
  UDI_AVERAGE_EQUAL?: number | null;
  UDI_AVERAGE_GT?: number | null;
  UDI_AVERAGE_GTE?: number | null;
  UDI_AVERAGE_LT?: number | null;
  UDI_AVERAGE_LTE?: number | null;
  UDI_EQUAL?: string | null;
  UDI_GT?: number | null;
  UDI_GTE?: number | null;
  UDI_LONGEST_EQUAL?: number | null;
  UDI_LONGEST_GT?: number | null;
  UDI_LONGEST_GTE?: number | null;
  UDI_LONGEST_LT?: number | null;
  UDI_LONGEST_LTE?: number | null;
  UDI_LT?: number | null;
  UDI_LTE?: number | null;
  UDI_SHORTEST_EQUAL?: number | null;
  UDI_SHORTEST_GT?: number | null;
  UDI_SHORTEST_GTE?: number | null;
  UDI_SHORTEST_LT?: number | null;
  UDI_SHORTEST_LTE?: number | null;
  activeIngredientQuantity_AVERAGE_EQUAL?: number | null;
  activeIngredientQuantity_AVERAGE_GT?: number | null;
  activeIngredientQuantity_AVERAGE_GTE?: number | null;
  activeIngredientQuantity_AVERAGE_LT?: number | null;
  activeIngredientQuantity_AVERAGE_LTE?: number | null;
  activeIngredientQuantity_EQUAL?: number | null;
  activeIngredientQuantity_GT?: number | null;
  activeIngredientQuantity_GTE?: number | null;
  activeIngredientQuantity_LT?: number | null;
  activeIngredientQuantity_LTE?: number | null;
  activeIngredientQuantity_MAX_EQUAL?: number | null;
  activeIngredientQuantity_MAX_GT?: number | null;
  activeIngredientQuantity_MAX_GTE?: number | null;
  activeIngredientQuantity_MAX_LT?: number | null;
  activeIngredientQuantity_MAX_LTE?: number | null;
  activeIngredientQuantity_MIN_EQUAL?: number | null;
  activeIngredientQuantity_MIN_GT?: number | null;
  activeIngredientQuantity_MIN_GTE?: number | null;
  activeIngredientQuantity_MIN_LT?: number | null;
  activeIngredientQuantity_MIN_LTE?: number | null;
  activeIngredientQuantity_SUM_EQUAL?: number | null;
  activeIngredientQuantity_SUM_GT?: number | null;
  activeIngredientQuantity_SUM_GTE?: number | null;
  activeIngredientQuantity_SUM_LT?: number | null;
  activeIngredientQuantity_SUM_LTE?: number | null;
  classificationSystem_AVERAGE_EQUAL?: number | null;
  classificationSystem_AVERAGE_GT?: number | null;
  classificationSystem_AVERAGE_GTE?: number | null;
  classificationSystem_AVERAGE_LT?: number | null;
  classificationSystem_AVERAGE_LTE?: number | null;
  classificationSystem_EQUAL?: string | null;
  classificationSystem_GT?: number | null;
  classificationSystem_GTE?: number | null;
  classificationSystem_LONGEST_EQUAL?: number | null;
  classificationSystem_LONGEST_GT?: number | null;
  classificationSystem_LONGEST_GTE?: number | null;
  classificationSystem_LONGEST_LT?: number | null;
  classificationSystem_LONGEST_LTE?: number | null;
  classificationSystem_LT?: number | null;
  classificationSystem_LTE?: number | null;
  classificationSystem_SHORTEST_EQUAL?: number | null;
  classificationSystem_SHORTEST_GT?: number | null;
  classificationSystem_SHORTEST_GTE?: number | null;
  classificationSystem_SHORTEST_LT?: number | null;
  classificationSystem_SHORTEST_LTE?: number | null;
  concentration_AVERAGE_EQUAL?: number | null;
  concentration_AVERAGE_GT?: number | null;
  concentration_AVERAGE_GTE?: number | null;
  concentration_AVERAGE_LT?: number | null;
  concentration_AVERAGE_LTE?: number | null;
  concentration_EQUAL?: string | null;
  concentration_GT?: number | null;
  concentration_GTE?: number | null;
  concentration_LONGEST_EQUAL?: number | null;
  concentration_LONGEST_GT?: number | null;
  concentration_LONGEST_GTE?: number | null;
  concentration_LONGEST_LT?: number | null;
  concentration_LONGEST_LTE?: number | null;
  concentration_LT?: number | null;
  concentration_LTE?: number | null;
  concentration_SHORTEST_EQUAL?: number | null;
  concentration_SHORTEST_GT?: number | null;
  concentration_SHORTEST_GTE?: number | null;
  concentration_SHORTEST_LT?: number | null;
  concentration_SHORTEST_LTE?: number | null;
  packVolume_AVERAGE_EQUAL?: number | null;
  packVolume_AVERAGE_GT?: number | null;
  packVolume_AVERAGE_GTE?: number | null;
  packVolume_AVERAGE_LT?: number | null;
  packVolume_AVERAGE_LTE?: number | null;
  packVolume_EQUAL?: string | null;
  packVolume_GT?: number | null;
  packVolume_GTE?: number | null;
  packVolume_LONGEST_EQUAL?: number | null;
  packVolume_LONGEST_GT?: number | null;
  packVolume_LONGEST_GTE?: number | null;
  packVolume_LONGEST_LT?: number | null;
  packVolume_LONGEST_LTE?: number | null;
  packVolume_LT?: number | null;
  packVolume_LTE?: number | null;
  packVolume_SHORTEST_EQUAL?: number | null;
  packVolume_SHORTEST_GT?: number | null;
  packVolume_SHORTEST_GTE?: number | null;
  packVolume_SHORTEST_LT?: number | null;
  packVolume_SHORTEST_LTE?: number | null;
}

export interface LimitationWhere {
  AND?: LimitationWhere[] | null;
  Code?: string | null;
  Code_CONTAINS?: string | null;
  Code_ENDS_WITH?: string | null;
  Code_IN?: (string | null)[] | null;
  Code_MATCHES?: string | null;
  Code_NOT?: string | null;
  Code_NOT_CONTAINS?: string | null;
  Code_NOT_ENDS_WITH?: string | null;
  Code_NOT_IN?: (string | null)[] | null;
  Code_NOT_STARTS_WITH?: string | null;
  Code_STARTS_WITH?: string | null;
  DescriptionDe?: string | null;
  DescriptionDe_CONTAINS?: string | null;
  DescriptionDe_ENDS_WITH?: string | null;
  DescriptionDe_IN?: (string | null)[] | null;
  DescriptionDe_MATCHES?: string | null;
  DescriptionDe_NOT?: string | null;
  DescriptionDe_NOT_CONTAINS?: string | null;
  DescriptionDe_NOT_ENDS_WITH?: string | null;
  DescriptionDe_NOT_IN?: (string | null)[] | null;
  DescriptionDe_NOT_STARTS_WITH?: string | null;
  DescriptionDe_STARTS_WITH?: string | null;
  DescriptionEn?: string | null;
  DescriptionEn_CONTAINS?: string | null;
  DescriptionEn_ENDS_WITH?: string | null;
  DescriptionEn_IN?: (string | null)[] | null;
  DescriptionEn_MATCHES?: string | null;
  DescriptionEn_NOT?: string | null;
  DescriptionEn_NOT_CONTAINS?: string | null;
  DescriptionEn_NOT_ENDS_WITH?: string | null;
  DescriptionEn_NOT_IN?: (string | null)[] | null;
  DescriptionEn_NOT_STARTS_WITH?: string | null;
  DescriptionEn_STARTS_WITH?: string | null;
  Niveau?: string | null;
  Niveau_CONTAINS?: string | null;
  Niveau_ENDS_WITH?: string | null;
  Niveau_IN?: (string | null)[] | null;
  Niveau_MATCHES?: string | null;
  Niveau_NOT?: string | null;
  Niveau_NOT_CONTAINS?: string | null;
  Niveau_NOT_ENDS_WITH?: string | null;
  Niveau_NOT_IN?: (string | null)[] | null;
  Niveau_NOT_STARTS_WITH?: string | null;
  Niveau_STARTS_WITH?: string | null;
  OR?: LimitationWhere[] | null;
  Type?: string | null;
  Type_CONTAINS?: string | null;
  Type_ENDS_WITH?: string | null;
  Type_IN?: (string | null)[] | null;
  Type_MATCHES?: string | null;
  Type_NOT?: string | null;
  Type_NOT_CONTAINS?: string | null;
  Type_NOT_ENDS_WITH?: string | null;
  Type_NOT_IN?: (string | null)[] | null;
  Type_NOT_STARTS_WITH?: string | null;
  Type_STARTS_WITH?: string | null;
  ValidFromDate?: any | null;
  ValidFromDate_GT?: any | null;
  ValidFromDate_GTE?: any | null;
  ValidFromDate_IN?: (any | null)[] | null;
  ValidFromDate_LT?: any | null;
  ValidFromDate_LTE?: any | null;
  ValidFromDate_NOT?: any | null;
  ValidFromDate_NOT_IN?: (any | null)[] | null;
  ValidThruDate?: any | null;
  ValidThruDate_GT?: any | null;
  ValidThruDate_GTE?: any | null;
  ValidThruDate_IN?: (any | null)[] | null;
  ValidThruDate_LT?: any | null;
  ValidThruDate_LTE?: any | null;
  ValidThruDate_NOT?: any | null;
  ValidThruDate_NOT_IN?: (any | null)[] | null;
  limitsPreparations?: PreparationWhere | null;
  limitsPreparationsAggregate?: LimitationLimitsPreparationsAggregateInput | null;
  limitsPreparationsConnection?: LimitationLimitsPreparationsConnectionWhere | null;
  limitsPreparationsConnection_NOT?: LimitationLimitsPreparationsConnectionWhere | null;
  limitsPreparations_NOT?: PreparationWhere | null;
  limitsTreatment?: TreatmentWhere | null;
  limitsTreatmentAggregate?: LimitationLimitsTreatmentAggregateInput | null;
  limitsTreatmentConnection?: LimitationLimitsTreatmentConnectionWhere | null;
  limitsTreatmentConnection_NOT?: LimitationLimitsTreatmentConnectionWhere | null;
  limitsTreatment_NOT?: TreatmentWhere | null;
  uuid?: string | null;
  uuid_CONTAINS?: string | null;
  uuid_ENDS_WITH?: string | null;
  uuid_IN?: (string | null)[] | null;
  uuid_MATCHES?: string | null;
  uuid_NOT?: string | null;
  uuid_NOT_CONTAINS?: string | null;
  uuid_NOT_ENDS_WITH?: string | null;
  uuid_NOT_IN?: (string | null)[] | null;
  uuid_NOT_STARTS_WITH?: string | null;
  uuid_STARTS_WITH?: string | null;
}

export interface MessageCaseAggregateInput {
  AND?: MessageCaseAggregateInput[] | null;
  OR?: MessageCaseAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: MessageCaseNodeAggregationWhereInput | null;
}

export interface MessageCaseConnectionWhere {
  AND?: MessageCaseConnectionWhere[] | null;
  OR?: MessageCaseConnectionWhere[] | null;
  node?: CaseWhere | null;
  node_NOT?: CaseWhere | null;
}

export interface MessageCaseNodeAggregationWhereInput {
  AND?: MessageCaseNodeAggregationWhereInput[] | null;
  OR?: MessageCaseNodeAggregationWhereInput[] | null;
  actualAgreementId_AVERAGE_EQUAL?: number | null;
  actualAgreementId_AVERAGE_GT?: number | null;
  actualAgreementId_AVERAGE_GTE?: number | null;
  actualAgreementId_AVERAGE_LT?: number | null;
  actualAgreementId_AVERAGE_LTE?: number | null;
  actualAgreementId_EQUAL?: string | null;
  actualAgreementId_GT?: number | null;
  actualAgreementId_GTE?: number | null;
  actualAgreementId_LONGEST_EQUAL?: number | null;
  actualAgreementId_LONGEST_GT?: number | null;
  actualAgreementId_LONGEST_GTE?: number | null;
  actualAgreementId_LONGEST_LT?: number | null;
  actualAgreementId_LONGEST_LTE?: number | null;
  actualAgreementId_LT?: number | null;
  actualAgreementId_LTE?: number | null;
  actualAgreementId_SHORTEST_EQUAL?: number | null;
  actualAgreementId_SHORTEST_GT?: number | null;
  actualAgreementId_SHORTEST_GTE?: number | null;
  actualAgreementId_SHORTEST_LT?: number | null;
  actualAgreementId_SHORTEST_LTE?: number | null;
  agreementName_AVERAGE_EQUAL?: number | null;
  agreementName_AVERAGE_GT?: number | null;
  agreementName_AVERAGE_GTE?: number | null;
  agreementName_AVERAGE_LT?: number | null;
  agreementName_AVERAGE_LTE?: number | null;
  agreementName_EQUAL?: string | null;
  agreementName_GT?: number | null;
  agreementName_GTE?: number | null;
  agreementName_LONGEST_EQUAL?: number | null;
  agreementName_LONGEST_GT?: number | null;
  agreementName_LONGEST_GTE?: number | null;
  agreementName_LONGEST_LT?: number | null;
  agreementName_LONGEST_LTE?: number | null;
  agreementName_LT?: number | null;
  agreementName_LTE?: number | null;
  agreementName_SHORTEST_EQUAL?: number | null;
  agreementName_SHORTEST_GT?: number | null;
  agreementName_SHORTEST_GTE?: number | null;
  agreementName_SHORTEST_LT?: number | null;
  agreementName_SHORTEST_LTE?: number | null;
  counterpartyInReview_AVERAGE_EQUAL?: number | null;
  counterpartyInReview_AVERAGE_GT?: number | null;
  counterpartyInReview_AVERAGE_GTE?: number | null;
  counterpartyInReview_AVERAGE_LT?: number | null;
  counterpartyInReview_AVERAGE_LTE?: number | null;
  counterpartyInReview_EQUAL?: string | null;
  counterpartyInReview_GT?: number | null;
  counterpartyInReview_GTE?: number | null;
  counterpartyInReview_LONGEST_EQUAL?: number | null;
  counterpartyInReview_LONGEST_GT?: number | null;
  counterpartyInReview_LONGEST_GTE?: number | null;
  counterpartyInReview_LONGEST_LT?: number | null;
  counterpartyInReview_LONGEST_LTE?: number | null;
  counterpartyInReview_LT?: number | null;
  counterpartyInReview_LTE?: number | null;
  counterpartyInReview_SHORTEST_EQUAL?: number | null;
  counterpartyInReview_SHORTEST_GT?: number | null;
  counterpartyInReview_SHORTEST_GTE?: number | null;
  counterpartyInReview_SHORTEST_LT?: number | null;
  counterpartyInReview_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  lastStatusChangeDate_EQUAL?: any | null;
  lastStatusChangeDate_GT?: any | null;
  lastStatusChangeDate_GTE?: any | null;
  lastStatusChangeDate_LT?: any | null;
  lastStatusChangeDate_LTE?: any | null;
  lastStatusChangeDate_MAX_EQUAL?: any | null;
  lastStatusChangeDate_MAX_GT?: any | null;
  lastStatusChangeDate_MAX_GTE?: any | null;
  lastStatusChangeDate_MAX_LT?: any | null;
  lastStatusChangeDate_MAX_LTE?: any | null;
  lastStatusChangeDate_MIN_EQUAL?: any | null;
  lastStatusChangeDate_MIN_GT?: any | null;
  lastStatusChangeDate_MIN_GTE?: any | null;
  lastStatusChangeDate_MIN_LT?: any | null;
  lastStatusChangeDate_MIN_LTE?: any | null;
  patientInitials_AVERAGE_EQUAL?: number | null;
  patientInitials_AVERAGE_GT?: number | null;
  patientInitials_AVERAGE_GTE?: number | null;
  patientInitials_AVERAGE_LT?: number | null;
  patientInitials_AVERAGE_LTE?: number | null;
  patientInitials_EQUAL?: string | null;
  patientInitials_GT?: number | null;
  patientInitials_GTE?: number | null;
  patientInitials_LONGEST_EQUAL?: number | null;
  patientInitials_LONGEST_GT?: number | null;
  patientInitials_LONGEST_GTE?: number | null;
  patientInitials_LONGEST_LT?: number | null;
  patientInitials_LONGEST_LTE?: number | null;
  patientInitials_LT?: number | null;
  patientInitials_LTE?: number | null;
  patientInitials_SHORTEST_EQUAL?: number | null;
  patientInitials_SHORTEST_GT?: number | null;
  patientInitials_SHORTEST_GTE?: number | null;
  patientInitials_SHORTEST_LT?: number | null;
  patientInitials_SHORTEST_LTE?: number | null;
  patientInsuranceId_AVERAGE_EQUAL?: number | null;
  patientInsuranceId_AVERAGE_GT?: number | null;
  patientInsuranceId_AVERAGE_GTE?: number | null;
  patientInsuranceId_AVERAGE_LT?: number | null;
  patientInsuranceId_AVERAGE_LTE?: number | null;
  patientInsuranceId_EQUAL?: string | null;
  patientInsuranceId_GT?: number | null;
  patientInsuranceId_GTE?: number | null;
  patientInsuranceId_LONGEST_EQUAL?: number | null;
  patientInsuranceId_LONGEST_GT?: number | null;
  patientInsuranceId_LONGEST_GTE?: number | null;
  patientInsuranceId_LONGEST_LT?: number | null;
  patientInsuranceId_LONGEST_LTE?: number | null;
  patientInsuranceId_LT?: number | null;
  patientInsuranceId_LTE?: number | null;
  patientInsuranceId_SHORTEST_EQUAL?: number | null;
  patientInsuranceId_SHORTEST_GT?: number | null;
  patientInsuranceId_SHORTEST_GTE?: number | null;
  patientInsuranceId_SHORTEST_LT?: number | null;
  patientInsuranceId_SHORTEST_LTE?: number | null;
  preparationBrandName_AVERAGE_EQUAL?: number | null;
  preparationBrandName_AVERAGE_GT?: number | null;
  preparationBrandName_AVERAGE_GTE?: number | null;
  preparationBrandName_AVERAGE_LT?: number | null;
  preparationBrandName_AVERAGE_LTE?: number | null;
  preparationBrandName_EQUAL?: string | null;
  preparationBrandName_GT?: number | null;
  preparationBrandName_GTE?: number | null;
  preparationBrandName_LONGEST_EQUAL?: number | null;
  preparationBrandName_LONGEST_GT?: number | null;
  preparationBrandName_LONGEST_GTE?: number | null;
  preparationBrandName_LONGEST_LT?: number | null;
  preparationBrandName_LONGEST_LTE?: number | null;
  preparationBrandName_LT?: number | null;
  preparationBrandName_LTE?: number | null;
  preparationBrandName_SHORTEST_EQUAL?: number | null;
  preparationBrandName_SHORTEST_GT?: number | null;
  preparationBrandName_SHORTEST_GTE?: number | null;
  preparationBrandName_SHORTEST_LT?: number | null;
  preparationBrandName_SHORTEST_LTE?: number | null;
  preparationGenericName_AVERAGE_EQUAL?: number | null;
  preparationGenericName_AVERAGE_GT?: number | null;
  preparationGenericName_AVERAGE_GTE?: number | null;
  preparationGenericName_AVERAGE_LT?: number | null;
  preparationGenericName_AVERAGE_LTE?: number | null;
  preparationGenericName_EQUAL?: string | null;
  preparationGenericName_GT?: number | null;
  preparationGenericName_GTE?: number | null;
  preparationGenericName_LONGEST_EQUAL?: number | null;
  preparationGenericName_LONGEST_GT?: number | null;
  preparationGenericName_LONGEST_GTE?: number | null;
  preparationGenericName_LONGEST_LT?: number | null;
  preparationGenericName_LONGEST_LTE?: number | null;
  preparationGenericName_LT?: number | null;
  preparationGenericName_LTE?: number | null;
  preparationGenericName_SHORTEST_EQUAL?: number | null;
  preparationGenericName_SHORTEST_GT?: number | null;
  preparationGenericName_SHORTEST_GTE?: number | null;
  preparationGenericName_SHORTEST_LT?: number | null;
  preparationGenericName_SHORTEST_LTE?: number | null;
  sourceTenantId_AVERAGE_EQUAL?: number | null;
  sourceTenantId_AVERAGE_GT?: number | null;
  sourceTenantId_AVERAGE_GTE?: number | null;
  sourceTenantId_AVERAGE_LT?: number | null;
  sourceTenantId_AVERAGE_LTE?: number | null;
  sourceTenantId_EQUAL?: string | null;
  sourceTenantId_GT?: number | null;
  sourceTenantId_GTE?: number | null;
  sourceTenantId_LONGEST_EQUAL?: number | null;
  sourceTenantId_LONGEST_GT?: number | null;
  sourceTenantId_LONGEST_GTE?: number | null;
  sourceTenantId_LONGEST_LT?: number | null;
  sourceTenantId_LONGEST_LTE?: number | null;
  sourceTenantId_LT?: number | null;
  sourceTenantId_LTE?: number | null;
  sourceTenantId_SHORTEST_EQUAL?: number | null;
  sourceTenantId_SHORTEST_GT?: number | null;
  sourceTenantId_SHORTEST_GTE?: number | null;
  sourceTenantId_SHORTEST_LT?: number | null;
  sourceTenantId_SHORTEST_LTE?: number | null;
  submissionDate_EQUAL?: any | null;
  submissionDate_GT?: any | null;
  submissionDate_GTE?: any | null;
  submissionDate_LT?: any | null;
  submissionDate_LTE?: any | null;
  submissionDate_MAX_EQUAL?: any | null;
  submissionDate_MAX_GT?: any | null;
  submissionDate_MAX_GTE?: any | null;
  submissionDate_MAX_LT?: any | null;
  submissionDate_MAX_LTE?: any | null;
  submissionDate_MIN_EQUAL?: any | null;
  submissionDate_MIN_GT?: any | null;
  submissionDate_MIN_GTE?: any | null;
  submissionDate_MIN_LT?: any | null;
  submissionDate_MIN_LTE?: any | null;
  suspensionReason_AVERAGE_EQUAL?: number | null;
  suspensionReason_AVERAGE_GT?: number | null;
  suspensionReason_AVERAGE_GTE?: number | null;
  suspensionReason_AVERAGE_LT?: number | null;
  suspensionReason_AVERAGE_LTE?: number | null;
  suspensionReason_EQUAL?: string | null;
  suspensionReason_GT?: number | null;
  suspensionReason_GTE?: number | null;
  suspensionReason_LONGEST_EQUAL?: number | null;
  suspensionReason_LONGEST_GT?: number | null;
  suspensionReason_LONGEST_GTE?: number | null;
  suspensionReason_LONGEST_LT?: number | null;
  suspensionReason_LONGEST_LTE?: number | null;
  suspensionReason_LT?: number | null;
  suspensionReason_LTE?: number | null;
  suspensionReason_SHORTEST_EQUAL?: number | null;
  suspensionReason_SHORTEST_GT?: number | null;
  suspensionReason_SHORTEST_GTE?: number | null;
  suspensionReason_SHORTEST_LT?: number | null;
  suspensionReason_SHORTEST_LTE?: number | null;
  totalAmount_AVERAGE_EQUAL?: number | null;
  totalAmount_AVERAGE_GT?: number | null;
  totalAmount_AVERAGE_GTE?: number | null;
  totalAmount_AVERAGE_LT?: number | null;
  totalAmount_AVERAGE_LTE?: number | null;
  totalAmount_EQUAL?: number | null;
  totalAmount_GT?: number | null;
  totalAmount_GTE?: number | null;
  totalAmount_LT?: number | null;
  totalAmount_LTE?: number | null;
  totalAmount_MAX_EQUAL?: number | null;
  totalAmount_MAX_GT?: number | null;
  totalAmount_MAX_GTE?: number | null;
  totalAmount_MAX_LT?: number | null;
  totalAmount_MAX_LTE?: number | null;
  totalAmount_MIN_EQUAL?: number | null;
  totalAmount_MIN_GT?: number | null;
  totalAmount_MIN_GTE?: number | null;
  totalAmount_MIN_LT?: number | null;
  totalAmount_MIN_LTE?: number | null;
  totalAmount_SUM_EQUAL?: number | null;
  totalAmount_SUM_GT?: number | null;
  totalAmount_SUM_GTE?: number | null;
  totalAmount_SUM_LT?: number | null;
  totalAmount_SUM_LTE?: number | null;
  unlimited_AVERAGE_EQUAL?: number | null;
  unlimited_AVERAGE_GT?: number | null;
  unlimited_AVERAGE_GTE?: number | null;
  unlimited_AVERAGE_LT?: number | null;
  unlimited_AVERAGE_LTE?: number | null;
  unlimited_EQUAL?: number | null;
  unlimited_GT?: number | null;
  unlimited_GTE?: number | null;
  unlimited_LT?: number | null;
  unlimited_LTE?: number | null;
  unlimited_MAX_EQUAL?: number | null;
  unlimited_MAX_GT?: number | null;
  unlimited_MAX_GTE?: number | null;
  unlimited_MAX_LT?: number | null;
  unlimited_MAX_LTE?: number | null;
  unlimited_MIN_EQUAL?: number | null;
  unlimited_MIN_GT?: number | null;
  unlimited_MIN_GTE?: number | null;
  unlimited_MIN_LT?: number | null;
  unlimited_MIN_LTE?: number | null;
  unlimited_SUM_EQUAL?: number | null;
  unlimited_SUM_GT?: number | null;
  unlimited_SUM_GTE?: number | null;
  unlimited_SUM_LT?: number | null;
  unlimited_SUM_LTE?: number | null;
}

export interface MessageMentionsAggregateInput {
  AND?: MessageMentionsAggregateInput[] | null;
  OR?: MessageMentionsAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: MessageMentionsNodeAggregationWhereInput | null;
}

export interface MessageMentionsConnectionWhere {
  AND?: MessageMentionsConnectionWhere[] | null;
  OR?: MessageMentionsConnectionWhere[] | null;
  node?: UserWhere | null;
  node_NOT?: UserWhere | null;
}

export interface MessageMentionsNodeAggregationWhereInput {
  AND?: MessageMentionsNodeAggregationWhereInput[] | null;
  OR?: MessageMentionsNodeAggregationWhereInput[] | null;
  deletedOn_EQUAL?: any | null;
  deletedOn_GT?: any | null;
  deletedOn_GTE?: any | null;
  deletedOn_LT?: any | null;
  deletedOn_LTE?: any | null;
  deletedOn_MAX_EQUAL?: any | null;
  deletedOn_MAX_GT?: any | null;
  deletedOn_MAX_GTE?: any | null;
  deletedOn_MAX_LT?: any | null;
  deletedOn_MAX_LTE?: any | null;
  deletedOn_MIN_EQUAL?: any | null;
  deletedOn_MIN_GT?: any | null;
  deletedOn_MIN_GTE?: any | null;
  deletedOn_MIN_LT?: any | null;
  deletedOn_MIN_LTE?: any | null;
  department_AVERAGE_EQUAL?: number | null;
  department_AVERAGE_GT?: number | null;
  department_AVERAGE_GTE?: number | null;
  department_AVERAGE_LT?: number | null;
  department_AVERAGE_LTE?: number | null;
  department_EQUAL?: string | null;
  department_GT?: number | null;
  department_GTE?: number | null;
  department_LONGEST_EQUAL?: number | null;
  department_LONGEST_GT?: number | null;
  department_LONGEST_GTE?: number | null;
  department_LONGEST_LT?: number | null;
  department_LONGEST_LTE?: number | null;
  department_LT?: number | null;
  department_LTE?: number | null;
  department_SHORTEST_EQUAL?: number | null;
  department_SHORTEST_GT?: number | null;
  department_SHORTEST_GTE?: number | null;
  department_SHORTEST_LT?: number | null;
  department_SHORTEST_LTE?: number | null;
  email_AVERAGE_EQUAL?: number | null;
  email_AVERAGE_GT?: number | null;
  email_AVERAGE_GTE?: number | null;
  email_AVERAGE_LT?: number | null;
  email_AVERAGE_LTE?: number | null;
  email_EQUAL?: string | null;
  email_GT?: number | null;
  email_GTE?: number | null;
  email_LONGEST_EQUAL?: number | null;
  email_LONGEST_GT?: number | null;
  email_LONGEST_GTE?: number | null;
  email_LONGEST_LT?: number | null;
  email_LONGEST_LTE?: number | null;
  email_LT?: number | null;
  email_LTE?: number | null;
  email_SHORTEST_EQUAL?: number | null;
  email_SHORTEST_GT?: number | null;
  email_SHORTEST_GTE?: number | null;
  email_SHORTEST_LT?: number | null;
  email_SHORTEST_LTE?: number | null;
  firstName_AVERAGE_EQUAL?: number | null;
  firstName_AVERAGE_GT?: number | null;
  firstName_AVERAGE_GTE?: number | null;
  firstName_AVERAGE_LT?: number | null;
  firstName_AVERAGE_LTE?: number | null;
  firstName_EQUAL?: string | null;
  firstName_GT?: number | null;
  firstName_GTE?: number | null;
  firstName_LONGEST_EQUAL?: number | null;
  firstName_LONGEST_GT?: number | null;
  firstName_LONGEST_GTE?: number | null;
  firstName_LONGEST_LT?: number | null;
  firstName_LONGEST_LTE?: number | null;
  firstName_LT?: number | null;
  firstName_LTE?: number | null;
  firstName_SHORTEST_EQUAL?: number | null;
  firstName_SHORTEST_GT?: number | null;
  firstName_SHORTEST_GTE?: number | null;
  firstName_SHORTEST_LT?: number | null;
  firstName_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  lastName_AVERAGE_EQUAL?: number | null;
  lastName_AVERAGE_GT?: number | null;
  lastName_AVERAGE_GTE?: number | null;
  lastName_AVERAGE_LT?: number | null;
  lastName_AVERAGE_LTE?: number | null;
  lastName_EQUAL?: string | null;
  lastName_GT?: number | null;
  lastName_GTE?: number | null;
  lastName_LONGEST_EQUAL?: number | null;
  lastName_LONGEST_GT?: number | null;
  lastName_LONGEST_GTE?: number | null;
  lastName_LONGEST_LT?: number | null;
  lastName_LONGEST_LTE?: number | null;
  lastName_LT?: number | null;
  lastName_LTE?: number | null;
  lastName_SHORTEST_EQUAL?: number | null;
  lastName_SHORTEST_GT?: number | null;
  lastName_SHORTEST_GTE?: number | null;
  lastName_SHORTEST_LT?: number | null;
  lastName_SHORTEST_LTE?: number | null;
  position_AVERAGE_EQUAL?: number | null;
  position_AVERAGE_GT?: number | null;
  position_AVERAGE_GTE?: number | null;
  position_AVERAGE_LT?: number | null;
  position_AVERAGE_LTE?: number | null;
  position_EQUAL?: string | null;
  position_GT?: number | null;
  position_GTE?: number | null;
  position_LONGEST_EQUAL?: number | null;
  position_LONGEST_GT?: number | null;
  position_LONGEST_GTE?: number | null;
  position_LONGEST_LT?: number | null;
  position_LONGEST_LTE?: number | null;
  position_LT?: number | null;
  position_LTE?: number | null;
  position_SHORTEST_EQUAL?: number | null;
  position_SHORTEST_GT?: number | null;
  position_SHORTEST_GTE?: number | null;
  position_SHORTEST_LT?: number | null;
  position_SHORTEST_LTE?: number | null;
  preferredLanguage_AVERAGE_EQUAL?: number | null;
  preferredLanguage_AVERAGE_GT?: number | null;
  preferredLanguage_AVERAGE_GTE?: number | null;
  preferredLanguage_AVERAGE_LT?: number | null;
  preferredLanguage_AVERAGE_LTE?: number | null;
  preferredLanguage_EQUAL?: string | null;
  preferredLanguage_GT?: number | null;
  preferredLanguage_GTE?: number | null;
  preferredLanguage_LONGEST_EQUAL?: number | null;
  preferredLanguage_LONGEST_GT?: number | null;
  preferredLanguage_LONGEST_GTE?: number | null;
  preferredLanguage_LONGEST_LT?: number | null;
  preferredLanguage_LONGEST_LTE?: number | null;
  preferredLanguage_LT?: number | null;
  preferredLanguage_LTE?: number | null;
  preferredLanguage_SHORTEST_EQUAL?: number | null;
  preferredLanguage_SHORTEST_GT?: number | null;
  preferredLanguage_SHORTEST_GTE?: number | null;
  preferredLanguage_SHORTEST_LT?: number | null;
  preferredLanguage_SHORTEST_LTE?: number | null;
  tenantId_AVERAGE_EQUAL?: number | null;
  tenantId_AVERAGE_GT?: number | null;
  tenantId_AVERAGE_GTE?: number | null;
  tenantId_AVERAGE_LT?: number | null;
  tenantId_AVERAGE_LTE?: number | null;
  tenantId_EQUAL?: string | null;
  tenantId_GT?: number | null;
  tenantId_GTE?: number | null;
  tenantId_LONGEST_EQUAL?: number | null;
  tenantId_LONGEST_GT?: number | null;
  tenantId_LONGEST_GTE?: number | null;
  tenantId_LONGEST_LT?: number | null;
  tenantId_LONGEST_LTE?: number | null;
  tenantId_LT?: number | null;
  tenantId_LTE?: number | null;
  tenantId_SHORTEST_EQUAL?: number | null;
  tenantId_SHORTEST_GT?: number | null;
  tenantId_SHORTEST_GTE?: number | null;
  tenantId_SHORTEST_LT?: number | null;
  tenantId_SHORTEST_LTE?: number | null;
}

export interface MessageRefundCaseAggregateInput {
  AND?: MessageRefundCaseAggregateInput[] | null;
  OR?: MessageRefundCaseAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: MessageRefundCaseNodeAggregationWhereInput | null;
}

export interface MessageRefundCaseConnectionWhere {
  AND?: MessageRefundCaseConnectionWhere[] | null;
  OR?: MessageRefundCaseConnectionWhere[] | null;
  node?: RefundCaseWhere | null;
  node_NOT?: RefundCaseWhere | null;
}

export interface MessageRefundCaseNodeAggregationWhereInput {
  AND?: MessageRefundCaseNodeAggregationWhereInput[] | null;
  OR?: MessageRefundCaseNodeAggregationWhereInput[] | null;
  id_EQUAL?: string | null;
}

export interface MessageSentByAggregateInput {
  AND?: MessageSentByAggregateInput[] | null;
  OR?: MessageSentByAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: MessageSentByNodeAggregationWhereInput | null;
}

export interface MessageSentByConnectionWhere {
  AND?: MessageSentByConnectionWhere[] | null;
  OR?: MessageSentByConnectionWhere[] | null;
  node?: UserWhere | null;
  node_NOT?: UserWhere | null;
}

export interface MessageSentByNodeAggregationWhereInput {
  AND?: MessageSentByNodeAggregationWhereInput[] | null;
  OR?: MessageSentByNodeAggregationWhereInput[] | null;
  deletedOn_EQUAL?: any | null;
  deletedOn_GT?: any | null;
  deletedOn_GTE?: any | null;
  deletedOn_LT?: any | null;
  deletedOn_LTE?: any | null;
  deletedOn_MAX_EQUAL?: any | null;
  deletedOn_MAX_GT?: any | null;
  deletedOn_MAX_GTE?: any | null;
  deletedOn_MAX_LT?: any | null;
  deletedOn_MAX_LTE?: any | null;
  deletedOn_MIN_EQUAL?: any | null;
  deletedOn_MIN_GT?: any | null;
  deletedOn_MIN_GTE?: any | null;
  deletedOn_MIN_LT?: any | null;
  deletedOn_MIN_LTE?: any | null;
  department_AVERAGE_EQUAL?: number | null;
  department_AVERAGE_GT?: number | null;
  department_AVERAGE_GTE?: number | null;
  department_AVERAGE_LT?: number | null;
  department_AVERAGE_LTE?: number | null;
  department_EQUAL?: string | null;
  department_GT?: number | null;
  department_GTE?: number | null;
  department_LONGEST_EQUAL?: number | null;
  department_LONGEST_GT?: number | null;
  department_LONGEST_GTE?: number | null;
  department_LONGEST_LT?: number | null;
  department_LONGEST_LTE?: number | null;
  department_LT?: number | null;
  department_LTE?: number | null;
  department_SHORTEST_EQUAL?: number | null;
  department_SHORTEST_GT?: number | null;
  department_SHORTEST_GTE?: number | null;
  department_SHORTEST_LT?: number | null;
  department_SHORTEST_LTE?: number | null;
  email_AVERAGE_EQUAL?: number | null;
  email_AVERAGE_GT?: number | null;
  email_AVERAGE_GTE?: number | null;
  email_AVERAGE_LT?: number | null;
  email_AVERAGE_LTE?: number | null;
  email_EQUAL?: string | null;
  email_GT?: number | null;
  email_GTE?: number | null;
  email_LONGEST_EQUAL?: number | null;
  email_LONGEST_GT?: number | null;
  email_LONGEST_GTE?: number | null;
  email_LONGEST_LT?: number | null;
  email_LONGEST_LTE?: number | null;
  email_LT?: number | null;
  email_LTE?: number | null;
  email_SHORTEST_EQUAL?: number | null;
  email_SHORTEST_GT?: number | null;
  email_SHORTEST_GTE?: number | null;
  email_SHORTEST_LT?: number | null;
  email_SHORTEST_LTE?: number | null;
  firstName_AVERAGE_EQUAL?: number | null;
  firstName_AVERAGE_GT?: number | null;
  firstName_AVERAGE_GTE?: number | null;
  firstName_AVERAGE_LT?: number | null;
  firstName_AVERAGE_LTE?: number | null;
  firstName_EQUAL?: string | null;
  firstName_GT?: number | null;
  firstName_GTE?: number | null;
  firstName_LONGEST_EQUAL?: number | null;
  firstName_LONGEST_GT?: number | null;
  firstName_LONGEST_GTE?: number | null;
  firstName_LONGEST_LT?: number | null;
  firstName_LONGEST_LTE?: number | null;
  firstName_LT?: number | null;
  firstName_LTE?: number | null;
  firstName_SHORTEST_EQUAL?: number | null;
  firstName_SHORTEST_GT?: number | null;
  firstName_SHORTEST_GTE?: number | null;
  firstName_SHORTEST_LT?: number | null;
  firstName_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  lastName_AVERAGE_EQUAL?: number | null;
  lastName_AVERAGE_GT?: number | null;
  lastName_AVERAGE_GTE?: number | null;
  lastName_AVERAGE_LT?: number | null;
  lastName_AVERAGE_LTE?: number | null;
  lastName_EQUAL?: string | null;
  lastName_GT?: number | null;
  lastName_GTE?: number | null;
  lastName_LONGEST_EQUAL?: number | null;
  lastName_LONGEST_GT?: number | null;
  lastName_LONGEST_GTE?: number | null;
  lastName_LONGEST_LT?: number | null;
  lastName_LONGEST_LTE?: number | null;
  lastName_LT?: number | null;
  lastName_LTE?: number | null;
  lastName_SHORTEST_EQUAL?: number | null;
  lastName_SHORTEST_GT?: number | null;
  lastName_SHORTEST_GTE?: number | null;
  lastName_SHORTEST_LT?: number | null;
  lastName_SHORTEST_LTE?: number | null;
  position_AVERAGE_EQUAL?: number | null;
  position_AVERAGE_GT?: number | null;
  position_AVERAGE_GTE?: number | null;
  position_AVERAGE_LT?: number | null;
  position_AVERAGE_LTE?: number | null;
  position_EQUAL?: string | null;
  position_GT?: number | null;
  position_GTE?: number | null;
  position_LONGEST_EQUAL?: number | null;
  position_LONGEST_GT?: number | null;
  position_LONGEST_GTE?: number | null;
  position_LONGEST_LT?: number | null;
  position_LONGEST_LTE?: number | null;
  position_LT?: number | null;
  position_LTE?: number | null;
  position_SHORTEST_EQUAL?: number | null;
  position_SHORTEST_GT?: number | null;
  position_SHORTEST_GTE?: number | null;
  position_SHORTEST_LT?: number | null;
  position_SHORTEST_LTE?: number | null;
  preferredLanguage_AVERAGE_EQUAL?: number | null;
  preferredLanguage_AVERAGE_GT?: number | null;
  preferredLanguage_AVERAGE_GTE?: number | null;
  preferredLanguage_AVERAGE_LT?: number | null;
  preferredLanguage_AVERAGE_LTE?: number | null;
  preferredLanguage_EQUAL?: string | null;
  preferredLanguage_GT?: number | null;
  preferredLanguage_GTE?: number | null;
  preferredLanguage_LONGEST_EQUAL?: number | null;
  preferredLanguage_LONGEST_GT?: number | null;
  preferredLanguage_LONGEST_GTE?: number | null;
  preferredLanguage_LONGEST_LT?: number | null;
  preferredLanguage_LONGEST_LTE?: number | null;
  preferredLanguage_LT?: number | null;
  preferredLanguage_LTE?: number | null;
  preferredLanguage_SHORTEST_EQUAL?: number | null;
  preferredLanguage_SHORTEST_GT?: number | null;
  preferredLanguage_SHORTEST_GTE?: number | null;
  preferredLanguage_SHORTEST_LT?: number | null;
  preferredLanguage_SHORTEST_LTE?: number | null;
  tenantId_AVERAGE_EQUAL?: number | null;
  tenantId_AVERAGE_GT?: number | null;
  tenantId_AVERAGE_GTE?: number | null;
  tenantId_AVERAGE_LT?: number | null;
  tenantId_AVERAGE_LTE?: number | null;
  tenantId_EQUAL?: string | null;
  tenantId_GT?: number | null;
  tenantId_GTE?: number | null;
  tenantId_LONGEST_EQUAL?: number | null;
  tenantId_LONGEST_GT?: number | null;
  tenantId_LONGEST_GTE?: number | null;
  tenantId_LONGEST_LT?: number | null;
  tenantId_LONGEST_LTE?: number | null;
  tenantId_LT?: number | null;
  tenantId_LTE?: number | null;
  tenantId_SHORTEST_EQUAL?: number | null;
  tenantId_SHORTEST_GT?: number | null;
  tenantId_SHORTEST_GTE?: number | null;
  tenantId_SHORTEST_LT?: number | null;
  tenantId_SHORTEST_LTE?: number | null;
}

export interface MessageWhere {
  AND?: MessageWhere[] | null;
  OR?: MessageWhere[] | null;
  case?: CaseWhere | null;
  caseAggregate?: MessageCaseAggregateInput | null;
  caseConnection?: MessageCaseConnectionWhere | null;
  caseConnection_NOT?: MessageCaseConnectionWhere | null;
  case_NOT?: CaseWhere | null;
  content?: string | null;
  content_CONTAINS?: string | null;
  content_ENDS_WITH?: string | null;
  content_IN?: (string | null)[] | null;
  content_MATCHES?: string | null;
  content_NOT?: string | null;
  content_NOT_CONTAINS?: string | null;
  content_NOT_ENDS_WITH?: string | null;
  content_NOT_IN?: (string | null)[] | null;
  content_NOT_STARTS_WITH?: string | null;
  content_STARTS_WITH?: string | null;
  createdOn?: number | null;
  createdOn_GT?: number | null;
  createdOn_GTE?: number | null;
  createdOn_IN?: (number | null)[] | null;
  createdOn_LT?: number | null;
  createdOn_LTE?: number | null;
  createdOn_NOT?: number | null;
  createdOn_NOT_IN?: (number | null)[] | null;
  mentions?: UserWhere | null;
  mentionsAggregate?: MessageMentionsAggregateInput | null;
  mentionsConnection?: MessageMentionsConnectionWhere | null;
  mentionsConnection_NOT?: MessageMentionsConnectionWhere | null;
  mentions_NOT?: UserWhere | null;
  refundCase?: RefundCaseWhere | null;
  refundCaseAggregate?: MessageRefundCaseAggregateInput | null;
  refundCaseConnection?: MessageRefundCaseConnectionWhere | null;
  refundCaseConnection_NOT?: MessageRefundCaseConnectionWhere | null;
  refundCase_NOT?: RefundCaseWhere | null;
  sentBy?: UserWhere | null;
  sentByAggregate?: MessageSentByAggregateInput | null;
  sentByConnection?: MessageSentByConnectionWhere | null;
  sentByConnection_NOT?: MessageSentByConnectionWhere | null;
  sentBy_NOT?: UserWhere | null;
  tenantIds?: string[] | null;
  tenantIds_INCLUDES?: string | null;
  tenantIds_NOT?: string[] | null;
  tenantIds_NOT_INCLUDES?: string | null;
}

export interface ModuleInput {
  code: string;
  id: number;
  name?: string | null;
}

export interface NegotiationRoundCaseAggregateInput {
  AND?: NegotiationRoundCaseAggregateInput[] | null;
  OR?: NegotiationRoundCaseAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: NegotiationRoundCaseNodeAggregationWhereInput | null;
}

export interface NegotiationRoundCaseConnectionWhere {
  AND?: NegotiationRoundCaseConnectionWhere[] | null;
  OR?: NegotiationRoundCaseConnectionWhere[] | null;
  node?: CaseWhere | null;
  node_NOT?: CaseWhere | null;
}

export interface NegotiationRoundCaseNodeAggregationWhereInput {
  AND?: NegotiationRoundCaseNodeAggregationWhereInput[] | null;
  OR?: NegotiationRoundCaseNodeAggregationWhereInput[] | null;
  actualAgreementId_AVERAGE_EQUAL?: number | null;
  actualAgreementId_AVERAGE_GT?: number | null;
  actualAgreementId_AVERAGE_GTE?: number | null;
  actualAgreementId_AVERAGE_LT?: number | null;
  actualAgreementId_AVERAGE_LTE?: number | null;
  actualAgreementId_EQUAL?: string | null;
  actualAgreementId_GT?: number | null;
  actualAgreementId_GTE?: number | null;
  actualAgreementId_LONGEST_EQUAL?: number | null;
  actualAgreementId_LONGEST_GT?: number | null;
  actualAgreementId_LONGEST_GTE?: number | null;
  actualAgreementId_LONGEST_LT?: number | null;
  actualAgreementId_LONGEST_LTE?: number | null;
  actualAgreementId_LT?: number | null;
  actualAgreementId_LTE?: number | null;
  actualAgreementId_SHORTEST_EQUAL?: number | null;
  actualAgreementId_SHORTEST_GT?: number | null;
  actualAgreementId_SHORTEST_GTE?: number | null;
  actualAgreementId_SHORTEST_LT?: number | null;
  actualAgreementId_SHORTEST_LTE?: number | null;
  agreementName_AVERAGE_EQUAL?: number | null;
  agreementName_AVERAGE_GT?: number | null;
  agreementName_AVERAGE_GTE?: number | null;
  agreementName_AVERAGE_LT?: number | null;
  agreementName_AVERAGE_LTE?: number | null;
  agreementName_EQUAL?: string | null;
  agreementName_GT?: number | null;
  agreementName_GTE?: number | null;
  agreementName_LONGEST_EQUAL?: number | null;
  agreementName_LONGEST_GT?: number | null;
  agreementName_LONGEST_GTE?: number | null;
  agreementName_LONGEST_LT?: number | null;
  agreementName_LONGEST_LTE?: number | null;
  agreementName_LT?: number | null;
  agreementName_LTE?: number | null;
  agreementName_SHORTEST_EQUAL?: number | null;
  agreementName_SHORTEST_GT?: number | null;
  agreementName_SHORTEST_GTE?: number | null;
  agreementName_SHORTEST_LT?: number | null;
  agreementName_SHORTEST_LTE?: number | null;
  counterpartyInReview_AVERAGE_EQUAL?: number | null;
  counterpartyInReview_AVERAGE_GT?: number | null;
  counterpartyInReview_AVERAGE_GTE?: number | null;
  counterpartyInReview_AVERAGE_LT?: number | null;
  counterpartyInReview_AVERAGE_LTE?: number | null;
  counterpartyInReview_EQUAL?: string | null;
  counterpartyInReview_GT?: number | null;
  counterpartyInReview_GTE?: number | null;
  counterpartyInReview_LONGEST_EQUAL?: number | null;
  counterpartyInReview_LONGEST_GT?: number | null;
  counterpartyInReview_LONGEST_GTE?: number | null;
  counterpartyInReview_LONGEST_LT?: number | null;
  counterpartyInReview_LONGEST_LTE?: number | null;
  counterpartyInReview_LT?: number | null;
  counterpartyInReview_LTE?: number | null;
  counterpartyInReview_SHORTEST_EQUAL?: number | null;
  counterpartyInReview_SHORTEST_GT?: number | null;
  counterpartyInReview_SHORTEST_GTE?: number | null;
  counterpartyInReview_SHORTEST_LT?: number | null;
  counterpartyInReview_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  lastStatusChangeDate_EQUAL?: any | null;
  lastStatusChangeDate_GT?: any | null;
  lastStatusChangeDate_GTE?: any | null;
  lastStatusChangeDate_LT?: any | null;
  lastStatusChangeDate_LTE?: any | null;
  lastStatusChangeDate_MAX_EQUAL?: any | null;
  lastStatusChangeDate_MAX_GT?: any | null;
  lastStatusChangeDate_MAX_GTE?: any | null;
  lastStatusChangeDate_MAX_LT?: any | null;
  lastStatusChangeDate_MAX_LTE?: any | null;
  lastStatusChangeDate_MIN_EQUAL?: any | null;
  lastStatusChangeDate_MIN_GT?: any | null;
  lastStatusChangeDate_MIN_GTE?: any | null;
  lastStatusChangeDate_MIN_LT?: any | null;
  lastStatusChangeDate_MIN_LTE?: any | null;
  patientInitials_AVERAGE_EQUAL?: number | null;
  patientInitials_AVERAGE_GT?: number | null;
  patientInitials_AVERAGE_GTE?: number | null;
  patientInitials_AVERAGE_LT?: number | null;
  patientInitials_AVERAGE_LTE?: number | null;
  patientInitials_EQUAL?: string | null;
  patientInitials_GT?: number | null;
  patientInitials_GTE?: number | null;
  patientInitials_LONGEST_EQUAL?: number | null;
  patientInitials_LONGEST_GT?: number | null;
  patientInitials_LONGEST_GTE?: number | null;
  patientInitials_LONGEST_LT?: number | null;
  patientInitials_LONGEST_LTE?: number | null;
  patientInitials_LT?: number | null;
  patientInitials_LTE?: number | null;
  patientInitials_SHORTEST_EQUAL?: number | null;
  patientInitials_SHORTEST_GT?: number | null;
  patientInitials_SHORTEST_GTE?: number | null;
  patientInitials_SHORTEST_LT?: number | null;
  patientInitials_SHORTEST_LTE?: number | null;
  patientInsuranceId_AVERAGE_EQUAL?: number | null;
  patientInsuranceId_AVERAGE_GT?: number | null;
  patientInsuranceId_AVERAGE_GTE?: number | null;
  patientInsuranceId_AVERAGE_LT?: number | null;
  patientInsuranceId_AVERAGE_LTE?: number | null;
  patientInsuranceId_EQUAL?: string | null;
  patientInsuranceId_GT?: number | null;
  patientInsuranceId_GTE?: number | null;
  patientInsuranceId_LONGEST_EQUAL?: number | null;
  patientInsuranceId_LONGEST_GT?: number | null;
  patientInsuranceId_LONGEST_GTE?: number | null;
  patientInsuranceId_LONGEST_LT?: number | null;
  patientInsuranceId_LONGEST_LTE?: number | null;
  patientInsuranceId_LT?: number | null;
  patientInsuranceId_LTE?: number | null;
  patientInsuranceId_SHORTEST_EQUAL?: number | null;
  patientInsuranceId_SHORTEST_GT?: number | null;
  patientInsuranceId_SHORTEST_GTE?: number | null;
  patientInsuranceId_SHORTEST_LT?: number | null;
  patientInsuranceId_SHORTEST_LTE?: number | null;
  preparationBrandName_AVERAGE_EQUAL?: number | null;
  preparationBrandName_AVERAGE_GT?: number | null;
  preparationBrandName_AVERAGE_GTE?: number | null;
  preparationBrandName_AVERAGE_LT?: number | null;
  preparationBrandName_AVERAGE_LTE?: number | null;
  preparationBrandName_EQUAL?: string | null;
  preparationBrandName_GT?: number | null;
  preparationBrandName_GTE?: number | null;
  preparationBrandName_LONGEST_EQUAL?: number | null;
  preparationBrandName_LONGEST_GT?: number | null;
  preparationBrandName_LONGEST_GTE?: number | null;
  preparationBrandName_LONGEST_LT?: number | null;
  preparationBrandName_LONGEST_LTE?: number | null;
  preparationBrandName_LT?: number | null;
  preparationBrandName_LTE?: number | null;
  preparationBrandName_SHORTEST_EQUAL?: number | null;
  preparationBrandName_SHORTEST_GT?: number | null;
  preparationBrandName_SHORTEST_GTE?: number | null;
  preparationBrandName_SHORTEST_LT?: number | null;
  preparationBrandName_SHORTEST_LTE?: number | null;
  preparationGenericName_AVERAGE_EQUAL?: number | null;
  preparationGenericName_AVERAGE_GT?: number | null;
  preparationGenericName_AVERAGE_GTE?: number | null;
  preparationGenericName_AVERAGE_LT?: number | null;
  preparationGenericName_AVERAGE_LTE?: number | null;
  preparationGenericName_EQUAL?: string | null;
  preparationGenericName_GT?: number | null;
  preparationGenericName_GTE?: number | null;
  preparationGenericName_LONGEST_EQUAL?: number | null;
  preparationGenericName_LONGEST_GT?: number | null;
  preparationGenericName_LONGEST_GTE?: number | null;
  preparationGenericName_LONGEST_LT?: number | null;
  preparationGenericName_LONGEST_LTE?: number | null;
  preparationGenericName_LT?: number | null;
  preparationGenericName_LTE?: number | null;
  preparationGenericName_SHORTEST_EQUAL?: number | null;
  preparationGenericName_SHORTEST_GT?: number | null;
  preparationGenericName_SHORTEST_GTE?: number | null;
  preparationGenericName_SHORTEST_LT?: number | null;
  preparationGenericName_SHORTEST_LTE?: number | null;
  sourceTenantId_AVERAGE_EQUAL?: number | null;
  sourceTenantId_AVERAGE_GT?: number | null;
  sourceTenantId_AVERAGE_GTE?: number | null;
  sourceTenantId_AVERAGE_LT?: number | null;
  sourceTenantId_AVERAGE_LTE?: number | null;
  sourceTenantId_EQUAL?: string | null;
  sourceTenantId_GT?: number | null;
  sourceTenantId_GTE?: number | null;
  sourceTenantId_LONGEST_EQUAL?: number | null;
  sourceTenantId_LONGEST_GT?: number | null;
  sourceTenantId_LONGEST_GTE?: number | null;
  sourceTenantId_LONGEST_LT?: number | null;
  sourceTenantId_LONGEST_LTE?: number | null;
  sourceTenantId_LT?: number | null;
  sourceTenantId_LTE?: number | null;
  sourceTenantId_SHORTEST_EQUAL?: number | null;
  sourceTenantId_SHORTEST_GT?: number | null;
  sourceTenantId_SHORTEST_GTE?: number | null;
  sourceTenantId_SHORTEST_LT?: number | null;
  sourceTenantId_SHORTEST_LTE?: number | null;
  submissionDate_EQUAL?: any | null;
  submissionDate_GT?: any | null;
  submissionDate_GTE?: any | null;
  submissionDate_LT?: any | null;
  submissionDate_LTE?: any | null;
  submissionDate_MAX_EQUAL?: any | null;
  submissionDate_MAX_GT?: any | null;
  submissionDate_MAX_GTE?: any | null;
  submissionDate_MAX_LT?: any | null;
  submissionDate_MAX_LTE?: any | null;
  submissionDate_MIN_EQUAL?: any | null;
  submissionDate_MIN_GT?: any | null;
  submissionDate_MIN_GTE?: any | null;
  submissionDate_MIN_LT?: any | null;
  submissionDate_MIN_LTE?: any | null;
  suspensionReason_AVERAGE_EQUAL?: number | null;
  suspensionReason_AVERAGE_GT?: number | null;
  suspensionReason_AVERAGE_GTE?: number | null;
  suspensionReason_AVERAGE_LT?: number | null;
  suspensionReason_AVERAGE_LTE?: number | null;
  suspensionReason_EQUAL?: string | null;
  suspensionReason_GT?: number | null;
  suspensionReason_GTE?: number | null;
  suspensionReason_LONGEST_EQUAL?: number | null;
  suspensionReason_LONGEST_GT?: number | null;
  suspensionReason_LONGEST_GTE?: number | null;
  suspensionReason_LONGEST_LT?: number | null;
  suspensionReason_LONGEST_LTE?: number | null;
  suspensionReason_LT?: number | null;
  suspensionReason_LTE?: number | null;
  suspensionReason_SHORTEST_EQUAL?: number | null;
  suspensionReason_SHORTEST_GT?: number | null;
  suspensionReason_SHORTEST_GTE?: number | null;
  suspensionReason_SHORTEST_LT?: number | null;
  suspensionReason_SHORTEST_LTE?: number | null;
  totalAmount_AVERAGE_EQUAL?: number | null;
  totalAmount_AVERAGE_GT?: number | null;
  totalAmount_AVERAGE_GTE?: number | null;
  totalAmount_AVERAGE_LT?: number | null;
  totalAmount_AVERAGE_LTE?: number | null;
  totalAmount_EQUAL?: number | null;
  totalAmount_GT?: number | null;
  totalAmount_GTE?: number | null;
  totalAmount_LT?: number | null;
  totalAmount_LTE?: number | null;
  totalAmount_MAX_EQUAL?: number | null;
  totalAmount_MAX_GT?: number | null;
  totalAmount_MAX_GTE?: number | null;
  totalAmount_MAX_LT?: number | null;
  totalAmount_MAX_LTE?: number | null;
  totalAmount_MIN_EQUAL?: number | null;
  totalAmount_MIN_GT?: number | null;
  totalAmount_MIN_GTE?: number | null;
  totalAmount_MIN_LT?: number | null;
  totalAmount_MIN_LTE?: number | null;
  totalAmount_SUM_EQUAL?: number | null;
  totalAmount_SUM_GT?: number | null;
  totalAmount_SUM_GTE?: number | null;
  totalAmount_SUM_LT?: number | null;
  totalAmount_SUM_LTE?: number | null;
  unlimited_AVERAGE_EQUAL?: number | null;
  unlimited_AVERAGE_GT?: number | null;
  unlimited_AVERAGE_GTE?: number | null;
  unlimited_AVERAGE_LT?: number | null;
  unlimited_AVERAGE_LTE?: number | null;
  unlimited_EQUAL?: number | null;
  unlimited_GT?: number | null;
  unlimited_GTE?: number | null;
  unlimited_LT?: number | null;
  unlimited_LTE?: number | null;
  unlimited_MAX_EQUAL?: number | null;
  unlimited_MAX_GT?: number | null;
  unlimited_MAX_GTE?: number | null;
  unlimited_MAX_LT?: number | null;
  unlimited_MAX_LTE?: number | null;
  unlimited_MIN_EQUAL?: number | null;
  unlimited_MIN_GT?: number | null;
  unlimited_MIN_GTE?: number | null;
  unlimited_MIN_LT?: number | null;
  unlimited_MIN_LTE?: number | null;
  unlimited_SUM_EQUAL?: number | null;
  unlimited_SUM_GT?: number | null;
  unlimited_SUM_GTE?: number | null;
  unlimited_SUM_LT?: number | null;
  unlimited_SUM_LTE?: number | null;
}

export interface NegotiationRoundInput {
  caseId: string;
  data?: string | null;
  id: string;
  status: NegotiationRoundStatus;
}

export interface NegotiationRoundProposedByAggregateInput {
  AND?: NegotiationRoundProposedByAggregateInput[] | null;
  OR?: NegotiationRoundProposedByAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: NegotiationRoundProposedByNodeAggregationWhereInput | null;
}

export interface NegotiationRoundProposedByConnectionWhere {
  AND?: NegotiationRoundProposedByConnectionWhere[] | null;
  OR?: NegotiationRoundProposedByConnectionWhere[] | null;
  node?: OrganizationWhere | null;
  node_NOT?: OrganizationWhere | null;
}

export interface NegotiationRoundProposedByNodeAggregationWhereInput {
  AND?: NegotiationRoundProposedByNodeAggregationWhereInput[] | null;
  BIC_AVERAGE_EQUAL?: number | null;
  BIC_AVERAGE_GT?: number | null;
  BIC_AVERAGE_GTE?: number | null;
  BIC_AVERAGE_LT?: number | null;
  BIC_AVERAGE_LTE?: number | null;
  BIC_EQUAL?: string | null;
  BIC_GT?: number | null;
  BIC_GTE?: number | null;
  BIC_LONGEST_EQUAL?: number | null;
  BIC_LONGEST_GT?: number | null;
  BIC_LONGEST_GTE?: number | null;
  BIC_LONGEST_LT?: number | null;
  BIC_LONGEST_LTE?: number | null;
  BIC_LT?: number | null;
  BIC_LTE?: number | null;
  BIC_SHORTEST_EQUAL?: number | null;
  BIC_SHORTEST_GT?: number | null;
  BIC_SHORTEST_GTE?: number | null;
  BIC_SHORTEST_LT?: number | null;
  BIC_SHORTEST_LTE?: number | null;
  IBAN_AVERAGE_EQUAL?: number | null;
  IBAN_AVERAGE_GT?: number | null;
  IBAN_AVERAGE_GTE?: number | null;
  IBAN_AVERAGE_LT?: number | null;
  IBAN_AVERAGE_LTE?: number | null;
  IBAN_EQUAL?: string | null;
  IBAN_GT?: number | null;
  IBAN_GTE?: number | null;
  IBAN_LONGEST_EQUAL?: number | null;
  IBAN_LONGEST_GT?: number | null;
  IBAN_LONGEST_GTE?: number | null;
  IBAN_LONGEST_LT?: number | null;
  IBAN_LONGEST_LTE?: number | null;
  IBAN_LT?: number | null;
  IBAN_LTE?: number | null;
  IBAN_SHORTEST_EQUAL?: number | null;
  IBAN_SHORTEST_GT?: number | null;
  IBAN_SHORTEST_GTE?: number | null;
  IBAN_SHORTEST_LT?: number | null;
  IBAN_SHORTEST_LTE?: number | null;
  OR?: NegotiationRoundProposedByNodeAggregationWhereInput[] | null;
  accountName_AVERAGE_EQUAL?: number | null;
  accountName_AVERAGE_GT?: number | null;
  accountName_AVERAGE_GTE?: number | null;
  accountName_AVERAGE_LT?: number | null;
  accountName_AVERAGE_LTE?: number | null;
  accountName_EQUAL?: string | null;
  accountName_GT?: number | null;
  accountName_GTE?: number | null;
  accountName_LONGEST_EQUAL?: number | null;
  accountName_LONGEST_GT?: number | null;
  accountName_LONGEST_GTE?: number | null;
  accountName_LONGEST_LT?: number | null;
  accountName_LONGEST_LTE?: number | null;
  accountName_LT?: number | null;
  accountName_LTE?: number | null;
  accountName_SHORTEST_EQUAL?: number | null;
  accountName_SHORTEST_GT?: number | null;
  accountName_SHORTEST_GTE?: number | null;
  accountName_SHORTEST_LT?: number | null;
  accountName_SHORTEST_LTE?: number | null;
  accountNumber_AVERAGE_EQUAL?: number | null;
  accountNumber_AVERAGE_GT?: number | null;
  accountNumber_AVERAGE_GTE?: number | null;
  accountNumber_AVERAGE_LT?: number | null;
  accountNumber_AVERAGE_LTE?: number | null;
  accountNumber_EQUAL?: string | null;
  accountNumber_GT?: number | null;
  accountNumber_GTE?: number | null;
  accountNumber_LONGEST_EQUAL?: number | null;
  accountNumber_LONGEST_GT?: number | null;
  accountNumber_LONGEST_GTE?: number | null;
  accountNumber_LONGEST_LT?: number | null;
  accountNumber_LONGEST_LTE?: number | null;
  accountNumber_LT?: number | null;
  accountNumber_LTE?: number | null;
  accountNumber_SHORTEST_EQUAL?: number | null;
  accountNumber_SHORTEST_GT?: number | null;
  accountNumber_SHORTEST_GTE?: number | null;
  accountNumber_SHORTEST_LT?: number | null;
  accountNumber_SHORTEST_LTE?: number | null;
  billingAddress_AVERAGE_EQUAL?: number | null;
  billingAddress_AVERAGE_GT?: number | null;
  billingAddress_AVERAGE_GTE?: number | null;
  billingAddress_AVERAGE_LT?: number | null;
  billingAddress_AVERAGE_LTE?: number | null;
  billingAddress_EQUAL?: string | null;
  billingAddress_GT?: number | null;
  billingAddress_GTE?: number | null;
  billingAddress_LONGEST_EQUAL?: number | null;
  billingAddress_LONGEST_GT?: number | null;
  billingAddress_LONGEST_GTE?: number | null;
  billingAddress_LONGEST_LT?: number | null;
  billingAddress_LONGEST_LTE?: number | null;
  billingAddress_LT?: number | null;
  billingAddress_LTE?: number | null;
  billingAddress_SHORTEST_EQUAL?: number | null;
  billingAddress_SHORTEST_GT?: number | null;
  billingAddress_SHORTEST_GTE?: number | null;
  billingAddress_SHORTEST_LT?: number | null;
  billingAddress_SHORTEST_LTE?: number | null;
  contactEmail_AVERAGE_EQUAL?: number | null;
  contactEmail_AVERAGE_GT?: number | null;
  contactEmail_AVERAGE_GTE?: number | null;
  contactEmail_AVERAGE_LT?: number | null;
  contactEmail_AVERAGE_LTE?: number | null;
  contactEmail_EQUAL?: string | null;
  contactEmail_GT?: number | null;
  contactEmail_GTE?: number | null;
  contactEmail_LONGEST_EQUAL?: number | null;
  contactEmail_LONGEST_GT?: number | null;
  contactEmail_LONGEST_GTE?: number | null;
  contactEmail_LONGEST_LT?: number | null;
  contactEmail_LONGEST_LTE?: number | null;
  contactEmail_LT?: number | null;
  contactEmail_LTE?: number | null;
  contactEmail_SHORTEST_EQUAL?: number | null;
  contactEmail_SHORTEST_GT?: number | null;
  contactEmail_SHORTEST_GTE?: number | null;
  contactEmail_SHORTEST_LT?: number | null;
  contactEmail_SHORTEST_LTE?: number | null;
  contactFirstName_AVERAGE_EQUAL?: number | null;
  contactFirstName_AVERAGE_GT?: number | null;
  contactFirstName_AVERAGE_GTE?: number | null;
  contactFirstName_AVERAGE_LT?: number | null;
  contactFirstName_AVERAGE_LTE?: number | null;
  contactFirstName_EQUAL?: string | null;
  contactFirstName_GT?: number | null;
  contactFirstName_GTE?: number | null;
  contactFirstName_LONGEST_EQUAL?: number | null;
  contactFirstName_LONGEST_GT?: number | null;
  contactFirstName_LONGEST_GTE?: number | null;
  contactFirstName_LONGEST_LT?: number | null;
  contactFirstName_LONGEST_LTE?: number | null;
  contactFirstName_LT?: number | null;
  contactFirstName_LTE?: number | null;
  contactFirstName_SHORTEST_EQUAL?: number | null;
  contactFirstName_SHORTEST_GT?: number | null;
  contactFirstName_SHORTEST_GTE?: number | null;
  contactFirstName_SHORTEST_LT?: number | null;
  contactFirstName_SHORTEST_LTE?: number | null;
  contactLastName_AVERAGE_EQUAL?: number | null;
  contactLastName_AVERAGE_GT?: number | null;
  contactLastName_AVERAGE_GTE?: number | null;
  contactLastName_AVERAGE_LT?: number | null;
  contactLastName_AVERAGE_LTE?: number | null;
  contactLastName_EQUAL?: string | null;
  contactLastName_GT?: number | null;
  contactLastName_GTE?: number | null;
  contactLastName_LONGEST_EQUAL?: number | null;
  contactLastName_LONGEST_GT?: number | null;
  contactLastName_LONGEST_GTE?: number | null;
  contactLastName_LONGEST_LT?: number | null;
  contactLastName_LONGEST_LTE?: number | null;
  contactLastName_LT?: number | null;
  contactLastName_LTE?: number | null;
  contactLastName_SHORTEST_EQUAL?: number | null;
  contactLastName_SHORTEST_GT?: number | null;
  contactLastName_SHORTEST_GTE?: number | null;
  contactLastName_SHORTEST_LT?: number | null;
  contactLastName_SHORTEST_LTE?: number | null;
  contactOccupation_AVERAGE_EQUAL?: number | null;
  contactOccupation_AVERAGE_GT?: number | null;
  contactOccupation_AVERAGE_GTE?: number | null;
  contactOccupation_AVERAGE_LT?: number | null;
  contactOccupation_AVERAGE_LTE?: number | null;
  contactOccupation_EQUAL?: string | null;
  contactOccupation_GT?: number | null;
  contactOccupation_GTE?: number | null;
  contactOccupation_LONGEST_EQUAL?: number | null;
  contactOccupation_LONGEST_GT?: number | null;
  contactOccupation_LONGEST_GTE?: number | null;
  contactOccupation_LONGEST_LT?: number | null;
  contactOccupation_LONGEST_LTE?: number | null;
  contactOccupation_LT?: number | null;
  contactOccupation_LTE?: number | null;
  contactOccupation_SHORTEST_EQUAL?: number | null;
  contactOccupation_SHORTEST_GT?: number | null;
  contactOccupation_SHORTEST_GTE?: number | null;
  contactOccupation_SHORTEST_LT?: number | null;
  contactOccupation_SHORTEST_LTE?: number | null;
  contactPhone_AVERAGE_EQUAL?: number | null;
  contactPhone_AVERAGE_GT?: number | null;
  contactPhone_AVERAGE_GTE?: number | null;
  contactPhone_AVERAGE_LT?: number | null;
  contactPhone_AVERAGE_LTE?: number | null;
  contactPhone_EQUAL?: string | null;
  contactPhone_GT?: number | null;
  contactPhone_GTE?: number | null;
  contactPhone_LONGEST_EQUAL?: number | null;
  contactPhone_LONGEST_GT?: number | null;
  contactPhone_LONGEST_GTE?: number | null;
  contactPhone_LONGEST_LT?: number | null;
  contactPhone_LONGEST_LTE?: number | null;
  contactPhone_LT?: number | null;
  contactPhone_LTE?: number | null;
  contactPhone_SHORTEST_EQUAL?: number | null;
  contactPhone_SHORTEST_GT?: number | null;
  contactPhone_SHORTEST_GTE?: number | null;
  contactPhone_SHORTEST_LT?: number | null;
  contactPhone_SHORTEST_LTE?: number | null;
  createdOn_AVERAGE_EQUAL?: number | null;
  createdOn_AVERAGE_GT?: number | null;
  createdOn_AVERAGE_GTE?: number | null;
  createdOn_AVERAGE_LT?: number | null;
  createdOn_AVERAGE_LTE?: number | null;
  createdOn_EQUAL?: number | null;
  createdOn_GT?: number | null;
  createdOn_GTE?: number | null;
  createdOn_LT?: number | null;
  createdOn_LTE?: number | null;
  createdOn_MAX_EQUAL?: number | null;
  createdOn_MAX_GT?: number | null;
  createdOn_MAX_GTE?: number | null;
  createdOn_MAX_LT?: number | null;
  createdOn_MAX_LTE?: number | null;
  createdOn_MIN_EQUAL?: number | null;
  createdOn_MIN_GT?: number | null;
  createdOn_MIN_GTE?: number | null;
  createdOn_MIN_LT?: number | null;
  createdOn_MIN_LTE?: number | null;
  createdOn_SUM_EQUAL?: number | null;
  createdOn_SUM_GT?: number | null;
  createdOn_SUM_GTE?: number | null;
  createdOn_SUM_LT?: number | null;
  createdOn_SUM_LTE?: number | null;
  deliveryAddress_AVERAGE_EQUAL?: number | null;
  deliveryAddress_AVERAGE_GT?: number | null;
  deliveryAddress_AVERAGE_GTE?: number | null;
  deliveryAddress_AVERAGE_LT?: number | null;
  deliveryAddress_AVERAGE_LTE?: number | null;
  deliveryAddress_EQUAL?: string | null;
  deliveryAddress_GT?: number | null;
  deliveryAddress_GTE?: number | null;
  deliveryAddress_LONGEST_EQUAL?: number | null;
  deliveryAddress_LONGEST_GT?: number | null;
  deliveryAddress_LONGEST_GTE?: number | null;
  deliveryAddress_LONGEST_LT?: number | null;
  deliveryAddress_LONGEST_LTE?: number | null;
  deliveryAddress_LT?: number | null;
  deliveryAddress_LTE?: number | null;
  deliveryAddress_SHORTEST_EQUAL?: number | null;
  deliveryAddress_SHORTEST_GT?: number | null;
  deliveryAddress_SHORTEST_GTE?: number | null;
  deliveryAddress_SHORTEST_LT?: number | null;
  deliveryAddress_SHORTEST_LTE?: number | null;
  domicile_AVERAGE_EQUAL?: number | null;
  domicile_AVERAGE_GT?: number | null;
  domicile_AVERAGE_GTE?: number | null;
  domicile_AVERAGE_LT?: number | null;
  domicile_AVERAGE_LTE?: number | null;
  domicile_EQUAL?: string | null;
  domicile_GT?: number | null;
  domicile_GTE?: number | null;
  domicile_LONGEST_EQUAL?: number | null;
  domicile_LONGEST_GT?: number | null;
  domicile_LONGEST_GTE?: number | null;
  domicile_LONGEST_LT?: number | null;
  domicile_LONGEST_LTE?: number | null;
  domicile_LT?: number | null;
  domicile_LTE?: number | null;
  domicile_SHORTEST_EQUAL?: number | null;
  domicile_SHORTEST_GT?: number | null;
  domicile_SHORTEST_GTE?: number | null;
  domicile_SHORTEST_LT?: number | null;
  domicile_SHORTEST_LTE?: number | null;
  dualApprovalThreshold_AVERAGE_EQUAL?: number | null;
  dualApprovalThreshold_AVERAGE_GT?: number | null;
  dualApprovalThreshold_AVERAGE_GTE?: number | null;
  dualApprovalThreshold_AVERAGE_LT?: number | null;
  dualApprovalThreshold_AVERAGE_LTE?: number | null;
  dualApprovalThreshold_EQUAL?: number | null;
  dualApprovalThreshold_GT?: number | null;
  dualApprovalThreshold_GTE?: number | null;
  dualApprovalThreshold_LT?: number | null;
  dualApprovalThreshold_LTE?: number | null;
  dualApprovalThreshold_MAX_EQUAL?: number | null;
  dualApprovalThreshold_MAX_GT?: number | null;
  dualApprovalThreshold_MAX_GTE?: number | null;
  dualApprovalThreshold_MAX_LT?: number | null;
  dualApprovalThreshold_MAX_LTE?: number | null;
  dualApprovalThreshold_MIN_EQUAL?: number | null;
  dualApprovalThreshold_MIN_GT?: number | null;
  dualApprovalThreshold_MIN_GTE?: number | null;
  dualApprovalThreshold_MIN_LT?: number | null;
  dualApprovalThreshold_MIN_LTE?: number | null;
  dualApprovalThreshold_SUM_EQUAL?: number | null;
  dualApprovalThreshold_SUM_GT?: number | null;
  dualApprovalThreshold_SUM_GTE?: number | null;
  dualApprovalThreshold_SUM_LT?: number | null;
  dualApprovalThreshold_SUM_LTE?: number | null;
  eIN_AVERAGE_EQUAL?: number | null;
  eIN_AVERAGE_GT?: number | null;
  eIN_AVERAGE_GTE?: number | null;
  eIN_AVERAGE_LT?: number | null;
  eIN_AVERAGE_LTE?: number | null;
  eIN_EQUAL?: string | null;
  eIN_GT?: number | null;
  eIN_GTE?: number | null;
  eIN_LONGEST_EQUAL?: number | null;
  eIN_LONGEST_GT?: number | null;
  eIN_LONGEST_GTE?: number | null;
  eIN_LONGEST_LT?: number | null;
  eIN_LONGEST_LTE?: number | null;
  eIN_LT?: number | null;
  eIN_LTE?: number | null;
  eIN_SHORTEST_EQUAL?: number | null;
  eIN_SHORTEST_GT?: number | null;
  eIN_SHORTEST_GTE?: number | null;
  eIN_SHORTEST_LT?: number | null;
  eIN_SHORTEST_LTE?: number | null;
  fax_AVERAGE_EQUAL?: number | null;
  fax_AVERAGE_GT?: number | null;
  fax_AVERAGE_GTE?: number | null;
  fax_AVERAGE_LT?: number | null;
  fax_AVERAGE_LTE?: number | null;
  fax_EQUAL?: string | null;
  fax_GT?: number | null;
  fax_GTE?: number | null;
  fax_LONGEST_EQUAL?: number | null;
  fax_LONGEST_GT?: number | null;
  fax_LONGEST_GTE?: number | null;
  fax_LONGEST_LT?: number | null;
  fax_LONGEST_LTE?: number | null;
  fax_LT?: number | null;
  fax_LTE?: number | null;
  fax_SHORTEST_EQUAL?: number | null;
  fax_SHORTEST_GT?: number | null;
  fax_SHORTEST_GTE?: number | null;
  fax_SHORTEST_LT?: number | null;
  fax_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  legalName_AVERAGE_EQUAL?: number | null;
  legalName_AVERAGE_GT?: number | null;
  legalName_AVERAGE_GTE?: number | null;
  legalName_AVERAGE_LT?: number | null;
  legalName_AVERAGE_LTE?: number | null;
  legalName_EQUAL?: string | null;
  legalName_GT?: number | null;
  legalName_GTE?: number | null;
  legalName_LONGEST_EQUAL?: number | null;
  legalName_LONGEST_GT?: number | null;
  legalName_LONGEST_GTE?: number | null;
  legalName_LONGEST_LT?: number | null;
  legalName_LONGEST_LTE?: number | null;
  legalName_LT?: number | null;
  legalName_LTE?: number | null;
  legalName_SHORTEST_EQUAL?: number | null;
  legalName_SHORTEST_GT?: number | null;
  legalName_SHORTEST_GTE?: number | null;
  legalName_SHORTEST_LT?: number | null;
  legalName_SHORTEST_LTE?: number | null;
  logo_AVERAGE_EQUAL?: number | null;
  logo_AVERAGE_GT?: number | null;
  logo_AVERAGE_GTE?: number | null;
  logo_AVERAGE_LT?: number | null;
  logo_AVERAGE_LTE?: number | null;
  logo_EQUAL?: string | null;
  logo_GT?: number | null;
  logo_GTE?: number | null;
  logo_LONGEST_EQUAL?: number | null;
  logo_LONGEST_GT?: number | null;
  logo_LONGEST_GTE?: number | null;
  logo_LONGEST_LT?: number | null;
  logo_LONGEST_LTE?: number | null;
  logo_LT?: number | null;
  logo_LTE?: number | null;
  logo_SHORTEST_EQUAL?: number | null;
  logo_SHORTEST_GT?: number | null;
  logo_SHORTEST_GTE?: number | null;
  logo_SHORTEST_LT?: number | null;
  logo_SHORTEST_LTE?: number | null;
  name_AVERAGE_EQUAL?: number | null;
  name_AVERAGE_GT?: number | null;
  name_AVERAGE_GTE?: number | null;
  name_AVERAGE_LT?: number | null;
  name_AVERAGE_LTE?: number | null;
  name_EQUAL?: string | null;
  name_GT?: number | null;
  name_GTE?: number | null;
  name_LONGEST_EQUAL?: number | null;
  name_LONGEST_GT?: number | null;
  name_LONGEST_GTE?: number | null;
  name_LONGEST_LT?: number | null;
  name_LONGEST_LTE?: number | null;
  name_LT?: number | null;
  name_LTE?: number | null;
  name_SHORTEST_EQUAL?: number | null;
  name_SHORTEST_GT?: number | null;
  name_SHORTEST_GTE?: number | null;
  name_SHORTEST_LT?: number | null;
  name_SHORTEST_LTE?: number | null;
  paymentTerms_AVERAGE_EQUAL?: number | null;
  paymentTerms_AVERAGE_GT?: number | null;
  paymentTerms_AVERAGE_GTE?: number | null;
  paymentTerms_AVERAGE_LT?: number | null;
  paymentTerms_AVERAGE_LTE?: number | null;
  paymentTerms_EQUAL?: number | null;
  paymentTerms_GT?: number | null;
  paymentTerms_GTE?: number | null;
  paymentTerms_LT?: number | null;
  paymentTerms_LTE?: number | null;
  paymentTerms_MAX_EQUAL?: number | null;
  paymentTerms_MAX_GT?: number | null;
  paymentTerms_MAX_GTE?: number | null;
  paymentTerms_MAX_LT?: number | null;
  paymentTerms_MAX_LTE?: number | null;
  paymentTerms_MIN_EQUAL?: number | null;
  paymentTerms_MIN_GT?: number | null;
  paymentTerms_MIN_GTE?: number | null;
  paymentTerms_MIN_LT?: number | null;
  paymentTerms_MIN_LTE?: number | null;
  paymentTerms_SUM_EQUAL?: number | null;
  paymentTerms_SUM_GT?: number | null;
  paymentTerms_SUM_GTE?: number | null;
  paymentTerms_SUM_LT?: number | null;
  paymentTerms_SUM_LTE?: number | null;
  phone_AVERAGE_EQUAL?: number | null;
  phone_AVERAGE_GT?: number | null;
  phone_AVERAGE_GTE?: number | null;
  phone_AVERAGE_LT?: number | null;
  phone_AVERAGE_LTE?: number | null;
  phone_EQUAL?: string | null;
  phone_GT?: number | null;
  phone_GTE?: number | null;
  phone_LONGEST_EQUAL?: number | null;
  phone_LONGEST_GT?: number | null;
  phone_LONGEST_GTE?: number | null;
  phone_LONGEST_LT?: number | null;
  phone_LONGEST_LTE?: number | null;
  phone_LT?: number | null;
  phone_LTE?: number | null;
  phone_SHORTEST_EQUAL?: number | null;
  phone_SHORTEST_GT?: number | null;
  phone_SHORTEST_GTE?: number | null;
  phone_SHORTEST_LT?: number | null;
  phone_SHORTEST_LTE?: number | null;
  tenantId_AVERAGE_EQUAL?: number | null;
  tenantId_AVERAGE_GT?: number | null;
  tenantId_AVERAGE_GTE?: number | null;
  tenantId_AVERAGE_LT?: number | null;
  tenantId_AVERAGE_LTE?: number | null;
  tenantId_EQUAL?: string | null;
  tenantId_GT?: number | null;
  tenantId_GTE?: number | null;
  tenantId_LONGEST_EQUAL?: number | null;
  tenantId_LONGEST_GT?: number | null;
  tenantId_LONGEST_GTE?: number | null;
  tenantId_LONGEST_LT?: number | null;
  tenantId_LONGEST_LTE?: number | null;
  tenantId_LT?: number | null;
  tenantId_LTE?: number | null;
  tenantId_SHORTEST_EQUAL?: number | null;
  tenantId_SHORTEST_GT?: number | null;
  tenantId_SHORTEST_GTE?: number | null;
  tenantId_SHORTEST_LT?: number | null;
  tenantId_SHORTEST_LTE?: number | null;
  website_AVERAGE_EQUAL?: number | null;
  website_AVERAGE_GT?: number | null;
  website_AVERAGE_GTE?: number | null;
  website_AVERAGE_LT?: number | null;
  website_AVERAGE_LTE?: number | null;
  website_EQUAL?: string | null;
  website_GT?: number | null;
  website_GTE?: number | null;
  website_LONGEST_EQUAL?: number | null;
  website_LONGEST_GT?: number | null;
  website_LONGEST_GTE?: number | null;
  website_LONGEST_LT?: number | null;
  website_LONGEST_LTE?: number | null;
  website_LT?: number | null;
  website_LTE?: number | null;
  website_SHORTEST_EQUAL?: number | null;
  website_SHORTEST_GT?: number | null;
  website_SHORTEST_GTE?: number | null;
  website_SHORTEST_LT?: number | null;
  website_SHORTEST_LTE?: number | null;
}

export interface NegotiationRoundSourceAggregateInput {
  AND?: NegotiationRoundSourceAggregateInput[] | null;
  OR?: NegotiationRoundSourceAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: NegotiationRoundSourceNodeAggregationWhereInput | null;
}

export interface NegotiationRoundSourceConnectionWhere {
  AND?: NegotiationRoundSourceConnectionWhere[] | null;
  OR?: NegotiationRoundSourceConnectionWhere[] | null;
  node?: FlexEntityWhere | null;
  node_NOT?: FlexEntityWhere | null;
}

export interface NegotiationRoundSourceNodeAggregationWhereInput {
  AND?: NegotiationRoundSourceNodeAggregationWhereInput[] | null;
  OR?: NegotiationRoundSourceNodeAggregationWhereInput[] | null;
  createdByEmail_AVERAGE_EQUAL?: number | null;
  createdByEmail_AVERAGE_GT?: number | null;
  createdByEmail_AVERAGE_GTE?: number | null;
  createdByEmail_AVERAGE_LT?: number | null;
  createdByEmail_AVERAGE_LTE?: number | null;
  createdByEmail_EQUAL?: string | null;
  createdByEmail_GT?: number | null;
  createdByEmail_GTE?: number | null;
  createdByEmail_LONGEST_EQUAL?: number | null;
  createdByEmail_LONGEST_GT?: number | null;
  createdByEmail_LONGEST_GTE?: number | null;
  createdByEmail_LONGEST_LT?: number | null;
  createdByEmail_LONGEST_LTE?: number | null;
  createdByEmail_LT?: number | null;
  createdByEmail_LTE?: number | null;
  createdByEmail_SHORTEST_EQUAL?: number | null;
  createdByEmail_SHORTEST_GT?: number | null;
  createdByEmail_SHORTEST_GTE?: number | null;
  createdByEmail_SHORTEST_LT?: number | null;
  createdByEmail_SHORTEST_LTE?: number | null;
  createdByName_AVERAGE_EQUAL?: number | null;
  createdByName_AVERAGE_GT?: number | null;
  createdByName_AVERAGE_GTE?: number | null;
  createdByName_AVERAGE_LT?: number | null;
  createdByName_AVERAGE_LTE?: number | null;
  createdByName_EQUAL?: string | null;
  createdByName_GT?: number | null;
  createdByName_GTE?: number | null;
  createdByName_LONGEST_EQUAL?: number | null;
  createdByName_LONGEST_GT?: number | null;
  createdByName_LONGEST_GTE?: number | null;
  createdByName_LONGEST_LT?: number | null;
  createdByName_LONGEST_LTE?: number | null;
  createdByName_LT?: number | null;
  createdByName_LTE?: number | null;
  createdByName_SHORTEST_EQUAL?: number | null;
  createdByName_SHORTEST_GT?: number | null;
  createdByName_SHORTEST_GTE?: number | null;
  createdByName_SHORTEST_LT?: number | null;
  createdByName_SHORTEST_LTE?: number | null;
  createdOn_EQUAL?: any | null;
  createdOn_GT?: any | null;
  createdOn_GTE?: any | null;
  createdOn_LT?: any | null;
  createdOn_LTE?: any | null;
  createdOn_MAX_EQUAL?: any | null;
  createdOn_MAX_GT?: any | null;
  createdOn_MAX_GTE?: any | null;
  createdOn_MAX_LT?: any | null;
  createdOn_MAX_LTE?: any | null;
  createdOn_MIN_EQUAL?: any | null;
  createdOn_MIN_GT?: any | null;
  createdOn_MIN_GTE?: any | null;
  createdOn_MIN_LT?: any | null;
  createdOn_MIN_LTE?: any | null;
  dataKeys_AVERAGE_EQUAL?: number | null;
  dataKeys_AVERAGE_GT?: number | null;
  dataKeys_AVERAGE_GTE?: number | null;
  dataKeys_AVERAGE_LT?: number | null;
  dataKeys_AVERAGE_LTE?: number | null;
  dataKeys_EQUAL?: string | null;
  dataKeys_GT?: number | null;
  dataKeys_GTE?: number | null;
  dataKeys_LONGEST_EQUAL?: number | null;
  dataKeys_LONGEST_GT?: number | null;
  dataKeys_LONGEST_GTE?: number | null;
  dataKeys_LONGEST_LT?: number | null;
  dataKeys_LONGEST_LTE?: number | null;
  dataKeys_LT?: number | null;
  dataKeys_LTE?: number | null;
  dataKeys_SHORTEST_EQUAL?: number | null;
  dataKeys_SHORTEST_GT?: number | null;
  dataKeys_SHORTEST_GTE?: number | null;
  dataKeys_SHORTEST_LT?: number | null;
  dataKeys_SHORTEST_LTE?: number | null;
  data_AVERAGE_EQUAL?: number | null;
  data_AVERAGE_GT?: number | null;
  data_AVERAGE_GTE?: number | null;
  data_AVERAGE_LT?: number | null;
  data_AVERAGE_LTE?: number | null;
  data_EQUAL?: string | null;
  data_GT?: number | null;
  data_GTE?: number | null;
  data_LONGEST_EQUAL?: number | null;
  data_LONGEST_GT?: number | null;
  data_LONGEST_GTE?: number | null;
  data_LONGEST_LT?: number | null;
  data_LONGEST_LTE?: number | null;
  data_LT?: number | null;
  data_LTE?: number | null;
  data_SHORTEST_EQUAL?: number | null;
  data_SHORTEST_GT?: number | null;
  data_SHORTEST_GTE?: number | null;
  data_SHORTEST_LT?: number | null;
  data_SHORTEST_LTE?: number | null;
  flexEntityName_AVERAGE_EQUAL?: number | null;
  flexEntityName_AVERAGE_GT?: number | null;
  flexEntityName_AVERAGE_GTE?: number | null;
  flexEntityName_AVERAGE_LT?: number | null;
  flexEntityName_AVERAGE_LTE?: number | null;
  flexEntityName_EQUAL?: string | null;
  flexEntityName_GT?: number | null;
  flexEntityName_GTE?: number | null;
  flexEntityName_LONGEST_EQUAL?: number | null;
  flexEntityName_LONGEST_GT?: number | null;
  flexEntityName_LONGEST_GTE?: number | null;
  flexEntityName_LONGEST_LT?: number | null;
  flexEntityName_LONGEST_LTE?: number | null;
  flexEntityName_LT?: number | null;
  flexEntityName_LTE?: number | null;
  flexEntityName_SHORTEST_EQUAL?: number | null;
  flexEntityName_SHORTEST_GT?: number | null;
  flexEntityName_SHORTEST_GTE?: number | null;
  flexEntityName_SHORTEST_LT?: number | null;
  flexEntityName_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  lastUpdatedOn_EQUAL?: any | null;
  lastUpdatedOn_GT?: any | null;
  lastUpdatedOn_GTE?: any | null;
  lastUpdatedOn_LT?: any | null;
  lastUpdatedOn_LTE?: any | null;
  lastUpdatedOn_MAX_EQUAL?: any | null;
  lastUpdatedOn_MAX_GT?: any | null;
  lastUpdatedOn_MAX_GTE?: any | null;
  lastUpdatedOn_MAX_LT?: any | null;
  lastUpdatedOn_MAX_LTE?: any | null;
  lastUpdatedOn_MIN_EQUAL?: any | null;
  lastUpdatedOn_MIN_GT?: any | null;
  lastUpdatedOn_MIN_GTE?: any | null;
  lastUpdatedOn_MIN_LT?: any | null;
  lastUpdatedOn_MIN_LTE?: any | null;
  patientId_AVERAGE_EQUAL?: number | null;
  patientId_AVERAGE_GT?: number | null;
  patientId_AVERAGE_GTE?: number | null;
  patientId_AVERAGE_LT?: number | null;
  patientId_AVERAGE_LTE?: number | null;
  patientId_EQUAL?: string | null;
  patientId_GT?: number | null;
  patientId_GTE?: number | null;
  patientId_LONGEST_EQUAL?: number | null;
  patientId_LONGEST_GT?: number | null;
  patientId_LONGEST_GTE?: number | null;
  patientId_LONGEST_LT?: number | null;
  patientId_LONGEST_LTE?: number | null;
  patientId_LT?: number | null;
  patientId_LTE?: number | null;
  patientId_SHORTEST_EQUAL?: number | null;
  patientId_SHORTEST_GT?: number | null;
  patientId_SHORTEST_GTE?: number | null;
  patientId_SHORTEST_LT?: number | null;
  patientId_SHORTEST_LTE?: number | null;
  preparationBrandNames_AVERAGE_EQUAL?: number | null;
  preparationBrandNames_AVERAGE_GT?: number | null;
  preparationBrandNames_AVERAGE_GTE?: number | null;
  preparationBrandNames_AVERAGE_LT?: number | null;
  preparationBrandNames_AVERAGE_LTE?: number | null;
  preparationBrandNames_EQUAL?: string | null;
  preparationBrandNames_GT?: number | null;
  preparationBrandNames_GTE?: number | null;
  preparationBrandNames_LONGEST_EQUAL?: number | null;
  preparationBrandNames_LONGEST_GT?: number | null;
  preparationBrandNames_LONGEST_GTE?: number | null;
  preparationBrandNames_LONGEST_LT?: number | null;
  preparationBrandNames_LONGEST_LTE?: number | null;
  preparationBrandNames_LT?: number | null;
  preparationBrandNames_LTE?: number | null;
  preparationBrandNames_SHORTEST_EQUAL?: number | null;
  preparationBrandNames_SHORTEST_GT?: number | null;
  preparationBrandNames_SHORTEST_GTE?: number | null;
  preparationBrandNames_SHORTEST_LT?: number | null;
  preparationBrandNames_SHORTEST_LTE?: number | null;
  preparationGenericNames_AVERAGE_EQUAL?: number | null;
  preparationGenericNames_AVERAGE_GT?: number | null;
  preparationGenericNames_AVERAGE_GTE?: number | null;
  preparationGenericNames_AVERAGE_LT?: number | null;
  preparationGenericNames_AVERAGE_LTE?: number | null;
  preparationGenericNames_EQUAL?: string | null;
  preparationGenericNames_GT?: number | null;
  preparationGenericNames_GTE?: number | null;
  preparationGenericNames_LONGEST_EQUAL?: number | null;
  preparationGenericNames_LONGEST_GT?: number | null;
  preparationGenericNames_LONGEST_GTE?: number | null;
  preparationGenericNames_LONGEST_LT?: number | null;
  preparationGenericNames_LONGEST_LTE?: number | null;
  preparationGenericNames_LT?: number | null;
  preparationGenericNames_LTE?: number | null;
  preparationGenericNames_SHORTEST_EQUAL?: number | null;
  preparationGenericNames_SHORTEST_GT?: number | null;
  preparationGenericNames_SHORTEST_GTE?: number | null;
  preparationGenericNames_SHORTEST_LT?: number | null;
  preparationGenericNames_SHORTEST_LTE?: number | null;
  quantity_AVERAGE_EQUAL?: number | null;
  quantity_AVERAGE_GT?: number | null;
  quantity_AVERAGE_GTE?: number | null;
  quantity_AVERAGE_LT?: number | null;
  quantity_AVERAGE_LTE?: number | null;
  quantity_EQUAL?: number | null;
  quantity_GT?: number | null;
  quantity_GTE?: number | null;
  quantity_LT?: number | null;
  quantity_LTE?: number | null;
  quantity_MAX_EQUAL?: number | null;
  quantity_MAX_GT?: number | null;
  quantity_MAX_GTE?: number | null;
  quantity_MAX_LT?: number | null;
  quantity_MAX_LTE?: number | null;
  quantity_MIN_EQUAL?: number | null;
  quantity_MIN_GT?: number | null;
  quantity_MIN_GTE?: number | null;
  quantity_MIN_LT?: number | null;
  quantity_MIN_LTE?: number | null;
  quantity_SUM_EQUAL?: number | null;
  quantity_SUM_GT?: number | null;
  quantity_SUM_GTE?: number | null;
  quantity_SUM_LT?: number | null;
  quantity_SUM_LTE?: number | null;
  tenantId_AVERAGE_EQUAL?: number | null;
  tenantId_AVERAGE_GT?: number | null;
  tenantId_AVERAGE_GTE?: number | null;
  tenantId_AVERAGE_LT?: number | null;
  tenantId_AVERAGE_LTE?: number | null;
  tenantId_EQUAL?: string | null;
  tenantId_GT?: number | null;
  tenantId_GTE?: number | null;
  tenantId_LONGEST_EQUAL?: number | null;
  tenantId_LONGEST_GT?: number | null;
  tenantId_LONGEST_GTE?: number | null;
  tenantId_LONGEST_LT?: number | null;
  tenantId_LONGEST_LTE?: number | null;
  tenantId_LT?: number | null;
  tenantId_LTE?: number | null;
  tenantId_SHORTEST_EQUAL?: number | null;
  tenantId_SHORTEST_GT?: number | null;
  tenantId_SHORTEST_GTE?: number | null;
  tenantId_SHORTEST_LT?: number | null;
  tenantId_SHORTEST_LTE?: number | null;
  unlimited_AVERAGE_EQUAL?: number | null;
  unlimited_AVERAGE_GT?: number | null;
  unlimited_AVERAGE_GTE?: number | null;
  unlimited_AVERAGE_LT?: number | null;
  unlimited_AVERAGE_LTE?: number | null;
  unlimited_EQUAL?: number | null;
  unlimited_GT?: number | null;
  unlimited_GTE?: number | null;
  unlimited_LT?: number | null;
  unlimited_LTE?: number | null;
  unlimited_MAX_EQUAL?: number | null;
  unlimited_MAX_GT?: number | null;
  unlimited_MAX_GTE?: number | null;
  unlimited_MAX_LT?: number | null;
  unlimited_MAX_LTE?: number | null;
  unlimited_MIN_EQUAL?: number | null;
  unlimited_MIN_GT?: number | null;
  unlimited_MIN_GTE?: number | null;
  unlimited_MIN_LT?: number | null;
  unlimited_MIN_LTE?: number | null;
  unlimited_SUM_EQUAL?: number | null;
  unlimited_SUM_GT?: number | null;
  unlimited_SUM_GTE?: number | null;
  unlimited_SUM_LT?: number | null;
  unlimited_SUM_LTE?: number | null;
  uuid_AVERAGE_EQUAL?: number | null;
  uuid_AVERAGE_GT?: number | null;
  uuid_AVERAGE_GTE?: number | null;
  uuid_AVERAGE_LT?: number | null;
  uuid_AVERAGE_LTE?: number | null;
  uuid_EQUAL?: string | null;
  uuid_GT?: number | null;
  uuid_GTE?: number | null;
  uuid_LONGEST_EQUAL?: number | null;
  uuid_LONGEST_GT?: number | null;
  uuid_LONGEST_GTE?: number | null;
  uuid_LONGEST_LT?: number | null;
  uuid_LONGEST_LTE?: number | null;
  uuid_LT?: number | null;
  uuid_LTE?: number | null;
  uuid_SHORTEST_EQUAL?: number | null;
  uuid_SHORTEST_GT?: number | null;
  uuid_SHORTEST_GTE?: number | null;
  uuid_SHORTEST_LT?: number | null;
  uuid_SHORTEST_LTE?: number | null;
}

export interface NegotiationRoundUpdatedByAggregateInput {
  AND?: NegotiationRoundUpdatedByAggregateInput[] | null;
  OR?: NegotiationRoundUpdatedByAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: NegotiationRoundUpdatedByNodeAggregationWhereInput | null;
}

export interface NegotiationRoundUpdatedByConnectionWhere {
  AND?: NegotiationRoundUpdatedByConnectionWhere[] | null;
  OR?: NegotiationRoundUpdatedByConnectionWhere[] | null;
  node?: UserWhere | null;
  node_NOT?: UserWhere | null;
}

export interface NegotiationRoundUpdatedByNodeAggregationWhereInput {
  AND?: NegotiationRoundUpdatedByNodeAggregationWhereInput[] | null;
  OR?: NegotiationRoundUpdatedByNodeAggregationWhereInput[] | null;
  deletedOn_EQUAL?: any | null;
  deletedOn_GT?: any | null;
  deletedOn_GTE?: any | null;
  deletedOn_LT?: any | null;
  deletedOn_LTE?: any | null;
  deletedOn_MAX_EQUAL?: any | null;
  deletedOn_MAX_GT?: any | null;
  deletedOn_MAX_GTE?: any | null;
  deletedOn_MAX_LT?: any | null;
  deletedOn_MAX_LTE?: any | null;
  deletedOn_MIN_EQUAL?: any | null;
  deletedOn_MIN_GT?: any | null;
  deletedOn_MIN_GTE?: any | null;
  deletedOn_MIN_LT?: any | null;
  deletedOn_MIN_LTE?: any | null;
  department_AVERAGE_EQUAL?: number | null;
  department_AVERAGE_GT?: number | null;
  department_AVERAGE_GTE?: number | null;
  department_AVERAGE_LT?: number | null;
  department_AVERAGE_LTE?: number | null;
  department_EQUAL?: string | null;
  department_GT?: number | null;
  department_GTE?: number | null;
  department_LONGEST_EQUAL?: number | null;
  department_LONGEST_GT?: number | null;
  department_LONGEST_GTE?: number | null;
  department_LONGEST_LT?: number | null;
  department_LONGEST_LTE?: number | null;
  department_LT?: number | null;
  department_LTE?: number | null;
  department_SHORTEST_EQUAL?: number | null;
  department_SHORTEST_GT?: number | null;
  department_SHORTEST_GTE?: number | null;
  department_SHORTEST_LT?: number | null;
  department_SHORTEST_LTE?: number | null;
  email_AVERAGE_EQUAL?: number | null;
  email_AVERAGE_GT?: number | null;
  email_AVERAGE_GTE?: number | null;
  email_AVERAGE_LT?: number | null;
  email_AVERAGE_LTE?: number | null;
  email_EQUAL?: string | null;
  email_GT?: number | null;
  email_GTE?: number | null;
  email_LONGEST_EQUAL?: number | null;
  email_LONGEST_GT?: number | null;
  email_LONGEST_GTE?: number | null;
  email_LONGEST_LT?: number | null;
  email_LONGEST_LTE?: number | null;
  email_LT?: number | null;
  email_LTE?: number | null;
  email_SHORTEST_EQUAL?: number | null;
  email_SHORTEST_GT?: number | null;
  email_SHORTEST_GTE?: number | null;
  email_SHORTEST_LT?: number | null;
  email_SHORTEST_LTE?: number | null;
  firstName_AVERAGE_EQUAL?: number | null;
  firstName_AVERAGE_GT?: number | null;
  firstName_AVERAGE_GTE?: number | null;
  firstName_AVERAGE_LT?: number | null;
  firstName_AVERAGE_LTE?: number | null;
  firstName_EQUAL?: string | null;
  firstName_GT?: number | null;
  firstName_GTE?: number | null;
  firstName_LONGEST_EQUAL?: number | null;
  firstName_LONGEST_GT?: number | null;
  firstName_LONGEST_GTE?: number | null;
  firstName_LONGEST_LT?: number | null;
  firstName_LONGEST_LTE?: number | null;
  firstName_LT?: number | null;
  firstName_LTE?: number | null;
  firstName_SHORTEST_EQUAL?: number | null;
  firstName_SHORTEST_GT?: number | null;
  firstName_SHORTEST_GTE?: number | null;
  firstName_SHORTEST_LT?: number | null;
  firstName_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  lastName_AVERAGE_EQUAL?: number | null;
  lastName_AVERAGE_GT?: number | null;
  lastName_AVERAGE_GTE?: number | null;
  lastName_AVERAGE_LT?: number | null;
  lastName_AVERAGE_LTE?: number | null;
  lastName_EQUAL?: string | null;
  lastName_GT?: number | null;
  lastName_GTE?: number | null;
  lastName_LONGEST_EQUAL?: number | null;
  lastName_LONGEST_GT?: number | null;
  lastName_LONGEST_GTE?: number | null;
  lastName_LONGEST_LT?: number | null;
  lastName_LONGEST_LTE?: number | null;
  lastName_LT?: number | null;
  lastName_LTE?: number | null;
  lastName_SHORTEST_EQUAL?: number | null;
  lastName_SHORTEST_GT?: number | null;
  lastName_SHORTEST_GTE?: number | null;
  lastName_SHORTEST_LT?: number | null;
  lastName_SHORTEST_LTE?: number | null;
  position_AVERAGE_EQUAL?: number | null;
  position_AVERAGE_GT?: number | null;
  position_AVERAGE_GTE?: number | null;
  position_AVERAGE_LT?: number | null;
  position_AVERAGE_LTE?: number | null;
  position_EQUAL?: string | null;
  position_GT?: number | null;
  position_GTE?: number | null;
  position_LONGEST_EQUAL?: number | null;
  position_LONGEST_GT?: number | null;
  position_LONGEST_GTE?: number | null;
  position_LONGEST_LT?: number | null;
  position_LONGEST_LTE?: number | null;
  position_LT?: number | null;
  position_LTE?: number | null;
  position_SHORTEST_EQUAL?: number | null;
  position_SHORTEST_GT?: number | null;
  position_SHORTEST_GTE?: number | null;
  position_SHORTEST_LT?: number | null;
  position_SHORTEST_LTE?: number | null;
  preferredLanguage_AVERAGE_EQUAL?: number | null;
  preferredLanguage_AVERAGE_GT?: number | null;
  preferredLanguage_AVERAGE_GTE?: number | null;
  preferredLanguage_AVERAGE_LT?: number | null;
  preferredLanguage_AVERAGE_LTE?: number | null;
  preferredLanguage_EQUAL?: string | null;
  preferredLanguage_GT?: number | null;
  preferredLanguage_GTE?: number | null;
  preferredLanguage_LONGEST_EQUAL?: number | null;
  preferredLanguage_LONGEST_GT?: number | null;
  preferredLanguage_LONGEST_GTE?: number | null;
  preferredLanguage_LONGEST_LT?: number | null;
  preferredLanguage_LONGEST_LTE?: number | null;
  preferredLanguage_LT?: number | null;
  preferredLanguage_LTE?: number | null;
  preferredLanguage_SHORTEST_EQUAL?: number | null;
  preferredLanguage_SHORTEST_GT?: number | null;
  preferredLanguage_SHORTEST_GTE?: number | null;
  preferredLanguage_SHORTEST_LT?: number | null;
  preferredLanguage_SHORTEST_LTE?: number | null;
  tenantId_AVERAGE_EQUAL?: number | null;
  tenantId_AVERAGE_GT?: number | null;
  tenantId_AVERAGE_GTE?: number | null;
  tenantId_AVERAGE_LT?: number | null;
  tenantId_AVERAGE_LTE?: number | null;
  tenantId_EQUAL?: string | null;
  tenantId_GT?: number | null;
  tenantId_GTE?: number | null;
  tenantId_LONGEST_EQUAL?: number | null;
  tenantId_LONGEST_GT?: number | null;
  tenantId_LONGEST_GTE?: number | null;
  tenantId_LONGEST_LT?: number | null;
  tenantId_LONGEST_LTE?: number | null;
  tenantId_LT?: number | null;
  tenantId_LTE?: number | null;
  tenantId_SHORTEST_EQUAL?: number | null;
  tenantId_SHORTEST_GT?: number | null;
  tenantId_SHORTEST_GTE?: number | null;
  tenantId_SHORTEST_LT?: number | null;
  tenantId_SHORTEST_LTE?: number | null;
}

export interface NegotiationRoundWhere {
  AND?: NegotiationRoundWhere[] | null;
  OR?: NegotiationRoundWhere[] | null;
  case?: CaseWhere | null;
  caseAggregate?: NegotiationRoundCaseAggregateInput | null;
  caseConnection?: NegotiationRoundCaseConnectionWhere | null;
  caseConnection_NOT?: NegotiationRoundCaseConnectionWhere | null;
  case_NOT?: CaseWhere | null;
  changedOn?: any | null;
  changedOn_GT?: any | null;
  changedOn_GTE?: any | null;
  changedOn_IN?: (any | null)[] | null;
  changedOn_LT?: any | null;
  changedOn_LTE?: any | null;
  changedOn_NOT?: any | null;
  changedOn_NOT_IN?: (any | null)[] | null;
  data?: string | null;
  data_CONTAINS?: string | null;
  data_ENDS_WITH?: string | null;
  data_IN?: (string | null)[] | null;
  data_MATCHES?: string | null;
  data_NOT?: string | null;
  data_NOT_CONTAINS?: string | null;
  data_NOT_ENDS_WITH?: string | null;
  data_NOT_IN?: (string | null)[] | null;
  data_NOT_STARTS_WITH?: string | null;
  data_STARTS_WITH?: string | null;
  id?: string | null;
  id_CONTAINS?: string | null;
  id_ENDS_WITH?: string | null;
  id_IN?: (string | null)[] | null;
  id_MATCHES?: string | null;
  id_NOT?: string | null;
  id_NOT_CONTAINS?: string | null;
  id_NOT_ENDS_WITH?: string | null;
  id_NOT_IN?: (string | null)[] | null;
  id_NOT_STARTS_WITH?: string | null;
  id_STARTS_WITH?: string | null;
  proposedBy?: OrganizationWhere | null;
  proposedByAggregate?: NegotiationRoundProposedByAggregateInput | null;
  proposedByConnection?: NegotiationRoundProposedByConnectionWhere | null;
  proposedByConnection_NOT?: NegotiationRoundProposedByConnectionWhere | null;
  proposedBy_NOT?: OrganizationWhere | null;
  source?: FlexEntityWhere | null;
  sourceAggregate?: NegotiationRoundSourceAggregateInput | null;
  sourceConnection?: NegotiationRoundSourceConnectionWhere | null;
  sourceConnection_NOT?: NegotiationRoundSourceConnectionWhere | null;
  source_NOT?: FlexEntityWhere | null;
  status?: NegotiationRoundStatus | null;
  status_IN?: (NegotiationRoundStatus | null)[] | null;
  status_NOT?: NegotiationRoundStatus | null;
  status_NOT_IN?: (NegotiationRoundStatus | null)[] | null;
  updatedBy?: UserWhere | null;
  updatedByAggregate?: NegotiationRoundUpdatedByAggregateInput | null;
  updatedByConnection?: NegotiationRoundUpdatedByConnectionWhere | null;
  updatedByConnection_NOT?: NegotiationRoundUpdatedByConnectionWhere | null;
  updatedBy_NOT?: UserWhere | null;
}

export interface NotificationNotificationInstanceAggregateInput {
  AND?: NotificationNotificationInstanceAggregateInput[] | null;
  OR?: NotificationNotificationInstanceAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: NotificationNotificationInstanceNodeAggregationWhereInput | null;
}

export interface NotificationNotificationInstanceConnectionWhere {
  AND?: NotificationNotificationInstanceConnectionWhere[] | null;
  OR?: NotificationNotificationInstanceConnectionWhere[] | null;
  node?: UserNotificationWhere | null;
  node_NOT?: UserNotificationWhere | null;
}

export interface NotificationNotificationInstanceNodeAggregationWhereInput {
  AND?: NotificationNotificationInstanceNodeAggregationWhereInput[] | null;
  OR?: NotificationNotificationInstanceNodeAggregationWhereInput[] | null;
  timeStamp_AVERAGE_EQUAL?: number | null;
  timeStamp_AVERAGE_GT?: number | null;
  timeStamp_AVERAGE_GTE?: number | null;
  timeStamp_AVERAGE_LT?: number | null;
  timeStamp_AVERAGE_LTE?: number | null;
  timeStamp_EQUAL?: number | null;
  timeStamp_GT?: number | null;
  timeStamp_GTE?: number | null;
  timeStamp_LT?: number | null;
  timeStamp_LTE?: number | null;
  timeStamp_MAX_EQUAL?: number | null;
  timeStamp_MAX_GT?: number | null;
  timeStamp_MAX_GTE?: number | null;
  timeStamp_MAX_LT?: number | null;
  timeStamp_MAX_LTE?: number | null;
  timeStamp_MIN_EQUAL?: number | null;
  timeStamp_MIN_GT?: number | null;
  timeStamp_MIN_GTE?: number | null;
  timeStamp_MIN_LT?: number | null;
  timeStamp_MIN_LTE?: number | null;
  timeStamp_SUM_EQUAL?: number | null;
  timeStamp_SUM_GT?: number | null;
  timeStamp_SUM_GTE?: number | null;
  timeStamp_SUM_LT?: number | null;
  timeStamp_SUM_LTE?: number | null;
}

export interface NotificationSubscribedAggregateInput {
  AND?: NotificationSubscribedAggregateInput[] | null;
  OR?: NotificationSubscribedAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: NotificationSubscribedNodeAggregationWhereInput | null;
}

export interface NotificationSubscribedConnectionWhere {
  AND?: NotificationSubscribedConnectionWhere[] | null;
  OR?: NotificationSubscribedConnectionWhere[] | null;
  node?: UserWhere | null;
  node_NOT?: UserWhere | null;
}

export interface NotificationSubscribedNodeAggregationWhereInput {
  AND?: NotificationSubscribedNodeAggregationWhereInput[] | null;
  OR?: NotificationSubscribedNodeAggregationWhereInput[] | null;
  deletedOn_EQUAL?: any | null;
  deletedOn_GT?: any | null;
  deletedOn_GTE?: any | null;
  deletedOn_LT?: any | null;
  deletedOn_LTE?: any | null;
  deletedOn_MAX_EQUAL?: any | null;
  deletedOn_MAX_GT?: any | null;
  deletedOn_MAX_GTE?: any | null;
  deletedOn_MAX_LT?: any | null;
  deletedOn_MAX_LTE?: any | null;
  deletedOn_MIN_EQUAL?: any | null;
  deletedOn_MIN_GT?: any | null;
  deletedOn_MIN_GTE?: any | null;
  deletedOn_MIN_LT?: any | null;
  deletedOn_MIN_LTE?: any | null;
  department_AVERAGE_EQUAL?: number | null;
  department_AVERAGE_GT?: number | null;
  department_AVERAGE_GTE?: number | null;
  department_AVERAGE_LT?: number | null;
  department_AVERAGE_LTE?: number | null;
  department_EQUAL?: string | null;
  department_GT?: number | null;
  department_GTE?: number | null;
  department_LONGEST_EQUAL?: number | null;
  department_LONGEST_GT?: number | null;
  department_LONGEST_GTE?: number | null;
  department_LONGEST_LT?: number | null;
  department_LONGEST_LTE?: number | null;
  department_LT?: number | null;
  department_LTE?: number | null;
  department_SHORTEST_EQUAL?: number | null;
  department_SHORTEST_GT?: number | null;
  department_SHORTEST_GTE?: number | null;
  department_SHORTEST_LT?: number | null;
  department_SHORTEST_LTE?: number | null;
  email_AVERAGE_EQUAL?: number | null;
  email_AVERAGE_GT?: number | null;
  email_AVERAGE_GTE?: number | null;
  email_AVERAGE_LT?: number | null;
  email_AVERAGE_LTE?: number | null;
  email_EQUAL?: string | null;
  email_GT?: number | null;
  email_GTE?: number | null;
  email_LONGEST_EQUAL?: number | null;
  email_LONGEST_GT?: number | null;
  email_LONGEST_GTE?: number | null;
  email_LONGEST_LT?: number | null;
  email_LONGEST_LTE?: number | null;
  email_LT?: number | null;
  email_LTE?: number | null;
  email_SHORTEST_EQUAL?: number | null;
  email_SHORTEST_GT?: number | null;
  email_SHORTEST_GTE?: number | null;
  email_SHORTEST_LT?: number | null;
  email_SHORTEST_LTE?: number | null;
  firstName_AVERAGE_EQUAL?: number | null;
  firstName_AVERAGE_GT?: number | null;
  firstName_AVERAGE_GTE?: number | null;
  firstName_AVERAGE_LT?: number | null;
  firstName_AVERAGE_LTE?: number | null;
  firstName_EQUAL?: string | null;
  firstName_GT?: number | null;
  firstName_GTE?: number | null;
  firstName_LONGEST_EQUAL?: number | null;
  firstName_LONGEST_GT?: number | null;
  firstName_LONGEST_GTE?: number | null;
  firstName_LONGEST_LT?: number | null;
  firstName_LONGEST_LTE?: number | null;
  firstName_LT?: number | null;
  firstName_LTE?: number | null;
  firstName_SHORTEST_EQUAL?: number | null;
  firstName_SHORTEST_GT?: number | null;
  firstName_SHORTEST_GTE?: number | null;
  firstName_SHORTEST_LT?: number | null;
  firstName_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  lastName_AVERAGE_EQUAL?: number | null;
  lastName_AVERAGE_GT?: number | null;
  lastName_AVERAGE_GTE?: number | null;
  lastName_AVERAGE_LT?: number | null;
  lastName_AVERAGE_LTE?: number | null;
  lastName_EQUAL?: string | null;
  lastName_GT?: number | null;
  lastName_GTE?: number | null;
  lastName_LONGEST_EQUAL?: number | null;
  lastName_LONGEST_GT?: number | null;
  lastName_LONGEST_GTE?: number | null;
  lastName_LONGEST_LT?: number | null;
  lastName_LONGEST_LTE?: number | null;
  lastName_LT?: number | null;
  lastName_LTE?: number | null;
  lastName_SHORTEST_EQUAL?: number | null;
  lastName_SHORTEST_GT?: number | null;
  lastName_SHORTEST_GTE?: number | null;
  lastName_SHORTEST_LT?: number | null;
  lastName_SHORTEST_LTE?: number | null;
  position_AVERAGE_EQUAL?: number | null;
  position_AVERAGE_GT?: number | null;
  position_AVERAGE_GTE?: number | null;
  position_AVERAGE_LT?: number | null;
  position_AVERAGE_LTE?: number | null;
  position_EQUAL?: string | null;
  position_GT?: number | null;
  position_GTE?: number | null;
  position_LONGEST_EQUAL?: number | null;
  position_LONGEST_GT?: number | null;
  position_LONGEST_GTE?: number | null;
  position_LONGEST_LT?: number | null;
  position_LONGEST_LTE?: number | null;
  position_LT?: number | null;
  position_LTE?: number | null;
  position_SHORTEST_EQUAL?: number | null;
  position_SHORTEST_GT?: number | null;
  position_SHORTEST_GTE?: number | null;
  position_SHORTEST_LT?: number | null;
  position_SHORTEST_LTE?: number | null;
  preferredLanguage_AVERAGE_EQUAL?: number | null;
  preferredLanguage_AVERAGE_GT?: number | null;
  preferredLanguage_AVERAGE_GTE?: number | null;
  preferredLanguage_AVERAGE_LT?: number | null;
  preferredLanguage_AVERAGE_LTE?: number | null;
  preferredLanguage_EQUAL?: string | null;
  preferredLanguage_GT?: number | null;
  preferredLanguage_GTE?: number | null;
  preferredLanguage_LONGEST_EQUAL?: number | null;
  preferredLanguage_LONGEST_GT?: number | null;
  preferredLanguage_LONGEST_GTE?: number | null;
  preferredLanguage_LONGEST_LT?: number | null;
  preferredLanguage_LONGEST_LTE?: number | null;
  preferredLanguage_LT?: number | null;
  preferredLanguage_LTE?: number | null;
  preferredLanguage_SHORTEST_EQUAL?: number | null;
  preferredLanguage_SHORTEST_GT?: number | null;
  preferredLanguage_SHORTEST_GTE?: number | null;
  preferredLanguage_SHORTEST_LT?: number | null;
  preferredLanguage_SHORTEST_LTE?: number | null;
  tenantId_AVERAGE_EQUAL?: number | null;
  tenantId_AVERAGE_GT?: number | null;
  tenantId_AVERAGE_GTE?: number | null;
  tenantId_AVERAGE_LT?: number | null;
  tenantId_AVERAGE_LTE?: number | null;
  tenantId_EQUAL?: string | null;
  tenantId_GT?: number | null;
  tenantId_GTE?: number | null;
  tenantId_LONGEST_EQUAL?: number | null;
  tenantId_LONGEST_GT?: number | null;
  tenantId_LONGEST_GTE?: number | null;
  tenantId_LONGEST_LT?: number | null;
  tenantId_LONGEST_LTE?: number | null;
  tenantId_LT?: number | null;
  tenantId_LTE?: number | null;
  tenantId_SHORTEST_EQUAL?: number | null;
  tenantId_SHORTEST_GT?: number | null;
  tenantId_SHORTEST_GTE?: number | null;
  tenantId_SHORTEST_LT?: number | null;
  tenantId_SHORTEST_LTE?: number | null;
}

export interface NotificationWhere {
  AND?: NotificationWhere[] | null;
  OR?: NotificationWhere[] | null;
  id?: number | null;
  id_GT?: number | null;
  id_GTE?: number | null;
  id_IN?: (number | null)[] | null;
  id_LT?: number | null;
  id_LTE?: number | null;
  id_NOT?: number | null;
  id_NOT_IN?: (number | null)[] | null;
  name?: string | null;
  name_CONTAINS?: string | null;
  name_ENDS_WITH?: string | null;
  name_IN?: (string | null)[] | null;
  name_MATCHES?: string | null;
  name_NOT?: string | null;
  name_NOT_CONTAINS?: string | null;
  name_NOT_ENDS_WITH?: string | null;
  name_NOT_IN?: (string | null)[] | null;
  name_NOT_STARTS_WITH?: string | null;
  name_STARTS_WITH?: string | null;
  notificationInstance?: UserNotificationWhere | null;
  notificationInstanceAggregate?: NotificationNotificationInstanceAggregateInput | null;
  notificationInstanceConnection?: NotificationNotificationInstanceConnectionWhere | null;
  notificationInstanceConnection_NOT?: NotificationNotificationInstanceConnectionWhere | null;
  notificationInstance_NOT?: UserNotificationWhere | null;
  subscribed?: UserWhere | null;
  subscribedAggregate?: NotificationSubscribedAggregateInput | null;
  subscribedConnection?: NotificationSubscribedConnectionWhere | null;
  subscribedConnection_NOT?: NotificationSubscribedConnectionWhere | null;
  subscribed_NOT?: UserWhere | null;
  type?: NotificationType | null;
  type_IN?: (NotificationType | null)[] | null;
  type_NOT?: NotificationType | null;
  type_NOT_IN?: (NotificationType | null)[] | null;
}

export interface OrgSettingsDataFilterInput {
  id: string;
  tags: string[];
  users: string[];
}

export interface OrganizationAgreementsAggregateInput {
  AND?: OrganizationAgreementsAggregateInput[] | null;
  OR?: OrganizationAgreementsAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: OrganizationAgreementsNodeAggregationWhereInput | null;
}

export interface OrganizationAgreementsConnectionWhere {
  AND?: OrganizationAgreementsConnectionWhere[] | null;
  OR?: OrganizationAgreementsConnectionWhere[] | null;
  node?: AgreementWhere | null;
  node_NOT?: AgreementWhere | null;
}

export interface OrganizationAgreementsNodeAggregationWhereInput {
  AND?: OrganizationAgreementsNodeAggregationWhereInput[] | null;
  OR?: OrganizationAgreementsNodeAggregationWhereInput[] | null;
  description_AVERAGE_EQUAL?: number | null;
  description_AVERAGE_GT?: number | null;
  description_AVERAGE_GTE?: number | null;
  description_AVERAGE_LT?: number | null;
  description_AVERAGE_LTE?: number | null;
  description_EQUAL?: string | null;
  description_GT?: number | null;
  description_GTE?: number | null;
  description_LONGEST_EQUAL?: number | null;
  description_LONGEST_GT?: number | null;
  description_LONGEST_GTE?: number | null;
  description_LONGEST_LT?: number | null;
  description_LONGEST_LTE?: number | null;
  description_LT?: number | null;
  description_LTE?: number | null;
  description_SHORTEST_EQUAL?: number | null;
  description_SHORTEST_GT?: number | null;
  description_SHORTEST_GTE?: number | null;
  description_SHORTEST_LT?: number | null;
  description_SHORTEST_LTE?: number | null;
  formattedAmount_AVERAGE_EQUAL?: number | null;
  formattedAmount_AVERAGE_GT?: number | null;
  formattedAmount_AVERAGE_GTE?: number | null;
  formattedAmount_AVERAGE_LT?: number | null;
  formattedAmount_AVERAGE_LTE?: number | null;
  formattedAmount_EQUAL?: string | null;
  formattedAmount_GT?: number | null;
  formattedAmount_GTE?: number | null;
  formattedAmount_LONGEST_EQUAL?: number | null;
  formattedAmount_LONGEST_GT?: number | null;
  formattedAmount_LONGEST_GTE?: number | null;
  formattedAmount_LONGEST_LT?: number | null;
  formattedAmount_LONGEST_LTE?: number | null;
  formattedAmount_LT?: number | null;
  formattedAmount_LTE?: number | null;
  formattedAmount_SHORTEST_EQUAL?: number | null;
  formattedAmount_SHORTEST_GT?: number | null;
  formattedAmount_SHORTEST_GTE?: number | null;
  formattedAmount_SHORTEST_LT?: number | null;
  formattedAmount_SHORTEST_LTE?: number | null;
  formattedCounterparties_AVERAGE_EQUAL?: number | null;
  formattedCounterparties_AVERAGE_GT?: number | null;
  formattedCounterparties_AVERAGE_GTE?: number | null;
  formattedCounterparties_AVERAGE_LT?: number | null;
  formattedCounterparties_AVERAGE_LTE?: number | null;
  formattedCounterparties_EQUAL?: string | null;
  formattedCounterparties_GT?: number | null;
  formattedCounterparties_GTE?: number | null;
  formattedCounterparties_LONGEST_EQUAL?: number | null;
  formattedCounterparties_LONGEST_GT?: number | null;
  formattedCounterparties_LONGEST_GTE?: number | null;
  formattedCounterparties_LONGEST_LT?: number | null;
  formattedCounterparties_LONGEST_LTE?: number | null;
  formattedCounterparties_LT?: number | null;
  formattedCounterparties_LTE?: number | null;
  formattedCounterparties_SHORTEST_EQUAL?: number | null;
  formattedCounterparties_SHORTEST_GT?: number | null;
  formattedCounterparties_SHORTEST_GTE?: number | null;
  formattedCounterparties_SHORTEST_LT?: number | null;
  formattedCounterparties_SHORTEST_LTE?: number | null;
  formattedDiseases_AVERAGE_EQUAL?: number | null;
  formattedDiseases_AVERAGE_GT?: number | null;
  formattedDiseases_AVERAGE_GTE?: number | null;
  formattedDiseases_AVERAGE_LT?: number | null;
  formattedDiseases_AVERAGE_LTE?: number | null;
  formattedDiseases_EQUAL?: string | null;
  formattedDiseases_GT?: number | null;
  formattedDiseases_GTE?: number | null;
  formattedDiseases_LONGEST_EQUAL?: number | null;
  formattedDiseases_LONGEST_GT?: number | null;
  formattedDiseases_LONGEST_GTE?: number | null;
  formattedDiseases_LONGEST_LT?: number | null;
  formattedDiseases_LONGEST_LTE?: number | null;
  formattedDiseases_LT?: number | null;
  formattedDiseases_LTE?: number | null;
  formattedDiseases_SHORTEST_EQUAL?: number | null;
  formattedDiseases_SHORTEST_GT?: number | null;
  formattedDiseases_SHORTEST_GTE?: number | null;
  formattedDiseases_SHORTEST_LT?: number | null;
  formattedDiseases_SHORTEST_LTE?: number | null;
  formattedIndications_AVERAGE_EQUAL?: number | null;
  formattedIndications_AVERAGE_GT?: number | null;
  formattedIndications_AVERAGE_GTE?: number | null;
  formattedIndications_AVERAGE_LT?: number | null;
  formattedIndications_AVERAGE_LTE?: number | null;
  formattedIndications_EQUAL?: string | null;
  formattedIndications_GT?: number | null;
  formattedIndications_GTE?: number | null;
  formattedIndications_LONGEST_EQUAL?: number | null;
  formattedIndications_LONGEST_GT?: number | null;
  formattedIndications_LONGEST_GTE?: number | null;
  formattedIndications_LONGEST_LT?: number | null;
  formattedIndications_LONGEST_LTE?: number | null;
  formattedIndications_LT?: number | null;
  formattedIndications_LTE?: number | null;
  formattedIndications_SHORTEST_EQUAL?: number | null;
  formattedIndications_SHORTEST_GT?: number | null;
  formattedIndications_SHORTEST_GTE?: number | null;
  formattedIndications_SHORTEST_LT?: number | null;
  formattedIndications_SHORTEST_LTE?: number | null;
  formattedProducts_AVERAGE_EQUAL?: number | null;
  formattedProducts_AVERAGE_GT?: number | null;
  formattedProducts_AVERAGE_GTE?: number | null;
  formattedProducts_AVERAGE_LT?: number | null;
  formattedProducts_AVERAGE_LTE?: number | null;
  formattedProducts_EQUAL?: string | null;
  formattedProducts_GT?: number | null;
  formattedProducts_GTE?: number | null;
  formattedProducts_LONGEST_EQUAL?: number | null;
  formattedProducts_LONGEST_GT?: number | null;
  formattedProducts_LONGEST_GTE?: number | null;
  formattedProducts_LONGEST_LT?: number | null;
  formattedProducts_LONGEST_LTE?: number | null;
  formattedProducts_LT?: number | null;
  formattedProducts_LTE?: number | null;
  formattedProducts_SHORTEST_EQUAL?: number | null;
  formattedProducts_SHORTEST_GT?: number | null;
  formattedProducts_SHORTEST_GTE?: number | null;
  formattedProducts_SHORTEST_LT?: number | null;
  formattedProducts_SHORTEST_LTE?: number | null;
  formattedTags_AVERAGE_EQUAL?: number | null;
  formattedTags_AVERAGE_GT?: number | null;
  formattedTags_AVERAGE_GTE?: number | null;
  formattedTags_AVERAGE_LT?: number | null;
  formattedTags_AVERAGE_LTE?: number | null;
  formattedTags_EQUAL?: string | null;
  formattedTags_GT?: number | null;
  formattedTags_GTE?: number | null;
  formattedTags_LONGEST_EQUAL?: number | null;
  formattedTags_LONGEST_GT?: number | null;
  formattedTags_LONGEST_GTE?: number | null;
  formattedTags_LONGEST_LT?: number | null;
  formattedTags_LONGEST_LTE?: number | null;
  formattedTags_LT?: number | null;
  formattedTags_LTE?: number | null;
  formattedTags_SHORTEST_EQUAL?: number | null;
  formattedTags_SHORTEST_GT?: number | null;
  formattedTags_SHORTEST_GTE?: number | null;
  formattedTags_SHORTEST_LT?: number | null;
  formattedTags_SHORTEST_LTE?: number | null;
  formattedValidityPeriod_AVERAGE_EQUAL?: number | null;
  formattedValidityPeriod_AVERAGE_GT?: number | null;
  formattedValidityPeriod_AVERAGE_GTE?: number | null;
  formattedValidityPeriod_AVERAGE_LT?: number | null;
  formattedValidityPeriod_AVERAGE_LTE?: number | null;
  formattedValidityPeriod_EQUAL?: string | null;
  formattedValidityPeriod_GT?: number | null;
  formattedValidityPeriod_GTE?: number | null;
  formattedValidityPeriod_LONGEST_EQUAL?: number | null;
  formattedValidityPeriod_LONGEST_GT?: number | null;
  formattedValidityPeriod_LONGEST_GTE?: number | null;
  formattedValidityPeriod_LONGEST_LT?: number | null;
  formattedValidityPeriod_LONGEST_LTE?: number | null;
  formattedValidityPeriod_LT?: number | null;
  formattedValidityPeriod_LTE?: number | null;
  formattedValidityPeriod_SHORTEST_EQUAL?: number | null;
  formattedValidityPeriod_SHORTEST_GT?: number | null;
  formattedValidityPeriod_SHORTEST_GTE?: number | null;
  formattedValidityPeriod_SHORTEST_LT?: number | null;
  formattedValidityPeriod_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  initialVersionId_AVERAGE_EQUAL?: number | null;
  initialVersionId_AVERAGE_GT?: number | null;
  initialVersionId_AVERAGE_GTE?: number | null;
  initialVersionId_AVERAGE_LT?: number | null;
  initialVersionId_AVERAGE_LTE?: number | null;
  initialVersionId_EQUAL?: string | null;
  initialVersionId_GT?: number | null;
  initialVersionId_GTE?: number | null;
  initialVersionId_LONGEST_EQUAL?: number | null;
  initialVersionId_LONGEST_GT?: number | null;
  initialVersionId_LONGEST_GTE?: number | null;
  initialVersionId_LONGEST_LT?: number | null;
  initialVersionId_LONGEST_LTE?: number | null;
  initialVersionId_LT?: number | null;
  initialVersionId_LTE?: number | null;
  initialVersionId_SHORTEST_EQUAL?: number | null;
  initialVersionId_SHORTEST_GT?: number | null;
  initialVersionId_SHORTEST_GTE?: number | null;
  initialVersionId_SHORTEST_LT?: number | null;
  initialVersionId_SHORTEST_LTE?: number | null;
  name_AVERAGE_EQUAL?: number | null;
  name_AVERAGE_GT?: number | null;
  name_AVERAGE_GTE?: number | null;
  name_AVERAGE_LT?: number | null;
  name_AVERAGE_LTE?: number | null;
  name_EQUAL?: string | null;
  name_GT?: number | null;
  name_GTE?: number | null;
  name_LONGEST_EQUAL?: number | null;
  name_LONGEST_GT?: number | null;
  name_LONGEST_GTE?: number | null;
  name_LONGEST_LT?: number | null;
  name_LONGEST_LTE?: number | null;
  name_LT?: number | null;
  name_LTE?: number | null;
  name_SHORTEST_EQUAL?: number | null;
  name_SHORTEST_GT?: number | null;
  name_SHORTEST_GTE?: number | null;
  name_SHORTEST_LT?: number | null;
  name_SHORTEST_LTE?: number | null;
  searchTerm_AVERAGE_EQUAL?: number | null;
  searchTerm_AVERAGE_GT?: number | null;
  searchTerm_AVERAGE_GTE?: number | null;
  searchTerm_AVERAGE_LT?: number | null;
  searchTerm_AVERAGE_LTE?: number | null;
  searchTerm_EQUAL?: string | null;
  searchTerm_GT?: number | null;
  searchTerm_GTE?: number | null;
  searchTerm_LONGEST_EQUAL?: number | null;
  searchTerm_LONGEST_GT?: number | null;
  searchTerm_LONGEST_GTE?: number | null;
  searchTerm_LONGEST_LT?: number | null;
  searchTerm_LONGEST_LTE?: number | null;
  searchTerm_LT?: number | null;
  searchTerm_LTE?: number | null;
  searchTerm_SHORTEST_EQUAL?: number | null;
  searchTerm_SHORTEST_GT?: number | null;
  searchTerm_SHORTEST_GTE?: number | null;
  searchTerm_SHORTEST_LT?: number | null;
  searchTerm_SHORTEST_LTE?: number | null;
  totalAmount_AVERAGE_EQUAL?: number | null;
  totalAmount_AVERAGE_GT?: number | null;
  totalAmount_AVERAGE_GTE?: number | null;
  totalAmount_AVERAGE_LT?: number | null;
  totalAmount_AVERAGE_LTE?: number | null;
  totalAmount_EQUAL?: number | null;
  totalAmount_GT?: number | null;
  totalAmount_GTE?: number | null;
  totalAmount_LT?: number | null;
  totalAmount_LTE?: number | null;
  totalAmount_MAX_EQUAL?: number | null;
  totalAmount_MAX_GT?: number | null;
  totalAmount_MAX_GTE?: number | null;
  totalAmount_MAX_LT?: number | null;
  totalAmount_MAX_LTE?: number | null;
  totalAmount_MIN_EQUAL?: number | null;
  totalAmount_MIN_GT?: number | null;
  totalAmount_MIN_GTE?: number | null;
  totalAmount_MIN_LT?: number | null;
  totalAmount_MIN_LTE?: number | null;
  totalAmount_SUM_EQUAL?: number | null;
  totalAmount_SUM_GT?: number | null;
  totalAmount_SUM_GTE?: number | null;
  totalAmount_SUM_LT?: number | null;
  totalAmount_SUM_LTE?: number | null;
  unlimited_AVERAGE_EQUAL?: number | null;
  unlimited_AVERAGE_GT?: number | null;
  unlimited_AVERAGE_GTE?: number | null;
  unlimited_AVERAGE_LT?: number | null;
  unlimited_AVERAGE_LTE?: number | null;
  unlimited_EQUAL?: number | null;
  unlimited_GT?: number | null;
  unlimited_GTE?: number | null;
  unlimited_LT?: number | null;
  unlimited_LTE?: number | null;
  unlimited_MAX_EQUAL?: number | null;
  unlimited_MAX_GT?: number | null;
  unlimited_MAX_GTE?: number | null;
  unlimited_MAX_LT?: number | null;
  unlimited_MAX_LTE?: number | null;
  unlimited_MIN_EQUAL?: number | null;
  unlimited_MIN_GT?: number | null;
  unlimited_MIN_GTE?: number | null;
  unlimited_MIN_LT?: number | null;
  unlimited_MIN_LTE?: number | null;
  unlimited_SUM_EQUAL?: number | null;
  unlimited_SUM_GT?: number | null;
  unlimited_SUM_GTE?: number | null;
  unlimited_SUM_LT?: number | null;
  unlimited_SUM_LTE?: number | null;
  version_AVERAGE_EQUAL?: number | null;
  version_AVERAGE_GT?: number | null;
  version_AVERAGE_GTE?: number | null;
  version_AVERAGE_LT?: number | null;
  version_AVERAGE_LTE?: number | null;
  version_EQUAL?: number | null;
  version_GT?: number | null;
  version_GTE?: number | null;
  version_LT?: number | null;
  version_LTE?: number | null;
  version_MAX_EQUAL?: number | null;
  version_MAX_GT?: number | null;
  version_MAX_GTE?: number | null;
  version_MAX_LT?: number | null;
  version_MAX_LTE?: number | null;
  version_MIN_EQUAL?: number | null;
  version_MIN_GT?: number | null;
  version_MIN_GTE?: number | null;
  version_MIN_LT?: number | null;
  version_MIN_LTE?: number | null;
  version_SUM_EQUAL?: number | null;
  version_SUM_GT?: number | null;
  version_SUM_GTE?: number | null;
  version_SUM_LT?: number | null;
  version_SUM_LTE?: number | null;
}

export interface OrganizationEncapsulatedFeaturesAggregateInput {
  AND?: OrganizationEncapsulatedFeaturesAggregateInput[] | null;
  OR?: OrganizationEncapsulatedFeaturesAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
}

export interface OrganizationEncapsulatedFeaturesConnectionWhere {
  AND?: OrganizationEncapsulatedFeaturesConnectionWhere[] | null;
  OR?: OrganizationEncapsulatedFeaturesConnectionWhere[] | null;
  node?: EncapsulatedFeatureConfigurationWhere | null;
  node_NOT?: EncapsulatedFeatureConfigurationWhere | null;
}

export interface OrganizationFlexEntityTypeMappingsAggregateInput {
  AND?: OrganizationFlexEntityTypeMappingsAggregateInput[] | null;
  OR?: OrganizationFlexEntityTypeMappingsAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  edge?: OrganizationFlexEntityTypeMappingsEdgeAggregationWhereInput | null;
  node?: OrganizationFlexEntityTypeMappingsNodeAggregationWhereInput | null;
}

export interface OrganizationFlexEntityTypeMappingsConnectionWhere {
  AND?: OrganizationFlexEntityTypeMappingsConnectionWhere[] | null;
  OR?: OrganizationFlexEntityTypeMappingsConnectionWhere[] | null;
  edge?: EntityTypeMappingRelationshipWhere | null;
  edge_NOT?: EntityTypeMappingRelationshipWhere | null;
  node?: FlexEntityTypeWhere | null;
  node_NOT?: FlexEntityTypeWhere | null;
}

export interface OrganizationFlexEntityTypeMappingsEdgeAggregationWhereInput {
  AND?: OrganizationFlexEntityTypeMappingsEdgeAggregationWhereInput[] | null;
  OR?: OrganizationFlexEntityTypeMappingsEdgeAggregationWhereInput[] | null;
  data_AVERAGE_EQUAL?: number | null;
  data_AVERAGE_GT?: number | null;
  data_AVERAGE_GTE?: number | null;
  data_AVERAGE_LT?: number | null;
  data_AVERAGE_LTE?: number | null;
  data_EQUAL?: string | null;
  data_GT?: number | null;
  data_GTE?: number | null;
  data_LONGEST_EQUAL?: number | null;
  data_LONGEST_GT?: number | null;
  data_LONGEST_GTE?: number | null;
  data_LONGEST_LT?: number | null;
  data_LONGEST_LTE?: number | null;
  data_LT?: number | null;
  data_LTE?: number | null;
  data_SHORTEST_EQUAL?: number | null;
  data_SHORTEST_GT?: number | null;
  data_SHORTEST_GTE?: number | null;
  data_SHORTEST_LT?: number | null;
  data_SHORTEST_LTE?: number | null;
}

export interface OrganizationFlexEntityTypeMappingsNodeAggregationWhereInput {
  AND?: OrganizationFlexEntityTypeMappingsNodeAggregationWhereInput[] | null;
  OR?: OrganizationFlexEntityTypeMappingsNodeAggregationWhereInput[] | null;
  addedByName_AVERAGE_EQUAL?: number | null;
  addedByName_AVERAGE_GT?: number | null;
  addedByName_AVERAGE_GTE?: number | null;
  addedByName_AVERAGE_LT?: number | null;
  addedByName_AVERAGE_LTE?: number | null;
  addedByName_EQUAL?: string | null;
  addedByName_GT?: number | null;
  addedByName_GTE?: number | null;
  addedByName_LONGEST_EQUAL?: number | null;
  addedByName_LONGEST_GT?: number | null;
  addedByName_LONGEST_GTE?: number | null;
  addedByName_LONGEST_LT?: number | null;
  addedByName_LONGEST_LTE?: number | null;
  addedByName_LT?: number | null;
  addedByName_LTE?: number | null;
  addedByName_SHORTEST_EQUAL?: number | null;
  addedByName_SHORTEST_GT?: number | null;
  addedByName_SHORTEST_GTE?: number | null;
  addedByName_SHORTEST_LT?: number | null;
  addedByName_SHORTEST_LTE?: number | null;
  attributeCount_AVERAGE_EQUAL?: number | null;
  attributeCount_AVERAGE_GT?: number | null;
  attributeCount_AVERAGE_GTE?: number | null;
  attributeCount_AVERAGE_LT?: number | null;
  attributeCount_AVERAGE_LTE?: number | null;
  attributeCount_EQUAL?: number | null;
  attributeCount_GT?: number | null;
  attributeCount_GTE?: number | null;
  attributeCount_LT?: number | null;
  attributeCount_LTE?: number | null;
  attributeCount_MAX_EQUAL?: number | null;
  attributeCount_MAX_GT?: number | null;
  attributeCount_MAX_GTE?: number | null;
  attributeCount_MAX_LT?: number | null;
  attributeCount_MAX_LTE?: number | null;
  attributeCount_MIN_EQUAL?: number | null;
  attributeCount_MIN_GT?: number | null;
  attributeCount_MIN_GTE?: number | null;
  attributeCount_MIN_LT?: number | null;
  attributeCount_MIN_LTE?: number | null;
  attributeCount_SUM_EQUAL?: number | null;
  attributeCount_SUM_GT?: number | null;
  attributeCount_SUM_GTE?: number | null;
  attributeCount_SUM_LT?: number | null;
  attributeCount_SUM_LTE?: number | null;
  createdOn_EQUAL?: any | null;
  createdOn_GT?: any | null;
  createdOn_GTE?: any | null;
  createdOn_LT?: any | null;
  createdOn_LTE?: any | null;
  createdOn_MAX_EQUAL?: any | null;
  createdOn_MAX_GT?: any | null;
  createdOn_MAX_GTE?: any | null;
  createdOn_MAX_LT?: any | null;
  createdOn_MAX_LTE?: any | null;
  createdOn_MIN_EQUAL?: any | null;
  createdOn_MIN_GT?: any | null;
  createdOn_MIN_GTE?: any | null;
  createdOn_MIN_LT?: any | null;
  createdOn_MIN_LTE?: any | null;
  data_AVERAGE_EQUAL?: number | null;
  data_AVERAGE_GT?: number | null;
  data_AVERAGE_GTE?: number | null;
  data_AVERAGE_LT?: number | null;
  data_AVERAGE_LTE?: number | null;
  data_EQUAL?: string | null;
  data_GT?: number | null;
  data_GTE?: number | null;
  data_LONGEST_EQUAL?: number | null;
  data_LONGEST_GT?: number | null;
  data_LONGEST_GTE?: number | null;
  data_LONGEST_LT?: number | null;
  data_LONGEST_LTE?: number | null;
  data_LT?: number | null;
  data_LTE?: number | null;
  data_SHORTEST_EQUAL?: number | null;
  data_SHORTEST_GT?: number | null;
  data_SHORTEST_GTE?: number | null;
  data_SHORTEST_LT?: number | null;
  data_SHORTEST_LTE?: number | null;
  description_AVERAGE_EQUAL?: number | null;
  description_AVERAGE_GT?: number | null;
  description_AVERAGE_GTE?: number | null;
  description_AVERAGE_LT?: number | null;
  description_AVERAGE_LTE?: number | null;
  description_EQUAL?: string | null;
  description_GT?: number | null;
  description_GTE?: number | null;
  description_LONGEST_EQUAL?: number | null;
  description_LONGEST_GT?: number | null;
  description_LONGEST_GTE?: number | null;
  description_LONGEST_LT?: number | null;
  description_LONGEST_LTE?: number | null;
  description_LT?: number | null;
  description_LTE?: number | null;
  description_SHORTEST_EQUAL?: number | null;
  description_SHORTEST_GT?: number | null;
  description_SHORTEST_GTE?: number | null;
  description_SHORTEST_LT?: number | null;
  description_SHORTEST_LTE?: number | null;
  idPrefix_AVERAGE_EQUAL?: number | null;
  idPrefix_AVERAGE_GT?: number | null;
  idPrefix_AVERAGE_GTE?: number | null;
  idPrefix_AVERAGE_LT?: number | null;
  idPrefix_AVERAGE_LTE?: number | null;
  idPrefix_EQUAL?: string | null;
  idPrefix_GT?: number | null;
  idPrefix_GTE?: number | null;
  idPrefix_LONGEST_EQUAL?: number | null;
  idPrefix_LONGEST_GT?: number | null;
  idPrefix_LONGEST_GTE?: number | null;
  idPrefix_LONGEST_LT?: number | null;
  idPrefix_LONGEST_LTE?: number | null;
  idPrefix_LT?: number | null;
  idPrefix_LTE?: number | null;
  idPrefix_SHORTEST_EQUAL?: number | null;
  idPrefix_SHORTEST_GT?: number | null;
  idPrefix_SHORTEST_GTE?: number | null;
  idPrefix_SHORTEST_LT?: number | null;
  idPrefix_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  localizationKey_AVERAGE_EQUAL?: number | null;
  localizationKey_AVERAGE_GT?: number | null;
  localizationKey_AVERAGE_GTE?: number | null;
  localizationKey_AVERAGE_LT?: number | null;
  localizationKey_AVERAGE_LTE?: number | null;
  localizationKey_EQUAL?: string | null;
  localizationKey_GT?: number | null;
  localizationKey_GTE?: number | null;
  localizationKey_LONGEST_EQUAL?: number | null;
  localizationKey_LONGEST_GT?: number | null;
  localizationKey_LONGEST_GTE?: number | null;
  localizationKey_LONGEST_LT?: number | null;
  localizationKey_LONGEST_LTE?: number | null;
  localizationKey_LT?: number | null;
  localizationKey_LTE?: number | null;
  localizationKey_SHORTEST_EQUAL?: number | null;
  localizationKey_SHORTEST_GT?: number | null;
  localizationKey_SHORTEST_GTE?: number | null;
  localizationKey_SHORTEST_LT?: number | null;
  localizationKey_SHORTEST_LTE?: number | null;
  name_AVERAGE_EQUAL?: number | null;
  name_AVERAGE_GT?: number | null;
  name_AVERAGE_GTE?: number | null;
  name_AVERAGE_LT?: number | null;
  name_AVERAGE_LTE?: number | null;
  name_EQUAL?: string | null;
  name_GT?: number | null;
  name_GTE?: number | null;
  name_LONGEST_EQUAL?: number | null;
  name_LONGEST_GT?: number | null;
  name_LONGEST_GTE?: number | null;
  name_LONGEST_LT?: number | null;
  name_LONGEST_LTE?: number | null;
  name_LT?: number | null;
  name_LTE?: number | null;
  name_SHORTEST_EQUAL?: number | null;
  name_SHORTEST_GT?: number | null;
  name_SHORTEST_GTE?: number | null;
  name_SHORTEST_LT?: number | null;
  name_SHORTEST_LTE?: number | null;
  tooltipText_AVERAGE_EQUAL?: number | null;
  tooltipText_AVERAGE_GT?: number | null;
  tooltipText_AVERAGE_GTE?: number | null;
  tooltipText_AVERAGE_LT?: number | null;
  tooltipText_AVERAGE_LTE?: number | null;
  tooltipText_EQUAL?: string | null;
  tooltipText_GT?: number | null;
  tooltipText_GTE?: number | null;
  tooltipText_LONGEST_EQUAL?: number | null;
  tooltipText_LONGEST_GT?: number | null;
  tooltipText_LONGEST_GTE?: number | null;
  tooltipText_LONGEST_LT?: number | null;
  tooltipText_LONGEST_LTE?: number | null;
  tooltipText_LT?: number | null;
  tooltipText_LTE?: number | null;
  tooltipText_SHORTEST_EQUAL?: number | null;
  tooltipText_SHORTEST_GT?: number | null;
  tooltipText_SHORTEST_GTE?: number | null;
  tooltipText_SHORTEST_LT?: number | null;
  tooltipText_SHORTEST_LTE?: number | null;
}

export interface OrganizationQuestNotificationsAggregateInput {
  AND?: OrganizationQuestNotificationsAggregateInput[] | null;
  OR?: OrganizationQuestNotificationsAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  edge?: OrganizationQuestNotificationsEdgeAggregationWhereInput | null;
  node?: OrganizationQuestNotificationsNodeAggregationWhereInput | null;
}

export interface OrganizationQuestNotificationsConnectionWhere {
  AND?: OrganizationQuestNotificationsConnectionWhere[] | null;
  OR?: OrganizationQuestNotificationsConnectionWhere[] | null;
  edge?: OrganizationQuestRelationshipWhere | null;
  edge_NOT?: OrganizationQuestRelationshipWhere | null;
  node?: QuestNotificationWhere | null;
  node_NOT?: QuestNotificationWhere | null;
}

export interface OrganizationQuestNotificationsEdgeAggregationWhereInput {
  AND?: OrganizationQuestNotificationsEdgeAggregationWhereInput[] | null;
  OR?: OrganizationQuestNotificationsEdgeAggregationWhereInput[] | null;
  threshold_AVERAGE_EQUAL?: number | null;
  threshold_AVERAGE_GT?: number | null;
  threshold_AVERAGE_GTE?: number | null;
  threshold_AVERAGE_LT?: number | null;
  threshold_AVERAGE_LTE?: number | null;
  threshold_EQUAL?: number | null;
  threshold_GT?: number | null;
  threshold_GTE?: number | null;
  threshold_LT?: number | null;
  threshold_LTE?: number | null;
  threshold_MAX_EQUAL?: number | null;
  threshold_MAX_GT?: number | null;
  threshold_MAX_GTE?: number | null;
  threshold_MAX_LT?: number | null;
  threshold_MAX_LTE?: number | null;
  threshold_MIN_EQUAL?: number | null;
  threshold_MIN_GT?: number | null;
  threshold_MIN_GTE?: number | null;
  threshold_MIN_LT?: number | null;
  threshold_MIN_LTE?: number | null;
  threshold_SUM_EQUAL?: number | null;
  threshold_SUM_GT?: number | null;
  threshold_SUM_GTE?: number | null;
  threshold_SUM_LT?: number | null;
  threshold_SUM_LTE?: number | null;
}

export interface OrganizationQuestNotificationsNodeAggregationWhereInput {
  AND?: OrganizationQuestNotificationsNodeAggregationWhereInput[] | null;
  OR?: OrganizationQuestNotificationsNodeAggregationWhereInput[] | null;
  id_AVERAGE_EQUAL?: number | null;
  id_AVERAGE_GT?: number | null;
  id_AVERAGE_GTE?: number | null;
  id_AVERAGE_LT?: number | null;
  id_AVERAGE_LTE?: number | null;
  id_EQUAL?: number | null;
  id_GT?: number | null;
  id_GTE?: number | null;
  id_LT?: number | null;
  id_LTE?: number | null;
  id_MAX_EQUAL?: number | null;
  id_MAX_GT?: number | null;
  id_MAX_GTE?: number | null;
  id_MAX_LT?: number | null;
  id_MAX_LTE?: number | null;
  id_MIN_EQUAL?: number | null;
  id_MIN_GT?: number | null;
  id_MIN_GTE?: number | null;
  id_MIN_LT?: number | null;
  id_MIN_LTE?: number | null;
  id_SUM_EQUAL?: number | null;
  id_SUM_GT?: number | null;
  id_SUM_GTE?: number | null;
  id_SUM_LT?: number | null;
  id_SUM_LTE?: number | null;
  name_AVERAGE_EQUAL?: number | null;
  name_AVERAGE_GT?: number | null;
  name_AVERAGE_GTE?: number | null;
  name_AVERAGE_LT?: number | null;
  name_AVERAGE_LTE?: number | null;
  name_EQUAL?: string | null;
  name_GT?: number | null;
  name_GTE?: number | null;
  name_LONGEST_EQUAL?: number | null;
  name_LONGEST_GT?: number | null;
  name_LONGEST_GTE?: number | null;
  name_LONGEST_LT?: number | null;
  name_LONGEST_LTE?: number | null;
  name_LT?: number | null;
  name_LTE?: number | null;
  name_SHORTEST_EQUAL?: number | null;
  name_SHORTEST_GT?: number | null;
  name_SHORTEST_GTE?: number | null;
  name_SHORTEST_LT?: number | null;
  name_SHORTEST_LTE?: number | null;
}

export interface OrganizationQuestRelationshipWhere {
  AND?: OrganizationQuestRelationshipWhere[] | null;
  OR?: OrganizationQuestRelationshipWhere[] | null;
  active?: boolean | null;
  active_NOT?: boolean | null;
  amountType?: AmountsType | null;
  amountType_IN?: (AmountsType | null)[] | null;
  amountType_NOT?: AmountsType | null;
  amountType_NOT_IN?: (AmountsType | null)[] | null;
  threshold?: number | null;
  threshold_GT?: number | null;
  threshold_GTE?: number | null;
  threshold_IN?: (number | null)[] | null;
  threshold_LT?: number | null;
  threshold_LTE?: number | null;
  threshold_NOT?: number | null;
  threshold_NOT_IN?: (number | null)[] | null;
}

export interface OrganizationScopeRelationshipWhere {
  AND?: OrganizationScopeRelationshipWhere[] | null;
  OR?: OrganizationScopeRelationshipWhere[] | null;
  organizationScopeId?: string | null;
  organizationScopeId_CONTAINS?: string | null;
  organizationScopeId_ENDS_WITH?: string | null;
  organizationScopeId_IN?: (string | null)[] | null;
  organizationScopeId_MATCHES?: string | null;
  organizationScopeId_NOT?: string | null;
  organizationScopeId_NOT_CONTAINS?: string | null;
  organizationScopeId_NOT_ENDS_WITH?: string | null;
  organizationScopeId_NOT_IN?: (string | null)[] | null;
  organizationScopeId_NOT_STARTS_WITH?: string | null;
  organizationScopeId_STARTS_WITH?: string | null;
}

export interface OrganizationWhere {
  AND?: OrganizationWhere[] | null;
  BIC?: string | null;
  BIC_CONTAINS?: string | null;
  BIC_ENDS_WITH?: string | null;
  BIC_IN?: (string | null)[] | null;
  BIC_MATCHES?: string | null;
  BIC_NOT?: string | null;
  BIC_NOT_CONTAINS?: string | null;
  BIC_NOT_ENDS_WITH?: string | null;
  BIC_NOT_IN?: (string | null)[] | null;
  BIC_NOT_STARTS_WITH?: string | null;
  BIC_STARTS_WITH?: string | null;
  IBAN?: string | null;
  IBAN_CONTAINS?: string | null;
  IBAN_ENDS_WITH?: string | null;
  IBAN_IN?: (string | null)[] | null;
  IBAN_MATCHES?: string | null;
  IBAN_NOT?: string | null;
  IBAN_NOT_CONTAINS?: string | null;
  IBAN_NOT_ENDS_WITH?: string | null;
  IBAN_NOT_IN?: (string | null)[] | null;
  IBAN_NOT_STARTS_WITH?: string | null;
  IBAN_STARTS_WITH?: string | null;
  OR?: OrganizationWhere[] | null;
  accountName?: string | null;
  accountName_CONTAINS?: string | null;
  accountName_ENDS_WITH?: string | null;
  accountName_IN?: (string | null)[] | null;
  accountName_MATCHES?: string | null;
  accountName_NOT?: string | null;
  accountName_NOT_CONTAINS?: string | null;
  accountName_NOT_ENDS_WITH?: string | null;
  accountName_NOT_IN?: (string | null)[] | null;
  accountName_NOT_STARTS_WITH?: string | null;
  accountName_STARTS_WITH?: string | null;
  accountNumber?: string | null;
  accountNumber_CONTAINS?: string | null;
  accountNumber_ENDS_WITH?: string | null;
  accountNumber_IN?: (string | null)[] | null;
  accountNumber_MATCHES?: string | null;
  accountNumber_NOT?: string | null;
  accountNumber_NOT_CONTAINS?: string | null;
  accountNumber_NOT_ENDS_WITH?: string | null;
  accountNumber_NOT_IN?: (string | null)[] | null;
  accountNumber_NOT_STARTS_WITH?: string | null;
  accountNumber_STARTS_WITH?: string | null;
  agreements?: AgreementWhere | null;
  agreementsAggregate?: OrganizationAgreementsAggregateInput | null;
  agreementsConnection?: OrganizationAgreementsConnectionWhere | null;
  agreementsConnection_NOT?: OrganizationAgreementsConnectionWhere | null;
  agreements_NOT?: AgreementWhere | null;
  billingAddress?: string | null;
  billingAddress_CONTAINS?: string | null;
  billingAddress_ENDS_WITH?: string | null;
  billingAddress_IN?: (string | null)[] | null;
  billingAddress_MATCHES?: string | null;
  billingAddress_NOT?: string | null;
  billingAddress_NOT_CONTAINS?: string | null;
  billingAddress_NOT_ENDS_WITH?: string | null;
  billingAddress_NOT_IN?: (string | null)[] | null;
  billingAddress_NOT_STARTS_WITH?: string | null;
  billingAddress_STARTS_WITH?: string | null;
  contactEmail?: string | null;
  contactEmail_CONTAINS?: string | null;
  contactEmail_ENDS_WITH?: string | null;
  contactEmail_IN?: (string | null)[] | null;
  contactEmail_MATCHES?: string | null;
  contactEmail_NOT?: string | null;
  contactEmail_NOT_CONTAINS?: string | null;
  contactEmail_NOT_ENDS_WITH?: string | null;
  contactEmail_NOT_IN?: (string | null)[] | null;
  contactEmail_NOT_STARTS_WITH?: string | null;
  contactEmail_STARTS_WITH?: string | null;
  contactFirstName?: string | null;
  contactFirstName_CONTAINS?: string | null;
  contactFirstName_ENDS_WITH?: string | null;
  contactFirstName_IN?: (string | null)[] | null;
  contactFirstName_MATCHES?: string | null;
  contactFirstName_NOT?: string | null;
  contactFirstName_NOT_CONTAINS?: string | null;
  contactFirstName_NOT_ENDS_WITH?: string | null;
  contactFirstName_NOT_IN?: (string | null)[] | null;
  contactFirstName_NOT_STARTS_WITH?: string | null;
  contactFirstName_STARTS_WITH?: string | null;
  contactLastName?: string | null;
  contactLastName_CONTAINS?: string | null;
  contactLastName_ENDS_WITH?: string | null;
  contactLastName_IN?: (string | null)[] | null;
  contactLastName_MATCHES?: string | null;
  contactLastName_NOT?: string | null;
  contactLastName_NOT_CONTAINS?: string | null;
  contactLastName_NOT_ENDS_WITH?: string | null;
  contactLastName_NOT_IN?: (string | null)[] | null;
  contactLastName_NOT_STARTS_WITH?: string | null;
  contactLastName_STARTS_WITH?: string | null;
  contactOccupation?: string | null;
  contactOccupation_CONTAINS?: string | null;
  contactOccupation_ENDS_WITH?: string | null;
  contactOccupation_IN?: (string | null)[] | null;
  contactOccupation_MATCHES?: string | null;
  contactOccupation_NOT?: string | null;
  contactOccupation_NOT_CONTAINS?: string | null;
  contactOccupation_NOT_ENDS_WITH?: string | null;
  contactOccupation_NOT_IN?: (string | null)[] | null;
  contactOccupation_NOT_STARTS_WITH?: string | null;
  contactOccupation_STARTS_WITH?: string | null;
  contactPhone?: string | null;
  contactPhone_CONTAINS?: string | null;
  contactPhone_ENDS_WITH?: string | null;
  contactPhone_IN?: (string | null)[] | null;
  contactPhone_MATCHES?: string | null;
  contactPhone_NOT?: string | null;
  contactPhone_NOT_CONTAINS?: string | null;
  contactPhone_NOT_ENDS_WITH?: string | null;
  contactPhone_NOT_IN?: (string | null)[] | null;
  contactPhone_NOT_STARTS_WITH?: string | null;
  contactPhone_STARTS_WITH?: string | null;
  createdOn?: number | null;
  createdOn_GT?: number | null;
  createdOn_GTE?: number | null;
  createdOn_IN?: (number | null)[] | null;
  createdOn_LT?: number | null;
  createdOn_LTE?: number | null;
  createdOn_NOT?: number | null;
  createdOn_NOT_IN?: (number | null)[] | null;
  customTranslations?: (Translations | null)[] | null;
  customTranslations_INCLUDES?: Translations | null;
  customTranslations_NOT?: (Translations | null)[] | null;
  customTranslations_NOT_INCLUDES?: Translations | null;
  deliveryAddress?: string | null;
  deliveryAddress_CONTAINS?: string | null;
  deliveryAddress_ENDS_WITH?: string | null;
  deliveryAddress_IN?: (string | null)[] | null;
  deliveryAddress_MATCHES?: string | null;
  deliveryAddress_NOT?: string | null;
  deliveryAddress_NOT_CONTAINS?: string | null;
  deliveryAddress_NOT_ENDS_WITH?: string | null;
  deliveryAddress_NOT_IN?: (string | null)[] | null;
  deliveryAddress_NOT_STARTS_WITH?: string | null;
  deliveryAddress_STARTS_WITH?: string | null;
  domicile?: string | null;
  domicile_CONTAINS?: string | null;
  domicile_ENDS_WITH?: string | null;
  domicile_IN?: (string | null)[] | null;
  domicile_MATCHES?: string | null;
  domicile_NOT?: string | null;
  domicile_NOT_CONTAINS?: string | null;
  domicile_NOT_ENDS_WITH?: string | null;
  domicile_NOT_IN?: (string | null)[] | null;
  domicile_NOT_STARTS_WITH?: string | null;
  domicile_STARTS_WITH?: string | null;
  dualApprovalThreshold?: number | null;
  dualApprovalThreshold_GT?: number | null;
  dualApprovalThreshold_GTE?: number | null;
  dualApprovalThreshold_IN?: (number | null)[] | null;
  dualApprovalThreshold_LT?: number | null;
  dualApprovalThreshold_LTE?: number | null;
  dualApprovalThreshold_NOT?: number | null;
  dualApprovalThreshold_NOT_IN?: (number | null)[] | null;
  eIN?: string | null;
  eIN_CONTAINS?: string | null;
  eIN_ENDS_WITH?: string | null;
  eIN_IN?: (string | null)[] | null;
  eIN_MATCHES?: string | null;
  eIN_NOT?: string | null;
  eIN_NOT_CONTAINS?: string | null;
  eIN_NOT_ENDS_WITH?: string | null;
  eIN_NOT_IN?: (string | null)[] | null;
  eIN_NOT_STARTS_WITH?: string | null;
  eIN_STARTS_WITH?: string | null;
  encapsulatedFeatures?: EncapsulatedFeatureConfigurationWhere | null;
  encapsulatedFeaturesAggregate?: OrganizationEncapsulatedFeaturesAggregateInput | null;
  encapsulatedFeaturesConnection?: OrganizationEncapsulatedFeaturesConnectionWhere | null;
  encapsulatedFeaturesConnection_NOT?: OrganizationEncapsulatedFeaturesConnectionWhere | null;
  encapsulatedFeatures_NOT?: EncapsulatedFeatureConfigurationWhere | null;
  fax?: string | null;
  fax_CONTAINS?: string | null;
  fax_ENDS_WITH?: string | null;
  fax_IN?: (string | null)[] | null;
  fax_MATCHES?: string | null;
  fax_NOT?: string | null;
  fax_NOT_CONTAINS?: string | null;
  fax_NOT_ENDS_WITH?: string | null;
  fax_NOT_IN?: (string | null)[] | null;
  fax_NOT_STARTS_WITH?: string | null;
  fax_STARTS_WITH?: string | null;
  flexEntityTypeMappings?: FlexEntityTypeWhere | null;
  flexEntityTypeMappingsAggregate?: OrganizationFlexEntityTypeMappingsAggregateInput | null;
  flexEntityTypeMappingsConnection?: OrganizationFlexEntityTypeMappingsConnectionWhere | null;
  flexEntityTypeMappingsConnection_NOT?: OrganizationFlexEntityTypeMappingsConnectionWhere | null;
  flexEntityTypeMappings_NOT?: FlexEntityTypeWhere | null;
  id?: string | null;
  id_CONTAINS?: string | null;
  id_ENDS_WITH?: string | null;
  id_IN?: (string | null)[] | null;
  id_MATCHES?: string | null;
  id_NOT?: string | null;
  id_NOT_CONTAINS?: string | null;
  id_NOT_ENDS_WITH?: string | null;
  id_NOT_IN?: (string | null)[] | null;
  id_NOT_STARTS_WITH?: string | null;
  id_STARTS_WITH?: string | null;
  isExternalExposureAllowed?: boolean | null;
  isExternalExposureAllowed_NOT?: boolean | null;
  legalName?: string | null;
  legalName_CONTAINS?: string | null;
  legalName_ENDS_WITH?: string | null;
  legalName_IN?: (string | null)[] | null;
  legalName_MATCHES?: string | null;
  legalName_NOT?: string | null;
  legalName_NOT_CONTAINS?: string | null;
  legalName_NOT_ENDS_WITH?: string | null;
  legalName_NOT_IN?: (string | null)[] | null;
  legalName_NOT_STARTS_WITH?: string | null;
  legalName_STARTS_WITH?: string | null;
  logo?: string | null;
  logo_CONTAINS?: string | null;
  logo_ENDS_WITH?: string | null;
  logo_IN?: (string | null)[] | null;
  logo_MATCHES?: string | null;
  logo_NOT?: string | null;
  logo_NOT_CONTAINS?: string | null;
  logo_NOT_ENDS_WITH?: string | null;
  logo_NOT_IN?: (string | null)[] | null;
  logo_NOT_STARTS_WITH?: string | null;
  logo_STARTS_WITH?: string | null;
  name?: string | null;
  name_CONTAINS?: string | null;
  name_ENDS_WITH?: string | null;
  name_IN?: (string | null)[] | null;
  name_MATCHES?: string | null;
  name_NOT?: string | null;
  name_NOT_CONTAINS?: string | null;
  name_NOT_ENDS_WITH?: string | null;
  name_NOT_IN?: (string | null)[] | null;
  name_NOT_STARTS_WITH?: string | null;
  name_STARTS_WITH?: string | null;
  paymentTerms?: number | null;
  paymentTerms_GT?: number | null;
  paymentTerms_GTE?: number | null;
  paymentTerms_IN?: (number | null)[] | null;
  paymentTerms_LT?: number | null;
  paymentTerms_LTE?: number | null;
  paymentTerms_NOT?: number | null;
  paymentTerms_NOT_IN?: (number | null)[] | null;
  phone?: string | null;
  phone_CONTAINS?: string | null;
  phone_ENDS_WITH?: string | null;
  phone_IN?: (string | null)[] | null;
  phone_MATCHES?: string | null;
  phone_NOT?: string | null;
  phone_NOT_CONTAINS?: string | null;
  phone_NOT_ENDS_WITH?: string | null;
  phone_NOT_IN?: (string | null)[] | null;
  phone_NOT_STARTS_WITH?: string | null;
  phone_STARTS_WITH?: string | null;
  questNotifications?: QuestNotificationWhere | null;
  questNotificationsAggregate?: OrganizationQuestNotificationsAggregateInput | null;
  questNotificationsConnection?: OrganizationQuestNotificationsConnectionWhere | null;
  questNotificationsConnection_NOT?: OrganizationQuestNotificationsConnectionWhere | null;
  questNotifications_NOT?: QuestNotificationWhere | null;
  tenantId?: string | null;
  tenantId_CONTAINS?: string | null;
  tenantId_ENDS_WITH?: string | null;
  tenantId_IN?: (string | null)[] | null;
  tenantId_MATCHES?: string | null;
  tenantId_NOT?: string | null;
  tenantId_NOT_CONTAINS?: string | null;
  tenantId_NOT_ENDS_WITH?: string | null;
  tenantId_NOT_IN?: (string | null)[] | null;
  tenantId_NOT_STARTS_WITH?: string | null;
  tenantId_STARTS_WITH?: string | null;
  website?: string | null;
  website_CONTAINS?: string | null;
  website_ENDS_WITH?: string | null;
  website_IN?: (string | null)[] | null;
  website_MATCHES?: string | null;
  website_NOT?: string | null;
  website_NOT_CONTAINS?: string | null;
  website_NOT_ENDS_WITH?: string | null;
  website_NOT_IN?: (string | null)[] | null;
  website_NOT_STARTS_WITH?: string | null;
  website_STARTS_WITH?: string | null;
}

export interface PartnerTreatmentAggregateInput {
  AND?: PartnerTreatmentAggregateInput[] | null;
  OR?: PartnerTreatmentAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: PartnerTreatmentNodeAggregationWhereInput | null;
}

export interface PartnerTreatmentConnectionWhere {
  AND?: PartnerTreatmentConnectionWhere[] | null;
  OR?: PartnerTreatmentConnectionWhere[] | null;
  node?: TreatmentWhere | null;
  node_NOT?: TreatmentWhere | null;
}

export interface PartnerTreatmentNodeAggregationWhereInput {
  AND?: PartnerTreatmentNodeAggregationWhereInput[] | null;
  BagDossierNo_AVERAGE_EQUAL?: number | null;
  BagDossierNo_AVERAGE_GT?: number | null;
  BagDossierNo_AVERAGE_GTE?: number | null;
  BagDossierNo_AVERAGE_LT?: number | null;
  BagDossierNo_AVERAGE_LTE?: number | null;
  BagDossierNo_EQUAL?: string | null;
  BagDossierNo_GT?: number | null;
  BagDossierNo_GTE?: number | null;
  BagDossierNo_LONGEST_EQUAL?: number | null;
  BagDossierNo_LONGEST_GT?: number | null;
  BagDossierNo_LONGEST_GTE?: number | null;
  BagDossierNo_LONGEST_LT?: number | null;
  BagDossierNo_LONGEST_LTE?: number | null;
  BagDossierNo_LT?: number | null;
  BagDossierNo_LTE?: number | null;
  BagDossierNo_SHORTEST_EQUAL?: number | null;
  BagDossierNo_SHORTEST_GT?: number | null;
  BagDossierNo_SHORTEST_GTE?: number | null;
  BagDossierNo_SHORTEST_LT?: number | null;
  BagDossierNo_SHORTEST_LTE?: number | null;
  Code_AVERAGE_EQUAL?: number | null;
  Code_AVERAGE_GT?: number | null;
  Code_AVERAGE_GTE?: number | null;
  Code_AVERAGE_LT?: number | null;
  Code_AVERAGE_LTE?: number | null;
  Code_EQUAL?: string | null;
  Code_GT?: number | null;
  Code_GTE?: number | null;
  Code_LONGEST_EQUAL?: number | null;
  Code_LONGEST_GT?: number | null;
  Code_LONGEST_GTE?: number | null;
  Code_LONGEST_LT?: number | null;
  Code_LONGEST_LTE?: number | null;
  Code_LT?: number | null;
  Code_LTE?: number | null;
  Code_SHORTEST_EQUAL?: number | null;
  Code_SHORTEST_GT?: number | null;
  Code_SHORTEST_GTE?: number | null;
  Code_SHORTEST_LT?: number | null;
  Code_SHORTEST_LTE?: number | null;
  FlagModal_AVERAGE_EQUAL?: number | null;
  FlagModal_AVERAGE_GT?: number | null;
  FlagModal_AVERAGE_GTE?: number | null;
  FlagModal_AVERAGE_LT?: number | null;
  FlagModal_AVERAGE_LTE?: number | null;
  FlagModal_EQUAL?: string | null;
  FlagModal_GT?: number | null;
  FlagModal_GTE?: number | null;
  FlagModal_LONGEST_EQUAL?: number | null;
  FlagModal_LONGEST_GT?: number | null;
  FlagModal_LONGEST_GTE?: number | null;
  FlagModal_LONGEST_LT?: number | null;
  FlagModal_LONGEST_LTE?: number | null;
  FlagModal_LT?: number | null;
  FlagModal_LTE?: number | null;
  FlagModal_SHORTEST_EQUAL?: number | null;
  FlagModal_SHORTEST_GT?: number | null;
  FlagModal_SHORTEST_GTE?: number | null;
  FlagModal_SHORTEST_LT?: number | null;
  FlagModal_SHORTEST_LTE?: number | null;
  FlagNarcosis_AVERAGE_EQUAL?: number | null;
  FlagNarcosis_AVERAGE_GT?: number | null;
  FlagNarcosis_AVERAGE_GTE?: number | null;
  FlagNarcosis_AVERAGE_LT?: number | null;
  FlagNarcosis_AVERAGE_LTE?: number | null;
  FlagNarcosis_EQUAL?: string | null;
  FlagNarcosis_GT?: number | null;
  FlagNarcosis_GTE?: number | null;
  FlagNarcosis_LONGEST_EQUAL?: number | null;
  FlagNarcosis_LONGEST_GT?: number | null;
  FlagNarcosis_LONGEST_GTE?: number | null;
  FlagNarcosis_LONGEST_LT?: number | null;
  FlagNarcosis_LONGEST_LTE?: number | null;
  FlagNarcosis_LT?: number | null;
  FlagNarcosis_LTE?: number | null;
  FlagNarcosis_SHORTEST_EQUAL?: number | null;
  FlagNarcosis_SHORTEST_GT?: number | null;
  FlagNarcosis_SHORTEST_GTE?: number | null;
  FlagNarcosis_SHORTEST_LT?: number | null;
  FlagNarcosis_SHORTEST_LTE?: number | null;
  GTIN_AVERAGE_EQUAL?: number | null;
  GTIN_AVERAGE_GT?: number | null;
  GTIN_AVERAGE_GTE?: number | null;
  GTIN_AVERAGE_LT?: number | null;
  GTIN_AVERAGE_LTE?: number | null;
  GTIN_EQUAL?: string | null;
  GTIN_GT?: number | null;
  GTIN_GTE?: number | null;
  GTIN_LONGEST_EQUAL?: number | null;
  GTIN_LONGEST_GT?: number | null;
  GTIN_LONGEST_GTE?: number | null;
  GTIN_LONGEST_LT?: number | null;
  GTIN_LONGEST_LTE?: number | null;
  GTIN_LT?: number | null;
  GTIN_LTE?: number | null;
  GTIN_SHORTEST_EQUAL?: number | null;
  GTIN_SHORTEST_GT?: number | null;
  GTIN_SHORTEST_GTE?: number | null;
  GTIN_SHORTEST_LT?: number | null;
  GTIN_SHORTEST_LTE?: number | null;
  LOT_AVERAGE_EQUAL?: number | null;
  LOT_AVERAGE_GT?: number | null;
  LOT_AVERAGE_GTE?: number | null;
  LOT_AVERAGE_LT?: number | null;
  LOT_AVERAGE_LTE?: number | null;
  LOT_EQUAL?: string | null;
  LOT_GT?: number | null;
  LOT_GTE?: number | null;
  LOT_LONGEST_EQUAL?: number | null;
  LOT_LONGEST_GT?: number | null;
  LOT_LONGEST_GTE?: number | null;
  LOT_LONGEST_LT?: number | null;
  LOT_LONGEST_LTE?: number | null;
  LOT_LT?: number | null;
  LOT_LTE?: number | null;
  LOT_SHORTEST_EQUAL?: number | null;
  LOT_SHORTEST_GT?: number | null;
  LOT_SHORTEST_GTE?: number | null;
  LOT_SHORTEST_LT?: number | null;
  LOT_SHORTEST_LTE?: number | null;
  Name_AVERAGE_EQUAL?: number | null;
  Name_AVERAGE_GT?: number | null;
  Name_AVERAGE_GTE?: number | null;
  Name_AVERAGE_LT?: number | null;
  Name_AVERAGE_LTE?: number | null;
  Name_EQUAL?: string | null;
  Name_GT?: number | null;
  Name_GTE?: number | null;
  Name_LONGEST_EQUAL?: number | null;
  Name_LONGEST_GT?: number | null;
  Name_LONGEST_GTE?: number | null;
  Name_LONGEST_LT?: number | null;
  Name_LONGEST_LTE?: number | null;
  Name_LT?: number | null;
  Name_LTE?: number | null;
  Name_SHORTEST_EQUAL?: number | null;
  Name_SHORTEST_GT?: number | null;
  Name_SHORTEST_GTE?: number | null;
  Name_SHORTEST_LT?: number | null;
  Name_SHORTEST_LTE?: number | null;
  OR?: PartnerTreatmentNodeAggregationWhereInput[] | null;
  PharmaCode_AVERAGE_EQUAL?: number | null;
  PharmaCode_AVERAGE_GT?: number | null;
  PharmaCode_AVERAGE_GTE?: number | null;
  PharmaCode_AVERAGE_LT?: number | null;
  PharmaCode_AVERAGE_LTE?: number | null;
  PharmaCode_EQUAL?: string | null;
  PharmaCode_GT?: number | null;
  PharmaCode_GTE?: number | null;
  PharmaCode_LONGEST_EQUAL?: number | null;
  PharmaCode_LONGEST_GT?: number | null;
  PharmaCode_LONGEST_GTE?: number | null;
  PharmaCode_LONGEST_LT?: number | null;
  PharmaCode_LONGEST_LTE?: number | null;
  PharmaCode_LT?: number | null;
  PharmaCode_LTE?: number | null;
  PharmaCode_SHORTEST_EQUAL?: number | null;
  PharmaCode_SHORTEST_GT?: number | null;
  PharmaCode_SHORTEST_GTE?: number | null;
  PharmaCode_SHORTEST_LT?: number | null;
  PharmaCode_SHORTEST_LTE?: number | null;
  PrevPharmacode_AVERAGE_EQUAL?: number | null;
  PrevPharmacode_AVERAGE_GT?: number | null;
  PrevPharmacode_AVERAGE_GTE?: number | null;
  PrevPharmacode_AVERAGE_LT?: number | null;
  PrevPharmacode_AVERAGE_LTE?: number | null;
  PrevPharmacode_EQUAL?: string | null;
  PrevPharmacode_GT?: number | null;
  PrevPharmacode_GTE?: number | null;
  PrevPharmacode_LONGEST_EQUAL?: number | null;
  PrevPharmacode_LONGEST_GT?: number | null;
  PrevPharmacode_LONGEST_GTE?: number | null;
  PrevPharmacode_LONGEST_LT?: number | null;
  PrevPharmacode_LONGEST_LTE?: number | null;
  PrevPharmacode_LT?: number | null;
  PrevPharmacode_LTE?: number | null;
  PrevPharmacode_SHORTEST_EQUAL?: number | null;
  PrevPharmacode_SHORTEST_GT?: number | null;
  PrevPharmacode_SHORTEST_GTE?: number | null;
  PrevPharmacode_SHORTEST_LT?: number | null;
  PrevPharmacode_SHORTEST_LTE?: number | null;
  REF_AVERAGE_EQUAL?: number | null;
  REF_AVERAGE_GT?: number | null;
  REF_AVERAGE_GTE?: number | null;
  REF_AVERAGE_LT?: number | null;
  REF_AVERAGE_LTE?: number | null;
  REF_EQUAL?: string | null;
  REF_GT?: number | null;
  REF_GTE?: number | null;
  REF_LONGEST_EQUAL?: number | null;
  REF_LONGEST_GT?: number | null;
  REF_LONGEST_GTE?: number | null;
  REF_LONGEST_LT?: number | null;
  REF_LONGEST_LTE?: number | null;
  REF_LT?: number | null;
  REF_LTE?: number | null;
  REF_SHORTEST_EQUAL?: number | null;
  REF_SHORTEST_GT?: number | null;
  REF_SHORTEST_GTE?: number | null;
  REF_SHORTEST_LT?: number | null;
  REF_SHORTEST_LTE?: number | null;
  SwissmedicCategory_AVERAGE_EQUAL?: number | null;
  SwissmedicCategory_AVERAGE_GT?: number | null;
  SwissmedicCategory_AVERAGE_GTE?: number | null;
  SwissmedicCategory_AVERAGE_LT?: number | null;
  SwissmedicCategory_AVERAGE_LTE?: number | null;
  SwissmedicCategory_EQUAL?: string | null;
  SwissmedicCategory_GT?: number | null;
  SwissmedicCategory_GTE?: number | null;
  SwissmedicCategory_LONGEST_EQUAL?: number | null;
  SwissmedicCategory_LONGEST_GT?: number | null;
  SwissmedicCategory_LONGEST_GTE?: number | null;
  SwissmedicCategory_LONGEST_LT?: number | null;
  SwissmedicCategory_LONGEST_LTE?: number | null;
  SwissmedicCategory_LT?: number | null;
  SwissmedicCategory_LTE?: number | null;
  SwissmedicCategory_SHORTEST_EQUAL?: number | null;
  SwissmedicCategory_SHORTEST_GT?: number | null;
  SwissmedicCategory_SHORTEST_GTE?: number | null;
  SwissmedicCategory_SHORTEST_LT?: number | null;
  SwissmedicCategory_SHORTEST_LTE?: number | null;
  SwissmedicNo8_AVERAGE_EQUAL?: number | null;
  SwissmedicNo8_AVERAGE_GT?: number | null;
  SwissmedicNo8_AVERAGE_GTE?: number | null;
  SwissmedicNo8_AVERAGE_LT?: number | null;
  SwissmedicNo8_AVERAGE_LTE?: number | null;
  SwissmedicNo8_EQUAL?: string | null;
  SwissmedicNo8_GT?: number | null;
  SwissmedicNo8_GTE?: number | null;
  SwissmedicNo8_LONGEST_EQUAL?: number | null;
  SwissmedicNo8_LONGEST_GT?: number | null;
  SwissmedicNo8_LONGEST_GTE?: number | null;
  SwissmedicNo8_LONGEST_LT?: number | null;
  SwissmedicNo8_LONGEST_LTE?: number | null;
  SwissmedicNo8_LT?: number | null;
  SwissmedicNo8_LTE?: number | null;
  SwissmedicNo8_SHORTEST_EQUAL?: number | null;
  SwissmedicNo8_SHORTEST_GT?: number | null;
  SwissmedicNo8_SHORTEST_GTE?: number | null;
  SwissmedicNo8_SHORTEST_LT?: number | null;
  SwissmedicNo8_SHORTEST_LTE?: number | null;
  UDI_AVERAGE_EQUAL?: number | null;
  UDI_AVERAGE_GT?: number | null;
  UDI_AVERAGE_GTE?: number | null;
  UDI_AVERAGE_LT?: number | null;
  UDI_AVERAGE_LTE?: number | null;
  UDI_EQUAL?: string | null;
  UDI_GT?: number | null;
  UDI_GTE?: number | null;
  UDI_LONGEST_EQUAL?: number | null;
  UDI_LONGEST_GT?: number | null;
  UDI_LONGEST_GTE?: number | null;
  UDI_LONGEST_LT?: number | null;
  UDI_LONGEST_LTE?: number | null;
  UDI_LT?: number | null;
  UDI_LTE?: number | null;
  UDI_SHORTEST_EQUAL?: number | null;
  UDI_SHORTEST_GT?: number | null;
  UDI_SHORTEST_GTE?: number | null;
  UDI_SHORTEST_LT?: number | null;
  UDI_SHORTEST_LTE?: number | null;
  activeIngredientQuantity_AVERAGE_EQUAL?: number | null;
  activeIngredientQuantity_AVERAGE_GT?: number | null;
  activeIngredientQuantity_AVERAGE_GTE?: number | null;
  activeIngredientQuantity_AVERAGE_LT?: number | null;
  activeIngredientQuantity_AVERAGE_LTE?: number | null;
  activeIngredientQuantity_EQUAL?: number | null;
  activeIngredientQuantity_GT?: number | null;
  activeIngredientQuantity_GTE?: number | null;
  activeIngredientQuantity_LT?: number | null;
  activeIngredientQuantity_LTE?: number | null;
  activeIngredientQuantity_MAX_EQUAL?: number | null;
  activeIngredientQuantity_MAX_GT?: number | null;
  activeIngredientQuantity_MAX_GTE?: number | null;
  activeIngredientQuantity_MAX_LT?: number | null;
  activeIngredientQuantity_MAX_LTE?: number | null;
  activeIngredientQuantity_MIN_EQUAL?: number | null;
  activeIngredientQuantity_MIN_GT?: number | null;
  activeIngredientQuantity_MIN_GTE?: number | null;
  activeIngredientQuantity_MIN_LT?: number | null;
  activeIngredientQuantity_MIN_LTE?: number | null;
  activeIngredientQuantity_SUM_EQUAL?: number | null;
  activeIngredientQuantity_SUM_GT?: number | null;
  activeIngredientQuantity_SUM_GTE?: number | null;
  activeIngredientQuantity_SUM_LT?: number | null;
  activeIngredientQuantity_SUM_LTE?: number | null;
  classificationSystem_AVERAGE_EQUAL?: number | null;
  classificationSystem_AVERAGE_GT?: number | null;
  classificationSystem_AVERAGE_GTE?: number | null;
  classificationSystem_AVERAGE_LT?: number | null;
  classificationSystem_AVERAGE_LTE?: number | null;
  classificationSystem_EQUAL?: string | null;
  classificationSystem_GT?: number | null;
  classificationSystem_GTE?: number | null;
  classificationSystem_LONGEST_EQUAL?: number | null;
  classificationSystem_LONGEST_GT?: number | null;
  classificationSystem_LONGEST_GTE?: number | null;
  classificationSystem_LONGEST_LT?: number | null;
  classificationSystem_LONGEST_LTE?: number | null;
  classificationSystem_LT?: number | null;
  classificationSystem_LTE?: number | null;
  classificationSystem_SHORTEST_EQUAL?: number | null;
  classificationSystem_SHORTEST_GT?: number | null;
  classificationSystem_SHORTEST_GTE?: number | null;
  classificationSystem_SHORTEST_LT?: number | null;
  classificationSystem_SHORTEST_LTE?: number | null;
  concentration_AVERAGE_EQUAL?: number | null;
  concentration_AVERAGE_GT?: number | null;
  concentration_AVERAGE_GTE?: number | null;
  concentration_AVERAGE_LT?: number | null;
  concentration_AVERAGE_LTE?: number | null;
  concentration_EQUAL?: string | null;
  concentration_GT?: number | null;
  concentration_GTE?: number | null;
  concentration_LONGEST_EQUAL?: number | null;
  concentration_LONGEST_GT?: number | null;
  concentration_LONGEST_GTE?: number | null;
  concentration_LONGEST_LT?: number | null;
  concentration_LONGEST_LTE?: number | null;
  concentration_LT?: number | null;
  concentration_LTE?: number | null;
  concentration_SHORTEST_EQUAL?: number | null;
  concentration_SHORTEST_GT?: number | null;
  concentration_SHORTEST_GTE?: number | null;
  concentration_SHORTEST_LT?: number | null;
  concentration_SHORTEST_LTE?: number | null;
  packVolume_AVERAGE_EQUAL?: number | null;
  packVolume_AVERAGE_GT?: number | null;
  packVolume_AVERAGE_GTE?: number | null;
  packVolume_AVERAGE_LT?: number | null;
  packVolume_AVERAGE_LTE?: number | null;
  packVolume_EQUAL?: string | null;
  packVolume_GT?: number | null;
  packVolume_GTE?: number | null;
  packVolume_LONGEST_EQUAL?: number | null;
  packVolume_LONGEST_GT?: number | null;
  packVolume_LONGEST_GTE?: number | null;
  packVolume_LONGEST_LT?: number | null;
  packVolume_LONGEST_LTE?: number | null;
  packVolume_LT?: number | null;
  packVolume_LTE?: number | null;
  packVolume_SHORTEST_EQUAL?: number | null;
  packVolume_SHORTEST_GT?: number | null;
  packVolume_SHORTEST_GTE?: number | null;
  packVolume_SHORTEST_LT?: number | null;
  packVolume_SHORTEST_LTE?: number | null;
}

export interface PartnerWhere {
  AND?: PartnerWhere[] | null;
  Description?: string | null;
  Description_CONTAINS?: string | null;
  Description_ENDS_WITH?: string | null;
  Description_IN?: (string | null)[] | null;
  Description_MATCHES?: string | null;
  Description_NOT?: string | null;
  Description_NOT_CONTAINS?: string | null;
  Description_NOT_ENDS_WITH?: string | null;
  Description_NOT_IN?: (string | null)[] | null;
  Description_NOT_STARTS_WITH?: string | null;
  Description_STARTS_WITH?: string | null;
  OR?: PartnerWhere[] | null;
  PartnerType?: string | null;
  PartnerType_CONTAINS?: string | null;
  PartnerType_ENDS_WITH?: string | null;
  PartnerType_IN?: (string | null)[] | null;
  PartnerType_MATCHES?: string | null;
  PartnerType_NOT?: string | null;
  PartnerType_NOT_CONTAINS?: string | null;
  PartnerType_NOT_ENDS_WITH?: string | null;
  PartnerType_NOT_IN?: (string | null)[] | null;
  PartnerType_NOT_STARTS_WITH?: string | null;
  PartnerType_STARTS_WITH?: string | null;
  Phone?: string | null;
  Phone_CONTAINS?: string | null;
  Phone_ENDS_WITH?: string | null;
  Phone_IN?: (string | null)[] | null;
  Phone_MATCHES?: string | null;
  Phone_NOT?: string | null;
  Phone_NOT_CONTAINS?: string | null;
  Phone_NOT_ENDS_WITH?: string | null;
  Phone_NOT_IN?: (string | null)[] | null;
  Phone_NOT_STARTS_WITH?: string | null;
  Phone_STARTS_WITH?: string | null;
  Place?: string | null;
  Place_CONTAINS?: string | null;
  Place_ENDS_WITH?: string | null;
  Place_IN?: (string | null)[] | null;
  Place_MATCHES?: string | null;
  Place_NOT?: string | null;
  Place_NOT_CONTAINS?: string | null;
  Place_NOT_ENDS_WITH?: string | null;
  Place_NOT_IN?: (string | null)[] | null;
  Place_NOT_STARTS_WITH?: string | null;
  Place_STARTS_WITH?: string | null;
  Street?: string | null;
  Street_CONTAINS?: string | null;
  Street_ENDS_WITH?: string | null;
  Street_IN?: (string | null)[] | null;
  Street_MATCHES?: string | null;
  Street_NOT?: string | null;
  Street_NOT_CONTAINS?: string | null;
  Street_NOT_ENDS_WITH?: string | null;
  Street_NOT_IN?: (string | null)[] | null;
  Street_NOT_STARTS_WITH?: string | null;
  Street_STARTS_WITH?: string | null;
  ZipCode?: number | null;
  ZipCode_GT?: number | null;
  ZipCode_GTE?: number | null;
  ZipCode_IN?: (number | null)[] | null;
  ZipCode_LT?: number | null;
  ZipCode_LTE?: number | null;
  ZipCode_NOT?: number | null;
  ZipCode_NOT_IN?: (number | null)[] | null;
  treatment?: TreatmentWhere | null;
  treatmentAggregate?: PartnerTreatmentAggregateInput | null;
  treatmentConnection?: PartnerTreatmentConnectionWhere | null;
  treatmentConnection_NOT?: PartnerTreatmentConnectionWhere | null;
  treatment_NOT?: TreatmentWhere | null;
}

export interface PatientAssignedFlexEntitiesAggregateInput {
  AND?: PatientAssignedFlexEntitiesAggregateInput[] | null;
  OR?: PatientAssignedFlexEntitiesAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: PatientAssignedFlexEntitiesNodeAggregationWhereInput | null;
}

export interface PatientAssignedFlexEntitiesConnectionWhere {
  AND?: PatientAssignedFlexEntitiesConnectionWhere[] | null;
  OR?: PatientAssignedFlexEntitiesConnectionWhere[] | null;
  node?: FlexEntityWhere | null;
  node_NOT?: FlexEntityWhere | null;
}

export interface PatientAssignedFlexEntitiesNodeAggregationWhereInput {
  AND?: PatientAssignedFlexEntitiesNodeAggregationWhereInput[] | null;
  OR?: PatientAssignedFlexEntitiesNodeAggregationWhereInput[] | null;
  createdByEmail_AVERAGE_EQUAL?: number | null;
  createdByEmail_AVERAGE_GT?: number | null;
  createdByEmail_AVERAGE_GTE?: number | null;
  createdByEmail_AVERAGE_LT?: number | null;
  createdByEmail_AVERAGE_LTE?: number | null;
  createdByEmail_EQUAL?: string | null;
  createdByEmail_GT?: number | null;
  createdByEmail_GTE?: number | null;
  createdByEmail_LONGEST_EQUAL?: number | null;
  createdByEmail_LONGEST_GT?: number | null;
  createdByEmail_LONGEST_GTE?: number | null;
  createdByEmail_LONGEST_LT?: number | null;
  createdByEmail_LONGEST_LTE?: number | null;
  createdByEmail_LT?: number | null;
  createdByEmail_LTE?: number | null;
  createdByEmail_SHORTEST_EQUAL?: number | null;
  createdByEmail_SHORTEST_GT?: number | null;
  createdByEmail_SHORTEST_GTE?: number | null;
  createdByEmail_SHORTEST_LT?: number | null;
  createdByEmail_SHORTEST_LTE?: number | null;
  createdByName_AVERAGE_EQUAL?: number | null;
  createdByName_AVERAGE_GT?: number | null;
  createdByName_AVERAGE_GTE?: number | null;
  createdByName_AVERAGE_LT?: number | null;
  createdByName_AVERAGE_LTE?: number | null;
  createdByName_EQUAL?: string | null;
  createdByName_GT?: number | null;
  createdByName_GTE?: number | null;
  createdByName_LONGEST_EQUAL?: number | null;
  createdByName_LONGEST_GT?: number | null;
  createdByName_LONGEST_GTE?: number | null;
  createdByName_LONGEST_LT?: number | null;
  createdByName_LONGEST_LTE?: number | null;
  createdByName_LT?: number | null;
  createdByName_LTE?: number | null;
  createdByName_SHORTEST_EQUAL?: number | null;
  createdByName_SHORTEST_GT?: number | null;
  createdByName_SHORTEST_GTE?: number | null;
  createdByName_SHORTEST_LT?: number | null;
  createdByName_SHORTEST_LTE?: number | null;
  createdOn_EQUAL?: any | null;
  createdOn_GT?: any | null;
  createdOn_GTE?: any | null;
  createdOn_LT?: any | null;
  createdOn_LTE?: any | null;
  createdOn_MAX_EQUAL?: any | null;
  createdOn_MAX_GT?: any | null;
  createdOn_MAX_GTE?: any | null;
  createdOn_MAX_LT?: any | null;
  createdOn_MAX_LTE?: any | null;
  createdOn_MIN_EQUAL?: any | null;
  createdOn_MIN_GT?: any | null;
  createdOn_MIN_GTE?: any | null;
  createdOn_MIN_LT?: any | null;
  createdOn_MIN_LTE?: any | null;
  dataKeys_AVERAGE_EQUAL?: number | null;
  dataKeys_AVERAGE_GT?: number | null;
  dataKeys_AVERAGE_GTE?: number | null;
  dataKeys_AVERAGE_LT?: number | null;
  dataKeys_AVERAGE_LTE?: number | null;
  dataKeys_EQUAL?: string | null;
  dataKeys_GT?: number | null;
  dataKeys_GTE?: number | null;
  dataKeys_LONGEST_EQUAL?: number | null;
  dataKeys_LONGEST_GT?: number | null;
  dataKeys_LONGEST_GTE?: number | null;
  dataKeys_LONGEST_LT?: number | null;
  dataKeys_LONGEST_LTE?: number | null;
  dataKeys_LT?: number | null;
  dataKeys_LTE?: number | null;
  dataKeys_SHORTEST_EQUAL?: number | null;
  dataKeys_SHORTEST_GT?: number | null;
  dataKeys_SHORTEST_GTE?: number | null;
  dataKeys_SHORTEST_LT?: number | null;
  dataKeys_SHORTEST_LTE?: number | null;
  data_AVERAGE_EQUAL?: number | null;
  data_AVERAGE_GT?: number | null;
  data_AVERAGE_GTE?: number | null;
  data_AVERAGE_LT?: number | null;
  data_AVERAGE_LTE?: number | null;
  data_EQUAL?: string | null;
  data_GT?: number | null;
  data_GTE?: number | null;
  data_LONGEST_EQUAL?: number | null;
  data_LONGEST_GT?: number | null;
  data_LONGEST_GTE?: number | null;
  data_LONGEST_LT?: number | null;
  data_LONGEST_LTE?: number | null;
  data_LT?: number | null;
  data_LTE?: number | null;
  data_SHORTEST_EQUAL?: number | null;
  data_SHORTEST_GT?: number | null;
  data_SHORTEST_GTE?: number | null;
  data_SHORTEST_LT?: number | null;
  data_SHORTEST_LTE?: number | null;
  flexEntityName_AVERAGE_EQUAL?: number | null;
  flexEntityName_AVERAGE_GT?: number | null;
  flexEntityName_AVERAGE_GTE?: number | null;
  flexEntityName_AVERAGE_LT?: number | null;
  flexEntityName_AVERAGE_LTE?: number | null;
  flexEntityName_EQUAL?: string | null;
  flexEntityName_GT?: number | null;
  flexEntityName_GTE?: number | null;
  flexEntityName_LONGEST_EQUAL?: number | null;
  flexEntityName_LONGEST_GT?: number | null;
  flexEntityName_LONGEST_GTE?: number | null;
  flexEntityName_LONGEST_LT?: number | null;
  flexEntityName_LONGEST_LTE?: number | null;
  flexEntityName_LT?: number | null;
  flexEntityName_LTE?: number | null;
  flexEntityName_SHORTEST_EQUAL?: number | null;
  flexEntityName_SHORTEST_GT?: number | null;
  flexEntityName_SHORTEST_GTE?: number | null;
  flexEntityName_SHORTEST_LT?: number | null;
  flexEntityName_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  lastUpdatedOn_EQUAL?: any | null;
  lastUpdatedOn_GT?: any | null;
  lastUpdatedOn_GTE?: any | null;
  lastUpdatedOn_LT?: any | null;
  lastUpdatedOn_LTE?: any | null;
  lastUpdatedOn_MAX_EQUAL?: any | null;
  lastUpdatedOn_MAX_GT?: any | null;
  lastUpdatedOn_MAX_GTE?: any | null;
  lastUpdatedOn_MAX_LT?: any | null;
  lastUpdatedOn_MAX_LTE?: any | null;
  lastUpdatedOn_MIN_EQUAL?: any | null;
  lastUpdatedOn_MIN_GT?: any | null;
  lastUpdatedOn_MIN_GTE?: any | null;
  lastUpdatedOn_MIN_LT?: any | null;
  lastUpdatedOn_MIN_LTE?: any | null;
  patientId_AVERAGE_EQUAL?: number | null;
  patientId_AVERAGE_GT?: number | null;
  patientId_AVERAGE_GTE?: number | null;
  patientId_AVERAGE_LT?: number | null;
  patientId_AVERAGE_LTE?: number | null;
  patientId_EQUAL?: string | null;
  patientId_GT?: number | null;
  patientId_GTE?: number | null;
  patientId_LONGEST_EQUAL?: number | null;
  patientId_LONGEST_GT?: number | null;
  patientId_LONGEST_GTE?: number | null;
  patientId_LONGEST_LT?: number | null;
  patientId_LONGEST_LTE?: number | null;
  patientId_LT?: number | null;
  patientId_LTE?: number | null;
  patientId_SHORTEST_EQUAL?: number | null;
  patientId_SHORTEST_GT?: number | null;
  patientId_SHORTEST_GTE?: number | null;
  patientId_SHORTEST_LT?: number | null;
  patientId_SHORTEST_LTE?: number | null;
  preparationBrandNames_AVERAGE_EQUAL?: number | null;
  preparationBrandNames_AVERAGE_GT?: number | null;
  preparationBrandNames_AVERAGE_GTE?: number | null;
  preparationBrandNames_AVERAGE_LT?: number | null;
  preparationBrandNames_AVERAGE_LTE?: number | null;
  preparationBrandNames_EQUAL?: string | null;
  preparationBrandNames_GT?: number | null;
  preparationBrandNames_GTE?: number | null;
  preparationBrandNames_LONGEST_EQUAL?: number | null;
  preparationBrandNames_LONGEST_GT?: number | null;
  preparationBrandNames_LONGEST_GTE?: number | null;
  preparationBrandNames_LONGEST_LT?: number | null;
  preparationBrandNames_LONGEST_LTE?: number | null;
  preparationBrandNames_LT?: number | null;
  preparationBrandNames_LTE?: number | null;
  preparationBrandNames_SHORTEST_EQUAL?: number | null;
  preparationBrandNames_SHORTEST_GT?: number | null;
  preparationBrandNames_SHORTEST_GTE?: number | null;
  preparationBrandNames_SHORTEST_LT?: number | null;
  preparationBrandNames_SHORTEST_LTE?: number | null;
  preparationGenericNames_AVERAGE_EQUAL?: number | null;
  preparationGenericNames_AVERAGE_GT?: number | null;
  preparationGenericNames_AVERAGE_GTE?: number | null;
  preparationGenericNames_AVERAGE_LT?: number | null;
  preparationGenericNames_AVERAGE_LTE?: number | null;
  preparationGenericNames_EQUAL?: string | null;
  preparationGenericNames_GT?: number | null;
  preparationGenericNames_GTE?: number | null;
  preparationGenericNames_LONGEST_EQUAL?: number | null;
  preparationGenericNames_LONGEST_GT?: number | null;
  preparationGenericNames_LONGEST_GTE?: number | null;
  preparationGenericNames_LONGEST_LT?: number | null;
  preparationGenericNames_LONGEST_LTE?: number | null;
  preparationGenericNames_LT?: number | null;
  preparationGenericNames_LTE?: number | null;
  preparationGenericNames_SHORTEST_EQUAL?: number | null;
  preparationGenericNames_SHORTEST_GT?: number | null;
  preparationGenericNames_SHORTEST_GTE?: number | null;
  preparationGenericNames_SHORTEST_LT?: number | null;
  preparationGenericNames_SHORTEST_LTE?: number | null;
  quantity_AVERAGE_EQUAL?: number | null;
  quantity_AVERAGE_GT?: number | null;
  quantity_AVERAGE_GTE?: number | null;
  quantity_AVERAGE_LT?: number | null;
  quantity_AVERAGE_LTE?: number | null;
  quantity_EQUAL?: number | null;
  quantity_GT?: number | null;
  quantity_GTE?: number | null;
  quantity_LT?: number | null;
  quantity_LTE?: number | null;
  quantity_MAX_EQUAL?: number | null;
  quantity_MAX_GT?: number | null;
  quantity_MAX_GTE?: number | null;
  quantity_MAX_LT?: number | null;
  quantity_MAX_LTE?: number | null;
  quantity_MIN_EQUAL?: number | null;
  quantity_MIN_GT?: number | null;
  quantity_MIN_GTE?: number | null;
  quantity_MIN_LT?: number | null;
  quantity_MIN_LTE?: number | null;
  quantity_SUM_EQUAL?: number | null;
  quantity_SUM_GT?: number | null;
  quantity_SUM_GTE?: number | null;
  quantity_SUM_LT?: number | null;
  quantity_SUM_LTE?: number | null;
  tenantId_AVERAGE_EQUAL?: number | null;
  tenantId_AVERAGE_GT?: number | null;
  tenantId_AVERAGE_GTE?: number | null;
  tenantId_AVERAGE_LT?: number | null;
  tenantId_AVERAGE_LTE?: number | null;
  tenantId_EQUAL?: string | null;
  tenantId_GT?: number | null;
  tenantId_GTE?: number | null;
  tenantId_LONGEST_EQUAL?: number | null;
  tenantId_LONGEST_GT?: number | null;
  tenantId_LONGEST_GTE?: number | null;
  tenantId_LONGEST_LT?: number | null;
  tenantId_LONGEST_LTE?: number | null;
  tenantId_LT?: number | null;
  tenantId_LTE?: number | null;
  tenantId_SHORTEST_EQUAL?: number | null;
  tenantId_SHORTEST_GT?: number | null;
  tenantId_SHORTEST_GTE?: number | null;
  tenantId_SHORTEST_LT?: number | null;
  tenantId_SHORTEST_LTE?: number | null;
  unlimited_AVERAGE_EQUAL?: number | null;
  unlimited_AVERAGE_GT?: number | null;
  unlimited_AVERAGE_GTE?: number | null;
  unlimited_AVERAGE_LT?: number | null;
  unlimited_AVERAGE_LTE?: number | null;
  unlimited_EQUAL?: number | null;
  unlimited_GT?: number | null;
  unlimited_GTE?: number | null;
  unlimited_LT?: number | null;
  unlimited_LTE?: number | null;
  unlimited_MAX_EQUAL?: number | null;
  unlimited_MAX_GT?: number | null;
  unlimited_MAX_GTE?: number | null;
  unlimited_MAX_LT?: number | null;
  unlimited_MAX_LTE?: number | null;
  unlimited_MIN_EQUAL?: number | null;
  unlimited_MIN_GT?: number | null;
  unlimited_MIN_GTE?: number | null;
  unlimited_MIN_LT?: number | null;
  unlimited_MIN_LTE?: number | null;
  unlimited_SUM_EQUAL?: number | null;
  unlimited_SUM_GT?: number | null;
  unlimited_SUM_GTE?: number | null;
  unlimited_SUM_LT?: number | null;
  unlimited_SUM_LTE?: number | null;
  uuid_AVERAGE_EQUAL?: number | null;
  uuid_AVERAGE_GT?: number | null;
  uuid_AVERAGE_GTE?: number | null;
  uuid_AVERAGE_LT?: number | null;
  uuid_AVERAGE_LTE?: number | null;
  uuid_EQUAL?: string | null;
  uuid_GT?: number | null;
  uuid_GTE?: number | null;
  uuid_LONGEST_EQUAL?: number | null;
  uuid_LONGEST_GT?: number | null;
  uuid_LONGEST_GTE?: number | null;
  uuid_LONGEST_LT?: number | null;
  uuid_LONGEST_LTE?: number | null;
  uuid_LT?: number | null;
  uuid_LTE?: number | null;
  uuid_SHORTEST_EQUAL?: number | null;
  uuid_SHORTEST_GT?: number | null;
  uuid_SHORTEST_GTE?: number | null;
  uuid_SHORTEST_LT?: number | null;
  uuid_SHORTEST_LTE?: number | null;
}

export interface PatientCasesAggregateInput {
  AND?: PatientCasesAggregateInput[] | null;
  OR?: PatientCasesAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: PatientCasesNodeAggregationWhereInput | null;
}

export interface PatientCasesConnectionWhere {
  AND?: PatientCasesConnectionWhere[] | null;
  OR?: PatientCasesConnectionWhere[] | null;
  node?: CaseWhere | null;
  node_NOT?: CaseWhere | null;
}

export interface PatientCasesNodeAggregationWhereInput {
  AND?: PatientCasesNodeAggregationWhereInput[] | null;
  OR?: PatientCasesNodeAggregationWhereInput[] | null;
  actualAgreementId_AVERAGE_EQUAL?: number | null;
  actualAgreementId_AVERAGE_GT?: number | null;
  actualAgreementId_AVERAGE_GTE?: number | null;
  actualAgreementId_AVERAGE_LT?: number | null;
  actualAgreementId_AVERAGE_LTE?: number | null;
  actualAgreementId_EQUAL?: string | null;
  actualAgreementId_GT?: number | null;
  actualAgreementId_GTE?: number | null;
  actualAgreementId_LONGEST_EQUAL?: number | null;
  actualAgreementId_LONGEST_GT?: number | null;
  actualAgreementId_LONGEST_GTE?: number | null;
  actualAgreementId_LONGEST_LT?: number | null;
  actualAgreementId_LONGEST_LTE?: number | null;
  actualAgreementId_LT?: number | null;
  actualAgreementId_LTE?: number | null;
  actualAgreementId_SHORTEST_EQUAL?: number | null;
  actualAgreementId_SHORTEST_GT?: number | null;
  actualAgreementId_SHORTEST_GTE?: number | null;
  actualAgreementId_SHORTEST_LT?: number | null;
  actualAgreementId_SHORTEST_LTE?: number | null;
  agreementName_AVERAGE_EQUAL?: number | null;
  agreementName_AVERAGE_GT?: number | null;
  agreementName_AVERAGE_GTE?: number | null;
  agreementName_AVERAGE_LT?: number | null;
  agreementName_AVERAGE_LTE?: number | null;
  agreementName_EQUAL?: string | null;
  agreementName_GT?: number | null;
  agreementName_GTE?: number | null;
  agreementName_LONGEST_EQUAL?: number | null;
  agreementName_LONGEST_GT?: number | null;
  agreementName_LONGEST_GTE?: number | null;
  agreementName_LONGEST_LT?: number | null;
  agreementName_LONGEST_LTE?: number | null;
  agreementName_LT?: number | null;
  agreementName_LTE?: number | null;
  agreementName_SHORTEST_EQUAL?: number | null;
  agreementName_SHORTEST_GT?: number | null;
  agreementName_SHORTEST_GTE?: number | null;
  agreementName_SHORTEST_LT?: number | null;
  agreementName_SHORTEST_LTE?: number | null;
  counterpartyInReview_AVERAGE_EQUAL?: number | null;
  counterpartyInReview_AVERAGE_GT?: number | null;
  counterpartyInReview_AVERAGE_GTE?: number | null;
  counterpartyInReview_AVERAGE_LT?: number | null;
  counterpartyInReview_AVERAGE_LTE?: number | null;
  counterpartyInReview_EQUAL?: string | null;
  counterpartyInReview_GT?: number | null;
  counterpartyInReview_GTE?: number | null;
  counterpartyInReview_LONGEST_EQUAL?: number | null;
  counterpartyInReview_LONGEST_GT?: number | null;
  counterpartyInReview_LONGEST_GTE?: number | null;
  counterpartyInReview_LONGEST_LT?: number | null;
  counterpartyInReview_LONGEST_LTE?: number | null;
  counterpartyInReview_LT?: number | null;
  counterpartyInReview_LTE?: number | null;
  counterpartyInReview_SHORTEST_EQUAL?: number | null;
  counterpartyInReview_SHORTEST_GT?: number | null;
  counterpartyInReview_SHORTEST_GTE?: number | null;
  counterpartyInReview_SHORTEST_LT?: number | null;
  counterpartyInReview_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  lastStatusChangeDate_EQUAL?: any | null;
  lastStatusChangeDate_GT?: any | null;
  lastStatusChangeDate_GTE?: any | null;
  lastStatusChangeDate_LT?: any | null;
  lastStatusChangeDate_LTE?: any | null;
  lastStatusChangeDate_MAX_EQUAL?: any | null;
  lastStatusChangeDate_MAX_GT?: any | null;
  lastStatusChangeDate_MAX_GTE?: any | null;
  lastStatusChangeDate_MAX_LT?: any | null;
  lastStatusChangeDate_MAX_LTE?: any | null;
  lastStatusChangeDate_MIN_EQUAL?: any | null;
  lastStatusChangeDate_MIN_GT?: any | null;
  lastStatusChangeDate_MIN_GTE?: any | null;
  lastStatusChangeDate_MIN_LT?: any | null;
  lastStatusChangeDate_MIN_LTE?: any | null;
  patientInitials_AVERAGE_EQUAL?: number | null;
  patientInitials_AVERAGE_GT?: number | null;
  patientInitials_AVERAGE_GTE?: number | null;
  patientInitials_AVERAGE_LT?: number | null;
  patientInitials_AVERAGE_LTE?: number | null;
  patientInitials_EQUAL?: string | null;
  patientInitials_GT?: number | null;
  patientInitials_GTE?: number | null;
  patientInitials_LONGEST_EQUAL?: number | null;
  patientInitials_LONGEST_GT?: number | null;
  patientInitials_LONGEST_GTE?: number | null;
  patientInitials_LONGEST_LT?: number | null;
  patientInitials_LONGEST_LTE?: number | null;
  patientInitials_LT?: number | null;
  patientInitials_LTE?: number | null;
  patientInitials_SHORTEST_EQUAL?: number | null;
  patientInitials_SHORTEST_GT?: number | null;
  patientInitials_SHORTEST_GTE?: number | null;
  patientInitials_SHORTEST_LT?: number | null;
  patientInitials_SHORTEST_LTE?: number | null;
  patientInsuranceId_AVERAGE_EQUAL?: number | null;
  patientInsuranceId_AVERAGE_GT?: number | null;
  patientInsuranceId_AVERAGE_GTE?: number | null;
  patientInsuranceId_AVERAGE_LT?: number | null;
  patientInsuranceId_AVERAGE_LTE?: number | null;
  patientInsuranceId_EQUAL?: string | null;
  patientInsuranceId_GT?: number | null;
  patientInsuranceId_GTE?: number | null;
  patientInsuranceId_LONGEST_EQUAL?: number | null;
  patientInsuranceId_LONGEST_GT?: number | null;
  patientInsuranceId_LONGEST_GTE?: number | null;
  patientInsuranceId_LONGEST_LT?: number | null;
  patientInsuranceId_LONGEST_LTE?: number | null;
  patientInsuranceId_LT?: number | null;
  patientInsuranceId_LTE?: number | null;
  patientInsuranceId_SHORTEST_EQUAL?: number | null;
  patientInsuranceId_SHORTEST_GT?: number | null;
  patientInsuranceId_SHORTEST_GTE?: number | null;
  patientInsuranceId_SHORTEST_LT?: number | null;
  patientInsuranceId_SHORTEST_LTE?: number | null;
  preparationBrandName_AVERAGE_EQUAL?: number | null;
  preparationBrandName_AVERAGE_GT?: number | null;
  preparationBrandName_AVERAGE_GTE?: number | null;
  preparationBrandName_AVERAGE_LT?: number | null;
  preparationBrandName_AVERAGE_LTE?: number | null;
  preparationBrandName_EQUAL?: string | null;
  preparationBrandName_GT?: number | null;
  preparationBrandName_GTE?: number | null;
  preparationBrandName_LONGEST_EQUAL?: number | null;
  preparationBrandName_LONGEST_GT?: number | null;
  preparationBrandName_LONGEST_GTE?: number | null;
  preparationBrandName_LONGEST_LT?: number | null;
  preparationBrandName_LONGEST_LTE?: number | null;
  preparationBrandName_LT?: number | null;
  preparationBrandName_LTE?: number | null;
  preparationBrandName_SHORTEST_EQUAL?: number | null;
  preparationBrandName_SHORTEST_GT?: number | null;
  preparationBrandName_SHORTEST_GTE?: number | null;
  preparationBrandName_SHORTEST_LT?: number | null;
  preparationBrandName_SHORTEST_LTE?: number | null;
  preparationGenericName_AVERAGE_EQUAL?: number | null;
  preparationGenericName_AVERAGE_GT?: number | null;
  preparationGenericName_AVERAGE_GTE?: number | null;
  preparationGenericName_AVERAGE_LT?: number | null;
  preparationGenericName_AVERAGE_LTE?: number | null;
  preparationGenericName_EQUAL?: string | null;
  preparationGenericName_GT?: number | null;
  preparationGenericName_GTE?: number | null;
  preparationGenericName_LONGEST_EQUAL?: number | null;
  preparationGenericName_LONGEST_GT?: number | null;
  preparationGenericName_LONGEST_GTE?: number | null;
  preparationGenericName_LONGEST_LT?: number | null;
  preparationGenericName_LONGEST_LTE?: number | null;
  preparationGenericName_LT?: number | null;
  preparationGenericName_LTE?: number | null;
  preparationGenericName_SHORTEST_EQUAL?: number | null;
  preparationGenericName_SHORTEST_GT?: number | null;
  preparationGenericName_SHORTEST_GTE?: number | null;
  preparationGenericName_SHORTEST_LT?: number | null;
  preparationGenericName_SHORTEST_LTE?: number | null;
  sourceTenantId_AVERAGE_EQUAL?: number | null;
  sourceTenantId_AVERAGE_GT?: number | null;
  sourceTenantId_AVERAGE_GTE?: number | null;
  sourceTenantId_AVERAGE_LT?: number | null;
  sourceTenantId_AVERAGE_LTE?: number | null;
  sourceTenantId_EQUAL?: string | null;
  sourceTenantId_GT?: number | null;
  sourceTenantId_GTE?: number | null;
  sourceTenantId_LONGEST_EQUAL?: number | null;
  sourceTenantId_LONGEST_GT?: number | null;
  sourceTenantId_LONGEST_GTE?: number | null;
  sourceTenantId_LONGEST_LT?: number | null;
  sourceTenantId_LONGEST_LTE?: number | null;
  sourceTenantId_LT?: number | null;
  sourceTenantId_LTE?: number | null;
  sourceTenantId_SHORTEST_EQUAL?: number | null;
  sourceTenantId_SHORTEST_GT?: number | null;
  sourceTenantId_SHORTEST_GTE?: number | null;
  sourceTenantId_SHORTEST_LT?: number | null;
  sourceTenantId_SHORTEST_LTE?: number | null;
  submissionDate_EQUAL?: any | null;
  submissionDate_GT?: any | null;
  submissionDate_GTE?: any | null;
  submissionDate_LT?: any | null;
  submissionDate_LTE?: any | null;
  submissionDate_MAX_EQUAL?: any | null;
  submissionDate_MAX_GT?: any | null;
  submissionDate_MAX_GTE?: any | null;
  submissionDate_MAX_LT?: any | null;
  submissionDate_MAX_LTE?: any | null;
  submissionDate_MIN_EQUAL?: any | null;
  submissionDate_MIN_GT?: any | null;
  submissionDate_MIN_GTE?: any | null;
  submissionDate_MIN_LT?: any | null;
  submissionDate_MIN_LTE?: any | null;
  suspensionReason_AVERAGE_EQUAL?: number | null;
  suspensionReason_AVERAGE_GT?: number | null;
  suspensionReason_AVERAGE_GTE?: number | null;
  suspensionReason_AVERAGE_LT?: number | null;
  suspensionReason_AVERAGE_LTE?: number | null;
  suspensionReason_EQUAL?: string | null;
  suspensionReason_GT?: number | null;
  suspensionReason_GTE?: number | null;
  suspensionReason_LONGEST_EQUAL?: number | null;
  suspensionReason_LONGEST_GT?: number | null;
  suspensionReason_LONGEST_GTE?: number | null;
  suspensionReason_LONGEST_LT?: number | null;
  suspensionReason_LONGEST_LTE?: number | null;
  suspensionReason_LT?: number | null;
  suspensionReason_LTE?: number | null;
  suspensionReason_SHORTEST_EQUAL?: number | null;
  suspensionReason_SHORTEST_GT?: number | null;
  suspensionReason_SHORTEST_GTE?: number | null;
  suspensionReason_SHORTEST_LT?: number | null;
  suspensionReason_SHORTEST_LTE?: number | null;
  totalAmount_AVERAGE_EQUAL?: number | null;
  totalAmount_AVERAGE_GT?: number | null;
  totalAmount_AVERAGE_GTE?: number | null;
  totalAmount_AVERAGE_LT?: number | null;
  totalAmount_AVERAGE_LTE?: number | null;
  totalAmount_EQUAL?: number | null;
  totalAmount_GT?: number | null;
  totalAmount_GTE?: number | null;
  totalAmount_LT?: number | null;
  totalAmount_LTE?: number | null;
  totalAmount_MAX_EQUAL?: number | null;
  totalAmount_MAX_GT?: number | null;
  totalAmount_MAX_GTE?: number | null;
  totalAmount_MAX_LT?: number | null;
  totalAmount_MAX_LTE?: number | null;
  totalAmount_MIN_EQUAL?: number | null;
  totalAmount_MIN_GT?: number | null;
  totalAmount_MIN_GTE?: number | null;
  totalAmount_MIN_LT?: number | null;
  totalAmount_MIN_LTE?: number | null;
  totalAmount_SUM_EQUAL?: number | null;
  totalAmount_SUM_GT?: number | null;
  totalAmount_SUM_GTE?: number | null;
  totalAmount_SUM_LT?: number | null;
  totalAmount_SUM_LTE?: number | null;
  unlimited_AVERAGE_EQUAL?: number | null;
  unlimited_AVERAGE_GT?: number | null;
  unlimited_AVERAGE_GTE?: number | null;
  unlimited_AVERAGE_LT?: number | null;
  unlimited_AVERAGE_LTE?: number | null;
  unlimited_EQUAL?: number | null;
  unlimited_GT?: number | null;
  unlimited_GTE?: number | null;
  unlimited_LT?: number | null;
  unlimited_LTE?: number | null;
  unlimited_MAX_EQUAL?: number | null;
  unlimited_MAX_GT?: number | null;
  unlimited_MAX_GTE?: number | null;
  unlimited_MAX_LT?: number | null;
  unlimited_MAX_LTE?: number | null;
  unlimited_MIN_EQUAL?: number | null;
  unlimited_MIN_GT?: number | null;
  unlimited_MIN_GTE?: number | null;
  unlimited_MIN_LT?: number | null;
  unlimited_MIN_LTE?: number | null;
  unlimited_SUM_EQUAL?: number | null;
  unlimited_SUM_GT?: number | null;
  unlimited_SUM_GTE?: number | null;
  unlimited_SUM_LT?: number | null;
  unlimited_SUM_LTE?: number | null;
}

export interface PatientWhere {
  AND?: PatientWhere[] | null;
  OR?: PatientWhere[] | null;
  assignedFlexEntities?: FlexEntityWhere | null;
  assignedFlexEntitiesAggregate?: PatientAssignedFlexEntitiesAggregateInput | null;
  assignedFlexEntitiesConnection?: PatientAssignedFlexEntitiesConnectionWhere | null;
  assignedFlexEntitiesConnection_NOT?: PatientAssignedFlexEntitiesConnectionWhere | null;
  assignedFlexEntities_NOT?: FlexEntityWhere | null;
  cases?: CaseWhere | null;
  casesAggregate?: PatientCasesAggregateInput | null;
  casesConnection?: PatientCasesConnectionWhere | null;
  casesConnection_NOT?: PatientCasesConnectionWhere | null;
  cases_NOT?: CaseWhere | null;
  id?: string | null;
  id_CONTAINS?: string | null;
  id_ENDS_WITH?: string | null;
  id_IN?: (string | null)[] | null;
  id_MATCHES?: string | null;
  id_NOT?: string | null;
  id_NOT_CONTAINS?: string | null;
  id_NOT_ENDS_WITH?: string | null;
  id_NOT_IN?: (string | null)[] | null;
  id_NOT_STARTS_WITH?: string | null;
  id_STARTS_WITH?: string | null;
  initials?: string | null;
  initials_CONTAINS?: string | null;
  initials_ENDS_WITH?: string | null;
  initials_IN?: (string | null)[] | null;
  initials_MATCHES?: string | null;
  initials_NOT?: string | null;
  initials_NOT_CONTAINS?: string | null;
  initials_NOT_ENDS_WITH?: string | null;
  initials_NOT_IN?: (string | null)[] | null;
  initials_NOT_STARTS_WITH?: string | null;
  initials_STARTS_WITH?: string | null;
  insuranceId?: string | null;
  insuranceId_CONTAINS?: string | null;
  insuranceId_ENDS_WITH?: string | null;
  insuranceId_IN?: (string | null)[] | null;
  insuranceId_MATCHES?: string | null;
  insuranceId_NOT?: string | null;
  insuranceId_NOT_CONTAINS?: string | null;
  insuranceId_NOT_ENDS_WITH?: string | null;
  insuranceId_NOT_IN?: (string | null)[] | null;
  insuranceId_NOT_STARTS_WITH?: string | null;
  insuranceId_STARTS_WITH?: string | null;
  tenantId?: string | null;
  tenantId_CONTAINS?: string | null;
  tenantId_ENDS_WITH?: string | null;
  tenantId_IN?: (string | null)[] | null;
  tenantId_MATCHES?: string | null;
  tenantId_NOT?: string | null;
  tenantId_NOT_CONTAINS?: string | null;
  tenantId_NOT_ENDS_WITH?: string | null;
  tenantId_NOT_IN?: (string | null)[] | null;
  tenantId_NOT_STARTS_WITH?: string | null;
  tenantId_STARTS_WITH?: string | null;
  timeStamp?: any | null;
  timeStamp_GT?: any | null;
  timeStamp_GTE?: any | null;
  timeStamp_IN?: (any | null)[] | null;
  timeStamp_LT?: any | null;
  timeStamp_LTE?: any | null;
  timeStamp_NOT?: any | null;
  timeStamp_NOT_IN?: (any | null)[] | null;
  yearOfBirth?: number | null;
  yearOfBirth_GT?: number | null;
  yearOfBirth_GTE?: number | null;
  yearOfBirth_IN?: (number | null)[] | null;
  yearOfBirth_LT?: number | null;
  yearOfBirth_LTE?: number | null;
  yearOfBirth_NOT?: number | null;
  yearOfBirth_NOT_IN?: (number | null)[] | null;
}

export interface PreparationBrandAggregateInput {
  AND?: PreparationBrandAggregateInput[] | null;
  OR?: PreparationBrandAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: PreparationBrandNodeAggregationWhereInput | null;
}

export interface PreparationBrandConnectionWhere {
  AND?: PreparationBrandConnectionWhere[] | null;
  OR?: PreparationBrandConnectionWhere[] | null;
  node?: BrandWhere | null;
  node_NOT?: BrandWhere | null;
}

export interface PreparationBrandNodeAggregationWhereInput {
  AND?: PreparationBrandNodeAggregationWhereInput[] | null;
  Name_AVERAGE_EQUAL?: number | null;
  Name_AVERAGE_GT?: number | null;
  Name_AVERAGE_GTE?: number | null;
  Name_AVERAGE_LT?: number | null;
  Name_AVERAGE_LTE?: number | null;
  Name_EQUAL?: string | null;
  Name_GT?: number | null;
  Name_GTE?: number | null;
  Name_LONGEST_EQUAL?: number | null;
  Name_LONGEST_GT?: number | null;
  Name_LONGEST_GTE?: number | null;
  Name_LONGEST_LT?: number | null;
  Name_LONGEST_LTE?: number | null;
  Name_LT?: number | null;
  Name_LTE?: number | null;
  Name_SHORTEST_EQUAL?: number | null;
  Name_SHORTEST_GT?: number | null;
  Name_SHORTEST_GTE?: number | null;
  Name_SHORTEST_LT?: number | null;
  Name_SHORTEST_LTE?: number | null;
  OR?: PreparationBrandNodeAggregationWhereInput[] | null;
  id_EQUAL?: string | null;
}

export interface PreparationCountriesAggregateInput {
  AND?: PreparationCountriesAggregateInput[] | null;
  OR?: PreparationCountriesAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: PreparationCountriesNodeAggregationWhereInput | null;
}

export interface PreparationCountriesConnectionWhere {
  AND?: PreparationCountriesConnectionWhere[] | null;
  OR?: PreparationCountriesConnectionWhere[] | null;
  node?: CountryWhere | null;
  node_NOT?: CountryWhere | null;
}

export interface PreparationCountriesNodeAggregationWhereInput {
  AND?: PreparationCountriesNodeAggregationWhereInput[] | null;
  OR?: PreparationCountriesNodeAggregationWhereInput[] | null;
  alpha2Code_AVERAGE_EQUAL?: number | null;
  alpha2Code_AVERAGE_GT?: number | null;
  alpha2Code_AVERAGE_GTE?: number | null;
  alpha2Code_AVERAGE_LT?: number | null;
  alpha2Code_AVERAGE_LTE?: number | null;
  alpha2Code_EQUAL?: string | null;
  alpha2Code_GT?: number | null;
  alpha2Code_GTE?: number | null;
  alpha2Code_LONGEST_EQUAL?: number | null;
  alpha2Code_LONGEST_GT?: number | null;
  alpha2Code_LONGEST_GTE?: number | null;
  alpha2Code_LONGEST_LT?: number | null;
  alpha2Code_LONGEST_LTE?: number | null;
  alpha2Code_LT?: number | null;
  alpha2Code_LTE?: number | null;
  alpha2Code_SHORTEST_EQUAL?: number | null;
  alpha2Code_SHORTEST_GT?: number | null;
  alpha2Code_SHORTEST_GTE?: number | null;
  alpha2Code_SHORTEST_LT?: number | null;
  alpha2Code_SHORTEST_LTE?: number | null;
  alpha3Code_AVERAGE_EQUAL?: number | null;
  alpha3Code_AVERAGE_GT?: number | null;
  alpha3Code_AVERAGE_GTE?: number | null;
  alpha3Code_AVERAGE_LT?: number | null;
  alpha3Code_AVERAGE_LTE?: number | null;
  alpha3Code_EQUAL?: string | null;
  alpha3Code_GT?: number | null;
  alpha3Code_GTE?: number | null;
  alpha3Code_LONGEST_EQUAL?: number | null;
  alpha3Code_LONGEST_GT?: number | null;
  alpha3Code_LONGEST_GTE?: number | null;
  alpha3Code_LONGEST_LT?: number | null;
  alpha3Code_LONGEST_LTE?: number | null;
  alpha3Code_LT?: number | null;
  alpha3Code_LTE?: number | null;
  alpha3Code_SHORTEST_EQUAL?: number | null;
  alpha3Code_SHORTEST_GT?: number | null;
  alpha3Code_SHORTEST_GTE?: number | null;
  alpha3Code_SHORTEST_LT?: number | null;
  alpha3Code_SHORTEST_LTE?: number | null;
  flag_AVERAGE_EQUAL?: number | null;
  flag_AVERAGE_GT?: number | null;
  flag_AVERAGE_GTE?: number | null;
  flag_AVERAGE_LT?: number | null;
  flag_AVERAGE_LTE?: number | null;
  flag_EQUAL?: string | null;
  flag_GT?: number | null;
  flag_GTE?: number | null;
  flag_LONGEST_EQUAL?: number | null;
  flag_LONGEST_GT?: number | null;
  flag_LONGEST_GTE?: number | null;
  flag_LONGEST_LT?: number | null;
  flag_LONGEST_LTE?: number | null;
  flag_LT?: number | null;
  flag_LTE?: number | null;
  flag_SHORTEST_EQUAL?: number | null;
  flag_SHORTEST_GT?: number | null;
  flag_SHORTEST_GTE?: number | null;
  flag_SHORTEST_LT?: number | null;
  flag_SHORTEST_LTE?: number | null;
  name_AVERAGE_EQUAL?: number | null;
  name_AVERAGE_GT?: number | null;
  name_AVERAGE_GTE?: number | null;
  name_AVERAGE_LT?: number | null;
  name_AVERAGE_LTE?: number | null;
  name_EQUAL?: string | null;
  name_GT?: number | null;
  name_GTE?: number | null;
  name_LONGEST_EQUAL?: number | null;
  name_LONGEST_GT?: number | null;
  name_LONGEST_GTE?: number | null;
  name_LONGEST_LT?: number | null;
  name_LONGEST_LTE?: number | null;
  name_LT?: number | null;
  name_LTE?: number | null;
  name_SHORTEST_EQUAL?: number | null;
  name_SHORTEST_GT?: number | null;
  name_SHORTEST_GTE?: number | null;
  name_SHORTEST_LT?: number | null;
  name_SHORTEST_LTE?: number | null;
  numericCode_AVERAGE_EQUAL?: number | null;
  numericCode_AVERAGE_GT?: number | null;
  numericCode_AVERAGE_GTE?: number | null;
  numericCode_AVERAGE_LT?: number | null;
  numericCode_AVERAGE_LTE?: number | null;
  numericCode_EQUAL?: string | null;
  numericCode_GT?: number | null;
  numericCode_GTE?: number | null;
  numericCode_LONGEST_EQUAL?: number | null;
  numericCode_LONGEST_GT?: number | null;
  numericCode_LONGEST_GTE?: number | null;
  numericCode_LONGEST_LT?: number | null;
  numericCode_LONGEST_LTE?: number | null;
  numericCode_LT?: number | null;
  numericCode_LTE?: number | null;
  numericCode_SHORTEST_EQUAL?: number | null;
  numericCode_SHORTEST_GT?: number | null;
  numericCode_SHORTEST_GTE?: number | null;
  numericCode_SHORTEST_LT?: number | null;
  numericCode_SHORTEST_LTE?: number | null;
}

export interface PreparationGenericAggregateInput {
  AND?: PreparationGenericAggregateInput[] | null;
  OR?: PreparationGenericAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: PreparationGenericNodeAggregationWhereInput | null;
}

export interface PreparationGenericConnectionWhere {
  AND?: PreparationGenericConnectionWhere[] | null;
  OR?: PreparationGenericConnectionWhere[] | null;
  node?: GenericWhere | null;
  node_NOT?: GenericWhere | null;
}

export interface PreparationGenericNodeAggregationWhereInput {
  AND?: PreparationGenericNodeAggregationWhereInput[] | null;
  Name_AVERAGE_EQUAL?: number | null;
  Name_AVERAGE_GT?: number | null;
  Name_AVERAGE_GTE?: number | null;
  Name_AVERAGE_LT?: number | null;
  Name_AVERAGE_LTE?: number | null;
  Name_EQUAL?: string | null;
  Name_GT?: number | null;
  Name_GTE?: number | null;
  Name_LONGEST_EQUAL?: number | null;
  Name_LONGEST_GT?: number | null;
  Name_LONGEST_GTE?: number | null;
  Name_LONGEST_LT?: number | null;
  Name_LONGEST_LTE?: number | null;
  Name_LT?: number | null;
  Name_LTE?: number | null;
  Name_SHORTEST_EQUAL?: number | null;
  Name_SHORTEST_GT?: number | null;
  Name_SHORTEST_GTE?: number | null;
  Name_SHORTEST_LT?: number | null;
  Name_SHORTEST_LTE?: number | null;
  OR?: PreparationGenericNodeAggregationWhereInput[] | null;
  id_EQUAL?: string | null;
}

export interface PreparationHasLimitationsAggregateInput {
  AND?: PreparationHasLimitationsAggregateInput[] | null;
  OR?: PreparationHasLimitationsAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: PreparationHasLimitationsNodeAggregationWhereInput | null;
}

export interface PreparationHasLimitationsConnectionWhere {
  AND?: PreparationHasLimitationsConnectionWhere[] | null;
  OR?: PreparationHasLimitationsConnectionWhere[] | null;
  node?: LimitationWhere | null;
  node_NOT?: LimitationWhere | null;
}

export interface PreparationHasLimitationsNodeAggregationWhereInput {
  AND?: PreparationHasLimitationsNodeAggregationWhereInput[] | null;
  Code_AVERAGE_EQUAL?: number | null;
  Code_AVERAGE_GT?: number | null;
  Code_AVERAGE_GTE?: number | null;
  Code_AVERAGE_LT?: number | null;
  Code_AVERAGE_LTE?: number | null;
  Code_EQUAL?: string | null;
  Code_GT?: number | null;
  Code_GTE?: number | null;
  Code_LONGEST_EQUAL?: number | null;
  Code_LONGEST_GT?: number | null;
  Code_LONGEST_GTE?: number | null;
  Code_LONGEST_LT?: number | null;
  Code_LONGEST_LTE?: number | null;
  Code_LT?: number | null;
  Code_LTE?: number | null;
  Code_SHORTEST_EQUAL?: number | null;
  Code_SHORTEST_GT?: number | null;
  Code_SHORTEST_GTE?: number | null;
  Code_SHORTEST_LT?: number | null;
  Code_SHORTEST_LTE?: number | null;
  DescriptionDe_AVERAGE_EQUAL?: number | null;
  DescriptionDe_AVERAGE_GT?: number | null;
  DescriptionDe_AVERAGE_GTE?: number | null;
  DescriptionDe_AVERAGE_LT?: number | null;
  DescriptionDe_AVERAGE_LTE?: number | null;
  DescriptionDe_EQUAL?: string | null;
  DescriptionDe_GT?: number | null;
  DescriptionDe_GTE?: number | null;
  DescriptionDe_LONGEST_EQUAL?: number | null;
  DescriptionDe_LONGEST_GT?: number | null;
  DescriptionDe_LONGEST_GTE?: number | null;
  DescriptionDe_LONGEST_LT?: number | null;
  DescriptionDe_LONGEST_LTE?: number | null;
  DescriptionDe_LT?: number | null;
  DescriptionDe_LTE?: number | null;
  DescriptionDe_SHORTEST_EQUAL?: number | null;
  DescriptionDe_SHORTEST_GT?: number | null;
  DescriptionDe_SHORTEST_GTE?: number | null;
  DescriptionDe_SHORTEST_LT?: number | null;
  DescriptionDe_SHORTEST_LTE?: number | null;
  DescriptionEn_AVERAGE_EQUAL?: number | null;
  DescriptionEn_AVERAGE_GT?: number | null;
  DescriptionEn_AVERAGE_GTE?: number | null;
  DescriptionEn_AVERAGE_LT?: number | null;
  DescriptionEn_AVERAGE_LTE?: number | null;
  DescriptionEn_EQUAL?: string | null;
  DescriptionEn_GT?: number | null;
  DescriptionEn_GTE?: number | null;
  DescriptionEn_LONGEST_EQUAL?: number | null;
  DescriptionEn_LONGEST_GT?: number | null;
  DescriptionEn_LONGEST_GTE?: number | null;
  DescriptionEn_LONGEST_LT?: number | null;
  DescriptionEn_LONGEST_LTE?: number | null;
  DescriptionEn_LT?: number | null;
  DescriptionEn_LTE?: number | null;
  DescriptionEn_SHORTEST_EQUAL?: number | null;
  DescriptionEn_SHORTEST_GT?: number | null;
  DescriptionEn_SHORTEST_GTE?: number | null;
  DescriptionEn_SHORTEST_LT?: number | null;
  DescriptionEn_SHORTEST_LTE?: number | null;
  Niveau_AVERAGE_EQUAL?: number | null;
  Niveau_AVERAGE_GT?: number | null;
  Niveau_AVERAGE_GTE?: number | null;
  Niveau_AVERAGE_LT?: number | null;
  Niveau_AVERAGE_LTE?: number | null;
  Niveau_EQUAL?: string | null;
  Niveau_GT?: number | null;
  Niveau_GTE?: number | null;
  Niveau_LONGEST_EQUAL?: number | null;
  Niveau_LONGEST_GT?: number | null;
  Niveau_LONGEST_GTE?: number | null;
  Niveau_LONGEST_LT?: number | null;
  Niveau_LONGEST_LTE?: number | null;
  Niveau_LT?: number | null;
  Niveau_LTE?: number | null;
  Niveau_SHORTEST_EQUAL?: number | null;
  Niveau_SHORTEST_GT?: number | null;
  Niveau_SHORTEST_GTE?: number | null;
  Niveau_SHORTEST_LT?: number | null;
  Niveau_SHORTEST_LTE?: number | null;
  OR?: PreparationHasLimitationsNodeAggregationWhereInput[] | null;
  Type_AVERAGE_EQUAL?: number | null;
  Type_AVERAGE_GT?: number | null;
  Type_AVERAGE_GTE?: number | null;
  Type_AVERAGE_LT?: number | null;
  Type_AVERAGE_LTE?: number | null;
  Type_EQUAL?: string | null;
  Type_GT?: number | null;
  Type_GTE?: number | null;
  Type_LONGEST_EQUAL?: number | null;
  Type_LONGEST_GT?: number | null;
  Type_LONGEST_GTE?: number | null;
  Type_LONGEST_LT?: number | null;
  Type_LONGEST_LTE?: number | null;
  Type_LT?: number | null;
  Type_LTE?: number | null;
  Type_SHORTEST_EQUAL?: number | null;
  Type_SHORTEST_GT?: number | null;
  Type_SHORTEST_GTE?: number | null;
  Type_SHORTEST_LT?: number | null;
  Type_SHORTEST_LTE?: number | null;
  uuid_EQUAL?: string | null;
}

export interface PreparationRegulatesAggregateInput {
  AND?: PreparationRegulatesAggregateInput[] | null;
  OR?: PreparationRegulatesAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: PreparationRegulatesNodeAggregationWhereInput | null;
}

export interface PreparationRegulatesConnectionWhere {
  AND?: PreparationRegulatesConnectionWhere[] | null;
  OR?: PreparationRegulatesConnectionWhere[] | null;
  node?: TreatmentWhere | null;
  node_NOT?: TreatmentWhere | null;
}

export interface PreparationRegulatesNodeAggregationWhereInput {
  AND?: PreparationRegulatesNodeAggregationWhereInput[] | null;
  BagDossierNo_AVERAGE_EQUAL?: number | null;
  BagDossierNo_AVERAGE_GT?: number | null;
  BagDossierNo_AVERAGE_GTE?: number | null;
  BagDossierNo_AVERAGE_LT?: number | null;
  BagDossierNo_AVERAGE_LTE?: number | null;
  BagDossierNo_EQUAL?: string | null;
  BagDossierNo_GT?: number | null;
  BagDossierNo_GTE?: number | null;
  BagDossierNo_LONGEST_EQUAL?: number | null;
  BagDossierNo_LONGEST_GT?: number | null;
  BagDossierNo_LONGEST_GTE?: number | null;
  BagDossierNo_LONGEST_LT?: number | null;
  BagDossierNo_LONGEST_LTE?: number | null;
  BagDossierNo_LT?: number | null;
  BagDossierNo_LTE?: number | null;
  BagDossierNo_SHORTEST_EQUAL?: number | null;
  BagDossierNo_SHORTEST_GT?: number | null;
  BagDossierNo_SHORTEST_GTE?: number | null;
  BagDossierNo_SHORTEST_LT?: number | null;
  BagDossierNo_SHORTEST_LTE?: number | null;
  Code_AVERAGE_EQUAL?: number | null;
  Code_AVERAGE_GT?: number | null;
  Code_AVERAGE_GTE?: number | null;
  Code_AVERAGE_LT?: number | null;
  Code_AVERAGE_LTE?: number | null;
  Code_EQUAL?: string | null;
  Code_GT?: number | null;
  Code_GTE?: number | null;
  Code_LONGEST_EQUAL?: number | null;
  Code_LONGEST_GT?: number | null;
  Code_LONGEST_GTE?: number | null;
  Code_LONGEST_LT?: number | null;
  Code_LONGEST_LTE?: number | null;
  Code_LT?: number | null;
  Code_LTE?: number | null;
  Code_SHORTEST_EQUAL?: number | null;
  Code_SHORTEST_GT?: number | null;
  Code_SHORTEST_GTE?: number | null;
  Code_SHORTEST_LT?: number | null;
  Code_SHORTEST_LTE?: number | null;
  FlagModal_AVERAGE_EQUAL?: number | null;
  FlagModal_AVERAGE_GT?: number | null;
  FlagModal_AVERAGE_GTE?: number | null;
  FlagModal_AVERAGE_LT?: number | null;
  FlagModal_AVERAGE_LTE?: number | null;
  FlagModal_EQUAL?: string | null;
  FlagModal_GT?: number | null;
  FlagModal_GTE?: number | null;
  FlagModal_LONGEST_EQUAL?: number | null;
  FlagModal_LONGEST_GT?: number | null;
  FlagModal_LONGEST_GTE?: number | null;
  FlagModal_LONGEST_LT?: number | null;
  FlagModal_LONGEST_LTE?: number | null;
  FlagModal_LT?: number | null;
  FlagModal_LTE?: number | null;
  FlagModal_SHORTEST_EQUAL?: number | null;
  FlagModal_SHORTEST_GT?: number | null;
  FlagModal_SHORTEST_GTE?: number | null;
  FlagModal_SHORTEST_LT?: number | null;
  FlagModal_SHORTEST_LTE?: number | null;
  FlagNarcosis_AVERAGE_EQUAL?: number | null;
  FlagNarcosis_AVERAGE_GT?: number | null;
  FlagNarcosis_AVERAGE_GTE?: number | null;
  FlagNarcosis_AVERAGE_LT?: number | null;
  FlagNarcosis_AVERAGE_LTE?: number | null;
  FlagNarcosis_EQUAL?: string | null;
  FlagNarcosis_GT?: number | null;
  FlagNarcosis_GTE?: number | null;
  FlagNarcosis_LONGEST_EQUAL?: number | null;
  FlagNarcosis_LONGEST_GT?: number | null;
  FlagNarcosis_LONGEST_GTE?: number | null;
  FlagNarcosis_LONGEST_LT?: number | null;
  FlagNarcosis_LONGEST_LTE?: number | null;
  FlagNarcosis_LT?: number | null;
  FlagNarcosis_LTE?: number | null;
  FlagNarcosis_SHORTEST_EQUAL?: number | null;
  FlagNarcosis_SHORTEST_GT?: number | null;
  FlagNarcosis_SHORTEST_GTE?: number | null;
  FlagNarcosis_SHORTEST_LT?: number | null;
  FlagNarcosis_SHORTEST_LTE?: number | null;
  GTIN_AVERAGE_EQUAL?: number | null;
  GTIN_AVERAGE_GT?: number | null;
  GTIN_AVERAGE_GTE?: number | null;
  GTIN_AVERAGE_LT?: number | null;
  GTIN_AVERAGE_LTE?: number | null;
  GTIN_EQUAL?: string | null;
  GTIN_GT?: number | null;
  GTIN_GTE?: number | null;
  GTIN_LONGEST_EQUAL?: number | null;
  GTIN_LONGEST_GT?: number | null;
  GTIN_LONGEST_GTE?: number | null;
  GTIN_LONGEST_LT?: number | null;
  GTIN_LONGEST_LTE?: number | null;
  GTIN_LT?: number | null;
  GTIN_LTE?: number | null;
  GTIN_SHORTEST_EQUAL?: number | null;
  GTIN_SHORTEST_GT?: number | null;
  GTIN_SHORTEST_GTE?: number | null;
  GTIN_SHORTEST_LT?: number | null;
  GTIN_SHORTEST_LTE?: number | null;
  LOT_AVERAGE_EQUAL?: number | null;
  LOT_AVERAGE_GT?: number | null;
  LOT_AVERAGE_GTE?: number | null;
  LOT_AVERAGE_LT?: number | null;
  LOT_AVERAGE_LTE?: number | null;
  LOT_EQUAL?: string | null;
  LOT_GT?: number | null;
  LOT_GTE?: number | null;
  LOT_LONGEST_EQUAL?: number | null;
  LOT_LONGEST_GT?: number | null;
  LOT_LONGEST_GTE?: number | null;
  LOT_LONGEST_LT?: number | null;
  LOT_LONGEST_LTE?: number | null;
  LOT_LT?: number | null;
  LOT_LTE?: number | null;
  LOT_SHORTEST_EQUAL?: number | null;
  LOT_SHORTEST_GT?: number | null;
  LOT_SHORTEST_GTE?: number | null;
  LOT_SHORTEST_LT?: number | null;
  LOT_SHORTEST_LTE?: number | null;
  Name_AVERAGE_EQUAL?: number | null;
  Name_AVERAGE_GT?: number | null;
  Name_AVERAGE_GTE?: number | null;
  Name_AVERAGE_LT?: number | null;
  Name_AVERAGE_LTE?: number | null;
  Name_EQUAL?: string | null;
  Name_GT?: number | null;
  Name_GTE?: number | null;
  Name_LONGEST_EQUAL?: number | null;
  Name_LONGEST_GT?: number | null;
  Name_LONGEST_GTE?: number | null;
  Name_LONGEST_LT?: number | null;
  Name_LONGEST_LTE?: number | null;
  Name_LT?: number | null;
  Name_LTE?: number | null;
  Name_SHORTEST_EQUAL?: number | null;
  Name_SHORTEST_GT?: number | null;
  Name_SHORTEST_GTE?: number | null;
  Name_SHORTEST_LT?: number | null;
  Name_SHORTEST_LTE?: number | null;
  OR?: PreparationRegulatesNodeAggregationWhereInput[] | null;
  PharmaCode_AVERAGE_EQUAL?: number | null;
  PharmaCode_AVERAGE_GT?: number | null;
  PharmaCode_AVERAGE_GTE?: number | null;
  PharmaCode_AVERAGE_LT?: number | null;
  PharmaCode_AVERAGE_LTE?: number | null;
  PharmaCode_EQUAL?: string | null;
  PharmaCode_GT?: number | null;
  PharmaCode_GTE?: number | null;
  PharmaCode_LONGEST_EQUAL?: number | null;
  PharmaCode_LONGEST_GT?: number | null;
  PharmaCode_LONGEST_GTE?: number | null;
  PharmaCode_LONGEST_LT?: number | null;
  PharmaCode_LONGEST_LTE?: number | null;
  PharmaCode_LT?: number | null;
  PharmaCode_LTE?: number | null;
  PharmaCode_SHORTEST_EQUAL?: number | null;
  PharmaCode_SHORTEST_GT?: number | null;
  PharmaCode_SHORTEST_GTE?: number | null;
  PharmaCode_SHORTEST_LT?: number | null;
  PharmaCode_SHORTEST_LTE?: number | null;
  PrevPharmacode_AVERAGE_EQUAL?: number | null;
  PrevPharmacode_AVERAGE_GT?: number | null;
  PrevPharmacode_AVERAGE_GTE?: number | null;
  PrevPharmacode_AVERAGE_LT?: number | null;
  PrevPharmacode_AVERAGE_LTE?: number | null;
  PrevPharmacode_EQUAL?: string | null;
  PrevPharmacode_GT?: number | null;
  PrevPharmacode_GTE?: number | null;
  PrevPharmacode_LONGEST_EQUAL?: number | null;
  PrevPharmacode_LONGEST_GT?: number | null;
  PrevPharmacode_LONGEST_GTE?: number | null;
  PrevPharmacode_LONGEST_LT?: number | null;
  PrevPharmacode_LONGEST_LTE?: number | null;
  PrevPharmacode_LT?: number | null;
  PrevPharmacode_LTE?: number | null;
  PrevPharmacode_SHORTEST_EQUAL?: number | null;
  PrevPharmacode_SHORTEST_GT?: number | null;
  PrevPharmacode_SHORTEST_GTE?: number | null;
  PrevPharmacode_SHORTEST_LT?: number | null;
  PrevPharmacode_SHORTEST_LTE?: number | null;
  REF_AVERAGE_EQUAL?: number | null;
  REF_AVERAGE_GT?: number | null;
  REF_AVERAGE_GTE?: number | null;
  REF_AVERAGE_LT?: number | null;
  REF_AVERAGE_LTE?: number | null;
  REF_EQUAL?: string | null;
  REF_GT?: number | null;
  REF_GTE?: number | null;
  REF_LONGEST_EQUAL?: number | null;
  REF_LONGEST_GT?: number | null;
  REF_LONGEST_GTE?: number | null;
  REF_LONGEST_LT?: number | null;
  REF_LONGEST_LTE?: number | null;
  REF_LT?: number | null;
  REF_LTE?: number | null;
  REF_SHORTEST_EQUAL?: number | null;
  REF_SHORTEST_GT?: number | null;
  REF_SHORTEST_GTE?: number | null;
  REF_SHORTEST_LT?: number | null;
  REF_SHORTEST_LTE?: number | null;
  SwissmedicCategory_AVERAGE_EQUAL?: number | null;
  SwissmedicCategory_AVERAGE_GT?: number | null;
  SwissmedicCategory_AVERAGE_GTE?: number | null;
  SwissmedicCategory_AVERAGE_LT?: number | null;
  SwissmedicCategory_AVERAGE_LTE?: number | null;
  SwissmedicCategory_EQUAL?: string | null;
  SwissmedicCategory_GT?: number | null;
  SwissmedicCategory_GTE?: number | null;
  SwissmedicCategory_LONGEST_EQUAL?: number | null;
  SwissmedicCategory_LONGEST_GT?: number | null;
  SwissmedicCategory_LONGEST_GTE?: number | null;
  SwissmedicCategory_LONGEST_LT?: number | null;
  SwissmedicCategory_LONGEST_LTE?: number | null;
  SwissmedicCategory_LT?: number | null;
  SwissmedicCategory_LTE?: number | null;
  SwissmedicCategory_SHORTEST_EQUAL?: number | null;
  SwissmedicCategory_SHORTEST_GT?: number | null;
  SwissmedicCategory_SHORTEST_GTE?: number | null;
  SwissmedicCategory_SHORTEST_LT?: number | null;
  SwissmedicCategory_SHORTEST_LTE?: number | null;
  SwissmedicNo8_AVERAGE_EQUAL?: number | null;
  SwissmedicNo8_AVERAGE_GT?: number | null;
  SwissmedicNo8_AVERAGE_GTE?: number | null;
  SwissmedicNo8_AVERAGE_LT?: number | null;
  SwissmedicNo8_AVERAGE_LTE?: number | null;
  SwissmedicNo8_EQUAL?: string | null;
  SwissmedicNo8_GT?: number | null;
  SwissmedicNo8_GTE?: number | null;
  SwissmedicNo8_LONGEST_EQUAL?: number | null;
  SwissmedicNo8_LONGEST_GT?: number | null;
  SwissmedicNo8_LONGEST_GTE?: number | null;
  SwissmedicNo8_LONGEST_LT?: number | null;
  SwissmedicNo8_LONGEST_LTE?: number | null;
  SwissmedicNo8_LT?: number | null;
  SwissmedicNo8_LTE?: number | null;
  SwissmedicNo8_SHORTEST_EQUAL?: number | null;
  SwissmedicNo8_SHORTEST_GT?: number | null;
  SwissmedicNo8_SHORTEST_GTE?: number | null;
  SwissmedicNo8_SHORTEST_LT?: number | null;
  SwissmedicNo8_SHORTEST_LTE?: number | null;
  UDI_AVERAGE_EQUAL?: number | null;
  UDI_AVERAGE_GT?: number | null;
  UDI_AVERAGE_GTE?: number | null;
  UDI_AVERAGE_LT?: number | null;
  UDI_AVERAGE_LTE?: number | null;
  UDI_EQUAL?: string | null;
  UDI_GT?: number | null;
  UDI_GTE?: number | null;
  UDI_LONGEST_EQUAL?: number | null;
  UDI_LONGEST_GT?: number | null;
  UDI_LONGEST_GTE?: number | null;
  UDI_LONGEST_LT?: number | null;
  UDI_LONGEST_LTE?: number | null;
  UDI_LT?: number | null;
  UDI_LTE?: number | null;
  UDI_SHORTEST_EQUAL?: number | null;
  UDI_SHORTEST_GT?: number | null;
  UDI_SHORTEST_GTE?: number | null;
  UDI_SHORTEST_LT?: number | null;
  UDI_SHORTEST_LTE?: number | null;
  activeIngredientQuantity_AVERAGE_EQUAL?: number | null;
  activeIngredientQuantity_AVERAGE_GT?: number | null;
  activeIngredientQuantity_AVERAGE_GTE?: number | null;
  activeIngredientQuantity_AVERAGE_LT?: number | null;
  activeIngredientQuantity_AVERAGE_LTE?: number | null;
  activeIngredientQuantity_EQUAL?: number | null;
  activeIngredientQuantity_GT?: number | null;
  activeIngredientQuantity_GTE?: number | null;
  activeIngredientQuantity_LT?: number | null;
  activeIngredientQuantity_LTE?: number | null;
  activeIngredientQuantity_MAX_EQUAL?: number | null;
  activeIngredientQuantity_MAX_GT?: number | null;
  activeIngredientQuantity_MAX_GTE?: number | null;
  activeIngredientQuantity_MAX_LT?: number | null;
  activeIngredientQuantity_MAX_LTE?: number | null;
  activeIngredientQuantity_MIN_EQUAL?: number | null;
  activeIngredientQuantity_MIN_GT?: number | null;
  activeIngredientQuantity_MIN_GTE?: number | null;
  activeIngredientQuantity_MIN_LT?: number | null;
  activeIngredientQuantity_MIN_LTE?: number | null;
  activeIngredientQuantity_SUM_EQUAL?: number | null;
  activeIngredientQuantity_SUM_GT?: number | null;
  activeIngredientQuantity_SUM_GTE?: number | null;
  activeIngredientQuantity_SUM_LT?: number | null;
  activeIngredientQuantity_SUM_LTE?: number | null;
  classificationSystem_AVERAGE_EQUAL?: number | null;
  classificationSystem_AVERAGE_GT?: number | null;
  classificationSystem_AVERAGE_GTE?: number | null;
  classificationSystem_AVERAGE_LT?: number | null;
  classificationSystem_AVERAGE_LTE?: number | null;
  classificationSystem_EQUAL?: string | null;
  classificationSystem_GT?: number | null;
  classificationSystem_GTE?: number | null;
  classificationSystem_LONGEST_EQUAL?: number | null;
  classificationSystem_LONGEST_GT?: number | null;
  classificationSystem_LONGEST_GTE?: number | null;
  classificationSystem_LONGEST_LT?: number | null;
  classificationSystem_LONGEST_LTE?: number | null;
  classificationSystem_LT?: number | null;
  classificationSystem_LTE?: number | null;
  classificationSystem_SHORTEST_EQUAL?: number | null;
  classificationSystem_SHORTEST_GT?: number | null;
  classificationSystem_SHORTEST_GTE?: number | null;
  classificationSystem_SHORTEST_LT?: number | null;
  classificationSystem_SHORTEST_LTE?: number | null;
  concentration_AVERAGE_EQUAL?: number | null;
  concentration_AVERAGE_GT?: number | null;
  concentration_AVERAGE_GTE?: number | null;
  concentration_AVERAGE_LT?: number | null;
  concentration_AVERAGE_LTE?: number | null;
  concentration_EQUAL?: string | null;
  concentration_GT?: number | null;
  concentration_GTE?: number | null;
  concentration_LONGEST_EQUAL?: number | null;
  concentration_LONGEST_GT?: number | null;
  concentration_LONGEST_GTE?: number | null;
  concentration_LONGEST_LT?: number | null;
  concentration_LONGEST_LTE?: number | null;
  concentration_LT?: number | null;
  concentration_LTE?: number | null;
  concentration_SHORTEST_EQUAL?: number | null;
  concentration_SHORTEST_GT?: number | null;
  concentration_SHORTEST_GTE?: number | null;
  concentration_SHORTEST_LT?: number | null;
  concentration_SHORTEST_LTE?: number | null;
  packVolume_AVERAGE_EQUAL?: number | null;
  packVolume_AVERAGE_GT?: number | null;
  packVolume_AVERAGE_GTE?: number | null;
  packVolume_AVERAGE_LT?: number | null;
  packVolume_AVERAGE_LTE?: number | null;
  packVolume_EQUAL?: string | null;
  packVolume_GT?: number | null;
  packVolume_GTE?: number | null;
  packVolume_LONGEST_EQUAL?: number | null;
  packVolume_LONGEST_GT?: number | null;
  packVolume_LONGEST_GTE?: number | null;
  packVolume_LONGEST_LT?: number | null;
  packVolume_LONGEST_LTE?: number | null;
  packVolume_LT?: number | null;
  packVolume_LTE?: number | null;
  packVolume_SHORTEST_EQUAL?: number | null;
  packVolume_SHORTEST_GT?: number | null;
  packVolume_SHORTEST_GTE?: number | null;
  packVolume_SHORTEST_LT?: number | null;
  packVolume_SHORTEST_LTE?: number | null;
}

export interface PreparationStatusPreparationAggregateInput {
  AND?: PreparationStatusPreparationAggregateInput[] | null;
  OR?: PreparationStatusPreparationAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: PreparationStatusPreparationNodeAggregationWhereInput | null;
}

export interface PreparationStatusPreparationConnectionWhere {
  AND?: PreparationStatusPreparationConnectionWhere[] | null;
  OR?: PreparationStatusPreparationConnectionWhere[] | null;
  node?: PreparationWhere | null;
  node_NOT?: PreparationWhere | null;
}

export interface PreparationStatusPreparationNodeAggregationWhereInput {
  AND?: PreparationStatusPreparationNodeAggregationWhereInput[] | null;
  AtcCode_AVERAGE_EQUAL?: number | null;
  AtcCode_AVERAGE_GT?: number | null;
  AtcCode_AVERAGE_GTE?: number | null;
  AtcCode_AVERAGE_LT?: number | null;
  AtcCode_AVERAGE_LTE?: number | null;
  AtcCode_EQUAL?: string | null;
  AtcCode_GT?: number | null;
  AtcCode_GTE?: number | null;
  AtcCode_LONGEST_EQUAL?: number | null;
  AtcCode_LONGEST_GT?: number | null;
  AtcCode_LONGEST_GTE?: number | null;
  AtcCode_LONGEST_LT?: number | null;
  AtcCode_LONGEST_LTE?: number | null;
  AtcCode_LT?: number | null;
  AtcCode_LTE?: number | null;
  AtcCode_SHORTEST_EQUAL?: number | null;
  AtcCode_SHORTEST_GT?: number | null;
  AtcCode_SHORTEST_GTE?: number | null;
  AtcCode_SHORTEST_LT?: number | null;
  AtcCode_SHORTEST_LTE?: number | null;
  BrandName_AVERAGE_EQUAL?: number | null;
  BrandName_AVERAGE_GT?: number | null;
  BrandName_AVERAGE_GTE?: number | null;
  BrandName_AVERAGE_LT?: number | null;
  BrandName_AVERAGE_LTE?: number | null;
  BrandName_EQUAL?: string | null;
  BrandName_GT?: number | null;
  BrandName_GTE?: number | null;
  BrandName_LONGEST_EQUAL?: number | null;
  BrandName_LONGEST_GT?: number | null;
  BrandName_LONGEST_GTE?: number | null;
  BrandName_LONGEST_LT?: number | null;
  BrandName_LONGEST_LTE?: number | null;
  BrandName_LT?: number | null;
  BrandName_LTE?: number | null;
  BrandName_SHORTEST_EQUAL?: number | null;
  BrandName_SHORTEST_GT?: number | null;
  BrandName_SHORTEST_GTE?: number | null;
  BrandName_SHORTEST_LT?: number | null;
  BrandName_SHORTEST_LTE?: number | null;
  DescriptionDe_AVERAGE_EQUAL?: number | null;
  DescriptionDe_AVERAGE_GT?: number | null;
  DescriptionDe_AVERAGE_GTE?: number | null;
  DescriptionDe_AVERAGE_LT?: number | null;
  DescriptionDe_AVERAGE_LTE?: number | null;
  DescriptionDe_EQUAL?: string | null;
  DescriptionDe_GT?: number | null;
  DescriptionDe_GTE?: number | null;
  DescriptionDe_LONGEST_EQUAL?: number | null;
  DescriptionDe_LONGEST_GT?: number | null;
  DescriptionDe_LONGEST_GTE?: number | null;
  DescriptionDe_LONGEST_LT?: number | null;
  DescriptionDe_LONGEST_LTE?: number | null;
  DescriptionDe_LT?: number | null;
  DescriptionDe_LTE?: number | null;
  DescriptionDe_SHORTEST_EQUAL?: number | null;
  DescriptionDe_SHORTEST_GT?: number | null;
  DescriptionDe_SHORTEST_GTE?: number | null;
  DescriptionDe_SHORTEST_LT?: number | null;
  DescriptionDe_SHORTEST_LTE?: number | null;
  DescriptionFr_AVERAGE_EQUAL?: number | null;
  DescriptionFr_AVERAGE_GT?: number | null;
  DescriptionFr_AVERAGE_GTE?: number | null;
  DescriptionFr_AVERAGE_LT?: number | null;
  DescriptionFr_AVERAGE_LTE?: number | null;
  DescriptionFr_EQUAL?: string | null;
  DescriptionFr_GT?: number | null;
  DescriptionFr_GTE?: number | null;
  DescriptionFr_LONGEST_EQUAL?: number | null;
  DescriptionFr_LONGEST_GT?: number | null;
  DescriptionFr_LONGEST_GTE?: number | null;
  DescriptionFr_LONGEST_LT?: number | null;
  DescriptionFr_LONGEST_LTE?: number | null;
  DescriptionFr_LT?: number | null;
  DescriptionFr_LTE?: number | null;
  DescriptionFr_SHORTEST_EQUAL?: number | null;
  DescriptionFr_SHORTEST_GT?: number | null;
  DescriptionFr_SHORTEST_GTE?: number | null;
  DescriptionFr_SHORTEST_LT?: number | null;
  DescriptionFr_SHORTEST_LTE?: number | null;
  DescriptionIt_AVERAGE_EQUAL?: number | null;
  DescriptionIt_AVERAGE_GT?: number | null;
  DescriptionIt_AVERAGE_GTE?: number | null;
  DescriptionIt_AVERAGE_LT?: number | null;
  DescriptionIt_AVERAGE_LTE?: number | null;
  DescriptionIt_EQUAL?: string | null;
  DescriptionIt_GT?: number | null;
  DescriptionIt_GTE?: number | null;
  DescriptionIt_LONGEST_EQUAL?: number | null;
  DescriptionIt_LONGEST_GT?: number | null;
  DescriptionIt_LONGEST_GTE?: number | null;
  DescriptionIt_LONGEST_LT?: number | null;
  DescriptionIt_LONGEST_LTE?: number | null;
  DescriptionIt_LT?: number | null;
  DescriptionIt_LTE?: number | null;
  DescriptionIt_SHORTEST_EQUAL?: number | null;
  DescriptionIt_SHORTEST_GT?: number | null;
  DescriptionIt_SHORTEST_GTE?: number | null;
  DescriptionIt_SHORTEST_LT?: number | null;
  DescriptionIt_SHORTEST_LTE?: number | null;
  GenericName_AVERAGE_EQUAL?: number | null;
  GenericName_AVERAGE_GT?: number | null;
  GenericName_AVERAGE_GTE?: number | null;
  GenericName_AVERAGE_LT?: number | null;
  GenericName_AVERAGE_LTE?: number | null;
  GenericName_EQUAL?: string | null;
  GenericName_GT?: number | null;
  GenericName_GTE?: number | null;
  GenericName_LONGEST_EQUAL?: number | null;
  GenericName_LONGEST_GT?: number | null;
  GenericName_LONGEST_GTE?: number | null;
  GenericName_LONGEST_LT?: number | null;
  GenericName_LONGEST_LTE?: number | null;
  GenericName_LT?: number | null;
  GenericName_LTE?: number | null;
  GenericName_SHORTEST_EQUAL?: number | null;
  GenericName_SHORTEST_GT?: number | null;
  GenericName_SHORTEST_GTE?: number | null;
  GenericName_SHORTEST_LT?: number | null;
  GenericName_SHORTEST_LTE?: number | null;
  OR?: PreparationStatusPreparationNodeAggregationWhereInput[] | null;
  SwissmedicNo5_AVERAGE_EQUAL?: number | null;
  SwissmedicNo5_AVERAGE_GT?: number | null;
  SwissmedicNo5_AVERAGE_GTE?: number | null;
  SwissmedicNo5_AVERAGE_LT?: number | null;
  SwissmedicNo5_AVERAGE_LTE?: number | null;
  SwissmedicNo5_EQUAL?: string | null;
  SwissmedicNo5_GT?: number | null;
  SwissmedicNo5_GTE?: number | null;
  SwissmedicNo5_LONGEST_EQUAL?: number | null;
  SwissmedicNo5_LONGEST_GT?: number | null;
  SwissmedicNo5_LONGEST_GTE?: number | null;
  SwissmedicNo5_LONGEST_LT?: number | null;
  SwissmedicNo5_LONGEST_LTE?: number | null;
  SwissmedicNo5_LT?: number | null;
  SwissmedicNo5_LTE?: number | null;
  SwissmedicNo5_SHORTEST_EQUAL?: number | null;
  SwissmedicNo5_SHORTEST_GT?: number | null;
  SwissmedicNo5_SHORTEST_GTE?: number | null;
  SwissmedicNo5_SHORTEST_LT?: number | null;
  SwissmedicNo5_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
}

export interface PreparationStatusWhere {
  AND?: PreparationStatusWhere[] | null;
  FlagApd?: string | null;
  FlagApd_CONTAINS?: string | null;
  FlagApd_ENDS_WITH?: string | null;
  FlagApd_IN?: (string | null)[] | null;
  FlagApd_MATCHES?: string | null;
  FlagApd_NOT?: string | null;
  FlagApd_NOT_CONTAINS?: string | null;
  FlagApd_NOT_ENDS_WITH?: string | null;
  FlagApd_NOT_IN?: (string | null)[] | null;
  FlagApd_NOT_STARTS_WITH?: string | null;
  FlagApd_STARTS_WITH?: string | null;
  IntegrationDate?: any | null;
  IntegrationDate_GT?: any | null;
  IntegrationDate_GTE?: any | null;
  IntegrationDate_IN?: (any | null)[] | null;
  IntegrationDate_LT?: any | null;
  IntegrationDate_LTE?: any | null;
  IntegrationDate_NOT?: any | null;
  IntegrationDate_NOT_IN?: (any | null)[] | null;
  OR?: PreparationStatusWhere[] | null;
  StatusTypeCodeSl?: string | null;
  StatusTypeCodeSl_CONTAINS?: string | null;
  StatusTypeCodeSl_ENDS_WITH?: string | null;
  StatusTypeCodeSl_IN?: (string | null)[] | null;
  StatusTypeCodeSl_MATCHES?: string | null;
  StatusTypeCodeSl_NOT?: string | null;
  StatusTypeCodeSl_NOT_CONTAINS?: string | null;
  StatusTypeCodeSl_NOT_ENDS_WITH?: string | null;
  StatusTypeCodeSl_NOT_IN?: (string | null)[] | null;
  StatusTypeCodeSl_NOT_STARTS_WITH?: string | null;
  StatusTypeCodeSl_STARTS_WITH?: string | null;
  StatusTypeDescriptionSl?: string | null;
  StatusTypeDescriptionSl_CONTAINS?: string | null;
  StatusTypeDescriptionSl_ENDS_WITH?: string | null;
  StatusTypeDescriptionSl_IN?: (string | null)[] | null;
  StatusTypeDescriptionSl_MATCHES?: string | null;
  StatusTypeDescriptionSl_NOT?: string | null;
  StatusTypeDescriptionSl_NOT_CONTAINS?: string | null;
  StatusTypeDescriptionSl_NOT_ENDS_WITH?: string | null;
  StatusTypeDescriptionSl_NOT_IN?: (string | null)[] | null;
  StatusTypeDescriptionSl_NOT_STARTS_WITH?: string | null;
  StatusTypeDescriptionSl_STARTS_WITH?: string | null;
  ValidFromDate?: any | null;
  ValidFromDate_GT?: any | null;
  ValidFromDate_GTE?: any | null;
  ValidFromDate_IN?: (any | null)[] | null;
  ValidFromDate_LT?: any | null;
  ValidFromDate_LTE?: any | null;
  ValidFromDate_NOT?: any | null;
  ValidFromDate_NOT_IN?: (any | null)[] | null;
  ValidThruDate?: any | null;
  ValidThruDate_GT?: any | null;
  ValidThruDate_GTE?: any | null;
  ValidThruDate_IN?: (any | null)[] | null;
  ValidThruDate_LT?: any | null;
  ValidThruDate_LTE?: any | null;
  ValidThruDate_NOT?: any | null;
  ValidThruDate_NOT_IN?: (any | null)[] | null;
  preparation?: PreparationWhere | null;
  preparationAggregate?: PreparationStatusPreparationAggregateInput | null;
  preparationConnection?: PreparationStatusPreparationConnectionWhere | null;
  preparationConnection_NOT?: PreparationStatusPreparationConnectionWhere | null;
  preparation_NOT?: PreparationWhere | null;
}

export interface PreparationWhere {
  AND?: PreparationWhere[] | null;
  AtcCode?: string | null;
  AtcCode_CONTAINS?: string | null;
  AtcCode_ENDS_WITH?: string | null;
  AtcCode_IN?: (string | null)[] | null;
  AtcCode_MATCHES?: string | null;
  AtcCode_NOT?: string | null;
  AtcCode_NOT_CONTAINS?: string | null;
  AtcCode_NOT_ENDS_WITH?: string | null;
  AtcCode_NOT_IN?: (string | null)[] | null;
  AtcCode_NOT_STARTS_WITH?: string | null;
  AtcCode_STARTS_WITH?: string | null;
  BrandName?: string | null;
  BrandName_CONTAINS?: string | null;
  BrandName_ENDS_WITH?: string | null;
  BrandName_IN?: (string | null)[] | null;
  BrandName_MATCHES?: string | null;
  BrandName_NOT?: string | null;
  BrandName_NOT_CONTAINS?: string | null;
  BrandName_NOT_ENDS_WITH?: string | null;
  BrandName_NOT_IN?: (string | null)[] | null;
  BrandName_NOT_STARTS_WITH?: string | null;
  BrandName_STARTS_WITH?: string | null;
  DescriptionDe?: string | null;
  DescriptionDe_CONTAINS?: string | null;
  DescriptionDe_ENDS_WITH?: string | null;
  DescriptionDe_IN?: (string | null)[] | null;
  DescriptionDe_MATCHES?: string | null;
  DescriptionDe_NOT?: string | null;
  DescriptionDe_NOT_CONTAINS?: string | null;
  DescriptionDe_NOT_ENDS_WITH?: string | null;
  DescriptionDe_NOT_IN?: (string | null)[] | null;
  DescriptionDe_NOT_STARTS_WITH?: string | null;
  DescriptionDe_STARTS_WITH?: string | null;
  DescriptionFr?: string | null;
  DescriptionFr_CONTAINS?: string | null;
  DescriptionFr_ENDS_WITH?: string | null;
  DescriptionFr_IN?: (string | null)[] | null;
  DescriptionFr_MATCHES?: string | null;
  DescriptionFr_NOT?: string | null;
  DescriptionFr_NOT_CONTAINS?: string | null;
  DescriptionFr_NOT_ENDS_WITH?: string | null;
  DescriptionFr_NOT_IN?: (string | null)[] | null;
  DescriptionFr_NOT_STARTS_WITH?: string | null;
  DescriptionFr_STARTS_WITH?: string | null;
  DescriptionIt?: string | null;
  DescriptionIt_CONTAINS?: string | null;
  DescriptionIt_ENDS_WITH?: string | null;
  DescriptionIt_IN?: (string | null)[] | null;
  DescriptionIt_MATCHES?: string | null;
  DescriptionIt_NOT?: string | null;
  DescriptionIt_NOT_CONTAINS?: string | null;
  DescriptionIt_NOT_ENDS_WITH?: string | null;
  DescriptionIt_NOT_IN?: (string | null)[] | null;
  DescriptionIt_NOT_STARTS_WITH?: string | null;
  DescriptionIt_STARTS_WITH?: string | null;
  GenericName?: string | null;
  GenericName_CONTAINS?: string | null;
  GenericName_ENDS_WITH?: string | null;
  GenericName_IN?: (string | null)[] | null;
  GenericName_MATCHES?: string | null;
  GenericName_NOT?: string | null;
  GenericName_NOT_CONTAINS?: string | null;
  GenericName_NOT_ENDS_WITH?: string | null;
  GenericName_NOT_IN?: (string | null)[] | null;
  GenericName_NOT_STARTS_WITH?: string | null;
  GenericName_STARTS_WITH?: string | null;
  OR?: PreparationWhere[] | null;
  ReleaseDate?: any | null;
  ReleaseDate_GT?: any | null;
  ReleaseDate_GTE?: any | null;
  ReleaseDate_IN?: (any | null)[] | null;
  ReleaseDate_LT?: any | null;
  ReleaseDate_LTE?: any | null;
  ReleaseDate_NOT?: any | null;
  ReleaseDate_NOT_IN?: (any | null)[] | null;
  SubjectMatter?: AgreementSubjectMatter | null;
  SubjectMatter_IN?: (AgreementSubjectMatter | null)[] | null;
  SubjectMatter_NOT?: AgreementSubjectMatter | null;
  SubjectMatter_NOT_IN?: (AgreementSubjectMatter | null)[] | null;
  SwissmedicNo5?: string | null;
  SwissmedicNo5_CONTAINS?: string | null;
  SwissmedicNo5_ENDS_WITH?: string | null;
  SwissmedicNo5_IN?: (string | null)[] | null;
  SwissmedicNo5_MATCHES?: string | null;
  SwissmedicNo5_NOT?: string | null;
  SwissmedicNo5_NOT_CONTAINS?: string | null;
  SwissmedicNo5_NOT_ENDS_WITH?: string | null;
  SwissmedicNo5_NOT_IN?: (string | null)[] | null;
  SwissmedicNo5_NOT_STARTS_WITH?: string | null;
  SwissmedicNo5_STARTS_WITH?: string | null;
  brand?: BrandWhere | null;
  brandAggregate?: PreparationBrandAggregateInput | null;
  brandConnection?: PreparationBrandConnectionWhere | null;
  brandConnection_NOT?: PreparationBrandConnectionWhere | null;
  brand_NOT?: BrandWhere | null;
  countries?: CountryWhere | null;
  countriesAggregate?: PreparationCountriesAggregateInput | null;
  countriesConnection?: PreparationCountriesConnectionWhere | null;
  countriesConnection_NOT?: PreparationCountriesConnectionWhere | null;
  countries_NOT?: CountryWhere | null;
  generic?: GenericWhere | null;
  genericAggregate?: PreparationGenericAggregateInput | null;
  genericConnection?: PreparationGenericConnectionWhere | null;
  genericConnection_NOT?: PreparationGenericConnectionWhere | null;
  generic_NOT?: GenericWhere | null;
  hasLimitations?: LimitationWhere | null;
  hasLimitationsAggregate?: PreparationHasLimitationsAggregateInput | null;
  hasLimitationsConnection?: PreparationHasLimitationsConnectionWhere | null;
  hasLimitationsConnection_NOT?: PreparationHasLimitationsConnectionWhere | null;
  hasLimitations_NOT?: LimitationWhere | null;
  id?: string | null;
  id_CONTAINS?: string | null;
  id_ENDS_WITH?: string | null;
  id_IN?: (string | null)[] | null;
  id_MATCHES?: string | null;
  id_NOT?: string | null;
  id_NOT_CONTAINS?: string | null;
  id_NOT_ENDS_WITH?: string | null;
  id_NOT_IN?: (string | null)[] | null;
  id_NOT_STARTS_WITH?: string | null;
  id_STARTS_WITH?: string | null;
  regulates?: TreatmentWhere | null;
  regulatesAggregate?: PreparationRegulatesAggregateInput | null;
  regulatesConnection?: PreparationRegulatesConnectionWhere | null;
  regulatesConnection_NOT?: PreparationRegulatesConnectionWhere | null;
  regulates_NOT?: TreatmentWhere | null;
}

export interface PriceCountryAggregateInput {
  AND?: PriceCountryAggregateInput[] | null;
  OR?: PriceCountryAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: PriceCountryNodeAggregationWhereInput | null;
}

export interface PriceCountryConnectionWhere {
  AND?: PriceCountryConnectionWhere[] | null;
  OR?: PriceCountryConnectionWhere[] | null;
  node?: CountryWhere | null;
  node_NOT?: CountryWhere | null;
}

export interface PriceCountryNodeAggregationWhereInput {
  AND?: PriceCountryNodeAggregationWhereInput[] | null;
  OR?: PriceCountryNodeAggregationWhereInput[] | null;
  alpha2Code_AVERAGE_EQUAL?: number | null;
  alpha2Code_AVERAGE_GT?: number | null;
  alpha2Code_AVERAGE_GTE?: number | null;
  alpha2Code_AVERAGE_LT?: number | null;
  alpha2Code_AVERAGE_LTE?: number | null;
  alpha2Code_EQUAL?: string | null;
  alpha2Code_GT?: number | null;
  alpha2Code_GTE?: number | null;
  alpha2Code_LONGEST_EQUAL?: number | null;
  alpha2Code_LONGEST_GT?: number | null;
  alpha2Code_LONGEST_GTE?: number | null;
  alpha2Code_LONGEST_LT?: number | null;
  alpha2Code_LONGEST_LTE?: number | null;
  alpha2Code_LT?: number | null;
  alpha2Code_LTE?: number | null;
  alpha2Code_SHORTEST_EQUAL?: number | null;
  alpha2Code_SHORTEST_GT?: number | null;
  alpha2Code_SHORTEST_GTE?: number | null;
  alpha2Code_SHORTEST_LT?: number | null;
  alpha2Code_SHORTEST_LTE?: number | null;
  alpha3Code_AVERAGE_EQUAL?: number | null;
  alpha3Code_AVERAGE_GT?: number | null;
  alpha3Code_AVERAGE_GTE?: number | null;
  alpha3Code_AVERAGE_LT?: number | null;
  alpha3Code_AVERAGE_LTE?: number | null;
  alpha3Code_EQUAL?: string | null;
  alpha3Code_GT?: number | null;
  alpha3Code_GTE?: number | null;
  alpha3Code_LONGEST_EQUAL?: number | null;
  alpha3Code_LONGEST_GT?: number | null;
  alpha3Code_LONGEST_GTE?: number | null;
  alpha3Code_LONGEST_LT?: number | null;
  alpha3Code_LONGEST_LTE?: number | null;
  alpha3Code_LT?: number | null;
  alpha3Code_LTE?: number | null;
  alpha3Code_SHORTEST_EQUAL?: number | null;
  alpha3Code_SHORTEST_GT?: number | null;
  alpha3Code_SHORTEST_GTE?: number | null;
  alpha3Code_SHORTEST_LT?: number | null;
  alpha3Code_SHORTEST_LTE?: number | null;
  flag_AVERAGE_EQUAL?: number | null;
  flag_AVERAGE_GT?: number | null;
  flag_AVERAGE_GTE?: number | null;
  flag_AVERAGE_LT?: number | null;
  flag_AVERAGE_LTE?: number | null;
  flag_EQUAL?: string | null;
  flag_GT?: number | null;
  flag_GTE?: number | null;
  flag_LONGEST_EQUAL?: number | null;
  flag_LONGEST_GT?: number | null;
  flag_LONGEST_GTE?: number | null;
  flag_LONGEST_LT?: number | null;
  flag_LONGEST_LTE?: number | null;
  flag_LT?: number | null;
  flag_LTE?: number | null;
  flag_SHORTEST_EQUAL?: number | null;
  flag_SHORTEST_GT?: number | null;
  flag_SHORTEST_GTE?: number | null;
  flag_SHORTEST_LT?: number | null;
  flag_SHORTEST_LTE?: number | null;
  name_AVERAGE_EQUAL?: number | null;
  name_AVERAGE_GT?: number | null;
  name_AVERAGE_GTE?: number | null;
  name_AVERAGE_LT?: number | null;
  name_AVERAGE_LTE?: number | null;
  name_EQUAL?: string | null;
  name_GT?: number | null;
  name_GTE?: number | null;
  name_LONGEST_EQUAL?: number | null;
  name_LONGEST_GT?: number | null;
  name_LONGEST_GTE?: number | null;
  name_LONGEST_LT?: number | null;
  name_LONGEST_LTE?: number | null;
  name_LT?: number | null;
  name_LTE?: number | null;
  name_SHORTEST_EQUAL?: number | null;
  name_SHORTEST_GT?: number | null;
  name_SHORTEST_GTE?: number | null;
  name_SHORTEST_LT?: number | null;
  name_SHORTEST_LTE?: number | null;
  numericCode_AVERAGE_EQUAL?: number | null;
  numericCode_AVERAGE_GT?: number | null;
  numericCode_AVERAGE_GTE?: number | null;
  numericCode_AVERAGE_LT?: number | null;
  numericCode_AVERAGE_LTE?: number | null;
  numericCode_EQUAL?: string | null;
  numericCode_GT?: number | null;
  numericCode_GTE?: number | null;
  numericCode_LONGEST_EQUAL?: number | null;
  numericCode_LONGEST_GT?: number | null;
  numericCode_LONGEST_GTE?: number | null;
  numericCode_LONGEST_LT?: number | null;
  numericCode_LONGEST_LTE?: number | null;
  numericCode_LT?: number | null;
  numericCode_LTE?: number | null;
  numericCode_SHORTEST_EQUAL?: number | null;
  numericCode_SHORTEST_GT?: number | null;
  numericCode_SHORTEST_GTE?: number | null;
  numericCode_SHORTEST_LT?: number | null;
  numericCode_SHORTEST_LTE?: number | null;
}

export interface PriceTreatmentAggregateInput {
  AND?: PriceTreatmentAggregateInput[] | null;
  OR?: PriceTreatmentAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: PriceTreatmentNodeAggregationWhereInput | null;
}

export interface PriceTreatmentConnectionWhere {
  AND?: PriceTreatmentConnectionWhere[] | null;
  OR?: PriceTreatmentConnectionWhere[] | null;
  node?: TreatmentWhere | null;
  node_NOT?: TreatmentWhere | null;
}

export interface PriceTreatmentNodeAggregationWhereInput {
  AND?: PriceTreatmentNodeAggregationWhereInput[] | null;
  BagDossierNo_AVERAGE_EQUAL?: number | null;
  BagDossierNo_AVERAGE_GT?: number | null;
  BagDossierNo_AVERAGE_GTE?: number | null;
  BagDossierNo_AVERAGE_LT?: number | null;
  BagDossierNo_AVERAGE_LTE?: number | null;
  BagDossierNo_EQUAL?: string | null;
  BagDossierNo_GT?: number | null;
  BagDossierNo_GTE?: number | null;
  BagDossierNo_LONGEST_EQUAL?: number | null;
  BagDossierNo_LONGEST_GT?: number | null;
  BagDossierNo_LONGEST_GTE?: number | null;
  BagDossierNo_LONGEST_LT?: number | null;
  BagDossierNo_LONGEST_LTE?: number | null;
  BagDossierNo_LT?: number | null;
  BagDossierNo_LTE?: number | null;
  BagDossierNo_SHORTEST_EQUAL?: number | null;
  BagDossierNo_SHORTEST_GT?: number | null;
  BagDossierNo_SHORTEST_GTE?: number | null;
  BagDossierNo_SHORTEST_LT?: number | null;
  BagDossierNo_SHORTEST_LTE?: number | null;
  Code_AVERAGE_EQUAL?: number | null;
  Code_AVERAGE_GT?: number | null;
  Code_AVERAGE_GTE?: number | null;
  Code_AVERAGE_LT?: number | null;
  Code_AVERAGE_LTE?: number | null;
  Code_EQUAL?: string | null;
  Code_GT?: number | null;
  Code_GTE?: number | null;
  Code_LONGEST_EQUAL?: number | null;
  Code_LONGEST_GT?: number | null;
  Code_LONGEST_GTE?: number | null;
  Code_LONGEST_LT?: number | null;
  Code_LONGEST_LTE?: number | null;
  Code_LT?: number | null;
  Code_LTE?: number | null;
  Code_SHORTEST_EQUAL?: number | null;
  Code_SHORTEST_GT?: number | null;
  Code_SHORTEST_GTE?: number | null;
  Code_SHORTEST_LT?: number | null;
  Code_SHORTEST_LTE?: number | null;
  FlagModal_AVERAGE_EQUAL?: number | null;
  FlagModal_AVERAGE_GT?: number | null;
  FlagModal_AVERAGE_GTE?: number | null;
  FlagModal_AVERAGE_LT?: number | null;
  FlagModal_AVERAGE_LTE?: number | null;
  FlagModal_EQUAL?: string | null;
  FlagModal_GT?: number | null;
  FlagModal_GTE?: number | null;
  FlagModal_LONGEST_EQUAL?: number | null;
  FlagModal_LONGEST_GT?: number | null;
  FlagModal_LONGEST_GTE?: number | null;
  FlagModal_LONGEST_LT?: number | null;
  FlagModal_LONGEST_LTE?: number | null;
  FlagModal_LT?: number | null;
  FlagModal_LTE?: number | null;
  FlagModal_SHORTEST_EQUAL?: number | null;
  FlagModal_SHORTEST_GT?: number | null;
  FlagModal_SHORTEST_GTE?: number | null;
  FlagModal_SHORTEST_LT?: number | null;
  FlagModal_SHORTEST_LTE?: number | null;
  FlagNarcosis_AVERAGE_EQUAL?: number | null;
  FlagNarcosis_AVERAGE_GT?: number | null;
  FlagNarcosis_AVERAGE_GTE?: number | null;
  FlagNarcosis_AVERAGE_LT?: number | null;
  FlagNarcosis_AVERAGE_LTE?: number | null;
  FlagNarcosis_EQUAL?: string | null;
  FlagNarcosis_GT?: number | null;
  FlagNarcosis_GTE?: number | null;
  FlagNarcosis_LONGEST_EQUAL?: number | null;
  FlagNarcosis_LONGEST_GT?: number | null;
  FlagNarcosis_LONGEST_GTE?: number | null;
  FlagNarcosis_LONGEST_LT?: number | null;
  FlagNarcosis_LONGEST_LTE?: number | null;
  FlagNarcosis_LT?: number | null;
  FlagNarcosis_LTE?: number | null;
  FlagNarcosis_SHORTEST_EQUAL?: number | null;
  FlagNarcosis_SHORTEST_GT?: number | null;
  FlagNarcosis_SHORTEST_GTE?: number | null;
  FlagNarcosis_SHORTEST_LT?: number | null;
  FlagNarcosis_SHORTEST_LTE?: number | null;
  GTIN_AVERAGE_EQUAL?: number | null;
  GTIN_AVERAGE_GT?: number | null;
  GTIN_AVERAGE_GTE?: number | null;
  GTIN_AVERAGE_LT?: number | null;
  GTIN_AVERAGE_LTE?: number | null;
  GTIN_EQUAL?: string | null;
  GTIN_GT?: number | null;
  GTIN_GTE?: number | null;
  GTIN_LONGEST_EQUAL?: number | null;
  GTIN_LONGEST_GT?: number | null;
  GTIN_LONGEST_GTE?: number | null;
  GTIN_LONGEST_LT?: number | null;
  GTIN_LONGEST_LTE?: number | null;
  GTIN_LT?: number | null;
  GTIN_LTE?: number | null;
  GTIN_SHORTEST_EQUAL?: number | null;
  GTIN_SHORTEST_GT?: number | null;
  GTIN_SHORTEST_GTE?: number | null;
  GTIN_SHORTEST_LT?: number | null;
  GTIN_SHORTEST_LTE?: number | null;
  LOT_AVERAGE_EQUAL?: number | null;
  LOT_AVERAGE_GT?: number | null;
  LOT_AVERAGE_GTE?: number | null;
  LOT_AVERAGE_LT?: number | null;
  LOT_AVERAGE_LTE?: number | null;
  LOT_EQUAL?: string | null;
  LOT_GT?: number | null;
  LOT_GTE?: number | null;
  LOT_LONGEST_EQUAL?: number | null;
  LOT_LONGEST_GT?: number | null;
  LOT_LONGEST_GTE?: number | null;
  LOT_LONGEST_LT?: number | null;
  LOT_LONGEST_LTE?: number | null;
  LOT_LT?: number | null;
  LOT_LTE?: number | null;
  LOT_SHORTEST_EQUAL?: number | null;
  LOT_SHORTEST_GT?: number | null;
  LOT_SHORTEST_GTE?: number | null;
  LOT_SHORTEST_LT?: number | null;
  LOT_SHORTEST_LTE?: number | null;
  Name_AVERAGE_EQUAL?: number | null;
  Name_AVERAGE_GT?: number | null;
  Name_AVERAGE_GTE?: number | null;
  Name_AVERAGE_LT?: number | null;
  Name_AVERAGE_LTE?: number | null;
  Name_EQUAL?: string | null;
  Name_GT?: number | null;
  Name_GTE?: number | null;
  Name_LONGEST_EQUAL?: number | null;
  Name_LONGEST_GT?: number | null;
  Name_LONGEST_GTE?: number | null;
  Name_LONGEST_LT?: number | null;
  Name_LONGEST_LTE?: number | null;
  Name_LT?: number | null;
  Name_LTE?: number | null;
  Name_SHORTEST_EQUAL?: number | null;
  Name_SHORTEST_GT?: number | null;
  Name_SHORTEST_GTE?: number | null;
  Name_SHORTEST_LT?: number | null;
  Name_SHORTEST_LTE?: number | null;
  OR?: PriceTreatmentNodeAggregationWhereInput[] | null;
  PharmaCode_AVERAGE_EQUAL?: number | null;
  PharmaCode_AVERAGE_GT?: number | null;
  PharmaCode_AVERAGE_GTE?: number | null;
  PharmaCode_AVERAGE_LT?: number | null;
  PharmaCode_AVERAGE_LTE?: number | null;
  PharmaCode_EQUAL?: string | null;
  PharmaCode_GT?: number | null;
  PharmaCode_GTE?: number | null;
  PharmaCode_LONGEST_EQUAL?: number | null;
  PharmaCode_LONGEST_GT?: number | null;
  PharmaCode_LONGEST_GTE?: number | null;
  PharmaCode_LONGEST_LT?: number | null;
  PharmaCode_LONGEST_LTE?: number | null;
  PharmaCode_LT?: number | null;
  PharmaCode_LTE?: number | null;
  PharmaCode_SHORTEST_EQUAL?: number | null;
  PharmaCode_SHORTEST_GT?: number | null;
  PharmaCode_SHORTEST_GTE?: number | null;
  PharmaCode_SHORTEST_LT?: number | null;
  PharmaCode_SHORTEST_LTE?: number | null;
  PrevPharmacode_AVERAGE_EQUAL?: number | null;
  PrevPharmacode_AVERAGE_GT?: number | null;
  PrevPharmacode_AVERAGE_GTE?: number | null;
  PrevPharmacode_AVERAGE_LT?: number | null;
  PrevPharmacode_AVERAGE_LTE?: number | null;
  PrevPharmacode_EQUAL?: string | null;
  PrevPharmacode_GT?: number | null;
  PrevPharmacode_GTE?: number | null;
  PrevPharmacode_LONGEST_EQUAL?: number | null;
  PrevPharmacode_LONGEST_GT?: number | null;
  PrevPharmacode_LONGEST_GTE?: number | null;
  PrevPharmacode_LONGEST_LT?: number | null;
  PrevPharmacode_LONGEST_LTE?: number | null;
  PrevPharmacode_LT?: number | null;
  PrevPharmacode_LTE?: number | null;
  PrevPharmacode_SHORTEST_EQUAL?: number | null;
  PrevPharmacode_SHORTEST_GT?: number | null;
  PrevPharmacode_SHORTEST_GTE?: number | null;
  PrevPharmacode_SHORTEST_LT?: number | null;
  PrevPharmacode_SHORTEST_LTE?: number | null;
  REF_AVERAGE_EQUAL?: number | null;
  REF_AVERAGE_GT?: number | null;
  REF_AVERAGE_GTE?: number | null;
  REF_AVERAGE_LT?: number | null;
  REF_AVERAGE_LTE?: number | null;
  REF_EQUAL?: string | null;
  REF_GT?: number | null;
  REF_GTE?: number | null;
  REF_LONGEST_EQUAL?: number | null;
  REF_LONGEST_GT?: number | null;
  REF_LONGEST_GTE?: number | null;
  REF_LONGEST_LT?: number | null;
  REF_LONGEST_LTE?: number | null;
  REF_LT?: number | null;
  REF_LTE?: number | null;
  REF_SHORTEST_EQUAL?: number | null;
  REF_SHORTEST_GT?: number | null;
  REF_SHORTEST_GTE?: number | null;
  REF_SHORTEST_LT?: number | null;
  REF_SHORTEST_LTE?: number | null;
  SwissmedicCategory_AVERAGE_EQUAL?: number | null;
  SwissmedicCategory_AVERAGE_GT?: number | null;
  SwissmedicCategory_AVERAGE_GTE?: number | null;
  SwissmedicCategory_AVERAGE_LT?: number | null;
  SwissmedicCategory_AVERAGE_LTE?: number | null;
  SwissmedicCategory_EQUAL?: string | null;
  SwissmedicCategory_GT?: number | null;
  SwissmedicCategory_GTE?: number | null;
  SwissmedicCategory_LONGEST_EQUAL?: number | null;
  SwissmedicCategory_LONGEST_GT?: number | null;
  SwissmedicCategory_LONGEST_GTE?: number | null;
  SwissmedicCategory_LONGEST_LT?: number | null;
  SwissmedicCategory_LONGEST_LTE?: number | null;
  SwissmedicCategory_LT?: number | null;
  SwissmedicCategory_LTE?: number | null;
  SwissmedicCategory_SHORTEST_EQUAL?: number | null;
  SwissmedicCategory_SHORTEST_GT?: number | null;
  SwissmedicCategory_SHORTEST_GTE?: number | null;
  SwissmedicCategory_SHORTEST_LT?: number | null;
  SwissmedicCategory_SHORTEST_LTE?: number | null;
  SwissmedicNo8_AVERAGE_EQUAL?: number | null;
  SwissmedicNo8_AVERAGE_GT?: number | null;
  SwissmedicNo8_AVERAGE_GTE?: number | null;
  SwissmedicNo8_AVERAGE_LT?: number | null;
  SwissmedicNo8_AVERAGE_LTE?: number | null;
  SwissmedicNo8_EQUAL?: string | null;
  SwissmedicNo8_GT?: number | null;
  SwissmedicNo8_GTE?: number | null;
  SwissmedicNo8_LONGEST_EQUAL?: number | null;
  SwissmedicNo8_LONGEST_GT?: number | null;
  SwissmedicNo8_LONGEST_GTE?: number | null;
  SwissmedicNo8_LONGEST_LT?: number | null;
  SwissmedicNo8_LONGEST_LTE?: number | null;
  SwissmedicNo8_LT?: number | null;
  SwissmedicNo8_LTE?: number | null;
  SwissmedicNo8_SHORTEST_EQUAL?: number | null;
  SwissmedicNo8_SHORTEST_GT?: number | null;
  SwissmedicNo8_SHORTEST_GTE?: number | null;
  SwissmedicNo8_SHORTEST_LT?: number | null;
  SwissmedicNo8_SHORTEST_LTE?: number | null;
  UDI_AVERAGE_EQUAL?: number | null;
  UDI_AVERAGE_GT?: number | null;
  UDI_AVERAGE_GTE?: number | null;
  UDI_AVERAGE_LT?: number | null;
  UDI_AVERAGE_LTE?: number | null;
  UDI_EQUAL?: string | null;
  UDI_GT?: number | null;
  UDI_GTE?: number | null;
  UDI_LONGEST_EQUAL?: number | null;
  UDI_LONGEST_GT?: number | null;
  UDI_LONGEST_GTE?: number | null;
  UDI_LONGEST_LT?: number | null;
  UDI_LONGEST_LTE?: number | null;
  UDI_LT?: number | null;
  UDI_LTE?: number | null;
  UDI_SHORTEST_EQUAL?: number | null;
  UDI_SHORTEST_GT?: number | null;
  UDI_SHORTEST_GTE?: number | null;
  UDI_SHORTEST_LT?: number | null;
  UDI_SHORTEST_LTE?: number | null;
  activeIngredientQuantity_AVERAGE_EQUAL?: number | null;
  activeIngredientQuantity_AVERAGE_GT?: number | null;
  activeIngredientQuantity_AVERAGE_GTE?: number | null;
  activeIngredientQuantity_AVERAGE_LT?: number | null;
  activeIngredientQuantity_AVERAGE_LTE?: number | null;
  activeIngredientQuantity_EQUAL?: number | null;
  activeIngredientQuantity_GT?: number | null;
  activeIngredientQuantity_GTE?: number | null;
  activeIngredientQuantity_LT?: number | null;
  activeIngredientQuantity_LTE?: number | null;
  activeIngredientQuantity_MAX_EQUAL?: number | null;
  activeIngredientQuantity_MAX_GT?: number | null;
  activeIngredientQuantity_MAX_GTE?: number | null;
  activeIngredientQuantity_MAX_LT?: number | null;
  activeIngredientQuantity_MAX_LTE?: number | null;
  activeIngredientQuantity_MIN_EQUAL?: number | null;
  activeIngredientQuantity_MIN_GT?: number | null;
  activeIngredientQuantity_MIN_GTE?: number | null;
  activeIngredientQuantity_MIN_LT?: number | null;
  activeIngredientQuantity_MIN_LTE?: number | null;
  activeIngredientQuantity_SUM_EQUAL?: number | null;
  activeIngredientQuantity_SUM_GT?: number | null;
  activeIngredientQuantity_SUM_GTE?: number | null;
  activeIngredientQuantity_SUM_LT?: number | null;
  activeIngredientQuantity_SUM_LTE?: number | null;
  classificationSystem_AVERAGE_EQUAL?: number | null;
  classificationSystem_AVERAGE_GT?: number | null;
  classificationSystem_AVERAGE_GTE?: number | null;
  classificationSystem_AVERAGE_LT?: number | null;
  classificationSystem_AVERAGE_LTE?: number | null;
  classificationSystem_EQUAL?: string | null;
  classificationSystem_GT?: number | null;
  classificationSystem_GTE?: number | null;
  classificationSystem_LONGEST_EQUAL?: number | null;
  classificationSystem_LONGEST_GT?: number | null;
  classificationSystem_LONGEST_GTE?: number | null;
  classificationSystem_LONGEST_LT?: number | null;
  classificationSystem_LONGEST_LTE?: number | null;
  classificationSystem_LT?: number | null;
  classificationSystem_LTE?: number | null;
  classificationSystem_SHORTEST_EQUAL?: number | null;
  classificationSystem_SHORTEST_GT?: number | null;
  classificationSystem_SHORTEST_GTE?: number | null;
  classificationSystem_SHORTEST_LT?: number | null;
  classificationSystem_SHORTEST_LTE?: number | null;
  concentration_AVERAGE_EQUAL?: number | null;
  concentration_AVERAGE_GT?: number | null;
  concentration_AVERAGE_GTE?: number | null;
  concentration_AVERAGE_LT?: number | null;
  concentration_AVERAGE_LTE?: number | null;
  concentration_EQUAL?: string | null;
  concentration_GT?: number | null;
  concentration_GTE?: number | null;
  concentration_LONGEST_EQUAL?: number | null;
  concentration_LONGEST_GT?: number | null;
  concentration_LONGEST_GTE?: number | null;
  concentration_LONGEST_LT?: number | null;
  concentration_LONGEST_LTE?: number | null;
  concentration_LT?: number | null;
  concentration_LTE?: number | null;
  concentration_SHORTEST_EQUAL?: number | null;
  concentration_SHORTEST_GT?: number | null;
  concentration_SHORTEST_GTE?: number | null;
  concentration_SHORTEST_LT?: number | null;
  concentration_SHORTEST_LTE?: number | null;
  packVolume_AVERAGE_EQUAL?: number | null;
  packVolume_AVERAGE_GT?: number | null;
  packVolume_AVERAGE_GTE?: number | null;
  packVolume_AVERAGE_LT?: number | null;
  packVolume_AVERAGE_LTE?: number | null;
  packVolume_EQUAL?: string | null;
  packVolume_GT?: number | null;
  packVolume_GTE?: number | null;
  packVolume_LONGEST_EQUAL?: number | null;
  packVolume_LONGEST_GT?: number | null;
  packVolume_LONGEST_GTE?: number | null;
  packVolume_LONGEST_LT?: number | null;
  packVolume_LONGEST_LTE?: number | null;
  packVolume_LT?: number | null;
  packVolume_LTE?: number | null;
  packVolume_SHORTEST_EQUAL?: number | null;
  packVolume_SHORTEST_GT?: number | null;
  packVolume_SHORTEST_GTE?: number | null;
  packVolume_SHORTEST_LT?: number | null;
  packVolume_SHORTEST_LTE?: number | null;
}

export interface PriceWhere {
  AND?: PriceWhere[] | null;
  OR?: PriceWhere[] | null;
  Price?: string | null;
  PriceChangeTypeDescriptionDe?: string | null;
  PriceChangeTypeDescriptionDe_CONTAINS?: string | null;
  PriceChangeTypeDescriptionDe_ENDS_WITH?: string | null;
  PriceChangeTypeDescriptionDe_IN?: (string | null)[] | null;
  PriceChangeTypeDescriptionDe_MATCHES?: string | null;
  PriceChangeTypeDescriptionDe_NOT?: string | null;
  PriceChangeTypeDescriptionDe_NOT_CONTAINS?: string | null;
  PriceChangeTypeDescriptionDe_NOT_ENDS_WITH?: string | null;
  PriceChangeTypeDescriptionDe_NOT_IN?: (string | null)[] | null;
  PriceChangeTypeDescriptionDe_NOT_STARTS_WITH?: string | null;
  PriceChangeTypeDescriptionDe_STARTS_WITH?: string | null;
  PriceChangeTypeDescriptionFr?: string | null;
  PriceChangeTypeDescriptionFr_CONTAINS?: string | null;
  PriceChangeTypeDescriptionFr_ENDS_WITH?: string | null;
  PriceChangeTypeDescriptionFr_IN?: (string | null)[] | null;
  PriceChangeTypeDescriptionFr_MATCHES?: string | null;
  PriceChangeTypeDescriptionFr_NOT?: string | null;
  PriceChangeTypeDescriptionFr_NOT_CONTAINS?: string | null;
  PriceChangeTypeDescriptionFr_NOT_ENDS_WITH?: string | null;
  PriceChangeTypeDescriptionFr_NOT_IN?: (string | null)[] | null;
  PriceChangeTypeDescriptionFr_NOT_STARTS_WITH?: string | null;
  PriceChangeTypeDescriptionFr_STARTS_WITH?: string | null;
  PriceChangeTypeDescriptionIt?: string | null;
  PriceChangeTypeDescriptionIt_CONTAINS?: string | null;
  PriceChangeTypeDescriptionIt_ENDS_WITH?: string | null;
  PriceChangeTypeDescriptionIt_IN?: (string | null)[] | null;
  PriceChangeTypeDescriptionIt_MATCHES?: string | null;
  PriceChangeTypeDescriptionIt_NOT?: string | null;
  PriceChangeTypeDescriptionIt_NOT_CONTAINS?: string | null;
  PriceChangeTypeDescriptionIt_NOT_ENDS_WITH?: string | null;
  PriceChangeTypeDescriptionIt_NOT_IN?: (string | null)[] | null;
  PriceChangeTypeDescriptionIt_NOT_STARTS_WITH?: string | null;
  PriceChangeTypeDescriptionIt_STARTS_WITH?: string | null;
  PriceTypeDescriptionDe?: string | null;
  PriceTypeDescriptionDe_CONTAINS?: string | null;
  PriceTypeDescriptionDe_ENDS_WITH?: string | null;
  PriceTypeDescriptionDe_IN?: (string | null)[] | null;
  PriceTypeDescriptionDe_MATCHES?: string | null;
  PriceTypeDescriptionDe_NOT?: string | null;
  PriceTypeDescriptionDe_NOT_CONTAINS?: string | null;
  PriceTypeDescriptionDe_NOT_ENDS_WITH?: string | null;
  PriceTypeDescriptionDe_NOT_IN?: (string | null)[] | null;
  PriceTypeDescriptionDe_NOT_STARTS_WITH?: string | null;
  PriceTypeDescriptionDe_STARTS_WITH?: string | null;
  PriceTypeDescriptionFr?: string | null;
  PriceTypeDescriptionFr_CONTAINS?: string | null;
  PriceTypeDescriptionFr_ENDS_WITH?: string | null;
  PriceTypeDescriptionFr_IN?: (string | null)[] | null;
  PriceTypeDescriptionFr_MATCHES?: string | null;
  PriceTypeDescriptionFr_NOT?: string | null;
  PriceTypeDescriptionFr_NOT_CONTAINS?: string | null;
  PriceTypeDescriptionFr_NOT_ENDS_WITH?: string | null;
  PriceTypeDescriptionFr_NOT_IN?: (string | null)[] | null;
  PriceTypeDescriptionFr_NOT_STARTS_WITH?: string | null;
  PriceTypeDescriptionFr_STARTS_WITH?: string | null;
  PriceTypeDescriptionIt?: string | null;
  PriceTypeDescriptionIt_CONTAINS?: string | null;
  PriceTypeDescriptionIt_ENDS_WITH?: string | null;
  PriceTypeDescriptionIt_IN?: (string | null)[] | null;
  PriceTypeDescriptionIt_MATCHES?: string | null;
  PriceTypeDescriptionIt_NOT?: string | null;
  PriceTypeDescriptionIt_NOT_CONTAINS?: string | null;
  PriceTypeDescriptionIt_NOT_ENDS_WITH?: string | null;
  PriceTypeDescriptionIt_NOT_IN?: (string | null)[] | null;
  PriceTypeDescriptionIt_NOT_STARTS_WITH?: string | null;
  PriceTypeDescriptionIt_STARTS_WITH?: string | null;
  Price_CONTAINS?: string | null;
  Price_ENDS_WITH?: string | null;
  Price_IN?: (string | null)[] | null;
  Price_MATCHES?: string | null;
  Price_NOT?: string | null;
  Price_NOT_CONTAINS?: string | null;
  Price_NOT_ENDS_WITH?: string | null;
  Price_NOT_IN?: (string | null)[] | null;
  Price_NOT_STARTS_WITH?: string | null;
  Price_STARTS_WITH?: string | null;
  ValidFromDate?: any | null;
  ValidFromDate_GT?: any | null;
  ValidFromDate_GTE?: any | null;
  ValidFromDate_IN?: (any | null)[] | null;
  ValidFromDate_LT?: any | null;
  ValidFromDate_LTE?: any | null;
  ValidFromDate_NOT?: any | null;
  ValidFromDate_NOT_IN?: (any | null)[] | null;
  ValidToDate?: any | null;
  ValidToDate_GT?: any | null;
  ValidToDate_GTE?: any | null;
  ValidToDate_IN?: (any | null)[] | null;
  ValidToDate_LT?: any | null;
  ValidToDate_LTE?: any | null;
  ValidToDate_NOT?: any | null;
  ValidToDate_NOT_IN?: (any | null)[] | null;
  country?: CountryWhere | null;
  countryAggregate?: PriceCountryAggregateInput | null;
  countryConnection?: PriceCountryConnectionWhere | null;
  countryConnection_NOT?: PriceCountryConnectionWhere | null;
  country_NOT?: CountryWhere | null;
  priceType?: PriceCategory | null;
  priceType_IN?: (PriceCategory | null)[] | null;
  priceType_NOT?: PriceCategory | null;
  priceType_NOT_IN?: (PriceCategory | null)[] | null;
  treatment?: TreatmentWhere | null;
  treatmentAggregate?: PriceTreatmentAggregateInput | null;
  treatmentConnection?: PriceTreatmentConnectionWhere | null;
  treatmentConnection_NOT?: PriceTreatmentConnectionWhere | null;
  treatment_NOT?: TreatmentWhere | null;
  uniqueCode?: string | null;
  uniqueCode_CONTAINS?: string | null;
  uniqueCode_ENDS_WITH?: string | null;
  uniqueCode_IN?: (string | null)[] | null;
  uniqueCode_MATCHES?: string | null;
  uniqueCode_NOT?: string | null;
  uniqueCode_NOT_CONTAINS?: string | null;
  uniqueCode_NOT_ENDS_WITH?: string | null;
  uniqueCode_NOT_IN?: (string | null)[] | null;
  uniqueCode_NOT_STARTS_WITH?: string | null;
  uniqueCode_STARTS_WITH?: string | null;
}

export interface ProfileDataInfoInput {
  email?: string | null;
  isQuerySourceImage?: boolean | null;
  notificationCount?: number | null;
  questsCount?: number | null;
  userId?: string | null;
  lastLoginDate?: Date | null;
  currentLoginDate?: Date | null; 
}

export interface PublicAgreementCountryAggregateInput {
  AND?: PublicAgreementCountryAggregateInput[] | null;
  OR?: PublicAgreementCountryAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: PublicAgreementCountryNodeAggregationWhereInput | null;
}

export interface PublicAgreementCountryConnectionWhere {
  AND?: PublicAgreementCountryConnectionWhere[] | null;
  OR?: PublicAgreementCountryConnectionWhere[] | null;
  node?: CountriesInAgreementWhere | null;
  node_NOT?: CountriesInAgreementWhere | null;
}

export interface PublicAgreementCountryNodeAggregationWhereInput {
  AND?: PublicAgreementCountryNodeAggregationWhereInput[] | null;
  ISO_A3_AVERAGE_EQUAL?: number | null;
  ISO_A3_AVERAGE_GT?: number | null;
  ISO_A3_AVERAGE_GTE?: number | null;
  ISO_A3_AVERAGE_LT?: number | null;
  ISO_A3_AVERAGE_LTE?: number | null;
  ISO_A3_EQUAL?: string | null;
  ISO_A3_GT?: number | null;
  ISO_A3_GTE?: number | null;
  ISO_A3_LONGEST_EQUAL?: number | null;
  ISO_A3_LONGEST_GT?: number | null;
  ISO_A3_LONGEST_GTE?: number | null;
  ISO_A3_LONGEST_LT?: number | null;
  ISO_A3_LONGEST_LTE?: number | null;
  ISO_A3_LT?: number | null;
  ISO_A3_LTE?: number | null;
  ISO_A3_SHORTEST_EQUAL?: number | null;
  ISO_A3_SHORTEST_GT?: number | null;
  ISO_A3_SHORTEST_GTE?: number | null;
  ISO_A3_SHORTEST_LT?: number | null;
  ISO_A3_SHORTEST_LTE?: number | null;
  OR?: PublicAgreementCountryNodeAggregationWhereInput[] | null;
  id_AVERAGE_EQUAL?: number | null;
  id_AVERAGE_GT?: number | null;
  id_AVERAGE_GTE?: number | null;
  id_AVERAGE_LT?: number | null;
  id_AVERAGE_LTE?: number | null;
  id_EQUAL?: string | null;
  id_GT?: number | null;
  id_GTE?: number | null;
  id_LONGEST_EQUAL?: number | null;
  id_LONGEST_GT?: number | null;
  id_LONGEST_GTE?: number | null;
  id_LONGEST_LT?: number | null;
  id_LONGEST_LTE?: number | null;
  id_LT?: number | null;
  id_LTE?: number | null;
  id_SHORTEST_EQUAL?: number | null;
  id_SHORTEST_GT?: number | null;
  id_SHORTEST_GTE?: number | null;
  id_SHORTEST_LT?: number | null;
  id_SHORTEST_LTE?: number | null;
  name_AVERAGE_EQUAL?: number | null;
  name_AVERAGE_GT?: number | null;
  name_AVERAGE_GTE?: number | null;
  name_AVERAGE_LT?: number | null;
  name_AVERAGE_LTE?: number | null;
  name_EQUAL?: string | null;
  name_GT?: number | null;
  name_GTE?: number | null;
  name_LONGEST_EQUAL?: number | null;
  name_LONGEST_GT?: number | null;
  name_LONGEST_GTE?: number | null;
  name_LONGEST_LT?: number | null;
  name_LONGEST_LTE?: number | null;
  name_LT?: number | null;
  name_LTE?: number | null;
  name_SHORTEST_EQUAL?: number | null;
  name_SHORTEST_GT?: number | null;
  name_SHORTEST_GTE?: number | null;
  name_SHORTEST_LT?: number | null;
  name_SHORTEST_LTE?: number | null;
  region_AVERAGE_EQUAL?: number | null;
  region_AVERAGE_GT?: number | null;
  region_AVERAGE_GTE?: number | null;
  region_AVERAGE_LT?: number | null;
  region_AVERAGE_LTE?: number | null;
  region_EQUAL?: string | null;
  region_GT?: number | null;
  region_GTE?: number | null;
  region_LONGEST_EQUAL?: number | null;
  region_LONGEST_GT?: number | null;
  region_LONGEST_GTE?: number | null;
  region_LONGEST_LT?: number | null;
  region_LONGEST_LTE?: number | null;
  region_LT?: number | null;
  region_LTE?: number | null;
  region_SHORTEST_EQUAL?: number | null;
  region_SHORTEST_GT?: number | null;
  region_SHORTEST_GTE?: number | null;
  region_SHORTEST_LT?: number | null;
  region_SHORTEST_LTE?: number | null;
}

export interface PublicAgreementOptions {
  limit?: number | null;
  offset?: number | null;
  sort?: (PublicAgreementSort | null)[] | null;
}

/**
 * Fields to sort PublicAgreements by. The order in which sorts are applied is not guaranteed when specifying many fields in one PublicAgreementSort object.
 */
export interface PublicAgreementSort {
  addedOn?: SortDirection | null;
  archetype?: SortDirection | null;
  formattedCountry?: SortDirection | null;
  formattedDiseaseNames?: SortDirection | null;
  formattedManufacturers?: SortDirection | null;
  formattedMeasures?: SortDirection | null;
  formattedModels?: SortDirection | null;
  formattedRegion?: SortDirection | null;
  formattedTherapeuticAreas?: SortDirection | null;
  id?: SortDirection | null;
  indication?: SortDirection | null;
  payer?: SortDirection | null;
  payerType?: SortDirection | null;
  product?: SortDirection | null;
  productType?: SortDirection | null;
  status?: SortDirection | null;
  summary?: SortDirection | null;
  year?: SortDirection | null;
}

export interface PublicAgreementWhere {
  AND?: PublicAgreementWhere[] | null;
  OR?: PublicAgreementWhere[] | null;
  addedOn?: string | null;
  addedOn_CONTAINS?: string | null;
  addedOn_ENDS_WITH?: string | null;
  addedOn_IN?: (string | null)[] | null;
  addedOn_MATCHES?: string | null;
  addedOn_NOT?: string | null;
  addedOn_NOT_CONTAINS?: string | null;
  addedOn_NOT_ENDS_WITH?: string | null;
  addedOn_NOT_IN?: (string | null)[] | null;
  addedOn_NOT_STARTS_WITH?: string | null;
  addedOn_STARTS_WITH?: string | null;
  archetype?: string | null;
  archetype_CONTAINS?: string | null;
  archetype_ENDS_WITH?: string | null;
  archetype_IN?: (string | null)[] | null;
  archetype_MATCHES?: string | null;
  archetype_NOT?: string | null;
  archetype_NOT_CONTAINS?: string | null;
  archetype_NOT_ENDS_WITH?: string | null;
  archetype_NOT_IN?: (string | null)[] | null;
  archetype_NOT_STARTS_WITH?: string | null;
  archetype_STARTS_WITH?: string | null;
  country?: CountriesInAgreementWhere | null;
  countryAggregate?: PublicAgreementCountryAggregateInput | null;
  countryConnection?: PublicAgreementCountryConnectionWhere | null;
  countryConnection_NOT?: PublicAgreementCountryConnectionWhere | null;
  country_NOT?: CountriesInAgreementWhere | null;
  diseaseNames?: (string | null)[] | null;
  diseaseNames_INCLUDES?: string | null;
  diseaseNames_NOT?: (string | null)[] | null;
  diseaseNames_NOT_INCLUDES?: string | null;
  diseases?: (string | null)[] | null;
  diseases_INCLUDES?: string | null;
  diseases_NOT?: (string | null)[] | null;
  diseases_NOT_INCLUDES?: string | null;
  formattedCountry?: string | null;
  formattedCountry_CONTAINS?: string | null;
  formattedCountry_ENDS_WITH?: string | null;
  formattedCountry_IN?: (string | null)[] | null;
  formattedCountry_MATCHES?: string | null;
  formattedCountry_NOT?: string | null;
  formattedCountry_NOT_CONTAINS?: string | null;
  formattedCountry_NOT_ENDS_WITH?: string | null;
  formattedCountry_NOT_IN?: (string | null)[] | null;
  formattedCountry_NOT_STARTS_WITH?: string | null;
  formattedCountry_STARTS_WITH?: string | null;
  formattedDiseaseNames?: string | null;
  formattedDiseaseNames_CONTAINS?: string | null;
  formattedDiseaseNames_ENDS_WITH?: string | null;
  formattedDiseaseNames_IN?: (string | null)[] | null;
  formattedDiseaseNames_MATCHES?: string | null;
  formattedDiseaseNames_NOT?: string | null;
  formattedDiseaseNames_NOT_CONTAINS?: string | null;
  formattedDiseaseNames_NOT_ENDS_WITH?: string | null;
  formattedDiseaseNames_NOT_IN?: (string | null)[] | null;
  formattedDiseaseNames_NOT_STARTS_WITH?: string | null;
  formattedDiseaseNames_STARTS_WITH?: string | null;
  formattedManufacturers?: string | null;
  formattedManufacturers_CONTAINS?: string | null;
  formattedManufacturers_ENDS_WITH?: string | null;
  formattedManufacturers_IN?: (string | null)[] | null;
  formattedManufacturers_MATCHES?: string | null;
  formattedManufacturers_NOT?: string | null;
  formattedManufacturers_NOT_CONTAINS?: string | null;
  formattedManufacturers_NOT_ENDS_WITH?: string | null;
  formattedManufacturers_NOT_IN?: (string | null)[] | null;
  formattedManufacturers_NOT_STARTS_WITH?: string | null;
  formattedManufacturers_STARTS_WITH?: string | null;
  formattedMeasures?: string | null;
  formattedMeasures_CONTAINS?: string | null;
  formattedMeasures_ENDS_WITH?: string | null;
  formattedMeasures_IN?: (string | null)[] | null;
  formattedMeasures_MATCHES?: string | null;
  formattedMeasures_NOT?: string | null;
  formattedMeasures_NOT_CONTAINS?: string | null;
  formattedMeasures_NOT_ENDS_WITH?: string | null;
  formattedMeasures_NOT_IN?: (string | null)[] | null;
  formattedMeasures_NOT_STARTS_WITH?: string | null;
  formattedMeasures_STARTS_WITH?: string | null;
  formattedModels?: string | null;
  formattedModels_CONTAINS?: string | null;
  formattedModels_ENDS_WITH?: string | null;
  formattedModels_IN?: (string | null)[] | null;
  formattedModels_MATCHES?: string | null;
  formattedModels_NOT?: string | null;
  formattedModels_NOT_CONTAINS?: string | null;
  formattedModels_NOT_ENDS_WITH?: string | null;
  formattedModels_NOT_IN?: (string | null)[] | null;
  formattedModels_NOT_STARTS_WITH?: string | null;
  formattedModels_STARTS_WITH?: string | null;
  formattedRegion?: string | null;
  formattedRegion_CONTAINS?: string | null;
  formattedRegion_ENDS_WITH?: string | null;
  formattedRegion_IN?: (string | null)[] | null;
  formattedRegion_MATCHES?: string | null;
  formattedRegion_NOT?: string | null;
  formattedRegion_NOT_CONTAINS?: string | null;
  formattedRegion_NOT_ENDS_WITH?: string | null;
  formattedRegion_NOT_IN?: (string | null)[] | null;
  formattedRegion_NOT_STARTS_WITH?: string | null;
  formattedRegion_STARTS_WITH?: string | null;
  formattedTherapeuticAreas?: string | null;
  formattedTherapeuticAreas_CONTAINS?: string | null;
  formattedTherapeuticAreas_ENDS_WITH?: string | null;
  formattedTherapeuticAreas_IN?: (string | null)[] | null;
  formattedTherapeuticAreas_MATCHES?: string | null;
  formattedTherapeuticAreas_NOT?: string | null;
  formattedTherapeuticAreas_NOT_CONTAINS?: string | null;
  formattedTherapeuticAreas_NOT_ENDS_WITH?: string | null;
  formattedTherapeuticAreas_NOT_IN?: (string | null)[] | null;
  formattedTherapeuticAreas_NOT_STARTS_WITH?: string | null;
  formattedTherapeuticAreas_STARTS_WITH?: string | null;
  id?: string | null;
  id_CONTAINS?: string | null;
  id_ENDS_WITH?: string | null;
  id_IN?: (string | null)[] | null;
  id_MATCHES?: string | null;
  id_NOT?: string | null;
  id_NOT_CONTAINS?: string | null;
  id_NOT_ENDS_WITH?: string | null;
  id_NOT_IN?: (string | null)[] | null;
  id_NOT_STARTS_WITH?: string | null;
  id_STARTS_WITH?: string | null;
  indication?: string | null;
  indication_CONTAINS?: string | null;
  indication_ENDS_WITH?: string | null;
  indication_IN?: (string | null)[] | null;
  indication_MATCHES?: string | null;
  indication_NOT?: string | null;
  indication_NOT_CONTAINS?: string | null;
  indication_NOT_ENDS_WITH?: string | null;
  indication_NOT_IN?: (string | null)[] | null;
  indication_NOT_STARTS_WITH?: string | null;
  indication_STARTS_WITH?: string | null;
  manufacturers?: string[] | null;
  manufacturersReference?: string[] | null;
  manufacturersReference_INCLUDES?: string | null;
  manufacturersReference_NOT?: string[] | null;
  manufacturersReference_NOT_INCLUDES?: string | null;
  manufacturers_INCLUDES?: string | null;
  manufacturers_NOT?: string[] | null;
  manufacturers_NOT_INCLUDES?: string | null;
  measures?: (string | null)[] | null;
  measures_INCLUDES?: string | null;
  measures_NOT?: (string | null)[] | null;
  measures_NOT_INCLUDES?: string | null;
  models?: string[] | null;
  models_INCLUDES?: string | null;
  models_NOT?: string[] | null;
  models_NOT_INCLUDES?: string | null;
  payer?: string | null;
  payerReference?: string[] | null;
  payerReference_INCLUDES?: string | null;
  payerReference_NOT?: string[] | null;
  payerReference_NOT_INCLUDES?: string | null;
  payerType?: string | null;
  payerType_CONTAINS?: string | null;
  payerType_ENDS_WITH?: string | null;
  payerType_IN?: (string | null)[] | null;
  payerType_MATCHES?: string | null;
  payerType_NOT?: string | null;
  payerType_NOT_CONTAINS?: string | null;
  payerType_NOT_ENDS_WITH?: string | null;
  payerType_NOT_IN?: (string | null)[] | null;
  payerType_NOT_STARTS_WITH?: string | null;
  payerType_STARTS_WITH?: string | null;
  payer_CONTAINS?: string | null;
  payer_ENDS_WITH?: string | null;
  payer_IN?: (string | null)[] | null;
  payer_MATCHES?: string | null;
  payer_NOT?: string | null;
  payer_NOT_CONTAINS?: string | null;
  payer_NOT_ENDS_WITH?: string | null;
  payer_NOT_IN?: (string | null)[] | null;
  payer_NOT_STARTS_WITH?: string | null;
  payer_STARTS_WITH?: string | null;
  product?: string | null;
  productType?: string | null;
  productType_CONTAINS?: string | null;
  productType_ENDS_WITH?: string | null;
  productType_IN?: (string | null)[] | null;
  productType_MATCHES?: string | null;
  productType_NOT?: string | null;
  productType_NOT_CONTAINS?: string | null;
  productType_NOT_ENDS_WITH?: string | null;
  productType_NOT_IN?: (string | null)[] | null;
  productType_NOT_STARTS_WITH?: string | null;
  productType_STARTS_WITH?: string | null;
  product_CONTAINS?: string | null;
  product_ENDS_WITH?: string | null;
  product_IN?: (string | null)[] | null;
  product_MATCHES?: string | null;
  product_NOT?: string | null;
  product_NOT_CONTAINS?: string | null;
  product_NOT_ENDS_WITH?: string | null;
  product_NOT_IN?: (string | null)[] | null;
  product_NOT_STARTS_WITH?: string | null;
  product_STARTS_WITH?: string | null;
  sources?: (string | null)[] | null;
  sources_INCLUDES?: string | null;
  sources_NOT?: (string | null)[] | null;
  sources_NOT_INCLUDES?: string | null;
  status?: string | null;
  status_CONTAINS?: string | null;
  status_ENDS_WITH?: string | null;
  status_IN?: (string | null)[] | null;
  status_MATCHES?: string | null;
  status_NOT?: string | null;
  status_NOT_CONTAINS?: string | null;
  status_NOT_ENDS_WITH?: string | null;
  status_NOT_IN?: (string | null)[] | null;
  status_NOT_STARTS_WITH?: string | null;
  status_STARTS_WITH?: string | null;
  summary?: string | null;
  summary_CONTAINS?: string | null;
  summary_ENDS_WITH?: string | null;
  summary_IN?: (string | null)[] | null;
  summary_MATCHES?: string | null;
  summary_NOT?: string | null;
  summary_NOT_CONTAINS?: string | null;
  summary_NOT_ENDS_WITH?: string | null;
  summary_NOT_IN?: (string | null)[] | null;
  summary_NOT_STARTS_WITH?: string | null;
  summary_STARTS_WITH?: string | null;
  therapeuticAreas?: (string | null)[] | null;
  therapeuticAreas_INCLUDES?: string | null;
  therapeuticAreas_NOT?: (string | null)[] | null;
  therapeuticAreas_NOT_INCLUDES?: string | null;
  year?: number | null;
  year_GT?: number | null;
  year_GTE?: number | null;
  year_IN?: (number | null)[] | null;
  year_LT?: number | null;
  year_LTE?: number | null;
  year_NOT?: number | null;
  year_NOT_IN?: (number | null)[] | null;
}

export interface QuestBrandAggregateInput {
  AND?: QuestBrandAggregateInput[] | null;
  OR?: QuestBrandAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: QuestBrandNodeAggregationWhereInput | null;
}

export interface QuestBrandConnectionWhere {
  AND?: QuestBrandConnectionWhere[] | null;
  OR?: QuestBrandConnectionWhere[] | null;
  node?: BrandWhere | null;
  node_NOT?: BrandWhere | null;
}

export interface QuestBrandNodeAggregationWhereInput {
  AND?: QuestBrandNodeAggregationWhereInput[] | null;
  Name_AVERAGE_EQUAL?: number | null;
  Name_AVERAGE_GT?: number | null;
  Name_AVERAGE_GTE?: number | null;
  Name_AVERAGE_LT?: number | null;
  Name_AVERAGE_LTE?: number | null;
  Name_EQUAL?: string | null;
  Name_GT?: number | null;
  Name_GTE?: number | null;
  Name_LONGEST_EQUAL?: number | null;
  Name_LONGEST_GT?: number | null;
  Name_LONGEST_GTE?: number | null;
  Name_LONGEST_LT?: number | null;
  Name_LONGEST_LTE?: number | null;
  Name_LT?: number | null;
  Name_LTE?: number | null;
  Name_SHORTEST_EQUAL?: number | null;
  Name_SHORTEST_GT?: number | null;
  Name_SHORTEST_GTE?: number | null;
  Name_SHORTEST_LT?: number | null;
  Name_SHORTEST_LTE?: number | null;
  OR?: QuestBrandNodeAggregationWhereInput[] | null;
  id_EQUAL?: string | null;
}

export interface QuestCaseAggregateInput {
  AND?: QuestCaseAggregateInput[] | null;
  OR?: QuestCaseAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: QuestCaseNodeAggregationWhereInput | null;
}

export interface QuestCaseConnectionWhere {
  AND?: QuestCaseConnectionWhere[] | null;
  OR?: QuestCaseConnectionWhere[] | null;
  node?: CaseWhere | null;
  node_NOT?: CaseWhere | null;
}

export interface QuestCaseNodeAggregationWhereInput {
  AND?: QuestCaseNodeAggregationWhereInput[] | null;
  OR?: QuestCaseNodeAggregationWhereInput[] | null;
  actualAgreementId_AVERAGE_EQUAL?: number | null;
  actualAgreementId_AVERAGE_GT?: number | null;
  actualAgreementId_AVERAGE_GTE?: number | null;
  actualAgreementId_AVERAGE_LT?: number | null;
  actualAgreementId_AVERAGE_LTE?: number | null;
  actualAgreementId_EQUAL?: string | null;
  actualAgreementId_GT?: number | null;
  actualAgreementId_GTE?: number | null;
  actualAgreementId_LONGEST_EQUAL?: number | null;
  actualAgreementId_LONGEST_GT?: number | null;
  actualAgreementId_LONGEST_GTE?: number | null;
  actualAgreementId_LONGEST_LT?: number | null;
  actualAgreementId_LONGEST_LTE?: number | null;
  actualAgreementId_LT?: number | null;
  actualAgreementId_LTE?: number | null;
  actualAgreementId_SHORTEST_EQUAL?: number | null;
  actualAgreementId_SHORTEST_GT?: number | null;
  actualAgreementId_SHORTEST_GTE?: number | null;
  actualAgreementId_SHORTEST_LT?: number | null;
  actualAgreementId_SHORTEST_LTE?: number | null;
  agreementName_AVERAGE_EQUAL?: number | null;
  agreementName_AVERAGE_GT?: number | null;
  agreementName_AVERAGE_GTE?: number | null;
  agreementName_AVERAGE_LT?: number | null;
  agreementName_AVERAGE_LTE?: number | null;
  agreementName_EQUAL?: string | null;
  agreementName_GT?: number | null;
  agreementName_GTE?: number | null;
  agreementName_LONGEST_EQUAL?: number | null;
  agreementName_LONGEST_GT?: number | null;
  agreementName_LONGEST_GTE?: number | null;
  agreementName_LONGEST_LT?: number | null;
  agreementName_LONGEST_LTE?: number | null;
  agreementName_LT?: number | null;
  agreementName_LTE?: number | null;
  agreementName_SHORTEST_EQUAL?: number | null;
  agreementName_SHORTEST_GT?: number | null;
  agreementName_SHORTEST_GTE?: number | null;
  agreementName_SHORTEST_LT?: number | null;
  agreementName_SHORTEST_LTE?: number | null;
  counterpartyInReview_AVERAGE_EQUAL?: number | null;
  counterpartyInReview_AVERAGE_GT?: number | null;
  counterpartyInReview_AVERAGE_GTE?: number | null;
  counterpartyInReview_AVERAGE_LT?: number | null;
  counterpartyInReview_AVERAGE_LTE?: number | null;
  counterpartyInReview_EQUAL?: string | null;
  counterpartyInReview_GT?: number | null;
  counterpartyInReview_GTE?: number | null;
  counterpartyInReview_LONGEST_EQUAL?: number | null;
  counterpartyInReview_LONGEST_GT?: number | null;
  counterpartyInReview_LONGEST_GTE?: number | null;
  counterpartyInReview_LONGEST_LT?: number | null;
  counterpartyInReview_LONGEST_LTE?: number | null;
  counterpartyInReview_LT?: number | null;
  counterpartyInReview_LTE?: number | null;
  counterpartyInReview_SHORTEST_EQUAL?: number | null;
  counterpartyInReview_SHORTEST_GT?: number | null;
  counterpartyInReview_SHORTEST_GTE?: number | null;
  counterpartyInReview_SHORTEST_LT?: number | null;
  counterpartyInReview_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  lastStatusChangeDate_EQUAL?: any | null;
  lastStatusChangeDate_GT?: any | null;
  lastStatusChangeDate_GTE?: any | null;
  lastStatusChangeDate_LT?: any | null;
  lastStatusChangeDate_LTE?: any | null;
  lastStatusChangeDate_MAX_EQUAL?: any | null;
  lastStatusChangeDate_MAX_GT?: any | null;
  lastStatusChangeDate_MAX_GTE?: any | null;
  lastStatusChangeDate_MAX_LT?: any | null;
  lastStatusChangeDate_MAX_LTE?: any | null;
  lastStatusChangeDate_MIN_EQUAL?: any | null;
  lastStatusChangeDate_MIN_GT?: any | null;
  lastStatusChangeDate_MIN_GTE?: any | null;
  lastStatusChangeDate_MIN_LT?: any | null;
  lastStatusChangeDate_MIN_LTE?: any | null;
  patientInitials_AVERAGE_EQUAL?: number | null;
  patientInitials_AVERAGE_GT?: number | null;
  patientInitials_AVERAGE_GTE?: number | null;
  patientInitials_AVERAGE_LT?: number | null;
  patientInitials_AVERAGE_LTE?: number | null;
  patientInitials_EQUAL?: string | null;
  patientInitials_GT?: number | null;
  patientInitials_GTE?: number | null;
  patientInitials_LONGEST_EQUAL?: number | null;
  patientInitials_LONGEST_GT?: number | null;
  patientInitials_LONGEST_GTE?: number | null;
  patientInitials_LONGEST_LT?: number | null;
  patientInitials_LONGEST_LTE?: number | null;
  patientInitials_LT?: number | null;
  patientInitials_LTE?: number | null;
  patientInitials_SHORTEST_EQUAL?: number | null;
  patientInitials_SHORTEST_GT?: number | null;
  patientInitials_SHORTEST_GTE?: number | null;
  patientInitials_SHORTEST_LT?: number | null;
  patientInitials_SHORTEST_LTE?: number | null;
  patientInsuranceId_AVERAGE_EQUAL?: number | null;
  patientInsuranceId_AVERAGE_GT?: number | null;
  patientInsuranceId_AVERAGE_GTE?: number | null;
  patientInsuranceId_AVERAGE_LT?: number | null;
  patientInsuranceId_AVERAGE_LTE?: number | null;
  patientInsuranceId_EQUAL?: string | null;
  patientInsuranceId_GT?: number | null;
  patientInsuranceId_GTE?: number | null;
  patientInsuranceId_LONGEST_EQUAL?: number | null;
  patientInsuranceId_LONGEST_GT?: number | null;
  patientInsuranceId_LONGEST_GTE?: number | null;
  patientInsuranceId_LONGEST_LT?: number | null;
  patientInsuranceId_LONGEST_LTE?: number | null;
  patientInsuranceId_LT?: number | null;
  patientInsuranceId_LTE?: number | null;
  patientInsuranceId_SHORTEST_EQUAL?: number | null;
  patientInsuranceId_SHORTEST_GT?: number | null;
  patientInsuranceId_SHORTEST_GTE?: number | null;
  patientInsuranceId_SHORTEST_LT?: number | null;
  patientInsuranceId_SHORTEST_LTE?: number | null;
  preparationBrandName_AVERAGE_EQUAL?: number | null;
  preparationBrandName_AVERAGE_GT?: number | null;
  preparationBrandName_AVERAGE_GTE?: number | null;
  preparationBrandName_AVERAGE_LT?: number | null;
  preparationBrandName_AVERAGE_LTE?: number | null;
  preparationBrandName_EQUAL?: string | null;
  preparationBrandName_GT?: number | null;
  preparationBrandName_GTE?: number | null;
  preparationBrandName_LONGEST_EQUAL?: number | null;
  preparationBrandName_LONGEST_GT?: number | null;
  preparationBrandName_LONGEST_GTE?: number | null;
  preparationBrandName_LONGEST_LT?: number | null;
  preparationBrandName_LONGEST_LTE?: number | null;
  preparationBrandName_LT?: number | null;
  preparationBrandName_LTE?: number | null;
  preparationBrandName_SHORTEST_EQUAL?: number | null;
  preparationBrandName_SHORTEST_GT?: number | null;
  preparationBrandName_SHORTEST_GTE?: number | null;
  preparationBrandName_SHORTEST_LT?: number | null;
  preparationBrandName_SHORTEST_LTE?: number | null;
  preparationGenericName_AVERAGE_EQUAL?: number | null;
  preparationGenericName_AVERAGE_GT?: number | null;
  preparationGenericName_AVERAGE_GTE?: number | null;
  preparationGenericName_AVERAGE_LT?: number | null;
  preparationGenericName_AVERAGE_LTE?: number | null;
  preparationGenericName_EQUAL?: string | null;
  preparationGenericName_GT?: number | null;
  preparationGenericName_GTE?: number | null;
  preparationGenericName_LONGEST_EQUAL?: number | null;
  preparationGenericName_LONGEST_GT?: number | null;
  preparationGenericName_LONGEST_GTE?: number | null;
  preparationGenericName_LONGEST_LT?: number | null;
  preparationGenericName_LONGEST_LTE?: number | null;
  preparationGenericName_LT?: number | null;
  preparationGenericName_LTE?: number | null;
  preparationGenericName_SHORTEST_EQUAL?: number | null;
  preparationGenericName_SHORTEST_GT?: number | null;
  preparationGenericName_SHORTEST_GTE?: number | null;
  preparationGenericName_SHORTEST_LT?: number | null;
  preparationGenericName_SHORTEST_LTE?: number | null;
  sourceTenantId_AVERAGE_EQUAL?: number | null;
  sourceTenantId_AVERAGE_GT?: number | null;
  sourceTenantId_AVERAGE_GTE?: number | null;
  sourceTenantId_AVERAGE_LT?: number | null;
  sourceTenantId_AVERAGE_LTE?: number | null;
  sourceTenantId_EQUAL?: string | null;
  sourceTenantId_GT?: number | null;
  sourceTenantId_GTE?: number | null;
  sourceTenantId_LONGEST_EQUAL?: number | null;
  sourceTenantId_LONGEST_GT?: number | null;
  sourceTenantId_LONGEST_GTE?: number | null;
  sourceTenantId_LONGEST_LT?: number | null;
  sourceTenantId_LONGEST_LTE?: number | null;
  sourceTenantId_LT?: number | null;
  sourceTenantId_LTE?: number | null;
  sourceTenantId_SHORTEST_EQUAL?: number | null;
  sourceTenantId_SHORTEST_GT?: number | null;
  sourceTenantId_SHORTEST_GTE?: number | null;
  sourceTenantId_SHORTEST_LT?: number | null;
  sourceTenantId_SHORTEST_LTE?: number | null;
  submissionDate_EQUAL?: any | null;
  submissionDate_GT?: any | null;
  submissionDate_GTE?: any | null;
  submissionDate_LT?: any | null;
  submissionDate_LTE?: any | null;
  submissionDate_MAX_EQUAL?: any | null;
  submissionDate_MAX_GT?: any | null;
  submissionDate_MAX_GTE?: any | null;
  submissionDate_MAX_LT?: any | null;
  submissionDate_MAX_LTE?: any | null;
  submissionDate_MIN_EQUAL?: any | null;
  submissionDate_MIN_GT?: any | null;
  submissionDate_MIN_GTE?: any | null;
  submissionDate_MIN_LT?: any | null;
  submissionDate_MIN_LTE?: any | null;
  suspensionReason_AVERAGE_EQUAL?: number | null;
  suspensionReason_AVERAGE_GT?: number | null;
  suspensionReason_AVERAGE_GTE?: number | null;
  suspensionReason_AVERAGE_LT?: number | null;
  suspensionReason_AVERAGE_LTE?: number | null;
  suspensionReason_EQUAL?: string | null;
  suspensionReason_GT?: number | null;
  suspensionReason_GTE?: number | null;
  suspensionReason_LONGEST_EQUAL?: number | null;
  suspensionReason_LONGEST_GT?: number | null;
  suspensionReason_LONGEST_GTE?: number | null;
  suspensionReason_LONGEST_LT?: number | null;
  suspensionReason_LONGEST_LTE?: number | null;
  suspensionReason_LT?: number | null;
  suspensionReason_LTE?: number | null;
  suspensionReason_SHORTEST_EQUAL?: number | null;
  suspensionReason_SHORTEST_GT?: number | null;
  suspensionReason_SHORTEST_GTE?: number | null;
  suspensionReason_SHORTEST_LT?: number | null;
  suspensionReason_SHORTEST_LTE?: number | null;
  totalAmount_AVERAGE_EQUAL?: number | null;
  totalAmount_AVERAGE_GT?: number | null;
  totalAmount_AVERAGE_GTE?: number | null;
  totalAmount_AVERAGE_LT?: number | null;
  totalAmount_AVERAGE_LTE?: number | null;
  totalAmount_EQUAL?: number | null;
  totalAmount_GT?: number | null;
  totalAmount_GTE?: number | null;
  totalAmount_LT?: number | null;
  totalAmount_LTE?: number | null;
  totalAmount_MAX_EQUAL?: number | null;
  totalAmount_MAX_GT?: number | null;
  totalAmount_MAX_GTE?: number | null;
  totalAmount_MAX_LT?: number | null;
  totalAmount_MAX_LTE?: number | null;
  totalAmount_MIN_EQUAL?: number | null;
  totalAmount_MIN_GT?: number | null;
  totalAmount_MIN_GTE?: number | null;
  totalAmount_MIN_LT?: number | null;
  totalAmount_MIN_LTE?: number | null;
  totalAmount_SUM_EQUAL?: number | null;
  totalAmount_SUM_GT?: number | null;
  totalAmount_SUM_GTE?: number | null;
  totalAmount_SUM_LT?: number | null;
  totalAmount_SUM_LTE?: number | null;
  unlimited_AVERAGE_EQUAL?: number | null;
  unlimited_AVERAGE_GT?: number | null;
  unlimited_AVERAGE_GTE?: number | null;
  unlimited_AVERAGE_LT?: number | null;
  unlimited_AVERAGE_LTE?: number | null;
  unlimited_EQUAL?: number | null;
  unlimited_GT?: number | null;
  unlimited_GTE?: number | null;
  unlimited_LT?: number | null;
  unlimited_LTE?: number | null;
  unlimited_MAX_EQUAL?: number | null;
  unlimited_MAX_GT?: number | null;
  unlimited_MAX_GTE?: number | null;
  unlimited_MAX_LT?: number | null;
  unlimited_MAX_LTE?: number | null;
  unlimited_MIN_EQUAL?: number | null;
  unlimited_MIN_GT?: number | null;
  unlimited_MIN_GTE?: number | null;
  unlimited_MIN_LT?: number | null;
  unlimited_MIN_LTE?: number | null;
  unlimited_SUM_EQUAL?: number | null;
  unlimited_SUM_GT?: number | null;
  unlimited_SUM_GTE?: number | null;
  unlimited_SUM_LT?: number | null;
  unlimited_SUM_LTE?: number | null;
}

export interface QuestNotificationSubscribedAggregateInput {
  AND?: QuestNotificationSubscribedAggregateInput[] | null;
  OR?: QuestNotificationSubscribedAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  edge?: QuestNotificationSubscribedEdgeAggregationWhereInput | null;
  node?: QuestNotificationSubscribedNodeAggregationWhereInput | null;
}

export interface QuestNotificationSubscribedConnectionWhere {
  AND?: QuestNotificationSubscribedConnectionWhere[] | null;
  OR?: QuestNotificationSubscribedConnectionWhere[] | null;
  edge?: OrganizationQuestRelationshipWhere | null;
  edge_NOT?: OrganizationQuestRelationshipWhere | null;
  node?: OrganizationWhere | null;
  node_NOT?: OrganizationWhere | null;
}

export interface QuestNotificationSubscribedEdgeAggregationWhereInput {
  AND?: QuestNotificationSubscribedEdgeAggregationWhereInput[] | null;
  OR?: QuestNotificationSubscribedEdgeAggregationWhereInput[] | null;
  threshold_AVERAGE_EQUAL?: number | null;
  threshold_AVERAGE_GT?: number | null;
  threshold_AVERAGE_GTE?: number | null;
  threshold_AVERAGE_LT?: number | null;
  threshold_AVERAGE_LTE?: number | null;
  threshold_EQUAL?: number | null;
  threshold_GT?: number | null;
  threshold_GTE?: number | null;
  threshold_LT?: number | null;
  threshold_LTE?: number | null;
  threshold_MAX_EQUAL?: number | null;
  threshold_MAX_GT?: number | null;
  threshold_MAX_GTE?: number | null;
  threshold_MAX_LT?: number | null;
  threshold_MAX_LTE?: number | null;
  threshold_MIN_EQUAL?: number | null;
  threshold_MIN_GT?: number | null;
  threshold_MIN_GTE?: number | null;
  threshold_MIN_LT?: number | null;
  threshold_MIN_LTE?: number | null;
  threshold_SUM_EQUAL?: number | null;
  threshold_SUM_GT?: number | null;
  threshold_SUM_GTE?: number | null;
  threshold_SUM_LT?: number | null;
  threshold_SUM_LTE?: number | null;
}

export interface QuestNotificationSubscribedNodeAggregationWhereInput {
  AND?: QuestNotificationSubscribedNodeAggregationWhereInput[] | null;
  BIC_AVERAGE_EQUAL?: number | null;
  BIC_AVERAGE_GT?: number | null;
  BIC_AVERAGE_GTE?: number | null;
  BIC_AVERAGE_LT?: number | null;
  BIC_AVERAGE_LTE?: number | null;
  BIC_EQUAL?: string | null;
  BIC_GT?: number | null;
  BIC_GTE?: number | null;
  BIC_LONGEST_EQUAL?: number | null;
  BIC_LONGEST_GT?: number | null;
  BIC_LONGEST_GTE?: number | null;
  BIC_LONGEST_LT?: number | null;
  BIC_LONGEST_LTE?: number | null;
  BIC_LT?: number | null;
  BIC_LTE?: number | null;
  BIC_SHORTEST_EQUAL?: number | null;
  BIC_SHORTEST_GT?: number | null;
  BIC_SHORTEST_GTE?: number | null;
  BIC_SHORTEST_LT?: number | null;
  BIC_SHORTEST_LTE?: number | null;
  IBAN_AVERAGE_EQUAL?: number | null;
  IBAN_AVERAGE_GT?: number | null;
  IBAN_AVERAGE_GTE?: number | null;
  IBAN_AVERAGE_LT?: number | null;
  IBAN_AVERAGE_LTE?: number | null;
  IBAN_EQUAL?: string | null;
  IBAN_GT?: number | null;
  IBAN_GTE?: number | null;
  IBAN_LONGEST_EQUAL?: number | null;
  IBAN_LONGEST_GT?: number | null;
  IBAN_LONGEST_GTE?: number | null;
  IBAN_LONGEST_LT?: number | null;
  IBAN_LONGEST_LTE?: number | null;
  IBAN_LT?: number | null;
  IBAN_LTE?: number | null;
  IBAN_SHORTEST_EQUAL?: number | null;
  IBAN_SHORTEST_GT?: number | null;
  IBAN_SHORTEST_GTE?: number | null;
  IBAN_SHORTEST_LT?: number | null;
  IBAN_SHORTEST_LTE?: number | null;
  OR?: QuestNotificationSubscribedNodeAggregationWhereInput[] | null;
  accountName_AVERAGE_EQUAL?: number | null;
  accountName_AVERAGE_GT?: number | null;
  accountName_AVERAGE_GTE?: number | null;
  accountName_AVERAGE_LT?: number | null;
  accountName_AVERAGE_LTE?: number | null;
  accountName_EQUAL?: string | null;
  accountName_GT?: number | null;
  accountName_GTE?: number | null;
  accountName_LONGEST_EQUAL?: number | null;
  accountName_LONGEST_GT?: number | null;
  accountName_LONGEST_GTE?: number | null;
  accountName_LONGEST_LT?: number | null;
  accountName_LONGEST_LTE?: number | null;
  accountName_LT?: number | null;
  accountName_LTE?: number | null;
  accountName_SHORTEST_EQUAL?: number | null;
  accountName_SHORTEST_GT?: number | null;
  accountName_SHORTEST_GTE?: number | null;
  accountName_SHORTEST_LT?: number | null;
  accountName_SHORTEST_LTE?: number | null;
  accountNumber_AVERAGE_EQUAL?: number | null;
  accountNumber_AVERAGE_GT?: number | null;
  accountNumber_AVERAGE_GTE?: number | null;
  accountNumber_AVERAGE_LT?: number | null;
  accountNumber_AVERAGE_LTE?: number | null;
  accountNumber_EQUAL?: string | null;
  accountNumber_GT?: number | null;
  accountNumber_GTE?: number | null;
  accountNumber_LONGEST_EQUAL?: number | null;
  accountNumber_LONGEST_GT?: number | null;
  accountNumber_LONGEST_GTE?: number | null;
  accountNumber_LONGEST_LT?: number | null;
  accountNumber_LONGEST_LTE?: number | null;
  accountNumber_LT?: number | null;
  accountNumber_LTE?: number | null;
  accountNumber_SHORTEST_EQUAL?: number | null;
  accountNumber_SHORTEST_GT?: number | null;
  accountNumber_SHORTEST_GTE?: number | null;
  accountNumber_SHORTEST_LT?: number | null;
  accountNumber_SHORTEST_LTE?: number | null;
  billingAddress_AVERAGE_EQUAL?: number | null;
  billingAddress_AVERAGE_GT?: number | null;
  billingAddress_AVERAGE_GTE?: number | null;
  billingAddress_AVERAGE_LT?: number | null;
  billingAddress_AVERAGE_LTE?: number | null;
  billingAddress_EQUAL?: string | null;
  billingAddress_GT?: number | null;
  billingAddress_GTE?: number | null;
  billingAddress_LONGEST_EQUAL?: number | null;
  billingAddress_LONGEST_GT?: number | null;
  billingAddress_LONGEST_GTE?: number | null;
  billingAddress_LONGEST_LT?: number | null;
  billingAddress_LONGEST_LTE?: number | null;
  billingAddress_LT?: number | null;
  billingAddress_LTE?: number | null;
  billingAddress_SHORTEST_EQUAL?: number | null;
  billingAddress_SHORTEST_GT?: number | null;
  billingAddress_SHORTEST_GTE?: number | null;
  billingAddress_SHORTEST_LT?: number | null;
  billingAddress_SHORTEST_LTE?: number | null;
  contactEmail_AVERAGE_EQUAL?: number | null;
  contactEmail_AVERAGE_GT?: number | null;
  contactEmail_AVERAGE_GTE?: number | null;
  contactEmail_AVERAGE_LT?: number | null;
  contactEmail_AVERAGE_LTE?: number | null;
  contactEmail_EQUAL?: string | null;
  contactEmail_GT?: number | null;
  contactEmail_GTE?: number | null;
  contactEmail_LONGEST_EQUAL?: number | null;
  contactEmail_LONGEST_GT?: number | null;
  contactEmail_LONGEST_GTE?: number | null;
  contactEmail_LONGEST_LT?: number | null;
  contactEmail_LONGEST_LTE?: number | null;
  contactEmail_LT?: number | null;
  contactEmail_LTE?: number | null;
  contactEmail_SHORTEST_EQUAL?: number | null;
  contactEmail_SHORTEST_GT?: number | null;
  contactEmail_SHORTEST_GTE?: number | null;
  contactEmail_SHORTEST_LT?: number | null;
  contactEmail_SHORTEST_LTE?: number | null;
  contactFirstName_AVERAGE_EQUAL?: number | null;
  contactFirstName_AVERAGE_GT?: number | null;
  contactFirstName_AVERAGE_GTE?: number | null;
  contactFirstName_AVERAGE_LT?: number | null;
  contactFirstName_AVERAGE_LTE?: number | null;
  contactFirstName_EQUAL?: string | null;
  contactFirstName_GT?: number | null;
  contactFirstName_GTE?: number | null;
  contactFirstName_LONGEST_EQUAL?: number | null;
  contactFirstName_LONGEST_GT?: number | null;
  contactFirstName_LONGEST_GTE?: number | null;
  contactFirstName_LONGEST_LT?: number | null;
  contactFirstName_LONGEST_LTE?: number | null;
  contactFirstName_LT?: number | null;
  contactFirstName_LTE?: number | null;
  contactFirstName_SHORTEST_EQUAL?: number | null;
  contactFirstName_SHORTEST_GT?: number | null;
  contactFirstName_SHORTEST_GTE?: number | null;
  contactFirstName_SHORTEST_LT?: number | null;
  contactFirstName_SHORTEST_LTE?: number | null;
  contactLastName_AVERAGE_EQUAL?: number | null;
  contactLastName_AVERAGE_GT?: number | null;
  contactLastName_AVERAGE_GTE?: number | null;
  contactLastName_AVERAGE_LT?: number | null;
  contactLastName_AVERAGE_LTE?: number | null;
  contactLastName_EQUAL?: string | null;
  contactLastName_GT?: number | null;
  contactLastName_GTE?: number | null;
  contactLastName_LONGEST_EQUAL?: number | null;
  contactLastName_LONGEST_GT?: number | null;
  contactLastName_LONGEST_GTE?: number | null;
  contactLastName_LONGEST_LT?: number | null;
  contactLastName_LONGEST_LTE?: number | null;
  contactLastName_LT?: number | null;
  contactLastName_LTE?: number | null;
  contactLastName_SHORTEST_EQUAL?: number | null;
  contactLastName_SHORTEST_GT?: number | null;
  contactLastName_SHORTEST_GTE?: number | null;
  contactLastName_SHORTEST_LT?: number | null;
  contactLastName_SHORTEST_LTE?: number | null;
  contactOccupation_AVERAGE_EQUAL?: number | null;
  contactOccupation_AVERAGE_GT?: number | null;
  contactOccupation_AVERAGE_GTE?: number | null;
  contactOccupation_AVERAGE_LT?: number | null;
  contactOccupation_AVERAGE_LTE?: number | null;
  contactOccupation_EQUAL?: string | null;
  contactOccupation_GT?: number | null;
  contactOccupation_GTE?: number | null;
  contactOccupation_LONGEST_EQUAL?: number | null;
  contactOccupation_LONGEST_GT?: number | null;
  contactOccupation_LONGEST_GTE?: number | null;
  contactOccupation_LONGEST_LT?: number | null;
  contactOccupation_LONGEST_LTE?: number | null;
  contactOccupation_LT?: number | null;
  contactOccupation_LTE?: number | null;
  contactOccupation_SHORTEST_EQUAL?: number | null;
  contactOccupation_SHORTEST_GT?: number | null;
  contactOccupation_SHORTEST_GTE?: number | null;
  contactOccupation_SHORTEST_LT?: number | null;
  contactOccupation_SHORTEST_LTE?: number | null;
  contactPhone_AVERAGE_EQUAL?: number | null;
  contactPhone_AVERAGE_GT?: number | null;
  contactPhone_AVERAGE_GTE?: number | null;
  contactPhone_AVERAGE_LT?: number | null;
  contactPhone_AVERAGE_LTE?: number | null;
  contactPhone_EQUAL?: string | null;
  contactPhone_GT?: number | null;
  contactPhone_GTE?: number | null;
  contactPhone_LONGEST_EQUAL?: number | null;
  contactPhone_LONGEST_GT?: number | null;
  contactPhone_LONGEST_GTE?: number | null;
  contactPhone_LONGEST_LT?: number | null;
  contactPhone_LONGEST_LTE?: number | null;
  contactPhone_LT?: number | null;
  contactPhone_LTE?: number | null;
  contactPhone_SHORTEST_EQUAL?: number | null;
  contactPhone_SHORTEST_GT?: number | null;
  contactPhone_SHORTEST_GTE?: number | null;
  contactPhone_SHORTEST_LT?: number | null;
  contactPhone_SHORTEST_LTE?: number | null;
  createdOn_AVERAGE_EQUAL?: number | null;
  createdOn_AVERAGE_GT?: number | null;
  createdOn_AVERAGE_GTE?: number | null;
  createdOn_AVERAGE_LT?: number | null;
  createdOn_AVERAGE_LTE?: number | null;
  createdOn_EQUAL?: number | null;
  createdOn_GT?: number | null;
  createdOn_GTE?: number | null;
  createdOn_LT?: number | null;
  createdOn_LTE?: number | null;
  createdOn_MAX_EQUAL?: number | null;
  createdOn_MAX_GT?: number | null;
  createdOn_MAX_GTE?: number | null;
  createdOn_MAX_LT?: number | null;
  createdOn_MAX_LTE?: number | null;
  createdOn_MIN_EQUAL?: number | null;
  createdOn_MIN_GT?: number | null;
  createdOn_MIN_GTE?: number | null;
  createdOn_MIN_LT?: number | null;
  createdOn_MIN_LTE?: number | null;
  createdOn_SUM_EQUAL?: number | null;
  createdOn_SUM_GT?: number | null;
  createdOn_SUM_GTE?: number | null;
  createdOn_SUM_LT?: number | null;
  createdOn_SUM_LTE?: number | null;
  deliveryAddress_AVERAGE_EQUAL?: number | null;
  deliveryAddress_AVERAGE_GT?: number | null;
  deliveryAddress_AVERAGE_GTE?: number | null;
  deliveryAddress_AVERAGE_LT?: number | null;
  deliveryAddress_AVERAGE_LTE?: number | null;
  deliveryAddress_EQUAL?: string | null;
  deliveryAddress_GT?: number | null;
  deliveryAddress_GTE?: number | null;
  deliveryAddress_LONGEST_EQUAL?: number | null;
  deliveryAddress_LONGEST_GT?: number | null;
  deliveryAddress_LONGEST_GTE?: number | null;
  deliveryAddress_LONGEST_LT?: number | null;
  deliveryAddress_LONGEST_LTE?: number | null;
  deliveryAddress_LT?: number | null;
  deliveryAddress_LTE?: number | null;
  deliveryAddress_SHORTEST_EQUAL?: number | null;
  deliveryAddress_SHORTEST_GT?: number | null;
  deliveryAddress_SHORTEST_GTE?: number | null;
  deliveryAddress_SHORTEST_LT?: number | null;
  deliveryAddress_SHORTEST_LTE?: number | null;
  domicile_AVERAGE_EQUAL?: number | null;
  domicile_AVERAGE_GT?: number | null;
  domicile_AVERAGE_GTE?: number | null;
  domicile_AVERAGE_LT?: number | null;
  domicile_AVERAGE_LTE?: number | null;
  domicile_EQUAL?: string | null;
  domicile_GT?: number | null;
  domicile_GTE?: number | null;
  domicile_LONGEST_EQUAL?: number | null;
  domicile_LONGEST_GT?: number | null;
  domicile_LONGEST_GTE?: number | null;
  domicile_LONGEST_LT?: number | null;
  domicile_LONGEST_LTE?: number | null;
  domicile_LT?: number | null;
  domicile_LTE?: number | null;
  domicile_SHORTEST_EQUAL?: number | null;
  domicile_SHORTEST_GT?: number | null;
  domicile_SHORTEST_GTE?: number | null;
  domicile_SHORTEST_LT?: number | null;
  domicile_SHORTEST_LTE?: number | null;
  dualApprovalThreshold_AVERAGE_EQUAL?: number | null;
  dualApprovalThreshold_AVERAGE_GT?: number | null;
  dualApprovalThreshold_AVERAGE_GTE?: number | null;
  dualApprovalThreshold_AVERAGE_LT?: number | null;
  dualApprovalThreshold_AVERAGE_LTE?: number | null;
  dualApprovalThreshold_EQUAL?: number | null;
  dualApprovalThreshold_GT?: number | null;
  dualApprovalThreshold_GTE?: number | null;
  dualApprovalThreshold_LT?: number | null;
  dualApprovalThreshold_LTE?: number | null;
  dualApprovalThreshold_MAX_EQUAL?: number | null;
  dualApprovalThreshold_MAX_GT?: number | null;
  dualApprovalThreshold_MAX_GTE?: number | null;
  dualApprovalThreshold_MAX_LT?: number | null;
  dualApprovalThreshold_MAX_LTE?: number | null;
  dualApprovalThreshold_MIN_EQUAL?: number | null;
  dualApprovalThreshold_MIN_GT?: number | null;
  dualApprovalThreshold_MIN_GTE?: number | null;
  dualApprovalThreshold_MIN_LT?: number | null;
  dualApprovalThreshold_MIN_LTE?: number | null;
  dualApprovalThreshold_SUM_EQUAL?: number | null;
  dualApprovalThreshold_SUM_GT?: number | null;
  dualApprovalThreshold_SUM_GTE?: number | null;
  dualApprovalThreshold_SUM_LT?: number | null;
  dualApprovalThreshold_SUM_LTE?: number | null;
  eIN_AVERAGE_EQUAL?: number | null;
  eIN_AVERAGE_GT?: number | null;
  eIN_AVERAGE_GTE?: number | null;
  eIN_AVERAGE_LT?: number | null;
  eIN_AVERAGE_LTE?: number | null;
  eIN_EQUAL?: string | null;
  eIN_GT?: number | null;
  eIN_GTE?: number | null;
  eIN_LONGEST_EQUAL?: number | null;
  eIN_LONGEST_GT?: number | null;
  eIN_LONGEST_GTE?: number | null;
  eIN_LONGEST_LT?: number | null;
  eIN_LONGEST_LTE?: number | null;
  eIN_LT?: number | null;
  eIN_LTE?: number | null;
  eIN_SHORTEST_EQUAL?: number | null;
  eIN_SHORTEST_GT?: number | null;
  eIN_SHORTEST_GTE?: number | null;
  eIN_SHORTEST_LT?: number | null;
  eIN_SHORTEST_LTE?: number | null;
  fax_AVERAGE_EQUAL?: number | null;
  fax_AVERAGE_GT?: number | null;
  fax_AVERAGE_GTE?: number | null;
  fax_AVERAGE_LT?: number | null;
  fax_AVERAGE_LTE?: number | null;
  fax_EQUAL?: string | null;
  fax_GT?: number | null;
  fax_GTE?: number | null;
  fax_LONGEST_EQUAL?: number | null;
  fax_LONGEST_GT?: number | null;
  fax_LONGEST_GTE?: number | null;
  fax_LONGEST_LT?: number | null;
  fax_LONGEST_LTE?: number | null;
  fax_LT?: number | null;
  fax_LTE?: number | null;
  fax_SHORTEST_EQUAL?: number | null;
  fax_SHORTEST_GT?: number | null;
  fax_SHORTEST_GTE?: number | null;
  fax_SHORTEST_LT?: number | null;
  fax_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  legalName_AVERAGE_EQUAL?: number | null;
  legalName_AVERAGE_GT?: number | null;
  legalName_AVERAGE_GTE?: number | null;
  legalName_AVERAGE_LT?: number | null;
  legalName_AVERAGE_LTE?: number | null;
  legalName_EQUAL?: string | null;
  legalName_GT?: number | null;
  legalName_GTE?: number | null;
  legalName_LONGEST_EQUAL?: number | null;
  legalName_LONGEST_GT?: number | null;
  legalName_LONGEST_GTE?: number | null;
  legalName_LONGEST_LT?: number | null;
  legalName_LONGEST_LTE?: number | null;
  legalName_LT?: number | null;
  legalName_LTE?: number | null;
  legalName_SHORTEST_EQUAL?: number | null;
  legalName_SHORTEST_GT?: number | null;
  legalName_SHORTEST_GTE?: number | null;
  legalName_SHORTEST_LT?: number | null;
  legalName_SHORTEST_LTE?: number | null;
  logo_AVERAGE_EQUAL?: number | null;
  logo_AVERAGE_GT?: number | null;
  logo_AVERAGE_GTE?: number | null;
  logo_AVERAGE_LT?: number | null;
  logo_AVERAGE_LTE?: number | null;
  logo_EQUAL?: string | null;
  logo_GT?: number | null;
  logo_GTE?: number | null;
  logo_LONGEST_EQUAL?: number | null;
  logo_LONGEST_GT?: number | null;
  logo_LONGEST_GTE?: number | null;
  logo_LONGEST_LT?: number | null;
  logo_LONGEST_LTE?: number | null;
  logo_LT?: number | null;
  logo_LTE?: number | null;
  logo_SHORTEST_EQUAL?: number | null;
  logo_SHORTEST_GT?: number | null;
  logo_SHORTEST_GTE?: number | null;
  logo_SHORTEST_LT?: number | null;
  logo_SHORTEST_LTE?: number | null;
  name_AVERAGE_EQUAL?: number | null;
  name_AVERAGE_GT?: number | null;
  name_AVERAGE_GTE?: number | null;
  name_AVERAGE_LT?: number | null;
  name_AVERAGE_LTE?: number | null;
  name_EQUAL?: string | null;
  name_GT?: number | null;
  name_GTE?: number | null;
  name_LONGEST_EQUAL?: number | null;
  name_LONGEST_GT?: number | null;
  name_LONGEST_GTE?: number | null;
  name_LONGEST_LT?: number | null;
  name_LONGEST_LTE?: number | null;
  name_LT?: number | null;
  name_LTE?: number | null;
  name_SHORTEST_EQUAL?: number | null;
  name_SHORTEST_GT?: number | null;
  name_SHORTEST_GTE?: number | null;
  name_SHORTEST_LT?: number | null;
  name_SHORTEST_LTE?: number | null;
  paymentTerms_AVERAGE_EQUAL?: number | null;
  paymentTerms_AVERAGE_GT?: number | null;
  paymentTerms_AVERAGE_GTE?: number | null;
  paymentTerms_AVERAGE_LT?: number | null;
  paymentTerms_AVERAGE_LTE?: number | null;
  paymentTerms_EQUAL?: number | null;
  paymentTerms_GT?: number | null;
  paymentTerms_GTE?: number | null;
  paymentTerms_LT?: number | null;
  paymentTerms_LTE?: number | null;
  paymentTerms_MAX_EQUAL?: number | null;
  paymentTerms_MAX_GT?: number | null;
  paymentTerms_MAX_GTE?: number | null;
  paymentTerms_MAX_LT?: number | null;
  paymentTerms_MAX_LTE?: number | null;
  paymentTerms_MIN_EQUAL?: number | null;
  paymentTerms_MIN_GT?: number | null;
  paymentTerms_MIN_GTE?: number | null;
  paymentTerms_MIN_LT?: number | null;
  paymentTerms_MIN_LTE?: number | null;
  paymentTerms_SUM_EQUAL?: number | null;
  paymentTerms_SUM_GT?: number | null;
  paymentTerms_SUM_GTE?: number | null;
  paymentTerms_SUM_LT?: number | null;
  paymentTerms_SUM_LTE?: number | null;
  phone_AVERAGE_EQUAL?: number | null;
  phone_AVERAGE_GT?: number | null;
  phone_AVERAGE_GTE?: number | null;
  phone_AVERAGE_LT?: number | null;
  phone_AVERAGE_LTE?: number | null;
  phone_EQUAL?: string | null;
  phone_GT?: number | null;
  phone_GTE?: number | null;
  phone_LONGEST_EQUAL?: number | null;
  phone_LONGEST_GT?: number | null;
  phone_LONGEST_GTE?: number | null;
  phone_LONGEST_LT?: number | null;
  phone_LONGEST_LTE?: number | null;
  phone_LT?: number | null;
  phone_LTE?: number | null;
  phone_SHORTEST_EQUAL?: number | null;
  phone_SHORTEST_GT?: number | null;
  phone_SHORTEST_GTE?: number | null;
  phone_SHORTEST_LT?: number | null;
  phone_SHORTEST_LTE?: number | null;
  tenantId_AVERAGE_EQUAL?: number | null;
  tenantId_AVERAGE_GT?: number | null;
  tenantId_AVERAGE_GTE?: number | null;
  tenantId_AVERAGE_LT?: number | null;
  tenantId_AVERAGE_LTE?: number | null;
  tenantId_EQUAL?: string | null;
  tenantId_GT?: number | null;
  tenantId_GTE?: number | null;
  tenantId_LONGEST_EQUAL?: number | null;
  tenantId_LONGEST_GT?: number | null;
  tenantId_LONGEST_GTE?: number | null;
  tenantId_LONGEST_LT?: number | null;
  tenantId_LONGEST_LTE?: number | null;
  tenantId_LT?: number | null;
  tenantId_LTE?: number | null;
  tenantId_SHORTEST_EQUAL?: number | null;
  tenantId_SHORTEST_GT?: number | null;
  tenantId_SHORTEST_GTE?: number | null;
  tenantId_SHORTEST_LT?: number | null;
  tenantId_SHORTEST_LTE?: number | null;
  website_AVERAGE_EQUAL?: number | null;
  website_AVERAGE_GT?: number | null;
  website_AVERAGE_GTE?: number | null;
  website_AVERAGE_LT?: number | null;
  website_AVERAGE_LTE?: number | null;
  website_EQUAL?: string | null;
  website_GT?: number | null;
  website_GTE?: number | null;
  website_LONGEST_EQUAL?: number | null;
  website_LONGEST_GT?: number | null;
  website_LONGEST_GTE?: number | null;
  website_LONGEST_LT?: number | null;
  website_LONGEST_LTE?: number | null;
  website_LT?: number | null;
  website_LTE?: number | null;
  website_SHORTEST_EQUAL?: number | null;
  website_SHORTEST_GT?: number | null;
  website_SHORTEST_GTE?: number | null;
  website_SHORTEST_LT?: number | null;
  website_SHORTEST_LTE?: number | null;
}

export interface QuestNotificationWhere {
  AND?: QuestNotificationWhere[] | null;
  OR?: QuestNotificationWhere[] | null;
  id?: number | null;
  id_GT?: number | null;
  id_GTE?: number | null;
  id_IN?: (number | null)[] | null;
  id_LT?: number | null;
  id_LTE?: number | null;
  id_NOT?: number | null;
  id_NOT_IN?: (number | null)[] | null;
  name?: string | null;
  name_CONTAINS?: string | null;
  name_ENDS_WITH?: string | null;
  name_IN?: (string | null)[] | null;
  name_MATCHES?: string | null;
  name_NOT?: string | null;
  name_NOT_CONTAINS?: string | null;
  name_NOT_ENDS_WITH?: string | null;
  name_NOT_IN?: (string | null)[] | null;
  name_NOT_STARTS_WITH?: string | null;
  name_STARTS_WITH?: string | null;
  subscribed?: OrganizationWhere | null;
  subscribedAggregate?: QuestNotificationSubscribedAggregateInput | null;
  subscribedConnection?: QuestNotificationSubscribedConnectionWhere | null;
  subscribedConnection_NOT?: QuestNotificationSubscribedConnectionWhere | null;
  subscribed_NOT?: OrganizationWhere | null;
}

export interface QuestOptions {
  limit?: number | null;
  offset?: number | null;
  sort?: (QuestSort | null)[] | null;
}

export interface QuestRecordRelationshipWhere {
  AND?: QuestRecordRelationshipWhere[] | null;
  OR?: QuestRecordRelationshipWhere[] | null;
  isCompleted?: boolean | null;
  isCompleted_NOT?: boolean | null;
}

export interface QuestRecordsRelationshipAggregateInput {
  AND?: QuestRecordsRelationshipAggregateInput[] | null;
  OR?: QuestRecordsRelationshipAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: QuestRecordsRelationshipNodeAggregationWhereInput | null;
}

export interface QuestRecordsRelationshipConnectionWhere {
  AND?: QuestRecordsRelationshipConnectionWhere[] | null;
  OR?: QuestRecordsRelationshipConnectionWhere[] | null;
  edge?: QuestRecordRelationshipWhere | null;
  edge_NOT?: QuestRecordRelationshipWhere | null;
  node?: RecordWhere | null;
  node_NOT?: RecordWhere | null;
}

export interface QuestRecordsRelationshipNodeAggregationWhereInput {
  AND?: QuestRecordsRelationshipNodeAggregationWhereInput[] | null;
  OR?: QuestRecordsRelationshipNodeAggregationWhereInput[] | null;
  administrationDate_EQUAL?: any | null;
  administrationDate_GT?: any | null;
  administrationDate_GTE?: any | null;
  administrationDate_LT?: any | null;
  administrationDate_LTE?: any | null;
  administrationDate_MAX_EQUAL?: any | null;
  administrationDate_MAX_GT?: any | null;
  administrationDate_MAX_GTE?: any | null;
  administrationDate_MAX_LT?: any | null;
  administrationDate_MAX_LTE?: any | null;
  administrationDate_MIN_EQUAL?: any | null;
  administrationDate_MIN_GT?: any | null;
  administrationDate_MIN_GTE?: any | null;
  administrationDate_MIN_LT?: any | null;
  administrationDate_MIN_LTE?: any | null;
  claimId_AVERAGE_EQUAL?: number | null;
  claimId_AVERAGE_GT?: number | null;
  claimId_AVERAGE_GTE?: number | null;
  claimId_AVERAGE_LT?: number | null;
  claimId_AVERAGE_LTE?: number | null;
  claimId_EQUAL?: string | null;
  claimId_GT?: number | null;
  claimId_GTE?: number | null;
  claimId_LONGEST_EQUAL?: number | null;
  claimId_LONGEST_GT?: number | null;
  claimId_LONGEST_GTE?: number | null;
  claimId_LONGEST_LT?: number | null;
  claimId_LONGEST_LTE?: number | null;
  claimId_LT?: number | null;
  claimId_LTE?: number | null;
  claimId_SHORTEST_EQUAL?: number | null;
  claimId_SHORTEST_GT?: number | null;
  claimId_SHORTEST_GTE?: number | null;
  claimId_SHORTEST_LT?: number | null;
  claimId_SHORTEST_LTE?: number | null;
  createdByEmail_AVERAGE_EQUAL?: number | null;
  createdByEmail_AVERAGE_GT?: number | null;
  createdByEmail_AVERAGE_GTE?: number | null;
  createdByEmail_AVERAGE_LT?: number | null;
  createdByEmail_AVERAGE_LTE?: number | null;
  createdByEmail_EQUAL?: string | null;
  createdByEmail_GT?: number | null;
  createdByEmail_GTE?: number | null;
  createdByEmail_LONGEST_EQUAL?: number | null;
  createdByEmail_LONGEST_GT?: number | null;
  createdByEmail_LONGEST_GTE?: number | null;
  createdByEmail_LONGEST_LT?: number | null;
  createdByEmail_LONGEST_LTE?: number | null;
  createdByEmail_LT?: number | null;
  createdByEmail_LTE?: number | null;
  createdByEmail_SHORTEST_EQUAL?: number | null;
  createdByEmail_SHORTEST_GT?: number | null;
  createdByEmail_SHORTEST_GTE?: number | null;
  createdByEmail_SHORTEST_LT?: number | null;
  createdByEmail_SHORTEST_LTE?: number | null;
  createdByName_AVERAGE_EQUAL?: number | null;
  createdByName_AVERAGE_GT?: number | null;
  createdByName_AVERAGE_GTE?: number | null;
  createdByName_AVERAGE_LT?: number | null;
  createdByName_AVERAGE_LTE?: number | null;
  createdByName_EQUAL?: string | null;
  createdByName_GT?: number | null;
  createdByName_GTE?: number | null;
  createdByName_LONGEST_EQUAL?: number | null;
  createdByName_LONGEST_GT?: number | null;
  createdByName_LONGEST_GTE?: number | null;
  createdByName_LONGEST_LT?: number | null;
  createdByName_LONGEST_LTE?: number | null;
  createdByName_LT?: number | null;
  createdByName_LTE?: number | null;
  createdByName_SHORTEST_EQUAL?: number | null;
  createdByName_SHORTEST_GT?: number | null;
  createdByName_SHORTEST_GTE?: number | null;
  createdByName_SHORTEST_LT?: number | null;
  createdByName_SHORTEST_LTE?: number | null;
  createdOn_EQUAL?: any | null;
  createdOn_GT?: any | null;
  createdOn_GTE?: any | null;
  createdOn_LT?: any | null;
  createdOn_LTE?: any | null;
  createdOn_MAX_EQUAL?: any | null;
  createdOn_MAX_GT?: any | null;
  createdOn_MAX_GTE?: any | null;
  createdOn_MAX_LT?: any | null;
  createdOn_MAX_LTE?: any | null;
  createdOn_MIN_EQUAL?: any | null;
  createdOn_MIN_GT?: any | null;
  createdOn_MIN_GTE?: any | null;
  createdOn_MIN_LT?: any | null;
  createdOn_MIN_LTE?: any | null;
  data_AVERAGE_EQUAL?: number | null;
  data_AVERAGE_GT?: number | null;
  data_AVERAGE_GTE?: number | null;
  data_AVERAGE_LT?: number | null;
  data_AVERAGE_LTE?: number | null;
  data_EQUAL?: string | null;
  data_GT?: number | null;
  data_GTE?: number | null;
  data_LONGEST_EQUAL?: number | null;
  data_LONGEST_GT?: number | null;
  data_LONGEST_GTE?: number | null;
  data_LONGEST_LT?: number | null;
  data_LONGEST_LTE?: number | null;
  data_LT?: number | null;
  data_LTE?: number | null;
  data_SHORTEST_EQUAL?: number | null;
  data_SHORTEST_GT?: number | null;
  data_SHORTEST_GTE?: number | null;
  data_SHORTEST_LT?: number | null;
  data_SHORTEST_LTE?: number | null;
  flexEntityName_AVERAGE_EQUAL?: number | null;
  flexEntityName_AVERAGE_GT?: number | null;
  flexEntityName_AVERAGE_GTE?: number | null;
  flexEntityName_AVERAGE_LT?: number | null;
  flexEntityName_AVERAGE_LTE?: number | null;
  flexEntityName_EQUAL?: string | null;
  flexEntityName_GT?: number | null;
  flexEntityName_GTE?: number | null;
  flexEntityName_LONGEST_EQUAL?: number | null;
  flexEntityName_LONGEST_GT?: number | null;
  flexEntityName_LONGEST_GTE?: number | null;
  flexEntityName_LONGEST_LT?: number | null;
  flexEntityName_LONGEST_LTE?: number | null;
  flexEntityName_LT?: number | null;
  flexEntityName_LTE?: number | null;
  flexEntityName_SHORTEST_EQUAL?: number | null;
  flexEntityName_SHORTEST_GT?: number | null;
  flexEntityName_SHORTEST_GTE?: number | null;
  flexEntityName_SHORTEST_LT?: number | null;
  flexEntityName_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  insuranceId_AVERAGE_EQUAL?: number | null;
  insuranceId_AVERAGE_GT?: number | null;
  insuranceId_AVERAGE_GTE?: number | null;
  insuranceId_AVERAGE_LT?: number | null;
  insuranceId_AVERAGE_LTE?: number | null;
  insuranceId_EQUAL?: string | null;
  insuranceId_GT?: number | null;
  insuranceId_GTE?: number | null;
  insuranceId_LONGEST_EQUAL?: number | null;
  insuranceId_LONGEST_GT?: number | null;
  insuranceId_LONGEST_GTE?: number | null;
  insuranceId_LONGEST_LT?: number | null;
  insuranceId_LONGEST_LTE?: number | null;
  insuranceId_LT?: number | null;
  insuranceId_LTE?: number | null;
  insuranceId_SHORTEST_EQUAL?: number | null;
  insuranceId_SHORTEST_GT?: number | null;
  insuranceId_SHORTEST_GTE?: number | null;
  insuranceId_SHORTEST_LT?: number | null;
  insuranceId_SHORTEST_LTE?: number | null;
  invoiceNumber_AVERAGE_EQUAL?: number | null;
  invoiceNumber_AVERAGE_GT?: number | null;
  invoiceNumber_AVERAGE_GTE?: number | null;
  invoiceNumber_AVERAGE_LT?: number | null;
  invoiceNumber_AVERAGE_LTE?: number | null;
  invoiceNumber_EQUAL?: string | null;
  invoiceNumber_GT?: number | null;
  invoiceNumber_GTE?: number | null;
  invoiceNumber_LONGEST_EQUAL?: number | null;
  invoiceNumber_LONGEST_GT?: number | null;
  invoiceNumber_LONGEST_GTE?: number | null;
  invoiceNumber_LONGEST_LT?: number | null;
  invoiceNumber_LONGEST_LTE?: number | null;
  invoiceNumber_LT?: number | null;
  invoiceNumber_LTE?: number | null;
  invoiceNumber_SHORTEST_EQUAL?: number | null;
  invoiceNumber_SHORTEST_GT?: number | null;
  invoiceNumber_SHORTEST_GTE?: number | null;
  invoiceNumber_SHORTEST_LT?: number | null;
  invoiceNumber_SHORTEST_LTE?: number | null;
  preparationBrandNames_AVERAGE_EQUAL?: number | null;
  preparationBrandNames_AVERAGE_GT?: number | null;
  preparationBrandNames_AVERAGE_GTE?: number | null;
  preparationBrandNames_AVERAGE_LT?: number | null;
  preparationBrandNames_AVERAGE_LTE?: number | null;
  preparationBrandNames_EQUAL?: string | null;
  preparationBrandNames_GT?: number | null;
  preparationBrandNames_GTE?: number | null;
  preparationBrandNames_LONGEST_EQUAL?: number | null;
  preparationBrandNames_LONGEST_GT?: number | null;
  preparationBrandNames_LONGEST_GTE?: number | null;
  preparationBrandNames_LONGEST_LT?: number | null;
  preparationBrandNames_LONGEST_LTE?: number | null;
  preparationBrandNames_LT?: number | null;
  preparationBrandNames_LTE?: number | null;
  preparationBrandNames_SHORTEST_EQUAL?: number | null;
  preparationBrandNames_SHORTEST_GT?: number | null;
  preparationBrandNames_SHORTEST_GTE?: number | null;
  preparationBrandNames_SHORTEST_LT?: number | null;
  preparationBrandNames_SHORTEST_LTE?: number | null;
  preparationGenericNames_AVERAGE_EQUAL?: number | null;
  preparationGenericNames_AVERAGE_GT?: number | null;
  preparationGenericNames_AVERAGE_GTE?: number | null;
  preparationGenericNames_AVERAGE_LT?: number | null;
  preparationGenericNames_AVERAGE_LTE?: number | null;
  preparationGenericNames_EQUAL?: string | null;
  preparationGenericNames_GT?: number | null;
  preparationGenericNames_GTE?: number | null;
  preparationGenericNames_LONGEST_EQUAL?: number | null;
  preparationGenericNames_LONGEST_GT?: number | null;
  preparationGenericNames_LONGEST_GTE?: number | null;
  preparationGenericNames_LONGEST_LT?: number | null;
  preparationGenericNames_LONGEST_LTE?: number | null;
  preparationGenericNames_LT?: number | null;
  preparationGenericNames_LTE?: number | null;
  preparationGenericNames_SHORTEST_EQUAL?: number | null;
  preparationGenericNames_SHORTEST_GT?: number | null;
  preparationGenericNames_SHORTEST_GTE?: number | null;
  preparationGenericNames_SHORTEST_LT?: number | null;
  preparationGenericNames_SHORTEST_LTE?: number | null;
  preparationId_AVERAGE_EQUAL?: number | null;
  preparationId_AVERAGE_GT?: number | null;
  preparationId_AVERAGE_GTE?: number | null;
  preparationId_AVERAGE_LT?: number | null;
  preparationId_AVERAGE_LTE?: number | null;
  preparationId_EQUAL?: string | null;
  preparationId_GT?: number | null;
  preparationId_GTE?: number | null;
  preparationId_LONGEST_EQUAL?: number | null;
  preparationId_LONGEST_GT?: number | null;
  preparationId_LONGEST_GTE?: number | null;
  preparationId_LONGEST_LT?: number | null;
  preparationId_LONGEST_LTE?: number | null;
  preparationId_LT?: number | null;
  preparationId_LTE?: number | null;
  preparationId_SHORTEST_EQUAL?: number | null;
  preparationId_SHORTEST_GT?: number | null;
  preparationId_SHORTEST_GTE?: number | null;
  preparationId_SHORTEST_LT?: number | null;
  preparationId_SHORTEST_LTE?: number | null;
  quantity_AVERAGE_EQUAL?: number | null;
  quantity_AVERAGE_GT?: number | null;
  quantity_AVERAGE_GTE?: number | null;
  quantity_AVERAGE_LT?: number | null;
  quantity_AVERAGE_LTE?: number | null;
  quantity_EQUAL?: number | null;
  quantity_GT?: number | null;
  quantity_GTE?: number | null;
  quantity_LT?: number | null;
  quantity_LTE?: number | null;
  quantity_MAX_EQUAL?: number | null;
  quantity_MAX_GT?: number | null;
  quantity_MAX_GTE?: number | null;
  quantity_MAX_LT?: number | null;
  quantity_MAX_LTE?: number | null;
  quantity_MIN_EQUAL?: number | null;
  quantity_MIN_GT?: number | null;
  quantity_MIN_GTE?: number | null;
  quantity_MIN_LT?: number | null;
  quantity_MIN_LTE?: number | null;
  quantity_SUM_EQUAL?: number | null;
  quantity_SUM_GT?: number | null;
  quantity_SUM_GTE?: number | null;
  quantity_SUM_LT?: number | null;
  quantity_SUM_LTE?: number | null;
  revokedOn_EQUAL?: any | null;
  revokedOn_GT?: any | null;
  revokedOn_GTE?: any | null;
  revokedOn_LT?: any | null;
  revokedOn_LTE?: any | null;
  revokedOn_MAX_EQUAL?: any | null;
  revokedOn_MAX_GT?: any | null;
  revokedOn_MAX_GTE?: any | null;
  revokedOn_MAX_LT?: any | null;
  revokedOn_MAX_LTE?: any | null;
  revokedOn_MIN_EQUAL?: any | null;
  revokedOn_MIN_GT?: any | null;
  revokedOn_MIN_GTE?: any | null;
  revokedOn_MIN_LT?: any | null;
  revokedOn_MIN_LTE?: any | null;
  tenantId_AVERAGE_EQUAL?: number | null;
  tenantId_AVERAGE_GT?: number | null;
  tenantId_AVERAGE_GTE?: number | null;
  tenantId_AVERAGE_LT?: number | null;
  tenantId_AVERAGE_LTE?: number | null;
  tenantId_EQUAL?: string | null;
  tenantId_GT?: number | null;
  tenantId_GTE?: number | null;
  tenantId_LONGEST_EQUAL?: number | null;
  tenantId_LONGEST_GT?: number | null;
  tenantId_LONGEST_GTE?: number | null;
  tenantId_LONGEST_LT?: number | null;
  tenantId_LONGEST_LTE?: number | null;
  tenantId_LT?: number | null;
  tenantId_LTE?: number | null;
  tenantId_SHORTEST_EQUAL?: number | null;
  tenantId_SHORTEST_GT?: number | null;
  tenantId_SHORTEST_GTE?: number | null;
  tenantId_SHORTEST_LT?: number | null;
  tenantId_SHORTEST_LTE?: number | null;
  type_AVERAGE_EQUAL?: number | null;
  type_AVERAGE_GT?: number | null;
  type_AVERAGE_GTE?: number | null;
  type_AVERAGE_LT?: number | null;
  type_AVERAGE_LTE?: number | null;
  type_EQUAL?: string | null;
  type_GT?: number | null;
  type_GTE?: number | null;
  type_LONGEST_EQUAL?: number | null;
  type_LONGEST_GT?: number | null;
  type_LONGEST_GTE?: number | null;
  type_LONGEST_LT?: number | null;
  type_LONGEST_LTE?: number | null;
  type_LT?: number | null;
  type_LTE?: number | null;
  type_SHORTEST_EQUAL?: number | null;
  type_SHORTEST_GT?: number | null;
  type_SHORTEST_GTE?: number | null;
  type_SHORTEST_LT?: number | null;
  type_SHORTEST_LTE?: number | null;
  unlimited_AVERAGE_EQUAL?: number | null;
  unlimited_AVERAGE_GT?: number | null;
  unlimited_AVERAGE_GTE?: number | null;
  unlimited_AVERAGE_LT?: number | null;
  unlimited_AVERAGE_LTE?: number | null;
  unlimited_EQUAL?: number | null;
  unlimited_GT?: number | null;
  unlimited_GTE?: number | null;
  unlimited_LT?: number | null;
  unlimited_LTE?: number | null;
  unlimited_MAX_EQUAL?: number | null;
  unlimited_MAX_GT?: number | null;
  unlimited_MAX_GTE?: number | null;
  unlimited_MAX_LT?: number | null;
  unlimited_MAX_LTE?: number | null;
  unlimited_MIN_EQUAL?: number | null;
  unlimited_MIN_GT?: number | null;
  unlimited_MIN_GTE?: number | null;
  unlimited_MIN_LT?: number | null;
  unlimited_MIN_LTE?: number | null;
  unlimited_SUM_EQUAL?: number | null;
  unlimited_SUM_GT?: number | null;
  unlimited_SUM_GTE?: number | null;
  unlimited_SUM_LT?: number | null;
  unlimited_SUM_LTE?: number | null;
  uuid_AVERAGE_EQUAL?: number | null;
  uuid_AVERAGE_GT?: number | null;
  uuid_AVERAGE_GTE?: number | null;
  uuid_AVERAGE_LT?: number | null;
  uuid_AVERAGE_LTE?: number | null;
  uuid_EQUAL?: string | null;
  uuid_GT?: number | null;
  uuid_GTE?: number | null;
  uuid_LONGEST_EQUAL?: number | null;
  uuid_LONGEST_GT?: number | null;
  uuid_LONGEST_GTE?: number | null;
  uuid_LONGEST_LT?: number | null;
  uuid_LONGEST_LTE?: number | null;
  uuid_LT?: number | null;
  uuid_LTE?: number | null;
  uuid_SHORTEST_EQUAL?: number | null;
  uuid_SHORTEST_GT?: number | null;
  uuid_SHORTEST_GTE?: number | null;
  uuid_SHORTEST_LT?: number | null;
  uuid_SHORTEST_LTE?: number | null;
}

/**
 * Fields to sort Quests by. The order in which sorts are applied is not guaranteed when specifying many fields in one QuestSort object.
 */
export interface QuestSort {
  brandName?: SortDirection | null;
  completionStatus?: SortDirection | null;
  id?: SortDirection | null;
  patientsNo?: SortDirection | null;
  questContentDe?: SortDirection | null;
  questContentEn?: SortDirection | null;
  questOwnerName?: SortDirection | null;
  questStatus?: SortDirection | null;
  recordsCompleted?: SortDirection | null;
  recordsCount?: SortDirection | null;
  resolvedByName?: SortDirection | null;
  threshold?: SortDirection | null;
  timeStamp?: SortDirection | null;
  triggerEventId?: SortDirection | null;
  unlimited?: SortDirection | null;
  value?: SortDirection | null;
}

export interface QuestUsersRelationshipAggregateInput {
  AND?: QuestUsersRelationshipAggregateInput[] | null;
  OR?: QuestUsersRelationshipAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: QuestUsersRelationshipNodeAggregationWhereInput | null;
}

export interface QuestUsersRelationshipConnectionWhere {
  AND?: QuestUsersRelationshipConnectionWhere[] | null;
  OR?: QuestUsersRelationshipConnectionWhere[] | null;
  edge?: UserQuestRelationshipWhere | null;
  edge_NOT?: UserQuestRelationshipWhere | null;
  node?: UserWhere | null;
  node_NOT?: UserWhere | null;
}

export interface QuestUsersRelationshipNodeAggregationWhereInput {
  AND?: QuestUsersRelationshipNodeAggregationWhereInput[] | null;
  OR?: QuestUsersRelationshipNodeAggregationWhereInput[] | null;
  deletedOn_EQUAL?: any | null;
  deletedOn_GT?: any | null;
  deletedOn_GTE?: any | null;
  deletedOn_LT?: any | null;
  deletedOn_LTE?: any | null;
  deletedOn_MAX_EQUAL?: any | null;
  deletedOn_MAX_GT?: any | null;
  deletedOn_MAX_GTE?: any | null;
  deletedOn_MAX_LT?: any | null;
  deletedOn_MAX_LTE?: any | null;
  deletedOn_MIN_EQUAL?: any | null;
  deletedOn_MIN_GT?: any | null;
  deletedOn_MIN_GTE?: any | null;
  deletedOn_MIN_LT?: any | null;
  deletedOn_MIN_LTE?: any | null;
  department_AVERAGE_EQUAL?: number | null;
  department_AVERAGE_GT?: number | null;
  department_AVERAGE_GTE?: number | null;
  department_AVERAGE_LT?: number | null;
  department_AVERAGE_LTE?: number | null;
  department_EQUAL?: string | null;
  department_GT?: number | null;
  department_GTE?: number | null;
  department_LONGEST_EQUAL?: number | null;
  department_LONGEST_GT?: number | null;
  department_LONGEST_GTE?: number | null;
  department_LONGEST_LT?: number | null;
  department_LONGEST_LTE?: number | null;
  department_LT?: number | null;
  department_LTE?: number | null;
  department_SHORTEST_EQUAL?: number | null;
  department_SHORTEST_GT?: number | null;
  department_SHORTEST_GTE?: number | null;
  department_SHORTEST_LT?: number | null;
  department_SHORTEST_LTE?: number | null;
  email_AVERAGE_EQUAL?: number | null;
  email_AVERAGE_GT?: number | null;
  email_AVERAGE_GTE?: number | null;
  email_AVERAGE_LT?: number | null;
  email_AVERAGE_LTE?: number | null;
  email_EQUAL?: string | null;
  email_GT?: number | null;
  email_GTE?: number | null;
  email_LONGEST_EQUAL?: number | null;
  email_LONGEST_GT?: number | null;
  email_LONGEST_GTE?: number | null;
  email_LONGEST_LT?: number | null;
  email_LONGEST_LTE?: number | null;
  email_LT?: number | null;
  email_LTE?: number | null;
  email_SHORTEST_EQUAL?: number | null;
  email_SHORTEST_GT?: number | null;
  email_SHORTEST_GTE?: number | null;
  email_SHORTEST_LT?: number | null;
  email_SHORTEST_LTE?: number | null;
  firstName_AVERAGE_EQUAL?: number | null;
  firstName_AVERAGE_GT?: number | null;
  firstName_AVERAGE_GTE?: number | null;
  firstName_AVERAGE_LT?: number | null;
  firstName_AVERAGE_LTE?: number | null;
  firstName_EQUAL?: string | null;
  firstName_GT?: number | null;
  firstName_GTE?: number | null;
  firstName_LONGEST_EQUAL?: number | null;
  firstName_LONGEST_GT?: number | null;
  firstName_LONGEST_GTE?: number | null;
  firstName_LONGEST_LT?: number | null;
  firstName_LONGEST_LTE?: number | null;
  firstName_LT?: number | null;
  firstName_LTE?: number | null;
  firstName_SHORTEST_EQUAL?: number | null;
  firstName_SHORTEST_GT?: number | null;
  firstName_SHORTEST_GTE?: number | null;
  firstName_SHORTEST_LT?: number | null;
  firstName_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  lastName_AVERAGE_EQUAL?: number | null;
  lastName_AVERAGE_GT?: number | null;
  lastName_AVERAGE_GTE?: number | null;
  lastName_AVERAGE_LT?: number | null;
  lastName_AVERAGE_LTE?: number | null;
  lastName_EQUAL?: string | null;
  lastName_GT?: number | null;
  lastName_GTE?: number | null;
  lastName_LONGEST_EQUAL?: number | null;
  lastName_LONGEST_GT?: number | null;
  lastName_LONGEST_GTE?: number | null;
  lastName_LONGEST_LT?: number | null;
  lastName_LONGEST_LTE?: number | null;
  lastName_LT?: number | null;
  lastName_LTE?: number | null;
  lastName_SHORTEST_EQUAL?: number | null;
  lastName_SHORTEST_GT?: number | null;
  lastName_SHORTEST_GTE?: number | null;
  lastName_SHORTEST_LT?: number | null;
  lastName_SHORTEST_LTE?: number | null;
  position_AVERAGE_EQUAL?: number | null;
  position_AVERAGE_GT?: number | null;
  position_AVERAGE_GTE?: number | null;
  position_AVERAGE_LT?: number | null;
  position_AVERAGE_LTE?: number | null;
  position_EQUAL?: string | null;
  position_GT?: number | null;
  position_GTE?: number | null;
  position_LONGEST_EQUAL?: number | null;
  position_LONGEST_GT?: number | null;
  position_LONGEST_GTE?: number | null;
  position_LONGEST_LT?: number | null;
  position_LONGEST_LTE?: number | null;
  position_LT?: number | null;
  position_LTE?: number | null;
  position_SHORTEST_EQUAL?: number | null;
  position_SHORTEST_GT?: number | null;
  position_SHORTEST_GTE?: number | null;
  position_SHORTEST_LT?: number | null;
  position_SHORTEST_LTE?: number | null;
  preferredLanguage_AVERAGE_EQUAL?: number | null;
  preferredLanguage_AVERAGE_GT?: number | null;
  preferredLanguage_AVERAGE_GTE?: number | null;
  preferredLanguage_AVERAGE_LT?: number | null;
  preferredLanguage_AVERAGE_LTE?: number | null;
  preferredLanguage_EQUAL?: string | null;
  preferredLanguage_GT?: number | null;
  preferredLanguage_GTE?: number | null;
  preferredLanguage_LONGEST_EQUAL?: number | null;
  preferredLanguage_LONGEST_GT?: number | null;
  preferredLanguage_LONGEST_GTE?: number | null;
  preferredLanguage_LONGEST_LT?: number | null;
  preferredLanguage_LONGEST_LTE?: number | null;
  preferredLanguage_LT?: number | null;
  preferredLanguage_LTE?: number | null;
  preferredLanguage_SHORTEST_EQUAL?: number | null;
  preferredLanguage_SHORTEST_GT?: number | null;
  preferredLanguage_SHORTEST_GTE?: number | null;
  preferredLanguage_SHORTEST_LT?: number | null;
  preferredLanguage_SHORTEST_LTE?: number | null;
  tenantId_AVERAGE_EQUAL?: number | null;
  tenantId_AVERAGE_GT?: number | null;
  tenantId_AVERAGE_GTE?: number | null;
  tenantId_AVERAGE_LT?: number | null;
  tenantId_AVERAGE_LTE?: number | null;
  tenantId_EQUAL?: string | null;
  tenantId_GT?: number | null;
  tenantId_GTE?: number | null;
  tenantId_LONGEST_EQUAL?: number | null;
  tenantId_LONGEST_GT?: number | null;
  tenantId_LONGEST_GTE?: number | null;
  tenantId_LONGEST_LT?: number | null;
  tenantId_LONGEST_LTE?: number | null;
  tenantId_LT?: number | null;
  tenantId_LTE?: number | null;
  tenantId_SHORTEST_EQUAL?: number | null;
  tenantId_SHORTEST_GT?: number | null;
  tenantId_SHORTEST_GTE?: number | null;
  tenantId_SHORTEST_LT?: number | null;
  tenantId_SHORTEST_LTE?: number | null;
}

export interface QuestWhere {
  AND?: QuestWhere[] | null;
  OR?: QuestWhere[] | null;
  brand?: BrandWhere | null;
  brandAggregate?: QuestBrandAggregateInput | null;
  brandConnection?: QuestBrandConnectionWhere | null;
  brandConnection_NOT?: QuestBrandConnectionWhere | null;
  brand_NOT?: BrandWhere | null;
  case?: CaseWhere | null;
  caseAggregate?: QuestCaseAggregateInput | null;
  caseConnection?: QuestCaseConnectionWhere | null;
  caseConnection_NOT?: QuestCaseConnectionWhere | null;
  case_NOT?: CaseWhere | null;
  completionStatus?: QuestCompletionStatus | null;
  completionStatus_IN?: (QuestCompletionStatus | null)[] | null;
  completionStatus_NOT?: QuestCompletionStatus | null;
  completionStatus_NOT_IN?: (QuestCompletionStatus | null)[] | null;
  id?: string | null;
  id_CONTAINS?: string | null;
  id_ENDS_WITH?: string | null;
  id_IN?: (string | null)[] | null;
  id_MATCHES?: string | null;
  id_NOT?: string | null;
  id_NOT_CONTAINS?: string | null;
  id_NOT_ENDS_WITH?: string | null;
  id_NOT_IN?: (string | null)[] | null;
  id_NOT_STARTS_WITH?: string | null;
  id_STARTS_WITH?: string | null;
  questContentDe?: string | null;
  questContentDe_CONTAINS?: string | null;
  questContentDe_ENDS_WITH?: string | null;
  questContentDe_IN?: (string | null)[] | null;
  questContentDe_MATCHES?: string | null;
  questContentDe_NOT?: string | null;
  questContentDe_NOT_CONTAINS?: string | null;
  questContentDe_NOT_ENDS_WITH?: string | null;
  questContentDe_NOT_IN?: (string | null)[] | null;
  questContentDe_NOT_STARTS_WITH?: string | null;
  questContentDe_STARTS_WITH?: string | null;
  questContentEn?: string | null;
  questContentEn_CONTAINS?: string | null;
  questContentEn_ENDS_WITH?: string | null;
  questContentEn_IN?: (string | null)[] | null;
  questContentEn_MATCHES?: string | null;
  questContentEn_NOT?: string | null;
  questContentEn_NOT_CONTAINS?: string | null;
  questContentEn_NOT_ENDS_WITH?: string | null;
  questContentEn_NOT_IN?: (string | null)[] | null;
  questContentEn_NOT_STARTS_WITH?: string | null;
  questContentEn_STARTS_WITH?: string | null;
  questStatus?: TaskStatus | null;
  questStatus_IN?: (TaskStatus | null)[] | null;
  questStatus_NOT?: TaskStatus | null;
  questStatus_NOT_IN?: (TaskStatus | null)[] | null;
  recordsRelationship?: RecordWhere | null;
  recordsRelationshipAggregate?: QuestRecordsRelationshipAggregateInput | null;
  recordsRelationshipConnection?: QuestRecordsRelationshipConnectionWhere | null;
  recordsRelationshipConnection_NOT?: QuestRecordsRelationshipConnectionWhere | null;
  recordsRelationship_NOT?: RecordWhere | null;
  tenantIds?: string[] | null;
  tenantIds_INCLUDES?: string | null;
  tenantIds_NOT?: string[] | null;
  tenantIds_NOT_INCLUDES?: string | null;
  threshold?: number | null;
  threshold_GT?: number | null;
  threshold_GTE?: number | null;
  threshold_IN?: (number | null)[] | null;
  threshold_LT?: number | null;
  threshold_LTE?: number | null;
  threshold_NOT?: number | null;
  threshold_NOT_IN?: (number | null)[] | null;
  timeStamp?: number | null;
  timeStamp_GT?: number | null;
  timeStamp_GTE?: number | null;
  timeStamp_IN?: (number | null)[] | null;
  timeStamp_LT?: number | null;
  timeStamp_LTE?: number | null;
  timeStamp_NOT?: number | null;
  timeStamp_NOT_IN?: (number | null)[] | null;
  triggerEventId?: number | null;
  triggerEventId_GT?: number | null;
  triggerEventId_GTE?: number | null;
  triggerEventId_IN?: (number | null)[] | null;
  triggerEventId_LT?: number | null;
  triggerEventId_LTE?: number | null;
  triggerEventId_NOT?: number | null;
  triggerEventId_NOT_IN?: (number | null)[] | null;
  unlimited?: number | null;
  unlimited_GT?: number | null;
  unlimited_GTE?: number | null;
  unlimited_IN?: (number | null)[] | null;
  unlimited_LT?: number | null;
  unlimited_LTE?: number | null;
  unlimited_NOT?: number | null;
  unlimited_NOT_IN?: (number | null)[] | null;
  usersRelationship?: UserWhere | null;
  usersRelationshipAggregate?: QuestUsersRelationshipAggregateInput | null;
  usersRelationshipConnection?: QuestUsersRelationshipConnectionWhere | null;
  usersRelationshipConnection_NOT?: QuestUsersRelationshipConnectionWhere | null;
  usersRelationship_NOT?: UserWhere | null;
  value?: string | null;
  value_CONTAINS?: string | null;
  value_ENDS_WITH?: string | null;
  value_IN?: (string | null)[] | null;
  value_MATCHES?: string | null;
  value_NOT?: string | null;
  value_NOT_CONTAINS?: string | null;
  value_NOT_ENDS_WITH?: string | null;
  value_NOT_IN?: (string | null)[] | null;
  value_NOT_STARTS_WITH?: string | null;
  value_STARTS_WITH?: string | null;
}

export interface RecallToDraftInput {
  invoiceId: string;
}

export interface RecordEvaluatedByAggregateInput {
  AND?: RecordEvaluatedByAggregateInput[] | null;
  OR?: RecordEvaluatedByAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: RecordEvaluatedByNodeAggregationWhereInput | null;
}

export interface RecordEvaluatedByConnectionWhere {
  AND?: RecordEvaluatedByConnectionWhere[] | null;
  OR?: RecordEvaluatedByConnectionWhere[] | null;
  node?: FlexFinancialDataPointWhere | null;
  node_NOT?: FlexFinancialDataPointWhere | null;
}

export interface RecordEvaluatedByNodeAggregationWhereInput {
  AND?: RecordEvaluatedByNodeAggregationWhereInput[] | null;
  OR?: RecordEvaluatedByNodeAggregationWhereInput[] | null;
  basePrice_AVERAGE_EQUAL?: number | null;
  basePrice_AVERAGE_GT?: number | null;
  basePrice_AVERAGE_GTE?: number | null;
  basePrice_AVERAGE_LT?: number | null;
  basePrice_AVERAGE_LTE?: number | null;
  basePrice_EQUAL?: number | null;
  basePrice_GT?: number | null;
  basePrice_GTE?: number | null;
  basePrice_LT?: number | null;
  basePrice_LTE?: number | null;
  basePrice_MAX_EQUAL?: number | null;
  basePrice_MAX_GT?: number | null;
  basePrice_MAX_GTE?: number | null;
  basePrice_MAX_LT?: number | null;
  basePrice_MAX_LTE?: number | null;
  basePrice_MIN_EQUAL?: number | null;
  basePrice_MIN_GT?: number | null;
  basePrice_MIN_GTE?: number | null;
  basePrice_MIN_LT?: number | null;
  basePrice_MIN_LTE?: number | null;
  basePrice_SUM_EQUAL?: number | null;
  basePrice_SUM_GT?: number | null;
  basePrice_SUM_GTE?: number | null;
  basePrice_SUM_LT?: number | null;
  basePrice_SUM_LTE?: number | null;
  createdOn_EQUAL?: any | null;
  createdOn_GT?: any | null;
  createdOn_GTE?: any | null;
  createdOn_LT?: any | null;
  createdOn_LTE?: any | null;
  createdOn_MAX_EQUAL?: any | null;
  createdOn_MAX_GT?: any | null;
  createdOn_MAX_GTE?: any | null;
  createdOn_MAX_LT?: any | null;
  createdOn_MAX_LTE?: any | null;
  createdOn_MIN_EQUAL?: any | null;
  createdOn_MIN_GT?: any | null;
  createdOn_MIN_GTE?: any | null;
  createdOn_MIN_LT?: any | null;
  createdOn_MIN_LTE?: any | null;
  currencyCode_AVERAGE_EQUAL?: number | null;
  currencyCode_AVERAGE_GT?: number | null;
  currencyCode_AVERAGE_GTE?: number | null;
  currencyCode_AVERAGE_LT?: number | null;
  currencyCode_AVERAGE_LTE?: number | null;
  currencyCode_EQUAL?: string | null;
  currencyCode_GT?: number | null;
  currencyCode_GTE?: number | null;
  currencyCode_LONGEST_EQUAL?: number | null;
  currencyCode_LONGEST_GT?: number | null;
  currencyCode_LONGEST_GTE?: number | null;
  currencyCode_LONGEST_LT?: number | null;
  currencyCode_LONGEST_LTE?: number | null;
  currencyCode_LT?: number | null;
  currencyCode_LTE?: number | null;
  currencyCode_SHORTEST_EQUAL?: number | null;
  currencyCode_SHORTEST_GT?: number | null;
  currencyCode_SHORTEST_GTE?: number | null;
  currencyCode_SHORTEST_LT?: number | null;
  currencyCode_SHORTEST_LTE?: number | null;
  evaluationSnapshot_AVERAGE_EQUAL?: number | null;
  evaluationSnapshot_AVERAGE_GT?: number | null;
  evaluationSnapshot_AVERAGE_GTE?: number | null;
  evaluationSnapshot_AVERAGE_LT?: number | null;
  evaluationSnapshot_AVERAGE_LTE?: number | null;
  evaluationSnapshot_EQUAL?: string | null;
  evaluationSnapshot_GT?: number | null;
  evaluationSnapshot_GTE?: number | null;
  evaluationSnapshot_LONGEST_EQUAL?: number | null;
  evaluationSnapshot_LONGEST_GT?: number | null;
  evaluationSnapshot_LONGEST_GTE?: number | null;
  evaluationSnapshot_LONGEST_LT?: number | null;
  evaluationSnapshot_LONGEST_LTE?: number | null;
  evaluationSnapshot_LT?: number | null;
  evaluationSnapshot_LTE?: number | null;
  evaluationSnapshot_SHORTEST_EQUAL?: number | null;
  evaluationSnapshot_SHORTEST_GT?: number | null;
  evaluationSnapshot_SHORTEST_GTE?: number | null;
  evaluationSnapshot_SHORTEST_LT?: number | null;
  evaluationSnapshot_SHORTEST_LTE?: number | null;
  generatedUuid_EQUAL?: string | null;
  payablePercentage_AVERAGE_EQUAL?: number | null;
  payablePercentage_AVERAGE_GT?: number | null;
  payablePercentage_AVERAGE_GTE?: number | null;
  payablePercentage_AVERAGE_LT?: number | null;
  payablePercentage_AVERAGE_LTE?: number | null;
  payablePercentage_EQUAL?: number | null;
  payablePercentage_GT?: number | null;
  payablePercentage_GTE?: number | null;
  payablePercentage_LT?: number | null;
  payablePercentage_LTE?: number | null;
  payablePercentage_MAX_EQUAL?: number | null;
  payablePercentage_MAX_GT?: number | null;
  payablePercentage_MAX_GTE?: number | null;
  payablePercentage_MAX_LT?: number | null;
  payablePercentage_MAX_LTE?: number | null;
  payablePercentage_MIN_EQUAL?: number | null;
  payablePercentage_MIN_GT?: number | null;
  payablePercentage_MIN_GTE?: number | null;
  payablePercentage_MIN_LT?: number | null;
  payablePercentage_MIN_LTE?: number | null;
  payablePercentage_SUM_EQUAL?: number | null;
  payablePercentage_SUM_GT?: number | null;
  payablePercentage_SUM_GTE?: number | null;
  payablePercentage_SUM_LT?: number | null;
  payablePercentage_SUM_LTE?: number | null;
  payable_AVERAGE_EQUAL?: number | null;
  payable_AVERAGE_GT?: number | null;
  payable_AVERAGE_GTE?: number | null;
  payable_AVERAGE_LT?: number | null;
  payable_AVERAGE_LTE?: number | null;
  payable_EQUAL?: number | null;
  payable_GT?: number | null;
  payable_GTE?: number | null;
  payable_LT?: number | null;
  payable_LTE?: number | null;
  payable_MAX_EQUAL?: number | null;
  payable_MAX_GT?: number | null;
  payable_MAX_GTE?: number | null;
  payable_MAX_LT?: number | null;
  payable_MAX_LTE?: number | null;
  payable_MIN_EQUAL?: number | null;
  payable_MIN_GT?: number | null;
  payable_MIN_GTE?: number | null;
  payable_MIN_LT?: number | null;
  payable_MIN_LTE?: number | null;
  payable_SUM_EQUAL?: number | null;
  payable_SUM_GT?: number | null;
  payable_SUM_GTE?: number | null;
  payable_SUM_LT?: number | null;
  payable_SUM_LTE?: number | null;
  quantity_AVERAGE_EQUAL?: number | null;
  quantity_AVERAGE_GT?: number | null;
  quantity_AVERAGE_GTE?: number | null;
  quantity_AVERAGE_LT?: number | null;
  quantity_AVERAGE_LTE?: number | null;
  quantity_EQUAL?: number | null;
  quantity_GT?: number | null;
  quantity_GTE?: number | null;
  quantity_LT?: number | null;
  quantity_LTE?: number | null;
  quantity_MAX_EQUAL?: number | null;
  quantity_MAX_GT?: number | null;
  quantity_MAX_GTE?: number | null;
  quantity_MAX_LT?: number | null;
  quantity_MAX_LTE?: number | null;
  quantity_MIN_EQUAL?: number | null;
  quantity_MIN_GT?: number | null;
  quantity_MIN_GTE?: number | null;
  quantity_MIN_LT?: number | null;
  quantity_MIN_LTE?: number | null;
  quantity_SUM_EQUAL?: number | null;
  quantity_SUM_GT?: number | null;
  quantity_SUM_GTE?: number | null;
  quantity_SUM_LT?: number | null;
  quantity_SUM_LTE?: number | null;
  refundDeltaNumber_AVERAGE_EQUAL?: number | null;
  refundDeltaNumber_AVERAGE_GT?: number | null;
  refundDeltaNumber_AVERAGE_GTE?: number | null;
  refundDeltaNumber_AVERAGE_LT?: number | null;
  refundDeltaNumber_AVERAGE_LTE?: number | null;
  refundDeltaNumber_EQUAL?: number | null;
  refundDeltaNumber_GT?: number | null;
  refundDeltaNumber_GTE?: number | null;
  refundDeltaNumber_LT?: number | null;
  refundDeltaNumber_LTE?: number | null;
  refundDeltaNumber_MAX_EQUAL?: number | null;
  refundDeltaNumber_MAX_GT?: number | null;
  refundDeltaNumber_MAX_GTE?: number | null;
  refundDeltaNumber_MAX_LT?: number | null;
  refundDeltaNumber_MAX_LTE?: number | null;
  refundDeltaNumber_MIN_EQUAL?: number | null;
  refundDeltaNumber_MIN_GT?: number | null;
  refundDeltaNumber_MIN_GTE?: number | null;
  refundDeltaNumber_MIN_LT?: number | null;
  refundDeltaNumber_MIN_LTE?: number | null;
  refundDeltaNumber_SUM_EQUAL?: number | null;
  refundDeltaNumber_SUM_GT?: number | null;
  refundDeltaNumber_SUM_GTE?: number | null;
  refundDeltaNumber_SUM_LT?: number | null;
  refundDeltaNumber_SUM_LTE?: number | null;
  refundablePercentage_AVERAGE_EQUAL?: number | null;
  refundablePercentage_AVERAGE_GT?: number | null;
  refundablePercentage_AVERAGE_GTE?: number | null;
  refundablePercentage_AVERAGE_LT?: number | null;
  refundablePercentage_AVERAGE_LTE?: number | null;
  refundablePercentage_EQUAL?: number | null;
  refundablePercentage_GT?: number | null;
  refundablePercentage_GTE?: number | null;
  refundablePercentage_LT?: number | null;
  refundablePercentage_LTE?: number | null;
  refundablePercentage_MAX_EQUAL?: number | null;
  refundablePercentage_MAX_GT?: number | null;
  refundablePercentage_MAX_GTE?: number | null;
  refundablePercentage_MAX_LT?: number | null;
  refundablePercentage_MAX_LTE?: number | null;
  refundablePercentage_MIN_EQUAL?: number | null;
  refundablePercentage_MIN_GT?: number | null;
  refundablePercentage_MIN_GTE?: number | null;
  refundablePercentage_MIN_LT?: number | null;
  refundablePercentage_MIN_LTE?: number | null;
  refundablePercentage_SUM_EQUAL?: number | null;
  refundablePercentage_SUM_GT?: number | null;
  refundablePercentage_SUM_GTE?: number | null;
  refundablePercentage_SUM_LT?: number | null;
  refundablePercentage_SUM_LTE?: number | null;
  refundable_AVERAGE_EQUAL?: number | null;
  refundable_AVERAGE_GT?: number | null;
  refundable_AVERAGE_GTE?: number | null;
  refundable_AVERAGE_LT?: number | null;
  refundable_AVERAGE_LTE?: number | null;
  refundable_EQUAL?: number | null;
  refundable_GT?: number | null;
  refundable_GTE?: number | null;
  refundable_LT?: number | null;
  refundable_LTE?: number | null;
  refundable_MAX_EQUAL?: number | null;
  refundable_MAX_GT?: number | null;
  refundable_MAX_GTE?: number | null;
  refundable_MAX_LT?: number | null;
  refundable_MAX_LTE?: number | null;
  refundable_MIN_EQUAL?: number | null;
  refundable_MIN_GT?: number | null;
  refundable_MIN_GTE?: number | null;
  refundable_MIN_LT?: number | null;
  refundable_MIN_LTE?: number | null;
  refundable_SUM_EQUAL?: number | null;
  refundable_SUM_GT?: number | null;
  refundable_SUM_GTE?: number | null;
  refundable_SUM_LT?: number | null;
  refundable_SUM_LTE?: number | null;
  revokedOn_EQUAL?: any | null;
  revokedOn_GT?: any | null;
  revokedOn_GTE?: any | null;
  revokedOn_LT?: any | null;
  revokedOn_LTE?: any | null;
  revokedOn_MAX_EQUAL?: any | null;
  revokedOn_MAX_GT?: any | null;
  revokedOn_MAX_GTE?: any | null;
  revokedOn_MAX_LT?: any | null;
  revokedOn_MAX_LTE?: any | null;
  revokedOn_MIN_EQUAL?: any | null;
  revokedOn_MIN_GT?: any | null;
  revokedOn_MIN_GTE?: any | null;
  revokedOn_MIN_LT?: any | null;
  revokedOn_MIN_LTE?: any | null;
  uuid_EQUAL?: string | null;
  variablePercentage_AVERAGE_EQUAL?: number | null;
  variablePercentage_AVERAGE_GT?: number | null;
  variablePercentage_AVERAGE_GTE?: number | null;
  variablePercentage_AVERAGE_LT?: number | null;
  variablePercentage_AVERAGE_LTE?: number | null;
  variablePercentage_EQUAL?: number | null;
  variablePercentage_GT?: number | null;
  variablePercentage_GTE?: number | null;
  variablePercentage_LT?: number | null;
  variablePercentage_LTE?: number | null;
  variablePercentage_MAX_EQUAL?: number | null;
  variablePercentage_MAX_GT?: number | null;
  variablePercentage_MAX_GTE?: number | null;
  variablePercentage_MAX_LT?: number | null;
  variablePercentage_MAX_LTE?: number | null;
  variablePercentage_MIN_EQUAL?: number | null;
  variablePercentage_MIN_GT?: number | null;
  variablePercentage_MIN_GTE?: number | null;
  variablePercentage_MIN_LT?: number | null;
  variablePercentage_MIN_LTE?: number | null;
  variablePercentage_SUM_EQUAL?: number | null;
  variablePercentage_SUM_GT?: number | null;
  variablePercentage_SUM_GTE?: number | null;
  variablePercentage_SUM_LT?: number | null;
  variablePercentage_SUM_LTE?: number | null;
  variable_AVERAGE_EQUAL?: number | null;
  variable_AVERAGE_GT?: number | null;
  variable_AVERAGE_GTE?: number | null;
  variable_AVERAGE_LT?: number | null;
  variable_AVERAGE_LTE?: number | null;
  variable_EQUAL?: number | null;
  variable_GT?: number | null;
  variable_GTE?: number | null;
  variable_LT?: number | null;
  variable_LTE?: number | null;
  variable_MAX_EQUAL?: number | null;
  variable_MAX_GT?: number | null;
  variable_MAX_GTE?: number | null;
  variable_MAX_LT?: number | null;
  variable_MAX_LTE?: number | null;
  variable_MIN_EQUAL?: number | null;
  variable_MIN_GT?: number | null;
  variable_MIN_GTE?: number | null;
  variable_MIN_LT?: number | null;
  variable_MIN_LTE?: number | null;
  variable_SUM_EQUAL?: number | null;
  variable_SUM_GT?: number | null;
  variable_SUM_GTE?: number | null;
  variable_SUM_LT?: number | null;
  variable_SUM_LTE?: number | null;
}

export interface RecordOptions {
  limit?: number | null;
  offset?: number | null;
  sort?: (RecordSort | null)[] | null;
}

export interface RecordPredecessorAggregateInput {
  AND?: RecordPredecessorAggregateInput[] | null;
  OR?: RecordPredecessorAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: RecordPredecessorNodeAggregationWhereInput | null;
}

export interface RecordPredecessorConnectionWhere {
  AND?: RecordPredecessorConnectionWhere[] | null;
  OR?: RecordPredecessorConnectionWhere[] | null;
  node?: RecordWhere | null;
  node_NOT?: RecordWhere | null;
}

export interface RecordPredecessorNodeAggregationWhereInput {
  AND?: RecordPredecessorNodeAggregationWhereInput[] | null;
  OR?: RecordPredecessorNodeAggregationWhereInput[] | null;
  administrationDate_EQUAL?: any | null;
  administrationDate_GT?: any | null;
  administrationDate_GTE?: any | null;
  administrationDate_LT?: any | null;
  administrationDate_LTE?: any | null;
  administrationDate_MAX_EQUAL?: any | null;
  administrationDate_MAX_GT?: any | null;
  administrationDate_MAX_GTE?: any | null;
  administrationDate_MAX_LT?: any | null;
  administrationDate_MAX_LTE?: any | null;
  administrationDate_MIN_EQUAL?: any | null;
  administrationDate_MIN_GT?: any | null;
  administrationDate_MIN_GTE?: any | null;
  administrationDate_MIN_LT?: any | null;
  administrationDate_MIN_LTE?: any | null;
  claimId_AVERAGE_EQUAL?: number | null;
  claimId_AVERAGE_GT?: number | null;
  claimId_AVERAGE_GTE?: number | null;
  claimId_AVERAGE_LT?: number | null;
  claimId_AVERAGE_LTE?: number | null;
  claimId_EQUAL?: string | null;
  claimId_GT?: number | null;
  claimId_GTE?: number | null;
  claimId_LONGEST_EQUAL?: number | null;
  claimId_LONGEST_GT?: number | null;
  claimId_LONGEST_GTE?: number | null;
  claimId_LONGEST_LT?: number | null;
  claimId_LONGEST_LTE?: number | null;
  claimId_LT?: number | null;
  claimId_LTE?: number | null;
  claimId_SHORTEST_EQUAL?: number | null;
  claimId_SHORTEST_GT?: number | null;
  claimId_SHORTEST_GTE?: number | null;
  claimId_SHORTEST_LT?: number | null;
  claimId_SHORTEST_LTE?: number | null;
  createdByEmail_AVERAGE_EQUAL?: number | null;
  createdByEmail_AVERAGE_GT?: number | null;
  createdByEmail_AVERAGE_GTE?: number | null;
  createdByEmail_AVERAGE_LT?: number | null;
  createdByEmail_AVERAGE_LTE?: number | null;
  createdByEmail_EQUAL?: string | null;
  createdByEmail_GT?: number | null;
  createdByEmail_GTE?: number | null;
  createdByEmail_LONGEST_EQUAL?: number | null;
  createdByEmail_LONGEST_GT?: number | null;
  createdByEmail_LONGEST_GTE?: number | null;
  createdByEmail_LONGEST_LT?: number | null;
  createdByEmail_LONGEST_LTE?: number | null;
  createdByEmail_LT?: number | null;
  createdByEmail_LTE?: number | null;
  createdByEmail_SHORTEST_EQUAL?: number | null;
  createdByEmail_SHORTEST_GT?: number | null;
  createdByEmail_SHORTEST_GTE?: number | null;
  createdByEmail_SHORTEST_LT?: number | null;
  createdByEmail_SHORTEST_LTE?: number | null;
  createdByName_AVERAGE_EQUAL?: number | null;
  createdByName_AVERAGE_GT?: number | null;
  createdByName_AVERAGE_GTE?: number | null;
  createdByName_AVERAGE_LT?: number | null;
  createdByName_AVERAGE_LTE?: number | null;
  createdByName_EQUAL?: string | null;
  createdByName_GT?: number | null;
  createdByName_GTE?: number | null;
  createdByName_LONGEST_EQUAL?: number | null;
  createdByName_LONGEST_GT?: number | null;
  createdByName_LONGEST_GTE?: number | null;
  createdByName_LONGEST_LT?: number | null;
  createdByName_LONGEST_LTE?: number | null;
  createdByName_LT?: number | null;
  createdByName_LTE?: number | null;
  createdByName_SHORTEST_EQUAL?: number | null;
  createdByName_SHORTEST_GT?: number | null;
  createdByName_SHORTEST_GTE?: number | null;
  createdByName_SHORTEST_LT?: number | null;
  createdByName_SHORTEST_LTE?: number | null;
  createdOn_EQUAL?: any | null;
  createdOn_GT?: any | null;
  createdOn_GTE?: any | null;
  createdOn_LT?: any | null;
  createdOn_LTE?: any | null;
  createdOn_MAX_EQUAL?: any | null;
  createdOn_MAX_GT?: any | null;
  createdOn_MAX_GTE?: any | null;
  createdOn_MAX_LT?: any | null;
  createdOn_MAX_LTE?: any | null;
  createdOn_MIN_EQUAL?: any | null;
  createdOn_MIN_GT?: any | null;
  createdOn_MIN_GTE?: any | null;
  createdOn_MIN_LT?: any | null;
  createdOn_MIN_LTE?: any | null;
  data_AVERAGE_EQUAL?: number | null;
  data_AVERAGE_GT?: number | null;
  data_AVERAGE_GTE?: number | null;
  data_AVERAGE_LT?: number | null;
  data_AVERAGE_LTE?: number | null;
  data_EQUAL?: string | null;
  data_GT?: number | null;
  data_GTE?: number | null;
  data_LONGEST_EQUAL?: number | null;
  data_LONGEST_GT?: number | null;
  data_LONGEST_GTE?: number | null;
  data_LONGEST_LT?: number | null;
  data_LONGEST_LTE?: number | null;
  data_LT?: number | null;
  data_LTE?: number | null;
  data_SHORTEST_EQUAL?: number | null;
  data_SHORTEST_GT?: number | null;
  data_SHORTEST_GTE?: number | null;
  data_SHORTEST_LT?: number | null;
  data_SHORTEST_LTE?: number | null;
  flexEntityName_AVERAGE_EQUAL?: number | null;
  flexEntityName_AVERAGE_GT?: number | null;
  flexEntityName_AVERAGE_GTE?: number | null;
  flexEntityName_AVERAGE_LT?: number | null;
  flexEntityName_AVERAGE_LTE?: number | null;
  flexEntityName_EQUAL?: string | null;
  flexEntityName_GT?: number | null;
  flexEntityName_GTE?: number | null;
  flexEntityName_LONGEST_EQUAL?: number | null;
  flexEntityName_LONGEST_GT?: number | null;
  flexEntityName_LONGEST_GTE?: number | null;
  flexEntityName_LONGEST_LT?: number | null;
  flexEntityName_LONGEST_LTE?: number | null;
  flexEntityName_LT?: number | null;
  flexEntityName_LTE?: number | null;
  flexEntityName_SHORTEST_EQUAL?: number | null;
  flexEntityName_SHORTEST_GT?: number | null;
  flexEntityName_SHORTEST_GTE?: number | null;
  flexEntityName_SHORTEST_LT?: number | null;
  flexEntityName_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  insuranceId_AVERAGE_EQUAL?: number | null;
  insuranceId_AVERAGE_GT?: number | null;
  insuranceId_AVERAGE_GTE?: number | null;
  insuranceId_AVERAGE_LT?: number | null;
  insuranceId_AVERAGE_LTE?: number | null;
  insuranceId_EQUAL?: string | null;
  insuranceId_GT?: number | null;
  insuranceId_GTE?: number | null;
  insuranceId_LONGEST_EQUAL?: number | null;
  insuranceId_LONGEST_GT?: number | null;
  insuranceId_LONGEST_GTE?: number | null;
  insuranceId_LONGEST_LT?: number | null;
  insuranceId_LONGEST_LTE?: number | null;
  insuranceId_LT?: number | null;
  insuranceId_LTE?: number | null;
  insuranceId_SHORTEST_EQUAL?: number | null;
  insuranceId_SHORTEST_GT?: number | null;
  insuranceId_SHORTEST_GTE?: number | null;
  insuranceId_SHORTEST_LT?: number | null;
  insuranceId_SHORTEST_LTE?: number | null;
  invoiceNumber_AVERAGE_EQUAL?: number | null;
  invoiceNumber_AVERAGE_GT?: number | null;
  invoiceNumber_AVERAGE_GTE?: number | null;
  invoiceNumber_AVERAGE_LT?: number | null;
  invoiceNumber_AVERAGE_LTE?: number | null;
  invoiceNumber_EQUAL?: string | null;
  invoiceNumber_GT?: number | null;
  invoiceNumber_GTE?: number | null;
  invoiceNumber_LONGEST_EQUAL?: number | null;
  invoiceNumber_LONGEST_GT?: number | null;
  invoiceNumber_LONGEST_GTE?: number | null;
  invoiceNumber_LONGEST_LT?: number | null;
  invoiceNumber_LONGEST_LTE?: number | null;
  invoiceNumber_LT?: number | null;
  invoiceNumber_LTE?: number | null;
  invoiceNumber_SHORTEST_EQUAL?: number | null;
  invoiceNumber_SHORTEST_GT?: number | null;
  invoiceNumber_SHORTEST_GTE?: number | null;
  invoiceNumber_SHORTEST_LT?: number | null;
  invoiceNumber_SHORTEST_LTE?: number | null;
  preparationBrandNames_AVERAGE_EQUAL?: number | null;
  preparationBrandNames_AVERAGE_GT?: number | null;
  preparationBrandNames_AVERAGE_GTE?: number | null;
  preparationBrandNames_AVERAGE_LT?: number | null;
  preparationBrandNames_AVERAGE_LTE?: number | null;
  preparationBrandNames_EQUAL?: string | null;
  preparationBrandNames_GT?: number | null;
  preparationBrandNames_GTE?: number | null;
  preparationBrandNames_LONGEST_EQUAL?: number | null;
  preparationBrandNames_LONGEST_GT?: number | null;
  preparationBrandNames_LONGEST_GTE?: number | null;
  preparationBrandNames_LONGEST_LT?: number | null;
  preparationBrandNames_LONGEST_LTE?: number | null;
  preparationBrandNames_LT?: number | null;
  preparationBrandNames_LTE?: number | null;
  preparationBrandNames_SHORTEST_EQUAL?: number | null;
  preparationBrandNames_SHORTEST_GT?: number | null;
  preparationBrandNames_SHORTEST_GTE?: number | null;
  preparationBrandNames_SHORTEST_LT?: number | null;
  preparationBrandNames_SHORTEST_LTE?: number | null;
  preparationGenericNames_AVERAGE_EQUAL?: number | null;
  preparationGenericNames_AVERAGE_GT?: number | null;
  preparationGenericNames_AVERAGE_GTE?: number | null;
  preparationGenericNames_AVERAGE_LT?: number | null;
  preparationGenericNames_AVERAGE_LTE?: number | null;
  preparationGenericNames_EQUAL?: string | null;
  preparationGenericNames_GT?: number | null;
  preparationGenericNames_GTE?: number | null;
  preparationGenericNames_LONGEST_EQUAL?: number | null;
  preparationGenericNames_LONGEST_GT?: number | null;
  preparationGenericNames_LONGEST_GTE?: number | null;
  preparationGenericNames_LONGEST_LT?: number | null;
  preparationGenericNames_LONGEST_LTE?: number | null;
  preparationGenericNames_LT?: number | null;
  preparationGenericNames_LTE?: number | null;
  preparationGenericNames_SHORTEST_EQUAL?: number | null;
  preparationGenericNames_SHORTEST_GT?: number | null;
  preparationGenericNames_SHORTEST_GTE?: number | null;
  preparationGenericNames_SHORTEST_LT?: number | null;
  preparationGenericNames_SHORTEST_LTE?: number | null;
  preparationId_AVERAGE_EQUAL?: number | null;
  preparationId_AVERAGE_GT?: number | null;
  preparationId_AVERAGE_GTE?: number | null;
  preparationId_AVERAGE_LT?: number | null;
  preparationId_AVERAGE_LTE?: number | null;
  preparationId_EQUAL?: string | null;
  preparationId_GT?: number | null;
  preparationId_GTE?: number | null;
  preparationId_LONGEST_EQUAL?: number | null;
  preparationId_LONGEST_GT?: number | null;
  preparationId_LONGEST_GTE?: number | null;
  preparationId_LONGEST_LT?: number | null;
  preparationId_LONGEST_LTE?: number | null;
  preparationId_LT?: number | null;
  preparationId_LTE?: number | null;
  preparationId_SHORTEST_EQUAL?: number | null;
  preparationId_SHORTEST_GT?: number | null;
  preparationId_SHORTEST_GTE?: number | null;
  preparationId_SHORTEST_LT?: number | null;
  preparationId_SHORTEST_LTE?: number | null;
  quantity_AVERAGE_EQUAL?: number | null;
  quantity_AVERAGE_GT?: number | null;
  quantity_AVERAGE_GTE?: number | null;
  quantity_AVERAGE_LT?: number | null;
  quantity_AVERAGE_LTE?: number | null;
  quantity_EQUAL?: number | null;
  quantity_GT?: number | null;
  quantity_GTE?: number | null;
  quantity_LT?: number | null;
  quantity_LTE?: number | null;
  quantity_MAX_EQUAL?: number | null;
  quantity_MAX_GT?: number | null;
  quantity_MAX_GTE?: number | null;
  quantity_MAX_LT?: number | null;
  quantity_MAX_LTE?: number | null;
  quantity_MIN_EQUAL?: number | null;
  quantity_MIN_GT?: number | null;
  quantity_MIN_GTE?: number | null;
  quantity_MIN_LT?: number | null;
  quantity_MIN_LTE?: number | null;
  quantity_SUM_EQUAL?: number | null;
  quantity_SUM_GT?: number | null;
  quantity_SUM_GTE?: number | null;
  quantity_SUM_LT?: number | null;
  quantity_SUM_LTE?: number | null;
  revokedOn_EQUAL?: any | null;
  revokedOn_GT?: any | null;
  revokedOn_GTE?: any | null;
  revokedOn_LT?: any | null;
  revokedOn_LTE?: any | null;
  revokedOn_MAX_EQUAL?: any | null;
  revokedOn_MAX_GT?: any | null;
  revokedOn_MAX_GTE?: any | null;
  revokedOn_MAX_LT?: any | null;
  revokedOn_MAX_LTE?: any | null;
  revokedOn_MIN_EQUAL?: any | null;
  revokedOn_MIN_GT?: any | null;
  revokedOn_MIN_GTE?: any | null;
  revokedOn_MIN_LT?: any | null;
  revokedOn_MIN_LTE?: any | null;
  tenantId_AVERAGE_EQUAL?: number | null;
  tenantId_AVERAGE_GT?: number | null;
  tenantId_AVERAGE_GTE?: number | null;
  tenantId_AVERAGE_LT?: number | null;
  tenantId_AVERAGE_LTE?: number | null;
  tenantId_EQUAL?: string | null;
  tenantId_GT?: number | null;
  tenantId_GTE?: number | null;
  tenantId_LONGEST_EQUAL?: number | null;
  tenantId_LONGEST_GT?: number | null;
  tenantId_LONGEST_GTE?: number | null;
  tenantId_LONGEST_LT?: number | null;
  tenantId_LONGEST_LTE?: number | null;
  tenantId_LT?: number | null;
  tenantId_LTE?: number | null;
  tenantId_SHORTEST_EQUAL?: number | null;
  tenantId_SHORTEST_GT?: number | null;
  tenantId_SHORTEST_GTE?: number | null;
  tenantId_SHORTEST_LT?: number | null;
  tenantId_SHORTEST_LTE?: number | null;
  type_AVERAGE_EQUAL?: number | null;
  type_AVERAGE_GT?: number | null;
  type_AVERAGE_GTE?: number | null;
  type_AVERAGE_LT?: number | null;
  type_AVERAGE_LTE?: number | null;
  type_EQUAL?: string | null;
  type_GT?: number | null;
  type_GTE?: number | null;
  type_LONGEST_EQUAL?: number | null;
  type_LONGEST_GT?: number | null;
  type_LONGEST_GTE?: number | null;
  type_LONGEST_LT?: number | null;
  type_LONGEST_LTE?: number | null;
  type_LT?: number | null;
  type_LTE?: number | null;
  type_SHORTEST_EQUAL?: number | null;
  type_SHORTEST_GT?: number | null;
  type_SHORTEST_GTE?: number | null;
  type_SHORTEST_LT?: number | null;
  type_SHORTEST_LTE?: number | null;
  unlimited_AVERAGE_EQUAL?: number | null;
  unlimited_AVERAGE_GT?: number | null;
  unlimited_AVERAGE_GTE?: number | null;
  unlimited_AVERAGE_LT?: number | null;
  unlimited_AVERAGE_LTE?: number | null;
  unlimited_EQUAL?: number | null;
  unlimited_GT?: number | null;
  unlimited_GTE?: number | null;
  unlimited_LT?: number | null;
  unlimited_LTE?: number | null;
  unlimited_MAX_EQUAL?: number | null;
  unlimited_MAX_GT?: number | null;
  unlimited_MAX_GTE?: number | null;
  unlimited_MAX_LT?: number | null;
  unlimited_MAX_LTE?: number | null;
  unlimited_MIN_EQUAL?: number | null;
  unlimited_MIN_GT?: number | null;
  unlimited_MIN_GTE?: number | null;
  unlimited_MIN_LT?: number | null;
  unlimited_MIN_LTE?: number | null;
  unlimited_SUM_EQUAL?: number | null;
  unlimited_SUM_GT?: number | null;
  unlimited_SUM_GTE?: number | null;
  unlimited_SUM_LT?: number | null;
  unlimited_SUM_LTE?: number | null;
  uuid_AVERAGE_EQUAL?: number | null;
  uuid_AVERAGE_GT?: number | null;
  uuid_AVERAGE_GTE?: number | null;
  uuid_AVERAGE_LT?: number | null;
  uuid_AVERAGE_LTE?: number | null;
  uuid_EQUAL?: string | null;
  uuid_GT?: number | null;
  uuid_GTE?: number | null;
  uuid_LONGEST_EQUAL?: number | null;
  uuid_LONGEST_GT?: number | null;
  uuid_LONGEST_GTE?: number | null;
  uuid_LONGEST_LT?: number | null;
  uuid_LONGEST_LTE?: number | null;
  uuid_LT?: number | null;
  uuid_LTE?: number | null;
  uuid_SHORTEST_EQUAL?: number | null;
  uuid_SHORTEST_GT?: number | null;
  uuid_SHORTEST_GTE?: number | null;
  uuid_SHORTEST_LT?: number | null;
  uuid_SHORTEST_LTE?: number | null;
}

/**
 * Fields to sort Records by. The order in which sorts are applied is not guaranteed when specifying many fields in one RecordSort object.
 */
export interface RecordSort {
  administrationDate?: SortDirection | null;
  claimId?: SortDirection | null;
  createdByEmail?: SortDirection | null;
  createdByName?: SortDirection | null;
  createdOn?: SortDirection | null;
  data?: SortDirection | null;
  flexEntityName?: SortDirection | null;
  id?: SortDirection | null;
  insuranceId?: SortDirection | null;
  invoiceDate?: SortDirection | null;
  invoiceNumber?: SortDirection | null;
  isArchived?: SortDirection | null;
  isDeleted?: SortDirection | null;
  isRevoked?: SortDirection | null;
  matchedCaseCount?: SortDirection | null;
  occurrence?: SortDirection | null;
  preparationBrandNames?: SortDirection | null;
  preparationGenericNames?: SortDirection | null;
  preparationId?: SortDirection | null;
  quantity?: SortDirection | null;
  revokedOn?: SortDirection | null;
  status?: SortDirection | null;
  tenantId?: SortDirection | null;
  type?: SortDirection | null;
  unlimited?: SortDirection | null;
  uuid?: SortDirection | null;
}

export interface RecordSuccessorAggregateInput {
  AND?: RecordSuccessorAggregateInput[] | null;
  OR?: RecordSuccessorAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: RecordSuccessorNodeAggregationWhereInput | null;
}

export interface RecordSuccessorConnectionWhere {
  AND?: RecordSuccessorConnectionWhere[] | null;
  OR?: RecordSuccessorConnectionWhere[] | null;
  node?: RecordWhere | null;
  node_NOT?: RecordWhere | null;
}

export interface RecordSuccessorNodeAggregationWhereInput {
  AND?: RecordSuccessorNodeAggregationWhereInput[] | null;
  OR?: RecordSuccessorNodeAggregationWhereInput[] | null;
  administrationDate_EQUAL?: any | null;
  administrationDate_GT?: any | null;
  administrationDate_GTE?: any | null;
  administrationDate_LT?: any | null;
  administrationDate_LTE?: any | null;
  administrationDate_MAX_EQUAL?: any | null;
  administrationDate_MAX_GT?: any | null;
  administrationDate_MAX_GTE?: any | null;
  administrationDate_MAX_LT?: any | null;
  administrationDate_MAX_LTE?: any | null;
  administrationDate_MIN_EQUAL?: any | null;
  administrationDate_MIN_GT?: any | null;
  administrationDate_MIN_GTE?: any | null;
  administrationDate_MIN_LT?: any | null;
  administrationDate_MIN_LTE?: any | null;
  claimId_AVERAGE_EQUAL?: number | null;
  claimId_AVERAGE_GT?: number | null;
  claimId_AVERAGE_GTE?: number | null;
  claimId_AVERAGE_LT?: number | null;
  claimId_AVERAGE_LTE?: number | null;
  claimId_EQUAL?: string | null;
  claimId_GT?: number | null;
  claimId_GTE?: number | null;
  claimId_LONGEST_EQUAL?: number | null;
  claimId_LONGEST_GT?: number | null;
  claimId_LONGEST_GTE?: number | null;
  claimId_LONGEST_LT?: number | null;
  claimId_LONGEST_LTE?: number | null;
  claimId_LT?: number | null;
  claimId_LTE?: number | null;
  claimId_SHORTEST_EQUAL?: number | null;
  claimId_SHORTEST_GT?: number | null;
  claimId_SHORTEST_GTE?: number | null;
  claimId_SHORTEST_LT?: number | null;
  claimId_SHORTEST_LTE?: number | null;
  createdByEmail_AVERAGE_EQUAL?: number | null;
  createdByEmail_AVERAGE_GT?: number | null;
  createdByEmail_AVERAGE_GTE?: number | null;
  createdByEmail_AVERAGE_LT?: number | null;
  createdByEmail_AVERAGE_LTE?: number | null;
  createdByEmail_EQUAL?: string | null;
  createdByEmail_GT?: number | null;
  createdByEmail_GTE?: number | null;
  createdByEmail_LONGEST_EQUAL?: number | null;
  createdByEmail_LONGEST_GT?: number | null;
  createdByEmail_LONGEST_GTE?: number | null;
  createdByEmail_LONGEST_LT?: number | null;
  createdByEmail_LONGEST_LTE?: number | null;
  createdByEmail_LT?: number | null;
  createdByEmail_LTE?: number | null;
  createdByEmail_SHORTEST_EQUAL?: number | null;
  createdByEmail_SHORTEST_GT?: number | null;
  createdByEmail_SHORTEST_GTE?: number | null;
  createdByEmail_SHORTEST_LT?: number | null;
  createdByEmail_SHORTEST_LTE?: number | null;
  createdByName_AVERAGE_EQUAL?: number | null;
  createdByName_AVERAGE_GT?: number | null;
  createdByName_AVERAGE_GTE?: number | null;
  createdByName_AVERAGE_LT?: number | null;
  createdByName_AVERAGE_LTE?: number | null;
  createdByName_EQUAL?: string | null;
  createdByName_GT?: number | null;
  createdByName_GTE?: number | null;
  createdByName_LONGEST_EQUAL?: number | null;
  createdByName_LONGEST_GT?: number | null;
  createdByName_LONGEST_GTE?: number | null;
  createdByName_LONGEST_LT?: number | null;
  createdByName_LONGEST_LTE?: number | null;
  createdByName_LT?: number | null;
  createdByName_LTE?: number | null;
  createdByName_SHORTEST_EQUAL?: number | null;
  createdByName_SHORTEST_GT?: number | null;
  createdByName_SHORTEST_GTE?: number | null;
  createdByName_SHORTEST_LT?: number | null;
  createdByName_SHORTEST_LTE?: number | null;
  createdOn_EQUAL?: any | null;
  createdOn_GT?: any | null;
  createdOn_GTE?: any | null;
  createdOn_LT?: any | null;
  createdOn_LTE?: any | null;
  createdOn_MAX_EQUAL?: any | null;
  createdOn_MAX_GT?: any | null;
  createdOn_MAX_GTE?: any | null;
  createdOn_MAX_LT?: any | null;
  createdOn_MAX_LTE?: any | null;
  createdOn_MIN_EQUAL?: any | null;
  createdOn_MIN_GT?: any | null;
  createdOn_MIN_GTE?: any | null;
  createdOn_MIN_LT?: any | null;
  createdOn_MIN_LTE?: any | null;
  data_AVERAGE_EQUAL?: number | null;
  data_AVERAGE_GT?: number | null;
  data_AVERAGE_GTE?: number | null;
  data_AVERAGE_LT?: number | null;
  data_AVERAGE_LTE?: number | null;
  data_EQUAL?: string | null;
  data_GT?: number | null;
  data_GTE?: number | null;
  data_LONGEST_EQUAL?: number | null;
  data_LONGEST_GT?: number | null;
  data_LONGEST_GTE?: number | null;
  data_LONGEST_LT?: number | null;
  data_LONGEST_LTE?: number | null;
  data_LT?: number | null;
  data_LTE?: number | null;
  data_SHORTEST_EQUAL?: number | null;
  data_SHORTEST_GT?: number | null;
  data_SHORTEST_GTE?: number | null;
  data_SHORTEST_LT?: number | null;
  data_SHORTEST_LTE?: number | null;
  flexEntityName_AVERAGE_EQUAL?: number | null;
  flexEntityName_AVERAGE_GT?: number | null;
  flexEntityName_AVERAGE_GTE?: number | null;
  flexEntityName_AVERAGE_LT?: number | null;
  flexEntityName_AVERAGE_LTE?: number | null;
  flexEntityName_EQUAL?: string | null;
  flexEntityName_GT?: number | null;
  flexEntityName_GTE?: number | null;
  flexEntityName_LONGEST_EQUAL?: number | null;
  flexEntityName_LONGEST_GT?: number | null;
  flexEntityName_LONGEST_GTE?: number | null;
  flexEntityName_LONGEST_LT?: number | null;
  flexEntityName_LONGEST_LTE?: number | null;
  flexEntityName_LT?: number | null;
  flexEntityName_LTE?: number | null;
  flexEntityName_SHORTEST_EQUAL?: number | null;
  flexEntityName_SHORTEST_GT?: number | null;
  flexEntityName_SHORTEST_GTE?: number | null;
  flexEntityName_SHORTEST_LT?: number | null;
  flexEntityName_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  insuranceId_AVERAGE_EQUAL?: number | null;
  insuranceId_AVERAGE_GT?: number | null;
  insuranceId_AVERAGE_GTE?: number | null;
  insuranceId_AVERAGE_LT?: number | null;
  insuranceId_AVERAGE_LTE?: number | null;
  insuranceId_EQUAL?: string | null;
  insuranceId_GT?: number | null;
  insuranceId_GTE?: number | null;
  insuranceId_LONGEST_EQUAL?: number | null;
  insuranceId_LONGEST_GT?: number | null;
  insuranceId_LONGEST_GTE?: number | null;
  insuranceId_LONGEST_LT?: number | null;
  insuranceId_LONGEST_LTE?: number | null;
  insuranceId_LT?: number | null;
  insuranceId_LTE?: number | null;
  insuranceId_SHORTEST_EQUAL?: number | null;
  insuranceId_SHORTEST_GT?: number | null;
  insuranceId_SHORTEST_GTE?: number | null;
  insuranceId_SHORTEST_LT?: number | null;
  insuranceId_SHORTEST_LTE?: number | null;
  invoiceNumber_AVERAGE_EQUAL?: number | null;
  invoiceNumber_AVERAGE_GT?: number | null;
  invoiceNumber_AVERAGE_GTE?: number | null;
  invoiceNumber_AVERAGE_LT?: number | null;
  invoiceNumber_AVERAGE_LTE?: number | null;
  invoiceNumber_EQUAL?: string | null;
  invoiceNumber_GT?: number | null;
  invoiceNumber_GTE?: number | null;
  invoiceNumber_LONGEST_EQUAL?: number | null;
  invoiceNumber_LONGEST_GT?: number | null;
  invoiceNumber_LONGEST_GTE?: number | null;
  invoiceNumber_LONGEST_LT?: number | null;
  invoiceNumber_LONGEST_LTE?: number | null;
  invoiceNumber_LT?: number | null;
  invoiceNumber_LTE?: number | null;
  invoiceNumber_SHORTEST_EQUAL?: number | null;
  invoiceNumber_SHORTEST_GT?: number | null;
  invoiceNumber_SHORTEST_GTE?: number | null;
  invoiceNumber_SHORTEST_LT?: number | null;
  invoiceNumber_SHORTEST_LTE?: number | null;
  preparationBrandNames_AVERAGE_EQUAL?: number | null;
  preparationBrandNames_AVERAGE_GT?: number | null;
  preparationBrandNames_AVERAGE_GTE?: number | null;
  preparationBrandNames_AVERAGE_LT?: number | null;
  preparationBrandNames_AVERAGE_LTE?: number | null;
  preparationBrandNames_EQUAL?: string | null;
  preparationBrandNames_GT?: number | null;
  preparationBrandNames_GTE?: number | null;
  preparationBrandNames_LONGEST_EQUAL?: number | null;
  preparationBrandNames_LONGEST_GT?: number | null;
  preparationBrandNames_LONGEST_GTE?: number | null;
  preparationBrandNames_LONGEST_LT?: number | null;
  preparationBrandNames_LONGEST_LTE?: number | null;
  preparationBrandNames_LT?: number | null;
  preparationBrandNames_LTE?: number | null;
  preparationBrandNames_SHORTEST_EQUAL?: number | null;
  preparationBrandNames_SHORTEST_GT?: number | null;
  preparationBrandNames_SHORTEST_GTE?: number | null;
  preparationBrandNames_SHORTEST_LT?: number | null;
  preparationBrandNames_SHORTEST_LTE?: number | null;
  preparationGenericNames_AVERAGE_EQUAL?: number | null;
  preparationGenericNames_AVERAGE_GT?: number | null;
  preparationGenericNames_AVERAGE_GTE?: number | null;
  preparationGenericNames_AVERAGE_LT?: number | null;
  preparationGenericNames_AVERAGE_LTE?: number | null;
  preparationGenericNames_EQUAL?: string | null;
  preparationGenericNames_GT?: number | null;
  preparationGenericNames_GTE?: number | null;
  preparationGenericNames_LONGEST_EQUAL?: number | null;
  preparationGenericNames_LONGEST_GT?: number | null;
  preparationGenericNames_LONGEST_GTE?: number | null;
  preparationGenericNames_LONGEST_LT?: number | null;
  preparationGenericNames_LONGEST_LTE?: number | null;
  preparationGenericNames_LT?: number | null;
  preparationGenericNames_LTE?: number | null;
  preparationGenericNames_SHORTEST_EQUAL?: number | null;
  preparationGenericNames_SHORTEST_GT?: number | null;
  preparationGenericNames_SHORTEST_GTE?: number | null;
  preparationGenericNames_SHORTEST_LT?: number | null;
  preparationGenericNames_SHORTEST_LTE?: number | null;
  preparationId_AVERAGE_EQUAL?: number | null;
  preparationId_AVERAGE_GT?: number | null;
  preparationId_AVERAGE_GTE?: number | null;
  preparationId_AVERAGE_LT?: number | null;
  preparationId_AVERAGE_LTE?: number | null;
  preparationId_EQUAL?: string | null;
  preparationId_GT?: number | null;
  preparationId_GTE?: number | null;
  preparationId_LONGEST_EQUAL?: number | null;
  preparationId_LONGEST_GT?: number | null;
  preparationId_LONGEST_GTE?: number | null;
  preparationId_LONGEST_LT?: number | null;
  preparationId_LONGEST_LTE?: number | null;
  preparationId_LT?: number | null;
  preparationId_LTE?: number | null;
  preparationId_SHORTEST_EQUAL?: number | null;
  preparationId_SHORTEST_GT?: number | null;
  preparationId_SHORTEST_GTE?: number | null;
  preparationId_SHORTEST_LT?: number | null;
  preparationId_SHORTEST_LTE?: number | null;
  quantity_AVERAGE_EQUAL?: number | null;
  quantity_AVERAGE_GT?: number | null;
  quantity_AVERAGE_GTE?: number | null;
  quantity_AVERAGE_LT?: number | null;
  quantity_AVERAGE_LTE?: number | null;
  quantity_EQUAL?: number | null;
  quantity_GT?: number | null;
  quantity_GTE?: number | null;
  quantity_LT?: number | null;
  quantity_LTE?: number | null;
  quantity_MAX_EQUAL?: number | null;
  quantity_MAX_GT?: number | null;
  quantity_MAX_GTE?: number | null;
  quantity_MAX_LT?: number | null;
  quantity_MAX_LTE?: number | null;
  quantity_MIN_EQUAL?: number | null;
  quantity_MIN_GT?: number | null;
  quantity_MIN_GTE?: number | null;
  quantity_MIN_LT?: number | null;
  quantity_MIN_LTE?: number | null;
  quantity_SUM_EQUAL?: number | null;
  quantity_SUM_GT?: number | null;
  quantity_SUM_GTE?: number | null;
  quantity_SUM_LT?: number | null;
  quantity_SUM_LTE?: number | null;
  revokedOn_EQUAL?: any | null;
  revokedOn_GT?: any | null;
  revokedOn_GTE?: any | null;
  revokedOn_LT?: any | null;
  revokedOn_LTE?: any | null;
  revokedOn_MAX_EQUAL?: any | null;
  revokedOn_MAX_GT?: any | null;
  revokedOn_MAX_GTE?: any | null;
  revokedOn_MAX_LT?: any | null;
  revokedOn_MAX_LTE?: any | null;
  revokedOn_MIN_EQUAL?: any | null;
  revokedOn_MIN_GT?: any | null;
  revokedOn_MIN_GTE?: any | null;
  revokedOn_MIN_LT?: any | null;
  revokedOn_MIN_LTE?: any | null;
  tenantId_AVERAGE_EQUAL?: number | null;
  tenantId_AVERAGE_GT?: number | null;
  tenantId_AVERAGE_GTE?: number | null;
  tenantId_AVERAGE_LT?: number | null;
  tenantId_AVERAGE_LTE?: number | null;
  tenantId_EQUAL?: string | null;
  tenantId_GT?: number | null;
  tenantId_GTE?: number | null;
  tenantId_LONGEST_EQUAL?: number | null;
  tenantId_LONGEST_GT?: number | null;
  tenantId_LONGEST_GTE?: number | null;
  tenantId_LONGEST_LT?: number | null;
  tenantId_LONGEST_LTE?: number | null;
  tenantId_LT?: number | null;
  tenantId_LTE?: number | null;
  tenantId_SHORTEST_EQUAL?: number | null;
  tenantId_SHORTEST_GT?: number | null;
  tenantId_SHORTEST_GTE?: number | null;
  tenantId_SHORTEST_LT?: number | null;
  tenantId_SHORTEST_LTE?: number | null;
  type_AVERAGE_EQUAL?: number | null;
  type_AVERAGE_GT?: number | null;
  type_AVERAGE_GTE?: number | null;
  type_AVERAGE_LT?: number | null;
  type_AVERAGE_LTE?: number | null;
  type_EQUAL?: string | null;
  type_GT?: number | null;
  type_GTE?: number | null;
  type_LONGEST_EQUAL?: number | null;
  type_LONGEST_GT?: number | null;
  type_LONGEST_GTE?: number | null;
  type_LONGEST_LT?: number | null;
  type_LONGEST_LTE?: number | null;
  type_LT?: number | null;
  type_LTE?: number | null;
  type_SHORTEST_EQUAL?: number | null;
  type_SHORTEST_GT?: number | null;
  type_SHORTEST_GTE?: number | null;
  type_SHORTEST_LT?: number | null;
  type_SHORTEST_LTE?: number | null;
  unlimited_AVERAGE_EQUAL?: number | null;
  unlimited_AVERAGE_GT?: number | null;
  unlimited_AVERAGE_GTE?: number | null;
  unlimited_AVERAGE_LT?: number | null;
  unlimited_AVERAGE_LTE?: number | null;
  unlimited_EQUAL?: number | null;
  unlimited_GT?: number | null;
  unlimited_GTE?: number | null;
  unlimited_LT?: number | null;
  unlimited_LTE?: number | null;
  unlimited_MAX_EQUAL?: number | null;
  unlimited_MAX_GT?: number | null;
  unlimited_MAX_GTE?: number | null;
  unlimited_MAX_LT?: number | null;
  unlimited_MAX_LTE?: number | null;
  unlimited_MIN_EQUAL?: number | null;
  unlimited_MIN_GT?: number | null;
  unlimited_MIN_GTE?: number | null;
  unlimited_MIN_LT?: number | null;
  unlimited_MIN_LTE?: number | null;
  unlimited_SUM_EQUAL?: number | null;
  unlimited_SUM_GT?: number | null;
  unlimited_SUM_GTE?: number | null;
  unlimited_SUM_LT?: number | null;
  unlimited_SUM_LTE?: number | null;
  uuid_AVERAGE_EQUAL?: number | null;
  uuid_AVERAGE_GT?: number | null;
  uuid_AVERAGE_GTE?: number | null;
  uuid_AVERAGE_LT?: number | null;
  uuid_AVERAGE_LTE?: number | null;
  uuid_EQUAL?: string | null;
  uuid_GT?: number | null;
  uuid_GTE?: number | null;
  uuid_LONGEST_EQUAL?: number | null;
  uuid_LONGEST_GT?: number | null;
  uuid_LONGEST_GTE?: number | null;
  uuid_LONGEST_LT?: number | null;
  uuid_LONGEST_LTE?: number | null;
  uuid_LT?: number | null;
  uuid_LTE?: number | null;
  uuid_SHORTEST_EQUAL?: number | null;
  uuid_SHORTEST_GT?: number | null;
  uuid_SHORTEST_GTE?: number | null;
  uuid_SHORTEST_LT?: number | null;
  uuid_SHORTEST_LTE?: number | null;
}

export interface RecordVerifiedByAggregateInput {
  AND?: RecordVerifiedByAggregateInput[] | null;
  OR?: RecordVerifiedByAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: RecordVerifiedByNodeAggregationWhereInput | null;
}

export interface RecordVerifiedByConnectionWhere {
  AND?: RecordVerifiedByConnectionWhere[] | null;
  OR?: RecordVerifiedByConnectionWhere[] | null;
  node?: UserWhere | null;
  node_NOT?: UserWhere | null;
}

export interface RecordVerifiedByNodeAggregationWhereInput {
  AND?: RecordVerifiedByNodeAggregationWhereInput[] | null;
  OR?: RecordVerifiedByNodeAggregationWhereInput[] | null;
  deletedOn_EQUAL?: any | null;
  deletedOn_GT?: any | null;
  deletedOn_GTE?: any | null;
  deletedOn_LT?: any | null;
  deletedOn_LTE?: any | null;
  deletedOn_MAX_EQUAL?: any | null;
  deletedOn_MAX_GT?: any | null;
  deletedOn_MAX_GTE?: any | null;
  deletedOn_MAX_LT?: any | null;
  deletedOn_MAX_LTE?: any | null;
  deletedOn_MIN_EQUAL?: any | null;
  deletedOn_MIN_GT?: any | null;
  deletedOn_MIN_GTE?: any | null;
  deletedOn_MIN_LT?: any | null;
  deletedOn_MIN_LTE?: any | null;
  department_AVERAGE_EQUAL?: number | null;
  department_AVERAGE_GT?: number | null;
  department_AVERAGE_GTE?: number | null;
  department_AVERAGE_LT?: number | null;
  department_AVERAGE_LTE?: number | null;
  department_EQUAL?: string | null;
  department_GT?: number | null;
  department_GTE?: number | null;
  department_LONGEST_EQUAL?: number | null;
  department_LONGEST_GT?: number | null;
  department_LONGEST_GTE?: number | null;
  department_LONGEST_LT?: number | null;
  department_LONGEST_LTE?: number | null;
  department_LT?: number | null;
  department_LTE?: number | null;
  department_SHORTEST_EQUAL?: number | null;
  department_SHORTEST_GT?: number | null;
  department_SHORTEST_GTE?: number | null;
  department_SHORTEST_LT?: number | null;
  department_SHORTEST_LTE?: number | null;
  email_AVERAGE_EQUAL?: number | null;
  email_AVERAGE_GT?: number | null;
  email_AVERAGE_GTE?: number | null;
  email_AVERAGE_LT?: number | null;
  email_AVERAGE_LTE?: number | null;
  email_EQUAL?: string | null;
  email_GT?: number | null;
  email_GTE?: number | null;
  email_LONGEST_EQUAL?: number | null;
  email_LONGEST_GT?: number | null;
  email_LONGEST_GTE?: number | null;
  email_LONGEST_LT?: number | null;
  email_LONGEST_LTE?: number | null;
  email_LT?: number | null;
  email_LTE?: number | null;
  email_SHORTEST_EQUAL?: number | null;
  email_SHORTEST_GT?: number | null;
  email_SHORTEST_GTE?: number | null;
  email_SHORTEST_LT?: number | null;
  email_SHORTEST_LTE?: number | null;
  firstName_AVERAGE_EQUAL?: number | null;
  firstName_AVERAGE_GT?: number | null;
  firstName_AVERAGE_GTE?: number | null;
  firstName_AVERAGE_LT?: number | null;
  firstName_AVERAGE_LTE?: number | null;
  firstName_EQUAL?: string | null;
  firstName_GT?: number | null;
  firstName_GTE?: number | null;
  firstName_LONGEST_EQUAL?: number | null;
  firstName_LONGEST_GT?: number | null;
  firstName_LONGEST_GTE?: number | null;
  firstName_LONGEST_LT?: number | null;
  firstName_LONGEST_LTE?: number | null;
  firstName_LT?: number | null;
  firstName_LTE?: number | null;
  firstName_SHORTEST_EQUAL?: number | null;
  firstName_SHORTEST_GT?: number | null;
  firstName_SHORTEST_GTE?: number | null;
  firstName_SHORTEST_LT?: number | null;
  firstName_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  lastName_AVERAGE_EQUAL?: number | null;
  lastName_AVERAGE_GT?: number | null;
  lastName_AVERAGE_GTE?: number | null;
  lastName_AVERAGE_LT?: number | null;
  lastName_AVERAGE_LTE?: number | null;
  lastName_EQUAL?: string | null;
  lastName_GT?: number | null;
  lastName_GTE?: number | null;
  lastName_LONGEST_EQUAL?: number | null;
  lastName_LONGEST_GT?: number | null;
  lastName_LONGEST_GTE?: number | null;
  lastName_LONGEST_LT?: number | null;
  lastName_LONGEST_LTE?: number | null;
  lastName_LT?: number | null;
  lastName_LTE?: number | null;
  lastName_SHORTEST_EQUAL?: number | null;
  lastName_SHORTEST_GT?: number | null;
  lastName_SHORTEST_GTE?: number | null;
  lastName_SHORTEST_LT?: number | null;
  lastName_SHORTEST_LTE?: number | null;
  position_AVERAGE_EQUAL?: number | null;
  position_AVERAGE_GT?: number | null;
  position_AVERAGE_GTE?: number | null;
  position_AVERAGE_LT?: number | null;
  position_AVERAGE_LTE?: number | null;
  position_EQUAL?: string | null;
  position_GT?: number | null;
  position_GTE?: number | null;
  position_LONGEST_EQUAL?: number | null;
  position_LONGEST_GT?: number | null;
  position_LONGEST_GTE?: number | null;
  position_LONGEST_LT?: number | null;
  position_LONGEST_LTE?: number | null;
  position_LT?: number | null;
  position_LTE?: number | null;
  position_SHORTEST_EQUAL?: number | null;
  position_SHORTEST_GT?: number | null;
  position_SHORTEST_GTE?: number | null;
  position_SHORTEST_LT?: number | null;
  position_SHORTEST_LTE?: number | null;
  preferredLanguage_AVERAGE_EQUAL?: number | null;
  preferredLanguage_AVERAGE_GT?: number | null;
  preferredLanguage_AVERAGE_GTE?: number | null;
  preferredLanguage_AVERAGE_LT?: number | null;
  preferredLanguage_AVERAGE_LTE?: number | null;
  preferredLanguage_EQUAL?: string | null;
  preferredLanguage_GT?: number | null;
  preferredLanguage_GTE?: number | null;
  preferredLanguage_LONGEST_EQUAL?: number | null;
  preferredLanguage_LONGEST_GT?: number | null;
  preferredLanguage_LONGEST_GTE?: number | null;
  preferredLanguage_LONGEST_LT?: number | null;
  preferredLanguage_LONGEST_LTE?: number | null;
  preferredLanguage_LT?: number | null;
  preferredLanguage_LTE?: number | null;
  preferredLanguage_SHORTEST_EQUAL?: number | null;
  preferredLanguage_SHORTEST_GT?: number | null;
  preferredLanguage_SHORTEST_GTE?: number | null;
  preferredLanguage_SHORTEST_LT?: number | null;
  preferredLanguage_SHORTEST_LTE?: number | null;
  tenantId_AVERAGE_EQUAL?: number | null;
  tenantId_AVERAGE_GT?: number | null;
  tenantId_AVERAGE_GTE?: number | null;
  tenantId_AVERAGE_LT?: number | null;
  tenantId_AVERAGE_LTE?: number | null;
  tenantId_EQUAL?: string | null;
  tenantId_GT?: number | null;
  tenantId_GTE?: number | null;
  tenantId_LONGEST_EQUAL?: number | null;
  tenantId_LONGEST_GT?: number | null;
  tenantId_LONGEST_GTE?: number | null;
  tenantId_LONGEST_LT?: number | null;
  tenantId_LONGEST_LTE?: number | null;
  tenantId_LT?: number | null;
  tenantId_LTE?: number | null;
  tenantId_SHORTEST_EQUAL?: number | null;
  tenantId_SHORTEST_GT?: number | null;
  tenantId_SHORTEST_GTE?: number | null;
  tenantId_SHORTEST_LT?: number | null;
  tenantId_SHORTEST_LTE?: number | null;
}

export interface RecordWhere {
  AND?: RecordWhere[] | null;
  OR?: RecordWhere[] | null;
  administrationDate?: any | null;
  administrationDate_GT?: any | null;
  administrationDate_GTE?: any | null;
  administrationDate_IN?: (any | null)[] | null;
  administrationDate_LT?: any | null;
  administrationDate_LTE?: any | null;
  administrationDate_NOT?: any | null;
  administrationDate_NOT_IN?: (any | null)[] | null;
  claimId?: string | null;
  claimId_CONTAINS?: string | null;
  claimId_ENDS_WITH?: string | null;
  claimId_IN?: (string | null)[] | null;
  claimId_MATCHES?: string | null;
  claimId_NOT?: string | null;
  claimId_NOT_CONTAINS?: string | null;
  claimId_NOT_ENDS_WITH?: string | null;
  claimId_NOT_IN?: (string | null)[] | null;
  claimId_NOT_STARTS_WITH?: string | null;
  claimId_STARTS_WITH?: string | null;
  createdByEmail?: string | null;
  createdByEmail_CONTAINS?: string | null;
  createdByEmail_ENDS_WITH?: string | null;
  createdByEmail_IN?: (string | null)[] | null;
  createdByEmail_MATCHES?: string | null;
  createdByEmail_NOT?: string | null;
  createdByEmail_NOT_CONTAINS?: string | null;
  createdByEmail_NOT_ENDS_WITH?: string | null;
  createdByEmail_NOT_IN?: (string | null)[] | null;
  createdByEmail_NOT_STARTS_WITH?: string | null;
  createdByEmail_STARTS_WITH?: string | null;
  createdByName?: string | null;
  createdByName_CONTAINS?: string | null;
  createdByName_ENDS_WITH?: string | null;
  createdByName_IN?: (string | null)[] | null;
  createdByName_MATCHES?: string | null;
  createdByName_NOT?: string | null;
  createdByName_NOT_CONTAINS?: string | null;
  createdByName_NOT_ENDS_WITH?: string | null;
  createdByName_NOT_IN?: (string | null)[] | null;
  createdByName_NOT_STARTS_WITH?: string | null;
  createdByName_STARTS_WITH?: string | null;
  createdOn?: any | null;
  createdOn_GT?: any | null;
  createdOn_GTE?: any | null;
  createdOn_IN?: (any | null)[] | null;
  createdOn_LT?: any | null;
  createdOn_LTE?: any | null;
  createdOn_NOT?: any | null;
  createdOn_NOT_IN?: (any | null)[] | null;
  data?: string | null;
  data_CONTAINS?: string | null;
  data_ENDS_WITH?: string | null;
  data_IN?: (string | null)[] | null;
  data_MATCHES?: string | null;
  data_NOT?: string | null;
  data_NOT_CONTAINS?: string | null;
  data_NOT_ENDS_WITH?: string | null;
  data_NOT_IN?: (string | null)[] | null;
  data_NOT_STARTS_WITH?: string | null;
  data_STARTS_WITH?: string | null;
  evaluatedBy?: FlexFinancialDataPointWhere | null;
  evaluatedByAggregate?: RecordEvaluatedByAggregateInput | null;
  evaluatedByConnection?: RecordEvaluatedByConnectionWhere | null;
  evaluatedByConnection_NOT?: RecordEvaluatedByConnectionWhere | null;
  evaluatedBy_NOT?: FlexFinancialDataPointWhere | null;
  flexEntityName?: string | null;
  flexEntityName_CONTAINS?: string | null;
  flexEntityName_ENDS_WITH?: string | null;
  flexEntityName_IN?: (string | null)[] | null;
  flexEntityName_MATCHES?: string | null;
  flexEntityName_NOT?: string | null;
  flexEntityName_NOT_CONTAINS?: string | null;
  flexEntityName_NOT_ENDS_WITH?: string | null;
  flexEntityName_NOT_IN?: (string | null)[] | null;
  flexEntityName_NOT_STARTS_WITH?: string | null;
  flexEntityName_STARTS_WITH?: string | null;
  id?: string | null;
  id_CONTAINS?: string | null;
  id_ENDS_WITH?: string | null;
  id_IN?: (string | null)[] | null;
  id_MATCHES?: string | null;
  id_NOT?: string | null;
  id_NOT_CONTAINS?: string | null;
  id_NOT_ENDS_WITH?: string | null;
  id_NOT_IN?: (string | null)[] | null;
  id_NOT_STARTS_WITH?: string | null;
  id_STARTS_WITH?: string | null;
  insuranceId?: string | null;
  insuranceId_CONTAINS?: string | null;
  insuranceId_ENDS_WITH?: string | null;
  insuranceId_IN?: (string | null)[] | null;
  insuranceId_MATCHES?: string | null;
  insuranceId_NOT?: string | null;
  insuranceId_NOT_CONTAINS?: string | null;
  insuranceId_NOT_ENDS_WITH?: string | null;
  insuranceId_NOT_IN?: (string | null)[] | null;
  insuranceId_NOT_STARTS_WITH?: string | null;
  insuranceId_STARTS_WITH?: string | null;
  invoiceDate?: any | null;
  invoiceDate_GT?: any | null;
  invoiceDate_GTE?: any | null;
  invoiceDate_IN?: (any | null)[] | null;
  invoiceDate_LT?: any | null;
  invoiceDate_LTE?: any | null;
  invoiceDate_NOT?: any | null;
  invoiceDate_NOT_IN?: (any | null)[] | null;
  invoiceNumber?: string | null;
  invoiceNumber_CONTAINS?: string | null;
  invoiceNumber_ENDS_WITH?: string | null;
  invoiceNumber_IN?: (string | null)[] | null;
  invoiceNumber_MATCHES?: string | null;
  invoiceNumber_NOT?: string | null;
  invoiceNumber_NOT_CONTAINS?: string | null;
  invoiceNumber_NOT_ENDS_WITH?: string | null;
  invoiceNumber_NOT_IN?: (string | null)[] | null;
  invoiceNumber_NOT_STARTS_WITH?: string | null;
  invoiceNumber_STARTS_WITH?: string | null;
  isArchived?: boolean | null;
  isArchived_NOT?: boolean | null;
  isDeleted?: boolean | null;
  isDeleted_NOT?: boolean | null;
  isRevoked?: boolean | null;
  isRevoked_NOT?: boolean | null;
  occurrence?: OccurrenceEnum | null;
  occurrence_IN?: (OccurrenceEnum | null)[] | null;
  occurrence_NOT?: OccurrenceEnum | null;
  occurrence_NOT_IN?: (OccurrenceEnum | null)[] | null;
  predecessor?: RecordWhere | null;
  predecessorAggregate?: RecordPredecessorAggregateInput | null;
  predecessorConnection?: RecordPredecessorConnectionWhere | null;
  predecessorConnection_NOT?: RecordPredecessorConnectionWhere | null;
  predecessor_NOT?: RecordWhere | null;
  preparationBrandNames?: string | null;
  preparationBrandNames_CONTAINS?: string | null;
  preparationBrandNames_ENDS_WITH?: string | null;
  preparationBrandNames_IN?: (string | null)[] | null;
  preparationBrandNames_MATCHES?: string | null;
  preparationBrandNames_NOT?: string | null;
  preparationBrandNames_NOT_CONTAINS?: string | null;
  preparationBrandNames_NOT_ENDS_WITH?: string | null;
  preparationBrandNames_NOT_IN?: (string | null)[] | null;
  preparationBrandNames_NOT_STARTS_WITH?: string | null;
  preparationBrandNames_STARTS_WITH?: string | null;
  preparationGenericNames?: string | null;
  preparationGenericNames_CONTAINS?: string | null;
  preparationGenericNames_ENDS_WITH?: string | null;
  preparationGenericNames_IN?: (string | null)[] | null;
  preparationGenericNames_MATCHES?: string | null;
  preparationGenericNames_NOT?: string | null;
  preparationGenericNames_NOT_CONTAINS?: string | null;
  preparationGenericNames_NOT_ENDS_WITH?: string | null;
  preparationGenericNames_NOT_IN?: (string | null)[] | null;
  preparationGenericNames_NOT_STARTS_WITH?: string | null;
  preparationGenericNames_STARTS_WITH?: string | null;
  preparationId?: string | null;
  preparationId_CONTAINS?: string | null;
  preparationId_ENDS_WITH?: string | null;
  preparationId_IN?: (string | null)[] | null;
  preparationId_MATCHES?: string | null;
  preparationId_NOT?: string | null;
  preparationId_NOT_CONTAINS?: string | null;
  preparationId_NOT_ENDS_WITH?: string | null;
  preparationId_NOT_IN?: (string | null)[] | null;
  preparationId_NOT_STARTS_WITH?: string | null;
  preparationId_STARTS_WITH?: string | null;
  quantity?: number | null;
  quantity_GT?: number | null;
  quantity_GTE?: number | null;
  quantity_IN?: (number | null)[] | null;
  quantity_LT?: number | null;
  quantity_LTE?: number | null;
  quantity_NOT?: number | null;
  quantity_NOT_IN?: (number | null)[] | null;
  revokedOn?: any | null;
  revokedOn_GT?: any | null;
  revokedOn_GTE?: any | null;
  revokedOn_IN?: (any | null)[] | null;
  revokedOn_LT?: any | null;
  revokedOn_LTE?: any | null;
  revokedOn_NOT?: any | null;
  revokedOn_NOT_IN?: (any | null)[] | null;
  status?: FlexFormStatus | null;
  status_IN?: (FlexFormStatus | null)[] | null;
  status_NOT?: FlexFormStatus | null;
  status_NOT_IN?: (FlexFormStatus | null)[] | null;
  successor?: RecordWhere | null;
  successorAggregate?: RecordSuccessorAggregateInput | null;
  successorConnection?: RecordSuccessorConnectionWhere | null;
  successorConnection_NOT?: RecordSuccessorConnectionWhere | null;
  successor_NOT?: RecordWhere | null;
  tenantId?: string | null;
  tenantId_CONTAINS?: string | null;
  tenantId_ENDS_WITH?: string | null;
  tenantId_IN?: (string | null)[] | null;
  tenantId_MATCHES?: string | null;
  tenantId_NOT?: string | null;
  tenantId_NOT_CONTAINS?: string | null;
  tenantId_NOT_ENDS_WITH?: string | null;
  tenantId_NOT_IN?: (string | null)[] | null;
  tenantId_NOT_STARTS_WITH?: string | null;
  tenantId_STARTS_WITH?: string | null;
  type?: string | null;
  type_CONTAINS?: string | null;
  type_ENDS_WITH?: string | null;
  type_IN?: (string | null)[] | null;
  type_MATCHES?: string | null;
  type_NOT?: string | null;
  type_NOT_CONTAINS?: string | null;
  type_NOT_ENDS_WITH?: string | null;
  type_NOT_IN?: (string | null)[] | null;
  type_NOT_STARTS_WITH?: string | null;
  type_STARTS_WITH?: string | null;
  unlimited?: number | null;
  unlimited_GT?: number | null;
  unlimited_GTE?: number | null;
  unlimited_IN?: (number | null)[] | null;
  unlimited_LT?: number | null;
  unlimited_LTE?: number | null;
  unlimited_NOT?: number | null;
  unlimited_NOT_IN?: (number | null)[] | null;
  uuid?: string | null;
  uuid_CONTAINS?: string | null;
  uuid_ENDS_WITH?: string | null;
  uuid_IN?: (string | null)[] | null;
  uuid_MATCHES?: string | null;
  uuid_NOT?: string | null;
  uuid_NOT_CONTAINS?: string | null;
  uuid_NOT_ENDS_WITH?: string | null;
  uuid_NOT_IN?: (string | null)[] | null;
  uuid_NOT_STARTS_WITH?: string | null;
  uuid_STARTS_WITH?: string | null;
  verifiedBy?: UserWhere | null;
  verifiedByAggregate?: RecordVerifiedByAggregateInput | null;
  verifiedByConnection?: RecordVerifiedByConnectionWhere | null;
  verifiedByConnection_NOT?: RecordVerifiedByConnectionWhere | null;
  verifiedBy_NOT?: UserWhere | null;
}

export interface RefundCaseAggregateInput {
  AND?: RefundCaseAggregateInput[] | null;
  OR?: RefundCaseAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: RefundCaseNodeAggregationWhereInput | null;
}

export interface RefundCaseCaseAggregateInput {
  AND?: RefundCaseCaseAggregateInput[] | null;
  OR?: RefundCaseCaseAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: RefundCaseCaseNodeAggregationWhereInput | null;
}

export interface RefundCaseCaseConnectionWhere {
  AND?: RefundCaseCaseConnectionWhere[] | null;
  OR?: RefundCaseCaseConnectionWhere[] | null;
  node?: CaseWhere | null;
  node_NOT?: CaseWhere | null;
}

export interface RefundCaseCaseNodeAggregationWhereInput {
  AND?: RefundCaseCaseNodeAggregationWhereInput[] | null;
  OR?: RefundCaseCaseNodeAggregationWhereInput[] | null;
  actualAgreementId_AVERAGE_EQUAL?: number | null;
  actualAgreementId_AVERAGE_GT?: number | null;
  actualAgreementId_AVERAGE_GTE?: number | null;
  actualAgreementId_AVERAGE_LT?: number | null;
  actualAgreementId_AVERAGE_LTE?: number | null;
  actualAgreementId_EQUAL?: string | null;
  actualAgreementId_GT?: number | null;
  actualAgreementId_GTE?: number | null;
  actualAgreementId_LONGEST_EQUAL?: number | null;
  actualAgreementId_LONGEST_GT?: number | null;
  actualAgreementId_LONGEST_GTE?: number | null;
  actualAgreementId_LONGEST_LT?: number | null;
  actualAgreementId_LONGEST_LTE?: number | null;
  actualAgreementId_LT?: number | null;
  actualAgreementId_LTE?: number | null;
  actualAgreementId_SHORTEST_EQUAL?: number | null;
  actualAgreementId_SHORTEST_GT?: number | null;
  actualAgreementId_SHORTEST_GTE?: number | null;
  actualAgreementId_SHORTEST_LT?: number | null;
  actualAgreementId_SHORTEST_LTE?: number | null;
  agreementName_AVERAGE_EQUAL?: number | null;
  agreementName_AVERAGE_GT?: number | null;
  agreementName_AVERAGE_GTE?: number | null;
  agreementName_AVERAGE_LT?: number | null;
  agreementName_AVERAGE_LTE?: number | null;
  agreementName_EQUAL?: string | null;
  agreementName_GT?: number | null;
  agreementName_GTE?: number | null;
  agreementName_LONGEST_EQUAL?: number | null;
  agreementName_LONGEST_GT?: number | null;
  agreementName_LONGEST_GTE?: number | null;
  agreementName_LONGEST_LT?: number | null;
  agreementName_LONGEST_LTE?: number | null;
  agreementName_LT?: number | null;
  agreementName_LTE?: number | null;
  agreementName_SHORTEST_EQUAL?: number | null;
  agreementName_SHORTEST_GT?: number | null;
  agreementName_SHORTEST_GTE?: number | null;
  agreementName_SHORTEST_LT?: number | null;
  agreementName_SHORTEST_LTE?: number | null;
  counterpartyInReview_AVERAGE_EQUAL?: number | null;
  counterpartyInReview_AVERAGE_GT?: number | null;
  counterpartyInReview_AVERAGE_GTE?: number | null;
  counterpartyInReview_AVERAGE_LT?: number | null;
  counterpartyInReview_AVERAGE_LTE?: number | null;
  counterpartyInReview_EQUAL?: string | null;
  counterpartyInReview_GT?: number | null;
  counterpartyInReview_GTE?: number | null;
  counterpartyInReview_LONGEST_EQUAL?: number | null;
  counterpartyInReview_LONGEST_GT?: number | null;
  counterpartyInReview_LONGEST_GTE?: number | null;
  counterpartyInReview_LONGEST_LT?: number | null;
  counterpartyInReview_LONGEST_LTE?: number | null;
  counterpartyInReview_LT?: number | null;
  counterpartyInReview_LTE?: number | null;
  counterpartyInReview_SHORTEST_EQUAL?: number | null;
  counterpartyInReview_SHORTEST_GT?: number | null;
  counterpartyInReview_SHORTEST_GTE?: number | null;
  counterpartyInReview_SHORTEST_LT?: number | null;
  counterpartyInReview_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  lastStatusChangeDate_EQUAL?: any | null;
  lastStatusChangeDate_GT?: any | null;
  lastStatusChangeDate_GTE?: any | null;
  lastStatusChangeDate_LT?: any | null;
  lastStatusChangeDate_LTE?: any | null;
  lastStatusChangeDate_MAX_EQUAL?: any | null;
  lastStatusChangeDate_MAX_GT?: any | null;
  lastStatusChangeDate_MAX_GTE?: any | null;
  lastStatusChangeDate_MAX_LT?: any | null;
  lastStatusChangeDate_MAX_LTE?: any | null;
  lastStatusChangeDate_MIN_EQUAL?: any | null;
  lastStatusChangeDate_MIN_GT?: any | null;
  lastStatusChangeDate_MIN_GTE?: any | null;
  lastStatusChangeDate_MIN_LT?: any | null;
  lastStatusChangeDate_MIN_LTE?: any | null;
  patientInitials_AVERAGE_EQUAL?: number | null;
  patientInitials_AVERAGE_GT?: number | null;
  patientInitials_AVERAGE_GTE?: number | null;
  patientInitials_AVERAGE_LT?: number | null;
  patientInitials_AVERAGE_LTE?: number | null;
  patientInitials_EQUAL?: string | null;
  patientInitials_GT?: number | null;
  patientInitials_GTE?: number | null;
  patientInitials_LONGEST_EQUAL?: number | null;
  patientInitials_LONGEST_GT?: number | null;
  patientInitials_LONGEST_GTE?: number | null;
  patientInitials_LONGEST_LT?: number | null;
  patientInitials_LONGEST_LTE?: number | null;
  patientInitials_LT?: number | null;
  patientInitials_LTE?: number | null;
  patientInitials_SHORTEST_EQUAL?: number | null;
  patientInitials_SHORTEST_GT?: number | null;
  patientInitials_SHORTEST_GTE?: number | null;
  patientInitials_SHORTEST_LT?: number | null;
  patientInitials_SHORTEST_LTE?: number | null;
  patientInsuranceId_AVERAGE_EQUAL?: number | null;
  patientInsuranceId_AVERAGE_GT?: number | null;
  patientInsuranceId_AVERAGE_GTE?: number | null;
  patientInsuranceId_AVERAGE_LT?: number | null;
  patientInsuranceId_AVERAGE_LTE?: number | null;
  patientInsuranceId_EQUAL?: string | null;
  patientInsuranceId_GT?: number | null;
  patientInsuranceId_GTE?: number | null;
  patientInsuranceId_LONGEST_EQUAL?: number | null;
  patientInsuranceId_LONGEST_GT?: number | null;
  patientInsuranceId_LONGEST_GTE?: number | null;
  patientInsuranceId_LONGEST_LT?: number | null;
  patientInsuranceId_LONGEST_LTE?: number | null;
  patientInsuranceId_LT?: number | null;
  patientInsuranceId_LTE?: number | null;
  patientInsuranceId_SHORTEST_EQUAL?: number | null;
  patientInsuranceId_SHORTEST_GT?: number | null;
  patientInsuranceId_SHORTEST_GTE?: number | null;
  patientInsuranceId_SHORTEST_LT?: number | null;
  patientInsuranceId_SHORTEST_LTE?: number | null;
  preparationBrandName_AVERAGE_EQUAL?: number | null;
  preparationBrandName_AVERAGE_GT?: number | null;
  preparationBrandName_AVERAGE_GTE?: number | null;
  preparationBrandName_AVERAGE_LT?: number | null;
  preparationBrandName_AVERAGE_LTE?: number | null;
  preparationBrandName_EQUAL?: string | null;
  preparationBrandName_GT?: number | null;
  preparationBrandName_GTE?: number | null;
  preparationBrandName_LONGEST_EQUAL?: number | null;
  preparationBrandName_LONGEST_GT?: number | null;
  preparationBrandName_LONGEST_GTE?: number | null;
  preparationBrandName_LONGEST_LT?: number | null;
  preparationBrandName_LONGEST_LTE?: number | null;
  preparationBrandName_LT?: number | null;
  preparationBrandName_LTE?: number | null;
  preparationBrandName_SHORTEST_EQUAL?: number | null;
  preparationBrandName_SHORTEST_GT?: number | null;
  preparationBrandName_SHORTEST_GTE?: number | null;
  preparationBrandName_SHORTEST_LT?: number | null;
  preparationBrandName_SHORTEST_LTE?: number | null;
  preparationGenericName_AVERAGE_EQUAL?: number | null;
  preparationGenericName_AVERAGE_GT?: number | null;
  preparationGenericName_AVERAGE_GTE?: number | null;
  preparationGenericName_AVERAGE_LT?: number | null;
  preparationGenericName_AVERAGE_LTE?: number | null;
  preparationGenericName_EQUAL?: string | null;
  preparationGenericName_GT?: number | null;
  preparationGenericName_GTE?: number | null;
  preparationGenericName_LONGEST_EQUAL?: number | null;
  preparationGenericName_LONGEST_GT?: number | null;
  preparationGenericName_LONGEST_GTE?: number | null;
  preparationGenericName_LONGEST_LT?: number | null;
  preparationGenericName_LONGEST_LTE?: number | null;
  preparationGenericName_LT?: number | null;
  preparationGenericName_LTE?: number | null;
  preparationGenericName_SHORTEST_EQUAL?: number | null;
  preparationGenericName_SHORTEST_GT?: number | null;
  preparationGenericName_SHORTEST_GTE?: number | null;
  preparationGenericName_SHORTEST_LT?: number | null;
  preparationGenericName_SHORTEST_LTE?: number | null;
  sourceTenantId_AVERAGE_EQUAL?: number | null;
  sourceTenantId_AVERAGE_GT?: number | null;
  sourceTenantId_AVERAGE_GTE?: number | null;
  sourceTenantId_AVERAGE_LT?: number | null;
  sourceTenantId_AVERAGE_LTE?: number | null;
  sourceTenantId_EQUAL?: string | null;
  sourceTenantId_GT?: number | null;
  sourceTenantId_GTE?: number | null;
  sourceTenantId_LONGEST_EQUAL?: number | null;
  sourceTenantId_LONGEST_GT?: number | null;
  sourceTenantId_LONGEST_GTE?: number | null;
  sourceTenantId_LONGEST_LT?: number | null;
  sourceTenantId_LONGEST_LTE?: number | null;
  sourceTenantId_LT?: number | null;
  sourceTenantId_LTE?: number | null;
  sourceTenantId_SHORTEST_EQUAL?: number | null;
  sourceTenantId_SHORTEST_GT?: number | null;
  sourceTenantId_SHORTEST_GTE?: number | null;
  sourceTenantId_SHORTEST_LT?: number | null;
  sourceTenantId_SHORTEST_LTE?: number | null;
  submissionDate_EQUAL?: any | null;
  submissionDate_GT?: any | null;
  submissionDate_GTE?: any | null;
  submissionDate_LT?: any | null;
  submissionDate_LTE?: any | null;
  submissionDate_MAX_EQUAL?: any | null;
  submissionDate_MAX_GT?: any | null;
  submissionDate_MAX_GTE?: any | null;
  submissionDate_MAX_LT?: any | null;
  submissionDate_MAX_LTE?: any | null;
  submissionDate_MIN_EQUAL?: any | null;
  submissionDate_MIN_GT?: any | null;
  submissionDate_MIN_GTE?: any | null;
  submissionDate_MIN_LT?: any | null;
  submissionDate_MIN_LTE?: any | null;
  suspensionReason_AVERAGE_EQUAL?: number | null;
  suspensionReason_AVERAGE_GT?: number | null;
  suspensionReason_AVERAGE_GTE?: number | null;
  suspensionReason_AVERAGE_LT?: number | null;
  suspensionReason_AVERAGE_LTE?: number | null;
  suspensionReason_EQUAL?: string | null;
  suspensionReason_GT?: number | null;
  suspensionReason_GTE?: number | null;
  suspensionReason_LONGEST_EQUAL?: number | null;
  suspensionReason_LONGEST_GT?: number | null;
  suspensionReason_LONGEST_GTE?: number | null;
  suspensionReason_LONGEST_LT?: number | null;
  suspensionReason_LONGEST_LTE?: number | null;
  suspensionReason_LT?: number | null;
  suspensionReason_LTE?: number | null;
  suspensionReason_SHORTEST_EQUAL?: number | null;
  suspensionReason_SHORTEST_GT?: number | null;
  suspensionReason_SHORTEST_GTE?: number | null;
  suspensionReason_SHORTEST_LT?: number | null;
  suspensionReason_SHORTEST_LTE?: number | null;
  totalAmount_AVERAGE_EQUAL?: number | null;
  totalAmount_AVERAGE_GT?: number | null;
  totalAmount_AVERAGE_GTE?: number | null;
  totalAmount_AVERAGE_LT?: number | null;
  totalAmount_AVERAGE_LTE?: number | null;
  totalAmount_EQUAL?: number | null;
  totalAmount_GT?: number | null;
  totalAmount_GTE?: number | null;
  totalAmount_LT?: number | null;
  totalAmount_LTE?: number | null;
  totalAmount_MAX_EQUAL?: number | null;
  totalAmount_MAX_GT?: number | null;
  totalAmount_MAX_GTE?: number | null;
  totalAmount_MAX_LT?: number | null;
  totalAmount_MAX_LTE?: number | null;
  totalAmount_MIN_EQUAL?: number | null;
  totalAmount_MIN_GT?: number | null;
  totalAmount_MIN_GTE?: number | null;
  totalAmount_MIN_LT?: number | null;
  totalAmount_MIN_LTE?: number | null;
  totalAmount_SUM_EQUAL?: number | null;
  totalAmount_SUM_GT?: number | null;
  totalAmount_SUM_GTE?: number | null;
  totalAmount_SUM_LT?: number | null;
  totalAmount_SUM_LTE?: number | null;
  unlimited_AVERAGE_EQUAL?: number | null;
  unlimited_AVERAGE_GT?: number | null;
  unlimited_AVERAGE_GTE?: number | null;
  unlimited_AVERAGE_LT?: number | null;
  unlimited_AVERAGE_LTE?: number | null;
  unlimited_EQUAL?: number | null;
  unlimited_GT?: number | null;
  unlimited_GTE?: number | null;
  unlimited_LT?: number | null;
  unlimited_LTE?: number | null;
  unlimited_MAX_EQUAL?: number | null;
  unlimited_MAX_GT?: number | null;
  unlimited_MAX_GTE?: number | null;
  unlimited_MAX_LT?: number | null;
  unlimited_MAX_LTE?: number | null;
  unlimited_MIN_EQUAL?: number | null;
  unlimited_MIN_GT?: number | null;
  unlimited_MIN_GTE?: number | null;
  unlimited_MIN_LT?: number | null;
  unlimited_MIN_LTE?: number | null;
  unlimited_SUM_EQUAL?: number | null;
  unlimited_SUM_GT?: number | null;
  unlimited_SUM_GTE?: number | null;
  unlimited_SUM_LT?: number | null;
  unlimited_SUM_LTE?: number | null;
}

export interface RefundCaseConnectionWhere {
  AND?: RefundCaseConnectionWhere[] | null;
  OR?: RefundCaseConnectionWhere[] | null;
  node?: CaseWhere | null;
  node_NOT?: CaseWhere | null;
}

export interface RefundCaseDocumentAggregateInput {
  AND?: RefundCaseDocumentAggregateInput[] | null;
  OR?: RefundCaseDocumentAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: RefundCaseDocumentNodeAggregationWhereInput | null;
}

export interface RefundCaseDocumentConnectionWhere {
  AND?: RefundCaseDocumentConnectionWhere[] | null;
  OR?: RefundCaseDocumentConnectionWhere[] | null;
  node?: DocumentWhere | null;
  node_NOT?: DocumentWhere | null;
}

export interface RefundCaseDocumentNodeAggregationWhereInput {
  AND?: RefundCaseDocumentNodeAggregationWhereInput[] | null;
  OR?: RefundCaseDocumentNodeAggregationWhereInput[] | null;
  counterParties_AVERAGE_EQUAL?: number | null;
  counterParties_AVERAGE_GT?: number | null;
  counterParties_AVERAGE_GTE?: number | null;
  counterParties_AVERAGE_LT?: number | null;
  counterParties_AVERAGE_LTE?: number | null;
  counterParties_EQUAL?: string | null;
  counterParties_GT?: number | null;
  counterParties_GTE?: number | null;
  counterParties_LONGEST_EQUAL?: number | null;
  counterParties_LONGEST_GT?: number | null;
  counterParties_LONGEST_GTE?: number | null;
  counterParties_LONGEST_LT?: number | null;
  counterParties_LONGEST_LTE?: number | null;
  counterParties_LT?: number | null;
  counterParties_LTE?: number | null;
  counterParties_SHORTEST_EQUAL?: number | null;
  counterParties_SHORTEST_GT?: number | null;
  counterParties_SHORTEST_GTE?: number | null;
  counterParties_SHORTEST_LT?: number | null;
  counterParties_SHORTEST_LTE?: number | null;
  coveragePeriod_AVERAGE_EQUAL?: number | null;
  coveragePeriod_AVERAGE_GT?: number | null;
  coveragePeriod_AVERAGE_GTE?: number | null;
  coveragePeriod_AVERAGE_LT?: number | null;
  coveragePeriod_AVERAGE_LTE?: number | null;
  coveragePeriod_EQUAL?: string | null;
  coveragePeriod_GT?: number | null;
  coveragePeriod_GTE?: number | null;
  coveragePeriod_LONGEST_EQUAL?: number | null;
  coveragePeriod_LONGEST_GT?: number | null;
  coveragePeriod_LONGEST_GTE?: number | null;
  coveragePeriod_LONGEST_LT?: number | null;
  coveragePeriod_LONGEST_LTE?: number | null;
  coveragePeriod_LT?: number | null;
  coveragePeriod_LTE?: number | null;
  coveragePeriod_SHORTEST_EQUAL?: number | null;
  coveragePeriod_SHORTEST_GT?: number | null;
  coveragePeriod_SHORTEST_GTE?: number | null;
  coveragePeriod_SHORTEST_LT?: number | null;
  coveragePeriod_SHORTEST_LTE?: number | null;
  createdByEmail_AVERAGE_EQUAL?: number | null;
  createdByEmail_AVERAGE_GT?: number | null;
  createdByEmail_AVERAGE_GTE?: number | null;
  createdByEmail_AVERAGE_LT?: number | null;
  createdByEmail_AVERAGE_LTE?: number | null;
  createdByEmail_EQUAL?: string | null;
  createdByEmail_GT?: number | null;
  createdByEmail_GTE?: number | null;
  createdByEmail_LONGEST_EQUAL?: number | null;
  createdByEmail_LONGEST_GT?: number | null;
  createdByEmail_LONGEST_GTE?: number | null;
  createdByEmail_LONGEST_LT?: number | null;
  createdByEmail_LONGEST_LTE?: number | null;
  createdByEmail_LT?: number | null;
  createdByEmail_LTE?: number | null;
  createdByEmail_SHORTEST_EQUAL?: number | null;
  createdByEmail_SHORTEST_GT?: number | null;
  createdByEmail_SHORTEST_GTE?: number | null;
  createdByEmail_SHORTEST_LT?: number | null;
  createdByEmail_SHORTEST_LTE?: number | null;
  createdOn_EQUAL?: any | null;
  createdOn_GT?: any | null;
  createdOn_GTE?: any | null;
  createdOn_LT?: any | null;
  createdOn_LTE?: any | null;
  createdOn_MAX_EQUAL?: any | null;
  createdOn_MAX_GT?: any | null;
  createdOn_MAX_GTE?: any | null;
  createdOn_MAX_LT?: any | null;
  createdOn_MAX_LTE?: any | null;
  createdOn_MIN_EQUAL?: any | null;
  createdOn_MIN_GT?: any | null;
  createdOn_MIN_GTE?: any | null;
  createdOn_MIN_LT?: any | null;
  createdOn_MIN_LTE?: any | null;
  creatorOrgName_AVERAGE_EQUAL?: number | null;
  creatorOrgName_AVERAGE_GT?: number | null;
  creatorOrgName_AVERAGE_GTE?: number | null;
  creatorOrgName_AVERAGE_LT?: number | null;
  creatorOrgName_AVERAGE_LTE?: number | null;
  creatorOrgName_EQUAL?: string | null;
  creatorOrgName_GT?: number | null;
  creatorOrgName_GTE?: number | null;
  creatorOrgName_LONGEST_EQUAL?: number | null;
  creatorOrgName_LONGEST_GT?: number | null;
  creatorOrgName_LONGEST_GTE?: number | null;
  creatorOrgName_LONGEST_LT?: number | null;
  creatorOrgName_LONGEST_LTE?: number | null;
  creatorOrgName_LT?: number | null;
  creatorOrgName_LTE?: number | null;
  creatorOrgName_SHORTEST_EQUAL?: number | null;
  creatorOrgName_SHORTEST_GT?: number | null;
  creatorOrgName_SHORTEST_GTE?: number | null;
  creatorOrgName_SHORTEST_LT?: number | null;
  creatorOrgName_SHORTEST_LTE?: number | null;
  creatorTenantId_AVERAGE_EQUAL?: number | null;
  creatorTenantId_AVERAGE_GT?: number | null;
  creatorTenantId_AVERAGE_GTE?: number | null;
  creatorTenantId_AVERAGE_LT?: number | null;
  creatorTenantId_AVERAGE_LTE?: number | null;
  creatorTenantId_EQUAL?: string | null;
  creatorTenantId_GT?: number | null;
  creatorTenantId_GTE?: number | null;
  creatorTenantId_LONGEST_EQUAL?: number | null;
  creatorTenantId_LONGEST_GT?: number | null;
  creatorTenantId_LONGEST_GTE?: number | null;
  creatorTenantId_LONGEST_LT?: number | null;
  creatorTenantId_LONGEST_LTE?: number | null;
  creatorTenantId_LT?: number | null;
  creatorTenantId_LTE?: number | null;
  creatorTenantId_SHORTEST_EQUAL?: number | null;
  creatorTenantId_SHORTEST_GT?: number | null;
  creatorTenantId_SHORTEST_GTE?: number | null;
  creatorTenantId_SHORTEST_LT?: number | null;
  creatorTenantId_SHORTEST_LTE?: number | null;
  formattedTags_AVERAGE_EQUAL?: number | null;
  formattedTags_AVERAGE_GT?: number | null;
  formattedTags_AVERAGE_GTE?: number | null;
  formattedTags_AVERAGE_LT?: number | null;
  formattedTags_AVERAGE_LTE?: number | null;
  formattedTags_EQUAL?: string | null;
  formattedTags_GT?: number | null;
  formattedTags_GTE?: number | null;
  formattedTags_LONGEST_EQUAL?: number | null;
  formattedTags_LONGEST_GT?: number | null;
  formattedTags_LONGEST_GTE?: number | null;
  formattedTags_LONGEST_LT?: number | null;
  formattedTags_LONGEST_LTE?: number | null;
  formattedTags_LT?: number | null;
  formattedTags_LTE?: number | null;
  formattedTags_SHORTEST_EQUAL?: number | null;
  formattedTags_SHORTEST_GT?: number | null;
  formattedTags_SHORTEST_GTE?: number | null;
  formattedTags_SHORTEST_LT?: number | null;
  formattedTags_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  invoiceAmount_AVERAGE_EQUAL?: number | null;
  invoiceAmount_AVERAGE_GT?: number | null;
  invoiceAmount_AVERAGE_GTE?: number | null;
  invoiceAmount_AVERAGE_LT?: number | null;
  invoiceAmount_AVERAGE_LTE?: number | null;
  invoiceAmount_EQUAL?: number | null;
  invoiceAmount_GT?: number | null;
  invoiceAmount_GTE?: number | null;
  invoiceAmount_LT?: number | null;
  invoiceAmount_LTE?: number | null;
  invoiceAmount_MAX_EQUAL?: number | null;
  invoiceAmount_MAX_GT?: number | null;
  invoiceAmount_MAX_GTE?: number | null;
  invoiceAmount_MAX_LT?: number | null;
  invoiceAmount_MAX_LTE?: number | null;
  invoiceAmount_MIN_EQUAL?: number | null;
  invoiceAmount_MIN_GT?: number | null;
  invoiceAmount_MIN_GTE?: number | null;
  invoiceAmount_MIN_LT?: number | null;
  invoiceAmount_MIN_LTE?: number | null;
  invoiceAmount_SUM_EQUAL?: number | null;
  invoiceAmount_SUM_GT?: number | null;
  invoiceAmount_SUM_GTE?: number | null;
  invoiceAmount_SUM_LT?: number | null;
  invoiceAmount_SUM_LTE?: number | null;
  issuedOn_EQUAL?: any | null;
  issuedOn_GT?: any | null;
  issuedOn_GTE?: any | null;
  issuedOn_LT?: any | null;
  issuedOn_LTE?: any | null;
  issuedOn_MAX_EQUAL?: any | null;
  issuedOn_MAX_GT?: any | null;
  issuedOn_MAX_GTE?: any | null;
  issuedOn_MAX_LT?: any | null;
  issuedOn_MAX_LTE?: any | null;
  issuedOn_MIN_EQUAL?: any | null;
  issuedOn_MIN_GT?: any | null;
  issuedOn_MIN_GTE?: any | null;
  issuedOn_MIN_LT?: any | null;
  issuedOn_MIN_LTE?: any | null;
  lastChangedOn_EQUAL?: any | null;
  lastChangedOn_GT?: any | null;
  lastChangedOn_GTE?: any | null;
  lastChangedOn_LT?: any | null;
  lastChangedOn_LTE?: any | null;
  lastChangedOn_MAX_EQUAL?: any | null;
  lastChangedOn_MAX_GT?: any | null;
  lastChangedOn_MAX_GTE?: any | null;
  lastChangedOn_MAX_LT?: any | null;
  lastChangedOn_MAX_LTE?: any | null;
  lastChangedOn_MIN_EQUAL?: any | null;
  lastChangedOn_MIN_GT?: any | null;
  lastChangedOn_MIN_GTE?: any | null;
  lastChangedOn_MIN_LT?: any | null;
  lastChangedOn_MIN_LTE?: any | null;
  lastRemindedOn_EQUAL?: any | null;
  lastRemindedOn_GT?: any | null;
  lastRemindedOn_GTE?: any | null;
  lastRemindedOn_LT?: any | null;
  lastRemindedOn_LTE?: any | null;
  lastRemindedOn_MAX_EQUAL?: any | null;
  lastRemindedOn_MAX_GT?: any | null;
  lastRemindedOn_MAX_GTE?: any | null;
  lastRemindedOn_MAX_LT?: any | null;
  lastRemindedOn_MAX_LTE?: any | null;
  lastRemindedOn_MIN_EQUAL?: any | null;
  lastRemindedOn_MIN_GT?: any | null;
  lastRemindedOn_MIN_GTE?: any | null;
  lastRemindedOn_MIN_LT?: any | null;
  lastRemindedOn_MIN_LTE?: any | null;
  lastUpdatedOn_EQUAL?: any | null;
  lastUpdatedOn_GT?: any | null;
  lastUpdatedOn_GTE?: any | null;
  lastUpdatedOn_LT?: any | null;
  lastUpdatedOn_LTE?: any | null;
  lastUpdatedOn_MAX_EQUAL?: any | null;
  lastUpdatedOn_MAX_GT?: any | null;
  lastUpdatedOn_MAX_GTE?: any | null;
  lastUpdatedOn_MAX_LT?: any | null;
  lastUpdatedOn_MAX_LTE?: any | null;
  lastUpdatedOn_MIN_EQUAL?: any | null;
  lastUpdatedOn_MIN_GT?: any | null;
  lastUpdatedOn_MIN_GTE?: any | null;
  lastUpdatedOn_MIN_LT?: any | null;
  lastUpdatedOn_MIN_LTE?: any | null;
  product_AVERAGE_EQUAL?: number | null;
  product_AVERAGE_GT?: number | null;
  product_AVERAGE_GTE?: number | null;
  product_AVERAGE_LT?: number | null;
  product_AVERAGE_LTE?: number | null;
  product_EQUAL?: string | null;
  product_GT?: number | null;
  product_GTE?: number | null;
  product_LONGEST_EQUAL?: number | null;
  product_LONGEST_GT?: number | null;
  product_LONGEST_GTE?: number | null;
  product_LONGEST_LT?: number | null;
  product_LONGEST_LTE?: number | null;
  product_LT?: number | null;
  product_LTE?: number | null;
  product_SHORTEST_EQUAL?: number | null;
  product_SHORTEST_GT?: number | null;
  product_SHORTEST_GTE?: number | null;
  product_SHORTEST_LT?: number | null;
  product_SHORTEST_LTE?: number | null;
  unlimited_AVERAGE_EQUAL?: number | null;
  unlimited_AVERAGE_GT?: number | null;
  unlimited_AVERAGE_GTE?: number | null;
  unlimited_AVERAGE_LT?: number | null;
  unlimited_AVERAGE_LTE?: number | null;
  unlimited_EQUAL?: number | null;
  unlimited_GT?: number | null;
  unlimited_GTE?: number | null;
  unlimited_LT?: number | null;
  unlimited_LTE?: number | null;
  unlimited_MAX_EQUAL?: number | null;
  unlimited_MAX_GT?: number | null;
  unlimited_MAX_GTE?: number | null;
  unlimited_MAX_LT?: number | null;
  unlimited_MAX_LTE?: number | null;
  unlimited_MIN_EQUAL?: number | null;
  unlimited_MIN_GT?: number | null;
  unlimited_MIN_GTE?: number | null;
  unlimited_MIN_LT?: number | null;
  unlimited_MIN_LTE?: number | null;
  unlimited_SUM_EQUAL?: number | null;
  unlimited_SUM_GT?: number | null;
  unlimited_SUM_GTE?: number | null;
  unlimited_SUM_LT?: number | null;
  unlimited_SUM_LTE?: number | null;
}

export interface RefundCaseMessageAggregateInput {
  AND?: RefundCaseMessageAggregateInput[] | null;
  OR?: RefundCaseMessageAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: RefundCaseMessageNodeAggregationWhereInput | null;
}

export interface RefundCaseMessageConnectionWhere {
  AND?: RefundCaseMessageConnectionWhere[] | null;
  OR?: RefundCaseMessageConnectionWhere[] | null;
  node?: MessageWhere | null;
  node_NOT?: MessageWhere | null;
}

export interface RefundCaseMessageNodeAggregationWhereInput {
  AND?: RefundCaseMessageNodeAggregationWhereInput[] | null;
  OR?: RefundCaseMessageNodeAggregationWhereInput[] | null;
  content_AVERAGE_EQUAL?: number | null;
  content_AVERAGE_GT?: number | null;
  content_AVERAGE_GTE?: number | null;
  content_AVERAGE_LT?: number | null;
  content_AVERAGE_LTE?: number | null;
  content_EQUAL?: string | null;
  content_GT?: number | null;
  content_GTE?: number | null;
  content_LONGEST_EQUAL?: number | null;
  content_LONGEST_GT?: number | null;
  content_LONGEST_GTE?: number | null;
  content_LONGEST_LT?: number | null;
  content_LONGEST_LTE?: number | null;
  content_LT?: number | null;
  content_LTE?: number | null;
  content_SHORTEST_EQUAL?: number | null;
  content_SHORTEST_GT?: number | null;
  content_SHORTEST_GTE?: number | null;
  content_SHORTEST_LT?: number | null;
  content_SHORTEST_LTE?: number | null;
  createdOn_AVERAGE_EQUAL?: number | null;
  createdOn_AVERAGE_GT?: number | null;
  createdOn_AVERAGE_GTE?: number | null;
  createdOn_AVERAGE_LT?: number | null;
  createdOn_AVERAGE_LTE?: number | null;
  createdOn_EQUAL?: number | null;
  createdOn_GT?: number | null;
  createdOn_GTE?: number | null;
  createdOn_LT?: number | null;
  createdOn_LTE?: number | null;
  createdOn_MAX_EQUAL?: number | null;
  createdOn_MAX_GT?: number | null;
  createdOn_MAX_GTE?: number | null;
  createdOn_MAX_LT?: number | null;
  createdOn_MAX_LTE?: number | null;
  createdOn_MIN_EQUAL?: number | null;
  createdOn_MIN_GT?: number | null;
  createdOn_MIN_GTE?: number | null;
  createdOn_MIN_LT?: number | null;
  createdOn_MIN_LTE?: number | null;
  createdOn_SUM_EQUAL?: number | null;
  createdOn_SUM_GT?: number | null;
  createdOn_SUM_GTE?: number | null;
  createdOn_SUM_LT?: number | null;
  createdOn_SUM_LTE?: number | null;
}

export interface RefundCaseNodeAggregationWhereInput {
  AND?: RefundCaseNodeAggregationWhereInput[] | null;
  OR?: RefundCaseNodeAggregationWhereInput[] | null;
  actualAgreementId_AVERAGE_EQUAL?: number | null;
  actualAgreementId_AVERAGE_GT?: number | null;
  actualAgreementId_AVERAGE_GTE?: number | null;
  actualAgreementId_AVERAGE_LT?: number | null;
  actualAgreementId_AVERAGE_LTE?: number | null;
  actualAgreementId_EQUAL?: string | null;
  actualAgreementId_GT?: number | null;
  actualAgreementId_GTE?: number | null;
  actualAgreementId_LONGEST_EQUAL?: number | null;
  actualAgreementId_LONGEST_GT?: number | null;
  actualAgreementId_LONGEST_GTE?: number | null;
  actualAgreementId_LONGEST_LT?: number | null;
  actualAgreementId_LONGEST_LTE?: number | null;
  actualAgreementId_LT?: number | null;
  actualAgreementId_LTE?: number | null;
  actualAgreementId_SHORTEST_EQUAL?: number | null;
  actualAgreementId_SHORTEST_GT?: number | null;
  actualAgreementId_SHORTEST_GTE?: number | null;
  actualAgreementId_SHORTEST_LT?: number | null;
  actualAgreementId_SHORTEST_LTE?: number | null;
  agreementName_AVERAGE_EQUAL?: number | null;
  agreementName_AVERAGE_GT?: number | null;
  agreementName_AVERAGE_GTE?: number | null;
  agreementName_AVERAGE_LT?: number | null;
  agreementName_AVERAGE_LTE?: number | null;
  agreementName_EQUAL?: string | null;
  agreementName_GT?: number | null;
  agreementName_GTE?: number | null;
  agreementName_LONGEST_EQUAL?: number | null;
  agreementName_LONGEST_GT?: number | null;
  agreementName_LONGEST_GTE?: number | null;
  agreementName_LONGEST_LT?: number | null;
  agreementName_LONGEST_LTE?: number | null;
  agreementName_LT?: number | null;
  agreementName_LTE?: number | null;
  agreementName_SHORTEST_EQUAL?: number | null;
  agreementName_SHORTEST_GT?: number | null;
  agreementName_SHORTEST_GTE?: number | null;
  agreementName_SHORTEST_LT?: number | null;
  agreementName_SHORTEST_LTE?: number | null;
  counterpartyInReview_AVERAGE_EQUAL?: number | null;
  counterpartyInReview_AVERAGE_GT?: number | null;
  counterpartyInReview_AVERAGE_GTE?: number | null;
  counterpartyInReview_AVERAGE_LT?: number | null;
  counterpartyInReview_AVERAGE_LTE?: number | null;
  counterpartyInReview_EQUAL?: string | null;
  counterpartyInReview_GT?: number | null;
  counterpartyInReview_GTE?: number | null;
  counterpartyInReview_LONGEST_EQUAL?: number | null;
  counterpartyInReview_LONGEST_GT?: number | null;
  counterpartyInReview_LONGEST_GTE?: number | null;
  counterpartyInReview_LONGEST_LT?: number | null;
  counterpartyInReview_LONGEST_LTE?: number | null;
  counterpartyInReview_LT?: number | null;
  counterpartyInReview_LTE?: number | null;
  counterpartyInReview_SHORTEST_EQUAL?: number | null;
  counterpartyInReview_SHORTEST_GT?: number | null;
  counterpartyInReview_SHORTEST_GTE?: number | null;
  counterpartyInReview_SHORTEST_LT?: number | null;
  counterpartyInReview_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  lastStatusChangeDate_EQUAL?: any | null;
  lastStatusChangeDate_GT?: any | null;
  lastStatusChangeDate_GTE?: any | null;
  lastStatusChangeDate_LT?: any | null;
  lastStatusChangeDate_LTE?: any | null;
  lastStatusChangeDate_MAX_EQUAL?: any | null;
  lastStatusChangeDate_MAX_GT?: any | null;
  lastStatusChangeDate_MAX_GTE?: any | null;
  lastStatusChangeDate_MAX_LT?: any | null;
  lastStatusChangeDate_MAX_LTE?: any | null;
  lastStatusChangeDate_MIN_EQUAL?: any | null;
  lastStatusChangeDate_MIN_GT?: any | null;
  lastStatusChangeDate_MIN_GTE?: any | null;
  lastStatusChangeDate_MIN_LT?: any | null;
  lastStatusChangeDate_MIN_LTE?: any | null;
  patientInitials_AVERAGE_EQUAL?: number | null;
  patientInitials_AVERAGE_GT?: number | null;
  patientInitials_AVERAGE_GTE?: number | null;
  patientInitials_AVERAGE_LT?: number | null;
  patientInitials_AVERAGE_LTE?: number | null;
  patientInitials_EQUAL?: string | null;
  patientInitials_GT?: number | null;
  patientInitials_GTE?: number | null;
  patientInitials_LONGEST_EQUAL?: number | null;
  patientInitials_LONGEST_GT?: number | null;
  patientInitials_LONGEST_GTE?: number | null;
  patientInitials_LONGEST_LT?: number | null;
  patientInitials_LONGEST_LTE?: number | null;
  patientInitials_LT?: number | null;
  patientInitials_LTE?: number | null;
  patientInitials_SHORTEST_EQUAL?: number | null;
  patientInitials_SHORTEST_GT?: number | null;
  patientInitials_SHORTEST_GTE?: number | null;
  patientInitials_SHORTEST_LT?: number | null;
  patientInitials_SHORTEST_LTE?: number | null;
  patientInsuranceId_AVERAGE_EQUAL?: number | null;
  patientInsuranceId_AVERAGE_GT?: number | null;
  patientInsuranceId_AVERAGE_GTE?: number | null;
  patientInsuranceId_AVERAGE_LT?: number | null;
  patientInsuranceId_AVERAGE_LTE?: number | null;
  patientInsuranceId_EQUAL?: string | null;
  patientInsuranceId_GT?: number | null;
  patientInsuranceId_GTE?: number | null;
  patientInsuranceId_LONGEST_EQUAL?: number | null;
  patientInsuranceId_LONGEST_GT?: number | null;
  patientInsuranceId_LONGEST_GTE?: number | null;
  patientInsuranceId_LONGEST_LT?: number | null;
  patientInsuranceId_LONGEST_LTE?: number | null;
  patientInsuranceId_LT?: number | null;
  patientInsuranceId_LTE?: number | null;
  patientInsuranceId_SHORTEST_EQUAL?: number | null;
  patientInsuranceId_SHORTEST_GT?: number | null;
  patientInsuranceId_SHORTEST_GTE?: number | null;
  patientInsuranceId_SHORTEST_LT?: number | null;
  patientInsuranceId_SHORTEST_LTE?: number | null;
  preparationBrandName_AVERAGE_EQUAL?: number | null;
  preparationBrandName_AVERAGE_GT?: number | null;
  preparationBrandName_AVERAGE_GTE?: number | null;
  preparationBrandName_AVERAGE_LT?: number | null;
  preparationBrandName_AVERAGE_LTE?: number | null;
  preparationBrandName_EQUAL?: string | null;
  preparationBrandName_GT?: number | null;
  preparationBrandName_GTE?: number | null;
  preparationBrandName_LONGEST_EQUAL?: number | null;
  preparationBrandName_LONGEST_GT?: number | null;
  preparationBrandName_LONGEST_GTE?: number | null;
  preparationBrandName_LONGEST_LT?: number | null;
  preparationBrandName_LONGEST_LTE?: number | null;
  preparationBrandName_LT?: number | null;
  preparationBrandName_LTE?: number | null;
  preparationBrandName_SHORTEST_EQUAL?: number | null;
  preparationBrandName_SHORTEST_GT?: number | null;
  preparationBrandName_SHORTEST_GTE?: number | null;
  preparationBrandName_SHORTEST_LT?: number | null;
  preparationBrandName_SHORTEST_LTE?: number | null;
  preparationGenericName_AVERAGE_EQUAL?: number | null;
  preparationGenericName_AVERAGE_GT?: number | null;
  preparationGenericName_AVERAGE_GTE?: number | null;
  preparationGenericName_AVERAGE_LT?: number | null;
  preparationGenericName_AVERAGE_LTE?: number | null;
  preparationGenericName_EQUAL?: string | null;
  preparationGenericName_GT?: number | null;
  preparationGenericName_GTE?: number | null;
  preparationGenericName_LONGEST_EQUAL?: number | null;
  preparationGenericName_LONGEST_GT?: number | null;
  preparationGenericName_LONGEST_GTE?: number | null;
  preparationGenericName_LONGEST_LT?: number | null;
  preparationGenericName_LONGEST_LTE?: number | null;
  preparationGenericName_LT?: number | null;
  preparationGenericName_LTE?: number | null;
  preparationGenericName_SHORTEST_EQUAL?: number | null;
  preparationGenericName_SHORTEST_GT?: number | null;
  preparationGenericName_SHORTEST_GTE?: number | null;
  preparationGenericName_SHORTEST_LT?: number | null;
  preparationGenericName_SHORTEST_LTE?: number | null;
  sourceTenantId_AVERAGE_EQUAL?: number | null;
  sourceTenantId_AVERAGE_GT?: number | null;
  sourceTenantId_AVERAGE_GTE?: number | null;
  sourceTenantId_AVERAGE_LT?: number | null;
  sourceTenantId_AVERAGE_LTE?: number | null;
  sourceTenantId_EQUAL?: string | null;
  sourceTenantId_GT?: number | null;
  sourceTenantId_GTE?: number | null;
  sourceTenantId_LONGEST_EQUAL?: number | null;
  sourceTenantId_LONGEST_GT?: number | null;
  sourceTenantId_LONGEST_GTE?: number | null;
  sourceTenantId_LONGEST_LT?: number | null;
  sourceTenantId_LONGEST_LTE?: number | null;
  sourceTenantId_LT?: number | null;
  sourceTenantId_LTE?: number | null;
  sourceTenantId_SHORTEST_EQUAL?: number | null;
  sourceTenantId_SHORTEST_GT?: number | null;
  sourceTenantId_SHORTEST_GTE?: number | null;
  sourceTenantId_SHORTEST_LT?: number | null;
  sourceTenantId_SHORTEST_LTE?: number | null;
  submissionDate_EQUAL?: any | null;
  submissionDate_GT?: any | null;
  submissionDate_GTE?: any | null;
  submissionDate_LT?: any | null;
  submissionDate_LTE?: any | null;
  submissionDate_MAX_EQUAL?: any | null;
  submissionDate_MAX_GT?: any | null;
  submissionDate_MAX_GTE?: any | null;
  submissionDate_MAX_LT?: any | null;
  submissionDate_MAX_LTE?: any | null;
  submissionDate_MIN_EQUAL?: any | null;
  submissionDate_MIN_GT?: any | null;
  submissionDate_MIN_GTE?: any | null;
  submissionDate_MIN_LT?: any | null;
  submissionDate_MIN_LTE?: any | null;
  suspensionReason_AVERAGE_EQUAL?: number | null;
  suspensionReason_AVERAGE_GT?: number | null;
  suspensionReason_AVERAGE_GTE?: number | null;
  suspensionReason_AVERAGE_LT?: number | null;
  suspensionReason_AVERAGE_LTE?: number | null;
  suspensionReason_EQUAL?: string | null;
  suspensionReason_GT?: number | null;
  suspensionReason_GTE?: number | null;
  suspensionReason_LONGEST_EQUAL?: number | null;
  suspensionReason_LONGEST_GT?: number | null;
  suspensionReason_LONGEST_GTE?: number | null;
  suspensionReason_LONGEST_LT?: number | null;
  suspensionReason_LONGEST_LTE?: number | null;
  suspensionReason_LT?: number | null;
  suspensionReason_LTE?: number | null;
  suspensionReason_SHORTEST_EQUAL?: number | null;
  suspensionReason_SHORTEST_GT?: number | null;
  suspensionReason_SHORTEST_GTE?: number | null;
  suspensionReason_SHORTEST_LT?: number | null;
  suspensionReason_SHORTEST_LTE?: number | null;
  totalAmount_AVERAGE_EQUAL?: number | null;
  totalAmount_AVERAGE_GT?: number | null;
  totalAmount_AVERAGE_GTE?: number | null;
  totalAmount_AVERAGE_LT?: number | null;
  totalAmount_AVERAGE_LTE?: number | null;
  totalAmount_EQUAL?: number | null;
  totalAmount_GT?: number | null;
  totalAmount_GTE?: number | null;
  totalAmount_LT?: number | null;
  totalAmount_LTE?: number | null;
  totalAmount_MAX_EQUAL?: number | null;
  totalAmount_MAX_GT?: number | null;
  totalAmount_MAX_GTE?: number | null;
  totalAmount_MAX_LT?: number | null;
  totalAmount_MAX_LTE?: number | null;
  totalAmount_MIN_EQUAL?: number | null;
  totalAmount_MIN_GT?: number | null;
  totalAmount_MIN_GTE?: number | null;
  totalAmount_MIN_LT?: number | null;
  totalAmount_MIN_LTE?: number | null;
  totalAmount_SUM_EQUAL?: number | null;
  totalAmount_SUM_GT?: number | null;
  totalAmount_SUM_GTE?: number | null;
  totalAmount_SUM_LT?: number | null;
  totalAmount_SUM_LTE?: number | null;
  unlimited_AVERAGE_EQUAL?: number | null;
  unlimited_AVERAGE_GT?: number | null;
  unlimited_AVERAGE_GTE?: number | null;
  unlimited_AVERAGE_LT?: number | null;
  unlimited_AVERAGE_LTE?: number | null;
  unlimited_EQUAL?: number | null;
  unlimited_GT?: number | null;
  unlimited_GTE?: number | null;
  unlimited_LT?: number | null;
  unlimited_LTE?: number | null;
  unlimited_MAX_EQUAL?: number | null;
  unlimited_MAX_GT?: number | null;
  unlimited_MAX_GTE?: number | null;
  unlimited_MAX_LT?: number | null;
  unlimited_MAX_LTE?: number | null;
  unlimited_MIN_EQUAL?: number | null;
  unlimited_MIN_GT?: number | null;
  unlimited_MIN_GTE?: number | null;
  unlimited_MIN_LT?: number | null;
  unlimited_MIN_LTE?: number | null;
  unlimited_SUM_EQUAL?: number | null;
  unlimited_SUM_GT?: number | null;
  unlimited_SUM_GTE?: number | null;
  unlimited_SUM_LT?: number | null;
  unlimited_SUM_LTE?: number | null;
}

export interface RefundCaseRefundsAggregateInput {
  AND?: RefundCaseRefundsAggregateInput[] | null;
  OR?: RefundCaseRefundsAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: RefundCaseRefundsNodeAggregationWhereInput | null;
}

export interface RefundCaseRefundsConnectionWhere {
  AND?: RefundCaseRefundsConnectionWhere[] | null;
  OR?: RefundCaseRefundsConnectionWhere[] | null;
  node?: RefundWhere | null;
  node_NOT?: RefundWhere | null;
}

export interface RefundCaseRefundsNodeAggregationWhereInput {
  AND?: RefundCaseRefundsNodeAggregationWhereInput[] | null;
  OR?: RefundCaseRefundsNodeAggregationWhereInput[] | null;
  agreementName_AVERAGE_EQUAL?: number | null;
  agreementName_AVERAGE_GT?: number | null;
  agreementName_AVERAGE_GTE?: number | null;
  agreementName_AVERAGE_LT?: number | null;
  agreementName_AVERAGE_LTE?: number | null;
  agreementName_EQUAL?: string | null;
  agreementName_GT?: number | null;
  agreementName_GTE?: number | null;
  agreementName_LONGEST_EQUAL?: number | null;
  agreementName_LONGEST_GT?: number | null;
  agreementName_LONGEST_GTE?: number | null;
  agreementName_LONGEST_LT?: number | null;
  agreementName_LONGEST_LTE?: number | null;
  agreementName_LT?: number | null;
  agreementName_LTE?: number | null;
  agreementName_SHORTEST_EQUAL?: number | null;
  agreementName_SHORTEST_GT?: number | null;
  agreementName_SHORTEST_GTE?: number | null;
  agreementName_SHORTEST_LT?: number | null;
  agreementName_SHORTEST_LTE?: number | null;
  amount_AVERAGE_EQUAL?: number | null;
  amount_AVERAGE_GT?: number | null;
  amount_AVERAGE_GTE?: number | null;
  amount_AVERAGE_LT?: number | null;
  amount_AVERAGE_LTE?: number | null;
  amount_EQUAL?: number | null;
  amount_GT?: number | null;
  amount_GTE?: number | null;
  amount_LT?: number | null;
  amount_LTE?: number | null;
  amount_MAX_EQUAL?: number | null;
  amount_MAX_GT?: number | null;
  amount_MAX_GTE?: number | null;
  amount_MAX_LT?: number | null;
  amount_MAX_LTE?: number | null;
  amount_MIN_EQUAL?: number | null;
  amount_MIN_GT?: number | null;
  amount_MIN_GTE?: number | null;
  amount_MIN_LT?: number | null;
  amount_MIN_LTE?: number | null;
  amount_SUM_EQUAL?: number | null;
  amount_SUM_GT?: number | null;
  amount_SUM_GTE?: number | null;
  amount_SUM_LT?: number | null;
  amount_SUM_LTE?: number | null;
  caseId_AVERAGE_EQUAL?: number | null;
  caseId_AVERAGE_GT?: number | null;
  caseId_AVERAGE_GTE?: number | null;
  caseId_AVERAGE_LT?: number | null;
  caseId_AVERAGE_LTE?: number | null;
  caseId_EQUAL?: string | null;
  caseId_GT?: number | null;
  caseId_GTE?: number | null;
  caseId_LONGEST_EQUAL?: number | null;
  caseId_LONGEST_GT?: number | null;
  caseId_LONGEST_GTE?: number | null;
  caseId_LONGEST_LT?: number | null;
  caseId_LONGEST_LTE?: number | null;
  caseId_LT?: number | null;
  caseId_LTE?: number | null;
  caseId_SHORTEST_EQUAL?: number | null;
  caseId_SHORTEST_GT?: number | null;
  caseId_SHORTEST_GTE?: number | null;
  caseId_SHORTEST_LT?: number | null;
  caseId_SHORTEST_LTE?: number | null;
  counterParties_AVERAGE_EQUAL?: number | null;
  counterParties_AVERAGE_GT?: number | null;
  counterParties_AVERAGE_GTE?: number | null;
  counterParties_AVERAGE_LT?: number | null;
  counterParties_AVERAGE_LTE?: number | null;
  counterParties_EQUAL?: string | null;
  counterParties_GT?: number | null;
  counterParties_GTE?: number | null;
  counterParties_LONGEST_EQUAL?: number | null;
  counterParties_LONGEST_GT?: number | null;
  counterParties_LONGEST_GTE?: number | null;
  counterParties_LONGEST_LT?: number | null;
  counterParties_LONGEST_LTE?: number | null;
  counterParties_LT?: number | null;
  counterParties_LTE?: number | null;
  counterParties_SHORTEST_EQUAL?: number | null;
  counterParties_SHORTEST_GT?: number | null;
  counterParties_SHORTEST_GTE?: number | null;
  counterParties_SHORTEST_LT?: number | null;
  counterParties_SHORTEST_LTE?: number | null;
  currency_AVERAGE_EQUAL?: number | null;
  currency_AVERAGE_GT?: number | null;
  currency_AVERAGE_GTE?: number | null;
  currency_AVERAGE_LT?: number | null;
  currency_AVERAGE_LTE?: number | null;
  currency_EQUAL?: string | null;
  currency_GT?: number | null;
  currency_GTE?: number | null;
  currency_LONGEST_EQUAL?: number | null;
  currency_LONGEST_GT?: number | null;
  currency_LONGEST_GTE?: number | null;
  currency_LONGEST_LT?: number | null;
  currency_LONGEST_LTE?: number | null;
  currency_LT?: number | null;
  currency_LTE?: number | null;
  currency_SHORTEST_EQUAL?: number | null;
  currency_SHORTEST_GT?: number | null;
  currency_SHORTEST_GTE?: number | null;
  currency_SHORTEST_LT?: number | null;
  currency_SHORTEST_LTE?: number | null;
  formattedTags_AVERAGE_EQUAL?: number | null;
  formattedTags_AVERAGE_GT?: number | null;
  formattedTags_AVERAGE_GTE?: number | null;
  formattedTags_AVERAGE_LT?: number | null;
  formattedTags_AVERAGE_LTE?: number | null;
  formattedTags_EQUAL?: string | null;
  formattedTags_GT?: number | null;
  formattedTags_GTE?: number | null;
  formattedTags_LONGEST_EQUAL?: number | null;
  formattedTags_LONGEST_GT?: number | null;
  formattedTags_LONGEST_GTE?: number | null;
  formattedTags_LONGEST_LT?: number | null;
  formattedTags_LONGEST_LTE?: number | null;
  formattedTags_LT?: number | null;
  formattedTags_LTE?: number | null;
  formattedTags_SHORTEST_EQUAL?: number | null;
  formattedTags_SHORTEST_GT?: number | null;
  formattedTags_SHORTEST_GTE?: number | null;
  formattedTags_SHORTEST_LT?: number | null;
  formattedTags_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  iin_AVERAGE_EQUAL?: number | null;
  iin_AVERAGE_GT?: number | null;
  iin_AVERAGE_GTE?: number | null;
  iin_AVERAGE_LT?: number | null;
  iin_AVERAGE_LTE?: number | null;
  iin_EQUAL?: string | null;
  iin_GT?: number | null;
  iin_GTE?: number | null;
  iin_LONGEST_EQUAL?: number | null;
  iin_LONGEST_GT?: number | null;
  iin_LONGEST_GTE?: number | null;
  iin_LONGEST_LT?: number | null;
  iin_LONGEST_LTE?: number | null;
  iin_LT?: number | null;
  iin_LTE?: number | null;
  iin_SHORTEST_EQUAL?: number | null;
  iin_SHORTEST_GT?: number | null;
  iin_SHORTEST_GTE?: number | null;
  iin_SHORTEST_LT?: number | null;
  iin_SHORTEST_LTE?: number | null;
  product_AVERAGE_EQUAL?: number | null;
  product_AVERAGE_GT?: number | null;
  product_AVERAGE_GTE?: number | null;
  product_AVERAGE_LT?: number | null;
  product_AVERAGE_LTE?: number | null;
  product_EQUAL?: string | null;
  product_GT?: number | null;
  product_GTE?: number | null;
  product_LONGEST_EQUAL?: number | null;
  product_LONGEST_GT?: number | null;
  product_LONGEST_GTE?: number | null;
  product_LONGEST_LT?: number | null;
  product_LONGEST_LTE?: number | null;
  product_LT?: number | null;
  product_LTE?: number | null;
  product_SHORTEST_EQUAL?: number | null;
  product_SHORTEST_GT?: number | null;
  product_SHORTEST_GTE?: number | null;
  product_SHORTEST_LT?: number | null;
  product_SHORTEST_LTE?: number | null;
  refundRate_AVERAGE_EQUAL?: number | null;
  refundRate_AVERAGE_GT?: number | null;
  refundRate_AVERAGE_GTE?: number | null;
  refundRate_AVERAGE_LT?: number | null;
  refundRate_AVERAGE_LTE?: number | null;
  refundRate_EQUAL?: number | null;
  refundRate_GT?: number | null;
  refundRate_GTE?: number | null;
  refundRate_LT?: number | null;
  refundRate_LTE?: number | null;
  refundRate_MAX_EQUAL?: number | null;
  refundRate_MAX_GT?: number | null;
  refundRate_MAX_GTE?: number | null;
  refundRate_MAX_LT?: number | null;
  refundRate_MAX_LTE?: number | null;
  refundRate_MIN_EQUAL?: number | null;
  refundRate_MIN_GT?: number | null;
  refundRate_MIN_GTE?: number | null;
  refundRate_MIN_LT?: number | null;
  refundRate_MIN_LTE?: number | null;
  refundRate_SUM_EQUAL?: number | null;
  refundRate_SUM_GT?: number | null;
  refundRate_SUM_GTE?: number | null;
  refundRate_SUM_LT?: number | null;
  refundRate_SUM_LTE?: number | null;
  revokedOn_EQUAL?: any | null;
  revokedOn_GT?: any | null;
  revokedOn_GTE?: any | null;
  revokedOn_LT?: any | null;
  revokedOn_LTE?: any | null;
  revokedOn_MAX_EQUAL?: any | null;
  revokedOn_MAX_GT?: any | null;
  revokedOn_MAX_GTE?: any | null;
  revokedOn_MAX_LT?: any | null;
  revokedOn_MAX_LTE?: any | null;
  revokedOn_MIN_EQUAL?: any | null;
  revokedOn_MIN_GT?: any | null;
  revokedOn_MIN_GTE?: any | null;
  revokedOn_MIN_LT?: any | null;
  revokedOn_MIN_LTE?: any | null;
  unlimited_AVERAGE_EQUAL?: number | null;
  unlimited_AVERAGE_GT?: number | null;
  unlimited_AVERAGE_GTE?: number | null;
  unlimited_AVERAGE_LT?: number | null;
  unlimited_AVERAGE_LTE?: number | null;
  unlimited_EQUAL?: number | null;
  unlimited_GT?: number | null;
  unlimited_GTE?: number | null;
  unlimited_LT?: number | null;
  unlimited_LTE?: number | null;
  unlimited_MAX_EQUAL?: number | null;
  unlimited_MAX_GT?: number | null;
  unlimited_MAX_GTE?: number | null;
  unlimited_MAX_LT?: number | null;
  unlimited_MAX_LTE?: number | null;
  unlimited_MIN_EQUAL?: number | null;
  unlimited_MIN_GT?: number | null;
  unlimited_MIN_GTE?: number | null;
  unlimited_MIN_LT?: number | null;
  unlimited_MIN_LTE?: number | null;
  unlimited_SUM_EQUAL?: number | null;
  unlimited_SUM_GT?: number | null;
  unlimited_SUM_GTE?: number | null;
  unlimited_SUM_LT?: number | null;
  unlimited_SUM_LTE?: number | null;
}

export interface RefundCaseWhere {
  AND?: RefundCaseWhere[] | null;
  OR?: RefundCaseWhere[] | null;
  case?: CaseWhere | null;
  caseAggregate?: RefundCaseCaseAggregateInput | null;
  caseConnection?: RefundCaseCaseConnectionWhere | null;
  caseConnection_NOT?: RefundCaseCaseConnectionWhere | null;
  case_NOT?: CaseWhere | null;
  document?: DocumentWhere | null;
  documentAggregate?: RefundCaseDocumentAggregateInput | null;
  documentConnection?: RefundCaseDocumentConnectionWhere | null;
  documentConnection_NOT?: RefundCaseDocumentConnectionWhere | null;
  document_NOT?: DocumentWhere | null;
  id?: string | null;
  id_CONTAINS?: string | null;
  id_ENDS_WITH?: string | null;
  id_IN?: (string | null)[] | null;
  id_MATCHES?: string | null;
  id_NOT?: string | null;
  id_NOT_CONTAINS?: string | null;
  id_NOT_ENDS_WITH?: string | null;
  id_NOT_IN?: (string | null)[] | null;
  id_NOT_STARTS_WITH?: string | null;
  id_STARTS_WITH?: string | null;
  message?: MessageWhere | null;
  messageAggregate?: RefundCaseMessageAggregateInput | null;
  messageConnection?: RefundCaseMessageConnectionWhere | null;
  messageConnection_NOT?: RefundCaseMessageConnectionWhere | null;
  message_NOT?: MessageWhere | null;
  refunds?: RefundWhere | null;
  refundsAggregate?: RefundCaseRefundsAggregateInput | null;
  refundsConnection?: RefundCaseRefundsConnectionWhere | null;
  refundsConnection_NOT?: RefundCaseRefundsConnectionWhere | null;
  refunds_NOT?: RefundWhere | null;
  tenantIds?: string[] | null;
  tenantIds_INCLUDES?: string | null;
  tenantIds_NOT?: string[] | null;
  tenantIds_NOT_INCLUDES?: string | null;
}

export interface RefundDocumentFinancialDataPointAggregateInput {
  AND?: RefundDocumentFinancialDataPointAggregateInput[] | null;
  OR?: RefundDocumentFinancialDataPointAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  edge?: RefundDocumentFinancialDataPointEdgeAggregationWhereInput | null;
  node?: RefundDocumentFinancialDataPointNodeAggregationWhereInput | null;
}

export interface RefundDocumentFinancialDataPointConnectionWhere {
  AND?: RefundDocumentFinancialDataPointConnectionWhere[] | null;
  OR?: RefundDocumentFinancialDataPointConnectionWhere[] | null;
  edge?: DocumentRefundFinancialDataPointWhere | null;
  edge_NOT?: DocumentRefundFinancialDataPointWhere | null;
  node?: FlexFinancialDataPointWhere | null;
  node_NOT?: FlexFinancialDataPointWhere | null;
}

export interface RefundDocumentFinancialDataPointEdgeAggregationWhereInput {
  AND?: RefundDocumentFinancialDataPointEdgeAggregationWhereInput[] | null;
  OR?: RefundDocumentFinancialDataPointEdgeAggregationWhereInput[] | null;
  connectionId_EQUAL?: string | null;
}

export interface RefundDocumentFinancialDataPointNodeAggregationWhereInput {
  AND?: RefundDocumentFinancialDataPointNodeAggregationWhereInput[] | null;
  OR?: RefundDocumentFinancialDataPointNodeAggregationWhereInput[] | null;
  basePrice_AVERAGE_EQUAL?: number | null;
  basePrice_AVERAGE_GT?: number | null;
  basePrice_AVERAGE_GTE?: number | null;
  basePrice_AVERAGE_LT?: number | null;
  basePrice_AVERAGE_LTE?: number | null;
  basePrice_EQUAL?: number | null;
  basePrice_GT?: number | null;
  basePrice_GTE?: number | null;
  basePrice_LT?: number | null;
  basePrice_LTE?: number | null;
  basePrice_MAX_EQUAL?: number | null;
  basePrice_MAX_GT?: number | null;
  basePrice_MAX_GTE?: number | null;
  basePrice_MAX_LT?: number | null;
  basePrice_MAX_LTE?: number | null;
  basePrice_MIN_EQUAL?: number | null;
  basePrice_MIN_GT?: number | null;
  basePrice_MIN_GTE?: number | null;
  basePrice_MIN_LT?: number | null;
  basePrice_MIN_LTE?: number | null;
  basePrice_SUM_EQUAL?: number | null;
  basePrice_SUM_GT?: number | null;
  basePrice_SUM_GTE?: number | null;
  basePrice_SUM_LT?: number | null;
  basePrice_SUM_LTE?: number | null;
  createdOn_EQUAL?: any | null;
  createdOn_GT?: any | null;
  createdOn_GTE?: any | null;
  createdOn_LT?: any | null;
  createdOn_LTE?: any | null;
  createdOn_MAX_EQUAL?: any | null;
  createdOn_MAX_GT?: any | null;
  createdOn_MAX_GTE?: any | null;
  createdOn_MAX_LT?: any | null;
  createdOn_MAX_LTE?: any | null;
  createdOn_MIN_EQUAL?: any | null;
  createdOn_MIN_GT?: any | null;
  createdOn_MIN_GTE?: any | null;
  createdOn_MIN_LT?: any | null;
  createdOn_MIN_LTE?: any | null;
  currencyCode_AVERAGE_EQUAL?: number | null;
  currencyCode_AVERAGE_GT?: number | null;
  currencyCode_AVERAGE_GTE?: number | null;
  currencyCode_AVERAGE_LT?: number | null;
  currencyCode_AVERAGE_LTE?: number | null;
  currencyCode_EQUAL?: string | null;
  currencyCode_GT?: number | null;
  currencyCode_GTE?: number | null;
  currencyCode_LONGEST_EQUAL?: number | null;
  currencyCode_LONGEST_GT?: number | null;
  currencyCode_LONGEST_GTE?: number | null;
  currencyCode_LONGEST_LT?: number | null;
  currencyCode_LONGEST_LTE?: number | null;
  currencyCode_LT?: number | null;
  currencyCode_LTE?: number | null;
  currencyCode_SHORTEST_EQUAL?: number | null;
  currencyCode_SHORTEST_GT?: number | null;
  currencyCode_SHORTEST_GTE?: number | null;
  currencyCode_SHORTEST_LT?: number | null;
  currencyCode_SHORTEST_LTE?: number | null;
  evaluationSnapshot_AVERAGE_EQUAL?: number | null;
  evaluationSnapshot_AVERAGE_GT?: number | null;
  evaluationSnapshot_AVERAGE_GTE?: number | null;
  evaluationSnapshot_AVERAGE_LT?: number | null;
  evaluationSnapshot_AVERAGE_LTE?: number | null;
  evaluationSnapshot_EQUAL?: string | null;
  evaluationSnapshot_GT?: number | null;
  evaluationSnapshot_GTE?: number | null;
  evaluationSnapshot_LONGEST_EQUAL?: number | null;
  evaluationSnapshot_LONGEST_GT?: number | null;
  evaluationSnapshot_LONGEST_GTE?: number | null;
  evaluationSnapshot_LONGEST_LT?: number | null;
  evaluationSnapshot_LONGEST_LTE?: number | null;
  evaluationSnapshot_LT?: number | null;
  evaluationSnapshot_LTE?: number | null;
  evaluationSnapshot_SHORTEST_EQUAL?: number | null;
  evaluationSnapshot_SHORTEST_GT?: number | null;
  evaluationSnapshot_SHORTEST_GTE?: number | null;
  evaluationSnapshot_SHORTEST_LT?: number | null;
  evaluationSnapshot_SHORTEST_LTE?: number | null;
  generatedUuid_EQUAL?: string | null;
  payablePercentage_AVERAGE_EQUAL?: number | null;
  payablePercentage_AVERAGE_GT?: number | null;
  payablePercentage_AVERAGE_GTE?: number | null;
  payablePercentage_AVERAGE_LT?: number | null;
  payablePercentage_AVERAGE_LTE?: number | null;
  payablePercentage_EQUAL?: number | null;
  payablePercentage_GT?: number | null;
  payablePercentage_GTE?: number | null;
  payablePercentage_LT?: number | null;
  payablePercentage_LTE?: number | null;
  payablePercentage_MAX_EQUAL?: number | null;
  payablePercentage_MAX_GT?: number | null;
  payablePercentage_MAX_GTE?: number | null;
  payablePercentage_MAX_LT?: number | null;
  payablePercentage_MAX_LTE?: number | null;
  payablePercentage_MIN_EQUAL?: number | null;
  payablePercentage_MIN_GT?: number | null;
  payablePercentage_MIN_GTE?: number | null;
  payablePercentage_MIN_LT?: number | null;
  payablePercentage_MIN_LTE?: number | null;
  payablePercentage_SUM_EQUAL?: number | null;
  payablePercentage_SUM_GT?: number | null;
  payablePercentage_SUM_GTE?: number | null;
  payablePercentage_SUM_LT?: number | null;
  payablePercentage_SUM_LTE?: number | null;
  payable_AVERAGE_EQUAL?: number | null;
  payable_AVERAGE_GT?: number | null;
  payable_AVERAGE_GTE?: number | null;
  payable_AVERAGE_LT?: number | null;
  payable_AVERAGE_LTE?: number | null;
  payable_EQUAL?: number | null;
  payable_GT?: number | null;
  payable_GTE?: number | null;
  payable_LT?: number | null;
  payable_LTE?: number | null;
  payable_MAX_EQUAL?: number | null;
  payable_MAX_GT?: number | null;
  payable_MAX_GTE?: number | null;
  payable_MAX_LT?: number | null;
  payable_MAX_LTE?: number | null;
  payable_MIN_EQUAL?: number | null;
  payable_MIN_GT?: number | null;
  payable_MIN_GTE?: number | null;
  payable_MIN_LT?: number | null;
  payable_MIN_LTE?: number | null;
  payable_SUM_EQUAL?: number | null;
  payable_SUM_GT?: number | null;
  payable_SUM_GTE?: number | null;
  payable_SUM_LT?: number | null;
  payable_SUM_LTE?: number | null;
  quantity_AVERAGE_EQUAL?: number | null;
  quantity_AVERAGE_GT?: number | null;
  quantity_AVERAGE_GTE?: number | null;
  quantity_AVERAGE_LT?: number | null;
  quantity_AVERAGE_LTE?: number | null;
  quantity_EQUAL?: number | null;
  quantity_GT?: number | null;
  quantity_GTE?: number | null;
  quantity_LT?: number | null;
  quantity_LTE?: number | null;
  quantity_MAX_EQUAL?: number | null;
  quantity_MAX_GT?: number | null;
  quantity_MAX_GTE?: number | null;
  quantity_MAX_LT?: number | null;
  quantity_MAX_LTE?: number | null;
  quantity_MIN_EQUAL?: number | null;
  quantity_MIN_GT?: number | null;
  quantity_MIN_GTE?: number | null;
  quantity_MIN_LT?: number | null;
  quantity_MIN_LTE?: number | null;
  quantity_SUM_EQUAL?: number | null;
  quantity_SUM_GT?: number | null;
  quantity_SUM_GTE?: number | null;
  quantity_SUM_LT?: number | null;
  quantity_SUM_LTE?: number | null;
  refundDeltaNumber_AVERAGE_EQUAL?: number | null;
  refundDeltaNumber_AVERAGE_GT?: number | null;
  refundDeltaNumber_AVERAGE_GTE?: number | null;
  refundDeltaNumber_AVERAGE_LT?: number | null;
  refundDeltaNumber_AVERAGE_LTE?: number | null;
  refundDeltaNumber_EQUAL?: number | null;
  refundDeltaNumber_GT?: number | null;
  refundDeltaNumber_GTE?: number | null;
  refundDeltaNumber_LT?: number | null;
  refundDeltaNumber_LTE?: number | null;
  refundDeltaNumber_MAX_EQUAL?: number | null;
  refundDeltaNumber_MAX_GT?: number | null;
  refundDeltaNumber_MAX_GTE?: number | null;
  refundDeltaNumber_MAX_LT?: number | null;
  refundDeltaNumber_MAX_LTE?: number | null;
  refundDeltaNumber_MIN_EQUAL?: number | null;
  refundDeltaNumber_MIN_GT?: number | null;
  refundDeltaNumber_MIN_GTE?: number | null;
  refundDeltaNumber_MIN_LT?: number | null;
  refundDeltaNumber_MIN_LTE?: number | null;
  refundDeltaNumber_SUM_EQUAL?: number | null;
  refundDeltaNumber_SUM_GT?: number | null;
  refundDeltaNumber_SUM_GTE?: number | null;
  refundDeltaNumber_SUM_LT?: number | null;
  refundDeltaNumber_SUM_LTE?: number | null;
  refundablePercentage_AVERAGE_EQUAL?: number | null;
  refundablePercentage_AVERAGE_GT?: number | null;
  refundablePercentage_AVERAGE_GTE?: number | null;
  refundablePercentage_AVERAGE_LT?: number | null;
  refundablePercentage_AVERAGE_LTE?: number | null;
  refundablePercentage_EQUAL?: number | null;
  refundablePercentage_GT?: number | null;
  refundablePercentage_GTE?: number | null;
  refundablePercentage_LT?: number | null;
  refundablePercentage_LTE?: number | null;
  refundablePercentage_MAX_EQUAL?: number | null;
  refundablePercentage_MAX_GT?: number | null;
  refundablePercentage_MAX_GTE?: number | null;
  refundablePercentage_MAX_LT?: number | null;
  refundablePercentage_MAX_LTE?: number | null;
  refundablePercentage_MIN_EQUAL?: number | null;
  refundablePercentage_MIN_GT?: number | null;
  refundablePercentage_MIN_GTE?: number | null;
  refundablePercentage_MIN_LT?: number | null;
  refundablePercentage_MIN_LTE?: number | null;
  refundablePercentage_SUM_EQUAL?: number | null;
  refundablePercentage_SUM_GT?: number | null;
  refundablePercentage_SUM_GTE?: number | null;
  refundablePercentage_SUM_LT?: number | null;
  refundablePercentage_SUM_LTE?: number | null;
  refundable_AVERAGE_EQUAL?: number | null;
  refundable_AVERAGE_GT?: number | null;
  refundable_AVERAGE_GTE?: number | null;
  refundable_AVERAGE_LT?: number | null;
  refundable_AVERAGE_LTE?: number | null;
  refundable_EQUAL?: number | null;
  refundable_GT?: number | null;
  refundable_GTE?: number | null;
  refundable_LT?: number | null;
  refundable_LTE?: number | null;
  refundable_MAX_EQUAL?: number | null;
  refundable_MAX_GT?: number | null;
  refundable_MAX_GTE?: number | null;
  refundable_MAX_LT?: number | null;
  refundable_MAX_LTE?: number | null;
  refundable_MIN_EQUAL?: number | null;
  refundable_MIN_GT?: number | null;
  refundable_MIN_GTE?: number | null;
  refundable_MIN_LT?: number | null;
  refundable_MIN_LTE?: number | null;
  refundable_SUM_EQUAL?: number | null;
  refundable_SUM_GT?: number | null;
  refundable_SUM_GTE?: number | null;
  refundable_SUM_LT?: number | null;
  refundable_SUM_LTE?: number | null;
  revokedOn_EQUAL?: any | null;
  revokedOn_GT?: any | null;
  revokedOn_GTE?: any | null;
  revokedOn_LT?: any | null;
  revokedOn_LTE?: any | null;
  revokedOn_MAX_EQUAL?: any | null;
  revokedOn_MAX_GT?: any | null;
  revokedOn_MAX_GTE?: any | null;
  revokedOn_MAX_LT?: any | null;
  revokedOn_MAX_LTE?: any | null;
  revokedOn_MIN_EQUAL?: any | null;
  revokedOn_MIN_GT?: any | null;
  revokedOn_MIN_GTE?: any | null;
  revokedOn_MIN_LT?: any | null;
  revokedOn_MIN_LTE?: any | null;
  uuid_EQUAL?: string | null;
  variablePercentage_AVERAGE_EQUAL?: number | null;
  variablePercentage_AVERAGE_GT?: number | null;
  variablePercentage_AVERAGE_GTE?: number | null;
  variablePercentage_AVERAGE_LT?: number | null;
  variablePercentage_AVERAGE_LTE?: number | null;
  variablePercentage_EQUAL?: number | null;
  variablePercentage_GT?: number | null;
  variablePercentage_GTE?: number | null;
  variablePercentage_LT?: number | null;
  variablePercentage_LTE?: number | null;
  variablePercentage_MAX_EQUAL?: number | null;
  variablePercentage_MAX_GT?: number | null;
  variablePercentage_MAX_GTE?: number | null;
  variablePercentage_MAX_LT?: number | null;
  variablePercentage_MAX_LTE?: number | null;
  variablePercentage_MIN_EQUAL?: number | null;
  variablePercentage_MIN_GT?: number | null;
  variablePercentage_MIN_GTE?: number | null;
  variablePercentage_MIN_LT?: number | null;
  variablePercentage_MIN_LTE?: number | null;
  variablePercentage_SUM_EQUAL?: number | null;
  variablePercentage_SUM_GT?: number | null;
  variablePercentage_SUM_GTE?: number | null;
  variablePercentage_SUM_LT?: number | null;
  variablePercentage_SUM_LTE?: number | null;
  variable_AVERAGE_EQUAL?: number | null;
  variable_AVERAGE_GT?: number | null;
  variable_AVERAGE_GTE?: number | null;
  variable_AVERAGE_LT?: number | null;
  variable_AVERAGE_LTE?: number | null;
  variable_EQUAL?: number | null;
  variable_GT?: number | null;
  variable_GTE?: number | null;
  variable_LT?: number | null;
  variable_LTE?: number | null;
  variable_MAX_EQUAL?: number | null;
  variable_MAX_GT?: number | null;
  variable_MAX_GTE?: number | null;
  variable_MAX_LT?: number | null;
  variable_MAX_LTE?: number | null;
  variable_MIN_EQUAL?: number | null;
  variable_MIN_GT?: number | null;
  variable_MIN_GTE?: number | null;
  variable_MIN_LT?: number | null;
  variable_MIN_LTE?: number | null;
  variable_SUM_EQUAL?: number | null;
  variable_SUM_GT?: number | null;
  variable_SUM_GTE?: number | null;
  variable_SUM_LT?: number | null;
  variable_SUM_LTE?: number | null;
}

export interface RefundDocumentsAggregateInput {
  AND?: RefundDocumentsAggregateInput[] | null;
  OR?: RefundDocumentsAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: RefundDocumentsNodeAggregationWhereInput | null;
}

export interface RefundDocumentsConnectionWhere {
  AND?: RefundDocumentsConnectionWhere[] | null;
  OR?: RefundDocumentsConnectionWhere[] | null;
  node?: DocumentWhere | null;
  node_NOT?: DocumentWhere | null;
}

export interface RefundDocumentsNodeAggregationWhereInput {
  AND?: RefundDocumentsNodeAggregationWhereInput[] | null;
  OR?: RefundDocumentsNodeAggregationWhereInput[] | null;
  counterParties_AVERAGE_EQUAL?: number | null;
  counterParties_AVERAGE_GT?: number | null;
  counterParties_AVERAGE_GTE?: number | null;
  counterParties_AVERAGE_LT?: number | null;
  counterParties_AVERAGE_LTE?: number | null;
  counterParties_EQUAL?: string | null;
  counterParties_GT?: number | null;
  counterParties_GTE?: number | null;
  counterParties_LONGEST_EQUAL?: number | null;
  counterParties_LONGEST_GT?: number | null;
  counterParties_LONGEST_GTE?: number | null;
  counterParties_LONGEST_LT?: number | null;
  counterParties_LONGEST_LTE?: number | null;
  counterParties_LT?: number | null;
  counterParties_LTE?: number | null;
  counterParties_SHORTEST_EQUAL?: number | null;
  counterParties_SHORTEST_GT?: number | null;
  counterParties_SHORTEST_GTE?: number | null;
  counterParties_SHORTEST_LT?: number | null;
  counterParties_SHORTEST_LTE?: number | null;
  coveragePeriod_AVERAGE_EQUAL?: number | null;
  coveragePeriod_AVERAGE_GT?: number | null;
  coveragePeriod_AVERAGE_GTE?: number | null;
  coveragePeriod_AVERAGE_LT?: number | null;
  coveragePeriod_AVERAGE_LTE?: number | null;
  coveragePeriod_EQUAL?: string | null;
  coveragePeriod_GT?: number | null;
  coveragePeriod_GTE?: number | null;
  coveragePeriod_LONGEST_EQUAL?: number | null;
  coveragePeriod_LONGEST_GT?: number | null;
  coveragePeriod_LONGEST_GTE?: number | null;
  coveragePeriod_LONGEST_LT?: number | null;
  coveragePeriod_LONGEST_LTE?: number | null;
  coveragePeriod_LT?: number | null;
  coveragePeriod_LTE?: number | null;
  coveragePeriod_SHORTEST_EQUAL?: number | null;
  coveragePeriod_SHORTEST_GT?: number | null;
  coveragePeriod_SHORTEST_GTE?: number | null;
  coveragePeriod_SHORTEST_LT?: number | null;
  coveragePeriod_SHORTEST_LTE?: number | null;
  createdByEmail_AVERAGE_EQUAL?: number | null;
  createdByEmail_AVERAGE_GT?: number | null;
  createdByEmail_AVERAGE_GTE?: number | null;
  createdByEmail_AVERAGE_LT?: number | null;
  createdByEmail_AVERAGE_LTE?: number | null;
  createdByEmail_EQUAL?: string | null;
  createdByEmail_GT?: number | null;
  createdByEmail_GTE?: number | null;
  createdByEmail_LONGEST_EQUAL?: number | null;
  createdByEmail_LONGEST_GT?: number | null;
  createdByEmail_LONGEST_GTE?: number | null;
  createdByEmail_LONGEST_LT?: number | null;
  createdByEmail_LONGEST_LTE?: number | null;
  createdByEmail_LT?: number | null;
  createdByEmail_LTE?: number | null;
  createdByEmail_SHORTEST_EQUAL?: number | null;
  createdByEmail_SHORTEST_GT?: number | null;
  createdByEmail_SHORTEST_GTE?: number | null;
  createdByEmail_SHORTEST_LT?: number | null;
  createdByEmail_SHORTEST_LTE?: number | null;
  createdOn_EQUAL?: any | null;
  createdOn_GT?: any | null;
  createdOn_GTE?: any | null;
  createdOn_LT?: any | null;
  createdOn_LTE?: any | null;
  createdOn_MAX_EQUAL?: any | null;
  createdOn_MAX_GT?: any | null;
  createdOn_MAX_GTE?: any | null;
  createdOn_MAX_LT?: any | null;
  createdOn_MAX_LTE?: any | null;
  createdOn_MIN_EQUAL?: any | null;
  createdOn_MIN_GT?: any | null;
  createdOn_MIN_GTE?: any | null;
  createdOn_MIN_LT?: any | null;
  createdOn_MIN_LTE?: any | null;
  creatorOrgName_AVERAGE_EQUAL?: number | null;
  creatorOrgName_AVERAGE_GT?: number | null;
  creatorOrgName_AVERAGE_GTE?: number | null;
  creatorOrgName_AVERAGE_LT?: number | null;
  creatorOrgName_AVERAGE_LTE?: number | null;
  creatorOrgName_EQUAL?: string | null;
  creatorOrgName_GT?: number | null;
  creatorOrgName_GTE?: number | null;
  creatorOrgName_LONGEST_EQUAL?: number | null;
  creatorOrgName_LONGEST_GT?: number | null;
  creatorOrgName_LONGEST_GTE?: number | null;
  creatorOrgName_LONGEST_LT?: number | null;
  creatorOrgName_LONGEST_LTE?: number | null;
  creatorOrgName_LT?: number | null;
  creatorOrgName_LTE?: number | null;
  creatorOrgName_SHORTEST_EQUAL?: number | null;
  creatorOrgName_SHORTEST_GT?: number | null;
  creatorOrgName_SHORTEST_GTE?: number | null;
  creatorOrgName_SHORTEST_LT?: number | null;
  creatorOrgName_SHORTEST_LTE?: number | null;
  creatorTenantId_AVERAGE_EQUAL?: number | null;
  creatorTenantId_AVERAGE_GT?: number | null;
  creatorTenantId_AVERAGE_GTE?: number | null;
  creatorTenantId_AVERAGE_LT?: number | null;
  creatorTenantId_AVERAGE_LTE?: number | null;
  creatorTenantId_EQUAL?: string | null;
  creatorTenantId_GT?: number | null;
  creatorTenantId_GTE?: number | null;
  creatorTenantId_LONGEST_EQUAL?: number | null;
  creatorTenantId_LONGEST_GT?: number | null;
  creatorTenantId_LONGEST_GTE?: number | null;
  creatorTenantId_LONGEST_LT?: number | null;
  creatorTenantId_LONGEST_LTE?: number | null;
  creatorTenantId_LT?: number | null;
  creatorTenantId_LTE?: number | null;
  creatorTenantId_SHORTEST_EQUAL?: number | null;
  creatorTenantId_SHORTEST_GT?: number | null;
  creatorTenantId_SHORTEST_GTE?: number | null;
  creatorTenantId_SHORTEST_LT?: number | null;
  creatorTenantId_SHORTEST_LTE?: number | null;
  formattedTags_AVERAGE_EQUAL?: number | null;
  formattedTags_AVERAGE_GT?: number | null;
  formattedTags_AVERAGE_GTE?: number | null;
  formattedTags_AVERAGE_LT?: number | null;
  formattedTags_AVERAGE_LTE?: number | null;
  formattedTags_EQUAL?: string | null;
  formattedTags_GT?: number | null;
  formattedTags_GTE?: number | null;
  formattedTags_LONGEST_EQUAL?: number | null;
  formattedTags_LONGEST_GT?: number | null;
  formattedTags_LONGEST_GTE?: number | null;
  formattedTags_LONGEST_LT?: number | null;
  formattedTags_LONGEST_LTE?: number | null;
  formattedTags_LT?: number | null;
  formattedTags_LTE?: number | null;
  formattedTags_SHORTEST_EQUAL?: number | null;
  formattedTags_SHORTEST_GT?: number | null;
  formattedTags_SHORTEST_GTE?: number | null;
  formattedTags_SHORTEST_LT?: number | null;
  formattedTags_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  invoiceAmount_AVERAGE_EQUAL?: number | null;
  invoiceAmount_AVERAGE_GT?: number | null;
  invoiceAmount_AVERAGE_GTE?: number | null;
  invoiceAmount_AVERAGE_LT?: number | null;
  invoiceAmount_AVERAGE_LTE?: number | null;
  invoiceAmount_EQUAL?: number | null;
  invoiceAmount_GT?: number | null;
  invoiceAmount_GTE?: number | null;
  invoiceAmount_LT?: number | null;
  invoiceAmount_LTE?: number | null;
  invoiceAmount_MAX_EQUAL?: number | null;
  invoiceAmount_MAX_GT?: number | null;
  invoiceAmount_MAX_GTE?: number | null;
  invoiceAmount_MAX_LT?: number | null;
  invoiceAmount_MAX_LTE?: number | null;
  invoiceAmount_MIN_EQUAL?: number | null;
  invoiceAmount_MIN_GT?: number | null;
  invoiceAmount_MIN_GTE?: number | null;
  invoiceAmount_MIN_LT?: number | null;
  invoiceAmount_MIN_LTE?: number | null;
  invoiceAmount_SUM_EQUAL?: number | null;
  invoiceAmount_SUM_GT?: number | null;
  invoiceAmount_SUM_GTE?: number | null;
  invoiceAmount_SUM_LT?: number | null;
  invoiceAmount_SUM_LTE?: number | null;
  issuedOn_EQUAL?: any | null;
  issuedOn_GT?: any | null;
  issuedOn_GTE?: any | null;
  issuedOn_LT?: any | null;
  issuedOn_LTE?: any | null;
  issuedOn_MAX_EQUAL?: any | null;
  issuedOn_MAX_GT?: any | null;
  issuedOn_MAX_GTE?: any | null;
  issuedOn_MAX_LT?: any | null;
  issuedOn_MAX_LTE?: any | null;
  issuedOn_MIN_EQUAL?: any | null;
  issuedOn_MIN_GT?: any | null;
  issuedOn_MIN_GTE?: any | null;
  issuedOn_MIN_LT?: any | null;
  issuedOn_MIN_LTE?: any | null;
  lastChangedOn_EQUAL?: any | null;
  lastChangedOn_GT?: any | null;
  lastChangedOn_GTE?: any | null;
  lastChangedOn_LT?: any | null;
  lastChangedOn_LTE?: any | null;
  lastChangedOn_MAX_EQUAL?: any | null;
  lastChangedOn_MAX_GT?: any | null;
  lastChangedOn_MAX_GTE?: any | null;
  lastChangedOn_MAX_LT?: any | null;
  lastChangedOn_MAX_LTE?: any | null;
  lastChangedOn_MIN_EQUAL?: any | null;
  lastChangedOn_MIN_GT?: any | null;
  lastChangedOn_MIN_GTE?: any | null;
  lastChangedOn_MIN_LT?: any | null;
  lastChangedOn_MIN_LTE?: any | null;
  lastRemindedOn_EQUAL?: any | null;
  lastRemindedOn_GT?: any | null;
  lastRemindedOn_GTE?: any | null;
  lastRemindedOn_LT?: any | null;
  lastRemindedOn_LTE?: any | null;
  lastRemindedOn_MAX_EQUAL?: any | null;
  lastRemindedOn_MAX_GT?: any | null;
  lastRemindedOn_MAX_GTE?: any | null;
  lastRemindedOn_MAX_LT?: any | null;
  lastRemindedOn_MAX_LTE?: any | null;
  lastRemindedOn_MIN_EQUAL?: any | null;
  lastRemindedOn_MIN_GT?: any | null;
  lastRemindedOn_MIN_GTE?: any | null;
  lastRemindedOn_MIN_LT?: any | null;
  lastRemindedOn_MIN_LTE?: any | null;
  lastUpdatedOn_EQUAL?: any | null;
  lastUpdatedOn_GT?: any | null;
  lastUpdatedOn_GTE?: any | null;
  lastUpdatedOn_LT?: any | null;
  lastUpdatedOn_LTE?: any | null;
  lastUpdatedOn_MAX_EQUAL?: any | null;
  lastUpdatedOn_MAX_GT?: any | null;
  lastUpdatedOn_MAX_GTE?: any | null;
  lastUpdatedOn_MAX_LT?: any | null;
  lastUpdatedOn_MAX_LTE?: any | null;
  lastUpdatedOn_MIN_EQUAL?: any | null;
  lastUpdatedOn_MIN_GT?: any | null;
  lastUpdatedOn_MIN_GTE?: any | null;
  lastUpdatedOn_MIN_LT?: any | null;
  lastUpdatedOn_MIN_LTE?: any | null;
  product_AVERAGE_EQUAL?: number | null;
  product_AVERAGE_GT?: number | null;
  product_AVERAGE_GTE?: number | null;
  product_AVERAGE_LT?: number | null;
  product_AVERAGE_LTE?: number | null;
  product_EQUAL?: string | null;
  product_GT?: number | null;
  product_GTE?: number | null;
  product_LONGEST_EQUAL?: number | null;
  product_LONGEST_GT?: number | null;
  product_LONGEST_GTE?: number | null;
  product_LONGEST_LT?: number | null;
  product_LONGEST_LTE?: number | null;
  product_LT?: number | null;
  product_LTE?: number | null;
  product_SHORTEST_EQUAL?: number | null;
  product_SHORTEST_GT?: number | null;
  product_SHORTEST_GTE?: number | null;
  product_SHORTEST_LT?: number | null;
  product_SHORTEST_LTE?: number | null;
  unlimited_AVERAGE_EQUAL?: number | null;
  unlimited_AVERAGE_GT?: number | null;
  unlimited_AVERAGE_GTE?: number | null;
  unlimited_AVERAGE_LT?: number | null;
  unlimited_AVERAGE_LTE?: number | null;
  unlimited_EQUAL?: number | null;
  unlimited_GT?: number | null;
  unlimited_GTE?: number | null;
  unlimited_LT?: number | null;
  unlimited_LTE?: number | null;
  unlimited_MAX_EQUAL?: number | null;
  unlimited_MAX_GT?: number | null;
  unlimited_MAX_GTE?: number | null;
  unlimited_MAX_LT?: number | null;
  unlimited_MAX_LTE?: number | null;
  unlimited_MIN_EQUAL?: number | null;
  unlimited_MIN_GT?: number | null;
  unlimited_MIN_GTE?: number | null;
  unlimited_MIN_LT?: number | null;
  unlimited_MIN_LTE?: number | null;
  unlimited_SUM_EQUAL?: number | null;
  unlimited_SUM_GT?: number | null;
  unlimited_SUM_GTE?: number | null;
  unlimited_SUM_LT?: number | null;
  unlimited_SUM_LTE?: number | null;
}

export interface RefundOptions {
  limit?: number | null;
  offset?: number | null;
  sort?: (RefundSort | null)[] | null;
}

export interface RefundRefundCaseAggregateInput {
  AND?: RefundRefundCaseAggregateInput[] | null;
  OR?: RefundRefundCaseAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: RefundRefundCaseNodeAggregationWhereInput | null;
}

export interface RefundRefundCaseConnectionWhere {
  AND?: RefundRefundCaseConnectionWhere[] | null;
  OR?: RefundRefundCaseConnectionWhere[] | null;
  node?: RefundCaseWhere | null;
  node_NOT?: RefundCaseWhere | null;
}

export interface RefundRefundCaseNodeAggregationWhereInput {
  AND?: RefundRefundCaseNodeAggregationWhereInput[] | null;
  OR?: RefundRefundCaseNodeAggregationWhereInput[] | null;
  id_EQUAL?: string | null;
}

/**
 * Fields to sort Refunds by. The order in which sorts are applied is not guaranteed when specifying many fields in one RefundSort object.
 */
export interface RefundSort {
  agreementName?: SortDirection | null;
  amount?: SortDirection | null;
  canUserModifyFinancials?: SortDirection | null;
  caseId?: SortDirection | null;
  case_legalEntity_name?: string | null;
  counterParties?: SortDirection | null;
  createdOn?: SortDirection | null;
  currency?: SortDirection | null;
  formattedTags?: SortDirection | null;
  id?: SortDirection | null;
  iin?: SortDirection | null;
  isAgreementBuyer?: SortDirection | null;
  isAgreementSeller?: SortDirection | null;
  isDeleted?: SortDirection | null;
  product?: SortDirection | null;
  refundRate?: SortDirection | null;
  revokedOn?: SortDirection | null;
  sourceFinancialDataPoint_basePrice?: string | null;
  sourceFinancialDataPoint_evaluates_invoiceDate?: string | null;
  sourceFinancialDataPoint_prescriptionDate?: string | null;
  sourceFinancialDataPoint_quantity?: string | null;
  sourceFinancialDataPoint_refundablePercentage?: string | null;
  status?: SortDirection | null;
  threadMessageCount?: SortDirection | null;
  unlimited?: SortDirection | null;
  wasDeclined?: SortDirection | null;
}

export interface RefundSourceFinancialDataPointAggregateInput {
  AND?: RefundSourceFinancialDataPointAggregateInput[] | null;
  OR?: RefundSourceFinancialDataPointAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: RefundSourceFinancialDataPointNodeAggregationWhereInput | null;
}

export interface RefundSourceFinancialDataPointConnectionWhere {
  AND?: RefundSourceFinancialDataPointConnectionWhere[] | null;
  OR?: RefundSourceFinancialDataPointConnectionWhere[] | null;
  node?: FlexFinancialDataPointWhere | null;
  node_NOT?: FlexFinancialDataPointWhere | null;
}

export interface RefundSourceFinancialDataPointNodeAggregationWhereInput {
  AND?: RefundSourceFinancialDataPointNodeAggregationWhereInput[] | null;
  OR?: RefundSourceFinancialDataPointNodeAggregationWhereInput[] | null;
  basePrice_AVERAGE_EQUAL?: number | null;
  basePrice_AVERAGE_GT?: number | null;
  basePrice_AVERAGE_GTE?: number | null;
  basePrice_AVERAGE_LT?: number | null;
  basePrice_AVERAGE_LTE?: number | null;
  basePrice_EQUAL?: number | null;
  basePrice_GT?: number | null;
  basePrice_GTE?: number | null;
  basePrice_LT?: number | null;
  basePrice_LTE?: number | null;
  basePrice_MAX_EQUAL?: number | null;
  basePrice_MAX_GT?: number | null;
  basePrice_MAX_GTE?: number | null;
  basePrice_MAX_LT?: number | null;
  basePrice_MAX_LTE?: number | null;
  basePrice_MIN_EQUAL?: number | null;
  basePrice_MIN_GT?: number | null;
  basePrice_MIN_GTE?: number | null;
  basePrice_MIN_LT?: number | null;
  basePrice_MIN_LTE?: number | null;
  basePrice_SUM_EQUAL?: number | null;
  basePrice_SUM_GT?: number | null;
  basePrice_SUM_GTE?: number | null;
  basePrice_SUM_LT?: number | null;
  basePrice_SUM_LTE?: number | null;
  createdOn_EQUAL?: any | null;
  createdOn_GT?: any | null;
  createdOn_GTE?: any | null;
  createdOn_LT?: any | null;
  createdOn_LTE?: any | null;
  createdOn_MAX_EQUAL?: any | null;
  createdOn_MAX_GT?: any | null;
  createdOn_MAX_GTE?: any | null;
  createdOn_MAX_LT?: any | null;
  createdOn_MAX_LTE?: any | null;
  createdOn_MIN_EQUAL?: any | null;
  createdOn_MIN_GT?: any | null;
  createdOn_MIN_GTE?: any | null;
  createdOn_MIN_LT?: any | null;
  createdOn_MIN_LTE?: any | null;
  currencyCode_AVERAGE_EQUAL?: number | null;
  currencyCode_AVERAGE_GT?: number | null;
  currencyCode_AVERAGE_GTE?: number | null;
  currencyCode_AVERAGE_LT?: number | null;
  currencyCode_AVERAGE_LTE?: number | null;
  currencyCode_EQUAL?: string | null;
  currencyCode_GT?: number | null;
  currencyCode_GTE?: number | null;
  currencyCode_LONGEST_EQUAL?: number | null;
  currencyCode_LONGEST_GT?: number | null;
  currencyCode_LONGEST_GTE?: number | null;
  currencyCode_LONGEST_LT?: number | null;
  currencyCode_LONGEST_LTE?: number | null;
  currencyCode_LT?: number | null;
  currencyCode_LTE?: number | null;
  currencyCode_SHORTEST_EQUAL?: number | null;
  currencyCode_SHORTEST_GT?: number | null;
  currencyCode_SHORTEST_GTE?: number | null;
  currencyCode_SHORTEST_LT?: number | null;
  currencyCode_SHORTEST_LTE?: number | null;
  evaluationSnapshot_AVERAGE_EQUAL?: number | null;
  evaluationSnapshot_AVERAGE_GT?: number | null;
  evaluationSnapshot_AVERAGE_GTE?: number | null;
  evaluationSnapshot_AVERAGE_LT?: number | null;
  evaluationSnapshot_AVERAGE_LTE?: number | null;
  evaluationSnapshot_EQUAL?: string | null;
  evaluationSnapshot_GT?: number | null;
  evaluationSnapshot_GTE?: number | null;
  evaluationSnapshot_LONGEST_EQUAL?: number | null;
  evaluationSnapshot_LONGEST_GT?: number | null;
  evaluationSnapshot_LONGEST_GTE?: number | null;
  evaluationSnapshot_LONGEST_LT?: number | null;
  evaluationSnapshot_LONGEST_LTE?: number | null;
  evaluationSnapshot_LT?: number | null;
  evaluationSnapshot_LTE?: number | null;
  evaluationSnapshot_SHORTEST_EQUAL?: number | null;
  evaluationSnapshot_SHORTEST_GT?: number | null;
  evaluationSnapshot_SHORTEST_GTE?: number | null;
  evaluationSnapshot_SHORTEST_LT?: number | null;
  evaluationSnapshot_SHORTEST_LTE?: number | null;
  generatedUuid_EQUAL?: string | null;
  payablePercentage_AVERAGE_EQUAL?: number | null;
  payablePercentage_AVERAGE_GT?: number | null;
  payablePercentage_AVERAGE_GTE?: number | null;
  payablePercentage_AVERAGE_LT?: number | null;
  payablePercentage_AVERAGE_LTE?: number | null;
  payablePercentage_EQUAL?: number | null;
  payablePercentage_GT?: number | null;
  payablePercentage_GTE?: number | null;
  payablePercentage_LT?: number | null;
  payablePercentage_LTE?: number | null;
  payablePercentage_MAX_EQUAL?: number | null;
  payablePercentage_MAX_GT?: number | null;
  payablePercentage_MAX_GTE?: number | null;
  payablePercentage_MAX_LT?: number | null;
  payablePercentage_MAX_LTE?: number | null;
  payablePercentage_MIN_EQUAL?: number | null;
  payablePercentage_MIN_GT?: number | null;
  payablePercentage_MIN_GTE?: number | null;
  payablePercentage_MIN_LT?: number | null;
  payablePercentage_MIN_LTE?: number | null;
  payablePercentage_SUM_EQUAL?: number | null;
  payablePercentage_SUM_GT?: number | null;
  payablePercentage_SUM_GTE?: number | null;
  payablePercentage_SUM_LT?: number | null;
  payablePercentage_SUM_LTE?: number | null;
  payable_AVERAGE_EQUAL?: number | null;
  payable_AVERAGE_GT?: number | null;
  payable_AVERAGE_GTE?: number | null;
  payable_AVERAGE_LT?: number | null;
  payable_AVERAGE_LTE?: number | null;
  payable_EQUAL?: number | null;
  payable_GT?: number | null;
  payable_GTE?: number | null;
  payable_LT?: number | null;
  payable_LTE?: number | null;
  payable_MAX_EQUAL?: number | null;
  payable_MAX_GT?: number | null;
  payable_MAX_GTE?: number | null;
  payable_MAX_LT?: number | null;
  payable_MAX_LTE?: number | null;
  payable_MIN_EQUAL?: number | null;
  payable_MIN_GT?: number | null;
  payable_MIN_GTE?: number | null;
  payable_MIN_LT?: number | null;
  payable_MIN_LTE?: number | null;
  payable_SUM_EQUAL?: number | null;
  payable_SUM_GT?: number | null;
  payable_SUM_GTE?: number | null;
  payable_SUM_LT?: number | null;
  payable_SUM_LTE?: number | null;
  quantity_AVERAGE_EQUAL?: number | null;
  quantity_AVERAGE_GT?: number | null;
  quantity_AVERAGE_GTE?: number | null;
  quantity_AVERAGE_LT?: number | null;
  quantity_AVERAGE_LTE?: number | null;
  quantity_EQUAL?: number | null;
  quantity_GT?: number | null;
  quantity_GTE?: number | null;
  quantity_LT?: number | null;
  quantity_LTE?: number | null;
  quantity_MAX_EQUAL?: number | null;
  quantity_MAX_GT?: number | null;
  quantity_MAX_GTE?: number | null;
  quantity_MAX_LT?: number | null;
  quantity_MAX_LTE?: number | null;
  quantity_MIN_EQUAL?: number | null;
  quantity_MIN_GT?: number | null;
  quantity_MIN_GTE?: number | null;
  quantity_MIN_LT?: number | null;
  quantity_MIN_LTE?: number | null;
  quantity_SUM_EQUAL?: number | null;
  quantity_SUM_GT?: number | null;
  quantity_SUM_GTE?: number | null;
  quantity_SUM_LT?: number | null;
  quantity_SUM_LTE?: number | null;
  refundDeltaNumber_AVERAGE_EQUAL?: number | null;
  refundDeltaNumber_AVERAGE_GT?: number | null;
  refundDeltaNumber_AVERAGE_GTE?: number | null;
  refundDeltaNumber_AVERAGE_LT?: number | null;
  refundDeltaNumber_AVERAGE_LTE?: number | null;
  refundDeltaNumber_EQUAL?: number | null;
  refundDeltaNumber_GT?: number | null;
  refundDeltaNumber_GTE?: number | null;
  refundDeltaNumber_LT?: number | null;
  refundDeltaNumber_LTE?: number | null;
  refundDeltaNumber_MAX_EQUAL?: number | null;
  refundDeltaNumber_MAX_GT?: number | null;
  refundDeltaNumber_MAX_GTE?: number | null;
  refundDeltaNumber_MAX_LT?: number | null;
  refundDeltaNumber_MAX_LTE?: number | null;
  refundDeltaNumber_MIN_EQUAL?: number | null;
  refundDeltaNumber_MIN_GT?: number | null;
  refundDeltaNumber_MIN_GTE?: number | null;
  refundDeltaNumber_MIN_LT?: number | null;
  refundDeltaNumber_MIN_LTE?: number | null;
  refundDeltaNumber_SUM_EQUAL?: number | null;
  refundDeltaNumber_SUM_GT?: number | null;
  refundDeltaNumber_SUM_GTE?: number | null;
  refundDeltaNumber_SUM_LT?: number | null;
  refundDeltaNumber_SUM_LTE?: number | null;
  refundablePercentage_AVERAGE_EQUAL?: number | null;
  refundablePercentage_AVERAGE_GT?: number | null;
  refundablePercentage_AVERAGE_GTE?: number | null;
  refundablePercentage_AVERAGE_LT?: number | null;
  refundablePercentage_AVERAGE_LTE?: number | null;
  refundablePercentage_EQUAL?: number | null;
  refundablePercentage_GT?: number | null;
  refundablePercentage_GTE?: number | null;
  refundablePercentage_LT?: number | null;
  refundablePercentage_LTE?: number | null;
  refundablePercentage_MAX_EQUAL?: number | null;
  refundablePercentage_MAX_GT?: number | null;
  refundablePercentage_MAX_GTE?: number | null;
  refundablePercentage_MAX_LT?: number | null;
  refundablePercentage_MAX_LTE?: number | null;
  refundablePercentage_MIN_EQUAL?: number | null;
  refundablePercentage_MIN_GT?: number | null;
  refundablePercentage_MIN_GTE?: number | null;
  refundablePercentage_MIN_LT?: number | null;
  refundablePercentage_MIN_LTE?: number | null;
  refundablePercentage_SUM_EQUAL?: number | null;
  refundablePercentage_SUM_GT?: number | null;
  refundablePercentage_SUM_GTE?: number | null;
  refundablePercentage_SUM_LT?: number | null;
  refundablePercentage_SUM_LTE?: number | null;
  refundable_AVERAGE_EQUAL?: number | null;
  refundable_AVERAGE_GT?: number | null;
  refundable_AVERAGE_GTE?: number | null;
  refundable_AVERAGE_LT?: number | null;
  refundable_AVERAGE_LTE?: number | null;
  refundable_EQUAL?: number | null;
  refundable_GT?: number | null;
  refundable_GTE?: number | null;
  refundable_LT?: number | null;
  refundable_LTE?: number | null;
  refundable_MAX_EQUAL?: number | null;
  refundable_MAX_GT?: number | null;
  refundable_MAX_GTE?: number | null;
  refundable_MAX_LT?: number | null;
  refundable_MAX_LTE?: number | null;
  refundable_MIN_EQUAL?: number | null;
  refundable_MIN_GT?: number | null;
  refundable_MIN_GTE?: number | null;
  refundable_MIN_LT?: number | null;
  refundable_MIN_LTE?: number | null;
  refundable_SUM_EQUAL?: number | null;
  refundable_SUM_GT?: number | null;
  refundable_SUM_GTE?: number | null;
  refundable_SUM_LT?: number | null;
  refundable_SUM_LTE?: number | null;
  revokedOn_EQUAL?: any | null;
  revokedOn_GT?: any | null;
  revokedOn_GTE?: any | null;
  revokedOn_LT?: any | null;
  revokedOn_LTE?: any | null;
  revokedOn_MAX_EQUAL?: any | null;
  revokedOn_MAX_GT?: any | null;
  revokedOn_MAX_GTE?: any | null;
  revokedOn_MAX_LT?: any | null;
  revokedOn_MAX_LTE?: any | null;
  revokedOn_MIN_EQUAL?: any | null;
  revokedOn_MIN_GT?: any | null;
  revokedOn_MIN_GTE?: any | null;
  revokedOn_MIN_LT?: any | null;
  revokedOn_MIN_LTE?: any | null;
  uuid_EQUAL?: string | null;
  variablePercentage_AVERAGE_EQUAL?: number | null;
  variablePercentage_AVERAGE_GT?: number | null;
  variablePercentage_AVERAGE_GTE?: number | null;
  variablePercentage_AVERAGE_LT?: number | null;
  variablePercentage_AVERAGE_LTE?: number | null;
  variablePercentage_EQUAL?: number | null;
  variablePercentage_GT?: number | null;
  variablePercentage_GTE?: number | null;
  variablePercentage_LT?: number | null;
  variablePercentage_LTE?: number | null;
  variablePercentage_MAX_EQUAL?: number | null;
  variablePercentage_MAX_GT?: number | null;
  variablePercentage_MAX_GTE?: number | null;
  variablePercentage_MAX_LT?: number | null;
  variablePercentage_MAX_LTE?: number | null;
  variablePercentage_MIN_EQUAL?: number | null;
  variablePercentage_MIN_GT?: number | null;
  variablePercentage_MIN_GTE?: number | null;
  variablePercentage_MIN_LT?: number | null;
  variablePercentage_MIN_LTE?: number | null;
  variablePercentage_SUM_EQUAL?: number | null;
  variablePercentage_SUM_GT?: number | null;
  variablePercentage_SUM_GTE?: number | null;
  variablePercentage_SUM_LT?: number | null;
  variablePercentage_SUM_LTE?: number | null;
  variable_AVERAGE_EQUAL?: number | null;
  variable_AVERAGE_GT?: number | null;
  variable_AVERAGE_GTE?: number | null;
  variable_AVERAGE_LT?: number | null;
  variable_AVERAGE_LTE?: number | null;
  variable_EQUAL?: number | null;
  variable_GT?: number | null;
  variable_GTE?: number | null;
  variable_LT?: number | null;
  variable_LTE?: number | null;
  variable_MAX_EQUAL?: number | null;
  variable_MAX_GT?: number | null;
  variable_MAX_GTE?: number | null;
  variable_MAX_LT?: number | null;
  variable_MAX_LTE?: number | null;
  variable_MIN_EQUAL?: number | null;
  variable_MIN_GT?: number | null;
  variable_MIN_GTE?: number | null;
  variable_MIN_LT?: number | null;
  variable_MIN_LTE?: number | null;
  variable_SUM_EQUAL?: number | null;
  variable_SUM_GT?: number | null;
  variable_SUM_GTE?: number | null;
  variable_SUM_LT?: number | null;
  variable_SUM_LTE?: number | null;
}

export interface RefundTagsAggregateInput {
  AND?: RefundTagsAggregateInput[] | null;
  OR?: RefundTagsAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: RefundTagsNodeAggregationWhereInput | null;
}

export interface RefundTagsConnectionWhere {
  AND?: RefundTagsConnectionWhere[] | null;
  OR?: RefundTagsConnectionWhere[] | null;
  node?: AgreementTagWhere | null;
  node_NOT?: AgreementTagWhere | null;
}

export interface RefundTagsNodeAggregationWhereInput {
  AND?: RefundTagsNodeAggregationWhereInput[] | null;
  OR?: RefundTagsNodeAggregationWhereInput[] | null;
  id_AVERAGE_EQUAL?: number | null;
  id_AVERAGE_GT?: number | null;
  id_AVERAGE_GTE?: number | null;
  id_AVERAGE_LT?: number | null;
  id_AVERAGE_LTE?: number | null;
  id_EQUAL?: number | null;
  id_GT?: number | null;
  id_GTE?: number | null;
  id_LT?: number | null;
  id_LTE?: number | null;
  id_MAX_EQUAL?: number | null;
  id_MAX_GT?: number | null;
  id_MAX_GTE?: number | null;
  id_MAX_LT?: number | null;
  id_MAX_LTE?: number | null;
  id_MIN_EQUAL?: number | null;
  id_MIN_GT?: number | null;
  id_MIN_GTE?: number | null;
  id_MIN_LT?: number | null;
  id_MIN_LTE?: number | null;
  id_SUM_EQUAL?: number | null;
  id_SUM_GT?: number | null;
  id_SUM_GTE?: number | null;
  id_SUM_LT?: number | null;
  id_SUM_LTE?: number | null;
  name_AVERAGE_EQUAL?: number | null;
  name_AVERAGE_GT?: number | null;
  name_AVERAGE_GTE?: number | null;
  name_AVERAGE_LT?: number | null;
  name_AVERAGE_LTE?: number | null;
  name_EQUAL?: string | null;
  name_GT?: number | null;
  name_GTE?: number | null;
  name_LONGEST_EQUAL?: number | null;
  name_LONGEST_GT?: number | null;
  name_LONGEST_GTE?: number | null;
  name_LONGEST_LT?: number | null;
  name_LONGEST_LTE?: number | null;
  name_LT?: number | null;
  name_LTE?: number | null;
  name_SHORTEST_EQUAL?: number | null;
  name_SHORTEST_GT?: number | null;
  name_SHORTEST_GTE?: number | null;
  name_SHORTEST_LT?: number | null;
  name_SHORTEST_LTE?: number | null;
}

export interface RefundWhere {
  AND?: RefundWhere[] | null;
  OR?: RefundWhere[] | null;
  agreementName?: string | null;
  agreementName_CONTAINS?: string | null;
  agreementName_ENDS_WITH?: string | null;
  agreementName_IN?: (string | null)[] | null;
  agreementName_MATCHES?: string | null;
  agreementName_NOT?: string | null;
  agreementName_NOT_CONTAINS?: string | null;
  agreementName_NOT_ENDS_WITH?: string | null;
  agreementName_NOT_IN?: (string | null)[] | null;
  agreementName_NOT_STARTS_WITH?: string | null;
  agreementName_STARTS_WITH?: string | null;
  amount?: number | null;
  amount_GT?: number | null;
  amount_GTE?: number | null;
  amount_IN?: (number | null)[] | null;
  amount_LT?: number | null;
  amount_LTE?: number | null;
  amount_NOT?: number | null;
  amount_NOT_IN?: (number | null)[] | null;
  case?: CaseWhere | null;
  caseAggregate?: RefundCaseAggregateInput | null;
  caseConnection?: RefundCaseConnectionWhere | null;
  caseConnection_NOT?: RefundCaseConnectionWhere | null;
  caseId?: string | null;
  caseId_CONTAINS?: string | null;
  caseId_ENDS_WITH?: string | null;
  caseId_IN?: (string | null)[] | null;
  caseId_MATCHES?: string | null;
  caseId_NOT?: string | null;
  caseId_NOT_CONTAINS?: string | null;
  caseId_NOT_ENDS_WITH?: string | null;
  caseId_NOT_IN?: (string | null)[] | null;
  caseId_NOT_STARTS_WITH?: string | null;
  caseId_STARTS_WITH?: string | null;
  case_NOT?: CaseWhere | null;
  counterParties?: string | null;
  counterParties_CONTAINS?: string | null;
  counterParties_ENDS_WITH?: string | null;
  counterParties_IN?: (string | null)[] | null;
  counterParties_MATCHES?: string | null;
  counterParties_NOT?: string | null;
  counterParties_NOT_CONTAINS?: string | null;
  counterParties_NOT_ENDS_WITH?: string | null;
  counterParties_NOT_IN?: (string | null)[] | null;
  counterParties_NOT_STARTS_WITH?: string | null;
  counterParties_STARTS_WITH?: string | null;
  createdOn?: any | null;
  createdOn_GT?: any | null;
  createdOn_GTE?: any | null;
  createdOn_IN?: (any | null)[] | null;
  createdOn_LT?: any | null;
  createdOn_LTE?: any | null;
  createdOn_NOT?: any | null;
  createdOn_NOT_IN?: (any | null)[] | null;
  currency?: string | null;
  currency_CONTAINS?: string | null;
  currency_ENDS_WITH?: string | null;
  currency_IN?: (string | null)[] | null;
  currency_MATCHES?: string | null;
  currency_NOT?: string | null;
  currency_NOT_CONTAINS?: string | null;
  currency_NOT_ENDS_WITH?: string | null;
  currency_NOT_IN?: (string | null)[] | null;
  currency_NOT_STARTS_WITH?: string | null;
  currency_STARTS_WITH?: string | null;
  documentFinancialDataPoint?: FlexFinancialDataPointWhere | null;
  documentFinancialDataPointAggregate?: RefundDocumentFinancialDataPointAggregateInput | null;
  documentFinancialDataPointConnection?: RefundDocumentFinancialDataPointConnectionWhere | null;
  documentFinancialDataPointConnection_NOT?: RefundDocumentFinancialDataPointConnectionWhere | null;
  documentFinancialDataPoint_NOT?: FlexFinancialDataPointWhere | null;
  documents?: DocumentWhere | null;
  documentsAggregate?: RefundDocumentsAggregateInput | null;
  documentsConnection?: RefundDocumentsConnectionWhere | null;
  documentsConnection_NOT?: RefundDocumentsConnectionWhere | null;
  documents_NOT?: DocumentWhere | null;
  formattedTags?: string | null;
  formattedTags_CONTAINS?: string | null;
  formattedTags_ENDS_WITH?: string | null;
  formattedTags_IN?: (string | null)[] | null;
  formattedTags_MATCHES?: string | null;
  formattedTags_NOT?: string | null;
  formattedTags_NOT_CONTAINS?: string | null;
  formattedTags_NOT_ENDS_WITH?: string | null;
  formattedTags_NOT_IN?: (string | null)[] | null;
  formattedTags_NOT_STARTS_WITH?: string | null;
  formattedTags_STARTS_WITH?: string | null;
  id?: string | null;
  id_CONTAINS?: string | null;
  id_ENDS_WITH?: string | null;
  id_IN?: (string | null)[] | null;
  id_MATCHES?: string | null;
  id_NOT?: string | null;
  id_NOT_CONTAINS?: string | null;
  id_NOT_ENDS_WITH?: string | null;
  id_NOT_IN?: (string | null)[] | null;
  id_NOT_STARTS_WITH?: string | null;
  id_STARTS_WITH?: string | null;
  iin?: string | null;
  iin_CONTAINS?: string | null;
  iin_ENDS_WITH?: string | null;
  iin_IN?: (string | null)[] | null;
  iin_MATCHES?: string | null;
  iin_NOT?: string | null;
  iin_NOT_CONTAINS?: string | null;
  iin_NOT_ENDS_WITH?: string | null;
  iin_NOT_IN?: (string | null)[] | null;
  iin_NOT_STARTS_WITH?: string | null;
  iin_STARTS_WITH?: string | null;
  isDeleted?: boolean | null;
  isDeleted_NOT?: boolean | null;
  product?: string | null;
  product_CONTAINS?: string | null;
  product_ENDS_WITH?: string | null;
  product_IN?: (string | null)[] | null;
  product_MATCHES?: string | null;
  product_NOT?: string | null;
  product_NOT_CONTAINS?: string | null;
  product_NOT_ENDS_WITH?: string | null;
  product_NOT_IN?: (string | null)[] | null;
  product_NOT_STARTS_WITH?: string | null;
  product_STARTS_WITH?: string | null;
  refundCase?: RefundCaseWhere | null;
  refundCaseAggregate?: RefundRefundCaseAggregateInput | null;
  refundCaseConnection?: RefundRefundCaseConnectionWhere | null;
  refundCaseConnection_NOT?: RefundRefundCaseConnectionWhere | null;
  refundCase_NOT?: RefundCaseWhere | null;
  refundRate?: number | null;
  refundRate_GT?: number | null;
  refundRate_GTE?: number | null;
  refundRate_IN?: (number | null)[] | null;
  refundRate_LT?: number | null;
  refundRate_LTE?: number | null;
  refundRate_NOT?: number | null;
  refundRate_NOT_IN?: (number | null)[] | null;
  revokedOn?: any | null;
  revokedOn_GT?: any | null;
  revokedOn_GTE?: any | null;
  revokedOn_IN?: (any | null)[] | null;
  revokedOn_LT?: any | null;
  revokedOn_LTE?: any | null;
  revokedOn_NOT?: any | null;
  revokedOn_NOT_IN?: (any | null)[] | null;
  sourceFinancialDataPoint?: FlexFinancialDataPointWhere | null;
  sourceFinancialDataPointAggregate?: RefundSourceFinancialDataPointAggregateInput | null;
  sourceFinancialDataPointConnection?: RefundSourceFinancialDataPointConnectionWhere | null;
  sourceFinancialDataPointConnection_NOT?: RefundSourceFinancialDataPointConnectionWhere | null;
  sourceFinancialDataPoint_NOT?: FlexFinancialDataPointWhere | null;
  status?: RefundStatus | null;
  status_IN?: (RefundStatus | null)[] | null;
  status_NOT?: RefundStatus | null;
  status_NOT_IN?: (RefundStatus | null)[] | null;
  tags?: AgreementTagWhere | null;
  tagsAggregate?: RefundTagsAggregateInput | null;
  tagsConnection?: RefundTagsConnectionWhere | null;
  tagsConnection_NOT?: RefundTagsConnectionWhere | null;
  tags_NOT?: AgreementTagWhere | null;
  tenantIds?: string[] | null;
  tenantIds_INCLUDES?: string | null;
  tenantIds_NOT?: string[] | null;
  tenantIds_NOT_INCLUDES?: string | null;
  unlimited?: number | null;
  unlimited_GT?: number | null;
  unlimited_GTE?: number | null;
  unlimited_IN?: (number | null)[] | null;
  unlimited_LT?: number | null;
  unlimited_LTE?: number | null;
  unlimited_NOT?: number | null;
  unlimited_NOT_IN?: (number | null)[] | null;
  wasDeclined?: boolean | null;
  wasDeclined_NOT?: boolean | null;
}

export interface SaveReviewedInvoiceInput {
  assignees?: (AssigneeInput | null)[] | null;
  confirmedByBuyer?: boolean | null;
  confirmedBySeller?: boolean | null;
  documentType?: DocumentType | null;
  financialDataPoints?: (FinancialDataPointInput | null)[] | null;
  invoiceId: string;
  invoiceStatus: DocumentStatus;
  isApproved: boolean;
  isExposure?: boolean | null;
  settledOn?: string | null;
}

export interface ScenarioActionBrandsAggregateInput {
  AND?: ScenarioActionBrandsAggregateInput[] | null;
  OR?: ScenarioActionBrandsAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  edge?: ScenarioActionBrandsEdgeAggregationWhereInput | null;
  node?: ScenarioActionBrandsNodeAggregationWhereInput | null;
}

export interface ScenarioActionBrandsConnectionWhere {
  AND?: ScenarioActionBrandsConnectionWhere[] | null;
  OR?: ScenarioActionBrandsConnectionWhere[] | null;
  edge?: ActionPrescriptionRelationshipWhere | null;
  edge_NOT?: ActionPrescriptionRelationshipWhere | null;
  node?: BrandWhere | null;
  node_NOT?: BrandWhere | null;
}

export interface ScenarioActionBrandsEdgeAggregationWhereInput {
  AND?: ScenarioActionBrandsEdgeAggregationWhereInput[] | null;
  OR?: ScenarioActionBrandsEdgeAggregationWhereInput[] | null;
  order_AVERAGE_EQUAL?: number | null;
  order_AVERAGE_GT?: number | null;
  order_AVERAGE_GTE?: number | null;
  order_AVERAGE_LT?: number | null;
  order_AVERAGE_LTE?: number | null;
  order_EQUAL?: number | null;
  order_GT?: number | null;
  order_GTE?: number | null;
  order_LT?: number | null;
  order_LTE?: number | null;
  order_MAX_EQUAL?: number | null;
  order_MAX_GT?: number | null;
  order_MAX_GTE?: number | null;
  order_MAX_LT?: number | null;
  order_MAX_LTE?: number | null;
  order_MIN_EQUAL?: number | null;
  order_MIN_GT?: number | null;
  order_MIN_GTE?: number | null;
  order_MIN_LT?: number | null;
  order_MIN_LTE?: number | null;
  order_SUM_EQUAL?: number | null;
  order_SUM_GT?: number | null;
  order_SUM_GTE?: number | null;
  order_SUM_LT?: number | null;
  order_SUM_LTE?: number | null;
}

export interface ScenarioActionBrandsNodeAggregationWhereInput {
  AND?: ScenarioActionBrandsNodeAggregationWhereInput[] | null;
  Name_AVERAGE_EQUAL?: number | null;
  Name_AVERAGE_GT?: number | null;
  Name_AVERAGE_GTE?: number | null;
  Name_AVERAGE_LT?: number | null;
  Name_AVERAGE_LTE?: number | null;
  Name_EQUAL?: string | null;
  Name_GT?: number | null;
  Name_GTE?: number | null;
  Name_LONGEST_EQUAL?: number | null;
  Name_LONGEST_GT?: number | null;
  Name_LONGEST_GTE?: number | null;
  Name_LONGEST_LT?: number | null;
  Name_LONGEST_LTE?: number | null;
  Name_LT?: number | null;
  Name_LTE?: number | null;
  Name_SHORTEST_EQUAL?: number | null;
  Name_SHORTEST_GT?: number | null;
  Name_SHORTEST_GTE?: number | null;
  Name_SHORTEST_LT?: number | null;
  Name_SHORTEST_LTE?: number | null;
  OR?: ScenarioActionBrandsNodeAggregationWhereInput[] | null;
  id_EQUAL?: string | null;
}

export interface ScenarioActionCombinedItemBrandsAggregateInput {
  AND?: ScenarioActionCombinedItemBrandsAggregateInput[] | null;
  OR?: ScenarioActionCombinedItemBrandsAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: ScenarioActionCombinedItemBrandsNodeAggregationWhereInput | null;
}

export interface ScenarioActionCombinedItemBrandsConnectionWhere {
  AND?: ScenarioActionCombinedItemBrandsConnectionWhere[] | null;
  OR?: ScenarioActionCombinedItemBrandsConnectionWhere[] | null;
  node?: BrandWhere | null;
  node_NOT?: BrandWhere | null;
}

export interface ScenarioActionCombinedItemBrandsNodeAggregationWhereInput {
  AND?: ScenarioActionCombinedItemBrandsNodeAggregationWhereInput[] | null;
  Name_AVERAGE_EQUAL?: number | null;
  Name_AVERAGE_GT?: number | null;
  Name_AVERAGE_GTE?: number | null;
  Name_AVERAGE_LT?: number | null;
  Name_AVERAGE_LTE?: number | null;
  Name_EQUAL?: string | null;
  Name_GT?: number | null;
  Name_GTE?: number | null;
  Name_LONGEST_EQUAL?: number | null;
  Name_LONGEST_GT?: number | null;
  Name_LONGEST_GTE?: number | null;
  Name_LONGEST_LT?: number | null;
  Name_LONGEST_LTE?: number | null;
  Name_LT?: number | null;
  Name_LTE?: number | null;
  Name_SHORTEST_EQUAL?: number | null;
  Name_SHORTEST_GT?: number | null;
  Name_SHORTEST_GTE?: number | null;
  Name_SHORTEST_LT?: number | null;
  Name_SHORTEST_LTE?: number | null;
  OR?: ScenarioActionCombinedItemBrandsNodeAggregationWhereInput[] | null;
  id_EQUAL?: string | null;
}

export interface ScenarioActionCombinedItemGenericsAggregateInput {
  AND?: ScenarioActionCombinedItemGenericsAggregateInput[] | null;
  OR?: ScenarioActionCombinedItemGenericsAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: ScenarioActionCombinedItemGenericsNodeAggregationWhereInput | null;
}

export interface ScenarioActionCombinedItemGenericsConnectionWhere {
  AND?: ScenarioActionCombinedItemGenericsConnectionWhere[] | null;
  OR?: ScenarioActionCombinedItemGenericsConnectionWhere[] | null;
  node?: GenericWhere | null;
  node_NOT?: GenericWhere | null;
}

export interface ScenarioActionCombinedItemGenericsNodeAggregationWhereInput {
  AND?: ScenarioActionCombinedItemGenericsNodeAggregationWhereInput[] | null;
  Name_AVERAGE_EQUAL?: number | null;
  Name_AVERAGE_GT?: number | null;
  Name_AVERAGE_GTE?: number | null;
  Name_AVERAGE_LT?: number | null;
  Name_AVERAGE_LTE?: number | null;
  Name_EQUAL?: string | null;
  Name_GT?: number | null;
  Name_GTE?: number | null;
  Name_LONGEST_EQUAL?: number | null;
  Name_LONGEST_GT?: number | null;
  Name_LONGEST_GTE?: number | null;
  Name_LONGEST_LT?: number | null;
  Name_LONGEST_LTE?: number | null;
  Name_LT?: number | null;
  Name_LTE?: number | null;
  Name_SHORTEST_EQUAL?: number | null;
  Name_SHORTEST_GT?: number | null;
  Name_SHORTEST_GTE?: number | null;
  Name_SHORTEST_LT?: number | null;
  Name_SHORTEST_LTE?: number | null;
  OR?: ScenarioActionCombinedItemGenericsNodeAggregationWhereInput[] | null;
  id_EQUAL?: string | null;
}

export interface ScenarioActionCombinedItemTreatmentsAggregateInput {
  AND?: ScenarioActionCombinedItemTreatmentsAggregateInput[] | null;
  OR?: ScenarioActionCombinedItemTreatmentsAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: ScenarioActionCombinedItemTreatmentsNodeAggregationWhereInput | null;
}

export interface ScenarioActionCombinedItemTreatmentsConnectionWhere {
  AND?: ScenarioActionCombinedItemTreatmentsConnectionWhere[] | null;
  OR?: ScenarioActionCombinedItemTreatmentsConnectionWhere[] | null;
  node?: TreatmentWhere | null;
  node_NOT?: TreatmentWhere | null;
}

export interface ScenarioActionCombinedItemTreatmentsNodeAggregationWhereInput {
  AND?: ScenarioActionCombinedItemTreatmentsNodeAggregationWhereInput[] | null;
  BagDossierNo_AVERAGE_EQUAL?: number | null;
  BagDossierNo_AVERAGE_GT?: number | null;
  BagDossierNo_AVERAGE_GTE?: number | null;
  BagDossierNo_AVERAGE_LT?: number | null;
  BagDossierNo_AVERAGE_LTE?: number | null;
  BagDossierNo_EQUAL?: string | null;
  BagDossierNo_GT?: number | null;
  BagDossierNo_GTE?: number | null;
  BagDossierNo_LONGEST_EQUAL?: number | null;
  BagDossierNo_LONGEST_GT?: number | null;
  BagDossierNo_LONGEST_GTE?: number | null;
  BagDossierNo_LONGEST_LT?: number | null;
  BagDossierNo_LONGEST_LTE?: number | null;
  BagDossierNo_LT?: number | null;
  BagDossierNo_LTE?: number | null;
  BagDossierNo_SHORTEST_EQUAL?: number | null;
  BagDossierNo_SHORTEST_GT?: number | null;
  BagDossierNo_SHORTEST_GTE?: number | null;
  BagDossierNo_SHORTEST_LT?: number | null;
  BagDossierNo_SHORTEST_LTE?: number | null;
  Code_AVERAGE_EQUAL?: number | null;
  Code_AVERAGE_GT?: number | null;
  Code_AVERAGE_GTE?: number | null;
  Code_AVERAGE_LT?: number | null;
  Code_AVERAGE_LTE?: number | null;
  Code_EQUAL?: string | null;
  Code_GT?: number | null;
  Code_GTE?: number | null;
  Code_LONGEST_EQUAL?: number | null;
  Code_LONGEST_GT?: number | null;
  Code_LONGEST_GTE?: number | null;
  Code_LONGEST_LT?: number | null;
  Code_LONGEST_LTE?: number | null;
  Code_LT?: number | null;
  Code_LTE?: number | null;
  Code_SHORTEST_EQUAL?: number | null;
  Code_SHORTEST_GT?: number | null;
  Code_SHORTEST_GTE?: number | null;
  Code_SHORTEST_LT?: number | null;
  Code_SHORTEST_LTE?: number | null;
  FlagModal_AVERAGE_EQUAL?: number | null;
  FlagModal_AVERAGE_GT?: number | null;
  FlagModal_AVERAGE_GTE?: number | null;
  FlagModal_AVERAGE_LT?: number | null;
  FlagModal_AVERAGE_LTE?: number | null;
  FlagModal_EQUAL?: string | null;
  FlagModal_GT?: number | null;
  FlagModal_GTE?: number | null;
  FlagModal_LONGEST_EQUAL?: number | null;
  FlagModal_LONGEST_GT?: number | null;
  FlagModal_LONGEST_GTE?: number | null;
  FlagModal_LONGEST_LT?: number | null;
  FlagModal_LONGEST_LTE?: number | null;
  FlagModal_LT?: number | null;
  FlagModal_LTE?: number | null;
  FlagModal_SHORTEST_EQUAL?: number | null;
  FlagModal_SHORTEST_GT?: number | null;
  FlagModal_SHORTEST_GTE?: number | null;
  FlagModal_SHORTEST_LT?: number | null;
  FlagModal_SHORTEST_LTE?: number | null;
  FlagNarcosis_AVERAGE_EQUAL?: number | null;
  FlagNarcosis_AVERAGE_GT?: number | null;
  FlagNarcosis_AVERAGE_GTE?: number | null;
  FlagNarcosis_AVERAGE_LT?: number | null;
  FlagNarcosis_AVERAGE_LTE?: number | null;
  FlagNarcosis_EQUAL?: string | null;
  FlagNarcosis_GT?: number | null;
  FlagNarcosis_GTE?: number | null;
  FlagNarcosis_LONGEST_EQUAL?: number | null;
  FlagNarcosis_LONGEST_GT?: number | null;
  FlagNarcosis_LONGEST_GTE?: number | null;
  FlagNarcosis_LONGEST_LT?: number | null;
  FlagNarcosis_LONGEST_LTE?: number | null;
  FlagNarcosis_LT?: number | null;
  FlagNarcosis_LTE?: number | null;
  FlagNarcosis_SHORTEST_EQUAL?: number | null;
  FlagNarcosis_SHORTEST_GT?: number | null;
  FlagNarcosis_SHORTEST_GTE?: number | null;
  FlagNarcosis_SHORTEST_LT?: number | null;
  FlagNarcosis_SHORTEST_LTE?: number | null;
  GTIN_AVERAGE_EQUAL?: number | null;
  GTIN_AVERAGE_GT?: number | null;
  GTIN_AVERAGE_GTE?: number | null;
  GTIN_AVERAGE_LT?: number | null;
  GTIN_AVERAGE_LTE?: number | null;
  GTIN_EQUAL?: string | null;
  GTIN_GT?: number | null;
  GTIN_GTE?: number | null;
  GTIN_LONGEST_EQUAL?: number | null;
  GTIN_LONGEST_GT?: number | null;
  GTIN_LONGEST_GTE?: number | null;
  GTIN_LONGEST_LT?: number | null;
  GTIN_LONGEST_LTE?: number | null;
  GTIN_LT?: number | null;
  GTIN_LTE?: number | null;
  GTIN_SHORTEST_EQUAL?: number | null;
  GTIN_SHORTEST_GT?: number | null;
  GTIN_SHORTEST_GTE?: number | null;
  GTIN_SHORTEST_LT?: number | null;
  GTIN_SHORTEST_LTE?: number | null;
  LOT_AVERAGE_EQUAL?: number | null;
  LOT_AVERAGE_GT?: number | null;
  LOT_AVERAGE_GTE?: number | null;
  LOT_AVERAGE_LT?: number | null;
  LOT_AVERAGE_LTE?: number | null;
  LOT_EQUAL?: string | null;
  LOT_GT?: number | null;
  LOT_GTE?: number | null;
  LOT_LONGEST_EQUAL?: number | null;
  LOT_LONGEST_GT?: number | null;
  LOT_LONGEST_GTE?: number | null;
  LOT_LONGEST_LT?: number | null;
  LOT_LONGEST_LTE?: number | null;
  LOT_LT?: number | null;
  LOT_LTE?: number | null;
  LOT_SHORTEST_EQUAL?: number | null;
  LOT_SHORTEST_GT?: number | null;
  LOT_SHORTEST_GTE?: number | null;
  LOT_SHORTEST_LT?: number | null;
  LOT_SHORTEST_LTE?: number | null;
  Name_AVERAGE_EQUAL?: number | null;
  Name_AVERAGE_GT?: number | null;
  Name_AVERAGE_GTE?: number | null;
  Name_AVERAGE_LT?: number | null;
  Name_AVERAGE_LTE?: number | null;
  Name_EQUAL?: string | null;
  Name_GT?: number | null;
  Name_GTE?: number | null;
  Name_LONGEST_EQUAL?: number | null;
  Name_LONGEST_GT?: number | null;
  Name_LONGEST_GTE?: number | null;
  Name_LONGEST_LT?: number | null;
  Name_LONGEST_LTE?: number | null;
  Name_LT?: number | null;
  Name_LTE?: number | null;
  Name_SHORTEST_EQUAL?: number | null;
  Name_SHORTEST_GT?: number | null;
  Name_SHORTEST_GTE?: number | null;
  Name_SHORTEST_LT?: number | null;
  Name_SHORTEST_LTE?: number | null;
  OR?: ScenarioActionCombinedItemTreatmentsNodeAggregationWhereInput[] | null;
  PharmaCode_AVERAGE_EQUAL?: number | null;
  PharmaCode_AVERAGE_GT?: number | null;
  PharmaCode_AVERAGE_GTE?: number | null;
  PharmaCode_AVERAGE_LT?: number | null;
  PharmaCode_AVERAGE_LTE?: number | null;
  PharmaCode_EQUAL?: string | null;
  PharmaCode_GT?: number | null;
  PharmaCode_GTE?: number | null;
  PharmaCode_LONGEST_EQUAL?: number | null;
  PharmaCode_LONGEST_GT?: number | null;
  PharmaCode_LONGEST_GTE?: number | null;
  PharmaCode_LONGEST_LT?: number | null;
  PharmaCode_LONGEST_LTE?: number | null;
  PharmaCode_LT?: number | null;
  PharmaCode_LTE?: number | null;
  PharmaCode_SHORTEST_EQUAL?: number | null;
  PharmaCode_SHORTEST_GT?: number | null;
  PharmaCode_SHORTEST_GTE?: number | null;
  PharmaCode_SHORTEST_LT?: number | null;
  PharmaCode_SHORTEST_LTE?: number | null;
  PrevPharmacode_AVERAGE_EQUAL?: number | null;
  PrevPharmacode_AVERAGE_GT?: number | null;
  PrevPharmacode_AVERAGE_GTE?: number | null;
  PrevPharmacode_AVERAGE_LT?: number | null;
  PrevPharmacode_AVERAGE_LTE?: number | null;
  PrevPharmacode_EQUAL?: string | null;
  PrevPharmacode_GT?: number | null;
  PrevPharmacode_GTE?: number | null;
  PrevPharmacode_LONGEST_EQUAL?: number | null;
  PrevPharmacode_LONGEST_GT?: number | null;
  PrevPharmacode_LONGEST_GTE?: number | null;
  PrevPharmacode_LONGEST_LT?: number | null;
  PrevPharmacode_LONGEST_LTE?: number | null;
  PrevPharmacode_LT?: number | null;
  PrevPharmacode_LTE?: number | null;
  PrevPharmacode_SHORTEST_EQUAL?: number | null;
  PrevPharmacode_SHORTEST_GT?: number | null;
  PrevPharmacode_SHORTEST_GTE?: number | null;
  PrevPharmacode_SHORTEST_LT?: number | null;
  PrevPharmacode_SHORTEST_LTE?: number | null;
  REF_AVERAGE_EQUAL?: number | null;
  REF_AVERAGE_GT?: number | null;
  REF_AVERAGE_GTE?: number | null;
  REF_AVERAGE_LT?: number | null;
  REF_AVERAGE_LTE?: number | null;
  REF_EQUAL?: string | null;
  REF_GT?: number | null;
  REF_GTE?: number | null;
  REF_LONGEST_EQUAL?: number | null;
  REF_LONGEST_GT?: number | null;
  REF_LONGEST_GTE?: number | null;
  REF_LONGEST_LT?: number | null;
  REF_LONGEST_LTE?: number | null;
  REF_LT?: number | null;
  REF_LTE?: number | null;
  REF_SHORTEST_EQUAL?: number | null;
  REF_SHORTEST_GT?: number | null;
  REF_SHORTEST_GTE?: number | null;
  REF_SHORTEST_LT?: number | null;
  REF_SHORTEST_LTE?: number | null;
  SwissmedicCategory_AVERAGE_EQUAL?: number | null;
  SwissmedicCategory_AVERAGE_GT?: number | null;
  SwissmedicCategory_AVERAGE_GTE?: number | null;
  SwissmedicCategory_AVERAGE_LT?: number | null;
  SwissmedicCategory_AVERAGE_LTE?: number | null;
  SwissmedicCategory_EQUAL?: string | null;
  SwissmedicCategory_GT?: number | null;
  SwissmedicCategory_GTE?: number | null;
  SwissmedicCategory_LONGEST_EQUAL?: number | null;
  SwissmedicCategory_LONGEST_GT?: number | null;
  SwissmedicCategory_LONGEST_GTE?: number | null;
  SwissmedicCategory_LONGEST_LT?: number | null;
  SwissmedicCategory_LONGEST_LTE?: number | null;
  SwissmedicCategory_LT?: number | null;
  SwissmedicCategory_LTE?: number | null;
  SwissmedicCategory_SHORTEST_EQUAL?: number | null;
  SwissmedicCategory_SHORTEST_GT?: number | null;
  SwissmedicCategory_SHORTEST_GTE?: number | null;
  SwissmedicCategory_SHORTEST_LT?: number | null;
  SwissmedicCategory_SHORTEST_LTE?: number | null;
  SwissmedicNo8_AVERAGE_EQUAL?: number | null;
  SwissmedicNo8_AVERAGE_GT?: number | null;
  SwissmedicNo8_AVERAGE_GTE?: number | null;
  SwissmedicNo8_AVERAGE_LT?: number | null;
  SwissmedicNo8_AVERAGE_LTE?: number | null;
  SwissmedicNo8_EQUAL?: string | null;
  SwissmedicNo8_GT?: number | null;
  SwissmedicNo8_GTE?: number | null;
  SwissmedicNo8_LONGEST_EQUAL?: number | null;
  SwissmedicNo8_LONGEST_GT?: number | null;
  SwissmedicNo8_LONGEST_GTE?: number | null;
  SwissmedicNo8_LONGEST_LT?: number | null;
  SwissmedicNo8_LONGEST_LTE?: number | null;
  SwissmedicNo8_LT?: number | null;
  SwissmedicNo8_LTE?: number | null;
  SwissmedicNo8_SHORTEST_EQUAL?: number | null;
  SwissmedicNo8_SHORTEST_GT?: number | null;
  SwissmedicNo8_SHORTEST_GTE?: number | null;
  SwissmedicNo8_SHORTEST_LT?: number | null;
  SwissmedicNo8_SHORTEST_LTE?: number | null;
  UDI_AVERAGE_EQUAL?: number | null;
  UDI_AVERAGE_GT?: number | null;
  UDI_AVERAGE_GTE?: number | null;
  UDI_AVERAGE_LT?: number | null;
  UDI_AVERAGE_LTE?: number | null;
  UDI_EQUAL?: string | null;
  UDI_GT?: number | null;
  UDI_GTE?: number | null;
  UDI_LONGEST_EQUAL?: number | null;
  UDI_LONGEST_GT?: number | null;
  UDI_LONGEST_GTE?: number | null;
  UDI_LONGEST_LT?: number | null;
  UDI_LONGEST_LTE?: number | null;
  UDI_LT?: number | null;
  UDI_LTE?: number | null;
  UDI_SHORTEST_EQUAL?: number | null;
  UDI_SHORTEST_GT?: number | null;
  UDI_SHORTEST_GTE?: number | null;
  UDI_SHORTEST_LT?: number | null;
  UDI_SHORTEST_LTE?: number | null;
  activeIngredientQuantity_AVERAGE_EQUAL?: number | null;
  activeIngredientQuantity_AVERAGE_GT?: number | null;
  activeIngredientQuantity_AVERAGE_GTE?: number | null;
  activeIngredientQuantity_AVERAGE_LT?: number | null;
  activeIngredientQuantity_AVERAGE_LTE?: number | null;
  activeIngredientQuantity_EQUAL?: number | null;
  activeIngredientQuantity_GT?: number | null;
  activeIngredientQuantity_GTE?: number | null;
  activeIngredientQuantity_LT?: number | null;
  activeIngredientQuantity_LTE?: number | null;
  activeIngredientQuantity_MAX_EQUAL?: number | null;
  activeIngredientQuantity_MAX_GT?: number | null;
  activeIngredientQuantity_MAX_GTE?: number | null;
  activeIngredientQuantity_MAX_LT?: number | null;
  activeIngredientQuantity_MAX_LTE?: number | null;
  activeIngredientQuantity_MIN_EQUAL?: number | null;
  activeIngredientQuantity_MIN_GT?: number | null;
  activeIngredientQuantity_MIN_GTE?: number | null;
  activeIngredientQuantity_MIN_LT?: number | null;
  activeIngredientQuantity_MIN_LTE?: number | null;
  activeIngredientQuantity_SUM_EQUAL?: number | null;
  activeIngredientQuantity_SUM_GT?: number | null;
  activeIngredientQuantity_SUM_GTE?: number | null;
  activeIngredientQuantity_SUM_LT?: number | null;
  activeIngredientQuantity_SUM_LTE?: number | null;
  classificationSystem_AVERAGE_EQUAL?: number | null;
  classificationSystem_AVERAGE_GT?: number | null;
  classificationSystem_AVERAGE_GTE?: number | null;
  classificationSystem_AVERAGE_LT?: number | null;
  classificationSystem_AVERAGE_LTE?: number | null;
  classificationSystem_EQUAL?: string | null;
  classificationSystem_GT?: number | null;
  classificationSystem_GTE?: number | null;
  classificationSystem_LONGEST_EQUAL?: number | null;
  classificationSystem_LONGEST_GT?: number | null;
  classificationSystem_LONGEST_GTE?: number | null;
  classificationSystem_LONGEST_LT?: number | null;
  classificationSystem_LONGEST_LTE?: number | null;
  classificationSystem_LT?: number | null;
  classificationSystem_LTE?: number | null;
  classificationSystem_SHORTEST_EQUAL?: number | null;
  classificationSystem_SHORTEST_GT?: number | null;
  classificationSystem_SHORTEST_GTE?: number | null;
  classificationSystem_SHORTEST_LT?: number | null;
  classificationSystem_SHORTEST_LTE?: number | null;
  concentration_AVERAGE_EQUAL?: number | null;
  concentration_AVERAGE_GT?: number | null;
  concentration_AVERAGE_GTE?: number | null;
  concentration_AVERAGE_LT?: number | null;
  concentration_AVERAGE_LTE?: number | null;
  concentration_EQUAL?: string | null;
  concentration_GT?: number | null;
  concentration_GTE?: number | null;
  concentration_LONGEST_EQUAL?: number | null;
  concentration_LONGEST_GT?: number | null;
  concentration_LONGEST_GTE?: number | null;
  concentration_LONGEST_LT?: number | null;
  concentration_LONGEST_LTE?: number | null;
  concentration_LT?: number | null;
  concentration_LTE?: number | null;
  concentration_SHORTEST_EQUAL?: number | null;
  concentration_SHORTEST_GT?: number | null;
  concentration_SHORTEST_GTE?: number | null;
  concentration_SHORTEST_LT?: number | null;
  concentration_SHORTEST_LTE?: number | null;
  packVolume_AVERAGE_EQUAL?: number | null;
  packVolume_AVERAGE_GT?: number | null;
  packVolume_AVERAGE_GTE?: number | null;
  packVolume_AVERAGE_LT?: number | null;
  packVolume_AVERAGE_LTE?: number | null;
  packVolume_EQUAL?: string | null;
  packVolume_GT?: number | null;
  packVolume_GTE?: number | null;
  packVolume_LONGEST_EQUAL?: number | null;
  packVolume_LONGEST_GT?: number | null;
  packVolume_LONGEST_GTE?: number | null;
  packVolume_LONGEST_LT?: number | null;
  packVolume_LONGEST_LTE?: number | null;
  packVolume_LT?: number | null;
  packVolume_LTE?: number | null;
  packVolume_SHORTEST_EQUAL?: number | null;
  packVolume_SHORTEST_GT?: number | null;
  packVolume_SHORTEST_GTE?: number | null;
  packVolume_SHORTEST_LT?: number | null;
  packVolume_SHORTEST_LTE?: number | null;
}

export interface ScenarioActionCycleAggregateInput {
  AND?: ScenarioActionCycleAggregateInput[] | null;
  OR?: ScenarioActionCycleAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: ScenarioActionCycleNodeAggregationWhereInput | null;
}

export interface ScenarioActionCycleConnectionWhere {
  AND?: ScenarioActionCycleConnectionWhere[] | null;
  OR?: ScenarioActionCycleConnectionWhere[] | null;
  node?: CycleConfigurationWhere | null;
  node_NOT?: CycleConfigurationWhere | null;
}

export interface ScenarioActionCycleNodeAggregationWhereInput {
  AND?: ScenarioActionCycleNodeAggregationWhereInput[] | null;
  OR?: ScenarioActionCycleNodeAggregationWhereInput[] | null;
  lengthFrom_AVERAGE_EQUAL?: number | null;
  lengthFrom_AVERAGE_GT?: number | null;
  lengthFrom_AVERAGE_GTE?: number | null;
  lengthFrom_AVERAGE_LT?: number | null;
  lengthFrom_AVERAGE_LTE?: number | null;
  lengthFrom_EQUAL?: number | null;
  lengthFrom_GT?: number | null;
  lengthFrom_GTE?: number | null;
  lengthFrom_LT?: number | null;
  lengthFrom_LTE?: number | null;
  lengthFrom_MAX_EQUAL?: number | null;
  lengthFrom_MAX_GT?: number | null;
  lengthFrom_MAX_GTE?: number | null;
  lengthFrom_MAX_LT?: number | null;
  lengthFrom_MAX_LTE?: number | null;
  lengthFrom_MIN_EQUAL?: number | null;
  lengthFrom_MIN_GT?: number | null;
  lengthFrom_MIN_GTE?: number | null;
  lengthFrom_MIN_LT?: number | null;
  lengthFrom_MIN_LTE?: number | null;
  lengthFrom_SUM_EQUAL?: number | null;
  lengthFrom_SUM_GT?: number | null;
  lengthFrom_SUM_GTE?: number | null;
  lengthFrom_SUM_LT?: number | null;
  lengthFrom_SUM_LTE?: number | null;
  lengthTo_AVERAGE_EQUAL?: number | null;
  lengthTo_AVERAGE_GT?: number | null;
  lengthTo_AVERAGE_GTE?: number | null;
  lengthTo_AVERAGE_LT?: number | null;
  lengthTo_AVERAGE_LTE?: number | null;
  lengthTo_EQUAL?: number | null;
  lengthTo_GT?: number | null;
  lengthTo_GTE?: number | null;
  lengthTo_LT?: number | null;
  lengthTo_LTE?: number | null;
  lengthTo_MAX_EQUAL?: number | null;
  lengthTo_MAX_GT?: number | null;
  lengthTo_MAX_GTE?: number | null;
  lengthTo_MAX_LT?: number | null;
  lengthTo_MAX_LTE?: number | null;
  lengthTo_MIN_EQUAL?: number | null;
  lengthTo_MIN_GT?: number | null;
  lengthTo_MIN_GTE?: number | null;
  lengthTo_MIN_LT?: number | null;
  lengthTo_MIN_LTE?: number | null;
  lengthTo_SUM_EQUAL?: number | null;
  lengthTo_SUM_GT?: number | null;
  lengthTo_SUM_GTE?: number | null;
  lengthTo_SUM_LT?: number | null;
  lengthTo_SUM_LTE?: number | null;
  name_AVERAGE_EQUAL?: number | null;
  name_AVERAGE_GT?: number | null;
  name_AVERAGE_GTE?: number | null;
  name_AVERAGE_LT?: number | null;
  name_AVERAGE_LTE?: number | null;
  name_EQUAL?: string | null;
  name_GT?: number | null;
  name_GTE?: number | null;
  name_LONGEST_EQUAL?: number | null;
  name_LONGEST_GT?: number | null;
  name_LONGEST_GTE?: number | null;
  name_LONGEST_LT?: number | null;
  name_LONGEST_LTE?: number | null;
  name_LT?: number | null;
  name_LTE?: number | null;
  name_SHORTEST_EQUAL?: number | null;
  name_SHORTEST_GT?: number | null;
  name_SHORTEST_GTE?: number | null;
  name_SHORTEST_LT?: number | null;
  name_SHORTEST_LTE?: number | null;
  order_AVERAGE_EQUAL?: number | null;
  order_AVERAGE_GT?: number | null;
  order_AVERAGE_GTE?: number | null;
  order_AVERAGE_LT?: number | null;
  order_AVERAGE_LTE?: number | null;
  order_EQUAL?: number | null;
  order_GT?: number | null;
  order_GTE?: number | null;
  order_LT?: number | null;
  order_LTE?: number | null;
  order_MAX_EQUAL?: number | null;
  order_MAX_GT?: number | null;
  order_MAX_GTE?: number | null;
  order_MAX_LT?: number | null;
  order_MAX_LTE?: number | null;
  order_MIN_EQUAL?: number | null;
  order_MIN_GT?: number | null;
  order_MIN_GTE?: number | null;
  order_MIN_LT?: number | null;
  order_MIN_LTE?: number | null;
  order_SUM_EQUAL?: number | null;
  order_SUM_GT?: number | null;
  order_SUM_GTE?: number | null;
  order_SUM_LT?: number | null;
  order_SUM_LTE?: number | null;
}

export interface ScenarioActionGenericsAggregateInput {
  AND?: ScenarioActionGenericsAggregateInput[] | null;
  OR?: ScenarioActionGenericsAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  edge?: ScenarioActionGenericsEdgeAggregationWhereInput | null;
  node?: ScenarioActionGenericsNodeAggregationWhereInput | null;
}

export interface ScenarioActionGenericsConnectionWhere {
  AND?: ScenarioActionGenericsConnectionWhere[] | null;
  OR?: ScenarioActionGenericsConnectionWhere[] | null;
  edge?: ActionPrescriptionRelationshipWhere | null;
  edge_NOT?: ActionPrescriptionRelationshipWhere | null;
  node?: GenericWhere | null;
  node_NOT?: GenericWhere | null;
}

export interface ScenarioActionGenericsEdgeAggregationWhereInput {
  AND?: ScenarioActionGenericsEdgeAggregationWhereInput[] | null;
  OR?: ScenarioActionGenericsEdgeAggregationWhereInput[] | null;
  order_AVERAGE_EQUAL?: number | null;
  order_AVERAGE_GT?: number | null;
  order_AVERAGE_GTE?: number | null;
  order_AVERAGE_LT?: number | null;
  order_AVERAGE_LTE?: number | null;
  order_EQUAL?: number | null;
  order_GT?: number | null;
  order_GTE?: number | null;
  order_LT?: number | null;
  order_LTE?: number | null;
  order_MAX_EQUAL?: number | null;
  order_MAX_GT?: number | null;
  order_MAX_GTE?: number | null;
  order_MAX_LT?: number | null;
  order_MAX_LTE?: number | null;
  order_MIN_EQUAL?: number | null;
  order_MIN_GT?: number | null;
  order_MIN_GTE?: number | null;
  order_MIN_LT?: number | null;
  order_MIN_LTE?: number | null;
  order_SUM_EQUAL?: number | null;
  order_SUM_GT?: number | null;
  order_SUM_GTE?: number | null;
  order_SUM_LT?: number | null;
  order_SUM_LTE?: number | null;
}

export interface ScenarioActionGenericsNodeAggregationWhereInput {
  AND?: ScenarioActionGenericsNodeAggregationWhereInput[] | null;
  Name_AVERAGE_EQUAL?: number | null;
  Name_AVERAGE_GT?: number | null;
  Name_AVERAGE_GTE?: number | null;
  Name_AVERAGE_LT?: number | null;
  Name_AVERAGE_LTE?: number | null;
  Name_EQUAL?: string | null;
  Name_GT?: number | null;
  Name_GTE?: number | null;
  Name_LONGEST_EQUAL?: number | null;
  Name_LONGEST_GT?: number | null;
  Name_LONGEST_GTE?: number | null;
  Name_LONGEST_LT?: number | null;
  Name_LONGEST_LTE?: number | null;
  Name_LT?: number | null;
  Name_LTE?: number | null;
  Name_SHORTEST_EQUAL?: number | null;
  Name_SHORTEST_GT?: number | null;
  Name_SHORTEST_GTE?: number | null;
  Name_SHORTEST_LT?: number | null;
  Name_SHORTEST_LTE?: number | null;
  OR?: ScenarioActionGenericsNodeAggregationWhereInput[] | null;
  id_EQUAL?: string | null;
}

export interface ScenarioActionScenarioAggregateInput {
  AND?: ScenarioActionScenarioAggregateInput[] | null;
  OR?: ScenarioActionScenarioAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: ScenarioActionScenarioNodeAggregationWhereInput | null;
}

export interface ScenarioActionScenarioConnectionWhere {
  AND?: ScenarioActionScenarioConnectionWhere[] | null;
  OR?: ScenarioActionScenarioConnectionWhere[] | null;
  node?: ScenarioWhere | null;
  node_NOT?: ScenarioWhere | null;
}

export interface ScenarioActionScenarioNodeAggregationWhereInput {
  AND?: ScenarioActionScenarioNodeAggregationWhereInput[] | null;
  OR?: ScenarioActionScenarioNodeAggregationWhereInput[] | null;
  group_AVERAGE_EQUAL?: number | null;
  group_AVERAGE_GT?: number | null;
  group_AVERAGE_GTE?: number | null;
  group_AVERAGE_LT?: number | null;
  group_AVERAGE_LTE?: number | null;
  group_EQUAL?: number | null;
  group_GT?: number | null;
  group_GTE?: number | null;
  group_LT?: number | null;
  group_LTE?: number | null;
  group_MAX_EQUAL?: number | null;
  group_MAX_GT?: number | null;
  group_MAX_GTE?: number | null;
  group_MAX_LT?: number | null;
  group_MAX_LTE?: number | null;
  group_MIN_EQUAL?: number | null;
  group_MIN_GT?: number | null;
  group_MIN_GTE?: number | null;
  group_MIN_LT?: number | null;
  group_MIN_LTE?: number | null;
  group_SUM_EQUAL?: number | null;
  group_SUM_GT?: number | null;
  group_SUM_GTE?: number | null;
  group_SUM_LT?: number | null;
  group_SUM_LTE?: number | null;
  order_AVERAGE_EQUAL?: number | null;
  order_AVERAGE_GT?: number | null;
  order_AVERAGE_GTE?: number | null;
  order_AVERAGE_LT?: number | null;
  order_AVERAGE_LTE?: number | null;
  order_EQUAL?: number | null;
  order_GT?: number | null;
  order_GTE?: number | null;
  order_LT?: number | null;
  order_LTE?: number | null;
  order_MAX_EQUAL?: number | null;
  order_MAX_GT?: number | null;
  order_MAX_GTE?: number | null;
  order_MAX_LT?: number | null;
  order_MAX_LTE?: number | null;
  order_MIN_EQUAL?: number | null;
  order_MIN_GT?: number | null;
  order_MIN_GTE?: number | null;
  order_MIN_LT?: number | null;
  order_MIN_LTE?: number | null;
  order_SUM_EQUAL?: number | null;
  order_SUM_GT?: number | null;
  order_SUM_GTE?: number | null;
  order_SUM_LT?: number | null;
  order_SUM_LTE?: number | null;
}

export interface ScenarioActionTreatmentsAggregateInput {
  AND?: ScenarioActionTreatmentsAggregateInput[] | null;
  OR?: ScenarioActionTreatmentsAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  edge?: ScenarioActionTreatmentsEdgeAggregationWhereInput | null;
  node?: ScenarioActionTreatmentsNodeAggregationWhereInput | null;
}

export interface ScenarioActionTreatmentsConnectionWhere {
  AND?: ScenarioActionTreatmentsConnectionWhere[] | null;
  OR?: ScenarioActionTreatmentsConnectionWhere[] | null;
  edge?: ActionPrescriptionRelationshipWhere | null;
  edge_NOT?: ActionPrescriptionRelationshipWhere | null;
  node?: TreatmentWhere | null;
  node_NOT?: TreatmentWhere | null;
}

export interface ScenarioActionTreatmentsEdgeAggregationWhereInput {
  AND?: ScenarioActionTreatmentsEdgeAggregationWhereInput[] | null;
  OR?: ScenarioActionTreatmentsEdgeAggregationWhereInput[] | null;
  order_AVERAGE_EQUAL?: number | null;
  order_AVERAGE_GT?: number | null;
  order_AVERAGE_GTE?: number | null;
  order_AVERAGE_LT?: number | null;
  order_AVERAGE_LTE?: number | null;
  order_EQUAL?: number | null;
  order_GT?: number | null;
  order_GTE?: number | null;
  order_LT?: number | null;
  order_LTE?: number | null;
  order_MAX_EQUAL?: number | null;
  order_MAX_GT?: number | null;
  order_MAX_GTE?: number | null;
  order_MAX_LT?: number | null;
  order_MAX_LTE?: number | null;
  order_MIN_EQUAL?: number | null;
  order_MIN_GT?: number | null;
  order_MIN_GTE?: number | null;
  order_MIN_LT?: number | null;
  order_MIN_LTE?: number | null;
  order_SUM_EQUAL?: number | null;
  order_SUM_GT?: number | null;
  order_SUM_GTE?: number | null;
  order_SUM_LT?: number | null;
  order_SUM_LTE?: number | null;
}

export interface ScenarioActionTreatmentsNodeAggregationWhereInput {
  AND?: ScenarioActionTreatmentsNodeAggregationWhereInput[] | null;
  BagDossierNo_AVERAGE_EQUAL?: number | null;
  BagDossierNo_AVERAGE_GT?: number | null;
  BagDossierNo_AVERAGE_GTE?: number | null;
  BagDossierNo_AVERAGE_LT?: number | null;
  BagDossierNo_AVERAGE_LTE?: number | null;
  BagDossierNo_EQUAL?: string | null;
  BagDossierNo_GT?: number | null;
  BagDossierNo_GTE?: number | null;
  BagDossierNo_LONGEST_EQUAL?: number | null;
  BagDossierNo_LONGEST_GT?: number | null;
  BagDossierNo_LONGEST_GTE?: number | null;
  BagDossierNo_LONGEST_LT?: number | null;
  BagDossierNo_LONGEST_LTE?: number | null;
  BagDossierNo_LT?: number | null;
  BagDossierNo_LTE?: number | null;
  BagDossierNo_SHORTEST_EQUAL?: number | null;
  BagDossierNo_SHORTEST_GT?: number | null;
  BagDossierNo_SHORTEST_GTE?: number | null;
  BagDossierNo_SHORTEST_LT?: number | null;
  BagDossierNo_SHORTEST_LTE?: number | null;
  Code_AVERAGE_EQUAL?: number | null;
  Code_AVERAGE_GT?: number | null;
  Code_AVERAGE_GTE?: number | null;
  Code_AVERAGE_LT?: number | null;
  Code_AVERAGE_LTE?: number | null;
  Code_EQUAL?: string | null;
  Code_GT?: number | null;
  Code_GTE?: number | null;
  Code_LONGEST_EQUAL?: number | null;
  Code_LONGEST_GT?: number | null;
  Code_LONGEST_GTE?: number | null;
  Code_LONGEST_LT?: number | null;
  Code_LONGEST_LTE?: number | null;
  Code_LT?: number | null;
  Code_LTE?: number | null;
  Code_SHORTEST_EQUAL?: number | null;
  Code_SHORTEST_GT?: number | null;
  Code_SHORTEST_GTE?: number | null;
  Code_SHORTEST_LT?: number | null;
  Code_SHORTEST_LTE?: number | null;
  FlagModal_AVERAGE_EQUAL?: number | null;
  FlagModal_AVERAGE_GT?: number | null;
  FlagModal_AVERAGE_GTE?: number | null;
  FlagModal_AVERAGE_LT?: number | null;
  FlagModal_AVERAGE_LTE?: number | null;
  FlagModal_EQUAL?: string | null;
  FlagModal_GT?: number | null;
  FlagModal_GTE?: number | null;
  FlagModal_LONGEST_EQUAL?: number | null;
  FlagModal_LONGEST_GT?: number | null;
  FlagModal_LONGEST_GTE?: number | null;
  FlagModal_LONGEST_LT?: number | null;
  FlagModal_LONGEST_LTE?: number | null;
  FlagModal_LT?: number | null;
  FlagModal_LTE?: number | null;
  FlagModal_SHORTEST_EQUAL?: number | null;
  FlagModal_SHORTEST_GT?: number | null;
  FlagModal_SHORTEST_GTE?: number | null;
  FlagModal_SHORTEST_LT?: number | null;
  FlagModal_SHORTEST_LTE?: number | null;
  FlagNarcosis_AVERAGE_EQUAL?: number | null;
  FlagNarcosis_AVERAGE_GT?: number | null;
  FlagNarcosis_AVERAGE_GTE?: number | null;
  FlagNarcosis_AVERAGE_LT?: number | null;
  FlagNarcosis_AVERAGE_LTE?: number | null;
  FlagNarcosis_EQUAL?: string | null;
  FlagNarcosis_GT?: number | null;
  FlagNarcosis_GTE?: number | null;
  FlagNarcosis_LONGEST_EQUAL?: number | null;
  FlagNarcosis_LONGEST_GT?: number | null;
  FlagNarcosis_LONGEST_GTE?: number | null;
  FlagNarcosis_LONGEST_LT?: number | null;
  FlagNarcosis_LONGEST_LTE?: number | null;
  FlagNarcosis_LT?: number | null;
  FlagNarcosis_LTE?: number | null;
  FlagNarcosis_SHORTEST_EQUAL?: number | null;
  FlagNarcosis_SHORTEST_GT?: number | null;
  FlagNarcosis_SHORTEST_GTE?: number | null;
  FlagNarcosis_SHORTEST_LT?: number | null;
  FlagNarcosis_SHORTEST_LTE?: number | null;
  GTIN_AVERAGE_EQUAL?: number | null;
  GTIN_AVERAGE_GT?: number | null;
  GTIN_AVERAGE_GTE?: number | null;
  GTIN_AVERAGE_LT?: number | null;
  GTIN_AVERAGE_LTE?: number | null;
  GTIN_EQUAL?: string | null;
  GTIN_GT?: number | null;
  GTIN_GTE?: number | null;
  GTIN_LONGEST_EQUAL?: number | null;
  GTIN_LONGEST_GT?: number | null;
  GTIN_LONGEST_GTE?: number | null;
  GTIN_LONGEST_LT?: number | null;
  GTIN_LONGEST_LTE?: number | null;
  GTIN_LT?: number | null;
  GTIN_LTE?: number | null;
  GTIN_SHORTEST_EQUAL?: number | null;
  GTIN_SHORTEST_GT?: number | null;
  GTIN_SHORTEST_GTE?: number | null;
  GTIN_SHORTEST_LT?: number | null;
  GTIN_SHORTEST_LTE?: number | null;
  LOT_AVERAGE_EQUAL?: number | null;
  LOT_AVERAGE_GT?: number | null;
  LOT_AVERAGE_GTE?: number | null;
  LOT_AVERAGE_LT?: number | null;
  LOT_AVERAGE_LTE?: number | null;
  LOT_EQUAL?: string | null;
  LOT_GT?: number | null;
  LOT_GTE?: number | null;
  LOT_LONGEST_EQUAL?: number | null;
  LOT_LONGEST_GT?: number | null;
  LOT_LONGEST_GTE?: number | null;
  LOT_LONGEST_LT?: number | null;
  LOT_LONGEST_LTE?: number | null;
  LOT_LT?: number | null;
  LOT_LTE?: number | null;
  LOT_SHORTEST_EQUAL?: number | null;
  LOT_SHORTEST_GT?: number | null;
  LOT_SHORTEST_GTE?: number | null;
  LOT_SHORTEST_LT?: number | null;
  LOT_SHORTEST_LTE?: number | null;
  Name_AVERAGE_EQUAL?: number | null;
  Name_AVERAGE_GT?: number | null;
  Name_AVERAGE_GTE?: number | null;
  Name_AVERAGE_LT?: number | null;
  Name_AVERAGE_LTE?: number | null;
  Name_EQUAL?: string | null;
  Name_GT?: number | null;
  Name_GTE?: number | null;
  Name_LONGEST_EQUAL?: number | null;
  Name_LONGEST_GT?: number | null;
  Name_LONGEST_GTE?: number | null;
  Name_LONGEST_LT?: number | null;
  Name_LONGEST_LTE?: number | null;
  Name_LT?: number | null;
  Name_LTE?: number | null;
  Name_SHORTEST_EQUAL?: number | null;
  Name_SHORTEST_GT?: number | null;
  Name_SHORTEST_GTE?: number | null;
  Name_SHORTEST_LT?: number | null;
  Name_SHORTEST_LTE?: number | null;
  OR?: ScenarioActionTreatmentsNodeAggregationWhereInput[] | null;
  PharmaCode_AVERAGE_EQUAL?: number | null;
  PharmaCode_AVERAGE_GT?: number | null;
  PharmaCode_AVERAGE_GTE?: number | null;
  PharmaCode_AVERAGE_LT?: number | null;
  PharmaCode_AVERAGE_LTE?: number | null;
  PharmaCode_EQUAL?: string | null;
  PharmaCode_GT?: number | null;
  PharmaCode_GTE?: number | null;
  PharmaCode_LONGEST_EQUAL?: number | null;
  PharmaCode_LONGEST_GT?: number | null;
  PharmaCode_LONGEST_GTE?: number | null;
  PharmaCode_LONGEST_LT?: number | null;
  PharmaCode_LONGEST_LTE?: number | null;
  PharmaCode_LT?: number | null;
  PharmaCode_LTE?: number | null;
  PharmaCode_SHORTEST_EQUAL?: number | null;
  PharmaCode_SHORTEST_GT?: number | null;
  PharmaCode_SHORTEST_GTE?: number | null;
  PharmaCode_SHORTEST_LT?: number | null;
  PharmaCode_SHORTEST_LTE?: number | null;
  PrevPharmacode_AVERAGE_EQUAL?: number | null;
  PrevPharmacode_AVERAGE_GT?: number | null;
  PrevPharmacode_AVERAGE_GTE?: number | null;
  PrevPharmacode_AVERAGE_LT?: number | null;
  PrevPharmacode_AVERAGE_LTE?: number | null;
  PrevPharmacode_EQUAL?: string | null;
  PrevPharmacode_GT?: number | null;
  PrevPharmacode_GTE?: number | null;
  PrevPharmacode_LONGEST_EQUAL?: number | null;
  PrevPharmacode_LONGEST_GT?: number | null;
  PrevPharmacode_LONGEST_GTE?: number | null;
  PrevPharmacode_LONGEST_LT?: number | null;
  PrevPharmacode_LONGEST_LTE?: number | null;
  PrevPharmacode_LT?: number | null;
  PrevPharmacode_LTE?: number | null;
  PrevPharmacode_SHORTEST_EQUAL?: number | null;
  PrevPharmacode_SHORTEST_GT?: number | null;
  PrevPharmacode_SHORTEST_GTE?: number | null;
  PrevPharmacode_SHORTEST_LT?: number | null;
  PrevPharmacode_SHORTEST_LTE?: number | null;
  REF_AVERAGE_EQUAL?: number | null;
  REF_AVERAGE_GT?: number | null;
  REF_AVERAGE_GTE?: number | null;
  REF_AVERAGE_LT?: number | null;
  REF_AVERAGE_LTE?: number | null;
  REF_EQUAL?: string | null;
  REF_GT?: number | null;
  REF_GTE?: number | null;
  REF_LONGEST_EQUAL?: number | null;
  REF_LONGEST_GT?: number | null;
  REF_LONGEST_GTE?: number | null;
  REF_LONGEST_LT?: number | null;
  REF_LONGEST_LTE?: number | null;
  REF_LT?: number | null;
  REF_LTE?: number | null;
  REF_SHORTEST_EQUAL?: number | null;
  REF_SHORTEST_GT?: number | null;
  REF_SHORTEST_GTE?: number | null;
  REF_SHORTEST_LT?: number | null;
  REF_SHORTEST_LTE?: number | null;
  SwissmedicCategory_AVERAGE_EQUAL?: number | null;
  SwissmedicCategory_AVERAGE_GT?: number | null;
  SwissmedicCategory_AVERAGE_GTE?: number | null;
  SwissmedicCategory_AVERAGE_LT?: number | null;
  SwissmedicCategory_AVERAGE_LTE?: number | null;
  SwissmedicCategory_EQUAL?: string | null;
  SwissmedicCategory_GT?: number | null;
  SwissmedicCategory_GTE?: number | null;
  SwissmedicCategory_LONGEST_EQUAL?: number | null;
  SwissmedicCategory_LONGEST_GT?: number | null;
  SwissmedicCategory_LONGEST_GTE?: number | null;
  SwissmedicCategory_LONGEST_LT?: number | null;
  SwissmedicCategory_LONGEST_LTE?: number | null;
  SwissmedicCategory_LT?: number | null;
  SwissmedicCategory_LTE?: number | null;
  SwissmedicCategory_SHORTEST_EQUAL?: number | null;
  SwissmedicCategory_SHORTEST_GT?: number | null;
  SwissmedicCategory_SHORTEST_GTE?: number | null;
  SwissmedicCategory_SHORTEST_LT?: number | null;
  SwissmedicCategory_SHORTEST_LTE?: number | null;
  SwissmedicNo8_AVERAGE_EQUAL?: number | null;
  SwissmedicNo8_AVERAGE_GT?: number | null;
  SwissmedicNo8_AVERAGE_GTE?: number | null;
  SwissmedicNo8_AVERAGE_LT?: number | null;
  SwissmedicNo8_AVERAGE_LTE?: number | null;
  SwissmedicNo8_EQUAL?: string | null;
  SwissmedicNo8_GT?: number | null;
  SwissmedicNo8_GTE?: number | null;
  SwissmedicNo8_LONGEST_EQUAL?: number | null;
  SwissmedicNo8_LONGEST_GT?: number | null;
  SwissmedicNo8_LONGEST_GTE?: number | null;
  SwissmedicNo8_LONGEST_LT?: number | null;
  SwissmedicNo8_LONGEST_LTE?: number | null;
  SwissmedicNo8_LT?: number | null;
  SwissmedicNo8_LTE?: number | null;
  SwissmedicNo8_SHORTEST_EQUAL?: number | null;
  SwissmedicNo8_SHORTEST_GT?: number | null;
  SwissmedicNo8_SHORTEST_GTE?: number | null;
  SwissmedicNo8_SHORTEST_LT?: number | null;
  SwissmedicNo8_SHORTEST_LTE?: number | null;
  UDI_AVERAGE_EQUAL?: number | null;
  UDI_AVERAGE_GT?: number | null;
  UDI_AVERAGE_GTE?: number | null;
  UDI_AVERAGE_LT?: number | null;
  UDI_AVERAGE_LTE?: number | null;
  UDI_EQUAL?: string | null;
  UDI_GT?: number | null;
  UDI_GTE?: number | null;
  UDI_LONGEST_EQUAL?: number | null;
  UDI_LONGEST_GT?: number | null;
  UDI_LONGEST_GTE?: number | null;
  UDI_LONGEST_LT?: number | null;
  UDI_LONGEST_LTE?: number | null;
  UDI_LT?: number | null;
  UDI_LTE?: number | null;
  UDI_SHORTEST_EQUAL?: number | null;
  UDI_SHORTEST_GT?: number | null;
  UDI_SHORTEST_GTE?: number | null;
  UDI_SHORTEST_LT?: number | null;
  UDI_SHORTEST_LTE?: number | null;
  activeIngredientQuantity_AVERAGE_EQUAL?: number | null;
  activeIngredientQuantity_AVERAGE_GT?: number | null;
  activeIngredientQuantity_AVERAGE_GTE?: number | null;
  activeIngredientQuantity_AVERAGE_LT?: number | null;
  activeIngredientQuantity_AVERAGE_LTE?: number | null;
  activeIngredientQuantity_EQUAL?: number | null;
  activeIngredientQuantity_GT?: number | null;
  activeIngredientQuantity_GTE?: number | null;
  activeIngredientQuantity_LT?: number | null;
  activeIngredientQuantity_LTE?: number | null;
  activeIngredientQuantity_MAX_EQUAL?: number | null;
  activeIngredientQuantity_MAX_GT?: number | null;
  activeIngredientQuantity_MAX_GTE?: number | null;
  activeIngredientQuantity_MAX_LT?: number | null;
  activeIngredientQuantity_MAX_LTE?: number | null;
  activeIngredientQuantity_MIN_EQUAL?: number | null;
  activeIngredientQuantity_MIN_GT?: number | null;
  activeIngredientQuantity_MIN_GTE?: number | null;
  activeIngredientQuantity_MIN_LT?: number | null;
  activeIngredientQuantity_MIN_LTE?: number | null;
  activeIngredientQuantity_SUM_EQUAL?: number | null;
  activeIngredientQuantity_SUM_GT?: number | null;
  activeIngredientQuantity_SUM_GTE?: number | null;
  activeIngredientQuantity_SUM_LT?: number | null;
  activeIngredientQuantity_SUM_LTE?: number | null;
  classificationSystem_AVERAGE_EQUAL?: number | null;
  classificationSystem_AVERAGE_GT?: number | null;
  classificationSystem_AVERAGE_GTE?: number | null;
  classificationSystem_AVERAGE_LT?: number | null;
  classificationSystem_AVERAGE_LTE?: number | null;
  classificationSystem_EQUAL?: string | null;
  classificationSystem_GT?: number | null;
  classificationSystem_GTE?: number | null;
  classificationSystem_LONGEST_EQUAL?: number | null;
  classificationSystem_LONGEST_GT?: number | null;
  classificationSystem_LONGEST_GTE?: number | null;
  classificationSystem_LONGEST_LT?: number | null;
  classificationSystem_LONGEST_LTE?: number | null;
  classificationSystem_LT?: number | null;
  classificationSystem_LTE?: number | null;
  classificationSystem_SHORTEST_EQUAL?: number | null;
  classificationSystem_SHORTEST_GT?: number | null;
  classificationSystem_SHORTEST_GTE?: number | null;
  classificationSystem_SHORTEST_LT?: number | null;
  classificationSystem_SHORTEST_LTE?: number | null;
  concentration_AVERAGE_EQUAL?: number | null;
  concentration_AVERAGE_GT?: number | null;
  concentration_AVERAGE_GTE?: number | null;
  concentration_AVERAGE_LT?: number | null;
  concentration_AVERAGE_LTE?: number | null;
  concentration_EQUAL?: string | null;
  concentration_GT?: number | null;
  concentration_GTE?: number | null;
  concentration_LONGEST_EQUAL?: number | null;
  concentration_LONGEST_GT?: number | null;
  concentration_LONGEST_GTE?: number | null;
  concentration_LONGEST_LT?: number | null;
  concentration_LONGEST_LTE?: number | null;
  concentration_LT?: number | null;
  concentration_LTE?: number | null;
  concentration_SHORTEST_EQUAL?: number | null;
  concentration_SHORTEST_GT?: number | null;
  concentration_SHORTEST_GTE?: number | null;
  concentration_SHORTEST_LT?: number | null;
  concentration_SHORTEST_LTE?: number | null;
  packVolume_AVERAGE_EQUAL?: number | null;
  packVolume_AVERAGE_GT?: number | null;
  packVolume_AVERAGE_GTE?: number | null;
  packVolume_AVERAGE_LT?: number | null;
  packVolume_AVERAGE_LTE?: number | null;
  packVolume_EQUAL?: string | null;
  packVolume_GT?: number | null;
  packVolume_GTE?: number | null;
  packVolume_LONGEST_EQUAL?: number | null;
  packVolume_LONGEST_GT?: number | null;
  packVolume_LONGEST_GTE?: number | null;
  packVolume_LONGEST_LT?: number | null;
  packVolume_LONGEST_LTE?: number | null;
  packVolume_LT?: number | null;
  packVolume_LTE?: number | null;
  packVolume_SHORTEST_EQUAL?: number | null;
  packVolume_SHORTEST_GT?: number | null;
  packVolume_SHORTEST_GTE?: number | null;
  packVolume_SHORTEST_LT?: number | null;
  packVolume_SHORTEST_LTE?: number | null;
}

export interface ScenarioActionWhere {
  AND?: ScenarioActionWhere[] | null;
  OR?: ScenarioActionWhere[] | null;
  actionLogicalOperator?: ActionLogicalOperator | null;
  actionLogicalOperator_IN?: (ActionLogicalOperator | null)[] | null;
  actionLogicalOperator_NOT?: ActionLogicalOperator | null;
  actionLogicalOperator_NOT_IN?: (ActionLogicalOperator | null)[] | null;
  actionType?: ActionType | null;
  actionType_IN?: (ActionType | null)[] | null;
  actionType_NOT?: ActionType | null;
  actionType_NOT_IN?: (ActionType | null)[] | null;
  adHocPriceTypes?: PriceType[] | null;
  adHocPriceTypes_INCLUDES?: PriceType | null;
  adHocPriceTypes_NOT?: PriceType[] | null;
  adHocPriceTypes_NOT_INCLUDES?: PriceType | null;
  brands?: BrandWhere | null;
  brandsAggregate?: ScenarioActionBrandsAggregateInput | null;
  brandsConnection?: ScenarioActionBrandsConnectionWhere | null;
  brandsConnection_NOT?: ScenarioActionBrandsConnectionWhere | null;
  brands_NOT?: BrandWhere | null;
  combinedItemBrands?: BrandWhere | null;
  combinedItemBrandsAggregate?: ScenarioActionCombinedItemBrandsAggregateInput | null;
  combinedItemBrandsConnection?: ScenarioActionCombinedItemBrandsConnectionWhere | null;
  combinedItemBrandsConnection_NOT?: ScenarioActionCombinedItemBrandsConnectionWhere | null;
  combinedItemBrands_NOT?: BrandWhere | null;
  combinedItemGenerics?: GenericWhere | null;
  combinedItemGenericsAggregate?: ScenarioActionCombinedItemGenericsAggregateInput | null;
  combinedItemGenericsConnection?: ScenarioActionCombinedItemGenericsConnectionWhere | null;
  combinedItemGenericsConnection_NOT?: ScenarioActionCombinedItemGenericsConnectionWhere | null;
  combinedItemGenerics_NOT?: GenericWhere | null;
  combinedItemTimeframeEnd?: number | null;
  combinedItemTimeframeEnd_GT?: number | null;
  combinedItemTimeframeEnd_GTE?: number | null;
  combinedItemTimeframeEnd_IN?: (number | null)[] | null;
  combinedItemTimeframeEnd_LT?: number | null;
  combinedItemTimeframeEnd_LTE?: number | null;
  combinedItemTimeframeEnd_NOT?: number | null;
  combinedItemTimeframeEnd_NOT_IN?: (number | null)[] | null;
  combinedItemTimeframeRangeType?: TimeframeRangeType | null;
  combinedItemTimeframeRangeType_IN?: (TimeframeRangeType | null)[] | null;
  combinedItemTimeframeRangeType_NOT?: TimeframeRangeType | null;
  combinedItemTimeframeRangeType_NOT_IN?: (TimeframeRangeType | null)[] | null;
  combinedItemTimeframeStart?: number | null;
  combinedItemTimeframeStart_GT?: number | null;
  combinedItemTimeframeStart_GTE?: number | null;
  combinedItemTimeframeStart_IN?: (number | null)[] | null;
  combinedItemTimeframeStart_LT?: number | null;
  combinedItemTimeframeStart_LTE?: number | null;
  combinedItemTimeframeStart_NOT?: number | null;
  combinedItemTimeframeStart_NOT_IN?: (number | null)[] | null;
  combinedItemTreatments?: TreatmentWhere | null;
  combinedItemTreatmentsAggregate?: ScenarioActionCombinedItemTreatmentsAggregateInput | null;
  combinedItemTreatmentsConnection?: ScenarioActionCombinedItemTreatmentsConnectionWhere | null;
  combinedItemTreatmentsConnection_NOT?: ScenarioActionCombinedItemTreatmentsConnectionWhere | null;
  combinedItemTreatments_NOT?: TreatmentWhere | null;
  cycle?: CycleConfigurationWhere | null;
  cycleAggregate?: ScenarioActionCycleAggregateInput | null;
  cycleConnection?: ScenarioActionCycleConnectionWhere | null;
  cycleConnection_NOT?: ScenarioActionCycleConnectionWhere | null;
  cycle_NOT?: CycleConfigurationWhere | null;
  endItemNumber?: number | null;
  endItemNumber_GT?: number | null;
  endItemNumber_GTE?: number | null;
  endItemNumber_IN?: (number | null)[] | null;
  endItemNumber_LT?: number | null;
  endItemNumber_LTE?: number | null;
  endItemNumber_NOT?: number | null;
  endItemNumber_NOT_IN?: (number | null)[] | null;
  entityPriceType?: EntityPriceType | null;
  entityPriceType_IN?: (EntityPriceType | null)[] | null;
  entityPriceType_NOT?: EntityPriceType | null;
  entityPriceType_NOT_IN?: (EntityPriceType | null)[] | null;
  generics?: GenericWhere | null;
  genericsAggregate?: ScenarioActionGenericsAggregateInput | null;
  genericsConnection?: ScenarioActionGenericsConnectionWhere | null;
  genericsConnection_NOT?: ScenarioActionGenericsConnectionWhere | null;
  generics_NOT?: GenericWhere | null;
  ingredientEndItemNumber?: number | null;
  ingredientEndItemNumber_GT?: number | null;
  ingredientEndItemNumber_GTE?: number | null;
  ingredientEndItemNumber_IN?: (number | null)[] | null;
  ingredientEndItemNumber_LT?: number | null;
  ingredientEndItemNumber_LTE?: number | null;
  ingredientEndItemNumber_NOT?: number | null;
  ingredientEndItemNumber_NOT_IN?: (number | null)[] | null;
  ingredientRangeType?: ActionItemRangeType | null;
  ingredientRangeType_IN?: (ActionItemRangeType | null)[] | null;
  ingredientRangeType_NOT?: ActionItemRangeType | null;
  ingredientRangeType_NOT_IN?: (ActionItemRangeType | null)[] | null;
  ingredientStartItemNumber?: number | null;
  ingredientStartItemNumber_GT?: number | null;
  ingredientStartItemNumber_GTE?: number | null;
  ingredientStartItemNumber_IN?: (number | null)[] | null;
  ingredientStartItemNumber_LT?: number | null;
  ingredientStartItemNumber_LTE?: number | null;
  ingredientStartItemNumber_NOT?: number | null;
  ingredientStartItemNumber_NOT_IN?: (number | null)[] | null;
  isAdHocDiscount?: boolean | null;
  isAdHocDiscount_NOT?: boolean | null;
  isCombinedScenarioRelevantDrugsActive?: boolean | null;
  isCombinedScenarioRelevantDrugsActive_NOT?: boolean | null;
  isNamedTimeRangeUsed?: boolean | null;
  isNamedTimeRangeUsed_NOT?: boolean | null;
  isScenarioRelevantDrugsActive?: boolean | null;
  isScenarioRelevantDrugsActive_NOT?: boolean | null;
  isSortedByPackOrder?: boolean | null;
  isSortedByPackOrder_NOT?: boolean | null;
  itemCombinationRelation?: ActionItemCombinationRelation | null;
  itemCombinationRelation_IN?: (ActionItemCombinationRelation | null)[] | null;
  itemCombinationRelation_NOT?: ActionItemCombinationRelation | null;
  itemCombinationRelation_NOT_IN?: (ActionItemCombinationRelation | null)[] | null;
  itemCombinationRule?: ActionItemCombinationRule | null;
  itemCombinationRule_IN?: (ActionItemCombinationRule | null)[] | null;
  itemCombinationRule_NOT?: ActionItemCombinationRule | null;
  itemCombinationRule_NOT_IN?: (ActionItemCombinationRule | null)[] | null;
  itemRangeType?: ActionItemRangeType | null;
  itemRangeType_IN?: (ActionItemRangeType | null)[] | null;
  itemRangeType_NOT?: ActionItemRangeType | null;
  itemRangeType_NOT_IN?: (ActionItemRangeType | null)[] | null;
  itemScope?: ItemScope | null;
  itemScope_IN?: (ItemScope | null)[] | null;
  itemScope_NOT?: ItemScope | null;
  itemScope_NOT_IN?: (ItemScope | null)[] | null;
  order?: number | null;
  order_GT?: number | null;
  order_GTE?: number | null;
  order_IN?: (number | null)[] | null;
  order_LT?: number | null;
  order_LTE?: number | null;
  order_NOT?: number | null;
  order_NOT_IN?: (number | null)[] | null;
  packOptionType?: PackOptionType | null;
  packOptionType_IN?: (PackOptionType | null)[] | null;
  packOptionType_NOT?: PackOptionType | null;
  packOptionType_NOT_IN?: (PackOptionType | null)[] | null;
  priceType?: PriceType | null;
  priceType_IN?: (PriceType | null)[] | null;
  priceType_NOT?: PriceType | null;
  priceType_NOT_IN?: (PriceType | null)[] | null;
  recordNature?: RecordNature | null;
  recordNature_IN?: (RecordNature | null)[] | null;
  recordNature_NOT?: RecordNature | null;
  recordNature_NOT_IN?: (RecordNature | null)[] | null;
  rollingRangeType?: RollingRangeType | null;
  rollingRangeType_IN?: (RollingRangeType | null)[] | null;
  rollingRangeType_NOT?: RollingRangeType | null;
  rollingRangeType_NOT_IN?: (RollingRangeType | null)[] | null;
  scenario?: ScenarioWhere | null;
  scenarioAggregate?: ScenarioActionScenarioAggregateInput | null;
  scenarioConnection?: ScenarioActionScenarioConnectionWhere | null;
  scenarioConnection_NOT?: ScenarioActionScenarioConnectionWhere | null;
  scenario_NOT?: ScenarioWhere | null;
  startItemNumber?: number | null;
  startItemNumber_GT?: number | null;
  startItemNumber_GTE?: number | null;
  startItemNumber_IN?: (number | null)[] | null;
  startItemNumber_LT?: number | null;
  startItemNumber_LTE?: number | null;
  startItemNumber_NOT?: number | null;
  startItemNumber_NOT_IN?: (number | null)[] | null;
  startingPoint?: TimeframeStartingPoint | null;
  startingPoint_IN?: (TimeframeStartingPoint | null)[] | null;
  startingPoint_NOT?: TimeframeStartingPoint | null;
  startingPoint_NOT_IN?: (TimeframeStartingPoint | null)[] | null;
  timeframeEnd?: number | null;
  timeframeEnd_GT?: number | null;
  timeframeEnd_GTE?: number | null;
  timeframeEnd_IN?: (number | null)[] | null;
  timeframeEnd_LT?: number | null;
  timeframeEnd_LTE?: number | null;
  timeframeEnd_NOT?: number | null;
  timeframeEnd_NOT_IN?: (number | null)[] | null;
  timeframeRangeType?: TimeframeRangeType | null;
  timeframeRangeType_IN?: (TimeframeRangeType | null)[] | null;
  timeframeRangeType_NOT?: TimeframeRangeType | null;
  timeframeRangeType_NOT_IN?: (TimeframeRangeType | null)[] | null;
  timeframeRelation?: TimeframeRelation | null;
  timeframeRelation_IN?: (TimeframeRelation | null)[] | null;
  timeframeRelation_NOT?: TimeframeRelation | null;
  timeframeRelation_NOT_IN?: (TimeframeRelation | null)[] | null;
  timeframeStart?: number | null;
  timeframeStart_GT?: number | null;
  timeframeStart_GTE?: number | null;
  timeframeStart_IN?: (number | null)[] | null;
  timeframeStart_LT?: number | null;
  timeframeStart_LTE?: number | null;
  timeframeStart_NOT?: number | null;
  timeframeStart_NOT_IN?: (number | null)[] | null;
  treatments?: TreatmentWhere | null;
  treatmentsAggregate?: ScenarioActionTreatmentsAggregateInput | null;
  treatmentsConnection?: ScenarioActionTreatmentsConnectionWhere | null;
  treatmentsConnection_NOT?: ScenarioActionTreatmentsConnectionWhere | null;
  treatments_NOT?: TreatmentWhere | null;
  uoMType?: UoMType | null;
  uoMType_IN?: (UoMType | null)[] | null;
  uoMType_NOT?: UoMType | null;
  uoMType_NOT_IN?: (UoMType | null)[] | null;
  value?: number | null;
  value_GT?: number | null;
  value_GTE?: number | null;
  value_IN?: (number | null)[] | null;
  value_LT?: number | null;
  value_LTE?: number | null;
  value_NOT?: number | null;
  value_NOT_IN?: (number | null)[] | null;
}

export interface ScenarioActionsAggregateInput {
  AND?: ScenarioActionsAggregateInput[] | null;
  OR?: ScenarioActionsAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: ScenarioActionsNodeAggregationWhereInput | null;
}

export interface ScenarioActionsConnectionWhere {
  AND?: ScenarioActionsConnectionWhere[] | null;
  OR?: ScenarioActionsConnectionWhere[] | null;
  node?: ScenarioActionWhere | null;
  node_NOT?: ScenarioActionWhere | null;
}

export interface ScenarioActionsNodeAggregationWhereInput {
  AND?: ScenarioActionsNodeAggregationWhereInput[] | null;
  OR?: ScenarioActionsNodeAggregationWhereInput[] | null;
  combinedItemTimeframeEnd_AVERAGE_EQUAL?: number | null;
  combinedItemTimeframeEnd_AVERAGE_GT?: number | null;
  combinedItemTimeframeEnd_AVERAGE_GTE?: number | null;
  combinedItemTimeframeEnd_AVERAGE_LT?: number | null;
  combinedItemTimeframeEnd_AVERAGE_LTE?: number | null;
  combinedItemTimeframeEnd_EQUAL?: number | null;
  combinedItemTimeframeEnd_GT?: number | null;
  combinedItemTimeframeEnd_GTE?: number | null;
  combinedItemTimeframeEnd_LT?: number | null;
  combinedItemTimeframeEnd_LTE?: number | null;
  combinedItemTimeframeEnd_MAX_EQUAL?: number | null;
  combinedItemTimeframeEnd_MAX_GT?: number | null;
  combinedItemTimeframeEnd_MAX_GTE?: number | null;
  combinedItemTimeframeEnd_MAX_LT?: number | null;
  combinedItemTimeframeEnd_MAX_LTE?: number | null;
  combinedItemTimeframeEnd_MIN_EQUAL?: number | null;
  combinedItemTimeframeEnd_MIN_GT?: number | null;
  combinedItemTimeframeEnd_MIN_GTE?: number | null;
  combinedItemTimeframeEnd_MIN_LT?: number | null;
  combinedItemTimeframeEnd_MIN_LTE?: number | null;
  combinedItemTimeframeEnd_SUM_EQUAL?: number | null;
  combinedItemTimeframeEnd_SUM_GT?: number | null;
  combinedItemTimeframeEnd_SUM_GTE?: number | null;
  combinedItemTimeframeEnd_SUM_LT?: number | null;
  combinedItemTimeframeEnd_SUM_LTE?: number | null;
  combinedItemTimeframeStart_AVERAGE_EQUAL?: number | null;
  combinedItemTimeframeStart_AVERAGE_GT?: number | null;
  combinedItemTimeframeStart_AVERAGE_GTE?: number | null;
  combinedItemTimeframeStart_AVERAGE_LT?: number | null;
  combinedItemTimeframeStart_AVERAGE_LTE?: number | null;
  combinedItemTimeframeStart_EQUAL?: number | null;
  combinedItemTimeframeStart_GT?: number | null;
  combinedItemTimeframeStart_GTE?: number | null;
  combinedItemTimeframeStart_LT?: number | null;
  combinedItemTimeframeStart_LTE?: number | null;
  combinedItemTimeframeStart_MAX_EQUAL?: number | null;
  combinedItemTimeframeStart_MAX_GT?: number | null;
  combinedItemTimeframeStart_MAX_GTE?: number | null;
  combinedItemTimeframeStart_MAX_LT?: number | null;
  combinedItemTimeframeStart_MAX_LTE?: number | null;
  combinedItemTimeframeStart_MIN_EQUAL?: number | null;
  combinedItemTimeframeStart_MIN_GT?: number | null;
  combinedItemTimeframeStart_MIN_GTE?: number | null;
  combinedItemTimeframeStart_MIN_LT?: number | null;
  combinedItemTimeframeStart_MIN_LTE?: number | null;
  combinedItemTimeframeStart_SUM_EQUAL?: number | null;
  combinedItemTimeframeStart_SUM_GT?: number | null;
  combinedItemTimeframeStart_SUM_GTE?: number | null;
  combinedItemTimeframeStart_SUM_LT?: number | null;
  combinedItemTimeframeStart_SUM_LTE?: number | null;
  endItemNumber_AVERAGE_EQUAL?: number | null;
  endItemNumber_AVERAGE_GT?: number | null;
  endItemNumber_AVERAGE_GTE?: number | null;
  endItemNumber_AVERAGE_LT?: number | null;
  endItemNumber_AVERAGE_LTE?: number | null;
  endItemNumber_EQUAL?: number | null;
  endItemNumber_GT?: number | null;
  endItemNumber_GTE?: number | null;
  endItemNumber_LT?: number | null;
  endItemNumber_LTE?: number | null;
  endItemNumber_MAX_EQUAL?: number | null;
  endItemNumber_MAX_GT?: number | null;
  endItemNumber_MAX_GTE?: number | null;
  endItemNumber_MAX_LT?: number | null;
  endItemNumber_MAX_LTE?: number | null;
  endItemNumber_MIN_EQUAL?: number | null;
  endItemNumber_MIN_GT?: number | null;
  endItemNumber_MIN_GTE?: number | null;
  endItemNumber_MIN_LT?: number | null;
  endItemNumber_MIN_LTE?: number | null;
  endItemNumber_SUM_EQUAL?: number | null;
  endItemNumber_SUM_GT?: number | null;
  endItemNumber_SUM_GTE?: number | null;
  endItemNumber_SUM_LT?: number | null;
  endItemNumber_SUM_LTE?: number | null;
  ingredientEndItemNumber_AVERAGE_EQUAL?: number | null;
  ingredientEndItemNumber_AVERAGE_GT?: number | null;
  ingredientEndItemNumber_AVERAGE_GTE?: number | null;
  ingredientEndItemNumber_AVERAGE_LT?: number | null;
  ingredientEndItemNumber_AVERAGE_LTE?: number | null;
  ingredientEndItemNumber_EQUAL?: number | null;
  ingredientEndItemNumber_GT?: number | null;
  ingredientEndItemNumber_GTE?: number | null;
  ingredientEndItemNumber_LT?: number | null;
  ingredientEndItemNumber_LTE?: number | null;
  ingredientEndItemNumber_MAX_EQUAL?: number | null;
  ingredientEndItemNumber_MAX_GT?: number | null;
  ingredientEndItemNumber_MAX_GTE?: number | null;
  ingredientEndItemNumber_MAX_LT?: number | null;
  ingredientEndItemNumber_MAX_LTE?: number | null;
  ingredientEndItemNumber_MIN_EQUAL?: number | null;
  ingredientEndItemNumber_MIN_GT?: number | null;
  ingredientEndItemNumber_MIN_GTE?: number | null;
  ingredientEndItemNumber_MIN_LT?: number | null;
  ingredientEndItemNumber_MIN_LTE?: number | null;
  ingredientEndItemNumber_SUM_EQUAL?: number | null;
  ingredientEndItemNumber_SUM_GT?: number | null;
  ingredientEndItemNumber_SUM_GTE?: number | null;
  ingredientEndItemNumber_SUM_LT?: number | null;
  ingredientEndItemNumber_SUM_LTE?: number | null;
  ingredientStartItemNumber_AVERAGE_EQUAL?: number | null;
  ingredientStartItemNumber_AVERAGE_GT?: number | null;
  ingredientStartItemNumber_AVERAGE_GTE?: number | null;
  ingredientStartItemNumber_AVERAGE_LT?: number | null;
  ingredientStartItemNumber_AVERAGE_LTE?: number | null;
  ingredientStartItemNumber_EQUAL?: number | null;
  ingredientStartItemNumber_GT?: number | null;
  ingredientStartItemNumber_GTE?: number | null;
  ingredientStartItemNumber_LT?: number | null;
  ingredientStartItemNumber_LTE?: number | null;
  ingredientStartItemNumber_MAX_EQUAL?: number | null;
  ingredientStartItemNumber_MAX_GT?: number | null;
  ingredientStartItemNumber_MAX_GTE?: number | null;
  ingredientStartItemNumber_MAX_LT?: number | null;
  ingredientStartItemNumber_MAX_LTE?: number | null;
  ingredientStartItemNumber_MIN_EQUAL?: number | null;
  ingredientStartItemNumber_MIN_GT?: number | null;
  ingredientStartItemNumber_MIN_GTE?: number | null;
  ingredientStartItemNumber_MIN_LT?: number | null;
  ingredientStartItemNumber_MIN_LTE?: number | null;
  ingredientStartItemNumber_SUM_EQUAL?: number | null;
  ingredientStartItemNumber_SUM_GT?: number | null;
  ingredientStartItemNumber_SUM_GTE?: number | null;
  ingredientStartItemNumber_SUM_LT?: number | null;
  ingredientStartItemNumber_SUM_LTE?: number | null;
  order_AVERAGE_EQUAL?: number | null;
  order_AVERAGE_GT?: number | null;
  order_AVERAGE_GTE?: number | null;
  order_AVERAGE_LT?: number | null;
  order_AVERAGE_LTE?: number | null;
  order_EQUAL?: number | null;
  order_GT?: number | null;
  order_GTE?: number | null;
  order_LT?: number | null;
  order_LTE?: number | null;
  order_MAX_EQUAL?: number | null;
  order_MAX_GT?: number | null;
  order_MAX_GTE?: number | null;
  order_MAX_LT?: number | null;
  order_MAX_LTE?: number | null;
  order_MIN_EQUAL?: number | null;
  order_MIN_GT?: number | null;
  order_MIN_GTE?: number | null;
  order_MIN_LT?: number | null;
  order_MIN_LTE?: number | null;
  order_SUM_EQUAL?: number | null;
  order_SUM_GT?: number | null;
  order_SUM_GTE?: number | null;
  order_SUM_LT?: number | null;
  order_SUM_LTE?: number | null;
  startItemNumber_AVERAGE_EQUAL?: number | null;
  startItemNumber_AVERAGE_GT?: number | null;
  startItemNumber_AVERAGE_GTE?: number | null;
  startItemNumber_AVERAGE_LT?: number | null;
  startItemNumber_AVERAGE_LTE?: number | null;
  startItemNumber_EQUAL?: number | null;
  startItemNumber_GT?: number | null;
  startItemNumber_GTE?: number | null;
  startItemNumber_LT?: number | null;
  startItemNumber_LTE?: number | null;
  startItemNumber_MAX_EQUAL?: number | null;
  startItemNumber_MAX_GT?: number | null;
  startItemNumber_MAX_GTE?: number | null;
  startItemNumber_MAX_LT?: number | null;
  startItemNumber_MAX_LTE?: number | null;
  startItemNumber_MIN_EQUAL?: number | null;
  startItemNumber_MIN_GT?: number | null;
  startItemNumber_MIN_GTE?: number | null;
  startItemNumber_MIN_LT?: number | null;
  startItemNumber_MIN_LTE?: number | null;
  startItemNumber_SUM_EQUAL?: number | null;
  startItemNumber_SUM_GT?: number | null;
  startItemNumber_SUM_GTE?: number | null;
  startItemNumber_SUM_LT?: number | null;
  startItemNumber_SUM_LTE?: number | null;
  timeframeEnd_AVERAGE_EQUAL?: number | null;
  timeframeEnd_AVERAGE_GT?: number | null;
  timeframeEnd_AVERAGE_GTE?: number | null;
  timeframeEnd_AVERAGE_LT?: number | null;
  timeframeEnd_AVERAGE_LTE?: number | null;
  timeframeEnd_EQUAL?: number | null;
  timeframeEnd_GT?: number | null;
  timeframeEnd_GTE?: number | null;
  timeframeEnd_LT?: number | null;
  timeframeEnd_LTE?: number | null;
  timeframeEnd_MAX_EQUAL?: number | null;
  timeframeEnd_MAX_GT?: number | null;
  timeframeEnd_MAX_GTE?: number | null;
  timeframeEnd_MAX_LT?: number | null;
  timeframeEnd_MAX_LTE?: number | null;
  timeframeEnd_MIN_EQUAL?: number | null;
  timeframeEnd_MIN_GT?: number | null;
  timeframeEnd_MIN_GTE?: number | null;
  timeframeEnd_MIN_LT?: number | null;
  timeframeEnd_MIN_LTE?: number | null;
  timeframeEnd_SUM_EQUAL?: number | null;
  timeframeEnd_SUM_GT?: number | null;
  timeframeEnd_SUM_GTE?: number | null;
  timeframeEnd_SUM_LT?: number | null;
  timeframeEnd_SUM_LTE?: number | null;
  timeframeStart_AVERAGE_EQUAL?: number | null;
  timeframeStart_AVERAGE_GT?: number | null;
  timeframeStart_AVERAGE_GTE?: number | null;
  timeframeStart_AVERAGE_LT?: number | null;
  timeframeStart_AVERAGE_LTE?: number | null;
  timeframeStart_EQUAL?: number | null;
  timeframeStart_GT?: number | null;
  timeframeStart_GTE?: number | null;
  timeframeStart_LT?: number | null;
  timeframeStart_LTE?: number | null;
  timeframeStart_MAX_EQUAL?: number | null;
  timeframeStart_MAX_GT?: number | null;
  timeframeStart_MAX_GTE?: number | null;
  timeframeStart_MAX_LT?: number | null;
  timeframeStart_MAX_LTE?: number | null;
  timeframeStart_MIN_EQUAL?: number | null;
  timeframeStart_MIN_GT?: number | null;
  timeframeStart_MIN_GTE?: number | null;
  timeframeStart_MIN_LT?: number | null;
  timeframeStart_MIN_LTE?: number | null;
  timeframeStart_SUM_EQUAL?: number | null;
  timeframeStart_SUM_GT?: number | null;
  timeframeStart_SUM_GTE?: number | null;
  timeframeStart_SUM_LT?: number | null;
  timeframeStart_SUM_LTE?: number | null;
  value_AVERAGE_EQUAL?: number | null;
  value_AVERAGE_GT?: number | null;
  value_AVERAGE_GTE?: number | null;
  value_AVERAGE_LT?: number | null;
  value_AVERAGE_LTE?: number | null;
  value_EQUAL?: number | null;
  value_GT?: number | null;
  value_GTE?: number | null;
  value_LT?: number | null;
  value_LTE?: number | null;
  value_MAX_EQUAL?: number | null;
  value_MAX_GT?: number | null;
  value_MAX_GTE?: number | null;
  value_MAX_LT?: number | null;
  value_MAX_LTE?: number | null;
  value_MIN_EQUAL?: number | null;
  value_MIN_GT?: number | null;
  value_MIN_GTE?: number | null;
  value_MIN_LT?: number | null;
  value_MIN_LTE?: number | null;
  value_SUM_EQUAL?: number | null;
  value_SUM_GT?: number | null;
  value_SUM_GTE?: number | null;
  value_SUM_LT?: number | null;
  value_SUM_LTE?: number | null;
}

export interface ScenarioAgreementAggregateInput {
  AND?: ScenarioAgreementAggregateInput[] | null;
  OR?: ScenarioAgreementAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: ScenarioAgreementNodeAggregationWhereInput | null;
}

export interface ScenarioAgreementConnectionWhere {
  AND?: ScenarioAgreementConnectionWhere[] | null;
  OR?: ScenarioAgreementConnectionWhere[] | null;
  node?: BaseAgreementWhere | null;
  node_NOT?: BaseAgreementWhere | null;
}

export interface ScenarioAgreementNodeAggregationWhereInput {
  AND?: ScenarioAgreementNodeAggregationWhereInput[] | null;
  OR?: ScenarioAgreementNodeAggregationWhereInput[] | null;
  caseSuspensionIntervalDays_AVERAGE_EQUAL?: number | null;
  caseSuspensionIntervalDays_AVERAGE_GT?: number | null;
  caseSuspensionIntervalDays_AVERAGE_GTE?: number | null;
  caseSuspensionIntervalDays_AVERAGE_LT?: number | null;
  caseSuspensionIntervalDays_AVERAGE_LTE?: number | null;
  caseSuspensionIntervalDays_EQUAL?: number | null;
  caseSuspensionIntervalDays_GT?: number | null;
  caseSuspensionIntervalDays_GTE?: number | null;
  caseSuspensionIntervalDays_LT?: number | null;
  caseSuspensionIntervalDays_LTE?: number | null;
  caseSuspensionIntervalDays_MAX_EQUAL?: number | null;
  caseSuspensionIntervalDays_MAX_GT?: number | null;
  caseSuspensionIntervalDays_MAX_GTE?: number | null;
  caseSuspensionIntervalDays_MAX_LT?: number | null;
  caseSuspensionIntervalDays_MAX_LTE?: number | null;
  caseSuspensionIntervalDays_MIN_EQUAL?: number | null;
  caseSuspensionIntervalDays_MIN_GT?: number | null;
  caseSuspensionIntervalDays_MIN_GTE?: number | null;
  caseSuspensionIntervalDays_MIN_LT?: number | null;
  caseSuspensionIntervalDays_MIN_LTE?: number | null;
  caseSuspensionIntervalDays_SUM_EQUAL?: number | null;
  caseSuspensionIntervalDays_SUM_GT?: number | null;
  caseSuspensionIntervalDays_SUM_GTE?: number | null;
  caseSuspensionIntervalDays_SUM_LT?: number | null;
  caseSuspensionIntervalDays_SUM_LTE?: number | null;
  coveringFormWaitInterval_AVERAGE_EQUAL?: number | null;
  coveringFormWaitInterval_AVERAGE_GT?: number | null;
  coveringFormWaitInterval_AVERAGE_GTE?: number | null;
  coveringFormWaitInterval_AVERAGE_LT?: number | null;
  coveringFormWaitInterval_AVERAGE_LTE?: number | null;
  coveringFormWaitInterval_EQUAL?: number | null;
  coveringFormWaitInterval_GT?: number | null;
  coveringFormWaitInterval_GTE?: number | null;
  coveringFormWaitInterval_LT?: number | null;
  coveringFormWaitInterval_LTE?: number | null;
  coveringFormWaitInterval_MAX_EQUAL?: number | null;
  coveringFormWaitInterval_MAX_GT?: number | null;
  coveringFormWaitInterval_MAX_GTE?: number | null;
  coveringFormWaitInterval_MAX_LT?: number | null;
  coveringFormWaitInterval_MAX_LTE?: number | null;
  coveringFormWaitInterval_MIN_EQUAL?: number | null;
  coveringFormWaitInterval_MIN_GT?: number | null;
  coveringFormWaitInterval_MIN_GTE?: number | null;
  coveringFormWaitInterval_MIN_LT?: number | null;
  coveringFormWaitInterval_MIN_LTE?: number | null;
  coveringFormWaitInterval_SUM_EQUAL?: number | null;
  coveringFormWaitInterval_SUM_GT?: number | null;
  coveringFormWaitInterval_SUM_GTE?: number | null;
  coveringFormWaitInterval_SUM_LT?: number | null;
  coveringFormWaitInterval_SUM_LTE?: number | null;
  createdOn_EQUAL?: any | null;
  createdOn_GT?: any | null;
  createdOn_GTE?: any | null;
  createdOn_LT?: any | null;
  createdOn_LTE?: any | null;
  createdOn_MAX_EQUAL?: any | null;
  createdOn_MAX_GT?: any | null;
  createdOn_MAX_GTE?: any | null;
  createdOn_MAX_LT?: any | null;
  createdOn_MAX_LTE?: any | null;
  createdOn_MIN_EQUAL?: any | null;
  createdOn_MIN_GT?: any | null;
  createdOn_MIN_GTE?: any | null;
  createdOn_MIN_LT?: any | null;
  createdOn_MIN_LTE?: any | null;
  defaultPriceRate_AVERAGE_EQUAL?: number | null;
  defaultPriceRate_AVERAGE_GT?: number | null;
  defaultPriceRate_AVERAGE_GTE?: number | null;
  defaultPriceRate_AVERAGE_LT?: number | null;
  defaultPriceRate_AVERAGE_LTE?: number | null;
  defaultPriceRate_EQUAL?: number | null;
  defaultPriceRate_GT?: number | null;
  defaultPriceRate_GTE?: number | null;
  defaultPriceRate_LT?: number | null;
  defaultPriceRate_LTE?: number | null;
  defaultPriceRate_MAX_EQUAL?: number | null;
  defaultPriceRate_MAX_GT?: number | null;
  defaultPriceRate_MAX_GTE?: number | null;
  defaultPriceRate_MAX_LT?: number | null;
  defaultPriceRate_MAX_LTE?: number | null;
  defaultPriceRate_MIN_EQUAL?: number | null;
  defaultPriceRate_MIN_GT?: number | null;
  defaultPriceRate_MIN_GTE?: number | null;
  defaultPriceRate_MIN_LT?: number | null;
  defaultPriceRate_MIN_LTE?: number | null;
  defaultPriceRate_SUM_EQUAL?: number | null;
  defaultPriceRate_SUM_GT?: number | null;
  defaultPriceRate_SUM_GTE?: number | null;
  defaultPriceRate_SUM_LT?: number | null;
  defaultPriceRate_SUM_LTE?: number | null;
  firstExecutionDate_EQUAL?: any | null;
  firstExecutionDate_GT?: any | null;
  firstExecutionDate_GTE?: any | null;
  firstExecutionDate_LT?: any | null;
  firstExecutionDate_LTE?: any | null;
  firstExecutionDate_MAX_EQUAL?: any | null;
  firstExecutionDate_MAX_GT?: any | null;
  firstExecutionDate_MAX_GTE?: any | null;
  firstExecutionDate_MAX_LT?: any | null;
  firstExecutionDate_MAX_LTE?: any | null;
  firstExecutionDate_MIN_EQUAL?: any | null;
  firstExecutionDate_MIN_GT?: any | null;
  firstExecutionDate_MIN_GTE?: any | null;
  firstExecutionDate_MIN_LT?: any | null;
  firstExecutionDate_MIN_LTE?: any | null;
  formattedAmount_AVERAGE_EQUAL?: number | null;
  formattedAmount_AVERAGE_GT?: number | null;
  formattedAmount_AVERAGE_GTE?: number | null;
  formattedAmount_AVERAGE_LT?: number | null;
  formattedAmount_AVERAGE_LTE?: number | null;
  formattedAmount_EQUAL?: string | null;
  formattedAmount_GT?: number | null;
  formattedAmount_GTE?: number | null;
  formattedAmount_LONGEST_EQUAL?: number | null;
  formattedAmount_LONGEST_GT?: number | null;
  formattedAmount_LONGEST_GTE?: number | null;
  formattedAmount_LONGEST_LT?: number | null;
  formattedAmount_LONGEST_LTE?: number | null;
  formattedAmount_LT?: number | null;
  formattedAmount_LTE?: number | null;
  formattedAmount_SHORTEST_EQUAL?: number | null;
  formattedAmount_SHORTEST_GT?: number | null;
  formattedAmount_SHORTEST_GTE?: number | null;
  formattedAmount_SHORTEST_LT?: number | null;
  formattedAmount_SHORTEST_LTE?: number | null;
  formattedCounterparties_AVERAGE_EQUAL?: number | null;
  formattedCounterparties_AVERAGE_GT?: number | null;
  formattedCounterparties_AVERAGE_GTE?: number | null;
  formattedCounterparties_AVERAGE_LT?: number | null;
  formattedCounterparties_AVERAGE_LTE?: number | null;
  formattedCounterparties_EQUAL?: string | null;
  formattedCounterparties_GT?: number | null;
  formattedCounterparties_GTE?: number | null;
  formattedCounterparties_LONGEST_EQUAL?: number | null;
  formattedCounterparties_LONGEST_GT?: number | null;
  formattedCounterparties_LONGEST_GTE?: number | null;
  formattedCounterparties_LONGEST_LT?: number | null;
  formattedCounterparties_LONGEST_LTE?: number | null;
  formattedCounterparties_LT?: number | null;
  formattedCounterparties_LTE?: number | null;
  formattedCounterparties_SHORTEST_EQUAL?: number | null;
  formattedCounterparties_SHORTEST_GT?: number | null;
  formattedCounterparties_SHORTEST_GTE?: number | null;
  formattedCounterparties_SHORTEST_LT?: number | null;
  formattedCounterparties_SHORTEST_LTE?: number | null;
  formattedDiseases_AVERAGE_EQUAL?: number | null;
  formattedDiseases_AVERAGE_GT?: number | null;
  formattedDiseases_AVERAGE_GTE?: number | null;
  formattedDiseases_AVERAGE_LT?: number | null;
  formattedDiseases_AVERAGE_LTE?: number | null;
  formattedDiseases_EQUAL?: string | null;
  formattedDiseases_GT?: number | null;
  formattedDiseases_GTE?: number | null;
  formattedDiseases_LONGEST_EQUAL?: number | null;
  formattedDiseases_LONGEST_GT?: number | null;
  formattedDiseases_LONGEST_GTE?: number | null;
  formattedDiseases_LONGEST_LT?: number | null;
  formattedDiseases_LONGEST_LTE?: number | null;
  formattedDiseases_LT?: number | null;
  formattedDiseases_LTE?: number | null;
  formattedDiseases_SHORTEST_EQUAL?: number | null;
  formattedDiseases_SHORTEST_GT?: number | null;
  formattedDiseases_SHORTEST_GTE?: number | null;
  formattedDiseases_SHORTEST_LT?: number | null;
  formattedDiseases_SHORTEST_LTE?: number | null;
  formattedIndications_AVERAGE_EQUAL?: number | null;
  formattedIndications_AVERAGE_GT?: number | null;
  formattedIndications_AVERAGE_GTE?: number | null;
  formattedIndications_AVERAGE_LT?: number | null;
  formattedIndications_AVERAGE_LTE?: number | null;
  formattedIndications_EQUAL?: string | null;
  formattedIndications_GT?: number | null;
  formattedIndications_GTE?: number | null;
  formattedIndications_LONGEST_EQUAL?: number | null;
  formattedIndications_LONGEST_GT?: number | null;
  formattedIndications_LONGEST_GTE?: number | null;
  formattedIndications_LONGEST_LT?: number | null;
  formattedIndications_LONGEST_LTE?: number | null;
  formattedIndications_LT?: number | null;
  formattedIndications_LTE?: number | null;
  formattedIndications_SHORTEST_EQUAL?: number | null;
  formattedIndications_SHORTEST_GT?: number | null;
  formattedIndications_SHORTEST_GTE?: number | null;
  formattedIndications_SHORTEST_LT?: number | null;
  formattedIndications_SHORTEST_LTE?: number | null;
  formattedProducts_AVERAGE_EQUAL?: number | null;
  formattedProducts_AVERAGE_GT?: number | null;
  formattedProducts_AVERAGE_GTE?: number | null;
  formattedProducts_AVERAGE_LT?: number | null;
  formattedProducts_AVERAGE_LTE?: number | null;
  formattedProducts_EQUAL?: string | null;
  formattedProducts_GT?: number | null;
  formattedProducts_GTE?: number | null;
  formattedProducts_LONGEST_EQUAL?: number | null;
  formattedProducts_LONGEST_GT?: number | null;
  formattedProducts_LONGEST_GTE?: number | null;
  formattedProducts_LONGEST_LT?: number | null;
  formattedProducts_LONGEST_LTE?: number | null;
  formattedProducts_LT?: number | null;
  formattedProducts_LTE?: number | null;
  formattedProducts_SHORTEST_EQUAL?: number | null;
  formattedProducts_SHORTEST_GT?: number | null;
  formattedProducts_SHORTEST_GTE?: number | null;
  formattedProducts_SHORTEST_LT?: number | null;
  formattedProducts_SHORTEST_LTE?: number | null;
  formattedTags_AVERAGE_EQUAL?: number | null;
  formattedTags_AVERAGE_GT?: number | null;
  formattedTags_AVERAGE_GTE?: number | null;
  formattedTags_AVERAGE_LT?: number | null;
  formattedTags_AVERAGE_LTE?: number | null;
  formattedTags_EQUAL?: string | null;
  formattedTags_GT?: number | null;
  formattedTags_GTE?: number | null;
  formattedTags_LONGEST_EQUAL?: number | null;
  formattedTags_LONGEST_GT?: number | null;
  formattedTags_LONGEST_GTE?: number | null;
  formattedTags_LONGEST_LT?: number | null;
  formattedTags_LONGEST_LTE?: number | null;
  formattedTags_LT?: number | null;
  formattedTags_LTE?: number | null;
  formattedTags_SHORTEST_EQUAL?: number | null;
  formattedTags_SHORTEST_GT?: number | null;
  formattedTags_SHORTEST_GTE?: number | null;
  formattedTags_SHORTEST_LT?: number | null;
  formattedTags_SHORTEST_LTE?: number | null;
  formattedValidityPeriod_AVERAGE_EQUAL?: number | null;
  formattedValidityPeriod_AVERAGE_GT?: number | null;
  formattedValidityPeriod_AVERAGE_GTE?: number | null;
  formattedValidityPeriod_AVERAGE_LT?: number | null;
  formattedValidityPeriod_AVERAGE_LTE?: number | null;
  formattedValidityPeriod_EQUAL?: string | null;
  formattedValidityPeriod_GT?: number | null;
  formattedValidityPeriod_GTE?: number | null;
  formattedValidityPeriod_LONGEST_EQUAL?: number | null;
  formattedValidityPeriod_LONGEST_GT?: number | null;
  formattedValidityPeriod_LONGEST_GTE?: number | null;
  formattedValidityPeriod_LONGEST_LT?: number | null;
  formattedValidityPeriod_LONGEST_LTE?: number | null;
  formattedValidityPeriod_LT?: number | null;
  formattedValidityPeriod_LTE?: number | null;
  formattedValidityPeriod_SHORTEST_EQUAL?: number | null;
  formattedValidityPeriod_SHORTEST_GT?: number | null;
  formattedValidityPeriod_SHORTEST_GTE?: number | null;
  formattedValidityPeriod_SHORTEST_LT?: number | null;
  formattedValidityPeriod_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  initialVersionId_AVERAGE_EQUAL?: number | null;
  initialVersionId_AVERAGE_GT?: number | null;
  initialVersionId_AVERAGE_GTE?: number | null;
  initialVersionId_AVERAGE_LT?: number | null;
  initialVersionId_AVERAGE_LTE?: number | null;
  initialVersionId_EQUAL?: string | null;
  initialVersionId_GT?: number | null;
  initialVersionId_GTE?: number | null;
  initialVersionId_LONGEST_EQUAL?: number | null;
  initialVersionId_LONGEST_GT?: number | null;
  initialVersionId_LONGEST_GTE?: number | null;
  initialVersionId_LONGEST_LT?: number | null;
  initialVersionId_LONGEST_LTE?: number | null;
  initialVersionId_LT?: number | null;
  initialVersionId_LTE?: number | null;
  initialVersionId_SHORTEST_EQUAL?: number | null;
  initialVersionId_SHORTEST_GT?: number | null;
  initialVersionId_SHORTEST_GTE?: number | null;
  initialVersionId_SHORTEST_LT?: number | null;
  initialVersionId_SHORTEST_LTE?: number | null;
  lastExecutionDate_EQUAL?: any | null;
  lastExecutionDate_GT?: any | null;
  lastExecutionDate_GTE?: any | null;
  lastExecutionDate_LT?: any | null;
  lastExecutionDate_LTE?: any | null;
  lastExecutionDate_MAX_EQUAL?: any | null;
  lastExecutionDate_MAX_GT?: any | null;
  lastExecutionDate_MAX_GTE?: any | null;
  lastExecutionDate_MAX_LT?: any | null;
  lastExecutionDate_MAX_LTE?: any | null;
  lastExecutionDate_MIN_EQUAL?: any | null;
  lastExecutionDate_MIN_GT?: any | null;
  lastExecutionDate_MIN_GTE?: any | null;
  lastExecutionDate_MIN_LT?: any | null;
  lastExecutionDate_MIN_LTE?: any | null;
  lastUpdatedOn_AVERAGE_EQUAL?: number | null;
  lastUpdatedOn_AVERAGE_GT?: number | null;
  lastUpdatedOn_AVERAGE_GTE?: number | null;
  lastUpdatedOn_AVERAGE_LT?: number | null;
  lastUpdatedOn_AVERAGE_LTE?: number | null;
  lastUpdatedOn_EQUAL?: number | null;
  lastUpdatedOn_GT?: number | null;
  lastUpdatedOn_GTE?: number | null;
  lastUpdatedOn_LT?: number | null;
  lastUpdatedOn_LTE?: number | null;
  lastUpdatedOn_MAX_EQUAL?: number | null;
  lastUpdatedOn_MAX_GT?: number | null;
  lastUpdatedOn_MAX_GTE?: number | null;
  lastUpdatedOn_MAX_LT?: number | null;
  lastUpdatedOn_MAX_LTE?: number | null;
  lastUpdatedOn_MIN_EQUAL?: number | null;
  lastUpdatedOn_MIN_GT?: number | null;
  lastUpdatedOn_MIN_GTE?: number | null;
  lastUpdatedOn_MIN_LT?: number | null;
  lastUpdatedOn_MIN_LTE?: number | null;
  lastUpdatedOn_SUM_EQUAL?: number | null;
  lastUpdatedOn_SUM_GT?: number | null;
  lastUpdatedOn_SUM_GTE?: number | null;
  lastUpdatedOn_SUM_LT?: number | null;
  lastUpdatedOn_SUM_LTE?: number | null;
  name_AVERAGE_EQUAL?: number | null;
  name_AVERAGE_GT?: number | null;
  name_AVERAGE_GTE?: number | null;
  name_AVERAGE_LT?: number | null;
  name_AVERAGE_LTE?: number | null;
  name_EQUAL?: string | null;
  name_GT?: number | null;
  name_GTE?: number | null;
  name_LONGEST_EQUAL?: number | null;
  name_LONGEST_GT?: number | null;
  name_LONGEST_GTE?: number | null;
  name_LONGEST_LT?: number | null;
  name_LONGEST_LTE?: number | null;
  name_LT?: number | null;
  name_LTE?: number | null;
  name_SHORTEST_EQUAL?: number | null;
  name_SHORTEST_GT?: number | null;
  name_SHORTEST_GTE?: number | null;
  name_SHORTEST_LT?: number | null;
  name_SHORTEST_LTE?: number | null;
  pushedOn_EQUAL?: any | null;
  pushedOn_GT?: any | null;
  pushedOn_GTE?: any | null;
  pushedOn_LT?: any | null;
  pushedOn_LTE?: any | null;
  pushedOn_MAX_EQUAL?: any | null;
  pushedOn_MAX_GT?: any | null;
  pushedOn_MAX_GTE?: any | null;
  pushedOn_MAX_LT?: any | null;
  pushedOn_MAX_LTE?: any | null;
  pushedOn_MIN_EQUAL?: any | null;
  pushedOn_MIN_GT?: any | null;
  pushedOn_MIN_GTE?: any | null;
  pushedOn_MIN_LT?: any | null;
  pushedOn_MIN_LTE?: any | null;
  reportData_AVERAGE_EQUAL?: number | null;
  reportData_AVERAGE_GT?: number | null;
  reportData_AVERAGE_GTE?: number | null;
  reportData_AVERAGE_LT?: number | null;
  reportData_AVERAGE_LTE?: number | null;
  reportData_EQUAL?: string | null;
  reportData_GT?: number | null;
  reportData_GTE?: number | null;
  reportData_LONGEST_EQUAL?: number | null;
  reportData_LONGEST_GT?: number | null;
  reportData_LONGEST_GTE?: number | null;
  reportData_LONGEST_LT?: number | null;
  reportData_LONGEST_LTE?: number | null;
  reportData_LT?: number | null;
  reportData_LTE?: number | null;
  reportData_SHORTEST_EQUAL?: number | null;
  reportData_SHORTEST_GT?: number | null;
  reportData_SHORTEST_GTE?: number | null;
  reportData_SHORTEST_LT?: number | null;
  reportData_SHORTEST_LTE?: number | null;
  totalAmount_AVERAGE_EQUAL?: number | null;
  totalAmount_AVERAGE_GT?: number | null;
  totalAmount_AVERAGE_GTE?: number | null;
  totalAmount_AVERAGE_LT?: number | null;
  totalAmount_AVERAGE_LTE?: number | null;
  totalAmount_EQUAL?: number | null;
  totalAmount_GT?: number | null;
  totalAmount_GTE?: number | null;
  totalAmount_LT?: number | null;
  totalAmount_LTE?: number | null;
  totalAmount_MAX_EQUAL?: number | null;
  totalAmount_MAX_GT?: number | null;
  totalAmount_MAX_GTE?: number | null;
  totalAmount_MAX_LT?: number | null;
  totalAmount_MAX_LTE?: number | null;
  totalAmount_MIN_EQUAL?: number | null;
  totalAmount_MIN_GT?: number | null;
  totalAmount_MIN_GTE?: number | null;
  totalAmount_MIN_LT?: number | null;
  totalAmount_MIN_LTE?: number | null;
  totalAmount_SUM_EQUAL?: number | null;
  totalAmount_SUM_GT?: number | null;
  totalAmount_SUM_GTE?: number | null;
  totalAmount_SUM_LT?: number | null;
  totalAmount_SUM_LTE?: number | null;
  version_AVERAGE_EQUAL?: number | null;
  version_AVERAGE_GT?: number | null;
  version_AVERAGE_GTE?: number | null;
  version_AVERAGE_LT?: number | null;
  version_AVERAGE_LTE?: number | null;
  version_EQUAL?: number | null;
  version_GT?: number | null;
  version_GTE?: number | null;
  version_LT?: number | null;
  version_LTE?: number | null;
  version_MAX_EQUAL?: number | null;
  version_MAX_GT?: number | null;
  version_MAX_GTE?: number | null;
  version_MAX_LT?: number | null;
  version_MAX_LTE?: number | null;
  version_MIN_EQUAL?: number | null;
  version_MIN_GT?: number | null;
  version_MIN_GTE?: number | null;
  version_MIN_LT?: number | null;
  version_MIN_LTE?: number | null;
  version_SUM_EQUAL?: number | null;
  version_SUM_GT?: number | null;
  version_SUM_GTE?: number | null;
  version_SUM_LT?: number | null;
  version_SUM_LTE?: number | null;
}

export interface ScenarioConditionBrandsAggregateInput {
  AND?: ScenarioConditionBrandsAggregateInput[] | null;
  OR?: ScenarioConditionBrandsAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: ScenarioConditionBrandsNodeAggregationWhereInput | null;
}

export interface ScenarioConditionBrandsConnectionWhere {
  AND?: ScenarioConditionBrandsConnectionWhere[] | null;
  OR?: ScenarioConditionBrandsConnectionWhere[] | null;
  node?: BrandWhere | null;
  node_NOT?: BrandWhere | null;
}

export interface ScenarioConditionBrandsNodeAggregationWhereInput {
  AND?: ScenarioConditionBrandsNodeAggregationWhereInput[] | null;
  Name_AVERAGE_EQUAL?: number | null;
  Name_AVERAGE_GT?: number | null;
  Name_AVERAGE_GTE?: number | null;
  Name_AVERAGE_LT?: number | null;
  Name_AVERAGE_LTE?: number | null;
  Name_EQUAL?: string | null;
  Name_GT?: number | null;
  Name_GTE?: number | null;
  Name_LONGEST_EQUAL?: number | null;
  Name_LONGEST_GT?: number | null;
  Name_LONGEST_GTE?: number | null;
  Name_LONGEST_LT?: number | null;
  Name_LONGEST_LTE?: number | null;
  Name_LT?: number | null;
  Name_LTE?: number | null;
  Name_SHORTEST_EQUAL?: number | null;
  Name_SHORTEST_GT?: number | null;
  Name_SHORTEST_GTE?: number | null;
  Name_SHORTEST_LT?: number | null;
  Name_SHORTEST_LTE?: number | null;
  OR?: ScenarioConditionBrandsNodeAggregationWhereInput[] | null;
  id_EQUAL?: string | null;
}

export interface ScenarioConditionGenericsAggregateInput {
  AND?: ScenarioConditionGenericsAggregateInput[] | null;
  OR?: ScenarioConditionGenericsAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: ScenarioConditionGenericsNodeAggregationWhereInput | null;
}

export interface ScenarioConditionGenericsConnectionWhere {
  AND?: ScenarioConditionGenericsConnectionWhere[] | null;
  OR?: ScenarioConditionGenericsConnectionWhere[] | null;
  node?: GenericWhere | null;
  node_NOT?: GenericWhere | null;
}

export interface ScenarioConditionGenericsNodeAggregationWhereInput {
  AND?: ScenarioConditionGenericsNodeAggregationWhereInput[] | null;
  Name_AVERAGE_EQUAL?: number | null;
  Name_AVERAGE_GT?: number | null;
  Name_AVERAGE_GTE?: number | null;
  Name_AVERAGE_LT?: number | null;
  Name_AVERAGE_LTE?: number | null;
  Name_EQUAL?: string | null;
  Name_GT?: number | null;
  Name_GTE?: number | null;
  Name_LONGEST_EQUAL?: number | null;
  Name_LONGEST_GT?: number | null;
  Name_LONGEST_GTE?: number | null;
  Name_LONGEST_LT?: number | null;
  Name_LONGEST_LTE?: number | null;
  Name_LT?: number | null;
  Name_LTE?: number | null;
  Name_SHORTEST_EQUAL?: number | null;
  Name_SHORTEST_GT?: number | null;
  Name_SHORTEST_GTE?: number | null;
  Name_SHORTEST_LT?: number | null;
  Name_SHORTEST_LTE?: number | null;
  OR?: ScenarioConditionGenericsNodeAggregationWhereInput[] | null;
  id_EQUAL?: string | null;
}

export interface ScenarioConditionScenarioAggregateInput {
  AND?: ScenarioConditionScenarioAggregateInput[] | null;
  OR?: ScenarioConditionScenarioAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: ScenarioConditionScenarioNodeAggregationWhereInput | null;
}

export interface ScenarioConditionScenarioConnectionWhere {
  AND?: ScenarioConditionScenarioConnectionWhere[] | null;
  OR?: ScenarioConditionScenarioConnectionWhere[] | null;
  node?: ScenarioWhere | null;
  node_NOT?: ScenarioWhere | null;
}

export interface ScenarioConditionScenarioNodeAggregationWhereInput {
  AND?: ScenarioConditionScenarioNodeAggregationWhereInput[] | null;
  OR?: ScenarioConditionScenarioNodeAggregationWhereInput[] | null;
  group_AVERAGE_EQUAL?: number | null;
  group_AVERAGE_GT?: number | null;
  group_AVERAGE_GTE?: number | null;
  group_AVERAGE_LT?: number | null;
  group_AVERAGE_LTE?: number | null;
  group_EQUAL?: number | null;
  group_GT?: number | null;
  group_GTE?: number | null;
  group_LT?: number | null;
  group_LTE?: number | null;
  group_MAX_EQUAL?: number | null;
  group_MAX_GT?: number | null;
  group_MAX_GTE?: number | null;
  group_MAX_LT?: number | null;
  group_MAX_LTE?: number | null;
  group_MIN_EQUAL?: number | null;
  group_MIN_GT?: number | null;
  group_MIN_GTE?: number | null;
  group_MIN_LT?: number | null;
  group_MIN_LTE?: number | null;
  group_SUM_EQUAL?: number | null;
  group_SUM_GT?: number | null;
  group_SUM_GTE?: number | null;
  group_SUM_LT?: number | null;
  group_SUM_LTE?: number | null;
  order_AVERAGE_EQUAL?: number | null;
  order_AVERAGE_GT?: number | null;
  order_AVERAGE_GTE?: number | null;
  order_AVERAGE_LT?: number | null;
  order_AVERAGE_LTE?: number | null;
  order_EQUAL?: number | null;
  order_GT?: number | null;
  order_GTE?: number | null;
  order_LT?: number | null;
  order_LTE?: number | null;
  order_MAX_EQUAL?: number | null;
  order_MAX_GT?: number | null;
  order_MAX_GTE?: number | null;
  order_MAX_LT?: number | null;
  order_MAX_LTE?: number | null;
  order_MIN_EQUAL?: number | null;
  order_MIN_GT?: number | null;
  order_MIN_GTE?: number | null;
  order_MIN_LT?: number | null;
  order_MIN_LTE?: number | null;
  order_SUM_EQUAL?: number | null;
  order_SUM_GT?: number | null;
  order_SUM_GTE?: number | null;
  order_SUM_LT?: number | null;
  order_SUM_LTE?: number | null;
}

export interface ScenarioConditionTreatmentsAggregateInput {
  AND?: ScenarioConditionTreatmentsAggregateInput[] | null;
  OR?: ScenarioConditionTreatmentsAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: ScenarioConditionTreatmentsNodeAggregationWhereInput | null;
}

export interface ScenarioConditionTreatmentsConnectionWhere {
  AND?: ScenarioConditionTreatmentsConnectionWhere[] | null;
  OR?: ScenarioConditionTreatmentsConnectionWhere[] | null;
  node?: TreatmentWhere | null;
  node_NOT?: TreatmentWhere | null;
}

export interface ScenarioConditionTreatmentsNodeAggregationWhereInput {
  AND?: ScenarioConditionTreatmentsNodeAggregationWhereInput[] | null;
  BagDossierNo_AVERAGE_EQUAL?: number | null;
  BagDossierNo_AVERAGE_GT?: number | null;
  BagDossierNo_AVERAGE_GTE?: number | null;
  BagDossierNo_AVERAGE_LT?: number | null;
  BagDossierNo_AVERAGE_LTE?: number | null;
  BagDossierNo_EQUAL?: string | null;
  BagDossierNo_GT?: number | null;
  BagDossierNo_GTE?: number | null;
  BagDossierNo_LONGEST_EQUAL?: number | null;
  BagDossierNo_LONGEST_GT?: number | null;
  BagDossierNo_LONGEST_GTE?: number | null;
  BagDossierNo_LONGEST_LT?: number | null;
  BagDossierNo_LONGEST_LTE?: number | null;
  BagDossierNo_LT?: number | null;
  BagDossierNo_LTE?: number | null;
  BagDossierNo_SHORTEST_EQUAL?: number | null;
  BagDossierNo_SHORTEST_GT?: number | null;
  BagDossierNo_SHORTEST_GTE?: number | null;
  BagDossierNo_SHORTEST_LT?: number | null;
  BagDossierNo_SHORTEST_LTE?: number | null;
  Code_AVERAGE_EQUAL?: number | null;
  Code_AVERAGE_GT?: number | null;
  Code_AVERAGE_GTE?: number | null;
  Code_AVERAGE_LT?: number | null;
  Code_AVERAGE_LTE?: number | null;
  Code_EQUAL?: string | null;
  Code_GT?: number | null;
  Code_GTE?: number | null;
  Code_LONGEST_EQUAL?: number | null;
  Code_LONGEST_GT?: number | null;
  Code_LONGEST_GTE?: number | null;
  Code_LONGEST_LT?: number | null;
  Code_LONGEST_LTE?: number | null;
  Code_LT?: number | null;
  Code_LTE?: number | null;
  Code_SHORTEST_EQUAL?: number | null;
  Code_SHORTEST_GT?: number | null;
  Code_SHORTEST_GTE?: number | null;
  Code_SHORTEST_LT?: number | null;
  Code_SHORTEST_LTE?: number | null;
  FlagModal_AVERAGE_EQUAL?: number | null;
  FlagModal_AVERAGE_GT?: number | null;
  FlagModal_AVERAGE_GTE?: number | null;
  FlagModal_AVERAGE_LT?: number | null;
  FlagModal_AVERAGE_LTE?: number | null;
  FlagModal_EQUAL?: string | null;
  FlagModal_GT?: number | null;
  FlagModal_GTE?: number | null;
  FlagModal_LONGEST_EQUAL?: number | null;
  FlagModal_LONGEST_GT?: number | null;
  FlagModal_LONGEST_GTE?: number | null;
  FlagModal_LONGEST_LT?: number | null;
  FlagModal_LONGEST_LTE?: number | null;
  FlagModal_LT?: number | null;
  FlagModal_LTE?: number | null;
  FlagModal_SHORTEST_EQUAL?: number | null;
  FlagModal_SHORTEST_GT?: number | null;
  FlagModal_SHORTEST_GTE?: number | null;
  FlagModal_SHORTEST_LT?: number | null;
  FlagModal_SHORTEST_LTE?: number | null;
  FlagNarcosis_AVERAGE_EQUAL?: number | null;
  FlagNarcosis_AVERAGE_GT?: number | null;
  FlagNarcosis_AVERAGE_GTE?: number | null;
  FlagNarcosis_AVERAGE_LT?: number | null;
  FlagNarcosis_AVERAGE_LTE?: number | null;
  FlagNarcosis_EQUAL?: string | null;
  FlagNarcosis_GT?: number | null;
  FlagNarcosis_GTE?: number | null;
  FlagNarcosis_LONGEST_EQUAL?: number | null;
  FlagNarcosis_LONGEST_GT?: number | null;
  FlagNarcosis_LONGEST_GTE?: number | null;
  FlagNarcosis_LONGEST_LT?: number | null;
  FlagNarcosis_LONGEST_LTE?: number | null;
  FlagNarcosis_LT?: number | null;
  FlagNarcosis_LTE?: number | null;
  FlagNarcosis_SHORTEST_EQUAL?: number | null;
  FlagNarcosis_SHORTEST_GT?: number | null;
  FlagNarcosis_SHORTEST_GTE?: number | null;
  FlagNarcosis_SHORTEST_LT?: number | null;
  FlagNarcosis_SHORTEST_LTE?: number | null;
  GTIN_AVERAGE_EQUAL?: number | null;
  GTIN_AVERAGE_GT?: number | null;
  GTIN_AVERAGE_GTE?: number | null;
  GTIN_AVERAGE_LT?: number | null;
  GTIN_AVERAGE_LTE?: number | null;
  GTIN_EQUAL?: string | null;
  GTIN_GT?: number | null;
  GTIN_GTE?: number | null;
  GTIN_LONGEST_EQUAL?: number | null;
  GTIN_LONGEST_GT?: number | null;
  GTIN_LONGEST_GTE?: number | null;
  GTIN_LONGEST_LT?: number | null;
  GTIN_LONGEST_LTE?: number | null;
  GTIN_LT?: number | null;
  GTIN_LTE?: number | null;
  GTIN_SHORTEST_EQUAL?: number | null;
  GTIN_SHORTEST_GT?: number | null;
  GTIN_SHORTEST_GTE?: number | null;
  GTIN_SHORTEST_LT?: number | null;
  GTIN_SHORTEST_LTE?: number | null;
  LOT_AVERAGE_EQUAL?: number | null;
  LOT_AVERAGE_GT?: number | null;
  LOT_AVERAGE_GTE?: number | null;
  LOT_AVERAGE_LT?: number | null;
  LOT_AVERAGE_LTE?: number | null;
  LOT_EQUAL?: string | null;
  LOT_GT?: number | null;
  LOT_GTE?: number | null;
  LOT_LONGEST_EQUAL?: number | null;
  LOT_LONGEST_GT?: number | null;
  LOT_LONGEST_GTE?: number | null;
  LOT_LONGEST_LT?: number | null;
  LOT_LONGEST_LTE?: number | null;
  LOT_LT?: number | null;
  LOT_LTE?: number | null;
  LOT_SHORTEST_EQUAL?: number | null;
  LOT_SHORTEST_GT?: number | null;
  LOT_SHORTEST_GTE?: number | null;
  LOT_SHORTEST_LT?: number | null;
  LOT_SHORTEST_LTE?: number | null;
  Name_AVERAGE_EQUAL?: number | null;
  Name_AVERAGE_GT?: number | null;
  Name_AVERAGE_GTE?: number | null;
  Name_AVERAGE_LT?: number | null;
  Name_AVERAGE_LTE?: number | null;
  Name_EQUAL?: string | null;
  Name_GT?: number | null;
  Name_GTE?: number | null;
  Name_LONGEST_EQUAL?: number | null;
  Name_LONGEST_GT?: number | null;
  Name_LONGEST_GTE?: number | null;
  Name_LONGEST_LT?: number | null;
  Name_LONGEST_LTE?: number | null;
  Name_LT?: number | null;
  Name_LTE?: number | null;
  Name_SHORTEST_EQUAL?: number | null;
  Name_SHORTEST_GT?: number | null;
  Name_SHORTEST_GTE?: number | null;
  Name_SHORTEST_LT?: number | null;
  Name_SHORTEST_LTE?: number | null;
  OR?: ScenarioConditionTreatmentsNodeAggregationWhereInput[] | null;
  PharmaCode_AVERAGE_EQUAL?: number | null;
  PharmaCode_AVERAGE_GT?: number | null;
  PharmaCode_AVERAGE_GTE?: number | null;
  PharmaCode_AVERAGE_LT?: number | null;
  PharmaCode_AVERAGE_LTE?: number | null;
  PharmaCode_EQUAL?: string | null;
  PharmaCode_GT?: number | null;
  PharmaCode_GTE?: number | null;
  PharmaCode_LONGEST_EQUAL?: number | null;
  PharmaCode_LONGEST_GT?: number | null;
  PharmaCode_LONGEST_GTE?: number | null;
  PharmaCode_LONGEST_LT?: number | null;
  PharmaCode_LONGEST_LTE?: number | null;
  PharmaCode_LT?: number | null;
  PharmaCode_LTE?: number | null;
  PharmaCode_SHORTEST_EQUAL?: number | null;
  PharmaCode_SHORTEST_GT?: number | null;
  PharmaCode_SHORTEST_GTE?: number | null;
  PharmaCode_SHORTEST_LT?: number | null;
  PharmaCode_SHORTEST_LTE?: number | null;
  PrevPharmacode_AVERAGE_EQUAL?: number | null;
  PrevPharmacode_AVERAGE_GT?: number | null;
  PrevPharmacode_AVERAGE_GTE?: number | null;
  PrevPharmacode_AVERAGE_LT?: number | null;
  PrevPharmacode_AVERAGE_LTE?: number | null;
  PrevPharmacode_EQUAL?: string | null;
  PrevPharmacode_GT?: number | null;
  PrevPharmacode_GTE?: number | null;
  PrevPharmacode_LONGEST_EQUAL?: number | null;
  PrevPharmacode_LONGEST_GT?: number | null;
  PrevPharmacode_LONGEST_GTE?: number | null;
  PrevPharmacode_LONGEST_LT?: number | null;
  PrevPharmacode_LONGEST_LTE?: number | null;
  PrevPharmacode_LT?: number | null;
  PrevPharmacode_LTE?: number | null;
  PrevPharmacode_SHORTEST_EQUAL?: number | null;
  PrevPharmacode_SHORTEST_GT?: number | null;
  PrevPharmacode_SHORTEST_GTE?: number | null;
  PrevPharmacode_SHORTEST_LT?: number | null;
  PrevPharmacode_SHORTEST_LTE?: number | null;
  REF_AVERAGE_EQUAL?: number | null;
  REF_AVERAGE_GT?: number | null;
  REF_AVERAGE_GTE?: number | null;
  REF_AVERAGE_LT?: number | null;
  REF_AVERAGE_LTE?: number | null;
  REF_EQUAL?: string | null;
  REF_GT?: number | null;
  REF_GTE?: number | null;
  REF_LONGEST_EQUAL?: number | null;
  REF_LONGEST_GT?: number | null;
  REF_LONGEST_GTE?: number | null;
  REF_LONGEST_LT?: number | null;
  REF_LONGEST_LTE?: number | null;
  REF_LT?: number | null;
  REF_LTE?: number | null;
  REF_SHORTEST_EQUAL?: number | null;
  REF_SHORTEST_GT?: number | null;
  REF_SHORTEST_GTE?: number | null;
  REF_SHORTEST_LT?: number | null;
  REF_SHORTEST_LTE?: number | null;
  SwissmedicCategory_AVERAGE_EQUAL?: number | null;
  SwissmedicCategory_AVERAGE_GT?: number | null;
  SwissmedicCategory_AVERAGE_GTE?: number | null;
  SwissmedicCategory_AVERAGE_LT?: number | null;
  SwissmedicCategory_AVERAGE_LTE?: number | null;
  SwissmedicCategory_EQUAL?: string | null;
  SwissmedicCategory_GT?: number | null;
  SwissmedicCategory_GTE?: number | null;
  SwissmedicCategory_LONGEST_EQUAL?: number | null;
  SwissmedicCategory_LONGEST_GT?: number | null;
  SwissmedicCategory_LONGEST_GTE?: number | null;
  SwissmedicCategory_LONGEST_LT?: number | null;
  SwissmedicCategory_LONGEST_LTE?: number | null;
  SwissmedicCategory_LT?: number | null;
  SwissmedicCategory_LTE?: number | null;
  SwissmedicCategory_SHORTEST_EQUAL?: number | null;
  SwissmedicCategory_SHORTEST_GT?: number | null;
  SwissmedicCategory_SHORTEST_GTE?: number | null;
  SwissmedicCategory_SHORTEST_LT?: number | null;
  SwissmedicCategory_SHORTEST_LTE?: number | null;
  SwissmedicNo8_AVERAGE_EQUAL?: number | null;
  SwissmedicNo8_AVERAGE_GT?: number | null;
  SwissmedicNo8_AVERAGE_GTE?: number | null;
  SwissmedicNo8_AVERAGE_LT?: number | null;
  SwissmedicNo8_AVERAGE_LTE?: number | null;
  SwissmedicNo8_EQUAL?: string | null;
  SwissmedicNo8_GT?: number | null;
  SwissmedicNo8_GTE?: number | null;
  SwissmedicNo8_LONGEST_EQUAL?: number | null;
  SwissmedicNo8_LONGEST_GT?: number | null;
  SwissmedicNo8_LONGEST_GTE?: number | null;
  SwissmedicNo8_LONGEST_LT?: number | null;
  SwissmedicNo8_LONGEST_LTE?: number | null;
  SwissmedicNo8_LT?: number | null;
  SwissmedicNo8_LTE?: number | null;
  SwissmedicNo8_SHORTEST_EQUAL?: number | null;
  SwissmedicNo8_SHORTEST_GT?: number | null;
  SwissmedicNo8_SHORTEST_GTE?: number | null;
  SwissmedicNo8_SHORTEST_LT?: number | null;
  SwissmedicNo8_SHORTEST_LTE?: number | null;
  UDI_AVERAGE_EQUAL?: number | null;
  UDI_AVERAGE_GT?: number | null;
  UDI_AVERAGE_GTE?: number | null;
  UDI_AVERAGE_LT?: number | null;
  UDI_AVERAGE_LTE?: number | null;
  UDI_EQUAL?: string | null;
  UDI_GT?: number | null;
  UDI_GTE?: number | null;
  UDI_LONGEST_EQUAL?: number | null;
  UDI_LONGEST_GT?: number | null;
  UDI_LONGEST_GTE?: number | null;
  UDI_LONGEST_LT?: number | null;
  UDI_LONGEST_LTE?: number | null;
  UDI_LT?: number | null;
  UDI_LTE?: number | null;
  UDI_SHORTEST_EQUAL?: number | null;
  UDI_SHORTEST_GT?: number | null;
  UDI_SHORTEST_GTE?: number | null;
  UDI_SHORTEST_LT?: number | null;
  UDI_SHORTEST_LTE?: number | null;
  activeIngredientQuantity_AVERAGE_EQUAL?: number | null;
  activeIngredientQuantity_AVERAGE_GT?: number | null;
  activeIngredientQuantity_AVERAGE_GTE?: number | null;
  activeIngredientQuantity_AVERAGE_LT?: number | null;
  activeIngredientQuantity_AVERAGE_LTE?: number | null;
  activeIngredientQuantity_EQUAL?: number | null;
  activeIngredientQuantity_GT?: number | null;
  activeIngredientQuantity_GTE?: number | null;
  activeIngredientQuantity_LT?: number | null;
  activeIngredientQuantity_LTE?: number | null;
  activeIngredientQuantity_MAX_EQUAL?: number | null;
  activeIngredientQuantity_MAX_GT?: number | null;
  activeIngredientQuantity_MAX_GTE?: number | null;
  activeIngredientQuantity_MAX_LT?: number | null;
  activeIngredientQuantity_MAX_LTE?: number | null;
  activeIngredientQuantity_MIN_EQUAL?: number | null;
  activeIngredientQuantity_MIN_GT?: number | null;
  activeIngredientQuantity_MIN_GTE?: number | null;
  activeIngredientQuantity_MIN_LT?: number | null;
  activeIngredientQuantity_MIN_LTE?: number | null;
  activeIngredientQuantity_SUM_EQUAL?: number | null;
  activeIngredientQuantity_SUM_GT?: number | null;
  activeIngredientQuantity_SUM_GTE?: number | null;
  activeIngredientQuantity_SUM_LT?: number | null;
  activeIngredientQuantity_SUM_LTE?: number | null;
  classificationSystem_AVERAGE_EQUAL?: number | null;
  classificationSystem_AVERAGE_GT?: number | null;
  classificationSystem_AVERAGE_GTE?: number | null;
  classificationSystem_AVERAGE_LT?: number | null;
  classificationSystem_AVERAGE_LTE?: number | null;
  classificationSystem_EQUAL?: string | null;
  classificationSystem_GT?: number | null;
  classificationSystem_GTE?: number | null;
  classificationSystem_LONGEST_EQUAL?: number | null;
  classificationSystem_LONGEST_GT?: number | null;
  classificationSystem_LONGEST_GTE?: number | null;
  classificationSystem_LONGEST_LT?: number | null;
  classificationSystem_LONGEST_LTE?: number | null;
  classificationSystem_LT?: number | null;
  classificationSystem_LTE?: number | null;
  classificationSystem_SHORTEST_EQUAL?: number | null;
  classificationSystem_SHORTEST_GT?: number | null;
  classificationSystem_SHORTEST_GTE?: number | null;
  classificationSystem_SHORTEST_LT?: number | null;
  classificationSystem_SHORTEST_LTE?: number | null;
  concentration_AVERAGE_EQUAL?: number | null;
  concentration_AVERAGE_GT?: number | null;
  concentration_AVERAGE_GTE?: number | null;
  concentration_AVERAGE_LT?: number | null;
  concentration_AVERAGE_LTE?: number | null;
  concentration_EQUAL?: string | null;
  concentration_GT?: number | null;
  concentration_GTE?: number | null;
  concentration_LONGEST_EQUAL?: number | null;
  concentration_LONGEST_GT?: number | null;
  concentration_LONGEST_GTE?: number | null;
  concentration_LONGEST_LT?: number | null;
  concentration_LONGEST_LTE?: number | null;
  concentration_LT?: number | null;
  concentration_LTE?: number | null;
  concentration_SHORTEST_EQUAL?: number | null;
  concentration_SHORTEST_GT?: number | null;
  concentration_SHORTEST_GTE?: number | null;
  concentration_SHORTEST_LT?: number | null;
  concentration_SHORTEST_LTE?: number | null;
  packVolume_AVERAGE_EQUAL?: number | null;
  packVolume_AVERAGE_GT?: number | null;
  packVolume_AVERAGE_GTE?: number | null;
  packVolume_AVERAGE_LT?: number | null;
  packVolume_AVERAGE_LTE?: number | null;
  packVolume_EQUAL?: string | null;
  packVolume_GT?: number | null;
  packVolume_GTE?: number | null;
  packVolume_LONGEST_EQUAL?: number | null;
  packVolume_LONGEST_GT?: number | null;
  packVolume_LONGEST_GTE?: number | null;
  packVolume_LONGEST_LT?: number | null;
  packVolume_LONGEST_LTE?: number | null;
  packVolume_LT?: number | null;
  packVolume_LTE?: number | null;
  packVolume_SHORTEST_EQUAL?: number | null;
  packVolume_SHORTEST_GT?: number | null;
  packVolume_SHORTEST_GTE?: number | null;
  packVolume_SHORTEST_LT?: number | null;
  packVolume_SHORTEST_LTE?: number | null;
}

export interface ScenarioConditionWhere {
  AND?: ScenarioConditionWhere[] | null;
  OR?: ScenarioConditionWhere[] | null;
  adverseEvents?: AdverseEventType[] | null;
  adverseEvents_INCLUDES?: AdverseEventType | null;
  adverseEvents_NOT?: AdverseEventType[] | null;
  adverseEvents_NOT_INCLUDES?: AdverseEventType | null;
  bothOperatorFirst?: ArithmeticalOperator | null;
  bothOperatorFirst_IN?: (ArithmeticalOperator | null)[] | null;
  bothOperatorFirst_NOT?: ArithmeticalOperator | null;
  bothOperatorFirst_NOT_IN?: (ArithmeticalOperator | null)[] | null;
  bothOperatorSecond?: ArithmeticalOperator | null;
  bothOperatorSecond_IN?: (ArithmeticalOperator | null)[] | null;
  bothOperatorSecond_NOT?: ArithmeticalOperator | null;
  bothOperatorSecond_NOT_IN?: (ArithmeticalOperator | null)[] | null;
  brands?: BrandWhere | null;
  brandsAggregate?: ScenarioConditionBrandsAggregateInput | null;
  brandsConnection?: ScenarioConditionBrandsConnectionWhere | null;
  brandsConnection_NOT?: ScenarioConditionBrandsConnectionWhere | null;
  brands_NOT?: BrandWhere | null;
  comparedCountdownPoint?: CountdownPoint | null;
  comparedCountdownPoint_IN?: (CountdownPoint | null)[] | null;
  comparedCountdownPoint_NOT?: CountdownPoint | null;
  comparedCountdownPoint_NOT_IN?: (CountdownPoint | null)[] | null;
  comparedStartingPoint?: TimeframeStartingPoint | null;
  comparedStartingPoint_IN?: (TimeframeStartingPoint | null)[] | null;
  comparedStartingPoint_NOT?: TimeframeStartingPoint | null;
  comparedStartingPoint_NOT_IN?: (TimeframeStartingPoint | null)[] | null;
  comparedTimeframeEnd?: number | null;
  comparedTimeframeEnd_GT?: number | null;
  comparedTimeframeEnd_GTE?: number | null;
  comparedTimeframeEnd_IN?: (number | null)[] | null;
  comparedTimeframeEnd_LT?: number | null;
  comparedTimeframeEnd_LTE?: number | null;
  comparedTimeframeEnd_NOT?: number | null;
  comparedTimeframeEnd_NOT_IN?: (number | null)[] | null;
  comparedTimeframeRangeType?: TimeframeRangeType | null;
  comparedTimeframeRangeType_IN?: (TimeframeRangeType | null)[] | null;
  comparedTimeframeRangeType_NOT?: TimeframeRangeType | null;
  comparedTimeframeRangeType_NOT_IN?: (TimeframeRangeType | null)[] | null;
  comparedTimeframeRelation?: TimeframeRelation | null;
  comparedTimeframeRelation_IN?: (TimeframeRelation | null)[] | null;
  comparedTimeframeRelation_NOT?: TimeframeRelation | null;
  comparedTimeframeRelation_NOT_IN?: (TimeframeRelation | null)[] | null;
  comparedTimeframeStart?: number | null;
  comparedTimeframeStart_GT?: number | null;
  comparedTimeframeStart_GTE?: number | null;
  comparedTimeframeStart_IN?: (number | null)[] | null;
  comparedTimeframeStart_LT?: number | null;
  comparedTimeframeStart_LTE?: number | null;
  comparedTimeframeStart_NOT?: number | null;
  comparedTimeframeStart_NOT_IN?: (number | null)[] | null;
  conditionStatus?: OutcomeBasedStatus[] | null;
  conditionStatus_INCLUDES?: OutcomeBasedStatus | null;
  conditionStatus_NOT?: OutcomeBasedStatus[] | null;
  conditionStatus_NOT_INCLUDES?: OutcomeBasedStatus | null;
  conditionType?: ConditionType | null;
  conditionType_IN?: (ConditionType | null)[] | null;
  conditionType_NOT?: ConditionType | null;
  conditionType_NOT_IN?: (ConditionType | null)[] | null;
  consideredRating?: ConditionConsideredRating | null;
  consideredRating_IN?: (ConditionConsideredRating | null)[] | null;
  consideredRating_NOT?: ConditionConsideredRating | null;
  consideredRating_NOT_IN?: (ConditionConsideredRating | null)[] | null;
  consideredSecInterventionRate?: ConditionConsideredSecIntervention | null;
  consideredSecInterventionRate_IN?: (ConditionConsideredSecIntervention | null)[] | null;
  consideredSecInterventionRate_NOT?: ConditionConsideredSecIntervention | null;
  consideredSecInterventionRate_NOT_IN?: (ConditionConsideredSecIntervention | null)[] | null;
  countdownPoint?: CountdownPoint | null;
  countdownPoint_IN?: (CountdownPoint | null)[] | null;
  countdownPoint_NOT?: CountdownPoint | null;
  countdownPoint_NOT_IN?: (CountdownPoint | null)[] | null;
  deltaType?: DeltaType | null;
  deltaType_IN?: (DeltaType | null)[] | null;
  deltaType_NOT?: DeltaType | null;
  deltaType_NOT_IN?: (DeltaType | null)[] | null;
  discontinuationReason?: TreatmentDiscontinuationReason | null;
  discontinuationReason_IN?: (TreatmentDiscontinuationReason | null)[] | null;
  discontinuationReason_NOT?: TreatmentDiscontinuationReason | null;
  discontinuationReason_NOT_IN?: (TreatmentDiscontinuationReason | null)[] | null;
  endRangeValue?: number | null;
  endRangeValue_GT?: number | null;
  endRangeValue_GTE?: number | null;
  endRangeValue_IN?: (number | null)[] | null;
  endRangeValue_LT?: number | null;
  endRangeValue_LTE?: number | null;
  endRangeValue_NOT?: number | null;
  endRangeValue_NOT_IN?: (number | null)[] | null;
  generics?: GenericWhere | null;
  genericsAggregate?: ScenarioConditionGenericsAggregateInput | null;
  genericsConnection?: ScenarioConditionGenericsConnectionWhere | null;
  genericsConnection_NOT?: ScenarioConditionGenericsConnectionWhere | null;
  generics_NOT?: GenericWhere | null;
  grades?: AdverseEventGrades[] | null;
  grades_INCLUDES?: AdverseEventGrades | null;
  grades_NOT?: AdverseEventGrades[] | null;
  grades_NOT_INCLUDES?: AdverseEventGrades | null;
  intervention?: InterventionType | null;
  interventionOccurrence?: InterventionOccurrence | null;
  interventionOccurrence_IN?: (InterventionOccurrence | null)[] | null;
  interventionOccurrence_NOT?: InterventionOccurrence | null;
  interventionOccurrence_NOT_IN?: (InterventionOccurrence | null)[] | null;
  intervention_IN?: (InterventionType | null)[] | null;
  intervention_NOT?: InterventionType | null;
  intervention_NOT_IN?: (InterventionType | null)[] | null;
  isNamedTimeRangeUsed?: boolean | null;
  isNamedTimeRangeUsed_NOT?: boolean | null;
  isScenarioRelevantDrugsActive?: boolean | null;
  isScenarioRelevantDrugsActive_NOT?: boolean | null;
  monitoringType?: MonitoringType | null;
  monitoringType_IN?: (MonitoringType | null)[] | null;
  monitoringType_NOT?: MonitoringType | null;
  monitoringType_NOT_IN?: (MonitoringType | null)[] | null;
  occurence?: Occurrence | null;
  occurence_IN?: (Occurrence | null)[] | null;
  occurence_NOT?: Occurrence | null;
  occurence_NOT_IN?: (Occurrence | null)[] | null;
  operator?: ArithmeticalOperator | null;
  operator_IN?: (ArithmeticalOperator | null)[] | null;
  operator_NOT?: ArithmeticalOperator | null;
  operator_NOT_IN?: (ArithmeticalOperator | null)[] | null;
  order?: number | null;
  order_GT?: number | null;
  order_GTE?: number | null;
  order_IN?: (number | null)[] | null;
  order_LT?: number | null;
  order_LTE?: number | null;
  order_NOT?: number | null;
  order_NOT_IN?: (number | null)[] | null;
  patientScope?: PatientScope | null;
  patientScope_IN?: (PatientScope | null)[] | null;
  patientScope_NOT?: PatientScope | null;
  patientScope_NOT_IN?: (PatientScope | null)[] | null;
  reintervention?: Reintervention | null;
  reintervention_IN?: (Reintervention | null)[] | null;
  reintervention_NOT?: Reintervention | null;
  reintervention_NOT_IN?: (Reintervention | null)[] | null;
  responseInclusionType?: ResponseInclusionType | null;
  responseInclusionType_IN?: (ResponseInclusionType | null)[] | null;
  responseInclusionType_NOT?: ResponseInclusionType | null;
  responseInclusionType_NOT_IN?: (ResponseInclusionType | null)[] | null;
  responseType?: UnitedResponseType | null;
  responseType_IN?: (UnitedResponseType | null)[] | null;
  responseType_NOT?: UnitedResponseType | null;
  responseType_NOT_IN?: (UnitedResponseType | null)[] | null;
  rollingRangeType?: RollingRangeType | null;
  rollingRangeType_IN?: (RollingRangeType | null)[] | null;
  rollingRangeType_NOT?: RollingRangeType | null;
  rollingRangeType_NOT_IN?: (RollingRangeType | null)[] | null;
  scenario?: ScenarioWhere | null;
  scenarioAggregate?: ScenarioConditionScenarioAggregateInput | null;
  scenarioConnection?: ScenarioConditionScenarioConnectionWhere | null;
  scenarioConnection_NOT?: ScenarioConditionScenarioConnectionWhere | null;
  scenario_NOT?: ScenarioWhere | null;
  startingPoint?: TimeframeStartingPoint | null;
  startingPoint_IN?: (TimeframeStartingPoint | null)[] | null;
  startingPoint_NOT?: TimeframeStartingPoint | null;
  startingPoint_NOT_IN?: (TimeframeStartingPoint | null)[] | null;
  timeframeEnd?: number | null;
  timeframeEnd_GT?: number | null;
  timeframeEnd_GTE?: number | null;
  timeframeEnd_IN?: (number | null)[] | null;
  timeframeEnd_LT?: number | null;
  timeframeEnd_LTE?: number | null;
  timeframeEnd_NOT?: number | null;
  timeframeEnd_NOT_IN?: (number | null)[] | null;
  timeframeRangeType?: TimeframeRangeType | null;
  timeframeRangeType_IN?: (TimeframeRangeType | null)[] | null;
  timeframeRangeType_NOT?: TimeframeRangeType | null;
  timeframeRangeType_NOT_IN?: (TimeframeRangeType | null)[] | null;
  timeframeRelation?: TimeframeRelation | null;
  timeframeRelation_IN?: (TimeframeRelation | null)[] | null;
  timeframeRelation_NOT?: TimeframeRelation | null;
  timeframeRelation_NOT_IN?: (TimeframeRelation | null)[] | null;
  timeframeStart?: number | null;
  timeframeStart_GT?: number | null;
  timeframeStart_GTE?: number | null;
  timeframeStart_IN?: (number | null)[] | null;
  timeframeStart_LT?: number | null;
  timeframeStart_LTE?: number | null;
  timeframeStart_NOT?: number | null;
  timeframeStart_NOT_IN?: (number | null)[] | null;
  treatmentDurationAspect?: TreatmentDurationConditionAspect | null;
  treatmentDurationAspect_IN?: (TreatmentDurationConditionAspect | null)[] | null;
  treatmentDurationAspect_NOT?: TreatmentDurationConditionAspect | null;
  treatmentDurationAspect_NOT_IN?: (TreatmentDurationConditionAspect | null)[] | null;
  treatments?: TreatmentWhere | null;
  treatmentsAggregate?: ScenarioConditionTreatmentsAggregateInput | null;
  treatmentsConnection?: ScenarioConditionTreatmentsConnectionWhere | null;
  treatmentsConnection_NOT?: ScenarioConditionTreatmentsConnectionWhere | null;
  treatments_NOT?: TreatmentWhere | null;
  uoMType?: UoMType | null;
  uoMType_IN?: (UoMType | null)[] | null;
  uoMType_NOT?: UoMType | null;
  uoMType_NOT_IN?: (UoMType | null)[] | null;
  value?: number | null;
  value_GT?: number | null;
  value_GTE?: number | null;
  value_IN?: (number | null)[] | null;
  value_LT?: number | null;
  value_LTE?: number | null;
  value_NOT?: number | null;
  value_NOT_IN?: (number | null)[] | null;
}

export interface ScenarioConditionsAggregateInput {
  AND?: ScenarioConditionsAggregateInput[] | null;
  OR?: ScenarioConditionsAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: ScenarioConditionsNodeAggregationWhereInput | null;
}

export interface ScenarioConditionsConnectionWhere {
  AND?: ScenarioConditionsConnectionWhere[] | null;
  OR?: ScenarioConditionsConnectionWhere[] | null;
  node?: ScenarioConditionWhere | null;
  node_NOT?: ScenarioConditionWhere | null;
}

export interface ScenarioConditionsNodeAggregationWhereInput {
  AND?: ScenarioConditionsNodeAggregationWhereInput[] | null;
  OR?: ScenarioConditionsNodeAggregationWhereInput[] | null;
  comparedTimeframeEnd_AVERAGE_EQUAL?: number | null;
  comparedTimeframeEnd_AVERAGE_GT?: number | null;
  comparedTimeframeEnd_AVERAGE_GTE?: number | null;
  comparedTimeframeEnd_AVERAGE_LT?: number | null;
  comparedTimeframeEnd_AVERAGE_LTE?: number | null;
  comparedTimeframeEnd_EQUAL?: number | null;
  comparedTimeframeEnd_GT?: number | null;
  comparedTimeframeEnd_GTE?: number | null;
  comparedTimeframeEnd_LT?: number | null;
  comparedTimeframeEnd_LTE?: number | null;
  comparedTimeframeEnd_MAX_EQUAL?: number | null;
  comparedTimeframeEnd_MAX_GT?: number | null;
  comparedTimeframeEnd_MAX_GTE?: number | null;
  comparedTimeframeEnd_MAX_LT?: number | null;
  comparedTimeframeEnd_MAX_LTE?: number | null;
  comparedTimeframeEnd_MIN_EQUAL?: number | null;
  comparedTimeframeEnd_MIN_GT?: number | null;
  comparedTimeframeEnd_MIN_GTE?: number | null;
  comparedTimeframeEnd_MIN_LT?: number | null;
  comparedTimeframeEnd_MIN_LTE?: number | null;
  comparedTimeframeEnd_SUM_EQUAL?: number | null;
  comparedTimeframeEnd_SUM_GT?: number | null;
  comparedTimeframeEnd_SUM_GTE?: number | null;
  comparedTimeframeEnd_SUM_LT?: number | null;
  comparedTimeframeEnd_SUM_LTE?: number | null;
  comparedTimeframeStart_AVERAGE_EQUAL?: number | null;
  comparedTimeframeStart_AVERAGE_GT?: number | null;
  comparedTimeframeStart_AVERAGE_GTE?: number | null;
  comparedTimeframeStart_AVERAGE_LT?: number | null;
  comparedTimeframeStart_AVERAGE_LTE?: number | null;
  comparedTimeframeStart_EQUAL?: number | null;
  comparedTimeframeStart_GT?: number | null;
  comparedTimeframeStart_GTE?: number | null;
  comparedTimeframeStart_LT?: number | null;
  comparedTimeframeStart_LTE?: number | null;
  comparedTimeframeStart_MAX_EQUAL?: number | null;
  comparedTimeframeStart_MAX_GT?: number | null;
  comparedTimeframeStart_MAX_GTE?: number | null;
  comparedTimeframeStart_MAX_LT?: number | null;
  comparedTimeframeStart_MAX_LTE?: number | null;
  comparedTimeframeStart_MIN_EQUAL?: number | null;
  comparedTimeframeStart_MIN_GT?: number | null;
  comparedTimeframeStart_MIN_GTE?: number | null;
  comparedTimeframeStart_MIN_LT?: number | null;
  comparedTimeframeStart_MIN_LTE?: number | null;
  comparedTimeframeStart_SUM_EQUAL?: number | null;
  comparedTimeframeStart_SUM_GT?: number | null;
  comparedTimeframeStart_SUM_GTE?: number | null;
  comparedTimeframeStart_SUM_LT?: number | null;
  comparedTimeframeStart_SUM_LTE?: number | null;
  endRangeValue_AVERAGE_EQUAL?: number | null;
  endRangeValue_AVERAGE_GT?: number | null;
  endRangeValue_AVERAGE_GTE?: number | null;
  endRangeValue_AVERAGE_LT?: number | null;
  endRangeValue_AVERAGE_LTE?: number | null;
  endRangeValue_EQUAL?: number | null;
  endRangeValue_GT?: number | null;
  endRangeValue_GTE?: number | null;
  endRangeValue_LT?: number | null;
  endRangeValue_LTE?: number | null;
  endRangeValue_MAX_EQUAL?: number | null;
  endRangeValue_MAX_GT?: number | null;
  endRangeValue_MAX_GTE?: number | null;
  endRangeValue_MAX_LT?: number | null;
  endRangeValue_MAX_LTE?: number | null;
  endRangeValue_MIN_EQUAL?: number | null;
  endRangeValue_MIN_GT?: number | null;
  endRangeValue_MIN_GTE?: number | null;
  endRangeValue_MIN_LT?: number | null;
  endRangeValue_MIN_LTE?: number | null;
  endRangeValue_SUM_EQUAL?: number | null;
  endRangeValue_SUM_GT?: number | null;
  endRangeValue_SUM_GTE?: number | null;
  endRangeValue_SUM_LT?: number | null;
  endRangeValue_SUM_LTE?: number | null;
  order_AVERAGE_EQUAL?: number | null;
  order_AVERAGE_GT?: number | null;
  order_AVERAGE_GTE?: number | null;
  order_AVERAGE_LT?: number | null;
  order_AVERAGE_LTE?: number | null;
  order_EQUAL?: number | null;
  order_GT?: number | null;
  order_GTE?: number | null;
  order_LT?: number | null;
  order_LTE?: number | null;
  order_MAX_EQUAL?: number | null;
  order_MAX_GT?: number | null;
  order_MAX_GTE?: number | null;
  order_MAX_LT?: number | null;
  order_MAX_LTE?: number | null;
  order_MIN_EQUAL?: number | null;
  order_MIN_GT?: number | null;
  order_MIN_GTE?: number | null;
  order_MIN_LT?: number | null;
  order_MIN_LTE?: number | null;
  order_SUM_EQUAL?: number | null;
  order_SUM_GT?: number | null;
  order_SUM_GTE?: number | null;
  order_SUM_LT?: number | null;
  order_SUM_LTE?: number | null;
  timeframeEnd_AVERAGE_EQUAL?: number | null;
  timeframeEnd_AVERAGE_GT?: number | null;
  timeframeEnd_AVERAGE_GTE?: number | null;
  timeframeEnd_AVERAGE_LT?: number | null;
  timeframeEnd_AVERAGE_LTE?: number | null;
  timeframeEnd_EQUAL?: number | null;
  timeframeEnd_GT?: number | null;
  timeframeEnd_GTE?: number | null;
  timeframeEnd_LT?: number | null;
  timeframeEnd_LTE?: number | null;
  timeframeEnd_MAX_EQUAL?: number | null;
  timeframeEnd_MAX_GT?: number | null;
  timeframeEnd_MAX_GTE?: number | null;
  timeframeEnd_MAX_LT?: number | null;
  timeframeEnd_MAX_LTE?: number | null;
  timeframeEnd_MIN_EQUAL?: number | null;
  timeframeEnd_MIN_GT?: number | null;
  timeframeEnd_MIN_GTE?: number | null;
  timeframeEnd_MIN_LT?: number | null;
  timeframeEnd_MIN_LTE?: number | null;
  timeframeEnd_SUM_EQUAL?: number | null;
  timeframeEnd_SUM_GT?: number | null;
  timeframeEnd_SUM_GTE?: number | null;
  timeframeEnd_SUM_LT?: number | null;
  timeframeEnd_SUM_LTE?: number | null;
  timeframeStart_AVERAGE_EQUAL?: number | null;
  timeframeStart_AVERAGE_GT?: number | null;
  timeframeStart_AVERAGE_GTE?: number | null;
  timeframeStart_AVERAGE_LT?: number | null;
  timeframeStart_AVERAGE_LTE?: number | null;
  timeframeStart_EQUAL?: number | null;
  timeframeStart_GT?: number | null;
  timeframeStart_GTE?: number | null;
  timeframeStart_LT?: number | null;
  timeframeStart_LTE?: number | null;
  timeframeStart_MAX_EQUAL?: number | null;
  timeframeStart_MAX_GT?: number | null;
  timeframeStart_MAX_GTE?: number | null;
  timeframeStart_MAX_LT?: number | null;
  timeframeStart_MAX_LTE?: number | null;
  timeframeStart_MIN_EQUAL?: number | null;
  timeframeStart_MIN_GT?: number | null;
  timeframeStart_MIN_GTE?: number | null;
  timeframeStart_MIN_LT?: number | null;
  timeframeStart_MIN_LTE?: number | null;
  timeframeStart_SUM_EQUAL?: number | null;
  timeframeStart_SUM_GT?: number | null;
  timeframeStart_SUM_GTE?: number | null;
  timeframeStart_SUM_LT?: number | null;
  timeframeStart_SUM_LTE?: number | null;
  value_AVERAGE_EQUAL?: number | null;
  value_AVERAGE_GT?: number | null;
  value_AVERAGE_GTE?: number | null;
  value_AVERAGE_LT?: number | null;
  value_AVERAGE_LTE?: number | null;
  value_EQUAL?: number | null;
  value_GT?: number | null;
  value_GTE?: number | null;
  value_LT?: number | null;
  value_LTE?: number | null;
  value_MAX_EQUAL?: number | null;
  value_MAX_GT?: number | null;
  value_MAX_GTE?: number | null;
  value_MAX_LT?: number | null;
  value_MAX_LTE?: number | null;
  value_MIN_EQUAL?: number | null;
  value_MIN_GT?: number | null;
  value_MIN_GTE?: number | null;
  value_MIN_LT?: number | null;
  value_MIN_LTE?: number | null;
  value_SUM_EQUAL?: number | null;
  value_SUM_GT?: number | null;
  value_SUM_GTE?: number | null;
  value_SUM_LT?: number | null;
  value_SUM_LTE?: number | null;
}

export interface ScenarioInsightsUserContextWhere {
  AND?: ScenarioInsightsUserContextWhere[] | null;
  OR?: ScenarioInsightsUserContextWhere[] | null;
  categoryInput?: string | null;
  categoryInput_CONTAINS?: string | null;
  categoryInput_ENDS_WITH?: string | null;
  categoryInput_IN?: (string | null)[] | null;
  categoryInput_MATCHES?: string | null;
  categoryInput_NOT?: string | null;
  categoryInput_NOT_CONTAINS?: string | null;
  categoryInput_NOT_ENDS_WITH?: string | null;
  categoryInput_NOT_IN?: (string | null)[] | null;
  categoryInput_NOT_STARTS_WITH?: string | null;
  categoryInput_STARTS_WITH?: string | null;
  groups?: (number | null)[] | null;
  groups_INCLUDES?: number | null;
  groups_NOT?: (number | null)[] | null;
  groups_NOT_INCLUDES?: number | null;
  rebateObjective?: string | null;
  rebateObjective_CONTAINS?: string | null;
  rebateObjective_ENDS_WITH?: string | null;
  rebateObjective_IN?: (string | null)[] | null;
  rebateObjective_MATCHES?: string | null;
  rebateObjective_NOT?: string | null;
  rebateObjective_NOT_CONTAINS?: string | null;
  rebateObjective_NOT_ENDS_WITH?: string | null;
  rebateObjective_NOT_IN?: (string | null)[] | null;
  rebateObjective_NOT_STARTS_WITH?: string | null;
  rebateObjective_STARTS_WITH?: string | null;
  timeframeLabel?: string | null;
  timeframeLabel_CONTAINS?: string | null;
  timeframeLabel_ENDS_WITH?: string | null;
  timeframeLabel_IN?: (string | null)[] | null;
  timeframeLabel_MATCHES?: string | null;
  timeframeLabel_NOT?: string | null;
  timeframeLabel_NOT_CONTAINS?: string | null;
  timeframeLabel_NOT_ENDS_WITH?: string | null;
  timeframeLabel_NOT_IN?: (string | null)[] | null;
  timeframeLabel_NOT_STARTS_WITH?: string | null;
  timeframeLabel_STARTS_WITH?: string | null;
}

export interface ScenarioWhere {
  AND?: ScenarioWhere[] | null;
  OR?: ScenarioWhere[] | null;
  actions?: ScenarioActionWhere | null;
  actionsAggregate?: ScenarioActionsAggregateInput | null;
  actionsConnection?: ScenarioActionsConnectionWhere | null;
  actionsConnection_NOT?: ScenarioActionsConnectionWhere | null;
  actions_NOT?: ScenarioActionWhere | null;
  agreement?: BaseAgreementWhere | null;
  agreementAggregate?: ScenarioAgreementAggregateInput | null;
  agreementConnection?: ScenarioAgreementConnectionWhere | null;
  agreementConnection_NOT?: ScenarioAgreementConnectionWhere | null;
  agreement_NOT?: BaseAgreementWhere | null;
  conditions?: ScenarioConditionWhere | null;
  conditionsAggregate?: ScenarioConditionsAggregateInput | null;
  conditionsConnection?: ScenarioConditionsConnectionWhere | null;
  conditionsConnection_NOT?: ScenarioConditionsConnectionWhere | null;
  conditions_NOT?: ScenarioConditionWhere | null;
  group?: number | null;
  group_GT?: number | null;
  group_GTE?: number | null;
  group_IN?: (number | null)[] | null;
  group_LT?: number | null;
  group_LTE?: number | null;
  group_NOT?: number | null;
  group_NOT_IN?: (number | null)[] | null;
  isForged?: boolean | null;
  isForged_NOT?: boolean | null;
  isGrouped?: boolean | null;
  isGrouped_NOT?: boolean | null;
  isProRating?: boolean | null;
  isProRating_NOT?: boolean | null;
  operator?: ConditionLogicalOperator | null;
  operator_IN?: (ConditionLogicalOperator | null)[] | null;
  operator_NOT?: ConditionLogicalOperator | null;
  operator_NOT_IN?: (ConditionLogicalOperator | null)[] | null;
  order?: number | null;
  order_GT?: number | null;
  order_GTE?: number | null;
  order_IN?: (number | null)[] | null;
  order_LT?: number | null;
  order_LTE?: number | null;
  order_NOT?: number | null;
  order_NOT_IN?: (number | null)[] | null;
}

export interface SearchUserEmailByNameInput {
  invoiceId: string;
  searchString?: string | null;
  targetTenantId?: string | null;
}

export interface SendDocumentForExternalReviewInput {
  id: string;
  receiverEmail: string;
  useCC?: boolean | null;
}

export interface SimulationAddedByAggregateInput {
  AND?: SimulationAddedByAggregateInput[] | null;
  OR?: SimulationAddedByAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: SimulationAddedByNodeAggregationWhereInput | null;
}

export interface SimulationAddedByConnectionWhere {
  AND?: SimulationAddedByConnectionWhere[] | null;
  OR?: SimulationAddedByConnectionWhere[] | null;
  node?: UserWhere | null;
  node_NOT?: UserWhere | null;
}

export interface SimulationAddedByNodeAggregationWhereInput {
  AND?: SimulationAddedByNodeAggregationWhereInput[] | null;
  OR?: SimulationAddedByNodeAggregationWhereInput[] | null;
  deletedOn_EQUAL?: any | null;
  deletedOn_GT?: any | null;
  deletedOn_GTE?: any | null;
  deletedOn_LT?: any | null;
  deletedOn_LTE?: any | null;
  deletedOn_MAX_EQUAL?: any | null;
  deletedOn_MAX_GT?: any | null;
  deletedOn_MAX_GTE?: any | null;
  deletedOn_MAX_LT?: any | null;
  deletedOn_MAX_LTE?: any | null;
  deletedOn_MIN_EQUAL?: any | null;
  deletedOn_MIN_GT?: any | null;
  deletedOn_MIN_GTE?: any | null;
  deletedOn_MIN_LT?: any | null;
  deletedOn_MIN_LTE?: any | null;
  department_AVERAGE_EQUAL?: number | null;
  department_AVERAGE_GT?: number | null;
  department_AVERAGE_GTE?: number | null;
  department_AVERAGE_LT?: number | null;
  department_AVERAGE_LTE?: number | null;
  department_EQUAL?: string | null;
  department_GT?: number | null;
  department_GTE?: number | null;
  department_LONGEST_EQUAL?: number | null;
  department_LONGEST_GT?: number | null;
  department_LONGEST_GTE?: number | null;
  department_LONGEST_LT?: number | null;
  department_LONGEST_LTE?: number | null;
  department_LT?: number | null;
  department_LTE?: number | null;
  department_SHORTEST_EQUAL?: number | null;
  department_SHORTEST_GT?: number | null;
  department_SHORTEST_GTE?: number | null;
  department_SHORTEST_LT?: number | null;
  department_SHORTEST_LTE?: number | null;
  email_AVERAGE_EQUAL?: number | null;
  email_AVERAGE_GT?: number | null;
  email_AVERAGE_GTE?: number | null;
  email_AVERAGE_LT?: number | null;
  email_AVERAGE_LTE?: number | null;
  email_EQUAL?: string | null;
  email_GT?: number | null;
  email_GTE?: number | null;
  email_LONGEST_EQUAL?: number | null;
  email_LONGEST_GT?: number | null;
  email_LONGEST_GTE?: number | null;
  email_LONGEST_LT?: number | null;
  email_LONGEST_LTE?: number | null;
  email_LT?: number | null;
  email_LTE?: number | null;
  email_SHORTEST_EQUAL?: number | null;
  email_SHORTEST_GT?: number | null;
  email_SHORTEST_GTE?: number | null;
  email_SHORTEST_LT?: number | null;
  email_SHORTEST_LTE?: number | null;
  firstName_AVERAGE_EQUAL?: number | null;
  firstName_AVERAGE_GT?: number | null;
  firstName_AVERAGE_GTE?: number | null;
  firstName_AVERAGE_LT?: number | null;
  firstName_AVERAGE_LTE?: number | null;
  firstName_EQUAL?: string | null;
  firstName_GT?: number | null;
  firstName_GTE?: number | null;
  firstName_LONGEST_EQUAL?: number | null;
  firstName_LONGEST_GT?: number | null;
  firstName_LONGEST_GTE?: number | null;
  firstName_LONGEST_LT?: number | null;
  firstName_LONGEST_LTE?: number | null;
  firstName_LT?: number | null;
  firstName_LTE?: number | null;
  firstName_SHORTEST_EQUAL?: number | null;
  firstName_SHORTEST_GT?: number | null;
  firstName_SHORTEST_GTE?: number | null;
  firstName_SHORTEST_LT?: number | null;
  firstName_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  lastName_AVERAGE_EQUAL?: number | null;
  lastName_AVERAGE_GT?: number | null;
  lastName_AVERAGE_GTE?: number | null;
  lastName_AVERAGE_LT?: number | null;
  lastName_AVERAGE_LTE?: number | null;
  lastName_EQUAL?: string | null;
  lastName_GT?: number | null;
  lastName_GTE?: number | null;
  lastName_LONGEST_EQUAL?: number | null;
  lastName_LONGEST_GT?: number | null;
  lastName_LONGEST_GTE?: number | null;
  lastName_LONGEST_LT?: number | null;
  lastName_LONGEST_LTE?: number | null;
  lastName_LT?: number | null;
  lastName_LTE?: number | null;
  lastName_SHORTEST_EQUAL?: number | null;
  lastName_SHORTEST_GT?: number | null;
  lastName_SHORTEST_GTE?: number | null;
  lastName_SHORTEST_LT?: number | null;
  lastName_SHORTEST_LTE?: number | null;
  position_AVERAGE_EQUAL?: number | null;
  position_AVERAGE_GT?: number | null;
  position_AVERAGE_GTE?: number | null;
  position_AVERAGE_LT?: number | null;
  position_AVERAGE_LTE?: number | null;
  position_EQUAL?: string | null;
  position_GT?: number | null;
  position_GTE?: number | null;
  position_LONGEST_EQUAL?: number | null;
  position_LONGEST_GT?: number | null;
  position_LONGEST_GTE?: number | null;
  position_LONGEST_LT?: number | null;
  position_LONGEST_LTE?: number | null;
  position_LT?: number | null;
  position_LTE?: number | null;
  position_SHORTEST_EQUAL?: number | null;
  position_SHORTEST_GT?: number | null;
  position_SHORTEST_GTE?: number | null;
  position_SHORTEST_LT?: number | null;
  position_SHORTEST_LTE?: number | null;
  preferredLanguage_AVERAGE_EQUAL?: number | null;
  preferredLanguage_AVERAGE_GT?: number | null;
  preferredLanguage_AVERAGE_GTE?: number | null;
  preferredLanguage_AVERAGE_LT?: number | null;
  preferredLanguage_AVERAGE_LTE?: number | null;
  preferredLanguage_EQUAL?: string | null;
  preferredLanguage_GT?: number | null;
  preferredLanguage_GTE?: number | null;
  preferredLanguage_LONGEST_EQUAL?: number | null;
  preferredLanguage_LONGEST_GT?: number | null;
  preferredLanguage_LONGEST_GTE?: number | null;
  preferredLanguage_LONGEST_LT?: number | null;
  preferredLanguage_LONGEST_LTE?: number | null;
  preferredLanguage_LT?: number | null;
  preferredLanguage_LTE?: number | null;
  preferredLanguage_SHORTEST_EQUAL?: number | null;
  preferredLanguage_SHORTEST_GT?: number | null;
  preferredLanguage_SHORTEST_GTE?: number | null;
  preferredLanguage_SHORTEST_LT?: number | null;
  preferredLanguage_SHORTEST_LTE?: number | null;
  tenantId_AVERAGE_EQUAL?: number | null;
  tenantId_AVERAGE_GT?: number | null;
  tenantId_AVERAGE_GTE?: number | null;
  tenantId_AVERAGE_LT?: number | null;
  tenantId_AVERAGE_LTE?: number | null;
  tenantId_EQUAL?: string | null;
  tenantId_GT?: number | null;
  tenantId_GTE?: number | null;
  tenantId_LONGEST_EQUAL?: number | null;
  tenantId_LONGEST_GT?: number | null;
  tenantId_LONGEST_GTE?: number | null;
  tenantId_LONGEST_LT?: number | null;
  tenantId_LONGEST_LTE?: number | null;
  tenantId_LT?: number | null;
  tenantId_LTE?: number | null;
  tenantId_SHORTEST_EQUAL?: number | null;
  tenantId_SHORTEST_GT?: number | null;
  tenantId_SHORTEST_GTE?: number | null;
  tenantId_SHORTEST_LT?: number | null;
  tenantId_SHORTEST_LTE?: number | null;
}

export interface SimulationInput {
  configuration: string;
  model: string;
  parentId?: string | null;
  product: string;
}

export interface SimulationOptions {
  limit?: number | null;
  offset?: number | null;
  sort?: (SimulationSort | null)[] | null;
}

/**
 * Fields to sort Simulations by. The order in which sorts are applied is not guaranteed when specifying many fields in one SimulationSort object.
 */
export interface SimulationSort {
  comment?: SortDirection | null;
  configuration?: SortDirection | null;
  createdByEmail?: SortDirection | null;
  createdByName?: SortDirection | null;
  createdOn?: SortDirection | null;
  id?: SortDirection | null;
  initialVersionId?: SortDirection | null;
  isSnapshot?: SortDirection | null;
  lastUpdatedOn?: SortDirection | null;
  model?: SortDirection | null;
  output?: SortDirection | null;
  product?: SortDirection | null;
  unlimited?: SortDirection | null;
  version?: SortDirection | null;
}

export interface SimulationWhere {
  AND?: SimulationWhere[] | null;
  OR?: SimulationWhere[] | null;
  addedBy?: UserWhere | null;
  addedByAggregate?: SimulationAddedByAggregateInput | null;
  addedByConnection?: SimulationAddedByConnectionWhere | null;
  addedByConnection_NOT?: SimulationAddedByConnectionWhere | null;
  addedBy_NOT?: UserWhere | null;
  comment?: string | null;
  comment_CONTAINS?: string | null;
  comment_ENDS_WITH?: string | null;
  comment_IN?: (string | null)[] | null;
  comment_MATCHES?: string | null;
  comment_NOT?: string | null;
  comment_NOT_CONTAINS?: string | null;
  comment_NOT_ENDS_WITH?: string | null;
  comment_NOT_IN?: (string | null)[] | null;
  comment_NOT_STARTS_WITH?: string | null;
  comment_STARTS_WITH?: string | null;
  configuration?: string | null;
  configuration_CONTAINS?: string | null;
  configuration_ENDS_WITH?: string | null;
  configuration_IN?: (string | null)[] | null;
  configuration_MATCHES?: string | null;
  configuration_NOT?: string | null;
  configuration_NOT_CONTAINS?: string | null;
  configuration_NOT_ENDS_WITH?: string | null;
  configuration_NOT_IN?: (string | null)[] | null;
  configuration_NOT_STARTS_WITH?: string | null;
  configuration_STARTS_WITH?: string | null;
  createdByEmail?: string | null;
  createdByEmail_CONTAINS?: string | null;
  createdByEmail_ENDS_WITH?: string | null;
  createdByEmail_IN?: (string | null)[] | null;
  createdByEmail_MATCHES?: string | null;
  createdByEmail_NOT?: string | null;
  createdByEmail_NOT_CONTAINS?: string | null;
  createdByEmail_NOT_ENDS_WITH?: string | null;
  createdByEmail_NOT_IN?: (string | null)[] | null;
  createdByEmail_NOT_STARTS_WITH?: string | null;
  createdByEmail_STARTS_WITH?: string | null;
  createdByName?: string | null;
  createdByName_CONTAINS?: string | null;
  createdByName_ENDS_WITH?: string | null;
  createdByName_IN?: (string | null)[] | null;
  createdByName_MATCHES?: string | null;
  createdByName_NOT?: string | null;
  createdByName_NOT_CONTAINS?: string | null;
  createdByName_NOT_ENDS_WITH?: string | null;
  createdByName_NOT_IN?: (string | null)[] | null;
  createdByName_NOT_STARTS_WITH?: string | null;
  createdByName_STARTS_WITH?: string | null;
  createdOn?: any | null;
  createdOn_GT?: any | null;
  createdOn_GTE?: any | null;
  createdOn_IN?: (any | null)[] | null;
  createdOn_LT?: any | null;
  createdOn_LTE?: any | null;
  createdOn_NOT?: any | null;
  createdOn_NOT_IN?: (any | null)[] | null;
  id?: string | null;
  id_CONTAINS?: string | null;
  id_ENDS_WITH?: string | null;
  id_IN?: (string | null)[] | null;
  id_MATCHES?: string | null;
  id_NOT?: string | null;
  id_NOT_CONTAINS?: string | null;
  id_NOT_ENDS_WITH?: string | null;
  id_NOT_IN?: (string | null)[] | null;
  id_NOT_STARTS_WITH?: string | null;
  id_STARTS_WITH?: string | null;
  initialVersionId?: string | null;
  initialVersionId_CONTAINS?: string | null;
  initialVersionId_ENDS_WITH?: string | null;
  initialVersionId_IN?: (string | null)[] | null;
  initialVersionId_MATCHES?: string | null;
  initialVersionId_NOT?: string | null;
  initialVersionId_NOT_CONTAINS?: string | null;
  initialVersionId_NOT_ENDS_WITH?: string | null;
  initialVersionId_NOT_IN?: (string | null)[] | null;
  initialVersionId_NOT_STARTS_WITH?: string | null;
  initialVersionId_STARTS_WITH?: string | null;
  isSnapshot?: boolean | null;
  isSnapshot_NOT?: boolean | null;
  lastUpdatedOn?: any | null;
  lastUpdatedOn_GT?: any | null;
  lastUpdatedOn_GTE?: any | null;
  lastUpdatedOn_IN?: (any | null)[] | null;
  lastUpdatedOn_LT?: any | null;
  lastUpdatedOn_LTE?: any | null;
  lastUpdatedOn_NOT?: any | null;
  lastUpdatedOn_NOT_IN?: (any | null)[] | null;
  model?: string | null;
  model_CONTAINS?: string | null;
  model_ENDS_WITH?: string | null;
  model_IN?: (string | null)[] | null;
  model_MATCHES?: string | null;
  model_NOT?: string | null;
  model_NOT_CONTAINS?: string | null;
  model_NOT_ENDS_WITH?: string | null;
  model_NOT_IN?: (string | null)[] | null;
  model_NOT_STARTS_WITH?: string | null;
  model_STARTS_WITH?: string | null;
  output?: string | null;
  output_CONTAINS?: string | null;
  output_ENDS_WITH?: string | null;
  output_IN?: (string | null)[] | null;
  output_MATCHES?: string | null;
  output_NOT?: string | null;
  output_NOT_CONTAINS?: string | null;
  output_NOT_ENDS_WITH?: string | null;
  output_NOT_IN?: (string | null)[] | null;
  output_NOT_STARTS_WITH?: string | null;
  output_STARTS_WITH?: string | null;
  product?: string | null;
  product_CONTAINS?: string | null;
  product_ENDS_WITH?: string | null;
  product_IN?: (string | null)[] | null;
  product_MATCHES?: string | null;
  product_NOT?: string | null;
  product_NOT_CONTAINS?: string | null;
  product_NOT_ENDS_WITH?: string | null;
  product_NOT_IN?: (string | null)[] | null;
  product_NOT_STARTS_WITH?: string | null;
  product_STARTS_WITH?: string | null;
  unlimited?: number | null;
  unlimited_GT?: number | null;
  unlimited_GTE?: number | null;
  unlimited_IN?: (number | null)[] | null;
  unlimited_LT?: number | null;
  unlimited_LTE?: number | null;
  unlimited_NOT?: number | null;
  unlimited_NOT_IN?: (number | null)[] | null;
  version?: number | null;
  version_GT?: number | null;
  version_GTE?: number | null;
  version_IN?: (number | null)[] | null;
  version_LT?: number | null;
  version_LTE?: number | null;
  version_NOT?: number | null;
  version_NOT_IN?: (number | null)[] | null;
}

export interface SnapshotInput {
  comment: string;
  configuration: string;
  model: string;
  parentId?: string | null;
  product: string;
}

export interface TaskAgreementAggregateInput {
  AND?: TaskAgreementAggregateInput[] | null;
  OR?: TaskAgreementAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: TaskAgreementNodeAggregationWhereInput | null;
}

export interface TaskAgreementConnectionWhere {
  AND?: TaskAgreementConnectionWhere[] | null;
  OR?: TaskAgreementConnectionWhere[] | null;
  node?: AgreementWhere | null;
  node_NOT?: AgreementWhere | null;
}

export interface TaskAgreementNodeAggregationWhereInput {
  AND?: TaskAgreementNodeAggregationWhereInput[] | null;
  OR?: TaskAgreementNodeAggregationWhereInput[] | null;
  description_AVERAGE_EQUAL?: number | null;
  description_AVERAGE_GT?: number | null;
  description_AVERAGE_GTE?: number | null;
  description_AVERAGE_LT?: number | null;
  description_AVERAGE_LTE?: number | null;
  description_EQUAL?: string | null;
  description_GT?: number | null;
  description_GTE?: number | null;
  description_LONGEST_EQUAL?: number | null;
  description_LONGEST_GT?: number | null;
  description_LONGEST_GTE?: number | null;
  description_LONGEST_LT?: number | null;
  description_LONGEST_LTE?: number | null;
  description_LT?: number | null;
  description_LTE?: number | null;
  description_SHORTEST_EQUAL?: number | null;
  description_SHORTEST_GT?: number | null;
  description_SHORTEST_GTE?: number | null;
  description_SHORTEST_LT?: number | null;
  description_SHORTEST_LTE?: number | null;
  formattedAmount_AVERAGE_EQUAL?: number | null;
  formattedAmount_AVERAGE_GT?: number | null;
  formattedAmount_AVERAGE_GTE?: number | null;
  formattedAmount_AVERAGE_LT?: number | null;
  formattedAmount_AVERAGE_LTE?: number | null;
  formattedAmount_EQUAL?: string | null;
  formattedAmount_GT?: number | null;
  formattedAmount_GTE?: number | null;
  formattedAmount_LONGEST_EQUAL?: number | null;
  formattedAmount_LONGEST_GT?: number | null;
  formattedAmount_LONGEST_GTE?: number | null;
  formattedAmount_LONGEST_LT?: number | null;
  formattedAmount_LONGEST_LTE?: number | null;
  formattedAmount_LT?: number | null;
  formattedAmount_LTE?: number | null;
  formattedAmount_SHORTEST_EQUAL?: number | null;
  formattedAmount_SHORTEST_GT?: number | null;
  formattedAmount_SHORTEST_GTE?: number | null;
  formattedAmount_SHORTEST_LT?: number | null;
  formattedAmount_SHORTEST_LTE?: number | null;
  formattedCounterparties_AVERAGE_EQUAL?: number | null;
  formattedCounterparties_AVERAGE_GT?: number | null;
  formattedCounterparties_AVERAGE_GTE?: number | null;
  formattedCounterparties_AVERAGE_LT?: number | null;
  formattedCounterparties_AVERAGE_LTE?: number | null;
  formattedCounterparties_EQUAL?: string | null;
  formattedCounterparties_GT?: number | null;
  formattedCounterparties_GTE?: number | null;
  formattedCounterparties_LONGEST_EQUAL?: number | null;
  formattedCounterparties_LONGEST_GT?: number | null;
  formattedCounterparties_LONGEST_GTE?: number | null;
  formattedCounterparties_LONGEST_LT?: number | null;
  formattedCounterparties_LONGEST_LTE?: number | null;
  formattedCounterparties_LT?: number | null;
  formattedCounterparties_LTE?: number | null;
  formattedCounterparties_SHORTEST_EQUAL?: number | null;
  formattedCounterparties_SHORTEST_GT?: number | null;
  formattedCounterparties_SHORTEST_GTE?: number | null;
  formattedCounterparties_SHORTEST_LT?: number | null;
  formattedCounterparties_SHORTEST_LTE?: number | null;
  formattedDiseases_AVERAGE_EQUAL?: number | null;
  formattedDiseases_AVERAGE_GT?: number | null;
  formattedDiseases_AVERAGE_GTE?: number | null;
  formattedDiseases_AVERAGE_LT?: number | null;
  formattedDiseases_AVERAGE_LTE?: number | null;
  formattedDiseases_EQUAL?: string | null;
  formattedDiseases_GT?: number | null;
  formattedDiseases_GTE?: number | null;
  formattedDiseases_LONGEST_EQUAL?: number | null;
  formattedDiseases_LONGEST_GT?: number | null;
  formattedDiseases_LONGEST_GTE?: number | null;
  formattedDiseases_LONGEST_LT?: number | null;
  formattedDiseases_LONGEST_LTE?: number | null;
  formattedDiseases_LT?: number | null;
  formattedDiseases_LTE?: number | null;
  formattedDiseases_SHORTEST_EQUAL?: number | null;
  formattedDiseases_SHORTEST_GT?: number | null;
  formattedDiseases_SHORTEST_GTE?: number | null;
  formattedDiseases_SHORTEST_LT?: number | null;
  formattedDiseases_SHORTEST_LTE?: number | null;
  formattedIndications_AVERAGE_EQUAL?: number | null;
  formattedIndications_AVERAGE_GT?: number | null;
  formattedIndications_AVERAGE_GTE?: number | null;
  formattedIndications_AVERAGE_LT?: number | null;
  formattedIndications_AVERAGE_LTE?: number | null;
  formattedIndications_EQUAL?: string | null;
  formattedIndications_GT?: number | null;
  formattedIndications_GTE?: number | null;
  formattedIndications_LONGEST_EQUAL?: number | null;
  formattedIndications_LONGEST_GT?: number | null;
  formattedIndications_LONGEST_GTE?: number | null;
  formattedIndications_LONGEST_LT?: number | null;
  formattedIndications_LONGEST_LTE?: number | null;
  formattedIndications_LT?: number | null;
  formattedIndications_LTE?: number | null;
  formattedIndications_SHORTEST_EQUAL?: number | null;
  formattedIndications_SHORTEST_GT?: number | null;
  formattedIndications_SHORTEST_GTE?: number | null;
  formattedIndications_SHORTEST_LT?: number | null;
  formattedIndications_SHORTEST_LTE?: number | null;
  formattedProducts_AVERAGE_EQUAL?: number | null;
  formattedProducts_AVERAGE_GT?: number | null;
  formattedProducts_AVERAGE_GTE?: number | null;
  formattedProducts_AVERAGE_LT?: number | null;
  formattedProducts_AVERAGE_LTE?: number | null;
  formattedProducts_EQUAL?: string | null;
  formattedProducts_GT?: number | null;
  formattedProducts_GTE?: number | null;
  formattedProducts_LONGEST_EQUAL?: number | null;
  formattedProducts_LONGEST_GT?: number | null;
  formattedProducts_LONGEST_GTE?: number | null;
  formattedProducts_LONGEST_LT?: number | null;
  formattedProducts_LONGEST_LTE?: number | null;
  formattedProducts_LT?: number | null;
  formattedProducts_LTE?: number | null;
  formattedProducts_SHORTEST_EQUAL?: number | null;
  formattedProducts_SHORTEST_GT?: number | null;
  formattedProducts_SHORTEST_GTE?: number | null;
  formattedProducts_SHORTEST_LT?: number | null;
  formattedProducts_SHORTEST_LTE?: number | null;
  formattedTags_AVERAGE_EQUAL?: number | null;
  formattedTags_AVERAGE_GT?: number | null;
  formattedTags_AVERAGE_GTE?: number | null;
  formattedTags_AVERAGE_LT?: number | null;
  formattedTags_AVERAGE_LTE?: number | null;
  formattedTags_EQUAL?: string | null;
  formattedTags_GT?: number | null;
  formattedTags_GTE?: number | null;
  formattedTags_LONGEST_EQUAL?: number | null;
  formattedTags_LONGEST_GT?: number | null;
  formattedTags_LONGEST_GTE?: number | null;
  formattedTags_LONGEST_LT?: number | null;
  formattedTags_LONGEST_LTE?: number | null;
  formattedTags_LT?: number | null;
  formattedTags_LTE?: number | null;
  formattedTags_SHORTEST_EQUAL?: number | null;
  formattedTags_SHORTEST_GT?: number | null;
  formattedTags_SHORTEST_GTE?: number | null;
  formattedTags_SHORTEST_LT?: number | null;
  formattedTags_SHORTEST_LTE?: number | null;
  formattedValidityPeriod_AVERAGE_EQUAL?: number | null;
  formattedValidityPeriod_AVERAGE_GT?: number | null;
  formattedValidityPeriod_AVERAGE_GTE?: number | null;
  formattedValidityPeriod_AVERAGE_LT?: number | null;
  formattedValidityPeriod_AVERAGE_LTE?: number | null;
  formattedValidityPeriod_EQUAL?: string | null;
  formattedValidityPeriod_GT?: number | null;
  formattedValidityPeriod_GTE?: number | null;
  formattedValidityPeriod_LONGEST_EQUAL?: number | null;
  formattedValidityPeriod_LONGEST_GT?: number | null;
  formattedValidityPeriod_LONGEST_GTE?: number | null;
  formattedValidityPeriod_LONGEST_LT?: number | null;
  formattedValidityPeriod_LONGEST_LTE?: number | null;
  formattedValidityPeriod_LT?: number | null;
  formattedValidityPeriod_LTE?: number | null;
  formattedValidityPeriod_SHORTEST_EQUAL?: number | null;
  formattedValidityPeriod_SHORTEST_GT?: number | null;
  formattedValidityPeriod_SHORTEST_GTE?: number | null;
  formattedValidityPeriod_SHORTEST_LT?: number | null;
  formattedValidityPeriod_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  initialVersionId_AVERAGE_EQUAL?: number | null;
  initialVersionId_AVERAGE_GT?: number | null;
  initialVersionId_AVERAGE_GTE?: number | null;
  initialVersionId_AVERAGE_LT?: number | null;
  initialVersionId_AVERAGE_LTE?: number | null;
  initialVersionId_EQUAL?: string | null;
  initialVersionId_GT?: number | null;
  initialVersionId_GTE?: number | null;
  initialVersionId_LONGEST_EQUAL?: number | null;
  initialVersionId_LONGEST_GT?: number | null;
  initialVersionId_LONGEST_GTE?: number | null;
  initialVersionId_LONGEST_LT?: number | null;
  initialVersionId_LONGEST_LTE?: number | null;
  initialVersionId_LT?: number | null;
  initialVersionId_LTE?: number | null;
  initialVersionId_SHORTEST_EQUAL?: number | null;
  initialVersionId_SHORTEST_GT?: number | null;
  initialVersionId_SHORTEST_GTE?: number | null;
  initialVersionId_SHORTEST_LT?: number | null;
  initialVersionId_SHORTEST_LTE?: number | null;
  name_AVERAGE_EQUAL?: number | null;
  name_AVERAGE_GT?: number | null;
  name_AVERAGE_GTE?: number | null;
  name_AVERAGE_LT?: number | null;
  name_AVERAGE_LTE?: number | null;
  name_EQUAL?: string | null;
  name_GT?: number | null;
  name_GTE?: number | null;
  name_LONGEST_EQUAL?: number | null;
  name_LONGEST_GT?: number | null;
  name_LONGEST_GTE?: number | null;
  name_LONGEST_LT?: number | null;
  name_LONGEST_LTE?: number | null;
  name_LT?: number | null;
  name_LTE?: number | null;
  name_SHORTEST_EQUAL?: number | null;
  name_SHORTEST_GT?: number | null;
  name_SHORTEST_GTE?: number | null;
  name_SHORTEST_LT?: number | null;
  name_SHORTEST_LTE?: number | null;
  searchTerm_AVERAGE_EQUAL?: number | null;
  searchTerm_AVERAGE_GT?: number | null;
  searchTerm_AVERAGE_GTE?: number | null;
  searchTerm_AVERAGE_LT?: number | null;
  searchTerm_AVERAGE_LTE?: number | null;
  searchTerm_EQUAL?: string | null;
  searchTerm_GT?: number | null;
  searchTerm_GTE?: number | null;
  searchTerm_LONGEST_EQUAL?: number | null;
  searchTerm_LONGEST_GT?: number | null;
  searchTerm_LONGEST_GTE?: number | null;
  searchTerm_LONGEST_LT?: number | null;
  searchTerm_LONGEST_LTE?: number | null;
  searchTerm_LT?: number | null;
  searchTerm_LTE?: number | null;
  searchTerm_SHORTEST_EQUAL?: number | null;
  searchTerm_SHORTEST_GT?: number | null;
  searchTerm_SHORTEST_GTE?: number | null;
  searchTerm_SHORTEST_LT?: number | null;
  searchTerm_SHORTEST_LTE?: number | null;
  totalAmount_AVERAGE_EQUAL?: number | null;
  totalAmount_AVERAGE_GT?: number | null;
  totalAmount_AVERAGE_GTE?: number | null;
  totalAmount_AVERAGE_LT?: number | null;
  totalAmount_AVERAGE_LTE?: number | null;
  totalAmount_EQUAL?: number | null;
  totalAmount_GT?: number | null;
  totalAmount_GTE?: number | null;
  totalAmount_LT?: number | null;
  totalAmount_LTE?: number | null;
  totalAmount_MAX_EQUAL?: number | null;
  totalAmount_MAX_GT?: number | null;
  totalAmount_MAX_GTE?: number | null;
  totalAmount_MAX_LT?: number | null;
  totalAmount_MAX_LTE?: number | null;
  totalAmount_MIN_EQUAL?: number | null;
  totalAmount_MIN_GT?: number | null;
  totalAmount_MIN_GTE?: number | null;
  totalAmount_MIN_LT?: number | null;
  totalAmount_MIN_LTE?: number | null;
  totalAmount_SUM_EQUAL?: number | null;
  totalAmount_SUM_GT?: number | null;
  totalAmount_SUM_GTE?: number | null;
  totalAmount_SUM_LT?: number | null;
  totalAmount_SUM_LTE?: number | null;
  unlimited_AVERAGE_EQUAL?: number | null;
  unlimited_AVERAGE_GT?: number | null;
  unlimited_AVERAGE_GTE?: number | null;
  unlimited_AVERAGE_LT?: number | null;
  unlimited_AVERAGE_LTE?: number | null;
  unlimited_EQUAL?: number | null;
  unlimited_GT?: number | null;
  unlimited_GTE?: number | null;
  unlimited_LT?: number | null;
  unlimited_LTE?: number | null;
  unlimited_MAX_EQUAL?: number | null;
  unlimited_MAX_GT?: number | null;
  unlimited_MAX_GTE?: number | null;
  unlimited_MAX_LT?: number | null;
  unlimited_MAX_LTE?: number | null;
  unlimited_MIN_EQUAL?: number | null;
  unlimited_MIN_GT?: number | null;
  unlimited_MIN_GTE?: number | null;
  unlimited_MIN_LT?: number | null;
  unlimited_MIN_LTE?: number | null;
  unlimited_SUM_EQUAL?: number | null;
  unlimited_SUM_GT?: number | null;
  unlimited_SUM_GTE?: number | null;
  unlimited_SUM_LT?: number | null;
  unlimited_SUM_LTE?: number | null;
  version_AVERAGE_EQUAL?: number | null;
  version_AVERAGE_GT?: number | null;
  version_AVERAGE_GTE?: number | null;
  version_AVERAGE_LT?: number | null;
  version_AVERAGE_LTE?: number | null;
  version_EQUAL?: number | null;
  version_GT?: number | null;
  version_GTE?: number | null;
  version_LT?: number | null;
  version_LTE?: number | null;
  version_MAX_EQUAL?: number | null;
  version_MAX_GT?: number | null;
  version_MAX_GTE?: number | null;
  version_MAX_LT?: number | null;
  version_MAX_LTE?: number | null;
  version_MIN_EQUAL?: number | null;
  version_MIN_GT?: number | null;
  version_MIN_GTE?: number | null;
  version_MIN_LT?: number | null;
  version_MIN_LTE?: number | null;
  version_SUM_EQUAL?: number | null;
  version_SUM_GT?: number | null;
  version_SUM_GTE?: number | null;
  version_SUM_LT?: number | null;
  version_SUM_LTE?: number | null;
}

export interface TaskCaseAggregateInput {
  AND?: TaskCaseAggregateInput[] | null;
  OR?: TaskCaseAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  edge?: TaskCaseEdgeAggregationWhereInput | null;
  node?: TaskCaseNodeAggregationWhereInput | null;
}

export interface TaskCaseConnectionWhere {
  AND?: TaskCaseConnectionWhere[] | null;
  OR?: TaskCaseConnectionWhere[] | null;
  edge?: CaseTaskRelationshipWhere | null;
  edge_NOT?: CaseTaskRelationshipWhere | null;
  node?: CaseWhere | null;
  node_NOT?: CaseWhere | null;
}

export interface TaskCaseEdgeAggregationWhereInput {
  AND?: TaskCaseEdgeAggregationWhereInput[] | null;
  OR?: TaskCaseEdgeAggregationWhereInput[] | null;
  formDueOrOverdue_AVERAGE_EQUAL?: number | null;
  formDueOrOverdue_AVERAGE_GT?: number | null;
  formDueOrOverdue_AVERAGE_GTE?: number | null;
  formDueOrOverdue_AVERAGE_LT?: number | null;
  formDueOrOverdue_AVERAGE_LTE?: number | null;
  formDueOrOverdue_EQUAL?: string | null;
  formDueOrOverdue_GT?: number | null;
  formDueOrOverdue_GTE?: number | null;
  formDueOrOverdue_LONGEST_EQUAL?: number | null;
  formDueOrOverdue_LONGEST_GT?: number | null;
  formDueOrOverdue_LONGEST_GTE?: number | null;
  formDueOrOverdue_LONGEST_LT?: number | null;
  formDueOrOverdue_LONGEST_LTE?: number | null;
  formDueOrOverdue_LT?: number | null;
  formDueOrOverdue_LTE?: number | null;
  formDueOrOverdue_SHORTEST_EQUAL?: number | null;
  formDueOrOverdue_SHORTEST_GT?: number | null;
  formDueOrOverdue_SHORTEST_GTE?: number | null;
  formDueOrOverdue_SHORTEST_LT?: number | null;
  formDueOrOverdue_SHORTEST_LTE?: number | null;
}

export interface TaskCaseNodeAggregationWhereInput {
  AND?: TaskCaseNodeAggregationWhereInput[] | null;
  OR?: TaskCaseNodeAggregationWhereInput[] | null;
  actualAgreementId_AVERAGE_EQUAL?: number | null;
  actualAgreementId_AVERAGE_GT?: number | null;
  actualAgreementId_AVERAGE_GTE?: number | null;
  actualAgreementId_AVERAGE_LT?: number | null;
  actualAgreementId_AVERAGE_LTE?: number | null;
  actualAgreementId_EQUAL?: string | null;
  actualAgreementId_GT?: number | null;
  actualAgreementId_GTE?: number | null;
  actualAgreementId_LONGEST_EQUAL?: number | null;
  actualAgreementId_LONGEST_GT?: number | null;
  actualAgreementId_LONGEST_GTE?: number | null;
  actualAgreementId_LONGEST_LT?: number | null;
  actualAgreementId_LONGEST_LTE?: number | null;
  actualAgreementId_LT?: number | null;
  actualAgreementId_LTE?: number | null;
  actualAgreementId_SHORTEST_EQUAL?: number | null;
  actualAgreementId_SHORTEST_GT?: number | null;
  actualAgreementId_SHORTEST_GTE?: number | null;
  actualAgreementId_SHORTEST_LT?: number | null;
  actualAgreementId_SHORTEST_LTE?: number | null;
  agreementName_AVERAGE_EQUAL?: number | null;
  agreementName_AVERAGE_GT?: number | null;
  agreementName_AVERAGE_GTE?: number | null;
  agreementName_AVERAGE_LT?: number | null;
  agreementName_AVERAGE_LTE?: number | null;
  agreementName_EQUAL?: string | null;
  agreementName_GT?: number | null;
  agreementName_GTE?: number | null;
  agreementName_LONGEST_EQUAL?: number | null;
  agreementName_LONGEST_GT?: number | null;
  agreementName_LONGEST_GTE?: number | null;
  agreementName_LONGEST_LT?: number | null;
  agreementName_LONGEST_LTE?: number | null;
  agreementName_LT?: number | null;
  agreementName_LTE?: number | null;
  agreementName_SHORTEST_EQUAL?: number | null;
  agreementName_SHORTEST_GT?: number | null;
  agreementName_SHORTEST_GTE?: number | null;
  agreementName_SHORTEST_LT?: number | null;
  agreementName_SHORTEST_LTE?: number | null;
  counterpartyInReview_AVERAGE_EQUAL?: number | null;
  counterpartyInReview_AVERAGE_GT?: number | null;
  counterpartyInReview_AVERAGE_GTE?: number | null;
  counterpartyInReview_AVERAGE_LT?: number | null;
  counterpartyInReview_AVERAGE_LTE?: number | null;
  counterpartyInReview_EQUAL?: string | null;
  counterpartyInReview_GT?: number | null;
  counterpartyInReview_GTE?: number | null;
  counterpartyInReview_LONGEST_EQUAL?: number | null;
  counterpartyInReview_LONGEST_GT?: number | null;
  counterpartyInReview_LONGEST_GTE?: number | null;
  counterpartyInReview_LONGEST_LT?: number | null;
  counterpartyInReview_LONGEST_LTE?: number | null;
  counterpartyInReview_LT?: number | null;
  counterpartyInReview_LTE?: number | null;
  counterpartyInReview_SHORTEST_EQUAL?: number | null;
  counterpartyInReview_SHORTEST_GT?: number | null;
  counterpartyInReview_SHORTEST_GTE?: number | null;
  counterpartyInReview_SHORTEST_LT?: number | null;
  counterpartyInReview_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  lastStatusChangeDate_EQUAL?: any | null;
  lastStatusChangeDate_GT?: any | null;
  lastStatusChangeDate_GTE?: any | null;
  lastStatusChangeDate_LT?: any | null;
  lastStatusChangeDate_LTE?: any | null;
  lastStatusChangeDate_MAX_EQUAL?: any | null;
  lastStatusChangeDate_MAX_GT?: any | null;
  lastStatusChangeDate_MAX_GTE?: any | null;
  lastStatusChangeDate_MAX_LT?: any | null;
  lastStatusChangeDate_MAX_LTE?: any | null;
  lastStatusChangeDate_MIN_EQUAL?: any | null;
  lastStatusChangeDate_MIN_GT?: any | null;
  lastStatusChangeDate_MIN_GTE?: any | null;
  lastStatusChangeDate_MIN_LT?: any | null;
  lastStatusChangeDate_MIN_LTE?: any | null;
  patientInitials_AVERAGE_EQUAL?: number | null;
  patientInitials_AVERAGE_GT?: number | null;
  patientInitials_AVERAGE_GTE?: number | null;
  patientInitials_AVERAGE_LT?: number | null;
  patientInitials_AVERAGE_LTE?: number | null;
  patientInitials_EQUAL?: string | null;
  patientInitials_GT?: number | null;
  patientInitials_GTE?: number | null;
  patientInitials_LONGEST_EQUAL?: number | null;
  patientInitials_LONGEST_GT?: number | null;
  patientInitials_LONGEST_GTE?: number | null;
  patientInitials_LONGEST_LT?: number | null;
  patientInitials_LONGEST_LTE?: number | null;
  patientInitials_LT?: number | null;
  patientInitials_LTE?: number | null;
  patientInitials_SHORTEST_EQUAL?: number | null;
  patientInitials_SHORTEST_GT?: number | null;
  patientInitials_SHORTEST_GTE?: number | null;
  patientInitials_SHORTEST_LT?: number | null;
  patientInitials_SHORTEST_LTE?: number | null;
  patientInsuranceId_AVERAGE_EQUAL?: number | null;
  patientInsuranceId_AVERAGE_GT?: number | null;
  patientInsuranceId_AVERAGE_GTE?: number | null;
  patientInsuranceId_AVERAGE_LT?: number | null;
  patientInsuranceId_AVERAGE_LTE?: number | null;
  patientInsuranceId_EQUAL?: string | null;
  patientInsuranceId_GT?: number | null;
  patientInsuranceId_GTE?: number | null;
  patientInsuranceId_LONGEST_EQUAL?: number | null;
  patientInsuranceId_LONGEST_GT?: number | null;
  patientInsuranceId_LONGEST_GTE?: number | null;
  patientInsuranceId_LONGEST_LT?: number | null;
  patientInsuranceId_LONGEST_LTE?: number | null;
  patientInsuranceId_LT?: number | null;
  patientInsuranceId_LTE?: number | null;
  patientInsuranceId_SHORTEST_EQUAL?: number | null;
  patientInsuranceId_SHORTEST_GT?: number | null;
  patientInsuranceId_SHORTEST_GTE?: number | null;
  patientInsuranceId_SHORTEST_LT?: number | null;
  patientInsuranceId_SHORTEST_LTE?: number | null;
  preparationBrandName_AVERAGE_EQUAL?: number | null;
  preparationBrandName_AVERAGE_GT?: number | null;
  preparationBrandName_AVERAGE_GTE?: number | null;
  preparationBrandName_AVERAGE_LT?: number | null;
  preparationBrandName_AVERAGE_LTE?: number | null;
  preparationBrandName_EQUAL?: string | null;
  preparationBrandName_GT?: number | null;
  preparationBrandName_GTE?: number | null;
  preparationBrandName_LONGEST_EQUAL?: number | null;
  preparationBrandName_LONGEST_GT?: number | null;
  preparationBrandName_LONGEST_GTE?: number | null;
  preparationBrandName_LONGEST_LT?: number | null;
  preparationBrandName_LONGEST_LTE?: number | null;
  preparationBrandName_LT?: number | null;
  preparationBrandName_LTE?: number | null;
  preparationBrandName_SHORTEST_EQUAL?: number | null;
  preparationBrandName_SHORTEST_GT?: number | null;
  preparationBrandName_SHORTEST_GTE?: number | null;
  preparationBrandName_SHORTEST_LT?: number | null;
  preparationBrandName_SHORTEST_LTE?: number | null;
  preparationGenericName_AVERAGE_EQUAL?: number | null;
  preparationGenericName_AVERAGE_GT?: number | null;
  preparationGenericName_AVERAGE_GTE?: number | null;
  preparationGenericName_AVERAGE_LT?: number | null;
  preparationGenericName_AVERAGE_LTE?: number | null;
  preparationGenericName_EQUAL?: string | null;
  preparationGenericName_GT?: number | null;
  preparationGenericName_GTE?: number | null;
  preparationGenericName_LONGEST_EQUAL?: number | null;
  preparationGenericName_LONGEST_GT?: number | null;
  preparationGenericName_LONGEST_GTE?: number | null;
  preparationGenericName_LONGEST_LT?: number | null;
  preparationGenericName_LONGEST_LTE?: number | null;
  preparationGenericName_LT?: number | null;
  preparationGenericName_LTE?: number | null;
  preparationGenericName_SHORTEST_EQUAL?: number | null;
  preparationGenericName_SHORTEST_GT?: number | null;
  preparationGenericName_SHORTEST_GTE?: number | null;
  preparationGenericName_SHORTEST_LT?: number | null;
  preparationGenericName_SHORTEST_LTE?: number | null;
  sourceTenantId_AVERAGE_EQUAL?: number | null;
  sourceTenantId_AVERAGE_GT?: number | null;
  sourceTenantId_AVERAGE_GTE?: number | null;
  sourceTenantId_AVERAGE_LT?: number | null;
  sourceTenantId_AVERAGE_LTE?: number | null;
  sourceTenantId_EQUAL?: string | null;
  sourceTenantId_GT?: number | null;
  sourceTenantId_GTE?: number | null;
  sourceTenantId_LONGEST_EQUAL?: number | null;
  sourceTenantId_LONGEST_GT?: number | null;
  sourceTenantId_LONGEST_GTE?: number | null;
  sourceTenantId_LONGEST_LT?: number | null;
  sourceTenantId_LONGEST_LTE?: number | null;
  sourceTenantId_LT?: number | null;
  sourceTenantId_LTE?: number | null;
  sourceTenantId_SHORTEST_EQUAL?: number | null;
  sourceTenantId_SHORTEST_GT?: number | null;
  sourceTenantId_SHORTEST_GTE?: number | null;
  sourceTenantId_SHORTEST_LT?: number | null;
  sourceTenantId_SHORTEST_LTE?: number | null;
  submissionDate_EQUAL?: any | null;
  submissionDate_GT?: any | null;
  submissionDate_GTE?: any | null;
  submissionDate_LT?: any | null;
  submissionDate_LTE?: any | null;
  submissionDate_MAX_EQUAL?: any | null;
  submissionDate_MAX_GT?: any | null;
  submissionDate_MAX_GTE?: any | null;
  submissionDate_MAX_LT?: any | null;
  submissionDate_MAX_LTE?: any | null;
  submissionDate_MIN_EQUAL?: any | null;
  submissionDate_MIN_GT?: any | null;
  submissionDate_MIN_GTE?: any | null;
  submissionDate_MIN_LT?: any | null;
  submissionDate_MIN_LTE?: any | null;
  suspensionReason_AVERAGE_EQUAL?: number | null;
  suspensionReason_AVERAGE_GT?: number | null;
  suspensionReason_AVERAGE_GTE?: number | null;
  suspensionReason_AVERAGE_LT?: number | null;
  suspensionReason_AVERAGE_LTE?: number | null;
  suspensionReason_EQUAL?: string | null;
  suspensionReason_GT?: number | null;
  suspensionReason_GTE?: number | null;
  suspensionReason_LONGEST_EQUAL?: number | null;
  suspensionReason_LONGEST_GT?: number | null;
  suspensionReason_LONGEST_GTE?: number | null;
  suspensionReason_LONGEST_LT?: number | null;
  suspensionReason_LONGEST_LTE?: number | null;
  suspensionReason_LT?: number | null;
  suspensionReason_LTE?: number | null;
  suspensionReason_SHORTEST_EQUAL?: number | null;
  suspensionReason_SHORTEST_GT?: number | null;
  suspensionReason_SHORTEST_GTE?: number | null;
  suspensionReason_SHORTEST_LT?: number | null;
  suspensionReason_SHORTEST_LTE?: number | null;
  totalAmount_AVERAGE_EQUAL?: number | null;
  totalAmount_AVERAGE_GT?: number | null;
  totalAmount_AVERAGE_GTE?: number | null;
  totalAmount_AVERAGE_LT?: number | null;
  totalAmount_AVERAGE_LTE?: number | null;
  totalAmount_EQUAL?: number | null;
  totalAmount_GT?: number | null;
  totalAmount_GTE?: number | null;
  totalAmount_LT?: number | null;
  totalAmount_LTE?: number | null;
  totalAmount_MAX_EQUAL?: number | null;
  totalAmount_MAX_GT?: number | null;
  totalAmount_MAX_GTE?: number | null;
  totalAmount_MAX_LT?: number | null;
  totalAmount_MAX_LTE?: number | null;
  totalAmount_MIN_EQUAL?: number | null;
  totalAmount_MIN_GT?: number | null;
  totalAmount_MIN_GTE?: number | null;
  totalAmount_MIN_LT?: number | null;
  totalAmount_MIN_LTE?: number | null;
  totalAmount_SUM_EQUAL?: number | null;
  totalAmount_SUM_GT?: number | null;
  totalAmount_SUM_GTE?: number | null;
  totalAmount_SUM_LT?: number | null;
  totalAmount_SUM_LTE?: number | null;
  unlimited_AVERAGE_EQUAL?: number | null;
  unlimited_AVERAGE_GT?: number | null;
  unlimited_AVERAGE_GTE?: number | null;
  unlimited_AVERAGE_LT?: number | null;
  unlimited_AVERAGE_LTE?: number | null;
  unlimited_EQUAL?: number | null;
  unlimited_GT?: number | null;
  unlimited_GTE?: number | null;
  unlimited_LT?: number | null;
  unlimited_LTE?: number | null;
  unlimited_MAX_EQUAL?: number | null;
  unlimited_MAX_GT?: number | null;
  unlimited_MAX_GTE?: number | null;
  unlimited_MAX_LT?: number | null;
  unlimited_MAX_LTE?: number | null;
  unlimited_MIN_EQUAL?: number | null;
  unlimited_MIN_GT?: number | null;
  unlimited_MIN_GTE?: number | null;
  unlimited_MIN_LT?: number | null;
  unlimited_MIN_LTE?: number | null;
  unlimited_SUM_EQUAL?: number | null;
  unlimited_SUM_GT?: number | null;
  unlimited_SUM_GTE?: number | null;
  unlimited_SUM_LT?: number | null;
  unlimited_SUM_LTE?: number | null;
}

export interface TaskCreatedByAggregateInput {
  AND?: TaskCreatedByAggregateInput[] | null;
  OR?: TaskCreatedByAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: TaskCreatedByNodeAggregationWhereInput | null;
}

export interface TaskCreatedByConnectionWhere {
  AND?: TaskCreatedByConnectionWhere[] | null;
  OR?: TaskCreatedByConnectionWhere[] | null;
  node?: UserWhere | null;
  node_NOT?: UserWhere | null;
}

export interface TaskCreatedByNodeAggregationWhereInput {
  AND?: TaskCreatedByNodeAggregationWhereInput[] | null;
  OR?: TaskCreatedByNodeAggregationWhereInput[] | null;
  deletedOn_EQUAL?: any | null;
  deletedOn_GT?: any | null;
  deletedOn_GTE?: any | null;
  deletedOn_LT?: any | null;
  deletedOn_LTE?: any | null;
  deletedOn_MAX_EQUAL?: any | null;
  deletedOn_MAX_GT?: any | null;
  deletedOn_MAX_GTE?: any | null;
  deletedOn_MAX_LT?: any | null;
  deletedOn_MAX_LTE?: any | null;
  deletedOn_MIN_EQUAL?: any | null;
  deletedOn_MIN_GT?: any | null;
  deletedOn_MIN_GTE?: any | null;
  deletedOn_MIN_LT?: any | null;
  deletedOn_MIN_LTE?: any | null;
  department_AVERAGE_EQUAL?: number | null;
  department_AVERAGE_GT?: number | null;
  department_AVERAGE_GTE?: number | null;
  department_AVERAGE_LT?: number | null;
  department_AVERAGE_LTE?: number | null;
  department_EQUAL?: string | null;
  department_GT?: number | null;
  department_GTE?: number | null;
  department_LONGEST_EQUAL?: number | null;
  department_LONGEST_GT?: number | null;
  department_LONGEST_GTE?: number | null;
  department_LONGEST_LT?: number | null;
  department_LONGEST_LTE?: number | null;
  department_LT?: number | null;
  department_LTE?: number | null;
  department_SHORTEST_EQUAL?: number | null;
  department_SHORTEST_GT?: number | null;
  department_SHORTEST_GTE?: number | null;
  department_SHORTEST_LT?: number | null;
  department_SHORTEST_LTE?: number | null;
  email_AVERAGE_EQUAL?: number | null;
  email_AVERAGE_GT?: number | null;
  email_AVERAGE_GTE?: number | null;
  email_AVERAGE_LT?: number | null;
  email_AVERAGE_LTE?: number | null;
  email_EQUAL?: string | null;
  email_GT?: number | null;
  email_GTE?: number | null;
  email_LONGEST_EQUAL?: number | null;
  email_LONGEST_GT?: number | null;
  email_LONGEST_GTE?: number | null;
  email_LONGEST_LT?: number | null;
  email_LONGEST_LTE?: number | null;
  email_LT?: number | null;
  email_LTE?: number | null;
  email_SHORTEST_EQUAL?: number | null;
  email_SHORTEST_GT?: number | null;
  email_SHORTEST_GTE?: number | null;
  email_SHORTEST_LT?: number | null;
  email_SHORTEST_LTE?: number | null;
  firstName_AVERAGE_EQUAL?: number | null;
  firstName_AVERAGE_GT?: number | null;
  firstName_AVERAGE_GTE?: number | null;
  firstName_AVERAGE_LT?: number | null;
  firstName_AVERAGE_LTE?: number | null;
  firstName_EQUAL?: string | null;
  firstName_GT?: number | null;
  firstName_GTE?: number | null;
  firstName_LONGEST_EQUAL?: number | null;
  firstName_LONGEST_GT?: number | null;
  firstName_LONGEST_GTE?: number | null;
  firstName_LONGEST_LT?: number | null;
  firstName_LONGEST_LTE?: number | null;
  firstName_LT?: number | null;
  firstName_LTE?: number | null;
  firstName_SHORTEST_EQUAL?: number | null;
  firstName_SHORTEST_GT?: number | null;
  firstName_SHORTEST_GTE?: number | null;
  firstName_SHORTEST_LT?: number | null;
  firstName_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  lastName_AVERAGE_EQUAL?: number | null;
  lastName_AVERAGE_GT?: number | null;
  lastName_AVERAGE_GTE?: number | null;
  lastName_AVERAGE_LT?: number | null;
  lastName_AVERAGE_LTE?: number | null;
  lastName_EQUAL?: string | null;
  lastName_GT?: number | null;
  lastName_GTE?: number | null;
  lastName_LONGEST_EQUAL?: number | null;
  lastName_LONGEST_GT?: number | null;
  lastName_LONGEST_GTE?: number | null;
  lastName_LONGEST_LT?: number | null;
  lastName_LONGEST_LTE?: number | null;
  lastName_LT?: number | null;
  lastName_LTE?: number | null;
  lastName_SHORTEST_EQUAL?: number | null;
  lastName_SHORTEST_GT?: number | null;
  lastName_SHORTEST_GTE?: number | null;
  lastName_SHORTEST_LT?: number | null;
  lastName_SHORTEST_LTE?: number | null;
  position_AVERAGE_EQUAL?: number | null;
  position_AVERAGE_GT?: number | null;
  position_AVERAGE_GTE?: number | null;
  position_AVERAGE_LT?: number | null;
  position_AVERAGE_LTE?: number | null;
  position_EQUAL?: string | null;
  position_GT?: number | null;
  position_GTE?: number | null;
  position_LONGEST_EQUAL?: number | null;
  position_LONGEST_GT?: number | null;
  position_LONGEST_GTE?: number | null;
  position_LONGEST_LT?: number | null;
  position_LONGEST_LTE?: number | null;
  position_LT?: number | null;
  position_LTE?: number | null;
  position_SHORTEST_EQUAL?: number | null;
  position_SHORTEST_GT?: number | null;
  position_SHORTEST_GTE?: number | null;
  position_SHORTEST_LT?: number | null;
  position_SHORTEST_LTE?: number | null;
  preferredLanguage_AVERAGE_EQUAL?: number | null;
  preferredLanguage_AVERAGE_GT?: number | null;
  preferredLanguage_AVERAGE_GTE?: number | null;
  preferredLanguage_AVERAGE_LT?: number | null;
  preferredLanguage_AVERAGE_LTE?: number | null;
  preferredLanguage_EQUAL?: string | null;
  preferredLanguage_GT?: number | null;
  preferredLanguage_GTE?: number | null;
  preferredLanguage_LONGEST_EQUAL?: number | null;
  preferredLanguage_LONGEST_GT?: number | null;
  preferredLanguage_LONGEST_GTE?: number | null;
  preferredLanguage_LONGEST_LT?: number | null;
  preferredLanguage_LONGEST_LTE?: number | null;
  preferredLanguage_LT?: number | null;
  preferredLanguage_LTE?: number | null;
  preferredLanguage_SHORTEST_EQUAL?: number | null;
  preferredLanguage_SHORTEST_GT?: number | null;
  preferredLanguage_SHORTEST_GTE?: number | null;
  preferredLanguage_SHORTEST_LT?: number | null;
  preferredLanguage_SHORTEST_LTE?: number | null;
  tenantId_AVERAGE_EQUAL?: number | null;
  tenantId_AVERAGE_GT?: number | null;
  tenantId_AVERAGE_GTE?: number | null;
  tenantId_AVERAGE_LT?: number | null;
  tenantId_AVERAGE_LTE?: number | null;
  tenantId_EQUAL?: string | null;
  tenantId_GT?: number | null;
  tenantId_GTE?: number | null;
  tenantId_LONGEST_EQUAL?: number | null;
  tenantId_LONGEST_GT?: number | null;
  tenantId_LONGEST_GTE?: number | null;
  tenantId_LONGEST_LT?: number | null;
  tenantId_LONGEST_LTE?: number | null;
  tenantId_LT?: number | null;
  tenantId_LTE?: number | null;
  tenantId_SHORTEST_EQUAL?: number | null;
  tenantId_SHORTEST_GT?: number | null;
  tenantId_SHORTEST_GTE?: number | null;
  tenantId_SHORTEST_LT?: number | null;
  tenantId_SHORTEST_LTE?: number | null;
}

export interface TaskDocumentAggregateInput {
  AND?: TaskDocumentAggregateInput[] | null;
  OR?: TaskDocumentAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: TaskDocumentNodeAggregationWhereInput | null;
}

export interface TaskDocumentConnectionWhere {
  AND?: TaskDocumentConnectionWhere[] | null;
  OR?: TaskDocumentConnectionWhere[] | null;
  node?: DocumentWhere | null;
  node_NOT?: DocumentWhere | null;
}

export interface TaskDocumentNodeAggregationWhereInput {
  AND?: TaskDocumentNodeAggregationWhereInput[] | null;
  OR?: TaskDocumentNodeAggregationWhereInput[] | null;
  counterParties_AVERAGE_EQUAL?: number | null;
  counterParties_AVERAGE_GT?: number | null;
  counterParties_AVERAGE_GTE?: number | null;
  counterParties_AVERAGE_LT?: number | null;
  counterParties_AVERAGE_LTE?: number | null;
  counterParties_EQUAL?: string | null;
  counterParties_GT?: number | null;
  counterParties_GTE?: number | null;
  counterParties_LONGEST_EQUAL?: number | null;
  counterParties_LONGEST_GT?: number | null;
  counterParties_LONGEST_GTE?: number | null;
  counterParties_LONGEST_LT?: number | null;
  counterParties_LONGEST_LTE?: number | null;
  counterParties_LT?: number | null;
  counterParties_LTE?: number | null;
  counterParties_SHORTEST_EQUAL?: number | null;
  counterParties_SHORTEST_GT?: number | null;
  counterParties_SHORTEST_GTE?: number | null;
  counterParties_SHORTEST_LT?: number | null;
  counterParties_SHORTEST_LTE?: number | null;
  coveragePeriod_AVERAGE_EQUAL?: number | null;
  coveragePeriod_AVERAGE_GT?: number | null;
  coveragePeriod_AVERAGE_GTE?: number | null;
  coveragePeriod_AVERAGE_LT?: number | null;
  coveragePeriod_AVERAGE_LTE?: number | null;
  coveragePeriod_EQUAL?: string | null;
  coveragePeriod_GT?: number | null;
  coveragePeriod_GTE?: number | null;
  coveragePeriod_LONGEST_EQUAL?: number | null;
  coveragePeriod_LONGEST_GT?: number | null;
  coveragePeriod_LONGEST_GTE?: number | null;
  coveragePeriod_LONGEST_LT?: number | null;
  coveragePeriod_LONGEST_LTE?: number | null;
  coveragePeriod_LT?: number | null;
  coveragePeriod_LTE?: number | null;
  coveragePeriod_SHORTEST_EQUAL?: number | null;
  coveragePeriod_SHORTEST_GT?: number | null;
  coveragePeriod_SHORTEST_GTE?: number | null;
  coveragePeriod_SHORTEST_LT?: number | null;
  coveragePeriod_SHORTEST_LTE?: number | null;
  createdByEmail_AVERAGE_EQUAL?: number | null;
  createdByEmail_AVERAGE_GT?: number | null;
  createdByEmail_AVERAGE_GTE?: number | null;
  createdByEmail_AVERAGE_LT?: number | null;
  createdByEmail_AVERAGE_LTE?: number | null;
  createdByEmail_EQUAL?: string | null;
  createdByEmail_GT?: number | null;
  createdByEmail_GTE?: number | null;
  createdByEmail_LONGEST_EQUAL?: number | null;
  createdByEmail_LONGEST_GT?: number | null;
  createdByEmail_LONGEST_GTE?: number | null;
  createdByEmail_LONGEST_LT?: number | null;
  createdByEmail_LONGEST_LTE?: number | null;
  createdByEmail_LT?: number | null;
  createdByEmail_LTE?: number | null;
  createdByEmail_SHORTEST_EQUAL?: number | null;
  createdByEmail_SHORTEST_GT?: number | null;
  createdByEmail_SHORTEST_GTE?: number | null;
  createdByEmail_SHORTEST_LT?: number | null;
  createdByEmail_SHORTEST_LTE?: number | null;
  createdOn_EQUAL?: any | null;
  createdOn_GT?: any | null;
  createdOn_GTE?: any | null;
  createdOn_LT?: any | null;
  createdOn_LTE?: any | null;
  createdOn_MAX_EQUAL?: any | null;
  createdOn_MAX_GT?: any | null;
  createdOn_MAX_GTE?: any | null;
  createdOn_MAX_LT?: any | null;
  createdOn_MAX_LTE?: any | null;
  createdOn_MIN_EQUAL?: any | null;
  createdOn_MIN_GT?: any | null;
  createdOn_MIN_GTE?: any | null;
  createdOn_MIN_LT?: any | null;
  createdOn_MIN_LTE?: any | null;
  creatorOrgName_AVERAGE_EQUAL?: number | null;
  creatorOrgName_AVERAGE_GT?: number | null;
  creatorOrgName_AVERAGE_GTE?: number | null;
  creatorOrgName_AVERAGE_LT?: number | null;
  creatorOrgName_AVERAGE_LTE?: number | null;
  creatorOrgName_EQUAL?: string | null;
  creatorOrgName_GT?: number | null;
  creatorOrgName_GTE?: number | null;
  creatorOrgName_LONGEST_EQUAL?: number | null;
  creatorOrgName_LONGEST_GT?: number | null;
  creatorOrgName_LONGEST_GTE?: number | null;
  creatorOrgName_LONGEST_LT?: number | null;
  creatorOrgName_LONGEST_LTE?: number | null;
  creatorOrgName_LT?: number | null;
  creatorOrgName_LTE?: number | null;
  creatorOrgName_SHORTEST_EQUAL?: number | null;
  creatorOrgName_SHORTEST_GT?: number | null;
  creatorOrgName_SHORTEST_GTE?: number | null;
  creatorOrgName_SHORTEST_LT?: number | null;
  creatorOrgName_SHORTEST_LTE?: number | null;
  creatorTenantId_AVERAGE_EQUAL?: number | null;
  creatorTenantId_AVERAGE_GT?: number | null;
  creatorTenantId_AVERAGE_GTE?: number | null;
  creatorTenantId_AVERAGE_LT?: number | null;
  creatorTenantId_AVERAGE_LTE?: number | null;
  creatorTenantId_EQUAL?: string | null;
  creatorTenantId_GT?: number | null;
  creatorTenantId_GTE?: number | null;
  creatorTenantId_LONGEST_EQUAL?: number | null;
  creatorTenantId_LONGEST_GT?: number | null;
  creatorTenantId_LONGEST_GTE?: number | null;
  creatorTenantId_LONGEST_LT?: number | null;
  creatorTenantId_LONGEST_LTE?: number | null;
  creatorTenantId_LT?: number | null;
  creatorTenantId_LTE?: number | null;
  creatorTenantId_SHORTEST_EQUAL?: number | null;
  creatorTenantId_SHORTEST_GT?: number | null;
  creatorTenantId_SHORTEST_GTE?: number | null;
  creatorTenantId_SHORTEST_LT?: number | null;
  creatorTenantId_SHORTEST_LTE?: number | null;
  formattedTags_AVERAGE_EQUAL?: number | null;
  formattedTags_AVERAGE_GT?: number | null;
  formattedTags_AVERAGE_GTE?: number | null;
  formattedTags_AVERAGE_LT?: number | null;
  formattedTags_AVERAGE_LTE?: number | null;
  formattedTags_EQUAL?: string | null;
  formattedTags_GT?: number | null;
  formattedTags_GTE?: number | null;
  formattedTags_LONGEST_EQUAL?: number | null;
  formattedTags_LONGEST_GT?: number | null;
  formattedTags_LONGEST_GTE?: number | null;
  formattedTags_LONGEST_LT?: number | null;
  formattedTags_LONGEST_LTE?: number | null;
  formattedTags_LT?: number | null;
  formattedTags_LTE?: number | null;
  formattedTags_SHORTEST_EQUAL?: number | null;
  formattedTags_SHORTEST_GT?: number | null;
  formattedTags_SHORTEST_GTE?: number | null;
  formattedTags_SHORTEST_LT?: number | null;
  formattedTags_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  invoiceAmount_AVERAGE_EQUAL?: number | null;
  invoiceAmount_AVERAGE_GT?: number | null;
  invoiceAmount_AVERAGE_GTE?: number | null;
  invoiceAmount_AVERAGE_LT?: number | null;
  invoiceAmount_AVERAGE_LTE?: number | null;
  invoiceAmount_EQUAL?: number | null;
  invoiceAmount_GT?: number | null;
  invoiceAmount_GTE?: number | null;
  invoiceAmount_LT?: number | null;
  invoiceAmount_LTE?: number | null;
  invoiceAmount_MAX_EQUAL?: number | null;
  invoiceAmount_MAX_GT?: number | null;
  invoiceAmount_MAX_GTE?: number | null;
  invoiceAmount_MAX_LT?: number | null;
  invoiceAmount_MAX_LTE?: number | null;
  invoiceAmount_MIN_EQUAL?: number | null;
  invoiceAmount_MIN_GT?: number | null;
  invoiceAmount_MIN_GTE?: number | null;
  invoiceAmount_MIN_LT?: number | null;
  invoiceAmount_MIN_LTE?: number | null;
  invoiceAmount_SUM_EQUAL?: number | null;
  invoiceAmount_SUM_GT?: number | null;
  invoiceAmount_SUM_GTE?: number | null;
  invoiceAmount_SUM_LT?: number | null;
  invoiceAmount_SUM_LTE?: number | null;
  issuedOn_EQUAL?: any | null;
  issuedOn_GT?: any | null;
  issuedOn_GTE?: any | null;
  issuedOn_LT?: any | null;
  issuedOn_LTE?: any | null;
  issuedOn_MAX_EQUAL?: any | null;
  issuedOn_MAX_GT?: any | null;
  issuedOn_MAX_GTE?: any | null;
  issuedOn_MAX_LT?: any | null;
  issuedOn_MAX_LTE?: any | null;
  issuedOn_MIN_EQUAL?: any | null;
  issuedOn_MIN_GT?: any | null;
  issuedOn_MIN_GTE?: any | null;
  issuedOn_MIN_LT?: any | null;
  issuedOn_MIN_LTE?: any | null;
  lastChangedOn_EQUAL?: any | null;
  lastChangedOn_GT?: any | null;
  lastChangedOn_GTE?: any | null;
  lastChangedOn_LT?: any | null;
  lastChangedOn_LTE?: any | null;
  lastChangedOn_MAX_EQUAL?: any | null;
  lastChangedOn_MAX_GT?: any | null;
  lastChangedOn_MAX_GTE?: any | null;
  lastChangedOn_MAX_LT?: any | null;
  lastChangedOn_MAX_LTE?: any | null;
  lastChangedOn_MIN_EQUAL?: any | null;
  lastChangedOn_MIN_GT?: any | null;
  lastChangedOn_MIN_GTE?: any | null;
  lastChangedOn_MIN_LT?: any | null;
  lastChangedOn_MIN_LTE?: any | null;
  lastRemindedOn_EQUAL?: any | null;
  lastRemindedOn_GT?: any | null;
  lastRemindedOn_GTE?: any | null;
  lastRemindedOn_LT?: any | null;
  lastRemindedOn_LTE?: any | null;
  lastRemindedOn_MAX_EQUAL?: any | null;
  lastRemindedOn_MAX_GT?: any | null;
  lastRemindedOn_MAX_GTE?: any | null;
  lastRemindedOn_MAX_LT?: any | null;
  lastRemindedOn_MAX_LTE?: any | null;
  lastRemindedOn_MIN_EQUAL?: any | null;
  lastRemindedOn_MIN_GT?: any | null;
  lastRemindedOn_MIN_GTE?: any | null;
  lastRemindedOn_MIN_LT?: any | null;
  lastRemindedOn_MIN_LTE?: any | null;
  lastUpdatedOn_EQUAL?: any | null;
  lastUpdatedOn_GT?: any | null;
  lastUpdatedOn_GTE?: any | null;
  lastUpdatedOn_LT?: any | null;
  lastUpdatedOn_LTE?: any | null;
  lastUpdatedOn_MAX_EQUAL?: any | null;
  lastUpdatedOn_MAX_GT?: any | null;
  lastUpdatedOn_MAX_GTE?: any | null;
  lastUpdatedOn_MAX_LT?: any | null;
  lastUpdatedOn_MAX_LTE?: any | null;
  lastUpdatedOn_MIN_EQUAL?: any | null;
  lastUpdatedOn_MIN_GT?: any | null;
  lastUpdatedOn_MIN_GTE?: any | null;
  lastUpdatedOn_MIN_LT?: any | null;
  lastUpdatedOn_MIN_LTE?: any | null;
  product_AVERAGE_EQUAL?: number | null;
  product_AVERAGE_GT?: number | null;
  product_AVERAGE_GTE?: number | null;
  product_AVERAGE_LT?: number | null;
  product_AVERAGE_LTE?: number | null;
  product_EQUAL?: string | null;
  product_GT?: number | null;
  product_GTE?: number | null;
  product_LONGEST_EQUAL?: number | null;
  product_LONGEST_GT?: number | null;
  product_LONGEST_GTE?: number | null;
  product_LONGEST_LT?: number | null;
  product_LONGEST_LTE?: number | null;
  product_LT?: number | null;
  product_LTE?: number | null;
  product_SHORTEST_EQUAL?: number | null;
  product_SHORTEST_GT?: number | null;
  product_SHORTEST_GTE?: number | null;
  product_SHORTEST_LT?: number | null;
  product_SHORTEST_LTE?: number | null;
  unlimited_AVERAGE_EQUAL?: number | null;
  unlimited_AVERAGE_GT?: number | null;
  unlimited_AVERAGE_GTE?: number | null;
  unlimited_AVERAGE_LT?: number | null;
  unlimited_AVERAGE_LTE?: number | null;
  unlimited_EQUAL?: number | null;
  unlimited_GT?: number | null;
  unlimited_GTE?: number | null;
  unlimited_LT?: number | null;
  unlimited_LTE?: number | null;
  unlimited_MAX_EQUAL?: number | null;
  unlimited_MAX_GT?: number | null;
  unlimited_MAX_GTE?: number | null;
  unlimited_MAX_LT?: number | null;
  unlimited_MAX_LTE?: number | null;
  unlimited_MIN_EQUAL?: number | null;
  unlimited_MIN_GT?: number | null;
  unlimited_MIN_GTE?: number | null;
  unlimited_MIN_LT?: number | null;
  unlimited_MIN_LTE?: number | null;
  unlimited_SUM_EQUAL?: number | null;
  unlimited_SUM_GT?: number | null;
  unlimited_SUM_GTE?: number | null;
  unlimited_SUM_LT?: number | null;
  unlimited_SUM_LTE?: number | null;
}

export interface TaskMessageAggregateInput {
  AND?: TaskMessageAggregateInput[] | null;
  OR?: TaskMessageAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  edge?: TaskMessageEdgeAggregationWhereInput | null;
  node?: TaskMessageNodeAggregationWhereInput | null;
}

export interface TaskMessageConnectionWhere {
  AND?: TaskMessageConnectionWhere[] | null;
  OR?: TaskMessageConnectionWhere[] | null;
  edge?: UserMessageRelationshipWhere | null;
  edge_NOT?: UserMessageRelationshipWhere | null;
  node?: MessageWhere | null;
  node_NOT?: MessageWhere | null;
}

export interface TaskMessageEdgeAggregationWhereInput {
  AND?: TaskMessageEdgeAggregationWhereInput[] | null;
  OR?: TaskMessageEdgeAggregationWhereInput[] | null;
  nodeContext_AVERAGE_EQUAL?: number | null;
  nodeContext_AVERAGE_GT?: number | null;
  nodeContext_AVERAGE_GTE?: number | null;
  nodeContext_AVERAGE_LT?: number | null;
  nodeContext_AVERAGE_LTE?: number | null;
  nodeContext_EQUAL?: string | null;
  nodeContext_GT?: number | null;
  nodeContext_GTE?: number | null;
  nodeContext_LONGEST_EQUAL?: number | null;
  nodeContext_LONGEST_GT?: number | null;
  nodeContext_LONGEST_GTE?: number | null;
  nodeContext_LONGEST_LT?: number | null;
  nodeContext_LONGEST_LTE?: number | null;
  nodeContext_LT?: number | null;
  nodeContext_LTE?: number | null;
  nodeContext_SHORTEST_EQUAL?: number | null;
  nodeContext_SHORTEST_GT?: number | null;
  nodeContext_SHORTEST_GTE?: number | null;
  nodeContext_SHORTEST_LT?: number | null;
  nodeContext_SHORTEST_LTE?: number | null;
  nodeId_EQUAL?: string | null;
}

export interface TaskMessageNodeAggregationWhereInput {
  AND?: TaskMessageNodeAggregationWhereInput[] | null;
  OR?: TaskMessageNodeAggregationWhereInput[] | null;
  content_AVERAGE_EQUAL?: number | null;
  content_AVERAGE_GT?: number | null;
  content_AVERAGE_GTE?: number | null;
  content_AVERAGE_LT?: number | null;
  content_AVERAGE_LTE?: number | null;
  content_EQUAL?: string | null;
  content_GT?: number | null;
  content_GTE?: number | null;
  content_LONGEST_EQUAL?: number | null;
  content_LONGEST_GT?: number | null;
  content_LONGEST_GTE?: number | null;
  content_LONGEST_LT?: number | null;
  content_LONGEST_LTE?: number | null;
  content_LT?: number | null;
  content_LTE?: number | null;
  content_SHORTEST_EQUAL?: number | null;
  content_SHORTEST_GT?: number | null;
  content_SHORTEST_GTE?: number | null;
  content_SHORTEST_LT?: number | null;
  content_SHORTEST_LTE?: number | null;
  createdOn_AVERAGE_EQUAL?: number | null;
  createdOn_AVERAGE_GT?: number | null;
  createdOn_AVERAGE_GTE?: number | null;
  createdOn_AVERAGE_LT?: number | null;
  createdOn_AVERAGE_LTE?: number | null;
  createdOn_EQUAL?: number | null;
  createdOn_GT?: number | null;
  createdOn_GTE?: number | null;
  createdOn_LT?: number | null;
  createdOn_LTE?: number | null;
  createdOn_MAX_EQUAL?: number | null;
  createdOn_MAX_GT?: number | null;
  createdOn_MAX_GTE?: number | null;
  createdOn_MAX_LT?: number | null;
  createdOn_MAX_LTE?: number | null;
  createdOn_MIN_EQUAL?: number | null;
  createdOn_MIN_GT?: number | null;
  createdOn_MIN_GTE?: number | null;
  createdOn_MIN_LT?: number | null;
  createdOn_MIN_LTE?: number | null;
  createdOn_SUM_EQUAL?: number | null;
  createdOn_SUM_GT?: number | null;
  createdOn_SUM_GTE?: number | null;
  createdOn_SUM_LT?: number | null;
  createdOn_SUM_LTE?: number | null;
}

export interface TaskUsersRelationshipAggregateInput {
  AND?: TaskUsersRelationshipAggregateInput[] | null;
  OR?: TaskUsersRelationshipAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: TaskUsersRelationshipNodeAggregationWhereInput | null;
}

export interface TaskUsersRelationshipConnectionWhere {
  AND?: TaskUsersRelationshipConnectionWhere[] | null;
  OR?: TaskUsersRelationshipConnectionWhere[] | null;
  edge?: UserTaskRelationshipWhere | null;
  edge_NOT?: UserTaskRelationshipWhere | null;
  node?: UserWhere | null;
  node_NOT?: UserWhere | null;
}

export interface TaskUsersRelationshipNodeAggregationWhereInput {
  AND?: TaskUsersRelationshipNodeAggregationWhereInput[] | null;
  OR?: TaskUsersRelationshipNodeAggregationWhereInput[] | null;
  deletedOn_EQUAL?: any | null;
  deletedOn_GT?: any | null;
  deletedOn_GTE?: any | null;
  deletedOn_LT?: any | null;
  deletedOn_LTE?: any | null;
  deletedOn_MAX_EQUAL?: any | null;
  deletedOn_MAX_GT?: any | null;
  deletedOn_MAX_GTE?: any | null;
  deletedOn_MAX_LT?: any | null;
  deletedOn_MAX_LTE?: any | null;
  deletedOn_MIN_EQUAL?: any | null;
  deletedOn_MIN_GT?: any | null;
  deletedOn_MIN_GTE?: any | null;
  deletedOn_MIN_LT?: any | null;
  deletedOn_MIN_LTE?: any | null;
  department_AVERAGE_EQUAL?: number | null;
  department_AVERAGE_GT?: number | null;
  department_AVERAGE_GTE?: number | null;
  department_AVERAGE_LT?: number | null;
  department_AVERAGE_LTE?: number | null;
  department_EQUAL?: string | null;
  department_GT?: number | null;
  department_GTE?: number | null;
  department_LONGEST_EQUAL?: number | null;
  department_LONGEST_GT?: number | null;
  department_LONGEST_GTE?: number | null;
  department_LONGEST_LT?: number | null;
  department_LONGEST_LTE?: number | null;
  department_LT?: number | null;
  department_LTE?: number | null;
  department_SHORTEST_EQUAL?: number | null;
  department_SHORTEST_GT?: number | null;
  department_SHORTEST_GTE?: number | null;
  department_SHORTEST_LT?: number | null;
  department_SHORTEST_LTE?: number | null;
  email_AVERAGE_EQUAL?: number | null;
  email_AVERAGE_GT?: number | null;
  email_AVERAGE_GTE?: number | null;
  email_AVERAGE_LT?: number | null;
  email_AVERAGE_LTE?: number | null;
  email_EQUAL?: string | null;
  email_GT?: number | null;
  email_GTE?: number | null;
  email_LONGEST_EQUAL?: number | null;
  email_LONGEST_GT?: number | null;
  email_LONGEST_GTE?: number | null;
  email_LONGEST_LT?: number | null;
  email_LONGEST_LTE?: number | null;
  email_LT?: number | null;
  email_LTE?: number | null;
  email_SHORTEST_EQUAL?: number | null;
  email_SHORTEST_GT?: number | null;
  email_SHORTEST_GTE?: number | null;
  email_SHORTEST_LT?: number | null;
  email_SHORTEST_LTE?: number | null;
  firstName_AVERAGE_EQUAL?: number | null;
  firstName_AVERAGE_GT?: number | null;
  firstName_AVERAGE_GTE?: number | null;
  firstName_AVERAGE_LT?: number | null;
  firstName_AVERAGE_LTE?: number | null;
  firstName_EQUAL?: string | null;
  firstName_GT?: number | null;
  firstName_GTE?: number | null;
  firstName_LONGEST_EQUAL?: number | null;
  firstName_LONGEST_GT?: number | null;
  firstName_LONGEST_GTE?: number | null;
  firstName_LONGEST_LT?: number | null;
  firstName_LONGEST_LTE?: number | null;
  firstName_LT?: number | null;
  firstName_LTE?: number | null;
  firstName_SHORTEST_EQUAL?: number | null;
  firstName_SHORTEST_GT?: number | null;
  firstName_SHORTEST_GTE?: number | null;
  firstName_SHORTEST_LT?: number | null;
  firstName_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  lastName_AVERAGE_EQUAL?: number | null;
  lastName_AVERAGE_GT?: number | null;
  lastName_AVERAGE_GTE?: number | null;
  lastName_AVERAGE_LT?: number | null;
  lastName_AVERAGE_LTE?: number | null;
  lastName_EQUAL?: string | null;
  lastName_GT?: number | null;
  lastName_GTE?: number | null;
  lastName_LONGEST_EQUAL?: number | null;
  lastName_LONGEST_GT?: number | null;
  lastName_LONGEST_GTE?: number | null;
  lastName_LONGEST_LT?: number | null;
  lastName_LONGEST_LTE?: number | null;
  lastName_LT?: number | null;
  lastName_LTE?: number | null;
  lastName_SHORTEST_EQUAL?: number | null;
  lastName_SHORTEST_GT?: number | null;
  lastName_SHORTEST_GTE?: number | null;
  lastName_SHORTEST_LT?: number | null;
  lastName_SHORTEST_LTE?: number | null;
  position_AVERAGE_EQUAL?: number | null;
  position_AVERAGE_GT?: number | null;
  position_AVERAGE_GTE?: number | null;
  position_AVERAGE_LT?: number | null;
  position_AVERAGE_LTE?: number | null;
  position_EQUAL?: string | null;
  position_GT?: number | null;
  position_GTE?: number | null;
  position_LONGEST_EQUAL?: number | null;
  position_LONGEST_GT?: number | null;
  position_LONGEST_GTE?: number | null;
  position_LONGEST_LT?: number | null;
  position_LONGEST_LTE?: number | null;
  position_LT?: number | null;
  position_LTE?: number | null;
  position_SHORTEST_EQUAL?: number | null;
  position_SHORTEST_GT?: number | null;
  position_SHORTEST_GTE?: number | null;
  position_SHORTEST_LT?: number | null;
  position_SHORTEST_LTE?: number | null;
  preferredLanguage_AVERAGE_EQUAL?: number | null;
  preferredLanguage_AVERAGE_GT?: number | null;
  preferredLanguage_AVERAGE_GTE?: number | null;
  preferredLanguage_AVERAGE_LT?: number | null;
  preferredLanguage_AVERAGE_LTE?: number | null;
  preferredLanguage_EQUAL?: string | null;
  preferredLanguage_GT?: number | null;
  preferredLanguage_GTE?: number | null;
  preferredLanguage_LONGEST_EQUAL?: number | null;
  preferredLanguage_LONGEST_GT?: number | null;
  preferredLanguage_LONGEST_GTE?: number | null;
  preferredLanguage_LONGEST_LT?: number | null;
  preferredLanguage_LONGEST_LTE?: number | null;
  preferredLanguage_LT?: number | null;
  preferredLanguage_LTE?: number | null;
  preferredLanguage_SHORTEST_EQUAL?: number | null;
  preferredLanguage_SHORTEST_GT?: number | null;
  preferredLanguage_SHORTEST_GTE?: number | null;
  preferredLanguage_SHORTEST_LT?: number | null;
  preferredLanguage_SHORTEST_LTE?: number | null;
  tenantId_AVERAGE_EQUAL?: number | null;
  tenantId_AVERAGE_GT?: number | null;
  tenantId_AVERAGE_GTE?: number | null;
  tenantId_AVERAGE_LT?: number | null;
  tenantId_AVERAGE_LTE?: number | null;
  tenantId_EQUAL?: string | null;
  tenantId_GT?: number | null;
  tenantId_GTE?: number | null;
  tenantId_LONGEST_EQUAL?: number | null;
  tenantId_LONGEST_GT?: number | null;
  tenantId_LONGEST_GTE?: number | null;
  tenantId_LONGEST_LT?: number | null;
  tenantId_LONGEST_LTE?: number | null;
  tenantId_LT?: number | null;
  tenantId_LTE?: number | null;
  tenantId_SHORTEST_EQUAL?: number | null;
  tenantId_SHORTEST_GT?: number | null;
  tenantId_SHORTEST_GTE?: number | null;
  tenantId_SHORTEST_LT?: number | null;
  tenantId_SHORTEST_LTE?: number | null;
}

export interface TaskWhere {
  AND?: TaskWhere[] | null;
  OR?: TaskWhere[] | null;
  agreement?: AgreementWhere | null;
  agreementAggregate?: TaskAgreementAggregateInput | null;
  agreementConnection?: TaskAgreementConnectionWhere | null;
  agreementConnection_NOT?: TaskAgreementConnectionWhere | null;
  agreement_NOT?: AgreementWhere | null;
  case?: CaseWhere | null;
  caseAggregate?: TaskCaseAggregateInput | null;
  caseConnection?: TaskCaseConnectionWhere | null;
  caseConnection_NOT?: TaskCaseConnectionWhere | null;
  case_NOT?: CaseWhere | null;
  createdBy?: UserWhere | null;
  createdByAggregate?: TaskCreatedByAggregateInput | null;
  createdByConnection?: TaskCreatedByConnectionWhere | null;
  createdByConnection_NOT?: TaskCreatedByConnectionWhere | null;
  createdBy_NOT?: UserWhere | null;
  document?: DocumentWhere | null;
  documentAggregate?: TaskDocumentAggregateInput | null;
  documentConnection?: TaskDocumentConnectionWhere | null;
  documentConnection_NOT?: TaskDocumentConnectionWhere | null;
  document_NOT?: DocumentWhere | null;
  id?: string | null;
  id_CONTAINS?: string | null;
  id_ENDS_WITH?: string | null;
  id_IN?: (string | null)[] | null;
  id_MATCHES?: string | null;
  id_NOT?: string | null;
  id_NOT_CONTAINS?: string | null;
  id_NOT_ENDS_WITH?: string | null;
  id_NOT_IN?: (string | null)[] | null;
  id_NOT_STARTS_WITH?: string | null;
  id_STARTS_WITH?: string | null;
  message?: MessageWhere | null;
  messageAggregate?: TaskMessageAggregateInput | null;
  messageConnection?: TaskMessageConnectionWhere | null;
  messageConnection_NOT?: TaskMessageConnectionWhere | null;
  message_NOT?: MessageWhere | null;
  taskContentDe?: string | null;
  taskContentDe_CONTAINS?: string | null;
  taskContentDe_ENDS_WITH?: string | null;
  taskContentDe_IN?: (string | null)[] | null;
  taskContentDe_MATCHES?: string | null;
  taskContentDe_NOT?: string | null;
  taskContentDe_NOT_CONTAINS?: string | null;
  taskContentDe_NOT_ENDS_WITH?: string | null;
  taskContentDe_NOT_IN?: (string | null)[] | null;
  taskContentDe_NOT_STARTS_WITH?: string | null;
  taskContentDe_STARTS_WITH?: string | null;
  taskContentEn?: string | null;
  taskContentEn_CONTAINS?: string | null;
  taskContentEn_ENDS_WITH?: string | null;
  taskContentEn_IN?: (string | null)[] | null;
  taskContentEn_MATCHES?: string | null;
  taskContentEn_NOT?: string | null;
  taskContentEn_NOT_CONTAINS?: string | null;
  taskContentEn_NOT_ENDS_WITH?: string | null;
  taskContentEn_NOT_IN?: (string | null)[] | null;
  taskContentEn_NOT_STARTS_WITH?: string | null;
  taskContentEn_STARTS_WITH?: string | null;
  taskStatus?: TaskStatus | null;
  taskStatus_IN?: (TaskStatus | null)[] | null;
  taskStatus_NOT?: TaskStatus | null;
  taskStatus_NOT_IN?: (TaskStatus | null)[] | null;
  tenantIds?: string[] | null;
  tenantIds_INCLUDES?: string | null;
  tenantIds_NOT?: string[] | null;
  tenantIds_NOT_INCLUDES?: string | null;
  timeStamp?: number | null;
  timeStamp_GT?: number | null;
  timeStamp_GTE?: number | null;
  timeStamp_IN?: (number | null)[] | null;
  timeStamp_LT?: number | null;
  timeStamp_LTE?: number | null;
  timeStamp_NOT?: number | null;
  timeStamp_NOT_IN?: (number | null)[] | null;
  triggerEventId?: number | null;
  triggerEventId_GT?: number | null;
  triggerEventId_GTE?: number | null;
  triggerEventId_IN?: (number | null)[] | null;
  triggerEventId_LT?: number | null;
  triggerEventId_LTE?: number | null;
  triggerEventId_NOT?: number | null;
  triggerEventId_NOT_IN?: (number | null)[] | null;
  usersRelationship?: UserWhere | null;
  usersRelationshipAggregate?: TaskUsersRelationshipAggregateInput | null;
  usersRelationshipConnection?: TaskUsersRelationshipConnectionWhere | null;
  usersRelationshipConnection_NOT?: TaskUsersRelationshipConnectionWhere | null;
  usersRelationship_NOT?: UserWhere | null;
}

export interface ThresholdConfigurationRelationshipWhere {
  AND?: ThresholdConfigurationRelationshipWhere[] | null;
  OR?: ThresholdConfigurationRelationshipWhere[] | null;
  threshold?: number | null;
  threshold_GT?: number | null;
  threshold_GTE?: number | null;
  threshold_IN?: (number | null)[] | null;
  threshold_LT?: number | null;
  threshold_LTE?: number | null;
  threshold_NOT?: number | null;
  threshold_NOT_IN?: (number | null)[] | null;
}

export interface TreatmentHasLimitationsAggregateInput {
  AND?: TreatmentHasLimitationsAggregateInput[] | null;
  OR?: TreatmentHasLimitationsAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: TreatmentHasLimitationsNodeAggregationWhereInput | null;
}

export interface TreatmentHasLimitationsConnectionWhere {
  AND?: TreatmentHasLimitationsConnectionWhere[] | null;
  OR?: TreatmentHasLimitationsConnectionWhere[] | null;
  node?: LimitationWhere | null;
  node_NOT?: LimitationWhere | null;
}

export interface TreatmentHasLimitationsNodeAggregationWhereInput {
  AND?: TreatmentHasLimitationsNodeAggregationWhereInput[] | null;
  Code_AVERAGE_EQUAL?: number | null;
  Code_AVERAGE_GT?: number | null;
  Code_AVERAGE_GTE?: number | null;
  Code_AVERAGE_LT?: number | null;
  Code_AVERAGE_LTE?: number | null;
  Code_EQUAL?: string | null;
  Code_GT?: number | null;
  Code_GTE?: number | null;
  Code_LONGEST_EQUAL?: number | null;
  Code_LONGEST_GT?: number | null;
  Code_LONGEST_GTE?: number | null;
  Code_LONGEST_LT?: number | null;
  Code_LONGEST_LTE?: number | null;
  Code_LT?: number | null;
  Code_LTE?: number | null;
  Code_SHORTEST_EQUAL?: number | null;
  Code_SHORTEST_GT?: number | null;
  Code_SHORTEST_GTE?: number | null;
  Code_SHORTEST_LT?: number | null;
  Code_SHORTEST_LTE?: number | null;
  DescriptionDe_AVERAGE_EQUAL?: number | null;
  DescriptionDe_AVERAGE_GT?: number | null;
  DescriptionDe_AVERAGE_GTE?: number | null;
  DescriptionDe_AVERAGE_LT?: number | null;
  DescriptionDe_AVERAGE_LTE?: number | null;
  DescriptionDe_EQUAL?: string | null;
  DescriptionDe_GT?: number | null;
  DescriptionDe_GTE?: number | null;
  DescriptionDe_LONGEST_EQUAL?: number | null;
  DescriptionDe_LONGEST_GT?: number | null;
  DescriptionDe_LONGEST_GTE?: number | null;
  DescriptionDe_LONGEST_LT?: number | null;
  DescriptionDe_LONGEST_LTE?: number | null;
  DescriptionDe_LT?: number | null;
  DescriptionDe_LTE?: number | null;
  DescriptionDe_SHORTEST_EQUAL?: number | null;
  DescriptionDe_SHORTEST_GT?: number | null;
  DescriptionDe_SHORTEST_GTE?: number | null;
  DescriptionDe_SHORTEST_LT?: number | null;
  DescriptionDe_SHORTEST_LTE?: number | null;
  DescriptionEn_AVERAGE_EQUAL?: number | null;
  DescriptionEn_AVERAGE_GT?: number | null;
  DescriptionEn_AVERAGE_GTE?: number | null;
  DescriptionEn_AVERAGE_LT?: number | null;
  DescriptionEn_AVERAGE_LTE?: number | null;
  DescriptionEn_EQUAL?: string | null;
  DescriptionEn_GT?: number | null;
  DescriptionEn_GTE?: number | null;
  DescriptionEn_LONGEST_EQUAL?: number | null;
  DescriptionEn_LONGEST_GT?: number | null;
  DescriptionEn_LONGEST_GTE?: number | null;
  DescriptionEn_LONGEST_LT?: number | null;
  DescriptionEn_LONGEST_LTE?: number | null;
  DescriptionEn_LT?: number | null;
  DescriptionEn_LTE?: number | null;
  DescriptionEn_SHORTEST_EQUAL?: number | null;
  DescriptionEn_SHORTEST_GT?: number | null;
  DescriptionEn_SHORTEST_GTE?: number | null;
  DescriptionEn_SHORTEST_LT?: number | null;
  DescriptionEn_SHORTEST_LTE?: number | null;
  Niveau_AVERAGE_EQUAL?: number | null;
  Niveau_AVERAGE_GT?: number | null;
  Niveau_AVERAGE_GTE?: number | null;
  Niveau_AVERAGE_LT?: number | null;
  Niveau_AVERAGE_LTE?: number | null;
  Niveau_EQUAL?: string | null;
  Niveau_GT?: number | null;
  Niveau_GTE?: number | null;
  Niveau_LONGEST_EQUAL?: number | null;
  Niveau_LONGEST_GT?: number | null;
  Niveau_LONGEST_GTE?: number | null;
  Niveau_LONGEST_LT?: number | null;
  Niveau_LONGEST_LTE?: number | null;
  Niveau_LT?: number | null;
  Niveau_LTE?: number | null;
  Niveau_SHORTEST_EQUAL?: number | null;
  Niveau_SHORTEST_GT?: number | null;
  Niveau_SHORTEST_GTE?: number | null;
  Niveau_SHORTEST_LT?: number | null;
  Niveau_SHORTEST_LTE?: number | null;
  OR?: TreatmentHasLimitationsNodeAggregationWhereInput[] | null;
  Type_AVERAGE_EQUAL?: number | null;
  Type_AVERAGE_GT?: number | null;
  Type_AVERAGE_GTE?: number | null;
  Type_AVERAGE_LT?: number | null;
  Type_AVERAGE_LTE?: number | null;
  Type_EQUAL?: string | null;
  Type_GT?: number | null;
  Type_GTE?: number | null;
  Type_LONGEST_EQUAL?: number | null;
  Type_LONGEST_GT?: number | null;
  Type_LONGEST_GTE?: number | null;
  Type_LONGEST_LT?: number | null;
  Type_LONGEST_LTE?: number | null;
  Type_LT?: number | null;
  Type_LTE?: number | null;
  Type_SHORTEST_EQUAL?: number | null;
  Type_SHORTEST_GT?: number | null;
  Type_SHORTEST_GTE?: number | null;
  Type_SHORTEST_LT?: number | null;
  Type_SHORTEST_LTE?: number | null;
  uuid_EQUAL?: string | null;
}

export interface TreatmentPartnersAggregateInput {
  AND?: TreatmentPartnersAggregateInput[] | null;
  OR?: TreatmentPartnersAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: TreatmentPartnersNodeAggregationWhereInput | null;
}

export interface TreatmentPartnersConnectionWhere {
  AND?: TreatmentPartnersConnectionWhere[] | null;
  OR?: TreatmentPartnersConnectionWhere[] | null;
  node?: PartnerWhere | null;
  node_NOT?: PartnerWhere | null;
}

export interface TreatmentPartnersNodeAggregationWhereInput {
  AND?: TreatmentPartnersNodeAggregationWhereInput[] | null;
  Description_AVERAGE_EQUAL?: number | null;
  Description_AVERAGE_GT?: number | null;
  Description_AVERAGE_GTE?: number | null;
  Description_AVERAGE_LT?: number | null;
  Description_AVERAGE_LTE?: number | null;
  Description_EQUAL?: string | null;
  Description_GT?: number | null;
  Description_GTE?: number | null;
  Description_LONGEST_EQUAL?: number | null;
  Description_LONGEST_GT?: number | null;
  Description_LONGEST_GTE?: number | null;
  Description_LONGEST_LT?: number | null;
  Description_LONGEST_LTE?: number | null;
  Description_LT?: number | null;
  Description_LTE?: number | null;
  Description_SHORTEST_EQUAL?: number | null;
  Description_SHORTEST_GT?: number | null;
  Description_SHORTEST_GTE?: number | null;
  Description_SHORTEST_LT?: number | null;
  Description_SHORTEST_LTE?: number | null;
  OR?: TreatmentPartnersNodeAggregationWhereInput[] | null;
  PartnerType_AVERAGE_EQUAL?: number | null;
  PartnerType_AVERAGE_GT?: number | null;
  PartnerType_AVERAGE_GTE?: number | null;
  PartnerType_AVERAGE_LT?: number | null;
  PartnerType_AVERAGE_LTE?: number | null;
  PartnerType_EQUAL?: string | null;
  PartnerType_GT?: number | null;
  PartnerType_GTE?: number | null;
  PartnerType_LONGEST_EQUAL?: number | null;
  PartnerType_LONGEST_GT?: number | null;
  PartnerType_LONGEST_GTE?: number | null;
  PartnerType_LONGEST_LT?: number | null;
  PartnerType_LONGEST_LTE?: number | null;
  PartnerType_LT?: number | null;
  PartnerType_LTE?: number | null;
  PartnerType_SHORTEST_EQUAL?: number | null;
  PartnerType_SHORTEST_GT?: number | null;
  PartnerType_SHORTEST_GTE?: number | null;
  PartnerType_SHORTEST_LT?: number | null;
  PartnerType_SHORTEST_LTE?: number | null;
  Phone_AVERAGE_EQUAL?: number | null;
  Phone_AVERAGE_GT?: number | null;
  Phone_AVERAGE_GTE?: number | null;
  Phone_AVERAGE_LT?: number | null;
  Phone_AVERAGE_LTE?: number | null;
  Phone_EQUAL?: string | null;
  Phone_GT?: number | null;
  Phone_GTE?: number | null;
  Phone_LONGEST_EQUAL?: number | null;
  Phone_LONGEST_GT?: number | null;
  Phone_LONGEST_GTE?: number | null;
  Phone_LONGEST_LT?: number | null;
  Phone_LONGEST_LTE?: number | null;
  Phone_LT?: number | null;
  Phone_LTE?: number | null;
  Phone_SHORTEST_EQUAL?: number | null;
  Phone_SHORTEST_GT?: number | null;
  Phone_SHORTEST_GTE?: number | null;
  Phone_SHORTEST_LT?: number | null;
  Phone_SHORTEST_LTE?: number | null;
  Place_AVERAGE_EQUAL?: number | null;
  Place_AVERAGE_GT?: number | null;
  Place_AVERAGE_GTE?: number | null;
  Place_AVERAGE_LT?: number | null;
  Place_AVERAGE_LTE?: number | null;
  Place_EQUAL?: string | null;
  Place_GT?: number | null;
  Place_GTE?: number | null;
  Place_LONGEST_EQUAL?: number | null;
  Place_LONGEST_GT?: number | null;
  Place_LONGEST_GTE?: number | null;
  Place_LONGEST_LT?: number | null;
  Place_LONGEST_LTE?: number | null;
  Place_LT?: number | null;
  Place_LTE?: number | null;
  Place_SHORTEST_EQUAL?: number | null;
  Place_SHORTEST_GT?: number | null;
  Place_SHORTEST_GTE?: number | null;
  Place_SHORTEST_LT?: number | null;
  Place_SHORTEST_LTE?: number | null;
  Street_AVERAGE_EQUAL?: number | null;
  Street_AVERAGE_GT?: number | null;
  Street_AVERAGE_GTE?: number | null;
  Street_AVERAGE_LT?: number | null;
  Street_AVERAGE_LTE?: number | null;
  Street_EQUAL?: string | null;
  Street_GT?: number | null;
  Street_GTE?: number | null;
  Street_LONGEST_EQUAL?: number | null;
  Street_LONGEST_GT?: number | null;
  Street_LONGEST_GTE?: number | null;
  Street_LONGEST_LT?: number | null;
  Street_LONGEST_LTE?: number | null;
  Street_LT?: number | null;
  Street_LTE?: number | null;
  Street_SHORTEST_EQUAL?: number | null;
  Street_SHORTEST_GT?: number | null;
  Street_SHORTEST_GTE?: number | null;
  Street_SHORTEST_LT?: number | null;
  Street_SHORTEST_LTE?: number | null;
  ZipCode_AVERAGE_EQUAL?: number | null;
  ZipCode_AVERAGE_GT?: number | null;
  ZipCode_AVERAGE_GTE?: number | null;
  ZipCode_AVERAGE_LT?: number | null;
  ZipCode_AVERAGE_LTE?: number | null;
  ZipCode_EQUAL?: number | null;
  ZipCode_GT?: number | null;
  ZipCode_GTE?: number | null;
  ZipCode_LT?: number | null;
  ZipCode_LTE?: number | null;
  ZipCode_MAX_EQUAL?: number | null;
  ZipCode_MAX_GT?: number | null;
  ZipCode_MAX_GTE?: number | null;
  ZipCode_MAX_LT?: number | null;
  ZipCode_MAX_LTE?: number | null;
  ZipCode_MIN_EQUAL?: number | null;
  ZipCode_MIN_GT?: number | null;
  ZipCode_MIN_GTE?: number | null;
  ZipCode_MIN_LT?: number | null;
  ZipCode_MIN_LTE?: number | null;
  ZipCode_SUM_EQUAL?: number | null;
  ZipCode_SUM_GT?: number | null;
  ZipCode_SUM_GTE?: number | null;
  ZipCode_SUM_LT?: number | null;
  ZipCode_SUM_LTE?: number | null;
}

export interface TreatmentPricesAggregateInput {
  AND?: TreatmentPricesAggregateInput[] | null;
  OR?: TreatmentPricesAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: TreatmentPricesNodeAggregationWhereInput | null;
}

export interface TreatmentPricesConnectionWhere {
  AND?: TreatmentPricesConnectionWhere[] | null;
  OR?: TreatmentPricesConnectionWhere[] | null;
  node?: PriceWhere | null;
  node_NOT?: PriceWhere | null;
}

export interface TreatmentPricesNodeAggregationWhereInput {
  AND?: TreatmentPricesNodeAggregationWhereInput[] | null;
  OR?: TreatmentPricesNodeAggregationWhereInput[] | null;
  PriceChangeTypeDescriptionDe_AVERAGE_EQUAL?: number | null;
  PriceChangeTypeDescriptionDe_AVERAGE_GT?: number | null;
  PriceChangeTypeDescriptionDe_AVERAGE_GTE?: number | null;
  PriceChangeTypeDescriptionDe_AVERAGE_LT?: number | null;
  PriceChangeTypeDescriptionDe_AVERAGE_LTE?: number | null;
  PriceChangeTypeDescriptionDe_EQUAL?: string | null;
  PriceChangeTypeDescriptionDe_GT?: number | null;
  PriceChangeTypeDescriptionDe_GTE?: number | null;
  PriceChangeTypeDescriptionDe_LONGEST_EQUAL?: number | null;
  PriceChangeTypeDescriptionDe_LONGEST_GT?: number | null;
  PriceChangeTypeDescriptionDe_LONGEST_GTE?: number | null;
  PriceChangeTypeDescriptionDe_LONGEST_LT?: number | null;
  PriceChangeTypeDescriptionDe_LONGEST_LTE?: number | null;
  PriceChangeTypeDescriptionDe_LT?: number | null;
  PriceChangeTypeDescriptionDe_LTE?: number | null;
  PriceChangeTypeDescriptionDe_SHORTEST_EQUAL?: number | null;
  PriceChangeTypeDescriptionDe_SHORTEST_GT?: number | null;
  PriceChangeTypeDescriptionDe_SHORTEST_GTE?: number | null;
  PriceChangeTypeDescriptionDe_SHORTEST_LT?: number | null;
  PriceChangeTypeDescriptionDe_SHORTEST_LTE?: number | null;
  PriceChangeTypeDescriptionFr_AVERAGE_EQUAL?: number | null;
  PriceChangeTypeDescriptionFr_AVERAGE_GT?: number | null;
  PriceChangeTypeDescriptionFr_AVERAGE_GTE?: number | null;
  PriceChangeTypeDescriptionFr_AVERAGE_LT?: number | null;
  PriceChangeTypeDescriptionFr_AVERAGE_LTE?: number | null;
  PriceChangeTypeDescriptionFr_EQUAL?: string | null;
  PriceChangeTypeDescriptionFr_GT?: number | null;
  PriceChangeTypeDescriptionFr_GTE?: number | null;
  PriceChangeTypeDescriptionFr_LONGEST_EQUAL?: number | null;
  PriceChangeTypeDescriptionFr_LONGEST_GT?: number | null;
  PriceChangeTypeDescriptionFr_LONGEST_GTE?: number | null;
  PriceChangeTypeDescriptionFr_LONGEST_LT?: number | null;
  PriceChangeTypeDescriptionFr_LONGEST_LTE?: number | null;
  PriceChangeTypeDescriptionFr_LT?: number | null;
  PriceChangeTypeDescriptionFr_LTE?: number | null;
  PriceChangeTypeDescriptionFr_SHORTEST_EQUAL?: number | null;
  PriceChangeTypeDescriptionFr_SHORTEST_GT?: number | null;
  PriceChangeTypeDescriptionFr_SHORTEST_GTE?: number | null;
  PriceChangeTypeDescriptionFr_SHORTEST_LT?: number | null;
  PriceChangeTypeDescriptionFr_SHORTEST_LTE?: number | null;
  PriceChangeTypeDescriptionIt_AVERAGE_EQUAL?: number | null;
  PriceChangeTypeDescriptionIt_AVERAGE_GT?: number | null;
  PriceChangeTypeDescriptionIt_AVERAGE_GTE?: number | null;
  PriceChangeTypeDescriptionIt_AVERAGE_LT?: number | null;
  PriceChangeTypeDescriptionIt_AVERAGE_LTE?: number | null;
  PriceChangeTypeDescriptionIt_EQUAL?: string | null;
  PriceChangeTypeDescriptionIt_GT?: number | null;
  PriceChangeTypeDescriptionIt_GTE?: number | null;
  PriceChangeTypeDescriptionIt_LONGEST_EQUAL?: number | null;
  PriceChangeTypeDescriptionIt_LONGEST_GT?: number | null;
  PriceChangeTypeDescriptionIt_LONGEST_GTE?: number | null;
  PriceChangeTypeDescriptionIt_LONGEST_LT?: number | null;
  PriceChangeTypeDescriptionIt_LONGEST_LTE?: number | null;
  PriceChangeTypeDescriptionIt_LT?: number | null;
  PriceChangeTypeDescriptionIt_LTE?: number | null;
  PriceChangeTypeDescriptionIt_SHORTEST_EQUAL?: number | null;
  PriceChangeTypeDescriptionIt_SHORTEST_GT?: number | null;
  PriceChangeTypeDescriptionIt_SHORTEST_GTE?: number | null;
  PriceChangeTypeDescriptionIt_SHORTEST_LT?: number | null;
  PriceChangeTypeDescriptionIt_SHORTEST_LTE?: number | null;
  PriceTypeDescriptionDe_AVERAGE_EQUAL?: number | null;
  PriceTypeDescriptionDe_AVERAGE_GT?: number | null;
  PriceTypeDescriptionDe_AVERAGE_GTE?: number | null;
  PriceTypeDescriptionDe_AVERAGE_LT?: number | null;
  PriceTypeDescriptionDe_AVERAGE_LTE?: number | null;
  PriceTypeDescriptionDe_EQUAL?: string | null;
  PriceTypeDescriptionDe_GT?: number | null;
  PriceTypeDescriptionDe_GTE?: number | null;
  PriceTypeDescriptionDe_LONGEST_EQUAL?: number | null;
  PriceTypeDescriptionDe_LONGEST_GT?: number | null;
  PriceTypeDescriptionDe_LONGEST_GTE?: number | null;
  PriceTypeDescriptionDe_LONGEST_LT?: number | null;
  PriceTypeDescriptionDe_LONGEST_LTE?: number | null;
  PriceTypeDescriptionDe_LT?: number | null;
  PriceTypeDescriptionDe_LTE?: number | null;
  PriceTypeDescriptionDe_SHORTEST_EQUAL?: number | null;
  PriceTypeDescriptionDe_SHORTEST_GT?: number | null;
  PriceTypeDescriptionDe_SHORTEST_GTE?: number | null;
  PriceTypeDescriptionDe_SHORTEST_LT?: number | null;
  PriceTypeDescriptionDe_SHORTEST_LTE?: number | null;
  PriceTypeDescriptionFr_AVERAGE_EQUAL?: number | null;
  PriceTypeDescriptionFr_AVERAGE_GT?: number | null;
  PriceTypeDescriptionFr_AVERAGE_GTE?: number | null;
  PriceTypeDescriptionFr_AVERAGE_LT?: number | null;
  PriceTypeDescriptionFr_AVERAGE_LTE?: number | null;
  PriceTypeDescriptionFr_EQUAL?: string | null;
  PriceTypeDescriptionFr_GT?: number | null;
  PriceTypeDescriptionFr_GTE?: number | null;
  PriceTypeDescriptionFr_LONGEST_EQUAL?: number | null;
  PriceTypeDescriptionFr_LONGEST_GT?: number | null;
  PriceTypeDescriptionFr_LONGEST_GTE?: number | null;
  PriceTypeDescriptionFr_LONGEST_LT?: number | null;
  PriceTypeDescriptionFr_LONGEST_LTE?: number | null;
  PriceTypeDescriptionFr_LT?: number | null;
  PriceTypeDescriptionFr_LTE?: number | null;
  PriceTypeDescriptionFr_SHORTEST_EQUAL?: number | null;
  PriceTypeDescriptionFr_SHORTEST_GT?: number | null;
  PriceTypeDescriptionFr_SHORTEST_GTE?: number | null;
  PriceTypeDescriptionFr_SHORTEST_LT?: number | null;
  PriceTypeDescriptionFr_SHORTEST_LTE?: number | null;
  PriceTypeDescriptionIt_AVERAGE_EQUAL?: number | null;
  PriceTypeDescriptionIt_AVERAGE_GT?: number | null;
  PriceTypeDescriptionIt_AVERAGE_GTE?: number | null;
  PriceTypeDescriptionIt_AVERAGE_LT?: number | null;
  PriceTypeDescriptionIt_AVERAGE_LTE?: number | null;
  PriceTypeDescriptionIt_EQUAL?: string | null;
  PriceTypeDescriptionIt_GT?: number | null;
  PriceTypeDescriptionIt_GTE?: number | null;
  PriceTypeDescriptionIt_LONGEST_EQUAL?: number | null;
  PriceTypeDescriptionIt_LONGEST_GT?: number | null;
  PriceTypeDescriptionIt_LONGEST_GTE?: number | null;
  PriceTypeDescriptionIt_LONGEST_LT?: number | null;
  PriceTypeDescriptionIt_LONGEST_LTE?: number | null;
  PriceTypeDescriptionIt_LT?: number | null;
  PriceTypeDescriptionIt_LTE?: number | null;
  PriceTypeDescriptionIt_SHORTEST_EQUAL?: number | null;
  PriceTypeDescriptionIt_SHORTEST_GT?: number | null;
  PriceTypeDescriptionIt_SHORTEST_GTE?: number | null;
  PriceTypeDescriptionIt_SHORTEST_LT?: number | null;
  PriceTypeDescriptionIt_SHORTEST_LTE?: number | null;
  Price_AVERAGE_EQUAL?: number | null;
  Price_AVERAGE_GT?: number | null;
  Price_AVERAGE_GTE?: number | null;
  Price_AVERAGE_LT?: number | null;
  Price_AVERAGE_LTE?: number | null;
  Price_EQUAL?: string | null;
  Price_GT?: number | null;
  Price_GTE?: number | null;
  Price_LONGEST_EQUAL?: number | null;
  Price_LONGEST_GT?: number | null;
  Price_LONGEST_GTE?: number | null;
  Price_LONGEST_LT?: number | null;
  Price_LONGEST_LTE?: number | null;
  Price_LT?: number | null;
  Price_LTE?: number | null;
  Price_SHORTEST_EQUAL?: number | null;
  Price_SHORTEST_GT?: number | null;
  Price_SHORTEST_GTE?: number | null;
  Price_SHORTEST_LT?: number | null;
  Price_SHORTEST_LTE?: number | null;
  uniqueCode_AVERAGE_EQUAL?: number | null;
  uniqueCode_AVERAGE_GT?: number | null;
  uniqueCode_AVERAGE_GTE?: number | null;
  uniqueCode_AVERAGE_LT?: number | null;
  uniqueCode_AVERAGE_LTE?: number | null;
  uniqueCode_EQUAL?: string | null;
  uniqueCode_GT?: number | null;
  uniqueCode_GTE?: number | null;
  uniqueCode_LONGEST_EQUAL?: number | null;
  uniqueCode_LONGEST_GT?: number | null;
  uniqueCode_LONGEST_GTE?: number | null;
  uniqueCode_LONGEST_LT?: number | null;
  uniqueCode_LONGEST_LTE?: number | null;
  uniqueCode_LT?: number | null;
  uniqueCode_LTE?: number | null;
  uniqueCode_SHORTEST_EQUAL?: number | null;
  uniqueCode_SHORTEST_GT?: number | null;
  uniqueCode_SHORTEST_GTE?: number | null;
  uniqueCode_SHORTEST_LT?: number | null;
  uniqueCode_SHORTEST_LTE?: number | null;
}

export interface TreatmentRegulatedByAggregateInput {
  AND?: TreatmentRegulatedByAggregateInput[] | null;
  OR?: TreatmentRegulatedByAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: TreatmentRegulatedByNodeAggregationWhereInput | null;
}

export interface TreatmentRegulatedByConnectionWhere {
  AND?: TreatmentRegulatedByConnectionWhere[] | null;
  OR?: TreatmentRegulatedByConnectionWhere[] | null;
  node?: PreparationWhere | null;
  node_NOT?: PreparationWhere | null;
}

export interface TreatmentRegulatedByNodeAggregationWhereInput {
  AND?: TreatmentRegulatedByNodeAggregationWhereInput[] | null;
  AtcCode_AVERAGE_EQUAL?: number | null;
  AtcCode_AVERAGE_GT?: number | null;
  AtcCode_AVERAGE_GTE?: number | null;
  AtcCode_AVERAGE_LT?: number | null;
  AtcCode_AVERAGE_LTE?: number | null;
  AtcCode_EQUAL?: string | null;
  AtcCode_GT?: number | null;
  AtcCode_GTE?: number | null;
  AtcCode_LONGEST_EQUAL?: number | null;
  AtcCode_LONGEST_GT?: number | null;
  AtcCode_LONGEST_GTE?: number | null;
  AtcCode_LONGEST_LT?: number | null;
  AtcCode_LONGEST_LTE?: number | null;
  AtcCode_LT?: number | null;
  AtcCode_LTE?: number | null;
  AtcCode_SHORTEST_EQUAL?: number | null;
  AtcCode_SHORTEST_GT?: number | null;
  AtcCode_SHORTEST_GTE?: number | null;
  AtcCode_SHORTEST_LT?: number | null;
  AtcCode_SHORTEST_LTE?: number | null;
  BrandName_AVERAGE_EQUAL?: number | null;
  BrandName_AVERAGE_GT?: number | null;
  BrandName_AVERAGE_GTE?: number | null;
  BrandName_AVERAGE_LT?: number | null;
  BrandName_AVERAGE_LTE?: number | null;
  BrandName_EQUAL?: string | null;
  BrandName_GT?: number | null;
  BrandName_GTE?: number | null;
  BrandName_LONGEST_EQUAL?: number | null;
  BrandName_LONGEST_GT?: number | null;
  BrandName_LONGEST_GTE?: number | null;
  BrandName_LONGEST_LT?: number | null;
  BrandName_LONGEST_LTE?: number | null;
  BrandName_LT?: number | null;
  BrandName_LTE?: number | null;
  BrandName_SHORTEST_EQUAL?: number | null;
  BrandName_SHORTEST_GT?: number | null;
  BrandName_SHORTEST_GTE?: number | null;
  BrandName_SHORTEST_LT?: number | null;
  BrandName_SHORTEST_LTE?: number | null;
  DescriptionDe_AVERAGE_EQUAL?: number | null;
  DescriptionDe_AVERAGE_GT?: number | null;
  DescriptionDe_AVERAGE_GTE?: number | null;
  DescriptionDe_AVERAGE_LT?: number | null;
  DescriptionDe_AVERAGE_LTE?: number | null;
  DescriptionDe_EQUAL?: string | null;
  DescriptionDe_GT?: number | null;
  DescriptionDe_GTE?: number | null;
  DescriptionDe_LONGEST_EQUAL?: number | null;
  DescriptionDe_LONGEST_GT?: number | null;
  DescriptionDe_LONGEST_GTE?: number | null;
  DescriptionDe_LONGEST_LT?: number | null;
  DescriptionDe_LONGEST_LTE?: number | null;
  DescriptionDe_LT?: number | null;
  DescriptionDe_LTE?: number | null;
  DescriptionDe_SHORTEST_EQUAL?: number | null;
  DescriptionDe_SHORTEST_GT?: number | null;
  DescriptionDe_SHORTEST_GTE?: number | null;
  DescriptionDe_SHORTEST_LT?: number | null;
  DescriptionDe_SHORTEST_LTE?: number | null;
  DescriptionFr_AVERAGE_EQUAL?: number | null;
  DescriptionFr_AVERAGE_GT?: number | null;
  DescriptionFr_AVERAGE_GTE?: number | null;
  DescriptionFr_AVERAGE_LT?: number | null;
  DescriptionFr_AVERAGE_LTE?: number | null;
  DescriptionFr_EQUAL?: string | null;
  DescriptionFr_GT?: number | null;
  DescriptionFr_GTE?: number | null;
  DescriptionFr_LONGEST_EQUAL?: number | null;
  DescriptionFr_LONGEST_GT?: number | null;
  DescriptionFr_LONGEST_GTE?: number | null;
  DescriptionFr_LONGEST_LT?: number | null;
  DescriptionFr_LONGEST_LTE?: number | null;
  DescriptionFr_LT?: number | null;
  DescriptionFr_LTE?: number | null;
  DescriptionFr_SHORTEST_EQUAL?: number | null;
  DescriptionFr_SHORTEST_GT?: number | null;
  DescriptionFr_SHORTEST_GTE?: number | null;
  DescriptionFr_SHORTEST_LT?: number | null;
  DescriptionFr_SHORTEST_LTE?: number | null;
  DescriptionIt_AVERAGE_EQUAL?: number | null;
  DescriptionIt_AVERAGE_GT?: number | null;
  DescriptionIt_AVERAGE_GTE?: number | null;
  DescriptionIt_AVERAGE_LT?: number | null;
  DescriptionIt_AVERAGE_LTE?: number | null;
  DescriptionIt_EQUAL?: string | null;
  DescriptionIt_GT?: number | null;
  DescriptionIt_GTE?: number | null;
  DescriptionIt_LONGEST_EQUAL?: number | null;
  DescriptionIt_LONGEST_GT?: number | null;
  DescriptionIt_LONGEST_GTE?: number | null;
  DescriptionIt_LONGEST_LT?: number | null;
  DescriptionIt_LONGEST_LTE?: number | null;
  DescriptionIt_LT?: number | null;
  DescriptionIt_LTE?: number | null;
  DescriptionIt_SHORTEST_EQUAL?: number | null;
  DescriptionIt_SHORTEST_GT?: number | null;
  DescriptionIt_SHORTEST_GTE?: number | null;
  DescriptionIt_SHORTEST_LT?: number | null;
  DescriptionIt_SHORTEST_LTE?: number | null;
  GenericName_AVERAGE_EQUAL?: number | null;
  GenericName_AVERAGE_GT?: number | null;
  GenericName_AVERAGE_GTE?: number | null;
  GenericName_AVERAGE_LT?: number | null;
  GenericName_AVERAGE_LTE?: number | null;
  GenericName_EQUAL?: string | null;
  GenericName_GT?: number | null;
  GenericName_GTE?: number | null;
  GenericName_LONGEST_EQUAL?: number | null;
  GenericName_LONGEST_GT?: number | null;
  GenericName_LONGEST_GTE?: number | null;
  GenericName_LONGEST_LT?: number | null;
  GenericName_LONGEST_LTE?: number | null;
  GenericName_LT?: number | null;
  GenericName_LTE?: number | null;
  GenericName_SHORTEST_EQUAL?: number | null;
  GenericName_SHORTEST_GT?: number | null;
  GenericName_SHORTEST_GTE?: number | null;
  GenericName_SHORTEST_LT?: number | null;
  GenericName_SHORTEST_LTE?: number | null;
  OR?: TreatmentRegulatedByNodeAggregationWhereInput[] | null;
  SwissmedicNo5_AVERAGE_EQUAL?: number | null;
  SwissmedicNo5_AVERAGE_GT?: number | null;
  SwissmedicNo5_AVERAGE_GTE?: number | null;
  SwissmedicNo5_AVERAGE_LT?: number | null;
  SwissmedicNo5_AVERAGE_LTE?: number | null;
  SwissmedicNo5_EQUAL?: string | null;
  SwissmedicNo5_GT?: number | null;
  SwissmedicNo5_GTE?: number | null;
  SwissmedicNo5_LONGEST_EQUAL?: number | null;
  SwissmedicNo5_LONGEST_GT?: number | null;
  SwissmedicNo5_LONGEST_GTE?: number | null;
  SwissmedicNo5_LONGEST_LT?: number | null;
  SwissmedicNo5_LONGEST_LTE?: number | null;
  SwissmedicNo5_LT?: number | null;
  SwissmedicNo5_LTE?: number | null;
  SwissmedicNo5_SHORTEST_EQUAL?: number | null;
  SwissmedicNo5_SHORTEST_GT?: number | null;
  SwissmedicNo5_SHORTEST_GTE?: number | null;
  SwissmedicNo5_SHORTEST_LT?: number | null;
  SwissmedicNo5_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
}

export interface TreatmentSetGenericAggregateInput {
  AND?: TreatmentSetGenericAggregateInput[] | null;
  OR?: TreatmentSetGenericAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: TreatmentSetGenericNodeAggregationWhereInput | null;
}

export interface TreatmentSetGenericConnectionWhere {
  AND?: TreatmentSetGenericConnectionWhere[] | null;
  OR?: TreatmentSetGenericConnectionWhere[] | null;
  node?: GenericWhere | null;
  node_NOT?: GenericWhere | null;
}

export interface TreatmentSetGenericNodeAggregationWhereInput {
  AND?: TreatmentSetGenericNodeAggregationWhereInput[] | null;
  Name_AVERAGE_EQUAL?: number | null;
  Name_AVERAGE_GT?: number | null;
  Name_AVERAGE_GTE?: number | null;
  Name_AVERAGE_LT?: number | null;
  Name_AVERAGE_LTE?: number | null;
  Name_EQUAL?: string | null;
  Name_GT?: number | null;
  Name_GTE?: number | null;
  Name_LONGEST_EQUAL?: number | null;
  Name_LONGEST_GT?: number | null;
  Name_LONGEST_GTE?: number | null;
  Name_LONGEST_LT?: number | null;
  Name_LONGEST_LTE?: number | null;
  Name_LT?: number | null;
  Name_LTE?: number | null;
  Name_SHORTEST_EQUAL?: number | null;
  Name_SHORTEST_GT?: number | null;
  Name_SHORTEST_GTE?: number | null;
  Name_SHORTEST_LT?: number | null;
  Name_SHORTEST_LTE?: number | null;
  OR?: TreatmentSetGenericNodeAggregationWhereInput[] | null;
  id_EQUAL?: string | null;
}

export interface TreatmentSetPreparationsAggregateInput {
  AND?: TreatmentSetPreparationsAggregateInput[] | null;
  OR?: TreatmentSetPreparationsAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: TreatmentSetPreparationsNodeAggregationWhereInput | null;
}

export interface TreatmentSetPreparationsConnectionWhere {
  AND?: TreatmentSetPreparationsConnectionWhere[] | null;
  OR?: TreatmentSetPreparationsConnectionWhere[] | null;
  node?: PreparationWhere | null;
  node_NOT?: PreparationWhere | null;
}

export interface TreatmentSetPreparationsNodeAggregationWhereInput {
  AND?: TreatmentSetPreparationsNodeAggregationWhereInput[] | null;
  AtcCode_AVERAGE_EQUAL?: number | null;
  AtcCode_AVERAGE_GT?: number | null;
  AtcCode_AVERAGE_GTE?: number | null;
  AtcCode_AVERAGE_LT?: number | null;
  AtcCode_AVERAGE_LTE?: number | null;
  AtcCode_EQUAL?: string | null;
  AtcCode_GT?: number | null;
  AtcCode_GTE?: number | null;
  AtcCode_LONGEST_EQUAL?: number | null;
  AtcCode_LONGEST_GT?: number | null;
  AtcCode_LONGEST_GTE?: number | null;
  AtcCode_LONGEST_LT?: number | null;
  AtcCode_LONGEST_LTE?: number | null;
  AtcCode_LT?: number | null;
  AtcCode_LTE?: number | null;
  AtcCode_SHORTEST_EQUAL?: number | null;
  AtcCode_SHORTEST_GT?: number | null;
  AtcCode_SHORTEST_GTE?: number | null;
  AtcCode_SHORTEST_LT?: number | null;
  AtcCode_SHORTEST_LTE?: number | null;
  BrandName_AVERAGE_EQUAL?: number | null;
  BrandName_AVERAGE_GT?: number | null;
  BrandName_AVERAGE_GTE?: number | null;
  BrandName_AVERAGE_LT?: number | null;
  BrandName_AVERAGE_LTE?: number | null;
  BrandName_EQUAL?: string | null;
  BrandName_GT?: number | null;
  BrandName_GTE?: number | null;
  BrandName_LONGEST_EQUAL?: number | null;
  BrandName_LONGEST_GT?: number | null;
  BrandName_LONGEST_GTE?: number | null;
  BrandName_LONGEST_LT?: number | null;
  BrandName_LONGEST_LTE?: number | null;
  BrandName_LT?: number | null;
  BrandName_LTE?: number | null;
  BrandName_SHORTEST_EQUAL?: number | null;
  BrandName_SHORTEST_GT?: number | null;
  BrandName_SHORTEST_GTE?: number | null;
  BrandName_SHORTEST_LT?: number | null;
  BrandName_SHORTEST_LTE?: number | null;
  DescriptionDe_AVERAGE_EQUAL?: number | null;
  DescriptionDe_AVERAGE_GT?: number | null;
  DescriptionDe_AVERAGE_GTE?: number | null;
  DescriptionDe_AVERAGE_LT?: number | null;
  DescriptionDe_AVERAGE_LTE?: number | null;
  DescriptionDe_EQUAL?: string | null;
  DescriptionDe_GT?: number | null;
  DescriptionDe_GTE?: number | null;
  DescriptionDe_LONGEST_EQUAL?: number | null;
  DescriptionDe_LONGEST_GT?: number | null;
  DescriptionDe_LONGEST_GTE?: number | null;
  DescriptionDe_LONGEST_LT?: number | null;
  DescriptionDe_LONGEST_LTE?: number | null;
  DescriptionDe_LT?: number | null;
  DescriptionDe_LTE?: number | null;
  DescriptionDe_SHORTEST_EQUAL?: number | null;
  DescriptionDe_SHORTEST_GT?: number | null;
  DescriptionDe_SHORTEST_GTE?: number | null;
  DescriptionDe_SHORTEST_LT?: number | null;
  DescriptionDe_SHORTEST_LTE?: number | null;
  DescriptionFr_AVERAGE_EQUAL?: number | null;
  DescriptionFr_AVERAGE_GT?: number | null;
  DescriptionFr_AVERAGE_GTE?: number | null;
  DescriptionFr_AVERAGE_LT?: number | null;
  DescriptionFr_AVERAGE_LTE?: number | null;
  DescriptionFr_EQUAL?: string | null;
  DescriptionFr_GT?: number | null;
  DescriptionFr_GTE?: number | null;
  DescriptionFr_LONGEST_EQUAL?: number | null;
  DescriptionFr_LONGEST_GT?: number | null;
  DescriptionFr_LONGEST_GTE?: number | null;
  DescriptionFr_LONGEST_LT?: number | null;
  DescriptionFr_LONGEST_LTE?: number | null;
  DescriptionFr_LT?: number | null;
  DescriptionFr_LTE?: number | null;
  DescriptionFr_SHORTEST_EQUAL?: number | null;
  DescriptionFr_SHORTEST_GT?: number | null;
  DescriptionFr_SHORTEST_GTE?: number | null;
  DescriptionFr_SHORTEST_LT?: number | null;
  DescriptionFr_SHORTEST_LTE?: number | null;
  DescriptionIt_AVERAGE_EQUAL?: number | null;
  DescriptionIt_AVERAGE_GT?: number | null;
  DescriptionIt_AVERAGE_GTE?: number | null;
  DescriptionIt_AVERAGE_LT?: number | null;
  DescriptionIt_AVERAGE_LTE?: number | null;
  DescriptionIt_EQUAL?: string | null;
  DescriptionIt_GT?: number | null;
  DescriptionIt_GTE?: number | null;
  DescriptionIt_LONGEST_EQUAL?: number | null;
  DescriptionIt_LONGEST_GT?: number | null;
  DescriptionIt_LONGEST_GTE?: number | null;
  DescriptionIt_LONGEST_LT?: number | null;
  DescriptionIt_LONGEST_LTE?: number | null;
  DescriptionIt_LT?: number | null;
  DescriptionIt_LTE?: number | null;
  DescriptionIt_SHORTEST_EQUAL?: number | null;
  DescriptionIt_SHORTEST_GT?: number | null;
  DescriptionIt_SHORTEST_GTE?: number | null;
  DescriptionIt_SHORTEST_LT?: number | null;
  DescriptionIt_SHORTEST_LTE?: number | null;
  GenericName_AVERAGE_EQUAL?: number | null;
  GenericName_AVERAGE_GT?: number | null;
  GenericName_AVERAGE_GTE?: number | null;
  GenericName_AVERAGE_LT?: number | null;
  GenericName_AVERAGE_LTE?: number | null;
  GenericName_EQUAL?: string | null;
  GenericName_GT?: number | null;
  GenericName_GTE?: number | null;
  GenericName_LONGEST_EQUAL?: number | null;
  GenericName_LONGEST_GT?: number | null;
  GenericName_LONGEST_GTE?: number | null;
  GenericName_LONGEST_LT?: number | null;
  GenericName_LONGEST_LTE?: number | null;
  GenericName_LT?: number | null;
  GenericName_LTE?: number | null;
  GenericName_SHORTEST_EQUAL?: number | null;
  GenericName_SHORTEST_GT?: number | null;
  GenericName_SHORTEST_GTE?: number | null;
  GenericName_SHORTEST_LT?: number | null;
  GenericName_SHORTEST_LTE?: number | null;
  OR?: TreatmentSetPreparationsNodeAggregationWhereInput[] | null;
  SwissmedicNo5_AVERAGE_EQUAL?: number | null;
  SwissmedicNo5_AVERAGE_GT?: number | null;
  SwissmedicNo5_AVERAGE_GTE?: number | null;
  SwissmedicNo5_AVERAGE_LT?: number | null;
  SwissmedicNo5_AVERAGE_LTE?: number | null;
  SwissmedicNo5_EQUAL?: string | null;
  SwissmedicNo5_GT?: number | null;
  SwissmedicNo5_GTE?: number | null;
  SwissmedicNo5_LONGEST_EQUAL?: number | null;
  SwissmedicNo5_LONGEST_GT?: number | null;
  SwissmedicNo5_LONGEST_GTE?: number | null;
  SwissmedicNo5_LONGEST_LT?: number | null;
  SwissmedicNo5_LONGEST_LTE?: number | null;
  SwissmedicNo5_LT?: number | null;
  SwissmedicNo5_LTE?: number | null;
  SwissmedicNo5_SHORTEST_EQUAL?: number | null;
  SwissmedicNo5_SHORTEST_GT?: number | null;
  SwissmedicNo5_SHORTEST_GTE?: number | null;
  SwissmedicNo5_SHORTEST_LT?: number | null;
  SwissmedicNo5_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
}

export interface TreatmentSetScopeAggregateInput {
  AND?: TreatmentSetScopeAggregateInput[] | null;
  OR?: TreatmentSetScopeAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: TreatmentSetScopeNodeAggregationWhereInput | null;
}

export interface TreatmentSetScopeConnectionWhere {
  AND?: TreatmentSetScopeConnectionWhere[] | null;
  OR?: TreatmentSetScopeConnectionWhere[] | null;
  node?: AgreementScopeWhere | null;
  node_NOT?: AgreementScopeWhere | null;
}

export interface TreatmentSetScopeNodeAggregationWhereInput {
  AND?: TreatmentSetScopeNodeAggregationWhereInput[] | null;
  OR?: TreatmentSetScopeNodeAggregationWhereInput[] | null;
  code_AVERAGE_EQUAL?: number | null;
  code_AVERAGE_GT?: number | null;
  code_AVERAGE_GTE?: number | null;
  code_AVERAGE_LT?: number | null;
  code_AVERAGE_LTE?: number | null;
  code_EQUAL?: string | null;
  code_GT?: number | null;
  code_GTE?: number | null;
  code_LONGEST_EQUAL?: number | null;
  code_LONGEST_GT?: number | null;
  code_LONGEST_GTE?: number | null;
  code_LONGEST_LT?: number | null;
  code_LONGEST_LTE?: number | null;
  code_LT?: number | null;
  code_LTE?: number | null;
  code_SHORTEST_EQUAL?: number | null;
  code_SHORTEST_GT?: number | null;
  code_SHORTEST_GTE?: number | null;
  code_SHORTEST_LT?: number | null;
  code_SHORTEST_LTE?: number | null;
  order_AVERAGE_EQUAL?: number | null;
  order_AVERAGE_GT?: number | null;
  order_AVERAGE_GTE?: number | null;
  order_AVERAGE_LT?: number | null;
  order_AVERAGE_LTE?: number | null;
  order_EQUAL?: number | null;
  order_GT?: number | null;
  order_GTE?: number | null;
  order_LT?: number | null;
  order_LTE?: number | null;
  order_MAX_EQUAL?: number | null;
  order_MAX_GT?: number | null;
  order_MAX_GTE?: number | null;
  order_MAX_LT?: number | null;
  order_MAX_LTE?: number | null;
  order_MIN_EQUAL?: number | null;
  order_MIN_GT?: number | null;
  order_MIN_GTE?: number | null;
  order_MIN_LT?: number | null;
  order_MIN_LTE?: number | null;
  order_SUM_EQUAL?: number | null;
  order_SUM_GT?: number | null;
  order_SUM_GTE?: number | null;
  order_SUM_LT?: number | null;
  order_SUM_LTE?: number | null;
  scopeId_AVERAGE_EQUAL?: number | null;
  scopeId_AVERAGE_GT?: number | null;
  scopeId_AVERAGE_GTE?: number | null;
  scopeId_AVERAGE_LT?: number | null;
  scopeId_AVERAGE_LTE?: number | null;
  scopeId_EQUAL?: string | null;
  scopeId_GT?: number | null;
  scopeId_GTE?: number | null;
  scopeId_LONGEST_EQUAL?: number | null;
  scopeId_LONGEST_GT?: number | null;
  scopeId_LONGEST_GTE?: number | null;
  scopeId_LONGEST_LT?: number | null;
  scopeId_LONGEST_LTE?: number | null;
  scopeId_LT?: number | null;
  scopeId_LTE?: number | null;
  scopeId_SHORTEST_EQUAL?: number | null;
  scopeId_SHORTEST_GT?: number | null;
  scopeId_SHORTEST_GTE?: number | null;
  scopeId_SHORTEST_LT?: number | null;
  scopeId_SHORTEST_LTE?: number | null;
}

export interface TreatmentSetTreatmentsAggregateInput {
  AND?: TreatmentSetTreatmentsAggregateInput[] | null;
  OR?: TreatmentSetTreatmentsAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: TreatmentSetTreatmentsNodeAggregationWhereInput | null;
}

export interface TreatmentSetTreatmentsConnectionWhere {
  AND?: TreatmentSetTreatmentsConnectionWhere[] | null;
  OR?: TreatmentSetTreatmentsConnectionWhere[] | null;
  node?: TreatmentWhere | null;
  node_NOT?: TreatmentWhere | null;
}

export interface TreatmentSetTreatmentsNodeAggregationWhereInput {
  AND?: TreatmentSetTreatmentsNodeAggregationWhereInput[] | null;
  BagDossierNo_AVERAGE_EQUAL?: number | null;
  BagDossierNo_AVERAGE_GT?: number | null;
  BagDossierNo_AVERAGE_GTE?: number | null;
  BagDossierNo_AVERAGE_LT?: number | null;
  BagDossierNo_AVERAGE_LTE?: number | null;
  BagDossierNo_EQUAL?: string | null;
  BagDossierNo_GT?: number | null;
  BagDossierNo_GTE?: number | null;
  BagDossierNo_LONGEST_EQUAL?: number | null;
  BagDossierNo_LONGEST_GT?: number | null;
  BagDossierNo_LONGEST_GTE?: number | null;
  BagDossierNo_LONGEST_LT?: number | null;
  BagDossierNo_LONGEST_LTE?: number | null;
  BagDossierNo_LT?: number | null;
  BagDossierNo_LTE?: number | null;
  BagDossierNo_SHORTEST_EQUAL?: number | null;
  BagDossierNo_SHORTEST_GT?: number | null;
  BagDossierNo_SHORTEST_GTE?: number | null;
  BagDossierNo_SHORTEST_LT?: number | null;
  BagDossierNo_SHORTEST_LTE?: number | null;
  Code_AVERAGE_EQUAL?: number | null;
  Code_AVERAGE_GT?: number | null;
  Code_AVERAGE_GTE?: number | null;
  Code_AVERAGE_LT?: number | null;
  Code_AVERAGE_LTE?: number | null;
  Code_EQUAL?: string | null;
  Code_GT?: number | null;
  Code_GTE?: number | null;
  Code_LONGEST_EQUAL?: number | null;
  Code_LONGEST_GT?: number | null;
  Code_LONGEST_GTE?: number | null;
  Code_LONGEST_LT?: number | null;
  Code_LONGEST_LTE?: number | null;
  Code_LT?: number | null;
  Code_LTE?: number | null;
  Code_SHORTEST_EQUAL?: number | null;
  Code_SHORTEST_GT?: number | null;
  Code_SHORTEST_GTE?: number | null;
  Code_SHORTEST_LT?: number | null;
  Code_SHORTEST_LTE?: number | null;
  FlagModal_AVERAGE_EQUAL?: number | null;
  FlagModal_AVERAGE_GT?: number | null;
  FlagModal_AVERAGE_GTE?: number | null;
  FlagModal_AVERAGE_LT?: number | null;
  FlagModal_AVERAGE_LTE?: number | null;
  FlagModal_EQUAL?: string | null;
  FlagModal_GT?: number | null;
  FlagModal_GTE?: number | null;
  FlagModal_LONGEST_EQUAL?: number | null;
  FlagModal_LONGEST_GT?: number | null;
  FlagModal_LONGEST_GTE?: number | null;
  FlagModal_LONGEST_LT?: number | null;
  FlagModal_LONGEST_LTE?: number | null;
  FlagModal_LT?: number | null;
  FlagModal_LTE?: number | null;
  FlagModal_SHORTEST_EQUAL?: number | null;
  FlagModal_SHORTEST_GT?: number | null;
  FlagModal_SHORTEST_GTE?: number | null;
  FlagModal_SHORTEST_LT?: number | null;
  FlagModal_SHORTEST_LTE?: number | null;
  FlagNarcosis_AVERAGE_EQUAL?: number | null;
  FlagNarcosis_AVERAGE_GT?: number | null;
  FlagNarcosis_AVERAGE_GTE?: number | null;
  FlagNarcosis_AVERAGE_LT?: number | null;
  FlagNarcosis_AVERAGE_LTE?: number | null;
  FlagNarcosis_EQUAL?: string | null;
  FlagNarcosis_GT?: number | null;
  FlagNarcosis_GTE?: number | null;
  FlagNarcosis_LONGEST_EQUAL?: number | null;
  FlagNarcosis_LONGEST_GT?: number | null;
  FlagNarcosis_LONGEST_GTE?: number | null;
  FlagNarcosis_LONGEST_LT?: number | null;
  FlagNarcosis_LONGEST_LTE?: number | null;
  FlagNarcosis_LT?: number | null;
  FlagNarcosis_LTE?: number | null;
  FlagNarcosis_SHORTEST_EQUAL?: number | null;
  FlagNarcosis_SHORTEST_GT?: number | null;
  FlagNarcosis_SHORTEST_GTE?: number | null;
  FlagNarcosis_SHORTEST_LT?: number | null;
  FlagNarcosis_SHORTEST_LTE?: number | null;
  GTIN_AVERAGE_EQUAL?: number | null;
  GTIN_AVERAGE_GT?: number | null;
  GTIN_AVERAGE_GTE?: number | null;
  GTIN_AVERAGE_LT?: number | null;
  GTIN_AVERAGE_LTE?: number | null;
  GTIN_EQUAL?: string | null;
  GTIN_GT?: number | null;
  GTIN_GTE?: number | null;
  GTIN_LONGEST_EQUAL?: number | null;
  GTIN_LONGEST_GT?: number | null;
  GTIN_LONGEST_GTE?: number | null;
  GTIN_LONGEST_LT?: number | null;
  GTIN_LONGEST_LTE?: number | null;
  GTIN_LT?: number | null;
  GTIN_LTE?: number | null;
  GTIN_SHORTEST_EQUAL?: number | null;
  GTIN_SHORTEST_GT?: number | null;
  GTIN_SHORTEST_GTE?: number | null;
  GTIN_SHORTEST_LT?: number | null;
  GTIN_SHORTEST_LTE?: number | null;
  LOT_AVERAGE_EQUAL?: number | null;
  LOT_AVERAGE_GT?: number | null;
  LOT_AVERAGE_GTE?: number | null;
  LOT_AVERAGE_LT?: number | null;
  LOT_AVERAGE_LTE?: number | null;
  LOT_EQUAL?: string | null;
  LOT_GT?: number | null;
  LOT_GTE?: number | null;
  LOT_LONGEST_EQUAL?: number | null;
  LOT_LONGEST_GT?: number | null;
  LOT_LONGEST_GTE?: number | null;
  LOT_LONGEST_LT?: number | null;
  LOT_LONGEST_LTE?: number | null;
  LOT_LT?: number | null;
  LOT_LTE?: number | null;
  LOT_SHORTEST_EQUAL?: number | null;
  LOT_SHORTEST_GT?: number | null;
  LOT_SHORTEST_GTE?: number | null;
  LOT_SHORTEST_LT?: number | null;
  LOT_SHORTEST_LTE?: number | null;
  Name_AVERAGE_EQUAL?: number | null;
  Name_AVERAGE_GT?: number | null;
  Name_AVERAGE_GTE?: number | null;
  Name_AVERAGE_LT?: number | null;
  Name_AVERAGE_LTE?: number | null;
  Name_EQUAL?: string | null;
  Name_GT?: number | null;
  Name_GTE?: number | null;
  Name_LONGEST_EQUAL?: number | null;
  Name_LONGEST_GT?: number | null;
  Name_LONGEST_GTE?: number | null;
  Name_LONGEST_LT?: number | null;
  Name_LONGEST_LTE?: number | null;
  Name_LT?: number | null;
  Name_LTE?: number | null;
  Name_SHORTEST_EQUAL?: number | null;
  Name_SHORTEST_GT?: number | null;
  Name_SHORTEST_GTE?: number | null;
  Name_SHORTEST_LT?: number | null;
  Name_SHORTEST_LTE?: number | null;
  OR?: TreatmentSetTreatmentsNodeAggregationWhereInput[] | null;
  PharmaCode_AVERAGE_EQUAL?: number | null;
  PharmaCode_AVERAGE_GT?: number | null;
  PharmaCode_AVERAGE_GTE?: number | null;
  PharmaCode_AVERAGE_LT?: number | null;
  PharmaCode_AVERAGE_LTE?: number | null;
  PharmaCode_EQUAL?: string | null;
  PharmaCode_GT?: number | null;
  PharmaCode_GTE?: number | null;
  PharmaCode_LONGEST_EQUAL?: number | null;
  PharmaCode_LONGEST_GT?: number | null;
  PharmaCode_LONGEST_GTE?: number | null;
  PharmaCode_LONGEST_LT?: number | null;
  PharmaCode_LONGEST_LTE?: number | null;
  PharmaCode_LT?: number | null;
  PharmaCode_LTE?: number | null;
  PharmaCode_SHORTEST_EQUAL?: number | null;
  PharmaCode_SHORTEST_GT?: number | null;
  PharmaCode_SHORTEST_GTE?: number | null;
  PharmaCode_SHORTEST_LT?: number | null;
  PharmaCode_SHORTEST_LTE?: number | null;
  PrevPharmacode_AVERAGE_EQUAL?: number | null;
  PrevPharmacode_AVERAGE_GT?: number | null;
  PrevPharmacode_AVERAGE_GTE?: number | null;
  PrevPharmacode_AVERAGE_LT?: number | null;
  PrevPharmacode_AVERAGE_LTE?: number | null;
  PrevPharmacode_EQUAL?: string | null;
  PrevPharmacode_GT?: number | null;
  PrevPharmacode_GTE?: number | null;
  PrevPharmacode_LONGEST_EQUAL?: number | null;
  PrevPharmacode_LONGEST_GT?: number | null;
  PrevPharmacode_LONGEST_GTE?: number | null;
  PrevPharmacode_LONGEST_LT?: number | null;
  PrevPharmacode_LONGEST_LTE?: number | null;
  PrevPharmacode_LT?: number | null;
  PrevPharmacode_LTE?: number | null;
  PrevPharmacode_SHORTEST_EQUAL?: number | null;
  PrevPharmacode_SHORTEST_GT?: number | null;
  PrevPharmacode_SHORTEST_GTE?: number | null;
  PrevPharmacode_SHORTEST_LT?: number | null;
  PrevPharmacode_SHORTEST_LTE?: number | null;
  REF_AVERAGE_EQUAL?: number | null;
  REF_AVERAGE_GT?: number | null;
  REF_AVERAGE_GTE?: number | null;
  REF_AVERAGE_LT?: number | null;
  REF_AVERAGE_LTE?: number | null;
  REF_EQUAL?: string | null;
  REF_GT?: number | null;
  REF_GTE?: number | null;
  REF_LONGEST_EQUAL?: number | null;
  REF_LONGEST_GT?: number | null;
  REF_LONGEST_GTE?: number | null;
  REF_LONGEST_LT?: number | null;
  REF_LONGEST_LTE?: number | null;
  REF_LT?: number | null;
  REF_LTE?: number | null;
  REF_SHORTEST_EQUAL?: number | null;
  REF_SHORTEST_GT?: number | null;
  REF_SHORTEST_GTE?: number | null;
  REF_SHORTEST_LT?: number | null;
  REF_SHORTEST_LTE?: number | null;
  SwissmedicCategory_AVERAGE_EQUAL?: number | null;
  SwissmedicCategory_AVERAGE_GT?: number | null;
  SwissmedicCategory_AVERAGE_GTE?: number | null;
  SwissmedicCategory_AVERAGE_LT?: number | null;
  SwissmedicCategory_AVERAGE_LTE?: number | null;
  SwissmedicCategory_EQUAL?: string | null;
  SwissmedicCategory_GT?: number | null;
  SwissmedicCategory_GTE?: number | null;
  SwissmedicCategory_LONGEST_EQUAL?: number | null;
  SwissmedicCategory_LONGEST_GT?: number | null;
  SwissmedicCategory_LONGEST_GTE?: number | null;
  SwissmedicCategory_LONGEST_LT?: number | null;
  SwissmedicCategory_LONGEST_LTE?: number | null;
  SwissmedicCategory_LT?: number | null;
  SwissmedicCategory_LTE?: number | null;
  SwissmedicCategory_SHORTEST_EQUAL?: number | null;
  SwissmedicCategory_SHORTEST_GT?: number | null;
  SwissmedicCategory_SHORTEST_GTE?: number | null;
  SwissmedicCategory_SHORTEST_LT?: number | null;
  SwissmedicCategory_SHORTEST_LTE?: number | null;
  SwissmedicNo8_AVERAGE_EQUAL?: number | null;
  SwissmedicNo8_AVERAGE_GT?: number | null;
  SwissmedicNo8_AVERAGE_GTE?: number | null;
  SwissmedicNo8_AVERAGE_LT?: number | null;
  SwissmedicNo8_AVERAGE_LTE?: number | null;
  SwissmedicNo8_EQUAL?: string | null;
  SwissmedicNo8_GT?: number | null;
  SwissmedicNo8_GTE?: number | null;
  SwissmedicNo8_LONGEST_EQUAL?: number | null;
  SwissmedicNo8_LONGEST_GT?: number | null;
  SwissmedicNo8_LONGEST_GTE?: number | null;
  SwissmedicNo8_LONGEST_LT?: number | null;
  SwissmedicNo8_LONGEST_LTE?: number | null;
  SwissmedicNo8_LT?: number | null;
  SwissmedicNo8_LTE?: number | null;
  SwissmedicNo8_SHORTEST_EQUAL?: number | null;
  SwissmedicNo8_SHORTEST_GT?: number | null;
  SwissmedicNo8_SHORTEST_GTE?: number | null;
  SwissmedicNo8_SHORTEST_LT?: number | null;
  SwissmedicNo8_SHORTEST_LTE?: number | null;
  UDI_AVERAGE_EQUAL?: number | null;
  UDI_AVERAGE_GT?: number | null;
  UDI_AVERAGE_GTE?: number | null;
  UDI_AVERAGE_LT?: number | null;
  UDI_AVERAGE_LTE?: number | null;
  UDI_EQUAL?: string | null;
  UDI_GT?: number | null;
  UDI_GTE?: number | null;
  UDI_LONGEST_EQUAL?: number | null;
  UDI_LONGEST_GT?: number | null;
  UDI_LONGEST_GTE?: number | null;
  UDI_LONGEST_LT?: number | null;
  UDI_LONGEST_LTE?: number | null;
  UDI_LT?: number | null;
  UDI_LTE?: number | null;
  UDI_SHORTEST_EQUAL?: number | null;
  UDI_SHORTEST_GT?: number | null;
  UDI_SHORTEST_GTE?: number | null;
  UDI_SHORTEST_LT?: number | null;
  UDI_SHORTEST_LTE?: number | null;
  activeIngredientQuantity_AVERAGE_EQUAL?: number | null;
  activeIngredientQuantity_AVERAGE_GT?: number | null;
  activeIngredientQuantity_AVERAGE_GTE?: number | null;
  activeIngredientQuantity_AVERAGE_LT?: number | null;
  activeIngredientQuantity_AVERAGE_LTE?: number | null;
  activeIngredientQuantity_EQUAL?: number | null;
  activeIngredientQuantity_GT?: number | null;
  activeIngredientQuantity_GTE?: number | null;
  activeIngredientQuantity_LT?: number | null;
  activeIngredientQuantity_LTE?: number | null;
  activeIngredientQuantity_MAX_EQUAL?: number | null;
  activeIngredientQuantity_MAX_GT?: number | null;
  activeIngredientQuantity_MAX_GTE?: number | null;
  activeIngredientQuantity_MAX_LT?: number | null;
  activeIngredientQuantity_MAX_LTE?: number | null;
  activeIngredientQuantity_MIN_EQUAL?: number | null;
  activeIngredientQuantity_MIN_GT?: number | null;
  activeIngredientQuantity_MIN_GTE?: number | null;
  activeIngredientQuantity_MIN_LT?: number | null;
  activeIngredientQuantity_MIN_LTE?: number | null;
  activeIngredientQuantity_SUM_EQUAL?: number | null;
  activeIngredientQuantity_SUM_GT?: number | null;
  activeIngredientQuantity_SUM_GTE?: number | null;
  activeIngredientQuantity_SUM_LT?: number | null;
  activeIngredientQuantity_SUM_LTE?: number | null;
  classificationSystem_AVERAGE_EQUAL?: number | null;
  classificationSystem_AVERAGE_GT?: number | null;
  classificationSystem_AVERAGE_GTE?: number | null;
  classificationSystem_AVERAGE_LT?: number | null;
  classificationSystem_AVERAGE_LTE?: number | null;
  classificationSystem_EQUAL?: string | null;
  classificationSystem_GT?: number | null;
  classificationSystem_GTE?: number | null;
  classificationSystem_LONGEST_EQUAL?: number | null;
  classificationSystem_LONGEST_GT?: number | null;
  classificationSystem_LONGEST_GTE?: number | null;
  classificationSystem_LONGEST_LT?: number | null;
  classificationSystem_LONGEST_LTE?: number | null;
  classificationSystem_LT?: number | null;
  classificationSystem_LTE?: number | null;
  classificationSystem_SHORTEST_EQUAL?: number | null;
  classificationSystem_SHORTEST_GT?: number | null;
  classificationSystem_SHORTEST_GTE?: number | null;
  classificationSystem_SHORTEST_LT?: number | null;
  classificationSystem_SHORTEST_LTE?: number | null;
  concentration_AVERAGE_EQUAL?: number | null;
  concentration_AVERAGE_GT?: number | null;
  concentration_AVERAGE_GTE?: number | null;
  concentration_AVERAGE_LT?: number | null;
  concentration_AVERAGE_LTE?: number | null;
  concentration_EQUAL?: string | null;
  concentration_GT?: number | null;
  concentration_GTE?: number | null;
  concentration_LONGEST_EQUAL?: number | null;
  concentration_LONGEST_GT?: number | null;
  concentration_LONGEST_GTE?: number | null;
  concentration_LONGEST_LT?: number | null;
  concentration_LONGEST_LTE?: number | null;
  concentration_LT?: number | null;
  concentration_LTE?: number | null;
  concentration_SHORTEST_EQUAL?: number | null;
  concentration_SHORTEST_GT?: number | null;
  concentration_SHORTEST_GTE?: number | null;
  concentration_SHORTEST_LT?: number | null;
  concentration_SHORTEST_LTE?: number | null;
  packVolume_AVERAGE_EQUAL?: number | null;
  packVolume_AVERAGE_GT?: number | null;
  packVolume_AVERAGE_GTE?: number | null;
  packVolume_AVERAGE_LT?: number | null;
  packVolume_AVERAGE_LTE?: number | null;
  packVolume_EQUAL?: string | null;
  packVolume_GT?: number | null;
  packVolume_GTE?: number | null;
  packVolume_LONGEST_EQUAL?: number | null;
  packVolume_LONGEST_GT?: number | null;
  packVolume_LONGEST_GTE?: number | null;
  packVolume_LONGEST_LT?: number | null;
  packVolume_LONGEST_LTE?: number | null;
  packVolume_LT?: number | null;
  packVolume_LTE?: number | null;
  packVolume_SHORTEST_EQUAL?: number | null;
  packVolume_SHORTEST_GT?: number | null;
  packVolume_SHORTEST_GTE?: number | null;
  packVolume_SHORTEST_LT?: number | null;
  packVolume_SHORTEST_LTE?: number | null;
}

export interface TreatmentSetWhere {
  AND?: TreatmentSetWhere[] | null;
  OR?: TreatmentSetWhere[] | null;
  generic?: GenericWhere | null;
  genericAggregate?: TreatmentSetGenericAggregateInput | null;
  genericConnection?: TreatmentSetGenericConnectionWhere | null;
  genericConnection_NOT?: TreatmentSetGenericConnectionWhere | null;
  generic_NOT?: GenericWhere | null;
  isFixedPriceTarget?: boolean | null;
  isFixedPriceTarget_NOT?: boolean | null;
  order?: number | null;
  order_GT?: number | null;
  order_GTE?: number | null;
  order_IN?: (number | null)[] | null;
  order_LT?: number | null;
  order_LTE?: number | null;
  order_NOT?: number | null;
  order_NOT_IN?: (number | null)[] | null;
  preparations?: PreparationWhere | null;
  preparationsAggregate?: TreatmentSetPreparationsAggregateInput | null;
  preparationsConnection?: TreatmentSetPreparationsConnectionWhere | null;
  preparationsConnection_NOT?: TreatmentSetPreparationsConnectionWhere | null;
  preparations_NOT?: PreparationWhere | null;
  scope?: AgreementScopeWhere | null;
  scopeAggregate?: TreatmentSetScopeAggregateInput | null;
  scopeConnection?: TreatmentSetScopeConnectionWhere | null;
  scopeConnection_NOT?: TreatmentSetScopeConnectionWhere | null;
  scope_NOT?: AgreementScopeWhere | null;
  treatments?: TreatmentWhere | null;
  treatmentsAggregate?: TreatmentSetTreatmentsAggregateInput | null;
  treatmentsConnection?: TreatmentSetTreatmentsConnectionWhere | null;
  treatmentsConnection_NOT?: TreatmentSetTreatmentsConnectionWhere | null;
  treatments_NOT?: TreatmentWhere | null;
}

export interface TreatmentStatusAggregateInput {
  AND?: TreatmentStatusAggregateInput[] | null;
  OR?: TreatmentStatusAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: TreatmentStatusNodeAggregationWhereInput | null;
}

export interface TreatmentStatusConnectionWhere {
  AND?: TreatmentStatusConnectionWhere[] | null;
  OR?: TreatmentStatusConnectionWhere[] | null;
  node?: PreparationStatusWhere | null;
  node_NOT?: PreparationStatusWhere | null;
}

export interface TreatmentStatusNodeAggregationWhereInput {
  AND?: TreatmentStatusNodeAggregationWhereInput[] | null;
  FlagApd_AVERAGE_EQUAL?: number | null;
  FlagApd_AVERAGE_GT?: number | null;
  FlagApd_AVERAGE_GTE?: number | null;
  FlagApd_AVERAGE_LT?: number | null;
  FlagApd_AVERAGE_LTE?: number | null;
  FlagApd_EQUAL?: string | null;
  FlagApd_GT?: number | null;
  FlagApd_GTE?: number | null;
  FlagApd_LONGEST_EQUAL?: number | null;
  FlagApd_LONGEST_GT?: number | null;
  FlagApd_LONGEST_GTE?: number | null;
  FlagApd_LONGEST_LT?: number | null;
  FlagApd_LONGEST_LTE?: number | null;
  FlagApd_LT?: number | null;
  FlagApd_LTE?: number | null;
  FlagApd_SHORTEST_EQUAL?: number | null;
  FlagApd_SHORTEST_GT?: number | null;
  FlagApd_SHORTEST_GTE?: number | null;
  FlagApd_SHORTEST_LT?: number | null;
  FlagApd_SHORTEST_LTE?: number | null;
  OR?: TreatmentStatusNodeAggregationWhereInput[] | null;
  StatusTypeCodeSl_AVERAGE_EQUAL?: number | null;
  StatusTypeCodeSl_AVERAGE_GT?: number | null;
  StatusTypeCodeSl_AVERAGE_GTE?: number | null;
  StatusTypeCodeSl_AVERAGE_LT?: number | null;
  StatusTypeCodeSl_AVERAGE_LTE?: number | null;
  StatusTypeCodeSl_EQUAL?: string | null;
  StatusTypeCodeSl_GT?: number | null;
  StatusTypeCodeSl_GTE?: number | null;
  StatusTypeCodeSl_LONGEST_EQUAL?: number | null;
  StatusTypeCodeSl_LONGEST_GT?: number | null;
  StatusTypeCodeSl_LONGEST_GTE?: number | null;
  StatusTypeCodeSl_LONGEST_LT?: number | null;
  StatusTypeCodeSl_LONGEST_LTE?: number | null;
  StatusTypeCodeSl_LT?: number | null;
  StatusTypeCodeSl_LTE?: number | null;
  StatusTypeCodeSl_SHORTEST_EQUAL?: number | null;
  StatusTypeCodeSl_SHORTEST_GT?: number | null;
  StatusTypeCodeSl_SHORTEST_GTE?: number | null;
  StatusTypeCodeSl_SHORTEST_LT?: number | null;
  StatusTypeCodeSl_SHORTEST_LTE?: number | null;
  StatusTypeDescriptionSl_AVERAGE_EQUAL?: number | null;
  StatusTypeDescriptionSl_AVERAGE_GT?: number | null;
  StatusTypeDescriptionSl_AVERAGE_GTE?: number | null;
  StatusTypeDescriptionSl_AVERAGE_LT?: number | null;
  StatusTypeDescriptionSl_AVERAGE_LTE?: number | null;
  StatusTypeDescriptionSl_EQUAL?: string | null;
  StatusTypeDescriptionSl_GT?: number | null;
  StatusTypeDescriptionSl_GTE?: number | null;
  StatusTypeDescriptionSl_LONGEST_EQUAL?: number | null;
  StatusTypeDescriptionSl_LONGEST_GT?: number | null;
  StatusTypeDescriptionSl_LONGEST_GTE?: number | null;
  StatusTypeDescriptionSl_LONGEST_LT?: number | null;
  StatusTypeDescriptionSl_LONGEST_LTE?: number | null;
  StatusTypeDescriptionSl_LT?: number | null;
  StatusTypeDescriptionSl_LTE?: number | null;
  StatusTypeDescriptionSl_SHORTEST_EQUAL?: number | null;
  StatusTypeDescriptionSl_SHORTEST_GT?: number | null;
  StatusTypeDescriptionSl_SHORTEST_GTE?: number | null;
  StatusTypeDescriptionSl_SHORTEST_LT?: number | null;
  StatusTypeDescriptionSl_SHORTEST_LTE?: number | null;
}

export interface TreatmentWhere {
  AND?: TreatmentWhere[] | null;
  BagDossierNo?: string | null;
  BagDossierNo_CONTAINS?: string | null;
  BagDossierNo_ENDS_WITH?: string | null;
  BagDossierNo_IN?: (string | null)[] | null;
  BagDossierNo_MATCHES?: string | null;
  BagDossierNo_NOT?: string | null;
  BagDossierNo_NOT_CONTAINS?: string | null;
  BagDossierNo_NOT_ENDS_WITH?: string | null;
  BagDossierNo_NOT_IN?: (string | null)[] | null;
  BagDossierNo_NOT_STARTS_WITH?: string | null;
  BagDossierNo_STARTS_WITH?: string | null;
  Code?: string | null;
  Code_CONTAINS?: string | null;
  Code_ENDS_WITH?: string | null;
  Code_IN?: (string | null)[] | null;
  Code_MATCHES?: string | null;
  Code_NOT?: string | null;
  Code_NOT_CONTAINS?: string | null;
  Code_NOT_ENDS_WITH?: string | null;
  Code_NOT_IN?: (string | null)[] | null;
  Code_NOT_STARTS_WITH?: string | null;
  Code_STARTS_WITH?: string | null;
  FlagModal?: string | null;
  FlagModal_CONTAINS?: string | null;
  FlagModal_ENDS_WITH?: string | null;
  FlagModal_IN?: (string | null)[] | null;
  FlagModal_MATCHES?: string | null;
  FlagModal_NOT?: string | null;
  FlagModal_NOT_CONTAINS?: string | null;
  FlagModal_NOT_ENDS_WITH?: string | null;
  FlagModal_NOT_IN?: (string | null)[] | null;
  FlagModal_NOT_STARTS_WITH?: string | null;
  FlagModal_STARTS_WITH?: string | null;
  FlagNarcosis?: string | null;
  FlagNarcosis_CONTAINS?: string | null;
  FlagNarcosis_ENDS_WITH?: string | null;
  FlagNarcosis_IN?: (string | null)[] | null;
  FlagNarcosis_MATCHES?: string | null;
  FlagNarcosis_NOT?: string | null;
  FlagNarcosis_NOT_CONTAINS?: string | null;
  FlagNarcosis_NOT_ENDS_WITH?: string | null;
  FlagNarcosis_NOT_IN?: (string | null)[] | null;
  FlagNarcosis_NOT_STARTS_WITH?: string | null;
  FlagNarcosis_STARTS_WITH?: string | null;
  GTIN?: string | null;
  GTIN_CONTAINS?: string | null;
  GTIN_ENDS_WITH?: string | null;
  GTIN_IN?: (string | null)[] | null;
  GTIN_MATCHES?: string | null;
  GTIN_NOT?: string | null;
  GTIN_NOT_CONTAINS?: string | null;
  GTIN_NOT_ENDS_WITH?: string | null;
  GTIN_NOT_IN?: (string | null)[] | null;
  GTIN_NOT_STARTS_WITH?: string | null;
  GTIN_STARTS_WITH?: string | null;
  LOT?: string | null;
  LOT_CONTAINS?: string | null;
  LOT_ENDS_WITH?: string | null;
  LOT_IN?: (string | null)[] | null;
  LOT_MATCHES?: string | null;
  LOT_NOT?: string | null;
  LOT_NOT_CONTAINS?: string | null;
  LOT_NOT_ENDS_WITH?: string | null;
  LOT_NOT_IN?: (string | null)[] | null;
  LOT_NOT_STARTS_WITH?: string | null;
  LOT_STARTS_WITH?: string | null;
  Name?: string | null;
  Name_CONTAINS?: string | null;
  Name_ENDS_WITH?: string | null;
  Name_IN?: (string | null)[] | null;
  Name_MATCHES?: string | null;
  Name_NOT?: string | null;
  Name_NOT_CONTAINS?: string | null;
  Name_NOT_ENDS_WITH?: string | null;
  Name_NOT_IN?: (string | null)[] | null;
  Name_NOT_STARTS_WITH?: string | null;
  Name_STARTS_WITH?: string | null;
  OR?: TreatmentWhere[] | null;
  Partners?: PartnerWhere | null;
  PartnersAggregate?: TreatmentPartnersAggregateInput | null;
  PartnersConnection?: TreatmentPartnersConnectionWhere | null;
  PartnersConnection_NOT?: TreatmentPartnersConnectionWhere | null;
  Partners_NOT?: PartnerWhere | null;
  PharmaCode?: string | null;
  PharmaCode_CONTAINS?: string | null;
  PharmaCode_ENDS_WITH?: string | null;
  PharmaCode_IN?: (string | null)[] | null;
  PharmaCode_MATCHES?: string | null;
  PharmaCode_NOT?: string | null;
  PharmaCode_NOT_CONTAINS?: string | null;
  PharmaCode_NOT_ENDS_WITH?: string | null;
  PharmaCode_NOT_IN?: (string | null)[] | null;
  PharmaCode_NOT_STARTS_WITH?: string | null;
  PharmaCode_STARTS_WITH?: string | null;
  PrevPharmacode?: string | null;
  PrevPharmacode_CONTAINS?: string | null;
  PrevPharmacode_ENDS_WITH?: string | null;
  PrevPharmacode_IN?: (string | null)[] | null;
  PrevPharmacode_MATCHES?: string | null;
  PrevPharmacode_NOT?: string | null;
  PrevPharmacode_NOT_CONTAINS?: string | null;
  PrevPharmacode_NOT_ENDS_WITH?: string | null;
  PrevPharmacode_NOT_IN?: (string | null)[] | null;
  PrevPharmacode_NOT_STARTS_WITH?: string | null;
  PrevPharmacode_STARTS_WITH?: string | null;
  REF?: string | null;
  REF_CONTAINS?: string | null;
  REF_ENDS_WITH?: string | null;
  REF_IN?: (string | null)[] | null;
  REF_MATCHES?: string | null;
  REF_NOT?: string | null;
  REF_NOT_CONTAINS?: string | null;
  REF_NOT_ENDS_WITH?: string | null;
  REF_NOT_IN?: (string | null)[] | null;
  REF_NOT_STARTS_WITH?: string | null;
  REF_STARTS_WITH?: string | null;
  Status?: PreparationStatusWhere | null;
  StatusAggregate?: TreatmentStatusAggregateInput | null;
  StatusConnection?: TreatmentStatusConnectionWhere | null;
  StatusConnection_NOT?: TreatmentStatusConnectionWhere | null;
  Status_NOT?: PreparationStatusWhere | null;
  SwissmedicCategory?: string | null;
  SwissmedicCategory_CONTAINS?: string | null;
  SwissmedicCategory_ENDS_WITH?: string | null;
  SwissmedicCategory_IN?: (string | null)[] | null;
  SwissmedicCategory_MATCHES?: string | null;
  SwissmedicCategory_NOT?: string | null;
  SwissmedicCategory_NOT_CONTAINS?: string | null;
  SwissmedicCategory_NOT_ENDS_WITH?: string | null;
  SwissmedicCategory_NOT_IN?: (string | null)[] | null;
  SwissmedicCategory_NOT_STARTS_WITH?: string | null;
  SwissmedicCategory_STARTS_WITH?: string | null;
  SwissmedicNo8?: string | null;
  SwissmedicNo8_CONTAINS?: string | null;
  SwissmedicNo8_ENDS_WITH?: string | null;
  SwissmedicNo8_IN?: (string | null)[] | null;
  SwissmedicNo8_MATCHES?: string | null;
  SwissmedicNo8_NOT?: string | null;
  SwissmedicNo8_NOT_CONTAINS?: string | null;
  SwissmedicNo8_NOT_ENDS_WITH?: string | null;
  SwissmedicNo8_NOT_IN?: (string | null)[] | null;
  SwissmedicNo8_NOT_STARTS_WITH?: string | null;
  SwissmedicNo8_STARTS_WITH?: string | null;
  UDI?: string | null;
  UDI_CONTAINS?: string | null;
  UDI_ENDS_WITH?: string | null;
  UDI_IN?: (string | null)[] | null;
  UDI_MATCHES?: string | null;
  UDI_NOT?: string | null;
  UDI_NOT_CONTAINS?: string | null;
  UDI_NOT_ENDS_WITH?: string | null;
  UDI_NOT_IN?: (string | null)[] | null;
  UDI_NOT_STARTS_WITH?: string | null;
  UDI_STARTS_WITH?: string | null;
  activeIngredientQuantity?: number | null;
  activeIngredientQuantity_GT?: number | null;
  activeIngredientQuantity_GTE?: number | null;
  activeIngredientQuantity_IN?: (number | null)[] | null;
  activeIngredientQuantity_LT?: number | null;
  activeIngredientQuantity_LTE?: number | null;
  activeIngredientQuantity_NOT?: number | null;
  activeIngredientQuantity_NOT_IN?: (number | null)[] | null;
  canBeMain?: boolean | null;
  canBeMain_NOT?: boolean | null;
  classificationSystem?: string | null;
  classificationSystem_CONTAINS?: string | null;
  classificationSystem_ENDS_WITH?: string | null;
  classificationSystem_IN?: (string | null)[] | null;
  classificationSystem_MATCHES?: string | null;
  classificationSystem_NOT?: string | null;
  classificationSystem_NOT_CONTAINS?: string | null;
  classificationSystem_NOT_ENDS_WITH?: string | null;
  classificationSystem_NOT_IN?: (string | null)[] | null;
  classificationSystem_NOT_STARTS_WITH?: string | null;
  classificationSystem_STARTS_WITH?: string | null;
  codeCategories?: CodeCategory[] | null;
  codeCategories_INCLUDES?: CodeCategory | null;
  codeCategories_NOT?: CodeCategory[] | null;
  codeCategories_NOT_INCLUDES?: CodeCategory | null;
  concentration?: string | null;
  concentration_CONTAINS?: string | null;
  concentration_ENDS_WITH?: string | null;
  concentration_IN?: (string | null)[] | null;
  concentration_MATCHES?: string | null;
  concentration_NOT?: string | null;
  concentration_NOT_CONTAINS?: string | null;
  concentration_NOT_ENDS_WITH?: string | null;
  concentration_NOT_IN?: (string | null)[] | null;
  concentration_NOT_STARTS_WITH?: string | null;
  concentration_STARTS_WITH?: string | null;
  hasLimitations?: LimitationWhere | null;
  hasLimitationsAggregate?: TreatmentHasLimitationsAggregateInput | null;
  hasLimitationsConnection?: TreatmentHasLimitationsConnectionWhere | null;
  hasLimitationsConnection_NOT?: TreatmentHasLimitationsConnectionWhere | null;
  hasLimitations_NOT?: LimitationWhere | null;
  packVolume?: string | null;
  packVolumeUoMType?: PackVolumeUoMType | null;
  packVolumeUoMType_IN?: (PackVolumeUoMType | null)[] | null;
  packVolumeUoMType_NOT?: PackVolumeUoMType | null;
  packVolumeUoMType_NOT_IN?: (PackVolumeUoMType | null)[] | null;
  packVolume_CONTAINS?: string | null;
  packVolume_ENDS_WITH?: string | null;
  packVolume_IN?: (string | null)[] | null;
  packVolume_MATCHES?: string | null;
  packVolume_NOT?: string | null;
  packVolume_NOT_CONTAINS?: string | null;
  packVolume_NOT_ENDS_WITH?: string | null;
  packVolume_NOT_IN?: (string | null)[] | null;
  packVolume_NOT_STARTS_WITH?: string | null;
  packVolume_STARTS_WITH?: string | null;
  prices?: PriceWhere | null;
  pricesAggregate?: TreatmentPricesAggregateInput | null;
  pricesConnection?: TreatmentPricesConnectionWhere | null;
  pricesConnection_NOT?: TreatmentPricesConnectionWhere | null;
  prices_NOT?: PriceWhere | null;
  regulatedBy?: PreparationWhere | null;
  regulatedByAggregate?: TreatmentRegulatedByAggregateInput | null;
  regulatedByConnection?: TreatmentRegulatedByConnectionWhere | null;
  regulatedByConnection_NOT?: TreatmentRegulatedByConnectionWhere | null;
  regulatedBy_NOT?: PreparationWhere | null;
  uoMType?: UoMType | null;
  uoMType_IN?: (UoMType | null)[] | null;
  uoMType_NOT?: UoMType | null;
  uoMType_NOT_IN?: (UoMType | null)[] | null;
}

export interface UniqueClaimsIdentifiers {
  administrationDate?: string | null;
  invoiceDate?: string | null;
  invoiceNumber?: string | null;
  preparationId?: string | null;
}

export interface UpdateCaseAssigneeInput {
  assignees: CaseAssigneeDataInput[];
  caseId: string;
}

export interface UpdateInvoiceForReviewInput {
  deletedRefunds?: (string | null)[] | null;
  invoiceAmount: number;
  invoiceId: string;
  receiverEmail?: string | null;
  refunds: string[];
  useCC?: boolean | null;
}

export interface UploadClaimsInput {
  administrationDate?: any | null;
  id: string;
  insuranceClaimId?: string | null;
  insuranceId: string;
  invoiceAmount?: string | null;
  invoiceDate?: any | null;
  invoiceNumber?: string | null;
  patientId?: string | null;
  preparationId: string;
  preparationIdType?: string | null;
  providerId?: string | null;
  providerName?: string | null;
  quantity?: string | null;
}

export interface UploadFlexEntitiesAggregateInput {
  AND?: UploadFlexEntitiesAggregateInput[] | null;
  OR?: UploadFlexEntitiesAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: UploadFlexEntitiesNodeAggregationWhereInput | null;
}

export interface UploadFlexEntitiesConnectionWhere {
  AND?: UploadFlexEntitiesConnectionWhere[] | null;
  OR?: UploadFlexEntitiesConnectionWhere[] | null;
  node?: FlexEntityWhere | null;
  node_NOT?: FlexEntityWhere | null;
}

export interface UploadFlexEntitiesNodeAggregationWhereInput {
  AND?: UploadFlexEntitiesNodeAggregationWhereInput[] | null;
  OR?: UploadFlexEntitiesNodeAggregationWhereInput[] | null;
  createdByEmail_AVERAGE_EQUAL?: number | null;
  createdByEmail_AVERAGE_GT?: number | null;
  createdByEmail_AVERAGE_GTE?: number | null;
  createdByEmail_AVERAGE_LT?: number | null;
  createdByEmail_AVERAGE_LTE?: number | null;
  createdByEmail_EQUAL?: string | null;
  createdByEmail_GT?: number | null;
  createdByEmail_GTE?: number | null;
  createdByEmail_LONGEST_EQUAL?: number | null;
  createdByEmail_LONGEST_GT?: number | null;
  createdByEmail_LONGEST_GTE?: number | null;
  createdByEmail_LONGEST_LT?: number | null;
  createdByEmail_LONGEST_LTE?: number | null;
  createdByEmail_LT?: number | null;
  createdByEmail_LTE?: number | null;
  createdByEmail_SHORTEST_EQUAL?: number | null;
  createdByEmail_SHORTEST_GT?: number | null;
  createdByEmail_SHORTEST_GTE?: number | null;
  createdByEmail_SHORTEST_LT?: number | null;
  createdByEmail_SHORTEST_LTE?: number | null;
  createdByName_AVERAGE_EQUAL?: number | null;
  createdByName_AVERAGE_GT?: number | null;
  createdByName_AVERAGE_GTE?: number | null;
  createdByName_AVERAGE_LT?: number | null;
  createdByName_AVERAGE_LTE?: number | null;
  createdByName_EQUAL?: string | null;
  createdByName_GT?: number | null;
  createdByName_GTE?: number | null;
  createdByName_LONGEST_EQUAL?: number | null;
  createdByName_LONGEST_GT?: number | null;
  createdByName_LONGEST_GTE?: number | null;
  createdByName_LONGEST_LT?: number | null;
  createdByName_LONGEST_LTE?: number | null;
  createdByName_LT?: number | null;
  createdByName_LTE?: number | null;
  createdByName_SHORTEST_EQUAL?: number | null;
  createdByName_SHORTEST_GT?: number | null;
  createdByName_SHORTEST_GTE?: number | null;
  createdByName_SHORTEST_LT?: number | null;
  createdByName_SHORTEST_LTE?: number | null;
  createdOn_EQUAL?: any | null;
  createdOn_GT?: any | null;
  createdOn_GTE?: any | null;
  createdOn_LT?: any | null;
  createdOn_LTE?: any | null;
  createdOn_MAX_EQUAL?: any | null;
  createdOn_MAX_GT?: any | null;
  createdOn_MAX_GTE?: any | null;
  createdOn_MAX_LT?: any | null;
  createdOn_MAX_LTE?: any | null;
  createdOn_MIN_EQUAL?: any | null;
  createdOn_MIN_GT?: any | null;
  createdOn_MIN_GTE?: any | null;
  createdOn_MIN_LT?: any | null;
  createdOn_MIN_LTE?: any | null;
  dataKeys_AVERAGE_EQUAL?: number | null;
  dataKeys_AVERAGE_GT?: number | null;
  dataKeys_AVERAGE_GTE?: number | null;
  dataKeys_AVERAGE_LT?: number | null;
  dataKeys_AVERAGE_LTE?: number | null;
  dataKeys_EQUAL?: string | null;
  dataKeys_GT?: number | null;
  dataKeys_GTE?: number | null;
  dataKeys_LONGEST_EQUAL?: number | null;
  dataKeys_LONGEST_GT?: number | null;
  dataKeys_LONGEST_GTE?: number | null;
  dataKeys_LONGEST_LT?: number | null;
  dataKeys_LONGEST_LTE?: number | null;
  dataKeys_LT?: number | null;
  dataKeys_LTE?: number | null;
  dataKeys_SHORTEST_EQUAL?: number | null;
  dataKeys_SHORTEST_GT?: number | null;
  dataKeys_SHORTEST_GTE?: number | null;
  dataKeys_SHORTEST_LT?: number | null;
  dataKeys_SHORTEST_LTE?: number | null;
  data_AVERAGE_EQUAL?: number | null;
  data_AVERAGE_GT?: number | null;
  data_AVERAGE_GTE?: number | null;
  data_AVERAGE_LT?: number | null;
  data_AVERAGE_LTE?: number | null;
  data_EQUAL?: string | null;
  data_GT?: number | null;
  data_GTE?: number | null;
  data_LONGEST_EQUAL?: number | null;
  data_LONGEST_GT?: number | null;
  data_LONGEST_GTE?: number | null;
  data_LONGEST_LT?: number | null;
  data_LONGEST_LTE?: number | null;
  data_LT?: number | null;
  data_LTE?: number | null;
  data_SHORTEST_EQUAL?: number | null;
  data_SHORTEST_GT?: number | null;
  data_SHORTEST_GTE?: number | null;
  data_SHORTEST_LT?: number | null;
  data_SHORTEST_LTE?: number | null;
  flexEntityName_AVERAGE_EQUAL?: number | null;
  flexEntityName_AVERAGE_GT?: number | null;
  flexEntityName_AVERAGE_GTE?: number | null;
  flexEntityName_AVERAGE_LT?: number | null;
  flexEntityName_AVERAGE_LTE?: number | null;
  flexEntityName_EQUAL?: string | null;
  flexEntityName_GT?: number | null;
  flexEntityName_GTE?: number | null;
  flexEntityName_LONGEST_EQUAL?: number | null;
  flexEntityName_LONGEST_GT?: number | null;
  flexEntityName_LONGEST_GTE?: number | null;
  flexEntityName_LONGEST_LT?: number | null;
  flexEntityName_LONGEST_LTE?: number | null;
  flexEntityName_LT?: number | null;
  flexEntityName_LTE?: number | null;
  flexEntityName_SHORTEST_EQUAL?: number | null;
  flexEntityName_SHORTEST_GT?: number | null;
  flexEntityName_SHORTEST_GTE?: number | null;
  flexEntityName_SHORTEST_LT?: number | null;
  flexEntityName_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  lastUpdatedOn_EQUAL?: any | null;
  lastUpdatedOn_GT?: any | null;
  lastUpdatedOn_GTE?: any | null;
  lastUpdatedOn_LT?: any | null;
  lastUpdatedOn_LTE?: any | null;
  lastUpdatedOn_MAX_EQUAL?: any | null;
  lastUpdatedOn_MAX_GT?: any | null;
  lastUpdatedOn_MAX_GTE?: any | null;
  lastUpdatedOn_MAX_LT?: any | null;
  lastUpdatedOn_MAX_LTE?: any | null;
  lastUpdatedOn_MIN_EQUAL?: any | null;
  lastUpdatedOn_MIN_GT?: any | null;
  lastUpdatedOn_MIN_GTE?: any | null;
  lastUpdatedOn_MIN_LT?: any | null;
  lastUpdatedOn_MIN_LTE?: any | null;
  patientId_AVERAGE_EQUAL?: number | null;
  patientId_AVERAGE_GT?: number | null;
  patientId_AVERAGE_GTE?: number | null;
  patientId_AVERAGE_LT?: number | null;
  patientId_AVERAGE_LTE?: number | null;
  patientId_EQUAL?: string | null;
  patientId_GT?: number | null;
  patientId_GTE?: number | null;
  patientId_LONGEST_EQUAL?: number | null;
  patientId_LONGEST_GT?: number | null;
  patientId_LONGEST_GTE?: number | null;
  patientId_LONGEST_LT?: number | null;
  patientId_LONGEST_LTE?: number | null;
  patientId_LT?: number | null;
  patientId_LTE?: number | null;
  patientId_SHORTEST_EQUAL?: number | null;
  patientId_SHORTEST_GT?: number | null;
  patientId_SHORTEST_GTE?: number | null;
  patientId_SHORTEST_LT?: number | null;
  patientId_SHORTEST_LTE?: number | null;
  preparationBrandNames_AVERAGE_EQUAL?: number | null;
  preparationBrandNames_AVERAGE_GT?: number | null;
  preparationBrandNames_AVERAGE_GTE?: number | null;
  preparationBrandNames_AVERAGE_LT?: number | null;
  preparationBrandNames_AVERAGE_LTE?: number | null;
  preparationBrandNames_EQUAL?: string | null;
  preparationBrandNames_GT?: number | null;
  preparationBrandNames_GTE?: number | null;
  preparationBrandNames_LONGEST_EQUAL?: number | null;
  preparationBrandNames_LONGEST_GT?: number | null;
  preparationBrandNames_LONGEST_GTE?: number | null;
  preparationBrandNames_LONGEST_LT?: number | null;
  preparationBrandNames_LONGEST_LTE?: number | null;
  preparationBrandNames_LT?: number | null;
  preparationBrandNames_LTE?: number | null;
  preparationBrandNames_SHORTEST_EQUAL?: number | null;
  preparationBrandNames_SHORTEST_GT?: number | null;
  preparationBrandNames_SHORTEST_GTE?: number | null;
  preparationBrandNames_SHORTEST_LT?: number | null;
  preparationBrandNames_SHORTEST_LTE?: number | null;
  preparationGenericNames_AVERAGE_EQUAL?: number | null;
  preparationGenericNames_AVERAGE_GT?: number | null;
  preparationGenericNames_AVERAGE_GTE?: number | null;
  preparationGenericNames_AVERAGE_LT?: number | null;
  preparationGenericNames_AVERAGE_LTE?: number | null;
  preparationGenericNames_EQUAL?: string | null;
  preparationGenericNames_GT?: number | null;
  preparationGenericNames_GTE?: number | null;
  preparationGenericNames_LONGEST_EQUAL?: number | null;
  preparationGenericNames_LONGEST_GT?: number | null;
  preparationGenericNames_LONGEST_GTE?: number | null;
  preparationGenericNames_LONGEST_LT?: number | null;
  preparationGenericNames_LONGEST_LTE?: number | null;
  preparationGenericNames_LT?: number | null;
  preparationGenericNames_LTE?: number | null;
  preparationGenericNames_SHORTEST_EQUAL?: number | null;
  preparationGenericNames_SHORTEST_GT?: number | null;
  preparationGenericNames_SHORTEST_GTE?: number | null;
  preparationGenericNames_SHORTEST_LT?: number | null;
  preparationGenericNames_SHORTEST_LTE?: number | null;
  quantity_AVERAGE_EQUAL?: number | null;
  quantity_AVERAGE_GT?: number | null;
  quantity_AVERAGE_GTE?: number | null;
  quantity_AVERAGE_LT?: number | null;
  quantity_AVERAGE_LTE?: number | null;
  quantity_EQUAL?: number | null;
  quantity_GT?: number | null;
  quantity_GTE?: number | null;
  quantity_LT?: number | null;
  quantity_LTE?: number | null;
  quantity_MAX_EQUAL?: number | null;
  quantity_MAX_GT?: number | null;
  quantity_MAX_GTE?: number | null;
  quantity_MAX_LT?: number | null;
  quantity_MAX_LTE?: number | null;
  quantity_MIN_EQUAL?: number | null;
  quantity_MIN_GT?: number | null;
  quantity_MIN_GTE?: number | null;
  quantity_MIN_LT?: number | null;
  quantity_MIN_LTE?: number | null;
  quantity_SUM_EQUAL?: number | null;
  quantity_SUM_GT?: number | null;
  quantity_SUM_GTE?: number | null;
  quantity_SUM_LT?: number | null;
  quantity_SUM_LTE?: number | null;
  tenantId_AVERAGE_EQUAL?: number | null;
  tenantId_AVERAGE_GT?: number | null;
  tenantId_AVERAGE_GTE?: number | null;
  tenantId_AVERAGE_LT?: number | null;
  tenantId_AVERAGE_LTE?: number | null;
  tenantId_EQUAL?: string | null;
  tenantId_GT?: number | null;
  tenantId_GTE?: number | null;
  tenantId_LONGEST_EQUAL?: number | null;
  tenantId_LONGEST_GT?: number | null;
  tenantId_LONGEST_GTE?: number | null;
  tenantId_LONGEST_LT?: number | null;
  tenantId_LONGEST_LTE?: number | null;
  tenantId_LT?: number | null;
  tenantId_LTE?: number | null;
  tenantId_SHORTEST_EQUAL?: number | null;
  tenantId_SHORTEST_GT?: number | null;
  tenantId_SHORTEST_GTE?: number | null;
  tenantId_SHORTEST_LT?: number | null;
  tenantId_SHORTEST_LTE?: number | null;
  unlimited_AVERAGE_EQUAL?: number | null;
  unlimited_AVERAGE_GT?: number | null;
  unlimited_AVERAGE_GTE?: number | null;
  unlimited_AVERAGE_LT?: number | null;
  unlimited_AVERAGE_LTE?: number | null;
  unlimited_EQUAL?: number | null;
  unlimited_GT?: number | null;
  unlimited_GTE?: number | null;
  unlimited_LT?: number | null;
  unlimited_LTE?: number | null;
  unlimited_MAX_EQUAL?: number | null;
  unlimited_MAX_GT?: number | null;
  unlimited_MAX_GTE?: number | null;
  unlimited_MAX_LT?: number | null;
  unlimited_MAX_LTE?: number | null;
  unlimited_MIN_EQUAL?: number | null;
  unlimited_MIN_GT?: number | null;
  unlimited_MIN_GTE?: number | null;
  unlimited_MIN_LT?: number | null;
  unlimited_MIN_LTE?: number | null;
  unlimited_SUM_EQUAL?: number | null;
  unlimited_SUM_GT?: number | null;
  unlimited_SUM_GTE?: number | null;
  unlimited_SUM_LT?: number | null;
  unlimited_SUM_LTE?: number | null;
  uuid_AVERAGE_EQUAL?: number | null;
  uuid_AVERAGE_GT?: number | null;
  uuid_AVERAGE_GTE?: number | null;
  uuid_AVERAGE_LT?: number | null;
  uuid_AVERAGE_LTE?: number | null;
  uuid_EQUAL?: string | null;
  uuid_GT?: number | null;
  uuid_GTE?: number | null;
  uuid_LONGEST_EQUAL?: number | null;
  uuid_LONGEST_GT?: number | null;
  uuid_LONGEST_GTE?: number | null;
  uuid_LONGEST_LT?: number | null;
  uuid_LONGEST_LTE?: number | null;
  uuid_LT?: number | null;
  uuid_LTE?: number | null;
  uuid_SHORTEST_EQUAL?: number | null;
  uuid_SHORTEST_GT?: number | null;
  uuid_SHORTEST_GTE?: number | null;
  uuid_SHORTEST_LT?: number | null;
  uuid_SHORTEST_LTE?: number | null;
}

export interface UploadFlexEntityInput {
  data: FlexEntityUploadInput[];
  flexEntityTypeId: string;
  mappingData?: string | null;
}

export interface UploadWhere {
  AND?: UploadWhere[] | null;
  OR?: UploadWhere[] | null;
  flexEntities?: FlexEntityWhere | null;
  flexEntitiesAggregate?: UploadFlexEntitiesAggregateInput | null;
  flexEntitiesConnection?: UploadFlexEntitiesConnectionWhere | null;
  flexEntitiesConnection_NOT?: UploadFlexEntitiesConnectionWhere | null;
  flexEntities_NOT?: FlexEntityWhere | null;
  id?: string | null;
  id_CONTAINS?: string | null;
  id_ENDS_WITH?: string | null;
  id_IN?: (string | null)[] | null;
  id_MATCHES?: string | null;
  id_NOT?: string | null;
  id_NOT_CONTAINS?: string | null;
  id_NOT_ENDS_WITH?: string | null;
  id_NOT_IN?: (string | null)[] | null;
  id_NOT_STARTS_WITH?: string | null;
  id_STARTS_WITH?: string | null;
  timestamp?: any | null;
  timestamp_GT?: any | null;
  timestamp_GTE?: any | null;
  timestamp_IN?: (any | null)[] | null;
  timestamp_LT?: any | null;
  timestamp_LTE?: any | null;
  timestamp_NOT?: any | null;
  timestamp_NOT_IN?: (any | null)[] | null;
}

export interface UserContextAggregateInput {
  AND?: UserContextAggregateInput[] | null;
  OR?: UserContextAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: UserContextNodeAggregationWhereInput | null;
}

export interface UserContextBaseAgreementContextAggregateInput {
  AND?: UserContextBaseAgreementContextAggregateInput[] | null;
  OR?: UserContextBaseAgreementContextAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  edge?: UserContextBaseAgreementContextEdgeAggregationWhereInput | null;
  node?: UserContextBaseAgreementContextNodeAggregationWhereInput | null;
}

export interface UserContextBaseAgreementContextConnectionWhere {
  AND?: UserContextBaseAgreementContextConnectionWhere[] | null;
  OR?: UserContextBaseAgreementContextConnectionWhere[] | null;
  edge?: ScenarioInsightsUserContextWhere | null;
  edge_NOT?: ScenarioInsightsUserContextWhere | null;
  node?: BaseAgreementWhere | null;
  node_NOT?: BaseAgreementWhere | null;
}

export interface UserContextBaseAgreementContextEdgeAggregationWhereInput {
  AND?: UserContextBaseAgreementContextEdgeAggregationWhereInput[] | null;
  OR?: UserContextBaseAgreementContextEdgeAggregationWhereInput[] | null;
  categoryInput_AVERAGE_EQUAL?: number | null;
  categoryInput_AVERAGE_GT?: number | null;
  categoryInput_AVERAGE_GTE?: number | null;
  categoryInput_AVERAGE_LT?: number | null;
  categoryInput_AVERAGE_LTE?: number | null;
  categoryInput_EQUAL?: string | null;
  categoryInput_GT?: number | null;
  categoryInput_GTE?: number | null;
  categoryInput_LONGEST_EQUAL?: number | null;
  categoryInput_LONGEST_GT?: number | null;
  categoryInput_LONGEST_GTE?: number | null;
  categoryInput_LONGEST_LT?: number | null;
  categoryInput_LONGEST_LTE?: number | null;
  categoryInput_LT?: number | null;
  categoryInput_LTE?: number | null;
  categoryInput_SHORTEST_EQUAL?: number | null;
  categoryInput_SHORTEST_GT?: number | null;
  categoryInput_SHORTEST_GTE?: number | null;
  categoryInput_SHORTEST_LT?: number | null;
  categoryInput_SHORTEST_LTE?: number | null;
  rebateObjective_AVERAGE_EQUAL?: number | null;
  rebateObjective_AVERAGE_GT?: number | null;
  rebateObjective_AVERAGE_GTE?: number | null;
  rebateObjective_AVERAGE_LT?: number | null;
  rebateObjective_AVERAGE_LTE?: number | null;
  rebateObjective_EQUAL?: string | null;
  rebateObjective_GT?: number | null;
  rebateObjective_GTE?: number | null;
  rebateObjective_LONGEST_EQUAL?: number | null;
  rebateObjective_LONGEST_GT?: number | null;
  rebateObjective_LONGEST_GTE?: number | null;
  rebateObjective_LONGEST_LT?: number | null;
  rebateObjective_LONGEST_LTE?: number | null;
  rebateObjective_LT?: number | null;
  rebateObjective_LTE?: number | null;
  rebateObjective_SHORTEST_EQUAL?: number | null;
  rebateObjective_SHORTEST_GT?: number | null;
  rebateObjective_SHORTEST_GTE?: number | null;
  rebateObjective_SHORTEST_LT?: number | null;
  rebateObjective_SHORTEST_LTE?: number | null;
  timeframeLabel_AVERAGE_EQUAL?: number | null;
  timeframeLabel_AVERAGE_GT?: number | null;
  timeframeLabel_AVERAGE_GTE?: number | null;
  timeframeLabel_AVERAGE_LT?: number | null;
  timeframeLabel_AVERAGE_LTE?: number | null;
  timeframeLabel_EQUAL?: string | null;
  timeframeLabel_GT?: number | null;
  timeframeLabel_GTE?: number | null;
  timeframeLabel_LONGEST_EQUAL?: number | null;
  timeframeLabel_LONGEST_GT?: number | null;
  timeframeLabel_LONGEST_GTE?: number | null;
  timeframeLabel_LONGEST_LT?: number | null;
  timeframeLabel_LONGEST_LTE?: number | null;
  timeframeLabel_LT?: number | null;
  timeframeLabel_LTE?: number | null;
  timeframeLabel_SHORTEST_EQUAL?: number | null;
  timeframeLabel_SHORTEST_GT?: number | null;
  timeframeLabel_SHORTEST_GTE?: number | null;
  timeframeLabel_SHORTEST_LT?: number | null;
  timeframeLabel_SHORTEST_LTE?: number | null;
}

export interface UserContextBaseAgreementContextNodeAggregationWhereInput {
  AND?: UserContextBaseAgreementContextNodeAggregationWhereInput[] | null;
  OR?: UserContextBaseAgreementContextNodeAggregationWhereInput[] | null;
  caseSuspensionIntervalDays_AVERAGE_EQUAL?: number | null;
  caseSuspensionIntervalDays_AVERAGE_GT?: number | null;
  caseSuspensionIntervalDays_AVERAGE_GTE?: number | null;
  caseSuspensionIntervalDays_AVERAGE_LT?: number | null;
  caseSuspensionIntervalDays_AVERAGE_LTE?: number | null;
  caseSuspensionIntervalDays_EQUAL?: number | null;
  caseSuspensionIntervalDays_GT?: number | null;
  caseSuspensionIntervalDays_GTE?: number | null;
  caseSuspensionIntervalDays_LT?: number | null;
  caseSuspensionIntervalDays_LTE?: number | null;
  caseSuspensionIntervalDays_MAX_EQUAL?: number | null;
  caseSuspensionIntervalDays_MAX_GT?: number | null;
  caseSuspensionIntervalDays_MAX_GTE?: number | null;
  caseSuspensionIntervalDays_MAX_LT?: number | null;
  caseSuspensionIntervalDays_MAX_LTE?: number | null;
  caseSuspensionIntervalDays_MIN_EQUAL?: number | null;
  caseSuspensionIntervalDays_MIN_GT?: number | null;
  caseSuspensionIntervalDays_MIN_GTE?: number | null;
  caseSuspensionIntervalDays_MIN_LT?: number | null;
  caseSuspensionIntervalDays_MIN_LTE?: number | null;
  caseSuspensionIntervalDays_SUM_EQUAL?: number | null;
  caseSuspensionIntervalDays_SUM_GT?: number | null;
  caseSuspensionIntervalDays_SUM_GTE?: number | null;
  caseSuspensionIntervalDays_SUM_LT?: number | null;
  caseSuspensionIntervalDays_SUM_LTE?: number | null;
  coveringFormWaitInterval_AVERAGE_EQUAL?: number | null;
  coveringFormWaitInterval_AVERAGE_GT?: number | null;
  coveringFormWaitInterval_AVERAGE_GTE?: number | null;
  coveringFormWaitInterval_AVERAGE_LT?: number | null;
  coveringFormWaitInterval_AVERAGE_LTE?: number | null;
  coveringFormWaitInterval_EQUAL?: number | null;
  coveringFormWaitInterval_GT?: number | null;
  coveringFormWaitInterval_GTE?: number | null;
  coveringFormWaitInterval_LT?: number | null;
  coveringFormWaitInterval_LTE?: number | null;
  coveringFormWaitInterval_MAX_EQUAL?: number | null;
  coveringFormWaitInterval_MAX_GT?: number | null;
  coveringFormWaitInterval_MAX_GTE?: number | null;
  coveringFormWaitInterval_MAX_LT?: number | null;
  coveringFormWaitInterval_MAX_LTE?: number | null;
  coveringFormWaitInterval_MIN_EQUAL?: number | null;
  coveringFormWaitInterval_MIN_GT?: number | null;
  coveringFormWaitInterval_MIN_GTE?: number | null;
  coveringFormWaitInterval_MIN_LT?: number | null;
  coveringFormWaitInterval_MIN_LTE?: number | null;
  coveringFormWaitInterval_SUM_EQUAL?: number | null;
  coveringFormWaitInterval_SUM_GT?: number | null;
  coveringFormWaitInterval_SUM_GTE?: number | null;
  coveringFormWaitInterval_SUM_LT?: number | null;
  coveringFormWaitInterval_SUM_LTE?: number | null;
  createdOn_EQUAL?: any | null;
  createdOn_GT?: any | null;
  createdOn_GTE?: any | null;
  createdOn_LT?: any | null;
  createdOn_LTE?: any | null;
  createdOn_MAX_EQUAL?: any | null;
  createdOn_MAX_GT?: any | null;
  createdOn_MAX_GTE?: any | null;
  createdOn_MAX_LT?: any | null;
  createdOn_MAX_LTE?: any | null;
  createdOn_MIN_EQUAL?: any | null;
  createdOn_MIN_GT?: any | null;
  createdOn_MIN_GTE?: any | null;
  createdOn_MIN_LT?: any | null;
  createdOn_MIN_LTE?: any | null;
  defaultPriceRate_AVERAGE_EQUAL?: number | null;
  defaultPriceRate_AVERAGE_GT?: number | null;
  defaultPriceRate_AVERAGE_GTE?: number | null;
  defaultPriceRate_AVERAGE_LT?: number | null;
  defaultPriceRate_AVERAGE_LTE?: number | null;
  defaultPriceRate_EQUAL?: number | null;
  defaultPriceRate_GT?: number | null;
  defaultPriceRate_GTE?: number | null;
  defaultPriceRate_LT?: number | null;
  defaultPriceRate_LTE?: number | null;
  defaultPriceRate_MAX_EQUAL?: number | null;
  defaultPriceRate_MAX_GT?: number | null;
  defaultPriceRate_MAX_GTE?: number | null;
  defaultPriceRate_MAX_LT?: number | null;
  defaultPriceRate_MAX_LTE?: number | null;
  defaultPriceRate_MIN_EQUAL?: number | null;
  defaultPriceRate_MIN_GT?: number | null;
  defaultPriceRate_MIN_GTE?: number | null;
  defaultPriceRate_MIN_LT?: number | null;
  defaultPriceRate_MIN_LTE?: number | null;
  defaultPriceRate_SUM_EQUAL?: number | null;
  defaultPriceRate_SUM_GT?: number | null;
  defaultPriceRate_SUM_GTE?: number | null;
  defaultPriceRate_SUM_LT?: number | null;
  defaultPriceRate_SUM_LTE?: number | null;
  firstExecutionDate_EQUAL?: any | null;
  firstExecutionDate_GT?: any | null;
  firstExecutionDate_GTE?: any | null;
  firstExecutionDate_LT?: any | null;
  firstExecutionDate_LTE?: any | null;
  firstExecutionDate_MAX_EQUAL?: any | null;
  firstExecutionDate_MAX_GT?: any | null;
  firstExecutionDate_MAX_GTE?: any | null;
  firstExecutionDate_MAX_LT?: any | null;
  firstExecutionDate_MAX_LTE?: any | null;
  firstExecutionDate_MIN_EQUAL?: any | null;
  firstExecutionDate_MIN_GT?: any | null;
  firstExecutionDate_MIN_GTE?: any | null;
  firstExecutionDate_MIN_LT?: any | null;
  firstExecutionDate_MIN_LTE?: any | null;
  formattedAmount_AVERAGE_EQUAL?: number | null;
  formattedAmount_AVERAGE_GT?: number | null;
  formattedAmount_AVERAGE_GTE?: number | null;
  formattedAmount_AVERAGE_LT?: number | null;
  formattedAmount_AVERAGE_LTE?: number | null;
  formattedAmount_EQUAL?: string | null;
  formattedAmount_GT?: number | null;
  formattedAmount_GTE?: number | null;
  formattedAmount_LONGEST_EQUAL?: number | null;
  formattedAmount_LONGEST_GT?: number | null;
  formattedAmount_LONGEST_GTE?: number | null;
  formattedAmount_LONGEST_LT?: number | null;
  formattedAmount_LONGEST_LTE?: number | null;
  formattedAmount_LT?: number | null;
  formattedAmount_LTE?: number | null;
  formattedAmount_SHORTEST_EQUAL?: number | null;
  formattedAmount_SHORTEST_GT?: number | null;
  formattedAmount_SHORTEST_GTE?: number | null;
  formattedAmount_SHORTEST_LT?: number | null;
  formattedAmount_SHORTEST_LTE?: number | null;
  formattedCounterparties_AVERAGE_EQUAL?: number | null;
  formattedCounterparties_AVERAGE_GT?: number | null;
  formattedCounterparties_AVERAGE_GTE?: number | null;
  formattedCounterparties_AVERAGE_LT?: number | null;
  formattedCounterparties_AVERAGE_LTE?: number | null;
  formattedCounterparties_EQUAL?: string | null;
  formattedCounterparties_GT?: number | null;
  formattedCounterparties_GTE?: number | null;
  formattedCounterparties_LONGEST_EQUAL?: number | null;
  formattedCounterparties_LONGEST_GT?: number | null;
  formattedCounterparties_LONGEST_GTE?: number | null;
  formattedCounterparties_LONGEST_LT?: number | null;
  formattedCounterparties_LONGEST_LTE?: number | null;
  formattedCounterparties_LT?: number | null;
  formattedCounterparties_LTE?: number | null;
  formattedCounterparties_SHORTEST_EQUAL?: number | null;
  formattedCounterparties_SHORTEST_GT?: number | null;
  formattedCounterparties_SHORTEST_GTE?: number | null;
  formattedCounterparties_SHORTEST_LT?: number | null;
  formattedCounterparties_SHORTEST_LTE?: number | null;
  formattedDiseases_AVERAGE_EQUAL?: number | null;
  formattedDiseases_AVERAGE_GT?: number | null;
  formattedDiseases_AVERAGE_GTE?: number | null;
  formattedDiseases_AVERAGE_LT?: number | null;
  formattedDiseases_AVERAGE_LTE?: number | null;
  formattedDiseases_EQUAL?: string | null;
  formattedDiseases_GT?: number | null;
  formattedDiseases_GTE?: number | null;
  formattedDiseases_LONGEST_EQUAL?: number | null;
  formattedDiseases_LONGEST_GT?: number | null;
  formattedDiseases_LONGEST_GTE?: number | null;
  formattedDiseases_LONGEST_LT?: number | null;
  formattedDiseases_LONGEST_LTE?: number | null;
  formattedDiseases_LT?: number | null;
  formattedDiseases_LTE?: number | null;
  formattedDiseases_SHORTEST_EQUAL?: number | null;
  formattedDiseases_SHORTEST_GT?: number | null;
  formattedDiseases_SHORTEST_GTE?: number | null;
  formattedDiseases_SHORTEST_LT?: number | null;
  formattedDiseases_SHORTEST_LTE?: number | null;
  formattedIndications_AVERAGE_EQUAL?: number | null;
  formattedIndications_AVERAGE_GT?: number | null;
  formattedIndications_AVERAGE_GTE?: number | null;
  formattedIndications_AVERAGE_LT?: number | null;
  formattedIndications_AVERAGE_LTE?: number | null;
  formattedIndications_EQUAL?: string | null;
  formattedIndications_GT?: number | null;
  formattedIndications_GTE?: number | null;
  formattedIndications_LONGEST_EQUAL?: number | null;
  formattedIndications_LONGEST_GT?: number | null;
  formattedIndications_LONGEST_GTE?: number | null;
  formattedIndications_LONGEST_LT?: number | null;
  formattedIndications_LONGEST_LTE?: number | null;
  formattedIndications_LT?: number | null;
  formattedIndications_LTE?: number | null;
  formattedIndications_SHORTEST_EQUAL?: number | null;
  formattedIndications_SHORTEST_GT?: number | null;
  formattedIndications_SHORTEST_GTE?: number | null;
  formattedIndications_SHORTEST_LT?: number | null;
  formattedIndications_SHORTEST_LTE?: number | null;
  formattedProducts_AVERAGE_EQUAL?: number | null;
  formattedProducts_AVERAGE_GT?: number | null;
  formattedProducts_AVERAGE_GTE?: number | null;
  formattedProducts_AVERAGE_LT?: number | null;
  formattedProducts_AVERAGE_LTE?: number | null;
  formattedProducts_EQUAL?: string | null;
  formattedProducts_GT?: number | null;
  formattedProducts_GTE?: number | null;
  formattedProducts_LONGEST_EQUAL?: number | null;
  formattedProducts_LONGEST_GT?: number | null;
  formattedProducts_LONGEST_GTE?: number | null;
  formattedProducts_LONGEST_LT?: number | null;
  formattedProducts_LONGEST_LTE?: number | null;
  formattedProducts_LT?: number | null;
  formattedProducts_LTE?: number | null;
  formattedProducts_SHORTEST_EQUAL?: number | null;
  formattedProducts_SHORTEST_GT?: number | null;
  formattedProducts_SHORTEST_GTE?: number | null;
  formattedProducts_SHORTEST_LT?: number | null;
  formattedProducts_SHORTEST_LTE?: number | null;
  formattedTags_AVERAGE_EQUAL?: number | null;
  formattedTags_AVERAGE_GT?: number | null;
  formattedTags_AVERAGE_GTE?: number | null;
  formattedTags_AVERAGE_LT?: number | null;
  formattedTags_AVERAGE_LTE?: number | null;
  formattedTags_EQUAL?: string | null;
  formattedTags_GT?: number | null;
  formattedTags_GTE?: number | null;
  formattedTags_LONGEST_EQUAL?: number | null;
  formattedTags_LONGEST_GT?: number | null;
  formattedTags_LONGEST_GTE?: number | null;
  formattedTags_LONGEST_LT?: number | null;
  formattedTags_LONGEST_LTE?: number | null;
  formattedTags_LT?: number | null;
  formattedTags_LTE?: number | null;
  formattedTags_SHORTEST_EQUAL?: number | null;
  formattedTags_SHORTEST_GT?: number | null;
  formattedTags_SHORTEST_GTE?: number | null;
  formattedTags_SHORTEST_LT?: number | null;
  formattedTags_SHORTEST_LTE?: number | null;
  formattedValidityPeriod_AVERAGE_EQUAL?: number | null;
  formattedValidityPeriod_AVERAGE_GT?: number | null;
  formattedValidityPeriod_AVERAGE_GTE?: number | null;
  formattedValidityPeriod_AVERAGE_LT?: number | null;
  formattedValidityPeriod_AVERAGE_LTE?: number | null;
  formattedValidityPeriod_EQUAL?: string | null;
  formattedValidityPeriod_GT?: number | null;
  formattedValidityPeriod_GTE?: number | null;
  formattedValidityPeriod_LONGEST_EQUAL?: number | null;
  formattedValidityPeriod_LONGEST_GT?: number | null;
  formattedValidityPeriod_LONGEST_GTE?: number | null;
  formattedValidityPeriod_LONGEST_LT?: number | null;
  formattedValidityPeriod_LONGEST_LTE?: number | null;
  formattedValidityPeriod_LT?: number | null;
  formattedValidityPeriod_LTE?: number | null;
  formattedValidityPeriod_SHORTEST_EQUAL?: number | null;
  formattedValidityPeriod_SHORTEST_GT?: number | null;
  formattedValidityPeriod_SHORTEST_GTE?: number | null;
  formattedValidityPeriod_SHORTEST_LT?: number | null;
  formattedValidityPeriod_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  initialVersionId_AVERAGE_EQUAL?: number | null;
  initialVersionId_AVERAGE_GT?: number | null;
  initialVersionId_AVERAGE_GTE?: number | null;
  initialVersionId_AVERAGE_LT?: number | null;
  initialVersionId_AVERAGE_LTE?: number | null;
  initialVersionId_EQUAL?: string | null;
  initialVersionId_GT?: number | null;
  initialVersionId_GTE?: number | null;
  initialVersionId_LONGEST_EQUAL?: number | null;
  initialVersionId_LONGEST_GT?: number | null;
  initialVersionId_LONGEST_GTE?: number | null;
  initialVersionId_LONGEST_LT?: number | null;
  initialVersionId_LONGEST_LTE?: number | null;
  initialVersionId_LT?: number | null;
  initialVersionId_LTE?: number | null;
  initialVersionId_SHORTEST_EQUAL?: number | null;
  initialVersionId_SHORTEST_GT?: number | null;
  initialVersionId_SHORTEST_GTE?: number | null;
  initialVersionId_SHORTEST_LT?: number | null;
  initialVersionId_SHORTEST_LTE?: number | null;
  lastExecutionDate_EQUAL?: any | null;
  lastExecutionDate_GT?: any | null;
  lastExecutionDate_GTE?: any | null;
  lastExecutionDate_LT?: any | null;
  lastExecutionDate_LTE?: any | null;
  lastExecutionDate_MAX_EQUAL?: any | null;
  lastExecutionDate_MAX_GT?: any | null;
  lastExecutionDate_MAX_GTE?: any | null;
  lastExecutionDate_MAX_LT?: any | null;
  lastExecutionDate_MAX_LTE?: any | null;
  lastExecutionDate_MIN_EQUAL?: any | null;
  lastExecutionDate_MIN_GT?: any | null;
  lastExecutionDate_MIN_GTE?: any | null;
  lastExecutionDate_MIN_LT?: any | null;
  lastExecutionDate_MIN_LTE?: any | null;
  lastUpdatedOn_AVERAGE_EQUAL?: number | null;
  lastUpdatedOn_AVERAGE_GT?: number | null;
  lastUpdatedOn_AVERAGE_GTE?: number | null;
  lastUpdatedOn_AVERAGE_LT?: number | null;
  lastUpdatedOn_AVERAGE_LTE?: number | null;
  lastUpdatedOn_EQUAL?: number | null;
  lastUpdatedOn_GT?: number | null;
  lastUpdatedOn_GTE?: number | null;
  lastUpdatedOn_LT?: number | null;
  lastUpdatedOn_LTE?: number | null;
  lastUpdatedOn_MAX_EQUAL?: number | null;
  lastUpdatedOn_MAX_GT?: number | null;
  lastUpdatedOn_MAX_GTE?: number | null;
  lastUpdatedOn_MAX_LT?: number | null;
  lastUpdatedOn_MAX_LTE?: number | null;
  lastUpdatedOn_MIN_EQUAL?: number | null;
  lastUpdatedOn_MIN_GT?: number | null;
  lastUpdatedOn_MIN_GTE?: number | null;
  lastUpdatedOn_MIN_LT?: number | null;
  lastUpdatedOn_MIN_LTE?: number | null;
  lastUpdatedOn_SUM_EQUAL?: number | null;
  lastUpdatedOn_SUM_GT?: number | null;
  lastUpdatedOn_SUM_GTE?: number | null;
  lastUpdatedOn_SUM_LT?: number | null;
  lastUpdatedOn_SUM_LTE?: number | null;
  name_AVERAGE_EQUAL?: number | null;
  name_AVERAGE_GT?: number | null;
  name_AVERAGE_GTE?: number | null;
  name_AVERAGE_LT?: number | null;
  name_AVERAGE_LTE?: number | null;
  name_EQUAL?: string | null;
  name_GT?: number | null;
  name_GTE?: number | null;
  name_LONGEST_EQUAL?: number | null;
  name_LONGEST_GT?: number | null;
  name_LONGEST_GTE?: number | null;
  name_LONGEST_LT?: number | null;
  name_LONGEST_LTE?: number | null;
  name_LT?: number | null;
  name_LTE?: number | null;
  name_SHORTEST_EQUAL?: number | null;
  name_SHORTEST_GT?: number | null;
  name_SHORTEST_GTE?: number | null;
  name_SHORTEST_LT?: number | null;
  name_SHORTEST_LTE?: number | null;
  pushedOn_EQUAL?: any | null;
  pushedOn_GT?: any | null;
  pushedOn_GTE?: any | null;
  pushedOn_LT?: any | null;
  pushedOn_LTE?: any | null;
  pushedOn_MAX_EQUAL?: any | null;
  pushedOn_MAX_GT?: any | null;
  pushedOn_MAX_GTE?: any | null;
  pushedOn_MAX_LT?: any | null;
  pushedOn_MAX_LTE?: any | null;
  pushedOn_MIN_EQUAL?: any | null;
  pushedOn_MIN_GT?: any | null;
  pushedOn_MIN_GTE?: any | null;
  pushedOn_MIN_LT?: any | null;
  pushedOn_MIN_LTE?: any | null;
  reportData_AVERAGE_EQUAL?: number | null;
  reportData_AVERAGE_GT?: number | null;
  reportData_AVERAGE_GTE?: number | null;
  reportData_AVERAGE_LT?: number | null;
  reportData_AVERAGE_LTE?: number | null;
  reportData_EQUAL?: string | null;
  reportData_GT?: number | null;
  reportData_GTE?: number | null;
  reportData_LONGEST_EQUAL?: number | null;
  reportData_LONGEST_GT?: number | null;
  reportData_LONGEST_GTE?: number | null;
  reportData_LONGEST_LT?: number | null;
  reportData_LONGEST_LTE?: number | null;
  reportData_LT?: number | null;
  reportData_LTE?: number | null;
  reportData_SHORTEST_EQUAL?: number | null;
  reportData_SHORTEST_GT?: number | null;
  reportData_SHORTEST_GTE?: number | null;
  reportData_SHORTEST_LT?: number | null;
  reportData_SHORTEST_LTE?: number | null;
  totalAmount_AVERAGE_EQUAL?: number | null;
  totalAmount_AVERAGE_GT?: number | null;
  totalAmount_AVERAGE_GTE?: number | null;
  totalAmount_AVERAGE_LT?: number | null;
  totalAmount_AVERAGE_LTE?: number | null;
  totalAmount_EQUAL?: number | null;
  totalAmount_GT?: number | null;
  totalAmount_GTE?: number | null;
  totalAmount_LT?: number | null;
  totalAmount_LTE?: number | null;
  totalAmount_MAX_EQUAL?: number | null;
  totalAmount_MAX_GT?: number | null;
  totalAmount_MAX_GTE?: number | null;
  totalAmount_MAX_LT?: number | null;
  totalAmount_MAX_LTE?: number | null;
  totalAmount_MIN_EQUAL?: number | null;
  totalAmount_MIN_GT?: number | null;
  totalAmount_MIN_GTE?: number | null;
  totalAmount_MIN_LT?: number | null;
  totalAmount_MIN_LTE?: number | null;
  totalAmount_SUM_EQUAL?: number | null;
  totalAmount_SUM_GT?: number | null;
  totalAmount_SUM_GTE?: number | null;
  totalAmount_SUM_LT?: number | null;
  totalAmount_SUM_LTE?: number | null;
  version_AVERAGE_EQUAL?: number | null;
  version_AVERAGE_GT?: number | null;
  version_AVERAGE_GTE?: number | null;
  version_AVERAGE_LT?: number | null;
  version_AVERAGE_LTE?: number | null;
  version_EQUAL?: number | null;
  version_GT?: number | null;
  version_GTE?: number | null;
  version_LT?: number | null;
  version_LTE?: number | null;
  version_MAX_EQUAL?: number | null;
  version_MAX_GT?: number | null;
  version_MAX_GTE?: number | null;
  version_MAX_LT?: number | null;
  version_MAX_LTE?: number | null;
  version_MIN_EQUAL?: number | null;
  version_MIN_GT?: number | null;
  version_MIN_GTE?: number | null;
  version_MIN_LT?: number | null;
  version_MIN_LTE?: number | null;
  version_SUM_EQUAL?: number | null;
  version_SUM_GT?: number | null;
  version_SUM_GTE?: number | null;
  version_SUM_LT?: number | null;
  version_SUM_LTE?: number | null;
}

export interface UserContextConnectionWhere {
  AND?: UserContextConnectionWhere[] | null;
  OR?: UserContextConnectionWhere[] | null;
  node?: UserContextWhere | null;
  node_NOT?: UserContextWhere | null;
}

export interface UserContextNodeAggregationWhereInput {
  AND?: UserContextNodeAggregationWhereInput[] | null;
  OR?: UserContextNodeAggregationWhereInput[] | null;
  email_AVERAGE_EQUAL?: number | null;
  email_AVERAGE_GT?: number | null;
  email_AVERAGE_GTE?: number | null;
  email_AVERAGE_LT?: number | null;
  email_AVERAGE_LTE?: number | null;
  email_EQUAL?: string | null;
  email_GT?: number | null;
  email_GTE?: number | null;
  email_LONGEST_EQUAL?: number | null;
  email_LONGEST_GT?: number | null;
  email_LONGEST_GTE?: number | null;
  email_LONGEST_LT?: number | null;
  email_LONGEST_LTE?: number | null;
  email_LT?: number | null;
  email_LTE?: number | null;
  email_SHORTEST_EQUAL?: number | null;
  email_SHORTEST_GT?: number | null;
  email_SHORTEST_GTE?: number | null;
  email_SHORTEST_LT?: number | null;
  email_SHORTEST_LTE?: number | null;
  filterCaseLogs_AVERAGE_EQUAL?: number | null;
  filterCaseLogs_AVERAGE_GT?: number | null;
  filterCaseLogs_AVERAGE_GTE?: number | null;
  filterCaseLogs_AVERAGE_LT?: number | null;
  filterCaseLogs_AVERAGE_LTE?: number | null;
  filterCaseLogs_EQUAL?: string | null;
  filterCaseLogs_GT?: number | null;
  filterCaseLogs_GTE?: number | null;
  filterCaseLogs_LONGEST_EQUAL?: number | null;
  filterCaseLogs_LONGEST_GT?: number | null;
  filterCaseLogs_LONGEST_GTE?: number | null;
  filterCaseLogs_LONGEST_LT?: number | null;
  filterCaseLogs_LONGEST_LTE?: number | null;
  filterCaseLogs_LT?: number | null;
  filterCaseLogs_LTE?: number | null;
  filterCaseLogs_SHORTEST_EQUAL?: number | null;
  filterCaseLogs_SHORTEST_GT?: number | null;
  filterCaseLogs_SHORTEST_GTE?: number | null;
  filterCaseLogs_SHORTEST_LT?: number | null;
  filterCaseLogs_SHORTEST_LTE?: number | null;
  filtersAgreements_AVERAGE_EQUAL?: number | null;
  filtersAgreements_AVERAGE_GT?: number | null;
  filtersAgreements_AVERAGE_GTE?: number | null;
  filtersAgreements_AVERAGE_LT?: number | null;
  filtersAgreements_AVERAGE_LTE?: number | null;
  filtersAgreements_EQUAL?: string | null;
  filtersAgreements_GT?: number | null;
  filtersAgreements_GTE?: number | null;
  filtersAgreements_LONGEST_EQUAL?: number | null;
  filtersAgreements_LONGEST_GT?: number | null;
  filtersAgreements_LONGEST_GTE?: number | null;
  filtersAgreements_LONGEST_LT?: number | null;
  filtersAgreements_LONGEST_LTE?: number | null;
  filtersAgreements_LT?: number | null;
  filtersAgreements_LTE?: number | null;
  filtersAgreements_SHORTEST_EQUAL?: number | null;
  filtersAgreements_SHORTEST_GT?: number | null;
  filtersAgreements_SHORTEST_GTE?: number | null;
  filtersAgreements_SHORTEST_LT?: number | null;
  filtersAgreements_SHORTEST_LTE?: number | null;
  filtersCases_AVERAGE_EQUAL?: number | null;
  filtersCases_AVERAGE_GT?: number | null;
  filtersCases_AVERAGE_GTE?: number | null;
  filtersCases_AVERAGE_LT?: number | null;
  filtersCases_AVERAGE_LTE?: number | null;
  filtersCases_EQUAL?: string | null;
  filtersCases_GT?: number | null;
  filtersCases_GTE?: number | null;
  filtersCases_LONGEST_EQUAL?: number | null;
  filtersCases_LONGEST_GT?: number | null;
  filtersCases_LONGEST_GTE?: number | null;
  filtersCases_LONGEST_LT?: number | null;
  filtersCases_LONGEST_LTE?: number | null;
  filtersCases_LT?: number | null;
  filtersCases_LTE?: number | null;
  filtersCases_SHORTEST_EQUAL?: number | null;
  filtersCases_SHORTEST_GT?: number | null;
  filtersCases_SHORTEST_GTE?: number | null;
  filtersCases_SHORTEST_LT?: number | null;
  filtersCases_SHORTEST_LTE?: number | null;
  filtersDataForms_AVERAGE_EQUAL?: number | null;
  filtersDataForms_AVERAGE_GT?: number | null;
  filtersDataForms_AVERAGE_GTE?: number | null;
  filtersDataForms_AVERAGE_LT?: number | null;
  filtersDataForms_AVERAGE_LTE?: number | null;
  filtersDataForms_EQUAL?: string | null;
  filtersDataForms_GT?: number | null;
  filtersDataForms_GTE?: number | null;
  filtersDataForms_LONGEST_EQUAL?: number | null;
  filtersDataForms_LONGEST_GT?: number | null;
  filtersDataForms_LONGEST_GTE?: number | null;
  filtersDataForms_LONGEST_LT?: number | null;
  filtersDataForms_LONGEST_LTE?: number | null;
  filtersDataForms_LT?: number | null;
  filtersDataForms_LTE?: number | null;
  filtersDataForms_SHORTEST_EQUAL?: number | null;
  filtersDataForms_SHORTEST_GT?: number | null;
  filtersDataForms_SHORTEST_GTE?: number | null;
  filtersDataForms_SHORTEST_LT?: number | null;
  filtersDataForms_SHORTEST_LTE?: number | null;
  filtersDataRecords_AVERAGE_EQUAL?: number | null;
  filtersDataRecords_AVERAGE_GT?: number | null;
  filtersDataRecords_AVERAGE_GTE?: number | null;
  filtersDataRecords_AVERAGE_LT?: number | null;
  filtersDataRecords_AVERAGE_LTE?: number | null;
  filtersDataRecords_EQUAL?: string | null;
  filtersDataRecords_GT?: number | null;
  filtersDataRecords_GTE?: number | null;
  filtersDataRecords_LONGEST_EQUAL?: number | null;
  filtersDataRecords_LONGEST_GT?: number | null;
  filtersDataRecords_LONGEST_GTE?: number | null;
  filtersDataRecords_LONGEST_LT?: number | null;
  filtersDataRecords_LONGEST_LTE?: number | null;
  filtersDataRecords_LT?: number | null;
  filtersDataRecords_LTE?: number | null;
  filtersDataRecords_SHORTEST_EQUAL?: number | null;
  filtersDataRecords_SHORTEST_GT?: number | null;
  filtersDataRecords_SHORTEST_GTE?: number | null;
  filtersDataRecords_SHORTEST_LT?: number | null;
  filtersDataRecords_SHORTEST_LTE?: number | null;
  filtersDocuments_AVERAGE_EQUAL?: number | null;
  filtersDocuments_AVERAGE_GT?: number | null;
  filtersDocuments_AVERAGE_GTE?: number | null;
  filtersDocuments_AVERAGE_LT?: number | null;
  filtersDocuments_AVERAGE_LTE?: number | null;
  filtersDocuments_EQUAL?: string | null;
  filtersDocuments_GT?: number | null;
  filtersDocuments_GTE?: number | null;
  filtersDocuments_LONGEST_EQUAL?: number | null;
  filtersDocuments_LONGEST_GT?: number | null;
  filtersDocuments_LONGEST_GTE?: number | null;
  filtersDocuments_LONGEST_LT?: number | null;
  filtersDocuments_LONGEST_LTE?: number | null;
  filtersDocuments_LT?: number | null;
  filtersDocuments_LTE?: number | null;
  filtersDocuments_SHORTEST_EQUAL?: number | null;
  filtersDocuments_SHORTEST_GT?: number | null;
  filtersDocuments_SHORTEST_GTE?: number | null;
  filtersDocuments_SHORTEST_LT?: number | null;
  filtersDocuments_SHORTEST_LTE?: number | null;
  filtersRefunds_AVERAGE_EQUAL?: number | null;
  filtersRefunds_AVERAGE_GT?: number | null;
  filtersRefunds_AVERAGE_GTE?: number | null;
  filtersRefunds_AVERAGE_LT?: number | null;
  filtersRefunds_AVERAGE_LTE?: number | null;
  filtersRefunds_EQUAL?: string | null;
  filtersRefunds_GT?: number | null;
  filtersRefunds_GTE?: number | null;
  filtersRefunds_LONGEST_EQUAL?: number | null;
  filtersRefunds_LONGEST_GT?: number | null;
  filtersRefunds_LONGEST_GTE?: number | null;
  filtersRefunds_LONGEST_LT?: number | null;
  filtersRefunds_LONGEST_LTE?: number | null;
  filtersRefunds_LT?: number | null;
  filtersRefunds_LTE?: number | null;
  filtersRefunds_SHORTEST_EQUAL?: number | null;
  filtersRefunds_SHORTEST_GT?: number | null;
  filtersRefunds_SHORTEST_GTE?: number | null;
  filtersRefunds_SHORTEST_LT?: number | null;
  filtersRefunds_SHORTEST_LTE?: number | null;
  filtersSimulations_AVERAGE_EQUAL?: number | null;
  filtersSimulations_AVERAGE_GT?: number | null;
  filtersSimulations_AVERAGE_GTE?: number | null;
  filtersSimulations_AVERAGE_LT?: number | null;
  filtersSimulations_AVERAGE_LTE?: number | null;
  filtersSimulations_EQUAL?: string | null;
  filtersSimulations_GT?: number | null;
  filtersSimulations_GTE?: number | null;
  filtersSimulations_LONGEST_EQUAL?: number | null;
  filtersSimulations_LONGEST_GT?: number | null;
  filtersSimulations_LONGEST_GTE?: number | null;
  filtersSimulations_LONGEST_LT?: number | null;
  filtersSimulations_LONGEST_LTE?: number | null;
  filtersSimulations_LT?: number | null;
  filtersSimulations_LTE?: number | null;
  filtersSimulations_SHORTEST_EQUAL?: number | null;
  filtersSimulations_SHORTEST_GT?: number | null;
  filtersSimulations_SHORTEST_GTE?: number | null;
  filtersSimulations_SHORTEST_LT?: number | null;
  filtersSimulations_SHORTEST_LTE?: number | null;
  timePeriodCaseDetails_AVERAGE_EQUAL?: number | null;
  timePeriodCaseDetails_AVERAGE_GT?: number | null;
  timePeriodCaseDetails_AVERAGE_GTE?: number | null;
  timePeriodCaseDetails_AVERAGE_LT?: number | null;
  timePeriodCaseDetails_AVERAGE_LTE?: number | null;
  timePeriodCaseDetails_EQUAL?: string | null;
  timePeriodCaseDetails_GT?: number | null;
  timePeriodCaseDetails_GTE?: number | null;
  timePeriodCaseDetails_LONGEST_EQUAL?: number | null;
  timePeriodCaseDetails_LONGEST_GT?: number | null;
  timePeriodCaseDetails_LONGEST_GTE?: number | null;
  timePeriodCaseDetails_LONGEST_LT?: number | null;
  timePeriodCaseDetails_LONGEST_LTE?: number | null;
  timePeriodCaseDetails_LT?: number | null;
  timePeriodCaseDetails_LTE?: number | null;
  timePeriodCaseDetails_SHORTEST_EQUAL?: number | null;
  timePeriodCaseDetails_SHORTEST_GT?: number | null;
  timePeriodCaseDetails_SHORTEST_GTE?: number | null;
  timePeriodCaseDetails_SHORTEST_LT?: number | null;
  timePeriodCaseDetails_SHORTEST_LTE?: number | null;
  timePeriodFilterDashboard_AVERAGE_EQUAL?: number | null;
  timePeriodFilterDashboard_AVERAGE_GT?: number | null;
  timePeriodFilterDashboard_AVERAGE_GTE?: number | null;
  timePeriodFilterDashboard_AVERAGE_LT?: number | null;
  timePeriodFilterDashboard_AVERAGE_LTE?: number | null;
  timePeriodFilterDashboard_EQUAL?: string | null;
  timePeriodFilterDashboard_GT?: number | null;
  timePeriodFilterDashboard_GTE?: number | null;
  timePeriodFilterDashboard_LONGEST_EQUAL?: number | null;
  timePeriodFilterDashboard_LONGEST_GT?: number | null;
  timePeriodFilterDashboard_LONGEST_GTE?: number | null;
  timePeriodFilterDashboard_LONGEST_LT?: number | null;
  timePeriodFilterDashboard_LONGEST_LTE?: number | null;
  timePeriodFilterDashboard_LT?: number | null;
  timePeriodFilterDashboard_LTE?: number | null;
  timePeriodFilterDashboard_SHORTEST_EQUAL?: number | null;
  timePeriodFilterDashboard_SHORTEST_GT?: number | null;
  timePeriodFilterDashboard_SHORTEST_GTE?: number | null;
  timePeriodFilterDashboard_SHORTEST_LT?: number | null;
  timePeriodFilterDashboard_SHORTEST_LTE?: number | null;
  timePeriodFilterHome_AVERAGE_EQUAL?: number | null;
  timePeriodFilterHome_AVERAGE_GT?: number | null;
  timePeriodFilterHome_AVERAGE_GTE?: number | null;
  timePeriodFilterHome_AVERAGE_LT?: number | null;
  timePeriodFilterHome_AVERAGE_LTE?: number | null;
  timePeriodFilterHome_EQUAL?: string | null;
  timePeriodFilterHome_GT?: number | null;
  timePeriodFilterHome_GTE?: number | null;
  timePeriodFilterHome_LONGEST_EQUAL?: number | null;
  timePeriodFilterHome_LONGEST_GT?: number | null;
  timePeriodFilterHome_LONGEST_GTE?: number | null;
  timePeriodFilterHome_LONGEST_LT?: number | null;
  timePeriodFilterHome_LONGEST_LTE?: number | null;
  timePeriodFilterHome_LT?: number | null;
  timePeriodFilterHome_LTE?: number | null;
  timePeriodFilterHome_SHORTEST_EQUAL?: number | null;
  timePeriodFilterHome_SHORTEST_GT?: number | null;
  timePeriodFilterHome_SHORTEST_GTE?: number | null;
  timePeriodFilterHome_SHORTEST_LT?: number | null;
  timePeriodFilterHome_SHORTEST_LTE?: number | null;
  timePeriodFilterReporting_AVERAGE_EQUAL?: number | null;
  timePeriodFilterReporting_AVERAGE_GT?: number | null;
  timePeriodFilterReporting_AVERAGE_GTE?: number | null;
  timePeriodFilterReporting_AVERAGE_LT?: number | null;
  timePeriodFilterReporting_AVERAGE_LTE?: number | null;
  timePeriodFilterReporting_EQUAL?: string | null;
  timePeriodFilterReporting_GT?: number | null;
  timePeriodFilterReporting_GTE?: number | null;
  timePeriodFilterReporting_LONGEST_EQUAL?: number | null;
  timePeriodFilterReporting_LONGEST_GT?: number | null;
  timePeriodFilterReporting_LONGEST_GTE?: number | null;
  timePeriodFilterReporting_LONGEST_LT?: number | null;
  timePeriodFilterReporting_LONGEST_LTE?: number | null;
  timePeriodFilterReporting_LT?: number | null;
  timePeriodFilterReporting_LTE?: number | null;
  timePeriodFilterReporting_SHORTEST_EQUAL?: number | null;
  timePeriodFilterReporting_SHORTEST_GT?: number | null;
  timePeriodFilterReporting_SHORTEST_GTE?: number | null;
  timePeriodFilterReporting_SHORTEST_LT?: number | null;
  timePeriodFilterReporting_SHORTEST_LTE?: number | null;
}

export interface UserContextScenariosAggregateInput {
  AND?: UserContextScenariosAggregateInput[] | null;
  OR?: UserContextScenariosAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  edge?: UserContextScenariosEdgeAggregationWhereInput | null;
  node?: UserContextScenariosNodeAggregationWhereInput | null;
}

export interface UserContextScenariosConnectionWhere {
  AND?: UserContextScenariosConnectionWhere[] | null;
  OR?: UserContextScenariosConnectionWhere[] | null;
  edge?: ScenarioInsightsUserContextWhere | null;
  edge_NOT?: ScenarioInsightsUserContextWhere | null;
  node?: ScenarioWhere | null;
  node_NOT?: ScenarioWhere | null;
}

export interface UserContextScenariosEdgeAggregationWhereInput {
  AND?: UserContextScenariosEdgeAggregationWhereInput[] | null;
  OR?: UserContextScenariosEdgeAggregationWhereInput[] | null;
  categoryInput_AVERAGE_EQUAL?: number | null;
  categoryInput_AVERAGE_GT?: number | null;
  categoryInput_AVERAGE_GTE?: number | null;
  categoryInput_AVERAGE_LT?: number | null;
  categoryInput_AVERAGE_LTE?: number | null;
  categoryInput_EQUAL?: string | null;
  categoryInput_GT?: number | null;
  categoryInput_GTE?: number | null;
  categoryInput_LONGEST_EQUAL?: number | null;
  categoryInput_LONGEST_GT?: number | null;
  categoryInput_LONGEST_GTE?: number | null;
  categoryInput_LONGEST_LT?: number | null;
  categoryInput_LONGEST_LTE?: number | null;
  categoryInput_LT?: number | null;
  categoryInput_LTE?: number | null;
  categoryInput_SHORTEST_EQUAL?: number | null;
  categoryInput_SHORTEST_GT?: number | null;
  categoryInput_SHORTEST_GTE?: number | null;
  categoryInput_SHORTEST_LT?: number | null;
  categoryInput_SHORTEST_LTE?: number | null;
  rebateObjective_AVERAGE_EQUAL?: number | null;
  rebateObjective_AVERAGE_GT?: number | null;
  rebateObjective_AVERAGE_GTE?: number | null;
  rebateObjective_AVERAGE_LT?: number | null;
  rebateObjective_AVERAGE_LTE?: number | null;
  rebateObjective_EQUAL?: string | null;
  rebateObjective_GT?: number | null;
  rebateObjective_GTE?: number | null;
  rebateObjective_LONGEST_EQUAL?: number | null;
  rebateObjective_LONGEST_GT?: number | null;
  rebateObjective_LONGEST_GTE?: number | null;
  rebateObjective_LONGEST_LT?: number | null;
  rebateObjective_LONGEST_LTE?: number | null;
  rebateObjective_LT?: number | null;
  rebateObjective_LTE?: number | null;
  rebateObjective_SHORTEST_EQUAL?: number | null;
  rebateObjective_SHORTEST_GT?: number | null;
  rebateObjective_SHORTEST_GTE?: number | null;
  rebateObjective_SHORTEST_LT?: number | null;
  rebateObjective_SHORTEST_LTE?: number | null;
  timeframeLabel_AVERAGE_EQUAL?: number | null;
  timeframeLabel_AVERAGE_GT?: number | null;
  timeframeLabel_AVERAGE_GTE?: number | null;
  timeframeLabel_AVERAGE_LT?: number | null;
  timeframeLabel_AVERAGE_LTE?: number | null;
  timeframeLabel_EQUAL?: string | null;
  timeframeLabel_GT?: number | null;
  timeframeLabel_GTE?: number | null;
  timeframeLabel_LONGEST_EQUAL?: number | null;
  timeframeLabel_LONGEST_GT?: number | null;
  timeframeLabel_LONGEST_GTE?: number | null;
  timeframeLabel_LONGEST_LT?: number | null;
  timeframeLabel_LONGEST_LTE?: number | null;
  timeframeLabel_LT?: number | null;
  timeframeLabel_LTE?: number | null;
  timeframeLabel_SHORTEST_EQUAL?: number | null;
  timeframeLabel_SHORTEST_GT?: number | null;
  timeframeLabel_SHORTEST_GTE?: number | null;
  timeframeLabel_SHORTEST_LT?: number | null;
  timeframeLabel_SHORTEST_LTE?: number | null;
}

export interface UserContextScenariosNodeAggregationWhereInput {
  AND?: UserContextScenariosNodeAggregationWhereInput[] | null;
  OR?: UserContextScenariosNodeAggregationWhereInput[] | null;
  group_AVERAGE_EQUAL?: number | null;
  group_AVERAGE_GT?: number | null;
  group_AVERAGE_GTE?: number | null;
  group_AVERAGE_LT?: number | null;
  group_AVERAGE_LTE?: number | null;
  group_EQUAL?: number | null;
  group_GT?: number | null;
  group_GTE?: number | null;
  group_LT?: number | null;
  group_LTE?: number | null;
  group_MAX_EQUAL?: number | null;
  group_MAX_GT?: number | null;
  group_MAX_GTE?: number | null;
  group_MAX_LT?: number | null;
  group_MAX_LTE?: number | null;
  group_MIN_EQUAL?: number | null;
  group_MIN_GT?: number | null;
  group_MIN_GTE?: number | null;
  group_MIN_LT?: number | null;
  group_MIN_LTE?: number | null;
  group_SUM_EQUAL?: number | null;
  group_SUM_GT?: number | null;
  group_SUM_GTE?: number | null;
  group_SUM_LT?: number | null;
  group_SUM_LTE?: number | null;
  order_AVERAGE_EQUAL?: number | null;
  order_AVERAGE_GT?: number | null;
  order_AVERAGE_GTE?: number | null;
  order_AVERAGE_LT?: number | null;
  order_AVERAGE_LTE?: number | null;
  order_EQUAL?: number | null;
  order_GT?: number | null;
  order_GTE?: number | null;
  order_LT?: number | null;
  order_LTE?: number | null;
  order_MAX_EQUAL?: number | null;
  order_MAX_GT?: number | null;
  order_MAX_GTE?: number | null;
  order_MAX_LT?: number | null;
  order_MAX_LTE?: number | null;
  order_MIN_EQUAL?: number | null;
  order_MIN_GT?: number | null;
  order_MIN_GTE?: number | null;
  order_MIN_LT?: number | null;
  order_MIN_LTE?: number | null;
  order_SUM_EQUAL?: number | null;
  order_SUM_GT?: number | null;
  order_SUM_GTE?: number | null;
  order_SUM_LT?: number | null;
  order_SUM_LTE?: number | null;
}

export interface UserContextWhere {
  AND?: UserContextWhere[] | null;
  OR?: UserContextWhere[] | null;
  agreementsTableColumns?: string[] | null;
  agreementsTableColumns_INCLUDES?: string | null;
  agreementsTableColumns_NOT?: string[] | null;
  agreementsTableColumns_NOT_INCLUDES?: string | null;
  baseAgreementContext?: BaseAgreementWhere | null;
  baseAgreementContextAggregate?: UserContextBaseAgreementContextAggregateInput | null;
  baseAgreementContextConnection?: UserContextBaseAgreementContextConnectionWhere | null;
  baseAgreementContextConnection_NOT?: UserContextBaseAgreementContextConnectionWhere | null;
  baseAgreementContext_NOT?: BaseAgreementWhere | null;
  simulationsTableColumns?: string[] | null;
  simulationsTableColumns_INCLUDES?: string | null;
  simulationsTableColumns_NOT?: string[] | null;
  simulationsTableColumns_NOT_INCLUDES?: string | null;
  email?: string | null;
  email_CONTAINS?: string | null;
  email_ENDS_WITH?: string | null;
  email_IN?: (string | null)[] | null;
  email_MATCHES?: string | null;
  email_NOT?: string | null;
  email_NOT_CONTAINS?: string | null;
  email_NOT_ENDS_WITH?: string | null;
  email_NOT_IN?: (string | null)[] | null;
  email_NOT_STARTS_WITH?: string | null;
  email_STARTS_WITH?: string | null;
  filterCaseLogs?: string | null;
  filterCaseLogs_CONTAINS?: string | null;
  filterCaseLogs_ENDS_WITH?: string | null;
  filterCaseLogs_IN?: (string | null)[] | null;
  filterCaseLogs_MATCHES?: string | null;
  filterCaseLogs_NOT?: string | null;
  filterCaseLogs_NOT_CONTAINS?: string | null;
  filterCaseLogs_NOT_ENDS_WITH?: string | null;
  filterCaseLogs_NOT_IN?: (string | null)[] | null;
  filterCaseLogs_NOT_STARTS_WITH?: string | null;
  filterCaseLogs_STARTS_WITH?: string | null;
  filtersAgreements?: string | null;
  filtersAgreements_CONTAINS?: string | null;
  filtersAgreements_ENDS_WITH?: string | null;
  filtersAgreements_IN?: (string | null)[] | null;
  filtersAgreements_MATCHES?: string | null;
  filtersAgreements_NOT?: string | null;
  filtersAgreements_NOT_CONTAINS?: string | null;
  filtersAgreements_NOT_ENDS_WITH?: string | null;
  filtersAgreements_NOT_IN?: (string | null)[] | null;
  filtersAgreements_NOT_STARTS_WITH?: string | null;
  filtersAgreements_STARTS_WITH?: string | null;
  filtersCases?: string | null;
  filtersCases_CONTAINS?: string | null;
  filtersCases_ENDS_WITH?: string | null;
  filtersCases_IN?: (string | null)[] | null;
  filtersCases_MATCHES?: string | null;
  filtersCases_NOT?: string | null;
  filtersCases_NOT_CONTAINS?: string | null;
  filtersCases_NOT_ENDS_WITH?: string | null;
  filtersCases_NOT_IN?: (string | null)[] | null;
  filtersCases_NOT_STARTS_WITH?: string | null;
  filtersCases_STARTS_WITH?: string | null;
  filtersDataForms?: string | null;
  filtersDataForms_CONTAINS?: string | null;
  filtersDataForms_ENDS_WITH?: string | null;
  filtersDataForms_IN?: (string | null)[] | null;
  filtersDataForms_MATCHES?: string | null;
  filtersDataForms_NOT?: string | null;
  filtersDataForms_NOT_CONTAINS?: string | null;
  filtersDataForms_NOT_ENDS_WITH?: string | null;
  filtersDataForms_NOT_IN?: (string | null)[] | null;
  filtersDataForms_NOT_STARTS_WITH?: string | null;
  filtersDataForms_STARTS_WITH?: string | null;
  filtersDataRecords?: string | null;
  filtersDataRecords_CONTAINS?: string | null;
  filtersDataRecords_ENDS_WITH?: string | null;
  filtersDataRecords_IN?: (string | null)[] | null;
  filtersDataRecords_MATCHES?: string | null;
  filtersDataRecords_NOT?: string | null;
  filtersDataRecords_NOT_CONTAINS?: string | null;
  filtersDataRecords_NOT_ENDS_WITH?: string | null;
  filtersDataRecords_NOT_IN?: (string | null)[] | null;
  filtersDataRecords_NOT_STARTS_WITH?: string | null;
  filtersDataRecords_STARTS_WITH?: string | null;
  filtersDocuments?: string | null;
  filtersDocuments_CONTAINS?: string | null;
  filtersDocuments_ENDS_WITH?: string | null;
  filtersDocuments_IN?: (string | null)[] | null;
  filtersDocuments_MATCHES?: string | null;
  filtersDocuments_NOT?: string | null;
  filtersDocuments_NOT_CONTAINS?: string | null;
  filtersDocuments_NOT_ENDS_WITH?: string | null;
  filtersDocuments_NOT_IN?: (string | null)[] | null;
  filtersDocuments_NOT_STARTS_WITH?: string | null;
  filtersDocuments_STARTS_WITH?: string | null;
  filtersRefunds?: string | null;
  filtersRefunds_CONTAINS?: string | null;
  filtersRefunds_ENDS_WITH?: string | null;
  filtersRefunds_IN?: (string | null)[] | null;
  filtersRefunds_MATCHES?: string | null;
  filtersRefunds_NOT?: string | null;
  filtersRefunds_NOT_CONTAINS?: string | null;
  filtersRefunds_NOT_ENDS_WITH?: string | null;
  filtersRefunds_NOT_IN?: (string | null)[] | null;
  filtersRefunds_NOT_STARTS_WITH?: string | null;
  filtersRefunds_STARTS_WITH?: string | null;
  filtersSimulations?: string | null;
  filtersSimulations_CONTAINS?: string | null;
  filtersSimulations_ENDS_WITH?: string | null;
  filtersSimulations_IN?: (string | null)[] | null;
  filtersSimulations_MATCHES?: string | null;
  filtersSimulations_NOT?: string | null;
  filtersSimulations_NOT_CONTAINS?: string | null;
  filtersSimulations_NOT_ENDS_WITH?: string | null;
  filtersSimulations_NOT_IN?: (string | null)[] | null;
  filtersSimulations_NOT_STARTS_WITH?: string | null;
  filtersSimulations_STARTS_WITH?: string | null;
  scenarios?: ScenarioWhere | null;
  scenariosAggregate?: UserContextScenariosAggregateInput | null;
  scenariosConnection?: UserContextScenariosConnectionWhere | null;
  scenariosConnection_NOT?: UserContextScenariosConnectionWhere | null;
  scenarios_NOT?: ScenarioWhere | null;
  timePeriodCaseDetails?: string | null;
  timePeriodCaseDetails_CONTAINS?: string | null;
  timePeriodCaseDetails_ENDS_WITH?: string | null;
  timePeriodCaseDetails_IN?: (string | null)[] | null;
  timePeriodCaseDetails_MATCHES?: string | null;
  timePeriodCaseDetails_NOT?: string | null;
  timePeriodCaseDetails_NOT_CONTAINS?: string | null;
  timePeriodCaseDetails_NOT_ENDS_WITH?: string | null;
  timePeriodCaseDetails_NOT_IN?: (string | null)[] | null;
  timePeriodCaseDetails_NOT_STARTS_WITH?: string | null;
  timePeriodCaseDetails_STARTS_WITH?: string | null;
  timePeriodFilterDashboard?: string | null;
  timePeriodFilterDashboard_CONTAINS?: string | null;
  timePeriodFilterDashboard_ENDS_WITH?: string | null;
  timePeriodFilterDashboard_IN?: (string | null)[] | null;
  timePeriodFilterDashboard_MATCHES?: string | null;
  timePeriodFilterDashboard_NOT?: string | null;
  timePeriodFilterDashboard_NOT_CONTAINS?: string | null;
  timePeriodFilterDashboard_NOT_ENDS_WITH?: string | null;
  timePeriodFilterDashboard_NOT_IN?: (string | null)[] | null;
  timePeriodFilterDashboard_NOT_STARTS_WITH?: string | null;
  timePeriodFilterDashboard_STARTS_WITH?: string | null;
  timePeriodFilterHome?: string | null;
  timePeriodFilterHome_CONTAINS?: string | null;
  timePeriodFilterHome_ENDS_WITH?: string | null;
  timePeriodFilterHome_IN?: (string | null)[] | null;
  timePeriodFilterHome_MATCHES?: string | null;
  timePeriodFilterHome_NOT?: string | null;
  timePeriodFilterHome_NOT_CONTAINS?: string | null;
  timePeriodFilterHome_NOT_ENDS_WITH?: string | null;
  timePeriodFilterHome_NOT_IN?: (string | null)[] | null;
  timePeriodFilterHome_NOT_STARTS_WITH?: string | null;
  timePeriodFilterHome_STARTS_WITH?: string | null;
  timePeriodFilterReporting?: string | null;
  timePeriodFilterReporting_CONTAINS?: string | null;
  timePeriodFilterReporting_ENDS_WITH?: string | null;
  timePeriodFilterReporting_IN?: (string | null)[] | null;
  timePeriodFilterReporting_MATCHES?: string | null;
  timePeriodFilterReporting_NOT?: string | null;
  timePeriodFilterReporting_NOT_CONTAINS?: string | null;
  timePeriodFilterReporting_NOT_ENDS_WITH?: string | null;
  timePeriodFilterReporting_NOT_IN?: (string | null)[] | null;
  timePeriodFilterReporting_NOT_STARTS_WITH?: string | null;
  timePeriodFilterReporting_STARTS_WITH?: string | null;
}

export interface UserCreatedUserNotificationAggregateInput {
  AND?: UserCreatedUserNotificationAggregateInput[] | null;
  OR?: UserCreatedUserNotificationAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: UserCreatedUserNotificationNodeAggregationWhereInput | null;
}

export interface UserCreatedUserNotificationConnectionWhere {
  AND?: UserCreatedUserNotificationConnectionWhere[] | null;
  OR?: UserCreatedUserNotificationConnectionWhere[] | null;
  node?: UserNotificationWhere | null;
  node_NOT?: UserNotificationWhere | null;
}

export interface UserCreatedUserNotificationNodeAggregationWhereInput {
  AND?: UserCreatedUserNotificationNodeAggregationWhereInput[] | null;
  OR?: UserCreatedUserNotificationNodeAggregationWhereInput[] | null;
  timeStamp_AVERAGE_EQUAL?: number | null;
  timeStamp_AVERAGE_GT?: number | null;
  timeStamp_AVERAGE_GTE?: number | null;
  timeStamp_AVERAGE_LT?: number | null;
  timeStamp_AVERAGE_LTE?: number | null;
  timeStamp_EQUAL?: number | null;
  timeStamp_GT?: number | null;
  timeStamp_GTE?: number | null;
  timeStamp_LT?: number | null;
  timeStamp_LTE?: number | null;
  timeStamp_MAX_EQUAL?: number | null;
  timeStamp_MAX_GT?: number | null;
  timeStamp_MAX_GTE?: number | null;
  timeStamp_MAX_LT?: number | null;
  timeStamp_MAX_LTE?: number | null;
  timeStamp_MIN_EQUAL?: number | null;
  timeStamp_MIN_GT?: number | null;
  timeStamp_MIN_GTE?: number | null;
  timeStamp_MIN_LT?: number | null;
  timeStamp_MIN_LTE?: number | null;
  timeStamp_SUM_EQUAL?: number | null;
  timeStamp_SUM_GT?: number | null;
  timeStamp_SUM_GTE?: number | null;
  timeStamp_SUM_LT?: number | null;
  timeStamp_SUM_LTE?: number | null;
}

export interface UserMentionsAggregateInput {
  AND?: UserMentionsAggregateInput[] | null;
  OR?: UserMentionsAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: UserMentionsNodeAggregationWhereInput | null;
}

export interface UserMentionsConnectionWhere {
  AND?: UserMentionsConnectionWhere[] | null;
  OR?: UserMentionsConnectionWhere[] | null;
  node?: MessageWhere | null;
  node_NOT?: MessageWhere | null;
}

export interface UserMentionsNodeAggregationWhereInput {
  AND?: UserMentionsNodeAggregationWhereInput[] | null;
  OR?: UserMentionsNodeAggregationWhereInput[] | null;
  content_AVERAGE_EQUAL?: number | null;
  content_AVERAGE_GT?: number | null;
  content_AVERAGE_GTE?: number | null;
  content_AVERAGE_LT?: number | null;
  content_AVERAGE_LTE?: number | null;
  content_EQUAL?: string | null;
  content_GT?: number | null;
  content_GTE?: number | null;
  content_LONGEST_EQUAL?: number | null;
  content_LONGEST_GT?: number | null;
  content_LONGEST_GTE?: number | null;
  content_LONGEST_LT?: number | null;
  content_LONGEST_LTE?: number | null;
  content_LT?: number | null;
  content_LTE?: number | null;
  content_SHORTEST_EQUAL?: number | null;
  content_SHORTEST_GT?: number | null;
  content_SHORTEST_GTE?: number | null;
  content_SHORTEST_LT?: number | null;
  content_SHORTEST_LTE?: number | null;
  createdOn_AVERAGE_EQUAL?: number | null;
  createdOn_AVERAGE_GT?: number | null;
  createdOn_AVERAGE_GTE?: number | null;
  createdOn_AVERAGE_LT?: number | null;
  createdOn_AVERAGE_LTE?: number | null;
  createdOn_EQUAL?: number | null;
  createdOn_GT?: number | null;
  createdOn_GTE?: number | null;
  createdOn_LT?: number | null;
  createdOn_LTE?: number | null;
  createdOn_MAX_EQUAL?: number | null;
  createdOn_MAX_GT?: number | null;
  createdOn_MAX_GTE?: number | null;
  createdOn_MAX_LT?: number | null;
  createdOn_MAX_LTE?: number | null;
  createdOn_MIN_EQUAL?: number | null;
  createdOn_MIN_GT?: number | null;
  createdOn_MIN_GTE?: number | null;
  createdOn_MIN_LT?: number | null;
  createdOn_MIN_LTE?: number | null;
  createdOn_SUM_EQUAL?: number | null;
  createdOn_SUM_GT?: number | null;
  createdOn_SUM_GTE?: number | null;
  createdOn_SUM_LT?: number | null;
  createdOn_SUM_LTE?: number | null;
}

export interface UserMessageRelationshipWhere {
  AND?: UserMessageRelationshipWhere[] | null;
  OR?: UserMessageRelationshipWhere[] | null;
  nodeContext?: string | null;
  nodeContext_CONTAINS?: string | null;
  nodeContext_ENDS_WITH?: string | null;
  nodeContext_IN?: (string | null)[] | null;
  nodeContext_MATCHES?: string | null;
  nodeContext_NOT?: string | null;
  nodeContext_NOT_CONTAINS?: string | null;
  nodeContext_NOT_ENDS_WITH?: string | null;
  nodeContext_NOT_IN?: (string | null)[] | null;
  nodeContext_NOT_STARTS_WITH?: string | null;
  nodeContext_STARTS_WITH?: string | null;
  nodeId?: string | null;
  nodeId_CONTAINS?: string | null;
  nodeId_ENDS_WITH?: string | null;
  nodeId_IN?: (string | null)[] | null;
  nodeId_MATCHES?: string | null;
  nodeId_NOT?: string | null;
  nodeId_NOT_CONTAINS?: string | null;
  nodeId_NOT_ENDS_WITH?: string | null;
  nodeId_NOT_IN?: (string | null)[] | null;
  nodeId_NOT_STARTS_WITH?: string | null;
  nodeId_STARTS_WITH?: string | null;
  nodeLabel?: SupportedMessageNodes | null;
  nodeLabel_IN?: (SupportedMessageNodes | null)[] | null;
  nodeLabel_NOT?: SupportedMessageNodes | null;
  nodeLabel_NOT_IN?: (SupportedMessageNodes | null)[] | null;
}

export interface UserNegotiationRoundsAggregateInput {
  AND?: UserNegotiationRoundsAggregateInput[] | null;
  OR?: UserNegotiationRoundsAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: UserNegotiationRoundsNodeAggregationWhereInput | null;
}

export interface UserNegotiationRoundsConnectionWhere {
  AND?: UserNegotiationRoundsConnectionWhere[] | null;
  OR?: UserNegotiationRoundsConnectionWhere[] | null;
  node?: NegotiationRoundWhere | null;
  node_NOT?: NegotiationRoundWhere | null;
}

export interface UserNegotiationRoundsNodeAggregationWhereInput {
  AND?: UserNegotiationRoundsNodeAggregationWhereInput[] | null;
  OR?: UserNegotiationRoundsNodeAggregationWhereInput[] | null;
  changedOn_EQUAL?: any | null;
  changedOn_GT?: any | null;
  changedOn_GTE?: any | null;
  changedOn_LT?: any | null;
  changedOn_LTE?: any | null;
  changedOn_MAX_EQUAL?: any | null;
  changedOn_MAX_GT?: any | null;
  changedOn_MAX_GTE?: any | null;
  changedOn_MAX_LT?: any | null;
  changedOn_MAX_LTE?: any | null;
  changedOn_MIN_EQUAL?: any | null;
  changedOn_MIN_GT?: any | null;
  changedOn_MIN_GTE?: any | null;
  changedOn_MIN_LT?: any | null;
  changedOn_MIN_LTE?: any | null;
  data_AVERAGE_EQUAL?: number | null;
  data_AVERAGE_GT?: number | null;
  data_AVERAGE_GTE?: number | null;
  data_AVERAGE_LT?: number | null;
  data_AVERAGE_LTE?: number | null;
  data_EQUAL?: string | null;
  data_GT?: number | null;
  data_GTE?: number | null;
  data_LONGEST_EQUAL?: number | null;
  data_LONGEST_GT?: number | null;
  data_LONGEST_GTE?: number | null;
  data_LONGEST_LT?: number | null;
  data_LONGEST_LTE?: number | null;
  data_LT?: number | null;
  data_LTE?: number | null;
  data_SHORTEST_EQUAL?: number | null;
  data_SHORTEST_GT?: number | null;
  data_SHORTEST_GTE?: number | null;
  data_SHORTEST_LT?: number | null;
  data_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
}

export interface UserNotificationCreatorAggregateInput {
  AND?: UserNotificationCreatorAggregateInput[] | null;
  OR?: UserNotificationCreatorAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: UserNotificationCreatorNodeAggregationWhereInput | null;
}

export interface UserNotificationCreatorConnectionWhere {
  AND?: UserNotificationCreatorConnectionWhere[] | null;
  OR?: UserNotificationCreatorConnectionWhere[] | null;
  node?: UserWhere | null;
  node_NOT?: UserWhere | null;
}

export interface UserNotificationCreatorNodeAggregationWhereInput {
  AND?: UserNotificationCreatorNodeAggregationWhereInput[] | null;
  OR?: UserNotificationCreatorNodeAggregationWhereInput[] | null;
  deletedOn_EQUAL?: any | null;
  deletedOn_GT?: any | null;
  deletedOn_GTE?: any | null;
  deletedOn_LT?: any | null;
  deletedOn_LTE?: any | null;
  deletedOn_MAX_EQUAL?: any | null;
  deletedOn_MAX_GT?: any | null;
  deletedOn_MAX_GTE?: any | null;
  deletedOn_MAX_LT?: any | null;
  deletedOn_MAX_LTE?: any | null;
  deletedOn_MIN_EQUAL?: any | null;
  deletedOn_MIN_GT?: any | null;
  deletedOn_MIN_GTE?: any | null;
  deletedOn_MIN_LT?: any | null;
  deletedOn_MIN_LTE?: any | null;
  department_AVERAGE_EQUAL?: number | null;
  department_AVERAGE_GT?: number | null;
  department_AVERAGE_GTE?: number | null;
  department_AVERAGE_LT?: number | null;
  department_AVERAGE_LTE?: number | null;
  department_EQUAL?: string | null;
  department_GT?: number | null;
  department_GTE?: number | null;
  department_LONGEST_EQUAL?: number | null;
  department_LONGEST_GT?: number | null;
  department_LONGEST_GTE?: number | null;
  department_LONGEST_LT?: number | null;
  department_LONGEST_LTE?: number | null;
  department_LT?: number | null;
  department_LTE?: number | null;
  department_SHORTEST_EQUAL?: number | null;
  department_SHORTEST_GT?: number | null;
  department_SHORTEST_GTE?: number | null;
  department_SHORTEST_LT?: number | null;
  department_SHORTEST_LTE?: number | null;
  email_AVERAGE_EQUAL?: number | null;
  email_AVERAGE_GT?: number | null;
  email_AVERAGE_GTE?: number | null;
  email_AVERAGE_LT?: number | null;
  email_AVERAGE_LTE?: number | null;
  email_EQUAL?: string | null;
  email_GT?: number | null;
  email_GTE?: number | null;
  email_LONGEST_EQUAL?: number | null;
  email_LONGEST_GT?: number | null;
  email_LONGEST_GTE?: number | null;
  email_LONGEST_LT?: number | null;
  email_LONGEST_LTE?: number | null;
  email_LT?: number | null;
  email_LTE?: number | null;
  email_SHORTEST_EQUAL?: number | null;
  email_SHORTEST_GT?: number | null;
  email_SHORTEST_GTE?: number | null;
  email_SHORTEST_LT?: number | null;
  email_SHORTEST_LTE?: number | null;
  firstName_AVERAGE_EQUAL?: number | null;
  firstName_AVERAGE_GT?: number | null;
  firstName_AVERAGE_GTE?: number | null;
  firstName_AVERAGE_LT?: number | null;
  firstName_AVERAGE_LTE?: number | null;
  firstName_EQUAL?: string | null;
  firstName_GT?: number | null;
  firstName_GTE?: number | null;
  firstName_LONGEST_EQUAL?: number | null;
  firstName_LONGEST_GT?: number | null;
  firstName_LONGEST_GTE?: number | null;
  firstName_LONGEST_LT?: number | null;
  firstName_LONGEST_LTE?: number | null;
  firstName_LT?: number | null;
  firstName_LTE?: number | null;
  firstName_SHORTEST_EQUAL?: number | null;
  firstName_SHORTEST_GT?: number | null;
  firstName_SHORTEST_GTE?: number | null;
  firstName_SHORTEST_LT?: number | null;
  firstName_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  lastName_AVERAGE_EQUAL?: number | null;
  lastName_AVERAGE_GT?: number | null;
  lastName_AVERAGE_GTE?: number | null;
  lastName_AVERAGE_LT?: number | null;
  lastName_AVERAGE_LTE?: number | null;
  lastName_EQUAL?: string | null;
  lastName_GT?: number | null;
  lastName_GTE?: number | null;
  lastName_LONGEST_EQUAL?: number | null;
  lastName_LONGEST_GT?: number | null;
  lastName_LONGEST_GTE?: number | null;
  lastName_LONGEST_LT?: number | null;
  lastName_LONGEST_LTE?: number | null;
  lastName_LT?: number | null;
  lastName_LTE?: number | null;
  lastName_SHORTEST_EQUAL?: number | null;
  lastName_SHORTEST_GT?: number | null;
  lastName_SHORTEST_GTE?: number | null;
  lastName_SHORTEST_LT?: number | null;
  lastName_SHORTEST_LTE?: number | null;
  position_AVERAGE_EQUAL?: number | null;
  position_AVERAGE_GT?: number | null;
  position_AVERAGE_GTE?: number | null;
  position_AVERAGE_LT?: number | null;
  position_AVERAGE_LTE?: number | null;
  position_EQUAL?: string | null;
  position_GT?: number | null;
  position_GTE?: number | null;
  position_LONGEST_EQUAL?: number | null;
  position_LONGEST_GT?: number | null;
  position_LONGEST_GTE?: number | null;
  position_LONGEST_LT?: number | null;
  position_LONGEST_LTE?: number | null;
  position_LT?: number | null;
  position_LTE?: number | null;
  position_SHORTEST_EQUAL?: number | null;
  position_SHORTEST_GT?: number | null;
  position_SHORTEST_GTE?: number | null;
  position_SHORTEST_LT?: number | null;
  position_SHORTEST_LTE?: number | null;
  preferredLanguage_AVERAGE_EQUAL?: number | null;
  preferredLanguage_AVERAGE_GT?: number | null;
  preferredLanguage_AVERAGE_GTE?: number | null;
  preferredLanguage_AVERAGE_LT?: number | null;
  preferredLanguage_AVERAGE_LTE?: number | null;
  preferredLanguage_EQUAL?: string | null;
  preferredLanguage_GT?: number | null;
  preferredLanguage_GTE?: number | null;
  preferredLanguage_LONGEST_EQUAL?: number | null;
  preferredLanguage_LONGEST_GT?: number | null;
  preferredLanguage_LONGEST_GTE?: number | null;
  preferredLanguage_LONGEST_LT?: number | null;
  preferredLanguage_LONGEST_LTE?: number | null;
  preferredLanguage_LT?: number | null;
  preferredLanguage_LTE?: number | null;
  preferredLanguage_SHORTEST_EQUAL?: number | null;
  preferredLanguage_SHORTEST_GT?: number | null;
  preferredLanguage_SHORTEST_GTE?: number | null;
  preferredLanguage_SHORTEST_LT?: number | null;
  preferredLanguage_SHORTEST_LTE?: number | null;
  tenantId_AVERAGE_EQUAL?: number | null;
  tenantId_AVERAGE_GT?: number | null;
  tenantId_AVERAGE_GTE?: number | null;
  tenantId_AVERAGE_LT?: number | null;
  tenantId_AVERAGE_LTE?: number | null;
  tenantId_EQUAL?: string | null;
  tenantId_GT?: number | null;
  tenantId_GTE?: number | null;
  tenantId_LONGEST_EQUAL?: number | null;
  tenantId_LONGEST_GT?: number | null;
  tenantId_LONGEST_GTE?: number | null;
  tenantId_LONGEST_LT?: number | null;
  tenantId_LONGEST_LTE?: number | null;
  tenantId_LT?: number | null;
  tenantId_LTE?: number | null;
  tenantId_SHORTEST_EQUAL?: number | null;
  tenantId_SHORTEST_GT?: number | null;
  tenantId_SHORTEST_GTE?: number | null;
  tenantId_SHORTEST_LT?: number | null;
  tenantId_SHORTEST_LTE?: number | null;
}

export interface UserNotificationDueAggregateInput {
  AND?: UserNotificationDueAggregateInput[] | null;
  OR?: UserNotificationDueAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  edge?: UserNotificationDueEdgeAggregationWhereInput | null;
  node?: UserNotificationDueNodeAggregationWhereInput | null;
}

export interface UserNotificationDueConnectionWhere {
  AND?: UserNotificationDueConnectionWhere[] | null;
  OR?: UserNotificationDueConnectionWhere[] | null;
  edge?: UserNotificationRelationshipWhere | null;
  edge_NOT?: UserNotificationRelationshipWhere | null;
  node?: UserNotificationWhere | null;
  node_NOT?: UserNotificationWhere | null;
}

export interface UserNotificationDueEdgeAggregationWhereInput {
  AND?: UserNotificationDueEdgeAggregationWhereInput[] | null;
  OR?: UserNotificationDueEdgeAggregationWhereInput[] | null;
  message_AVERAGE_EQUAL?: number | null;
  message_AVERAGE_GT?: number | null;
  message_AVERAGE_GTE?: number | null;
  message_AVERAGE_LT?: number | null;
  message_AVERAGE_LTE?: number | null;
  message_EQUAL?: string | null;
  message_GT?: number | null;
  message_GTE?: number | null;
  message_LONGEST_EQUAL?: number | null;
  message_LONGEST_GT?: number | null;
  message_LONGEST_GTE?: number | null;
  message_LONGEST_LT?: number | null;
  message_LONGEST_LTE?: number | null;
  message_LT?: number | null;
  message_LTE?: number | null;
  message_SHORTEST_EQUAL?: number | null;
  message_SHORTEST_GT?: number | null;
  message_SHORTEST_GTE?: number | null;
  message_SHORTEST_LT?: number | null;
  message_SHORTEST_LTE?: number | null;
}

export interface UserNotificationDueNodeAggregationWhereInput {
  AND?: UserNotificationDueNodeAggregationWhereInput[] | null;
  OR?: UserNotificationDueNodeAggregationWhereInput[] | null;
  timeStamp_AVERAGE_EQUAL?: number | null;
  timeStamp_AVERAGE_GT?: number | null;
  timeStamp_AVERAGE_GTE?: number | null;
  timeStamp_AVERAGE_LT?: number | null;
  timeStamp_AVERAGE_LTE?: number | null;
  timeStamp_EQUAL?: number | null;
  timeStamp_GT?: number | null;
  timeStamp_GTE?: number | null;
  timeStamp_LT?: number | null;
  timeStamp_LTE?: number | null;
  timeStamp_MAX_EQUAL?: number | null;
  timeStamp_MAX_GT?: number | null;
  timeStamp_MAX_GTE?: number | null;
  timeStamp_MAX_LT?: number | null;
  timeStamp_MAX_LTE?: number | null;
  timeStamp_MIN_EQUAL?: number | null;
  timeStamp_MIN_GT?: number | null;
  timeStamp_MIN_GTE?: number | null;
  timeStamp_MIN_LT?: number | null;
  timeStamp_MIN_LTE?: number | null;
  timeStamp_SUM_EQUAL?: number | null;
  timeStamp_SUM_GT?: number | null;
  timeStamp_SUM_GTE?: number | null;
  timeStamp_SUM_LT?: number | null;
  timeStamp_SUM_LTE?: number | null;
}

export interface UserNotificationNotificationDueAggregateInput {
  AND?: UserNotificationNotificationDueAggregateInput[] | null;
  OR?: UserNotificationNotificationDueAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  edge?: UserNotificationNotificationDueEdgeAggregationWhereInput | null;
  node?: UserNotificationNotificationDueNodeAggregationWhereInput | null;
}

export interface UserNotificationNotificationDueConnectionWhere {
  AND?: UserNotificationNotificationDueConnectionWhere[] | null;
  OR?: UserNotificationNotificationDueConnectionWhere[] | null;
  edge?: UserNotificationRelationshipWhere | null;
  edge_NOT?: UserNotificationRelationshipWhere | null;
  node?: UserWhere | null;
  node_NOT?: UserWhere | null;
}

export interface UserNotificationNotificationDueEdgeAggregationWhereInput {
  AND?: UserNotificationNotificationDueEdgeAggregationWhereInput[] | null;
  OR?: UserNotificationNotificationDueEdgeAggregationWhereInput[] | null;
  message_AVERAGE_EQUAL?: number | null;
  message_AVERAGE_GT?: number | null;
  message_AVERAGE_GTE?: number | null;
  message_AVERAGE_LT?: number | null;
  message_AVERAGE_LTE?: number | null;
  message_EQUAL?: string | null;
  message_GT?: number | null;
  message_GTE?: number | null;
  message_LONGEST_EQUAL?: number | null;
  message_LONGEST_GT?: number | null;
  message_LONGEST_GTE?: number | null;
  message_LONGEST_LT?: number | null;
  message_LONGEST_LTE?: number | null;
  message_LT?: number | null;
  message_LTE?: number | null;
  message_SHORTEST_EQUAL?: number | null;
  message_SHORTEST_GT?: number | null;
  message_SHORTEST_GTE?: number | null;
  message_SHORTEST_LT?: number | null;
  message_SHORTEST_LTE?: number | null;
}

export interface UserNotificationNotificationDueNodeAggregationWhereInput {
  AND?: UserNotificationNotificationDueNodeAggregationWhereInput[] | null;
  OR?: UserNotificationNotificationDueNodeAggregationWhereInput[] | null;
  deletedOn_EQUAL?: any | null;
  deletedOn_GT?: any | null;
  deletedOn_GTE?: any | null;
  deletedOn_LT?: any | null;
  deletedOn_LTE?: any | null;
  deletedOn_MAX_EQUAL?: any | null;
  deletedOn_MAX_GT?: any | null;
  deletedOn_MAX_GTE?: any | null;
  deletedOn_MAX_LT?: any | null;
  deletedOn_MAX_LTE?: any | null;
  deletedOn_MIN_EQUAL?: any | null;
  deletedOn_MIN_GT?: any | null;
  deletedOn_MIN_GTE?: any | null;
  deletedOn_MIN_LT?: any | null;
  deletedOn_MIN_LTE?: any | null;
  department_AVERAGE_EQUAL?: number | null;
  department_AVERAGE_GT?: number | null;
  department_AVERAGE_GTE?: number | null;
  department_AVERAGE_LT?: number | null;
  department_AVERAGE_LTE?: number | null;
  department_EQUAL?: string | null;
  department_GT?: number | null;
  department_GTE?: number | null;
  department_LONGEST_EQUAL?: number | null;
  department_LONGEST_GT?: number | null;
  department_LONGEST_GTE?: number | null;
  department_LONGEST_LT?: number | null;
  department_LONGEST_LTE?: number | null;
  department_LT?: number | null;
  department_LTE?: number | null;
  department_SHORTEST_EQUAL?: number | null;
  department_SHORTEST_GT?: number | null;
  department_SHORTEST_GTE?: number | null;
  department_SHORTEST_LT?: number | null;
  department_SHORTEST_LTE?: number | null;
  email_AVERAGE_EQUAL?: number | null;
  email_AVERAGE_GT?: number | null;
  email_AVERAGE_GTE?: number | null;
  email_AVERAGE_LT?: number | null;
  email_AVERAGE_LTE?: number | null;
  email_EQUAL?: string | null;
  email_GT?: number | null;
  email_GTE?: number | null;
  email_LONGEST_EQUAL?: number | null;
  email_LONGEST_GT?: number | null;
  email_LONGEST_GTE?: number | null;
  email_LONGEST_LT?: number | null;
  email_LONGEST_LTE?: number | null;
  email_LT?: number | null;
  email_LTE?: number | null;
  email_SHORTEST_EQUAL?: number | null;
  email_SHORTEST_GT?: number | null;
  email_SHORTEST_GTE?: number | null;
  email_SHORTEST_LT?: number | null;
  email_SHORTEST_LTE?: number | null;
  firstName_AVERAGE_EQUAL?: number | null;
  firstName_AVERAGE_GT?: number | null;
  firstName_AVERAGE_GTE?: number | null;
  firstName_AVERAGE_LT?: number | null;
  firstName_AVERAGE_LTE?: number | null;
  firstName_EQUAL?: string | null;
  firstName_GT?: number | null;
  firstName_GTE?: number | null;
  firstName_LONGEST_EQUAL?: number | null;
  firstName_LONGEST_GT?: number | null;
  firstName_LONGEST_GTE?: number | null;
  firstName_LONGEST_LT?: number | null;
  firstName_LONGEST_LTE?: number | null;
  firstName_LT?: number | null;
  firstName_LTE?: number | null;
  firstName_SHORTEST_EQUAL?: number | null;
  firstName_SHORTEST_GT?: number | null;
  firstName_SHORTEST_GTE?: number | null;
  firstName_SHORTEST_LT?: number | null;
  firstName_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  lastName_AVERAGE_EQUAL?: number | null;
  lastName_AVERAGE_GT?: number | null;
  lastName_AVERAGE_GTE?: number | null;
  lastName_AVERAGE_LT?: number | null;
  lastName_AVERAGE_LTE?: number | null;
  lastName_EQUAL?: string | null;
  lastName_GT?: number | null;
  lastName_GTE?: number | null;
  lastName_LONGEST_EQUAL?: number | null;
  lastName_LONGEST_GT?: number | null;
  lastName_LONGEST_GTE?: number | null;
  lastName_LONGEST_LT?: number | null;
  lastName_LONGEST_LTE?: number | null;
  lastName_LT?: number | null;
  lastName_LTE?: number | null;
  lastName_SHORTEST_EQUAL?: number | null;
  lastName_SHORTEST_GT?: number | null;
  lastName_SHORTEST_GTE?: number | null;
  lastName_SHORTEST_LT?: number | null;
  lastName_SHORTEST_LTE?: number | null;
  position_AVERAGE_EQUAL?: number | null;
  position_AVERAGE_GT?: number | null;
  position_AVERAGE_GTE?: number | null;
  position_AVERAGE_LT?: number | null;
  position_AVERAGE_LTE?: number | null;
  position_EQUAL?: string | null;
  position_GT?: number | null;
  position_GTE?: number | null;
  position_LONGEST_EQUAL?: number | null;
  position_LONGEST_GT?: number | null;
  position_LONGEST_GTE?: number | null;
  position_LONGEST_LT?: number | null;
  position_LONGEST_LTE?: number | null;
  position_LT?: number | null;
  position_LTE?: number | null;
  position_SHORTEST_EQUAL?: number | null;
  position_SHORTEST_GT?: number | null;
  position_SHORTEST_GTE?: number | null;
  position_SHORTEST_LT?: number | null;
  position_SHORTEST_LTE?: number | null;
  preferredLanguage_AVERAGE_EQUAL?: number | null;
  preferredLanguage_AVERAGE_GT?: number | null;
  preferredLanguage_AVERAGE_GTE?: number | null;
  preferredLanguage_AVERAGE_LT?: number | null;
  preferredLanguage_AVERAGE_LTE?: number | null;
  preferredLanguage_EQUAL?: string | null;
  preferredLanguage_GT?: number | null;
  preferredLanguage_GTE?: number | null;
  preferredLanguage_LONGEST_EQUAL?: number | null;
  preferredLanguage_LONGEST_GT?: number | null;
  preferredLanguage_LONGEST_GTE?: number | null;
  preferredLanguage_LONGEST_LT?: number | null;
  preferredLanguage_LONGEST_LTE?: number | null;
  preferredLanguage_LT?: number | null;
  preferredLanguage_LTE?: number | null;
  preferredLanguage_SHORTEST_EQUAL?: number | null;
  preferredLanguage_SHORTEST_GT?: number | null;
  preferredLanguage_SHORTEST_GTE?: number | null;
  preferredLanguage_SHORTEST_LT?: number | null;
  preferredLanguage_SHORTEST_LTE?: number | null;
  tenantId_AVERAGE_EQUAL?: number | null;
  tenantId_AVERAGE_GT?: number | null;
  tenantId_AVERAGE_GTE?: number | null;
  tenantId_AVERAGE_LT?: number | null;
  tenantId_AVERAGE_LTE?: number | null;
  tenantId_EQUAL?: string | null;
  tenantId_GT?: number | null;
  tenantId_GTE?: number | null;
  tenantId_LONGEST_EQUAL?: number | null;
  tenantId_LONGEST_GT?: number | null;
  tenantId_LONGEST_GTE?: number | null;
  tenantId_LONGEST_LT?: number | null;
  tenantId_LONGEST_LTE?: number | null;
  tenantId_LT?: number | null;
  tenantId_LTE?: number | null;
  tenantId_SHORTEST_EQUAL?: number | null;
  tenantId_SHORTEST_GT?: number | null;
  tenantId_SHORTEST_GTE?: number | null;
  tenantId_SHORTEST_LT?: number | null;
  tenantId_SHORTEST_LTE?: number | null;
}

export interface UserNotificationNotifiedAggregateInput {
  AND?: UserNotificationNotifiedAggregateInput[] | null;
  OR?: UserNotificationNotifiedAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  edge?: UserNotificationNotifiedEdgeAggregationWhereInput | null;
  node?: UserNotificationNotifiedNodeAggregationWhereInput | null;
}

export interface UserNotificationNotifiedConnectionWhere {
  AND?: UserNotificationNotifiedConnectionWhere[] | null;
  OR?: UserNotificationNotifiedConnectionWhere[] | null;
  edge?: UserNotificationRelationshipWhere | null;
  edge_NOT?: UserNotificationRelationshipWhere | null;
  node?: UserWhere | null;
  node_NOT?: UserWhere | null;
}

export interface UserNotificationNotifiedEdgeAggregationWhereInput {
  AND?: UserNotificationNotifiedEdgeAggregationWhereInput[] | null;
  OR?: UserNotificationNotifiedEdgeAggregationWhereInput[] | null;
  message_AVERAGE_EQUAL?: number | null;
  message_AVERAGE_GT?: number | null;
  message_AVERAGE_GTE?: number | null;
  message_AVERAGE_LT?: number | null;
  message_AVERAGE_LTE?: number | null;
  message_EQUAL?: string | null;
  message_GT?: number | null;
  message_GTE?: number | null;
  message_LONGEST_EQUAL?: number | null;
  message_LONGEST_GT?: number | null;
  message_LONGEST_GTE?: number | null;
  message_LONGEST_LT?: number | null;
  message_LONGEST_LTE?: number | null;
  message_LT?: number | null;
  message_LTE?: number | null;
  message_SHORTEST_EQUAL?: number | null;
  message_SHORTEST_GT?: number | null;
  message_SHORTEST_GTE?: number | null;
  message_SHORTEST_LT?: number | null;
  message_SHORTEST_LTE?: number | null;
}

export interface UserNotificationNotifiedNodeAggregationWhereInput {
  AND?: UserNotificationNotifiedNodeAggregationWhereInput[] | null;
  OR?: UserNotificationNotifiedNodeAggregationWhereInput[] | null;
  deletedOn_EQUAL?: any | null;
  deletedOn_GT?: any | null;
  deletedOn_GTE?: any | null;
  deletedOn_LT?: any | null;
  deletedOn_LTE?: any | null;
  deletedOn_MAX_EQUAL?: any | null;
  deletedOn_MAX_GT?: any | null;
  deletedOn_MAX_GTE?: any | null;
  deletedOn_MAX_LT?: any | null;
  deletedOn_MAX_LTE?: any | null;
  deletedOn_MIN_EQUAL?: any | null;
  deletedOn_MIN_GT?: any | null;
  deletedOn_MIN_GTE?: any | null;
  deletedOn_MIN_LT?: any | null;
  deletedOn_MIN_LTE?: any | null;
  department_AVERAGE_EQUAL?: number | null;
  department_AVERAGE_GT?: number | null;
  department_AVERAGE_GTE?: number | null;
  department_AVERAGE_LT?: number | null;
  department_AVERAGE_LTE?: number | null;
  department_EQUAL?: string | null;
  department_GT?: number | null;
  department_GTE?: number | null;
  department_LONGEST_EQUAL?: number | null;
  department_LONGEST_GT?: number | null;
  department_LONGEST_GTE?: number | null;
  department_LONGEST_LT?: number | null;
  department_LONGEST_LTE?: number | null;
  department_LT?: number | null;
  department_LTE?: number | null;
  department_SHORTEST_EQUAL?: number | null;
  department_SHORTEST_GT?: number | null;
  department_SHORTEST_GTE?: number | null;
  department_SHORTEST_LT?: number | null;
  department_SHORTEST_LTE?: number | null;
  email_AVERAGE_EQUAL?: number | null;
  email_AVERAGE_GT?: number | null;
  email_AVERAGE_GTE?: number | null;
  email_AVERAGE_LT?: number | null;
  email_AVERAGE_LTE?: number | null;
  email_EQUAL?: string | null;
  email_GT?: number | null;
  email_GTE?: number | null;
  email_LONGEST_EQUAL?: number | null;
  email_LONGEST_GT?: number | null;
  email_LONGEST_GTE?: number | null;
  email_LONGEST_LT?: number | null;
  email_LONGEST_LTE?: number | null;
  email_LT?: number | null;
  email_LTE?: number | null;
  email_SHORTEST_EQUAL?: number | null;
  email_SHORTEST_GT?: number | null;
  email_SHORTEST_GTE?: number | null;
  email_SHORTEST_LT?: number | null;
  email_SHORTEST_LTE?: number | null;
  firstName_AVERAGE_EQUAL?: number | null;
  firstName_AVERAGE_GT?: number | null;
  firstName_AVERAGE_GTE?: number | null;
  firstName_AVERAGE_LT?: number | null;
  firstName_AVERAGE_LTE?: number | null;
  firstName_EQUAL?: string | null;
  firstName_GT?: number | null;
  firstName_GTE?: number | null;
  firstName_LONGEST_EQUAL?: number | null;
  firstName_LONGEST_GT?: number | null;
  firstName_LONGEST_GTE?: number | null;
  firstName_LONGEST_LT?: number | null;
  firstName_LONGEST_LTE?: number | null;
  firstName_LT?: number | null;
  firstName_LTE?: number | null;
  firstName_SHORTEST_EQUAL?: number | null;
  firstName_SHORTEST_GT?: number | null;
  firstName_SHORTEST_GTE?: number | null;
  firstName_SHORTEST_LT?: number | null;
  firstName_SHORTEST_LTE?: number | null;
  id_EQUAL?: string | null;
  lastName_AVERAGE_EQUAL?: number | null;
  lastName_AVERAGE_GT?: number | null;
  lastName_AVERAGE_GTE?: number | null;
  lastName_AVERAGE_LT?: number | null;
  lastName_AVERAGE_LTE?: number | null;
  lastName_EQUAL?: string | null;
  lastName_GT?: number | null;
  lastName_GTE?: number | null;
  lastName_LONGEST_EQUAL?: number | null;
  lastName_LONGEST_GT?: number | null;
  lastName_LONGEST_GTE?: number | null;
  lastName_LONGEST_LT?: number | null;
  lastName_LONGEST_LTE?: number | null;
  lastName_LT?: number | null;
  lastName_LTE?: number | null;
  lastName_SHORTEST_EQUAL?: number | null;
  lastName_SHORTEST_GT?: number | null;
  lastName_SHORTEST_GTE?: number | null;
  lastName_SHORTEST_LT?: number | null;
  lastName_SHORTEST_LTE?: number | null;
  position_AVERAGE_EQUAL?: number | null;
  position_AVERAGE_GT?: number | null;
  position_AVERAGE_GTE?: number | null;
  position_AVERAGE_LT?: number | null;
  position_AVERAGE_LTE?: number | null;
  position_EQUAL?: string | null;
  position_GT?: number | null;
  position_GTE?: number | null;
  position_LONGEST_EQUAL?: number | null;
  position_LONGEST_GT?: number | null;
  position_LONGEST_GTE?: number | null;
  position_LONGEST_LT?: number | null;
  position_LONGEST_LTE?: number | null;
  position_LT?: number | null;
  position_LTE?: number | null;
  position_SHORTEST_EQUAL?: number | null;
  position_SHORTEST_GT?: number | null;
  position_SHORTEST_GTE?: number | null;
  position_SHORTEST_LT?: number | null;
  position_SHORTEST_LTE?: number | null;
  preferredLanguage_AVERAGE_EQUAL?: number | null;
  preferredLanguage_AVERAGE_GT?: number | null;
  preferredLanguage_AVERAGE_GTE?: number | null;
  preferredLanguage_AVERAGE_LT?: number | null;
  preferredLanguage_AVERAGE_LTE?: number | null;
  preferredLanguage_EQUAL?: string | null;
  preferredLanguage_GT?: number | null;
  preferredLanguage_GTE?: number | null;
  preferredLanguage_LONGEST_EQUAL?: number | null;
  preferredLanguage_LONGEST_GT?: number | null;
  preferredLanguage_LONGEST_GTE?: number | null;
  preferredLanguage_LONGEST_LT?: number | null;
  preferredLanguage_LONGEST_LTE?: number | null;
  preferredLanguage_LT?: number | null;
  preferredLanguage_LTE?: number | null;
  preferredLanguage_SHORTEST_EQUAL?: number | null;
  preferredLanguage_SHORTEST_GT?: number | null;
  preferredLanguage_SHORTEST_GTE?: number | null;
  preferredLanguage_SHORTEST_LT?: number | null;
  preferredLanguage_SHORTEST_LTE?: number | null;
  tenantId_AVERAGE_EQUAL?: number | null;
  tenantId_AVERAGE_GT?: number | null;
  tenantId_AVERAGE_GTE?: number | null;
  tenantId_AVERAGE_LT?: number | null;
  tenantId_AVERAGE_LTE?: number | null;
  tenantId_EQUAL?: string | null;
  tenantId_GT?: number | null;
  tenantId_GTE?: number | null;
  tenantId_LONGEST_EQUAL?: number | null;
  tenantId_LONGEST_GT?: number | null;
  tenantId_LONGEST_GTE?: number | null;
  tenantId_LONGEST_LT?: number | null;
  tenantId_LONGEST_LTE?: number | null;
  tenantId_LT?: number | null;
  tenantId_LTE?: number | null;
  tenantId_SHORTEST_EQUAL?: number | null;
  tenantId_SHORTEST_GT?: number | null;
  tenantId_SHORTEST_GTE?: number | null;
  tenantId_SHORTEST_LT?: number | null;
  tenantId_SHORTEST_LTE?: number | null;
}

export interface UserNotificationRelationshipWhere {
  AND?: UserNotificationRelationshipWhere[] | null;
  OR?: UserNotificationRelationshipWhere[] | null;
  isEmailEncryptionEnabled?: boolean | null;
  isEmailEncryptionEnabled_NOT?: boolean | null;
  message?: string | null;
  message_CONTAINS?: string | null;
  message_ENDS_WITH?: string | null;
  message_IN?: (string | null)[] | null;
  message_MATCHES?: string | null;
  message_NOT?: string | null;
  message_NOT_CONTAINS?: string | null;
  message_NOT_ENDS_WITH?: string | null;
  message_NOT_IN?: (string | null)[] | null;
  message_NOT_STARTS_WITH?: string | null;
  message_STARTS_WITH?: string | null;
}

export interface UserNotificationTypeAggregateInput {
  AND?: UserNotificationTypeAggregateInput[] | null;
  OR?: UserNotificationTypeAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: UserNotificationTypeNodeAggregationWhereInput | null;
}

export interface UserNotificationTypeConnectionWhere {
  AND?: UserNotificationTypeConnectionWhere[] | null;
  OR?: UserNotificationTypeConnectionWhere[] | null;
  node?: NotificationWhere | null;
  node_NOT?: NotificationWhere | null;
}

export interface UserNotificationTypeNodeAggregationWhereInput {
  AND?: UserNotificationTypeNodeAggregationWhereInput[] | null;
  OR?: UserNotificationTypeNodeAggregationWhereInput[] | null;
  id_AVERAGE_EQUAL?: number | null;
  id_AVERAGE_GT?: number | null;
  id_AVERAGE_GTE?: number | null;
  id_AVERAGE_LT?: number | null;
  id_AVERAGE_LTE?: number | null;
  id_EQUAL?: number | null;
  id_GT?: number | null;
  id_GTE?: number | null;
  id_LT?: number | null;
  id_LTE?: number | null;
  id_MAX_EQUAL?: number | null;
  id_MAX_GT?: number | null;
  id_MAX_GTE?: number | null;
  id_MAX_LT?: number | null;
  id_MAX_LTE?: number | null;
  id_MIN_EQUAL?: number | null;
  id_MIN_GT?: number | null;
  id_MIN_GTE?: number | null;
  id_MIN_LT?: number | null;
  id_MIN_LTE?: number | null;
  id_SUM_EQUAL?: number | null;
  id_SUM_GT?: number | null;
  id_SUM_GTE?: number | null;
  id_SUM_LT?: number | null;
  id_SUM_LTE?: number | null;
  name_AVERAGE_EQUAL?: number | null;
  name_AVERAGE_GT?: number | null;
  name_AVERAGE_GTE?: number | null;
  name_AVERAGE_LT?: number | null;
  name_AVERAGE_LTE?: number | null;
  name_EQUAL?: string | null;
  name_GT?: number | null;
  name_GTE?: number | null;
  name_LONGEST_EQUAL?: number | null;
  name_LONGEST_GT?: number | null;
  name_LONGEST_GTE?: number | null;
  name_LONGEST_LT?: number | null;
  name_LONGEST_LTE?: number | null;
  name_LT?: number | null;
  name_LTE?: number | null;
  name_SHORTEST_EQUAL?: number | null;
  name_SHORTEST_GT?: number | null;
  name_SHORTEST_GTE?: number | null;
  name_SHORTEST_LT?: number | null;
  name_SHORTEST_LTE?: number | null;
}

export interface UserNotificationWhere {
  AND?: UserNotificationWhere[] | null;
  OR?: UserNotificationWhere[] | null;
  creator?: UserWhere | null;
  creatorAggregate?: UserNotificationCreatorAggregateInput | null;
  creatorConnection?: UserNotificationCreatorConnectionWhere | null;
  creatorConnection_NOT?: UserNotificationCreatorConnectionWhere | null;
  creator_NOT?: UserWhere | null;
  dueDate?: any | null;
  dueDate_GT?: any | null;
  dueDate_GTE?: any | null;
  dueDate_IN?: (any | null)[] | null;
  dueDate_LT?: any | null;
  dueDate_LTE?: any | null;
  dueDate_NOT?: any | null;
  dueDate_NOT_IN?: (any | null)[] | null;
  emailSentDate?: any | null;
  emailSentDate_GT?: any | null;
  emailSentDate_GTE?: any | null;
  emailSentDate_IN?: (any | null)[] | null;
  emailSentDate_LT?: any | null;
  emailSentDate_LTE?: any | null;
  emailSentDate_NOT?: any | null;
  emailSentDate_NOT_IN?: (any | null)[] | null;
  notificationDue?: UserWhere | null;
  notificationDueAggregate?: UserNotificationNotificationDueAggregateInput | null;
  notificationDueConnection?: UserNotificationNotificationDueConnectionWhere | null;
  notificationDueConnection_NOT?: UserNotificationNotificationDueConnectionWhere | null;
  notificationDue_NOT?: UserWhere | null;
  notified?: UserWhere | null;
  notifiedAggregate?: UserNotificationNotifiedAggregateInput | null;
  notifiedConnection?: UserNotificationNotifiedConnectionWhere | null;
  notifiedConnection_NOT?: UserNotificationNotifiedConnectionWhere | null;
  notified_NOT?: UserWhere | null;
  timeStamp?: number | null;
  timeStamp_GT?: number | null;
  timeStamp_GTE?: number | null;
  timeStamp_IN?: (number | null)[] | null;
  timeStamp_LT?: number | null;
  timeStamp_LTE?: number | null;
  timeStamp_NOT?: number | null;
  timeStamp_NOT_IN?: (number | null)[] | null;
  type?: NotificationWhere | null;
  typeAggregate?: UserNotificationTypeAggregateInput | null;
  typeConnection?: UserNotificationTypeConnectionWhere | null;
  typeConnection_NOT?: UserNotificationTypeConnectionWhere | null;
  type_NOT?: NotificationWhere | null;
}

export interface UserNotifiedAggregateInput {
  AND?: UserNotifiedAggregateInput[] | null;
  OR?: UserNotifiedAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  edge?: UserNotifiedEdgeAggregationWhereInput | null;
  node?: UserNotifiedNodeAggregationWhereInput | null;
}

export interface UserNotifiedConnectionWhere {
  AND?: UserNotifiedConnectionWhere[] | null;
  OR?: UserNotifiedConnectionWhere[] | null;
  edge?: UserNotificationRelationshipWhere | null;
  edge_NOT?: UserNotificationRelationshipWhere | null;
  node?: UserNotificationWhere | null;
  node_NOT?: UserNotificationWhere | null;
}

export interface UserNotifiedEdgeAggregationWhereInput {
  AND?: UserNotifiedEdgeAggregationWhereInput[] | null;
  OR?: UserNotifiedEdgeAggregationWhereInput[] | null;
  message_AVERAGE_EQUAL?: number | null;
  message_AVERAGE_GT?: number | null;
  message_AVERAGE_GTE?: number | null;
  message_AVERAGE_LT?: number | null;
  message_AVERAGE_LTE?: number | null;
  message_EQUAL?: string | null;
  message_GT?: number | null;
  message_GTE?: number | null;
  message_LONGEST_EQUAL?: number | null;
  message_LONGEST_GT?: number | null;
  message_LONGEST_GTE?: number | null;
  message_LONGEST_LT?: number | null;
  message_LONGEST_LTE?: number | null;
  message_LT?: number | null;
  message_LTE?: number | null;
  message_SHORTEST_EQUAL?: number | null;
  message_SHORTEST_GT?: number | null;
  message_SHORTEST_GTE?: number | null;
  message_SHORTEST_LT?: number | null;
  message_SHORTEST_LTE?: number | null;
}

export interface UserNotifiedNodeAggregationWhereInput {
  AND?: UserNotifiedNodeAggregationWhereInput[] | null;
  OR?: UserNotifiedNodeAggregationWhereInput[] | null;
  timeStamp_AVERAGE_EQUAL?: number | null;
  timeStamp_AVERAGE_GT?: number | null;
  timeStamp_AVERAGE_GTE?: number | null;
  timeStamp_AVERAGE_LT?: number | null;
  timeStamp_AVERAGE_LTE?: number | null;
  timeStamp_EQUAL?: number | null;
  timeStamp_GT?: number | null;
  timeStamp_GTE?: number | null;
  timeStamp_LT?: number | null;
  timeStamp_LTE?: number | null;
  timeStamp_MAX_EQUAL?: number | null;
  timeStamp_MAX_GT?: number | null;
  timeStamp_MAX_GTE?: number | null;
  timeStamp_MAX_LT?: number | null;
  timeStamp_MAX_LTE?: number | null;
  timeStamp_MIN_EQUAL?: number | null;
  timeStamp_MIN_GT?: number | null;
  timeStamp_MIN_GTE?: number | null;
  timeStamp_MIN_LT?: number | null;
  timeStamp_MIN_LTE?: number | null;
  timeStamp_SUM_EQUAL?: number | null;
  timeStamp_SUM_GT?: number | null;
  timeStamp_SUM_GTE?: number | null;
  timeStamp_SUM_LT?: number | null;
  timeStamp_SUM_LTE?: number | null;
}

export interface UserPatientsAggregateInput {
  AND?: UserPatientsAggregateInput[] | null;
  OR?: UserPatientsAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: UserPatientsNodeAggregationWhereInput | null;
}

export interface UserPatientsConnectionWhere {
  AND?: UserPatientsConnectionWhere[] | null;
  OR?: UserPatientsConnectionWhere[] | null;
  node?: PatientWhere | null;
  node_NOT?: PatientWhere | null;
}

export interface UserPatientsNodeAggregationWhereInput {
  AND?: UserPatientsNodeAggregationWhereInput[] | null;
  OR?: UserPatientsNodeAggregationWhereInput[] | null;
  id_EQUAL?: string | null;
  initials_AVERAGE_EQUAL?: number | null;
  initials_AVERAGE_GT?: number | null;
  initials_AVERAGE_GTE?: number | null;
  initials_AVERAGE_LT?: number | null;
  initials_AVERAGE_LTE?: number | null;
  initials_EQUAL?: string | null;
  initials_GT?: number | null;
  initials_GTE?: number | null;
  initials_LONGEST_EQUAL?: number | null;
  initials_LONGEST_GT?: number | null;
  initials_LONGEST_GTE?: number | null;
  initials_LONGEST_LT?: number | null;
  initials_LONGEST_LTE?: number | null;
  initials_LT?: number | null;
  initials_LTE?: number | null;
  initials_SHORTEST_EQUAL?: number | null;
  initials_SHORTEST_GT?: number | null;
  initials_SHORTEST_GTE?: number | null;
  initials_SHORTEST_LT?: number | null;
  initials_SHORTEST_LTE?: number | null;
  insuranceId_AVERAGE_EQUAL?: number | null;
  insuranceId_AVERAGE_GT?: number | null;
  insuranceId_AVERAGE_GTE?: number | null;
  insuranceId_AVERAGE_LT?: number | null;
  insuranceId_AVERAGE_LTE?: number | null;
  insuranceId_EQUAL?: string | null;
  insuranceId_GT?: number | null;
  insuranceId_GTE?: number | null;
  insuranceId_LONGEST_EQUAL?: number | null;
  insuranceId_LONGEST_GT?: number | null;
  insuranceId_LONGEST_GTE?: number | null;
  insuranceId_LONGEST_LT?: number | null;
  insuranceId_LONGEST_LTE?: number | null;
  insuranceId_LT?: number | null;
  insuranceId_LTE?: number | null;
  insuranceId_SHORTEST_EQUAL?: number | null;
  insuranceId_SHORTEST_GT?: number | null;
  insuranceId_SHORTEST_GTE?: number | null;
  insuranceId_SHORTEST_LT?: number | null;
  insuranceId_SHORTEST_LTE?: number | null;
  tenantId_AVERAGE_EQUAL?: number | null;
  tenantId_AVERAGE_GT?: number | null;
  tenantId_AVERAGE_GTE?: number | null;
  tenantId_AVERAGE_LT?: number | null;
  tenantId_AVERAGE_LTE?: number | null;
  tenantId_EQUAL?: string | null;
  tenantId_GT?: number | null;
  tenantId_GTE?: number | null;
  tenantId_LONGEST_EQUAL?: number | null;
  tenantId_LONGEST_GT?: number | null;
  tenantId_LONGEST_GTE?: number | null;
  tenantId_LONGEST_LT?: number | null;
  tenantId_LONGEST_LTE?: number | null;
  tenantId_LT?: number | null;
  tenantId_LTE?: number | null;
  tenantId_SHORTEST_EQUAL?: number | null;
  tenantId_SHORTEST_GT?: number | null;
  tenantId_SHORTEST_GTE?: number | null;
  tenantId_SHORTEST_LT?: number | null;
  tenantId_SHORTEST_LTE?: number | null;
  timeStamp_EQUAL?: any | null;
  timeStamp_GT?: any | null;
  timeStamp_GTE?: any | null;
  timeStamp_LT?: any | null;
  timeStamp_LTE?: any | null;
  timeStamp_MAX_EQUAL?: any | null;
  timeStamp_MAX_GT?: any | null;
  timeStamp_MAX_GTE?: any | null;
  timeStamp_MAX_LT?: any | null;
  timeStamp_MAX_LTE?: any | null;
  timeStamp_MIN_EQUAL?: any | null;
  timeStamp_MIN_GT?: any | null;
  timeStamp_MIN_GTE?: any | null;
  timeStamp_MIN_LT?: any | null;
  timeStamp_MIN_LTE?: any | null;
  yearOfBirth_AVERAGE_EQUAL?: number | null;
  yearOfBirth_AVERAGE_GT?: number | null;
  yearOfBirth_AVERAGE_GTE?: number | null;
  yearOfBirth_AVERAGE_LT?: number | null;
  yearOfBirth_AVERAGE_LTE?: number | null;
  yearOfBirth_EQUAL?: number | null;
  yearOfBirth_GT?: number | null;
  yearOfBirth_GTE?: number | null;
  yearOfBirth_LT?: number | null;
  yearOfBirth_LTE?: number | null;
  yearOfBirth_MAX_EQUAL?: number | null;
  yearOfBirth_MAX_GT?: number | null;
  yearOfBirth_MAX_GTE?: number | null;
  yearOfBirth_MAX_LT?: number | null;
  yearOfBirth_MAX_LTE?: number | null;
  yearOfBirth_MIN_EQUAL?: number | null;
  yearOfBirth_MIN_GT?: number | null;
  yearOfBirth_MIN_GTE?: number | null;
  yearOfBirth_MIN_LT?: number | null;
  yearOfBirth_MIN_LTE?: number | null;
  yearOfBirth_SUM_EQUAL?: number | null;
  yearOfBirth_SUM_GT?: number | null;
  yearOfBirth_SUM_GTE?: number | null;
  yearOfBirth_SUM_LT?: number | null;
  yearOfBirth_SUM_LTE?: number | null;
}

export interface UserPersonalInfoInput {
  department?: string | null;
  firstName: string;
  lastName: string;
  position?: string | null;
  preferredLanguage: string;
  currency?: string | null;
  sourceUserImage?: string | null;
  lastLoginDate?: Date | null;
  currentLoginDate?: Date | null;
}

export interface UserProfileOrSignatureInput {
  blobContainerType: BlobContainerType;
  blobName?: string | null;
  blobNameSource?: string | null;
  content?: string | null;
  contentSource?: string | null;
}

export interface UserQuestPropertiesWhere {
  AND?: UserQuestPropertiesWhere[] | null;
  OR?: UserQuestPropertiesWhere[] | null;
  isOwner?: boolean | null;
  isOwner_NOT?: boolean | null;
  isResolved?: boolean | null;
  isResolved_NOT?: boolean | null;
}

export interface UserQuestRelationshipWhere {
  AND?: UserQuestRelationshipWhere[] | null;
  OR?: UserQuestRelationshipWhere[] | null;
  isOwner?: boolean | null;
  isOwner_NOT?: boolean | null;
  isResolved?: boolean | null;
  isResolved_NOT?: boolean | null;
}

export interface UserQuestsAggregateInput {
  AND?: UserQuestsAggregateInput[] | null;
  OR?: UserQuestsAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: UserQuestsNodeAggregationWhereInput | null;
}

export interface UserQuestsConnectionWhere {
  AND?: UserQuestsConnectionWhere[] | null;
  OR?: UserQuestsConnectionWhere[] | null;
  edge?: UserQuestPropertiesWhere | null;
  edge_NOT?: UserQuestPropertiesWhere | null;
  node?: QuestWhere | null;
  node_NOT?: QuestWhere | null;
}

export interface UserQuestsNodeAggregationWhereInput {
  AND?: UserQuestsNodeAggregationWhereInput[] | null;
  OR?: UserQuestsNodeAggregationWhereInput[] | null;
  id_EQUAL?: string | null;
  questContentDe_AVERAGE_EQUAL?: number | null;
  questContentDe_AVERAGE_GT?: number | null;
  questContentDe_AVERAGE_GTE?: number | null;
  questContentDe_AVERAGE_LT?: number | null;
  questContentDe_AVERAGE_LTE?: number | null;
  questContentDe_EQUAL?: string | null;
  questContentDe_GT?: number | null;
  questContentDe_GTE?: number | null;
  questContentDe_LONGEST_EQUAL?: number | null;
  questContentDe_LONGEST_GT?: number | null;
  questContentDe_LONGEST_GTE?: number | null;
  questContentDe_LONGEST_LT?: number | null;
  questContentDe_LONGEST_LTE?: number | null;
  questContentDe_LT?: number | null;
  questContentDe_LTE?: number | null;
  questContentDe_SHORTEST_EQUAL?: number | null;
  questContentDe_SHORTEST_GT?: number | null;
  questContentDe_SHORTEST_GTE?: number | null;
  questContentDe_SHORTEST_LT?: number | null;
  questContentDe_SHORTEST_LTE?: number | null;
  questContentEn_AVERAGE_EQUAL?: number | null;
  questContentEn_AVERAGE_GT?: number | null;
  questContentEn_AVERAGE_GTE?: number | null;
  questContentEn_AVERAGE_LT?: number | null;
  questContentEn_AVERAGE_LTE?: number | null;
  questContentEn_EQUAL?: string | null;
  questContentEn_GT?: number | null;
  questContentEn_GTE?: number | null;
  questContentEn_LONGEST_EQUAL?: number | null;
  questContentEn_LONGEST_GT?: number | null;
  questContentEn_LONGEST_GTE?: number | null;
  questContentEn_LONGEST_LT?: number | null;
  questContentEn_LONGEST_LTE?: number | null;
  questContentEn_LT?: number | null;
  questContentEn_LTE?: number | null;
  questContentEn_SHORTEST_EQUAL?: number | null;
  questContentEn_SHORTEST_GT?: number | null;
  questContentEn_SHORTEST_GTE?: number | null;
  questContentEn_SHORTEST_LT?: number | null;
  questContentEn_SHORTEST_LTE?: number | null;
  threshold_AVERAGE_EQUAL?: number | null;
  threshold_AVERAGE_GT?: number | null;
  threshold_AVERAGE_GTE?: number | null;
  threshold_AVERAGE_LT?: number | null;
  threshold_AVERAGE_LTE?: number | null;
  threshold_EQUAL?: number | null;
  threshold_GT?: number | null;
  threshold_GTE?: number | null;
  threshold_LT?: number | null;
  threshold_LTE?: number | null;
  threshold_MAX_EQUAL?: number | null;
  threshold_MAX_GT?: number | null;
  threshold_MAX_GTE?: number | null;
  threshold_MAX_LT?: number | null;
  threshold_MAX_LTE?: number | null;
  threshold_MIN_EQUAL?: number | null;
  threshold_MIN_GT?: number | null;
  threshold_MIN_GTE?: number | null;
  threshold_MIN_LT?: number | null;
  threshold_MIN_LTE?: number | null;
  threshold_SUM_EQUAL?: number | null;
  threshold_SUM_GT?: number | null;
  threshold_SUM_GTE?: number | null;
  threshold_SUM_LT?: number | null;
  threshold_SUM_LTE?: number | null;
  timeStamp_AVERAGE_EQUAL?: number | null;
  timeStamp_AVERAGE_GT?: number | null;
  timeStamp_AVERAGE_GTE?: number | null;
  timeStamp_AVERAGE_LT?: number | null;
  timeStamp_AVERAGE_LTE?: number | null;
  timeStamp_EQUAL?: number | null;
  timeStamp_GT?: number | null;
  timeStamp_GTE?: number | null;
  timeStamp_LT?: number | null;
  timeStamp_LTE?: number | null;
  timeStamp_MAX_EQUAL?: number | null;
  timeStamp_MAX_GT?: number | null;
  timeStamp_MAX_GTE?: number | null;
  timeStamp_MAX_LT?: number | null;
  timeStamp_MAX_LTE?: number | null;
  timeStamp_MIN_EQUAL?: number | null;
  timeStamp_MIN_GT?: number | null;
  timeStamp_MIN_GTE?: number | null;
  timeStamp_MIN_LT?: number | null;
  timeStamp_MIN_LTE?: number | null;
  timeStamp_SUM_EQUAL?: number | null;
  timeStamp_SUM_GT?: number | null;
  timeStamp_SUM_GTE?: number | null;
  timeStamp_SUM_LT?: number | null;
  timeStamp_SUM_LTE?: number | null;
  triggerEventId_AVERAGE_EQUAL?: number | null;
  triggerEventId_AVERAGE_GT?: number | null;
  triggerEventId_AVERAGE_GTE?: number | null;
  triggerEventId_AVERAGE_LT?: number | null;
  triggerEventId_AVERAGE_LTE?: number | null;
  triggerEventId_EQUAL?: number | null;
  triggerEventId_GT?: number | null;
  triggerEventId_GTE?: number | null;
  triggerEventId_LT?: number | null;
  triggerEventId_LTE?: number | null;
  triggerEventId_MAX_EQUAL?: number | null;
  triggerEventId_MAX_GT?: number | null;
  triggerEventId_MAX_GTE?: number | null;
  triggerEventId_MAX_LT?: number | null;
  triggerEventId_MAX_LTE?: number | null;
  triggerEventId_MIN_EQUAL?: number | null;
  triggerEventId_MIN_GT?: number | null;
  triggerEventId_MIN_GTE?: number | null;
  triggerEventId_MIN_LT?: number | null;
  triggerEventId_MIN_LTE?: number | null;
  triggerEventId_SUM_EQUAL?: number | null;
  triggerEventId_SUM_GT?: number | null;
  triggerEventId_SUM_GTE?: number | null;
  triggerEventId_SUM_LT?: number | null;
  triggerEventId_SUM_LTE?: number | null;
  unlimited_AVERAGE_EQUAL?: number | null;
  unlimited_AVERAGE_GT?: number | null;
  unlimited_AVERAGE_GTE?: number | null;
  unlimited_AVERAGE_LT?: number | null;
  unlimited_AVERAGE_LTE?: number | null;
  unlimited_EQUAL?: number | null;
  unlimited_GT?: number | null;
  unlimited_GTE?: number | null;
  unlimited_LT?: number | null;
  unlimited_LTE?: number | null;
  unlimited_MAX_EQUAL?: number | null;
  unlimited_MAX_GT?: number | null;
  unlimited_MAX_GTE?: number | null;
  unlimited_MAX_LT?: number | null;
  unlimited_MAX_LTE?: number | null;
  unlimited_MIN_EQUAL?: number | null;
  unlimited_MIN_GT?: number | null;
  unlimited_MIN_GTE?: number | null;
  unlimited_MIN_LT?: number | null;
  unlimited_MIN_LTE?: number | null;
  unlimited_SUM_EQUAL?: number | null;
  unlimited_SUM_GT?: number | null;
  unlimited_SUM_GTE?: number | null;
  unlimited_SUM_LT?: number | null;
  unlimited_SUM_LTE?: number | null;
  value_AVERAGE_EQUAL?: number | null;
  value_AVERAGE_GT?: number | null;
  value_AVERAGE_GTE?: number | null;
  value_AVERAGE_LT?: number | null;
  value_AVERAGE_LTE?: number | null;
  value_EQUAL?: string | null;
  value_GT?: number | null;
  value_GTE?: number | null;
  value_LONGEST_EQUAL?: number | null;
  value_LONGEST_GT?: number | null;
  value_LONGEST_GTE?: number | null;
  value_LONGEST_LT?: number | null;
  value_LONGEST_LTE?: number | null;
  value_LT?: number | null;
  value_LTE?: number | null;
  value_SHORTEST_EQUAL?: number | null;
  value_SHORTEST_GT?: number | null;
  value_SHORTEST_GTE?: number | null;
  value_SHORTEST_LT?: number | null;
  value_SHORTEST_LTE?: number | null;
}

export interface UserRoleRequestUpdateInput {
  agreementId: string;
  agreementName: string;
  role: string;
  userId: string;
}

export interface UserSentMessageAggregateInput {
  AND?: UserSentMessageAggregateInput[] | null;
  OR?: UserSentMessageAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: UserSentMessageNodeAggregationWhereInput | null;
}

export interface UserSentMessageConnectionWhere {
  AND?: UserSentMessageConnectionWhere[] | null;
  OR?: UserSentMessageConnectionWhere[] | null;
  node?: MessageWhere | null;
  node_NOT?: MessageWhere | null;
}

export interface UserSentMessageNodeAggregationWhereInput {
  AND?: UserSentMessageNodeAggregationWhereInput[] | null;
  OR?: UserSentMessageNodeAggregationWhereInput[] | null;
  content_AVERAGE_EQUAL?: number | null;
  content_AVERAGE_GT?: number | null;
  content_AVERAGE_GTE?: number | null;
  content_AVERAGE_LT?: number | null;
  content_AVERAGE_LTE?: number | null;
  content_EQUAL?: string | null;
  content_GT?: number | null;
  content_GTE?: number | null;
  content_LONGEST_EQUAL?: number | null;
  content_LONGEST_GT?: number | null;
  content_LONGEST_GTE?: number | null;
  content_LONGEST_LT?: number | null;
  content_LONGEST_LTE?: number | null;
  content_LT?: number | null;
  content_LTE?: number | null;
  content_SHORTEST_EQUAL?: number | null;
  content_SHORTEST_GT?: number | null;
  content_SHORTEST_GTE?: number | null;
  content_SHORTEST_LT?: number | null;
  content_SHORTEST_LTE?: number | null;
  createdOn_AVERAGE_EQUAL?: number | null;
  createdOn_AVERAGE_GT?: number | null;
  createdOn_AVERAGE_GTE?: number | null;
  createdOn_AVERAGE_LT?: number | null;
  createdOn_AVERAGE_LTE?: number | null;
  createdOn_EQUAL?: number | null;
  createdOn_GT?: number | null;
  createdOn_GTE?: number | null;
  createdOn_LT?: number | null;
  createdOn_LTE?: number | null;
  createdOn_MAX_EQUAL?: number | null;
  createdOn_MAX_GT?: number | null;
  createdOn_MAX_GTE?: number | null;
  createdOn_MAX_LT?: number | null;
  createdOn_MAX_LTE?: number | null;
  createdOn_MIN_EQUAL?: number | null;
  createdOn_MIN_GT?: number | null;
  createdOn_MIN_GTE?: number | null;
  createdOn_MIN_LT?: number | null;
  createdOn_MIN_LTE?: number | null;
  createdOn_SUM_EQUAL?: number | null;
  createdOn_SUM_GT?: number | null;
  createdOn_SUM_GTE?: number | null;
  createdOn_SUM_LT?: number | null;
  createdOn_SUM_LTE?: number | null;
}

export interface UserSubscribedAggregateInput {
  AND?: UserSubscribedAggregateInput[] | null;
  OR?: UserSubscribedAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: UserSubscribedNodeAggregationWhereInput | null;
}

export interface UserSubscribedConnectionWhere {
  AND?: UserSubscribedConnectionWhere[] | null;
  OR?: UserSubscribedConnectionWhere[] | null;
  node?: NotificationWhere | null;
  node_NOT?: NotificationWhere | null;
}

export interface UserSubscribedNodeAggregationWhereInput {
  AND?: UserSubscribedNodeAggregationWhereInput[] | null;
  OR?: UserSubscribedNodeAggregationWhereInput[] | null;
  id_AVERAGE_EQUAL?: number | null;
  id_AVERAGE_GT?: number | null;
  id_AVERAGE_GTE?: number | null;
  id_AVERAGE_LT?: number | null;
  id_AVERAGE_LTE?: number | null;
  id_EQUAL?: number | null;
  id_GT?: number | null;
  id_GTE?: number | null;
  id_LT?: number | null;
  id_LTE?: number | null;
  id_MAX_EQUAL?: number | null;
  id_MAX_GT?: number | null;
  id_MAX_GTE?: number | null;
  id_MAX_LT?: number | null;
  id_MAX_LTE?: number | null;
  id_MIN_EQUAL?: number | null;
  id_MIN_GT?: number | null;
  id_MIN_GTE?: number | null;
  id_MIN_LT?: number | null;
  id_MIN_LTE?: number | null;
  id_SUM_EQUAL?: number | null;
  id_SUM_GT?: number | null;
  id_SUM_GTE?: number | null;
  id_SUM_LT?: number | null;
  id_SUM_LTE?: number | null;
  name_AVERAGE_EQUAL?: number | null;
  name_AVERAGE_GT?: number | null;
  name_AVERAGE_GTE?: number | null;
  name_AVERAGE_LT?: number | null;
  name_AVERAGE_LTE?: number | null;
  name_EQUAL?: string | null;
  name_GT?: number | null;
  name_GTE?: number | null;
  name_LONGEST_EQUAL?: number | null;
  name_LONGEST_GT?: number | null;
  name_LONGEST_GTE?: number | null;
  name_LONGEST_LT?: number | null;
  name_LONGEST_LTE?: number | null;
  name_LT?: number | null;
  name_LTE?: number | null;
  name_SHORTEST_EQUAL?: number | null;
  name_SHORTEST_GT?: number | null;
  name_SHORTEST_GTE?: number | null;
  name_SHORTEST_LT?: number | null;
  name_SHORTEST_LTE?: number | null;
}

export interface UserTaskPropertiesWhere {
  AND?: UserTaskPropertiesWhere[] | null;
  OR?: UserTaskPropertiesWhere[] | null;
  isCompleted?: boolean | null;
  isCompleted_NOT?: boolean | null;
}

export interface UserTaskRelationshipWhere {
  AND?: UserTaskRelationshipWhere[] | null;
  OR?: UserTaskRelationshipWhere[] | null;
  isCompleted?: boolean | null;
  isCompleted_NOT?: boolean | null;
}

export interface UserTasksAggregateInput {
  AND?: UserTasksAggregateInput[] | null;
  OR?: UserTasksAggregateInput[] | null;
  count?: number | null;
  count_GT?: number | null;
  count_GTE?: number | null;
  count_LT?: number | null;
  count_LTE?: number | null;
  node?: UserTasksNodeAggregationWhereInput | null;
}

export interface UserTasksConnectionWhere {
  AND?: UserTasksConnectionWhere[] | null;
  OR?: UserTasksConnectionWhere[] | null;
  edge?: UserTaskPropertiesWhere | null;
  edge_NOT?: UserTaskPropertiesWhere | null;
  node?: TaskWhere | null;
  node_NOT?: TaskWhere | null;
}

export interface UserTasksNodeAggregationWhereInput {
  AND?: UserTasksNodeAggregationWhereInput[] | null;
  OR?: UserTasksNodeAggregationWhereInput[] | null;
  id_EQUAL?: string | null;
  taskContentDe_AVERAGE_EQUAL?: number | null;
  taskContentDe_AVERAGE_GT?: number | null;
  taskContentDe_AVERAGE_GTE?: number | null;
  taskContentDe_AVERAGE_LT?: number | null;
  taskContentDe_AVERAGE_LTE?: number | null;
  taskContentDe_EQUAL?: string | null;
  taskContentDe_GT?: number | null;
  taskContentDe_GTE?: number | null;
  taskContentDe_LONGEST_EQUAL?: number | null;
  taskContentDe_LONGEST_GT?: number | null;
  taskContentDe_LONGEST_GTE?: number | null;
  taskContentDe_LONGEST_LT?: number | null;
  taskContentDe_LONGEST_LTE?: number | null;
  taskContentDe_LT?: number | null;
  taskContentDe_LTE?: number | null;
  taskContentDe_SHORTEST_EQUAL?: number | null;
  taskContentDe_SHORTEST_GT?: number | null;
  taskContentDe_SHORTEST_GTE?: number | null;
  taskContentDe_SHORTEST_LT?: number | null;
  taskContentDe_SHORTEST_LTE?: number | null;
  taskContentEn_AVERAGE_EQUAL?: number | null;
  taskContentEn_AVERAGE_GT?: number | null;
  taskContentEn_AVERAGE_GTE?: number | null;
  taskContentEn_AVERAGE_LT?: number | null;
  taskContentEn_AVERAGE_LTE?: number | null;
  taskContentEn_EQUAL?: string | null;
  taskContentEn_GT?: number | null;
  taskContentEn_GTE?: number | null;
  taskContentEn_LONGEST_EQUAL?: number | null;
  taskContentEn_LONGEST_GT?: number | null;
  taskContentEn_LONGEST_GTE?: number | null;
  taskContentEn_LONGEST_LT?: number | null;
  taskContentEn_LONGEST_LTE?: number | null;
  taskContentEn_LT?: number | null;
  taskContentEn_LTE?: number | null;
  taskContentEn_SHORTEST_EQUAL?: number | null;
  taskContentEn_SHORTEST_GT?: number | null;
  taskContentEn_SHORTEST_GTE?: number | null;
  taskContentEn_SHORTEST_LT?: number | null;
  taskContentEn_SHORTEST_LTE?: number | null;
  timeStamp_AVERAGE_EQUAL?: number | null;
  timeStamp_AVERAGE_GT?: number | null;
  timeStamp_AVERAGE_GTE?: number | null;
  timeStamp_AVERAGE_LT?: number | null;
  timeStamp_AVERAGE_LTE?: number | null;
  timeStamp_EQUAL?: number | null;
  timeStamp_GT?: number | null;
  timeStamp_GTE?: number | null;
  timeStamp_LT?: number | null;
  timeStamp_LTE?: number | null;
  timeStamp_MAX_EQUAL?: number | null;
  timeStamp_MAX_GT?: number | null;
  timeStamp_MAX_GTE?: number | null;
  timeStamp_MAX_LT?: number | null;
  timeStamp_MAX_LTE?: number | null;
  timeStamp_MIN_EQUAL?: number | null;
  timeStamp_MIN_GT?: number | null;
  timeStamp_MIN_GTE?: number | null;
  timeStamp_MIN_LT?: number | null;
  timeStamp_MIN_LTE?: number | null;
  timeStamp_SUM_EQUAL?: number | null;
  timeStamp_SUM_GT?: number | null;
  timeStamp_SUM_GTE?: number | null;
  timeStamp_SUM_LT?: number | null;
  timeStamp_SUM_LTE?: number | null;
  triggerEventId_AVERAGE_EQUAL?: number | null;
  triggerEventId_AVERAGE_GT?: number | null;
  triggerEventId_AVERAGE_GTE?: number | null;
  triggerEventId_AVERAGE_LT?: number | null;
  triggerEventId_AVERAGE_LTE?: number | null;
  triggerEventId_EQUAL?: number | null;
  triggerEventId_GT?: number | null;
  triggerEventId_GTE?: number | null;
  triggerEventId_LT?: number | null;
  triggerEventId_LTE?: number | null;
  triggerEventId_MAX_EQUAL?: number | null;
  triggerEventId_MAX_GT?: number | null;
  triggerEventId_MAX_GTE?: number | null;
  triggerEventId_MAX_LT?: number | null;
  triggerEventId_MAX_LTE?: number | null;
  triggerEventId_MIN_EQUAL?: number | null;
  triggerEventId_MIN_GT?: number | null;
  triggerEventId_MIN_GTE?: number | null;
  triggerEventId_MIN_LT?: number | null;
  triggerEventId_MIN_LTE?: number | null;
  triggerEventId_SUM_EQUAL?: number | null;
  triggerEventId_SUM_GT?: number | null;
  triggerEventId_SUM_GTE?: number | null;
  triggerEventId_SUM_LT?: number | null;
  triggerEventId_SUM_LTE?: number | null;
}

export interface UserWhere {
  AND?: UserWhere[] | null;
  OR?: UserWhere[] | null;
  context?: UserContextWhere | null;
  contextAggregate?: UserContextAggregateInput | null;
  contextConnection?: UserContextConnectionWhere | null;
  contextConnection_NOT?: UserContextConnectionWhere | null;
  context_NOT?: UserContextWhere | null;
  createdUserNotification?: UserNotificationWhere | null;
  createdUserNotificationAggregate?: UserCreatedUserNotificationAggregateInput | null;
  createdUserNotificationConnection?: UserCreatedUserNotificationConnectionWhere | null;
  createdUserNotificationConnection_NOT?: UserCreatedUserNotificationConnectionWhere | null;
  createdUserNotification_NOT?: UserNotificationWhere | null;
  deletedOn?: any | null;
  deletedOn_GT?: any | null;
  deletedOn_GTE?: any | null;
  deletedOn_IN?: (any | null)[] | null;
  deletedOn_LT?: any | null;
  deletedOn_LTE?: any | null;
  deletedOn_NOT?: any | null;
  deletedOn_NOT_IN?: (any | null)[] | null;
  department?: string | null;
  department_CONTAINS?: string | null;
  department_ENDS_WITH?: string | null;
  department_IN?: (string | null)[] | null;
  department_MATCHES?: string | null;
  department_NOT?: string | null;
  department_NOT_CONTAINS?: string | null;
  department_NOT_ENDS_WITH?: string | null;
  department_NOT_IN?: (string | null)[] | null;
  department_NOT_STARTS_WITH?: string | null;
  department_STARTS_WITH?: string | null;
  email?: string | null;
  email_CONTAINS?: string | null;
  email_ENDS_WITH?: string | null;
  email_IN?: (string | null)[] | null;
  email_MATCHES?: string | null;
  email_NOT?: string | null;
  email_NOT_CONTAINS?: string | null;
  email_NOT_ENDS_WITH?: string | null;
  email_NOT_IN?: (string | null)[] | null;
  email_NOT_STARTS_WITH?: string | null;
  email_STARTS_WITH?: string | null;
  firstName?: string | null;
  firstName_CONTAINS?: string | null;
  firstName_ENDS_WITH?: string | null;
  firstName_IN?: (string | null)[] | null;
  firstName_MATCHES?: string | null;
  firstName_NOT?: string | null;
  firstName_NOT_CONTAINS?: string | null;
  firstName_NOT_ENDS_WITH?: string | null;
  firstName_NOT_IN?: (string | null)[] | null;
  firstName_NOT_STARTS_WITH?: string | null;
  firstName_STARTS_WITH?: string | null;
  id?: string | null;
  id_CONTAINS?: string | null;
  id_ENDS_WITH?: string | null;
  id_IN?: (string | null)[] | null;
  id_MATCHES?: string | null;
  id_NOT?: string | null;
  id_NOT_CONTAINS?: string | null;
  id_NOT_ENDS_WITH?: string | null;
  id_NOT_IN?: (string | null)[] | null;
  id_NOT_STARTS_WITH?: string | null;
  id_STARTS_WITH?: string | null;
  isDeleted?: boolean | null;
  isDeleted_NOT?: boolean | null;
  isGuest?: boolean | null;
  isGuest_NOT?: boolean | null;
  lastName?: string | null;
  lastName_CONTAINS?: string | null;
  lastName_ENDS_WITH?: string | null;
  lastName_IN?: (string | null)[] | null;
  lastName_MATCHES?: string | null;
  lastName_NOT?: string | null;
  lastName_NOT_CONTAINS?: string | null;
  lastName_NOT_ENDS_WITH?: string | null;
  lastName_NOT_IN?: (string | null)[] | null;
  lastName_NOT_STARTS_WITH?: string | null;
  lastName_STARTS_WITH?: string | null;
  mentions?: MessageWhere | null;
  mentionsAggregate?: UserMentionsAggregateInput | null;
  mentionsConnection?: UserMentionsConnectionWhere | null;
  mentionsConnection_NOT?: UserMentionsConnectionWhere | null;
  mentions_NOT?: MessageWhere | null;
  negotiationRounds?: NegotiationRoundWhere | null;
  negotiationRoundsAggregate?: UserNegotiationRoundsAggregateInput | null;
  negotiationRoundsConnection?: UserNegotiationRoundsConnectionWhere | null;
  negotiationRoundsConnection_NOT?: UserNegotiationRoundsConnectionWhere | null;
  negotiationRounds_NOT?: NegotiationRoundWhere | null;
  notificationDue?: UserNotificationWhere | null;
  notificationDueAggregate?: UserNotificationDueAggregateInput | null;
  notificationDueConnection?: UserNotificationDueConnectionWhere | null;
  notificationDueConnection_NOT?: UserNotificationDueConnectionWhere | null;
  notificationDue_NOT?: UserNotificationWhere | null;
  notified?: UserNotificationWhere | null;
  notifiedAggregate?: UserNotifiedAggregateInput | null;
  notifiedConnection?: UserNotifiedConnectionWhere | null;
  notifiedConnection_NOT?: UserNotifiedConnectionWhere | null;
  notified_NOT?: UserNotificationWhere | null;
  patients?: PatientWhere | null;
  patientsAggregate?: UserPatientsAggregateInput | null;
  patientsConnection?: UserPatientsConnectionWhere | null;
  patientsConnection_NOT?: UserPatientsConnectionWhere | null;
  patients_NOT?: PatientWhere | null;
  position?: string | null;
  position_CONTAINS?: string | null;
  position_ENDS_WITH?: string | null;
  position_IN?: (string | null)[] | null;
  position_MATCHES?: string | null;
  position_NOT?: string | null;
  position_NOT_CONTAINS?: string | null;
  position_NOT_ENDS_WITH?: string | null;
  position_NOT_IN?: (string | null)[] | null;
  position_NOT_STARTS_WITH?: string | null;
  position_STARTS_WITH?: string | null;
  preferredLanguage?: string | null;
  preferredLanguage_CONTAINS?: string | null;
  preferredLanguage_ENDS_WITH?: string | null;
  preferredLanguage_IN?: (string | null)[] | null;
  preferredLanguage_MATCHES?: string | null;
  preferredLanguage_NOT?: string | null;
  preferredLanguage_NOT_CONTAINS?: string | null;
  preferredLanguage_NOT_ENDS_WITH?: string | null;
  preferredLanguage_NOT_IN?: (string | null)[] | null;
  preferredLanguage_NOT_STARTS_WITH?: string | null;
  preferredLanguage_STARTS_WITH?: string | null;
  quests?: QuestWhere | null;
  questsAggregate?: UserQuestsAggregateInput | null;
  questsConnection?: UserQuestsConnectionWhere | null;
  questsConnection_NOT?: UserQuestsConnectionWhere | null;
  quests_NOT?: QuestWhere | null;
  reads?: string[] | null;
  reads_INCLUDES?: string | null;
  reads_NOT?: string[] | null;
  reads_NOT_INCLUDES?: string | null;
  sentMessage?: MessageWhere | null;
  sentMessageAggregate?: UserSentMessageAggregateInput | null;
  sentMessageConnection?: UserSentMessageConnectionWhere | null;
  sentMessageConnection_NOT?: UserSentMessageConnectionWhere | null;
  sentMessage_NOT?: MessageWhere | null;
  subscribed?: NotificationWhere | null;
  subscribedAggregate?: UserSubscribedAggregateInput | null;
  subscribedConnection?: UserSubscribedConnectionWhere | null;
  subscribedConnection_NOT?: UserSubscribedConnectionWhere | null;
  subscribed_NOT?: NotificationWhere | null;
  tasks?: TaskWhere | null;
  tasksAggregate?: UserTasksAggregateInput | null;
  tasksConnection?: UserTasksConnectionWhere | null;
  tasksConnection_NOT?: UserTasksConnectionWhere | null;
  tasks_NOT?: TaskWhere | null;
  tenantId?: string | null;
  tenantId_CONTAINS?: string | null;
  tenantId_ENDS_WITH?: string | null;
  tenantId_IN?: (string | null)[] | null;
  tenantId_MATCHES?: string | null;
  tenantId_NOT?: string | null;
  tenantId_NOT_CONTAINS?: string | null;
  tenantId_NOT_ENDS_WITH?: string | null;
  tenantId_NOT_IN?: (string | null)[] | null;
  tenantId_NOT_STARTS_WITH?: string | null;
  tenantId_STARTS_WITH?: string | null;
  writes?: string[] | null;
  writes_INCLUDES?: string | null;
  writes_NOT?: string[] | null;
  writes_NOT_INCLUDES?: string | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
